"use client";
import { createContext as uJ, useContext as cJ, useCallback as Xo, useMemo as C8, useState as Zj, useEffect as Xj } from "react";
import { jsx as ae, jsxs as Lr } from "react/jsx-runtime";
var lJ = Object.defineProperty, fJ = (e, t, r) => t in e ? lJ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, st = (e, t, r) => fJ(e, typeof t != "symbol" ? t + "" : t, r);
function dJ(e, t) {
  for (var r = 0; r < t.length; r++) {
    const n = t[r];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const o in n)
        if (o !== "default" && !(o in e)) {
          const i = Object.getOwnPropertyDescriptor(n, o);
          i && Object.defineProperty(e, o, i.get ? i : {
            enumerable: !0,
            get: () => n[o]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
let fI = Symbol("clean"), lu = [], xf = 0;
const kv = 4;
let dI = (e) => {
  let t = [], r = {
    get() {
      return r.lc || r.listen(() => {
      })(), r.value;
    },
    lc: 0,
    listen(n) {
      return r.lc = t.push(n), () => {
        for (let i = xf + kv; i < lu.length; )
          lu[i] === n ? lu.splice(i, kv) : i += kv;
        let o = t.indexOf(n);
        ~o && (t.splice(o, 1), --r.lc || r.off());
      };
    },
    notify(n, o) {
      let i = !lu.length;
      for (let a of t)
        lu.push(
          a,
          r.value,
          n,
          o
        );
      if (i) {
        for (xf = 0; xf < lu.length; xf += kv)
          lu[xf](
            lu[xf + 1],
            lu[xf + 2],
            lu[xf + 3]
          );
        lu.length = 0;
      }
    },
    /* It will be called on last listener unsubscribing.
       We will redefine it in onMount and onStop. */
    off() {
    },
    set(n) {
      let o = r.value;
      o !== n && (r.value = n, r.notify(o));
    },
    subscribe(n) {
      let o = r.listen(n);
      return n(r.value), o;
    },
    value: e
  };
  return process.env.NODE_ENV !== "production" && (r[fI] = () => {
    t = [], r.lc = 0, r.off();
  }), r;
};
const hJ = 5, H0 = 6, Sv = 10;
let pJ = (e, t, r, n) => (e.events = e.events || {}, e.events[r + Sv] || (e.events[r + Sv] = n((o) => {
  e.events[r].reduceRight((i, a) => (a(i), i), {
    shared: {},
    ...o
  });
})), e.events[r] = e.events[r] || [], e.events[r].push(t), () => {
  let o = e.events[r], i = o.indexOf(t);
  o.splice(i, 1), o.length || (delete e.events[r], e.events[r + Sv](), delete e.events[r + Sv]);
}), gJ = 1e3, mJ = (e, t) => pJ(e, (r) => {
  let n = t(r);
  n && e.events[H0].push(n);
}, hJ, (r) => {
  let n = e.listen;
  e.listen = (...i) => (!e.lc && !e.active && (e.active = !0, r()), n(...i));
  let o = e.off;
  if (e.events[H0] = [], e.off = () => {
    o(), setTimeout(() => {
      if (e.active && !e.lc) {
        e.active = !1;
        for (let i of e.events[H0]) i();
        e.events[H0] = [];
      }
    }, gJ);
  }, process.env.NODE_ENV !== "production") {
    let i = e[fI];
    e[fI] = () => {
      for (let a of e.events[H0]) a();
      e.events[H0] = [], e.active = !1, i();
    };
  }
  return () => {
    e.listen = n, e.off = o;
  };
}), yJ = (e) => {
  e.listen(() => {
  });
};
function Ku(e, t, r) {
  let n = new Set(t).add(void 0);
  return e.listen((o, i, a) => {
    n.has(a) && r(o, i, a);
  });
}
let Yj = (e = {}) => {
  let t = dI(e);
  return t.setKey = function(r, n) {
    let o = t.value;
    typeof n > "u" && r in t.value ? (t.value = { ...t.value }, delete t.value[r], t.notify(o, r)) : t.value[r] !== n && (t.value = {
      ...t.value,
      [r]: n
    }, t.notify(o, r));
  }, t;
};
const Zb = "oyl", n1 = "unisat", o1 = "xverse", xp = "phantom", Xb = "leather", Ed = "magic-eden", Yb = "okx", i1 = "wizz", kp = "orange", Sp = "op_net", a1 = "sparrow", $1 = "p2tr", bJ = "p2pkh", wJ = "p2sh-p2wpkh", hI = "p2wpkh", _$e = "p2psh", vJ = "p2wsh", h2 = "p2sh", A$e = {
  leather: {
    name: "leather",
    url: "https://leather.io/install-extension"
  },
  "magic-eden": {
    name: "magic-eden",
    url: "https://wallet.magiceden.io/"
  },
  okx: {
    name: "okx",
    url: "https://chromewebstore.google.com/detail/okx-wallet/mcohilncbfahbmgdjkbpemcciiolgcge"
  },
  op_net: {
    name: "op_net",
    url: "https://opnet.org/"
  },
  orange: {
    name: "orange",
    url: "https://www.orangewallet.com/"
  },
  oyl: {
    name: "oyl",
    url: "https://www.oyl.io/#get-wallet"
  },
  phantom: {
    name: "phantom",
    url: "https://phantom.app/download"
  },
  sparrow: {
    name: "sparrow",
    url: "https://sparrowwallet.com/"
  },
  unisat: {
    name: "unisat",
    url: "https://unisat.io/download"
  },
  wizz: {
    name: "wizz",
    url: "https://wizzwallet.io/#extension"
  },
  xverse: {
    name: "xverse",
    url: "https://www.xverse.app/download"
  }
}, gS = "defaultWallet", qu = {
  /**
   * The message prefix used for signing Bitcoin messages.
   */
  messagePrefix: `Bitcoin Signed Message:
`,
  /**
   * The Bech32 prefix used for Bitcoin addresses.
   */
  bech32: "bc",
  /**
   * The BIP32 key prefixes for Bitcoin.
   */
  bip32: {
    /**
     * The public key prefix for BIP32 extended public keys.
     */
    public: 76067358,
    /**
     * The private key prefix for BIP32 extended private keys.
     */
    private: 76066276
  },
  /**
   * The prefix for Bitcoin public key hashes.
   */
  pubKeyHash: 0,
  /**
   * The prefix for Bitcoin script hashes.
   */
  scriptHash: 5,
  /**
   * The prefix for Bitcoin Wallet Import Format (WIF) private keys.
   */
  wif: 128
}, EJ = {
  messagePrefix: `Bitcoin Signed Message:
`,
  bech32: "tb",
  bip32: {
    public: 70617039,
    private: 70615956
  },
  pubKeyHash: 111,
  scriptHash: 196,
  wif: 239
};
function _J(e) {
  if (e.length < 8 || e.length > 72 || e[0] !== 48 || e[1] !== e.length - 2 || e[2] !== 2) return !1;
  const t = e[3];
  if (t === 0 || 5 + t >= e.length || e[4 + t] !== 2) return !1;
  const r = e[5 + t];
  return !(r === 0 || 6 + t + r !== e.length || e[4] & 128 || t > 1 && e[4] === 0 && !(e[5] & 128) || e[t + 6] & 128 || r > 1 && e[t + 6] === 0 && !(e[t + 7] & 128));
}
function AJ(e) {
  if (e.length < 8) throw new Error("DER sequence length is too short");
  if (e.length > 72) throw new Error("DER sequence length is too long");
  if (e[0] !== 48) throw new Error("Expected DER sequence");
  if (e[1] !== e.length - 2)
    throw new Error("DER sequence length is invalid");
  if (e[2] !== 2) throw new Error("Expected DER integer");
  const t = e[3];
  if (t === 0) throw new Error("R length is zero");
  if (5 + t >= e.length) throw new Error("R length is too long");
  if (e[4 + t] !== 2) throw new Error("Expected DER integer (2)");
  const r = e[5 + t];
  if (r === 0) throw new Error("S length is zero");
  if (6 + t + r !== e.length) throw new Error("S length is invalid");
  if (e[4] & 128) throw new Error("R value is negative");
  if (t > 1 && e[4] === 0 && !(e[5] & 128))
    throw new Error("R value excessively padded");
  if (e[t + 6] & 128) throw new Error("S value is negative");
  if (r > 1 && e[t + 6] === 0 && !(e[t + 7] & 128))
    throw new Error("S value excessively padded");
  return {
    r: e.slice(4, 4 + t),
    s: e.slice(6 + t)
  };
}
function xJ(e, t) {
  const r = e.length, n = t.length;
  if (r === 0) throw new Error("R length is zero");
  if (n === 0) throw new Error("S length is zero");
  if (r > 33) throw new Error("R length is too long");
  if (n > 33) throw new Error("S length is too long");
  if (e[0] & 128) throw new Error("R value is negative");
  if (t[0] & 128) throw new Error("S value is negative");
  if (r > 1 && e[0] === 0 && !(e[1] & 128))
    throw new Error("R value excessively padded");
  if (n > 1 && t[0] === 0 && !(t[1] & 128))
    throw new Error("S value excessively padded");
  const o = new Uint8Array(6 + r + n);
  return o[0] = 48, o[1] = o.length - 2, o[2] = 2, o[3] = e.length, o.set(e, 4), o[4 + r] = 2, o[5 + r] = t.length, o.set(t, 6 + r), o;
}
const on = {
  OP_FALSE: 0,
  OP_0: 0,
  OP_PUSHDATA1: 76,
  OP_PUSHDATA2: 77,
  OP_PUSHDATA4: 78,
  OP_1NEGATE: 79,
  OP_RESERVED: 80,
  OP_TRUE: 81,
  OP_1: 81,
  OP_2: 82,
  OP_3: 83,
  OP_4: 84,
  OP_5: 85,
  OP_6: 86,
  OP_7: 87,
  OP_8: 88,
  OP_9: 89,
  OP_10: 90,
  OP_11: 91,
  OP_12: 92,
  OP_13: 93,
  OP_14: 94,
  OP_15: 95,
  OP_16: 96,
  OP_NOP: 97,
  OP_VER: 98,
  OP_IF: 99,
  OP_NOTIF: 100,
  OP_VERIF: 101,
  OP_VERNOTIF: 102,
  OP_ELSE: 103,
  OP_ENDIF: 104,
  OP_VERIFY: 105,
  OP_RETURN: 106,
  OP_TOALTSTACK: 107,
  OP_FROMALTSTACK: 108,
  OP_2DROP: 109,
  OP_2DUP: 110,
  OP_3DUP: 111,
  OP_2OVER: 112,
  OP_2ROT: 113,
  OP_2SWAP: 114,
  OP_IFDUP: 115,
  OP_DEPTH: 116,
  OP_DROP: 117,
  OP_DUP: 118,
  OP_NIP: 119,
  OP_OVER: 120,
  OP_PICK: 121,
  OP_ROLL: 122,
  OP_ROT: 123,
  OP_SWAP: 124,
  OP_TUCK: 125,
  OP_CAT: 126,
  OP_SUBSTR: 127,
  OP_LEFT: 128,
  OP_RIGHT: 129,
  OP_SIZE: 130,
  OP_INVERT: 131,
  OP_AND: 132,
  OP_OR: 133,
  OP_XOR: 134,
  OP_EQUAL: 135,
  OP_EQUALVERIFY: 136,
  OP_RESERVED1: 137,
  OP_RESERVED2: 138,
  OP_1ADD: 139,
  OP_1SUB: 140,
  OP_2MUL: 141,
  OP_2DIV: 142,
  OP_NEGATE: 143,
  OP_ABS: 144,
  OP_NOT: 145,
  OP_0NOTEQUAL: 146,
  OP_ADD: 147,
  OP_SUB: 148,
  OP_MUL: 149,
  OP_DIV: 150,
  OP_MOD: 151,
  OP_LSHIFT: 152,
  OP_RSHIFT: 153,
  OP_BOOLAND: 154,
  OP_BOOLOR: 155,
  OP_NUMEQUAL: 156,
  OP_NUMEQUALVERIFY: 157,
  OP_NUMNOTEQUAL: 158,
  OP_LESSTHAN: 159,
  OP_GREATERTHAN: 160,
  OP_LESSTHANOREQUAL: 161,
  OP_GREATERTHANOREQUAL: 162,
  OP_MIN: 163,
  OP_MAX: 164,
  OP_WITHIN: 165,
  OP_RIPEMD160: 166,
  OP_SHA1: 167,
  OP_SHA256: 168,
  OP_HASH160: 169,
  OP_HASH256: 170,
  OP_CODESEPARATOR: 171,
  OP_CHECKSIG: 172,
  OP_CHECKSIGVERIFY: 173,
  OP_CHECKMULTISIG: 174,
  OP_CHECKMULTISIGVERIFY: 175,
  OP_NOP1: 176,
  OP_NOP2: 177,
  OP_CHECKLOCKTIMEVERIFY: 177,
  OP_NOP3: 178,
  OP_CHECKSEQUENCEVERIFY: 178,
  OP_NOP4: 179,
  OP_NOP5: 180,
  OP_NOP6: 181,
  OP_NOP7: 182,
  OP_NOP8: 183,
  OP_NOP9: 184,
  OP_NOP10: 185,
  OP_CHECKSIGADD: 186,
  OP_PUBKEYHASH: 253,
  OP_PUBKEY: 254,
  OP_INVALIDOPCODE: 255
}, Jj = {};
for (const e of Object.keys(on)) {
  const t = on[e];
  Jj[t] = e;
}
const Q8 = "0123456789abcdefABCDEF", e3 = Q8.split("").map((e) => e.codePointAt(0)), t3 = Array(256).fill(!0).map((e, t) => {
  const r = String.fromCodePoint(t), n = Q8.indexOf(r);
  return n < 0 ? void 0 : n < 16 ? n : n - 6;
}), Qj = new TextEncoder(), eL = new TextDecoder();
function kJ(e) {
  return eL.decode(e);
}
function SJ(e) {
  return Qj.encode(e);
}
function io(e) {
  const t = e.reduce((o, i) => o + i.length, 0), r = new Uint8Array(t);
  let n = 0;
  for (const o of e)
    r.set(o, n), n += o.length;
  return r;
}
function Gt(e) {
  const t = e || new Uint8Array();
  return t.length > 512 ? IJ(t) : TJ(t);
}
function TJ(e) {
  let t = "";
  for (let r = 0; r < e.length; ++r)
    t += Q8[t3[e3[e[r] >> 4]]], t += Q8[t3[e3[e[r] & 15]]];
  return t;
}
function IJ(e) {
  const t = new Uint8Array(e.length * 2);
  for (let r = 0; r < e.length; ++r)
    t[r * 2] = e3[e[r] >> 4], t[r * 2 + 1] = e3[e[r] & 15];
  return eL.decode(t);
}
function mf(e) {
  const t = Qj.encode(e || ""), r = new Uint8Array(Math.floor(t.length / 2));
  let n;
  for (n = 0; n < r.length; n++) {
    const o = t3[t[n * 2]], i = t3[t[n * 2 + 1]];
    if (o === void 0 || i === void 0)
      break;
    r[n] = o << 4 | i;
  }
  return n === r.length ? r : r.slice(0, n);
}
function OJ(e) {
  return btoa(String.fromCharCode(...e));
}
function tL(e) {
  const t = atob(e), r = new Uint8Array(t.length);
  for (let n = 0; n < t.length; n++)
    r[n] = t.charCodeAt(n);
  return r;
}
function ft(e, t) {
  const r = Math.min(e.length, t.length);
  for (let n = 0; n < r; ++n)
    if (e[n] !== t[n])
      return e[n] < t[n] ? -1 : 1;
  return e.length === t.length ? 0 : e.length > t.length ? 1 : -1;
}
function ts(e, t, r) {
  if (t + 1 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r > 255)
    throw new Error(`The value of "value" is out of range. It must be >= 0 and <= 255. Received ${r}`);
  return e[t] = r, t + 1;
}
function PJ(e, t, r, n) {
  if (t + 2 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (n = n.toUpperCase(), r > 65535)
    throw new Error(`The value of "value" is out of range. It must be >= 0 and <= 65535. Received ${r}`);
  return n === "LE" ? (e[t] = r & 255, e[t + 1] = r >> 8 & 255) : (e[t] = r >> 8 & 255, e[t + 1] = r & 255), t + 2;
}
function p2(e, t, r, n) {
  if (t + 4 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (n = n.toUpperCase(), r > 4294967295)
    throw new Error(`The value of "value" is out of range. It must be >= 0 and <= ${4294967295}. Received ${r}`);
  return n === "LE" ? (e[t] = r & 255, e[t + 1] = r >> 8 & 255, e[t + 2] = r >> 16 & 255, e[t + 3] = r >> 24 & 255) : (e[t] = r >> 24 & 255, e[t + 1] = r >> 16 & 255, e[t + 2] = r >> 8 & 255, e[t + 3] = r & 255), t + 4;
}
function CJ(e, t, r, n) {
  if (t + 8 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (n = n.toUpperCase(), r > 0xffffffffffffffffn)
    throw new Error(`The value of "value" is out of range. It must be >= 0 and <= ${0xffffffffffffffffn}. Received ${r}`);
  return n === "LE" ? (e[t] = Number(r & 0xffn), e[t + 1] = Number(r >> 8n & 0xffn), e[t + 2] = Number(r >> 16n & 0xffn), e[t + 3] = Number(r >> 24n & 0xffn), e[t + 4] = Number(r >> 32n & 0xffn), e[t + 5] = Number(r >> 40n & 0xffn), e[t + 6] = Number(r >> 48n & 0xffn), e[t + 7] = Number(r >> 56n & 0xffn)) : (e[t] = Number(r >> 56n & 0xffn), e[t + 1] = Number(r >> 48n & 0xffn), e[t + 2] = Number(r >> 40n & 0xffn), e[t + 3] = Number(r >> 32n & 0xffn), e[t + 4] = Number(r >> 24n & 0xffn), e[t + 5] = Number(r >> 16n & 0xffn), e[t + 6] = Number(r >> 8n & 0xffn), e[t + 7] = Number(r & 0xffn)), t + 8;
}
function nf(e, t) {
  if (t + 1 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  return e[t];
}
function BJ(e, t, r) {
  if (t + 2 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r = r.toUpperCase(), r === "LE") {
    let n = 0;
    return n = (n << 8) + e[t + 1], n = (n << 8) + e[t], n;
  } else {
    let n = 0;
    return n = (n << 8) + e[t], n = (n << 8) + e[t + 1], n;
  }
}
function hg(e, t, r) {
  if (t + 4 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r = r.toUpperCase(), r === "LE") {
    let n = 0;
    return n = (n << 8) + e[t + 3] >>> 0, n = (n << 8) + e[t + 2] >>> 0, n = (n << 8) + e[t + 1] >>> 0, n = (n << 8) + e[t] >>> 0, n;
  } else {
    let n = 0;
    return n = (n << 8) + e[t] >>> 0, n = (n << 8) + e[t + 1] >>> 0, n = (n << 8) + e[t + 2] >>> 0, n = (n << 8) + e[t + 3] >>> 0, n;
  }
}
function rL(e, t, r, n) {
  if (t + 4 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r > 2147483647 || r < -2147483648)
    throw new Error(`The value of "value" is out of range. It must be >= -2147483648 and <= 2147483647. Received ${r}`);
  return n = n.toUpperCase(), n === "LE" ? (e[t] = r & 255, e[t + 1] = r >> 8 & 255, e[t + 2] = r >> 16 & 255, e[t + 3] = r >> 24 & 255) : (e[t] = r >> 24 & 255, e[t + 1] = r >> 16 & 255, e[t + 2] = r >> 8 & 255, e[t + 3] = r & 255), t + 4;
}
function nL(e, t, r, n) {
  if (t + 8 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r > 0x7fffffffffffffffn || r < -0x8000000000000000n)
    throw new Error(`The value of "value" is out of range. It must be >= ${-0x8000000000000000n} and <= ${0x7fffffffffffffffn}. Received ${r}`);
  return n = n.toUpperCase(), n === "LE" ? (e[t] = Number(r & 0xffn), e[t + 1] = Number(r >> 8n & 0xffn), e[t + 2] = Number(r >> 16n & 0xffn), e[t + 3] = Number(r >> 24n & 0xffn), e[t + 4] = Number(r >> 32n & 0xffn), e[t + 5] = Number(r >> 40n & 0xffn), e[t + 6] = Number(r >> 48n & 0xffn), e[t + 7] = Number(r >> 56n & 0xffn)) : (e[t] = Number(r >> 56n & 0xffn), e[t + 1] = Number(r >> 48n & 0xffn), e[t + 2] = Number(r >> 40n & 0xffn), e[t + 3] = Number(r >> 32n & 0xffn), e[t + 4] = Number(r >> 24n & 0xffn), e[t + 5] = Number(r >> 16n & 0xffn), e[t + 6] = Number(r >> 8n & 0xffn), e[t + 7] = Number(r & 0xffn)), t + 8;
}
function NJ(e, t, r) {
  if (t + 4 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r = r.toUpperCase(), r === "LE") {
    const n = e[t] + (e[t + 1] << 8) + (e[t + 2] << 16) + (e[t + 3] << 24 >>> 0);
    return e[t + 3] <= 127 ? n : n - 4294967296;
  } else {
    const n = (e[t] << 24 >>> 0) + (e[t + 1] << 16) + (e[t + 2] << 8) + e[t + 3];
    return e[t] <= 127 ? n : n - 4294967296;
  }
}
function oL(e, t, r) {
  if (t + 8 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  r = r.toUpperCase();
  let n = 0n;
  if (r === "LE")
    return n = (n << 8n) + BigInt(e[t + 7]), n = (n << 8n) + BigInt(e[t + 6]), n = (n << 8n) + BigInt(e[t + 5]), n = (n << 8n) + BigInt(e[t + 4]), n = (n << 8n) + BigInt(e[t + 3]), n = (n << 8n) + BigInt(e[t + 2]), n = (n << 8n) + BigInt(e[t + 1]), n = (n << 8n) + BigInt(e[t]), e[t + 7] <= 127 ? n : n - 0x10000000000000000n;
  {
    let o = 0n;
    return o = (o << 8n) + BigInt(e[t]), o = (o << 8n) + BigInt(e[t + 1]), o = (o << 8n) + BigInt(e[t + 2]), o = (o << 8n) + BigInt(e[t + 3]), o = (o << 8n) + BigInt(e[t + 4]), o = (o << 8n) + BigInt(e[t + 5]), o = (o << 8n) + BigInt(e[t + 6]), o = (o << 8n) + BigInt(e[t + 7]), e[t] <= 127 ? o : o - 0x10000000000000000n;
  }
}
function iL(e) {
  return e < on.OP_PUSHDATA1 ? 1 : e <= 255 ? 2 : e <= 65535 ? 3 : 5;
}
function $J(e, t, r) {
  const n = iL(t);
  return n === 1 ? ts(e, r, t) : n === 2 ? (ts(e, r, on.OP_PUSHDATA1), ts(e, r + 1, t)) : n === 3 ? (ts(e, r, on.OP_PUSHDATA2), PJ(e, r + 1, t, "LE")) : (ts(e, r, on.OP_PUSHDATA4), p2(e, r + 1, t, "LE")), n;
}
function UJ(e, t) {
  const r = nf(e, t);
  let n, o;
  if (r < on.OP_PUSHDATA1)
    n = r, o = 1;
  else if (r === on.OP_PUSHDATA1) {
    if (t + 2 > e.length) return null;
    n = nf(e, t + 1), o = 2;
  } else if (r === on.OP_PUSHDATA2) {
    if (t + 3 > e.length) return null;
    n = BJ(e, t + 1, "LE"), o = 3;
  } else {
    if (t + 5 > e.length) return null;
    if (r !== on.OP_PUSHDATA4) throw new Error("Unexpected opcode");
    n = hg(e, t + 1, "LE"), o = 5;
  }
  return {
    opcode: r,
    number: n,
    size: o
  };
}
function RJ(e) {
  return e > 2147483647 ? 5 : e > 8388607 ? 4 : e > 32767 ? 3 : e > 127 ? 2 : e > 0 ? 1 : 0;
}
function zJ(e) {
  let t = Math.abs(e);
  const r = RJ(t), n = new Uint8Array(r), o = e < 0;
  for (let i = 0; i < r; ++i)
    ts(n, i, t & 255), t >>= 8;
  return n[r - 1] & 128 ? ts(n, r - 1, o ? 128 : 0) : o && (n[r - 1] |= 128), n;
}
function jJ(e) {
  return {
    lang: (e == null ? void 0 : e.lang) ?? void 0,
    message: e == null ? void 0 : e.message,
    abortEarly: (e == null ? void 0 : e.abortEarly) ?? void 0,
    abortPipeEarly: (e == null ? void 0 : e.abortPipeEarly) ?? void 0
  };
}
function LJ(e, t) {
  var r;
  return (r = void 0) == null ? void 0 : r.get(t);
}
function fw(e) {
  var t, r;
  const n = typeof e;
  return n === "string" ? `"${e}"` : n === "number" || n === "bigint" || n === "boolean" ? `${e}` : n === "object" || n === "function" ? (e && ((r = (t = Object.getPrototypeOf(e)) == null ? void 0 : t.constructor) == null ? void 0 : r.name)) ?? "null" : n;
}
function Fi(e, t, r, n, o) {
  const i = o && "input" in o ? o.input : r.value, a = (o == null ? void 0 : o.expected) ?? e.expects ?? null, u = (o == null ? void 0 : o.received) ?? fw(i), l = {
    kind: e.kind,
    type: e.type,
    input: i,
    expected: a,
    received: u,
    message: `Invalid ${t}: ${a ? `Expected ${a} but r` : "R"}eceived ${u}`,
    // @ts-expect-error
    requirement: e.requirement,
    path: o == null ? void 0 : o.path,
    issues: o == null ? void 0 : o.issues,
    lang: n.lang,
    abortEarly: n.abortEarly,
    abortPipeEarly: n.abortPipeEarly
  }, d = e.kind === "schema", f = (o == null ? void 0 : o.message) ?? // @ts-expect-error
  e.message ?? LJ(e.reference, l.lang) ?? (d ? (l.lang, void 0) : null) ?? n.message ?? (l.lang, void 0);
  f && (l.message = typeof f == "function" ? f(l) : f), d && (r.typed = !1), r.issues ? r.issues.push(l) : r.issues = [l];
}
function HJ(e, t) {
  const r = [...new Set(e)];
  return r.length > 1 ? `(${r.join(` ${t} `)})` : r[0] ?? "never";
}
var FJ = class extends Error {
  /**
   * Creates a Valibot error with useful information.
   *
   * @param issues The error issues.
   */
  constructor(t) {
    super(t[0].message), st(this, "issues"), this.name = "ValiError", this.issues = t;
  }
};
function aL(e, t) {
  return {
    kind: "validation",
    type: "every_item",
    reference: aL,
    async: !1,
    expects: null,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && !r.value.every(this.requirement) && Fi(this, "item", r, n), r;
    }
  };
}
function IP(e) {
  return {
    kind: "validation",
    type: "integer",
    reference: IP,
    async: !1,
    expects: null,
    requirement: Number.isInteger,
    message: e,
    _run(t, r) {
      return t.typed && !this.requirement(t.value) && Fi(this, "integer", t, r), t;
    }
  };
}
function sL(e, t) {
  return {
    kind: "validation",
    type: "length",
    reference: sL,
    async: !1,
    expects: `${e}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && r.value.length !== this.requirement && Fi(this, "length", r, n, {
        received: `${r.value.length}`
      }), r;
    }
  };
}
function $5(e, t) {
  return {
    kind: "validation",
    type: "max_value",
    reference: $5,
    async: !1,
    expects: `<=${e instanceof Date ? e.toJSON() : fw(e)}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && r.value > this.requirement && Fi(this, "value", r, n, {
        received: r.value instanceof Date ? r.value.toJSON() : fw(r.value)
      }), r;
    }
  };
}
function U5(e, t) {
  return {
    kind: "validation",
    type: "min_value",
    reference: U5,
    async: !1,
    expects: `>=${e instanceof Date ? e.toJSON() : fw(e)}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && r.value < this.requirement && Fi(this, "value", r, n, {
        received: r.value instanceof Date ? r.value.toJSON() : fw(r.value)
      }), r;
    }
  };
}
function uL(e, t) {
  return {
    kind: "validation",
    type: "regex",
    reference: uL,
    async: !1,
    expects: `${e}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && !this.requirement.test(r.value) && Fi(this, "format", r, n), r;
    }
  };
}
function OP(e, t, r) {
  return typeof e.default == "function" ? (
    // @ts-expect-error
    e.default(t, r)
  ) : (
    // @ts-expect-error
    e.default
  );
}
function R5(e, t) {
  return !e._run({ typed: !1, value: t }, { abortEarly: !0 }).issues;
}
function cL() {
  return {
    kind: "schema",
    type: "any",
    reference: cL,
    expects: "any",
    async: !1,
    _run(e) {
      return e.typed = !0, e;
    }
  };
}
function Ia(e, t) {
  return {
    kind: "schema",
    type: "array",
    reference: Ia,
    expects: "Array",
    async: !1,
    item: e,
    message: t,
    _run(r, n) {
      var o;
      const i = r.value;
      if (Array.isArray(i)) {
        r.typed = !0, r.value = [];
        for (let a = 0; a < i.length; a++) {
          const u = i[a], l = this.item._run({ typed: !1, value: u }, n);
          if (l.issues) {
            const d = {
              type: "array",
              origin: "value",
              input: i,
              key: a,
              value: u
            };
            for (const f of l.issues)
              f.path ? f.path.unshift(d) : f.path = [d], (o = r.issues) == null || o.push(f);
            if (r.issues || (r.issues = l.issues), n.abortEarly) {
              r.typed = !1;
              break;
            }
          }
          l.typed || (r.typed = !1), r.value.push(l.value);
        }
      } else
        Fi(this, "type", r, n);
      return r;
    }
  };
}
function lL(e) {
  return {
    kind: "schema",
    type: "bigint",
    reference: lL,
    expects: "bigint",
    async: !1,
    message: e,
    _run(t, r) {
      return typeof t.value == "bigint" ? t.typed = !0 : Fi(this, "type", t, r), t;
    }
  };
}
function Hu(e, t) {
  return {
    kind: "schema",
    type: "custom",
    reference: Hu,
    expects: "unknown",
    async: !1,
    check: e,
    message: t,
    _run(r, n) {
      return this.check(r.value) ? r.typed = !0 : Fi(this, "type", r, n), r;
    }
  };
}
function z5(e, t) {
  return {
    kind: "schema",
    type: "instance",
    reference: z5,
    expects: e.name,
    async: !1,
    class: e,
    message: t,
    _run(r, n) {
      return r.value instanceof this.class ? r.typed = !0 : Fi(this, "type", r, n), r;
    }
  };
}
function pI(e, ...t) {
  const r = {
    kind: "schema",
    type: "nullable",
    reference: pI,
    expects: `(${e.expects} | null)`,
    async: !1,
    wrapped: e,
    _run(n, o) {
      return n.value === null && ("default" in this && (n.value = OP(
        this,
        n,
        o
      )), n.value === null) ? (n.typed = !0, n) : this.wrapped._run(n, o);
    }
  };
  return 0 in t && (r.default = t[0]), r;
}
function fL(e, ...t) {
  const r = {
    kind: "schema",
    type: "nullish",
    reference: fL,
    expects: `(${e.expects} | null | undefined)`,
    async: !1,
    wrapped: e,
    _run(n, o) {
      return (n.value === null || n.value === void 0) && ("default" in this && (n.value = OP(
        this,
        n,
        o
      )), n.value === null || n.value === void 0) ? (n.typed = !0, n) : this.wrapped._run(n, o);
    }
  };
  return 0 in t && (r.default = t[0]), r;
}
function xa(e) {
  return {
    kind: "schema",
    type: "number",
    reference: xa,
    expects: "number",
    async: !1,
    message: e,
    _run(t, r) {
      return typeof t.value == "number" && !isNaN(t.value) ? t.typed = !0 : Fi(this, "type", t, r), t;
    }
  };
}
function So(e, t) {
  return {
    kind: "schema",
    type: "object",
    reference: So,
    expects: "Object",
    async: !1,
    entries: e,
    message: t,
    _run(r, n) {
      var o;
      const i = r.value;
      if (i && typeof i == "object") {
        r.typed = !0, r.value = {};
        for (const a in this.entries) {
          const u = i[a], l = this.entries[a]._run(
            { typed: !1, value: u },
            n
          );
          if (l.issues) {
            const d = {
              type: "object",
              origin: "value",
              input: i,
              key: a,
              value: u
            };
            for (const f of l.issues)
              f.path ? f.path.unshift(d) : f.path = [d], (o = r.issues) == null || o.push(f);
            if (r.issues || (r.issues = l.issues), n.abortEarly) {
              r.typed = !1;
              break;
            }
          }
          l.typed || (r.typed = !1), (l.value !== void 0 || a in i) && (r.value[a] = l.value);
        }
      } else
        Fi(this, "type", r, n);
      return r;
    }
  };
}
function r3(e, ...t) {
  const r = {
    kind: "schema",
    type: "optional",
    reference: r3,
    expects: `(${e.expects} | undefined)`,
    async: !1,
    wrapped: e,
    _run(n, o) {
      return n.value === void 0 && ("default" in this && (n.value = OP(
        this,
        n,
        o
      )), n.value === void 0) ? (n.typed = !0, n) : this.wrapped._run(n, o);
    }
  };
  return 0 in t && (r.default = t[0]), r;
}
function v0(e) {
  return {
    kind: "schema",
    type: "string",
    reference: v0,
    expects: "string",
    async: !1,
    message: e,
    _run(t, r) {
      return typeof t.value == "string" ? t.typed = !0 : Fi(this, "type", t, r), t;
    }
  };
}
function bc(e, t) {
  return {
    kind: "schema",
    type: "tuple",
    reference: bc,
    expects: "Array",
    async: !1,
    items: e,
    message: t,
    _run(r, n) {
      var o;
      const i = r.value;
      if (Array.isArray(i)) {
        r.typed = !0, r.value = [];
        for (let a = 0; a < this.items.length; a++) {
          const u = i[a], l = this.items[a]._run(
            { typed: !1, value: u },
            n
          );
          if (l.issues) {
            const d = {
              type: "array",
              origin: "value",
              input: i,
              key: a,
              value: u
            };
            for (const f of l.issues)
              f.path ? f.path.unshift(d) : f.path = [d], (o = r.issues) == null || o.push(f);
            if (r.issues || (r.issues = l.issues), n.abortEarly) {
              r.typed = !1;
              break;
            }
          }
          l.typed || (r.typed = !1), r.value.push(l.value);
        }
      } else
        Fi(this, "type", r, n);
      return r;
    }
  };
}
function i$(e) {
  let t;
  if (e)
    for (const r of e)
      t ? t.push(...r.issues) : t = r.issues;
  return t;
}
function PP(e, t) {
  return {
    kind: "schema",
    type: "union",
    reference: PP,
    expects: HJ(
      e.map((r) => r.expects),
      "|"
    ),
    async: !1,
    options: e,
    message: t,
    _run(r, n) {
      let o, i, a;
      for (const u of this.options) {
        const l = u._run(
          { typed: !1, value: r.value },
          n
        );
        if (l.typed)
          if (l.issues)
            i ? i.push(l) : i = [l];
          else {
            o = l;
            break;
          }
        else
          a ? a.push(l) : a = [l];
      }
      if (o)
        return o;
      if (i) {
        if (i.length === 1)
          return i[0];
        Fi(this, "type", r, n, {
          issues: i$(i)
        }), r.typed = !0;
      } else {
        if ((a == null ? void 0 : a.length) === 1)
          return a[0];
        Fi(this, "type", r, n, {
          issues: i$(a)
        });
      }
      return r;
    }
  };
}
function Qn(e, t, r) {
  const n = e._run(
    { typed: !1, value: t },
    jJ(r)
  );
  if (n.issues)
    throw new FJ(n.issues);
  return n.value;
}
function Ud(e, t) {
  const r = {};
  for (const n in e.entries)
    r[n] = r3(e.entries[n]);
  return { ...e, entries: r };
}
function pg(...e) {
  return {
    ...e[0],
    pipe: e,
    _run(t, r) {
      for (const n of e)
        if (n.kind !== "metadata") {
          if (t.issues && (n.kind === "schema" || n.kind === "transformation")) {
            t.typed = !1;
            break;
          }
          (!t.issues || !r.abortEarly && !r.abortPipeEarly) && (t = n._run(t, r));
        }
      return t;
    }
  };
}
const a$ = new Uint8Array(32), s$ = mf(
  "fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"
), Ko = (e) => pg(z5(Uint8Array), sL(e));
function dw(e, t) {
  return e.length !== t.length ? !1 : e.every((r, n) => ft(r, t[n]) === 0);
}
function Ou(e) {
  if (!(e instanceof Uint8Array) || e.length < 33) return !1;
  const t = e[0], r = e.slice(1, 33);
  if (ft(a$, r) === 0 || ft(r, s$) >= 0) return !1;
  if ((t === 2 || t === 3) && e.length === 33)
    return !0;
  const n = e.slice(33);
  return ft(a$, n) === 0 || ft(n, s$) >= 0 ? !1 : t === 4 && e.length === 65;
}
const B8 = 254;
function CP(e) {
  return !e || !("output" in e) || !(e.output instanceof Uint8Array) ? !1 : e.version !== void 0 ? (e.version & B8) === e.version : !0;
}
function dL(e) {
  return Array.isArray(e) ? e.length !== 2 ? !1 : e.every((t) => dL(t)) : CP(e);
}
const MJ = Ko(32), DJ = Ko(20), u$ = Ko(32), rn = z5(Uint8Array);
pg(v0(), uL(/^([0-9a-f]{2})+$/i));
const KJ = pg(
  xa(),
  IP(),
  U5(0),
  $5(255)
), Ml = pg(
  xa(),
  IP(),
  U5(0),
  $5(4294967295)
), mS = pg(
  lL(),
  U5(0n),
  $5(0x7fffffffffffffffn)
), c$ = (e) => So(
  Object.entries(e).reduce(
    (t, r) => ({ ...t, [r[0]]: fL(r[1]) }),
    {}
  )
), l$ = new Uint8Array(1);
function f$(e) {
  let t = 0;
  for (; e[t] === 0; ) ++t;
  return t === e.length ? l$ : (e = e.slice(t), e[0] & 128 ? io([l$, e]) : e);
}
function d$(e) {
  e[0] === 0 && (e = e.slice(1));
  const t = new Uint8Array(32), r = Math.max(0, 32 - e.length);
  return t.set(e, r), t;
}
function qJ(e) {
  const t = nf(e, e.length - 1);
  if (!NP(t))
    throw new Error("Invalid hashType " + t);
  const r = AJ(e.subarray(0, -1)), n = d$(r.r), o = d$(r.s);
  return { signature: io([n, o]), hashType: t };
}
function VJ(e, t) {
  if (Qn(
    So({
      signature: Ko(64),
      hashType: KJ
    }),
    { signature: e, hashType: t }
  ), !NP(t))
    throw new Error("Invalid hashType " + t);
  const r = new Uint8Array(1);
  ts(r, 0, t);
  const n = f$(e.slice(0, 32)), o = f$(e.slice(32, 64));
  return io([xJ(n, o), r]);
}
const GJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: qJ,
  encode: VJ
}, Symbol.toStringTag, { value: "Module" })), hL = on.OP_RESERVED, pL = Ia(PP([z5(Uint8Array), xa()]));
function WJ(e) {
  return R5(xa(), e) && (e === on.OP_0 || e >= on.OP_1 && e <= on.OP_16 || e === on.OP_1NEGATE);
}
function gL(e) {
  return R5(rn, e) || WJ(e);
}
function BP(e) {
  return R5(pg(cL(), aL(gL)), e);
}
function mL(e) {
  return e.length - e.filter(gL).length;
}
function n3(e) {
  if (e.length === 0) return on.OP_0;
  if (e.length === 1) {
    if (e[0] >= 1 && e[0] <= 16) return hL + e[0];
    if (e[0] === 129) return on.OP_1NEGATE;
  }
}
function yL(e) {
  return e instanceof Uint8Array;
}
function ZJ(e) {
  return R5(pL, e);
}
function o3(e) {
  return e instanceof Uint8Array;
}
function Oa(e) {
  if (yL(e)) return e;
  Qn(pL, e);
  const t = e.reduce((o, i) => o3(i) ? i.length === 1 && n3(i) !== void 0 ? o + 1 : o + iL(i.length) + i.length : o + 1, 0), r = new Uint8Array(t);
  let n = 0;
  if (e.forEach((o) => {
    if (o3(o)) {
      const i = n3(o);
      if (i !== void 0) {
        ts(r, n, i), n += 1;
        return;
      }
      n += $J(r, o.length, n), r.set(o, n), n += o.length;
    } else
      ts(r, n, o), n += 1;
  }), n !== r.length) throw new Error("Could not decode chunks");
  return r;
}
function to(e) {
  if (ZJ(e)) return e;
  Qn(rn, e);
  const t = [];
  let r = 0;
  for (; r < e.length; ) {
    const n = e[r];
    if (n > on.OP_0 && n <= on.OP_PUSHDATA4) {
      const o = UJ(e, r);
      if (o === null || (r += o.size, r + o.number > e.length)) return null;
      const i = e.slice(r, r + o.number);
      r += o.number;
      const a = n3(i);
      a !== void 0 ? t.push(a) : t.push(i);
    } else
      t.push(n), r += 1;
  }
  return t;
}
function XJ(e) {
  if (yL(e) && (e = to(e)), !e)
    throw new Error("Could not convert invalid chunks to ASM");
  return e.map((t) => {
    if (o3(t)) {
      const r = n3(t);
      if (r === void 0) return Gt(t);
      t = r;
    }
    return Jj[t];
  }).join(" ");
}
function YJ(e) {
  return e = to(e), Qn(Hu(BP), e), e.map((t) => o3(t) ? t : t === on.OP_0 ? new Uint8Array(0) : zJ(t - hL));
}
function JJ(e) {
  return Ou(e);
}
function NP(e) {
  const t = e & -129;
  return t > 0 && t < 4;
}
function of(e) {
  return !(e instanceof Uint8Array) || !NP(e[e.length - 1]) ? !1 : _J(e.slice(0, -1));
}
const Jb = GJ;
function Mt(e, t, r) {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !0,
    get() {
      const n = r.call(this);
      return this[t] = n, n;
    },
    set(n) {
      Object.defineProperty(this, t, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      });
    }
  });
}
function js(e) {
  let t;
  return () => (t !== void 0 || (t = e()), t);
}
const Z0 = on, Tv = Z0.OP_RESERVED;
function j5(e, t) {
  if (!e.input && !e.output && !(e.pubkeys && e.m !== void 0) && !e.signatures)
    throw new TypeError("Not enough data");
  t = Object.assign({ validate: !0 }, t || {});
  function r(u) {
    return of(u) || (t.allowIncomplete && u === Z0.OP_0) !== void 0;
  }
  Qn(
    Ud(
      So({
        network: So({}),
        m: xa(),
        n: xa(),
        output: rn,
        pubkeys: Ia(Hu(Ou), "Received invalid pubkey"),
        signatures: Ia(
          Hu(r),
          "Expected signature to be of type isAcceptableSignature"
        ),
        input: rn
      })
    ),
    e
  );
  const n = { network: e.network || qu };
  let o = [], i = !1;
  function a(u) {
    i || (i = !0, o = to(u), n.m = o[0] - Tv, n.n = o[o.length - 2] - Tv, n.pubkeys = o.slice(1, -2));
  }
  if (Mt(n, "output", () => {
    if (e.m && n.n && e.pubkeys)
      return Oa(
        [].concat(
          Tv + e.m,
          e.pubkeys,
          Tv + n.n,
          Z0.OP_CHECKMULTISIG
        )
      );
  }), Mt(n, "m", () => {
    if (n.output)
      return a(n.output), n.m;
  }), Mt(n, "n", () => {
    if (n.pubkeys)
      return n.pubkeys.length;
  }), Mt(n, "pubkeys", () => {
    if (e.output)
      return a(e.output), n.pubkeys;
  }), Mt(n, "signatures", () => {
    if (e.input)
      return to(e.input).slice(1);
  }), Mt(n, "input", () => {
    if (e.signatures)
      return Oa([Z0.OP_0].concat(e.signatures));
  }), Mt(n, "witness", () => {
    if (n.input)
      return [];
  }), Mt(n, "name", () => {
    if (!(!n.m || !n.n))
      return `p2ms(${n.m} of ${n.n})`;
  }), t.validate) {
    if (e.output) {
      if (a(e.output), Qn(xa(), o[0], { message: "Output is invalid" }), Qn(xa(), o[o.length - 2], {
        message: "Output is invalid"
      }), o[o.length - 1] !== Z0.OP_CHECKMULTISIG)
        throw new TypeError("Output is invalid");
      if (n.m <= 0 || n.n > 16 || n.m > n.n || n.n !== o.length - 3)
        throw new TypeError("Output is invalid");
      if (!n.pubkeys.every((u) => Ou(u)))
        throw new TypeError("Output is invalid");
      if (e.m !== void 0 && e.m !== n.m) throw new TypeError("m mismatch");
      if (e.n !== void 0 && e.n !== n.n) throw new TypeError("n mismatch");
      if (e.pubkeys && !dw(e.pubkeys, n.pubkeys))
        throw new TypeError("Pubkeys mismatch");
    }
    if (e.pubkeys) {
      if (e.n !== void 0 && e.n !== e.pubkeys.length)
        throw new TypeError("Pubkey count mismatch");
      if (n.n = e.pubkeys.length, n.n < n.m) throw new TypeError("Pubkey count cannot be less than m");
    }
    if (e.signatures) {
      if (e.signatures.length < n.m)
        throw new TypeError("Not enough signatures provided");
      if (e.signatures.length > n.m)
        throw new TypeError("Too many signatures provided");
    }
    if (e.input) {
      if (e.input[0] !== Z0.OP_0) throw new TypeError("Input is invalid");
      if (n.signatures.length === 0 || !n.signatures.every(r))
        throw new TypeError("Input has invalid signature(s)");
      if (e.signatures && !dw(e.signatures, n.signatures))
        throw new TypeError("Signature mismatch");
      if (e.m !== void 0 && e.m !== e.signatures.length)
        throw new TypeError("Signature count mismatch");
    }
  }
  return Object.assign(n, e);
}
const h$ = on;
function bL(e, t) {
  if (!e.input && !e.output && !e.pubkey && !e.input && !e.signature)
    throw new TypeError("Not enough data");
  t = Object.assign({ validate: !0 }, t || {}), Qn(
    Ud(
      So({
        network: So({}),
        output: rn,
        pubkey: Hu(Ou, "invalid pubkey"),
        signature: Hu(
          of,
          "Expected signature to be of type isCanonicalScriptSignature"
        ),
        input: rn
      })
    ),
    e
  );
  const r = js(() => to(e.input)), n = { name: "p2pk", network: e.network || qu };
  if (Mt(n, "output", () => {
    if (e.pubkey)
      return Oa([e.pubkey, h$.OP_CHECKSIG]);
  }), Mt(n, "pubkey", () => {
    if (e.output)
      return e.output.slice(1, -1);
  }), Mt(n, "signature", () => {
    if (e.input)
      return r()[0];
  }), Mt(n, "input", () => {
    if (e.signature)
      return Oa([e.signature]);
  }), Mt(n, "witness", () => {
    if (n.input)
      return [];
  }), t.validate) {
    if (e.output) {
      if (e.output[e.output.length - 1] !== h$.OP_CHECKSIG)
        throw new TypeError("Output is invalid");
      if (!Ou(n.pubkey)) throw new TypeError("Output pubkey is invalid");
      if (e.pubkey && ft(e.pubkey, n.pubkey) !== 0)
        throw new TypeError("Pubkey mismatch");
    }
    if (e.signature && e.input && ft(e.input, n.input) !== 0)
      throw new TypeError("Signature mismatch");
    if (e.input) {
      if (r().length !== 1) throw new TypeError("Input is invalid");
      if (!of(n.signature))
        throw new TypeError("Input has invalid signature");
    }
  }
  return Object.assign(n, e);
}
function p$(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error("positive integer expected, got " + e);
}
function QJ(e) {
  return e instanceof Uint8Array || ArrayBuffer.isView(e) && e.constructor.name === "Uint8Array";
}
function $P(e, ...t) {
  if (!QJ(e))
    throw new Error("Uint8Array expected");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error("Uint8Array expected of length " + t + ", got length=" + e.length);
}
function eQ(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  p$(e.outputLen), p$(e.blockLen);
}
function i3(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function tQ(e, t) {
  $P(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error("digestInto() expects output buffer of length at least " + r);
}
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function yS(e) {
  return new DataView(e.buffer, e.byteOffset, e.byteLength);
}
function ec(e, t) {
  return e << 32 - t | e >>> t;
}
function Iv(e, t) {
  return e << t | e >>> 32 - t >>> 0;
}
function rQ(e) {
  if (typeof e != "string")
    throw new Error("utf8ToBytes expected string, got " + typeof e);
  return new Uint8Array(new TextEncoder().encode(e));
}
function UP(e) {
  return typeof e == "string" && (e = rQ(e)), $P(e), e;
}
let wL = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function RP(e) {
  const t = (n) => e().update(UP(n)).digest(), r = e();
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = () => e(), t;
}
function nQ(e, t, r, n) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, r, n);
  const o = BigInt(32), i = BigInt(4294967295), a = Number(r >> o & i), u = Number(r & i), l = n ? 4 : 0, d = n ? 0 : 4;
  e.setUint32(t + l, a, n), e.setUint32(t + d, u, n);
}
function oQ(e, t, r) {
  return e & t ^ ~e & r;
}
function iQ(e, t, r) {
  return e & t ^ e & r ^ t & r;
}
let zP = class extends wL {
  constructor(e, t, r, n) {
    super(), this.blockLen = e, this.outputLen = t, this.padOffset = r, this.isLE = n, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = yS(this.buffer);
  }
  update(e) {
    i3(this);
    const { view: t, buffer: r, blockLen: n } = this;
    e = UP(e);
    const o = e.length;
    for (let i = 0; i < o; ) {
      const a = Math.min(n - this.pos, o - i);
      if (a === n) {
        const u = yS(e);
        for (; n <= o - i; i += n)
          this.process(u, i);
        continue;
      }
      r.set(e.subarray(i, i + a), this.pos), this.pos += a, i += a, this.pos === n && (this.process(t, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    i3(this), tQ(e, this), this.finished = !0;
    const { buffer: t, view: r, blockLen: n, isLE: o } = this;
    let { pos: i } = this;
    t[i++] = 128, this.buffer.subarray(i).fill(0), this.padOffset > n - i && (this.process(r, 0), i = 0);
    for (let f = i; f < n; f++)
      t[f] = 0;
    nQ(r, n - 8, BigInt(this.length * 8), o), this.process(r, 0);
    const a = yS(e), u = this.outputLen;
    if (u % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const l = u / 4, d = this.get();
    if (l > d.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let f = 0; f < l; f++)
      a.setUint32(4 * f, d[f], o);
  }
  digest() {
    const { buffer: e, outputLen: t } = this;
    this.digestInto(e);
    const r = e.slice(0, t);
    return this.destroy(), r;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: t, buffer: r, length: n, finished: o, destroyed: i, pos: a } = this;
    return e.length = n, e.pos = a, e.finished = o, e.destroyed = i, n % t && e.buffer.set(r), e;
  }
};
const aQ = /* @__PURE__ */ new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]), vL = /* @__PURE__ */ new Uint8Array(new Array(16).fill(0).map((e, t) => t)), sQ = /* @__PURE__ */ vL.map((e) => (9 * e + 5) % 16);
let jP = [vL], LP = [sQ];
for (let e = 0; e < 4; e++)
  for (let t of [jP, LP])
    t.push(t[e].map((r) => aQ[r]));
const EL = /* @__PURE__ */ [
  [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
  [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
  [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
  [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
  [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
].map((e) => new Uint8Array(e)), uQ = /* @__PURE__ */ jP.map((e, t) => e.map((r) => EL[t][r])), cQ = /* @__PURE__ */ LP.map((e, t) => e.map((r) => EL[t][r])), lQ = /* @__PURE__ */ new Uint32Array([
  0,
  1518500249,
  1859775393,
  2400959708,
  2840853838
]), fQ = /* @__PURE__ */ new Uint32Array([
  1352829926,
  1548603684,
  1836072691,
  2053994217,
  0
]);
function g$(e, t, r, n) {
  return e === 0 ? t ^ r ^ n : e === 1 ? t & r | ~t & n : e === 2 ? (t | ~r) ^ n : e === 3 ? t & n | r & ~n : t ^ (r | ~n);
}
const Ov = /* @__PURE__ */ new Uint32Array(16);
let dQ = class extends zP {
  constructor() {
    super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
  }
  get() {
    const { h0: t, h1: r, h2: n, h3: o, h4: i } = this;
    return [t, r, n, o, i];
  }
  set(t, r, n, o, i) {
    this.h0 = t | 0, this.h1 = r | 0, this.h2 = n | 0, this.h3 = o | 0, this.h4 = i | 0;
  }
  process(t, r) {
    for (let b = 0; b < 16; b++, r += 4)
      Ov[b] = t.getUint32(r, !0);
    let n = this.h0 | 0, o = n, i = this.h1 | 0, a = i, u = this.h2 | 0, l = u, d = this.h3 | 0, f = d, h = this.h4 | 0, g = h;
    for (let b = 0; b < 5; b++) {
      const w = 4 - b, E = lQ[b], _ = fQ[b], O = jP[b], C = LP[b], I = uQ[b], S = cQ[b];
      for (let T = 0; T < 16; T++) {
        const A = Iv(n + g$(b, i, u, d) + Ov[O[T]] + E, I[T]) + h | 0;
        n = h, h = d, d = Iv(u, 10) | 0, u = i, i = A;
      }
      for (let T = 0; T < 16; T++) {
        const A = Iv(o + g$(w, a, l, f) + Ov[C[T]] + _, S[T]) + g | 0;
        o = g, g = f, f = Iv(l, 10) | 0, l = a, a = A;
      }
    }
    this.set(this.h1 + u + f | 0, this.h2 + d + g | 0, this.h3 + h + o | 0, this.h4 + n + a | 0, this.h0 + i + l | 0);
  }
  roundClean() {
    Ov.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
  }
};
const _L = /* @__PURE__ */ RP(() => new dQ()), hQ = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), kf = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), Sf = /* @__PURE__ */ new Uint32Array(64);
let pQ = class extends zP {
  constructor() {
    super(64, 32, 8, !1), this.A = kf[0] | 0, this.B = kf[1] | 0, this.C = kf[2] | 0, this.D = kf[3] | 0, this.E = kf[4] | 0, this.F = kf[5] | 0, this.G = kf[6] | 0, this.H = kf[7] | 0;
  }
  get() {
    const { A: t, B: r, C: n, D: o, E: i, F: a, G: u, H: l } = this;
    return [t, r, n, o, i, a, u, l];
  }
  // prettier-ignore
  set(t, r, n, o, i, a, u, l) {
    this.A = t | 0, this.B = r | 0, this.C = n | 0, this.D = o | 0, this.E = i | 0, this.F = a | 0, this.G = u | 0, this.H = l | 0;
  }
  process(t, r) {
    for (let h = 0; h < 16; h++, r += 4)
      Sf[h] = t.getUint32(r, !1);
    for (let h = 16; h < 64; h++) {
      const g = Sf[h - 15], b = Sf[h - 2], w = ec(g, 7) ^ ec(g, 18) ^ g >>> 3, E = ec(b, 17) ^ ec(b, 19) ^ b >>> 10;
      Sf[h] = E + Sf[h - 7] + w + Sf[h - 16] | 0;
    }
    let { A: n, B: o, C: i, D: a, E: u, F: l, G: d, H: f } = this;
    for (let h = 0; h < 64; h++) {
      const g = ec(u, 6) ^ ec(u, 11) ^ ec(u, 25), b = f + g + oQ(u, l, d) + hQ[h] + Sf[h] | 0, w = (ec(n, 2) ^ ec(n, 13) ^ ec(n, 22)) + iQ(n, o, i) | 0;
      f = d, d = l, l = u, u = a + b | 0, a = i, i = o, o = n, n = b + w | 0;
    }
    n = n + this.A | 0, o = o + this.B | 0, i = i + this.C | 0, a = a + this.D | 0, u = u + this.E | 0, l = l + this.F | 0, d = d + this.G | 0, f = f + this.H | 0, this.set(n, o, i, a, u, l, d, f);
  }
  roundClean() {
    Sf.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
};
const ki = /* @__PURE__ */ RP(() => new pQ());
function Ql(e) {
  return _L(ki(e));
}
function mp(e) {
  return ki(ki(e));
}
const gQ = {
  "BIP0340/challenge": Uint8Array.from([
    123,
    181,
    45,
    122,
    159,
    239,
    88,
    50,
    62,
    177,
    191,
    122,
    64,
    125,
    179,
    130,
    210,
    243,
    242,
    216,
    27,
    177,
    34,
    79,
    73,
    254,
    81,
    143,
    109,
    72,
    211,
    124,
    123,
    181,
    45,
    122,
    159,
    239,
    88,
    50,
    62,
    177,
    191,
    122,
    64,
    125,
    179,
    130,
    210,
    243,
    242,
    216,
    27,
    177,
    34,
    79,
    73,
    254,
    81,
    143,
    109,
    72,
    211,
    124
  ]),
  "BIP0340/aux": Uint8Array.from([
    241,
    239,
    78,
    94,
    192,
    99,
    202,
    218,
    109,
    148,
    202,
    250,
    157,
    152,
    126,
    160,
    105,
    38,
    88,
    57,
    236,
    193,
    31,
    151,
    45,
    119,
    165,
    46,
    216,
    193,
    204,
    144,
    241,
    239,
    78,
    94,
    192,
    99,
    202,
    218,
    109,
    148,
    202,
    250,
    157,
    152,
    126,
    160,
    105,
    38,
    88,
    57,
    236,
    193,
    31,
    151,
    45,
    119,
    165,
    46,
    216,
    193,
    204,
    144
  ]),
  "BIP0340/nonce": Uint8Array.from([
    7,
    73,
    119,
    52,
    167,
    155,
    203,
    53,
    91,
    155,
    140,
    125,
    3,
    79,
    18,
    28,
    244,
    52,
    215,
    62,
    247,
    45,
    218,
    25,
    135,
    0,
    97,
    251,
    82,
    191,
    235,
    47,
    7,
    73,
    119,
    52,
    167,
    155,
    203,
    53,
    91,
    155,
    140,
    125,
    3,
    79,
    18,
    28,
    244,
    52,
    215,
    62,
    247,
    45,
    218,
    25,
    135,
    0,
    97,
    251,
    82,
    191,
    235,
    47
  ]),
  TapLeaf: Uint8Array.from([
    174,
    234,
    143,
    220,
    66,
    8,
    152,
    49,
    5,
    115,
    75,
    88,
    8,
    29,
    30,
    38,
    56,
    211,
    95,
    28,
    181,
    64,
    8,
    212,
    211,
    87,
    202,
    3,
    190,
    120,
    233,
    238,
    174,
    234,
    143,
    220,
    66,
    8,
    152,
    49,
    5,
    115,
    75,
    88,
    8,
    29,
    30,
    38,
    56,
    211,
    95,
    28,
    181,
    64,
    8,
    212,
    211,
    87,
    202,
    3,
    190,
    120,
    233,
    238
  ]),
  TapBranch: Uint8Array.from([
    25,
    65,
    161,
    242,
    229,
    110,
    185,
    95,
    162,
    169,
    241,
    148,
    190,
    92,
    1,
    247,
    33,
    111,
    51,
    237,
    130,
    176,
    145,
    70,
    52,
    144,
    208,
    91,
    245,
    22,
    160,
    21,
    25,
    65,
    161,
    242,
    229,
    110,
    185,
    95,
    162,
    169,
    241,
    148,
    190,
    92,
    1,
    247,
    33,
    111,
    51,
    237,
    130,
    176,
    145,
    70,
    52,
    144,
    208,
    91,
    245,
    22,
    160,
    21
  ]),
  TapSighash: Uint8Array.from([
    244,
    10,
    72,
    223,
    75,
    42,
    112,
    200,
    180,
    146,
    75,
    242,
    101,
    70,
    97,
    237,
    61,
    149,
    253,
    102,
    163,
    19,
    235,
    135,
    35,
    117,
    151,
    198,
    40,
    228,
    160,
    49,
    244,
    10,
    72,
    223,
    75,
    42,
    112,
    200,
    180,
    146,
    75,
    242,
    101,
    70,
    97,
    237,
    61,
    149,
    253,
    102,
    163,
    19,
    235,
    135,
    35,
    117,
    151,
    198,
    40,
    228,
    160,
    49
  ]),
  TapTweak: Uint8Array.from([
    232,
    15,
    225,
    99,
    156,
    156,
    160,
    80,
    227,
    175,
    27,
    57,
    193,
    67,
    198,
    62,
    66,
    156,
    188,
    235,
    21,
    217,
    64,
    251,
    181,
    197,
    161,
    244,
    175,
    87,
    197,
    233,
    232,
    15,
    225,
    99,
    156,
    156,
    160,
    80,
    227,
    175,
    27,
    57,
    193,
    67,
    198,
    62,
    66,
    156,
    188,
    235,
    21,
    217,
    64,
    251,
    181,
    197,
    161,
    244,
    175,
    87,
    197,
    233
  ]),
  "KeyAgg list": Uint8Array.from([
    72,
    28,
    151,
    28,
    60,
    11,
    70,
    215,
    240,
    178,
    117,
    174,
    89,
    141,
    78,
    44,
    126,
    215,
    49,
    156,
    89,
    74,
    92,
    110,
    199,
    158,
    160,
    212,
    153,
    2,
    148,
    240,
    72,
    28,
    151,
    28,
    60,
    11,
    70,
    215,
    240,
    178,
    117,
    174,
    89,
    141,
    78,
    44,
    126,
    215,
    49,
    156,
    89,
    74,
    92,
    110,
    199,
    158,
    160,
    212,
    153,
    2,
    148,
    240
  ]),
  "KeyAgg coefficient": Uint8Array.from([
    191,
    201,
    4,
    3,
    77,
    28,
    136,
    232,
    200,
    14,
    34,
    229,
    61,
    36,
    86,
    109,
    100,
    130,
    78,
    214,
    66,
    114,
    129,
    192,
    145,
    0,
    249,
    77,
    205,
    82,
    201,
    129,
    191,
    201,
    4,
    3,
    77,
    28,
    136,
    232,
    200,
    14,
    34,
    229,
    61,
    36,
    86,
    109,
    100,
    130,
    78,
    214,
    66,
    114,
    129,
    192,
    145,
    0,
    249,
    77,
    205,
    82,
    201,
    129
  ])
};
function L5(e, t) {
  return ki(io([gQ[e], t]));
}
function mQ(e) {
  if (e.length >= 255)
    throw new TypeError("Alphabet too long");
  const t = new Uint8Array(256);
  for (let d = 0; d < t.length; d++)
    t[d] = 255;
  for (let d = 0; d < e.length; d++) {
    const f = e.charAt(d), h = f.charCodeAt(0);
    if (t[h] !== 255)
      throw new TypeError(f + " is ambiguous");
    t[h] = d;
  }
  const r = e.length, n = e.charAt(0), o = Math.log(r) / Math.log(256), i = Math.log(256) / Math.log(r);
  function a(d) {
    if (d instanceof Uint8Array || (ArrayBuffer.isView(d) ? d = new Uint8Array(d.buffer, d.byteOffset, d.byteLength) : Array.isArray(d) && (d = Uint8Array.from(d))), !(d instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (d.length === 0)
      return "";
    let f = 0, h = 0, g = 0;
    const b = d.length;
    for (; g !== b && d[g] === 0; )
      g++, f++;
    const w = (b - g) * i + 1 >>> 0, E = new Uint8Array(w);
    for (; g !== b; ) {
      let C = d[g], I = 0;
      for (let S = w - 1; (C !== 0 || I < h) && S !== -1; S--, I++)
        C += 256 * E[S] >>> 0, E[S] = C % r >>> 0, C = C / r >>> 0;
      if (C !== 0)
        throw new Error("Non-zero carry");
      h = I, g++;
    }
    let _ = w - h;
    for (; _ !== w && E[_] === 0; )
      _++;
    let O = n.repeat(f);
    for (; _ < w; ++_)
      O += e.charAt(E[_]);
    return O;
  }
  function u(d) {
    if (typeof d != "string")
      throw new TypeError("Expected String");
    if (d.length === 0)
      return new Uint8Array();
    let f = 0, h = 0, g = 0;
    for (; d[f] === n; )
      h++, f++;
    const b = (d.length - f) * o + 1 >>> 0, w = new Uint8Array(b);
    for (; f < d.length; ) {
      const C = d.charCodeAt(f);
      if (C > 255)
        return;
      let I = t[C];
      if (I === 255)
        return;
      let S = 0;
      for (let T = b - 1; (I !== 0 || S < g) && T !== -1; T--, S++)
        I += r * w[T] >>> 0, w[T] = I % 256 >>> 0, I = I / 256 >>> 0;
      if (I !== 0)
        throw new Error("Non-zero carry");
      g = S, f++;
    }
    let E = b - g;
    for (; E !== b && w[E] === 0; )
      E++;
    const _ = new Uint8Array(h + (b - E));
    let O = h;
    for (; E !== b; )
      _[O++] = w[E++];
    return _;
  }
  function l(d) {
    const f = u(d);
    if (f)
      return f;
    throw new Error("Non-base" + r + " character");
  }
  return {
    encode: a,
    decodeUnsafe: u,
    decode: l
  };
}
var yQ = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
const bS = mQ(yQ);
function bQ(e) {
  function t(i) {
    var a = Uint8Array.from(i), u = e(a), l = a.length + 4, d = new Uint8Array(l);
    return d.set(a, 0), d.set(u.subarray(0, 4), a.length), bS.encode(d);
  }
  function r(i) {
    var a = i.slice(0, -4), u = i.slice(-4), l = e(a);
    if (!(u[0] ^ l[0] | u[1] ^ l[1] | u[2] ^ l[2] | u[3] ^ l[3]))
      return a;
  }
  function n(i) {
    var a = bS.decodeUnsafe(i);
    if (a != null)
      return r(a);
  }
  function o(i) {
    var a = bS.decode(i), u = r(a);
    if (u == null)
      throw new Error("Invalid checksum");
    return u;
  }
  return {
    encode: t,
    decode: o,
    decodeUnsafe: n
  };
}
function wQ(e) {
  return ki(ki(e));
}
const U1 = bQ(wQ), Tf = on;
function g2(e, t) {
  if (!e.address && !e.hash && !e.output && !e.pubkey && !e.input)
    throw new TypeError("Not enough data");
  t = Object.assign({ validate: !0 }, t || {}), Qn(
    Ud(
      So({
        network: So({}),
        address: v0(),
        hash: DJ,
        output: Ko(25),
        pubkey: Hu(Ou),
        signature: Hu(of),
        input: rn
      })
    ),
    e
  );
  const r = js(() => {
    const a = U1.decode(e.address), u = nf(a, 0), l = a.slice(1);
    return { version: u, hash: l };
  }), n = js(() => to(e.input)), o = e.network || qu, i = { name: "p2pkh", network: o };
  if (Mt(i, "address", () => {
    if (!i.hash) return;
    const a = new Uint8Array(21);
    return ts(a, 0, o.pubKeyHash), a.set(i.hash, 1), U1.encode(a);
  }), Mt(i, "hash", () => {
    if (e.output) return e.output.slice(3, 23);
    if (e.address) return r().hash;
    if (e.pubkey || i.pubkey) return Ql(e.pubkey || i.pubkey);
  }), Mt(i, "output", () => {
    if (i.hash)
      return Oa([
        Tf.OP_DUP,
        Tf.OP_HASH160,
        i.hash,
        Tf.OP_EQUALVERIFY,
        Tf.OP_CHECKSIG
      ]);
  }), Mt(i, "pubkey", () => {
    if (e.input)
      return n()[1];
  }), Mt(i, "signature", () => {
    if (e.input)
      return n()[0];
  }), Mt(i, "input", () => {
    if (e.pubkey && e.signature)
      return Oa([e.signature, e.pubkey]);
  }), Mt(i, "witness", () => {
    if (i.input)
      return [];
  }), t.validate) {
    let a = Uint8Array.from([]);
    if (e.address) {
      if (r().version !== o.pubKeyHash)
        throw new TypeError("Invalid version or Network mismatch");
      if (r().hash.length !== 20) throw new TypeError("Invalid address");
      a = r().hash;
    }
    if (e.hash) {
      if (a.length > 0 && ft(a, e.hash) !== 0)
        throw new TypeError("Hash mismatch");
      a = e.hash;
    }
    if (e.output) {
      if (e.output.length !== 25 || e.output[0] !== Tf.OP_DUP || e.output[1] !== Tf.OP_HASH160 || e.output[2] !== 20 || e.output[23] !== Tf.OP_EQUALVERIFY || e.output[24] !== Tf.OP_CHECKSIG)
        throw new TypeError("Output is invalid");
      const u = e.output.slice(3, 23);
      if (a.length > 0 && ft(a, u) !== 0)
        throw new TypeError("Hash mismatch");
      a = u;
    }
    if (e.pubkey) {
      const u = Ql(e.pubkey);
      if (a.length > 0 && ft(a, u) !== 0)
        throw new TypeError("Hash mismatch");
      a = u;
    }
    if (e.input) {
      const u = n();
      if (u.length !== 2) throw new TypeError("Input is invalid");
      if (!of(u[0]))
        throw new TypeError("Input has invalid signature");
      if (!Ou(u[1])) throw new TypeError("Input has invalid pubkey");
      if (e.signature && ft(e.signature, u[0]) !== 0)
        throw new TypeError("Signature mismatch");
      if (e.pubkey && ft(e.pubkey, u[1]) !== 0)
        throw new TypeError("Pubkey mismatch");
      const l = Ql(u[1]);
      if (a.length > 0 && ft(a, l) !== 0)
        throw new TypeError("Hash mismatch");
    }
  }
  return Object.assign(i, e);
}
const _b = on;
function gg(e, t) {
  if (!e.address && !e.hash && !e.output && !e.redeem && !e.input)
    throw new TypeError("Not enough data");
  t = Object.assign({ validate: !0 }, t || {}), Qn(
    Ud(
      So({
        network: So({}),
        address: v0(),
        hash: Ko(20),
        output: Ko(23),
        redeem: Ud(
          So({
            network: So({}),
            output: rn,
            input: rn,
            witness: Ia(rn)
          })
        ),
        input: rn,
        witness: Ia(rn)
      })
    ),
    e
  );
  let r = e.network;
  r || (r = e.redeem && e.redeem.network || qu);
  const n = { network: r }, o = js(() => {
    const u = U1.decode(e.address), l = nf(u, 0), d = u.slice(1);
    return { version: l, hash: d };
  }), i = js(() => to(e.input)), a = js(() => {
    const u = i(), l = u[u.length - 1];
    return {
      network: r,
      output: l === _b.OP_FALSE ? Uint8Array.from([]) : l,
      input: Oa(u.slice(0, -1)),
      witness: e.witness || []
    };
  });
  if (Mt(n, "address", () => {
    if (!n.hash) return;
    const u = new Uint8Array(21);
    return ts(u, 0, n.network.scriptHash), u.set(n.hash, 1), U1.encode(u);
  }), Mt(n, "hash", () => {
    if (e.output) return e.output.slice(2, 22);
    if (e.address) return o().hash;
    if (n.redeem && n.redeem.output) return Ql(n.redeem.output);
  }), Mt(n, "output", () => {
    if (n.hash)
      return Oa([_b.OP_HASH160, n.hash, _b.OP_EQUAL]);
  }), Mt(n, "redeem", () => {
    if (e.input)
      return a();
  }), Mt(n, "input", () => {
    if (!(!e.redeem || !e.redeem.input || !e.redeem.output))
      return Oa(
        [].concat(to(e.redeem.input), e.redeem.output)
      );
  }), Mt(n, "witness", () => {
    if (n.redeem && n.redeem.witness) return n.redeem.witness;
    if (n.input) return [];
  }), Mt(n, "name", () => {
    const u = ["p2sh"];
    return n.redeem !== void 0 && n.redeem.name !== void 0 && u.push(n.redeem.name), u.join("-");
  }), t.validate) {
    let u = Uint8Array.from([]);
    if (e.address) {
      if (o().version !== r.scriptHash)
        throw new TypeError("Invalid version or Network mismatch");
      if (o().hash.length !== 20) throw new TypeError("Invalid address");
      u = o().hash;
    }
    if (e.hash) {
      if (u.length > 0 && ft(u, e.hash) !== 0)
        throw new TypeError("Hash mismatch");
      u = e.hash;
    }
    if (e.output) {
      if (e.output.length !== 23 || e.output[0] !== _b.OP_HASH160 || e.output[1] !== 20 || e.output[22] !== _b.OP_EQUAL)
        throw new TypeError("Output is invalid");
      const d = e.output.slice(2, 22);
      if (u.length > 0 && ft(u, d) !== 0)
        throw new TypeError("Hash mismatch");
      u = d;
    }
    const l = (d) => {
      if (d.output) {
        const f = to(d.output);
        if (!f || f.length < 1)
          throw new TypeError("Redeem.output too short");
        if (d.output.byteLength > 520)
          throw new TypeError(
            "Redeem.output unspendable if larger than 520 bytes"
          );
        if (mL(f) > 201)
          throw new TypeError(
            "Redeem.output unspendable with more than 201 non-push ops"
          );
        const h = Ql(d.output);
        if (u.length > 0 && ft(u, h) !== 0)
          throw new TypeError("Hash mismatch");
        u = h;
      }
      if (d.input) {
        const f = d.input.length > 0, h = d.witness && d.witness.length > 0;
        if (!f && !h) throw new TypeError("Empty input");
        if (f && h)
          throw new TypeError("Input and witness provided");
        if (f) {
          const g = to(d.input);
          if (!BP(g))
            throw new TypeError("Non push-only scriptSig");
        }
      }
    };
    if (e.input) {
      const d = i();
      if (!d || d.length < 1) throw new TypeError("Input too short");
      if (!(a().output instanceof Uint8Array))
        throw new TypeError("Input is invalid");
      l(a());
    }
    if (e.redeem) {
      if (e.redeem.network && e.redeem.network !== r)
        throw new TypeError("Network mismatch");
      if (e.input) {
        const d = a();
        if (e.redeem.output && ft(e.redeem.output, d.output) !== 0)
          throw new TypeError("Redeem.output mismatch");
        if (e.redeem.input && ft(e.redeem.input, d.input) !== 0)
          throw new TypeError("Redeem.input mismatch");
      }
      l(e.redeem);
    }
    if (e.witness && e.redeem && e.redeem.witness && !dw(e.redeem.witness, e.witness))
      throw new TypeError("Witness and redeem.witness mismatch");
  }
  return Object.assign(n, e);
}
var Rt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function AL(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function vQ(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var hw = {};
Object.defineProperty(hw, "__esModule", { value: !0 });
var pw = hw.bech32m = is = hw.bech32 = void 0;
const a3 = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", xL = {};
for (let e = 0; e < a3.length; e++) {
  const t = a3.charAt(e);
  xL[t] = e;
}
function m1(e) {
  const t = e >> 25;
  return (e & 33554431) << 5 ^ -(t >> 0 & 1) & 996825010 ^ -(t >> 1 & 1) & 642813549 ^ -(t >> 2 & 1) & 513874426 ^ -(t >> 3 & 1) & 1027748829 ^ -(t >> 4 & 1) & 705979059;
}
function m$(e) {
  let t = 1;
  for (let r = 0; r < e.length; ++r) {
    const n = e.charCodeAt(r);
    if (n < 33 || n > 126)
      return "Invalid prefix (" + e + ")";
    t = m1(t) ^ n >> 5;
  }
  t = m1(t);
  for (let r = 0; r < e.length; ++r) {
    const n = e.charCodeAt(r);
    t = m1(t) ^ n & 31;
  }
  return t;
}
function HP(e, t, r, n) {
  let o = 0, i = 0;
  const a = (1 << r) - 1, u = [];
  for (let l = 0; l < e.length; ++l)
    for (o = o << t | e[l], i += t; i >= r; )
      i -= r, u.push(o >> i & a);
  if (n)
    i > 0 && u.push(o << r - i & a);
  else {
    if (i >= t)
      return "Excess padding";
    if (o << r - i & a)
      return "Non-zero padding";
  }
  return u;
}
function EQ(e) {
  return HP(e, 8, 5, !0);
}
function _Q(e) {
  const t = HP(e, 5, 8, !1);
  if (Array.isArray(t))
    return t;
}
function AQ(e) {
  const t = HP(e, 5, 8, !1);
  if (Array.isArray(t))
    return t;
  throw new Error(t);
}
function kL(e) {
  let t;
  e === "bech32" ? t = 1 : t = 734539939;
  function r(a, u, l) {
    if (l = l || 90, a.length + 7 + u.length > l)
      throw new TypeError("Exceeds length limit");
    a = a.toLowerCase();
    let d = m$(a);
    if (typeof d == "string")
      throw new Error(d);
    let f = a + "1";
    for (let h = 0; h < u.length; ++h) {
      const g = u[h];
      if (g >> 5)
        throw new Error("Non 5-bit word");
      d = m1(d) ^ g, f += a3.charAt(g);
    }
    for (let h = 0; h < 6; ++h)
      d = m1(d);
    d ^= t;
    for (let h = 0; h < 6; ++h) {
      const g = d >> (5 - h) * 5 & 31;
      f += a3.charAt(g);
    }
    return f;
  }
  function n(a, u) {
    if (u = u || 90, a.length < 8)
      return a + " too short";
    if (a.length > u)
      return "Exceeds length limit";
    const l = a.toLowerCase(), d = a.toUpperCase();
    if (a !== l && a !== d)
      return "Mixed-case string " + a;
    a = l;
    const f = a.lastIndexOf("1");
    if (f === -1)
      return "No separator character for " + a;
    if (f === 0)
      return "Missing prefix for " + a;
    const h = a.slice(0, f), g = a.slice(f + 1);
    if (g.length < 6)
      return "Data too short";
    let b = m$(h);
    if (typeof b == "string")
      return b;
    const w = [];
    for (let E = 0; E < g.length; ++E) {
      const _ = g.charAt(E), O = xL[_];
      if (O === void 0)
        return "Unknown character " + _;
      b = m1(b) ^ O, !(E + 6 >= g.length) && w.push(O);
    }
    return b !== t ? "Invalid checksum for " + a : { prefix: h, words: w };
  }
  function o(a, u) {
    const l = n(a, u);
    if (typeof l == "object")
      return l;
  }
  function i(a, u) {
    const l = n(a, u);
    if (typeof l == "object")
      return l;
    throw new Error(l);
  }
  return {
    decodeUnsafe: o,
    decode: i,
    encode: r,
    toWords: EQ,
    fromWordsUnsafe: _Q,
    fromWords: AQ
  };
}
var is = hw.bech32 = kL("bech32");
pw = hw.bech32m = kL("bech32m");
const y$ = on, xQ = new Uint8Array(0);
function m2(e, t) {
  if (!e.address && !e.hash && !e.output && !e.pubkey && !e.witness)
    throw new TypeError("Not enough data");
  t = Object.assign({ validate: !0 }, t || {}), Qn(
    Ud(
      So({
        address: v0(),
        hash: Ko(20),
        input: Ko(0),
        network: So({}),
        output: Ko(22),
        pubkey: Hu(Ou, "Not a valid pubkey"),
        signature: Hu(of),
        witness: Ia(rn)
      })
    ),
    e
  );
  const r = js(() => {
    const i = is.decode(e.address), a = i.words.shift(), u = is.fromWords(i.words);
    return {
      version: a,
      prefix: i.prefix,
      data: Uint8Array.from(u)
    };
  }), n = e.network || qu, o = { name: "p2wpkh", network: n };
  if (Mt(o, "address", () => {
    if (!o.hash) return;
    const i = is.toWords(o.hash);
    return i.unshift(0), is.encode(n.bech32, i);
  }), Mt(o, "hash", () => {
    if (e.output) return e.output.slice(2, 22);
    if (e.address) return r().data;
    if (e.pubkey || o.pubkey) return Ql(e.pubkey || o.pubkey);
  }), Mt(o, "output", () => {
    if (o.hash)
      return Oa([y$.OP_0, o.hash]);
  }), Mt(o, "pubkey", () => {
    if (e.pubkey) return e.pubkey;
    if (e.witness)
      return e.witness[1];
  }), Mt(o, "signature", () => {
    if (e.witness)
      return e.witness[0];
  }), Mt(o, "input", () => {
    if (o.witness)
      return xQ;
  }), Mt(o, "witness", () => {
    if (e.pubkey && e.signature)
      return [e.signature, e.pubkey];
  }), t.validate) {
    let i = Uint8Array.from([]);
    if (e.address) {
      if (n && n.bech32 !== r().prefix)
        throw new TypeError("Invalid prefix or Network mismatch");
      if (r().version !== 0)
        throw new TypeError("Invalid address version");
      if (r().data.length !== 20)
        throw new TypeError("Invalid address data");
      i = r().data;
    }
    if (e.hash) {
      if (i.length > 0 && ft(i, e.hash) !== 0)
        throw new TypeError("Hash mismatch");
      i = e.hash;
    }
    if (e.output) {
      if (e.output.length !== 22 || e.output[0] !== y$.OP_0 || e.output[1] !== 20)
        throw new TypeError("Output is invalid");
      if (i.length > 0 && ft(i, e.output.slice(2)) !== 0)
        throw new TypeError("Hash mismatch");
      i = e.output.slice(2);
    }
    if (e.pubkey) {
      const a = Ql(e.pubkey);
      if (i.length > 0 && ft(i, a) !== 0)
        throw new TypeError("Hash mismatch");
      if (i = a, !Ou(e.pubkey) || e.pubkey.length !== 33)
        throw new TypeError("Invalid pubkey for p2wpkh");
    }
    if (e.witness) {
      if (e.witness.length !== 2) throw new TypeError("Witness is invalid");
      if (!of(e.witness[0]))
        throw new TypeError("Witness has invalid signature");
      if (!Ou(e.witness[1]) || e.witness[1].length !== 33)
        throw new TypeError("Witness has invalid pubkey");
      if (e.signature && ft(e.signature, e.witness[0]) !== 0)
        throw new TypeError("Signature mismatch");
      if (e.pubkey && ft(e.pubkey, e.witness[1]) !== 0)
        throw new TypeError("Pubkey mismatch");
      const a = Ql(e.witness[1]);
      if (i.length > 0 && ft(i, a) !== 0)
        throw new TypeError("Hash mismatch");
    }
  }
  return Object.assign(o, e);
}
const b$ = on, wS = new Uint8Array(0);
function Pv(e) {
  return !!(e instanceof Uint8Array && e.length === 65 && e[0] === 4 && Ou(e));
}
function y2(e, t) {
  if (!e.address && !e.hash && !e.output && !e.redeem && !e.witness)
    throw new TypeError("Not enough data");
  t = Object.assign({ validate: !0 }, t || {}), Qn(
    c$({
      network: So({}),
      address: v0(),
      hash: MJ,
      output: Ko(34),
      redeem: c$({
        input: rn,
        network: So({}),
        output: rn,
        witness: Ia(rn)
      }),
      input: Ko(0),
      witness: Ia(rn)
    }),
    e
  );
  const r = js(() => {
    const a = is.decode(e.address), u = a.words.shift(), l = is.fromWords(a.words);
    return {
      version: u,
      prefix: a.prefix,
      data: Uint8Array.from(l)
    };
  }), n = js(() => to(e.redeem.input));
  let o = e.network;
  o || (o = e.redeem && e.redeem.network || qu);
  const i = { network: o };
  if (Mt(i, "address", () => {
    if (!i.hash) return;
    const a = is.toWords(i.hash);
    return a.unshift(0), is.encode(o.bech32, a);
  }), Mt(i, "hash", () => {
    if (e.output) return e.output.slice(2);
    if (e.address) return r().data;
    if (i.redeem && i.redeem.output) return ki(i.redeem.output);
  }), Mt(i, "output", () => {
    if (i.hash)
      return Oa([b$.OP_0, i.hash]);
  }), Mt(i, "redeem", () => {
    if (e.witness)
      return {
        output: e.witness[e.witness.length - 1],
        input: wS,
        witness: e.witness.slice(0, -1)
      };
  }), Mt(i, "input", () => {
    if (i.witness)
      return wS;
  }), Mt(i, "witness", () => {
    if (e.redeem && e.redeem.input && e.redeem.input.length > 0 && e.redeem.output && e.redeem.output.length > 0) {
      const a = YJ(n());
      return i.redeem = Object.assign({ witness: a }, e.redeem), i.redeem.input = wS, [].concat(a, e.redeem.output);
    }
    if (e.redeem && e.redeem.output && e.redeem.witness)
      return [].concat(e.redeem.witness, e.redeem.output);
  }), Mt(i, "name", () => {
    const a = ["p2wsh"];
    return i.redeem !== void 0 && i.redeem.name !== void 0 && a.push(i.redeem.name), a.join("-");
  }), t.validate) {
    let a = Uint8Array.from([]);
    if (e.address) {
      if (r().prefix !== o.bech32)
        throw new TypeError("Invalid prefix or Network mismatch");
      if (r().version !== 0)
        throw new TypeError("Invalid address version");
      if (r().data.length !== 32)
        throw new TypeError("Invalid address data");
      a = r().data;
    }
    if (e.hash) {
      if (a.length > 0 && ft(a, e.hash) !== 0)
        throw new TypeError("Hash mismatch");
      a = e.hash;
    }
    if (e.output) {
      if (e.output.length !== 34 || e.output[0] !== b$.OP_0 || e.output[1] !== 32)
        throw new TypeError("Output is invalid");
      const u = e.output.slice(2);
      if (a.length > 0 && ft(a, u) !== 0)
        throw new TypeError("Hash mismatch");
      a = u;
    }
    if (e.redeem) {
      if (e.redeem.network && e.redeem.network !== o)
        throw new TypeError("Network mismatch");
      if (e.redeem.input && e.redeem.input.length > 0 && e.redeem.witness && e.redeem.witness.length > 0)
        throw new TypeError("Ambiguous witness source");
      if (e.redeem.output) {
        const u = to(e.redeem.output);
        if (!u || u.length < 1)
          throw new TypeError("Redeem.output is invalid");
        if (e.redeem.output.byteLength > 3600)
          throw new TypeError(
            "Redeem.output unspendable if larger than 3600 bytes"
          );
        if (mL(u) > 201)
          throw new TypeError(
            "Redeem.output unspendable with more than 201 non-push ops"
          );
        const l = ki(e.redeem.output);
        if (a.length > 0 && ft(a, l) !== 0)
          throw new TypeError("Hash mismatch");
        a = l;
      }
      if (e.redeem.input && !BP(n()))
        throw new TypeError("Non push-only scriptSig");
      if (e.witness && e.redeem.witness && !dw(e.witness, e.redeem.witness))
        throw new TypeError("Witness and redeem.witness mismatch");
      if (e.redeem.input && n().some(Pv) || e.redeem.output && (to(e.redeem.output) || []).some(
        Pv
      ))
        throw new TypeError(
          "redeem.input or redeem.output contains uncompressed pubkey"
        );
    }
    if (e.witness && e.witness.length > 0) {
      const u = e.witness[e.witness.length - 1];
      if (e.redeem && e.redeem.output && ft(e.redeem.output, u) !== 0)
        throw new TypeError("Witness and redeem.output mismatch");
      if (e.witness.some(Pv) || (to(u) || []).some(Pv))
        throw new TypeError("Witness contains uncompressed pubkey");
    }
  }
  return Object.assign(i, e);
}
const Qb = {};
function FP(e) {
  e ? e !== Qb.eccLib && (kQ(e), Qb.eccLib = e) : Qb.eccLib = e;
}
function gI() {
  if (!Qb.eccLib)
    throw new Error(
      "No ECC Library provided. You must call initEccLib() with a valid TinySecp256k1Interface instance"
    );
  return Qb.eccLib;
}
const Il = (e) => mf(e);
function kQ(e) {
  Es(typeof e.isXOnlyPoint == "function"), Es(
    e.isXOnlyPoint(
      Il("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")
    )
  ), Es(
    e.isXOnlyPoint(
      Il("fffffffffffffffffffffffffffffffffffffffffffffffffffffffeeffffc2e")
    )
  ), Es(
    e.isXOnlyPoint(
      Il("f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9")
    )
  ), Es(
    e.isXOnlyPoint(
      Il("0000000000000000000000000000000000000000000000000000000000000001")
    )
  ), Es(
    !e.isXOnlyPoint(
      Il("0000000000000000000000000000000000000000000000000000000000000000")
    )
  ), Es(
    !e.isXOnlyPoint(
      Il("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f")
    )
  ), Es(typeof e.xOnlyPointAddTweak == "function"), SQ.forEach((t) => {
    const r = e.xOnlyPointAddTweak(Il(t.pubkey), Il(t.tweak));
    t.result === null ? Es(r === null) : (Es(r !== null), Es(r.parity === t.parity), Es(ft(r.xOnlyPubkey, Il(t.result)) === 0));
  });
}
function Es(e) {
  if (!e) throw new Error("ecc library invalid");
}
const SQ = [
  {
    pubkey: "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
    tweak: "fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140",
    parity: -1,
    result: null
  },
  {
    pubkey: "1617d38ed8d8657da4d4761e8057bc396ea9e4b9d29776d4be096016dbd2509b",
    tweak: "a8397a935f0dfceba6ba9618f6451ef4d80637abf4e6af2669fbc9de6a8fd2ac",
    parity: 1,
    result: "e478f99dab91052ab39a33ea35fd5e6e4933f4d28023cd597c9a1f6760346adf"
  },
  {
    pubkey: "2c0b7cf95324a07d05398b240174dc0c2be444d96b159aa6c7f7b1e668680991",
    tweak: "823c3cd2142744b075a87eade7e1b8678ba308d566226a0056ca2b7a76f86b47",
    parity: 0,
    result: "9534f8dc8c6deda2dc007655981c78b49c5d96c778fbf363462a11ec9dfd948c"
  }
], SL = "0123456789abcdefABCDEF";
SL.split("").map((e) => e.codePointAt(0));
const w$ = Array(256).fill(!0).map((e, t) => {
  const r = String.fromCodePoint(t), n = SL.indexOf(r);
  return n < 0 ? void 0 : n < 16 ? n : n - 6;
}), TL = new TextEncoder();
new TextDecoder();
function TQ(e) {
  return TL.encode(e);
}
function IQ(e) {
  const t = e.reduce((o, i) => o + i.length, 0), r = new Uint8Array(t);
  let n = 0;
  for (const o of e)
    r.set(o, n), n += o.length;
  return r;
}
function OQ(e) {
  const t = TL.encode(e || ""), r = new Uint8Array(Math.floor(t.length / 2));
  let n;
  for (n = 0; n < r.length; n++) {
    const o = w$[t[n * 2]], i = w$[t[n * 2 + 1]];
    if (o === void 0 || i === void 0)
      break;
    r[n] = o << 4 | i;
  }
  return n === r.length ? r : r.slice(0, n);
}
function Ol(e, t) {
  const r = Math.min(e.length, t.length);
  for (let n = 0; n < r; ++n)
    if (e[n] !== t[n])
      return e[n] < t[n] ? -1 : 1;
  return e.length === t.length ? 0 : e.length > t.length ? 1 : -1;
}
function v$(e, t, r) {
  if (t + 1 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r > 255)
    throw new Error(`The value of "value" is out of range. It must be >= 0 and <= 255. Received ${r}`);
  e[t] = r;
}
function PQ(e, t, r, n) {
  if (t + 2 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (n = n.toUpperCase(), r > 65535)
    throw new Error(`The value of "value" is out of range. It must be >= 0 and <= 65535. Received ${r}`);
  n === "LE" ? (e[t] = r & 255, e[t + 1] = r >> 8 & 255) : (e[t] = r >> 8 & 255, e[t + 1] = r & 255);
}
function _p(e, t, r, n) {
  if (t + 4 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (n = n.toUpperCase(), r > 4294967295)
    throw new Error(`The value of "value" is out of range. It must be >= 0 and <= ${4294967295}. Received ${r}`);
  n === "LE" ? (e[t] = r & 255, e[t + 1] = r >> 8 & 255, e[t + 2] = r >> 16 & 255, e[t + 3] = r >> 24 & 255) : (e[t] = r >> 24 & 255, e[t + 1] = r >> 16 & 255, e[t + 2] = r >> 8 & 255, e[t + 3] = r & 255);
}
function CQ(e, t, r, n) {
  if (t + 8 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (n = n.toUpperCase(), r > 0xffffffffffffffffn)
    throw new Error(`The value of "value" is out of range. It must be >= 0 and <= ${0xffffffffffffffffn}. Received ${r}`);
  n === "LE" ? (e[t] = Number(r & 0xffn), e[t + 1] = Number(r >> 8n & 0xffn), e[t + 2] = Number(r >> 16n & 0xffn), e[t + 3] = Number(r >> 24n & 0xffn), e[t + 4] = Number(r >> 32n & 0xffn), e[t + 5] = Number(r >> 40n & 0xffn), e[t + 6] = Number(r >> 48n & 0xffn), e[t + 7] = Number(r >> 56n & 0xffn)) : (e[t] = Number(r >> 56n & 0xffn), e[t + 1] = Number(r >> 48n & 0xffn), e[t + 2] = Number(r >> 40n & 0xffn), e[t + 3] = Number(r >> 32n & 0xffn), e[t + 4] = Number(r >> 24n & 0xffn), e[t + 5] = Number(r >> 16n & 0xffn), e[t + 6] = Number(r >> 8n & 0xffn), e[t + 7] = Number(r & 0xffn));
}
function BQ(e, t, r) {
  if (t + 2 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r = r.toUpperCase(), r === "LE") {
    let n = 0;
    return n = (n << 8) + e[t + 1], n = (n << 8) + e[t], n;
  } else {
    let n = 0;
    return n = (n << 8) + e[t], n = (n << 8) + e[t + 1], n;
  }
}
function X0(e, t, r) {
  if (t + 4 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r = r.toUpperCase(), r === "LE") {
    let n = 0;
    return n = (n << 8) + e[t + 3] >>> 0, n = (n << 8) + e[t + 2] >>> 0, n = (n << 8) + e[t + 1] >>> 0, n = (n << 8) + e[t] >>> 0, n;
  } else {
    let n = 0;
    return n = (n << 8) + e[t] >>> 0, n = (n << 8) + e[t + 1] >>> 0, n = (n << 8) + e[t + 2] >>> 0, n = (n << 8) + e[t + 3] >>> 0, n;
  }
}
function NQ(e, t, r) {
  if (t + 8 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r = r.toUpperCase(), r === "LE") {
    let n = 0n;
    return n = (n << 8n) + BigInt(e[t + 7]), n = (n << 8n) + BigInt(e[t + 6]), n = (n << 8n) + BigInt(e[t + 5]), n = (n << 8n) + BigInt(e[t + 4]), n = (n << 8n) + BigInt(e[t + 3]), n = (n << 8n) + BigInt(e[t + 2]), n = (n << 8n) + BigInt(e[t + 1]), n = (n << 8n) + BigInt(e[t]), n;
  } else {
    let n = 0n;
    return n = (n << 8n) + BigInt(e[t]), n = (n << 8n) + BigInt(e[t + 1]), n = (n << 8n) + BigInt(e[t + 2]), n = (n << 8n) + BigInt(e[t + 3]), n = (n << 8n) + BigInt(e[t + 4]), n = (n << 8n) + BigInt(e[t + 5]), n = (n << 8n) + BigInt(e[t + 6]), n = (n << 8n) + BigInt(e[t + 7]), n;
  }
}
const $Q = (e) => {
  if (e < 0 || e > 0xffffffffffffffffn)
    throw new RangeError("value out of range");
};
function UQ(e) {
  if (e < 0 || e > Number.MAX_SAFE_INTEGER || e % 1 !== 0)
    throw new RangeError("value out of range");
}
function IL(e) {
  typeof e == "number" ? UQ(e) : $Q(e);
}
function Rd(e, t, r) {
  IL(e), r === void 0 && (r = 0), t === void 0 && (t = new Uint8Array(Ms(e)));
  let n = 0;
  return e < 253 ? (t.set([Number(e)], r), n = 1) : e <= 65535 ? (t.set([253], r), PQ(t, r + 1, Number(e), "LE"), n = 3) : e <= 4294967295 ? (t.set([254], r), _p(t, r + 1, Number(e), "LE"), n = 5) : (t.set([255], r), CQ(t, r + 1, BigInt(e), "LE"), n = 9), { buffer: t, bytes: n };
}
function mg(e, t) {
  t === void 0 && (t = 0);
  const r = e.at(t);
  if (r === void 0)
    throw new Error("buffer too small");
  if (r < 253)
    return { numberValue: r, bigintValue: BigInt(r), bytes: 1 };
  if (r === 253) {
    const n = BQ(e, t + 1, "LE");
    return {
      numberValue: n,
      bigintValue: BigInt(n),
      bytes: 3
    };
  } else if (r === 254) {
    const n = X0(e, t + 1, "LE");
    return {
      numberValue: n,
      bigintValue: BigInt(n),
      bytes: 5
    };
  } else {
    const n = NQ(e, t + 1, "LE");
    return { numberValue: n <= Number.MAX_SAFE_INTEGER ? Number(n) : null, bigintValue: n, bytes: 9 };
  }
}
function Ms(e) {
  return IL(e), e < 253 ? 1 : e <= 65535 ? 3 : e <= 4294967295 ? 5 : 9;
}
const RQ = 9007199254740991;
function zQ(e, t) {
  if (typeof e != "number" && typeof e != "bigint")
    throw new Error("cannot write a non-number as a number");
  if (e < 0 && e < BigInt(0))
    throw new Error("specified a negative value for writing an unsigned value");
  if (e > t && e > BigInt(t))
    throw new Error("RangeError: value out of range");
  if (Math.floor(Number(e)) !== Number(e))
    throw new Error("value has a fractional component");
}
function MP(e) {
  if (e.length < 1) return e;
  let t = e.length - 1, r = 0;
  for (let n = 0; n < e.length / 2; n++)
    r = e[n], e[n] = e[t], e[t] = r, t--;
  return e;
}
function E$(e) {
  const t = new Uint8Array(e.length);
  return t.set(e), t;
}
class Ci {
  constructor(t, r = 0) {
    st(this, "buffer"), st(this, "offset"), this.buffer = t, this.offset = r, Qn(bc([rn, Ml]), [
      t,
      r
    ]);
  }
  static withCapacity(t) {
    return new Ci(new Uint8Array(t));
  }
  writeUInt8(t) {
    this.offset = ts(this.buffer, this.offset, t);
  }
  writeInt32(t) {
    this.offset = rL(this.buffer, this.offset, t, "LE");
  }
  writeInt64(t) {
    this.offset = nL(this.buffer, this.offset, BigInt(t), "LE");
  }
  writeUInt32(t) {
    this.offset = p2(this.buffer, this.offset, t, "LE");
  }
  writeUInt64(t) {
    this.offset = CJ(this.buffer, this.offset, BigInt(t), "LE");
  }
  writeVarInt(t) {
    const { bytes: r } = Rd(t, this.buffer, this.offset);
    this.offset += r;
  }
  writeSlice(t) {
    if (this.buffer.length < this.offset + t.length)
      throw new Error("Cannot write slice out of bounds");
    this.buffer.set(t, this.offset), this.offset += t.length;
  }
  writeVarSlice(t) {
    this.writeVarInt(t.length), this.writeSlice(t);
  }
  writeVector(t) {
    this.writeVarInt(t.length), t.forEach((r) => this.writeVarSlice(r));
  }
  end() {
    if (this.buffer.length === this.offset)
      return this.buffer;
    throw new Error(`buffer size ${this.buffer.length}, offset ${this.offset}`);
  }
}
let jQ = class {
  constructor(t, r = 0) {
    st(this, "buffer"), st(this, "offset"), this.buffer = t, this.offset = r, Qn(bc([rn, Ml]), [
      t,
      r
    ]);
  }
  readUInt8() {
    const t = nf(this.buffer, this.offset);
    return this.offset++, t;
  }
  readInt32() {
    const t = NJ(this.buffer, this.offset, "LE");
    return this.offset += 4, t;
  }
  readUInt32() {
    const t = hg(this.buffer, this.offset, "LE");
    return this.offset += 4, t;
  }
  readInt64() {
    const t = oL(this.buffer, this.offset, "LE");
    return this.offset += 8, t;
  }
  readVarInt() {
    const { bigintValue: t, bytes: r } = mg(this.buffer, this.offset);
    return this.offset += r, t;
  }
  readSlice(t) {
    zQ(t, RQ);
    const r = Number(t);
    if (this.buffer.length < this.offset + r)
      throw new Error("Cannot read slice out of bounds");
    const n = this.buffer.slice(this.offset, this.offset + r);
    return this.offset += r, n;
  }
  readVarSlice() {
    return this.readSlice(this.readVarInt());
  }
  readVector() {
    const t = this.readVarInt(), r = [];
    for (let n = 0; n < t; n++) r.push(this.readVarSlice());
    return r;
  }
};
const OL = 192, LQ = 128, HQ = (e) => "left" in e && "right" in e;
function mI(e, t) {
  if (e.length < 33)
    throw new TypeError(
      `The control-block length is too small. Got ${e.length}, expected min 33.`
    );
  const r = (e.length - 33) / 32;
  let n = t;
  for (let o = 0; o < r; o++) {
    const i = e.slice(33 + 32 * o, 65 + 32 * o);
    ft(n, i) < 0 ? n = bI(n, i) : n = bI(i, n);
  }
  return n;
}
function yI(e) {
  if (CP(e)) return { hash: Yl(e) };
  const t = [yI(e[0]), yI(e[1])];
  t.sort((o, i) => ft(o.hash, i.hash));
  const [r, n] = t;
  return {
    hash: bI(r.hash, n.hash),
    left: r,
    right: n
  };
}
function s3(e, t) {
  if (HQ(e)) {
    const r = s3(e.left, t);
    if (r !== void 0) return [...r, e.right.hash];
    const n = s3(e.right, t);
    if (n !== void 0) return [...n, e.left.hash];
  } else if (ft(e.hash, t) === 0)
    return [];
}
function Yl(e) {
  const t = e.version || OL;
  return L5(
    "TapLeaf",
    io([Uint8Array.from([t]), MQ(e.output)])
  );
}
function FQ(e, t) {
  return L5(
    "TapTweak",
    io(t ? [e, t] : [e])
  );
}
function Cv(e, t) {
  if (!(e instanceof Uint8Array) || e.length !== 32 || t && t.length !== 32) return null;
  const r = FQ(e, t), n = gI().xOnlyPointAddTweak(e, r);
  return !n || n.xOnlyPubkey === null ? null : {
    parity: n.parity,
    x: Uint8Array.from(n.xOnlyPubkey)
  };
}
function bI(e, t) {
  return L5("TapBranch", io([e, t]));
}
function MQ(e) {
  const t = Ms(e.length), r = new Uint8Array(t);
  return Rd(e.length, r), io([r, e]);
}
const _$ = on, A$ = 1, DQ = 80;
function b2(e, t) {
  if (!e.address && !e.output && !e.pubkey && !e.internalPubkey && !(e.witness && e.witness.length > 1))
    throw new TypeError("Not enough data");
  t = Object.assign({ validate: !0 }, t || {}), Qn(
    Ud(
      So({
        address: v0(),
        input: Ko(0),
        network: So({}),
        output: Ko(34),
        internalPubkey: Ko(32),
        hash: Ko(32),
        // merkle root hash, the tweak
        pubkey: Ko(32),
        // tweaked with `hash` from `internalPubkey`
        signature: PP([
          Ko(64),
          Ko(65)
        ]),
        witness: Ia(rn),
        scriptTree: Hu(dL, "Taptree is not of type isTaptree"),
        redeem: Ud(
          So({
            output: rn,
            // tapleaf script
            redeemVersion: xa(),
            // tapleaf version
            witness: Ia(rn)
          })
        ),
        redeemVersion: xa()
      })
    ),
    e
  );
  const r = js(() => DP(e.address)), n = js(() => {
    if (!(!e.witness || !e.witness.length))
      return e.witness.length >= 2 && e.witness[e.witness.length - 1][0] === DQ ? e.witness.slice(0, -1) : e.witness.slice();
  }), o = js(() => {
    if (e.scriptTree) return yI(e.scriptTree);
    if (e.hash) return { hash: e.hash };
  }), i = e.network || qu, a = { name: "p2tr", network: i };
  if (Mt(a, "address", () => {
    if (!a.pubkey) return;
    const u = pw.toWords(a.pubkey);
    return u.unshift(A$), pw.encode(i.bech32, u);
  }), Mt(a, "hash", () => {
    const u = o();
    if (u) return u.hash;
    const l = n();
    if (l && l.length > 1) {
      const d = l[l.length - 1], f = d[0] & B8, h = l[l.length - 2], g = Yl({ output: h, version: f });
      return mI(d, g);
    }
    return null;
  }), Mt(a, "output", () => {
    if (a.pubkey)
      return Oa([_$.OP_1, a.pubkey]);
  }), Mt(a, "redeemVersion", () => e.redeemVersion ? e.redeemVersion : e.redeem && e.redeem.redeemVersion !== void 0 && e.redeem.redeemVersion !== null ? e.redeem.redeemVersion : OL), Mt(a, "redeem", () => {
    const u = n();
    if (!(!u || u.length < 2))
      return {
        output: u[u.length - 2],
        witness: u.slice(0, -2),
        redeemVersion: u[u.length - 1][0] & B8
      };
  }), Mt(a, "pubkey", () => {
    if (e.pubkey) return e.pubkey;
    if (e.output) return e.output.slice(2);
    if (e.address) return r().data;
    if (a.internalPubkey) {
      const u = Cv(a.internalPubkey, a.hash);
      if (u) return u.x;
    }
  }), Mt(a, "internalPubkey", () => {
    if (e.internalPubkey) return e.internalPubkey;
    const u = n();
    if (u && u.length > 1)
      return u[u.length - 1].slice(1, 33);
  }), Mt(a, "signature", () => {
    if (e.signature) return e.signature;
    const u = n();
    if (!(!u || u.length !== 1))
      return u[0];
  }), Mt(a, "witness", () => {
    if (e.witness) return e.witness;
    const u = o();
    if (u && e.redeem && e.redeem.output && e.internalPubkey) {
      const l = Yl({
        output: e.redeem.output,
        version: a.redeemVersion
      }), d = s3(u, l);
      if (!d) return;
      const f = Cv(e.internalPubkey, u.hash);
      if (!f) return;
      const h = io(
        [
          Uint8Array.from([a.redeemVersion | f.parity]),
          e.internalPubkey
        ].concat(d)
      );
      return [e.redeem.output, h];
    }
    if (e.signature) return [e.signature];
  }), t.validate) {
    let u = Uint8Array.from([]);
    if (e.address) {
      if (i && i.bech32 !== r().prefix)
        throw new TypeError("Invalid prefix or Network mismatch");
      if (r().version !== A$)
        throw new TypeError("Invalid address version");
      if (r().data.length !== 32)
        throw new TypeError("Invalid address data");
      u = r().data;
    }
    if (e.pubkey) {
      if (u.length > 0 && ft(u, e.pubkey) !== 0)
        throw new TypeError("Pubkey mismatch");
      u = e.pubkey;
    }
    if (e.output) {
      if (e.output.length !== 34 || e.output[0] !== _$.OP_1 || e.output[1] !== 32)
        throw new TypeError("Output is invalid");
      if (u.length > 0 && ft(u, e.output.slice(2)) !== 0)
        throw new TypeError("Pubkey mismatch");
      u = e.output.slice(2);
    }
    if (e.internalPubkey) {
      const f = Cv(e.internalPubkey, a.hash);
      if (u.length > 0 && ft(u, f.x) !== 0)
        throw new TypeError("Pubkey mismatch");
      u = f.x;
    }
    if (u && u.length && !gI().isXOnlyPoint(u))
      throw new TypeError("Invalid pubkey for p2tr");
    const l = o();
    if (e.hash && l && ft(e.hash, l.hash) !== 0)
      throw new TypeError("Hash mismatch");
    if (e.redeem && e.redeem.output && l) {
      const f = Yl({
        output: e.redeem.output,
        version: a.redeemVersion
      });
      if (!s3(l, f))
        throw new TypeError("Redeem script not in tree");
    }
    const d = n();
    if (e.redeem && a.redeem) {
      if (e.redeem.redeemVersion && e.redeem.redeemVersion !== a.redeem.redeemVersion)
        throw new TypeError("Redeem.redeemVersion and witness mismatch");
      if (e.redeem.output) {
        if (to(e.redeem.output).length === 0)
          throw new TypeError("Redeem.output is invalid");
        if (a.redeem.output && ft(e.redeem.output, a.redeem.output) !== 0)
          throw new TypeError("Redeem.output and witness mismatch");
      }
      if (e.redeem.witness && a.redeem.witness && !dw(e.redeem.witness, a.redeem.witness))
        throw new TypeError("Redeem.witness and witness mismatch");
    }
    if (d && d.length)
      if (d.length === 1) {
        if (e.signature && ft(e.signature, d[0]) !== 0)
          throw new TypeError("Signature mismatch");
      } else {
        const f = d[d.length - 1];
        if (f.length < 33)
          throw new TypeError(
            `The control-block length is too small. Got ${f.length}, expected min 33.`
          );
        if ((f.length - 33) % 32 !== 0)
          throw new TypeError(
            `The control-block length of ${f.length} is incorrect!`
          );
        const h = (f.length - 33) / 32;
        if (h > 128)
          throw new TypeError(
            `The script path is too long. Got ${h}, expected max 128.`
          );
        const g = f.slice(1, 33);
        if (e.internalPubkey && ft(e.internalPubkey, g) !== 0)
          throw new TypeError("Internal pubkey mismatch");
        if (!gI().isXOnlyPoint(g))
          throw new TypeError("Invalid internalPubkey for p2tr witness");
        const b = f[0] & B8, w = d[d.length - 2], E = Yl({ output: w, version: b }), _ = mI(f, E), O = Cv(g, _);
        if (!O)
          throw new TypeError("Invalid outputKey for p2tr witness");
        if (u.length && ft(u, O.x) !== 0)
          throw new TypeError("Pubkey mismatch for p2tr witness");
        if (O.parity !== (f[0] & 1))
          throw new Error("Incorrect parity");
      }
  }
  return Object.assign(a, e);
}
const PL = 40, CL = 2, BL = 16, NL = 2, $L = 80, UL = "WARNING: Sending to a future segwit version address can lead to loss of funds. End users MUST be warned carefully in the GUI and asked if they wish to proceed with caution. Wallets should verify the segwit version from the output of fromBech32, then decide when it is safe to use which version of segwit.";
function KQ(e, t) {
  const r = e.slice(2);
  if (r.length < CL || r.length > PL)
    throw new TypeError("Invalid program length for segwit address");
  const n = e[0] - $L;
  if (n < NL || n > BL)
    throw new TypeError("Invalid version for segwit address");
  if (e[1] !== r.length)
    throw new TypeError("Invalid script for segwit address");
  return console.warn(UL), qQ(r, n, t.bech32);
}
function RL(e) {
  const t = U1.decode(e);
  if (t.length < 21) throw new TypeError(e + " is too short");
  if (t.length > 21) throw new TypeError(e + " is too long");
  const r = nf(t, 0), n = t.slice(1);
  return { version: r, hash: n };
}
function DP(e) {
  let t, r;
  try {
    t = is.decode(e);
  } catch {
  }
  if (t) {
    if (r = t.words[0], r !== 0) throw new TypeError(e + " uses wrong encoding");
  } else if (t = pw.decode(e), r = t.words[0], r === 0) throw new TypeError(e + " uses wrong encoding");
  const n = is.fromWords(t.words.slice(1));
  return {
    version: r,
    prefix: t.prefix,
    data: Uint8Array.from(n)
  };
}
function qQ(e, t, r) {
  const n = is.toWords(e);
  return n.unshift(t), t === 0 ? is.encode(r, n) : pw.encode(r, n);
}
function w2(e, t) {
  t = t || qu;
  try {
    return g2({ output: e, network: t }).address;
  } catch {
  }
  try {
    return gg({ output: e, network: t }).address;
  } catch {
  }
  try {
    return m2({ output: e, network: t }).address;
  } catch {
  }
  try {
    return y2({ output: e, network: t }).address;
  } catch {
  }
  try {
    return b2({ output: e, network: t }).address;
  } catch {
  }
  try {
    return KQ(e, t);
  } catch {
  }
  throw new Error(XJ(e) + " has no matching Address");
}
function af(e, t) {
  t = t || qu;
  let r, n;
  try {
    r = RL(e);
  } catch {
  }
  if (r) {
    if (r.version === t.pubKeyHash)
      return g2({ hash: r.hash }).output;
    if (r.version === t.scriptHash)
      return gg({ hash: r.hash }).output;
  } else {
    try {
      n = DP(e);
    } catch {
    }
    if (n) {
      if (n.prefix !== t.bech32)
        throw new Error(e + " has an invalid prefix");
      if (n.version === 0) {
        if (n.data.length === 20)
          return m2({ hash: n.data }).output;
        if (n.data.length === 32)
          return y2({ hash: n.data }).output;
      } else if (n.version === 1) {
        if (n.data.length === 32)
          return b2({ pubkey: n.data }).output;
      } else if (n.version >= NL && n.version <= BL && n.data.length >= CL && n.data.length <= PL)
        return console.warn(UL), Oa([
          n.version + $L,
          n.data
        ]);
    }
  }
  throw new Error(e + " has no matching Script");
}
function mc(e) {
  const t = e.length;
  return Ms(t) + t;
}
function VQ(e) {
  const t = e.length;
  return Ms(t) + e.reduce((r, n) => r + mc(n), 0);
}
const yd = new Uint8Array(0), x$ = [], vS = mf(
  "0000000000000000000000000000000000000000000000000000000000000000"
), k$ = mf(
  "0000000000000000000000000000000000000000000000000000000000000001"
), GQ = mf("ffffffffffffffff"), WQ = {
  script: yd,
  valueBuffer: GQ
};
function ZQ(e) {
  return e.value !== void 0;
}
const hu = class xn {
  constructor() {
    st(this, "version", 1), st(this, "locktime", 0), st(this, "ins", []), st(this, "outs", []);
  }
  static fromBuffer(t, r) {
    const n = new jQ(t), o = new xn();
    o.version = n.readInt32();
    const i = n.readUInt8(), a = n.readUInt8();
    let u = !1;
    i === xn.ADVANCED_TRANSACTION_MARKER && a === xn.ADVANCED_TRANSACTION_FLAG ? u = !0 : n.offset -= 2;
    const l = n.readVarInt();
    for (let f = 0; f < l; ++f)
      o.ins.push({
        hash: n.readSlice(32),
        index: n.readUInt32(),
        script: n.readVarSlice(),
        sequence: n.readUInt32(),
        witness: x$
      });
    const d = n.readVarInt();
    for (let f = 0; f < d; ++f)
      o.outs.push({
        value: n.readInt64(),
        script: n.readVarSlice()
      });
    if (u) {
      for (let f = 0; f < l; ++f)
        o.ins[f].witness = n.readVector();
      if (!o.hasWitnesses())
        throw new Error("Transaction has superfluous witness data");
    }
    if (o.locktime = n.readUInt32(), r) return o;
    if (n.offset !== t.length)
      throw new Error("Transaction has unexpected data");
    return o;
  }
  static fromHex(t) {
    return xn.fromBuffer(mf(t), !1);
  }
  static isCoinbaseHash(t) {
    Qn(u$, t);
    for (let r = 0; r < 32; ++r)
      if (t[r] !== 0) return !1;
    return !0;
  }
  isCoinbase() {
    return this.ins.length === 1 && xn.isCoinbaseHash(this.ins[0].hash);
  }
  addInput(t, r, n, o) {
    return Qn(
      bc([
        u$,
        Ml,
        pI(r3(Ml)),
        pI(r3(rn))
      ]),
      [t, r, n, o]
    ), n == null && (n = xn.DEFAULT_SEQUENCE), this.ins.push({
      hash: t,
      index: r,
      script: o || yd,
      sequence: n,
      witness: x$
    }) - 1;
  }
  addOutput(t, r) {
    return Qn(bc([rn, mS]), [
      t,
      r
    ]), this.outs.push({
      script: t,
      value: r
    }) - 1;
  }
  hasWitnesses() {
    return this.ins.some((t) => t.witness.length !== 0);
  }
  weight() {
    const t = this.byteLength(!1), r = this.byteLength(!0);
    return t * 3 + r;
  }
  virtualSize() {
    return Math.ceil(this.weight() / 4);
  }
  byteLength(t = !0) {
    const r = t && this.hasWitnesses();
    return (r ? 10 : 8) + Ms(this.ins.length) + Ms(this.outs.length) + this.ins.reduce((n, o) => n + 40 + mc(o.script), 0) + this.outs.reduce((n, o) => n + 8 + mc(o.script), 0) + (r ? this.ins.reduce((n, o) => n + VQ(o.witness), 0) : 0);
  }
  clone() {
    const t = new xn();
    return t.version = this.version, t.locktime = this.locktime, t.ins = this.ins.map((r) => ({
      hash: r.hash,
      index: r.index,
      script: r.script,
      sequence: r.sequence,
      witness: r.witness
    })), t.outs = this.outs.map((r) => ({
      script: r.script,
      value: r.value
    })), t;
  }
  /**
   * Hash transaction for signing a specific input.
   *
   * Bitcoin uses a different hash for each signed transaction input.
   * This method copies the transaction, makes the necessary changes based on the
   * hashType, and then hashes the result.
   * This hash can then be used to sign the provided transaction input.
   */
  hashForSignature(t, r, n) {
    if (Qn(bc([Ml, rn, xa()]), [
      t,
      r,
      n
    ]), t >= this.ins.length) return k$;
    const o = Oa(
      to(r).filter((u) => u !== on.OP_CODESEPARATOR)
    ), i = this.clone();
    if ((n & 31) === xn.SIGHASH_NONE)
      i.outs = [], i.ins.forEach((u, l) => {
        l !== t && (u.sequence = 0);
      });
    else if ((n & 31) === xn.SIGHASH_SINGLE) {
      if (t >= this.outs.length) return k$;
      i.outs.length = t + 1;
      for (let u = 0; u < t; u++)
        i.outs[u] = WQ;
      i.ins.forEach((u, l) => {
        l !== t && (u.sequence = 0);
      });
    }
    n & xn.SIGHASH_ANYONECANPAY ? (i.ins = [i.ins[t]], i.ins[0].script = o) : (i.ins.forEach((u) => {
      u.script = yd;
    }), i.ins[t].script = o);
    const a = new Uint8Array(i.byteLength(!1) + 4);
    return rL(a, a.length - 4, n, "LE"), i.__toBuffer(a, 0, !1), mp(a);
  }
  hashForWitnessV1(t, r, n, o, i, a) {
    if (Qn(
      bc([
        Ml,
        Ia(rn),
        Ia(mS),
        Ml
      ]),
      [t, r, n, o]
    ), n.length !== this.ins.length || r.length !== this.ins.length)
      throw new Error("Must supply prevout script and value for all inputs");
    const u = o === xn.SIGHASH_DEFAULT ? xn.SIGHASH_ALL : o & xn.SIGHASH_OUTPUT_MASK, l = (o & xn.SIGHASH_INPUT_MASK) === xn.SIGHASH_ANYONECANPAY, d = u === xn.SIGHASH_NONE, f = u === xn.SIGHASH_SINGLE;
    let h = yd, g = yd, b = yd, w = yd, E = yd;
    if (!l) {
      let I = Ci.withCapacity(36 * this.ins.length);
      this.ins.forEach((S) => {
        I.writeSlice(S.hash), I.writeUInt32(S.index);
      }), h = ki(I.end()), I = Ci.withCapacity(8 * this.ins.length), n.forEach((S) => I.writeInt64(S)), g = ki(I.end()), I = Ci.withCapacity(
        r.map(mc).reduce((S, T) => S + T)
      ), r.forEach(
        (S) => I.writeVarSlice(S)
      ), b = ki(I.end()), I = Ci.withCapacity(4 * this.ins.length), this.ins.forEach((S) => I.writeUInt32(S.sequence)), w = ki(I.end());
    }
    if (d || f) {
      if (f && t < this.outs.length) {
        const I = this.outs[t], S = Ci.withCapacity(
          8 + mc(I.script)
        );
        S.writeInt64(I.value), S.writeVarSlice(I.script), E = ki(S.end());
      }
    } else {
      if (!this.outs.length)
        throw new Error("Add outputs to the transaction before signing.");
      const I = this.outs.map((T) => 8 + mc(T.script)).reduce((T, A) => T + A), S = Ci.withCapacity(I);
      this.outs.forEach((T) => {
        S.writeInt64(T.value), S.writeVarSlice(T.script);
      }), E = ki(S.end());
    }
    const _ = (i ? 2 : 0) + (a ? 1 : 0), O = 174 - (l ? 49 : 0) - (d ? 32 : 0) + (a ? 32 : 0) + (i ? 37 : 0), C = Ci.withCapacity(O);
    if (C.writeUInt8(o), C.writeInt32(this.version), C.writeUInt32(this.locktime), C.writeSlice(h), C.writeSlice(g), C.writeSlice(b), C.writeSlice(w), d || f || C.writeSlice(E), C.writeUInt8(_), l) {
      const I = this.ins[t];
      C.writeSlice(I.hash), C.writeUInt32(I.index), C.writeInt64(n[t]), C.writeVarSlice(r[t]), C.writeUInt32(I.sequence);
    } else
      C.writeUInt32(t);
    if (a) {
      const I = Ci.withCapacity(mc(a));
      I.writeVarSlice(a), C.writeSlice(ki(I.end()));
    }
    return f && C.writeSlice(E), i && (C.writeSlice(i), C.writeUInt8(0), C.writeUInt32(4294967295)), L5(
      "TapSighash",
      io([Uint8Array.from([0]), C.end()])
    );
  }
  hashForWitnessV0(t, r, n, o) {
    Qn(
      bc([
        Ml,
        rn,
        mS,
        Ml
      ]),
      [t, r, n, o]
    );
    let i = Uint8Array.from([]), a, u = vS, l = vS, d = vS;
    if (o & xn.SIGHASH_ANYONECANPAY || (i = new Uint8Array(36 * this.ins.length), a = new Ci(i, 0), this.ins.forEach((h) => {
      a.writeSlice(h.hash), a.writeUInt32(h.index);
    }), l = mp(i)), !(o & xn.SIGHASH_ANYONECANPAY) && (o & 31) !== xn.SIGHASH_SINGLE && (o & 31) !== xn.SIGHASH_NONE && (i = new Uint8Array(4 * this.ins.length), a = new Ci(i, 0), this.ins.forEach((h) => {
      a.writeUInt32(h.sequence);
    }), d = mp(i)), (o & 31) !== xn.SIGHASH_SINGLE && (o & 31) !== xn.SIGHASH_NONE) {
      const h = this.outs.reduce((g, b) => g + 8 + mc(b.script), 0);
      i = new Uint8Array(h), a = new Ci(i, 0), this.outs.forEach((g) => {
        a.writeInt64(g.value), a.writeVarSlice(g.script);
      }), u = mp(i);
    } else if ((o & 31) === xn.SIGHASH_SINGLE && t < this.outs.length) {
      const h = this.outs[t];
      i = new Uint8Array(8 + mc(h.script)), a = new Ci(i, 0), a.writeInt64(h.value), a.writeVarSlice(h.script), u = mp(i);
    }
    i = new Uint8Array(156 + mc(r)), a = new Ci(i, 0);
    const f = this.ins[t];
    return a.writeInt32(this.version), a.writeSlice(l), a.writeSlice(d), a.writeSlice(f.hash), a.writeUInt32(f.index), a.writeVarSlice(r), a.writeInt64(n), a.writeUInt32(f.sequence), a.writeSlice(u), a.writeUInt32(this.locktime), a.writeUInt32(o), mp(i);
  }
  getHash(t) {
    return t && this.isCoinbase() ? new Uint8Array(32) : mp(this.__toBuffer(void 0, void 0, t));
  }
  getId() {
    return Gt(MP(this.getHash(!1)));
  }
  toBuffer(t, r) {
    return this.__toBuffer(t, r, !0);
  }
  toHex() {
    return Gt(this.toBuffer(void 0, void 0));
  }
  setInputScript(t, r) {
    Qn(bc([xa(), rn]), [t, r]), this.ins[t].script = r;
  }
  setWitness(t, r) {
    Qn(bc([xa(), Ia(rn)]), [
      t,
      r
    ]), this.ins[t].witness = r;
  }
  __toBuffer(t, r, n = !1) {
    t || (t = new Uint8Array(this.byteLength(n)));
    const o = new Ci(t, r || 0);
    o.writeInt32(this.version);
    const i = n && this.hasWitnesses();
    return i && (o.writeUInt8(xn.ADVANCED_TRANSACTION_MARKER), o.writeUInt8(xn.ADVANCED_TRANSACTION_FLAG)), o.writeVarInt(this.ins.length), this.ins.forEach((a) => {
      o.writeSlice(a.hash), o.writeUInt32(a.index), o.writeVarSlice(a.script), o.writeUInt32(a.sequence);
    }), o.writeVarInt(this.outs.length), this.outs.forEach((a) => {
      ZQ(a) ? o.writeInt64(a.value) : o.writeSlice(a.valueBuffer), o.writeVarSlice(a.script);
    }), i && this.ins.forEach((a) => {
      o.writeVector(a.witness);
    }), o.writeUInt32(this.locktime), r !== void 0 ? t.slice(r, o.offset) : t;
  }
};
st(hu, "DEFAULT_SEQUENCE", 4294967295), st(hu, "SIGHASH_DEFAULT", 0), st(hu, "SIGHASH_ALL", 1), st(hu, "SIGHASH_NONE", 2), st(hu, "SIGHASH_SINGLE", 3), st(hu, "SIGHASH_ANYONECANPAY", 128), st(hu, "SIGHASH_OUTPUT_MASK", 3), st(hu, "SIGHASH_INPUT_MASK", 128), st(hu, "ADVANCED_TRANSACTION_MARKER", 0), st(hu, "ADVANCED_TRANSACTION_FLAG", 1);
let vo = hu;
var xc;
(function(e) {
  e[e.UNSIGNED_TX = 0] = "UNSIGNED_TX", e[e.GLOBAL_XPUB = 1] = "GLOBAL_XPUB";
})(xc || (xc = {}));
var Tt;
(function(e) {
  e[e.NON_WITNESS_UTXO = 0] = "NON_WITNESS_UTXO", e[e.WITNESS_UTXO = 1] = "WITNESS_UTXO", e[e.PARTIAL_SIG = 2] = "PARTIAL_SIG", e[e.SIGHASH_TYPE = 3] = "SIGHASH_TYPE", e[e.REDEEM_SCRIPT = 4] = "REDEEM_SCRIPT", e[e.WITNESS_SCRIPT = 5] = "WITNESS_SCRIPT", e[e.BIP32_DERIVATION = 6] = "BIP32_DERIVATION", e[e.FINAL_SCRIPTSIG = 7] = "FINAL_SCRIPTSIG", e[e.FINAL_SCRIPTWITNESS = 8] = "FINAL_SCRIPTWITNESS", e[e.POR_COMMITMENT = 9] = "POR_COMMITMENT", e[e.TAP_KEY_SIG = 19] = "TAP_KEY_SIG", e[e.TAP_SCRIPT_SIG = 20] = "TAP_SCRIPT_SIG", e[e.TAP_LEAF_SCRIPT = 21] = "TAP_LEAF_SCRIPT", e[e.TAP_BIP32_DERIVATION = 22] = "TAP_BIP32_DERIVATION", e[e.TAP_INTERNAL_KEY = 23] = "TAP_INTERNAL_KEY", e[e.TAP_MERKLE_ROOT = 24] = "TAP_MERKLE_ROOT";
})(Tt || (Tt = {}));
var bo;
(function(e) {
  e[e.REDEEM_SCRIPT = 0] = "REDEEM_SCRIPT", e[e.WITNESS_SCRIPT = 1] = "WITNESS_SCRIPT", e[e.BIP32_DERIVATION = 2] = "BIP32_DERIVATION", e[e.TAP_INTERNAL_KEY = 5] = "TAP_INTERNAL_KEY", e[e.TAP_TREE = 6] = "TAP_TREE", e[e.TAP_BIP32_DERIVATION = 7] = "TAP_BIP32_DERIVATION";
})(bo || (bo = {}));
const XQ = (e) => [...Array(e).keys()];
function YQ(e) {
  if (e.key[0] !== xc.GLOBAL_XPUB)
    throw new Error(
      "Decode Error: could not decode globalXpub with key 0x" + Gt(e.key)
    );
  if (e.key.length !== 79 || ![2, 3].includes(e.key[46]))
    throw new Error(
      "Decode Error: globalXpub has invalid extended pubkey in key 0x" + Gt(e.key)
    );
  if (e.value.length / 4 % 1 !== 0)
    throw new Error(
      "Decode Error: Global GLOBAL_XPUB value length should be multiple of 4"
    );
  const t = e.key.slice(1), r = {
    masterFingerprint: e.value.slice(0, 4),
    extendedPubkey: t,
    path: "m"
  };
  for (const n of XQ(e.value.length / 4 - 1)) {
    const o = hg(e.value, n * 4 + 4, "LE"), i = !!(o & 2147483648), a = o & 2147483647;
    r.path += "/" + a.toString(10) + (i ? "'" : "");
  }
  return r;
}
function JQ(e) {
  const t = new Uint8Array([xc.GLOBAL_XPUB]), r = io([t, e.extendedPubkey]), n = e.path.split("/"), o = new Uint8Array(n.length * 4);
  o.set(e.masterFingerprint, 0);
  let i = 4;
  return n.slice(1).forEach((a) => {
    const u = a.slice(-1) === "'";
    let l = 2147483647 & parseInt(u ? a.slice(0, -1) : a, 10);
    u && (l += 2147483648), p2(o, i, l, "LE"), i += 4;
  }), {
    key: r,
    value: o
  };
}
const QQ = "{ masterFingerprint: Uint8Array; extendedPubkey: Uint8Array; path: string; }";
function eee(e) {
  const t = e.extendedPubkey, r = e.masterFingerprint, n = e.path;
  return t instanceof Uint8Array && t.length === 78 && [2, 3].indexOf(t[45]) > -1 && r instanceof Uint8Array && r.length === 4 && typeof n == "string" && !!n.match(/^m(\/\d+'?)*$/);
}
function tee(e, t, r) {
  const n = Gt(t.extendedPubkey);
  return r.has(n) ? !1 : (r.add(n), e.filter((o) => ft(o.extendedPubkey, t.extendedPubkey)).length === 0);
}
const ree = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAddToArray: tee,
  check: eee,
  decode: YQ,
  encode: JQ,
  expected: QQ
}, Symbol.toStringTag, { value: "Module" }));
function nee(e) {
  return {
    key: new Uint8Array([xc.UNSIGNED_TX]),
    value: e.toBuffer()
  };
}
const oee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  encode: nee
}, Symbol.toStringTag, { value: "Module" }));
function iee(e) {
  if (e.key[0] !== Tt.FINAL_SCRIPTSIG)
    throw new Error(
      "Decode Error: could not decode finalScriptSig with key 0x" + Gt(e.key)
    );
  return e.value;
}
function aee(e) {
  return {
    key: new Uint8Array([Tt.FINAL_SCRIPTSIG]),
    value: e
  };
}
const see = "Uint8Array";
function uee(e) {
  return e instanceof Uint8Array;
}
function cee(e, t) {
  return !!e && !!t && e.finalScriptSig === void 0;
}
const lee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAdd: cee,
  check: uee,
  decode: iee,
  encode: aee,
  expected: see
}, Symbol.toStringTag, { value: "Module" }));
function fee(e) {
  if (e.key[0] !== Tt.FINAL_SCRIPTWITNESS)
    throw new Error(
      "Decode Error: could not decode finalScriptWitness with key 0x" + Gt(e.key)
    );
  return e.value;
}
function dee(e) {
  return {
    key: new Uint8Array([Tt.FINAL_SCRIPTWITNESS]),
    value: e
  };
}
const hee = "Uint8Array";
function pee(e) {
  return e instanceof Uint8Array;
}
function gee(e, t) {
  return !!e && !!t && e.finalScriptWitness === void 0;
}
const mee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAdd: gee,
  check: pee,
  decode: fee,
  encode: dee,
  expected: hee
}, Symbol.toStringTag, { value: "Module" }));
function yee(e) {
  if (e.key[0] !== Tt.NON_WITNESS_UTXO)
    throw new Error(
      "Decode Error: could not decode nonWitnessUtxo with key 0x" + Gt(e.key)
    );
  return e.value;
}
function bee(e) {
  return {
    key: new Uint8Array([Tt.NON_WITNESS_UTXO]),
    value: e
  };
}
const wee = "Uint8Array";
function vee(e) {
  return e instanceof Uint8Array;
}
function Eee(e, t) {
  return !!e && !!t && e.nonWitnessUtxo === void 0;
}
const _ee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAdd: Eee,
  check: vee,
  decode: yee,
  encode: bee,
  expected: wee
}, Symbol.toStringTag, { value: "Module" }));
function Aee(e) {
  if (e.key[0] !== Tt.PARTIAL_SIG)
    throw new Error(
      "Decode Error: could not decode partialSig with key 0x" + Gt(e.key)
    );
  if (!(e.key.length === 34 || e.key.length === 66) || ![2, 3, 4].includes(e.key[1]))
    throw new Error(
      "Decode Error: partialSig has invalid pubkey in key 0x" + Gt(e.key)
    );
  return {
    pubkey: e.key.slice(1),
    signature: e.value
  };
}
function xee(e) {
  const t = new Uint8Array([Tt.PARTIAL_SIG]);
  return {
    key: io([t, e.pubkey]),
    value: e.signature
  };
}
const kee = "{ pubkey: Uint8Array; signature: Uint8Array; }";
function See(e) {
  return e.pubkey instanceof Uint8Array && e.signature instanceof Uint8Array && [33, 65].includes(e.pubkey.length) && [2, 3, 4].includes(e.pubkey[0]) && Tee(e.signature);
}
function Tee(e) {
  if (!(e instanceof Uint8Array) || e.length < 9 || e[0] !== 48 || e.length !== e[1] + 3 || e[2] !== 2) return !1;
  const t = e[3];
  if (t > 33 || t < 1 || e[3 + t + 1] !== 2) return !1;
  const r = e[3 + t + 2];
  return !(r > 33 || r < 1 || e.length !== 3 + t + 2 + r + 2);
}
function Iee(e, t, r) {
  const n = Gt(t.pubkey);
  return r.has(n) ? !1 : (r.add(n), e.filter((o) => ft(o.pubkey, t.pubkey) === 0).length === 0);
}
const Oee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAddToArray: Iee,
  check: See,
  decode: Aee,
  encode: xee,
  expected: kee
}, Symbol.toStringTag, { value: "Module" }));
function Pee(e) {
  if (e.key[0] !== Tt.POR_COMMITMENT)
    throw new Error(
      "Decode Error: could not decode porCommitment with key 0x" + Gt(e.key)
    );
  return kJ(e.value);
}
function Cee(e) {
  return {
    key: new Uint8Array([Tt.POR_COMMITMENT]),
    value: SJ(e)
  };
}
const Bee = "string";
function Nee(e) {
  return typeof e == "string";
}
function $ee(e, t) {
  return !!e && !!t && e.porCommitment === void 0;
}
const Uee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAdd: $ee,
  check: Nee,
  decode: Pee,
  encode: Cee,
  expected: Bee
}, Symbol.toStringTag, { value: "Module" }));
function Ree(e) {
  if (e.key[0] !== Tt.SIGHASH_TYPE)
    throw new Error(
      "Decode Error: could not decode sighashType with key 0x" + Gt(e.key)
    );
  return Number(hg(e.value, 0, "LE"));
}
function zee(e) {
  const t = Uint8Array.from([Tt.SIGHASH_TYPE]), r = new Uint8Array(4);
  return p2(r, 0, e, "LE"), {
    key: t,
    value: r
  };
}
const jee = "number";
function Lee(e) {
  return typeof e == "number";
}
function Hee(e, t) {
  return !!e && !!t && e.sighashType === void 0;
}
const Fee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAdd: Hee,
  check: Lee,
  decode: Ree,
  encode: zee,
  expected: jee
}, Symbol.toStringTag, { value: "Module" }));
function Mee(e) {
  if (e.key[0] !== Tt.TAP_KEY_SIG || e.key.length !== 1)
    throw new Error(
      "Decode Error: could not decode tapKeySig with key 0x" + Gt(e.key)
    );
  if (!zL(e.value))
    throw new Error(
      "Decode Error: tapKeySig not a valid 64-65-byte BIP340 signature"
    );
  return e.value;
}
function Dee(e) {
  return { key: Uint8Array.from([Tt.TAP_KEY_SIG]), value: e };
}
const Kee = "Uint8Array";
function zL(e) {
  return e instanceof Uint8Array && (e.length === 64 || e.length === 65);
}
function qee(e, t) {
  return !!e && !!t && e.tapKeySig === void 0;
}
const Vee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAdd: qee,
  check: zL,
  decode: Mee,
  encode: Dee,
  expected: Kee
}, Symbol.toStringTag, { value: "Module" }));
function Gee(e) {
  if (e.key[0] !== Tt.TAP_LEAF_SCRIPT)
    throw new Error(
      "Decode Error: could not decode tapLeafScript with key 0x" + Gt(e.key)
    );
  if ((e.key.length - 2) % 32 !== 0)
    throw new Error(
      "Decode Error: tapLeafScript has invalid control block in key 0x" + Gt(e.key)
    );
  const t = e.value[e.value.length - 1];
  if ((e.key[1] & 254) !== t)
    throw new Error(
      "Decode Error: tapLeafScript bad leaf version in key 0x" + Gt(e.key)
    );
  const r = e.value.slice(0, -1);
  return { controlBlock: e.key.slice(1), script: r, leafVersion: t };
}
function Wee(e) {
  const t = Uint8Array.from([Tt.TAP_LEAF_SCRIPT]), r = Uint8Array.from([e.leafVersion]);
  return {
    key: io([t, e.controlBlock]),
    value: io([e.script, r])
  };
}
const Zee = "{ controlBlock: Uint8Array; leafVersion: number, script: Uint8Array; }";
function Xee(e) {
  return e.controlBlock instanceof Uint8Array && (e.controlBlock.length - 1) % 32 === 0 && (e.controlBlock[0] & 254) === e.leafVersion && e.script instanceof Uint8Array;
}
function Yee(e, t, r) {
  const n = Gt(t.controlBlock);
  return r.has(n) ? !1 : (r.add(n), e.filter((o) => ft(o.controlBlock, t.controlBlock) === 0).length === 0);
}
const Jee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAddToArray: Yee,
  check: Xee,
  decode: Gee,
  encode: Wee,
  expected: Zee
}, Symbol.toStringTag, { value: "Module" }));
function Qee(e) {
  if (e.key[0] !== Tt.TAP_MERKLE_ROOT || e.key.length !== 1)
    throw new Error(
      "Decode Error: could not decode tapMerkleRoot with key 0x" + Gt(e.key)
    );
  if (!jL(e.value))
    throw new Error("Decode Error: tapMerkleRoot not a 32-byte hash");
  return e.value;
}
function ete(e) {
  return { key: Uint8Array.from([Tt.TAP_MERKLE_ROOT]), value: e };
}
const tte = "Uint8Array";
function jL(e) {
  return e instanceof Uint8Array && e.length === 32;
}
function rte(e, t) {
  return !!e && !!t && e.tapMerkleRoot === void 0;
}
const nte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAdd: rte,
  check: jL,
  decode: Qee,
  encode: ete,
  expected: tte
}, Symbol.toStringTag, { value: "Module" }));
function ote(e) {
  if (e.key[0] !== Tt.TAP_SCRIPT_SIG)
    throw new Error(
      "Decode Error: could not decode tapScriptSig with key 0x" + Gt(e.key)
    );
  if (e.key.length !== 65)
    throw new Error(
      "Decode Error: tapScriptSig has invalid key 0x" + Gt(e.key)
    );
  if (e.value.length !== 64 && e.value.length !== 65)
    throw new Error(
      "Decode Error: tapScriptSig has invalid signature in key 0x" + Gt(e.key)
    );
  const t = e.key.slice(1, 33), r = e.key.slice(33);
  return {
    pubkey: t,
    leafHash: r,
    signature: e.value
  };
}
function ite(e) {
  const t = Uint8Array.from([Tt.TAP_SCRIPT_SIG]);
  return {
    key: io([t, e.pubkey, e.leafHash]),
    value: e.signature
  };
}
const ate = "{ pubkey: Uint8Array; leafHash: Uint8Array; signature: Uint8Array; }";
function ste(e) {
  return e.pubkey instanceof Uint8Array && e.leafHash instanceof Uint8Array && e.signature instanceof Uint8Array && e.pubkey.length === 32 && e.leafHash.length === 32 && (e.signature.length === 64 || e.signature.length === 65);
}
function ute(e, t, r) {
  const n = Gt(t.pubkey) + Gt(t.leafHash);
  return r.has(n) ? !1 : (r.add(n), e.filter(
    (o) => ft(o.pubkey, t.pubkey) === 0 && ft(o.leafHash, t.leafHash) === 0
  ).length === 0);
}
const cte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAddToArray: ute,
  check: ste,
  decode: ote,
  encode: ite,
  expected: ate
}, Symbol.toStringTag, { value: "Module" }));
function lte(e) {
  if (e.key[0] !== Tt.WITNESS_UTXO)
    throw new Error(
      "Decode Error: could not decode witnessUtxo with key 0x" + Gt(e.key)
    );
  const t = oL(e.value, 0, "LE");
  let r = 8;
  const { numberValue: n, bytes: o } = mg(
    e.value,
    r
  );
  r += o;
  const i = e.value.slice(r);
  if (i.length !== n)
    throw new Error("Decode Error: WITNESS_UTXO script is not proper length");
  return {
    script: i,
    value: t
  };
}
function fte(e) {
  const { script: t, value: r } = e, n = Ms(t.length), o = new Uint8Array(8 + n + t.length);
  return nL(o, 0, BigInt(r), "LE"), Rd(t.length, o, 8), o.set(t, 8 + n), {
    key: Uint8Array.from([Tt.WITNESS_UTXO]),
    value: o
  };
}
const dte = "{ script: Uint8Array; value: bigint; }";
function hte(e) {
  return e.script instanceof Uint8Array && typeof e.value == "bigint";
}
function pte(e, t) {
  return !!e && !!t && e.witnessUtxo === void 0;
}
const gte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAdd: pte,
  check: hte,
  decode: lte,
  encode: fte,
  expected: dte
}, Symbol.toStringTag, { value: "Module" }));
function mte(e) {
  if (e.key[0] !== bo.TAP_TREE || e.key.length !== 1)
    throw new Error(
      "Decode Error: could not decode tapTree with key 0x" + Gt(e.key)
    );
  let t = 0;
  const r = [];
  for (; t < e.value.length; ) {
    const n = e.value[t++], o = e.value[t++], { numberValue: i, bytes: a } = mg(
      e.value,
      t
    );
    t += a, r.push({
      depth: n,
      leafVersion: o,
      script: e.value.slice(t, t + i)
    }), t += i;
  }
  return { leaves: r };
}
function yte(e) {
  const t = Uint8Array.from([bo.TAP_TREE]), r = [].concat(
    ...e.leaves.map((n) => [
      Uint8Array.of(n.depth, n.leafVersion),
      Rd(BigInt(n.script.length)).buffer,
      n.script
    ])
  );
  return {
    key: t,
    value: io(r)
  };
}
const bte = "{ leaves: [{ depth: number; leafVersion: number, script: Uint8Array; }] }";
function wte(e) {
  return Array.isArray(e.leaves) && e.leaves.every(
    (t) => t.depth >= 0 && t.depth <= 128 && (t.leafVersion & 254) === t.leafVersion && t.script instanceof Uint8Array
  );
}
function vte(e, t) {
  return !!e && !!t && e.tapTree === void 0;
}
const Ete = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAdd: vte,
  check: wte,
  decode: mte,
  encode: yte,
  expected: bte
}, Symbol.toStringTag, { value: "Module" })), _te = (e) => [...Array(e).keys()], Ate = (e) => e.length === 33 && [2, 3].includes(e[0]) || e.length === 65 && e[0] === 4;
function KP(e, t = Ate) {
  function r(u) {
    if (u.key[0] !== e)
      throw new Error(
        "Decode Error: could not decode bip32Derivation with key 0x" + Gt(u.key)
      );
    const l = u.key.slice(1);
    if (!t(l))
      throw new Error(
        "Decode Error: bip32Derivation has invalid pubkey in key 0x" + Gt(u.key)
      );
    if (u.value.length / 4 % 1 !== 0)
      throw new Error(
        "Decode Error: Input BIP32_DERIVATION value length should be multiple of 4"
      );
    const d = {
      masterFingerprint: u.value.slice(0, 4),
      pubkey: l,
      path: "m"
    };
    for (const f of _te(u.value.length / 4 - 1)) {
      const h = hg(u.value, f * 4 + 4, "LE"), g = !!(h & 2147483648), b = h & 2147483647;
      d.path += "/" + b.toString(10) + (g ? "'" : "");
    }
    return d;
  }
  function n(u) {
    const l = Uint8Array.from([e]), d = io([l, u.pubkey]), f = u.path.split("/"), h = new Uint8Array(f.length * 4);
    h.set(u.masterFingerprint, 0);
    let g = 4;
    return f.slice(1).forEach((b) => {
      const w = b.slice(-1) === "'";
      let E = 2147483647 & parseInt(w ? b.slice(0, -1) : b, 10);
      w && (E += 2147483648), p2(h, g, E, "LE"), g += 4;
    }), {
      key: d,
      value: h
    };
  }
  const o = "{ masterFingerprint: Uint8Array; pubkey: Uint8Array; path: string; }";
  function i(u) {
    return u.pubkey instanceof Uint8Array && u.masterFingerprint instanceof Uint8Array && typeof u.path == "string" && t(u.pubkey) && u.masterFingerprint.length === 4;
  }
  function a(u, l, d) {
    const f = Gt(l.pubkey);
    return d.has(f) ? !1 : (d.add(f), u.filter((h) => ft(h.pubkey, l.pubkey) === 0).length === 0);
  }
  return {
    decode: r,
    encode: n,
    check: i,
    expected: o,
    canAddToArray: a
  };
}
function qP(e) {
  return t;
  function t(r) {
    let n;
    if (e.includes(r.key[0]) && (n = r.key.slice(1), !(n.length === 33 || n.length === 65) || ![2, 3, 4].includes(n[0])))
      throw new Error(
        "Format Error: invalid pubkey in key 0x" + Gt(r.key)
      );
    return n;
  }
}
function LL(e) {
  function t(a) {
    if (a.key[0] !== e)
      throw new Error(
        "Decode Error: could not decode redeemScript with key 0x" + Gt(a.key)
      );
    return a.value;
  }
  function r(a) {
    return {
      key: Uint8Array.from([e]),
      value: a
    };
  }
  const n = "Uint8Array";
  function o(a) {
    return a instanceof Uint8Array;
  }
  function i(a, u) {
    return !!a && !!u && a.redeemScript === void 0;
  }
  return {
    decode: t,
    encode: r,
    check: o,
    expected: n,
    canAdd: i
  };
}
const xte = (e) => e.length === 32;
function HL(e) {
  const t = KP(e, xte);
  function r(a) {
    const { numberValue: u, bytes: l } = mg(
      a.value
    ), d = t.decode({
      key: a.key,
      value: a.value.slice(l + Number(u) * 32)
    }), f = new Array(Number(u));
    for (let h = 0, g = l; h < u; h++, g += 32)
      f[h] = a.value.slice(g, g + 32);
    return { ...d, leafHashes: f };
  }
  function n(a) {
    const u = t.encode(a), l = Ms(a.leafHashes.length), d = new Uint8Array(l);
    Rd(a.leafHashes.length, d);
    const f = io([d, ...a.leafHashes, u.value]);
    return { ...u, value: f };
  }
  const o = "{ masterFingerprint: Uint8Array; pubkey: Uint8Array; path: string; leafHashes: Uint8Array[]; }";
  function i(a) {
    return Array.isArray(a.leafHashes) && a.leafHashes.every(
      (u) => u instanceof Uint8Array && u.length === 32
    ) && t.check(a);
  }
  return {
    decode: r,
    encode: n,
    check: i,
    expected: o,
    canAddToArray: t.canAddToArray
  };
}
function FL(e) {
  function t(a) {
    if (a.key[0] !== e || a.key.length !== 1)
      throw new Error(
        "Decode Error: could not decode tapInternalKey with key 0x" + Gt(a.key)
      );
    if (a.value.length !== 32)
      throw new Error(
        "Decode Error: tapInternalKey not a 32-byte x-only pubkey"
      );
    return a.value;
  }
  function r(a) {
    return { key: Uint8Array.from([e]), value: a };
  }
  const n = "Uint8Array";
  function o(a) {
    return a instanceof Uint8Array && a.length === 32;
  }
  function i(a, u) {
    return !!a && !!u && a.tapInternalKey === void 0;
  }
  return {
    decode: t,
    encode: r,
    check: o,
    expected: n,
    canAdd: i
  };
}
function ML(e) {
  function t(a) {
    if (a.key[0] !== e)
      throw new Error(
        "Decode Error: could not decode witnessScript with key 0x" + Gt(a.key)
      );
    return a.value;
  }
  function r(a) {
    return {
      key: Uint8Array.from([e]),
      value: a
    };
  }
  const n = "Uint8Array";
  function o(a) {
    return a instanceof Uint8Array;
  }
  function i(a, u) {
    return !!a && !!u && a.witnessScript === void 0;
  }
  return {
    decode: t,
    encode: r,
    check: o,
    expected: n,
    canAdd: i
  };
}
const VP = {
  unsignedTx: oee,
  globalXpub: ree,
  // pass an Array of key bytes that require pubkey beside the key
  checkPubkey: qP([])
}, Ho = {
  nonWitnessUtxo: _ee,
  partialSig: Oee,
  sighashType: Fee,
  finalScriptSig: lee,
  finalScriptWitness: mee,
  porCommitment: Uee,
  witnessUtxo: gte,
  bip32Derivation: KP(Tt.BIP32_DERIVATION),
  redeemScript: LL(Tt.REDEEM_SCRIPT),
  witnessScript: ML(Tt.WITNESS_SCRIPT),
  checkPubkey: qP([
    Tt.PARTIAL_SIG,
    Tt.BIP32_DERIVATION
  ]),
  tapKeySig: Vee,
  tapScriptSig: cte,
  tapLeafScript: Jee,
  tapBip32Derivation: HL(
    Tt.TAP_BIP32_DERIVATION
  ),
  tapInternalKey: FL(Tt.TAP_INTERNAL_KEY),
  tapMerkleRoot: nte
}, Dl = {
  bip32Derivation: KP(bo.BIP32_DERIVATION),
  redeemScript: LL(bo.REDEEM_SCRIPT),
  witnessScript: ML(bo.WITNESS_SCRIPT),
  checkPubkey: qP([bo.BIP32_DERIVATION]),
  tapBip32Derivation: HL(
    bo.TAP_BIP32_DERIVATION
  ),
  tapTree: Ete,
  tapInternalKey: FL(bo.TAP_INTERNAL_KEY)
}, kte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  globals: VP,
  inputs: Ho,
  outputs: Dl
}, Symbol.toStringTag, { value: "Module" })), u3 = (e) => [...Array(e).keys()];
function S$(e) {
  const t = e.map(Ste);
  return t.push(Uint8Array.from([0])), io(t);
}
function Ste(e) {
  const t = e.key.length, r = e.value.length, n = Ms(t), o = Ms(r), i = new Uint8Array(n + t + o + r);
  return Rd(t, i, 0), i.set(e.key, n), Rd(r, i, n + t), i.set(e.value, n + t + o), i;
}
function Tte(e, t) {
  let r = 0;
  function n() {
    const { numberValue: _, bytes: O } = mg(e, r);
    r += O;
    const C = e.slice(r, r + Number(_));
    return r += Number(_), C;
  }
  function o() {
    const _ = hg(e, r, "BE");
    return r += 4, _;
  }
  function i() {
    const _ = nf(e, r);
    return r += 1, _;
  }
  function a() {
    const _ = n(), O = n();
    return {
      key: _,
      value: O
    };
  }
  function u() {
    if (r >= e.length)
      throw new Error("Format Error: Unexpected End of PSBT");
    const _ = nf(e, r) === 0;
    return _ && r++, _;
  }
  if (o() !== 1886610036)
    throw new Error("Format Error: Invalid Magic Number");
  if (i() !== 255)
    throw new Error(
      "Format Error: Magic Number must be followed by 0xff separator"
    );
  const l = [], d = {};
  for (; !u(); ) {
    const _ = a(), O = Gt(_.key);
    if (d[O])
      throw new Error(
        "Format Error: Keys must be unique for global keymap: key " + O
      );
    d[O] = 1, l.push(_);
  }
  const f = l.filter(
    (_) => _.key[0] === xc.UNSIGNED_TX
  );
  if (f.length !== 1)
    throw new Error("Format Error: Only one UNSIGNED_TX allowed");
  const h = t(f[0].value), { inputCount: g, outputCount: b } = h.getInputOutputCounts(), w = [], E = [];
  for (const _ of u3(g)) {
    const O = {}, C = [];
    for (; !u(); ) {
      const I = a(), S = Gt(I.key);
      if (O[S])
        throw new Error(
          "Format Error: Keys must be unique for each input: input index " + _ + " key " + S
        );
      O[S] = 1, C.push(I);
    }
    w.push(C);
  }
  for (const _ of u3(b)) {
    const O = {}, C = [];
    for (; !u(); ) {
      const I = a(), S = Gt(I.key);
      if (O[S])
        throw new Error(
          "Format Error: Keys must be unique for each output: output index " + _ + " key " + S
        );
      O[S] = 1, C.push(I);
    }
    E.push(C);
  }
  return DL(h, {
    globalMapKeyVals: l,
    inputKeyVals: w,
    outputKeyVals: E
  });
}
function Oi(e, t, r) {
  if (ft(t, Uint8Array.from([r])))
    throw new Error(
      // `Format Error: Invalid ${type} key: ${keyBuf.toString('hex')}`,
      `Format Error: Invalid ${e} key: ${Gt(t)}`
    );
}
function DL(e, { globalMapKeyVals: t, inputKeyVals: r, outputKeyVals: n }) {
  const o = {
    unsignedTx: e
  };
  let i = 0;
  for (const f of t)
    switch (f.key[0]) {
      case xc.UNSIGNED_TX:
        if (Oi("global", f.key, xc.UNSIGNED_TX), i > 0)
          throw new Error("Format Error: GlobalMap has multiple UNSIGNED_TX");
        i++;
        break;
      case xc.GLOBAL_XPUB:
        o.globalXpub === void 0 && (o.globalXpub = []), o.globalXpub.push(VP.globalXpub.decode(f));
        break;
      default:
        o.unknownKeyVals || (o.unknownKeyVals = []), o.unknownKeyVals.push(f);
    }
  const a = r.length, u = n.length, l = [], d = [];
  for (const f of u3(a)) {
    const h = {};
    for (const g of r[f])
      switch (Ho.checkPubkey(g), g.key[0]) {
        case Tt.NON_WITNESS_UTXO:
          if (Oi("input", g.key, Tt.NON_WITNESS_UTXO), h.nonWitnessUtxo !== void 0)
            throw new Error(
              "Format Error: Input has multiple NON_WITNESS_UTXO"
            );
          h.nonWitnessUtxo = Ho.nonWitnessUtxo.decode(g);
          break;
        case Tt.WITNESS_UTXO:
          if (Oi("input", g.key, Tt.WITNESS_UTXO), h.witnessUtxo !== void 0)
            throw new Error("Format Error: Input has multiple WITNESS_UTXO");
          h.witnessUtxo = Ho.witnessUtxo.decode(g);
          break;
        case Tt.PARTIAL_SIG:
          h.partialSig === void 0 && (h.partialSig = []), h.partialSig.push(Ho.partialSig.decode(g));
          break;
        case Tt.SIGHASH_TYPE:
          if (Oi("input", g.key, Tt.SIGHASH_TYPE), h.sighashType !== void 0)
            throw new Error("Format Error: Input has multiple SIGHASH_TYPE");
          h.sighashType = Ho.sighashType.decode(g);
          break;
        case Tt.REDEEM_SCRIPT:
          if (Oi("input", g.key, Tt.REDEEM_SCRIPT), h.redeemScript !== void 0)
            throw new Error("Format Error: Input has multiple REDEEM_SCRIPT");
          h.redeemScript = Ho.redeemScript.decode(g);
          break;
        case Tt.WITNESS_SCRIPT:
          if (Oi("input", g.key, Tt.WITNESS_SCRIPT), h.witnessScript !== void 0)
            throw new Error("Format Error: Input has multiple WITNESS_SCRIPT");
          h.witnessScript = Ho.witnessScript.decode(g);
          break;
        case Tt.BIP32_DERIVATION:
          h.bip32Derivation === void 0 && (h.bip32Derivation = []), h.bip32Derivation.push(
            Ho.bip32Derivation.decode(g)
          );
          break;
        case Tt.FINAL_SCRIPTSIG:
          Oi("input", g.key, Tt.FINAL_SCRIPTSIG), h.finalScriptSig = Ho.finalScriptSig.decode(g);
          break;
        case Tt.FINAL_SCRIPTWITNESS:
          Oi("input", g.key, Tt.FINAL_SCRIPTWITNESS), h.finalScriptWitness = Ho.finalScriptWitness.decode(
            g
          );
          break;
        case Tt.POR_COMMITMENT:
          Oi("input", g.key, Tt.POR_COMMITMENT), h.porCommitment = Ho.porCommitment.decode(g);
          break;
        case Tt.TAP_KEY_SIG:
          Oi("input", g.key, Tt.TAP_KEY_SIG), h.tapKeySig = Ho.tapKeySig.decode(g);
          break;
        case Tt.TAP_SCRIPT_SIG:
          h.tapScriptSig === void 0 && (h.tapScriptSig = []), h.tapScriptSig.push(Ho.tapScriptSig.decode(g));
          break;
        case Tt.TAP_LEAF_SCRIPT:
          h.tapLeafScript === void 0 && (h.tapLeafScript = []), h.tapLeafScript.push(Ho.tapLeafScript.decode(g));
          break;
        case Tt.TAP_BIP32_DERIVATION:
          h.tapBip32Derivation === void 0 && (h.tapBip32Derivation = []), h.tapBip32Derivation.push(
            Ho.tapBip32Derivation.decode(g)
          );
          break;
        case Tt.TAP_INTERNAL_KEY:
          Oi("input", g.key, Tt.TAP_INTERNAL_KEY), h.tapInternalKey = Ho.tapInternalKey.decode(g);
          break;
        case Tt.TAP_MERKLE_ROOT:
          Oi("input", g.key, Tt.TAP_MERKLE_ROOT), h.tapMerkleRoot = Ho.tapMerkleRoot.decode(g);
          break;
        default:
          h.unknownKeyVals || (h.unknownKeyVals = []), h.unknownKeyVals.push(g);
      }
    l.push(h);
  }
  for (const f of u3(u)) {
    const h = {};
    for (const g of n[f])
      switch (Dl.checkPubkey(g), g.key[0]) {
        case bo.REDEEM_SCRIPT:
          if (Oi("output", g.key, bo.REDEEM_SCRIPT), h.redeemScript !== void 0)
            throw new Error("Format Error: Output has multiple REDEEM_SCRIPT");
          h.redeemScript = Dl.redeemScript.decode(g);
          break;
        case bo.WITNESS_SCRIPT:
          if (Oi("output", g.key, bo.WITNESS_SCRIPT), h.witnessScript !== void 0)
            throw new Error("Format Error: Output has multiple WITNESS_SCRIPT");
          h.witnessScript = Dl.witnessScript.decode(g);
          break;
        case bo.BIP32_DERIVATION:
          h.bip32Derivation === void 0 && (h.bip32Derivation = []), h.bip32Derivation.push(
            Dl.bip32Derivation.decode(g)
          );
          break;
        case bo.TAP_INTERNAL_KEY:
          Oi("output", g.key, bo.TAP_INTERNAL_KEY), h.tapInternalKey = Dl.tapInternalKey.decode(g);
          break;
        case bo.TAP_TREE:
          Oi("output", g.key, bo.TAP_TREE), h.tapTree = Dl.tapTree.decode(g);
          break;
        case bo.TAP_BIP32_DERIVATION:
          h.tapBip32Derivation === void 0 && (h.tapBip32Derivation = []), h.tapBip32Derivation.push(
            Dl.tapBip32Derivation.decode(g)
          );
          break;
        default:
          h.unknownKeyVals || (h.unknownKeyVals = []), h.unknownKeyVals.push(g);
      }
    d.push(h);
  }
  return { globalMap: o, inputs: l, outputs: d };
}
function Ite({ globalMap: e, inputs: t, outputs: r }) {
  const { globalKeyVals: n, inputKeyVals: o, outputKeyVals: i } = wI({
    globalMap: e,
    inputs: t,
    outputs: r
  }), a = S$(n), u = (h) => h.length === 0 ? [Uint8Array.from([0])] : h.map(S$), l = u(o), d = u(i), f = new Uint8Array(5);
  return f.set([112, 115, 98, 116, 255], 0), io(
    [f, a].concat(l, d)
  );
}
const Ote = (e, t) => ft(e.key, t.key);
function ES(e, t) {
  const r = /* @__PURE__ */ new Set(), n = Object.entries(e).reduce((i, [a, u]) => {
    if (a === "unknownKeyVals") return i;
    const l = t[a];
    if (l === void 0) return i;
    const d = (Array.isArray(u) ? u : [u]).map(
      l.encode
    );
    return d.map((f) => Gt(f.key)).forEach((f) => {
      if (r.has(f))
        throw new Error("Serialize Error: Duplicate key: " + f);
      r.add(f);
    }), i.concat(d);
  }, []), o = e.unknownKeyVals ? e.unknownKeyVals.filter((i) => !r.has(Gt(i.key))) : [];
  return n.concat(o).sort(Ote);
}
function wI({ globalMap: e, inputs: t, outputs: r }) {
  return {
    globalKeyVals: ES(e, VP),
    inputKeyVals: t.map((n) => ES(n, Ho)),
    outputKeyVals: r.map((n) => ES(n, Dl))
  };
}
function Pte(e) {
  const t = e[0], r = wI(t), n = e.slice(1);
  if (n.length === 0) throw new Error("Combine: Nothing to combine");
  const o = T$(t);
  if (o === void 0)
    throw new Error("Combine: Self missing transaction");
  const i = F0(r.globalKeyVals), a = r.inputKeyVals.map(F0), u = r.outputKeyVals.map(F0);
  for (const l of n) {
    const d = T$(l);
    if (d === void 0 || ft(d.toBuffer(), o.toBuffer()) !== 0)
      throw new Error(
        "Combine: One of the Psbts does not have the same transaction."
      );
    const f = wI(l);
    F0(f.globalKeyVals).forEach(
      _S(
        i,
        r.globalKeyVals,
        f.globalKeyVals
      )
    ), f.inputKeyVals.map(F0).forEach(
      (h, g) => h.forEach(
        _S(
          a[g],
          r.inputKeyVals[g],
          f.inputKeyVals[g]
        )
      )
    ), f.outputKeyVals.map(F0).forEach(
      (h, g) => h.forEach(
        _S(
          u[g],
          r.outputKeyVals[g],
          f.outputKeyVals[g]
        )
      )
    );
  }
  return DL(o, {
    globalMapKeyVals: r.globalKeyVals,
    inputKeyVals: r.inputKeyVals,
    outputKeyVals: r.outputKeyVals
  });
}
function _S(e, t, r) {
  return (n) => {
    if (e.has(n)) return;
    const o = r.filter((i) => Gt(i.key) === n)[0];
    t.push(o), e.add(n);
  };
}
function T$(e) {
  return e.globalMap.unsignedTx;
}
function F0(e) {
  const t = /* @__PURE__ */ new Set();
  return e.forEach((r) => {
    const n = Gt(r.key);
    if (t.has(n))
      throw new Error("Combine: KeyValue Map keys should be unique");
    t.add(n);
  }), t;
}
function Ei(e, t) {
  const r = e[t];
  if (r === void 0) throw new Error(`No input #${t}`);
  return r;
}
function gw(e, t) {
  const r = e[t];
  if (r === void 0) throw new Error(`No output #${t}`);
  return r;
}
function AS(e, t, r) {
  if (e.key[0] < r)
    throw new Error(
      "Use the method for your specific key instead of addUnknownKeyVal*"
    );
  if (t && t.filter((n) => ft(n.key, e.key) === 0).length !== 0)
    throw new Error(`Duplicate Key: ${Gt(e.key)}`);
}
function xS(e) {
  let t = 0;
  return Object.keys(e).forEach((r) => {
    Number(isNaN(Number(r))) && t++;
  }), t;
}
function Cte(e, t) {
  let r = !1;
  if (t.nonWitnessUtxo || t.witnessUtxo) {
    const n = !!t.redeemScript, o = !!t.witnessScript, i = !n || !!t.finalScriptSig, a = !o || !!t.finalScriptWitness, u = !!t.finalScriptSig || !!t.finalScriptWitness;
    r = i && a && u;
  }
  if (r === !1)
    throw new Error(
      `Input #${e} has too much or too little data to clean`
    );
}
function I$(e, t, r, n) {
  throw new Error(
    `Data for ${e} key ${t} is incorrect: Expected ${r} and got ${JSON.stringify(n)}`
  );
}
function GP(e) {
  return (t, r) => {
    for (const n of Object.keys(t)) {
      const o = t[n], { canAdd: i, canAddToArray: a, check: u, expected: l } = (
        // @ts-ignore
        kte[e + "s"][n] || {}
      ), d = !!a;
      if (u)
        if (d) {
          if (!Array.isArray(o) || // @ts-ignore
          r[n] && !Array.isArray(r[n]))
            throw new Error(`Key type ${n} must be an array`);
          o.every(u) || I$(e, n, l, o);
          const f = r[n] || [], h = /* @__PURE__ */ new Set();
          if (!o.every((g) => a(f, g, h)))
            throw new Error("Can not add duplicate data to array");
          r[n] = f.concat(o);
        } else {
          if (u(o) || I$(e, n, l, o), !i(r, o))
            throw new Error(`Can not add duplicate data to ${e}`);
          r[n] = o;
        }
    }
  };
}
const Bte = GP("global"), KL = GP("input"), qL = GP("output");
function Nte(e, t) {
  const r = e.length - 1, n = Ei(e, r);
  KL(t, n);
}
function $te(e, t) {
  const r = e.length - 1, n = gw(e, r);
  qL(t, n);
}
let O$ = class {
  constructor(t) {
    this.inputs = [], this.outputs = [], this.globalMap = {
      unsignedTx: t
    };
  }
  static fromBase64(t, r) {
    const n = tL(t);
    return this.fromBuffer(n, r);
  }
  static fromHex(t, r) {
    const n = mf(t);
    return this.fromBuffer(n, r);
  }
  static fromBuffer(t, r) {
    const n = Tte(t, r), o = new this(n.globalMap.unsignedTx);
    return Object.assign(o, n), o;
  }
  toBase64() {
    const t = this.toBuffer();
    return OJ(t);
  }
  toHex() {
    const t = this.toBuffer();
    return Gt(t);
  }
  toBuffer() {
    return Ite(this);
  }
  updateGlobal(t) {
    return Bte(t, this.globalMap), this;
  }
  updateInput(t, r) {
    const n = Ei(this.inputs, t);
    return KL(r, n), this;
  }
  updateOutput(t, r) {
    const n = gw(this.outputs, t);
    return qL(r, n), this;
  }
  addUnknownKeyValToGlobal(t) {
    return AS(
      t,
      this.globalMap.unknownKeyVals,
      xS(xc)
    ), this.globalMap.unknownKeyVals || (this.globalMap.unknownKeyVals = []), this.globalMap.unknownKeyVals.push(t), this;
  }
  addUnknownKeyValToInput(t, r) {
    const n = Ei(this.inputs, t);
    return AS(r, n.unknownKeyVals, xS(Tt)), n.unknownKeyVals || (n.unknownKeyVals = []), n.unknownKeyVals.push(r), this;
  }
  addUnknownKeyValToOutput(t, r) {
    const n = gw(this.outputs, t);
    return AS(r, n.unknownKeyVals, xS(bo)), n.unknownKeyVals || (n.unknownKeyVals = []), n.unknownKeyVals.push(r), this;
  }
  addInput(t) {
    this.globalMap.unsignedTx.addInput(t), this.inputs.push({
      unknownKeyVals: []
    });
    const r = t.unknownKeyVals || [], n = this.inputs.length - 1;
    if (!Array.isArray(r))
      throw new Error("unknownKeyVals must be an Array");
    return r.forEach(
      (o) => this.addUnknownKeyValToInput(n, o)
    ), Nte(this.inputs, t), this;
  }
  addOutput(t) {
    this.globalMap.unsignedTx.addOutput(t), this.outputs.push({
      unknownKeyVals: []
    });
    const r = t.unknownKeyVals || [], n = this.outputs.length - 1;
    if (!Array.isArray(r))
      throw new Error("unknownKeyVals must be an Array");
    return r.forEach(
      (o) => this.addUnknownKeyValToOutput(n, o)
    ), $te(this.outputs, t), this;
  }
  clearFinalizedInput(t) {
    const r = Ei(this.inputs, t);
    Cte(t, r);
    for (const n of Object.keys(r))
      [
        "witnessUtxo",
        "nonWitnessUtxo",
        "finalScriptSig",
        "finalScriptWitness",
        "unknownKeyVals"
      ].includes(n) || delete r[n];
    return this;
  }
  combine(...t) {
    const r = Pte([this].concat(t));
    return Object.assign(this, r), this;
  }
  getTransaction() {
    return this.globalMap.unsignedTx.toBuffer();
  }
};
function E0(e) {
  return (t) => {
    try {
      return e({ output: t }), !0;
    } catch {
      return !1;
    }
  };
}
const Ute = E0(j5), Rte = E0(bL), zte = E0(g2), H5 = E0(m2), P$ = E0(y2), VL = E0(gg), GL = E0(b2);
function c3(e) {
  let t = new Uint8Array(0);
  function r(a) {
    t = io([t, a]);
  }
  function n(a) {
    const u = t.length, l = Ms(a);
    t = io([t, new Uint8Array(l)]), Rd(a, t, u);
  }
  function o(a) {
    n(a.length), r(a);
  }
  function i(a) {
    n(a.length), a.forEach(o);
  }
  return i(e), t;
}
function WL(e, t) {
  const r = Ql(e), n = e.slice(1, 33), o = to(t);
  if (o === null) throw new Error("Unknown script error");
  return o.findIndex((i) => typeof i == "number" ? !1 : ft(e, i) === 0 || ft(r, i) === 0 || ft(n, i) === 0);
}
function F5(e, t) {
  return WL(e, t) !== -1;
}
function jte(e, t) {
  return Lte(e).some(
    (r) => ZL(r, Jb.decode, t)
  );
}
function ZL(e, t, r) {
  const { hashType: n } = t(e), o = [];
  switch (n & vo.SIGHASH_ANYONECANPAY && o.push("addInput"), n & 31) {
    case vo.SIGHASH_ALL:
      break;
    case vo.SIGHASH_SINGLE:
    case vo.SIGHASH_NONE:
      o.push("addOutput"), o.push("setInputSequence");
      break;
  }
  return o.indexOf(r) === -1;
}
function Lte(e) {
  let t = [];
  if ((e.partialSig || []).length === 0) {
    if (!e.finalScriptSig && !e.finalScriptWitness) return [];
    t = Hte(e);
  } else
    t = e.partialSig;
  return t.map((r) => r.signature);
}
function Hte(e) {
  const t = e.finalScriptSig ? to(e.finalScriptSig) || [] : [], r = e.finalScriptWitness ? to(e.finalScriptWitness) || [] : [];
  return t.concat(r).filter((n) => n instanceof Uint8Array && of(n)).map((n) => ({ signature: n }));
}
const Pu = (e) => e.length === 32 ? e : e.slice(1, 33);
function C$(e, t, r) {
  const n = ere(
    t,
    e,
    r
  );
  try {
    const o = Jte(t, n).concat(n.script).concat(n.controlBlock);
    return { finalScriptWitness: c3(o) };
  } catch (o) {
    throw new Error(`Can not finalize taproot input #${e}: ${o}`);
  }
}
function Bv(e, t) {
  const r = t ? Uint8Array.from([t]) : Uint8Array.from([]);
  return io([e, r]);
}
function vu(e) {
  return e && !!(e.tapInternalKey || e.tapMerkleRoot || e.tapLeafScript && e.tapLeafScript.length || e.tapBip32Derivation && e.tapBip32Derivation.length || e.witnessUtxo && GL(e.witnessUtxo.script));
}
function kS(e, t) {
  return e && !!(e.tapInternalKey || e.tapTree || e.tapBip32Derivation && e.tapBip32Derivation.length || t);
}
function B$(e, t, r) {
  Zte(e, t, r), Yte(e, t, r);
}
function N$(e, t, r) {
  Xte(e, t, r), Fte(e, t);
}
function Fte(e, t) {
  if (!t.tapTree && !t.tapInternalKey) return;
  const r = t.tapInternalKey || e.tapInternalKey, n = t.tapTree || e.tapTree;
  if (r) {
    const { script: o } = e, i = Mte(r, n);
    if (o && ft(i, o) !== 0)
      throw new Error("Error adding output. Script or address mismatch.");
  }
}
function Mte(e, t) {
  const r = t && Dte(t.leaves), { output: n } = b2({
    internalPubkey: e,
    scriptTree: r
  });
  return n;
}
function Dte(e = []) {
  return e.length === 1 && e[0].depth === 0 ? {
    output: e[0].script,
    version: e[0].leafVersion
  } : Wte(e);
}
function Kte(e, t) {
  return Vte(e).some(
    (r) => ZL(r, qte, t)
  );
}
function qte(e) {
  return {
    signature: e.slice(0, 64),
    hashType: e.slice(64)[0] || vo.SIGHASH_DEFAULT
  };
}
function Vte(e) {
  const t = [];
  if (e.tapKeySig && t.push(e.tapKeySig), e.tapScriptSig && t.push(...e.tapScriptSig.map((r) => r.signature)), !t.length) {
    const r = Gte(e.finalScriptWitness);
    r && t.push(r);
  }
  return t;
}
function Gte(e) {
  if (!e) return;
  const t = e.slice(2);
  if (t.length === 64 || t.length === 65) return t;
}
function Wte(e) {
  let t;
  for (const r of e)
    if (t = vI(r, t), !t) throw new Error("No room left to insert tapleaf in tree");
  return t;
}
function vI(e, t, r = 0) {
  if (r > LQ) throw new Error("Max taptree depth exceeded.");
  if (e.depth === r)
    return t ? void 0 : {
      output: e.script,
      version: e.leafVersion
    };
  if (CP(t)) return;
  const n = vI(e, t && t[0], r + 1);
  if (n) return [n, t && t[1]];
  const o = vI(e, t && t[1], r + 1);
  if (o) return [t && t[0], o];
}
function Zte(e, t, r) {
  const n = vu(e) && y1(t), o = y1(e) && vu(t), i = e === t && vu(t) && y1(t);
  if (n || o || i)
    throw new Error(
      `Invalid arguments for Psbt.${r}. Cannot use both taproot and non-taproot fields.`
    );
}
function Xte(e, t, r) {
  const n = kS(e) && y1(t), o = y1(e) && kS(t), i = e === t && kS(t) && y1(t);
  if (n || o || i)
    throw new Error(
      `Invalid arguments for Psbt.${r}. Cannot use both taproot and non-taproot fields.`
    );
}
function Yte(e, t, r) {
  if (t.tapMerkleRoot) {
    const n = (t.tapLeafScript || []).every(
      (i) => SS(i, t.tapMerkleRoot)
    ), o = (e.tapLeafScript || []).every(
      (i) => SS(i, t.tapMerkleRoot)
    );
    if (!n || !o)
      throw new Error(
        `Invalid arguments for Psbt.${r}. Tapleaf not part of taptree.`
      );
  } else if (e.tapMerkleRoot && !(t.tapLeafScript || []).every(
    (n) => SS(n, e.tapMerkleRoot)
  ))
    throw new Error(
      `Invalid arguments for Psbt.${r}. Tapleaf not part of taptree.`
    );
}
function SS(e, t) {
  if (!t) return !0;
  const r = Yl({
    output: e.script,
    version: e.leafVersion
  }), n = mI(e.controlBlock, r);
  return ft(n, t) === 0;
}
function Jte(e, t) {
  const r = Yl({
    output: t.script,
    version: t.leafVersion
  });
  return (e.tapScriptSig || []).filter((n) => ft(n.leafHash, r) === 0).map((n) => Qte(t.script, n)).sort((n, o) => o.positionInScript - n.positionInScript).map((n) => n.signature);
}
function Qte(e, t) {
  return Object.assign(
    {
      positionInScript: WL(t.pubkey, e)
    },
    t
  );
}
function ere(e, t, r) {
  if (!e.tapScriptSig || !e.tapScriptSig.length)
    throw new Error(
      `Can not finalize taproot input #${t}. No tapleaf script signature provided.`
    );
  const n = (e.tapLeafScript || []).sort((o, i) => o.controlBlock.length - i.controlBlock.length).find(
    (o) => tre(o, e.tapScriptSig, r)
  );
  if (!n)
    throw new Error(
      `Can not finalize taproot input #${t}. Signature for tapleaf script not found.`
    );
  return n;
}
function tre(e, t, r) {
  const n = Yl({
    output: e.script,
    version: e.leafVersion
  });
  return (!r || ft(n, r) === 0) && t.find((o) => ft(o.leafHash, n) === 0) !== void 0;
}
function y1(e) {
  return e && !!(e.redeemScript || e.witnessScript || e.bip32Derivation && e.bip32Derivation.length);
}
const rre = {
  /**
   * A bitcoinjs Network object. This is only used if you pass an `address`
   * parameter to addOutput. Otherwise it is not needed and can be left default.
   */
  network: qu,
  /**
   * When extractTransaction is called, the fee rate is checked.
   * THIS IS NOT TO BE RELIED ON.
   * It is only here as a last ditch effort to prevent sending a 500 BTC fee etc.
   */
  maximumFeeRate: 5e3
  // satoshi per byte
};
let Sn = class EI {
  constructor(t = {}, r = new O$(new XL())) {
    st(this, "data"), st(this, "__CACHE"), st(this, "opts"), this.data = r, this.opts = Object.assign({}, rre, t), this.__CACHE = {
      __NON_WITNESS_UTXO_TX_CACHE: [],
      __NON_WITNESS_UTXO_BUF_CACHE: [],
      __TX_IN_CACHE: {},
      __TX: this.data.globalMap.unsignedTx.tx,
      // Psbt's predecessor (TransactionBuilder - now removed) behavior
      // was to not confirm input values  before signing.
      // Even though we highly encourage people to get
      // the full parent transaction to verify values, the ability to
      // sign non-segwit inputs without the full transaction was often
      // requested. So the only way to activate is to use @ts-ignore.
      // We will disable exporting the Psbt when unsafe sign is active.
      // because it is not BIP174 compliant.
      __UNSAFE_SIGN_NONSEGWIT: !1
    }, this.data.inputs.length === 0 && this.setVersion(2);
    const n = (o, i, a, u) => Object.defineProperty(o, i, {
      enumerable: a,
      writable: u
    });
    n(this, "__CACHE", !1, !0), n(this, "opts", !1, !0);
  }
  static fromBase64(t, r = {}) {
    const n = tL(t);
    return this.fromBuffer(n, r);
  }
  static fromHex(t, r = {}) {
    const n = mf(t);
    return this.fromBuffer(n, r);
  }
  static fromBuffer(t, r = {}) {
    const n = O$.fromBuffer(t, nre), o = new EI(r, n);
    return ure(o.__CACHE.__TX, o.__CACHE), o;
  }
  get inputCount() {
    return this.data.inputs.length;
  }
  get version() {
    return this.__CACHE.__TX.version;
  }
  set version(t) {
    this.setVersion(t);
  }
  get locktime() {
    return this.__CACHE.__TX.locktime;
  }
  set locktime(t) {
    this.setLocktime(t);
  }
  get txInputs() {
    return this.__CACHE.__TX.ins.map((t) => ({
      hash: E$(t.hash),
      index: t.index,
      sequence: t.sequence
    }));
  }
  get txOutputs() {
    return this.__CACHE.__TX.outs.map((t) => {
      let r;
      try {
        r = w2(t.script, this.opts.network);
      } catch {
      }
      return {
        script: E$(t.script),
        value: t.value,
        address: r
      };
    });
  }
  combine(...t) {
    return this.data.combine(...t.map((r) => r.data)), this;
  }
  clone() {
    const t = EI.fromBuffer(this.data.toBuffer());
    return t.opts = JSON.parse(JSON.stringify(this.opts)), t;
  }
  setMaximumFeeRate(t) {
    Nv(t), this.opts.maximumFeeRate = t;
  }
  setVersion(t) {
    Nv(t), Ab(this.data.inputs, "setVersion");
    const r = this.__CACHE;
    return r.__TX.version = t, r.__EXTRACTED_TX = void 0, this;
  }
  setLocktime(t) {
    Nv(t), Ab(this.data.inputs, "setLocktime");
    const r = this.__CACHE;
    return r.__TX.locktime = t, r.__EXTRACTED_TX = void 0, this;
  }
  setInputSequence(t, r) {
    Nv(r), Ab(this.data.inputs, "setInputSequence");
    const n = this.__CACHE;
    if (n.__TX.ins.length <= t)
      throw new Error("Input index too high");
    return n.__TX.ins[t].sequence = r, n.__EXTRACTED_TX = void 0, this;
  }
  addInputs(t) {
    return t.forEach((r) => this.addInput(r)), this;
  }
  addInput(t) {
    if (arguments.length > 1 || !t || t.hash === void 0 || t.index === void 0)
      throw new Error(
        "Invalid arguments for Psbt.addInput. Requires single object with at least [hash] and [index]"
      );
    B$(t, t, "addInput"), Ab(this.data.inputs, "addInput"), t.witnessScript && l3(t.witnessScript);
    const r = this.__CACHE;
    this.data.addInput(t);
    const n = r.__TX.ins[r.__TX.ins.length - 1];
    QL(r, n);
    const o = this.data.inputs.length - 1, i = this.data.inputs[o];
    return i.nonWitnessUtxo && AI(this.__CACHE, i, o), r.__FEE = void 0, r.__FEE_RATE = void 0, r.__EXTRACTED_TX = void 0, this;
  }
  addOutputs(t) {
    return t.forEach((r) => this.addOutput(r)), this;
  }
  addOutput(t) {
    if (arguments.length > 1 || !t || t.value === void 0 || t.address === void 0 && t.script === void 0)
      throw new Error(
        "Invalid arguments for Psbt.addOutput. Requires single object with at least [script or address] and [value]"
      );
    Ab(this.data.inputs, "addOutput");
    const { address: r } = t;
    if (typeof r == "string") {
      const { network: o } = this.opts, i = af(r, o);
      t = Object.assign({}, t, { script: i });
    }
    N$(t, t, "addOutput");
    const n = this.__CACHE;
    return this.data.addOutput(t), n.__FEE = void 0, n.__FEE_RATE = void 0, n.__EXTRACTED_TX = void 0, this;
  }
  extractTransaction(t) {
    if (!this.data.inputs.every(YL)) throw new Error("Not finalized");
    const r = this.__CACHE;
    if (t || ire(this, r, this.opts), r.__EXTRACTED_TX) return r.__EXTRACTED_TX;
    const n = r.__TX.clone();
    return iH(this.data.inputs, n, r, !0), n;
  }
  getFeeRate() {
    return j$(
      "__FEE_RATE",
      "fee rate",
      this.data.inputs,
      this.__CACHE
    );
  }
  getFee() {
    return j$("__FEE", "fee", this.data.inputs, this.__CACHE);
  }
  finalizeAllInputs() {
    return Ei(this.data.inputs, 0), xb(this.data.inputs.length).forEach((t) => this.finalizeInput(t)), this;
  }
  finalizeInput(t, r) {
    const n = Ei(this.data.inputs, t);
    return vu(n) ? this._finalizeTaprootInput(
      t,
      n,
      void 0,
      r
    ) : this._finalizeInput(t, n, r);
  }
  finalizeTaprootInput(t, r, n = C$) {
    const o = Ei(this.data.inputs, t);
    if (vu(o))
      return this._finalizeTaprootInput(
        t,
        o,
        r,
        n
      );
    throw new Error(`Cannot finalize input #${t}. Not Taproot.`);
  }
  _finalizeInput(t, r, n = cre) {
    const { script: o, isP2SH: i, isP2WSH: a, isSegwit: u } = hre(
      t,
      r,
      this.__CACHE
    );
    if (!o) throw new Error(`No script found for input #${t}`);
    are(r);
    const { finalScriptSig: l, finalScriptWitness: d } = n(
      t,
      r,
      o,
      u,
      i,
      a
    );
    if (l && this.data.updateInput(t, { finalScriptSig: l }), d && this.data.updateInput(t, { finalScriptWitness: d }), !l && !d)
      throw new Error(`Unknown error finalizing input #${t}`);
    return this.data.clearFinalizedInput(t), this;
  }
  _finalizeTaprootInput(t, r, n, o = C$) {
    if (!r.witnessUtxo)
      throw new Error(
        `Cannot finalize input #${t}. Missing withness utxo.`
      );
    if (r.tapKeySig) {
      const i = b2({
        output: r.witnessUtxo.script,
        signature: r.tapKeySig
      }), a = c3(i.witness);
      this.data.updateInput(t, { finalScriptWitness: a });
    } else {
      const { finalScriptWitness: i } = o(
        t,
        r,
        n
      );
      this.data.updateInput(t, { finalScriptWitness: i });
    }
    return this.data.clearFinalizedInput(t), this;
  }
  getInputType(t) {
    const r = Ei(this.data.inputs, t), n = aH(t, r, this.__CACHE), o = D5(
      n,
      t,
      "input",
      r.redeemScript || bre(r.finalScriptSig),
      r.witnessScript || wre(r.finalScriptWitness)
    ), i = o.type === "raw" ? "" : o.type + "-", a = uH(o.meaningfulScript);
    return i + a;
  }
  inputHasPubkey(t, r) {
    const n = Ei(this.data.inputs, t);
    return mre(r, n, t, this.__CACHE);
  }
  inputHasHDKey(t, r) {
    const n = Ei(this.data.inputs, t), o = U$(r);
    return !!n.bip32Derivation && n.bip32Derivation.some(o);
  }
  outputHasPubkey(t, r) {
    const n = gw(this.data.outputs, t);
    return yre(r, n, t, this.__CACHE);
  }
  outputHasHDKey(t, r) {
    const n = gw(this.data.outputs, t), o = U$(r);
    return !!n.bip32Derivation && n.bip32Derivation.some(o);
  }
  validateSignaturesOfAllInputs(t) {
    return Ei(this.data.inputs, 0), xb(this.data.inputs.length).map(
      (r) => this.validateSignaturesOfInput(r, t)
    ).reduce((r, n) => n === !0 && r, !0);
  }
  validateSignaturesOfInput(t, r, n) {
    const o = this.data.inputs[t];
    return vu(o) ? this.validateSignaturesOfTaprootInput(
      t,
      r,
      n
    ) : this._validateSignaturesOfInput(t, r, n);
  }
  _validateSignaturesOfInput(t, r, n) {
    const o = this.data.inputs[t], i = (o || {}).partialSig;
    if (!o || !i || i.length < 1)
      throw new Error("No signatures to validate");
    if (typeof r != "function")
      throw new Error("Need validator function to validate signatures");
    const a = n ? i.filter((h) => ft(h.pubkey, n) === 0) : i;
    if (a.length < 1) throw new Error("No signatures for this pubkey");
    const u = [];
    let l, d, f;
    for (const h of a) {
      const g = Jb.decode(h.signature), { hash: b, script: w } = f !== g.hashType ? tH(
        t,
        Object.assign({}, o, { sighashType: g.hashType }),
        this.__CACHE,
        !0
      ) : { hash: l, script: d };
      f = g.hashType, l = b, d = w, JL(h.pubkey, w, "verify"), u.push(r(h.pubkey, b, g.signature));
    }
    return u.every((h) => h === !0);
  }
  validateSignaturesOfTaprootInput(t, r, n) {
    const o = this.data.inputs[t], i = (o || {}).tapKeySig, a = (o || {}).tapScriptSig;
    if (!o && !i && !(a && !a.length))
      throw new Error("No signatures to validate");
    if (typeof r != "function")
      throw new Error("Need validator function to validate signatures");
    n = n && Pu(n);
    const u = n ? _I(
      t,
      o,
      this.data.inputs,
      n,
      this.__CACHE
    ) : fre(
      t,
      o,
      this.data.inputs,
      this.__CACHE
    );
    if (!u.length) throw new Error("No signatures for this pubkey");
    const l = u.find((f) => !f.leafHash);
    let d = 0;
    if (i && l) {
      if (!r(
        l.pubkey,
        l.hash,
        H$(i)
      )) return !1;
      d++;
    }
    if (a)
      for (const f of a) {
        const h = u.find(
          (g) => ft(g.pubkey, f.pubkey) === 0
        );
        if (h) {
          if (!r(
            f.pubkey,
            h.hash,
            H$(f.signature)
          )) return !1;
          d++;
        }
      }
    return d > 0;
  }
  signAllInputsHD(t, r = [vo.SIGHASH_ALL]) {
    if (!t || !t.publicKey || !t.fingerprint)
      throw new Error("Need HDSigner to sign input");
    const n = [];
    for (const o of xb(this.data.inputs.length))
      try {
        this.signInputHD(o, t, r), n.push(!0);
      } catch {
        n.push(!1);
      }
    if (n.every((o) => o === !1))
      throw new Error("No inputs were signed");
    return this;
  }
  signAllInputsHDAsync(t, r = [vo.SIGHASH_ALL]) {
    return new Promise((n, o) => {
      if (!t || !t.publicKey || !t.fingerprint)
        return o(new Error("Need HDSigner to sign input"));
      const i = [], a = [];
      for (const u of xb(this.data.inputs.length))
        a.push(
          this.signInputHDAsync(u, t, r).then(
            () => {
              i.push(!0);
            },
            () => {
              i.push(!1);
            }
          )
        );
      return Promise.all(a).then(() => {
        if (i.every((u) => u === !1))
          return o(new Error("No inputs were signed"));
        n();
      });
    });
  }
  signInputHD(t, r, n = [vo.SIGHASH_ALL]) {
    if (!r || !r.publicKey || !r.fingerprint)
      throw new Error("Need HDSigner to sign input");
    return F$(t, this.data.inputs, r).forEach((o) => this.signInput(t, o, n)), this;
  }
  signInputHDAsync(t, r, n = [vo.SIGHASH_ALL]) {
    return new Promise((o, i) => {
      if (!r || !r.publicKey || !r.fingerprint)
        return i(new Error("Need HDSigner to sign input"));
      const a = F$(t, this.data.inputs, r).map(
        (u) => this.signInputAsync(t, u, n)
      );
      return Promise.all(a).then(() => {
        o();
      }).catch(i);
    });
  }
  signAllInputs(t, r) {
    if (!t || !t.publicKey)
      throw new Error("Need Signer to sign input");
    const n = [];
    for (const o of xb(this.data.inputs.length))
      try {
        this.signInput(o, t, r), n.push(!0);
      } catch {
        n.push(!1);
      }
    if (n.every((o) => o === !1))
      throw new Error("No inputs were signed");
    return this;
  }
  signAllInputsAsync(t, r) {
    return new Promise((n, o) => {
      if (!t || !t.publicKey)
        return o(new Error("Need Signer to sign input"));
      const i = [], a = [];
      for (const [u] of this.data.inputs.entries())
        a.push(
          this.signInputAsync(u, t, r).then(
            () => {
              i.push(!0);
            },
            () => {
              i.push(!1);
            }
          )
        );
      return Promise.all(a).then(() => {
        if (i.every((u) => u === !1))
          return o(new Error("No inputs were signed"));
        n();
      });
    });
  }
  signInput(t, r, n) {
    if (!r || !r.publicKey)
      throw new Error("Need Signer to sign input");
    const o = Ei(this.data.inputs, t);
    return vu(o) ? this._signTaprootInput(
      t,
      o,
      r,
      void 0,
      n
    ) : this._signInput(t, r, n);
  }
  signTaprootInput(t, r, n, o) {
    if (!r || !r.publicKey)
      throw new Error("Need Signer to sign input");
    const i = Ei(this.data.inputs, t);
    if (vu(i))
      return this._signTaprootInput(
        t,
        i,
        r,
        n,
        o
      );
    throw new Error(`Input #${t} is not of type Taproot.`);
  }
  _signInput(t, r, n = [vo.SIGHASH_ALL]) {
    const { hash: o, sighashType: i } = L$(
      this.data.inputs,
      t,
      r.publicKey,
      this.__CACHE,
      n
    ), a = [
      {
        pubkey: r.publicKey,
        signature: Jb.encode(r.sign(o), i)
      }
    ];
    return this.data.updateInput(t, { partialSig: a }), this;
  }
  _signTaprootInput(t, r, n, o, i = [vo.SIGHASH_DEFAULT]) {
    const a = this.checkTaprootHashesForSig(
      t,
      r,
      n,
      o,
      i
    ), u = a.filter((d) => !d.leafHash).map(
      (d) => Bv(
        n.signSchnorr(d.hash),
        r.sighashType
      )
    )[0], l = a.filter((d) => !!d.leafHash).map((d) => ({
      pubkey: Pu(n.publicKey),
      signature: Bv(
        n.signSchnorr(d.hash),
        r.sighashType
      ),
      leafHash: d.leafHash
    }));
    return u && this.data.updateInput(t, { tapKeySig: u }), l.length && this.data.updateInput(t, { tapScriptSig: l }), this;
  }
  signInputAsync(t, r, n) {
    return Promise.resolve().then(() => {
      if (!r || !r.publicKey)
        throw new Error("Need Signer to sign input");
      const o = Ei(this.data.inputs, t);
      return vu(o) ? this._signTaprootInputAsync(
        t,
        o,
        r,
        void 0,
        n
      ) : this._signInputAsync(t, r, n);
    });
  }
  signTaprootInputAsync(t, r, n, o) {
    return Promise.resolve().then(() => {
      if (!r || !r.publicKey)
        throw new Error("Need Signer to sign input");
      const i = Ei(this.data.inputs, t);
      if (vu(i))
        return this._signTaprootInputAsync(
          t,
          i,
          r,
          n,
          o
        );
      throw new Error(`Input #${t} is not of type Taproot.`);
    });
  }
  _signInputAsync(t, r, n = [vo.SIGHASH_ALL]) {
    const { hash: o, sighashType: i } = L$(
      this.data.inputs,
      t,
      r.publicKey,
      this.__CACHE,
      n
    );
    return Promise.resolve(r.sign(o)).then((a) => {
      const u = [
        {
          pubkey: r.publicKey,
          signature: Jb.encode(a, i)
        }
      ];
      this.data.updateInput(t, { partialSig: u });
    });
  }
  async _signTaprootInputAsync(t, r, n, o, i = [vo.SIGHASH_DEFAULT]) {
    const a = this.checkTaprootHashesForSig(
      t,
      r,
      n,
      o,
      i
    ), u = [], l = a.filter((f) => !f.leafHash)[0];
    if (l) {
      const f = Promise.resolve(
        n.signSchnorr(l.hash)
      ).then((h) => ({ tapKeySig: Bv(h, r.sighashType) }));
      u.push(f);
    }
    const d = a.filter((f) => !!f.leafHash);
    if (d.length) {
      const f = d.map((h) => Promise.resolve(n.signSchnorr(h.hash)).then(
        (g) => ({ tapScriptSig: [
          {
            pubkey: Pu(n.publicKey),
            signature: Bv(
              g,
              r.sighashType
            ),
            leafHash: h.leafHash
          }
        ] })
      ));
      u.push(...f);
    }
    return Promise.all(u).then((f) => {
      f.forEach((h) => this.data.updateInput(t, h));
    });
  }
  checkTaprootHashesForSig(t, r, n, o, i) {
    if (typeof n.signSchnorr != "function")
      throw new Error(
        `Need Schnorr Signer to sign taproot input #${t}.`
      );
    const a = _I(
      t,
      r,
      this.data.inputs,
      n.publicKey,
      this.__CACHE,
      o,
      i
    );
    if (!a || !a.length)
      throw new Error(
        `Can not sign for input #${t} with the key ${Gt(n.publicKey)}`
      );
    return a;
  }
  toBuffer() {
    return TS(this.__CACHE), this.data.toBuffer();
  }
  toHex() {
    return TS(this.__CACHE), this.data.toHex();
  }
  toBase64() {
    return TS(this.__CACHE), this.data.toBase64();
  }
  updateGlobal(t) {
    return this.data.updateGlobal(t), this;
  }
  updateInput(t, r) {
    return r.witnessScript && l3(r.witnessScript), B$(
      this.data.inputs[t],
      r,
      "updateInput"
    ), this.data.updateInput(t, r), r.nonWitnessUtxo && AI(
      this.__CACHE,
      this.data.inputs[t],
      t
    ), this;
  }
  updateOutput(t, r) {
    const n = this.data.outputs[t];
    return N$(n, r, "updateOutput"), this.data.updateOutput(t, r), this;
  }
  addUnknownKeyValToGlobal(t) {
    return this.data.addUnknownKeyValToGlobal(t), this;
  }
  addUnknownKeyValToInput(t, r) {
    return this.data.addUnknownKeyValToInput(t, r), this;
  }
  addUnknownKeyValToOutput(t, r) {
    return this.data.addUnknownKeyValToOutput(t, r), this;
  }
  clearFinalizedInput(t) {
    return this.data.clearFinalizedInput(t), this;
  }
};
const nre = (e) => new XL(e);
class XL {
  constructor(t = Uint8Array.from([2, 0, 0, 0, 0, 0, 0, 0, 0, 0])) {
    st(this, "tx"), this.tx = vo.fromBuffer(t), sre(this.tx), Object.defineProperty(this, "tx", {
      enumerable: !1,
      writable: !0
    });
  }
  getInputOutputCounts() {
    return {
      inputCount: this.tx.ins.length,
      outputCount: this.tx.outs.length
    };
  }
  addInput(t) {
    if (t.hash === void 0 || t.index === void 0 || !(t.hash instanceof Uint8Array) && typeof t.hash != "string" || typeof t.index != "number")
      throw new Error("Error adding input.");
    const r = typeof t.hash == "string" ? MP(mf(t.hash)) : t.hash;
    this.tx.addInput(r, t.index, t.sequence);
  }
  addOutput(t) {
    if (t.script === void 0 || t.value === void 0 || !(t.script instanceof Uint8Array) || typeof t.value != "bigint")
      throw new Error("Error adding output.");
    this.tx.addOutput(t.script, t.value);
  }
  toBuffer() {
    return this.tx.toBuffer();
  }
}
function ore(e, t, r) {
  switch (r) {
    case "pubkey":
    case "pubkeyhash":
    case "witnesspubkeyhash":
      return $$(1, e.partialSig);
    case "multisig":
      const n = j5({ output: t });
      return $$(n.m, e.partialSig, n.pubkeys);
    default:
      return !1;
  }
}
function TS(e) {
  if (e.__UNSAFE_SIGN_NONSEGWIT !== !1)
    throw new Error("Not BIP174 compliant, can not export");
}
function $$(e, t, r) {
  if (!t) return !1;
  let n;
  if (r ? n = r.map((o) => {
    const i = vre(o);
    return t.find(
      (a) => ft(a.pubkey, i) === 0
    );
  }).filter((o) => !!o) : n = t, n.length > e) throw new Error("Too many signatures");
  return n.length === e;
}
function YL(e) {
  return !!e.finalScriptSig || !!e.finalScriptWitness;
}
function U$(e) {
  return (t) => !(ft(e.fingerprint, t.masterFingerprint) || ft(e.derivePath(t.path).publicKey, t.pubkey));
}
function Nv(e) {
  if (typeof e != "number" || e !== Math.floor(e) || e > 4294967295 || e < 0)
    throw new Error("Invalid 32 bit integer");
}
function ire(e, t, r) {
  const n = t.__FEE_RATE || e.getFeeRate(), o = t.__EXTRACTED_TX.virtualSize(), i = n * o;
  if (n >= r.maximumFeeRate)
    throw new Error(
      `Warning: You are paying around ${(i / 1e8).toFixed(8)} in fees, which is ${n} satoshi per byte for a transaction with a VSize of ${o} bytes (segwit counted as 0.25 byte per byte). Use setMaximumFeeRate method to raise your threshold, or pass true to the first arg of extractTransaction.`
    );
}
function Ab(e, t) {
  e.forEach((r) => {
    if (vu(r) ? Kte(r, t) : jte(r, t))
      throw new Error("Can not modify transaction, signatures exist.");
  });
}
function are(e) {
  if (!e.sighashType || !e.partialSig) return;
  const { partialSig: t, sighashType: r } = e;
  t.forEach((n) => {
    const { hashType: o } = Jb.decode(n.signature);
    if (r !== o)
      throw new Error("Signature sighash does not match input sighash type");
  });
}
function JL(e, t, r) {
  if (!F5(e, t))
    throw new Error(
      `Can not ${r} for this input with the key ${Gt(e)}`
    );
}
function sre(e) {
  if (!e.ins.every(
    (t) => t.script && t.script.length === 0 && t.witness && t.witness.length === 0
  ))
    throw new Error("Format Error: Transaction ScriptSigs are not empty");
}
function ure(e, t) {
  e.ins.forEach((r) => {
    QL(t, r);
  });
}
function QL(e, t) {
  const r = Gt(MP(Uint8Array.from(t.hash))) + ":" + t.index;
  if (e.__TX_IN_CACHE[r]) throw new Error("Duplicate input detected.");
  e.__TX_IN_CACHE[r] = 1;
}
function eH(e, t) {
  return (r, n, o, i) => {
    const a = e({
      redeem: { output: o }
    }).output;
    if (ft(n, a))
      throw new Error(
        `${t} for ${i} #${r} doesn't match the scriptPubKey in the prevout`
      );
  };
}
const R$ = eH(gg, "Redeem script"), z$ = eH(
  y2,
  "Witness script"
);
function j$(e, t, r, n) {
  if (!r.every(YL))
    throw new Error(`PSBT must be finalized to calculate ${t}`);
  if (e === "__FEE_RATE" && n.__FEE_RATE) return n.__FEE_RATE;
  if (e === "__FEE" && n.__FEE) return n.__FEE;
  let o, i = !0;
  if (n.__EXTRACTED_TX ? (o = n.__EXTRACTED_TX, i = !1) : o = n.__TX.clone(), iH(r, o, n, i), e === "__FEE_RATE") return n.__FEE_RATE;
  if (e === "__FEE") return n.__FEE;
}
function cre(e, t, r, n, o, i) {
  const a = uH(r);
  if (!ore(t, r, a))
    throw new Error(`Can not finalize input #${e}`);
  return lre(
    r,
    a,
    t.partialSig,
    n,
    o,
    i
  );
}
function lre(e, t, r, n, o, i) {
  let a, u;
  const l = dre(e, t, r), d = i ? y2({ redeem: l }) : null, f = o ? gg({ redeem: d || l }) : null;
  return n ? (d ? u = c3(d.witness) : u = c3(l.witness), f && (a = f.input)) : f ? a = f.input : a = l.input, {
    finalScriptSig: a,
    finalScriptWitness: u
  };
}
function L$(e, t, r, n, o) {
  const i = Ei(e, t), { hash: a, sighashType: u, script: l } = tH(
    t,
    i,
    n,
    !1,
    o
  );
  return JL(r, l, "sign"), {
    hash: a,
    sighashType: u
  };
}
function tH(e, t, r, n, o) {
  const i = r.__TX, a = t.sighashType || vo.SIGHASH_ALL;
  nH(a, o);
  let u, l;
  if (t.nonWitnessUtxo) {
    const h = M5(
      r,
      t,
      e
    ), g = i.ins[e].hash, b = h.getHash();
    if (ft(g, b) !== 0)
      throw new Error(
        `Non-witness UTXO hash for input #${e} doesn't match the hash specified in the prevout`
      );
    const w = i.ins[e].index;
    l = h.outs[w];
  } else if (t.witnessUtxo)
    l = t.witnessUtxo;
  else
    throw new Error("Need a Utxo input item for signing");
  const { meaningfulScript: d, type: f } = D5(
    l.script,
    e,
    "input",
    t.redeemScript,
    t.witnessScript
  );
  if (["p2sh-p2wsh", "p2wsh"].indexOf(f) >= 0)
    u = i.hashForWitnessV0(
      e,
      d,
      l.value,
      a
    );
  else if (H5(d)) {
    const h = g2({
      hash: d.slice(2)
    }).output;
    u = i.hashForWitnessV0(
      e,
      h,
      l.value,
      a
    );
  } else {
    if (t.nonWitnessUtxo === void 0 && r.__UNSAFE_SIGN_NONSEGWIT === !1)
      throw new Error(
        `Input #${e} has witnessUtxo but non-segwit script: ${Gt(d)}`
      );
    !n && r.__UNSAFE_SIGN_NONSEGWIT !== !1 && console.warn(
      `Warning: Signing non-segwit inputs without the full parent transaction means there is a chance that a miner could feed you incorrect information to trick you into paying large fees. This behavior is the same as Psbt's predecessor (TransactionBuilder - now removed) when signing non-segwit scripts. You are not able to export this Psbt with toBuffer|toBase64|toHex since it is not BIP174 compliant.
*********************
PROCEED WITH CAUTION!
*********************`
    ), u = i.hashForSignature(
      e,
      d,
      a
    );
  }
  return {
    script: d,
    sighashType: a,
    hash: u
  };
}
function fre(e, t, r, n) {
  const o = [];
  if (t.tapInternalKey) {
    const i = rH(e, t, n);
    i && o.push(i);
  }
  if (t.tapScriptSig) {
    const i = t.tapScriptSig.map((a) => a.pubkey);
    o.push(...i);
  }
  return o.map(
    (i) => _I(e, t, r, i, n)
  ).flat();
}
function rH(e, t, r) {
  const { script: n } = WP(e, t, r);
  return GL(n) ? n.subarray(2, 34) : null;
}
function H$(e) {
  return e.length === 64 ? e : e.subarray(0, 64);
}
function _I(e, t, r, n, o, i, a) {
  const u = o.__TX, l = t.sighashType || vo.SIGHASH_DEFAULT;
  nH(l, a);
  const d = r.map(
    (w, E) => WP(E, w, o)
  ), f = d.map((w) => w.script), h = d.map((w) => w.value), g = [];
  if (t.tapInternalKey && !i) {
    const w = rH(e, t, o) || Uint8Array.from([]);
    if (ft(Pu(n), w) === 0) {
      const E = u.hashForWitnessV1(
        e,
        f,
        h,
        l
      );
      g.push({ pubkey: n, hash: E });
    }
  }
  const b = (t.tapLeafScript || []).filter((w) => F5(n, w.script)).map((w) => {
    const E = Yl({
      output: w.script,
      version: w.leafVersion
    });
    return Object.assign({ hash: E }, w);
  }).filter(
    (w) => !i || ft(i, w.hash) === 0
  ).map((w) => {
    const E = u.hashForWitnessV1(
      e,
      f,
      h,
      l,
      w.hash
    );
    return {
      pubkey: n,
      hash: E,
      leafHash: w.hash
    };
  });
  return g.concat(b);
}
function nH(e, t) {
  if (t && t.indexOf(e) < 0) {
    const r = gre(e);
    throw new Error(
      `Sighash type is not allowed. Retry the sign method passing the sighashTypes array of whitelisted types. Sighash type: ${r}`
    );
  }
}
function dre(e, t, r) {
  let n;
  switch (t) {
    case "multisig":
      const o = pre(e, r);
      n = j5({
        output: e,
        signatures: o
      });
      break;
    case "pubkey":
      n = bL({
        output: e,
        signature: r[0].signature
      });
      break;
    case "pubkeyhash":
      n = g2({
        output: e,
        pubkey: r[0].pubkey,
        signature: r[0].signature
      });
      break;
    case "witnesspubkeyhash":
      n = m2({
        output: e,
        pubkey: r[0].pubkey,
        signature: r[0].signature
      });
      break;
  }
  return n;
}
function hre(e, t, r) {
  const n = r.__TX, o = {
    script: null,
    isSegwit: !1,
    isP2SH: !1,
    isP2WSH: !1
  };
  if (o.isP2SH = !!t.redeemScript, o.isP2WSH = !!t.witnessScript, t.witnessScript)
    o.script = t.witnessScript;
  else if (t.redeemScript)
    o.script = t.redeemScript;
  else if (t.nonWitnessUtxo) {
    const i = M5(
      r,
      t,
      e
    ), a = n.ins[e].index;
    o.script = i.outs[a].script;
  } else t.witnessUtxo && (o.script = t.witnessUtxo.script);
  return (t.witnessScript || H5(o.script)) && (o.isSegwit = !0), o;
}
function F$(e, t, r) {
  const n = Ei(t, e);
  if (!n.bip32Derivation || n.bip32Derivation.length === 0)
    throw new Error("Need bip32Derivation to sign with HD");
  const o = n.bip32Derivation.map((i) => {
    if (ft(i.masterFingerprint, r.fingerprint) === 0)
      return i;
  }).filter((i) => !!i);
  if (o.length === 0)
    throw new Error(
      "Need one bip32Derivation masterFingerprint to match the HDSigner fingerprint"
    );
  return o.map((i) => {
    const a = r.derivePath(i.path);
    if (ft(i.pubkey, a.publicKey) !== 0)
      throw new Error("pubkey did not match bip32Derivation");
    return a;
  });
}
function pre(e, t) {
  return j5({ output: e }).pubkeys.map((r) => (t.filter((n) => ft(n.pubkey, r) === 0)[0] || {}).signature).filter((r) => !!r);
}
function oH(e) {
  let t = 0;
  function r(a) {
    return t += a, e.slice(t - a, t);
  }
  function n() {
    const a = mg(e, t);
    return t += Ms(a.bigintValue), a.numberValue;
  }
  function o() {
    return r(n());
  }
  function i() {
    const a = n(), u = [];
    for (let l = 0; l < a; l++) u.push(o());
    return u;
  }
  return i();
}
function gre(e) {
  let t = e & vo.SIGHASH_ANYONECANPAY ? "SIGHASH_ANYONECANPAY | " : "";
  switch (e & 31) {
    case vo.SIGHASH_ALL:
      t += "SIGHASH_ALL";
      break;
    case vo.SIGHASH_SINGLE:
      t += "SIGHASH_SINGLE";
      break;
    case vo.SIGHASH_NONE:
      t += "SIGHASH_NONE";
      break;
  }
  return t;
}
function AI(e, t, r) {
  e.__NON_WITNESS_UTXO_BUF_CACHE[r] = t.nonWitnessUtxo;
  const n = vo.fromBuffer(t.nonWitnessUtxo);
  e.__NON_WITNESS_UTXO_TX_CACHE[r] = n;
  const o = e, i = r;
  delete t.nonWitnessUtxo, Object.defineProperty(t, "nonWitnessUtxo", {
    enumerable: !0,
    get() {
      const a = o.__NON_WITNESS_UTXO_BUF_CACHE[i], u = o.__NON_WITNESS_UTXO_TX_CACHE[i];
      if (a !== void 0)
        return a;
      {
        const l = u.toBuffer();
        return o.__NON_WITNESS_UTXO_BUF_CACHE[i] = l, l;
      }
    },
    set(a) {
      o.__NON_WITNESS_UTXO_BUF_CACHE[i] = a;
    }
  });
}
function iH(e, t, r, n) {
  let o = 0n;
  e.forEach((l, d) => {
    if (n && l.finalScriptSig && (t.ins[d].script = l.finalScriptSig), n && l.finalScriptWitness && (t.ins[d].witness = oH(
      l.finalScriptWitness
    )), l.witnessUtxo)
      o += l.witnessUtxo.value;
    else if (l.nonWitnessUtxo) {
      const f = M5(r, l, d), h = t.ins[d].index, g = f.outs[h];
      o += g.value;
    }
  });
  const i = t.outs.reduce((l, d) => l + d.value, 0n), a = o - i;
  if (a < 0)
    throw new Error("Outputs are spending more than Inputs");
  const u = t.virtualSize();
  r.__FEE = a, r.__EXTRACTED_TX = t, r.__FEE_RATE = Math.floor(Number(a / BigInt(u)));
}
function M5(e, t, r) {
  const n = e.__NON_WITNESS_UTXO_TX_CACHE;
  return n[r] || AI(e, t, r), n[r];
}
function aH(e, t, r) {
  const { script: n } = WP(e, t, r);
  return n;
}
function WP(e, t, r) {
  if (t.witnessUtxo !== void 0)
    return {
      script: t.witnessUtxo.script,
      value: t.witnessUtxo.value
    };
  if (t.nonWitnessUtxo !== void 0) {
    const n = M5(
      r,
      t,
      e
    ).outs[r.__TX.ins[e].index];
    return { script: n.script, value: n.value };
  } else
    throw new Error("Can't find pubkey in input without Utxo data");
}
function mre(e, t, r, n) {
  const o = aH(r, t, n), { meaningfulScript: i } = D5(
    o,
    r,
    "input",
    t.redeemScript,
    t.witnessScript
  );
  return F5(e, i);
}
function yre(e, t, r, n) {
  const o = n.__TX.outs[r].script, { meaningfulScript: i } = D5(
    o,
    r,
    "output",
    t.redeemScript,
    t.witnessScript
  );
  return F5(e, i);
}
function bre(e) {
  if (!e) return;
  const t = to(e);
  if (!t) return;
  const r = t[t.length - 1];
  if (!(!(r instanceof Uint8Array) || sH(r) || Ere(r) || !to(r)))
    return r;
}
function wre(e) {
  if (!e) return;
  const t = oH(e), r = t[t.length - 1];
  if (!(sH(r) || !to(r)))
    return r;
}
function vre(e) {
  if (e.length === 65) {
    const t = e[64] & 1, r = e.slice(0, 33);
    return r[0] = 2 | t, r;
  }
  return e.slice();
}
function sH(e) {
  return e.length === 33 && JJ(e);
}
function Ere(e) {
  return of(e);
}
function D5(e, t, r, n, o) {
  const i = VL(e), a = i && n && P$(n), u = P$(e);
  if (i && n === void 0)
    throw new Error("scriptPubkey is P2SH but redeemScript missing");
  if ((u || a) && o === void 0)
    throw new Error(
      "scriptPubkey or redeemScript is P2WSH but witnessScript missing"
    );
  let l;
  return a ? (l = o, R$(t, e, n, r), z$(t, n, o, r), l3(l)) : u ? (l = o, z$(t, e, o, r), l3(l)) : i ? (l = n, R$(t, e, n, r)) : l = e, {
    meaningfulScript: l,
    type: a ? "p2sh-p2wsh" : i ? "p2sh" : u ? "p2wsh" : "raw"
  };
}
function l3(e) {
  if (H5(e) || VL(e))
    throw new Error("P2WPKH or P2SH can not be contained within P2WSH");
}
function uH(e) {
  return H5(e) ? "witnesspubkeyhash" : zte(e) ? "pubkeyhash" : Ute(e) ? "multisig" : Rte(e) ? "pubkey" : "nonstandard";
}
function xb(e) {
  return [...Array(e).keys()];
}
var Cu = {}, Jd = {}, Pc = {};
Object.defineProperty(Pc, "__esModule", { value: !0 });
Pc.anumber = xI;
Pc.abytes = cH;
Pc.ahash = Are;
Pc.aexists = xre;
Pc.aoutput = kre;
function xI(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error("positive integer expected, got " + e);
}
function _re(e) {
  return e instanceof Uint8Array || ArrayBuffer.isView(e) && e.constructor.name === "Uint8Array";
}
function cH(e, ...t) {
  if (!_re(e))
    throw new Error("Uint8Array expected");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error("Uint8Array expected of length " + t + ", got length=" + e.length);
}
function Are(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  xI(e.outputLen), xI(e.blockLen);
}
function xre(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function kre(e, t) {
  cH(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error("digestInto() expects output buffer of length at least " + r);
}
var Ds = {}, K5 = {};
Object.defineProperty(K5, "__esModule", { value: !0 });
K5.crypto = void 0;
K5.crypto = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
(function(e) {
  /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Hash = e.nextTick = e.byteSwapIfBE = e.isLE = void 0, e.isBytes = n, e.u8 = o, e.u32 = i, e.createView = a, e.rotr = u, e.rotl = l, e.byteSwap = d, e.byteSwap32 = f, e.bytesToHex = g, e.hexToBytes = E, e.asyncLoop = O, e.utf8ToBytes = C, e.toBytes = I, e.concatBytes = S, e.checkOpts = A, e.wrapConstructor = $, e.wrapConstructorWithOpts = U, e.wrapXOFConstructorWithOpts = M, e.randomBytes = Y;
  const t = K5, r = Pc;
  function n(L) {
    return L instanceof Uint8Array || ArrayBuffer.isView(L) && L.constructor.name === "Uint8Array";
  }
  function o(L) {
    return new Uint8Array(L.buffer, L.byteOffset, L.byteLength);
  }
  function i(L) {
    return new Uint32Array(L.buffer, L.byteOffset, Math.floor(L.byteLength / 4));
  }
  function a(L) {
    return new DataView(L.buffer, L.byteOffset, L.byteLength);
  }
  function u(L, ee) {
    return L << 32 - ee | L >>> ee;
  }
  function l(L, ee) {
    return L << ee | L >>> 32 - ee >>> 0;
  }
  e.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
  function d(L) {
    return L << 24 & 4278190080 | L << 8 & 16711680 | L >>> 8 & 65280 | L >>> 24 & 255;
  }
  e.byteSwapIfBE = e.isLE ? (L) => L : (L) => d(L);
  function f(L) {
    for (let ee = 0; ee < L.length; ee++)
      L[ee] = d(L[ee]);
  }
  const h = /* @__PURE__ */ Array.from({ length: 256 }, (L, ee) => ee.toString(16).padStart(2, "0"));
  function g(L) {
    (0, r.abytes)(L);
    let ee = "";
    for (let de = 0; de < L.length; de++)
      ee += h[L[de]];
    return ee;
  }
  const b = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
  function w(L) {
    if (L >= b._0 && L <= b._9)
      return L - b._0;
    if (L >= b.A && L <= b.F)
      return L - (b.A - 10);
    if (L >= b.a && L <= b.f)
      return L - (b.a - 10);
  }
  function E(L) {
    if (typeof L != "string")
      throw new Error("hex string expected, got " + typeof L);
    const ee = L.length, de = ee / 2;
    if (ee % 2)
      throw new Error("hex string expected, got unpadded hex of length " + ee);
    const ne = new Uint8Array(de);
    for (let D = 0, K = 0; D < de; D++, K += 2) {
      const le = w(L.charCodeAt(K)), re = w(L.charCodeAt(K + 1));
      if (le === void 0 || re === void 0) {
        const G = L[K] + L[K + 1];
        throw new Error('hex string expected, got non-hex character "' + G + '" at index ' + K);
      }
      ne[D] = le * 16 + re;
    }
    return ne;
  }
  const _ = async () => {
  };
  e.nextTick = _;
  async function O(L, ee, de) {
    let ne = Date.now();
    for (let D = 0; D < L; D++) {
      de(D);
      const K = Date.now() - ne;
      K >= 0 && K < ee || (await (0, e.nextTick)(), ne += K);
    }
  }
  function C(L) {
    if (typeof L != "string")
      throw new Error("utf8ToBytes expected string, got " + typeof L);
    return new Uint8Array(new TextEncoder().encode(L));
  }
  function I(L) {
    return typeof L == "string" && (L = C(L)), (0, r.abytes)(L), L;
  }
  function S(...L) {
    let ee = 0;
    for (let ne = 0; ne < L.length; ne++) {
      const D = L[ne];
      (0, r.abytes)(D), ee += D.length;
    }
    const de = new Uint8Array(ee);
    for (let ne = 0, D = 0; ne < L.length; ne++) {
      const K = L[ne];
      de.set(K, D), D += K.length;
    }
    return de;
  }
  class T {
    // Safe version that clones internal state
    clone() {
      return this._cloneInto();
    }
  }
  e.Hash = T;
  function A(L, ee) {
    if (ee !== void 0 && {}.toString.call(ee) !== "[object Object]")
      throw new Error("Options should be object or undefined");
    return Object.assign(L, ee);
  }
  function $(L) {
    const ee = (ne) => L().update(I(ne)).digest(), de = L();
    return ee.outputLen = de.outputLen, ee.blockLen = de.blockLen, ee.create = () => L(), ee;
  }
  function U(L) {
    const ee = (ne, D) => L(D).update(I(ne)).digest(), de = L({});
    return ee.outputLen = de.outputLen, ee.blockLen = de.blockLen, ee.create = (ne) => L(ne), ee;
  }
  function M(L) {
    const ee = (ne, D) => L(D).update(I(ne)).digest(), de = L({});
    return ee.outputLen = de.outputLen, ee.blockLen = de.blockLen, ee.create = (ne) => L(ne), ee;
  }
  function Y(L = 32) {
    if (t.crypto && typeof t.crypto.getRandomValues == "function")
      return t.crypto.getRandomValues(new Uint8Array(L));
    if (t.crypto && typeof t.crypto.randomBytes == "function")
      return t.crypto.randomBytes(L);
    throw new Error("crypto.getRandomValues must be defined");
  }
})(Ds);
Object.defineProperty(Jd, "__esModule", { value: !0 });
Jd.HashMD = void 0;
Jd.setBigUint64 = lH;
Jd.Chi = Sre;
Jd.Maj = Tre;
const IS = Pc, kb = Ds;
function lH(e, t, r, n) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, r, n);
  const o = BigInt(32), i = BigInt(4294967295), a = Number(r >> o & i), u = Number(r & i), l = n ? 4 : 0, d = n ? 0 : 4;
  e.setUint32(t + l, a, n), e.setUint32(t + d, u, n);
}
function Sre(e, t, r) {
  return e & t ^ ~e & r;
}
function Tre(e, t, r) {
  return e & t ^ e & r ^ t & r;
}
let Ire = class extends kb.Hash {
  constructor(t, r, n, o) {
    super(), this.blockLen = t, this.outputLen = r, this.padOffset = n, this.isLE = o, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = (0, kb.createView)(this.buffer);
  }
  update(t) {
    (0, IS.aexists)(this);
    const { view: r, buffer: n, blockLen: o } = this;
    t = (0, kb.toBytes)(t);
    const i = t.length;
    for (let a = 0; a < i; ) {
      const u = Math.min(o - this.pos, i - a);
      if (u === o) {
        const l = (0, kb.createView)(t);
        for (; o <= i - a; a += o)
          this.process(l, a);
        continue;
      }
      n.set(t.subarray(a, a + u), this.pos), this.pos += u, a += u, this.pos === o && (this.process(r, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    (0, IS.aexists)(this), (0, IS.aoutput)(t, this), this.finished = !0;
    const { buffer: r, view: n, blockLen: o, isLE: i } = this;
    let { pos: a } = this;
    r[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > o - a && (this.process(n, 0), a = 0);
    for (let h = a; h < o; h++)
      r[h] = 0;
    lH(n, o - 8, BigInt(this.length * 8), i), this.process(n, 0);
    const u = (0, kb.createView)(t), l = this.outputLen;
    if (l % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const d = l / 4, f = this.get();
    if (d > f.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let h = 0; h < d; h++)
      u.setUint32(4 * h, f[h], i);
  }
  digest() {
    const { buffer: t, outputLen: r } = this;
    this.digestInto(t);
    const n = t.slice(0, r);
    return this.destroy(), n;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: r, buffer: n, length: o, finished: i, destroyed: a, pos: u } = this;
    return t.length = o, t.pos = u, t.finished = i, t.destroyed = a, o % r && t.buffer.set(n), t;
  }
};
Jd.HashMD = Ire;
Object.defineProperty(Cu, "__esModule", { value: !0 });
Cu.sha224 = fH = Cu.sha256 = Cu.SHA256 = void 0;
const OS = Jd, Os = Ds, Ore = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), If = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), Of = /* @__PURE__ */ new Uint32Array(64);
let ZP = class extends OS.HashMD {
  constructor() {
    super(64, 32, 8, !1), this.A = If[0] | 0, this.B = If[1] | 0, this.C = If[2] | 0, this.D = If[3] | 0, this.E = If[4] | 0, this.F = If[5] | 0, this.G = If[6] | 0, this.H = If[7] | 0;
  }
  get() {
    const { A: t, B: r, C: n, D: o, E: i, F: a, G: u, H: l } = this;
    return [t, r, n, o, i, a, u, l];
  }
  // prettier-ignore
  set(t, r, n, o, i, a, u, l) {
    this.A = t | 0, this.B = r | 0, this.C = n | 0, this.D = o | 0, this.E = i | 0, this.F = a | 0, this.G = u | 0, this.H = l | 0;
  }
  process(t, r) {
    for (let h = 0; h < 16; h++, r += 4)
      Of[h] = t.getUint32(r, !1);
    for (let h = 16; h < 64; h++) {
      const g = Of[h - 15], b = Of[h - 2], w = (0, Os.rotr)(g, 7) ^ (0, Os.rotr)(g, 18) ^ g >>> 3, E = (0, Os.rotr)(b, 17) ^ (0, Os.rotr)(b, 19) ^ b >>> 10;
      Of[h] = E + Of[h - 7] + w + Of[h - 16] | 0;
    }
    let { A: n, B: o, C: i, D: a, E: u, F: l, G: d, H: f } = this;
    for (let h = 0; h < 64; h++) {
      const g = (0, Os.rotr)(u, 6) ^ (0, Os.rotr)(u, 11) ^ (0, Os.rotr)(u, 25), b = f + g + (0, OS.Chi)(u, l, d) + Ore[h] + Of[h] | 0, w = ((0, Os.rotr)(n, 2) ^ (0, Os.rotr)(n, 13) ^ (0, Os.rotr)(n, 22)) + (0, OS.Maj)(n, o, i) | 0;
      f = d, d = l, l = u, u = a + b | 0, a = i, i = o, o = n, n = b + w | 0;
    }
    n = n + this.A | 0, o = o + this.B | 0, i = i + this.C | 0, a = a + this.D | 0, u = u + this.E | 0, l = l + this.F | 0, d = d + this.G | 0, f = f + this.H | 0, this.set(n, o, i, a, u, l, d, f);
  }
  roundClean() {
    Of.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
};
Cu.SHA256 = ZP;
let Pre = class extends ZP {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
};
var fH = Cu.sha256 = (0, Os.wrapConstructor)(() => new ZP());
Cu.sha224 = (0, Os.wrapConstructor)(() => new Pre());
var v2 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.hmac = e.HMAC = void 0;
  const t = Pc, r = Ds;
  class n extends r.Hash {
    constructor(a, u) {
      super(), this.finished = !1, this.destroyed = !1, (0, t.ahash)(a);
      const l = (0, r.toBytes)(u);
      if (this.iHash = a.create(), typeof this.iHash.update != "function")
        throw new Error("Expected instance of class which extends utils.Hash");
      this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
      const d = this.blockLen, f = new Uint8Array(d);
      f.set(l.length > d ? a.create().update(l).digest() : l);
      for (let h = 0; h < f.length; h++)
        f[h] ^= 54;
      this.iHash.update(f), this.oHash = a.create();
      for (let h = 0; h < f.length; h++)
        f[h] ^= 106;
      this.oHash.update(f), f.fill(0);
    }
    update(a) {
      return (0, t.aexists)(this), this.iHash.update(a), this;
    }
    digestInto(a) {
      (0, t.aexists)(this), (0, t.abytes)(a, this.outputLen), this.finished = !0, this.iHash.digestInto(a), this.oHash.update(a), this.oHash.digestInto(a), this.destroy();
    }
    digest() {
      const a = new Uint8Array(this.oHash.outputLen);
      return this.digestInto(a), a;
    }
    _cloneInto(a) {
      a || (a = Object.create(Object.getPrototypeOf(this), {}));
      const { oHash: u, iHash: l, finished: d, destroyed: f, blockLen: h, outputLen: g } = this;
      return a = a, a.finished = d, a.destroyed = f, a.blockLen = h, a.outputLen = g, a.oHash = u._cloneInto(a.oHash), a.iHash = l._cloneInto(a.iHash), a;
    }
    destroy() {
      this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
    }
  }
  e.HMAC = n;
  const o = (i, a, u) => new n(i, a).update(u).digest();
  e.hmac = o, e.hmac.create = (i, a) => new n(i, a);
})(v2);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const q5 = /* @__PURE__ */ BigInt(0), V5 = /* @__PURE__ */ BigInt(1), Cre = /* @__PURE__ */ BigInt(2);
function t0(e) {
  return e instanceof Uint8Array || ArrayBuffer.isView(e) && e.constructor.name === "Uint8Array";
}
function E2(e) {
  if (!t0(e))
    throw new Error("Uint8Array expected");
}
function R1(e, t) {
  if (typeof t != "boolean")
    throw new Error(e + " boolean expected, got " + t);
}
const Bre = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function z1(e) {
  E2(e);
  let t = "";
  for (let r = 0; r < e.length; r++)
    t += Bre[e[r]];
  return t;
}
function s1(e) {
  const t = e.toString(16);
  return t.length & 1 ? "0" + t : t;
}
function XP(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  return e === "" ? q5 : BigInt("0x" + e);
}
const Pl = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function M$(e) {
  if (e >= Pl._0 && e <= Pl._9)
    return e - Pl._0;
  if (e >= Pl.A && e <= Pl.F)
    return e - (Pl.A - 10);
  if (e >= Pl.a && e <= Pl.f)
    return e - (Pl.a - 10);
}
function j1(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  const t = e.length, r = t / 2;
  if (t % 2)
    throw new Error("hex string expected, got unpadded hex of length " + t);
  const n = new Uint8Array(r);
  for (let o = 0, i = 0; o < r; o++, i += 2) {
    const a = M$(e.charCodeAt(i)), u = M$(e.charCodeAt(i + 1));
    if (a === void 0 || u === void 0) {
      const l = e[i] + e[i + 1];
      throw new Error('hex string expected, got non-hex character "' + l + '" at index ' + i);
    }
    n[o] = a * 16 + u;
  }
  return n;
}
function Dp(e) {
  return XP(z1(e));
}
function YP(e) {
  return E2(e), XP(z1(Uint8Array.from(e).reverse()));
}
function L1(e, t) {
  return j1(e.toString(16).padStart(t * 2, "0"));
}
function JP(e, t) {
  return L1(e, t).reverse();
}
function Nre(e) {
  return j1(s1(e));
}
function mu(e, t, r) {
  let n;
  if (typeof t == "string")
    try {
      n = j1(t);
    } catch (i) {
      throw new Error(e + " must be hex string or Uint8Array, cause: " + i);
    }
  else if (t0(t))
    n = Uint8Array.from(t);
  else
    throw new Error(e + " must be hex string or Uint8Array");
  const o = n.length;
  if (typeof r == "number" && o !== r)
    throw new Error(e + " of length " + r + " expected, got " + o);
  return n;
}
function mw(...e) {
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    E2(o), t += o.length;
  }
  const r = new Uint8Array(t);
  for (let n = 0, o = 0; n < e.length; n++) {
    const i = e[n];
    r.set(i, o), o += i.length;
  }
  return r;
}
function $re(e, t) {
  if (e.length !== t.length)
    return !1;
  let r = 0;
  for (let n = 0; n < e.length; n++)
    r |= e[n] ^ t[n];
  return r === 0;
}
function Ure(e) {
  if (typeof e != "string")
    throw new Error("string expected");
  return new Uint8Array(new TextEncoder().encode(e));
}
const PS = (e) => typeof e == "bigint" && q5 <= e;
function G5(e, t, r) {
  return PS(e) && PS(t) && PS(r) && t <= e && e < r;
}
function Kp(e, t, r, n) {
  if (!G5(t, r, n))
    throw new Error("expected valid " + e + ": " + r + " <= n < " + n + ", got " + t);
}
function dH(e) {
  let t;
  for (t = 0; e > q5; e >>= V5, t += 1)
    ;
  return t;
}
function Rre(e, t) {
  return e >> BigInt(t) & V5;
}
function zre(e, t, r) {
  return e | (r ? V5 : q5) << BigInt(t);
}
const QP = (e) => (Cre << BigInt(e - 1)) - V5, CS = (e) => new Uint8Array(e), D$ = (e) => Uint8Array.from(e);
function hH(e, t, r) {
  if (typeof e != "number" || e < 2)
    throw new Error("hashLen must be a number");
  if (typeof t != "number" || t < 2)
    throw new Error("qByteLen must be a number");
  if (typeof r != "function")
    throw new Error("hmacFn must be a function");
  let n = CS(e), o = CS(e), i = 0;
  const a = () => {
    n.fill(1), o.fill(0), i = 0;
  }, u = (...f) => r(o, n, ...f), l = (f = CS()) => {
    o = u(D$([0]), f), n = u(), f.length !== 0 && (o = u(D$([1]), f), n = u());
  }, d = () => {
    if (i++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let f = 0;
    const h = [];
    for (; f < t; ) {
      n = u();
      const g = n.slice();
      h.push(g), f += n.length;
    }
    return mw(...h);
  };
  return (f, h) => {
    a(), l(f);
    let g;
    for (; !(g = h(d())); )
      l();
    return a(), g;
  };
}
const jre = {
  bigint: (e) => typeof e == "bigint",
  function: (e) => typeof e == "function",
  boolean: (e) => typeof e == "boolean",
  string: (e) => typeof e == "string",
  stringOrUint8Array: (e) => typeof e == "string" || t0(e),
  isSafeInteger: (e) => Number.isSafeInteger(e),
  array: (e) => Array.isArray(e),
  field: (e, t) => t.Fp.isValid(e),
  hash: (e) => typeof e == "function" && Number.isSafeInteger(e.outputLen)
};
function _2(e, t, r = {}) {
  const n = (o, i, a) => {
    const u = jre[i];
    if (typeof u != "function")
      throw new Error("invalid validator function");
    const l = e[o];
    if (!(a && l === void 0) && !u(l, e))
      throw new Error("param " + String(o) + " is invalid. Expected " + i + ", got " + l);
  };
  for (const [o, i] of Object.entries(t))
    n(o, i, !1);
  for (const [o, i] of Object.entries(r))
    n(o, i, !0);
  return e;
}
const Lre = () => {
  throw new Error("not implemented");
};
function kI(e) {
  const t = /* @__PURE__ */ new WeakMap();
  return (r, ...n) => {
    const o = t.get(r);
    if (o !== void 0)
      return o;
    const i = e(r, ...n);
    return t.set(r, i), i;
  };
}
const Hre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  aInRange: Kp,
  abool: R1,
  abytes: E2,
  bitGet: Rre,
  bitLen: dH,
  bitMask: QP,
  bitSet: zre,
  bytesToHex: z1,
  bytesToNumberBE: Dp,
  bytesToNumberLE: YP,
  concatBytes: mw,
  createHmacDrbg: hH,
  ensureBytes: mu,
  equalBytes: $re,
  hexToBytes: j1,
  hexToNumber: XP,
  inRange: G5,
  isBytes: t0,
  memoized: kI,
  notImplemented: Lre,
  numberToBytesBE: L1,
  numberToBytesLE: JP,
  numberToHexUnpadded: s1,
  numberToVarBytesBE: Nre,
  utf8ToBytes: Ure,
  validateObject: _2
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const ti = BigInt(0), _o = BigInt(1), Tp = /* @__PURE__ */ BigInt(2), Fre = /* @__PURE__ */ BigInt(3), SI = /* @__PURE__ */ BigInt(4), K$ = /* @__PURE__ */ BigInt(5), q$ = /* @__PURE__ */ BigInt(8);
function oa(e, t) {
  const r = e % t;
  return r >= ti ? r : t + r;
}
function Mre(e, t, r) {
  if (t < ti)
    throw new Error("invalid exponent, negatives unsupported");
  if (r <= ti)
    throw new Error("invalid modulus");
  if (r === _o)
    return ti;
  let n = _o;
  for (; t > ti; )
    t & _o && (n = n * e % r), e = e * e % r, t >>= _o;
  return n;
}
function _s(e, t, r) {
  let n = e;
  for (; t-- > ti; )
    n *= n, n %= r;
  return n;
}
function TI(e, t) {
  if (e === ti)
    throw new Error("invert: expected non-zero number");
  if (t <= ti)
    throw new Error("invert: expected positive modulus, got " + t);
  let r = oa(e, t), n = t, o = ti, i = _o;
  for (; r !== ti; ) {
    const a = n / r, u = n % r, l = o - i * a;
    n = r, r = u, o = i, i = l;
  }
  if (n !== _o)
    throw new Error("invert: does not exist");
  return oa(o, t);
}
function Dre(e) {
  const t = (e - _o) / Tp;
  let r, n, o;
  for (r = e - _o, n = 0; r % Tp === ti; r /= Tp, n++)
    ;
  for (o = Tp; o < e && Mre(o, t, e) !== e - _o; o++)
    if (o > 1e3)
      throw new Error("Cannot find square root: likely non-prime P");
  if (n === 1) {
    const a = (e + _o) / SI;
    return function(u, l) {
      const d = u.pow(l, a);
      if (!u.eql(u.sqr(d), l))
        throw new Error("Cannot find square root");
      return d;
    };
  }
  const i = (r + _o) / Tp;
  return function(a, u) {
    if (a.pow(u, t) === a.neg(a.ONE))
      throw new Error("Cannot find square root");
    let l = n, d = a.pow(a.mul(a.ONE, o), r), f = a.pow(u, i), h = a.pow(u, r);
    for (; !a.eql(h, a.ONE); ) {
      if (a.eql(h, a.ZERO))
        return a.ZERO;
      let g = 1;
      for (let w = a.sqr(h); g < l && !a.eql(w, a.ONE); g++)
        w = a.sqr(w);
      const b = a.pow(d, _o << BigInt(l - g - 1));
      d = a.sqr(b), f = a.mul(f, b), h = a.mul(h, d), l = g;
    }
    return f;
  };
}
function Kre(e) {
  if (e % SI === Fre) {
    const t = (e + _o) / SI;
    return function(r, n) {
      const o = r.pow(n, t);
      if (!r.eql(r.sqr(o), n))
        throw new Error("Cannot find square root");
      return o;
    };
  }
  if (e % q$ === K$) {
    const t = (e - K$) / q$;
    return function(r, n) {
      const o = r.mul(n, Tp), i = r.pow(o, t), a = r.mul(n, i), u = r.mul(r.mul(a, Tp), i), l = r.mul(a, r.sub(u, r.ONE));
      if (!r.eql(r.sqr(l), n))
        throw new Error("Cannot find square root");
      return l;
    };
  }
  return Dre(e);
}
const qre = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function Vre(e) {
  const t = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, r = qre.reduce((n, o) => (n[o] = "function", n), t);
  return _2(e, r);
}
function Gre(e, t, r) {
  if (r < ti)
    throw new Error("invalid exponent, negatives unsupported");
  if (r === ti)
    return e.ONE;
  if (r === _o)
    return t;
  let n = e.ONE, o = t;
  for (; r > ti; )
    r & _o && (n = e.mul(n, o)), o = e.sqr(o), r >>= _o;
  return n;
}
function Wre(e, t) {
  const r = new Array(t.length), n = t.reduce((i, a, u) => e.is0(a) ? i : (r[u] = i, e.mul(i, a)), e.ONE), o = e.inv(n);
  return t.reduceRight((i, a, u) => e.is0(a) ? i : (r[u] = e.mul(i, r[u]), e.mul(i, a)), o), r;
}
function pH(e, t) {
  const r = t !== void 0 ? t : e.toString(2).length, n = Math.ceil(r / 8);
  return { nBitLength: r, nByteLength: n };
}
function eC(e, t, r = !1, n = {}) {
  if (e <= ti)
    throw new Error("invalid field: expected ORDER > 0, got " + e);
  const { nBitLength: o, nByteLength: i } = pH(e, t);
  if (i > 2048)
    throw new Error("invalid field: expected ORDER of <= 2048 bytes");
  let a;
  const u = Object.freeze({
    ORDER: e,
    isLE: r,
    BITS: o,
    BYTES: i,
    MASK: QP(o),
    ZERO: ti,
    ONE: _o,
    create: (l) => oa(l, e),
    isValid: (l) => {
      if (typeof l != "bigint")
        throw new Error("invalid field element: expected bigint, got " + typeof l);
      return ti <= l && l < e;
    },
    is0: (l) => l === ti,
    isOdd: (l) => (l & _o) === _o,
    neg: (l) => oa(-l, e),
    eql: (l, d) => l === d,
    sqr: (l) => oa(l * l, e),
    add: (l, d) => oa(l + d, e),
    sub: (l, d) => oa(l - d, e),
    mul: (l, d) => oa(l * d, e),
    pow: (l, d) => Gre(u, l, d),
    div: (l, d) => oa(l * TI(d, e), e),
    // Same as above, but doesn't normalize
    sqrN: (l) => l * l,
    addN: (l, d) => l + d,
    subN: (l, d) => l - d,
    mulN: (l, d) => l * d,
    inv: (l) => TI(l, e),
    sqrt: n.sqrt || ((l) => (a || (a = Kre(e)), a(u, l))),
    invertBatch: (l) => Wre(u, l),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (l, d, f) => f ? d : l,
    toBytes: (l) => r ? JP(l, i) : L1(l, i),
    fromBytes: (l) => {
      if (l.length !== i)
        throw new Error("Field.fromBytes: expected " + i + " bytes, got " + l.length);
      return r ? YP(l) : Dp(l);
    }
  });
  return Object.freeze(u);
}
function gH(e) {
  if (typeof e != "bigint")
    throw new Error("field order must be bigint");
  const t = e.toString(2).length;
  return Math.ceil(t / 8);
}
function mH(e) {
  const t = gH(e);
  return t + Math.ceil(t / 2);
}
function Zre(e, t, r = !1) {
  const n = e.length, o = gH(t), i = mH(t);
  if (n < 16 || n < i || n > 1024)
    throw new Error("expected " + i + "-1024 bytes of input, got " + n);
  const a = r ? YP(e) : Dp(e), u = oa(a, t - _o) + _o;
  return r ? JP(u, o) : L1(u, o);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const V$ = BigInt(0), $v = BigInt(1);
function BS(e, t) {
  const r = t.negate();
  return e ? r : t;
}
function yH(e, t) {
  if (!Number.isSafeInteger(e) || e <= 0 || e > t)
    throw new Error("invalid window size, expected [1.." + t + "], got W=" + e);
}
function NS(e, t) {
  yH(e, t);
  const r = Math.ceil(t / e) + 1, n = 2 ** (e - 1);
  return { windows: r, windowSize: n };
}
function Xre(e, t) {
  if (!Array.isArray(e))
    throw new Error("array expected");
  e.forEach((r, n) => {
    if (!(r instanceof t))
      throw new Error("invalid point at index " + n);
  });
}
function Yre(e, t) {
  if (!Array.isArray(e))
    throw new Error("array of scalars expected");
  e.forEach((r, n) => {
    if (!t.isValid(r))
      throw new Error("invalid scalar at index " + n);
  });
}
const $S = /* @__PURE__ */ new WeakMap(), bH = /* @__PURE__ */ new WeakMap();
function US(e) {
  return bH.get(e) || 1;
}
function Jre(e, t) {
  return {
    constTimeNegate: BS,
    hasPrecomputes(r) {
      return US(r) !== 1;
    },
    // non-const time multiplication ladder
    unsafeLadder(r, n, o = e.ZERO) {
      let i = r;
      for (; n > V$; )
        n & $v && (o = o.add(i)), i = i.double(), n >>= $v;
      return o;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param elm Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(r, n) {
      const { windows: o, windowSize: i } = NS(n, t), a = [];
      let u = r, l = u;
      for (let d = 0; d < o; d++) {
        l = u, a.push(l);
        for (let f = 1; f < i; f++)
          l = l.add(u), a.push(l);
        u = l.double();
      }
      return a;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(r, n, o) {
      const { windows: i, windowSize: a } = NS(r, t);
      let u = e.ZERO, l = e.BASE;
      const d = BigInt(2 ** r - 1), f = 2 ** r, h = BigInt(r);
      for (let g = 0; g < i; g++) {
        const b = g * a;
        let w = Number(o & d);
        o >>= h, w > a && (w -= f, o += $v);
        const E = b, _ = b + Math.abs(w) - 1, O = g % 2 !== 0, C = w < 0;
        w === 0 ? l = l.add(BS(O, n[E])) : u = u.add(BS(C, n[_]));
      }
      return { p: u, f: l };
    },
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */
    wNAFUnsafe(r, n, o, i = e.ZERO) {
      const { windows: a, windowSize: u } = NS(r, t), l = BigInt(2 ** r - 1), d = 2 ** r, f = BigInt(r);
      for (let h = 0; h < a; h++) {
        const g = h * u;
        if (o === V$)
          break;
        let b = Number(o & l);
        if (o >>= f, b > u && (b -= d, o += $v), b === 0)
          continue;
        let w = n[g + Math.abs(b) - 1];
        b < 0 && (w = w.negate()), i = i.add(w);
      }
      return i;
    },
    getPrecomputes(r, n, o) {
      let i = $S.get(n);
      return i || (i = this.precomputeWindow(n, r), r !== 1 && $S.set(n, o(i))), i;
    },
    wNAFCached(r, n, o) {
      const i = US(r);
      return this.wNAF(i, this.getPrecomputes(i, r, o), n);
    },
    wNAFCachedUnsafe(r, n, o, i) {
      const a = US(r);
      return a === 1 ? this.unsafeLadder(r, n, i) : this.wNAFUnsafe(a, this.getPrecomputes(a, r, o), n, i);
    },
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    setWindowSize(r, n) {
      yH(n, t), bH.set(r, n), $S.delete(r);
    }
  };
}
function Qre(e, t, r, n) {
  if (Xre(r, e), Yre(n, t), r.length !== n.length)
    throw new Error("arrays of points and scalars must have equal length");
  const o = e.ZERO, i = dH(BigInt(r.length)), a = i > 12 ? i - 3 : i > 4 ? i - 2 : i ? 2 : 1, u = (1 << a) - 1, l = new Array(u + 1).fill(o), d = Math.floor((t.BITS - 1) / a) * a;
  let f = o;
  for (let h = d; h >= 0; h -= a) {
    l.fill(o);
    for (let b = 0; b < n.length; b++) {
      const w = n[b], E = Number(w >> BigInt(h) & BigInt(u));
      l[E] = l[E].add(r[b]);
    }
    let g = o;
    for (let b = l.length - 1, w = o; b > 0; b--)
      w = w.add(l[b]), g = g.add(w);
    if (f = f.add(g), h !== 0)
      for (let b = 0; b < a; b++)
        f = f.double();
  }
  return f;
}
function wH(e) {
  return Vre(e.Fp), _2(e, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...pH(e.n, e.nBitLength),
    ...e,
    p: e.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function G$(e) {
  e.lowS !== void 0 && R1("lowS", e.lowS), e.prehash !== void 0 && R1("prehash", e.prehash);
}
function ene(e) {
  const t = wH(e);
  _2(t, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: r, Fp: n, a: o } = t;
  if (r) {
    if (!n.eql(o, n.ZERO))
      throw new Error("invalid endomorphism, can only be defined for Koblitz curves that have a=0");
    if (typeof r != "object" || typeof r.beta != "bigint" || typeof r.splitScalar != "function")
      throw new Error("invalid endomorphism, expected beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...t });
}
const { bytesToNumberBE: tne, hexToBytes: rne } = Hre;
let nne = class extends Error {
  constructor(t = "") {
    super(t);
  }
};
const Vl = {
  // asn.1 DER encoding utils
  Err: nne,
  // Basic building block is TLV (Tag-Length-Value)
  _tlv: {
    encode: (e, t) => {
      const { Err: r } = Vl;
      if (e < 0 || e > 256)
        throw new r("tlv.encode: wrong tag");
      if (t.length & 1)
        throw new r("tlv.encode: unpadded data");
      const n = t.length / 2, o = s1(n);
      if (o.length / 2 & 128)
        throw new r("tlv.encode: long form length too big");
      const i = n > 127 ? s1(o.length / 2 | 128) : "";
      return s1(e) + i + o + t;
    },
    // v - value, l - left bytes (unparsed)
    decode(e, t) {
      const { Err: r } = Vl;
      let n = 0;
      if (e < 0 || e > 256)
        throw new r("tlv.encode: wrong tag");
      if (t.length < 2 || t[n++] !== e)
        throw new r("tlv.decode: wrong tlv");
      const o = t[n++], i = !!(o & 128);
      let a = 0;
      if (!i)
        a = o;
      else {
        const l = o & 127;
        if (!l)
          throw new r("tlv.decode(long): indefinite length not supported");
        if (l > 4)
          throw new r("tlv.decode(long): byte length is too big");
        const d = t.subarray(n, n + l);
        if (d.length !== l)
          throw new r("tlv.decode: length bytes not complete");
        if (d[0] === 0)
          throw new r("tlv.decode(long): zero leftmost byte");
        for (const f of d)
          a = a << 8 | f;
        if (n += l, a < 128)
          throw new r("tlv.decode(long): not minimal encoding");
      }
      const u = t.subarray(n, n + a);
      if (u.length !== a)
        throw new r("tlv.decode: wrong value length");
      return { v: u, l: t.subarray(n + a) };
    }
  },
  // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
  // since we always use positive integers here. It must always be empty:
  // - add zero byte if exists
  // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
  _int: {
    encode(e) {
      const { Err: t } = Vl;
      if (e < Zl)
        throw new t("integer: negative integers are not allowed");
      let r = s1(e);
      if (Number.parseInt(r[0], 16) & 8 && (r = "00" + r), r.length & 1)
        throw new t("unexpected DER parsing assertion: unpadded hex");
      return r;
    },
    decode(e) {
      const { Err: t } = Vl;
      if (e[0] & 128)
        throw new t("invalid signature integer: negative");
      if (e[0] === 0 && !(e[1] & 128))
        throw new t("invalid signature integer: unnecessary leading zero");
      return tne(e);
    }
  },
  toSig(e) {
    const { Err: t, _int: r, _tlv: n } = Vl, o = typeof e == "string" ? rne(e) : e;
    E2(o);
    const { v: i, l: a } = n.decode(48, o);
    if (a.length)
      throw new t("invalid signature: left bytes after parsing");
    const { v: u, l } = n.decode(2, i), { v: d, l: f } = n.decode(2, l);
    if (f.length)
      throw new t("invalid signature: left bytes after parsing");
    return { r: r.decode(u), s: r.decode(d) };
  },
  hexFromSig(e) {
    const { _tlv: t, _int: r } = Vl, n = t.encode(2, r.encode(e.r)), o = t.encode(2, r.encode(e.s)), i = n + o;
    return t.encode(48, i);
  }
}, Zl = BigInt(0), Yo = BigInt(1);
BigInt(2);
const W$ = BigInt(3);
BigInt(4);
function one(e) {
  const t = ene(e), { Fp: r } = t, n = eC(t.n, t.nBitLength), o = t.toBytes || ((E, _, O) => {
    const C = _.toAffine();
    return mw(Uint8Array.from([4]), r.toBytes(C.x), r.toBytes(C.y));
  }), i = t.fromBytes || ((E) => {
    const _ = E.subarray(1), O = r.fromBytes(_.subarray(0, r.BYTES)), C = r.fromBytes(_.subarray(r.BYTES, 2 * r.BYTES));
    return { x: O, y: C };
  });
  function a(E) {
    const { a: _, b: O } = t, C = r.sqr(E), I = r.mul(C, E);
    return r.add(r.add(I, r.mul(E, _)), O);
  }
  if (!r.eql(r.sqr(t.Gy), a(t.Gx)))
    throw new Error("bad generator point: equation left != right");
  function u(E) {
    return G5(E, Yo, t.n);
  }
  function l(E) {
    const { allowedPrivateKeyLengths: _, nByteLength: O, wrapPrivateKey: C, n: I } = t;
    if (_ && typeof E != "bigint") {
      if (t0(E) && (E = z1(E)), typeof E != "string" || !_.includes(E.length))
        throw new Error("invalid private key");
      E = E.padStart(O * 2, "0");
    }
    let S;
    try {
      S = typeof E == "bigint" ? E : Dp(mu("private key", E, O));
    } catch {
      throw new Error("invalid private key, expected hex or " + O + " bytes, got " + typeof E);
    }
    return C && (S = oa(S, I)), Kp("private key", S, Yo, I), S;
  }
  function d(E) {
    if (!(E instanceof g))
      throw new Error("ProjectivePoint expected");
  }
  const f = kI((E, _) => {
    const { px: O, py: C, pz: I } = E;
    if (r.eql(I, r.ONE))
      return { x: O, y: C };
    const S = E.is0();
    _ == null && (_ = S ? r.ONE : r.inv(I));
    const T = r.mul(O, _), A = r.mul(C, _), $ = r.mul(I, _);
    if (S)
      return { x: r.ZERO, y: r.ZERO };
    if (!r.eql($, r.ONE))
      throw new Error("invZ was invalid");
    return { x: T, y: A };
  }), h = kI((E) => {
    if (E.is0()) {
      if (t.allowInfinityPoint && !r.is0(E.py))
        return;
      throw new Error("bad point: ZERO");
    }
    const { x: _, y: O } = E.toAffine();
    if (!r.isValid(_) || !r.isValid(O))
      throw new Error("bad point: x or y not FE");
    const C = r.sqr(O), I = a(_);
    if (!r.eql(C, I))
      throw new Error("bad point: equation left != right");
    if (!E.isTorsionFree())
      throw new Error("bad point: not in prime-order subgroup");
    return !0;
  });
  class g {
    constructor(_, O, C) {
      if (this.px = _, this.py = O, this.pz = C, _ == null || !r.isValid(_))
        throw new Error("x required");
      if (O == null || !r.isValid(O))
        throw new Error("y required");
      if (C == null || !r.isValid(C))
        throw new Error("z required");
      Object.freeze(this);
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(_) {
      const { x: O, y: C } = _ || {};
      if (!_ || !r.isValid(O) || !r.isValid(C))
        throw new Error("invalid affine point");
      if (_ instanceof g)
        throw new Error("projective point not allowed");
      const I = (S) => r.eql(S, r.ZERO);
      return I(O) && I(C) ? g.ZERO : new g(O, C, r.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(_) {
      const O = r.invertBatch(_.map((C) => C.pz));
      return _.map((C, I) => C.toAffine(O[I])).map(g.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(_) {
      const O = g.fromAffine(i(mu("pointHex", _)));
      return O.assertValidity(), O;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(_) {
      return g.BASE.multiply(l(_));
    }
    // Multiscalar Multiplication
    static msm(_, O) {
      return Qre(g, n, _, O);
    }
    // "Private method", don't use it directly
    _setWindowSize(_) {
      w.setWindowSize(this, _);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      h(this);
    }
    hasEvenY() {
      const { y: _ } = this.toAffine();
      if (r.isOdd)
        return !r.isOdd(_);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(_) {
      d(_);
      const { px: O, py: C, pz: I } = this, { px: S, py: T, pz: A } = _, $ = r.eql(r.mul(O, A), r.mul(S, I)), U = r.eql(r.mul(C, A), r.mul(T, I));
      return $ && U;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new g(this.px, r.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: _, b: O } = t, C = r.mul(O, W$), { px: I, py: S, pz: T } = this;
      let A = r.ZERO, $ = r.ZERO, U = r.ZERO, M = r.mul(I, I), Y = r.mul(S, S), L = r.mul(T, T), ee = r.mul(I, S);
      return ee = r.add(ee, ee), U = r.mul(I, T), U = r.add(U, U), A = r.mul(_, U), $ = r.mul(C, L), $ = r.add(A, $), A = r.sub(Y, $), $ = r.add(Y, $), $ = r.mul(A, $), A = r.mul(ee, A), U = r.mul(C, U), L = r.mul(_, L), ee = r.sub(M, L), ee = r.mul(_, ee), ee = r.add(ee, U), U = r.add(M, M), M = r.add(U, M), M = r.add(M, L), M = r.mul(M, ee), $ = r.add($, M), L = r.mul(S, T), L = r.add(L, L), M = r.mul(L, ee), A = r.sub(A, M), U = r.mul(L, Y), U = r.add(U, U), U = r.add(U, U), new g(A, $, U);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(_) {
      d(_);
      const { px: O, py: C, pz: I } = this, { px: S, py: T, pz: A } = _;
      let $ = r.ZERO, U = r.ZERO, M = r.ZERO;
      const Y = t.a, L = r.mul(t.b, W$);
      let ee = r.mul(O, S), de = r.mul(C, T), ne = r.mul(I, A), D = r.add(O, C), K = r.add(S, T);
      D = r.mul(D, K), K = r.add(ee, de), D = r.sub(D, K), K = r.add(O, I);
      let le = r.add(S, A);
      return K = r.mul(K, le), le = r.add(ee, ne), K = r.sub(K, le), le = r.add(C, I), $ = r.add(T, A), le = r.mul(le, $), $ = r.add(de, ne), le = r.sub(le, $), M = r.mul(Y, K), $ = r.mul(L, ne), M = r.add($, M), $ = r.sub(de, M), M = r.add(de, M), U = r.mul($, M), de = r.add(ee, ee), de = r.add(de, ee), ne = r.mul(Y, ne), K = r.mul(L, K), de = r.add(de, ne), ne = r.sub(ee, ne), ne = r.mul(Y, ne), K = r.add(K, ne), ee = r.mul(de, K), U = r.add(U, ee), ee = r.mul(le, K), $ = r.mul(D, $), $ = r.sub($, ee), ee = r.mul(D, de), M = r.mul(le, M), M = r.add(M, ee), new g($, U, M);
    }
    subtract(_) {
      return this.add(_.negate());
    }
    is0() {
      return this.equals(g.ZERO);
    }
    wNAF(_) {
      return w.wNAFCached(this, _, g.normalizeZ);
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(_) {
      const { endo: O, n: C } = t;
      Kp("scalar", _, Zl, C);
      const I = g.ZERO;
      if (_ === Zl)
        return I;
      if (this.is0() || _ === Yo)
        return this;
      if (!O || w.hasPrecomputes(this))
        return w.wNAFCachedUnsafe(this, _, g.normalizeZ);
      let { k1neg: S, k1: T, k2neg: A, k2: $ } = O.splitScalar(_), U = I, M = I, Y = this;
      for (; T > Zl || $ > Zl; )
        T & Yo && (U = U.add(Y)), $ & Yo && (M = M.add(Y)), Y = Y.double(), T >>= Yo, $ >>= Yo;
      return S && (U = U.negate()), A && (M = M.negate()), M = new g(r.mul(M.px, O.beta), M.py, M.pz), U.add(M);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(_) {
      const { endo: O, n: C } = t;
      Kp("scalar", _, Yo, C);
      let I, S;
      if (O) {
        const { k1neg: T, k1: A, k2neg: $, k2: U } = O.splitScalar(_);
        let { p: M, f: Y } = this.wNAF(A), { p: L, f: ee } = this.wNAF(U);
        M = w.constTimeNegate(T, M), L = w.constTimeNegate($, L), L = new g(r.mul(L.px, O.beta), L.py, L.pz), I = M.add(L), S = Y.add(ee);
      } else {
        const { p: T, f: A } = this.wNAF(_);
        I = T, S = A;
      }
      return g.normalizeZ([I, S])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(_, O, C) {
      const I = g.BASE, S = (A, $) => $ === Zl || $ === Yo || !A.equals(I) ? A.multiplyUnsafe($) : A.multiply($), T = S(this, O).add(S(_, C));
      return T.is0() ? void 0 : T;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(_) {
      return f(this, _);
    }
    isTorsionFree() {
      const { h: _, isTorsionFree: O } = t;
      if (_ === Yo)
        return !0;
      if (O)
        return O(g, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: _, clearCofactor: O } = t;
      return _ === Yo ? this : O ? O(g, this) : this.multiplyUnsafe(t.h);
    }
    toRawBytes(_ = !0) {
      return R1("isCompressed", _), this.assertValidity(), o(g, this, _);
    }
    toHex(_ = !0) {
      return R1("isCompressed", _), z1(this.toRawBytes(_));
    }
  }
  g.BASE = new g(t.Gx, t.Gy, r.ONE), g.ZERO = new g(r.ZERO, r.ONE, r.ZERO);
  const b = t.nBitLength, w = Jre(g, t.endo ? Math.ceil(b / 2) : b);
  return {
    CURVE: t,
    ProjectivePoint: g,
    normPrivateKeyToScalar: l,
    weierstrassEquation: a,
    isWithinCurveOrder: u
  };
}
function ine(e) {
  const t = wH(e);
  return _2(t, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...t });
}
function ane(e) {
  const t = ine(e), { Fp: r, n } = t, o = r.BYTES + 1, i = 2 * r.BYTES + 1;
  function a(ne) {
    return oa(ne, n);
  }
  function u(ne) {
    return TI(ne, n);
  }
  const { ProjectivePoint: l, normPrivateKeyToScalar: d, weierstrassEquation: f, isWithinCurveOrder: h } = one({
    ...t,
    toBytes(ne, D, K) {
      const le = D.toAffine(), re = r.toBytes(le.x), G = mw;
      return R1("isCompressed", K), K ? G(Uint8Array.from([D.hasEvenY() ? 2 : 3]), re) : G(Uint8Array.from([4]), re, r.toBytes(le.y));
    },
    fromBytes(ne) {
      const D = ne.length, K = ne[0], le = ne.subarray(1);
      if (D === o && (K === 2 || K === 3)) {
        const re = Dp(le);
        if (!G5(re, Yo, r.ORDER))
          throw new Error("Point is not on curve");
        const G = f(re);
        let q;
        try {
          q = r.sqrt(G);
        } catch (se) {
          const J = se instanceof Error ? ": " + se.message : "";
          throw new Error("Point is not on curve" + J);
        }
        const Q = (q & Yo) === Yo;
        return (K & 1) === 1 !== Q && (q = r.neg(q)), { x: re, y: q };
      } else if (D === i && K === 4) {
        const re = r.fromBytes(le.subarray(0, r.BYTES)), G = r.fromBytes(le.subarray(r.BYTES, 2 * r.BYTES));
        return { x: re, y: G };
      } else {
        const re = o, G = i;
        throw new Error("invalid Point, expected length of " + re + ", or uncompressed " + G + ", got " + D);
      }
    }
  }), g = (ne) => z1(L1(ne, t.nByteLength));
  function b(ne) {
    const D = n >> Yo;
    return ne > D;
  }
  function w(ne) {
    return b(ne) ? a(-ne) : ne;
  }
  const E = (ne, D, K) => Dp(ne.slice(D, K));
  class _ {
    constructor(D, K, le) {
      this.r = D, this.s = K, this.recovery = le, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(D) {
      const K = t.nByteLength;
      return D = mu("compactSignature", D, K * 2), new _(E(D, 0, K), E(D, K, 2 * K));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(D) {
      const { r: K, s: le } = Vl.toSig(mu("DER", D));
      return new _(K, le);
    }
    assertValidity() {
      Kp("r", this.r, Yo, n), Kp("s", this.s, Yo, n);
    }
    addRecoveryBit(D) {
      return new _(this.r, this.s, D);
    }
    recoverPublicKey(D) {
      const { r: K, s: le, recovery: re } = this, G = A(mu("msgHash", D));
      if (re == null || ![0, 1, 2, 3].includes(re))
        throw new Error("recovery id invalid");
      const q = re === 2 || re === 3 ? K + t.n : K;
      if (q >= r.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const Q = re & 1 ? "03" : "02", se = l.fromHex(Q + g(q)), J = u(q), ye = a(-G * J), ve = a(le * J), Ee = l.BASE.multiplyAndAddUnsafe(se, ye, ve);
      if (!Ee)
        throw new Error("point at infinify");
      return Ee.assertValidity(), Ee;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return b(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new _(this.r, a(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return j1(this.toDERHex());
    }
    toDERHex() {
      return Vl.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return j1(this.toCompactHex());
    }
    toCompactHex() {
      return g(this.r) + g(this.s);
    }
  }
  const O = {
    isValidPrivateKey(ne) {
      try {
        return d(ne), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: d,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const ne = mH(t.n);
      return Zre(t.randomBytes(ne), t.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(ne = 8, D = l.BASE) {
      return D._setWindowSize(ne), D.multiply(BigInt(3)), D;
    }
  };
  function C(ne, D = !0) {
    return l.fromPrivateKey(ne).toRawBytes(D);
  }
  function I(ne) {
    const D = t0(ne), K = typeof ne == "string", le = (D || K) && ne.length;
    return D ? le === o || le === i : K ? le === 2 * o || le === 2 * i : ne instanceof l;
  }
  function S(ne, D, K = !0) {
    if (I(ne))
      throw new Error("first arg must be private key");
    if (!I(D))
      throw new Error("second arg must be public key");
    return l.fromHex(D).multiply(d(ne)).toRawBytes(K);
  }
  const T = t.bits2int || function(ne) {
    if (ne.length > 8192)
      throw new Error("input is too large");
    const D = Dp(ne), K = ne.length * 8 - t.nBitLength;
    return K > 0 ? D >> BigInt(K) : D;
  }, A = t.bits2int_modN || function(ne) {
    return a(T(ne));
  }, $ = QP(t.nBitLength);
  function U(ne) {
    return Kp("num < 2^" + t.nBitLength, ne, Zl, $), L1(ne, t.nByteLength);
  }
  function M(ne, D, K = Y) {
    if (["recovered", "canonical"].some((we) => we in K))
      throw new Error("sign() legacy options not supported");
    const { hash: le, randomBytes: re } = t;
    let { lowS: G, prehash: q, extraEntropy: Q } = K;
    G == null && (G = !0), ne = mu("msgHash", ne), G$(K), q && (ne = mu("prehashed msgHash", le(ne)));
    const se = A(ne), J = d(D), ye = [U(J), U(se)];
    if (Q != null && Q !== !1) {
      const we = Q === !0 ? re(r.BYTES) : Q;
      ye.push(mu("extraEntropy", we));
    }
    const ve = mw(...ye), Ee = se;
    function _e(we) {
      const be = T(we);
      if (!h(be))
        return;
      const Ge = u(be), Le = l.BASE.multiply(be).toAffine(), Ne = a(Le.x);
      if (Ne === Zl)
        return;
      const Ve = a(Ge * a(Ee + Ne * J));
      if (Ve === Zl)
        return;
      let ge = (Le.x === Ne ? 0 : 2) | Number(Le.y & Yo), Te = Ve;
      return G && b(Ve) && (Te = w(Ve), ge ^= 1), new _(Ne, Te, ge);
    }
    return { seed: ve, k2sig: _e };
  }
  const Y = { lowS: t.lowS, prehash: !1 }, L = { lowS: t.lowS, prehash: !1 };
  function ee(ne, D, K = Y) {
    const { seed: le, k2sig: re } = M(ne, D, K), G = t;
    return hH(G.hash.outputLen, G.nByteLength, G.hmac)(le, re);
  }
  l.BASE._setWindowSize(8);
  function de(ne, D, K, le = L) {
    var re;
    const G = ne;
    D = mu("msgHash", D), K = mu("publicKey", K);
    const { lowS: q, prehash: Q, format: se } = le;
    if (G$(le), "strict" in le)
      throw new Error("options.strict was renamed to lowS");
    if (se !== void 0 && se !== "compact" && se !== "der")
      throw new Error("format must be compact or der");
    const J = typeof G == "string" || t0(G), ye = !J && !se && typeof G == "object" && G !== null && typeof G.r == "bigint" && typeof G.s == "bigint";
    if (!J && !ye)
      throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
    let ve, Ee;
    try {
      if (ye && (ve = new _(G.r, G.s)), J) {
        try {
          se !== "compact" && (ve = _.fromDER(G));
        } catch (ge) {
          if (!(ge instanceof Vl.Err))
            throw ge;
        }
        !ve && se !== "der" && (ve = _.fromCompact(G));
      }
      Ee = l.fromHex(K);
    } catch {
      return !1;
    }
    if (!ve || q && ve.hasHighS())
      return !1;
    Q && (D = t.hash(D));
    const { r: _e, s: we } = ve, be = A(D), Ge = u(we), Le = a(be * Ge), Ne = a(_e * Ge), Ve = (re = l.BASE.multiplyAndAddUnsafe(Ee, Le, Ne)) == null ? void 0 : re.toAffine();
    return Ve ? a(Ve.x) === _e : !1;
  }
  return {
    CURVE: t,
    getPublicKey: C,
    getSharedSecret: S,
    sign: ee,
    verify: de,
    ProjectivePoint: l,
    Signature: _,
    utils: O
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function sne(e) {
  return {
    hash: e,
    hmac: (t, ...r) => v2.hmac(e, t, Ds.concatBytes(...r)),
    randomBytes: Ds.randomBytes
  };
}
function une(e, t) {
  const r = (n) => ane({ ...e, ...sne(n) });
  return { ...r(t), create: r };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const vH = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), Z$ = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), cne = BigInt(1), II = BigInt(2), X$ = (e, t) => (e + t / II) / t;
function lne(e) {
  const t = vH, r = BigInt(3), n = BigInt(6), o = BigInt(11), i = BigInt(22), a = BigInt(23), u = BigInt(44), l = BigInt(88), d = e * e * e % t, f = d * d * e % t, h = _s(f, r, t) * f % t, g = _s(h, r, t) * f % t, b = _s(g, II, t) * d % t, w = _s(b, o, t) * b % t, E = _s(w, i, t) * w % t, _ = _s(E, u, t) * E % t, O = _s(_, l, t) * _ % t, C = _s(O, u, t) * E % t, I = _s(C, r, t) * f % t, S = _s(I, a, t) * w % t, T = _s(S, n, t) * d % t, A = _s(T, II, t);
  if (!OI.eql(OI.sqr(A), e))
    throw new Error("Cannot find square root");
  return A;
}
const OI = eC(vH, void 0, void 0, { sqrt: lne }), yw = une({
  a: BigInt(0),
  // equation params: a, b
  b: BigInt(7),
  Fp: OI,
  // Field's prime: 2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n
  n: Z$,
  // Curve order, total count of valid points in the field
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  // Cofactor
  lowS: !0,
  // Allow only low-S signatures by default in sign() and verify()
  endo: {
    // Endomorphism, see above
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (e) => {
      const t = Z$, r = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), n = -cne * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), o = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), i = r, a = BigInt("0x100000000000000000000000000000000"), u = X$(i * e, t), l = X$(-n * e, t);
      let d = oa(e - u * r - l * o, t), f = oa(-u * n - l * i, t);
      const h = d > a, g = f > a;
      if (h && (d = t - d), g && (f = t - f), d > a || f > a)
        throw new Error("splitScalar: Endomorphism failed, k=" + e);
      return { k1neg: h, k1: d, k2neg: g, k2: f };
    }
  }
}, fH);
BigInt(0);
function fne(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function Y$(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function dne(e, t) {
  fne(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error(`digestInto() expects output buffer of length at least ${r}`);
}
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const hne = (e) => e instanceof Uint8Array, RS = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), tc = (e, t) => e << 32 - t | e >>> t, pne = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!pne)
  throw new Error("Non little-endian hardware is not supported");
function gne(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function EH(e) {
  if (typeof e == "string" && (e = gne(e)), !hne(e))
    throw new Error(`expected Uint8Array, got ${typeof e}`);
  return e;
}
let mne = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function yne(e) {
  const t = (n) => e().update(EH(n)).digest(), r = e();
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = () => e(), t;
}
function bne(e, t, r, n) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, r, n);
  const o = BigInt(32), i = BigInt(4294967295), a = Number(r >> o & i), u = Number(r & i), l = n ? 4 : 0, d = n ? 0 : 4;
  e.setUint32(t + l, a, n), e.setUint32(t + d, u, n);
}
let wne = class extends mne {
  constructor(t, r, n, o) {
    super(), this.blockLen = t, this.outputLen = r, this.padOffset = n, this.isLE = o, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = RS(this.buffer);
  }
  update(t) {
    Y$(this);
    const { view: r, buffer: n, blockLen: o } = this;
    t = EH(t);
    const i = t.length;
    for (let a = 0; a < i; ) {
      const u = Math.min(o - this.pos, i - a);
      if (u === o) {
        const l = RS(t);
        for (; o <= i - a; a += o)
          this.process(l, a);
        continue;
      }
      n.set(t.subarray(a, a + u), this.pos), this.pos += u, a += u, this.pos === o && (this.process(r, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    Y$(this), dne(t, this), this.finished = !0;
    const { buffer: r, view: n, blockLen: o, isLE: i } = this;
    let { pos: a } = this;
    r[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > o - a && (this.process(n, 0), a = 0);
    for (let h = a; h < o; h++)
      r[h] = 0;
    bne(n, o - 8, BigInt(this.length * 8), i), this.process(n, 0);
    const u = RS(t), l = this.outputLen;
    if (l % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const d = l / 4, f = this.get();
    if (d > f.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let h = 0; h < d; h++)
      u.setUint32(4 * h, f[h], i);
  }
  digest() {
    const { buffer: t, outputLen: r } = this;
    this.digestInto(t);
    const n = t.slice(0, r);
    return this.destroy(), n;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: r, buffer: n, length: o, finished: i, destroyed: a, pos: u } = this;
    return t.length = o, t.pos = u, t.finished = i, t.destroyed = a, o % r && t.buffer.set(n), t;
  }
};
const vne = (e, t, r) => e & t ^ ~e & r, Ene = (e, t, r) => e & t ^ e & r ^ t & r, _ne = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), Pf = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), Cf = /* @__PURE__ */ new Uint32Array(64);
let Ane = class extends wne {
  constructor() {
    super(64, 32, 8, !1), this.A = Pf[0] | 0, this.B = Pf[1] | 0, this.C = Pf[2] | 0, this.D = Pf[3] | 0, this.E = Pf[4] | 0, this.F = Pf[5] | 0, this.G = Pf[6] | 0, this.H = Pf[7] | 0;
  }
  get() {
    const { A: t, B: r, C: n, D: o, E: i, F: a, G: u, H: l } = this;
    return [t, r, n, o, i, a, u, l];
  }
  // prettier-ignore
  set(t, r, n, o, i, a, u, l) {
    this.A = t | 0, this.B = r | 0, this.C = n | 0, this.D = o | 0, this.E = i | 0, this.F = a | 0, this.G = u | 0, this.H = l | 0;
  }
  process(t, r) {
    for (let h = 0; h < 16; h++, r += 4)
      Cf[h] = t.getUint32(r, !1);
    for (let h = 16; h < 64; h++) {
      const g = Cf[h - 15], b = Cf[h - 2], w = tc(g, 7) ^ tc(g, 18) ^ g >>> 3, E = tc(b, 17) ^ tc(b, 19) ^ b >>> 10;
      Cf[h] = E + Cf[h - 7] + w + Cf[h - 16] | 0;
    }
    let { A: n, B: o, C: i, D: a, E: u, F: l, G: d, H: f } = this;
    for (let h = 0; h < 64; h++) {
      const g = tc(u, 6) ^ tc(u, 11) ^ tc(u, 25), b = f + g + vne(u, l, d) + _ne[h] + Cf[h] | 0, w = (tc(n, 2) ^ tc(n, 13) ^ tc(n, 22)) + Ene(n, o, i) | 0;
      f = d, d = l, l = u, u = a + b | 0, a = i, i = o, o = n, n = b + w | 0;
    }
    n = n + this.A | 0, o = o + this.B | 0, i = i + this.C | 0, a = a + this.D | 0, u = u + this.E | 0, l = l + this.F | 0, d = d + this.G | 0, f = f + this.H | 0, this.set(n, o, i, a, u, l, d, f);
  }
  roundClean() {
    Cf.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
};
const PI = /* @__PURE__ */ yne(() => new Ane());
/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// @__NO_SIDE_EFFECTS__
function A2(...e) {
  const t = (o, i) => (a) => o(i(a)), r = Array.from(e).reverse().reduce((o, i) => o ? t(o, i.encode) : i.encode, void 0), n = e.reduce((o, i) => o ? t(o, i.decode) : i.decode, void 0);
  return { encode: r, decode: n };
}
// @__NO_SIDE_EFFECTS__
function W5(e) {
  return {
    encode: (t) => {
      if (!Array.isArray(t) || t.length && typeof t[0] != "number")
        throw new Error("alphabet.encode input should be an array of numbers");
      return t.map((r) => {
        if (r < 0 || r >= e.length)
          throw new Error(`Digit index outside alphabet: ${r} (alphabet: ${e.length})`);
        return e[r];
      });
    },
    decode: (t) => {
      if (!Array.isArray(t) || t.length && typeof t[0] != "string")
        throw new Error("alphabet.decode input should be array of strings");
      return t.map((r) => {
        if (typeof r != "string")
          throw new Error(`alphabet.decode: not string element=${r}`);
        const n = e.indexOf(r);
        if (n === -1)
          throw new Error(`Unknown letter: "${r}". Allowed: ${e}`);
        return n;
      });
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Z5(e = "") {
  if (typeof e != "string")
    throw new Error("join separator should be string");
  return {
    encode: (t) => {
      if (!Array.isArray(t) || t.length && typeof t[0] != "string")
        throw new Error("join.encode input should be array of strings");
      for (let r of t)
        if (typeof r != "string")
          throw new Error(`join.encode: non-string input=${r}`);
      return t.join(e);
    },
    decode: (t) => {
      if (typeof t != "string")
        throw new Error("join.decode input should be string");
      return t.split(e);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function _H(e, t = "=") {
  if (typeof t != "string")
    throw new Error("padding chr should be string");
  return {
    encode(r) {
      if (!Array.isArray(r) || r.length && typeof r[0] != "string")
        throw new Error("padding.encode input should be array of strings");
      for (let n of r)
        if (typeof n != "string")
          throw new Error(`padding.encode: non-string input=${n}`);
      for (; r.length * e % 8; )
        r.push(t);
      return r;
    },
    decode(r) {
      if (!Array.isArray(r) || r.length && typeof r[0] != "string")
        throw new Error("padding.encode input should be array of strings");
      for (let o of r)
        if (typeof o != "string")
          throw new Error(`padding.decode: non-string input=${o}`);
      let n = r.length;
      if (n * e % 8)
        throw new Error("Invalid padding: string should have whole number of bytes");
      for (; n > 0 && r[n - 1] === t; n--)
        if (!((n - 1) * e % 8))
          throw new Error("Invalid padding: string has too much padding");
      return r.slice(0, n);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function J$(e, t, r) {
  if (t < 2)
    throw new Error(`convertRadix: wrong from=${t}, base cannot be less than 2`);
  if (r < 2)
    throw new Error(`convertRadix: wrong to=${r}, base cannot be less than 2`);
  if (!Array.isArray(e))
    throw new Error("convertRadix: data should be array");
  if (!e.length)
    return [];
  let n = 0;
  const o = [], i = Array.from(e);
  for (i.forEach((a) => {
    if (a < 0 || a >= t)
      throw new Error(`Wrong integer: ${a}`);
  }); ; ) {
    let a = 0, u = !0;
    for (let l = n; l < i.length; l++) {
      const d = i[l], f = t * a + d;
      if (!Number.isSafeInteger(f) || t * a / t !== a || f - d !== t * a)
        throw new Error("convertRadix: carry overflow");
      a = f % r;
      const h = Math.floor(f / r);
      if (i[l] = h, !Number.isSafeInteger(h) || h * r + a !== f)
        throw new Error("convertRadix: carry overflow");
      if (u)
        h ? u = !1 : n = l;
      else continue;
    }
    if (o.push(a), u)
      break;
  }
  for (let a = 0; a < e.length - 1 && e[a] === 0; a++)
    o.push(0);
  return o.reverse();
}
const AH = /* @__NO_SIDE_EFFECTS__ */ (e, t) => t ? /* @__PURE__ */ AH(t, e % t) : e, f3 = /* @__NO_SIDE_EFFECTS__ */ (e, t) => e + (t - /* @__PURE__ */ AH(e, t));
// @__NO_SIDE_EFFECTS__
function CI(e, t, r, n) {
  if (!Array.isArray(e))
    throw new Error("convertRadix2: data should be array");
  if (t <= 0 || t > 32)
    throw new Error(`convertRadix2: wrong from=${t}`);
  if (r <= 0 || r > 32)
    throw new Error(`convertRadix2: wrong to=${r}`);
  if (/* @__PURE__ */ f3(t, r) > 32)
    throw new Error(`convertRadix2: carry overflow from=${t} to=${r} carryBits=${/* @__PURE__ */ f3(t, r)}`);
  let o = 0, i = 0;
  const a = 2 ** r - 1, u = [];
  for (const l of e) {
    if (l >= 2 ** t)
      throw new Error(`convertRadix2: invalid data word=${l} from=${t}`);
    if (o = o << t | l, i + t > 32)
      throw new Error(`convertRadix2: carry overflow pos=${i} from=${t}`);
    for (i += t; i >= r; i -= r)
      u.push((o >> i - r & a) >>> 0);
    o &= 2 ** i - 1;
  }
  if (o = o << r - i & a, !n && i >= t)
    throw new Error("Excess padding");
  if (!n && o)
    throw new Error(`Non-zero padding: ${o}`);
  return n && i > 0 && u.push(o >>> 0), u;
}
// @__NO_SIDE_EFFECTS__
function xne(e) {
  return {
    encode: (t) => {
      if (!(t instanceof Uint8Array))
        throw new Error("radix.encode input should be Uint8Array");
      return /* @__PURE__ */ J$(Array.from(t), 2 ** 8, e);
    },
    decode: (t) => {
      if (!Array.isArray(t) || t.length && typeof t[0] != "number")
        throw new Error("radix.decode input should be array of strings");
      return Uint8Array.from(/* @__PURE__ */ J$(t, e, 2 ** 8));
    }
  };
}
// @__NO_SIDE_EFFECTS__
function tC(e, t = !1) {
  if (e <= 0 || e > 32)
    throw new Error("radix2: bits should be in (0..32]");
  if (/* @__PURE__ */ f3(8, e) > 32 || /* @__PURE__ */ f3(e, 8) > 32)
    throw new Error("radix2: carry overflow");
  return {
    encode: (r) => {
      if (!(r instanceof Uint8Array))
        throw new Error("radix2.encode input should be Uint8Array");
      return /* @__PURE__ */ CI(Array.from(r), 8, e, !t);
    },
    decode: (r) => {
      if (!Array.isArray(r) || r.length && typeof r[0] != "number")
        throw new Error("radix2.decode input should be array of strings");
      return Uint8Array.from(/* @__PURE__ */ CI(r, e, 8, t));
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Q$(e) {
  if (typeof e != "function")
    throw new Error("unsafeWrapper fn should be function");
  return function(...t) {
    try {
      return e.apply(null, t);
    } catch {
    }
  };
}
// @__NO_SIDE_EFFECTS__
function kne(e, t) {
  if (typeof t != "function")
    throw new Error("checksum fn should be function");
  return {
    encode(r) {
      if (!(r instanceof Uint8Array))
        throw new Error("checksum.encode: input should be Uint8Array");
      const n = t(r).slice(0, e), o = new Uint8Array(r.length + e);
      return o.set(r), o.set(n, r.length), o;
    },
    decode(r) {
      if (!(r instanceof Uint8Array))
        throw new Error("checksum.decode: input should be Uint8Array");
      const n = r.slice(0, -4), o = t(n).slice(0, e), i = r.slice(-4);
      for (let a = 0; a < e; a++)
        if (o[a] !== i[a])
          throw new Error("Invalid checksum");
      return n;
    }
  };
}
const eU = /* @__PURE__ */ A2(/* @__PURE__ */ tC(6), /* @__PURE__ */ W5("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), /* @__PURE__ */ _H(6), /* @__PURE__ */ Z5("")), tU = /* @__PURE__ */ A2(/* @__PURE__ */ tC(6), /* @__PURE__ */ W5("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), /* @__PURE__ */ _H(6), /* @__PURE__ */ Z5("")), Sne = (e) => /* @__PURE__ */ A2(/* @__PURE__ */ xne(58), /* @__PURE__ */ W5(e), /* @__PURE__ */ Z5("")), Tne = /* @__PURE__ */ Sne("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), rU = (e) => /* @__PURE__ */ A2(/* @__PURE__ */ kne(4, (t) => e(e(t))), Tne), BI = /* @__PURE__ */ A2(/* @__PURE__ */ W5("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), /* @__PURE__ */ Z5("")), nU = [996825010, 642813549, 513874426, 1027748829, 705979059];
// @__NO_SIDE_EFFECTS__
function Sb(e) {
  const t = e >> 25;
  let r = (e & 33554431) << 5;
  for (let n = 0; n < nU.length; n++)
    (t >> n & 1) === 1 && (r ^= nU[n]);
  return r;
}
// @__NO_SIDE_EFFECTS__
function oU(e, t, r = 1) {
  const n = e.length;
  let o = 1;
  for (let i = 0; i < n; i++) {
    const a = e.charCodeAt(i);
    if (a < 33 || a > 126)
      throw new Error(`Invalid prefix (${e})`);
    o = /* @__PURE__ */ Sb(o) ^ a >> 5;
  }
  o = /* @__PURE__ */ Sb(o);
  for (let i = 0; i < n; i++)
    o = /* @__PURE__ */ Sb(o) ^ e.charCodeAt(i) & 31;
  for (let i of t)
    o = /* @__PURE__ */ Sb(o) ^ i;
  for (let i = 0; i < 6; i++)
    o = /* @__PURE__ */ Sb(o);
  return o ^= r, BI.encode(/* @__PURE__ */ CI([o % 2 ** 30], 30, 5, !1));
}
// @__NO_SIDE_EFFECTS__
function xH(e) {
  const t = e === "bech32" ? 1 : 734539939, r = /* @__PURE__ */ tC(5), n = r.decode, o = r.encode, i = /* @__PURE__ */ Q$(n);
  function a(f, h, g = 90) {
    if (typeof f != "string")
      throw new Error(`bech32.encode prefix should be string, not ${typeof f}`);
    if (!Array.isArray(h) || h.length && typeof h[0] != "number")
      throw new Error(`bech32.encode words should be array of numbers, not ${typeof h}`);
    const b = f.length + 7 + h.length;
    if (g !== !1 && b > g)
      throw new TypeError(`Length ${b} exceeds limit ${g}`);
    const w = f.toLowerCase(), E = /* @__PURE__ */ oU(w, h, t);
    return `${w}1${BI.encode(h)}${E}`;
  }
  function u(f, h = 90) {
    if (typeof f != "string")
      throw new Error(`bech32.decode input should be string, not ${typeof f}`);
    if (f.length < 8 || h !== !1 && f.length > h)
      throw new TypeError(`Wrong string length: ${f.length} (${f}). Expected (8..${h})`);
    const g = f.toLowerCase();
    if (f !== g && f !== f.toUpperCase())
      throw new Error("String must be lowercase or uppercase");
    f = g;
    const b = f.lastIndexOf("1");
    if (b === 0 || b === -1)
      throw new Error('Letter "1" must be present between prefix and data only');
    const w = f.slice(0, b), E = f.slice(b + 1);
    if (E.length < 6)
      throw new Error("Data must be at least 6 characters long");
    const _ = BI.decode(E).slice(0, -6), O = /* @__PURE__ */ oU(w, _, t);
    if (!E.endsWith(O))
      throw new Error(`Invalid checksum in ${f}: expected "${O}"`);
    return { prefix: w, words: _ };
  }
  const l = /* @__PURE__ */ Q$(u);
  function d(f) {
    const { prefix: h, words: g } = u(f, !1);
    return { prefix: h, words: g, bytes: n(g) };
  }
  return { encode: a, decode: u, decodeToBytes: d, decodeUnsafe: l, fromWords: n, fromWordsUnsafe: i, toWords: o };
}
const Uv = /* @__PURE__ */ xH("bech32"), Rv = /* @__PURE__ */ xH("bech32m"), vc = {
  b58chk: {
    encode: (e) => rU(PI).encode(e),
    decode: (e) => rU(PI).decode(e)
  },
  base64: {
    encode: (e) => eU.encode(e),
    decode: (e) => eU.decode(e)
  },
  b64url: {
    encode: (e) => tU.encode(e),
    decode: (e) => tU.decode(e)
  },
  bech32: {
    to_words: Uv.toWords,
    to_bytes: Uv.fromWords,
    encode: (e, t, r = !1) => Uv.encode(e, t, r),
    decode: (e, t = !1) => {
      const { prefix: r, words: n } = Uv.decode(e, t);
      return { prefix: r, words: n };
    }
  },
  bech32m: {
    to_words: Rv.toWords,
    to_bytes: Rv.fromWords,
    encode: (e, t, r = !1) => Rv.encode(e, t, r),
    decode: (e, t = !1) => {
      const { prefix: r, words: n } = Rv.decode(e, t);
      return { prefix: r, words: n };
    }
  }
};
function Ine(e, t) {
  if (e.length > t)
    throw new TypeError(`Data is larger than array size: ${e.length} > ${t}`);
}
function One(e) {
  if (e.match(/[^a-fA-f0-9]/) !== null)
    throw new TypeError("Invalid characters in hex string: " + e);
  if (e.length % 2 !== 0)
    throw new Error(`Length of hex string is invalid: ${e.length}`);
}
function Pne(e) {
  if (e > Number.MAX_SAFE_INTEGER)
    throw new TypeError("Number exceeds safe bounds!");
}
function kH(e, t) {
  if (e !== t)
    throw new TypeError(`Bech32 prefix does not match: ${e} !== ${t}`);
}
const Cne = BigInt(0), Bne = BigInt(255), SH = BigInt(256);
function Nne(e) {
  if (e <= 0xffn)
    return 1;
  if (e <= 0xffffn)
    return 2;
  if (e <= 0xffffffffn)
    return 4;
  if (e <= 0xffffffffffffffffn)
    return 8;
  if (e <= 0xffffffffffffffffffffffffffffffffn)
    return 16;
  if (e <= 0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffn)
    return 32;
  throw new TypeError("Must specify a fixed buffer size for bigints greater than 32 bytes.");
}
function $ne(e, t, r = "be") {
  t === void 0 && (t = Nne(e));
  const n = r === "le", o = new ArrayBuffer(t), i = new DataView(o);
  let a = n ? 0 : t - 1;
  for (; e > Cne; ) {
    const u = e & Bne, l = Number(u);
    n ? i.setUint8(a++, l) : i.setUint8(a--, l), e = (e - u) / SH;
  }
  return new Uint8Array(o);
}
function Une(e) {
  let t = BigInt(0);
  for (let r = e.length - 1; r >= 0; r--)
    t = t * SH + BigInt(e[r]);
  return BigInt(t);
}
function Rne(e) {
  const t = e.split("").map(Number);
  if (t.length % 8 !== 0)
    throw new Error(`Binary array is invalid length: ${e.length}`);
  const r = new Uint8Array(t.length / 8);
  for (let n = 0, o = 0; n < t.length; n += 8, o++) {
    let i = 0;
    for (let a = 0; a < 8; a++)
      i |= t[n + a] << 7 - a;
    r[o] = i;
  }
  return r;
}
function zne(e) {
  const t = new Array(e.length * 8);
  let r = 0;
  for (const n of e) {
    if (n > 255)
      throw new Error(`Invalid byte value: ${n}. Byte values must be between 0 and 255.`);
    for (let o = 7; o >= 0; o--, r++)
      t[r] = n >> o & 1;
  }
  return t.join("");
}
function jne(e) {
  if (e <= 255)
    return 1;
  if (e <= 65535)
    return 2;
  if (e <= 4294967295)
    return 4;
  throw new TypeError("Numbers larger than 4 bytes must specify a fixed size!");
}
function Lne(e, t, r = "be") {
  t === void 0 && (t = jne(e));
  const n = r === "le", o = new ArrayBuffer(t), i = new DataView(o);
  let a = n ? 0 : t - 1;
  for (; e > 0; ) {
    const u = e & 255;
    n ? i.setUint8(a++, e) : i.setUint8(a--, e), e = (e - u) / 256;
  }
  return new Uint8Array(o);
}
function Hne(e) {
  let t = 0;
  for (let r = e.length - 1; r >= 0; r--)
    t = t * 256 + e[r], Pne(t);
  return t;
}
const Fne = new TextEncoder(), Mne = new TextDecoder();
function rC(e) {
  return Fne.encode(e);
}
function zS(e) {
  return Mne.decode(e);
}
function Dne(e, t) {
  One(e);
  const r = e.length / 2;
  if (t === void 0 && (t = r), r > t)
    throw new TypeError(`Hex string is larger than array size: ${r} > ${t}`);
  return t;
}
function Kne(e, t, r = "le") {
  t = Dne(e, t);
  const n = r === "le", o = new ArrayBuffer(t), i = new DataView(o);
  let a = n ? 0 : t - 1;
  for (let u = 0; u < e.length; u += 2) {
    const l = e.substring(u, u + 2), d = parseInt(l, 16);
    n ? i.setUint8(a++, d) : i.setUint8(a--, d);
  }
  return new Uint8Array(o);
}
function qne(e) {
  let t = "";
  for (let r = 0; r < e.length; r++)
    t += e[r].toString(16).padStart(2, "0");
  return t;
}
const { getRandomValues: Vne } = crypto ?? globalThis.crypto ?? window.crypto;
function Gne(e = 32) {
  if (typeof Vne == "function")
    return crypto.getRandomValues(new Uint8Array(e));
  throw new Error("Crypto module missing getRandomValues!");
}
function TH(e) {
  return e.match(/[^a-fA-f0-9]/) === null && e.length % 2 === 0;
}
function Wne(e) {
  return typeof e == "string" && TH(e) || typeof e == "number" || typeof e == "bigint" || e instanceof Uint8Array ? !0 : !!(Array.isArray(e) && e.every((t) => typeof t == "number"));
}
function Zne(e, t, r = "be") {
  t === void 0 && (t = e.length), Ine(e, t);
  const n = new Uint8Array(t).fill(0), o = r === "be" ? 0 : t - e.length;
  return n.set(e, o), n;
}
function IH(e) {
  let t, r = 0;
  const n = e.reduce((i, a) => i + a.length, 0), o = new Uint8Array(n);
  for (t = 0; t < e.length; t++) {
    const i = e[t];
    o.set(i, r), r += i.length;
  }
  return o;
}
function Xne(e, t) {
  return typeof t == "bigint" ? `${t}n` : t;
}
function Yne(e, t) {
  return typeof t == "string" && /n$/.test(t) ? BigInt(t.slice(0, -1)) : t;
}
function Jne(e, t, r) {
  const n = e.length, o = r / t;
  if (r % t !== 0)
    throw new TypeError(`Invalid parameters: ${r} % ${t} !== 0`);
  if (n !== r)
    throw new TypeError(`Invalid data stream: ${n} !== ${r}`);
  if (n % t !== 0)
    throw new TypeError(`Invalid data stream: ${n} % ${t} !== 0`);
  const i = new Array(o);
  for (let a = 0; a < o; a++) {
    const u = a * t;
    i[a] = e.subarray(u, u + t);
  }
  return i;
}
function nC(e, t, r) {
  if (e instanceof ArrayBuffer)
    return new Uint8Array(e);
  if (e instanceof Uint8Array)
    return Zne(e, t, r);
  if (Array.isArray(e)) {
    const n = e.map((o) => nC(o, t, r));
    return IH(n);
  } else {
    if (typeof e == "string")
      return Kne(e, t, r);
    if (typeof e == "bigint")
      return $ne(e, t, r);
    if (typeof e == "number")
      return Lne(e, t, r);
    if (typeof e == "boolean")
      return Uint8Array.of(e ? 1 : 0);
  }
  throw new TypeError("Unsupported format:" + typeof e);
}
var Yt;
let fn = (Yt = class extends Uint8Array {
  static random(e = 32) {
    const t = Gne(e);
    return new Yt(t, e);
  }
  static now(e = 4) {
    const t = Math.floor(Date.now() / 1e3);
    return new Yt(t, e);
  }
  constructor(e, t, r) {
    if (e instanceof Yt && t === void 0)
      return e;
    const n = nC(e, t, r);
    super(n);
  }
  get arr() {
    return [...this];
  }
  get num() {
    return this.to_num();
  }
  get big() {
    return this.to_big();
  }
  get str() {
    return this.to_str();
  }
  get hex() {
    return this.to_hex();
  }
  get raw() {
    return new Uint8Array(this);
  }
  get bin() {
    return this.to_bin();
  }
  get b58chk() {
    return this.to_b58chk();
  }
  get base64() {
    return this.to_base64();
  }
  get b64url() {
    return this.to_b64url();
  }
  get digest() {
    return this.to_hash();
  }
  get id() {
    return this.to_hash().hex;
  }
  get stream() {
    return new doe(this);
  }
  to_num(e = "be") {
    const t = e === "be" ? this.reverse() : this;
    return Hne(t);
  }
  to_big(e = "be") {
    const t = e === "be" ? this.reverse() : this;
    return Une(t);
  }
  to_bin() {
    return zne(this);
  }
  to_hash() {
    const e = PI(this);
    return new Yt(e);
  }
  to_json(e) {
    e === void 0 && (e = Yne);
    const t = zS(this);
    return JSON.parse(t, e);
  }
  to_bech32(e, t) {
    const { encode: r, to_words: n } = vc.bech32, o = n(this);
    return r(e, o, t);
  }
  to_bech32m(e, t) {
    const { encode: r, to_words: n } = vc.bech32m, o = n(this);
    return r(e, o, t);
  }
  to_str() {
    return zS(this);
  }
  to_hex() {
    return qne(this);
  }
  to_bytes() {
    return new Uint8Array(this);
  }
  to_b58chk() {
    return vc.b58chk.encode(this);
  }
  to_base64() {
    return vc.base64.encode(this);
  }
  to_b64url() {
    return vc.b64url.encode(this);
  }
  append(e) {
    return Yt.join([this, Yt.bytes(e)]);
  }
  prepend(e) {
    return Yt.join([Yt.bytes(e), this]);
  }
  reverse() {
    const e = new Uint8Array(this).reverse();
    return new Yt(e);
  }
  slice(e, t) {
    const r = new Uint8Array(this).slice(e, t);
    return new Yt(r);
  }
  set(e, t) {
    this.set(e, t);
  }
  subarray(e, t) {
    const r = new Uint8Array(this).subarray(e, t);
    return new Yt(r);
  }
  write(e, t) {
    const r = Yt.bytes(e);
    this.set(r, t);
  }
  add_varint(e) {
    const t = Yt.calc_varint(this.length, e);
    return Yt.join([t, this]);
  }
  static from(e) {
    return new Yt(Uint8Array.from(e));
  }
  static of(...e) {
    return new Yt(Uint8Array.of(...e));
  }
  static join(e) {
    const t = e.map((n) => Yt.bytes(n)), r = IH(t);
    return new Yt(r);
  }
  static sort(e, t) {
    const r = e.map((n) => iU(n, t).hex);
    return r.sort(), r.map((n) => Yt.hex(n, t));
  }
  static calc_varint(e, t) {
    if (e < 253)
      return Yt.num(e, 1);
    if (e < 65536)
      return Yt.of(253, ...Yt.num(e, 2, t));
    if (e < 4294967296)
      return Yt.of(254, ...Yt.num(e, 4, t));
    if (BigInt(e) < 0x10000000000000000n)
      return Yt.of(255, ...Yt.num(e, 8, t));
    throw new Error(`Value is too large: ${e}`);
  }
}, Yt.num = Qne, Yt.big = toe, Yt.bin = eoe, Yt.raw = roe, Yt.str = noe, Yt.hex = ooe, Yt.bytes = iU, Yt.json = ioe, Yt.base64 = aoe, Yt.b64url = soe, Yt.bech32 = uoe, Yt.bech32m = coe, Yt.b58chk = loe, Yt.encode = rC, Yt.decode = zS, Yt.parse = foe, Yt.is_bytes = Wne, Yt.is_hex = TH, Yt);
function Qne(e, t, r) {
  return new fn(e, t, r);
}
function eoe(e, t, r) {
  return new fn(Rne(e), t, r);
}
function toe(e, t, r) {
  return new fn(e, t, r);
}
function roe(e, t, r) {
  return new fn(e, t, r);
}
function noe(e, t, r) {
  return new fn(rC(e), t, r);
}
function ooe(e, t, r) {
  return new fn(e, t, r);
}
function ioe(e, t) {
  t === void 0 && (t = Xne);
  const r = JSON.stringify(e, t);
  return new fn(rC(r));
}
function aoe(e) {
  return new fn(vc.base64.decode(e));
}
function soe(e) {
  return new fn(vc.b64url.decode(e));
}
function uoe(e, t, r) {
  const { decode: n, to_bytes: o } = vc.bech32, { prefix: i, words: a } = n(e, t), u = o(a);
  return typeof r == "string" && kH(i, r), new fn(u);
}
function coe(e, t, r) {
  const { decode: n, to_bytes: o } = vc.bech32m, { prefix: i, words: a } = n(e, t), u = o(a);
  return typeof r == "string" && kH(i, r), new fn(u);
}
function loe(e) {
  return new fn(vc.b58chk.decode(e));
}
function foe(e, t, r) {
  const n = nC(e);
  return Jne(n, t, r).map((o) => fn.bytes(o));
}
let doe = class {
  constructor(t) {
    this.data = fn.bytes(t), this.size = this.data.length;
  }
  peek(t) {
    if (t > this.size)
      throw new Error(`Size greater than stream: ${t} > ${this.size}`);
    return new fn(this.data.slice(0, t));
  }
  read(t) {
    const r = this.peek(t);
    return this.data = this.data.slice(t), this.size = this.data.length, r;
  }
  read_varint(t) {
    const r = this.read(1).num;
    switch (!0) {
      case (r >= 0 && r < 253):
        return r;
      case r === 253:
        return this.read(2).to_num(t);
      case r === 254:
        return this.read(4).to_num(t);
      case r === 255:
        return this.read(8).to_num(t);
      default:
        throw new Error(`Varint is out of range: ${r}`);
    }
  }
};
function iU(e, t, r) {
  return new fn(e, t, r);
}
const d3 = yw.CURVE, X5 = d3.n, hoe = d3.p, aU = { x: d3.Gx, y: d3.Gy }, poe = BigInt(0);
BigInt(1);
BigInt(2);
BigInt(3);
BigInt(4);
const goe = (e) => oa(e, X5);
function OH(e, t = !1) {
  if (!t)
    return !1;
  throw new Error(e);
}
function moe(e, t, r) {
  const n = fn.bytes(e);
  return n.length !== t ? OH(`Invalid byte size: ${n.hex} !== ${t}`, r) : !0;
}
function yoe(e, t) {
  return typeof e == "bigint" && poe < e && e < X5 || OH("x value is not in the field!", t), !0;
}
const boe = eC(X5, 32, !0), sU = yw.ProjectivePoint, Tb = boe;
var Xn;
let H1 = (Xn = class extends Uint8Array {
  static add(e) {
    return e.map((t) => Xn.mod(t)).reduce((t, r) => t.add(r));
  }
  static mod(e) {
    return new Xn(e);
  }
  static mul(e) {
    return e.map((t) => Xn.mod(t)).reduce((t, r) => t.mul(r));
  }
  static is_valid(e, t) {
    const r = fn.bytes(e, 32).big;
    return yoe(r, t);
  }
  constructor(e) {
    const t = goe(woe(e));
    Xn.is_valid(t, !0), super(fn.big(t, 32), 32);
  }
  get buff() {
    return new fn(this);
  }
  get raw() {
    return this.buff.raw;
  }
  get big() {
    return this.buff.big;
  }
  get hex() {
    return this.buff.hex;
  }
  get point() {
    return this.generate();
  }
  get hasOddY() {
    return this.point.hasOddY;
  }
  get negated() {
    return this.hasOddY ? this.negate() : this;
  }
  gt(e) {
    return new Xn(e).big > this.big;
  }
  lt(e) {
    return new Xn(e).big < this.big;
  }
  eq(e) {
    return new Xn(e).big === this.big;
  }
  ne(e) {
    return new Xn(e).big !== this.big;
  }
  add(e) {
    const t = Xn.mod(e), r = Tb.add(this.big, t.big);
    return new Xn(r);
  }
  sub(e) {
    const t = Xn.mod(e), r = Tb.sub(this.big, t.big);
    return new Xn(r);
  }
  mul(e) {
    const t = Xn.mod(e), r = Tb.mul(this.big, t.big);
    return new Xn(r);
  }
  pow(e) {
    const t = Xn.mod(e), r = Tb.pow(this.big, t.big);
    return new Xn(r);
  }
  div(e) {
    const t = Xn.mod(e), r = Tb.div(this.big, t.big);
    return new Xn(r);
  }
  negate() {
    return new Xn(Xn.N - this.big);
  }
  generate() {
    const e = yw.ProjectivePoint.BASE.multiply(this.big);
    return oC.import(e);
  }
}, Xn.N = X5, Xn);
var cn;
let oC = (cn = class {
  static from_x(e, t = !1) {
    let r = voe(e);
    r.length === 32 ? r = r.prepend(2) : t && (r[0] = 2), moe(r, 33);
    const n = sU.fromHex(r.hex);
    return n.assertValidity(), new cn(n.x, n.y);
  }
  static generate(e) {
    const t = H1.mod(e), r = cn.base.multiply(t.big);
    return cn.import(r);
  }
  static import(e) {
    const t = e instanceof cn ? { x: e.x.big, y: e.y.big } : { x: e.x, y: e.y };
    return new cn(t.x, t.y);
  }
  constructor(e, t) {
    this._p = new sU(e, t, 1n), this.p.assertValidity();
  }
  get p() {
    return this._p;
  }
  get x() {
    return fn.big(this.p.x, 32);
  }
  get y() {
    return fn.big(this.p.y, 32);
  }
  get buff() {
    return fn.raw(this.p.toRawBytes(!0));
  }
  get raw() {
    return this.buff.raw;
  }
  get hex() {
    return this.buff.hex;
  }
  get hasEvenY() {
    return this.p.hasEvenY();
  }
  get hasOddY() {
    return !this.p.hasEvenY();
  }
  get negated() {
    return this.hasOddY ? this.negate() : this;
  }
  eq(e) {
    const t = e instanceof cn ? e : cn.from_x(e);
    return this.x.big === t.x.big && this.y.big === t.y.big;
  }
  add(e) {
    return e instanceof cn ? cn.import(this.p.add(e.p)) : cn.import(this.p.add(cn.generate(e).p));
  }
  sub(e) {
    return e instanceof cn ? cn.import(this.p.subtract(e.p)) : cn.import(this.p.subtract(cn.generate(e).p));
  }
  mul(e) {
    return e instanceof cn ? cn.import(this.p.multiply(e.x.big)) : cn.import(this.p.multiply(H1.mod(e).big));
  }
  negate() {
    return cn.import(this.p.negate());
  }
}, cn.P = hoe, cn.G = new cn(aU.x, aU.y), cn.curve = yw.CURVE, cn.base = yw.ProjectivePoint.BASE, cn.mul = cn.generate, cn);
function woe(e) {
  if (e instanceof H1)
    return e.big;
  if (e instanceof oC)
    return e.x.big;
  if (e instanceof Uint8Array)
    return fn.raw(e).big;
  if (typeof e == "string")
    return fn.hex(e).big;
  if (typeof e == "number")
    return fn.num(e).big;
  if (typeof e == "bigint")
    return BigInt(e);
  throw TypeError("Invalid input type:" + typeof e);
}
function voe(e) {
  if (e instanceof H1)
    return e.point.buff;
  if (e instanceof oC)
    return e.buff;
  if (e instanceof Uint8Array || typeof e == "string")
    return fn.bytes(e);
  if (typeof e == "number" || typeof e == "bigint")
    return fn.bytes(e, 32);
  throw new TypeError(`Unknown type: ${typeof e}`);
}
const zv = /* @__PURE__ */ BigInt(2 ** 32 - 1), NI = /* @__PURE__ */ BigInt(32);
function PH(e, t = !1) {
  return t ? { h: Number(e & zv), l: Number(e >> NI & zv) } : { h: Number(e >> NI & zv) | 0, l: Number(e & zv) | 0 };
}
function Eoe(e, t = !1) {
  let r = new Uint32Array(e.length), n = new Uint32Array(e.length);
  for (let o = 0; o < e.length; o++) {
    const { h: i, l: a } = PH(e[o], t);
    [r[o], n[o]] = [i, a];
  }
  return [r, n];
}
const _oe = (e, t) => BigInt(e >>> 0) << NI | BigInt(t >>> 0), Aoe = (e, t, r) => e >>> r, xoe = (e, t, r) => e << 32 - r | t >>> r, koe = (e, t, r) => e >>> r | t << 32 - r, Soe = (e, t, r) => e << 32 - r | t >>> r, Toe = (e, t, r) => e << 64 - r | t >>> r - 32, Ioe = (e, t, r) => e >>> r - 32 | t << 64 - r, Ooe = (e, t) => t, Poe = (e, t) => e, Coe = (e, t, r) => e << r | t >>> 32 - r, Boe = (e, t, r) => t << r | e >>> 32 - r, Noe = (e, t, r) => t << r - 32 | e >>> 64 - r, $oe = (e, t, r) => e << r - 32 | t >>> 64 - r;
function Uoe(e, t, r, n) {
  const o = (t >>> 0) + (n >>> 0);
  return { h: e + r + (o / 2 ** 32 | 0) | 0, l: o | 0 };
}
const Roe = (e, t, r) => (e >>> 0) + (t >>> 0) + (r >>> 0), zoe = (e, t, r, n) => t + r + n + (e / 2 ** 32 | 0) | 0, joe = (e, t, r, n) => (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0), Loe = (e, t, r, n, o) => t + r + n + o + (e / 2 ** 32 | 0) | 0, Hoe = (e, t, r, n, o) => (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0) + (o >>> 0), Foe = (e, t, r, n, o, i) => t + r + n + o + i + (e / 2 ** 32 | 0) | 0, _r = {
  fromBig: PH,
  split: Eoe,
  toBig: _oe,
  shrSH: Aoe,
  shrSL: xoe,
  rotrSH: koe,
  rotrSL: Soe,
  rotrBH: Toe,
  rotrBL: Ioe,
  rotr32H: Ooe,
  rotr32L: Poe,
  rotlSH: Coe,
  rotlSL: Boe,
  rotlBH: Noe,
  rotlBL: $oe,
  add: Uoe,
  add3L: Roe,
  add3H: zoe,
  add4L: joe,
  add4H: Loe,
  add5H: Foe,
  add5L: Hoe
}, [Moe, Doe] = _r.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((e) => BigInt(e))), Bf = /* @__PURE__ */ new Uint32Array(80), Nf = /* @__PURE__ */ new Uint32Array(80);
let Koe = class extends zP {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: t, Al: r, Bh: n, Bl: o, Ch: i, Cl: a, Dh: u, Dl: l, Eh: d, El: f, Fh: h, Fl: g, Gh: b, Gl: w, Hh: E, Hl: _ } = this;
    return [t, r, n, o, i, a, u, l, d, f, h, g, b, w, E, _];
  }
  // prettier-ignore
  set(t, r, n, o, i, a, u, l, d, f, h, g, b, w, E, _) {
    this.Ah = t | 0, this.Al = r | 0, this.Bh = n | 0, this.Bl = o | 0, this.Ch = i | 0, this.Cl = a | 0, this.Dh = u | 0, this.Dl = l | 0, this.Eh = d | 0, this.El = f | 0, this.Fh = h | 0, this.Fl = g | 0, this.Gh = b | 0, this.Gl = w | 0, this.Hh = E | 0, this.Hl = _ | 0;
  }
  process(t, r) {
    for (let I = 0; I < 16; I++, r += 4)
      Bf[I] = t.getUint32(r), Nf[I] = t.getUint32(r += 4);
    for (let I = 16; I < 80; I++) {
      const S = Bf[I - 15] | 0, T = Nf[I - 15] | 0, A = _r.rotrSH(S, T, 1) ^ _r.rotrSH(S, T, 8) ^ _r.shrSH(S, T, 7), $ = _r.rotrSL(S, T, 1) ^ _r.rotrSL(S, T, 8) ^ _r.shrSL(S, T, 7), U = Bf[I - 2] | 0, M = Nf[I - 2] | 0, Y = _r.rotrSH(U, M, 19) ^ _r.rotrBH(U, M, 61) ^ _r.shrSH(U, M, 6), L = _r.rotrSL(U, M, 19) ^ _r.rotrBL(U, M, 61) ^ _r.shrSL(U, M, 6), ee = _r.add4L($, L, Nf[I - 7], Nf[I - 16]), de = _r.add4H(ee, A, Y, Bf[I - 7], Bf[I - 16]);
      Bf[I] = de | 0, Nf[I] = ee | 0;
    }
    let { Ah: n, Al: o, Bh: i, Bl: a, Ch: u, Cl: l, Dh: d, Dl: f, Eh: h, El: g, Fh: b, Fl: w, Gh: E, Gl: _, Hh: O, Hl: C } = this;
    for (let I = 0; I < 80; I++) {
      const S = _r.rotrSH(h, g, 14) ^ _r.rotrSH(h, g, 18) ^ _r.rotrBH(h, g, 41), T = _r.rotrSL(h, g, 14) ^ _r.rotrSL(h, g, 18) ^ _r.rotrBL(h, g, 41), A = h & b ^ ~h & E, $ = g & w ^ ~g & _, U = _r.add5L(C, T, $, Doe[I], Nf[I]), M = _r.add5H(U, O, S, A, Moe[I], Bf[I]), Y = U | 0, L = _r.rotrSH(n, o, 28) ^ _r.rotrBH(n, o, 34) ^ _r.rotrBH(n, o, 39), ee = _r.rotrSL(n, o, 28) ^ _r.rotrBL(n, o, 34) ^ _r.rotrBL(n, o, 39), de = n & i ^ n & u ^ i & u, ne = o & a ^ o & l ^ a & l;
      O = E | 0, C = _ | 0, E = b | 0, _ = w | 0, b = h | 0, w = g | 0, { h, l: g } = _r.add(d | 0, f | 0, M | 0, Y | 0), d = u | 0, f = l | 0, u = i | 0, l = a | 0, i = n | 0, a = o | 0;
      const D = _r.add3L(Y, ee, ne);
      n = _r.add3H(D, M, L, de), o = D | 0;
    }
    ({ h: n, l: o } = _r.add(this.Ah | 0, this.Al | 0, n | 0, o | 0)), { h: i, l: a } = _r.add(this.Bh | 0, this.Bl | 0, i | 0, a | 0), { h: u, l } = _r.add(this.Ch | 0, this.Cl | 0, u | 0, l | 0), { h: d, l: f } = _r.add(this.Dh | 0, this.Dl | 0, d | 0, f | 0), { h, l: g } = _r.add(this.Eh | 0, this.El | 0, h | 0, g | 0), { h: b, l: w } = _r.add(this.Fh | 0, this.Fl | 0, b | 0, w | 0), { h: E, l: _ } = _r.add(this.Gh | 0, this.Gl | 0, E | 0, _ | 0), { h: O, l: C } = _r.add(this.Hh | 0, this.Hl | 0, O | 0, C | 0), this.set(n, o, i, a, u, l, d, f, h, g, b, w, E, _, O, C);
  }
  roundClean() {
    Bf.fill(0), Nf.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
};
const qoe = /* @__PURE__ */ RP(() => new Koe());
let CH = class extends wL {
  constructor(e, t) {
    super(), this.finished = !1, this.destroyed = !1, eQ(e);
    const r = UP(t);
    if (this.iHash = e.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const n = this.blockLen, o = new Uint8Array(n);
    o.set(r.length > n ? e.create().update(r).digest() : r);
    for (let i = 0; i < o.length; i++)
      o[i] ^= 54;
    this.iHash.update(o), this.oHash = e.create();
    for (let i = 0; i < o.length; i++)
      o[i] ^= 106;
    this.oHash.update(o), o.fill(0);
  }
  update(e) {
    return i3(this), this.iHash.update(e), this;
  }
  digestInto(e) {
    i3(this), $P(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
  }
  digest() {
    const e = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(e), e;
  }
  _cloneInto(e) {
    e || (e = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: t, iHash: r, finished: n, destroyed: o, blockLen: i, outputLen: a } = this;
    return e = e, e.finished = n, e.destroyed = o, e.blockLen = i, e.outputLen = a, e.oHash = t._cloneInto(e.oHash), e.iHash = r._cloneInto(e.iHash), e;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
};
const BH = (e, t, r) => new CH(e, t).update(r).digest();
BH.create = (e, t) => new CH(e, t);
function Voe(e, t = !1) {
  const r = H1.mod(e);
  return t ? r.negated.buff : r.buff;
}
function NH(e, t = !1) {
  const r = H1.mod(e).point;
  return t ? r.x : r.buff;
}
function $I(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function Goe(e) {
  if (typeof e != "boolean")
    throw new Error(`Expected boolean, not ${e}`);
}
function $H(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new TypeError(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function Woe(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  $I(e.outputLen), $I(e.blockLen);
}
function Zoe(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function Xoe(e, t) {
  $H(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error(`digestInto() expects output buffer of length at least ${r}`);
}
const Yoe = {
  number: $I,
  bool: Goe,
  bytes: $H,
  hash: Woe,
  exists: Zoe,
  output: Xoe
};
var jS = Yoe;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const LS = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), rc = (e, t) => e << 32 - t | e >>> t, Joe = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!Joe)
  throw new Error("Non little-endian hardware is not supported");
Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function Qoe(e) {
  if (typeof e != "string")
    throw new TypeError(`utf8ToBytes expected string, got ${typeof e}`);
  return new TextEncoder().encode(e);
}
function UH(e) {
  if (typeof e == "string" && (e = Qoe(e)), !(e instanceof Uint8Array))
    throw new TypeError(`Expected input type is Uint8Array (got ${typeof e})`);
  return e;
}
let eie = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function RH(e) {
  const t = (n) => e().update(UH(n)).digest(), r = e();
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = () => e(), t;
}
function tie(e, t, r, n) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, r, n);
  const o = BigInt(32), i = BigInt(4294967295), a = Number(r >> o & i), u = Number(r & i), l = n ? 4 : 0, d = n ? 0 : 4;
  e.setUint32(t + l, a, n), e.setUint32(t + d, u, n);
}
let rie = class extends eie {
  constructor(t, r, n, o) {
    super(), this.blockLen = t, this.outputLen = r, this.padOffset = n, this.isLE = o, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = LS(this.buffer);
  }
  update(t) {
    jS.exists(this);
    const { view: r, buffer: n, blockLen: o } = this;
    t = UH(t);
    const i = t.length;
    for (let a = 0; a < i; ) {
      const u = Math.min(o - this.pos, i - a);
      if (u === o) {
        const l = LS(t);
        for (; o <= i - a; a += o)
          this.process(l, a);
        continue;
      }
      n.set(t.subarray(a, a + u), this.pos), this.pos += u, a += u, this.pos === o && (this.process(r, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    jS.exists(this), jS.output(t, this), this.finished = !0;
    const { buffer: r, view: n, blockLen: o, isLE: i } = this;
    let { pos: a } = this;
    r[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > o - a && (this.process(n, 0), a = 0);
    for (let h = a; h < o; h++)
      r[h] = 0;
    tie(n, o - 8, BigInt(this.length * 8), i), this.process(n, 0);
    const u = LS(t), l = this.outputLen;
    if (l % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const d = l / 4, f = this.get();
    if (d > f.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let h = 0; h < d; h++)
      u.setUint32(4 * h, f[h], i);
  }
  digest() {
    const { buffer: t, outputLen: r } = this;
    this.digestInto(t);
    const n = t.slice(0, r);
    return this.destroy(), n;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: r, buffer: n, length: o, finished: i, destroyed: a, pos: u } = this;
    return t.length = o, t.pos = u, t.finished = i, t.destroyed = a, o % r && t.buffer.set(n), t;
  }
};
const nie = (e, t, r) => e & t ^ ~e & r, oie = (e, t, r) => e & t ^ e & r ^ t & r, iie = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), $f = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), Uf = new Uint32Array(64);
let zH = class extends rie {
  constructor() {
    super(64, 32, 8, !1), this.A = $f[0] | 0, this.B = $f[1] | 0, this.C = $f[2] | 0, this.D = $f[3] | 0, this.E = $f[4] | 0, this.F = $f[5] | 0, this.G = $f[6] | 0, this.H = $f[7] | 0;
  }
  get() {
    const { A: e, B: t, C: r, D: n, E: o, F: i, G: a, H: u } = this;
    return [e, t, r, n, o, i, a, u];
  }
  // prettier-ignore
  set(e, t, r, n, o, i, a, u) {
    this.A = e | 0, this.B = t | 0, this.C = r | 0, this.D = n | 0, this.E = o | 0, this.F = i | 0, this.G = a | 0, this.H = u | 0;
  }
  process(e, t) {
    for (let f = 0; f < 16; f++, t += 4)
      Uf[f] = e.getUint32(t, !1);
    for (let f = 16; f < 64; f++) {
      const h = Uf[f - 15], g = Uf[f - 2], b = rc(h, 7) ^ rc(h, 18) ^ h >>> 3, w = rc(g, 17) ^ rc(g, 19) ^ g >>> 10;
      Uf[f] = w + Uf[f - 7] + b + Uf[f - 16] | 0;
    }
    let { A: r, B: n, C: o, D: i, E: a, F: u, G: l, H: d } = this;
    for (let f = 0; f < 64; f++) {
      const h = rc(a, 6) ^ rc(a, 11) ^ rc(a, 25), g = d + h + nie(a, u, l) + iie[f] + Uf[f] | 0, b = (rc(r, 2) ^ rc(r, 13) ^ rc(r, 22)) + oie(r, n, o) | 0;
      d = l, l = u, u = a, a = i + g | 0, i = o, o = n, n = r, r = g + b | 0;
    }
    r = r + this.A | 0, n = n + this.B | 0, o = o + this.C | 0, i = i + this.D | 0, a = a + this.E | 0, u = u + this.F | 0, l = l + this.G | 0, d = d + this.H | 0, this.set(r, n, o, i, a, u, l, d);
  }
  roundClean() {
    Uf.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}, aie = class extends zH {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
};
const UI = RH(() => new zH());
RH(() => new aie());
function sie(e, t) {
  if (e.length > t)
    throw new TypeError(`Data is larger than array size: ${e.length} > ${t}`);
}
function uie(e) {
  if (e.match(/[^a-fA-f0-9]/) !== null)
    throw new TypeError("Invalid characters in hex string: " + e);
  if (e.length % 2 !== 0)
    throw new Error(`Length of hex string is invalid: ${e.length}`);
}
function cie(e) {
  if (e > Number.MAX_SAFE_INTEGER)
    throw new TypeError("Number exceeds safe bounds!");
}
const { getRandomValues: lie } = crypto ?? globalThis.crypto ?? window.crypto;
function fie(e = 32) {
  if (typeof lie == "function")
    return crypto.getRandomValues(new Uint8Array(e));
  throw new Error("Crypto module missing getRandomValues!");
}
function die(e, t, r = "be") {
  t === void 0 && (t = e.length), sie(e, t);
  const n = new Uint8Array(t).fill(0), o = r === "be" ? 0 : t - e.length;
  return n.set(e, o), n;
}
function jH(e) {
  let t, r = 0;
  const n = e.reduce((i, a) => i + a.length, 0), o = new Uint8Array(n);
  for (t = 0; t < e.length; t++) {
    const i = e[t];
    o.set(i, r), r += i.length;
  }
  return o;
}
const hie = new TextEncoder(), pie = [
  {
    name: "base58",
    charset: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
  }
];
function LH(e) {
  for (const t of pie)
    if (t.name === e)
      return t.charset;
  throw TypeError("Charset does not exist: " + e);
}
function gie(e, t, r = !1) {
  typeof e == "string" && (e = hie.encode(e));
  const n = LH(t), o = n.length, i = [];
  let a = "", u, l = 0, d, f;
  for (u = 0; u < e.length; u++)
    for (l = 0, d = e[u], a += d > 0 || (a.length ^ u) > 0 ? "" : "1"; l in i || d > 0; )
      f = i[l], f = f > 0 ? f * 256 + d : d, d = f / o | 0, i[l] = f % o, l++;
  for (; l-- > 0; )
    a += n[i[l]];
  return r && a.length % 4 > 0 ? a + "=".repeat(4 - a.length % 4) : a;
}
function mie(e, t) {
  const r = LH(t), n = r.length, o = [], i = [];
  e = e.replace("=", "");
  let a, u = 0, l, d;
  for (a = 0; a < e.length; a++) {
    if (u = 0, l = r.indexOf(e[a]), l < 0)
      throw new Error(`Character range out of bounds: ${l}`);
    for (l > 0 || (i.length ^ a) > 0 || i.push(0); u in o || l > 0; )
      d = o[u], d = d > 0 ? d * n + l : l, l = d >> 8, o[u] = d % 256, u++;
  }
  for (; u-- > 0; )
    i.push(o[u]);
  return new Uint8Array(i);
}
function HH(e) {
  return UI(UI(e));
}
function yie(e) {
  const t = HH(e);
  return jH([e, t.slice(0, 4)]);
}
function bie(e) {
  const t = e.slice(0, -4), r = e.slice(-4);
  if (HH(t).slice(0, 4).toString() !== r.toString())
    throw new Error("Invalid checksum!");
  return t;
}
const uU = {
  encode: gie,
  decode: mie
}, FH = {
  encode: (e) => {
    const t = yie(e);
    return uU.encode(t, "base58");
  },
  decode: (e) => {
    const t = uU.decode(e, "base58");
    return bie(t);
  }
}, MH = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", wie = [996825010, 642813549, 513874426, 1027748829, 705979059], h3 = [
  { version: 0, name: "bech32", const: 1 },
  { version: 1, name: "bech32m", const: 734539939 }
];
function DH(e) {
  let t = 1;
  for (let r = 0; r < e.length; ++r) {
    const n = t >> 25;
    t = (t & 33554431) << 5 ^ e[r];
    for (let o = 0; o < 5; ++o)
      n >> o & 1 && (t ^= wie[o]);
  }
  return t;
}
function KH(e) {
  const t = [];
  let r;
  for (r = 0; r < e.length; ++r)
    t.push(e.charCodeAt(r) >> 5);
  for (t.push(0), r = 0; r < e.length; ++r)
    t.push(e.charCodeAt(r) & 31);
  return t;
}
function vie(e, t, r) {
  const n = KH(e).concat(t);
  return DH(n) === r.const;
}
function Eie(e, t, r) {
  const n = KH(e).concat(t).concat([0, 0, 0, 0, 0, 0]), o = DH(n) ^ r.const, i = [];
  for (let a = 0; a < 6; ++a)
    i.push(o >> 5 * (5 - a) & 31);
  return i;
}
function qH(e, t, r, n = !0) {
  const o = [];
  let i = 0, a = 0;
  const u = (1 << r) - 1, l = (1 << t + r - 1) - 1;
  for (const d of e) {
    if (d < 0 || d >> t > 0)
      throw new Error("Failed to perform base conversion. Invalid value: " + String(d));
    for (i = (i << t | d) & l, a += t; a >= r; )
      a -= r, o.push(i >> a & u);
  }
  if (n)
    a > 0 && o.push(i << r - a & u);
  else if (a >= t || (i << r - a & u) > 0)
    throw new Error("Failed to perform base conversion. Invalid Size!");
  return o;
}
function _ie(e, t, r) {
  const n = t.concat(Eie(e, t, r));
  let o = e + "1";
  for (let i = 0; i < n.length; ++i)
    o += MH.charAt(n[i]);
  return o;
}
function VH(e) {
  if (!Aie(e))
    throw new Error("Encoded string goes out of bounds!");
  if (e = e.toLowerCase(), !xie(e))
    throw new Error("Encoded string has invalid separator!");
  const t = [], r = e.lastIndexOf("1"), n = e.substring(0, r);
  for (let i = r + 1; i < e.length; ++i) {
    const a = MH.indexOf(e.charAt(i));
    if (a === -1)
      throw new Error("Character idx out of bounds: " + String(i));
    t.push(a);
  }
  const o = h3.find((i) => i.version === t[0]) ?? h3[0];
  if (!vie(n, t, o))
    throw new Error("Checksum verification failed!");
  return [n, t.slice(0, t.length - 6)];
}
function Aie(e) {
  let t, r, n = !1, o = !1;
  for (t = 0; t < e.length; ++t) {
    if (r = e.charCodeAt(t), r < 33 || r > 126)
      return !1;
    r >= 97 && r <= 122 && (n = !0), r >= 65 && r <= 90 && (o = !0);
  }
  return !(n && o);
}
function xie(e) {
  const t = e.lastIndexOf("1");
  return !(t < 1 || t + 7 > e.length || e.length > 90);
}
function kie(e, t = "bc", r = 0) {
  const n = [r, ...qH([...e], 8, 5)], o = h3.find((a) => a.version === r) ?? h3[0], i = _ie(t, n, o);
  return GH(i), i;
}
function GH(e) {
  e = e.toLowerCase();
  const t = e.split("1", 1)[0], [r, n] = VH(e), o = qH(n.slice(1), 5, 8, !1), i = o.length;
  switch (!0) {
    case t !== r:
      throw new Error("Returned hrp string is invalid.");
    case (o === null || i < 2 || i > 40):
      throw new Error("Decoded string is invalid or out of spec.");
    case n[0] > 16:
      throw new Error("Returned version bit is out of range.");
    default:
      return Uint8Array.from(o);
  }
}
function Sie(e) {
  e = e.toLowerCase();
  const [t, r] = VH(e);
  return r[0];
}
const WH = {
  encode: kie,
  decode: GH,
  version: Sie
}, ZH = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", XH = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", Tie = new TextEncoder();
function YH(e, t = !1, r = !0) {
  typeof e == "string" && (e = Tie.encode(e));
  const n = t ? XH : ZH;
  let o = "", i = 0, a = 0;
  for (let u = 0; u < e.length; u++)
    for (a = a << 8 | e[u], i += 8; i >= 6; )
      i -= 6, o += n[a >> i & 63];
  if (i > 0)
    for (a <<= 6 - i, o += n[a & 63]; i < 6; )
      o += r ? "=" : "", i += 2;
  return o;
}
function JH(e, t = !1) {
  const r = t || e.includes("-") || e.includes("_") ? XH.split("") : ZH.split("");
  e = e.replace(/=+$/, "");
  const n = e.split("");
  let o = 0, i = 0;
  const a = [];
  for (let u = 0; u < n.length; u++) {
    const l = n[u], d = r.indexOf(l);
    if (d === -1)
      throw new Error("Invalid character: " + l);
    o += 6, i <<= 6, i |= d, o >= 8 && (o -= 8, a.push(i >>> o & 255));
  }
  return new Uint8Array(a);
}
const QH = {
  encode: YH,
  decode: JH
}, eF = {
  encode: (e) => YH(e, !0, !1),
  decode: (e) => JH(e, !0)
}, Iie = BigInt(0), Oie = BigInt(255), tF = BigInt(256);
function Pie(e) {
  if (e <= 0xffn)
    return 1;
  if (e <= 0xffffn)
    return 2;
  if (e <= 0xffffffffn)
    return 4;
  if (e <= 0xffffffffffffffffn)
    return 8;
  if (e <= 0xffffffffffffffffffffffffffffffffn)
    return 16;
  if (e <= 0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffn)
    return 32;
  throw new TypeError("Must specify a fixed buffer size for bigints greater than 32 bytes.");
}
function Cie(e, t, r = "be") {
  t === void 0 && (t = Pie(e));
  const n = r === "le", o = new ArrayBuffer(t), i = new DataView(o);
  let a = n ? 0 : t - 1;
  for (; e > Iie; ) {
    const u = e & Oie, l = Number(u);
    n ? i.setUint8(a++, l) : i.setUint8(a--, l), e = (e - u) / tF;
  }
  return new Uint8Array(o);
}
function Bie(e) {
  let t = BigInt(0);
  for (let r = e.length - 1; r >= 0; r--)
    t = t * tF + BigInt(e[r]);
  return BigInt(t);
}
function Nie(e) {
  const t = e.split("").map(Number);
  if (t.length % 8 !== 0)
    throw new Error(`Binary array is invalid length: ${e.length}`);
  const r = new Uint8Array(t.length / 8);
  for (let n = 0, o = 0; n < t.length; n += 8, o++) {
    let i = 0;
    for (let a = 0; a < 8; a++)
      i |= t[n + a] << 7 - a;
    r[o] = i;
  }
  return r;
}
function $ie(e) {
  const t = new Array(e.length * 8);
  let r = 0;
  for (const n of e) {
    if (n > 255)
      throw new Error(`Invalid byte value: ${n}. Byte values must be between 0 and 255.`);
    for (let o = 7; o >= 0; o--, r++)
      t[r] = n >> o & 1;
  }
  return t.join("");
}
function Uie(e) {
  if (e <= 255)
    return 1;
  if (e <= 65535)
    return 2;
  if (e <= 4294967295)
    return 4;
  throw new TypeError("Numbers larger than 4 bytes must specify a fixed size!");
}
function Rie(e, t, r = "be") {
  t === void 0 && (t = Uie(e));
  const n = r === "le", o = new ArrayBuffer(t), i = new DataView(o);
  let a = n ? 0 : t - 1;
  for (; e > 0; ) {
    const u = e & 255;
    n ? i.setUint8(a++, e) : i.setUint8(a--, e), e = (e - u) / 256;
  }
  return new Uint8Array(o);
}
function zie(e) {
  let t = 0;
  for (let r = e.length - 1; r >= 0; r--)
    t = t * 256 + e[r], cie(t);
  return t;
}
const jie = new TextEncoder(), Lie = new TextDecoder();
function iC(e) {
  return jie.encode(e);
}
function HS(e) {
  return Lie.decode(e);
}
function Hie(e, t) {
  uie(e);
  const r = e.length / 2;
  if (t === void 0 && (t = r), r > t)
    throw new TypeError(`Hex string is larger than array size: ${r} > ${t}`);
  return t;
}
function Fie(e, t, r = "le") {
  t = Hie(e, t);
  const n = r === "le", o = new ArrayBuffer(t), i = new DataView(o);
  let a = n ? 0 : t - 1;
  for (let u = 0; u < e.length; u += 2) {
    const l = e.substring(u, u + 2), d = parseInt(l, 16);
    n ? i.setUint8(a++, d) : i.setUint8(a--, d);
  }
  return new Uint8Array(o);
}
function Mie(e) {
  let t = "";
  for (let r = 0; r < e.length; r++)
    t += e[r].toString(16).padStart(2, "0");
  return t;
}
function Die(e) {
  const t = JSON.stringify(e, (r, n) => typeof n == "bigint" ? `${n}n` : n);
  return iC(t);
}
function Kie(e, t, r) {
  if (e instanceof ArrayBuffer)
    return new Uint8Array(e);
  if (e instanceof Uint8Array)
    return die(e, t, r);
  if (typeof e == "string")
    return Fie(e, t, r);
  if (typeof e == "bigint")
    return Cie(e, t, r);
  if (typeof e == "number")
    return Rie(e, t, r);
  if (typeof e == "boolean")
    return Uint8Array.of(e ? 1 : 0);
  throw TypeError("Unsupported format:" + typeof e);
}
var Pr;
let xe = (Pr = class extends Uint8Array {
  static random(e = 32) {
    const t = fie(e);
    return new Pr(t, e);
  }
  constructor(e, t, r) {
    const n = Kie(e, t, r);
    super(n);
  }
  get arr() {
    return [...this];
  }
  get num() {
    return this.toNum();
  }
  get big() {
    return this.toBig();
  }
  get str() {
    return this.toStr();
  }
  get hex() {
    return this.toHex();
  }
  get raw() {
    return new Uint8Array(this);
  }
  get bin() {
    return this.toBin();
  }
  get b58chk() {
    return this.tob58chk();
  }
  get base64() {
    return this.toBase64();
  }
  get b64url() {
    return this.toB64url();
  }
  get digest() {
    return this.toHash();
  }
  get id() {
    return this.toHash().hex;
  }
  get stream() {
    return new yg(this);
  }
  toNum(e = "be") {
    const t = e === "be" ? this.reverse() : this;
    return zie(t);
  }
  toBin() {
    return $ie(this);
  }
  toBig(e = "be") {
    const t = e === "be" ? this.reverse() : this;
    return Bie(t);
  }
  toHash() {
    const e = UI(this);
    return new Pr(e);
  }
  toJson() {
    const e = HS(this);
    return JSON.parse(e);
  }
  toBech32(e, t = 0) {
    return WH.encode(this, e, t);
  }
  toStr() {
    return HS(this);
  }
  toHex() {
    return Mie(this);
  }
  toBytes() {
    return new Uint8Array(this);
  }
  tob58chk() {
    return FH.encode(this);
  }
  toBase64() {
    return QH.encode(this);
  }
  toB64url() {
    return eF.encode(this);
  }
  prepend(e) {
    return Pr.join([Pr.bytes(e), this]);
  }
  append(e) {
    return Pr.join([this, Pr.bytes(e)]);
  }
  slice(e, t) {
    const r = new Uint8Array(this).slice(e, t);
    return new Pr(r);
  }
  subarray(e, t) {
    const r = new Uint8Array(this).subarray(e, t);
    return new Pr(r);
  }
  reverse() {
    const e = new Uint8Array(this).reverse();
    return new Pr(e);
  }
  write(e, t) {
    const r = Pr.bytes(e);
    this.set(r, t);
  }
  prefixSize(e) {
    const t = Pr.varInt(this.length, e);
    return Pr.join([t, this]);
  }
  static from(e) {
    return new Pr(Uint8Array.from(e));
  }
  static of(...e) {
    return new Pr(Uint8Array.of(...e));
  }
  static join(e) {
    const t = e.map((n) => Pr.bytes(n)), r = jH(t);
    return new Pr(r);
  }
  static varInt(e, t) {
    if (e < 253)
      return Pr.num(e, 1);
    if (e < 65536)
      return Pr.of(253, ...Pr.num(e, 2, t));
    if (e < 4294967296)
      return Pr.of(254, ...Pr.num(e, 4, t));
    if (BigInt(e) < 0x10000000000000000n)
      return Pr.of(255, ...Pr.num(e, 8, t));
    throw new Error(`Value is too large: ${e}`);
  }
}, Pr.num = qie, Pr.big = Gie, Pr.bin = Vie, Pr.raw = Wie, Pr.str = Zie, Pr.hex = Xie, Pr.bytes = Yie, Pr.json = Jie, Pr.base64 = Qie, Pr.b64url = eae, Pr.bech32 = tae, Pr.b58chk = rae, Pr.encode = iC, Pr.decode = HS, Pr);
function qie(e, t, r) {
  return new xe(e, t, r);
}
function Vie(e, t, r) {
  return new xe(Nie(e), t, r);
}
function Gie(e, t, r) {
  return new xe(e, t, r);
}
function Wie(e, t, r) {
  return new xe(e, t, r);
}
function Zie(e, t, r) {
  return new xe(iC(e), t, r);
}
function Xie(e, t, r) {
  return new xe(e, t, r);
}
function Yie(e, t, r) {
  return new xe(e, t, r);
}
function Jie(e) {
  return new xe(Die(e));
}
function Qie(e) {
  return new xe(QH.decode(e));
}
function eae(e) {
  return new xe(eF.decode(e));
}
function tae(e) {
  return new xe(WH.decode(e));
}
function rae(e) {
  return new xe(FH.decode(e));
}
let yg = class {
  constructor(t) {
    this.data = xe.bytes(t), this.size = this.data.length;
  }
  peek(t) {
    if (t > this.size)
      throw new Error(`Size greater than stream: ${t} > ${this.size}`);
    return new xe(this.data.slice(0, t));
  }
  read(t) {
    t = t ?? this.readSize();
    const r = this.peek(t);
    return this.data = this.data.slice(t), this.size = this.data.length, r;
  }
  readSize(t) {
    const r = this.read(1).num;
    switch (!0) {
      case (r >= 0 && r < 253):
        return r;
      case r === 253:
        return this.read(2).toNum(t);
      case r === 254:
        return this.read(4).toNum(t);
      case r === 255:
        return this.read(8).toNum(t);
      default:
        throw new Error(`Varint is out of range: ${r}`);
    }
  }
};
function Cc(e, t) {
  const r = xe.bytes(e);
  if (r.length !== t)
    throw new Error(`Invalid input size: ${r.hex} !== ${t}`);
}
function Ui(e, t) {
  if (t)
    throw new Error(e);
  return !1;
}
function N8(e, ...t) {
  const r = xe.str(e).digest.raw, n = t.map((o) => xe.bytes(o));
  return xe.join([r, r, xe.join(n)]).digest;
}
const rF = {
  OP_0: 0,
  OP_PUSHDATA1: 76,
  OP_PUSHDATA2: 77,
  OP_PUSHDATA4: 78,
  OP_1NEGATE: 79,
  OP_SUCCESS80: 80,
  OP_1: 81,
  OP_2: 82,
  OP_3: 83,
  OP_4: 84,
  OP_5: 85,
  OP_6: 86,
  OP_7: 87,
  OP_8: 88,
  OP_9: 89,
  OP_10: 90,
  OP_11: 91,
  OP_12: 92,
  OP_13: 93,
  OP_14: 94,
  OP_15: 95,
  OP_16: 96,
  OP_NOP: 97,
  OP_SUCCESS98: 98,
  OP_IF: 99,
  OP_NOTIF: 100,
  OP_ELSE: 103,
  OP_ENDIF: 104,
  OP_VERIFY: 105,
  OP_RETURN: 106,
  OP_TOALTSTACK: 107,
  OP_FROMALTSTACK: 108,
  OP_2DROP: 109,
  OP_2DUP: 110,
  OP_3DUP: 111,
  OP_2OVER: 112,
  OP_2ROT: 113,
  OP_2SWAP: 114,
  OP_IFDUP: 115,
  OP_DEPTH: 116,
  OP_DROP: 117,
  OP_DUP: 118,
  OP_NIP: 119,
  OP_OVER: 120,
  OP_PICK: 121,
  OP_ROLL: 122,
  OP_ROT: 123,
  OP_SWAP: 124,
  OP_TUCK: 125,
  OP_SUCCESS126: 126,
  OP_SUCCESS127: 127,
  OP_SUCCESS128: 128,
  OP_SUCCESS129: 129,
  OP_SIZE: 130,
  OP_SUCCESS131: 131,
  OP_SUCCESS132: 132,
  OP_SUCCESS133: 133,
  OP_SUCCESS134: 134,
  OP_EQUAL: 135,
  OP_EQUALVERIFY: 136,
  OP_SUCCESS137: 137,
  OP_SUCCESS138: 138,
  OP_1ADD: 139,
  OP_1SUB: 140,
  OP_SUCCESS141: 141,
  OP_SUCCESS142: 142,
  OP_NEGATE: 143,
  OP_ABS: 144,
  OP_NOT: 145,
  OP_0NOTEQUAL: 146,
  OP_ADD: 147,
  OP_SUB: 148,
  OP_SUCCESS149: 149,
  OP_SUCCESS150: 150,
  OP_SUCCESS151: 151,
  OP_SUCCESS152: 152,
  OP_SUCCESS153: 153,
  OP_BOOLAND: 154,
  OP_BOOLOR: 155,
  OP_NUMEQUAL: 156,
  OP_NUMEQUALVERIFY: 157,
  OP_NUMNOTEQUAL: 158,
  OP_LESSTHAN: 159,
  OP_GREATERTHAN: 160,
  OP_LESSTHANOREQUAL: 161,
  OP_GREATERTHANOREQUAL: 162,
  OP_MIN: 163,
  OP_MAX: 164,
  OP_WITHIN: 165,
  OP_RIPEMD160: 166,
  OP_SHA1: 167,
  OP_SHA256: 168,
  OP_HASH160: 169,
  OP_HASH256: 170,
  OP_CODESEPARATOR: 171,
  OP_CHECKSIG: 172,
  OP_CHECKSIGVERIFY: 173,
  OP_CHECKMULTISIG: 174,
  OP_CHECKMULTISIGVERIFY: 175,
  OP_NOP1: 176,
  OP_CHECKLOCKTIMEVERIFY: 177,
  OP_CHECKSEQUENCEVERIFY: 178,
  OP_NOP4: 179,
  OP_NOP5: 180,
  OP_NOP6: 181,
  OP_NOP7: 182,
  OP_NOP8: 183,
  OP_NOP9: 184,
  OP_NOP10: 185,
  OP_CHECKSIGADD: 186,
  OP_SUCCESS187: 187,
  OP_SUCCESS188: 188,
  OP_SUCCESS189: 189,
  OP_SUCCESS190: 190,
  OP_SUCCESS191: 191,
  OP_SUCCESS192: 192,
  OP_SUCCESS193: 193,
  OP_SUCCESS194: 194,
  OP_SUCCESS195: 195,
  OP_SUCCESS196: 196,
  OP_SUCCESS197: 197,
  OP_SUCCESS198: 198,
  OP_SUCCESS199: 199,
  OP_SUCCESS200: 200,
  OP_SUCCESS201: 201,
  OP_SUCCESS202: 202,
  OP_SUCCESS203: 203,
  OP_SUCCESS204: 204,
  OP_SUCCESS205: 205,
  OP_SUCCESS206: 206,
  OP_SUCCESS207: 207,
  OP_SUCCESS208: 208,
  OP_SUCCESS209: 209,
  OP_SUCCESS210: 210,
  OP_SUCCESS211: 211,
  OP_SUCCESS212: 212,
  OP_SUCCESS213: 213,
  OP_SUCCESS214: 214,
  OP_SUCCESS215: 215,
  OP_SUCCESS216: 216,
  OP_SUCCESS217: 217,
  OP_SUCCESS218: 218,
  OP_SUCCESS219: 219,
  OP_SUCCESS220: 220,
  OP_SUCCESS221: 221,
  OP_SUCCESS222: 222,
  OP_SUCCESS223: 223,
  OP_SUCCESS224: 224,
  OP_SUCCESS225: 225,
  OP_SUCCESS226: 226,
  OP_SUCCESS227: 227,
  OP_SUCCESS228: 228,
  OP_SUCCESS229: 229,
  OP_SUCCESS230: 230,
  OP_SUCCESS231: 231,
  OP_SUCCESS232: 232,
  OP_SUCCESS233: 233,
  OP_SUCCESS234: 234,
  OP_SUCCESS235: 235,
  OP_SUCCESS236: 236,
  OP_SUCCESS237: 237,
  OP_SUCCESS238: 238,
  OP_SUCCESS239: 239,
  OP_SUCCESS240: 240,
  OP_SUCCESS241: 241,
  OP_SUCCESS242: 242,
  OP_SUCCESS243: 243,
  OP_SUCCESS244: 244,
  OP_SUCCESS245: 245,
  OP_SUCCESS246: 246,
  OP_SUCCESS247: 247,
  OP_SUCCESS248: 248,
  OP_SUCCESS249: 249,
  OP_SUCCESS250: 250,
  OP_SUCCESS251: 251,
  OP_SUCCESS252: 252,
  OP_SUCCESS253: 253,
  OP_SUCCESS254: 254
};
function nae(e) {
  if (e > 186 && e < 255)
    return "OP_SUCCESS" + String(e);
  for (const [t, r] of Object.entries(rF))
    if (r === e)
      return t;
  throw new Error("OPCODE not found:" + String(e));
}
function oae(e) {
  for (const [t, r] of Object.entries(rF))
    if (t === e)
      return Number(r);
  throw new Error("OPCODE not found:" + e);
}
function iae(e) {
  switch (!0) {
    case e === 0:
      return "opcode";
    case (e >= 1 && e <= 75):
      return "varint";
    case e === 76:
      return "pushdata1";
    case e === 77:
      return "pushdata2";
    case e === 78:
      return "pushdata4";
    case e <= 254:
      return "opcode";
    default:
      throw new Error(`Invalid word range: ${e}`);
  }
}
function aae(e) {
  const t = [];
  switch (!0) {
    case typeof e != "number":
      return !1;
    case e === 0:
      return !0;
    case t.includes(e):
      return !1;
    case (75 < e && e < 254):
      return !0;
    default:
      return !1;
  }
}
function yf(e) {
  return typeof e == "string" && e.length % 2 === 0 && /[0-9a-fA-F]/.test(e);
}
function nF(e) {
  return yf(e) || e instanceof Uint8Array;
}
const p3 = 520;
function _0(e = [], t = !0) {
  let r = xe.num(0);
  return Array.isArray(e) && (r = xe.raw(oF(e))), yf(e) && (r = xe.hex(e)), e instanceof Uint8Array && (r = xe.raw(e)), t && (r = r.prefixSize("le")), r;
}
function oF(e) {
  const t = [];
  for (const r of e)
    t.push(sae(r));
  return t.length > 0 ? xe.join(t) : new Uint8Array();
}
function sae(e) {
  let t = new Uint8Array();
  if (typeof e == "string") {
    if (e.startsWith("OP_"))
      return xe.num(oae(e), 1);
    yf(e) ? t = xe.hex(e) : t = xe.str(e);
  } else
    t = xe.bytes(e);
  if (t.length === 1)
    return t[0] !== 0 && t[0] <= 16 ? (t[0] += 80, t) : (t[0] > 128 && t[0] <= 255 && (t = new Uint8Array([t[0], 0])), xe.join([cU(t.length), t]));
  if (t.length > p3) {
    const r = uae(t);
    return oF(r);
  } else
    return xe.join([cU(t.length), t]);
}
function cU(e) {
  const t = xe.num(76, 1), r = xe.num(77, 1);
  switch (!0) {
    case e <= 75:
      return xe.num(e);
    case (e > 75 && e < 256):
      return xe.join([t, xe.num(e, 1, "le")]);
    case (e >= 256 && e <= p3):
      return xe.join([r, xe.num(e, 2, "le")]);
    default:
      throw new Error("Invalid word size:" + e.toString());
  }
}
function uae(e) {
  const t = [], r = new yg(e);
  for (; r.size > p3; )
    t.push(r.read(p3));
  return t.push(r.read(r.size)), t;
}
function aC(e, t = !1) {
  let r = xe.bytes(e);
  if (t) {
    const n = r.stream.readSize("le");
    if (r = r.slice(1), r.length !== n)
      throw new Error(`Varint does not match stream size: ${n} !== ${r.length}`);
  }
  return cae(r);
}
function cae(e) {
  const t = new yg(e), r = [], n = t.size;
  let o, i, a, u = 0;
  for (; u < n; )
    switch (o = t.read(1).num, i = iae(o), u++, i) {
      case "varint":
        r.push(t.read(o).hex), u += o;
        break;
      case "pushdata1":
        a = t.read(1).reverse().num, r.push(t.read(a).hex), u += a + 1;
        break;
      case "pushdata2":
        a = t.read(2).reverse().num, r.push(t.read(a).hex), u += a + 2;
        break;
      case "pushdata4":
        a = t.read(4).reverse().num, r.push(t.read(a).hex), u += a + 4;
        break;
      case "opcode":
        if (!aae(o))
          throw new Error(`Invalid OPCODE: ${o}`);
        r.push(nae(o));
        break;
      default:
        throw new Error(`Word type undefined: ${o}`);
    }
  return r;
}
function lae(e, t) {
  if (Array.isArray(e) && (e = _0(e, t)), e instanceof Uint8Array || yf(e))
    return aC(e, t);
  throw new Error("Invalid format: " + typeof e);
}
function fae(e, t) {
  if ((e instanceof Uint8Array || yf(e)) && (e = aC(e, t)), Array.isArray(e))
    return _0(e, t);
  throw new Error("Invalid format: " + typeof e);
}
function dae(e) {
  if (!Array.isArray(e))
    return xe.bytes(e);
  throw new Error("Invalid format: " + typeof e);
}
const hae = {
  toAsm: lae,
  toBytes: fae,
  toParam: dae
}, pa = {
  encode: _0,
  decode: aC,
  fmt: hae
};
function RI(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function pae(e) {
  if (typeof e != "boolean")
    throw new Error(`Expected boolean, not ${e}`);
}
function iF(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new TypeError(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function gae(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  RI(e.outputLen), RI(e.blockLen);
}
function mae(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function yae(e, t) {
  iF(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error(`digestInto() expects output buffer of length at least ${r}`);
}
const bae = {
  number: RI,
  bool: pae,
  bytes: iF,
  hash: gae,
  exists: mae,
  output: yae
};
var Cp = bae;
const FS = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const MS = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), nc = (e, t) => e << 32 - t | e >>> t, wae = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!wae)
  throw new Error("Non little-endian hardware is not supported");
Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function vae(e) {
  if (typeof e != "string")
    throw new TypeError(`utf8ToBytes expected string, got ${typeof e}`);
  return new TextEncoder().encode(e);
}
function sC(e) {
  if (typeof e == "string" && (e = vae(e)), !(e instanceof Uint8Array))
    throw new TypeError(`Expected input type is Uint8Array (got ${typeof e})`);
  return e;
}
function Eae(...e) {
  if (!e.every((n) => n instanceof Uint8Array))
    throw new Error("Uint8Array list expected");
  if (e.length === 1)
    return e[0];
  const t = e.reduce((n, o) => n + o.length, 0), r = new Uint8Array(t);
  for (let n = 0, o = 0; n < e.length; n++) {
    const i = e[n];
    r.set(i, o), o += i.length;
  }
  return r;
}
let aF = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function sF(e) {
  const t = (n) => e().update(sC(n)).digest(), r = e();
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = () => e(), t;
}
function _ae(e = 32) {
  if (FS && typeof FS.getRandomValues == "function")
    return FS.getRandomValues(new Uint8Array(e));
  throw new Error("crypto.getRandomValues must be defined");
}
function Aae(e, t, r, n) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, r, n);
  const o = BigInt(32), i = BigInt(4294967295), a = Number(r >> o & i), u = Number(r & i), l = n ? 4 : 0, d = n ? 0 : 4;
  e.setUint32(t + l, a, n), e.setUint32(t + d, u, n);
}
let xae = class extends aF {
  constructor(t, r, n, o) {
    super(), this.blockLen = t, this.outputLen = r, this.padOffset = n, this.isLE = o, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = MS(this.buffer);
  }
  update(t) {
    Cp.exists(this);
    const { view: r, buffer: n, blockLen: o } = this;
    t = sC(t);
    const i = t.length;
    for (let a = 0; a < i; ) {
      const u = Math.min(o - this.pos, i - a);
      if (u === o) {
        const l = MS(t);
        for (; o <= i - a; a += o)
          this.process(l, a);
        continue;
      }
      n.set(t.subarray(a, a + u), this.pos), this.pos += u, a += u, this.pos === o && (this.process(r, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    Cp.exists(this), Cp.output(t, this), this.finished = !0;
    const { buffer: r, view: n, blockLen: o, isLE: i } = this;
    let { pos: a } = this;
    r[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > o - a && (this.process(n, 0), a = 0);
    for (let h = a; h < o; h++)
      r[h] = 0;
    Aae(n, o - 8, BigInt(this.length * 8), i), this.process(n, 0);
    const u = MS(t), l = this.outputLen;
    if (l % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const d = l / 4, f = this.get();
    if (d > f.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let h = 0; h < d; h++)
      u.setUint32(4 * h, f[h], i);
  }
  digest() {
    const { buffer: t, outputLen: r } = this;
    this.digestInto(t);
    const n = t.slice(0, r);
    return this.destroy(), n;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: r, buffer: n, length: o, finished: i, destroyed: a, pos: u } = this;
    return t.length = o, t.pos = u, t.finished = i, t.destroyed = a, o % r && t.buffer.set(n), t;
  }
};
const kae = (e, t, r) => e & t ^ ~e & r, Sae = (e, t, r) => e & t ^ e & r ^ t & r, Tae = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), Rf = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), zf = new Uint32Array(64);
let uF = class extends xae {
  constructor() {
    super(64, 32, 8, !1), this.A = Rf[0] | 0, this.B = Rf[1] | 0, this.C = Rf[2] | 0, this.D = Rf[3] | 0, this.E = Rf[4] | 0, this.F = Rf[5] | 0, this.G = Rf[6] | 0, this.H = Rf[7] | 0;
  }
  get() {
    const { A: e, B: t, C: r, D: n, E: o, F: i, G: a, H: u } = this;
    return [e, t, r, n, o, i, a, u];
  }
  // prettier-ignore
  set(e, t, r, n, o, i, a, u) {
    this.A = e | 0, this.B = t | 0, this.C = r | 0, this.D = n | 0, this.E = o | 0, this.F = i | 0, this.G = a | 0, this.H = u | 0;
  }
  process(e, t) {
    for (let f = 0; f < 16; f++, t += 4)
      zf[f] = e.getUint32(t, !1);
    for (let f = 16; f < 64; f++) {
      const h = zf[f - 15], g = zf[f - 2], b = nc(h, 7) ^ nc(h, 18) ^ h >>> 3, w = nc(g, 17) ^ nc(g, 19) ^ g >>> 10;
      zf[f] = w + zf[f - 7] + b + zf[f - 16] | 0;
    }
    let { A: r, B: n, C: o, D: i, E: a, F: u, G: l, H: d } = this;
    for (let f = 0; f < 64; f++) {
      const h = nc(a, 6) ^ nc(a, 11) ^ nc(a, 25), g = d + h + kae(a, u, l) + Tae[f] + zf[f] | 0, b = (nc(r, 2) ^ nc(r, 13) ^ nc(r, 22)) + Sae(r, n, o) | 0;
      d = l, l = u, u = a, a = i + g | 0, i = o, o = n, n = r, r = g + b | 0;
    }
    r = r + this.A | 0, n = n + this.B | 0, o = o + this.C | 0, i = i + this.D | 0, a = a + this.E | 0, u = u + this.F | 0, l = l + this.G | 0, d = d + this.H | 0, this.set(r, n, o, i, a, u, l, d);
  }
  roundClean() {
    zf.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}, Iae = class extends uF {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
};
const cF = sF(() => new uF());
sF(() => new Iae());
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Oae = BigInt(0), uC = BigInt(1), Pae = BigInt(2), Y5 = (e) => e instanceof Uint8Array, Cae = Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function F1(e) {
  if (!Y5(e))
    throw new Error("Uint8Array expected");
  let t = "";
  for (let r = 0; r < e.length; r++)
    t += Cae[e[r]];
  return t;
}
function lF(e) {
  const t = e.toString(16);
  return t.length & 1 ? `0${t}` : t;
}
function cC(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  return BigInt(e === "" ? "0" : `0x${e}`);
}
function M1(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  if (e.length % 2)
    throw new Error("hex string is invalid: unpadded " + e.length);
  const t = new Uint8Array(e.length / 2);
  for (let r = 0; r < t.length; r++) {
    const n = r * 2, o = e.slice(n, n + 2), i = Number.parseInt(o, 16);
    if (Number.isNaN(i) || i < 0)
      throw new Error("invalid byte sequence");
    t[r] = i;
  }
  return t;
}
function Nd(e) {
  return cC(F1(e));
}
function lC(e) {
  if (!Y5(e))
    throw new Error("Uint8Array expected");
  return cC(F1(Uint8Array.from(e).reverse()));
}
const b1 = (e, t) => M1(e.toString(16).padStart(t * 2, "0")), fF = (e, t) => b1(e, t).reverse(), Bae = (e) => M1(lF(e));
function Ns(e, t, r) {
  let n;
  if (typeof t == "string")
    try {
      n = M1(t);
    } catch (i) {
      throw new Error(`${e} must be valid hex string, got "${t}". Cause: ${i}`);
    }
  else if (Y5(t))
    n = Uint8Array.from(t);
  else
    throw new Error(`${e} must be hex string or Uint8Array`);
  const o = n.length;
  if (typeof r == "number" && o !== r)
    throw new Error(`${e} expected ${r} bytes, got ${o}`);
  return n;
}
function _u(...e) {
  const t = new Uint8Array(e.reduce((n, o) => n + o.length, 0));
  let r = 0;
  return e.forEach((n) => {
    if (!Y5(n))
      throw new Error("Uint8Array expected");
    t.set(n, r), r += n.length;
  }), t;
}
function Nae(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function J5(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new TextEncoder().encode(e);
}
function $ae(e) {
  let t;
  for (t = 0; e > 0n; e >>= uC, t += 1)
    ;
  return t;
}
const Uae = (e, t) => e >> BigInt(t) & 1n, Rae = (e, t, r) => e | (r ? uC : Oae) << BigInt(t), fC = (e) => (Pae << BigInt(e - 1)) - uC, DS = (e) => new Uint8Array(e), lU = (e) => Uint8Array.from(e);
function dF(e, t, r) {
  if (typeof e != "number" || e < 2)
    throw new Error("hashLen must be a number");
  if (typeof t != "number" || t < 2)
    throw new Error("qByteLen must be a number");
  if (typeof r != "function")
    throw new Error("hmacFn must be a function");
  let n = DS(e), o = DS(e), i = 0;
  const a = () => {
    n.fill(1), o.fill(0), i = 0;
  }, u = (...f) => r(o, n, ...f), l = (f = DS()) => {
    o = u(lU([0]), f), n = u(), f.length !== 0 && (o = u(lU([1]), f), n = u());
  }, d = () => {
    if (i++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let f = 0;
    const h = [];
    for (; f < t; ) {
      n = u();
      const g = n.slice();
      h.push(g), f += n.length;
    }
    return _u(...h);
  };
  return (f, h) => {
    a(), l(f);
    let g;
    for (; !(g = h(d())); )
      l();
    return a(), g;
  };
}
const zae = {
  bigint: (e) => typeof e == "bigint",
  function: (e) => typeof e == "function",
  boolean: (e) => typeof e == "boolean",
  string: (e) => typeof e == "string",
  isSafeInteger: (e) => Number.isSafeInteger(e),
  array: (e) => Array.isArray(e),
  field: (e, t) => t.Fp.isValid(e),
  hash: (e) => typeof e == "function" && Number.isSafeInteger(e.outputLen)
};
function bg(e, t, r = {}) {
  const n = (o, i, a) => {
    const u = zae[i];
    if (typeof u != "function")
      throw new Error(`Invalid validator "${i}", expected function`);
    const l = e[o];
    if (!(a && l === void 0) && !u(l, e))
      throw new Error(`Invalid param ${String(o)}=${l} (${typeof l}), expected ${i}`);
  };
  for (const [o, i] of Object.entries(t))
    n(o, i, !1);
  for (const [o, i] of Object.entries(r))
    n(o, i, !0);
  return e;
}
var jae = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  bitGet: Uae,
  bitLen: $ae,
  bitMask: fC,
  bitSet: Rae,
  bytesToHex: F1,
  bytesToNumberBE: Nd,
  bytesToNumberLE: lC,
  concatBytes: _u,
  createHmacDrbg: dF,
  ensureBytes: Ns,
  equalBytes: Nae,
  hexToBytes: M1,
  hexToNumber: cC,
  numberToBytesBE: b1,
  numberToBytesLE: fF,
  numberToHexUnpadded: lF,
  numberToVarBytesBE: Bae,
  utf8ToBytes: J5,
  validateObject: bg
});
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const ri = BigInt(0), Ao = BigInt(1), Ip = BigInt(2), Lae = BigInt(3), zI = BigInt(4), fU = BigInt(5), dU = BigInt(8);
BigInt(9);
BigInt(16);
function Ri(e, t) {
  const r = e % t;
  return r >= ri ? r : t + r;
}
function Hae(e, t, r) {
  if (r <= ri || t < ri)
    throw new Error("Expected power/modulo > 0");
  if (r === Ao)
    return ri;
  let n = Ao;
  for (; t > ri; )
    t & Ao && (n = n * e % r), e = e * e % r, t >>= Ao;
  return n;
}
function As(e, t, r) {
  let n = e;
  for (; t-- > ri; )
    n *= n, n %= r;
  return n;
}
function jI(e, t) {
  if (e === ri || t <= ri)
    throw new Error(`invert: expected positive integers, got n=${e} mod=${t}`);
  let r = Ri(e, t), n = t, o = ri, i = Ao;
  for (; r !== ri; ) {
    const a = n / r, u = n % r, l = o - i * a;
    n = r, r = u, o = i, i = l;
  }
  if (n !== Ao)
    throw new Error("invert: does not exist");
  return Ri(o, t);
}
function Fae(e) {
  const t = (e - Ao) / Ip;
  let r, n, o;
  for (r = e - Ao, n = 0; r % Ip === ri; r /= Ip, n++)
    ;
  for (o = Ip; o < e && Hae(o, t, e) !== e - Ao; o++)
    ;
  if (n === 1) {
    const a = (e + Ao) / zI;
    return function(u, l) {
      const d = u.pow(l, a);
      if (!u.eql(u.sqr(d), l))
        throw new Error("Cannot find square root");
      return d;
    };
  }
  const i = (r + Ao) / Ip;
  return function(a, u) {
    if (a.pow(u, t) === a.neg(a.ONE))
      throw new Error("Cannot find square root");
    let l = n, d = a.pow(a.mul(a.ONE, o), r), f = a.pow(u, i), h = a.pow(u, r);
    for (; !a.eql(h, a.ONE); ) {
      if (a.eql(h, a.ZERO))
        return a.ZERO;
      let g = 1;
      for (let w = a.sqr(h); g < l && !a.eql(w, a.ONE); g++)
        w = a.sqr(w);
      const b = a.pow(d, Ao << BigInt(l - g - 1));
      d = a.sqr(b), f = a.mul(f, b), h = a.mul(h, d), l = g;
    }
    return f;
  };
}
function Mae(e) {
  if (e % zI === Lae) {
    const t = (e + Ao) / zI;
    return function(r, n) {
      const o = r.pow(n, t);
      if (!r.eql(r.sqr(o), n))
        throw new Error("Cannot find square root");
      return o;
    };
  }
  if (e % dU === fU) {
    const t = (e - fU) / dU;
    return function(r, n) {
      const o = r.mul(n, Ip), i = r.pow(o, t), a = r.mul(n, i), u = r.mul(r.mul(a, Ip), i), l = r.mul(a, r.sub(u, r.ONE));
      if (!r.eql(r.sqr(l), n))
        throw new Error("Cannot find square root");
      return l;
    };
  }
  return Fae(e);
}
const Dae = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function hF(e) {
  const t = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, r = Dae.reduce((n, o) => (n[o] = "function", n), t);
  return bg(e, r);
}
function Kae(e, t, r) {
  if (r < ri)
    throw new Error("Expected power > 0");
  if (r === ri)
    return e.ONE;
  if (r === Ao)
    return t;
  let n = e.ONE, o = t;
  for (; r > ri; )
    r & Ao && (n = e.mul(n, o)), o = e.sqr(o), r >>= Ao;
  return n;
}
function qae(e, t) {
  const r = new Array(t.length), n = t.reduce((i, a, u) => e.is0(a) ? i : (r[u] = i, e.mul(i, a)), e.ONE), o = e.inv(n);
  return t.reduceRight((i, a, u) => e.is0(a) ? i : (r[u] = e.mul(i, r[u]), e.mul(i, a)), o), r;
}
function dC(e, t) {
  const r = t !== void 0 ? t : e.toString(2).length, n = Math.ceil(r / 8);
  return { nBitLength: r, nByteLength: n };
}
function pF(e, t, r = !1, n = {}) {
  if (e <= ri)
    throw new Error(`Expected Fp ORDER > 0, got ${e}`);
  const { nBitLength: o, nByteLength: i } = dC(e, t);
  if (i > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const a = Mae(e), u = Object.freeze({
    ORDER: e,
    BITS: o,
    BYTES: i,
    MASK: fC(o),
    ZERO: ri,
    ONE: Ao,
    create: (l) => Ri(l, e),
    isValid: (l) => {
      if (typeof l != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof l}`);
      return ri <= l && l < e;
    },
    is0: (l) => l === ri,
    isOdd: (l) => (l & Ao) === Ao,
    neg: (l) => Ri(-l, e),
    eql: (l, d) => l === d,
    sqr: (l) => Ri(l * l, e),
    add: (l, d) => Ri(l + d, e),
    sub: (l, d) => Ri(l - d, e),
    mul: (l, d) => Ri(l * d, e),
    pow: (l, d) => Kae(u, l, d),
    div: (l, d) => Ri(l * jI(d, e), e),
    // Same as above, but doesn't normalize
    sqrN: (l) => l * l,
    addN: (l, d) => l + d,
    subN: (l, d) => l - d,
    mulN: (l, d) => l * d,
    inv: (l) => jI(l, e),
    sqrt: n.sqrt || ((l) => a(u, l)),
    invertBatch: (l) => qae(u, l),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (l, d, f) => f ? d : l,
    toBytes: (l) => r ? fF(l, i) : b1(l, i),
    fromBytes: (l) => {
      if (l.length !== i)
        throw new Error(`Fp.fromBytes: expected ${i}, got ${l.length}`);
      return r ? lC(l) : Nd(l);
    }
  });
  return Object.freeze(u);
}
function Vae(e, t, r = !1) {
  e = Ns("privateHash", e);
  const n = e.length, o = dC(t).nByteLength + 8;
  if (o < 24 || n < o || n > 1024)
    throw new Error(`hashToPrivateScalar: expected ${o}-1024 bytes of input, got ${n}`);
  const i = r ? lC(e) : Nd(e);
  return Ri(i, t - Ao) + Ao;
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Gae = BigInt(0), KS = BigInt(1);
function Wae(e, t) {
  const r = (o, i) => {
    const a = i.negate();
    return o ? a : i;
  }, n = (o) => {
    const i = Math.ceil(t / o) + 1, a = 2 ** (o - 1);
    return { windows: i, windowSize: a };
  };
  return {
    constTimeNegate: r,
    // non-const time multiplication ladder
    unsafeLadder(o, i) {
      let a = e.ZERO, u = o;
      for (; i > Gae; )
        i & KS && (a = a.add(u)), u = u.double(), i >>= KS;
      return a;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(o, i) {
      const { windows: a, windowSize: u } = n(i), l = [];
      let d = o, f = d;
      for (let h = 0; h < a; h++) {
        f = d, l.push(f);
        for (let g = 1; g < u; g++)
          f = f.add(d), l.push(f);
        d = f.double();
      }
      return l;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(o, i, a) {
      const { windows: u, windowSize: l } = n(o);
      let d = e.ZERO, f = e.BASE;
      const h = BigInt(2 ** o - 1), g = 2 ** o, b = BigInt(o);
      for (let w = 0; w < u; w++) {
        const E = w * l;
        let _ = Number(a & h);
        a >>= b, _ > l && (_ -= g, a += KS);
        const O = E, C = E + Math.abs(_) - 1, I = w % 2 !== 0, S = _ < 0;
        _ === 0 ? f = f.add(r(I, i[O])) : d = d.add(r(S, i[C]));
      }
      return { p: d, f };
    },
    wNAFCached(o, i, a, u) {
      const l = o._WINDOW_SIZE || 1;
      let d = i.get(o);
      return d || (d = this.precomputeWindow(o, l), l !== 1 && i.set(o, u(d))), this.wNAF(l, d, a);
    }
  };
}
function gF(e) {
  return hF(e.Fp), bg(e, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...dC(e.n, e.nBitLength),
    ...e,
    p: e.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function Zae(e) {
  const t = gF(e);
  bg(t, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: r, Fp: n, a: o } = t;
  if (r) {
    if (!n.eql(o, n.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof r != "object" || typeof r.beta != "bigint" || typeof r.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...t });
}
const { bytesToNumberBE: Xae, hexToBytes: Yae } = jae, Bp = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(e = "") {
      super(e);
    }
  },
  _parseInt(e) {
    const { Err: t } = Bp;
    if (e.length < 2 || e[0] !== 2)
      throw new t("Invalid signature integer tag");
    const r = e[1], n = e.subarray(2, r + 2);
    if (!r || n.length !== r)
      throw new t("Invalid signature integer: wrong length");
    if (n[0] === 0 && n[1] <= 127)
      throw new t("Invalid signature integer: trailing length");
    return { d: Xae(n), l: e.subarray(r + 2) };
  },
  toSig(e) {
    const { Err: t } = Bp, r = typeof e == "string" ? Yae(e) : e;
    if (!(r instanceof Uint8Array))
      throw new Error("ui8a expected");
    let n = r.length;
    if (n < 2 || r[0] != 48)
      throw new t("Invalid signature tag");
    if (r[1] !== n - 2)
      throw new t("Invalid signature: incorrect length");
    const { d: o, l: i } = Bp._parseInt(r.subarray(2)), { d: a, l: u } = Bp._parseInt(i);
    if (u.length)
      throw new t("Invalid signature: left bytes after parsing");
    return { r: o, s: a };
  },
  hexFromSig(e) {
    const t = (d) => Number.parseInt(d[0], 16) >= 8 ? "00" + d : d, r = (d) => {
      const f = d.toString(16);
      return f.length & 1 ? `0${f}` : f;
    }, n = t(r(e.s)), o = t(r(e.r)), i = n.length / 2, a = o.length / 2, u = r(i), l = r(a);
    return `30${r(a + i + 4)}02${l}${o}02${u}${n}`;
  }
}, Su = BigInt(0), Mo = BigInt(1), Cl = BigInt(2), g3 = BigInt(3), hU = BigInt(4);
function Jae(e) {
  const t = Zae(e), { Fp: r } = t, n = t.toBytes || ((w, E, _) => {
    const O = E.toAffine();
    return _u(Uint8Array.from([4]), r.toBytes(O.x), r.toBytes(O.y));
  }), o = t.fromBytes || ((w) => {
    const E = w.subarray(1), _ = r.fromBytes(E.subarray(0, r.BYTES)), O = r.fromBytes(E.subarray(r.BYTES, 2 * r.BYTES));
    return { x: _, y: O };
  });
  function i(w) {
    const { a: E, b: _ } = t, O = r.sqr(w), C = r.mul(O, w);
    return r.add(r.add(C, r.mul(w, E)), _);
  }
  function a(w) {
    return typeof w == "bigint" && Su < w && w < t.n;
  }
  function u(w) {
    if (!a(w))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function l(w) {
    const { allowedPrivateKeyLengths: E, nByteLength: _, wrapPrivateKey: O, n: C } = t;
    if (E && typeof w != "bigint") {
      if (w instanceof Uint8Array && (w = F1(w)), typeof w != "string" || !E.includes(w.length))
        throw new Error("Invalid key");
      w = w.padStart(_ * 2, "0");
    }
    let I;
    try {
      I = typeof w == "bigint" ? w : Nd(Ns("private key", w, _));
    } catch {
      throw new Error(`private key must be ${_} bytes, hex or bigint, not ${typeof w}`);
    }
    return O && (I = Ri(I, C)), u(I), I;
  }
  const d = /* @__PURE__ */ new Map();
  function f(w) {
    if (!(w instanceof h))
      throw new Error("ProjectivePoint expected");
  }
  class h {
    constructor(E, _, O) {
      if (this.px = E, this.py = _, this.pz = O, E == null || !r.isValid(E))
        throw new Error("x required");
      if (_ == null || !r.isValid(_))
        throw new Error("y required");
      if (O == null || !r.isValid(O))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(E) {
      const { x: _, y: O } = E || {};
      if (!E || !r.isValid(_) || !r.isValid(O))
        throw new Error("invalid affine point");
      if (E instanceof h)
        throw new Error("projective point not allowed");
      const C = (I) => r.eql(I, r.ZERO);
      return C(_) && C(O) ? h.ZERO : new h(_, O, r.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(E) {
      const _ = r.invertBatch(E.map((O) => O.pz));
      return E.map((O, C) => O.toAffine(_[C])).map(h.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(E) {
      const _ = h.fromAffine(o(Ns("pointHex", E)));
      return _.assertValidity(), _;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(E) {
      return h.BASE.multiply(l(E));
    }
    // "Private method", don't use it directly
    _setWindowSize(E) {
      this._WINDOW_SIZE = E, d.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (t.allowInfinityPoint)
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: E, y: _ } = this.toAffine();
      if (!r.isValid(E) || !r.isValid(_))
        throw new Error("bad point: x or y not FE");
      const O = r.sqr(_), C = i(E);
      if (!r.eql(O, C))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: E } = this.toAffine();
      if (r.isOdd)
        return !r.isOdd(E);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(E) {
      f(E);
      const { px: _, py: O, pz: C } = this, { px: I, py: S, pz: T } = E, A = r.eql(r.mul(_, T), r.mul(I, C)), $ = r.eql(r.mul(O, T), r.mul(S, C));
      return A && $;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new h(this.px, r.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: E, b: _ } = t, O = r.mul(_, g3), { px: C, py: I, pz: S } = this;
      let T = r.ZERO, A = r.ZERO, $ = r.ZERO, U = r.mul(C, C), M = r.mul(I, I), Y = r.mul(S, S), L = r.mul(C, I);
      return L = r.add(L, L), $ = r.mul(C, S), $ = r.add($, $), T = r.mul(E, $), A = r.mul(O, Y), A = r.add(T, A), T = r.sub(M, A), A = r.add(M, A), A = r.mul(T, A), T = r.mul(L, T), $ = r.mul(O, $), Y = r.mul(E, Y), L = r.sub(U, Y), L = r.mul(E, L), L = r.add(L, $), $ = r.add(U, U), U = r.add($, U), U = r.add(U, Y), U = r.mul(U, L), A = r.add(A, U), Y = r.mul(I, S), Y = r.add(Y, Y), U = r.mul(Y, L), T = r.sub(T, U), $ = r.mul(Y, M), $ = r.add($, $), $ = r.add($, $), new h(T, A, $);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(E) {
      f(E);
      const { px: _, py: O, pz: C } = this, { px: I, py: S, pz: T } = E;
      let A = r.ZERO, $ = r.ZERO, U = r.ZERO;
      const M = t.a, Y = r.mul(t.b, g3);
      let L = r.mul(_, I), ee = r.mul(O, S), de = r.mul(C, T), ne = r.add(_, O), D = r.add(I, S);
      ne = r.mul(ne, D), D = r.add(L, ee), ne = r.sub(ne, D), D = r.add(_, C);
      let K = r.add(I, T);
      return D = r.mul(D, K), K = r.add(L, de), D = r.sub(D, K), K = r.add(O, C), A = r.add(S, T), K = r.mul(K, A), A = r.add(ee, de), K = r.sub(K, A), U = r.mul(M, D), A = r.mul(Y, de), U = r.add(A, U), A = r.sub(ee, U), U = r.add(ee, U), $ = r.mul(A, U), ee = r.add(L, L), ee = r.add(ee, L), de = r.mul(M, de), D = r.mul(Y, D), ee = r.add(ee, de), de = r.sub(L, de), de = r.mul(M, de), D = r.add(D, de), L = r.mul(ee, D), $ = r.add($, L), L = r.mul(K, D), A = r.mul(ne, A), A = r.sub(A, L), L = r.mul(ne, ee), U = r.mul(K, U), U = r.add(U, L), new h(A, $, U);
    }
    subtract(E) {
      return this.add(E.negate());
    }
    is0() {
      return this.equals(h.ZERO);
    }
    wNAF(E) {
      return b.wNAFCached(this, d, E, (_) => {
        const O = r.invertBatch(_.map((C) => C.pz));
        return _.map((C, I) => C.toAffine(O[I])).map(h.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(E) {
      const _ = h.ZERO;
      if (E === Su)
        return _;
      if (u(E), E === Mo)
        return this;
      const { endo: O } = t;
      if (!O)
        return b.unsafeLadder(this, E);
      let { k1neg: C, k1: I, k2neg: S, k2: T } = O.splitScalar(E), A = _, $ = _, U = this;
      for (; I > Su || T > Su; )
        I & Mo && (A = A.add(U)), T & Mo && ($ = $.add(U)), U = U.double(), I >>= Mo, T >>= Mo;
      return C && (A = A.negate()), S && ($ = $.negate()), $ = new h(r.mul($.px, O.beta), $.py, $.pz), A.add($);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(E) {
      u(E);
      let _ = E, O, C;
      const { endo: I } = t;
      if (I) {
        const { k1neg: S, k1: T, k2neg: A, k2: $ } = I.splitScalar(_);
        let { p: U, f: M } = this.wNAF(T), { p: Y, f: L } = this.wNAF($);
        U = b.constTimeNegate(S, U), Y = b.constTimeNegate(A, Y), Y = new h(r.mul(Y.px, I.beta), Y.py, Y.pz), O = U.add(Y), C = M.add(L);
      } else {
        const { p: S, f: T } = this.wNAF(_);
        O = S, C = T;
      }
      return h.normalizeZ([O, C])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(E, _, O) {
      const C = h.BASE, I = (T, A) => A === Su || A === Mo || !T.equals(C) ? T.multiplyUnsafe(A) : T.multiply(A), S = I(this, _).add(I(E, O));
      return S.is0() ? void 0 : S;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(E) {
      const { px: _, py: O, pz: C } = this, I = this.is0();
      E == null && (E = I ? r.ONE : r.inv(C));
      const S = r.mul(_, E), T = r.mul(O, E), A = r.mul(C, E);
      if (I)
        return { x: r.ZERO, y: r.ZERO };
      if (!r.eql(A, r.ONE))
        throw new Error("invZ was invalid");
      return { x: S, y: T };
    }
    isTorsionFree() {
      const { h: E, isTorsionFree: _ } = t;
      if (E === Mo)
        return !0;
      if (_)
        return _(h, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: E, clearCofactor: _ } = t;
      return E === Mo ? this : _ ? _(h, this) : this.multiplyUnsafe(t.h);
    }
    toRawBytes(E = !0) {
      return this.assertValidity(), n(h, this, E);
    }
    toHex(E = !0) {
      return F1(this.toRawBytes(E));
    }
  }
  h.BASE = new h(t.Gx, t.Gy, r.ONE), h.ZERO = new h(r.ZERO, r.ONE, r.ZERO);
  const g = t.nBitLength, b = Wae(h, t.endo ? Math.ceil(g / 2) : g);
  return {
    CURVE: t,
    ProjectivePoint: h,
    normPrivateKeyToScalar: l,
    weierstrassEquation: i,
    isWithinCurveOrder: a
  };
}
function Qae(e) {
  const t = gF(e);
  return bg(t, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...t });
}
function ese(e) {
  const t = Qae(e), { Fp: r, n } = t, o = r.BYTES + 1, i = 2 * r.BYTES + 1;
  function a(D) {
    return Su < D && D < r.ORDER;
  }
  function u(D) {
    return Ri(D, n);
  }
  function l(D) {
    return jI(D, n);
  }
  const { ProjectivePoint: d, normPrivateKeyToScalar: f, weierstrassEquation: h, isWithinCurveOrder: g } = Jae({
    ...t,
    toBytes(D, K, le) {
      const re = K.toAffine(), G = r.toBytes(re.x), q = _u;
      return le ? q(Uint8Array.from([K.hasEvenY() ? 2 : 3]), G) : q(Uint8Array.from([4]), G, r.toBytes(re.y));
    },
    fromBytes(D) {
      const K = D.length, le = D[0], re = D.subarray(1);
      if (K === o && (le === 2 || le === 3)) {
        const G = Nd(re);
        if (!a(G))
          throw new Error("Point is not on curve");
        const q = h(G);
        let Q = r.sqrt(q);
        const se = (Q & Mo) === Mo;
        return (le & 1) === 1 !== se && (Q = r.neg(Q)), { x: G, y: Q };
      } else if (K === i && le === 4) {
        const G = r.fromBytes(re.subarray(0, r.BYTES)), q = r.fromBytes(re.subarray(r.BYTES, 2 * r.BYTES));
        return { x: G, y: q };
      } else
        throw new Error(`Point of length ${K} was invalid. Expected ${o} compressed bytes or ${i} uncompressed bytes`);
    }
  }), b = (D) => F1(b1(D, t.nByteLength));
  function w(D) {
    const K = n >> Mo;
    return D > K;
  }
  function E(D) {
    return w(D) ? u(-D) : D;
  }
  const _ = (D, K, le) => Nd(D.slice(K, le));
  class O {
    constructor(K, le, re) {
      this.r = K, this.s = le, this.recovery = re, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(K) {
      const le = t.nByteLength;
      return K = Ns("compactSignature", K, le * 2), new O(_(K, 0, le), _(K, le, 2 * le));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(K) {
      const { r: le, s: re } = Bp.toSig(Ns("DER", K));
      return new O(le, re);
    }
    assertValidity() {
      if (!g(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!g(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(K) {
      return new O(this.r, this.s, K);
    }
    recoverPublicKey(K) {
      const { r: le, s: re, recovery: G } = this, q = $(Ns("msgHash", K));
      if (G == null || ![0, 1, 2, 3].includes(G))
        throw new Error("recovery id invalid");
      const Q = G === 2 || G === 3 ? le + t.n : le;
      if (Q >= r.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const se = G & 1 ? "03" : "02", J = d.fromHex(se + b(Q)), ye = l(Q), ve = u(-q * ye), Ee = u(re * ye), _e = d.BASE.multiplyAndAddUnsafe(J, ve, Ee);
      if (!_e)
        throw new Error("point at infinify");
      return _e.assertValidity(), _e;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return w(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new O(this.r, u(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return M1(this.toDERHex());
    }
    toDERHex() {
      return Bp.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return M1(this.toCompactHex());
    }
    toCompactHex() {
      return b(this.r) + b(this.s);
    }
  }
  const C = {
    isValidPrivateKey(D) {
      try {
        return f(D), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: f,
    /**
     * Produces cryptographically secure private key from random of size (nBitLength+64)
     * as per FIPS 186 B.4.1 with modulo bias being neglible.
     */
    randomPrivateKey: () => {
      const D = t.randomBytes(r.BYTES + 8), K = Vae(D, n);
      return b1(K, t.nByteLength);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(D = 8, K = d.BASE) {
      return K._setWindowSize(D), K.multiply(BigInt(3)), K;
    }
  };
  function I(D, K = !0) {
    return d.fromPrivateKey(D).toRawBytes(K);
  }
  function S(D) {
    const K = D instanceof Uint8Array, le = typeof D == "string", re = (K || le) && D.length;
    return K ? re === o || re === i : le ? re === 2 * o || re === 2 * i : D instanceof d;
  }
  function T(D, K, le = !0) {
    if (S(D))
      throw new Error("first arg must be private key");
    if (!S(K))
      throw new Error("second arg must be public key");
    return d.fromHex(K).multiply(f(D)).toRawBytes(le);
  }
  const A = t.bits2int || function(D) {
    const K = Nd(D), le = D.length * 8 - t.nBitLength;
    return le > 0 ? K >> BigInt(le) : K;
  }, $ = t.bits2int_modN || function(D) {
    return u(A(D));
  }, U = fC(t.nBitLength);
  function M(D) {
    if (typeof D != "bigint")
      throw new Error("bigint expected");
    if (!(Su <= D && D < U))
      throw new Error(`bigint expected < 2^${t.nBitLength}`);
    return b1(D, t.nByteLength);
  }
  function Y(D, K, le = L) {
    if (["recovered", "canonical"].some((be) => be in le))
      throw new Error("sign() legacy options not supported");
    const { hash: re, randomBytes: G } = t;
    let { lowS: q, prehash: Q, extraEntropy: se } = le;
    q == null && (q = !0), D = Ns("msgHash", D), Q && (D = Ns("prehashed msgHash", re(D)));
    const J = $(D), ye = f(K), ve = [M(ye), M(J)];
    if (se != null) {
      const be = se === !0 ? G(r.BYTES) : se;
      ve.push(Ns("extraEntropy", be, r.BYTES));
    }
    const Ee = _u(...ve), _e = J;
    function we(be) {
      const Ge = A(be);
      if (!g(Ge))
        return;
      const Le = l(Ge), Ne = d.BASE.multiply(Ge).toAffine(), Ve = u(Ne.x);
      if (Ve === Su)
        return;
      const ge = u(Le * u(_e + Ve * ye));
      if (ge === Su)
        return;
      let Te = (Ne.x === Ve ? 0 : 2) | Number(Ne.y & Mo), Oe = ge;
      return q && w(ge) && (Oe = E(ge), Te ^= 1), new O(Ve, Oe, Te);
    }
    return { seed: Ee, k2sig: we };
  }
  const L = { lowS: t.lowS, prehash: !1 }, ee = { lowS: t.lowS, prehash: !1 };
  function de(D, K, le = L) {
    const { seed: re, k2sig: G } = Y(D, K, le);
    return dF(t.hash.outputLen, t.nByteLength, t.hmac)(re, G);
  }
  d.BASE._setWindowSize(8);
  function ne(D, K, le, re = ee) {
    var G;
    const q = D;
    if (K = Ns("msgHash", K), le = Ns("publicKey", le), "strict" in re)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: Q, prehash: se } = re;
    let J, ye;
    try {
      if (typeof q == "string" || q instanceof Uint8Array)
        try {
          J = O.fromDER(q);
        } catch (Ne) {
          if (!(Ne instanceof Bp.Err))
            throw Ne;
          J = O.fromCompact(q);
        }
      else if (typeof q == "object" && typeof q.r == "bigint" && typeof q.s == "bigint") {
        const { r: Ne, s: Ve } = q;
        J = new O(Ne, Ve);
      } else
        throw new Error("PARSE");
      ye = d.fromHex(le);
    } catch (Ne) {
      if (Ne.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (Q && J.hasHighS())
      return !1;
    se && (K = t.hash(K));
    const { r: ve, s: Ee } = J, _e = $(K), we = l(Ee), be = u(_e * we), Ge = u(ve * we), Le = (G = d.BASE.multiplyAndAddUnsafe(ye, be, Ge)) == null ? void 0 : G.toAffine();
    return Le ? u(Le.x) === ve : !1;
  }
  return {
    CURVE: t,
    getPublicKey: I,
    getSharedSecret: T,
    sign: de,
    verify: ne,
    ProjectivePoint: d,
    Signature: O,
    utils: C
  };
}
function tse(e, t) {
  const r = e.ORDER;
  let n = Su;
  for (let g = r - Mo; g % Cl === Su; g /= Cl)
    n += Mo;
  const o = n, i = (r - Mo) / Cl ** o, a = (i - Mo) / Cl, u = Cl ** o - Mo, l = Cl ** (o - Mo), d = e.pow(t, i), f = e.pow(t, (i + Mo) / Cl);
  let h = (g, b) => {
    let w = d, E = e.pow(b, u), _ = e.sqr(E);
    _ = e.mul(_, b);
    let O = e.mul(g, _);
    O = e.pow(O, a), O = e.mul(O, E), E = e.mul(O, b), _ = e.mul(O, g);
    let C = e.mul(_, E);
    O = e.pow(C, l);
    let I = e.eql(O, e.ONE);
    E = e.mul(_, f), O = e.mul(C, w), _ = e.cmov(E, _, I), C = e.cmov(O, C, I);
    for (let S = o; S > 1; S--) {
      let T = Cl ** (S - Cl), A = e.pow(C, T);
      const $ = e.eql(A, e.ONE);
      E = e.mul(_, w), w = e.mul(w, w), A = e.mul(C, w), _ = e.cmov(E, _, $), C = e.cmov(A, C, $);
    }
    return { isValid: I, value: _ };
  };
  if (e.ORDER % hU === g3) {
    const g = (e.ORDER - g3) / hU, b = e.sqrt(e.neg(t));
    h = (w, E) => {
      let _ = e.sqr(E);
      const O = e.mul(w, E);
      _ = e.mul(_, O);
      let C = e.pow(_, g);
      C = e.mul(C, O);
      const I = e.mul(C, b), S = e.mul(e.sqr(C), E), T = e.eql(S, w);
      let A = e.cmov(I, C, T);
      return { isValid: T, value: A };
    };
  }
  return h;
}
function rse(e, t) {
  if (hF(e), !e.isValid(t.A) || !e.isValid(t.B) || !e.isValid(t.Z))
    throw new Error("mapToCurveSimpleSWU: invalid opts");
  const r = tse(e, t.Z);
  if (!e.isOdd)
    throw new Error("Fp.isOdd is not implemented!");
  return (n) => {
    let o, i, a, u, l, d, f, h;
    o = e.sqr(n), o = e.mul(o, t.Z), i = e.sqr(o), i = e.add(i, o), a = e.add(i, e.ONE), a = e.mul(a, t.B), u = e.cmov(t.Z, e.neg(i), !e.eql(i, e.ZERO)), u = e.mul(u, t.A), i = e.sqr(a), d = e.sqr(u), l = e.mul(d, t.A), i = e.add(i, l), i = e.mul(i, a), d = e.mul(d, u), l = e.mul(d, t.B), i = e.add(i, l), f = e.mul(o, a);
    const { isValid: g, value: b } = r(i, d);
    h = e.mul(o, n), h = e.mul(h, b), f = e.cmov(f, a, g), h = e.cmov(h, b, g);
    const w = e.isOdd(n) === e.isOdd(h);
    return h = e.cmov(e.neg(h), h, w), f = e.div(f, u), { x: f, y: h };
  };
}
function nse(e) {
  if (e instanceof Uint8Array)
    return e;
  if (typeof e == "string")
    return J5(e);
  throw new Error("DST must be Uint8Array or string");
}
const ose = Nd;
function _d(e, t) {
  if (e < 0 || e >= 1 << 8 * t)
    throw new Error(`bad I2OSP call: value=${e} length=${t}`);
  const r = Array.from({ length: t }).fill(0);
  for (let n = t - 1; n >= 0; n--)
    r[n] = e & 255, e >>>= 8;
  return new Uint8Array(r);
}
function ise(e, t) {
  const r = new Uint8Array(e.length);
  for (let n = 0; n < e.length; n++)
    r[n] = e[n] ^ t[n];
  return r;
}
function bw(e) {
  if (!(e instanceof Uint8Array))
    throw new Error("Uint8Array expected");
}
function hC(e) {
  if (!Number.isSafeInteger(e))
    throw new Error("number expected");
}
function ase(e, t, r, n) {
  bw(e), bw(t), hC(r), t.length > 255 && (t = n(_u(J5("H2C-OVERSIZE-DST-"), t)));
  const { outputLen: o, blockLen: i } = n, a = Math.ceil(r / o);
  if (a > 255)
    throw new Error("Invalid xmd length");
  const u = _u(t, _d(t.length, 1)), l = _d(0, i), d = _d(r, 2), f = new Array(a), h = n(_u(l, e, d, _d(0, 1), u));
  f[0] = n(_u(h, _d(1, 1), u));
  for (let g = 1; g <= a; g++) {
    const b = [ise(h, f[g - 1]), _d(g + 1, 1), u];
    f[g] = n(_u(...b));
  }
  return _u(...f).slice(0, r);
}
function sse(e, t, r, n, o) {
  if (bw(e), bw(t), hC(r), t.length > 255) {
    const i = Math.ceil(2 * n / 8);
    t = o.create({ dkLen: i }).update(J5("H2C-OVERSIZE-DST-")).update(t).digest();
  }
  if (r > 65535 || t.length > 255)
    throw new Error("expand_message_xof: invalid lenInBytes");
  return o.create({ dkLen: r }).update(e).update(_d(r, 2)).update(t).update(_d(t.length, 1)).digest();
}
function pU(e, t, r) {
  bg(r, {
    DST: "string",
    p: "bigint",
    m: "isSafeInteger",
    k: "isSafeInteger",
    hash: "hash"
  });
  const { p: n, k: o, m: i, hash: a, expand: u, DST: l } = r;
  bw(e), hC(t);
  const d = nse(l), f = n.toString(2).length, h = Math.ceil((f + o) / 8), g = t * i * h;
  let b;
  if (u === "xmd")
    b = ase(e, d, g, a);
  else if (u === "xof")
    b = sse(e, d, g, o, a);
  else if (u === void 0)
    b = e;
  else
    throw new Error('expand must be "xmd", "xof" or undefined');
  const w = new Array(t);
  for (let E = 0; E < t; E++) {
    const _ = new Array(i);
    for (let O = 0; O < i; O++) {
      const C = h * (O + E * i), I = b.subarray(C, C + h);
      _[O] = Ri(ose(I), n);
    }
    w[E] = _;
  }
  return w;
}
function use(e, t) {
  const r = t.map((n) => Array.from(n).reverse());
  return (n, o) => {
    const [i, a, u, l] = r.map((d) => d.reduce((f, h) => e.add(e.mul(f, n), h)));
    return n = e.div(i, a), o = e.mul(o, e.div(u, l)), { x: n, y: o };
  };
}
function cse(e, t, r) {
  if (typeof t != "function")
    throw new Error("mapToCurve() must be defined");
  return {
    // Encodes byte string to elliptic curve
    // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-3
    hashToCurve(n, o) {
      const i = pU(n, 2, { ...r, DST: r.DST, ...o }), a = e.fromAffine(t(i[0])), u = e.fromAffine(t(i[1])), l = a.add(u).clearCofactor();
      return l.assertValidity(), l;
    },
    // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-3
    encodeToCurve(n, o) {
      const i = pU(n, 1, { ...r, DST: r.encodeDST, ...o }), a = e.fromAffine(t(i[0])).clearCofactor();
      return a.assertValidity(), a;
    }
  };
}
let mF = class extends aF {
  constructor(e, t) {
    super(), this.finished = !1, this.destroyed = !1, Cp.hash(e);
    const r = sC(t);
    if (this.iHash = e.create(), typeof this.iHash.update != "function")
      throw new TypeError("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const n = this.blockLen, o = new Uint8Array(n);
    o.set(r.length > n ? e.create().update(r).digest() : r);
    for (let i = 0; i < o.length; i++)
      o[i] ^= 54;
    this.iHash.update(o), this.oHash = e.create();
    for (let i = 0; i < o.length; i++)
      o[i] ^= 106;
    this.oHash.update(o), o.fill(0);
  }
  update(e) {
    return Cp.exists(this), this.iHash.update(e), this;
  }
  digestInto(e) {
    Cp.exists(this), Cp.bytes(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
  }
  digest() {
    const e = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(e), e;
  }
  _cloneInto(e) {
    e || (e = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: t, iHash: r, finished: n, destroyed: o, blockLen: i, outputLen: a } = this;
    return e = e, e.finished = n, e.destroyed = o, e.blockLen = i, e.outputLen = a, e.oHash = t._cloneInto(e.oHash), e.iHash = r._cloneInto(e.iHash), e;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
};
const yF = (e, t, r) => new mF(e, t).update(r).digest();
yF.create = (e, t) => new mF(e, t);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function lse(e) {
  return {
    hash: e,
    hmac: (t, ...r) => yF(e, t, Eae(...r)),
    randomBytes: _ae
  };
}
function fse(e, t) {
  const r = (n) => ese({ ...e, ...lse(n) });
  return Object.freeze({ ...r(t), create: r });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const bF = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), gU = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), dse = BigInt(1), LI = BigInt(2), mU = (e, t) => (e + t / LI) / t;
function hse(e) {
  const t = bF, r = BigInt(3), n = BigInt(6), o = BigInt(11), i = BigInt(22), a = BigInt(23), u = BigInt(44), l = BigInt(88), d = e * e * e % t, f = d * d * e % t, h = As(f, r, t) * f % t, g = As(h, r, t) * f % t, b = As(g, LI, t) * d % t, w = As(b, o, t) * b % t, E = As(w, i, t) * w % t, _ = As(E, u, t) * E % t, O = As(_, l, t) * _ % t, C = As(O, u, t) * E % t, I = As(C, r, t) * f % t, S = As(I, a, t) * w % t, T = As(S, n, t) * d % t, A = As(T, LI, t);
  if (!zd.eql(zd.sqr(A), e))
    throw new Error("Cannot find square root");
  return A;
}
const zd = pF(bF, void 0, void 0, { sqrt: hse }), sf = fse({
  a: BigInt(0),
  b: BigInt(7),
  Fp: zd,
  n: gU,
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  lowS: !0,
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (e) => {
      const t = gU, r = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), n = -dse * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), o = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), i = r, a = BigInt("0x100000000000000000000000000000000"), u = mU(i * e, t), l = mU(-n * e, t);
      let d = Ri(e - u * r - l * o, t), f = Ri(-u * n - l * i, t);
      const h = d > a, g = f > a;
      if (h && (d = t - d), g && (f = t - f), d > a || f > a)
        throw new Error("splitScalar: Endomorphism failed, k=" + e);
      return { k1neg: h, k1: d, k2neg: g, k2: f };
    }
  }
}, cF);
BigInt(0);
sf.ProjectivePoint;
sf.utils.randomPrivateKey;
const pse = use(zd, [
  // xNum
  [
    "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
    "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
    "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
    "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
  ],
  // xDen
  [
    "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
    "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
    "0x0000000000000000000000000000000000000000000000000000000000000001"
    // LAST 1
  ],
  // yNum
  [
    "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
    "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
    "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
    "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
  ],
  // yDen
  [
    "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
    "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
    "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
    "0x0000000000000000000000000000000000000000000000000000000000000001"
    // LAST 1
  ]
].map((e) => e.map((t) => BigInt(t)))), gse = rse(zd, {
  A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
  B: BigInt("1771"),
  Z: zd.create(BigInt("-11"))
});
cse(sf.ProjectivePoint, (e) => {
  const { x: t, y: r } = gse(zd.create(e[0]));
  return pse(t, r);
}, {
  DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
  encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
  p: zd.ORDER,
  m: 1,
  k: 128,
  expand: "xmd",
  hash: cF
});
function HI(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function mse(e) {
  if (typeof e != "boolean")
    throw new Error(`Expected boolean, not ${e}`);
}
function wF(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new TypeError(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function yse(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  HI(e.outputLen), HI(e.blockLen);
}
function bse(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function wse(e, t) {
  wF(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error(`digestInto() expects output buffer of length at least ${r}`);
}
const vse = {
  number: HI,
  bool: mse,
  bytes: wF,
  hash: yse,
  exists: bse,
  output: wse
};
var qS = vse;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const VS = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), oc = (e, t) => e << 32 - t | e >>> t, Ese = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!Ese)
  throw new Error("Non little-endian hardware is not supported");
Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function _se(e) {
  if (typeof e != "string")
    throw new TypeError(`utf8ToBytes expected string, got ${typeof e}`);
  return new TextEncoder().encode(e);
}
function vF(e) {
  if (typeof e == "string" && (e = _se(e)), !(e instanceof Uint8Array))
    throw new TypeError(`Expected input type is Uint8Array (got ${typeof e})`);
  return e;
}
let Ase = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function EF(e) {
  const t = (n) => e().update(vF(n)).digest(), r = e();
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = () => e(), t;
}
function xse(e, t, r, n) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, r, n);
  const o = BigInt(32), i = BigInt(4294967295), a = Number(r >> o & i), u = Number(r & i), l = n ? 4 : 0, d = n ? 0 : 4;
  e.setUint32(t + l, a, n), e.setUint32(t + d, u, n);
}
let kse = class extends Ase {
  constructor(t, r, n, o) {
    super(), this.blockLen = t, this.outputLen = r, this.padOffset = n, this.isLE = o, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = VS(this.buffer);
  }
  update(t) {
    qS.exists(this);
    const { view: r, buffer: n, blockLen: o } = this;
    t = vF(t);
    const i = t.length;
    for (let a = 0; a < i; ) {
      const u = Math.min(o - this.pos, i - a);
      if (u === o) {
        const l = VS(t);
        for (; o <= i - a; a += o)
          this.process(l, a);
        continue;
      }
      n.set(t.subarray(a, a + u), this.pos), this.pos += u, a += u, this.pos === o && (this.process(r, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    qS.exists(this), qS.output(t, this), this.finished = !0;
    const { buffer: r, view: n, blockLen: o, isLE: i } = this;
    let { pos: a } = this;
    r[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > o - a && (this.process(n, 0), a = 0);
    for (let h = a; h < o; h++)
      r[h] = 0;
    xse(n, o - 8, BigInt(this.length * 8), i), this.process(n, 0);
    const u = VS(t), l = this.outputLen;
    if (l % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const d = l / 4, f = this.get();
    if (d > f.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let h = 0; h < d; h++)
      u.setUint32(4 * h, f[h], i);
  }
  digest() {
    const { buffer: t, outputLen: r } = this;
    this.digestInto(t);
    const n = t.slice(0, r);
    return this.destroy(), n;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: r, buffer: n, length: o, finished: i, destroyed: a, pos: u } = this;
    return t.length = o, t.pos = u, t.finished = i, t.destroyed = a, o % r && t.buffer.set(n), t;
  }
};
const Sse = (e, t, r) => e & t ^ ~e & r, Tse = (e, t, r) => e & t ^ e & r ^ t & r, Ise = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), jf = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), Lf = new Uint32Array(64);
let _F = class extends kse {
  constructor() {
    super(64, 32, 8, !1), this.A = jf[0] | 0, this.B = jf[1] | 0, this.C = jf[2] | 0, this.D = jf[3] | 0, this.E = jf[4] | 0, this.F = jf[5] | 0, this.G = jf[6] | 0, this.H = jf[7] | 0;
  }
  get() {
    const { A: e, B: t, C: r, D: n, E: o, F: i, G: a, H: u } = this;
    return [e, t, r, n, o, i, a, u];
  }
  // prettier-ignore
  set(e, t, r, n, o, i, a, u) {
    this.A = e | 0, this.B = t | 0, this.C = r | 0, this.D = n | 0, this.E = o | 0, this.F = i | 0, this.G = a | 0, this.H = u | 0;
  }
  process(e, t) {
    for (let f = 0; f < 16; f++, t += 4)
      Lf[f] = e.getUint32(t, !1);
    for (let f = 16; f < 64; f++) {
      const h = Lf[f - 15], g = Lf[f - 2], b = oc(h, 7) ^ oc(h, 18) ^ h >>> 3, w = oc(g, 17) ^ oc(g, 19) ^ g >>> 10;
      Lf[f] = w + Lf[f - 7] + b + Lf[f - 16] | 0;
    }
    let { A: r, B: n, C: o, D: i, E: a, F: u, G: l, H: d } = this;
    for (let f = 0; f < 64; f++) {
      const h = oc(a, 6) ^ oc(a, 11) ^ oc(a, 25), g = d + h + Sse(a, u, l) + Ise[f] + Lf[f] | 0, b = (oc(r, 2) ^ oc(r, 13) ^ oc(r, 22)) + Tse(r, n, o) | 0;
      d = l, l = u, u = a, a = i + g | 0, i = o, o = n, n = r, r = g + b | 0;
    }
    r = r + this.A | 0, n = n + this.B | 0, o = o + this.C | 0, i = i + this.D | 0, a = a + this.E | 0, u = u + this.F | 0, l = l + this.G | 0, d = d + this.H | 0, this.set(r, n, o, i, a, u, l, d);
  }
  roundClean() {
    Lf.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}, Ose = class extends _F {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
};
const FI = EF(() => new _F());
EF(() => new Ose());
function Pse(e, t) {
  if (e.length > t)
    throw new TypeError(`Data is larger than array size: ${e.length} > ${t}`);
}
function Cse(e) {
  if (e.match(/[^a-fA-f0-9]/) !== null)
    throw new TypeError("Invalid characters in hex string: " + e);
  if (e.length % 2 !== 0)
    throw new Error(`Length of hex string is invalid: ${e.length}`);
}
function Bse(e) {
  if (e > Number.MAX_SAFE_INTEGER)
    throw new TypeError("Number exceeds safe bounds!");
}
const { getRandomValues: Nse } = crypto ?? globalThis.crypto ?? window.crypto;
function $se(e = 32) {
  if (typeof Nse == "function")
    return crypto.getRandomValues(new Uint8Array(e));
  throw new Error("Crypto module missing getRandomValues!");
}
function Use(e, t, r = "be") {
  t === void 0 && (t = e.length), Pse(e, t);
  const n = new Uint8Array(t).fill(0), o = r === "be" ? 0 : t - e.length;
  return n.set(e, o), n;
}
function AF(e) {
  let t, r = 0;
  const n = e.reduce((i, a) => i + a.length, 0), o = new Uint8Array(n);
  for (t = 0; t < e.length; t++) {
    const i = e[t];
    o.set(i, r), r += i.length;
  }
  return o;
}
const Rse = new TextEncoder(), zse = [
  {
    name: "base58",
    charset: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
  }
];
function xF(e) {
  for (const t of zse)
    if (t.name === e)
      return t.charset;
  throw TypeError("Charset does not exist: " + e);
}
function jse(e, t, r = !1) {
  typeof e == "string" && (e = Rse.encode(e));
  const n = xF(t), o = n.length, i = [];
  let a = "", u, l = 0, d, f;
  for (u = 0; u < e.length; u++)
    for (l = 0, d = e[u], a += d > 0 || (a.length ^ u) > 0 ? "" : "1"; l in i || d > 0; )
      f = i[l], f = f > 0 ? f * 256 + d : d, d = f / o | 0, i[l] = f % o, l++;
  for (; l-- > 0; )
    a += n[i[l]];
  return r && a.length % 4 > 0 ? a + "=".repeat(4 - a.length % 4) : a;
}
function Lse(e, t) {
  const r = xF(t), n = r.length, o = [], i = [];
  e = e.replace("=", "");
  let a, u = 0, l, d;
  for (a = 0; a < e.length; a++) {
    if (u = 0, l = r.indexOf(e[a]), l < 0)
      throw new Error(`Character range out of bounds: ${l}`);
    for (l > 0 || (i.length ^ a) > 0 || i.push(0); u in o || l > 0; )
      d = o[u], d = d > 0 ? d * n + l : l, l = d >> 8, o[u] = d % 256, u++;
  }
  for (; u-- > 0; )
    i.push(o[u]);
  return new Uint8Array(i);
}
function kF(e) {
  return FI(FI(e));
}
function Hse(e) {
  const t = kF(e);
  return AF([e, t.slice(0, 4)]);
}
function Fse(e) {
  const t = e.slice(0, -4), r = e.slice(-4);
  if (kF(t).slice(0, 4).toString() !== r.toString())
    throw new Error("Invalid checksum!");
  return t;
}
const yU = {
  encode: jse,
  decode: Lse
}, SF = {
  encode: (e) => {
    const t = Hse(e);
    return yU.encode(t, "base58");
  },
  decode: (e) => {
    const t = yU.decode(e, "base58");
    return Fse(t);
  }
}, TF = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", Mse = [996825010, 642813549, 513874426, 1027748829, 705979059], m3 = [
  { version: 0, name: "bech32", const: 1 },
  { version: 1, name: "bech32m", const: 734539939 }
];
function IF(e) {
  let t = 1;
  for (let r = 0; r < e.length; ++r) {
    const n = t >> 25;
    t = (t & 33554431) << 5 ^ e[r];
    for (let o = 0; o < 5; ++o)
      n >> o & 1 && (t ^= Mse[o]);
  }
  return t;
}
function OF(e) {
  const t = [];
  let r;
  for (r = 0; r < e.length; ++r)
    t.push(e.charCodeAt(r) >> 5);
  for (t.push(0), r = 0; r < e.length; ++r)
    t.push(e.charCodeAt(r) & 31);
  return t;
}
function Dse(e, t, r) {
  const n = OF(e).concat(t);
  return IF(n) === r.const;
}
function Kse(e, t, r) {
  const n = OF(e).concat(t).concat([0, 0, 0, 0, 0, 0]), o = IF(n) ^ r.const, i = [];
  for (let a = 0; a < 6; ++a)
    i.push(o >> 5 * (5 - a) & 31);
  return i;
}
function PF(e, t, r, n = !0) {
  const o = [];
  let i = 0, a = 0;
  const u = (1 << r) - 1, l = (1 << t + r - 1) - 1;
  for (const d of e) {
    if (d < 0 || d >> t > 0)
      throw new Error("Failed to perform base conversion. Invalid value: " + String(d));
    for (i = (i << t | d) & l, a += t; a >= r; )
      a -= r, o.push(i >> a & u);
  }
  if (n)
    a > 0 && o.push(i << r - a & u);
  else if (a >= t || (i << r - a & u) > 0)
    throw new Error("Failed to perform base conversion. Invalid Size!");
  return o;
}
function qse(e, t, r) {
  const n = t.concat(Kse(e, t, r));
  let o = e + "1";
  for (let i = 0; i < n.length; ++i)
    o += TF.charAt(n[i]);
  return o;
}
function CF(e) {
  if (!Vse(e))
    throw new Error("Encoded string goes out of bounds!");
  if (e = e.toLowerCase(), !Gse(e))
    throw new Error("Encoded string has invalid separator!");
  const t = [], r = e.lastIndexOf("1"), n = e.substring(0, r);
  for (let i = r + 1; i < e.length; ++i) {
    const a = TF.indexOf(e.charAt(i));
    if (a === -1)
      throw new Error("Character idx out of bounds: " + String(i));
    t.push(a);
  }
  const o = m3.find((i) => i.version === t[0]) ?? m3[0];
  if (!Dse(n, t, o))
    throw new Error("Checksum verification failed!");
  return [n, t.slice(0, t.length - 6)];
}
function Vse(e) {
  let t, r, n = !1, o = !1;
  for (t = 0; t < e.length; ++t) {
    if (r = e.charCodeAt(t), r < 33 || r > 126)
      return !1;
    r >= 97 && r <= 122 && (n = !0), r >= 65 && r <= 90 && (o = !0);
  }
  return !(n && o);
}
function Gse(e) {
  const t = e.lastIndexOf("1");
  return !(t < 1 || t + 7 > e.length || e.length > 90);
}
function Wse(e, t = "bc", r = 0) {
  const n = [r, ...PF([...e], 8, 5)], o = m3.find((a) => a.version === r) ?? m3[0], i = qse(t, n, o);
  return BF(i), i;
}
function BF(e) {
  e = e.toLowerCase();
  const t = e.split("1", 1)[0], [r, n] = CF(e), o = PF(n.slice(1), 5, 8, !1), i = o.length;
  switch (!0) {
    case t !== r:
      throw new Error("Returned hrp string is invalid.");
    case (o === null || i < 2 || i > 40):
      throw new Error("Decoded string is invalid or out of spec.");
    case n[0] > 16:
      throw new Error("Returned version bit is out of range.");
    default:
      return Uint8Array.from(o);
  }
}
function Zse(e) {
  e = e.toLowerCase();
  const [t, r] = CF(e);
  return r[0];
}
const NF = {
  encode: Wse,
  decode: BF,
  version: Zse
}, $F = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", UF = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", Xse = new TextEncoder();
function RF(e, t = !1, r = !0) {
  typeof e == "string" && (e = Xse.encode(e));
  const n = t ? UF : $F;
  let o = "", i = 0, a = 0;
  for (let u = 0; u < e.length; u++)
    for (a = a << 8 | e[u], i += 8; i >= 6; )
      i -= 6, o += n[a >> i & 63];
  if (i > 0)
    for (a <<= 6 - i, o += n[a & 63]; i < 6; )
      o += r ? "=" : "", i += 2;
  return o;
}
function zF(e, t = !1) {
  const r = t || e.includes("-") || e.includes("_") ? UF.split("") : $F.split("");
  e = e.replace(/=+$/, "");
  const n = e.split("");
  let o = 0, i = 0;
  const a = [];
  for (let u = 0; u < n.length; u++) {
    const l = n[u], d = r.indexOf(l);
    if (d === -1)
      throw new Error("Invalid character: " + l);
    o += 6, i <<= 6, i |= d, o >= 8 && (o -= 8, a.push(i >>> o & 255));
  }
  return new Uint8Array(a);
}
const jF = {
  encode: RF,
  decode: zF
}, LF = {
  encode: (e) => RF(e, !0, !1),
  decode: (e) => zF(e, !0)
}, Yse = BigInt(0), Jse = BigInt(255), HF = BigInt(256);
function Qse(e) {
  if (e <= 0xffn)
    return 1;
  if (e <= 0xffffn)
    return 2;
  if (e <= 0xffffffffn)
    return 4;
  if (e <= 0xffffffffffffffffn)
    return 8;
  if (e <= 0xffffffffffffffffffffffffffffffffn)
    return 16;
  if (e <= 0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffn)
    return 32;
  throw new TypeError("Must specify a fixed buffer size for bigints greater than 32 bytes.");
}
function eue(e, t, r = "be") {
  t === void 0 && (t = Qse(e));
  const n = r === "le", o = new ArrayBuffer(t), i = new DataView(o);
  let a = n ? 0 : t - 1;
  for (; e > Yse; ) {
    const u = e & Jse, l = Number(u);
    n ? i.setUint8(a++, l) : i.setUint8(a--, l), e = (e - u) / HF;
  }
  return new Uint8Array(o);
}
function tue(e) {
  let t = BigInt(0);
  for (let r = e.length - 1; r >= 0; r--)
    t = t * HF + BigInt(e[r]);
  return BigInt(t);
}
function rue(e) {
  const t = e.split("").map(Number);
  if (t.length % 8 !== 0)
    throw new Error(`Binary array is invalid length: ${e.length}`);
  const r = new Uint8Array(t.length / 8);
  for (let n = 0, o = 0; n < t.length; n += 8, o++) {
    let i = 0;
    for (let a = 0; a < 8; a++)
      i |= t[n + a] << 7 - a;
    r[o] = i;
  }
  return r;
}
function nue(e) {
  const t = new Array(e.length * 8);
  let r = 0;
  for (const n of e) {
    if (n > 255)
      throw new Error(`Invalid byte value: ${n}. Byte values must be between 0 and 255.`);
    for (let o = 7; o >= 0; o--, r++)
      t[r] = n >> o & 1;
  }
  return t.join("");
}
function oue(e) {
  if (e <= 255)
    return 1;
  if (e <= 65535)
    return 2;
  if (e <= 4294967295)
    return 4;
  throw new TypeError("Numbers larger than 4 bytes must specify a fixed size!");
}
function iue(e, t, r = "be") {
  t === void 0 && (t = oue(e));
  const n = r === "le", o = new ArrayBuffer(t), i = new DataView(o);
  let a = n ? 0 : t - 1;
  for (; e > 0; ) {
    const u = e & 255;
    n ? i.setUint8(a++, e) : i.setUint8(a--, e), e = (e - u) / 256;
  }
  return new Uint8Array(o);
}
function aue(e) {
  let t = 0;
  for (let r = e.length - 1; r >= 0; r--)
    t = t * 256 + e[r], Bse(t);
  return t;
}
const sue = new TextEncoder(), uue = new TextDecoder();
function pC(e) {
  return sue.encode(e);
}
function MI(e) {
  return uue.decode(e);
}
function cue(e, t) {
  Cse(e);
  const r = e.length / 2;
  if (t === void 0 && (t = r), r > t)
    throw new TypeError(`Hex string is larger than array size: ${r} > ${t}`);
  return t;
}
function lue(e, t, r = "le") {
  t = cue(e, t);
  const n = r === "le", o = new ArrayBuffer(t), i = new DataView(o);
  let a = n ? 0 : t - 1;
  for (let u = 0; u < e.length; u += 2) {
    const l = e.substring(u, u + 2), d = parseInt(l, 16);
    n ? i.setUint8(a++, d) : i.setUint8(a--, d);
  }
  return new Uint8Array(o);
}
function fue(e) {
  let t = "";
  for (let r = 0; r < e.length; r++)
    t += e[r].toString(16).padStart(2, "0");
  return t;
}
function due(e) {
  const t = JSON.stringify(e, (r, n) => typeof n == "bigint" ? `${n}n` : n);
  return pC(t);
}
function hue(e, t, r) {
  if (e instanceof ArrayBuffer)
    return new Uint8Array(e);
  if (e instanceof Uint8Array)
    return Use(e, t, r);
  if (typeof e == "string")
    return lue(e, t, r);
  if (typeof e == "bigint")
    return eue(e, t, r);
  if (typeof e == "number")
    return iue(e, t, r);
  if (typeof e == "boolean")
    return Uint8Array.of(e ? 1 : 0);
  throw TypeError("Unsupported format:" + typeof e);
}
const ra = class Hn extends Uint8Array {
  static random(t = 32) {
    const r = $se(t);
    return new Hn(r, t);
  }
  constructor(t, r, n) {
    const o = hue(t, r, n);
    super(o);
  }
  get arr() {
    return [...this];
  }
  get num() {
    return this.toNum();
  }
  get big() {
    return this.toBig();
  }
  get str() {
    return this.toStr();
  }
  get hex() {
    return this.toHex();
  }
  get raw() {
    return new Uint8Array(this);
  }
  get bin() {
    return this.toBin();
  }
  get b58chk() {
    return this.tob58chk();
  }
  get base64() {
    return this.toBase64();
  }
  get b64url() {
    return this.toB64url();
  }
  get digest() {
    return this.toHash();
  }
  get id() {
    return this.toHash().hex;
  }
  get stream() {
    return new Sue(this);
  }
  toNum(t = "be") {
    const r = t === "be" ? this.reverse() : this;
    return aue(r);
  }
  toBin() {
    return nue(this);
  }
  toBig(t = "be") {
    const r = t === "be" ? this.reverse() : this;
    return tue(r);
  }
  toHash() {
    const t = FI(this);
    return new Hn(t);
  }
  toJson() {
    const t = MI(this);
    return JSON.parse(t);
  }
  toBech32(t, r = 0) {
    return NF.encode(this, t, r);
  }
  toStr() {
    return MI(this);
  }
  toHex() {
    return fue(this);
  }
  toBytes() {
    return new Uint8Array(this);
  }
  tob58chk() {
    return SF.encode(this);
  }
  toBase64() {
    return jF.encode(this);
  }
  toB64url() {
    return LF.encode(this);
  }
  prepend(t) {
    return Hn.join([Hn.bytes(t), this]);
  }
  append(t) {
    return Hn.join([this, Hn.bytes(t)]);
  }
  slice(t, r) {
    const n = new Uint8Array(this).slice(t, r);
    return new Hn(n);
  }
  subarray(t, r) {
    const n = new Uint8Array(this).subarray(t, r);
    return new Hn(n);
  }
  reverse() {
    const t = new Uint8Array(this).reverse();
    return new Hn(t);
  }
  write(t, r) {
    const n = Hn.bytes(t);
    this.set(n, r);
  }
  prefixSize(t) {
    const r = Hn.varInt(this.length, t);
    return Hn.join([r, this]);
  }
  static from(t) {
    return new Hn(Uint8Array.from(t));
  }
  static of(...t) {
    return new Hn(Uint8Array.of(...t));
  }
  static join(t) {
    const r = t.map((o) => Hn.bytes(o)), n = AF(r);
    return new Hn(n);
  }
  static varInt(t, r) {
    if (t < 253)
      return Hn.num(t, 1);
    if (t < 65536)
      return Hn.of(253, ...Hn.num(t, 2, r));
    if (t < 4294967296)
      return Hn.of(254, ...Hn.num(t, 4, r));
    if (BigInt(t) < 0x10000000000000000n)
      return Hn.of(255, ...Hn.num(t, 8, r));
    throw new Error(`Value is too large: ${t}`);
  }
};
ra.num = pue, ra.big = mue, ra.bin = gue, ra.raw = yue, ra.str = bue, ra.hex = wue, ra.bytes = vue, ra.json = Eue, ra.base64 = _ue, ra.b64url = Aue, ra.bech32 = xue, ra.b58chk = kue, ra.encode = pC, ra.decode = MI;
let rr = ra;
function pue(e, t, r) {
  return new rr(e, t, r);
}
function gue(e, t, r) {
  return new rr(rue(e), t, r);
}
function mue(e, t, r) {
  return new rr(e, t, r);
}
function yue(e, t, r) {
  return new rr(e, t, r);
}
function bue(e, t, r) {
  return new rr(pC(e), t, r);
}
function wue(e, t, r) {
  return new rr(e, t, r);
}
function vue(e, t, r) {
  return new rr(e, t, r);
}
function Eue(e) {
  return new rr(due(e));
}
function _ue(e) {
  return new rr(jF.decode(e));
}
function Aue(e) {
  return new rr(LF.decode(e));
}
function xue(e) {
  return new rr(NF.decode(e));
}
function kue(e) {
  return new rr(SF.decode(e));
}
let Sue = class {
  constructor(t) {
    this.data = rr.bytes(t), this.size = this.data.length;
  }
  peek(t) {
    if (t > this.size)
      throw new Error(`Size greater than stream: ${t} > ${this.size}`);
    return new rr(this.data.slice(0, t));
  }
  read(t) {
    t = t ?? this.readSize();
    const r = this.peek(t);
    return this.data = this.data.slice(t), this.size = this.data.length, r;
  }
  readSize(t) {
    const r = this.read(1).num;
    switch (!0) {
      case (r >= 0 && r < 253):
        return r;
      case r === 253:
        return this.read(2).toNum(t);
      case r === 254:
        return this.read(4).toNum(t);
      case r === 255:
        return this.read(8).toNum(t);
      default:
        throw new Error(`Varint is out of range: ${r}`);
    }
  }
};
const y3 = sf.CURVE, gC = y3.n, Tue = y3.p, Iue = { x: y3.Gx, y: y3.Gy }, Oue = BigInt(0);
BigInt(1);
BigInt(2);
BigInt(3);
BigInt(4);
const DI = { N: gC, P: Tue, G: Iue, _0n: Oue }, Ib = pF(gC, 32, !0), FF = (e) => Ri(e, gC);
function mC(e, t = !1) {
  if (t)
    throw new Error(e);
  return !1;
}
function MF(e) {
  return rr.random(e);
}
function Pue(e) {
  const t = rr.bytes(e).big;
  return rr.big(FF(t), 32);
}
var Cue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  fail: mC,
  mod_bytes: Pue,
  random: MF
});
const { N: Bue, _0n: Nue } = DI;
function $ue(e, t, r) {
  const n = rr.bytes(e);
  return n.length !== t ? mC(`Invalid byte size: ${n.hex} !== ${t}`, r) : !0;
}
function Uue(e, t) {
  return typeof e == "bigint" && Nue < e && e < Bue || mC("x value is not in the field!", t), !0;
}
const bU = sf.ProjectivePoint;
var mo;
let la = (mo = class extends Uint8Array {
  static mod(e) {
    return new mo(e);
  }
  static is_valid(e, t) {
    const r = rr.bytes(e, 32).big;
    return Uue(r, t);
  }
  constructor(e) {
    let t = Rue(e);
    t = FF(t), mo.is_valid(t, !0), super(rr.big(t, 32), 32);
  }
  get buff() {
    return new rr(this);
  }
  get raw() {
    return this.buff.raw;
  }
  get big() {
    return this.buff.big;
  }
  get hex() {
    return this.buff.hex;
  }
  get point() {
    return this.generate();
  }
  get hasOddY() {
    return this.point.hasOddY;
  }
  get negated() {
    return this.hasOddY ? this.negate() : this;
  }
  gt(e) {
    return new mo(e).big > this.big;
  }
  lt(e) {
    return new mo(e).big < this.big;
  }
  eq(e) {
    return new mo(e).big === this.big;
  }
  ne(e) {
    return new mo(e).big !== this.big;
  }
  add(e) {
    const t = mo.mod(e), r = Ib.add(this.big, t.big);
    return new mo(r);
  }
  sub(e) {
    const t = mo.mod(e), r = Ib.sub(this.big, t.big);
    return new mo(r);
  }
  mul(e) {
    const t = mo.mod(e), r = Ib.mul(this.big, t.big);
    return new mo(r);
  }
  pow(e) {
    const t = mo.mod(e), r = Ib.pow(this.big, t.big);
    return new mo(r);
  }
  div(e) {
    const t = mo.mod(e), r = Ib.div(this.big, t.big);
    return new mo(r);
  }
  negate() {
    return new mo(mo.N - this.big);
  }
  generate() {
    const e = sf.ProjectivePoint.BASE.multiply(this.big);
    return A0.import(e);
  }
}, mo.N = sf.CURVE.n, mo);
var jn;
let A0 = (jn = class {
  static from_x(e) {
    let t = zue(e);
    t.length === 32 && (t = t.prepend(2)), $ue(t, 33);
    const r = bU.fromHex(t.hex);
    return r.assertValidity(), new jn(r.x, r.y);
  }
  static generate(e) {
    const t = la.mod(e), r = jn.base.multiply(t.big);
    return jn.import(r);
  }
  static import(e) {
    const t = e instanceof jn ? { x: e.x.big, y: e.y.big } : { x: e.x, y: e.y };
    return new jn(t.x, t.y);
  }
  constructor(e, t) {
    this._p = new bU(e, t, 1n), this.p.assertValidity();
  }
  get p() {
    return this._p;
  }
  get x() {
    return rr.big(this.p.x, 32);
  }
  get y() {
    return rr.big(this.p.y, 32);
  }
  get buff() {
    return rr.raw(this.p.toRawBytes(!0));
  }
  get raw() {
    return this.buff.raw;
  }
  get hex() {
    return this.buff.hex;
  }
  get hasEvenY() {
    return this.p.hasEvenY();
  }
  get hasOddY() {
    return !this.p.hasEvenY();
  }
  eq(e) {
    const t = e instanceof jn ? e : jn.from_x(e);
    return this.x.big === t.x.big && this.y.big === t.y.big;
  }
  add(e) {
    return e instanceof jn ? jn.import(this.p.add(e.p)) : jn.import(this.p.add(jn.generate(e).p));
  }
  sub(e) {
    return e instanceof jn ? jn.import(this.p.subtract(e.p)) : jn.import(this.p.subtract(jn.generate(e).p));
  }
  mul(e) {
    return e instanceof jn ? jn.import(this.p.multiply(e.x.big)) : jn.import(this.p.multiply(la.mod(e).big));
  }
  negate() {
    return jn.import(this.p.negate());
  }
}, jn.P = DI.P, jn.G = DI.G, jn.base = sf.ProjectivePoint.BASE, jn);
function Rue(e) {
  if (e instanceof la)
    return e.big;
  if (e instanceof A0)
    return e.x.big;
  if (e instanceof Uint8Array)
    return rr.raw(e).big;
  if (typeof e == "string")
    return rr.hex(e).big;
  if (typeof e == "number")
    return rr.num(e).big;
  if (typeof e == "bigint")
    return BigInt(e);
  throw TypeError("Invalid input type:" + typeof e);
}
function zue(e) {
  if (e instanceof la)
    return e.point.buff;
  if (e instanceof A0)
    return e.buff;
  if (e instanceof Uint8Array || typeof e == "string")
    return rr.bytes(e);
  if (typeof e == "number" || typeof e == "bigint")
    return rr.bytes(e, 32);
  throw new TypeError(`Unknown type: ${typeof e}`);
}
function KI(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function jue(e) {
  if (typeof e != "boolean")
    throw new Error(`Expected boolean, not ${e}`);
}
function DF(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function Lue(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  KI(e.outputLen), KI(e.blockLen);
}
function Hue(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function Fue(e, t) {
  DF(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error(`digestInto() expects output buffer of length at least ${r}`);
}
const Mue = {
  number: KI,
  bool: jue,
  bytes: DF,
  hash: Lue,
  exists: Hue,
  output: Fue
};
var Np = Mue;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Due = (e) => e instanceof Uint8Array, GS = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), ic = (e, t) => e << 32 - t | e >>> t, Kue = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!Kue)
  throw new Error("Non little-endian hardware is not supported");
Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function que(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function yC(e) {
  if (typeof e == "string" && (e = que(e)), !Due(e))
    throw new Error(`expected Uint8Array, got ${typeof e}`);
  return e;
}
class KF {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function x0(e) {
  const t = (n) => e().update(yC(n)).digest(), r = e();
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = () => e(), t;
}
function Vue(e, t, r, n) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, r, n);
  const o = BigInt(32), i = BigInt(4294967295), a = Number(r >> o & i), u = Number(r & i), l = n ? 4 : 0, d = n ? 0 : 4;
  e.setUint32(t + l, a, n), e.setUint32(t + d, u, n);
}
let bC = class extends KF {
  constructor(t, r, n, o) {
    super(), this.blockLen = t, this.outputLen = r, this.padOffset = n, this.isLE = o, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = GS(this.buffer);
  }
  update(t) {
    Np.exists(this);
    const { view: r, buffer: n, blockLen: o } = this;
    t = yC(t);
    const i = t.length;
    for (let a = 0; a < i; ) {
      const u = Math.min(o - this.pos, i - a);
      if (u === o) {
        const l = GS(t);
        for (; o <= i - a; a += o)
          this.process(l, a);
        continue;
      }
      n.set(t.subarray(a, a + u), this.pos), this.pos += u, a += u, this.pos === o && (this.process(r, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    Np.exists(this), Np.output(t, this), this.finished = !0;
    const { buffer: r, view: n, blockLen: o, isLE: i } = this;
    let { pos: a } = this;
    r[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > o - a && (this.process(n, 0), a = 0);
    for (let h = a; h < o; h++)
      r[h] = 0;
    Vue(n, o - 8, BigInt(this.length * 8), i), this.process(n, 0);
    const u = GS(t), l = this.outputLen;
    if (l % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const d = l / 4, f = this.get();
    if (d > f.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let h = 0; h < d; h++)
      u.setUint32(4 * h, f[h], i);
  }
  digest() {
    const { buffer: t, outputLen: r } = this;
    this.digestInto(t);
    const n = t.slice(0, r);
    return this.destroy(), n;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: r, buffer: n, length: o, finished: i, destroyed: a, pos: u } = this;
    return t.length = o, t.pos = u, t.finished = i, t.destroyed = a, o % r && t.buffer.set(n), t;
  }
};
const Gue = (e, t, r) => e & t ^ ~e & r, Wue = (e, t, r) => e & t ^ e & r ^ t & r, Zue = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), Hf = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), Ff = new Uint32Array(64);
class qF extends bC {
  constructor() {
    super(64, 32, 8, !1), this.A = Hf[0] | 0, this.B = Hf[1] | 0, this.C = Hf[2] | 0, this.D = Hf[3] | 0, this.E = Hf[4] | 0, this.F = Hf[5] | 0, this.G = Hf[6] | 0, this.H = Hf[7] | 0;
  }
  get() {
    const { A: t, B: r, C: n, D: o, E: i, F: a, G: u, H: l } = this;
    return [t, r, n, o, i, a, u, l];
  }
  // prettier-ignore
  set(t, r, n, o, i, a, u, l) {
    this.A = t | 0, this.B = r | 0, this.C = n | 0, this.D = o | 0, this.E = i | 0, this.F = a | 0, this.G = u | 0, this.H = l | 0;
  }
  process(t, r) {
    for (let h = 0; h < 16; h++, r += 4)
      Ff[h] = t.getUint32(r, !1);
    for (let h = 16; h < 64; h++) {
      const g = Ff[h - 15], b = Ff[h - 2], w = ic(g, 7) ^ ic(g, 18) ^ g >>> 3, E = ic(b, 17) ^ ic(b, 19) ^ b >>> 10;
      Ff[h] = E + Ff[h - 7] + w + Ff[h - 16] | 0;
    }
    let { A: n, B: o, C: i, D: a, E: u, F: l, G: d, H: f } = this;
    for (let h = 0; h < 64; h++) {
      const g = ic(u, 6) ^ ic(u, 11) ^ ic(u, 25), b = f + g + Gue(u, l, d) + Zue[h] + Ff[h] | 0, w = (ic(n, 2) ^ ic(n, 13) ^ ic(n, 22)) + Wue(n, o, i) | 0;
      f = d, d = l, l = u, u = a + b | 0, a = i, i = o, o = n, n = b + w | 0;
    }
    n = n + this.A | 0, o = o + this.B | 0, i = i + this.C | 0, a = a + this.D | 0, u = u + this.E | 0, l = l + this.F | 0, d = d + this.G | 0, f = f + this.H | 0, this.set(n, o, i, a, u, l, d, f);
  }
  roundClean() {
    Ff.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
let Xue = class extends qF {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
};
const b3 = x0(() => new qF());
x0(() => new Xue());
const jv = BigInt(2 ** 32 - 1), qI = BigInt(32);
function VF(e, t = !1) {
  return t ? { h: Number(e & jv), l: Number(e >> qI & jv) } : { h: Number(e >> qI & jv) | 0, l: Number(e & jv) | 0 };
}
function Yue(e, t = !1) {
  let r = new Uint32Array(e.length), n = new Uint32Array(e.length);
  for (let o = 0; o < e.length; o++) {
    const { h: i, l: a } = VF(e[o], t);
    [r[o], n[o]] = [i, a];
  }
  return [r, n];
}
const Jue = (e, t) => BigInt(e >>> 0) << qI | BigInt(t >>> 0), Que = (e, t, r) => e >>> r, ece = (e, t, r) => e << 32 - r | t >>> r, tce = (e, t, r) => e >>> r | t << 32 - r, rce = (e, t, r) => e << 32 - r | t >>> r, nce = (e, t, r) => e << 64 - r | t >>> r - 32, oce = (e, t, r) => e >>> r - 32 | t << 64 - r, ice = (e, t) => t, ace = (e, t) => e, sce = (e, t, r) => e << r | t >>> 32 - r, uce = (e, t, r) => t << r | e >>> 32 - r, cce = (e, t, r) => t << r - 32 | e >>> 64 - r, lce = (e, t, r) => e << r - 32 | t >>> 64 - r;
function fce(e, t, r, n) {
  const o = (t >>> 0) + (n >>> 0);
  return { h: e + r + (o / 2 ** 32 | 0) | 0, l: o | 0 };
}
const dce = (e, t, r) => (e >>> 0) + (t >>> 0) + (r >>> 0), hce = (e, t, r, n) => t + r + n + (e / 2 ** 32 | 0) | 0, pce = (e, t, r, n) => (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0), gce = (e, t, r, n, o) => t + r + n + o + (e / 2 ** 32 | 0) | 0, mce = (e, t, r, n, o) => (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0) + (o >>> 0), yce = (e, t, r, n, o, i) => t + r + n + o + i + (e / 2 ** 32 | 0) | 0, bce = {
  fromBig: VF,
  split: Yue,
  toBig: Jue,
  shrSH: Que,
  shrSL: ece,
  rotrSH: tce,
  rotrSL: rce,
  rotrBH: nce,
  rotrBL: oce,
  rotr32H: ice,
  rotr32L: ace,
  rotlSH: sce,
  rotlSL: uce,
  rotlBH: cce,
  rotlBL: lce,
  add: fce,
  add3L: dce,
  add3H: hce,
  add4L: pce,
  add4H: gce,
  add5H: yce,
  add5L: mce
};
var Ar = bce;
const [wce, vce] = Ar.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((e) => BigInt(e))), Mf = new Uint32Array(80), Df = new Uint32Array(80);
let Q5 = class extends bC {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: t, Al: r, Bh: n, Bl: o, Ch: i, Cl: a, Dh: u, Dl: l, Eh: d, El: f, Fh: h, Fl: g, Gh: b, Gl: w, Hh: E, Hl: _ } = this;
    return [t, r, n, o, i, a, u, l, d, f, h, g, b, w, E, _];
  }
  // prettier-ignore
  set(t, r, n, o, i, a, u, l, d, f, h, g, b, w, E, _) {
    this.Ah = t | 0, this.Al = r | 0, this.Bh = n | 0, this.Bl = o | 0, this.Ch = i | 0, this.Cl = a | 0, this.Dh = u | 0, this.Dl = l | 0, this.Eh = d | 0, this.El = f | 0, this.Fh = h | 0, this.Fl = g | 0, this.Gh = b | 0, this.Gl = w | 0, this.Hh = E | 0, this.Hl = _ | 0;
  }
  process(t, r) {
    for (let I = 0; I < 16; I++, r += 4)
      Mf[I] = t.getUint32(r), Df[I] = t.getUint32(r += 4);
    for (let I = 16; I < 80; I++) {
      const S = Mf[I - 15] | 0, T = Df[I - 15] | 0, A = Ar.rotrSH(S, T, 1) ^ Ar.rotrSH(S, T, 8) ^ Ar.shrSH(S, T, 7), $ = Ar.rotrSL(S, T, 1) ^ Ar.rotrSL(S, T, 8) ^ Ar.shrSL(S, T, 7), U = Mf[I - 2] | 0, M = Df[I - 2] | 0, Y = Ar.rotrSH(U, M, 19) ^ Ar.rotrBH(U, M, 61) ^ Ar.shrSH(U, M, 6), L = Ar.rotrSL(U, M, 19) ^ Ar.rotrBL(U, M, 61) ^ Ar.shrSL(U, M, 6), ee = Ar.add4L($, L, Df[I - 7], Df[I - 16]), de = Ar.add4H(ee, A, Y, Mf[I - 7], Mf[I - 16]);
      Mf[I] = de | 0, Df[I] = ee | 0;
    }
    let { Ah: n, Al: o, Bh: i, Bl: a, Ch: u, Cl: l, Dh: d, Dl: f, Eh: h, El: g, Fh: b, Fl: w, Gh: E, Gl: _, Hh: O, Hl: C } = this;
    for (let I = 0; I < 80; I++) {
      const S = Ar.rotrSH(h, g, 14) ^ Ar.rotrSH(h, g, 18) ^ Ar.rotrBH(h, g, 41), T = Ar.rotrSL(h, g, 14) ^ Ar.rotrSL(h, g, 18) ^ Ar.rotrBL(h, g, 41), A = h & b ^ ~h & E, $ = g & w ^ ~g & _, U = Ar.add5L(C, T, $, vce[I], Df[I]), M = Ar.add5H(U, O, S, A, wce[I], Mf[I]), Y = U | 0, L = Ar.rotrSH(n, o, 28) ^ Ar.rotrBH(n, o, 34) ^ Ar.rotrBH(n, o, 39), ee = Ar.rotrSL(n, o, 28) ^ Ar.rotrBL(n, o, 34) ^ Ar.rotrBL(n, o, 39), de = n & i ^ n & u ^ i & u, ne = o & a ^ o & l ^ a & l;
      O = E | 0, C = _ | 0, E = b | 0, _ = w | 0, b = h | 0, w = g | 0, { h, l: g } = Ar.add(d | 0, f | 0, M | 0, Y | 0), d = u | 0, f = l | 0, u = i | 0, l = a | 0, i = n | 0, a = o | 0;
      const D = Ar.add3L(Y, ee, ne);
      n = Ar.add3H(D, M, L, de), o = D | 0;
    }
    ({ h: n, l: o } = Ar.add(this.Ah | 0, this.Al | 0, n | 0, o | 0)), { h: i, l: a } = Ar.add(this.Bh | 0, this.Bl | 0, i | 0, a | 0), { h: u, l } = Ar.add(this.Ch | 0, this.Cl | 0, u | 0, l | 0), { h: d, l: f } = Ar.add(this.Dh | 0, this.Dl | 0, d | 0, f | 0), { h, l: g } = Ar.add(this.Eh | 0, this.El | 0, h | 0, g | 0), { h: b, l: w } = Ar.add(this.Fh | 0, this.Fl | 0, b | 0, w | 0), { h: E, l: _ } = Ar.add(this.Gh | 0, this.Gl | 0, E | 0, _ | 0), { h: O, l: C } = Ar.add(this.Hh | 0, this.Hl | 0, O | 0, C | 0), this.set(n, o, i, a, u, l, d, f, h, g, b, w, E, _, O, C);
  }
  roundClean() {
    Mf.fill(0), Df.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}, Ece = class extends Q5 {
  constructor() {
    super(), this.Ah = -1942145080, this.Al = 424955298, this.Bh = 1944164710, this.Bl = -1982016298, this.Ch = 502970286, this.Cl = 855612546, this.Dh = 1738396948, this.Dl = 1479516111, this.Eh = 258812777, this.El = 2077511080, this.Fh = 2011393907, this.Fl = 79989058, this.Gh = 1067287976, this.Gl = 1780299464, this.Hh = 286451373, this.Hl = -1848208735, this.outputLen = 28;
  }
}, _ce = class extends Q5 {
  constructor() {
    super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
  }
}, Ace = class extends Q5 {
  constructor() {
    super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
  }
};
const xce = x0(() => new Q5());
x0(() => new Ece());
x0(() => new _ce());
x0(() => new Ace());
const kce = new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]), GF = Uint8Array.from({ length: 16 }, (e, t) => t), Sce = GF.map((e) => (9 * e + 5) % 16);
let wC = [GF], vC = [Sce];
for (let e = 0; e < 4; e++)
  for (let t of [wC, vC])
    t.push(t[e].map((r) => kce[r]));
const WF = [
  [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
  [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
  [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
  [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
  [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
].map((e) => new Uint8Array(e)), Tce = wC.map((e, t) => e.map((r) => WF[t][r])), Ice = vC.map((e, t) => e.map((r) => WF[t][r])), Oce = new Uint32Array([0, 1518500249, 1859775393, 2400959708, 2840853838]), Pce = new Uint32Array([1352829926, 1548603684, 1836072691, 2053994217, 0]), Lv = (e, t) => e << t | e >>> 32 - t;
function wU(e, t, r, n) {
  return e === 0 ? t ^ r ^ n : e === 1 ? t & r | ~t & n : e === 2 ? (t | ~r) ^ n : e === 3 ? t & n | r & ~n : t ^ (r | ~n);
}
const Hv = new Uint32Array(16);
let Cce = class extends bC {
  constructor() {
    super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
  }
  get() {
    const { h0: t, h1: r, h2: n, h3: o, h4: i } = this;
    return [t, r, n, o, i];
  }
  set(t, r, n, o, i) {
    this.h0 = t | 0, this.h1 = r | 0, this.h2 = n | 0, this.h3 = o | 0, this.h4 = i | 0;
  }
  process(t, r) {
    for (let b = 0; b < 16; b++, r += 4)
      Hv[b] = t.getUint32(r, !0);
    let n = this.h0 | 0, o = n, i = this.h1 | 0, a = i, u = this.h2 | 0, l = u, d = this.h3 | 0, f = d, h = this.h4 | 0, g = h;
    for (let b = 0; b < 5; b++) {
      const w = 4 - b, E = Oce[b], _ = Pce[b], O = wC[b], C = vC[b], I = Tce[b], S = Ice[b];
      for (let T = 0; T < 16; T++) {
        const A = Lv(n + wU(b, i, u, d) + Hv[O[T]] + E, I[T]) + h | 0;
        n = h, h = d, d = Lv(u, 10) | 0, u = i, i = A;
      }
      for (let T = 0; T < 16; T++) {
        const A = Lv(o + wU(w, a, l, f) + Hv[C[T]] + _, S[T]) + g | 0;
        o = g, g = f, f = Lv(l, 10) | 0, l = a, a = A;
      }
    }
    this.set(this.h1 + u + f | 0, this.h2 + d + g | 0, this.h3 + h + o | 0, this.h4 + n + a | 0, this.h0 + i + l | 0);
  }
  roundClean() {
    Hv.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
  }
};
const Bce = x0(() => new Cce());
class ZF extends KF {
  constructor(t, r) {
    super(), this.finished = !1, this.destroyed = !1, Np.hash(t);
    const n = yC(r);
    if (this.iHash = t.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const o = this.blockLen, i = new Uint8Array(o);
    i.set(n.length > o ? t.create().update(n).digest() : n);
    for (let a = 0; a < i.length; a++)
      i[a] ^= 54;
    this.iHash.update(i), this.oHash = t.create();
    for (let a = 0; a < i.length; a++)
      i[a] ^= 106;
    this.oHash.update(i), i.fill(0);
  }
  update(t) {
    return Np.exists(this), this.iHash.update(t), this;
  }
  digestInto(t) {
    Np.exists(this), Np.bytes(t, this.outputLen), this.finished = !0, this.iHash.digestInto(t), this.oHash.update(t), this.oHash.digestInto(t), this.destroy();
  }
  digest() {
    const t = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(t), t;
  }
  _cloneInto(t) {
    t || (t = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: r, iHash: n, finished: o, destroyed: i, blockLen: a, outputLen: u } = this;
    return t = t, t.finished = o, t.destroyed = i, t.blockLen = a, t.outputLen = u, t.oHash = r._cloneInto(t.oHash), t.iHash = n._cloneInto(t.iHash), t;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const XF = (e, t, r) => new ZF(e, t).update(r).digest();
XF.create = (e, t) => new ZF(e, t);
function Nce(e) {
  const t = rr.bytes(e);
  return rr.raw(b3(t));
}
function D1(e) {
  const t = rr.bytes(e);
  return rr.raw(b3(b3(t)));
}
function EC(e) {
  const t = rr.bytes(e);
  return rr.raw(Bce(b3(t)));
}
function $ce(e, t) {
  const r = rr.bytes(e), n = rr.bytes(t);
  return rr.raw(XF(xce, r, n));
}
function Uce(e) {
  const t = rr.str(e).digest;
  return rr.join([t, t]);
}
function Rce(e = 32) {
  return _C(MF(e));
}
function _C(e) {
  return la.mod(e).buff;
}
function YF(e, t = !1) {
  const r = la.mod(e).point;
  return t ? r.x : r.buff;
}
function JF(e, t) {
  const r = A0.from_x(t), n = la.mod(e);
  return r.mul(n).buff;
}
function zce(e, t, r = "ecdh/code") {
  const n = Uce(r), o = _C(e), i = YF(o), a = rr.bytes(t), u = JF(o, a), l = [i.hex, a.hex];
  return l.sort(), $ce(u, rr.join([n, ...l]));
}
function jce(e) {
  const t = rr.bytes(e);
  switch (!0) {
    case t.length === 32:
      return !0;
    case (t.length === 33 && t[0] === 2):
      return !0;
    case (t.length === 33 && t[0] === 3):
      return !1;
    default:
      throw new TypeError(`Invalid public key: ${t.hex}`);
  }
}
function Lce(e) {
  const t = rr.bytes(e);
  switch (t.length) {
    case 32:
      return t;
    case 33:
      return t.slice(1, 33);
    default:
      throw new Error(`Invalid key length: ${t.length}`);
  }
}
var Hce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  genSecretKey: Rce,
  getPublicKey: YF,
  getSecretKey: _C,
  getSharedCode: zce,
  getSharedKey: JF,
  is_even_pub: jce,
  xonly_pub: Lce
});
rr.random(32);
const QF = { secp: sf }, VI = { ...Hce, ...Cue };
function e4(e) {
  const t = xe.bytes(e);
  return Cc(t, 33), EC(t);
}
function eM(e) {
  const t = pa.fmt.toBytes(e, !1);
  return EC(t);
}
function tM(e) {
  const t = pa.fmt.toBytes(e, !1);
  return Nce(t);
}
function rM(e, t = "main") {
  const r = t === "main" ? ["1"] : ["m", "n"];
  for (const n of r)
    if (e.startsWith(n))
      return !0;
  return !1;
}
function nM(e, t = "main") {
  const r = xe.bytes(e), n = t === "main" ? xe.num(0) : xe.num(111);
  return Cc(e, 20), r.prepend(n).tob58chk();
}
function Fce(e, t = "main") {
  if (!rM(e, t))
    throw new TypeError("Invalid p2pkh address!");
  return xe.b58chk(e).slice(1);
}
function Mce(e) {
  const t = xe.bytes(e);
  return Cc(t, 20), ["OP_DUP", "OP_HASH160", t.hex, "OP_EQUALVERIFY", "OP_CHECKSIG"];
}
function Dce(e, t) {
  const r = e4(e);
  return nM(r, t);
}
const oM = { check: rM, encode: nM, decode: Fce, hash: e4, scriptPubKey: Mce, fromPubKey: Dce };
function iM(e, t = "main") {
  const r = t === "main" ? ["3"] : ["2"];
  for (const n of r)
    if (e.startsWith(n))
      return !0;
  return !1;
}
function aM(e, t = "main") {
  const r = t === "main" ? xe.num(5) : xe.num(196), n = xe.bytes(e);
  return Cc(n, 20), n.prepend(r).tob58chk();
}
function Kce(e, t = "main") {
  if (!iM(e, t))
    throw new TypeError(`Invalid p2sh address for network ${t}:` + e);
  return xe.b58chk(e).slice(1);
}
function qce(e) {
  return ["OP_HASH160", xe.bytes(e).hex, "OP_EQUAL"];
}
function Vce(e, t) {
  const r = eM(e);
  return aM(r, t);
}
const sM = { check: iM, encode: aM, decode: Kce, hash: eM, scriptPubKey: qce, fromScript: Vce }, AC = {
  main: "bc",
  testnet: "tb",
  signet: "tb",
  regtest: "bcrt"
}, Gce = ["bc1q", "tb1q", "bcrt1q"];
function uM(e) {
  for (const t of Gce)
    if (e.startsWith(t))
      return !0;
  return !1;
}
function cM(e, t = "main") {
  const r = AC[t], n = xe.bytes(e);
  return Cc(n, 20), n.toBech32(r, 0);
}
function Wce(e) {
  if (!uM(e))
    throw new TypeError("Invalid segwit address!");
  return xe.bech32(e);
}
function Zce(e) {
  const t = xe.bytes(e);
  return Cc(t, 20), ["OP_0", t.hex];
}
function Xce(e, t) {
  const r = e4(e);
  return cM(r, t);
}
const lM = { check: uM, encode: cM, decode: Wce, hash: e4, scriptPubKey: Zce, fromPubKey: Xce }, Yce = ["bc1q", "tb1q", "bcrt1q"];
function fM(e) {
  for (const t of Yce)
    if (e.startsWith(t))
      return !0;
  return !1;
}
function dM(e, t = "main") {
  const r = AC[t], n = xe.bytes(e);
  return Cc(n, 32), n.toBech32(r, 0);
}
function Jce(e) {
  if (!fM(e))
    throw new TypeError("Invalid segwit address!");
  return xe.bech32(e);
}
function Qce(e) {
  const t = xe.bytes(e);
  return Cc(t, 32), ["OP_0", t.hex];
}
function ele(e, t) {
  const r = tM(e);
  return dM(r, t);
}
const hM = { check: fM, encode: dM, decode: Jce, hash: tM, scriptPubKey: Qce, fromScript: ele };
function r0(e) {
  const t = xe.bytes(e);
  return t.length > 32 ? t.slice(1, 33) : t;
}
const tle = ["bc1p", "tb1p", "bcrt1p"];
function pM(e) {
  for (const t of tle)
    if (e.startsWith(t))
      return !0;
  return !1;
}
function gM(e, t = "main") {
  const r = AC[t], n = xe.bytes(e);
  return Cc(n, 32), n.toBech32(r, 1);
}
function rle(e) {
  if (!pM(e))
    throw new TypeError("Invalid taproot address!");
  return xe.bech32(e);
}
function nle(e) {
  const t = xe.bytes(e);
  return Cc(t, 32), ["OP_1", t.hex];
}
function ole(e, t) {
  const r = r0(e);
  return gM(r, t);
}
const mM = { check: pM, encode: gM, decode: rle, scriptPubKey: nle, fromPubKey: ole }, ile = {
  version: 2,
  vin: [],
  vout: [],
  locktime: 0
}, ale = {
  scriptSig: [],
  sequence: 4294967293,
  witness: []
}, sle = {
  value: 0n,
  scriptPubKey: []
};
function xC(e) {
  const t = { ...ile, ...e };
  return t.vin = t.vin.map((r) => ({ ...ale, ...r })), t.vout = t.vout.map((r) => ({ ...sle, ...r })), t;
}
function K1(e, t) {
  const { version: r, vin: n, vout: o, locktime: i } = xC(e), a = t !== !0 && ule(n), u = [kC(r)];
  a && u.push(xe.hex("0001")), u.push(cle(n)), u.push(lle(o));
  for (const l of n)
    a && u.push(dle(l.witness));
  return u.push(SC(i)), xe.join(u);
}
function ule(e) {
  for (const t of e) {
    const { witness: r } = t;
    if (typeof r == "string" || r instanceof Uint8Array || Array.isArray(r) && r.length > 0)
      return !0;
  }
  return !1;
}
function kC(e) {
  return xe.num(e, 4).reverse();
}
function x2(e) {
  return xe.hex(e, 32).reverse();
}
function k2(e) {
  return xe.num(e, 4).reverse();
}
function S2(e) {
  if (typeof e == "string")
    return xe.hex(e, 4).reverse();
  if (typeof e == "number")
    return xe.num(e, 4).reverse();
  throw new Error("Unrecognized format: " + String(e));
}
function cle(e) {
  const t = [xe.varInt(e.length, "le")];
  for (const r of e) {
    const { txid: n, vout: o, scriptSig: i, sequence: a } = r;
    t.push(x2(n)), t.push(k2(o)), t.push(_0(i, !0)), t.push(S2(a));
  }
  return xe.join(t);
}
function jd(e) {
  if (typeof e == "number") {
    if (e % 1 !== 0)
      throw new Error("Value must be an integer:" + String(e));
    return xe.num(e, 8).reverse();
  }
  return xe.big(e, 8).reverse();
}
function lle(e) {
  const t = [xe.varInt(e.length, "le")];
  for (const r of e)
    t.push(fle(r));
  return xe.join(t);
}
function fle(e) {
  const { value: t, scriptPubKey: r } = e, n = [];
  return n.push(jd(t)), n.push(_0(r, !0)), xe.join(n);
}
function dle(e = []) {
  const t = [];
  if (Array.isArray(e)) {
    const r = xe.varInt(e.length);
    t.push(r);
    for (const n of e)
      t.push(hle(n));
    return xe.join(t);
  } else
    return xe.bytes(e);
}
function hle(e) {
  return ple(e) ? new xe(0) : _0(e, !0);
}
function ple(e) {
  if (Array.isArray(e))
    return e.length === 0;
  if (typeof e == "string" && e === "")
    return !0;
  const t = xe.bytes(e);
  return t.length === 1 && t[0] === 0;
}
function SC(e) {
  if (typeof e == "string")
    return xe.hex(e, 4);
  if (typeof e == "number")
    return xe.num(e, 4).reverse();
  throw new Error("Unrecognized format: " + String(e));
}
function TC(e) {
  typeof e == "string" && (e = xe.hex(e).raw);
  const t = new yg(e), r = gle(t), n = mle(t), o = yle(t), i = wle(t);
  if (n)
    for (const u of o)
      u.witness = Ele(t);
  const a = _le(t);
  return { version: r, vin: o, vout: i, locktime: a };
}
function gle(e) {
  return e.read(4).reverse().toNum();
}
function mle(e) {
  const [t, r] = [...e.peek(2)];
  if (t === 0) {
    if (e.read(2), r === 1)
      return !0;
    throw new Error(`Invalid witness flag: ${r}`);
  }
  return !1;
}
function yle(e) {
  const t = [], r = e.readSize("le");
  for (let n = 0; n < r; n++)
    t.push(ble(e));
  return t;
}
function ble(e) {
  return {
    txid: e.read(32).reverse().toHex(),
    vout: e.read(4).reverse().toNum(),
    scriptSig: bM(e),
    sequence: e.read(4).reverse().toHex(),
    witness: []
  };
}
function wle(e) {
  const t = [], r = e.readSize("le");
  for (let n = 0; n < r; n++)
    t.push(vle(e));
  return t;
}
function vle(e) {
  return {
    value: e.read(8).reverse().big,
    scriptPubKey: bM(e)
  };
}
function Ele(e) {
  const t = [], r = e.readSize();
  for (let n = 0; n < r; n++) {
    const o = yM(e);
    t.push(o ?? "");
  }
  return t;
}
function yM(e, t) {
  const r = e.readSize("le");
  return r > 0 ? e.read(r).hex : null;
}
function bM(e, t) {
  const r = yM(e);
  return r !== null ? r : [];
}
function _le(e) {
  return e.read(4).reverse().toNum();
}
function Ale(e) {
  if (nF(e))
    return TC(e);
  if (typeof e == "object" && !(e instanceof Uint8Array))
    return K1(e), xC(e);
  throw new Error("Invalid format: " + typeof e);
}
function xle(e) {
  if (nF(e))
    return TC(e), xe.bytes(e);
  if (typeof e == "object")
    return K1(e);
  throw new Error("Invalid format: " + typeof e);
}
const IC = {
  toBytes: xle,
  toJson: Ale
}, kle = [
  ["p2pkh", /^76a914(?<hash>\w{40})88ac$/],
  ["p2sh", /^a914(?<hash>\w{40})87$/],
  ["p2w-pkh", /^0014(?<hash>\w{40})$/],
  ["p2w-sh", /^0020(?<hash>\w{64})$/],
  ["p2tr", /^5120(?<hash>\w{64})$/]
], Sle = [
  192,
  194,
  196,
  198,
  200,
  202,
  204,
  206,
  208,
  210,
  212,
  214,
  216,
  218,
  220,
  222,
  224,
  226,
  228,
  230,
  232,
  234,
  236,
  238,
  240,
  242,
  244,
  246,
  248,
  250,
  252,
  254,
  102,
  126,
  128,
  132,
  150,
  152,
  186,
  188,
  190
];
function Tle(e) {
  let t = e.at(-1);
  return yf(t) && (t = xe.hex(t)), e.length > 1 && t instanceof Uint8Array && t[0] === 80 ? (e.pop(), xe.raw(t)) : null;
}
function Ile(e) {
  let t = e.at(-1);
  return yf(t) && (t = xe.hex(t)), e.length > 1 && t instanceof Uint8Array && t.length > 32 && Sle.includes(t[0] & 254) ? (e.pop(), xe.raw(t)) : null;
}
function Ole(e) {
  if (e.length > 1) {
    const t = e.at(-1);
    try {
      const r = pa.fmt.toBytes(t);
      return e.pop(), r;
    } catch {
      return null;
    }
  }
  return null;
}
function Ple(e) {
  const t = [];
  for (const r of e)
    if (yf(r) || r instanceof Uint8Array || typeof r == "number")
      t.push(xe.bytes(r));
    else
      throw new Error("unrecognized value: " + String(r));
  return t;
}
function Cle(e = []) {
  const t = [...e], r = Tle(t), n = Ile(t), o = Ole(t), i = Ple(t);
  return { annex: r, cblock: n, script: o, params: i };
}
function Ble(e) {
  const t = pa.fmt.toBytes(e, !1).hex;
  for (const [r, n] of kle) {
    const o = r, { groups: i } = n.exec(t) ?? {}, { hash: a } = i ?? {};
    if (yf(a))
      return { type: o, data: xe.hex(a) };
  }
  return { type: "raw", data: xe.hex(t) };
}
function Nle(e) {
  const t = IC.toJson(e), r = K1(t, !0);
  return D1(r).reverse().hex;
}
function $le(e) {
  const t = IC.toJson(e), r = K1(t, !0).length, n = K1(t, !1).length, o = r * 3 + n, i = o % 4 > 0 ? 1 : 0, a = Math.floor(o / 4) + i;
  return { size: n, bsize: r, vsize: a, weight: o };
}
const Bu = {
  create: xC,
  encode: K1,
  decode: TC,
  fmt: IC,
  util: {
    getTxSize: $le,
    getTxid: Nle,
    readScriptPubKey: Ble,
    readWitness: Cle
  }
}, Ule = [
  ["1", "p2pkh", "main", 20, "base58"],
  ["3", "p2sh", "main", 20, "base58"],
  ["m", "p2pkh", "testnet", 20, "base58"],
  ["n", "p2pkh", "testnet", 20, "base58"],
  ["2", "p2sh", "testnet", 20, "base58"],
  ["bc1q", "p2w-pkh", "main", 20, "bech32"],
  ["tb1q", "p2w-pkh", "testnet", 20, "bech32"],
  ["bcrt1q", "p2w-pkh", "regtest", 20, "bech32"],
  ["bc1q", "p2w-sh", "main", 32, "bech32"],
  ["tb1q", "p2w-sh", "testnet", 32, "bech32"],
  ["bcrt1q", "p2w-sh", "regtest", 32, "bech32"],
  ["bc1p", "p2tr", "main", 32, "bech32m"],
  ["tb1p", "p2tr", "testnet", 32, "bech32m"],
  ["bcrt1p", "p2tr", "regtest", 32, "bech32m"]
];
function Rle(e, t) {
  switch (t) {
    case "base58":
      return xe.b58chk(e).slice(1);
    case "bech32":
      return xe.bech32(e);
    case "bech32m":
      return xe.bech32(e);
    default:
      throw new Error("Invalid address format: " + t);
  }
}
function zle(e) {
  for (const t of Ule) {
    const [r, n, o, i, a] = t;
    if (e.startsWith(r) && Rle(e, a).length === i)
      return t;
  }
  throw new Error("Invalid address: " + e);
}
function wM(e) {
  switch (e) {
    case "p2pkh":
      return oM;
    case "p2sh":
      return sM;
    case "p2w-pkh":
      return lM;
    case "p2w-sh":
      return hM;
    case "p2tr":
      return mM;
    default:
      throw new Error("Invalid address type: " + e);
  }
}
function vM(e) {
  const [t, r, n] = zle(e), o = wM(r), i = o.decode(e, n), a = o.scriptPubKey(i);
  return { prefix: t, type: r, network: n, data: i, script: a };
}
function jle(e, t) {
  const { type: r, data: n } = Bu.util.readScriptPubKey(e);
  return wM(r).encode(n, t);
}
function Lle(e) {
  const { script: t } = vM(e);
  return pa.fmt.toAsm(t, !1);
}
const EM = {
  p2pkh: oM,
  p2sh: sM,
  p2wpkh: lM,
  p2wsh: hM,
  p2tr: mM,
  decode: vM,
  fromScriptPubKey: jle,
  toScriptPubKey: Lle
}, Hle = [1, 2, 3];
function OC(e, t, r = {}) {
  const { sigflag: n = 1 } = r, o = (n & 128) === 128, i = n % 128;
  if (!Hle.includes(i))
    throw new Error("Invalid hash type: " + String(n));
  const a = Bu.fmt.toJson(e), { version: u, vin: l, vout: d, locktime: f } = a, { txid: h, vout: g, prevout: b, sequence: w } = l[t], { value: E } = b ?? {};
  if (E === void 0)
    throw new Error("Prevout value is empty!");
  let _ = r.script;
  if (_ === void 0 && r.pubkey !== void 0 && (_ = `76a914${EC(r.pubkey).hex}88ac`), _ === void 0)
    throw new Error("No pubkey / script has been set!");
  if (pa.fmt.toAsm(_).includes("OP_CODESEPARATOR"))
    throw new Error("This library does not currently support the use of OP_CODESEPARATOR in segwit scripts.");
  const O = [
    kC(u),
    Fle(l, o),
    Mle(l, i, o),
    x2(h),
    k2(g),
    pa.encode(_, !0),
    jd(E),
    S2(w),
    Dle(d, t, i),
    SC(f),
    xe.num(n, 4).reverse()
  ];
  return D1(xe.join(O));
}
function Fle(e, t) {
  if (t === !0)
    return xe.num(0, 32);
  const r = [];
  for (const { txid: n, vout: o } of e)
    r.push(x2(n)), r.push(k2(o));
  return D1(xe.join(r));
}
function Mle(e, t, r) {
  if (r || t !== 1)
    return xe.num(0, 32);
  const n = [];
  for (const { sequence: o } of e)
    n.push(S2(o));
  return D1(xe.join(n));
}
function Dle(e, t, r) {
  const n = [];
  if (r === 1) {
    for (const { value: o, scriptPubKey: i } of e)
      n.push(jd(o)), n.push(pa.encode(i, !0));
    return D1(xe.join(n));
  }
  if (r === 3 && t < e.length) {
    const { value: o, scriptPubKey: i } = e[t];
    return n.push(jd(o)), n.push(pa.encode(i, !0)), D1(xe.join(n));
  }
  return xe.num(0, 32);
}
function Kle(e, t, r, n = {}) {
  const { sigflag: o = 1 } = n, i = OC(t, r, n), a = QF.secp.sign(i, e).toDERRawBytes(!0);
  return xe.join([a, o]);
}
function qle(e, t, r = {}) {
  const n = Bu.fmt.toJson(e), { throws: o = !1 } = r, { witness: i = [] } = n.vin[t], a = Bu.util.readWitness(i), { script: u, params: l } = a;
  let d = null;
  if (l.length < 1)
    return Ui("Invalid witness data: " + String(i), o);
  if (r.script === void 0 && u !== null && (r.script = u), r.pubkey !== void 0)
    d = xe.bytes(r.pubkey);
  else if (l.length > 1 && l[1].length === 33)
    d = xe.bytes(l[1]);
  else
    return Ui("No pubkey provided!", o);
  const f = pa.fmt.toParam(l[0]), h = f.slice(0, -1), g = f.slice(-1)[0], b = OC(n, t, { ...r, sigflag: g });
  return QF.secp.verify(h, b, d) ? !0 : Ui("Invalid signature!", o);
}
const Vle = {
  hash: OC,
  sign: Kle,
  verify: qle
}, Gle = [0, 1, 2, 3, 129, 130, 131];
function PC(e, t, r = {}) {
  const { extension: n, sigflag: o = 0, extflag: i = 0, key_version: a = 0, separator_pos: u = 4294967295 } = r, l = Bu.fmt.toJson(e), { version: d, vin: f, vout: h, locktime: g } = l;
  if (t >= f.length)
    throw new Error("Index out of bounds: " + String(t));
  if (!Gle.includes(o))
    throw new Error("Invalid hash type: " + String(o));
  if (i < 0 || i > 127)
    throw new Error("Extention flag out of range: " + String(i));
  const { txid: b, vout: w, sequence: E, witness: _ = [] } = f[t], O = (o & 128) === 128, C = efe(_), I = C !== void 0 ? 1 : 0, S = (i + (n !== void 0 ? 1 : 0)) * 2 + I, T = xe.str("TapSighash").digest, A = [
    T,
    T,
    xe.num(0, 1),
    xe.num(o, 1),
    kC(d),
    SC(g)
  ];
  if (!O) {
    const $ = f.map((U) => vU(U));
    A.push(Wle(f), Xle($), Yle($), Zle(f));
  }
  if (((o & 3) < 2 || (o & 3) > 3) && A.push(Jle(h)), A.push(xe.num(S, 1)), O) {
    const { value: $, scriptPubKey: U } = vU(f[t]);
    A.push(x2(b), k2(w), jd($), pa.encode(U, !0), S2(E));
  } else
    A.push(xe.num(t, 4).reverse());
  return C !== void 0 && A.push(C), (o & 3) === 3 && A.push(Qle(h[t])), n !== void 0 && A.push(xe.bytes(n), xe.num(a), xe.num(u, 4, "le")), xe.join(A).digest;
}
function Wle(e) {
  const t = [];
  for (const { txid: r, vout: n } of e)
    t.push(x2(r)), t.push(k2(n));
  return xe.join(t).digest;
}
function Zle(e) {
  const t = [];
  for (const { sequence: r } of e)
    t.push(S2(r));
  return xe.join(t).digest;
}
function Xle(e) {
  const t = [];
  for (const { value: r } of e)
    t.push(jd(r));
  return xe.join(t).digest;
}
function Yle(e) {
  const t = [];
  for (const { scriptPubKey: r } of e)
    t.push(_0(r, !0));
  return xe.join(t).digest;
}
function Jle(e) {
  const t = [];
  for (const { value: r, scriptPubKey: n } of e)
    t.push(jd(r)), t.push(pa.encode(n, !0));
  return xe.join(t).digest;
}
function Qle(e) {
  return xe.join([
    jd(e.value),
    pa.encode(e.scriptPubKey, !0)
  ]).digest;
}
function efe(e) {
  if (e === void 0 || e.length < 2)
    return;
  let t = e.at(-1);
  if (typeof t == "string" && (t = xe.hex(t)), t instanceof Uint8Array && t[0] === 80)
    return xe.raw(t).prefixSize("be").digest;
}
function vU(e) {
  if (e.prevout === void 0)
    throw new Error("Prevout data missing for input: " + String(e.txid));
  return e.prevout;
}
const tfe = 0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2fn, rfe = 0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141n;
function nfe(e, t, r, n = {}) {
  const { sigflag: o = 0 } = n, i = PC(t, r, n), a = ofe(e, i);
  return o === 0 ? xe.raw(a) : xe.join([a, o]);
}
function ofe(e, t, r = xe.random(32)) {
  const n = xe.bytes(t), o = new la(e), i = o.point, a = i.hasEvenY ? o.big : o.negated.big, u = N8("BIP0340/aux", xe.bytes(r)), l = a ^ u.big, d = N8("BIP0340/nonce", l, i.x.raw, n), f = new la(d), h = f.point, g = h.hasEvenY ? f.big : f.negated.big, b = new la(N8("BIP0340/challenge", h.x.raw, i.x.raw, n)), w = new la(g + b.big * a);
  return xe.join([h.x.raw, w.raw]);
}
function ife(e, t, r, n = !1) {
  const o = A0.from_x(r0(r)), i = xe.bytes(t), a = xe.bytes(e).stream;
  a.size < 64 && Ui("Signature length is too small: " + String(a.size), n);
  const u = a.read(32);
  u.big > tfe && Ui("Signature r value greater than field size!", n);
  const l = a.read(32);
  l.big > rfe && Ui("Signature s value greater than curve order!", n);
  const d = new la(N8("BIP0340/challenge", u.raw, o.x.raw, i)), f = new la(l).point, h = o.mul(d.big), g = f.sub(h);
  return g.hasOddY && Ui("Signature R value has odd Y coordinate!", n), g.x.big === 0n && Ui("Signature R value is infinite!", n), g.x.big === u.big;
}
const afe = 192;
function t4(e) {
  const t = xe.str(e).digest;
  return xe.join([t, t]);
}
function CC(e, t = afe) {
  return xe.join([
    t4("TapLeaf"),
    cfe(t),
    xe.bytes(e)
  ]).digest.hex;
}
function sfe(e, t) {
  return CC(pa.fmt.toBytes(e), t);
}
function BC(e, t) {
  return t < e && ([e, t] = [t, e]), xe.join([
    t4("TapBranch"),
    xe.hex(e).raw,
    xe.hex(t).raw
  ]).digest.hex;
}
function ufe(e) {
  return xe.hex(w3(e)[0]);
}
function w3(e, t, r = []) {
  const n = [], o = [];
  if (e.length < 1)
    throw new Error("Tree is empty!");
  for (let i = 0; i < e.length; i++) {
    const a = e[i];
    if (Array.isArray(a)) {
      const [u, l, d] = w3(a, t);
      t = l, n.push(u);
      for (const f of d)
        r.push(f);
    } else
      n.push(a);
  }
  if (n.length === 1)
    return [n[0], t, r];
  n.sort(), n.length % 2 !== 0 && n.push(n[n.length - 1]);
  for (let i = 0; i < n.length - 1; i += 2) {
    const a = BC(n[i], n[i + 1]);
    o.push(a), typeof t == "string" && (t === n[i] ? (r.push(n[i + 1]), t = a) : t === n[i + 1] && (r.push(n[i]), t = a));
  }
  return w3(o, t, r);
}
function cfe(e = 192) {
  return e & 254;
}
function _M(e, t = new Uint8Array(), r = !1) {
  const n = r ? new la(e).point.x.raw : r0(e);
  return xe.join([t4("TapTweak"), n, xe.bytes(t)]).digest;
}
function w1(e, t, r = !1) {
  t === void 0 && (t = new Uint8Array());
  const n = xe.bytes(e), o = _M(e, t, r);
  return r ? AM(n, o) : xM(n, o);
}
function lfe(e, t) {
  return w1(e, t);
}
function ffe(e, t) {
  return w1(e, t, !0);
}
function AM(e, t) {
  let r = new la(e);
  return r.point.hasOddY && (r = r.negate()), xe.raw(r.add(t).raw);
}
function xM(e, t) {
  e = r0(e);
  const r = A0.from_x(e).add(t);
  return xe.raw(r.raw);
}
function dfe() {
  const e = xe.hex("0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8");
  return A0.from_x(e.digest).x;
}
const hfe = dfe(), pfe = 192;
function gfe(e, t = {}) {
  return kM(e, { ...t, isPrivate: !0 });
}
function mfe(e, t = {}) {
  return kM(e, { ...t, isPrivate: !1 });
}
function kM(e, t = {}) {
  const { isPrivate: r = !1, tree: n = [], version: o = pfe } = t, i = r ? VI.getPublicKey(e, !0) : r0(e);
  let { target: a } = t;
  a !== void 0 && (a = xe.bytes(a).hex);
  let u, l = [];
  if (n.length > 0) {
    const [g, b, w] = w3(n, a);
    l = w, u = w1(e, g, r);
  } else
    a !== void 0 ? u = w1(e, a, r) : u = w1(e, void 0, r);
  const d = r ? VI.getPublicKey(u)[0] : u[0], f = [xe.num(o + TM(d)), i];
  l.length > 0 && l.forEach((g) => f.push(xe.hex(g)));
  const h = xe.join(f);
  if (a !== void 0 && !NC(u, a, h, t))
    throw new Error("Path checking failed! Unable to generate path.");
  return [r0(u).hex, h.hex];
}
function NC(e, t, r, n = {}) {
  const { isPrivate: o = !1, throws: i = !1 } = n, { parity: a, paths: u, intkey: l } = SM(r), d = o ? VI.getPublicKey(e, !0) : r0(e), f = xe.join([a, d]);
  if (f.length !== 33)
    return Ui("Invalid tapkey: " + f.hex, i);
  let h = xe.bytes(t).hex;
  for (const b of u)
    h = BC(h, b);
  const g = w1(l, h);
  return xe.raw(g).hex === xe.raw(f).hex;
}
function SM(e) {
  const t = new yg(xe.bytes(e)), r = t.read(1).num, n = t.read(32), [o, i] = r % 2 === 0 ? [r, 2] : [r - 1, 3], a = [];
  for (; t.size >= 32; )
    a.push(t.read(32).hex);
  if (t.size !== 0)
    throw new Error("Non-empty buffer on control block: " + String(t));
  return { intkey: n, paths: a, parity: i, version: o };
}
function TM(e = 2) {
  if (e === 0 || e === 1)
    return e;
  if (e === 2 || e === "02")
    return 0;
  if (e === 3 || e === "03")
    return 1;
  throw new Error("Invalid parity bit: " + String(e));
}
function yfe(e, t, r = {}) {
  const n = Bu.fmt.toJson(e), { throws: o = !1 } = r, { prevout: i, witness: a = [] } = n.vin[t], u = Bu.util.readWitness(a), { cblock: l, script: d, params: f } = u;
  let h;
  if (f.length < 1)
    return Ui("Invalid witness data: " + String(a), o);
  const { scriptPubKey: g } = i ?? {};
  if (g === void 0)
    return Ui("Prevout scriptPubKey is empty!", o);
  const { type: b, data: w } = Bu.util.readScriptPubKey(g);
  if (b !== "p2tr")
    return Ui("Prevout script is not a valid taproot output:" + w.hex, o);
  if (w.length !== 32)
    return Ui("Invalid tapkey length: " + String(w.length), o);
  if (l !== null && d !== null) {
    const I = l[0] & 254, S = CC(d, I);
    if (r.extension = S, !NC(w, S, l, { throws: o }))
      return Ui("cblock verification failed!", o);
  }
  r.pubkey !== void 0 ? h = xe.bytes(r.pubkey) : f.length > 1 && f[1].length === 32 ? h = xe.bytes(f[1]) : h = xe.bytes(w);
  const E = pa.fmt.toParam(f[0]), _ = new yg(E), O = _.read(64).raw;
  if (_.size === 1 && (r.sigflag = _.read(1).num, r.sigflag === 0))
    return Ui("0x00 is not a valid appended sigflag!", o);
  const C = PC(n, t, r);
  return ife(O, C, h, o) ? !0 : Ui("Invalid signature!", o);
}
const bfe = {
  hash: PC,
  sign: nfe,
  verify: yfe
}, wfe = {
  segwit: Vle,
  taproot: bfe
}, vfe = {
  getTag: t4,
  getLeaf: CC,
  getBranch: BC,
  getRoot: ufe
}, Efe = {
  readCtrlBlock: SM,
  readParityBit: TM
}, _fe = {
  getPubKey: lfe,
  getSecKey: ffe,
  getTweak: _M,
  tweakSecKey: AM,
  tweakPubKey: xM
}, v3 = {
  getPubKey: mfe,
  getSecKey: gfe,
  encodeScript: sfe,
  checkPath: NC,
  tree: vfe,
  tweak: _fe,
  util: Efe,
  SCRIPT_PUBKEY: hfe
};
var Dr;
(function(e) {
  e.assertEqual = (o) => o;
  function t(o) {
  }
  e.assertIs = t;
  function r(o) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (o) => {
    const i = {};
    for (const a of o)
      i[a] = a;
    return i;
  }, e.getValidEnumValues = (o) => {
    const i = e.objectKeys(o).filter((u) => typeof o[o[u]] != "number"), a = {};
    for (const u of i)
      a[u] = o[u];
    return e.objectValues(a);
  }, e.objectValues = (o) => e.objectKeys(o).map(function(i) {
    return o[i];
  }), e.objectKeys = typeof Object.keys == "function" ? (o) => Object.keys(o) : (o) => {
    const i = [];
    for (const a in o)
      Object.prototype.hasOwnProperty.call(o, a) && i.push(a);
    return i;
  }, e.find = (o, i) => {
    for (const a of o)
      if (i(a))
        return a;
  }, e.isInteger = typeof Number.isInteger == "function" ? (o) => Number.isInteger(o) : (o) => typeof o == "number" && isFinite(o) && Math.floor(o) === o;
  function n(o, i = " | ") {
    return o.map((a) => typeof a == "string" ? `'${a}'` : a).join(i);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (o, i) => typeof i == "bigint" ? i.toString() : i;
})(Dr || (Dr = {}));
var GI;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(GI || (GI = {}));
const ht = Dr.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Sd = (e) => {
  switch (typeof e) {
    case "undefined":
      return ht.undefined;
    case "string":
      return ht.string;
    case "number":
      return isNaN(e) ? ht.nan : ht.number;
    case "boolean":
      return ht.boolean;
    case "function":
      return ht.function;
    case "bigint":
      return ht.bigint;
    case "symbol":
      return ht.symbol;
    case "object":
      return Array.isArray(e) ? ht.array : e === null ? ht.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? ht.promise : typeof Map < "u" && e instanceof Map ? ht.map : typeof Set < "u" && e instanceof Set ? ht.set : typeof Date < "u" && e instanceof Date ? ht.date : ht.object;
    default:
      return ht.unknown;
  }
}, Ye = Dr.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), Afe = (e) => JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
let Nu = class extends Error {
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  get errors() {
    return this.issues;
  }
  format(t) {
    const r = t || function(i) {
      return i.message;
    }, n = { _errors: [] }, o = (i) => {
      for (const a of i.issues)
        if (a.code === "invalid_union")
          a.unionErrors.map(o);
        else if (a.code === "invalid_return_type")
          o(a.returnTypeError);
        else if (a.code === "invalid_arguments")
          o(a.argumentsError);
        else if (a.path.length === 0)
          n._errors.push(r(a));
        else {
          let u = n, l = 0;
          for (; l < a.path.length; ) {
            const d = a.path[l];
            l === a.path.length - 1 ? (u[d] = u[d] || { _errors: [] }, u[d]._errors.push(r(a))) : u[d] = u[d] || { _errors: [] }, u = u[d], l++;
          }
        }
    };
    return o(this), n;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Dr.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, n = [];
    for (const o of this.issues)
      o.path.length > 0 ? (r[o.path[0]] = r[o.path[0]] || [], r[o.path[0]].push(t(o))) : n.push(t(o));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
};
Nu.create = (e) => new Nu(e);
const ww = (e, t) => {
  let r;
  switch (e.code) {
    case Ye.invalid_type:
      e.received === ht.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case Ye.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, Dr.jsonStringifyReplacer)}`;
      break;
    case Ye.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${Dr.joinValues(e.keys, ", ")}`;
      break;
    case Ye.invalid_union:
      r = "Invalid input";
      break;
    case Ye.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${Dr.joinValues(e.options)}`;
      break;
    case Ye.invalid_enum_value:
      r = `Invalid enum value. Expected ${Dr.joinValues(e.options)}, received '${e.received}'`;
      break;
    case Ye.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case Ye.invalid_return_type:
      r = "Invalid function return type";
      break;
    case Ye.invalid_date:
      r = "Invalid date";
      break;
    case Ye.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : Dr.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case Ye.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case Ye.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case Ye.custom:
      r = "Invalid input";
      break;
    case Ye.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case Ye.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case Ye.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, Dr.assertNever(e);
  }
  return { message: r };
};
let IM = ww;
function xfe(e) {
  IM = e;
}
function E3() {
  return IM;
}
const _3 = (e) => {
  const { data: t, path: r, errorMaps: n, issueData: o } = e, i = [...r, ...o.path || []], a = {
    ...o,
    path: i
  };
  let u = "";
  const l = n.filter((d) => !!d).slice().reverse();
  for (const d of l)
    u = d(a, { data: t, defaultError: u }).message;
  return {
    ...o,
    path: i,
    message: o.message || u
  };
}, kfe = [];
function bt(e, t) {
  const r = _3({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      e.schemaErrorMap,
      E3(),
      ww
      // then global default map
    ].filter((n) => !!n)
  });
  e.common.issues.push(r);
}
let $a = class OM {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const n = [];
    for (const o of r) {
      if (o.status === "aborted")
        return lr;
      o.status === "dirty" && t.dirty(), n.push(o.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, r) {
    const n = [];
    for (const o of r)
      n.push({
        key: await o.key,
        value: await o.value
      });
    return OM.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, r) {
    const n = {};
    for (const o of r) {
      const { key: i, value: a } = o;
      if (i.status === "aborted" || a.status === "aborted")
        return lr;
      i.status === "dirty" && t.dirty(), a.status === "dirty" && t.dirty(), (typeof a.value < "u" || o.alwaysSet) && (n[i.value] = a.value);
    }
    return { status: t.value, value: n };
  }
};
const lr = Object.freeze({
  status: "aborted"
}), PM = (e) => ({ status: "dirty", value: e }), ga = (e) => ({ status: "valid", value: e }), WI = (e) => e.status === "aborted", ZI = (e) => e.status === "dirty", A3 = (e) => e.status === "valid", x3 = (e) => typeof Promise < "u" && e instanceof Promise;
var jt;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(jt || (jt = {}));
class Sc {
  constructor(t, r, n, o) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = n, this._key = o;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const EU = (e, t) => {
  if (A3(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new Nu(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function br(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: n, description: o } = e;
  if (t && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: o } : { errorMap: (i, a) => i.code !== "invalid_type" ? { message: a.defaultError } : typeof a.data > "u" ? { message: n ?? a.defaultError } : { message: r ?? a.defaultError }, description: o };
}
let Br = class {
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return Sd(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: Sd(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new $a(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: Sd(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (x3(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const n = this.safeParse(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, r) {
    var n;
    const o = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Sd(t)
    }, i = this._parseSync({ data: t, path: o.path, parent: o });
    return EU(o, i);
  }
  async parseAsync(t, r) {
    const n = await this.safeParseAsync(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Sd(t)
    }, o = this._parse({ data: t, path: n.path, parent: n }), i = await (x3(o) ? o : Promise.resolve(o));
    return EU(n, i);
  }
  refine(t, r) {
    const n = (o) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(o) : r;
    return this._refinement((o, i) => {
      const a = t(o), u = () => i.addIssue({
        code: Ye.custom,
        ...n(o)
      });
      return typeof Promise < "u" && a instanceof Promise ? a.then((l) => l ? !0 : (u(), !1)) : a ? !0 : (u(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((n, o) => t(n) ? !0 : (o.addIssue(typeof r == "function" ? r(n, o) : r), !1));
  }
  _refinement(t) {
    return new Fu({
      schema: this,
      typeName: qt.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  optional() {
    return ef.create(this, this._def);
  }
  nullable() {
    return o0.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return n0.create(this, this._def);
  }
  promise() {
    return G1.create(this, this._def);
  }
  or(t) {
    return Sw.create([this, t], this._def);
  }
  and(t) {
    return Tw.create(this, t, this._def);
  }
  transform(t) {
    return new Fu({
      ...br(this._def),
      schema: this,
      typeName: qt.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new Cw({
      ...br(this._def),
      innerType: this,
      defaultValue: r,
      typeName: qt.ZodDefault
    });
  }
  brand() {
    return new RM({
      typeName: qt.ZodBranded,
      type: this,
      ...br(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new O3({
      ...br(this._def),
      innerType: this,
      catchValue: r,
      typeName: qt.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return $C.create(this, t);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
const Sfe = /^c[^\s-]{8,}$/i, Tfe = /^[a-z][a-z0-9]*$/, Ife = /[0-9A-HJKMNP-TV-Z]{26}/, Ofe = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i, Pfe = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/, Cfe = new RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u"), Bfe = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, Nfe = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, $fe = (e) => e.precision ? e.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${e.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${e.precision}}Z$`) : e.precision === 0 ? e.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : e.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function Ufe(e, t) {
  return !!((t === "v4" || !t) && Bfe.test(e) || (t === "v6" || !t) && Nfe.test(e));
}
let q1 = class Kb extends Br {
  constructor() {
    super(...arguments), this._regex = (t, r, n) => this.refinement((o) => t.test(o), {
      validation: r,
      code: Ye.invalid_string,
      ...jt.errToObj(n)
    }), this.nonempty = (t) => this.min(1, jt.errToObj(t)), this.trim = () => new Kb({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    }), this.toLowerCase = () => new Kb({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    }), this.toUpperCase = () => new Kb({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== ht.string) {
      const o = this._getOrReturnCtx(t);
      return bt(
        o,
        {
          code: Ye.invalid_type,
          expected: ht.string,
          received: o.parsedType
        }
        //
      ), lr;
    }
    const r = new $a();
    let n;
    for (const o of this._def.checks)
      if (o.kind === "min")
        t.data.length < o.value && (n = this._getOrReturnCtx(t, n), bt(n, {
          code: Ye.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), r.dirty());
      else if (o.kind === "max")
        t.data.length > o.value && (n = this._getOrReturnCtx(t, n), bt(n, {
          code: Ye.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), r.dirty());
      else if (o.kind === "length") {
        const i = t.data.length > o.value, a = t.data.length < o.value;
        (i || a) && (n = this._getOrReturnCtx(t, n), i ? bt(n, {
          code: Ye.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }) : a && bt(n, {
          code: Ye.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }), r.dirty());
      } else if (o.kind === "email")
        Pfe.test(t.data) || (n = this._getOrReturnCtx(t, n), bt(n, {
          validation: "email",
          code: Ye.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "emoji")
        Cfe.test(t.data) || (n = this._getOrReturnCtx(t, n), bt(n, {
          validation: "emoji",
          code: Ye.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "uuid")
        Ofe.test(t.data) || (n = this._getOrReturnCtx(t, n), bt(n, {
          validation: "uuid",
          code: Ye.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "cuid")
        Sfe.test(t.data) || (n = this._getOrReturnCtx(t, n), bt(n, {
          validation: "cuid",
          code: Ye.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "cuid2")
        Tfe.test(t.data) || (n = this._getOrReturnCtx(t, n), bt(n, {
          validation: "cuid2",
          code: Ye.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "ulid")
        Ife.test(t.data) || (n = this._getOrReturnCtx(t, n), bt(n, {
          validation: "ulid",
          code: Ye.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "url")
        try {
          new URL(t.data);
        } catch {
          n = this._getOrReturnCtx(t, n), bt(n, {
            validation: "url",
            code: Ye.invalid_string,
            message: o.message
          }), r.dirty();
        }
      else o.kind === "regex" ? (o.regex.lastIndex = 0, o.regex.test(t.data) || (n = this._getOrReturnCtx(t, n), bt(n, {
        validation: "regex",
        code: Ye.invalid_string,
        message: o.message
      }), r.dirty())) : o.kind === "trim" ? t.data = t.data.trim() : o.kind === "includes" ? t.data.includes(o.value, o.position) || (n = this._getOrReturnCtx(t, n), bt(n, {
        code: Ye.invalid_string,
        validation: { includes: o.value, position: o.position },
        message: o.message
      }), r.dirty()) : o.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : o.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : o.kind === "startsWith" ? t.data.startsWith(o.value) || (n = this._getOrReturnCtx(t, n), bt(n, {
        code: Ye.invalid_string,
        validation: { startsWith: o.value },
        message: o.message
      }), r.dirty()) : o.kind === "endsWith" ? t.data.endsWith(o.value) || (n = this._getOrReturnCtx(t, n), bt(n, {
        code: Ye.invalid_string,
        validation: { endsWith: o.value },
        message: o.message
      }), r.dirty()) : o.kind === "datetime" ? $fe(o).test(t.data) || (n = this._getOrReturnCtx(t, n), bt(n, {
        code: Ye.invalid_string,
        validation: "datetime",
        message: o.message
      }), r.dirty()) : o.kind === "ip" ? Ufe(t.data, o.version) || (n = this._getOrReturnCtx(t, n), bt(n, {
        validation: "ip",
        code: Ye.invalid_string,
        message: o.message
      }), r.dirty()) : Dr.assertNever(o);
    return { status: r.value, value: t.data };
  }
  _addCheck(t) {
    return new Kb({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...jt.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...jt.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...jt.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...jt.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...jt.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...jt.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...jt.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...jt.errToObj(t) });
  }
  datetime(t) {
    var r;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (r = t == null ? void 0 : t.offset) !== null && r !== void 0 ? r : !1,
      ...jt.errToObj(t == null ? void 0 : t.message)
    });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...jt.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r == null ? void 0 : r.position,
      ...jt.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...jt.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...jt.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...jt.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...jt.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...jt.errToObj(r)
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
};
q1.create = (e) => {
  var t;
  return new q1({
    checks: [],
    typeName: qt.ZodString,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...br(e)
  });
};
function Rfe(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, o = r > n ? r : n, i = parseInt(e.toFixed(o).replace(".", "")), a = parseInt(t.toFixed(o).replace(".", ""));
  return i % a / Math.pow(10, o);
}
let vw = class XI extends Br {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== ht.number) {
      const o = this._getOrReturnCtx(t);
      return bt(o, {
        code: Ye.invalid_type,
        expected: ht.number,
        received: o.parsedType
      }), lr;
    }
    let r;
    const n = new $a();
    for (const o of this._def.checks)
      o.kind === "int" ? Dr.isInteger(t.data) || (r = this._getOrReturnCtx(t, r), bt(r, {
        code: Ye.invalid_type,
        expected: "integer",
        received: "float",
        message: o.message
      }), n.dirty()) : o.kind === "min" ? (o.inclusive ? t.data < o.value : t.data <= o.value) && (r = this._getOrReturnCtx(t, r), bt(r, {
        code: Ye.too_small,
        minimum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), n.dirty()) : o.kind === "max" ? (o.inclusive ? t.data > o.value : t.data >= o.value) && (r = this._getOrReturnCtx(t, r), bt(r, {
        code: Ye.too_big,
        maximum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), n.dirty()) : o.kind === "multipleOf" ? Rfe(t.data, o.value) !== 0 && (r = this._getOrReturnCtx(t, r), bt(r, {
        code: Ye.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), n.dirty()) : o.kind === "finite" ? Number.isFinite(t.data) || (r = this._getOrReturnCtx(t, r), bt(r, {
        code: Ye.not_finite,
        message: o.message
      }), n.dirty()) : Dr.assertNever(o);
    return { status: n.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, jt.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, jt.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, jt.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, jt.toString(r));
  }
  setLimit(t, r, n, o) {
    return new XI({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: jt.toString(o)
        }
      ]
    });
  }
  _addCheck(t) {
    return new XI({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: jt.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: jt.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: jt.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: jt.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: jt.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: jt.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: jt.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: jt.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: jt.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && Dr.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
};
vw.create = (e) => new vw({
  checks: [],
  typeName: qt.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...br(e)
});
let Ew = class YI extends Br {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = BigInt(t.data)), this._getType(t) !== ht.bigint) {
      const o = this._getOrReturnCtx(t);
      return bt(o, {
        code: Ye.invalid_type,
        expected: ht.bigint,
        received: o.parsedType
      }), lr;
    }
    let r;
    const n = new $a();
    for (const o of this._def.checks)
      o.kind === "min" ? (o.inclusive ? t.data < o.value : t.data <= o.value) && (r = this._getOrReturnCtx(t, r), bt(r, {
        code: Ye.too_small,
        type: "bigint",
        minimum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), n.dirty()) : o.kind === "max" ? (o.inclusive ? t.data > o.value : t.data >= o.value) && (r = this._getOrReturnCtx(t, r), bt(r, {
        code: Ye.too_big,
        type: "bigint",
        maximum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), n.dirty()) : o.kind === "multipleOf" ? t.data % o.value !== BigInt(0) && (r = this._getOrReturnCtx(t, r), bt(r, {
        code: Ye.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), n.dirty()) : Dr.assertNever(o);
    return { status: n.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, jt.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, jt.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, jt.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, jt.toString(r));
  }
  setLimit(t, r, n, o) {
    return new YI({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: jt.toString(o)
        }
      ]
    });
  }
  _addCheck(t) {
    return new YI({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: jt.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: jt.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: jt.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: jt.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: jt.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
};
Ew.create = (e) => {
  var t;
  return new Ew({
    checks: [],
    typeName: qt.ZodBigInt,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...br(e)
  });
};
let _w = class extends Br {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== ht.boolean) {
      const r = this._getOrReturnCtx(t);
      return bt(r, {
        code: Ye.invalid_type,
        expected: ht.boolean,
        received: r.parsedType
      }), lr;
    }
    return ga(t.data);
  }
};
_w.create = (e) => new _w({
  typeName: qt.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...br(e)
});
let Aw = class CM extends Br {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== ht.date) {
      const o = this._getOrReturnCtx(t);
      return bt(o, {
        code: Ye.invalid_type,
        expected: ht.date,
        received: o.parsedType
      }), lr;
    }
    if (isNaN(t.data.getTime())) {
      const o = this._getOrReturnCtx(t);
      return bt(o, {
        code: Ye.invalid_date
      }), lr;
    }
    const r = new $a();
    let n;
    for (const o of this._def.checks)
      o.kind === "min" ? t.data.getTime() < o.value && (n = this._getOrReturnCtx(t, n), bt(n, {
        code: Ye.too_small,
        message: o.message,
        inclusive: !0,
        exact: !1,
        minimum: o.value,
        type: "date"
      }), r.dirty()) : o.kind === "max" ? t.data.getTime() > o.value && (n = this._getOrReturnCtx(t, n), bt(n, {
        code: Ye.too_big,
        message: o.message,
        inclusive: !0,
        exact: !1,
        maximum: o.value,
        type: "date"
      }), r.dirty()) : Dr.assertNever(o);
    return {
      status: r.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new CM({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: jt.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: jt.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
};
Aw.create = (e) => new Aw({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: qt.ZodDate,
  ...br(e)
});
let k3 = class extends Br {
  _parse(t) {
    if (this._getType(t) !== ht.symbol) {
      const r = this._getOrReturnCtx(t);
      return bt(r, {
        code: Ye.invalid_type,
        expected: ht.symbol,
        received: r.parsedType
      }), lr;
    }
    return ga(t.data);
  }
};
k3.create = (e) => new k3({
  typeName: qt.ZodSymbol,
  ...br(e)
});
let xw = class extends Br {
  _parse(t) {
    if (this._getType(t) !== ht.undefined) {
      const r = this._getOrReturnCtx(t);
      return bt(r, {
        code: Ye.invalid_type,
        expected: ht.undefined,
        received: r.parsedType
      }), lr;
    }
    return ga(t.data);
  }
};
xw.create = (e) => new xw({
  typeName: qt.ZodUndefined,
  ...br(e)
});
let kw = class extends Br {
  _parse(t) {
    if (this._getType(t) !== ht.null) {
      const r = this._getOrReturnCtx(t);
      return bt(r, {
        code: Ye.invalid_type,
        expected: ht.null,
        received: r.parsedType
      }), lr;
    }
    return ga(t.data);
  }
};
kw.create = (e) => new kw({
  typeName: qt.ZodNull,
  ...br(e)
});
let V1 = class extends Br {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return ga(t.data);
  }
};
V1.create = (e) => new V1({
  typeName: qt.ZodAny,
  ...br(e)
});
let qp = class extends Br {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return ga(t.data);
  }
};
qp.create = (e) => new qp({
  typeName: qt.ZodUnknown,
  ...br(e)
});
let uf = class extends Br {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return bt(r, {
      code: Ye.invalid_type,
      expected: ht.never,
      received: r.parsedType
    }), lr;
  }
};
uf.create = (e) => new uf({
  typeName: qt.ZodNever,
  ...br(e)
});
let S3 = class extends Br {
  _parse(t) {
    if (this._getType(t) !== ht.undefined) {
      const r = this._getOrReturnCtx(t);
      return bt(r, {
        code: Ye.invalid_type,
        expected: ht.void,
        received: r.parsedType
      }), lr;
    }
    return ga(t.data);
  }
};
S3.create = (e) => new S3({
  typeName: qt.ZodVoid,
  ...br(e)
});
let n0 = class $8 extends Br {
  _parse(t) {
    const { ctx: r, status: n } = this._processInputParams(t), o = this._def;
    if (r.parsedType !== ht.array)
      return bt(r, {
        code: Ye.invalid_type,
        expected: ht.array,
        received: r.parsedType
      }), lr;
    if (o.exactLength !== null) {
      const a = r.data.length > o.exactLength.value, u = r.data.length < o.exactLength.value;
      (a || u) && (bt(r, {
        code: a ? Ye.too_big : Ye.too_small,
        minimum: u ? o.exactLength.value : void 0,
        maximum: a ? o.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: o.exactLength.message
      }), n.dirty());
    }
    if (o.minLength !== null && r.data.length < o.minLength.value && (bt(r, {
      code: Ye.too_small,
      minimum: o.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: o.minLength.message
    }), n.dirty()), o.maxLength !== null && r.data.length > o.maxLength.value && (bt(r, {
      code: Ye.too_big,
      maximum: o.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: o.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((a, u) => o.type._parseAsync(new Sc(r, a, r.path, u)))).then((a) => $a.mergeArray(n, a));
    const i = [...r.data].map((a, u) => o.type._parseSync(new Sc(r, a, r.path, u)));
    return $a.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new $8({
      ...this._def,
      minLength: { value: t, message: jt.toString(r) }
    });
  }
  max(t, r) {
    return new $8({
      ...this._def,
      maxLength: { value: t, message: jt.toString(r) }
    });
  }
  length(t, r) {
    return new $8({
      ...this._def,
      exactLength: { value: t, message: jt.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
};
n0.create = (e, t) => new n0({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: qt.ZodArray,
  ...br(t)
});
function Y0(e) {
  if (e instanceof Ks) {
    const t = {};
    for (const r in e.shape) {
      const n = e.shape[r];
      t[r] = ef.create(Y0(n));
    }
    return new Ks({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof n0 ? new n0({
    ...e._def,
    type: Y0(e.element)
  }) : e instanceof ef ? ef.create(Y0(e.unwrap())) : e instanceof o0 ? o0.create(Y0(e.unwrap())) : e instanceof Tc ? Tc.create(e.items.map((t) => Y0(t))) : e;
}
let Ks = class pu extends Br {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = Dr.objectKeys(t);
    return this._cached = { shape: t, keys: r };
  }
  _parse(t) {
    if (this._getType(t) !== ht.object) {
      const l = this._getOrReturnCtx(t);
      return bt(l, {
        code: Ye.invalid_type,
        expected: ht.object,
        received: l.parsedType
      }), lr;
    }
    const { status: r, ctx: n } = this._processInputParams(t), { shape: o, keys: i } = this._getCached(), a = [];
    if (!(this._def.catchall instanceof uf && this._def.unknownKeys === "strip"))
      for (const l in n.data)
        i.includes(l) || a.push(l);
    const u = [];
    for (const l of i) {
      const d = o[l], f = n.data[l];
      u.push({
        key: { status: "valid", value: l },
        value: d._parse(new Sc(n, f, n.path, l)),
        alwaysSet: l in n.data
      });
    }
    if (this._def.catchall instanceof uf) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const d of a)
          u.push({
            key: { status: "valid", value: d },
            value: { status: "valid", value: n.data[d] }
          });
      else if (l === "strict")
        a.length > 0 && (bt(n, {
          code: Ye.unrecognized_keys,
          keys: a
        }), r.dirty());
      else if (l !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const d of a) {
        const f = n.data[d];
        u.push({
          key: { status: "valid", value: d },
          value: l._parse(
            new Sc(n, f, n.path, d)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: d in n.data
        });
      }
    }
    return n.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const d of u) {
        const f = await d.key;
        l.push({
          key: f,
          value: await d.value,
          alwaysSet: d.alwaysSet
        });
      }
      return l;
    }).then((l) => $a.mergeObjectSync(r, l)) : $a.mergeObjectSync(r, u);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return new pu({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, n) => {
          var o, i, a, u;
          const l = (a = (i = (o = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(o, r, n).message) !== null && a !== void 0 ? a : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (u = jt.errToObj(t).message) !== null && u !== void 0 ? u : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new pu({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new pu({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new pu({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new pu({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: qt.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new pu({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    return Dr.objectKeys(t).forEach((n) => {
      t[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new pu({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    return Dr.objectKeys(this.shape).forEach((n) => {
      t[n] || (r[n] = this.shape[n]);
    }), new pu({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return Y0(this);
  }
  partial(t) {
    const r = {};
    return Dr.objectKeys(this.shape).forEach((n) => {
      const o = this.shape[n];
      t && !t[n] ? r[n] = o : r[n] = o.optional();
    }), new pu({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    return Dr.objectKeys(this.shape).forEach((n) => {
      if (t && !t[n])
        r[n] = this.shape[n];
      else {
        let o = this.shape[n];
        for (; o instanceof ef; )
          o = o._def.innerType;
        r[n] = o;
      }
    }), new pu({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return UM(Dr.objectKeys(this.shape));
  }
};
Ks.create = (e, t) => new Ks({
  shape: () => e,
  unknownKeys: "strip",
  catchall: uf.create(),
  typeName: qt.ZodObject,
  ...br(t)
});
Ks.strictCreate = (e, t) => new Ks({
  shape: () => e,
  unknownKeys: "strict",
  catchall: uf.create(),
  typeName: qt.ZodObject,
  ...br(t)
});
Ks.lazycreate = (e, t) => new Ks({
  shape: e,
  unknownKeys: "strip",
  catchall: uf.create(),
  typeName: qt.ZodObject,
  ...br(t)
});
let Sw = class extends Br {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = this._def.options;
    function o(i) {
      for (const u of i)
        if (u.result.status === "valid")
          return u.result;
      for (const u of i)
        if (u.result.status === "dirty")
          return r.common.issues.push(...u.ctx.common.issues), u.result;
      const a = i.map((u) => new Nu(u.ctx.common.issues));
      return bt(r, {
        code: Ye.invalid_union,
        unionErrors: a
      }), lr;
    }
    if (r.common.async)
      return Promise.all(n.map(async (i) => {
        const a = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: r.data,
            path: r.path,
            parent: a
          }),
          ctx: a
        };
      })).then(o);
    {
      let i;
      const a = [];
      for (const l of n) {
        const d = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, f = l._parseSync({
          data: r.data,
          path: r.path,
          parent: d
        });
        if (f.status === "valid")
          return f;
        f.status === "dirty" && !i && (i = { result: f, ctx: d }), d.common.issues.length && a.push(d.common.issues);
      }
      if (i)
        return r.common.issues.push(...i.ctx.common.issues), i.result;
      const u = a.map((l) => new Nu(l));
      return bt(r, {
        code: Ye.invalid_union,
        unionErrors: u
      }), lr;
    }
  }
  get options() {
    return this._def.options;
  }
};
Sw.create = (e, t) => new Sw({
  options: e,
  typeName: qt.ZodUnion,
  ...br(t)
});
const U8 = (e) => e instanceof Iw ? U8(e.schema) : e instanceof Fu ? U8(e.innerType()) : e instanceof Ow ? [e.value] : e instanceof T2 ? e.options : e instanceof Pw ? Object.keys(e.enum) : e instanceof Cw ? U8(e._def.innerType) : e instanceof xw ? [void 0] : e instanceof kw ? [null] : null;
let BM = class NM extends Br {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== ht.object)
      return bt(r, {
        code: Ye.invalid_type,
        expected: ht.object,
        received: r.parsedType
      }), lr;
    const n = this.discriminator, o = r.data[n], i = this.optionsMap.get(o);
    return i ? r.common.async ? i._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : i._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (bt(r, {
      code: Ye.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), lr);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, r, n) {
    const o = /* @__PURE__ */ new Map();
    for (const i of r) {
      const a = U8(i.shape[t]);
      if (!a)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const u of a) {
        if (o.has(u))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(u)}`);
        o.set(u, i);
      }
    }
    return new NM({
      typeName: qt.ZodDiscriminatedUnion,
      discriminator: t,
      options: r,
      optionsMap: o,
      ...br(n)
    });
  }
};
function JI(e, t) {
  const r = Sd(e), n = Sd(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === ht.object && n === ht.object) {
    const o = Dr.objectKeys(t), i = Dr.objectKeys(e).filter((u) => o.indexOf(u) !== -1), a = { ...e, ...t };
    for (const u of i) {
      const l = JI(e[u], t[u]);
      if (!l.valid)
        return { valid: !1 };
      a[u] = l.data;
    }
    return { valid: !0, data: a };
  } else if (r === ht.array && n === ht.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const o = [];
    for (let i = 0; i < e.length; i++) {
      const a = e[i], u = t[i], l = JI(a, u);
      if (!l.valid)
        return { valid: !1 };
      o.push(l.data);
    }
    return { valid: !0, data: o };
  } else return r === ht.date && n === ht.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
let Tw = class extends Br {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), o = (i, a) => {
      if (WI(i) || WI(a))
        return lr;
      const u = JI(i.value, a.value);
      return u.valid ? ((ZI(i) || ZI(a)) && r.dirty(), { status: r.value, value: u.data }) : (bt(n, {
        code: Ye.invalid_intersection_types
      }), lr);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([i, a]) => o(i, a)) : o(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
};
Tw.create = (e, t, r) => new Tw({
  left: e,
  right: t,
  typeName: qt.ZodIntersection,
  ...br(r)
});
class Tc extends Br {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== ht.array)
      return bt(n, {
        code: Ye.invalid_type,
        expected: ht.array,
        received: n.parsedType
      }), lr;
    if (n.data.length < this._def.items.length)
      return bt(n, {
        code: Ye.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), lr;
    !this._def.rest && n.data.length > this._def.items.length && (bt(n, {
      code: Ye.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const o = [...n.data].map((i, a) => {
      const u = this._def.items[a] || this._def.rest;
      return u ? u._parse(new Sc(n, i, n.path, a)) : null;
    }).filter((i) => !!i);
    return n.common.async ? Promise.all(o).then((i) => $a.mergeArray(r, i)) : $a.mergeArray(r, o);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new Tc({
      ...this._def,
      rest: t
    });
  }
}
Tc.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Tc({
    items: e,
    typeName: qt.ZodTuple,
    rest: null,
    ...br(t)
  });
};
let $M = class QI extends Br {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== ht.object)
      return bt(n, {
        code: Ye.invalid_type,
        expected: ht.object,
        received: n.parsedType
      }), lr;
    const o = [], i = this._def.keyType, a = this._def.valueType;
    for (const u in n.data)
      o.push({
        key: i._parse(new Sc(n, u, n.path, u)),
        value: a._parse(new Sc(n, n.data[u], n.path, u))
      });
    return n.common.async ? $a.mergeObjectAsync(r, o) : $a.mergeObjectSync(r, o);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, r, n) {
    return r instanceof Br ? new QI({
      keyType: t,
      valueType: r,
      typeName: qt.ZodRecord,
      ...br(n)
    }) : new QI({
      keyType: q1.create(),
      valueType: t,
      typeName: qt.ZodRecord,
      ...br(r)
    });
  }
}, T3 = class extends Br {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== ht.map)
      return bt(n, {
        code: Ye.invalid_type,
        expected: ht.map,
        received: n.parsedType
      }), lr;
    const o = this._def.keyType, i = this._def.valueType, a = [...n.data.entries()].map(([u, l], d) => ({
      key: o._parse(new Sc(n, u, n.path, [d, "key"])),
      value: i._parse(new Sc(n, l, n.path, [d, "value"]))
    }));
    if (n.common.async) {
      const u = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of a) {
          const d = await l.key, f = await l.value;
          if (d.status === "aborted" || f.status === "aborted")
            return lr;
          (d.status === "dirty" || f.status === "dirty") && r.dirty(), u.set(d.value, f.value);
        }
        return { status: r.value, value: u };
      });
    } else {
      const u = /* @__PURE__ */ new Map();
      for (const l of a) {
        const d = l.key, f = l.value;
        if (d.status === "aborted" || f.status === "aborted")
          return lr;
        (d.status === "dirty" || f.status === "dirty") && r.dirty(), u.set(d.value, f.value);
      }
      return { status: r.value, value: u };
    }
  }
};
T3.create = (e, t, r) => new T3({
  valueType: t,
  keyType: e,
  typeName: qt.ZodMap,
  ...br(r)
});
let I3 = class eO extends Br {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== ht.set)
      return bt(n, {
        code: Ye.invalid_type,
        expected: ht.set,
        received: n.parsedType
      }), lr;
    const o = this._def;
    o.minSize !== null && n.data.size < o.minSize.value && (bt(n, {
      code: Ye.too_small,
      minimum: o.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: o.minSize.message
    }), r.dirty()), o.maxSize !== null && n.data.size > o.maxSize.value && (bt(n, {
      code: Ye.too_big,
      maximum: o.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: o.maxSize.message
    }), r.dirty());
    const i = this._def.valueType;
    function a(l) {
      const d = /* @__PURE__ */ new Set();
      for (const f of l) {
        if (f.status === "aborted")
          return lr;
        f.status === "dirty" && r.dirty(), d.add(f.value);
      }
      return { status: r.value, value: d };
    }
    const u = [...n.data.values()].map((l, d) => i._parse(new Sc(n, l, n.path, d)));
    return n.common.async ? Promise.all(u).then((l) => a(l)) : a(u);
  }
  min(t, r) {
    return new eO({
      ...this._def,
      minSize: { value: t, message: jt.toString(r) }
    });
  }
  max(t, r) {
    return new eO({
      ...this._def,
      maxSize: { value: t, message: jt.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
};
I3.create = (e, t) => new I3({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: qt.ZodSet,
  ...br(t)
});
class v1 extends Br {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== ht.function)
      return bt(r, {
        code: Ye.invalid_type,
        expected: ht.function,
        received: r.parsedType
      }), lr;
    function n(u, l) {
      return _3({
        data: u,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          E3(),
          ww
        ].filter((d) => !!d),
        issueData: {
          code: Ye.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function o(u, l) {
      return _3({
        data: u,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          E3(),
          ww
        ].filter((d) => !!d),
        issueData: {
          code: Ye.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const i = { errorMap: r.common.contextualErrorMap }, a = r.data;
    return this._def.returns instanceof G1 ? ga(async (...u) => {
      const l = new Nu([]), d = await this._def.args.parseAsync(u, i).catch((h) => {
        throw l.addIssue(n(u, h)), l;
      }), f = await a(...d);
      return await this._def.returns._def.type.parseAsync(f, i).catch((h) => {
        throw l.addIssue(o(f, h)), l;
      });
    }) : ga((...u) => {
      const l = this._def.args.safeParse(u, i);
      if (!l.success)
        throw new Nu([n(u, l.error)]);
      const d = a(...l.data), f = this._def.returns.safeParse(d, i);
      if (!f.success)
        throw new Nu([o(d, f.error)]);
      return f.data;
    });
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new v1({
      ...this._def,
      args: Tc.create(t).rest(qp.create())
    });
  }
  returns(t) {
    return new v1({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, r, n) {
    return new v1({
      args: t || Tc.create([]).rest(qp.create()),
      returns: r || qp.create(),
      typeName: qt.ZodFunction,
      ...br(n)
    });
  }
}
let Iw = class extends Br {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
};
Iw.create = (e, t) => new Iw({
  getter: e,
  typeName: qt.ZodLazy,
  ...br(t)
});
let Ow = class extends Br {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return bt(r, {
        received: r.data,
        code: Ye.invalid_literal,
        expected: this._def.value
      }), lr;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
};
Ow.create = (e, t) => new Ow({
  value: e,
  typeName: qt.ZodLiteral,
  ...br(t)
});
function UM(e, t) {
  return new T2({
    values: e,
    typeName: qt.ZodEnum,
    ...br(t)
  });
}
let T2 = class tO extends Br {
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return bt(r, {
        expected: Dr.joinValues(n),
        received: r.parsedType,
        code: Ye.invalid_type
      }), lr;
    }
    if (this._def.values.indexOf(t.data) === -1) {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return bt(r, {
        received: r.data,
        code: Ye.invalid_enum_value,
        options: n
      }), lr;
    }
    return ga(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t) {
    return tO.create(t);
  }
  exclude(t) {
    return tO.create(this.options.filter((r) => !t.includes(r)));
  }
};
T2.create = UM;
let Pw = class extends Br {
  _parse(t) {
    const r = Dr.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== ht.string && n.parsedType !== ht.number) {
      const o = Dr.objectValues(r);
      return bt(n, {
        expected: Dr.joinValues(o),
        received: n.parsedType,
        code: Ye.invalid_type
      }), lr;
    }
    if (r.indexOf(t.data) === -1) {
      const o = Dr.objectValues(r);
      return bt(n, {
        received: n.data,
        code: Ye.invalid_enum_value,
        options: o
      }), lr;
    }
    return ga(t.data);
  }
  get enum() {
    return this._def.values;
  }
};
Pw.create = (e, t) => new Pw({
  values: e,
  typeName: qt.ZodNativeEnum,
  ...br(t)
});
let G1 = class extends Br {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== ht.promise && r.common.async === !1)
      return bt(r, {
        code: Ye.invalid_type,
        expected: ht.promise,
        received: r.parsedType
      }), lr;
    const n = r.parsedType === ht.promise ? r.data : Promise.resolve(r.data);
    return ga(n.then((o) => this._def.type.parseAsync(o, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
};
G1.create = (e, t) => new G1({
  type: e,
  typeName: qt.ZodPromise,
  ...br(t)
});
let Fu = class extends Br {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === qt.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), o = this._def.effect || null;
    if (o.type === "preprocess") {
      const a = o.transform(n.data);
      return n.common.async ? Promise.resolve(a).then((u) => this._def.schema._parseAsync({
        data: u,
        path: n.path,
        parent: n
      })) : this._def.schema._parseSync({
        data: a,
        path: n.path,
        parent: n
      });
    }
    const i = {
      addIssue: (a) => {
        bt(n, a), a.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), o.type === "refinement") {
      const a = (u) => {
        const l = o.refinement(u, i);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return u;
      };
      if (n.common.async === !1) {
        const u = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return u.status === "aborted" ? lr : (u.status === "dirty" && r.dirty(), a(u.value), { status: r.value, value: u.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((u) => u.status === "aborted" ? lr : (u.status === "dirty" && r.dirty(), a(u.value).then(() => ({ status: r.value, value: u.value }))));
    }
    if (o.type === "transform")
      if (n.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!A3(a))
          return a;
        const u = o.transform(a.value, i);
        if (u instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: u };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((a) => A3(a) ? Promise.resolve(o.transform(a.value, i)).then((u) => ({ status: r.value, value: u })) : a);
    Dr.assertNever(o);
  }
};
Fu.create = (e, t, r) => new Fu({
  schema: e,
  typeName: qt.ZodEffects,
  effect: t,
  ...br(r)
});
Fu.createWithPreprocess = (e, t, r) => new Fu({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: qt.ZodEffects,
  ...br(r)
});
let ef = class extends Br {
  _parse(t) {
    return this._getType(t) === ht.undefined ? ga(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ef.create = (e, t) => new ef({
  innerType: e,
  typeName: qt.ZodOptional,
  ...br(t)
});
let o0 = class extends Br {
  _parse(t) {
    return this._getType(t) === ht.null ? ga(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
};
o0.create = (e, t) => new o0({
  innerType: e,
  typeName: qt.ZodNullable,
  ...br(t)
});
let Cw = class extends Br {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let n = r.data;
    return r.parsedType === ht.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
Cw.create = (e, t) => new Cw({
  innerType: e,
  typeName: qt.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...br(t)
});
let O3 = class extends Br {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, o = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return x3(o) ? o.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new Nu(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: o.status === "valid" ? o.value : this._def.catchValue({
        get error() {
          return new Nu(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
};
O3.create = (e, t) => new O3({
  innerType: e,
  typeName: qt.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...br(t)
});
let P3 = class extends Br {
  _parse(t) {
    if (this._getType(t) !== ht.nan) {
      const r = this._getOrReturnCtx(t);
      return bt(r, {
        code: Ye.invalid_type,
        expected: ht.nan,
        received: r.parsedType
      }), lr;
    }
    return { status: "valid", value: t.data };
  }
};
P3.create = (e) => new P3({
  typeName: qt.ZodNaN,
  ...br(e)
});
const zfe = Symbol("zod_brand");
class RM extends Br {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
let $C = class zM extends Br {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const o = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? lr : o.status === "dirty" ? (r.dirty(), PM(o.value)) : this._def.out._parseAsync({
          data: o.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const o = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return o.status === "aborted" ? lr : o.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: o.value
      }) : this._def.out._parseSync({
        data: o.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, r) {
    return new zM({
      in: t,
      out: r,
      typeName: qt.ZodPipeline
    });
  }
};
const jM = (e, t = {}, r) => e ? V1.create().superRefine((n, o) => {
  var i, a;
  if (!e(n)) {
    const u = typeof t == "function" ? t(n) : typeof t == "string" ? { message: t } : t, l = (a = (i = u.fatal) !== null && i !== void 0 ? i : r) !== null && a !== void 0 ? a : !0, d = typeof u == "string" ? { message: u } : u;
    o.addIssue({ code: "custom", ...d, fatal: l });
  }
}) : V1.create(), jfe = {
  object: Ks.lazycreate
};
var qt;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline";
})(qt || (qt = {}));
const Lfe = (e, t = {
  message: `Input not instance of ${e.name}`
}) => jM((r) => r instanceof e, t), LM = q1.create, HM = vw.create, Hfe = P3.create, Ffe = Ew.create, FM = _w.create, Mfe = Aw.create, Dfe = k3.create, Kfe = xw.create, qfe = kw.create, Vfe = V1.create, Gfe = qp.create, Wfe = uf.create, Zfe = S3.create, Xfe = n0.create, Yfe = Ks.create, Jfe = Ks.strictCreate, Qfe = Sw.create, ede = BM.create, tde = Tw.create, rde = Tc.create, nde = $M.create, ode = T3.create, ide = I3.create, ade = v1.create, sde = Iw.create, ude = Ow.create, cde = T2.create, lde = Pw.create, fde = G1.create, _U = Fu.create, dde = ef.create, hde = o0.create, pde = Fu.createWithPreprocess, gde = $C.create, mde = () => LM().optional(), yde = () => HM().optional(), bde = () => FM().optional(), wde = {
  string: (e) => q1.create({ ...e, coerce: !0 }),
  number: (e) => vw.create({ ...e, coerce: !0 }),
  boolean: (e) => _w.create({
    ...e,
    coerce: !0
  }),
  bigint: (e) => Ew.create({ ...e, coerce: !0 }),
  date: (e) => Aw.create({ ...e, coerce: !0 })
}, vde = lr;
var da = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: ww,
  setErrorMap: xfe,
  getErrorMap: E3,
  makeIssue: _3,
  EMPTY_PATH: kfe,
  addIssueToContext: bt,
  ParseStatus: $a,
  INVALID: lr,
  DIRTY: PM,
  OK: ga,
  isAborted: WI,
  isDirty: ZI,
  isValid: A3,
  isAsync: x3,
  get util() {
    return Dr;
  },
  get objectUtil() {
    return GI;
  },
  ZodParsedType: ht,
  getParsedType: Sd,
  ZodType: Br,
  ZodString: q1,
  ZodNumber: vw,
  ZodBigInt: Ew,
  ZodBoolean: _w,
  ZodDate: Aw,
  ZodSymbol: k3,
  ZodUndefined: xw,
  ZodNull: kw,
  ZodAny: V1,
  ZodUnknown: qp,
  ZodNever: uf,
  ZodVoid: S3,
  ZodArray: n0,
  ZodObject: Ks,
  ZodUnion: Sw,
  ZodDiscriminatedUnion: BM,
  ZodIntersection: Tw,
  ZodTuple: Tc,
  ZodRecord: $M,
  ZodMap: T3,
  ZodSet: I3,
  ZodFunction: v1,
  ZodLazy: Iw,
  ZodLiteral: Ow,
  ZodEnum: T2,
  ZodNativeEnum: Pw,
  ZodPromise: G1,
  ZodEffects: Fu,
  ZodTransformer: Fu,
  ZodOptional: ef,
  ZodNullable: o0,
  ZodDefault: Cw,
  ZodCatch: O3,
  ZodNaN: P3,
  BRAND: zfe,
  ZodBranded: RM,
  ZodPipeline: $C,
  custom: jM,
  Schema: Br,
  ZodSchema: Br,
  late: jfe,
  get ZodFirstPartyTypeKind() {
    return qt;
  },
  coerce: wde,
  any: Vfe,
  array: Xfe,
  bigint: Ffe,
  boolean: FM,
  date: Mfe,
  discriminatedUnion: ede,
  effect: _U,
  enum: cde,
  function: ade,
  instanceof: Lfe,
  intersection: tde,
  lazy: sde,
  literal: ude,
  map: ode,
  nan: Hfe,
  nativeEnum: lde,
  never: Wfe,
  null: qfe,
  nullable: hde,
  number: HM,
  object: Yfe,
  oboolean: bde,
  onumber: yde,
  optional: dde,
  ostring: mde,
  pipeline: gde,
  preprocess: pde,
  promise: fde,
  record: nde,
  set: ide,
  strictObject: Jfe,
  string: LM,
  symbol: Dfe,
  transformer: _U,
  tuple: rde,
  undefined: Kfe,
  union: Qfe,
  unknown: Gfe,
  void: Zfe,
  NEVER: vde,
  ZodIssueCode: Ye,
  quotelessJson: Afe,
  ZodError: Nu
});
const MM = da.string().regex(/^[a-fA-F0-9]$/), Ede = da.string().regex(/^[a-fA-F0-9]{64}$/), W1 = da.number().min(0).max(4294967295), _de = da.bigint(), DM = da.instanceof(Uint8Array), Ade = da.union([MM, W1, da.string(), DM]).array(), UC = da.union([Ade, MM, DM]), xde = da.array(UC), KM = da.object({
  value: da.union([W1, _de]),
  scriptPubKey: UC
}), kde = da.object({
  txid: Ede,
  vout: W1,
  scriptSig: UC,
  sequence: W1,
  prevout: KM.optional(),
  witness: xde
});
da.object({
  version: W1,
  vin: da.array(kde),
  vout: da.array(KM),
  locktime: W1
});
var ao = {}, qM = {}, r4 = {}, RC = {}, wg = {}, gn = {}, Ur = {};
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
Object.defineProperty(Ur, "__esModule", { value: !0 });
Ur.notImplemented = Ur.bitMask = void 0;
Ur.isBytes = i4;
Ur.abytes = a4;
Ur.abool = Tde;
Ur.bytesToHex = zC;
Ur.numberToHexUnpadded = VM;
Ur.hexToNumber = jC;
Ur.hexToBytes = s4;
Ur.bytesToNumberBE = Ode;
Ur.bytesToNumberLE = Pde;
Ur.numberToBytesBE = GM;
Ur.numberToBytesLE = Cde;
Ur.numberToVarBytesBE = Bde;
Ur.ensureBytes = Nde;
Ur.concatBytes = WM;
Ur.equalBytes = $de;
Ur.utf8ToBytes = Ude;
Ur.inRange = ZM;
Ur.aInRange = Rde;
Ur.bitLen = zde;
Ur.bitGet = jde;
Ur.bitSet = Lde;
Ur.createHmacDrbg = Fde;
Ur.validateObject = Dde;
Ur.memoized = qde;
const n4 = /* @__PURE__ */ BigInt(0), o4 = /* @__PURE__ */ BigInt(1), Sde = /* @__PURE__ */ BigInt(2);
function i4(e) {
  return e instanceof Uint8Array || ArrayBuffer.isView(e) && e.constructor.name === "Uint8Array";
}
function a4(e) {
  if (!i4(e))
    throw new Error("Uint8Array expected");
}
function Tde(e, t) {
  if (typeof t != "boolean")
    throw new Error(e + " boolean expected, got " + t);
}
const Ide = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function zC(e) {
  a4(e);
  let t = "";
  for (let r = 0; r < e.length; r++)
    t += Ide[e[r]];
  return t;
}
function VM(e) {
  const t = e.toString(16);
  return t.length & 1 ? "0" + t : t;
}
function jC(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  return e === "" ? n4 : BigInt("0x" + e);
}
const Bl = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function AU(e) {
  if (e >= Bl._0 && e <= Bl._9)
    return e - Bl._0;
  if (e >= Bl.A && e <= Bl.F)
    return e - (Bl.A - 10);
  if (e >= Bl.a && e <= Bl.f)
    return e - (Bl.a - 10);
}
function s4(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  const t = e.length, r = t / 2;
  if (t % 2)
    throw new Error("hex string expected, got unpadded hex of length " + t);
  const n = new Uint8Array(r);
  for (let o = 0, i = 0; o < r; o++, i += 2) {
    const a = AU(e.charCodeAt(i)), u = AU(e.charCodeAt(i + 1));
    if (a === void 0 || u === void 0) {
      const l = e[i] + e[i + 1];
      throw new Error('hex string expected, got non-hex character "' + l + '" at index ' + i);
    }
    n[o] = a * 16 + u;
  }
  return n;
}
function Ode(e) {
  return jC(zC(e));
}
function Pde(e) {
  return a4(e), jC(zC(Uint8Array.from(e).reverse()));
}
function GM(e, t) {
  return s4(e.toString(16).padStart(t * 2, "0"));
}
function Cde(e, t) {
  return GM(e, t).reverse();
}
function Bde(e) {
  return s4(VM(e));
}
function Nde(e, t, r) {
  let n;
  if (typeof t == "string")
    try {
      n = s4(t);
    } catch (i) {
      throw new Error(e + " must be hex string or Uint8Array, cause: " + i);
    }
  else if (i4(t))
    n = Uint8Array.from(t);
  else
    throw new Error(e + " must be hex string or Uint8Array");
  const o = n.length;
  if (typeof r == "number" && o !== r)
    throw new Error(e + " of length " + r + " expected, got " + o);
  return n;
}
function WM(...e) {
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    a4(o), t += o.length;
  }
  const r = new Uint8Array(t);
  for (let n = 0, o = 0; n < e.length; n++) {
    const i = e[n];
    r.set(i, o), o += i.length;
  }
  return r;
}
function $de(e, t) {
  if (e.length !== t.length)
    return !1;
  let r = 0;
  for (let n = 0; n < e.length; n++)
    r |= e[n] ^ t[n];
  return r === 0;
}
function Ude(e) {
  if (typeof e != "string")
    throw new Error("string expected");
  return new Uint8Array(new TextEncoder().encode(e));
}
const WS = (e) => typeof e == "bigint" && n4 <= e;
function ZM(e, t, r) {
  return WS(e) && WS(t) && WS(r) && t <= e && e < r;
}
function Rde(e, t, r, n) {
  if (!ZM(t, r, n))
    throw new Error("expected valid " + e + ": " + r + " <= n < " + n + ", got " + t);
}
function zde(e) {
  let t;
  for (t = 0; e > n4; e >>= o4, t += 1)
    ;
  return t;
}
function jde(e, t) {
  return e >> BigInt(t) & o4;
}
function Lde(e, t, r) {
  return e | (r ? o4 : n4) << BigInt(t);
}
const Hde = (e) => (Sde << BigInt(e - 1)) - o4;
Ur.bitMask = Hde;
const ZS = (e) => new Uint8Array(e), xU = (e) => Uint8Array.from(e);
function Fde(e, t, r) {
  if (typeof e != "number" || e < 2)
    throw new Error("hashLen must be a number");
  if (typeof t != "number" || t < 2)
    throw new Error("qByteLen must be a number");
  if (typeof r != "function")
    throw new Error("hmacFn must be a function");
  let n = ZS(e), o = ZS(e), i = 0;
  const a = () => {
    n.fill(1), o.fill(0), i = 0;
  }, u = (...f) => r(o, n, ...f), l = (f = ZS()) => {
    o = u(xU([0]), f), n = u(), f.length !== 0 && (o = u(xU([1]), f), n = u());
  }, d = () => {
    if (i++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let f = 0;
    const h = [];
    for (; f < t; ) {
      n = u();
      const g = n.slice();
      h.push(g), f += n.length;
    }
    return WM(...h);
  };
  return (f, h) => {
    a(), l(f);
    let g;
    for (; !(g = h(d())); )
      l();
    return a(), g;
  };
}
const Mde = {
  bigint: (e) => typeof e == "bigint",
  function: (e) => typeof e == "function",
  boolean: (e) => typeof e == "boolean",
  string: (e) => typeof e == "string",
  stringOrUint8Array: (e) => typeof e == "string" || i4(e),
  isSafeInteger: (e) => Number.isSafeInteger(e),
  array: (e) => Array.isArray(e),
  field: (e, t) => t.Fp.isValid(e),
  hash: (e) => typeof e == "function" && Number.isSafeInteger(e.outputLen)
};
function Dde(e, t, r = {}) {
  const n = (o, i, a) => {
    const u = Mde[i];
    if (typeof u != "function")
      throw new Error("invalid validator function");
    const l = e[o];
    if (!(a && l === void 0) && !u(l, e))
      throw new Error("param " + String(o) + " is invalid. Expected " + i + ", got " + l);
  };
  for (const [o, i] of Object.entries(t))
    n(o, i, !1);
  for (const [o, i] of Object.entries(r))
    n(o, i, !0);
  return e;
}
const Kde = () => {
  throw new Error("not implemented");
};
Ur.notImplemented = Kde;
function qde(e) {
  const t = /* @__PURE__ */ new WeakMap();
  return (r, ...n) => {
    const o = t.get(r);
    if (o !== void 0)
      return o;
    const i = e(r, ...n);
    return t.set(r, i), i;
  };
}
Object.defineProperty(gn, "__esModule", { value: !0 });
gn.isNegativeLE = void 0;
gn.mod = Qa;
gn.pow = XM;
gn.pow2 = Gde;
gn.invert = C3;
gn.tonelliShanks = YM;
gn.FpSqrt = JM;
gn.validateField = Xde;
gn.FpPow = QM;
gn.FpInvertBatch = eD;
gn.FpDiv = Yde;
gn.FpLegendre = tD;
gn.FpIsSquare = Jde;
gn.nLength = LC;
gn.Field = Qde;
gn.FpSqrtOdd = ehe;
gn.FpSqrtEven = the;
gn.hashToPrivateScalar = rhe;
gn.getFieldBytesLength = HC;
gn.getMinHashLength = rD;
gn.mapHashToField = nhe;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const rs = Ur, ni = BigInt(0), Tn = BigInt(1), Td = /* @__PURE__ */ BigInt(2), Vde = /* @__PURE__ */ BigInt(3), rO = /* @__PURE__ */ BigInt(4), kU = /* @__PURE__ */ BigInt(5), SU = /* @__PURE__ */ BigInt(8);
function Qa(e, t) {
  const r = e % t;
  return r >= ni ? r : t + r;
}
function XM(e, t, r) {
  if (t < ni)
    throw new Error("invalid exponent, negatives unsupported");
  if (r <= ni)
    throw new Error("invalid modulus");
  if (r === Tn)
    return ni;
  let n = Tn;
  for (; t > ni; )
    t & Tn && (n = n * e % r), e = e * e % r, t >>= Tn;
  return n;
}
function Gde(e, t, r) {
  let n = e;
  for (; t-- > ni; )
    n *= n, n %= r;
  return n;
}
function C3(e, t) {
  if (e === ni)
    throw new Error("invert: expected non-zero number");
  if (t <= ni)
    throw new Error("invert: expected positive modulus, got " + t);
  let r = Qa(e, t), n = t, o = ni, i = Tn;
  for (; r !== ni; ) {
    const a = n / r, u = n % r, l = o - i * a;
    n = r, r = u, o = i, i = l;
  }
  if (n !== Tn)
    throw new Error("invert: does not exist");
  return Qa(o, t);
}
function YM(e) {
  const t = (e - Tn) / Td;
  let r, n, o;
  for (r = e - Tn, n = 0; r % Td === ni; r /= Td, n++)
    ;
  for (o = Td; o < e && XM(o, t, e) !== e - Tn; o++)
    if (o > 1e3)
      throw new Error("Cannot find square root: likely non-prime P");
  if (n === 1) {
    const a = (e + Tn) / rO;
    return function(u, l) {
      const d = u.pow(l, a);
      if (!u.eql(u.sqr(d), l))
        throw new Error("Cannot find square root");
      return d;
    };
  }
  const i = (r + Tn) / Td;
  return function(a, u) {
    if (a.pow(u, t) === a.neg(a.ONE))
      throw new Error("Cannot find square root");
    let l = n, d = a.pow(a.mul(a.ONE, o), r), f = a.pow(u, i), h = a.pow(u, r);
    for (; !a.eql(h, a.ONE); ) {
      if (a.eql(h, a.ZERO))
        return a.ZERO;
      let g = 1;
      for (let w = a.sqr(h); g < l && !a.eql(w, a.ONE); g++)
        w = a.sqr(w);
      const b = a.pow(d, Tn << BigInt(l - g - 1));
      d = a.sqr(b), f = a.mul(f, b), h = a.mul(h, d), l = g;
    }
    return f;
  };
}
function JM(e) {
  if (e % rO === Vde) {
    const t = (e + Tn) / rO;
    return function(r, n) {
      const o = r.pow(n, t);
      if (!r.eql(r.sqr(o), n))
        throw new Error("Cannot find square root");
      return o;
    };
  }
  if (e % SU === kU) {
    const t = (e - kU) / SU;
    return function(r, n) {
      const o = r.mul(n, Td), i = r.pow(o, t), a = r.mul(n, i), u = r.mul(r.mul(a, Td), i), l = r.mul(a, r.sub(u, r.ONE));
      if (!r.eql(r.sqr(l), n))
        throw new Error("Cannot find square root");
      return l;
    };
  }
  return YM(e);
}
const Wde = (e, t) => (Qa(e, t) & Tn) === Tn;
gn.isNegativeLE = Wde;
const Zde = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function Xde(e) {
  const t = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, r = Zde.reduce((n, o) => (n[o] = "function", n), t);
  return (0, rs.validateObject)(e, r);
}
function QM(e, t, r) {
  if (r < ni)
    throw new Error("invalid exponent, negatives unsupported");
  if (r === ni)
    return e.ONE;
  if (r === Tn)
    return t;
  let n = e.ONE, o = t;
  for (; r > ni; )
    r & Tn && (n = e.mul(n, o)), o = e.sqr(o), r >>= Tn;
  return n;
}
function eD(e, t) {
  const r = new Array(t.length), n = t.reduce((i, a, u) => e.is0(a) ? i : (r[u] = i, e.mul(i, a)), e.ONE), o = e.inv(n);
  return t.reduceRight((i, a, u) => e.is0(a) ? i : (r[u] = e.mul(i, r[u]), e.mul(i, a)), o), r;
}
function Yde(e, t, r) {
  return e.mul(t, typeof r == "bigint" ? C3(r, e.ORDER) : e.inv(r));
}
function tD(e) {
  const t = (e - Tn) / Td;
  return (r, n) => r.pow(n, t);
}
function Jde(e) {
  const t = tD(e.ORDER);
  return (r) => {
    const n = t(e, r);
    return e.eql(n, e.ZERO) || e.eql(n, e.ONE);
  };
}
function LC(e, t) {
  const r = t !== void 0 ? t : e.toString(2).length, n = Math.ceil(r / 8);
  return { nBitLength: r, nByteLength: n };
}
function Qde(e, t, r = !1, n = {}) {
  if (e <= ni)
    throw new Error("invalid field: expected ORDER > 0, got " + e);
  const { nBitLength: o, nByteLength: i } = LC(e, t);
  if (i > 2048)
    throw new Error("invalid field: expected ORDER of <= 2048 bytes");
  let a;
  const u = Object.freeze({
    ORDER: e,
    isLE: r,
    BITS: o,
    BYTES: i,
    MASK: (0, rs.bitMask)(o),
    ZERO: ni,
    ONE: Tn,
    create: (l) => Qa(l, e),
    isValid: (l) => {
      if (typeof l != "bigint")
        throw new Error("invalid field element: expected bigint, got " + typeof l);
      return ni <= l && l < e;
    },
    is0: (l) => l === ni,
    isOdd: (l) => (l & Tn) === Tn,
    neg: (l) => Qa(-l, e),
    eql: (l, d) => l === d,
    sqr: (l) => Qa(l * l, e),
    add: (l, d) => Qa(l + d, e),
    sub: (l, d) => Qa(l - d, e),
    mul: (l, d) => Qa(l * d, e),
    pow: (l, d) => QM(u, l, d),
    div: (l, d) => Qa(l * C3(d, e), e),
    // Same as above, but doesn't normalize
    sqrN: (l) => l * l,
    addN: (l, d) => l + d,
    subN: (l, d) => l - d,
    mulN: (l, d) => l * d,
    inv: (l) => C3(l, e),
    sqrt: n.sqrt || ((l) => (a || (a = JM(e)), a(u, l))),
    invertBatch: (l) => eD(u, l),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (l, d, f) => f ? d : l,
    toBytes: (l) => r ? (0, rs.numberToBytesLE)(l, i) : (0, rs.numberToBytesBE)(l, i),
    fromBytes: (l) => {
      if (l.length !== i)
        throw new Error("Field.fromBytes: expected " + i + " bytes, got " + l.length);
      return r ? (0, rs.bytesToNumberLE)(l) : (0, rs.bytesToNumberBE)(l);
    }
  });
  return Object.freeze(u);
}
function ehe(e, t) {
  if (!e.isOdd)
    throw new Error("Field doesn't have isOdd");
  const r = e.sqrt(t);
  return e.isOdd(r) ? r : e.neg(r);
}
function the(e, t) {
  if (!e.isOdd)
    throw new Error("Field doesn't have isOdd");
  const r = e.sqrt(t);
  return e.isOdd(r) ? e.neg(r) : r;
}
function rhe(e, t, r = !1) {
  e = (0, rs.ensureBytes)("privateHash", e);
  const n = e.length, o = LC(t).nByteLength + 8;
  if (o < 24 || n < o || n > 1024)
    throw new Error("hashToPrivateScalar: expected " + o + "-1024 bytes of input, got " + n);
  const i = r ? (0, rs.bytesToNumberLE)(e) : (0, rs.bytesToNumberBE)(e);
  return Qa(i, t - Tn) + Tn;
}
function HC(e) {
  if (typeof e != "bigint")
    throw new Error("field order must be bigint");
  const t = e.toString(2).length;
  return Math.ceil(t / 8);
}
function rD(e) {
  const t = HC(e);
  return t + Math.ceil(t / 2);
}
function nhe(e, t, r = !1) {
  const n = e.length, o = HC(t), i = rD(t);
  if (n < 16 || n < i || n > 1024)
    throw new Error("expected " + i + "-1024 bytes of input, got " + n);
  const a = r ? (0, rs.bytesToNumberLE)(e) : (0, rs.bytesToNumberBE)(e), u = Qa(a, t - Tn) + Tn;
  return r ? (0, rs.numberToBytesLE)(u, o) : (0, rs.numberToBytesBE)(u, o);
}
Object.defineProperty(wg, "__esModule", { value: !0 });
wg.wNAF = ohe;
wg.pippenger = ihe;
wg.precomputeMSMUnsafe = ahe;
wg.validateBasic = she;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const TU = gn, nD = Ur, IU = BigInt(0), Fv = BigInt(1);
function XS(e, t) {
  const r = t.negate();
  return e ? r : t;
}
function FC(e, t) {
  if (!Number.isSafeInteger(e) || e <= 0 || e > t)
    throw new Error("invalid window size, expected [1.." + t + "], got W=" + e);
}
function YS(e, t) {
  FC(e, t);
  const r = Math.ceil(t / e) + 1, n = 2 ** (e - 1);
  return { windows: r, windowSize: n };
}
function oD(e, t) {
  if (!Array.isArray(e))
    throw new Error("array expected");
  e.forEach((r, n) => {
    if (!(r instanceof t))
      throw new Error("invalid point at index " + n);
  });
}
function iD(e, t) {
  if (!Array.isArray(e))
    throw new Error("array of scalars expected");
  e.forEach((r, n) => {
    if (!t.isValid(r))
      throw new Error("invalid scalar at index " + n);
  });
}
const JS = /* @__PURE__ */ new WeakMap(), aD = /* @__PURE__ */ new WeakMap();
function QS(e) {
  return aD.get(e) || 1;
}
function ohe(e, t) {
  return {
    constTimeNegate: XS,
    hasPrecomputes(r) {
      return QS(r) !== 1;
    },
    // non-const time multiplication ladder
    unsafeLadder(r, n, o = e.ZERO) {
      let i = r;
      for (; n > IU; )
        n & Fv && (o = o.add(i)), i = i.double(), n >>= Fv;
      return o;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param elm Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(r, n) {
      const { windows: o, windowSize: i } = YS(n, t), a = [];
      let u = r, l = u;
      for (let d = 0; d < o; d++) {
        l = u, a.push(l);
        for (let f = 1; f < i; f++)
          l = l.add(u), a.push(l);
        u = l.double();
      }
      return a;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(r, n, o) {
      const { windows: i, windowSize: a } = YS(r, t);
      let u = e.ZERO, l = e.BASE;
      const d = BigInt(2 ** r - 1), f = 2 ** r, h = BigInt(r);
      for (let g = 0; g < i; g++) {
        const b = g * a;
        let w = Number(o & d);
        o >>= h, w > a && (w -= f, o += Fv);
        const E = b, _ = b + Math.abs(w) - 1, O = g % 2 !== 0, C = w < 0;
        w === 0 ? l = l.add(XS(O, n[E])) : u = u.add(XS(C, n[_]));
      }
      return { p: u, f: l };
    },
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */
    wNAFUnsafe(r, n, o, i = e.ZERO) {
      const { windows: a, windowSize: u } = YS(r, t), l = BigInt(2 ** r - 1), d = 2 ** r, f = BigInt(r);
      for (let h = 0; h < a; h++) {
        const g = h * u;
        if (o === IU)
          break;
        let b = Number(o & l);
        if (o >>= f, b > u && (b -= d, o += Fv), b === 0)
          continue;
        let w = n[g + Math.abs(b) - 1];
        b < 0 && (w = w.negate()), i = i.add(w);
      }
      return i;
    },
    getPrecomputes(r, n, o) {
      let i = JS.get(n);
      return i || (i = this.precomputeWindow(n, r), r !== 1 && JS.set(n, o(i))), i;
    },
    wNAFCached(r, n, o) {
      const i = QS(r);
      return this.wNAF(i, this.getPrecomputes(i, r, o), n);
    },
    wNAFCachedUnsafe(r, n, o, i) {
      const a = QS(r);
      return a === 1 ? this.unsafeLadder(r, n, i) : this.wNAFUnsafe(a, this.getPrecomputes(a, r, o), n, i);
    },
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    setWindowSize(r, n) {
      FC(n, t), aD.set(r, n), JS.delete(r);
    }
  };
}
function ihe(e, t, r, n) {
  if (oD(r, e), iD(n, t), r.length !== n.length)
    throw new Error("arrays of points and scalars must have equal length");
  const o = e.ZERO, i = (0, nD.bitLen)(BigInt(r.length)), a = i > 12 ? i - 3 : i > 4 ? i - 2 : i ? 2 : 1, u = (1 << a) - 1, l = new Array(u + 1).fill(o), d = Math.floor((t.BITS - 1) / a) * a;
  let f = o;
  for (let h = d; h >= 0; h -= a) {
    l.fill(o);
    for (let b = 0; b < n.length; b++) {
      const w = n[b], E = Number(w >> BigInt(h) & BigInt(u));
      l[E] = l[E].add(r[b]);
    }
    let g = o;
    for (let b = l.length - 1, w = o; b > 0; b--)
      w = w.add(l[b]), g = g.add(w);
    if (f = f.add(g), h !== 0)
      for (let b = 0; b < a; b++)
        f = f.double();
  }
  return f;
}
function ahe(e, t, r, n) {
  FC(n, t.BITS), oD(r, e);
  const o = e.ZERO, i = 2 ** n - 1, a = Math.ceil(t.BITS / n), u = BigInt((1 << n) - 1), l = r.map((d) => {
    const f = [];
    for (let h = 0, g = d; h < i; h++)
      f.push(g), g = g.add(d);
    return f;
  });
  return (d) => {
    if (iD(d, t), d.length > r.length)
      throw new Error("array of scalars must be smaller than array of points");
    let f = o;
    for (let h = 0; h < a; h++) {
      if (f !== o)
        for (let b = 0; b < n; b++)
          f = f.double();
      const g = BigInt(a * n - (h + 1) * n);
      for (let b = 0; b < d.length; b++) {
        const w = d[b], E = Number(w >> g & u);
        E && (f = f.add(l[b][E - 1]));
      }
    }
    return f;
  };
}
function she(e) {
  return (0, TU.validateField)(e.Fp), (0, nD.validateObject)(e, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...(0, TU.nLength)(e.n, e.nBitLength),
    ...e,
    p: e.Fp.ORDER
  });
}
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.DER = e.DERErr = void 0, e.weierstrassPoints = E, e.weierstrass = O, e.SWUFpSqrtRatio = C, e.mapToCurveSimpleSWU = I;
  /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  const t = wg, r = gn, n = Ur, o = Ur;
  function i(S) {
    S.lowS !== void 0 && (0, o.abool)("lowS", S.lowS), S.prehash !== void 0 && (0, o.abool)("prehash", S.prehash);
  }
  function a(S) {
    const T = (0, t.validateBasic)(S);
    n.validateObject(T, {
      a: "field",
      b: "field"
    }, {
      allowedPrivateKeyLengths: "array",
      wrapPrivateKey: "boolean",
      isTorsionFree: "function",
      clearCofactor: "function",
      allowInfinityPoint: "boolean",
      fromBytes: "function",
      toBytes: "function"
    });
    const { endo: A, Fp: $, a: U } = T;
    if (A) {
      if (!$.eql(U, $.ZERO))
        throw new Error("invalid endomorphism, can only be defined for Koblitz curves that have a=0");
      if (typeof A != "object" || typeof A.beta != "bigint" || typeof A.splitScalar != "function")
        throw new Error("invalid endomorphism, expected beta: bigint and splitScalar: function");
    }
    return Object.freeze({ ...T });
  }
  const { bytesToNumberBE: u, hexToBytes: l } = n;
  class d extends Error {
    constructor(T = "") {
      super(T);
    }
  }
  e.DERErr = d, e.DER = {
    // asn.1 DER encoding utils
    Err: d,
    // Basic building block is TLV (Tag-Length-Value)
    _tlv: {
      encode: (S, T) => {
        const { Err: A } = e.DER;
        if (S < 0 || S > 256)
          throw new A("tlv.encode: wrong tag");
        if (T.length & 1)
          throw new A("tlv.encode: unpadded data");
        const $ = T.length / 2, U = n.numberToHexUnpadded($);
        if (U.length / 2 & 128)
          throw new A("tlv.encode: long form length too big");
        const M = $ > 127 ? n.numberToHexUnpadded(U.length / 2 | 128) : "";
        return n.numberToHexUnpadded(S) + M + U + T;
      },
      // v - value, l - left bytes (unparsed)
      decode(S, T) {
        const { Err: A } = e.DER;
        let $ = 0;
        if (S < 0 || S > 256)
          throw new A("tlv.encode: wrong tag");
        if (T.length < 2 || T[$++] !== S)
          throw new A("tlv.decode: wrong tlv");
        const U = T[$++], M = !!(U & 128);
        let Y = 0;
        if (!M)
          Y = U;
        else {
          const ee = U & 127;
          if (!ee)
            throw new A("tlv.decode(long): indefinite length not supported");
          if (ee > 4)
            throw new A("tlv.decode(long): byte length is too big");
          const de = T.subarray($, $ + ee);
          if (de.length !== ee)
            throw new A("tlv.decode: length bytes not complete");
          if (de[0] === 0)
            throw new A("tlv.decode(long): zero leftmost byte");
          for (const ne of de)
            Y = Y << 8 | ne;
          if ($ += ee, Y < 128)
            throw new A("tlv.decode(long): not minimal encoding");
        }
        const L = T.subarray($, $ + Y);
        if (L.length !== Y)
          throw new A("tlv.decode: wrong value length");
        return { v: L, l: T.subarray($ + Y) };
      }
    },
    // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
    // since we always use positive integers here. It must always be empty:
    // - add zero byte if exists
    // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
    _int: {
      encode(S) {
        const { Err: T } = e.DER;
        if (S < f)
          throw new T("integer: negative integers are not allowed");
        let A = n.numberToHexUnpadded(S);
        if (Number.parseInt(A[0], 16) & 8 && (A = "00" + A), A.length & 1)
          throw new T("unexpected DER parsing assertion: unpadded hex");
        return A;
      },
      decode(S) {
        const { Err: T } = e.DER;
        if (S[0] & 128)
          throw new T("invalid signature integer: negative");
        if (S[0] === 0 && !(S[1] & 128))
          throw new T("invalid signature integer: unnecessary leading zero");
        return u(S);
      }
    },
    toSig(S) {
      const { Err: T, _int: A, _tlv: $ } = e.DER, U = typeof S == "string" ? l(S) : S;
      n.abytes(U);
      const { v: M, l: Y } = $.decode(48, U);
      if (Y.length)
        throw new T("invalid signature: left bytes after parsing");
      const { v: L, l: ee } = $.decode(2, M), { v: de, l: ne } = $.decode(2, ee);
      if (ne.length)
        throw new T("invalid signature: left bytes after parsing");
      return { r: A.decode(L), s: A.decode(de) };
    },
    hexFromSig(S) {
      const { _tlv: T, _int: A } = e.DER, $ = T.encode(2, A.encode(S.r)), U = T.encode(2, A.encode(S.s)), M = $ + U;
      return T.encode(48, M);
    }
  };
  const f = BigInt(0), h = BigInt(1), g = BigInt(2), b = BigInt(3), w = BigInt(4);
  function E(S) {
    const T = a(S), { Fp: A } = T, $ = (0, r.Field)(T.n, T.nBitLength), U = T.toBytes || ((G, q, Q) => {
      const se = q.toAffine();
      return n.concatBytes(Uint8Array.from([4]), A.toBytes(se.x), A.toBytes(se.y));
    }), M = T.fromBytes || ((G) => {
      const q = G.subarray(1), Q = A.fromBytes(q.subarray(0, A.BYTES)), se = A.fromBytes(q.subarray(A.BYTES, 2 * A.BYTES));
      return { x: Q, y: se };
    });
    function Y(G) {
      const { a: q, b: Q } = T, se = A.sqr(G), J = A.mul(se, G);
      return A.add(A.add(J, A.mul(G, q)), Q);
    }
    if (!A.eql(A.sqr(T.Gy), Y(T.Gx)))
      throw new Error("bad generator point: equation left != right");
    function L(G) {
      return n.inRange(G, h, T.n);
    }
    function ee(G) {
      const { allowedPrivateKeyLengths: q, nByteLength: Q, wrapPrivateKey: se, n: J } = T;
      if (q && typeof G != "bigint") {
        if (n.isBytes(G) && (G = n.bytesToHex(G)), typeof G != "string" || !q.includes(G.length))
          throw new Error("invalid private key");
        G = G.padStart(Q * 2, "0");
      }
      let ye;
      try {
        ye = typeof G == "bigint" ? G : n.bytesToNumberBE((0, o.ensureBytes)("private key", G, Q));
      } catch {
        throw new Error("invalid private key, expected hex or " + Q + " bytes, got " + typeof G);
      }
      return se && (ye = (0, r.mod)(ye, J)), n.aInRange("private key", ye, h, J), ye;
    }
    function de(G) {
      if (!(G instanceof K))
        throw new Error("ProjectivePoint expected");
    }
    const ne = (0, o.memoized)((G, q) => {
      const { px: Q, py: se, pz: J } = G;
      if (A.eql(J, A.ONE))
        return { x: Q, y: se };
      const ye = G.is0();
      q == null && (q = ye ? A.ONE : A.inv(J));
      const ve = A.mul(Q, q), Ee = A.mul(se, q), _e = A.mul(J, q);
      if (ye)
        return { x: A.ZERO, y: A.ZERO };
      if (!A.eql(_e, A.ONE))
        throw new Error("invZ was invalid");
      return { x: ve, y: Ee };
    }), D = (0, o.memoized)((G) => {
      if (G.is0()) {
        if (T.allowInfinityPoint && !A.is0(G.py))
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: q, y: Q } = G.toAffine();
      if (!A.isValid(q) || !A.isValid(Q))
        throw new Error("bad point: x or y not FE");
      const se = A.sqr(Q), J = Y(q);
      if (!A.eql(se, J))
        throw new Error("bad point: equation left != right");
      if (!G.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
      return !0;
    });
    class K {
      constructor(q, Q, se) {
        if (this.px = q, this.py = Q, this.pz = se, q == null || !A.isValid(q))
          throw new Error("x required");
        if (Q == null || !A.isValid(Q))
          throw new Error("y required");
        if (se == null || !A.isValid(se))
          throw new Error("z required");
        Object.freeze(this);
      }
      // Does not validate if the point is on-curve.
      // Use fromHex instead, or call assertValidity() later.
      static fromAffine(q) {
        const { x: Q, y: se } = q || {};
        if (!q || !A.isValid(Q) || !A.isValid(se))
          throw new Error("invalid affine point");
        if (q instanceof K)
          throw new Error("projective point not allowed");
        const J = (ye) => A.eql(ye, A.ZERO);
        return J(Q) && J(se) ? K.ZERO : new K(Q, se, A.ONE);
      }
      get x() {
        return this.toAffine().x;
      }
      get y() {
        return this.toAffine().y;
      }
      /**
       * Takes a bunch of Projective Points but executes only one
       * inversion on all of them. Inversion is very slow operation,
       * so this improves performance massively.
       * Optimization: converts a list of projective points to a list of identical points with Z=1.
       */
      static normalizeZ(q) {
        const Q = A.invertBatch(q.map((se) => se.pz));
        return q.map((se, J) => se.toAffine(Q[J])).map(K.fromAffine);
      }
      /**
       * Converts hash string or Uint8Array to Point.
       * @param hex short/long ECDSA hex
       */
      static fromHex(q) {
        const Q = K.fromAffine(M((0, o.ensureBytes)("pointHex", q)));
        return Q.assertValidity(), Q;
      }
      // Multiplies generator point by privateKey.
      static fromPrivateKey(q) {
        return K.BASE.multiply(ee(q));
      }
      // Multiscalar Multiplication
      static msm(q, Q) {
        return (0, t.pippenger)(K, $, q, Q);
      }
      // "Private method", don't use it directly
      _setWindowSize(q) {
        re.setWindowSize(this, q);
      }
      // A point on curve is valid if it conforms to equation.
      assertValidity() {
        D(this);
      }
      hasEvenY() {
        const { y: q } = this.toAffine();
        if (A.isOdd)
          return !A.isOdd(q);
        throw new Error("Field doesn't support isOdd");
      }
      /**
       * Compare one point to another.
       */
      equals(q) {
        de(q);
        const { px: Q, py: se, pz: J } = this, { px: ye, py: ve, pz: Ee } = q, _e = A.eql(A.mul(Q, Ee), A.mul(ye, J)), we = A.eql(A.mul(se, Ee), A.mul(ve, J));
        return _e && we;
      }
      /**
       * Flips point to one corresponding to (x, -y) in Affine coordinates.
       */
      negate() {
        return new K(this.px, A.neg(this.py), this.pz);
      }
      // Renes-Costello-Batina exception-free doubling formula.
      // There is 30% faster Jacobian formula, but it is not complete.
      // https://eprint.iacr.org/2015/1060, algorithm 3
      // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
      double() {
        const { a: q, b: Q } = T, se = A.mul(Q, b), { px: J, py: ye, pz: ve } = this;
        let Ee = A.ZERO, _e = A.ZERO, we = A.ZERO, be = A.mul(J, J), Ge = A.mul(ye, ye), Le = A.mul(ve, ve), Ne = A.mul(J, ye);
        return Ne = A.add(Ne, Ne), we = A.mul(J, ve), we = A.add(we, we), Ee = A.mul(q, we), _e = A.mul(se, Le), _e = A.add(Ee, _e), Ee = A.sub(Ge, _e), _e = A.add(Ge, _e), _e = A.mul(Ee, _e), Ee = A.mul(Ne, Ee), we = A.mul(se, we), Le = A.mul(q, Le), Ne = A.sub(be, Le), Ne = A.mul(q, Ne), Ne = A.add(Ne, we), we = A.add(be, be), be = A.add(we, be), be = A.add(be, Le), be = A.mul(be, Ne), _e = A.add(_e, be), Le = A.mul(ye, ve), Le = A.add(Le, Le), be = A.mul(Le, Ne), Ee = A.sub(Ee, be), we = A.mul(Le, Ge), we = A.add(we, we), we = A.add(we, we), new K(Ee, _e, we);
      }
      // Renes-Costello-Batina exception-free addition formula.
      // There is 30% faster Jacobian formula, but it is not complete.
      // https://eprint.iacr.org/2015/1060, algorithm 1
      // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
      add(q) {
        de(q);
        const { px: Q, py: se, pz: J } = this, { px: ye, py: ve, pz: Ee } = q;
        let _e = A.ZERO, we = A.ZERO, be = A.ZERO;
        const Ge = T.a, Le = A.mul(T.b, b);
        let Ne = A.mul(Q, ye), Ve = A.mul(se, ve), ge = A.mul(J, Ee), Te = A.add(Q, se), Oe = A.add(ye, ve);
        Te = A.mul(Te, Oe), Oe = A.add(Ne, Ve), Te = A.sub(Te, Oe), Oe = A.add(Q, J);
        let He = A.add(ye, Ee);
        return Oe = A.mul(Oe, He), He = A.add(Ne, ge), Oe = A.sub(Oe, He), He = A.add(se, J), _e = A.add(ve, Ee), He = A.mul(He, _e), _e = A.add(Ve, ge), He = A.sub(He, _e), be = A.mul(Ge, Oe), _e = A.mul(Le, ge), be = A.add(_e, be), _e = A.sub(Ve, be), be = A.add(Ve, be), we = A.mul(_e, be), Ve = A.add(Ne, Ne), Ve = A.add(Ve, Ne), ge = A.mul(Ge, ge), Oe = A.mul(Le, Oe), Ve = A.add(Ve, ge), ge = A.sub(Ne, ge), ge = A.mul(Ge, ge), Oe = A.add(Oe, ge), Ne = A.mul(Ve, Oe), we = A.add(we, Ne), Ne = A.mul(He, Oe), _e = A.mul(Te, _e), _e = A.sub(_e, Ne), Ne = A.mul(Te, Ve), be = A.mul(He, be), be = A.add(be, Ne), new K(_e, we, be);
      }
      subtract(q) {
        return this.add(q.negate());
      }
      is0() {
        return this.equals(K.ZERO);
      }
      wNAF(q) {
        return re.wNAFCached(this, q, K.normalizeZ);
      }
      /**
       * Non-constant-time multiplication. Uses double-and-add algorithm.
       * It's faster, but should only be used when you don't care about
       * an exposed private key e.g. sig verification, which works over *public* keys.
       */
      multiplyUnsafe(q) {
        const { endo: Q, n: se } = T;
        n.aInRange("scalar", q, f, se);
        const J = K.ZERO;
        if (q === f)
          return J;
        if (this.is0() || q === h)
          return this;
        if (!Q || re.hasPrecomputes(this))
          return re.wNAFCachedUnsafe(this, q, K.normalizeZ);
        let { k1neg: ye, k1: ve, k2neg: Ee, k2: _e } = Q.splitScalar(q), we = J, be = J, Ge = this;
        for (; ve > f || _e > f; )
          ve & h && (we = we.add(Ge)), _e & h && (be = be.add(Ge)), Ge = Ge.double(), ve >>= h, _e >>= h;
        return ye && (we = we.negate()), Ee && (be = be.negate()), be = new K(A.mul(be.px, Q.beta), be.py, be.pz), we.add(be);
      }
      /**
       * Constant time multiplication.
       * Uses wNAF method. Windowed method may be 10% faster,
       * but takes 2x longer to generate and consumes 2x memory.
       * Uses precomputes when available.
       * Uses endomorphism for Koblitz curves.
       * @param scalar by which the point would be multiplied
       * @returns New point
       */
      multiply(q) {
        const { endo: Q, n: se } = T;
        n.aInRange("scalar", q, h, se);
        let J, ye;
        if (Q) {
          const { k1neg: ve, k1: Ee, k2neg: _e, k2: we } = Q.splitScalar(q);
          let { p: be, f: Ge } = this.wNAF(Ee), { p: Le, f: Ne } = this.wNAF(we);
          be = re.constTimeNegate(ve, be), Le = re.constTimeNegate(_e, Le), Le = new K(A.mul(Le.px, Q.beta), Le.py, Le.pz), J = be.add(Le), ye = Ge.add(Ne);
        } else {
          const { p: ve, f: Ee } = this.wNAF(q);
          J = ve, ye = Ee;
        }
        return K.normalizeZ([J, ye])[0];
      }
      /**
       * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
       * Not using Strauss-Shamir trick: precomputation tables are faster.
       * The trick could be useful if both P and Q are not G (not in our case).
       * @returns non-zero affine point
       */
      multiplyAndAddUnsafe(q, Q, se) {
        const J = K.BASE, ye = (Ee, _e) => _e === f || _e === h || !Ee.equals(J) ? Ee.multiplyUnsafe(_e) : Ee.multiply(_e), ve = ye(this, Q).add(ye(q, se));
        return ve.is0() ? void 0 : ve;
      }
      // Converts Projective point to affine (x, y) coordinates.
      // Can accept precomputed Z^-1 - for example, from invertBatch.
      // (x, y, z) ∋ (x=x/z, y=y/z)
      toAffine(q) {
        return ne(this, q);
      }
      isTorsionFree() {
        const { h: q, isTorsionFree: Q } = T;
        if (q === h)
          return !0;
        if (Q)
          return Q(K, this);
        throw new Error("isTorsionFree() has not been declared for the elliptic curve");
      }
      clearCofactor() {
        const { h: q, clearCofactor: Q } = T;
        return q === h ? this : Q ? Q(K, this) : this.multiplyUnsafe(T.h);
      }
      toRawBytes(q = !0) {
        return (0, o.abool)("isCompressed", q), this.assertValidity(), U(K, this, q);
      }
      toHex(q = !0) {
        return (0, o.abool)("isCompressed", q), n.bytesToHex(this.toRawBytes(q));
      }
    }
    K.BASE = new K(T.Gx, T.Gy, A.ONE), K.ZERO = new K(A.ZERO, A.ONE, A.ZERO);
    const le = T.nBitLength, re = (0, t.wNAF)(K, T.endo ? Math.ceil(le / 2) : le);
    return {
      CURVE: T,
      ProjectivePoint: K,
      normPrivateKeyToScalar: ee,
      weierstrassEquation: Y,
      isWithinCurveOrder: L
    };
  }
  function _(S) {
    const T = (0, t.validateBasic)(S);
    return n.validateObject(T, {
      hash: "hash",
      hmac: "function",
      randomBytes: "function"
    }, {
      bits2int: "function",
      bits2int_modN: "function",
      lowS: "boolean"
    }), Object.freeze({ lowS: !0, ...T });
  }
  function O(S) {
    const T = _(S), { Fp: A, n: $ } = T, U = A.BYTES + 1, M = 2 * A.BYTES + 1;
    function Y(ge) {
      return (0, r.mod)(ge, $);
    }
    function L(ge) {
      return (0, r.invert)(ge, $);
    }
    const { ProjectivePoint: ee, normPrivateKeyToScalar: de, weierstrassEquation: ne, isWithinCurveOrder: D } = E({
      ...T,
      toBytes(ge, Te, Oe) {
        const He = Te.toAffine(), mt = A.toBytes(He.x), rt = n.concatBytes;
        return (0, o.abool)("isCompressed", Oe), Oe ? rt(Uint8Array.from([Te.hasEvenY() ? 2 : 3]), mt) : rt(Uint8Array.from([4]), mt, A.toBytes(He.y));
      },
      fromBytes(ge) {
        const Te = ge.length, Oe = ge[0], He = ge.subarray(1);
        if (Te === U && (Oe === 2 || Oe === 3)) {
          const mt = n.bytesToNumberBE(He);
          if (!n.inRange(mt, h, A.ORDER))
            throw new Error("Point is not on curve");
          const rt = ne(mt);
          let Pt;
          try {
            Pt = A.sqrt(rt);
          } catch (yt) {
            const Zt = yt instanceof Error ? ": " + yt.message : "";
            throw new Error("Point is not on curve" + Zt);
          }
          const _t = (Pt & h) === h;
          return (Oe & 1) === 1 !== _t && (Pt = A.neg(Pt)), { x: mt, y: Pt };
        } else if (Te === M && Oe === 4) {
          const mt = A.fromBytes(He.subarray(0, A.BYTES)), rt = A.fromBytes(He.subarray(A.BYTES, 2 * A.BYTES));
          return { x: mt, y: rt };
        } else {
          const mt = U, rt = M;
          throw new Error("invalid Point, expected length of " + mt + ", or uncompressed " + rt + ", got " + Te);
        }
      }
    }), K = (ge) => n.bytesToHex(n.numberToBytesBE(ge, T.nByteLength));
    function le(ge) {
      const Te = $ >> h;
      return ge > Te;
    }
    function re(ge) {
      return le(ge) ? Y(-ge) : ge;
    }
    const G = (ge, Te, Oe) => n.bytesToNumberBE(ge.slice(Te, Oe));
    class q {
      constructor(Te, Oe, He) {
        this.r = Te, this.s = Oe, this.recovery = He, this.assertValidity();
      }
      // pair (bytes of r, bytes of s)
      static fromCompact(Te) {
        const Oe = T.nByteLength;
        return Te = (0, o.ensureBytes)("compactSignature", Te, Oe * 2), new q(G(Te, 0, Oe), G(Te, Oe, 2 * Oe));
      }
      // DER encoded ECDSA signature
      // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
      static fromDER(Te) {
        const { r: Oe, s: He } = e.DER.toSig((0, o.ensureBytes)("DER", Te));
        return new q(Oe, He);
      }
      assertValidity() {
        n.aInRange("r", this.r, h, $), n.aInRange("s", this.s, h, $);
      }
      addRecoveryBit(Te) {
        return new q(this.r, this.s, Te);
      }
      recoverPublicKey(Te) {
        const { r: Oe, s: He, recovery: mt } = this, rt = Ee((0, o.ensureBytes)("msgHash", Te));
        if (mt == null || ![0, 1, 2, 3].includes(mt))
          throw new Error("recovery id invalid");
        const Pt = mt === 2 || mt === 3 ? Oe + T.n : Oe;
        if (Pt >= A.ORDER)
          throw new Error("recovery id 2 or 3 invalid");
        const _t = mt & 1 ? "03" : "02", yt = ee.fromHex(_t + K(Pt)), Zt = L(Pt), yn = Y(-rt * Zt), kt = Y(He * Zt), qr = ee.BASE.multiplyAndAddUnsafe(yt, yn, kt);
        if (!qr)
          throw new Error("point at infinify");
        return qr.assertValidity(), qr;
      }
      // Signatures should be low-s, to prevent malleability.
      hasHighS() {
        return le(this.s);
      }
      normalizeS() {
        return this.hasHighS() ? new q(this.r, Y(-this.s), this.recovery) : this;
      }
      // DER-encoded
      toDERRawBytes() {
        return n.hexToBytes(this.toDERHex());
      }
      toDERHex() {
        return e.DER.hexFromSig({ r: this.r, s: this.s });
      }
      // padded bytes of r, then padded bytes of s
      toCompactRawBytes() {
        return n.hexToBytes(this.toCompactHex());
      }
      toCompactHex() {
        return K(this.r) + K(this.s);
      }
    }
    const Q = {
      isValidPrivateKey(ge) {
        try {
          return de(ge), !0;
        } catch {
          return !1;
        }
      },
      normPrivateKeyToScalar: de,
      /**
       * Produces cryptographically secure private key from random of size
       * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
       */
      randomPrivateKey: () => {
        const ge = (0, r.getMinHashLength)(T.n);
        return (0, r.mapHashToField)(T.randomBytes(ge), T.n);
      },
      /**
       * Creates precompute table for an arbitrary EC point. Makes point "cached".
       * Allows to massively speed-up `point.multiply(scalar)`.
       * @returns cached point
       * @example
       * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
       * fast.multiply(privKey); // much faster ECDH now
       */
      precompute(ge = 8, Te = ee.BASE) {
        return Te._setWindowSize(ge), Te.multiply(BigInt(3)), Te;
      }
    };
    function se(ge, Te = !0) {
      return ee.fromPrivateKey(ge).toRawBytes(Te);
    }
    function J(ge) {
      const Te = n.isBytes(ge), Oe = typeof ge == "string", He = (Te || Oe) && ge.length;
      return Te ? He === U || He === M : Oe ? He === 2 * U || He === 2 * M : ge instanceof ee;
    }
    function ye(ge, Te, Oe = !0) {
      if (J(ge))
        throw new Error("first arg must be private key");
      if (!J(Te))
        throw new Error("second arg must be public key");
      return ee.fromHex(Te).multiply(de(ge)).toRawBytes(Oe);
    }
    const ve = T.bits2int || function(ge) {
      if (ge.length > 8192)
        throw new Error("input is too large");
      const Te = n.bytesToNumberBE(ge), Oe = ge.length * 8 - T.nBitLength;
      return Oe > 0 ? Te >> BigInt(Oe) : Te;
    }, Ee = T.bits2int_modN || function(ge) {
      return Y(ve(ge));
    }, _e = n.bitMask(T.nBitLength);
    function we(ge) {
      return n.aInRange("num < 2^" + T.nBitLength, ge, f, _e), n.numberToBytesBE(ge, T.nByteLength);
    }
    function be(ge, Te, Oe = Ge) {
      if (["recovered", "canonical"].some((v) => v in Oe))
        throw new Error("sign() legacy options not supported");
      const { hash: He, randomBytes: mt } = T;
      let { lowS: rt, prehash: Pt, extraEntropy: _t } = Oe;
      rt == null && (rt = !0), ge = (0, o.ensureBytes)("msgHash", ge), i(Oe), Pt && (ge = (0, o.ensureBytes)("prehashed msgHash", He(ge)));
      const yt = Ee(ge), Zt = de(Te), yn = [we(Zt), we(yt)];
      if (_t != null && _t !== !1) {
        const v = _t === !0 ? mt(A.BYTES) : _t;
        yn.push((0, o.ensureBytes)("extraEntropy", v));
      }
      const kt = n.concatBytes(...yn), qr = yt;
      function m(v) {
        const k = ve(v);
        if (!D(k))
          return;
        const H = L(k), X = ee.BASE.multiply(k).toAffine(), oe = Y(X.x);
        if (oe === f)
          return;
        const me = Y(H * Y(qr + oe * Zt));
        if (me === f)
          return;
        let nt = (X.x === oe ? 0 : 2) | Number(X.y & h), Ct = me;
        return rt && le(me) && (Ct = re(me), nt ^= 1), new q(oe, Ct, nt);
      }
      return { seed: kt, k2sig: m };
    }
    const Ge = { lowS: T.lowS, prehash: !1 }, Le = { lowS: T.lowS, prehash: !1 };
    function Ne(ge, Te, Oe = Ge) {
      const { seed: He, k2sig: mt } = be(ge, Te, Oe), rt = T;
      return n.createHmacDrbg(rt.hash.outputLen, rt.nByteLength, rt.hmac)(He, mt);
    }
    ee.BASE._setWindowSize(8);
    function Ve(ge, Te, Oe, He = Le) {
      var mt;
      const rt = ge;
      Te = (0, o.ensureBytes)("msgHash", Te), Oe = (0, o.ensureBytes)("publicKey", Oe);
      const { lowS: Pt, prehash: _t, format: yt } = He;
      if (i(He), "strict" in He)
        throw new Error("options.strict was renamed to lowS");
      if (yt !== void 0 && yt !== "compact" && yt !== "der")
        throw new Error("format must be compact or der");
      const Zt = typeof rt == "string" || n.isBytes(rt), yn = !Zt && !yt && typeof rt == "object" && rt !== null && typeof rt.r == "bigint" && typeof rt.s == "bigint";
      if (!Zt && !yn)
        throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
      let kt, qr;
      try {
        if (yn && (kt = new q(rt.r, rt.s)), Zt) {
          try {
            yt !== "compact" && (kt = q.fromDER(rt));
          } catch (nt) {
            if (!(nt instanceof e.DER.Err))
              throw nt;
          }
          !kt && yt !== "der" && (kt = q.fromCompact(rt));
        }
        qr = ee.fromHex(Oe);
      } catch {
        return !1;
      }
      if (!kt || Pt && kt.hasHighS())
        return !1;
      _t && (Te = T.hash(Te));
      const { r: m, s: v } = kt, k = Ee(Te), H = L(v), X = Y(k * H), oe = Y(m * H), me = (mt = ee.BASE.multiplyAndAddUnsafe(qr, X, oe)) == null ? void 0 : mt.toAffine();
      return me ? Y(me.x) === m : !1;
    }
    return {
      CURVE: T,
      getPublicKey: se,
      getSharedSecret: ye,
      sign: Ne,
      verify: Ve,
      ProjectivePoint: ee,
      Signature: q,
      utils: Q
    };
  }
  function C(S, T) {
    const A = S.ORDER;
    let $ = f;
    for (let re = A - h; re % g === f; re /= g)
      $ += h;
    const U = $, M = g << U - h - h, Y = M * g, L = (A - h) / Y, ee = (L - h) / g, de = Y - h, ne = M, D = S.pow(T, L), K = S.pow(T, (L + h) / g);
    let le = (re, G) => {
      let q = D, Q = S.pow(G, de), se = S.sqr(Q);
      se = S.mul(se, G);
      let J = S.mul(re, se);
      J = S.pow(J, ee), J = S.mul(J, Q), Q = S.mul(J, G), se = S.mul(J, re);
      let ye = S.mul(se, Q);
      J = S.pow(ye, ne);
      let ve = S.eql(J, S.ONE);
      Q = S.mul(se, K), J = S.mul(ye, q), se = S.cmov(Q, se, ve), ye = S.cmov(J, ye, ve);
      for (let Ee = U; Ee > h; Ee--) {
        let _e = Ee - g;
        _e = g << _e - h;
        let we = S.pow(ye, _e);
        const be = S.eql(we, S.ONE);
        Q = S.mul(se, q), q = S.mul(q, q), we = S.mul(ye, q), se = S.cmov(Q, se, be), ye = S.cmov(we, ye, be);
      }
      return { isValid: ve, value: se };
    };
    if (S.ORDER % w === b) {
      const re = (S.ORDER - b) / w, G = S.sqrt(S.neg(T));
      le = (q, Q) => {
        let se = S.sqr(Q);
        const J = S.mul(q, Q);
        se = S.mul(se, J);
        let ye = S.pow(se, re);
        ye = S.mul(ye, J);
        const ve = S.mul(ye, G), Ee = S.mul(S.sqr(ye), Q), _e = S.eql(Ee, q);
        let we = S.cmov(ve, ye, _e);
        return { isValid: _e, value: we };
      };
    }
    return le;
  }
  function I(S, T) {
    if ((0, r.validateField)(S), !S.isValid(T.A) || !S.isValid(T.B) || !S.isValid(T.Z))
      throw new Error("mapToCurveSimpleSWU: invalid opts");
    const A = C(S, T.Z);
    if (!S.isOdd)
      throw new Error("Fp.isOdd is not implemented!");
    return ($) => {
      let U, M, Y, L, ee, de, ne, D;
      U = S.sqr($), U = S.mul(U, T.Z), M = S.sqr(U), M = S.add(M, U), Y = S.add(M, S.ONE), Y = S.mul(Y, T.B), L = S.cmov(T.Z, S.neg(M), !S.eql(M, S.ZERO)), L = S.mul(L, T.A), M = S.sqr(Y), de = S.sqr(L), ee = S.mul(de, T.A), M = S.add(M, ee), M = S.mul(M, Y), de = S.mul(de, L), ee = S.mul(de, T.B), M = S.add(M, ee), ne = S.mul(U, Y);
      const { isValid: K, value: le } = A(M, de);
      D = S.mul(U, $), D = S.mul(D, le), ne = S.cmov(ne, Y, K), D = S.cmov(D, le, K);
      const re = S.isOdd($) === S.isOdd(D);
      return D = S.cmov(S.neg(D), D, re), ne = S.div(ne, L), { x: ne, y: D };
    };
  }
})(RC);
Object.defineProperty(r4, "__esModule", { value: !0 });
r4.getHash = sD;
r4.createCurve = lhe;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const uhe = v2, OU = Ds, che = RC;
function sD(e) {
  return {
    hash: e,
    hmac: (t, ...r) => (0, uhe.hmac)(e, t, (0, OU.concatBytes)(...r)),
    randomBytes: OU.randomBytes
  };
}
function lhe(e, t) {
  const r = (n) => (0, che.weierstrass)({ ...e, ...sD(n) });
  return { ...r(t), create: r };
}
var k0 = {};
Object.defineProperty(k0, "__esModule", { value: !0 });
k0.expand_message_xmd = uD;
k0.expand_message_xof = cD;
k0.hash_to_field = nO;
k0.isogenyMap = phe;
k0.createHasher = ghe;
const fhe = gn, Ni = Ur, dhe = Ni.bytesToNumberBE;
function Ad(e, t) {
  if (Bw(e), Bw(t), e < 0 || e >= 1 << 8 * t)
    throw new Error("invalid I2OSP input: " + e);
  const r = Array.from({ length: t }).fill(0);
  for (let n = t - 1; n >= 0; n--)
    r[n] = e & 255, e >>>= 8;
  return new Uint8Array(r);
}
function hhe(e, t) {
  const r = new Uint8Array(e.length);
  for (let n = 0; n < e.length; n++)
    r[n] = e[n] ^ t[n];
  return r;
}
function Bw(e) {
  if (!Number.isSafeInteger(e))
    throw new Error("number expected");
}
function uD(e, t, r, n) {
  (0, Ni.abytes)(e), (0, Ni.abytes)(t), Bw(r), t.length > 255 && (t = n((0, Ni.concatBytes)((0, Ni.utf8ToBytes)("H2C-OVERSIZE-DST-"), t)));
  const { outputLen: o, blockLen: i } = n, a = Math.ceil(r / o);
  if (r > 65535 || a > 255)
    throw new Error("expand_message_xmd: invalid lenInBytes");
  const u = (0, Ni.concatBytes)(t, Ad(t.length, 1)), l = Ad(0, i), d = Ad(r, 2), f = new Array(a), h = n((0, Ni.concatBytes)(l, e, d, Ad(0, 1), u));
  f[0] = n((0, Ni.concatBytes)(h, Ad(1, 1), u));
  for (let g = 1; g <= a; g++) {
    const b = [hhe(h, f[g - 1]), Ad(g + 1, 1), u];
    f[g] = n((0, Ni.concatBytes)(...b));
  }
  return (0, Ni.concatBytes)(...f).slice(0, r);
}
function cD(e, t, r, n, o) {
  if ((0, Ni.abytes)(e), (0, Ni.abytes)(t), Bw(r), t.length > 255) {
    const i = Math.ceil(2 * n / 8);
    t = o.create({ dkLen: i }).update((0, Ni.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(t).digest();
  }
  if (r > 65535 || t.length > 255)
    throw new Error("expand_message_xof: invalid lenInBytes");
  return o.create({ dkLen: r }).update(e).update(Ad(r, 2)).update(t).update(Ad(t.length, 1)).digest();
}
function nO(e, t, r) {
  (0, Ni.validateObject)(r, {
    DST: "stringOrUint8Array",
    p: "bigint",
    m: "isSafeInteger",
    k: "isSafeInteger",
    hash: "hash"
  });
  const { p: n, k: o, m: i, hash: a, expand: u, DST: l } = r;
  (0, Ni.abytes)(e), Bw(t);
  const d = typeof l == "string" ? (0, Ni.utf8ToBytes)(l) : l, f = n.toString(2).length, h = Math.ceil((f + o) / 8), g = t * i * h;
  let b;
  if (u === "xmd")
    b = uD(e, d, g, a);
  else if (u === "xof")
    b = cD(e, d, g, o, a);
  else if (u === "_internal_pass")
    b = e;
  else
    throw new Error('expand must be "xmd" or "xof"');
  const w = new Array(t);
  for (let E = 0; E < t; E++) {
    const _ = new Array(i);
    for (let O = 0; O < i; O++) {
      const C = h * (O + E * i), I = b.subarray(C, C + h);
      _[O] = (0, fhe.mod)(dhe(I), n);
    }
    w[E] = _;
  }
  return w;
}
function phe(e, t) {
  const r = t.map((n) => Array.from(n).reverse());
  return (n, o) => {
    const [i, a, u, l] = r.map((d) => d.reduce((f, h) => e.add(e.mul(f, n), h)));
    return n = e.div(i, a), o = e.mul(o, e.div(u, l)), { x: n, y: o };
  };
}
function ghe(e, t, r) {
  if (typeof t != "function")
    throw new Error("mapToCurve() must be defined");
  return {
    // Encodes byte string to elliptic curve.
    // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
    hashToCurve(n, o) {
      const i = nO(n, 2, { ...r, DST: r.DST, ...o }), a = e.fromAffine(t(i[0])), u = e.fromAffine(t(i[1])), l = a.add(u).clearCofactor();
      return l.assertValidity(), l;
    },
    // Encodes byte string to elliptic curve.
    // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
    encodeToCurve(n, o) {
      const i = nO(n, 1, { ...r, DST: r.encodeDST, ...o }), a = e.fromAffine(t(i[0])).clearCofactor();
      return a.assertValidity(), a;
    },
    // Same as encodeToCurve, but without hash
    mapToCurve(n) {
      if (!Array.isArray(n))
        throw new Error("mapToCurve: expected array of bigints");
      for (const i of n)
        if (typeof i != "bigint")
          throw new Error("mapToCurve: expected array of bigints");
      const o = e.fromAffine(t(n)).clearCofactor();
      return o.assertValidity(), o;
    }
  };
}
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.encodeToCurve = e.hashToCurve = e.schnorr = e.secp256k1 = void 0;
  /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  const t = Cu, r = Ds, n = r4, o = k0, i = gn, a = Ur, u = RC, l = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), d = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), f = BigInt(1), h = BigInt(2), g = (re, G) => (re + G / h) / G;
  function b(re) {
    const G = l, q = BigInt(3), Q = BigInt(6), se = BigInt(11), J = BigInt(22), ye = BigInt(23), ve = BigInt(44), Ee = BigInt(88), _e = re * re * re % G, we = _e * _e * re % G, be = (0, i.pow2)(we, q, G) * we % G, Ge = (0, i.pow2)(be, q, G) * we % G, Le = (0, i.pow2)(Ge, h, G) * _e % G, Ne = (0, i.pow2)(Le, se, G) * Le % G, Ve = (0, i.pow2)(Ne, J, G) * Ne % G, ge = (0, i.pow2)(Ve, ve, G) * Ve % G, Te = (0, i.pow2)(ge, Ee, G) * ge % G, Oe = (0, i.pow2)(Te, ve, G) * Ve % G, He = (0, i.pow2)(Oe, q, G) * we % G, mt = (0, i.pow2)(He, ye, G) * Ne % G, rt = (0, i.pow2)(mt, Q, G) * _e % G, Pt = (0, i.pow2)(rt, h, G);
    if (!w.eql(w.sqr(Pt), re))
      throw new Error("Cannot find square root");
    return Pt;
  }
  const w = (0, i.Field)(l, void 0, void 0, { sqrt: b });
  e.secp256k1 = (0, n.createCurve)({
    a: BigInt(0),
    // equation params: a, b
    b: BigInt(7),
    Fp: w,
    // Field's prime: 2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n
    n: d,
    // Curve order, total count of valid points in the field
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    // Cofactor
    lowS: !0,
    // Allow only low-S signatures by default in sign() and verify()
    endo: {
      // Endomorphism, see above
      beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
      splitScalar: (re) => {
        const G = d, q = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), Q = -f * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), se = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), J = q, ye = BigInt("0x100000000000000000000000000000000"), ve = g(J * re, G), Ee = g(-Q * re, G);
        let _e = (0, i.mod)(re - ve * q - Ee * se, G), we = (0, i.mod)(-ve * Q - Ee * J, G);
        const be = _e > ye, Ge = we > ye;
        if (be && (_e = G - _e), Ge && (we = G - we), _e > ye || we > ye)
          throw new Error("splitScalar: Endomorphism failed, k=" + re);
        return { k1neg: be, k1: _e, k2neg: Ge, k2: we };
      }
    }
  }, t.sha256);
  const E = BigInt(0), _ = {};
  function O(re, ...G) {
    let q = _[re];
    if (q === void 0) {
      const Q = (0, t.sha256)(Uint8Array.from(re, (se) => se.charCodeAt(0)));
      q = (0, a.concatBytes)(Q, Q), _[re] = q;
    }
    return (0, t.sha256)((0, a.concatBytes)(q, ...G));
  }
  const C = (re) => re.toRawBytes(!0).slice(1), I = (re) => (0, a.numberToBytesBE)(re, 32), S = (re) => (0, i.mod)(re, l), T = (re) => (0, i.mod)(re, d), A = e.secp256k1.ProjectivePoint, $ = (re, G, q) => A.BASE.multiplyAndAddUnsafe(re, G, q);
  function U(re) {
    let G = e.secp256k1.utils.normPrivateKeyToScalar(re), q = A.fromPrivateKey(G);
    return { scalar: q.hasEvenY() ? G : T(-G), bytes: C(q) };
  }
  function M(re) {
    (0, a.aInRange)("x", re, f, l);
    const G = S(re * re), q = S(G * re + BigInt(7));
    let Q = b(q);
    Q % h !== E && (Q = S(-Q));
    const se = new A(re, Q, f);
    return se.assertValidity(), se;
  }
  const Y = a.bytesToNumberBE;
  function L(...re) {
    return T(Y(O("BIP0340/challenge", ...re)));
  }
  function ee(re) {
    return U(re).bytes;
  }
  function de(re, G, q = (0, r.randomBytes)(32)) {
    const Q = (0, a.ensureBytes)("message", re), { bytes: se, scalar: J } = U(G), ye = (0, a.ensureBytes)("auxRand", q, 32), ve = I(J ^ Y(O("BIP0340/aux", ye))), Ee = O("BIP0340/nonce", ve, se, Q), _e = T(Y(Ee));
    if (_e === E)
      throw new Error("sign failed: k is zero");
    const { bytes: we, scalar: be } = U(_e), Ge = L(we, se, Q), Le = new Uint8Array(64);
    if (Le.set(we, 0), Le.set(I(T(be + Ge * J)), 32), !ne(Le, Q, se))
      throw new Error("sign: Invalid signature produced");
    return Le;
  }
  function ne(re, G, q) {
    const Q = (0, a.ensureBytes)("signature", re, 64), se = (0, a.ensureBytes)("message", G), J = (0, a.ensureBytes)("publicKey", q, 32);
    try {
      const ye = M(Y(J)), ve = Y(Q.subarray(0, 32));
      if (!(0, a.inRange)(ve, f, l))
        return !1;
      const Ee = Y(Q.subarray(32, 64));
      if (!(0, a.inRange)(Ee, f, d))
        return !1;
      const _e = L(I(ve), C(ye), se), we = $(ye, Ee, T(-_e));
      return !(!we || !we.hasEvenY() || we.toAffine().x !== ve);
    } catch {
      return !1;
    }
  }
  e.schnorr = {
    getPublicKey: ee,
    sign: de,
    verify: ne,
    utils: {
      randomPrivateKey: e.secp256k1.utils.randomPrivateKey,
      lift_x: M,
      pointToBytes: C,
      numberToBytesBE: a.numberToBytesBE,
      bytesToNumberBE: a.bytesToNumberBE,
      taggedHash: O,
      mod: i.mod
    }
  };
  const D = (0, o.isogenyMap)(w, [
    // xNum
    [
      "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
      "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
      "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
      "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
    ],
    // xDen
    [
      "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
      "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
      "0x0000000000000000000000000000000000000000000000000000000000000001"
      // LAST 1
    ],
    // yNum
    [
      "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
      "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
      "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
      "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
    ],
    // yDen
    [
      "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
      "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
      "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
      "0x0000000000000000000000000000000000000000000000000000000000000001"
      // LAST 1
    ]
  ].map((re) => re.map((G) => BigInt(G)))), K = (0, u.mapToCurveSimpleSWU)(w, {
    A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
    B: BigInt("1771"),
    Z: w.create(BigInt("-11"))
  }), le = (0, o.createHasher)(e.secp256k1.ProjectivePoint, (re) => {
    const { x: G, y: q } = K(w.create(re[0]));
    return D(G, q);
  }, {
    DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
    encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
    p: w.ORDER,
    m: 1,
    k: 128,
    expand: "xmd",
    hash: t.sha256
  });
  e.hashToCurve = le.hashToCurve, e.encodeToCurve = le.encodeToCurve;
})(qM);
var Ti = qM, mhe = gn, yhe = Ur;
function lD(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return e && Object.keys(e).forEach(function(r) {
    if (r !== "default") {
      var n = Object.getOwnPropertyDescriptor(e, r);
      Object.defineProperty(t, r, n.get ? n : {
        enumerable: !0,
        get: function() {
          return e[r];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}
var fD = /* @__PURE__ */ lD(mhe), Ld = /* @__PURE__ */ lD(yhe);
const MC = Ti.secp256k1.ProjectivePoint, Qd = "Expected Private", eh = "Expected Point", I2 = "Expected Tweak", bhe = "Expected Hash", ew = "Expected Signature", DC = "Expected Extra Data (32 bytes)", O2 = "Expected Scalar", whe = "Bad Recovery Id", vhe = 32, Ehe = 32, oO = new Uint8Array([
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  254,
  186,
  174,
  220,
  230,
  175,
  72,
  160,
  59,
  191,
  210,
  94,
  140,
  208,
  54,
  65,
  65
]), _he = 32, Ahe = new Uint8Array(32), xhe = new Uint8Array([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  69,
  81,
  35,
  25,
  80,
  183,
  95,
  196,
  64,
  45,
  161,
  114,
  47,
  201,
  186,
  238
]), khe = BigInt(1);
function She(e) {
  return e instanceof Uint8Array;
}
function Nw(e, t) {
  for (let r = 0; r < 32; ++r)
    if (e[r] !== t[r])
      return e[r] < t[r] ? -1 : 1;
  return 0;
}
function PU(e) {
  return Nw(e, Ahe) === 0;
}
function P2(e) {
  return !(!(e instanceof Uint8Array) || e.length !== Ehe || Nw(e, oO) >= 0);
}
function KC(e) {
  return e instanceof Uint8Array && e.length === 64 && Nw(e.subarray(0, 32), oO) < 0 && Nw(e.subarray(32, 64), oO) < 0;
}
function The(e) {
  return She(e) && e.length === 64 && Nw(e.subarray(0, 32), xhe) < 0;
}
function Ihe(e) {
  return !(PU(e.subarray(0, 32)) || PU(e.subarray(32, 64)));
}
function vg(e) {
  return e instanceof Uint8Array && e.length === vhe;
}
function qC(e) {
  return e === void 0 || e instanceof Uint8Array && e.length === _he;
}
function VC(e) {
  let t;
  if (typeof e == "bigint")
    t = e;
  else if (typeof e == "number" && Number.isSafeInteger(e) && e >= 0)
    t = BigInt(e);
  else if (typeof e == "string") {
    if (e.length !== 64)
      throw new Error("Expected 32 bytes of private scalar");
    t = Ld.hexToNumber(e);
  } else if (e instanceof Uint8Array) {
    if (e.length !== 32)
      throw new Error("Expected 32 bytes of private scalar");
    t = Ld.bytesToNumberBE(e);
  } else
    throw new TypeError("Expected valid private scalar");
  if (t < 0) throw new Error("Expected private scalar >= 0");
  return t;
}
function GC(e) {
  return Ti.secp256k1.utils.normPrivateKeyToScalar(e);
}
function Ohe(e, t) {
  const r = GC(e), n = VC(t), o = Ld.numberToBytesBE(fD.mod(r + n, Ti.secp256k1.CURVE.n), 32);
  return Ti.secp256k1.utils.isValidPrivateKey(o) ? o : null;
}
function Phe(e, t) {
  const r = GC(e), n = VC(t), o = Ld.numberToBytesBE(fD.mod(r - n, Ti.secp256k1.CURVE.n), 32);
  return Ti.secp256k1.utils.isValidPrivateKey(o) ? o : null;
}
function Che(e) {
  const t = GC(e), r = Ld.numberToBytesBE(Ti.secp256k1.CURVE.n - t, 32);
  return Ti.secp256k1.utils.isValidPrivateKey(r) ? r : null;
}
function dD(e, t, r) {
  const n = $w(e), o = VC(t), i = MC.BASE.multiplyAndAddUnsafe(n, o, khe);
  if (!i) throw new Error("Tweaked point at infinity");
  return i.toRawBytes(r);
}
function Bhe(e, t, r) {
  const n = $w(e), o = typeof t == "string" ? t : Ld.bytesToHex(t), i = Ld.hexToNumber(o);
  return n.multiply(i).toRawBytes(r);
}
function Eg(e, t) {
  return e === void 0 ? t !== void 0 ? pD(t) : !0 : !!e;
}
function S0(e) {
  try {
    return e();
  } catch {
    return null;
  }
}
function hD(e) {
  return Ti.schnorr.utils.lift_x(Ld.bytesToNumberBE(e));
}
function $w(e) {
  return e.length === 32 ? hD(e) : MC.fromHex(e);
}
function WC(e, t) {
  if (e.length === 32 !== t) return !1;
  try {
    return t ? !!hD(e) : !!MC.fromHex(e);
  } catch {
    return !1;
  }
}
function Hd(e) {
  return WC(e, !1);
}
function pD(e) {
  return WC(e, !1) && e.length === 33;
}
function bf(e) {
  return Ti.secp256k1.utils.isValidPrivateKey(e);
}
function u4(e) {
  return WC(e, !0);
}
function Nhe(e, t) {
  if (!u4(e))
    throw new Error(eh);
  if (!P2(t))
    throw new Error(I2);
  return S0(() => {
    const r = dD(e, t, !0);
    return { parity: r[0] % 2 === 1 ? 1 : 0, xOnlyPubkey: r.slice(1) };
  });
}
function gD(e) {
  if (!Hd(e))
    throw new Error(eh);
  return e.slice(1, 33);
}
function mD(e, t) {
  if (!bf(e))
    throw new Error(Qd);
  return S0(
    () => Ti.secp256k1.getPublicKey(e, Eg(t))
  );
}
function $he(e) {
  if (!bf(e))
    throw new Error(Qd);
  return gD(mD(e));
}
function Uhe(e, t) {
  if (!Hd(e))
    throw new Error(eh);
  return $w(e).toRawBytes(Eg(t, e));
}
function Rhe(e, t, r) {
  if (!Hd(e))
    throw new Error(eh);
  if (!P2(t))
    throw new Error(I2);
  return S0(
    () => Bhe(e, t, Eg(r, e))
  );
}
function zhe(e, t, r) {
  if (!Hd(e) || !Hd(t))
    throw new Error(eh);
  return S0(() => {
    const n = $w(e), o = $w(t);
    return n.equals(o.negate()) ? null : n.add(o).toRawBytes(Eg(r, e));
  });
}
function jhe(e, t, r) {
  if (!Hd(e))
    throw new Error(eh);
  if (!P2(t))
    throw new Error(I2);
  return S0(
    () => dD(e, t, Eg(r, e))
  );
}
function Lhe(e, t) {
  if (!bf(e))
    throw new Error(Qd);
  if (!P2(t))
    throw new Error(I2);
  return S0(() => Ohe(e, t));
}
function Hhe(e, t) {
  if (!bf(e))
    throw new Error(Qd);
  if (!P2(t))
    throw new Error(I2);
  return S0(() => Phe(e, t));
}
function Fhe(e) {
  if (!bf(e))
    throw new Error(Qd);
  return Che(e);
}
function Mhe(e, t, r) {
  if (!bf(t))
    throw new Error(Qd);
  if (!vg(e))
    throw new Error(O2);
  if (!qC(r))
    throw new Error(DC);
  return Ti.secp256k1.sign(e, t, { extraEntropy: r }).toCompactRawBytes();
}
function Dhe(e, t, r) {
  if (!bf(t))
    throw new Error(Qd);
  if (!vg(e))
    throw new Error(O2);
  if (!qC(r))
    throw new Error(DC);
  const n = Ti.secp256k1.sign(e, t, { extraEntropy: r });
  return {
    signature: n.toCompactRawBytes(),
    recoveryId: n.recovery
  };
}
function Khe(e, t, r) {
  if (!bf(t))
    throw new Error(Qd);
  if (!vg(e))
    throw new Error(O2);
  if (!qC(r))
    throw new Error(DC);
  return Ti.schnorr.sign(e, t, r);
}
function qhe(e, t, r, n) {
  if (!vg(e))
    throw new Error(bhe);
  if (!KC(t) || !Ihe(t))
    throw new Error(ew);
  if (r & 2 && !The(t))
    throw new Error(whe);
  if (!u4(t.subarray(0, 32)))
    throw new Error(ew);
  const o = Ti.secp256k1.Signature.fromCompact(t).addRecoveryBit(r).recoverPublicKey(e);
  if (!o) throw new Error(ew);
  return o.toRawBytes(Eg(n));
}
function Vhe(e, t, r, n) {
  if (!Hd(t))
    throw new Error(eh);
  if (!KC(r))
    throw new Error(ew);
  if (!vg(e))
    throw new Error(O2);
  return Ti.secp256k1.verify(r, e, t, { lowS: n });
}
function Ghe(e, t, r) {
  if (!u4(t))
    throw new Error(eh);
  if (!KC(r))
    throw new Error(ew);
  if (!vg(e))
    throw new Error(O2);
  return Ti.schnorr.verify(r, e, t);
}
var Whe = ao.isPoint = Hd, Zhe = ao.isPointCompressed = pD, Xhe = ao.isPrivate = bf, Yhe = ao.isXOnlyPoint = u4, Jhe = ao.pointAdd = zhe, Qhe = ao.pointAddScalar = jhe, epe = ao.pointCompress = Uhe, tpe = ao.pointFromScalar = mD, rpe = ao.pointMultiply = Rhe, npe = ao.privateAdd = Lhe, ope = ao.privateNegate = Fhe, ipe = ao.privateSub = Hhe, ape = ao.recover = qhe, spe = ao.sign = Mhe, upe = ao.signRecoverable = Dhe, cpe = ao.signSchnorr = Khe, lpe = ao.verify = Vhe, fpe = ao.verifySchnorr = Ghe, dpe = ao.xOnlyPointAddTweak = Nhe, hpe = ao.xOnlyPointFromPoint = gD, ppe = ao.xOnlyPointFromScalar = $he;
const c4 = /* @__PURE__ */ dJ({
  __proto__: null,
  default: ao,
  isPoint: Whe,
  isPointCompressed: Zhe,
  isPrivate: Xhe,
  isXOnlyPoint: Yhe,
  pointAdd: Jhe,
  pointAddScalar: Qhe,
  pointCompress: epe,
  pointFromScalar: tpe,
  pointMultiply: rpe,
  privateAdd: npe,
  privateNegate: ope,
  privateSub: ipe,
  recover: ape,
  sign: spe,
  signRecoverable: upe,
  signSchnorr: cpe,
  verify: lpe,
  verifySchnorr: fpe,
  xOnlyPointAddTweak: dpe,
  xOnlyPointFromPoint: hpe,
  xOnlyPointFromScalar: ppe
}, [ao]);
var iO = /* @__PURE__ */ ((e) => (e.MAINNET = "fractal_mainnet", e.TESTNET = "fractal_testnet", e))(iO || {}), qb = /* @__PURE__ */ ((e) => (e.MAINNET = "main", e.TESTNET = "testnet", e.SIGNET = "signet", e))(qb || {}), E1 = /* @__PURE__ */ ((e) => (e.MAINNET = "mainnet", e.TESTNET = "testnet", e))(E1 || {}), va = /* @__PURE__ */ ((e) => (e.MAINNET = "BITCOIN_MAINNET", e.TESTNET = "BITCOIN_TESTNET", e.TESTNET4 = "BITCOIN_TESTNET4", e.SIGNET = "BITCOIN_SIGNET", e.FRACTAL_MAINNET = "FRACTAL_BITCOIN_MAINNET", e.FRACTAL_TESTNET = "FRACTAL_BITCOIN_TESTNET", e))(va || {}), gpe = /* @__PURE__ */ ((e) => (e.MAINNET = "livenet", e.TESTNET = "testnet", e))(gpe || {}), Au = /* @__PURE__ */ ((e) => (e.MAINNET = "Mainnet", e.TESTNET = "Testnet", e.SIGNET = "Signet", e.FRACTAL_MAINNET = "fractal mainnet", e.FRACTAL_TESTNET = "fractal testnet", e.TESTNET4 = "Testnet4", e))(Au || {}), aO = /* @__PURE__ */ ((e) => (e.MAINNET = "livenet", e.TESTNET = "testnet", e))(aO || {}), zs = /* @__PURE__ */ ((e) => (e.MAINNET = "livenet", e.TESTNET = "testnet", e.TESTNET4 = "testnet4", e.SIGNET = "signet", e))(zs || {}), R8 = /* @__PURE__ */ ((e) => (e.MAINNET = "Mainnet", e.TESTNET = "Testnet", e))(R8 || {}), gt = /* @__PURE__ */ ((e) => (e.MAINNET = "mainnet", e.SIGNET = "signet", e.TESTNET = "testnet", e.TESTNET4 = "testnet4", e.REGTEST = "regtest", e.FRACTAL_MAINNET = "fractal_mainnet", e.FRACTAL_TESTNET = "fractal_testnet", e))(gt || {});
const Kn = gt.MAINNET, Ls = gt.SIGNET, aa = gt.TESTNET, ka = gt.TESTNET4, th = gt.FRACTAL_MAINNET, as = gt.FRACTAL_TESTNET, xUe = gt.REGTEST, eT = (e) => e === gt.MAINNET ? Au.MAINNET : e === gt.TESTNET || e === gt.TESTNET4 ? Au.TESTNET : e === gt.SIGNET ? Au.SIGNET : (e === gt.FRACTAL_MAINNET || gt.FRACTAL_TESTNET, Au.MAINNET), kUe = (e) => e === gt.MAINNET ? E1.MAINNET : e === gt.TESTNET ? E1.TESTNET : E1.MAINNET, yD = (e) => e === gt.MAINNET ? va.MAINNET : e === gt.TESTNET ? va.TESTNET : e === gt.TESTNET4 ? va.TESTNET4 : e === gt.SIGNET ? va.SIGNET : e === gt.FRACTAL_MAINNET ? va.FRACTAL_MAINNET : e === gt.FRACTAL_TESTNET ? va.FRACTAL_TESTNET : va.MAINNET, SUe = (e) => e === gt.MAINNET ? zs.MAINNET : e === gt.TESTNET ? zs.TESTNET : e === gt.TESTNET4 ? zs.TESTNET4 : e === gt.SIGNET ? zs.SIGNET : e === gt.FRACTAL_TESTNET ? zs.TESTNET : (gt.FRACTAL_MAINNET, zs.MAINNET), tT = (e) => e === gt.MAINNET ? R8.MAINNET : e === gt.TESTNET || e === gt.TESTNET4 || e === gt.SIGNET ? R8.TESTNET : (e === gt.FRACTAL_MAINNET || gt.FRACTAL_TESTNET, R8.MAINNET), mpe = (e) => e === gt.MAINNET ? qb.MAINNET : e === gt.TESTNET4 || e === gt.TESTNET ? qb.TESTNET : e === gt.SIGNET ? qb.SIGNET : (e === gt.MAINNET || gt.TESTNET, qb.MAINNET), B3 = (e) => e === va.MAINNET ? gt.MAINNET : e === va.TESTNET ? gt.TESTNET : e === va.TESTNET4 ? gt.TESTNET4 : e === va.SIGNET ? gt.SIGNET : e === va.FRACTAL_MAINNET ? gt.FRACTAL_MAINNET : e === va.FRACTAL_TESTNET ? gt.TESTNET : gt.MAINNET, rT = (e) => e === Au.MAINNET ? gt.MAINNET : e === Au.TESTNET ? gt.TESTNET : e === Au.TESTNET4 ? gt.TESTNET4 : e === Au.SIGNET ? gt.SIGNET : e === Au.FRACTAL_MAINNET ? gt.FRACTAL_MAINNET : e === Au.FRACTAL_TESTNET ? gt.FRACTAL_TESTNET : gt.MAINNET, TUe = (e) => e === E1.MAINNET ? gt.MAINNET : e === E1.TESTNET ? gt.TESTNET : gt.MAINNET, ype = (e) => e === aO.MAINNET ? gt.MAINNET : e === aO.TESTNET ? gt.TESTNET : gt.MAINNET, CU = (e) => e === zs.MAINNET ? gt.MAINNET : e === zs.TESTNET ? gt.TESTNET : e === zs.TESTNET4 ? gt.TESTNET4 : e === zs.SIGNET ? gt.SIGNET : e === iO.TESTNET ? gt.TESTNET : (iO.MAINNET, gt.MAINNET);
function bD(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: bpe } = Object.prototype, { getPrototypeOf: ZC } = Object, l4 = /* @__PURE__ */ ((e) => (t) => {
  const r = bpe.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Vu = (e) => (e = e.toLowerCase(), (t) => l4(t) === e), f4 = (e) => (t) => typeof t === e, { isArray: _g } = Array, Uw = f4("undefined");
function wpe(e) {
  return e !== null && !Uw(e) && e.constructor !== null && !Uw(e.constructor) && cs(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const wD = Vu("ArrayBuffer");
function vpe(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && wD(e.buffer), t;
}
const Epe = f4("string"), cs = f4("function"), vD = f4("number"), d4 = (e) => e !== null && typeof e == "object", _pe = (e) => e === !0 || e === !1, z8 = (e) => {
  if (l4(e) !== "object")
    return !1;
  const t = ZC(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Ape = Vu("Date"), xpe = Vu("File"), kpe = Vu("Blob"), Spe = Vu("FileList"), Tpe = (e) => d4(e) && cs(e.pipe), Ipe = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || cs(e.append) && ((t = l4(e)) === "formdata" || // detect form-data instance
  t === "object" && cs(e.toString) && e.toString() === "[object FormData]"));
}, Ope = Vu("URLSearchParams"), [Ppe, Cpe, Bpe, Npe] = ["ReadableStream", "Request", "Response", "Headers"].map(Vu), $pe = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function C2(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, o;
  if (typeof e != "object" && (e = [e]), _g(e))
    for (n = 0, o = e.length; n < o; n++)
      t.call(null, e[n], n, e);
  else {
    const i = r ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length;
    let u;
    for (n = 0; n < a; n++)
      u = i[n], t.call(null, e[u], u, e);
  }
}
function ED(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, o;
  for (; n-- > 0; )
    if (o = r[n], t === o.toLowerCase())
      return o;
  return null;
}
const $p = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, _D = (e) => !Uw(e) && e !== $p;
function sO() {
  const { caseless: e } = _D(this) && this || {}, t = {}, r = (n, o) => {
    const i = e && ED(t, o) || o;
    z8(t[i]) && z8(n) ? t[i] = sO(t[i], n) : z8(n) ? t[i] = sO({}, n) : _g(n) ? t[i] = n.slice() : t[i] = n;
  };
  for (let n = 0, o = arguments.length; n < o; n++)
    arguments[n] && C2(arguments[n], r);
  return t;
}
const Upe = (e, t, r, { allOwnKeys: n } = {}) => (C2(t, (o, i) => {
  r && cs(o) ? e[i] = bD(o, r) : e[i] = o;
}, { allOwnKeys: n }), e), Rpe = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), zpe = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, jpe = (e, t, r, n) => {
  let o, i, a;
  const u = {};
  if (t = t || {}, e == null) return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      a = o[i], (!n || n(a, e, t)) && !u[a] && (t[a] = e[a], u[a] = !0);
    e = r !== !1 && ZC(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, Lpe = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, Hpe = (e) => {
  if (!e) return null;
  if (_g(e)) return e;
  let t = e.length;
  if (!vD(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, Fpe = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && ZC(Uint8Array)), Mpe = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let n;
  for (; (n = r.next()) && !n.done; ) {
    const o = n.value;
    t.call(e, o[0], o[1]);
  }
}, Dpe = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, Kpe = Vu("HTMLFormElement"), qpe = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, r, n) {
    return r.toUpperCase() + n;
  }
), BU = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), Vpe = Vu("RegExp"), AD = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  C2(r, (o, i) => {
    let a;
    (a = t(o, i, e)) !== !1 && (n[i] = a || o);
  }), Object.defineProperties(e, n);
}, Gpe = (e) => {
  AD(e, (t, r) => {
    if (cs(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (cs(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, Wpe = (e, t) => {
  const r = {}, n = (o) => {
    o.forEach((i) => {
      r[i] = !0;
    });
  };
  return _g(e) ? n(e) : n(String(e).split(t)), r;
}, Zpe = () => {
}, Xpe = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function Ype(e) {
  return !!(e && cs(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const Jpe = (e) => {
  const t = new Array(10), r = (n, o) => {
    if (d4(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[o] = n;
        const i = _g(n) ? [] : {};
        return C2(n, (a, u) => {
          const l = r(a, o + 1);
          !Uw(l) && (i[u] = l);
        }), t[o] = void 0, i;
      }
    }
    return n;
  };
  return r(e, 0);
}, Qpe = Vu("AsyncFunction"), e0e = (e) => e && (d4(e) || cs(e)) && cs(e.then) && cs(e.catch), xD = ((e, t) => e ? setImmediate : t ? ((r, n) => ($p.addEventListener("message", ({ source: o, data: i }) => {
  o === $p && i === r && n.length && n.shift()();
}, !1), (o) => {
  n.push(o), $p.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  cs($p.postMessage)
), t0e = typeof queueMicrotask < "u" ? queueMicrotask.bind($p) : typeof process < "u" && process.nextTick || xD, Ce = {
  isArray: _g,
  isArrayBuffer: wD,
  isBuffer: wpe,
  isFormData: Ipe,
  isArrayBufferView: vpe,
  isString: Epe,
  isNumber: vD,
  isBoolean: _pe,
  isObject: d4,
  isPlainObject: z8,
  isReadableStream: Ppe,
  isRequest: Cpe,
  isResponse: Bpe,
  isHeaders: Npe,
  isUndefined: Uw,
  isDate: Ape,
  isFile: xpe,
  isBlob: kpe,
  isRegExp: Vpe,
  isFunction: cs,
  isStream: Tpe,
  isURLSearchParams: Ope,
  isTypedArray: Fpe,
  isFileList: Spe,
  forEach: C2,
  merge: sO,
  extend: Upe,
  trim: $pe,
  stripBOM: Rpe,
  inherits: zpe,
  toFlatObject: jpe,
  kindOf: l4,
  kindOfTest: Vu,
  endsWith: Lpe,
  toArray: Hpe,
  forEachEntry: Mpe,
  matchAll: Dpe,
  isHTMLForm: Kpe,
  hasOwnProperty: BU,
  hasOwnProp: BU,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: AD,
  freezeMethods: Gpe,
  toObjectSet: Wpe,
  toCamelCase: qpe,
  noop: Zpe,
  toFiniteNumber: Xpe,
  findKey: ED,
  global: $p,
  isContextDefined: _D,
  isSpecCompliantForm: Ype,
  toJSONObject: Jpe,
  isAsyncFn: Qpe,
  isThenable: e0e,
  setImmediate: xD,
  asap: t0e
};
function dr(e, t, r, n, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), o && (this.response = o, this.status = o.status ? o.status : null);
}
Ce.inherits(dr, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: Ce.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const kD = dr.prototype, SD = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  SD[e] = { value: e };
});
Object.defineProperties(dr, SD);
Object.defineProperty(kD, "isAxiosError", { value: !0 });
dr.from = (e, t, r, n, o, i) => {
  const a = Object.create(kD);
  return Ce.toFlatObject(e, a, function(u) {
    return u !== Error.prototype;
  }, (u) => u !== "isAxiosError"), dr.call(a, e.message, t, r, n, o), a.cause = e, a.name = e.name, i && Object.assign(a, i), a;
};
const r0e = null;
function uO(e) {
  return Ce.isPlainObject(e) || Ce.isArray(e);
}
function TD(e) {
  return Ce.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function NU(e, t, r) {
  return e ? e.concat(t).map(function(n, o) {
    return n = TD(n), !r && o ? "[" + n + "]" : n;
  }).join(r ? "." : "") : t;
}
function n0e(e) {
  return Ce.isArray(e) && !e.some(uO);
}
const o0e = Ce.toFlatObject(Ce, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function h4(e, t, r) {
  if (!Ce.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = Ce.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(b, w) {
    return !Ce.isUndefined(w[b]);
  });
  const n = r.metaTokens, o = r.visitor || d, i = r.dots, a = r.indexes, u = (r.Blob || typeof Blob < "u" && Blob) && Ce.isSpecCompliantForm(t);
  if (!Ce.isFunction(o))
    throw new TypeError("visitor must be a function");
  function l(b) {
    if (b === null) return "";
    if (Ce.isDate(b))
      return b.toISOString();
    if (!u && Ce.isBlob(b))
      throw new dr("Blob is not supported. Use a Buffer instead.");
    return Ce.isArrayBuffer(b) || Ce.isTypedArray(b) ? u && typeof Blob == "function" ? new Blob([b]) : Buffer.from(b) : b;
  }
  function d(b, w, E) {
    let _ = b;
    if (b && !E && typeof b == "object") {
      if (Ce.endsWith(w, "{}"))
        w = n ? w : w.slice(0, -2), b = JSON.stringify(b);
      else if (Ce.isArray(b) && n0e(b) || (Ce.isFileList(b) || Ce.endsWith(w, "[]")) && (_ = Ce.toArray(b)))
        return w = TD(w), _.forEach(function(O, C) {
          !(Ce.isUndefined(O) || O === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? NU([w], C, i) : a === null ? w : w + "[]",
            l(O)
          );
        }), !1;
    }
    return uO(b) ? !0 : (t.append(NU(E, w, i), l(b)), !1);
  }
  const f = [], h = Object.assign(o0e, {
    defaultVisitor: d,
    convertValue: l,
    isVisitable: uO
  });
  function g(b, w) {
    if (!Ce.isUndefined(b)) {
      if (f.indexOf(b) !== -1)
        throw Error("Circular reference detected in " + w.join("."));
      f.push(b), Ce.forEach(b, function(E, _) {
        (!(Ce.isUndefined(E) || E === null) && o.call(
          t,
          E,
          Ce.isString(_) ? _.trim() : _,
          w,
          h
        )) === !0 && g(E, w ? w.concat(_) : [_]);
      }), f.pop();
    }
  }
  if (!Ce.isObject(e))
    throw new TypeError("data must be an object");
  return g(e), t;
}
function $U(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function XC(e, t) {
  this._pairs = [], e && h4(e, this, t);
}
const ID = XC.prototype;
ID.append = function(e, t) {
  this._pairs.push([e, t]);
};
ID.toString = function(e) {
  const t = e ? function(r) {
    return e.call(this, r, $U);
  } : $U;
  return this._pairs.map(function(r) {
    return t(r[0]) + "=" + t(r[1]);
  }, "").join("&");
};
function i0e(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function OD(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || i0e;
  Ce.isFunction(r) && (r = {
    serialize: r
  });
  const o = r && r.serialize;
  let i;
  if (o ? i = o(t, r) : i = Ce.isURLSearchParams(t) ? t.toString() : new XC(t, r).toString(n), i) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
let UU = class {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    Ce.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
};
const PD = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, a0e = typeof URLSearchParams < "u" ? URLSearchParams : XC, s0e = typeof FormData < "u" ? FormData : null, u0e = typeof Blob < "u" ? Blob : null, c0e = {
  isBrowser: !0,
  classes: {
    URLSearchParams: a0e,
    FormData: s0e,
    Blob: u0e
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, YC = typeof window < "u" && typeof document < "u", cO = typeof navigator == "object" && navigator || void 0, l0e = YC && (!cO || ["ReactNative", "NativeScript", "NS"].indexOf(cO.product) < 0), f0e = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", d0e = YC && window.location.href || "http://localhost", h0e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: YC,
  hasStandardBrowserEnv: l0e,
  hasStandardBrowserWebWorkerEnv: f0e,
  navigator: cO,
  origin: d0e
}, Symbol.toStringTag, { value: "Module" })), Li = {
  ...h0e,
  ...c0e
};
function p0e(e, t) {
  return h4(e, new Li.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, o, i) {
      return Li.isNode && Ce.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function g0e(e) {
  return Ce.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function m0e(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const o = r.length;
  let i;
  for (n = 0; n < o; n++)
    i = r[n], t[i] = e[i];
  return t;
}
function CD(e) {
  function t(r, n, o, i) {
    let a = r[i++];
    if (a === "__proto__") return !0;
    const u = Number.isFinite(+a), l = i >= r.length;
    return a = !a && Ce.isArray(o) ? o.length : a, l ? (Ce.hasOwnProp(o, a) ? o[a] = [o[a], n] : o[a] = n, !u) : ((!o[a] || !Ce.isObject(o[a])) && (o[a] = []), t(r, n, o[a], i) && Ce.isArray(o[a]) && (o[a] = m0e(o[a])), !u);
  }
  if (Ce.isFormData(e) && Ce.isFunction(e.entries)) {
    const r = {};
    return Ce.forEachEntry(e, (n, o) => {
      t(g0e(n), o, r, 0);
    }), r;
  }
  return null;
}
function y0e(e, t, r) {
  if (Ce.isString(e))
    try {
      return (t || JSON.parse)(e), Ce.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const B2 = {
  transitional: PD,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const r = t.getContentType() || "", n = r.indexOf("application/json") > -1, o = Ce.isObject(e);
    if (o && Ce.isHTMLForm(e) && (e = new FormData(e)), Ce.isFormData(e))
      return n ? JSON.stringify(CD(e)) : e;
    if (Ce.isArrayBuffer(e) || Ce.isBuffer(e) || Ce.isStream(e) || Ce.isFile(e) || Ce.isBlob(e) || Ce.isReadableStream(e))
      return e;
    if (Ce.isArrayBufferView(e))
      return e.buffer;
    if (Ce.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let i;
    if (o) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return p0e(e, this.formSerializer).toString();
      if ((i = Ce.isFileList(e)) || r.indexOf("multipart/form-data") > -1) {
        const a = this.env && this.env.FormData;
        return h4(
          i ? { "files[]": e } : e,
          a && new a(),
          this.formSerializer
        );
      }
    }
    return o || n ? (t.setContentType("application/json", !1), y0e(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || B2.transitional, r = t && t.forcedJSONParsing, n = this.responseType === "json";
    if (Ce.isResponse(e) || Ce.isReadableStream(e))
      return e;
    if (e && Ce.isString(e) && (r && !this.responseType || n)) {
      const o = !(t && t.silentJSONParsing) && n;
      try {
        return JSON.parse(e);
      } catch (i) {
        if (o)
          throw i.name === "SyntaxError" ? dr.from(i, dr.ERR_BAD_RESPONSE, this, null, this.response) : i;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Li.classes.FormData,
    Blob: Li.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
Ce.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  B2.headers[e] = {};
});
const b0e = Ce.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), w0e = (e) => {
  const t = {};
  let r, n, o;
  return e && e.split(`
`).forEach(function(i) {
    o = i.indexOf(":"), r = i.substring(0, o).trim().toLowerCase(), n = i.substring(o + 1).trim(), !(!r || t[r] && b0e[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, RU = Symbol("internals");
function Ob(e) {
  return e && String(e).trim().toLowerCase();
}
function j8(e) {
  return e === !1 || e == null ? e : Ce.isArray(e) ? e.map(j8) : String(e);
}
function v0e(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const E0e = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function nT(e, t, r, n, o) {
  if (Ce.isFunction(n))
    return n.call(this, t, r);
  if (o && (t = r), !!Ce.isString(t)) {
    if (Ce.isString(n))
      return t.indexOf(n) !== -1;
    if (Ce.isRegExp(n))
      return n.test(t);
  }
}
function _0e(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function A0e(e, t) {
  const r = Ce.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(o, i, a) {
        return this[n].call(this, t, o, i, a);
      },
      configurable: !0
    });
  });
}
let Pa = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const o = this;
    function i(u, l, d) {
      const f = Ob(l);
      if (!f)
        throw new Error("header name must be a non-empty string");
      const h = Ce.findKey(o, f);
      (!h || o[h] === void 0 || d === !0 || d === void 0 && o[h] !== !1) && (o[h || l] = j8(u));
    }
    const a = (u, l) => Ce.forEach(u, (d, f) => i(d, f, l));
    if (Ce.isPlainObject(t) || t instanceof this.constructor)
      a(t, r);
    else if (Ce.isString(t) && (t = t.trim()) && !E0e(t))
      a(w0e(t), r);
    else if (Ce.isHeaders(t))
      for (const [u, l] of t.entries())
        i(l, u, n);
    else
      t != null && i(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = Ob(t), t) {
      const n = Ce.findKey(this, t);
      if (n) {
        const o = this[n];
        if (!r)
          return o;
        if (r === !0)
          return v0e(o);
        if (Ce.isFunction(r))
          return r.call(this, o, n);
        if (Ce.isRegExp(r))
          return r.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = Ob(t), t) {
      const n = Ce.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || nT(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let o = !1;
    function i(a) {
      if (a = Ob(a), a) {
        const u = Ce.findKey(n, a);
        u && (!r || nT(n, n[u], u, r)) && (delete n[u], o = !0);
      }
    }
    return Ce.isArray(t) ? t.forEach(i) : i(t), o;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, o = !1;
    for (; n--; ) {
      const i = r[n];
      (!t || nT(this, this[i], i, t, !0)) && (delete this[i], o = !0);
    }
    return o;
  }
  normalize(t) {
    const r = this, n = {};
    return Ce.forEach(this, (o, i) => {
      const a = Ce.findKey(n, i);
      if (a) {
        r[a] = j8(o), delete r[i];
        return;
      }
      const u = t ? _0e(i) : String(i).trim();
      u !== i && delete r[i], r[u] = j8(o), n[u] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return Ce.forEach(this, (n, o) => {
      n != null && n !== !1 && (r[o] = t && Ce.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((o) => n.set(o)), n;
  }
  static accessor(t) {
    const r = (this[RU] = this[RU] = {
      accessors: {}
    }).accessors, n = this.prototype;
    function o(i) {
      const a = Ob(i);
      r[a] || (A0e(n, i), r[a] = !0);
    }
    return Ce.isArray(t) ? t.forEach(o) : o(t), this;
  }
};
Pa.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
Ce.reduceDescriptors(Pa.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
Ce.freezeMethods(Pa);
function oT(e, t) {
  const r = this || B2, n = t || r, o = Pa.from(n.headers);
  let i = n.data;
  return Ce.forEach(e, function(a) {
    i = a.call(r, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function BD(e) {
  return !!(e && e.__CANCEL__);
}
function Ag(e, t, r) {
  dr.call(this, e ?? "canceled", dr.ERR_CANCELED, t, r), this.name = "CanceledError";
}
Ce.inherits(Ag, dr, {
  __CANCEL__: !0
});
function ND(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new dr(
    "Request failed with status code " + r.status,
    [dr.ERR_BAD_REQUEST, dr.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function x0e(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function k0e(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let o = 0, i = 0, a;
  return t = t !== void 0 ? t : 1e3, function(u) {
    const l = Date.now(), d = n[i];
    a || (a = l), r[o] = u, n[o] = l;
    let f = i, h = 0;
    for (; f !== o; )
      h += r[f++], f = f % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), l - a < t)
      return;
    const g = d && l - d;
    return g ? Math.round(h * 1e3 / g) : void 0;
  };
}
function S0e(e, t) {
  let r = 0, n = 1e3 / t, o, i;
  const a = (u, l = Date.now()) => {
    r = l, o = null, i && (clearTimeout(i), i = null), e.apply(null, u);
  };
  return [(...u) => {
    const l = Date.now(), d = l - r;
    d >= n ? a(u, l) : (o = u, i || (i = setTimeout(() => {
      i = null, a(o);
    }, n - d)));
  }, () => o && a(o)];
}
const N3 = (e, t, r = 3) => {
  let n = 0;
  const o = k0e(50, 250);
  return S0e((i) => {
    const a = i.loaded, u = i.lengthComputable ? i.total : void 0, l = a - n, d = o(l), f = a <= u;
    n = a;
    const h = {
      loaded: a,
      total: u,
      progress: u ? a / u : void 0,
      bytes: l,
      rate: d || void 0,
      estimated: d && u && f ? (u - a) / d : void 0,
      event: i,
      lengthComputable: u != null,
      [t ? "download" : "upload"]: !0
    };
    e(h);
  }, r);
}, zU = (e, t) => {
  const r = e != null;
  return [(n) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: n
  }), t[1]];
}, jU = (e) => (...t) => Ce.asap(() => e(...t)), T0e = Li.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (r) => (r = new URL(r, Li.origin), e.protocol === r.protocol && e.host === r.host && (t || e.port === r.port)))(
  new URL(Li.origin),
  Li.navigator && /(msie|trident)/i.test(Li.navigator.userAgent)
) : () => !0, I0e = Li.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, o, i) {
      const a = [e + "=" + encodeURIComponent(t)];
      Ce.isNumber(r) && a.push("expires=" + new Date(r).toGMTString()), Ce.isString(n) && a.push("path=" + n), Ce.isString(o) && a.push("domain=" + o), i === !0 && a.push("secure"), document.cookie = a.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function O0e(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function P0e(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function $D(e, t, r) {
  let n = !O0e(t);
  return e && (n || r == !1) ? P0e(e, t) : t;
}
const LU = (e) => e instanceof Pa ? { ...e } : e;
function i0(e, t) {
  t = t || {};
  const r = {};
  function n(d, f, h, g) {
    return Ce.isPlainObject(d) && Ce.isPlainObject(f) ? Ce.merge.call({ caseless: g }, d, f) : Ce.isPlainObject(f) ? Ce.merge({}, f) : Ce.isArray(f) ? f.slice() : f;
  }
  function o(d, f, h, g) {
    if (Ce.isUndefined(f)) {
      if (!Ce.isUndefined(d))
        return n(void 0, d, h, g);
    } else return n(d, f, h, g);
  }
  function i(d, f) {
    if (!Ce.isUndefined(f))
      return n(void 0, f);
  }
  function a(d, f) {
    if (Ce.isUndefined(f)) {
      if (!Ce.isUndefined(d))
        return n(void 0, d);
    } else return n(void 0, f);
  }
  function u(d, f, h) {
    if (h in t)
      return n(d, f);
    if (h in e)
      return n(void 0, d);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: u,
    headers: (d, f, h) => o(LU(d), LU(f), h, !0)
  };
  return Ce.forEach(Object.keys(Object.assign({}, e, t)), function(d) {
    const f = l[d] || o, h = f(e[d], t[d], d);
    Ce.isUndefined(h) && f !== u || (r[d] = h);
  }), r;
}
const UD = (e) => {
  const t = i0({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: o, xsrfCookieName: i, headers: a, auth: u } = t;
  t.headers = a = Pa.from(a), t.url = OD($D(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), u && a.set(
    "Authorization",
    "Basic " + btoa((u.username || "") + ":" + (u.password ? unescape(encodeURIComponent(u.password)) : ""))
  );
  let l;
  if (Ce.isFormData(r)) {
    if (Li.hasStandardBrowserEnv || Li.hasStandardBrowserWebWorkerEnv)
      a.setContentType(void 0);
    else if ((l = a.getContentType()) !== !1) {
      const [d, ...f] = l ? l.split(";").map((h) => h.trim()).filter(Boolean) : [];
      a.setContentType([d || "multipart/form-data", ...f].join("; "));
    }
  }
  if (Li.hasStandardBrowserEnv && (n && Ce.isFunction(n) && (n = n(t)), n || n !== !1 && T0e(t.url))) {
    const d = o && i && I0e.read(i);
    d && a.set(o, d);
  }
  return t;
}, C0e = typeof XMLHttpRequest < "u", B0e = C0e && function(e) {
  return new Promise(function(t, r) {
    const n = UD(e);
    let o = n.data;
    const i = Pa.from(n.headers).normalize();
    let { responseType: a, onUploadProgress: u, onDownloadProgress: l } = n, d, f, h, g, b;
    function w() {
      g && g(), b && b(), n.cancelToken && n.cancelToken.unsubscribe(d), n.signal && n.signal.removeEventListener("abort", d);
    }
    let E = new XMLHttpRequest();
    E.open(n.method.toUpperCase(), n.url, !0), E.timeout = n.timeout;
    function _() {
      if (!E)
        return;
      const C = Pa.from(
        "getAllResponseHeaders" in E && E.getAllResponseHeaders()
      ), I = {
        data: !a || a === "text" || a === "json" ? E.responseText : E.response,
        status: E.status,
        statusText: E.statusText,
        headers: C,
        config: e,
        request: E
      };
      ND(function(S) {
        t(S), w();
      }, function(S) {
        r(S), w();
      }, I), E = null;
    }
    "onloadend" in E ? E.onloadend = _ : E.onreadystatechange = function() {
      !E || E.readyState !== 4 || E.status === 0 && !(E.responseURL && E.responseURL.indexOf("file:") === 0) || setTimeout(_);
    }, E.onabort = function() {
      E && (r(new dr("Request aborted", dr.ECONNABORTED, e, E)), E = null);
    }, E.onerror = function() {
      r(new dr("Network Error", dr.ERR_NETWORK, e, E)), E = null;
    }, E.ontimeout = function() {
      let C = n.timeout ? "timeout of " + n.timeout + "ms exceeded" : "timeout exceeded";
      const I = n.transitional || PD;
      n.timeoutErrorMessage && (C = n.timeoutErrorMessage), r(new dr(
        C,
        I.clarifyTimeoutError ? dr.ETIMEDOUT : dr.ECONNABORTED,
        e,
        E
      )), E = null;
    }, o === void 0 && i.setContentType(null), "setRequestHeader" in E && Ce.forEach(i.toJSON(), function(C, I) {
      E.setRequestHeader(I, C);
    }), Ce.isUndefined(n.withCredentials) || (E.withCredentials = !!n.withCredentials), a && a !== "json" && (E.responseType = n.responseType), l && ([h, b] = N3(l, !0), E.addEventListener("progress", h)), u && E.upload && ([f, g] = N3(u), E.upload.addEventListener("progress", f), E.upload.addEventListener("loadend", g)), (n.cancelToken || n.signal) && (d = (C) => {
      E && (r(!C || C.type ? new Ag(null, e, E) : C), E.abort(), E = null);
    }, n.cancelToken && n.cancelToken.subscribe(d), n.signal && (n.signal.aborted ? d() : n.signal.addEventListener("abort", d)));
    const O = x0e(n.url);
    if (O && Li.protocols.indexOf(O) === -1) {
      r(new dr("Unsupported protocol " + O + ":", dr.ERR_BAD_REQUEST, e));
      return;
    }
    E.send(o || null);
  });
}, N0e = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let n = new AbortController(), o;
    const i = function(d) {
      if (!o) {
        o = !0, u();
        const f = d instanceof Error ? d : this.reason;
        n.abort(f instanceof dr ? f : new Ag(f instanceof Error ? f.message : f));
      }
    };
    let a = t && setTimeout(() => {
      a = null, i(new dr(`timeout ${t} of ms exceeded`, dr.ETIMEDOUT));
    }, t);
    const u = () => {
      e && (a && clearTimeout(a), a = null, e.forEach((d) => {
        d.unsubscribe ? d.unsubscribe(i) : d.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((d) => d.addEventListener("abort", i));
    const { signal: l } = n;
    return l.unsubscribe = () => Ce.asap(u), l;
  }
}, $0e = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, o;
  for (; n < r; )
    o = n + t, yield e.slice(n, o), n = o;
}, U0e = async function* (e, t) {
  for await (const r of R0e(e))
    yield* $0e(r, t);
}, R0e = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await t.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, HU = (e, t, r, n) => {
  const o = U0e(e, t);
  let i = 0, a, u = (l) => {
    a || (a = !0, n && n(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: d, value: f } = await o.next();
        if (d) {
          u(), l.close();
          return;
        }
        let h = f.byteLength;
        if (r) {
          let g = i += h;
          r(g);
        }
        l.enqueue(new Uint8Array(f));
      } catch (d) {
        throw u(d), d;
      }
    },
    cancel(l) {
      return u(l), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, p4 = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", RD = p4 && typeof ReadableStream == "function", z0e = p4 && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), zD = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, j0e = RD && zD(() => {
  let e = !1;
  const t = new Request(Li.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), FU = 64 * 1024, lO = RD && zD(() => Ce.isReadableStream(new Response("").body)), $3 = {
  stream: lO && ((e) => e.body)
};
p4 && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !$3[t] && ($3[t] = Ce.isFunction(e[t]) ? (r) => r[t]() : (r, n) => {
      throw new dr(`Response type '${t}' is not supported`, dr.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const L0e = async (e) => {
  if (e == null)
    return 0;
  if (Ce.isBlob(e))
    return e.size;
  if (Ce.isSpecCompliantForm(e))
    return (await new Request(Li.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (Ce.isArrayBufferView(e) || Ce.isArrayBuffer(e))
    return e.byteLength;
  if (Ce.isURLSearchParams(e) && (e = e + ""), Ce.isString(e))
    return (await z0e(e)).byteLength;
}, H0e = async (e, t) => Ce.toFiniteNumber(e.getContentLength()) ?? L0e(t), F0e = p4 && (async (e) => {
  let {
    url: t,
    method: r,
    data: n,
    signal: o,
    cancelToken: i,
    timeout: a,
    onDownloadProgress: u,
    onUploadProgress: l,
    responseType: d,
    headers: f,
    withCredentials: h = "same-origin",
    fetchOptions: g
  } = UD(e);
  d = d ? (d + "").toLowerCase() : "text";
  let b = N0e([o, i && i.toAbortSignal()], a), w;
  const E = b && b.unsubscribe && (() => {
    b.unsubscribe();
  });
  let _;
  try {
    if (l && j0e && r !== "get" && r !== "head" && (_ = await H0e(f, n)) !== 0) {
      let T = new Request(t, {
        method: "POST",
        body: n,
        duplex: "half"
      }), A;
      if (Ce.isFormData(n) && (A = T.headers.get("content-type")) && f.setContentType(A), T.body) {
        const [$, U] = zU(
          _,
          N3(jU(l))
        );
        n = HU(T.body, FU, $, U);
      }
    }
    Ce.isString(h) || (h = h ? "include" : "omit");
    const O = "credentials" in Request.prototype;
    w = new Request(t, {
      ...g,
      signal: b,
      method: r.toUpperCase(),
      headers: f.normalize().toJSON(),
      body: n,
      duplex: "half",
      credentials: O ? h : void 0
    });
    let C = await fetch(w);
    const I = lO && (d === "stream" || d === "response");
    if (lO && (u || I && E)) {
      const T = {};
      ["status", "statusText", "headers"].forEach((M) => {
        T[M] = C[M];
      });
      const A = Ce.toFiniteNumber(C.headers.get("content-length")), [$, U] = u && zU(
        A,
        N3(jU(u), !0)
      ) || [];
      C = new Response(
        HU(C.body, FU, $, () => {
          U && U(), E && E();
        }),
        T
      );
    }
    d = d || "text";
    let S = await $3[Ce.findKey($3, d) || "text"](C, e);
    return !I && E && E(), await new Promise((T, A) => {
      ND(T, A, {
        data: S,
        headers: Pa.from(C.headers),
        status: C.status,
        statusText: C.statusText,
        config: e,
        request: w
      });
    });
  } catch (O) {
    throw E && E(), O && O.name === "TypeError" && /fetch/i.test(O.message) ? Object.assign(
      new dr("Network Error", dr.ERR_NETWORK, e, w),
      {
        cause: O.cause || O
      }
    ) : dr.from(O, O && O.code, e, w);
  }
}), fO = {
  http: r0e,
  xhr: B0e,
  fetch: F0e
};
Ce.forEach(fO, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const MU = (e) => `- ${e}`, M0e = (e) => Ce.isFunction(e) || e === null || e === !1, jD = {
  getAdapter: (e) => {
    e = Ce.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    const o = {};
    for (let i = 0; i < t; i++) {
      r = e[i];
      let a;
      if (n = r, !M0e(r) && (n = fO[(a = String(r)).toLowerCase()], n === void 0))
        throw new dr(`Unknown adapter '${a}'`);
      if (n)
        break;
      o[a || "#" + i] = n;
    }
    if (!n) {
      const i = Object.entries(o).map(
        ([u, l]) => `adapter ${u} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = t ? i.length > 1 ? `since :
` + i.map(MU).join(`
`) : " " + MU(i[0]) : "as no adapter specified";
      throw new dr(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: fO
};
function iT(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Ag(null, e);
}
function DU(e) {
  return iT(e), e.headers = Pa.from(e.headers), e.data = oT.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), jD.getAdapter(e.adapter || B2.adapter)(e).then(function(t) {
    return iT(e), t.data = oT.call(
      e,
      e.transformResponse,
      t
    ), t.headers = Pa.from(t.headers), t;
  }, function(t) {
    return BD(t) || (iT(e), t && t.response && (t.response.data = oT.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = Pa.from(t.response.headers))), Promise.reject(t);
  });
}
const LD = "1.8.4", g4 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  g4[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const KU = {};
g4.transitional = function(e, t, r) {
  function n(o, i) {
    return "[Axios v" + LD + "] Transitional option '" + o + "'" + i + (r ? ". " + r : "");
  }
  return (o, i, a) => {
    if (e === !1)
      throw new dr(
        n(i, " has been removed" + (t ? " in " + t : "")),
        dr.ERR_DEPRECATED
      );
    return t && !KU[i] && (KU[i] = !0, console.warn(
      n(
        i,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(o, i, a) : !0;
  };
};
g4.spelling = function(e) {
  return (t, r) => (console.warn(`${r} is likely a misspelling of ${e}`), !0);
};
function D0e(e, t, r) {
  if (typeof e != "object")
    throw new dr("options must be an object", dr.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let o = n.length;
  for (; o-- > 0; ) {
    const i = n[o], a = t[i];
    if (a) {
      const u = e[i], l = u === void 0 || a(u, i, e);
      if (l !== !0)
        throw new dr("option " + i + " must be " + l, dr.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new dr("Unknown option " + i, dr.ERR_BAD_OPTION);
  }
}
const L8 = {
  assertOptions: D0e,
  validators: g4
}, ac = L8.validators;
let Vp = class {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new UU(),
      response: new UU()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (n) {
      if (n instanceof Error) {
        let o = {};
        Error.captureStackTrace ? Error.captureStackTrace(o) : o = new Error();
        const i = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? i && !String(n.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + i) : n.stack = i;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = i0(this.defaults, r);
    const { transitional: n, paramsSerializer: o, headers: i } = r;
    n !== void 0 && L8.assertOptions(n, {
      silentJSONParsing: ac.transitional(ac.boolean),
      forcedJSONParsing: ac.transitional(ac.boolean),
      clarifyTimeoutError: ac.transitional(ac.boolean)
    }, !1), o != null && (Ce.isFunction(o) ? r.paramsSerializer = {
      serialize: o
    } : L8.assertOptions(o, {
      encode: ac.function,
      serialize: ac.function
    }, !0)), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), L8.assertOptions(r, {
      baseUrl: ac.spelling("baseURL"),
      withXsrfToken: ac.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let a = i && Ce.merge(
      i.common,
      i[r.method]
    );
    i && Ce.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (w) => {
        delete i[w];
      }
    ), r.headers = Pa.concat(a, i);
    const u = [];
    let l = !0;
    this.interceptors.request.forEach(function(w) {
      typeof w.runWhen == "function" && w.runWhen(r) === !1 || (l = l && w.synchronous, u.unshift(w.fulfilled, w.rejected));
    });
    const d = [];
    this.interceptors.response.forEach(function(w) {
      d.push(w.fulfilled, w.rejected);
    });
    let f, h = 0, g;
    if (!l) {
      const w = [DU.bind(this), void 0];
      for (w.unshift.apply(w, u), w.push.apply(w, d), g = w.length, f = Promise.resolve(r); h < g; )
        f = f.then(w[h++], w[h++]);
      return f;
    }
    g = u.length;
    let b = r;
    for (h = 0; h < g; ) {
      const w = u[h++], E = u[h++];
      try {
        b = w(b);
      } catch (_) {
        E.call(this, _);
        break;
      }
    }
    try {
      f = DU.call(this, b);
    } catch (w) {
      return Promise.reject(w);
    }
    for (h = 0, g = d.length; h < g; )
      f = f.then(d[h++], d[h++]);
    return f;
  }
  getUri(t) {
    t = i0(this.defaults, t);
    const r = $D(t.baseURL, t.url, t.allowAbsoluteUrls);
    return OD(r, t.params, t.paramsSerializer);
  }
};
Ce.forEach(["delete", "get", "head", "options"], function(e) {
  Vp.prototype[e] = function(t, r) {
    return this.request(i0(r || {}, {
      method: e,
      url: t,
      data: (r || {}).data
    }));
  };
});
Ce.forEach(["post", "put", "patch"], function(e) {
  function t(r) {
    return function(n, o, i) {
      return this.request(i0(i || {}, {
        method: e,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: n,
        data: o
      }));
    };
  }
  Vp.prototype[e] = t(), Vp.prototype[e + "Form"] = t(!0);
});
let K0e = class HD {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const n = this;
    this.promise.then((o) => {
      if (!n._listeners) return;
      let i = n._listeners.length;
      for (; i-- > 0; )
        n._listeners[i](o);
      n._listeners = null;
    }), this.promise.then = (o) => {
      let i;
      const a = new Promise((u) => {
        n.subscribe(u), i = u;
      }).then(o);
      return a.cancel = function() {
        n.unsubscribe(i);
      }, a;
    }, t(function(o, i, a) {
      n.reason || (n.reason = new Ag(o, i, a), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (n) => {
      t.abort(n);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new HD(function(r) {
        t = r;
      }),
      cancel: t
    };
  }
};
function q0e(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function V0e(e) {
  return Ce.isObject(e) && e.isAxiosError === !0;
}
const dO = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(dO).forEach(([e, t]) => {
  dO[t] = e;
});
function FD(e) {
  const t = new Vp(e), r = bD(Vp.prototype.request, t);
  return Ce.extend(r, Vp.prototype, t, { allOwnKeys: !0 }), Ce.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(n) {
    return FD(i0(e, n));
  }, r;
}
const sn = FD(B2);
sn.Axios = Vp;
sn.CanceledError = Ag;
sn.CancelToken = K0e;
sn.isCancel = BD;
sn.VERSION = LD;
sn.toFormData = h4;
sn.AxiosError = dr;
sn.Cancel = sn.CanceledError;
sn.all = function(e) {
  return Promise.all(e);
};
sn.spread = q0e;
sn.isAxiosError = V0e;
sn.mergeConfig = i0;
sn.AxiosHeaders = Pa;
sn.formToJSON = (e) => CD(Ce.isHTMLForm(e) ? new FormData(e) : e);
sn.getAdapter = jD.getAdapter;
sn.HttpStatusCode = dO;
sn.default = sn;
const {
  Axios: CUe,
  AxiosError: BUe,
  CanceledError: NUe,
  isCancel: $Ue,
  CancelToken: UUe,
  VERSION: RUe,
  all: zUe,
  Cancel: jUe,
  isAxiosError: LUe,
  spread: HUe,
  toFormData: FUe,
  AxiosHeaders: MUe,
  HttpStatusCode: DUe,
  formToJSON: KUe,
  getAdapter: qUe,
  mergeConfig: VUe
} = sn, JC = "https://mainnet.sandshrew.io/v1/", tw = "lasereyes", G0e = "VIOi9IApvUkDFWBQ7I9oHsfUMWOIfDeO", W0e = "bVG4GSXShooC9f67hq5YQWAJfZyRPrEN", Z0e = "https://xbt-mainnet.gomaestro-api.org/v0", X0e = "https://xbt-testnet.gomaestro-api.org/v0", Y0e = "https://mempool.space", J0e = "https://mempool.space/testnet", Q0e = "https://mempool.space/testnet4", e1e = "https://mempool.space/signet", t1e = "https://mempool.fractalbitcoin.io", r1e = "https://mempool-testnet.fractalbitcoin.io", n1e = "https://static.unisat.io/content", qU = "https://static-testnet.unisat.io/content", o1e = "https://ordinals-testnet4.unisat.io/content", i1e = "https://ordinals.fractalbitcoin.io/content", a1e = "https://ordinals-testnet.fractalbitcoin.io/content", s1e = "https://static.unisat.io/preview", VU = "https://static-testnet.unisat.io/preview", u1e = "https://ordinals-testnet4.unisat.io/preview", c1e = "https://ordinals.fractalbitcoin.io/preview", l1e = "https://ordinals-testnet.fractalbitcoin.io/preview", N2 = (e) => e === aa ? J0e : e === ka ? Q0e : e === Ls ? e1e : e === th ? t1e : e === as ? r1e : Y0e, f1e = (e) => e === ka ? X0e : Z0e, d1e = (e) => e === aa ? qU : e === ka ? o1e : e === Ls ? qU : e === th ? i1e : e === as ? a1e : n1e, h1e = (e) => e === aa ? VU : e === ka ? u1e : e === Ls ? VU : e === th ? c1e : e === as ? l1e : s1e;
var Bc = {}, Qo = {}, or = {};
Object.defineProperty(or, "__esModule", { value: !0 });
or.add5L = or.add5H = or.add4H = or.add4L = or.add3H = or.add3L = or.rotlBL = or.rotlBH = or.rotlSL = or.rotlSH = or.rotr32L = or.rotr32H = or.rotrBL = or.rotrBH = or.rotrSL = or.rotrSH = or.shrSL = or.shrSH = or.toBig = void 0;
or.fromBig = QC;
or.split = MD;
or.add = rK;
const Mv = /* @__PURE__ */ BigInt(2 ** 32 - 1), hO = /* @__PURE__ */ BigInt(32);
function QC(e, t = !1) {
  return t ? { h: Number(e & Mv), l: Number(e >> hO & Mv) } : { h: Number(e >> hO & Mv) | 0, l: Number(e & Mv) | 0 };
}
function MD(e, t = !1) {
  let r = new Uint32Array(e.length), n = new Uint32Array(e.length);
  for (let o = 0; o < e.length; o++) {
    const { h: i, l: a } = QC(e[o], t);
    [r[o], n[o]] = [i, a];
  }
  return [r, n];
}
const DD = (e, t) => BigInt(e >>> 0) << hO | BigInt(t >>> 0);
or.toBig = DD;
const KD = (e, t, r) => e >>> r;
or.shrSH = KD;
const qD = (e, t, r) => e << 32 - r | t >>> r;
or.shrSL = qD;
const VD = (e, t, r) => e >>> r | t << 32 - r;
or.rotrSH = VD;
const GD = (e, t, r) => e << 32 - r | t >>> r;
or.rotrSL = GD;
const WD = (e, t, r) => e << 64 - r | t >>> r - 32;
or.rotrBH = WD;
const ZD = (e, t, r) => e >>> r - 32 | t << 64 - r;
or.rotrBL = ZD;
const XD = (e, t) => t;
or.rotr32H = XD;
const YD = (e, t) => e;
or.rotr32L = YD;
const JD = (e, t, r) => e << r | t >>> 32 - r;
or.rotlSH = JD;
const QD = (e, t, r) => t << r | e >>> 32 - r;
or.rotlSL = QD;
const eK = (e, t, r) => t << r - 32 | e >>> 64 - r;
or.rotlBH = eK;
const tK = (e, t, r) => e << r - 32 | t >>> 64 - r;
or.rotlBL = tK;
function rK(e, t, r, n) {
  const o = (t >>> 0) + (n >>> 0);
  return { h: e + r + (o / 2 ** 32 | 0) | 0, l: o | 0 };
}
const nK = (e, t, r) => (e >>> 0) + (t >>> 0) + (r >>> 0);
or.add3L = nK;
const oK = (e, t, r, n) => t + r + n + (e / 2 ** 32 | 0) | 0;
or.add3H = oK;
const iK = (e, t, r, n) => (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0);
or.add4L = iK;
const aK = (e, t, r, n, o) => t + r + n + o + (e / 2 ** 32 | 0) | 0;
or.add4H = aK;
const sK = (e, t, r, n, o) => (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0) + (o >>> 0);
or.add5L = sK;
const uK = (e, t, r, n, o, i) => t + r + n + o + i + (e / 2 ** 32 | 0) | 0;
or.add5H = uK;
const p1e = {
  fromBig: QC,
  split: MD,
  toBig: DD,
  shrSH: KD,
  shrSL: qD,
  rotrSH: VD,
  rotrSL: GD,
  rotrBH: WD,
  rotrBL: ZD,
  rotr32H: XD,
  rotr32L: YD,
  rotlSH: JD,
  rotlSL: QD,
  rotlBH: eK,
  rotlBL: tK,
  add: rK,
  add3L: nK,
  add3H: oK,
  add4L: iK,
  add4H: aK,
  add5H: uK,
  add5L: sK
};
or.default = p1e;
Object.defineProperty(Qo, "__esModule", { value: !0 });
Qo.sha384 = Qo.sha512_256 = Qo.sha512_224 = Qo.sha512 = Qo.SHA384 = Qo.SHA512_256 = Qo.SHA512_224 = Qo.SHA512 = void 0;
const g1e = Jd, xr = or, m4 = Ds, [m1e, y1e] = xr.default.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((e) => BigInt(e))), Kf = /* @__PURE__ */ new Uint32Array(80), qf = /* @__PURE__ */ new Uint32Array(80);
let $2 = class extends g1e.HashMD {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: t, Al: r, Bh: n, Bl: o, Ch: i, Cl: a, Dh: u, Dl: l, Eh: d, El: f, Fh: h, Fl: g, Gh: b, Gl: w, Hh: E, Hl: _ } = this;
    return [t, r, n, o, i, a, u, l, d, f, h, g, b, w, E, _];
  }
  // prettier-ignore
  set(t, r, n, o, i, a, u, l, d, f, h, g, b, w, E, _) {
    this.Ah = t | 0, this.Al = r | 0, this.Bh = n | 0, this.Bl = o | 0, this.Ch = i | 0, this.Cl = a | 0, this.Dh = u | 0, this.Dl = l | 0, this.Eh = d | 0, this.El = f | 0, this.Fh = h | 0, this.Fl = g | 0, this.Gh = b | 0, this.Gl = w | 0, this.Hh = E | 0, this.Hl = _ | 0;
  }
  process(t, r) {
    for (let I = 0; I < 16; I++, r += 4)
      Kf[I] = t.getUint32(r), qf[I] = t.getUint32(r += 4);
    for (let I = 16; I < 80; I++) {
      const S = Kf[I - 15] | 0, T = qf[I - 15] | 0, A = xr.default.rotrSH(S, T, 1) ^ xr.default.rotrSH(S, T, 8) ^ xr.default.shrSH(S, T, 7), $ = xr.default.rotrSL(S, T, 1) ^ xr.default.rotrSL(S, T, 8) ^ xr.default.shrSL(S, T, 7), U = Kf[I - 2] | 0, M = qf[I - 2] | 0, Y = xr.default.rotrSH(U, M, 19) ^ xr.default.rotrBH(U, M, 61) ^ xr.default.shrSH(U, M, 6), L = xr.default.rotrSL(U, M, 19) ^ xr.default.rotrBL(U, M, 61) ^ xr.default.shrSL(U, M, 6), ee = xr.default.add4L($, L, qf[I - 7], qf[I - 16]), de = xr.default.add4H(ee, A, Y, Kf[I - 7], Kf[I - 16]);
      Kf[I] = de | 0, qf[I] = ee | 0;
    }
    let { Ah: n, Al: o, Bh: i, Bl: a, Ch: u, Cl: l, Dh: d, Dl: f, Eh: h, El: g, Fh: b, Fl: w, Gh: E, Gl: _, Hh: O, Hl: C } = this;
    for (let I = 0; I < 80; I++) {
      const S = xr.default.rotrSH(h, g, 14) ^ xr.default.rotrSH(h, g, 18) ^ xr.default.rotrBH(h, g, 41), T = xr.default.rotrSL(h, g, 14) ^ xr.default.rotrSL(h, g, 18) ^ xr.default.rotrBL(h, g, 41), A = h & b ^ ~h & E, $ = g & w ^ ~g & _, U = xr.default.add5L(C, T, $, y1e[I], qf[I]), M = xr.default.add5H(U, O, S, A, m1e[I], Kf[I]), Y = U | 0, L = xr.default.rotrSH(n, o, 28) ^ xr.default.rotrBH(n, o, 34) ^ xr.default.rotrBH(n, o, 39), ee = xr.default.rotrSL(n, o, 28) ^ xr.default.rotrBL(n, o, 34) ^ xr.default.rotrBL(n, o, 39), de = n & i ^ n & u ^ i & u, ne = o & a ^ o & l ^ a & l;
      O = E | 0, C = _ | 0, E = b | 0, _ = w | 0, b = h | 0, w = g | 0, { h, l: g } = xr.default.add(d | 0, f | 0, M | 0, Y | 0), d = u | 0, f = l | 0, u = i | 0, l = a | 0, i = n | 0, a = o | 0;
      const D = xr.default.add3L(Y, ee, ne);
      n = xr.default.add3H(D, M, L, de), o = D | 0;
    }
    ({ h: n, l: o } = xr.default.add(this.Ah | 0, this.Al | 0, n | 0, o | 0)), { h: i, l: a } = xr.default.add(this.Bh | 0, this.Bl | 0, i | 0, a | 0), { h: u, l } = xr.default.add(this.Ch | 0, this.Cl | 0, u | 0, l | 0), { h: d, l: f } = xr.default.add(this.Dh | 0, this.Dl | 0, d | 0, f | 0), { h, l: g } = xr.default.add(this.Eh | 0, this.El | 0, h | 0, g | 0), { h: b, l: w } = xr.default.add(this.Fh | 0, this.Fl | 0, b | 0, w | 0), { h: E, l: _ } = xr.default.add(this.Gh | 0, this.Gl | 0, E | 0, _ | 0), { h: O, l: C } = xr.default.add(this.Hh | 0, this.Hl | 0, O | 0, C | 0), this.set(n, o, i, a, u, l, d, f, h, g, b, w, E, _, O, C);
  }
  roundClean() {
    Kf.fill(0), qf.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
};
Qo.SHA512 = $2;
class cK extends $2 {
  constructor() {
    super(), this.Ah = -1942145080, this.Al = 424955298, this.Bh = 1944164710, this.Bl = -1982016298, this.Ch = 502970286, this.Cl = 855612546, this.Dh = 1738396948, this.Dl = 1479516111, this.Eh = 258812777, this.El = 2077511080, this.Fh = 2011393907, this.Fl = 79989058, this.Gh = 1067287976, this.Gl = 1780299464, this.Hh = 286451373, this.Hl = -1848208735, this.outputLen = 28;
  }
}
Qo.SHA512_224 = cK;
class lK extends $2 {
  constructor() {
    super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
  }
}
Qo.SHA512_256 = lK;
class fK extends $2 {
  constructor() {
    super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
  }
}
Qo.SHA384 = fK;
Qo.sha512 = (0, m4.wrapConstructor)(() => new $2());
Qo.sha512_224 = (0, m4.wrapConstructor)(() => new cK());
Qo.sha512_256 = (0, m4.wrapConstructor)(() => new lK());
Qo.sha384 = (0, m4.wrapConstructor)(() => new fK());
var y4 = {};
Object.defineProperty(y4, "__esModule", { value: !0 });
y4.pbkdf2 = w1e;
y4.pbkdf2Async = v1e;
const Dv = Pc, b1e = v2, _1 = Ds;
function dK(e, t, r, n) {
  (0, Dv.ahash)(e);
  const o = (0, _1.checkOpts)({ dkLen: 32, asyncTick: 10 }, n), { c: i, dkLen: a, asyncTick: u } = o;
  if ((0, Dv.anumber)(i), (0, Dv.anumber)(a), (0, Dv.anumber)(u), i < 1)
    throw new Error("PBKDF2: iterations (c) should be >= 1");
  const l = (0, _1.toBytes)(t), d = (0, _1.toBytes)(r), f = new Uint8Array(a), h = b1e.hmac.create(e, l), g = h._cloneInto().update(d);
  return { c: i, dkLen: a, asyncTick: u, DK: f, PRF: h, PRFSalt: g };
}
function hK(e, t, r, n, o) {
  return e.destroy(), t.destroy(), n && n.destroy(), o.fill(0), r;
}
function w1e(e, t, r, n) {
  const { c: o, dkLen: i, DK: a, PRF: u, PRFSalt: l } = dK(e, t, r, n);
  let d;
  const f = new Uint8Array(4), h = (0, _1.createView)(f), g = new Uint8Array(u.outputLen);
  for (let b = 1, w = 0; w < i; b++, w += u.outputLen) {
    const E = a.subarray(w, w + u.outputLen);
    h.setInt32(0, b, !1), (d = l._cloneInto(d)).update(f).digestInto(g), E.set(g.subarray(0, E.length));
    for (let _ = 1; _ < o; _++) {
      u._cloneInto(d).update(g).digestInto(g);
      for (let O = 0; O < E.length; O++)
        E[O] ^= g[O];
    }
  }
  return hK(u, l, a, d, g);
}
async function v1e(e, t, r, n) {
  const { c: o, dkLen: i, asyncTick: a, DK: u, PRF: l, PRFSalt: d } = dK(e, t, r, n);
  let f;
  const h = new Uint8Array(4), g = (0, _1.createView)(h), b = new Uint8Array(l.outputLen);
  for (let w = 1, E = 0; E < i; w++, E += l.outputLen) {
    const _ = u.subarray(E, E + l.outputLen);
    g.setInt32(0, w, !1), (f = d._cloneInto(f)).update(h).digestInto(b), _.set(b.subarray(0, _.length)), await (0, _1.asyncLoop)(o - 1, a, () => {
      l._cloneInto(f).update(b).digestInto(b);
      for (let O = 0; O < _.length; O++)
        _[O] ^= b[O];
    });
  }
  return hK(l, d, u, f, b);
}
var ba = {};
const E1e = [
  "abdikace",
  "abeceda",
  "adresa",
  "agrese",
  "akce",
  "aktovka",
  "alej",
  "alkohol",
  "amputace",
  "ananas",
  "andulka",
  "anekdota",
  "anketa",
  "antika",
  "anulovat",
  "archa",
  "arogance",
  "asfalt",
  "asistent",
  "aspirace",
  "astma",
  "astronom",
  "atlas",
  "atletika",
  "atol",
  "autobus",
  "azyl",
  "babka",
  "bachor",
  "bacil",
  "baculka",
  "badatel",
  "bageta",
  "bagr",
  "bahno",
  "bakterie",
  "balada",
  "baletka",
  "balkon",
  "balonek",
  "balvan",
  "balza",
  "bambus",
  "bankomat",
  "barbar",
  "baret",
  "barman",
  "baroko",
  "barva",
  "baterka",
  "batoh",
  "bavlna",
  "bazalka",
  "bazilika",
  "bazuka",
  "bedna",
  "beran",
  "beseda",
  "bestie",
  "beton",
  "bezinka",
  "bezmoc",
  "beztak",
  "bicykl",
  "bidlo",
  "biftek",
  "bikiny",
  "bilance",
  "biograf",
  "biolog",
  "bitva",
  "bizon",
  "blahobyt",
  "blatouch",
  "blecha",
  "bledule",
  "blesk",
  "blikat",
  "blizna",
  "blokovat",
  "bloudit",
  "blud",
  "bobek",
  "bobr",
  "bodlina",
  "bodnout",
  "bohatost",
  "bojkot",
  "bojovat",
  "bokorys",
  "bolest",
  "borec",
  "borovice",
  "bota",
  "boubel",
  "bouchat",
  "bouda",
  "boule",
  "bourat",
  "boxer",
  "bradavka",
  "brambora",
  "branka",
  "bratr",
  "brepta",
  "briketa",
  "brko",
  "brloh",
  "bronz",
  "broskev",
  "brunetka",
  "brusinka",
  "brzda",
  "brzy",
  "bublina",
  "bubnovat",
  "buchta",
  "buditel",
  "budka",
  "budova",
  "bufet",
  "bujarost",
  "bukvice",
  "buldok",
  "bulva",
  "bunda",
  "bunkr",
  "burza",
  "butik",
  "buvol",
  "buzola",
  "bydlet",
  "bylina",
  "bytovka",
  "bzukot",
  "capart",
  "carevna",
  "cedr",
  "cedule",
  "cejch",
  "cejn",
  "cela",
  "celer",
  "celkem",
  "celnice",
  "cenina",
  "cennost",
  "cenovka",
  "centrum",
  "cenzor",
  "cestopis",
  "cetka",
  "chalupa",
  "chapadlo",
  "charita",
  "chata",
  "chechtat",
  "chemie",
  "chichot",
  "chirurg",
  "chlad",
  "chleba",
  "chlubit",
  "chmel",
  "chmura",
  "chobot",
  "chochol",
  "chodba",
  "cholera",
  "chomout",
  "chopit",
  "choroba",
  "chov",
  "chrapot",
  "chrlit",
  "chrt",
  "chrup",
  "chtivost",
  "chudina",
  "chutnat",
  "chvat",
  "chvilka",
  "chvost",
  "chyba",
  "chystat",
  "chytit",
  "cibule",
  "cigareta",
  "cihelna",
  "cihla",
  "cinkot",
  "cirkus",
  "cisterna",
  "citace",
  "citrus",
  "cizinec",
  "cizost",
  "clona",
  "cokoliv",
  "couvat",
  "ctitel",
  "ctnost",
  "cudnost",
  "cuketa",
  "cukr",
  "cupot",
  "cvaknout",
  "cval",
  "cvik",
  "cvrkot",
  "cyklista",
  "daleko",
  "dareba",
  "datel",
  "datum",
  "dcera",
  "debata",
  "dechovka",
  "decibel",
  "deficit",
  "deflace",
  "dekl",
  "dekret",
  "demokrat",
  "deprese",
  "derby",
  "deska",
  "detektiv",
  "dikobraz",
  "diktovat",
  "dioda",
  "diplom",
  "disk",
  "displej",
  "divadlo",
  "divoch",
  "dlaha",
  "dlouho",
  "dluhopis",
  "dnes",
  "dobro",
  "dobytek",
  "docent",
  "dochutit",
  "dodnes",
  "dohled",
  "dohoda",
  "dohra",
  "dojem",
  "dojnice",
  "doklad",
  "dokola",
  "doktor",
  "dokument",
  "dolar",
  "doleva",
  "dolina",
  "doma",
  "dominant",
  "domluvit",
  "domov",
  "donutit",
  "dopad",
  "dopis",
  "doplnit",
  "doposud",
  "doprovod",
  "dopustit",
  "dorazit",
  "dorost",
  "dort",
  "dosah",
  "doslov",
  "dostatek",
  "dosud",
  "dosyta",
  "dotaz",
  "dotek",
  "dotknout",
  "doufat",
  "doutnat",
  "dovozce",
  "dozadu",
  "doznat",
  "dozorce",
  "drahota",
  "drak",
  "dramatik",
  "dravec",
  "draze",
  "drdol",
  "drobnost",
  "drogerie",
  "drozd",
  "drsnost",
  "drtit",
  "drzost",
  "duben",
  "duchovno",
  "dudek",
  "duha",
  "duhovka",
  "dusit",
  "dusno",
  "dutost",
  "dvojice",
  "dvorec",
  "dynamit",
  "ekolog",
  "ekonomie",
  "elektron",
  "elipsa",
  "email",
  "emise",
  "emoce",
  "empatie",
  "epizoda",
  "epocha",
  "epopej",
  "epos",
  "esej",
  "esence",
  "eskorta",
  "eskymo",
  "etiketa",
  "euforie",
  "evoluce",
  "exekuce",
  "exkurze",
  "expedice",
  "exploze",
  "export",
  "extrakt",
  "facka",
  "fajfka",
  "fakulta",
  "fanatik",
  "fantazie",
  "farmacie",
  "favorit",
  "fazole",
  "federace",
  "fejeton",
  "fenka",
  "fialka",
  "figurant",
  "filozof",
  "filtr",
  "finance",
  "finta",
  "fixace",
  "fjord",
  "flanel",
  "flirt",
  "flotila",
  "fond",
  "fosfor",
  "fotbal",
  "fotka",
  "foton",
  "frakce",
  "freska",
  "fronta",
  "fukar",
  "funkce",
  "fyzika",
  "galeje",
  "garant",
  "genetika",
  "geolog",
  "gilotina",
  "glazura",
  "glejt",
  "golem",
  "golfista",
  "gotika",
  "graf",
  "gramofon",
  "granule",
  "grep",
  "gril",
  "grog",
  "groteska",
  "guma",
  "hadice",
  "hadr",
  "hala",
  "halenka",
  "hanba",
  "hanopis",
  "harfa",
  "harpuna",
  "havran",
  "hebkost",
  "hejkal",
  "hejno",
  "hejtman",
  "hektar",
  "helma",
  "hematom",
  "herec",
  "herna",
  "heslo",
  "hezky",
  "historik",
  "hladovka",
  "hlasivky",
  "hlava",
  "hledat",
  "hlen",
  "hlodavec",
  "hloh",
  "hloupost",
  "hltat",
  "hlubina",
  "hluchota",
  "hmat",
  "hmota",
  "hmyz",
  "hnis",
  "hnojivo",
  "hnout",
  "hoblina",
  "hoboj",
  "hoch",
  "hodiny",
  "hodlat",
  "hodnota",
  "hodovat",
  "hojnost",
  "hokej",
  "holinka",
  "holka",
  "holub",
  "homole",
  "honitba",
  "honorace",
  "horal",
  "horda",
  "horizont",
  "horko",
  "horlivec",
  "hormon",
  "hornina",
  "horoskop",
  "horstvo",
  "hospoda",
  "hostina",
  "hotovost",
  "houba",
  "houf",
  "houpat",
  "houska",
  "hovor",
  "hradba",
  "hranice",
  "hravost",
  "hrazda",
  "hrbolek",
  "hrdina",
  "hrdlo",
  "hrdost",
  "hrnek",
  "hrobka",
  "hromada",
  "hrot",
  "hrouda",
  "hrozen",
  "hrstka",
  "hrubost",
  "hryzat",
  "hubenost",
  "hubnout",
  "hudba",
  "hukot",
  "humr",
  "husita",
  "hustota",
  "hvozd",
  "hybnost",
  "hydrant",
  "hygiena",
  "hymna",
  "hysterik",
  "idylka",
  "ihned",
  "ikona",
  "iluze",
  "imunita",
  "infekce",
  "inflace",
  "inkaso",
  "inovace",
  "inspekce",
  "internet",
  "invalida",
  "investor",
  "inzerce",
  "ironie",
  "jablko",
  "jachta",
  "jahoda",
  "jakmile",
  "jakost",
  "jalovec",
  "jantar",
  "jarmark",
  "jaro",
  "jasan",
  "jasno",
  "jatka",
  "javor",
  "jazyk",
  "jedinec",
  "jedle",
  "jednatel",
  "jehlan",
  "jekot",
  "jelen",
  "jelito",
  "jemnost",
  "jenom",
  "jepice",
  "jeseter",
  "jevit",
  "jezdec",
  "jezero",
  "jinak",
  "jindy",
  "jinoch",
  "jiskra",
  "jistota",
  "jitrnice",
  "jizva",
  "jmenovat",
  "jogurt",
  "jurta",
  "kabaret",
  "kabel",
  "kabinet",
  "kachna",
  "kadet",
  "kadidlo",
  "kahan",
  "kajak",
  "kajuta",
  "kakao",
  "kaktus",
  "kalamita",
  "kalhoty",
  "kalibr",
  "kalnost",
  "kamera",
  "kamkoliv",
  "kamna",
  "kanibal",
  "kanoe",
  "kantor",
  "kapalina",
  "kapela",
  "kapitola",
  "kapka",
  "kaple",
  "kapota",
  "kapr",
  "kapusta",
  "kapybara",
  "karamel",
  "karotka",
  "karton",
  "kasa",
  "katalog",
  "katedra",
  "kauce",
  "kauza",
  "kavalec",
  "kazajka",
  "kazeta",
  "kazivost",
  "kdekoliv",
  "kdesi",
  "kedluben",
  "kemp",
  "keramika",
  "kino",
  "klacek",
  "kladivo",
  "klam",
  "klapot",
  "klasika",
  "klaun",
  "klec",
  "klenba",
  "klepat",
  "klesnout",
  "klid",
  "klima",
  "klisna",
  "klobouk",
  "klokan",
  "klopa",
  "kloub",
  "klubovna",
  "klusat",
  "kluzkost",
  "kmen",
  "kmitat",
  "kmotr",
  "kniha",
  "knot",
  "koalice",
  "koberec",
  "kobka",
  "kobliha",
  "kobyla",
  "kocour",
  "kohout",
  "kojenec",
  "kokos",
  "koktejl",
  "kolaps",
  "koleda",
  "kolize",
  "kolo",
  "komando",
  "kometa",
  "komik",
  "komnata",
  "komora",
  "kompas",
  "komunita",
  "konat",
  "koncept",
  "kondice",
  "konec",
  "konfese",
  "kongres",
  "konina",
  "konkurs",
  "kontakt",
  "konzerva",
  "kopanec",
  "kopie",
  "kopnout",
  "koprovka",
  "korbel",
  "korektor",
  "kormidlo",
  "koroptev",
  "korpus",
  "koruna",
  "koryto",
  "korzet",
  "kosatec",
  "kostka",
  "kotel",
  "kotleta",
  "kotoul",
  "koukat",
  "koupelna",
  "kousek",
  "kouzlo",
  "kovboj",
  "koza",
  "kozoroh",
  "krabice",
  "krach",
  "krajina",
  "kralovat",
  "krasopis",
  "kravata",
  "kredit",
  "krejcar",
  "kresba",
  "kreveta",
  "kriket",
  "kritik",
  "krize",
  "krkavec",
  "krmelec",
  "krmivo",
  "krocan",
  "krok",
  "kronika",
  "kropit",
  "kroupa",
  "krovka",
  "krtek",
  "kruhadlo",
  "krupice",
  "krutost",
  "krvinka",
  "krychle",
  "krypta",
  "krystal",
  "kryt",
  "kudlanka",
  "kufr",
  "kujnost",
  "kukla",
  "kulajda",
  "kulich",
  "kulka",
  "kulomet",
  "kultura",
  "kuna",
  "kupodivu",
  "kurt",
  "kurzor",
  "kutil",
  "kvalita",
  "kvasinka",
  "kvestor",
  "kynolog",
  "kyselina",
  "kytara",
  "kytice",
  "kytka",
  "kytovec",
  "kyvadlo",
  "labrador",
  "lachtan",
  "ladnost",
  "laik",
  "lakomec",
  "lamela",
  "lampa",
  "lanovka",
  "lasice",
  "laso",
  "lastura",
  "latinka",
  "lavina",
  "lebka",
  "leckdy",
  "leden",
  "lednice",
  "ledovka",
  "ledvina",
  "legenda",
  "legie",
  "legrace",
  "lehce",
  "lehkost",
  "lehnout",
  "lektvar",
  "lenochod",
  "lentilka",
  "lepenka",
  "lepidlo",
  "letadlo",
  "letec",
  "letmo",
  "letokruh",
  "levhart",
  "levitace",
  "levobok",
  "libra",
  "lichotka",
  "lidojed",
  "lidskost",
  "lihovina",
  "lijavec",
  "lilek",
  "limetka",
  "linie",
  "linka",
  "linoleum",
  "listopad",
  "litina",
  "litovat",
  "lobista",
  "lodivod",
  "logika",
  "logoped",
  "lokalita",
  "loket",
  "lomcovat",
  "lopata",
  "lopuch",
  "lord",
  "losos",
  "lotr",
  "loudal",
  "louh",
  "louka",
  "louskat",
  "lovec",
  "lstivost",
  "lucerna",
  "lucifer",
  "lump",
  "lusk",
  "lustrace",
  "lvice",
  "lyra",
  "lyrika",
  "lysina",
  "madam",
  "madlo",
  "magistr",
  "mahagon",
  "majetek",
  "majitel",
  "majorita",
  "makak",
  "makovice",
  "makrela",
  "malba",
  "malina",
  "malovat",
  "malvice",
  "maminka",
  "mandle",
  "manko",
  "marnost",
  "masakr",
  "maskot",
  "masopust",
  "matice",
  "matrika",
  "maturita",
  "mazanec",
  "mazivo",
  "mazlit",
  "mazurka",
  "mdloba",
  "mechanik",
  "meditace",
  "medovina",
  "melasa",
  "meloun",
  "mentolka",
  "metla",
  "metoda",
  "metr",
  "mezera",
  "migrace",
  "mihnout",
  "mihule",
  "mikina",
  "mikrofon",
  "milenec",
  "milimetr",
  "milost",
  "mimika",
  "mincovna",
  "minibar",
  "minomet",
  "minulost",
  "miska",
  "mistr",
  "mixovat",
  "mladost",
  "mlha",
  "mlhovina",
  "mlok",
  "mlsat",
  "mluvit",
  "mnich",
  "mnohem",
  "mobil",
  "mocnost",
  "modelka",
  "modlitba",
  "mohyla",
  "mokro",
  "molekula",
  "momentka",
  "monarcha",
  "monokl",
  "monstrum",
  "montovat",
  "monzun",
  "mosaz",
  "moskyt",
  "most",
  "motivace",
  "motorka",
  "motyka",
  "moucha",
  "moudrost",
  "mozaika",
  "mozek",
  "mozol",
  "mramor",
  "mravenec",
  "mrkev",
  "mrtvola",
  "mrzet",
  "mrzutost",
  "mstitel",
  "mudrc",
  "muflon",
  "mulat",
  "mumie",
  "munice",
  "muset",
  "mutace",
  "muzeum",
  "muzikant",
  "myslivec",
  "mzda",
  "nabourat",
  "nachytat",
  "nadace",
  "nadbytek",
  "nadhoz",
  "nadobro",
  "nadpis",
  "nahlas",
  "nahnat",
  "nahodile",
  "nahradit",
  "naivita",
  "najednou",
  "najisto",
  "najmout",
  "naklonit",
  "nakonec",
  "nakrmit",
  "nalevo",
  "namazat",
  "namluvit",
  "nanometr",
  "naoko",
  "naopak",
  "naostro",
  "napadat",
  "napevno",
  "naplnit",
  "napnout",
  "naposled",
  "naprosto",
  "narodit",
  "naruby",
  "narychlo",
  "nasadit",
  "nasekat",
  "naslepo",
  "nastat",
  "natolik",
  "navenek",
  "navrch",
  "navzdory",
  "nazvat",
  "nebe",
  "nechat",
  "necky",
  "nedaleko",
  "nedbat",
  "neduh",
  "negace",
  "nehet",
  "nehoda",
  "nejen",
  "nejprve",
  "neklid",
  "nelibost",
  "nemilost",
  "nemoc",
  "neochota",
  "neonka",
  "nepokoj",
  "nerost",
  "nerv",
  "nesmysl",
  "nesoulad",
  "netvor",
  "neuron",
  "nevina",
  "nezvykle",
  "nicota",
  "nijak",
  "nikam",
  "nikdy",
  "nikl",
  "nikterak",
  "nitro",
  "nocleh",
  "nohavice",
  "nominace",
  "nora",
  "norek",
  "nositel",
  "nosnost",
  "nouze",
  "noviny",
  "novota",
  "nozdra",
  "nuda",
  "nudle",
  "nuget",
  "nutit",
  "nutnost",
  "nutrie",
  "nymfa",
  "obal",
  "obarvit",
  "obava",
  "obdiv",
  "obec",
  "obehnat",
  "obejmout",
  "obezita",
  "obhajoba",
  "obilnice",
  "objasnit",
  "objekt",
  "obklopit",
  "oblast",
  "oblek",
  "obliba",
  "obloha",
  "obluda",
  "obnos",
  "obohatit",
  "obojek",
  "obout",
  "obrazec",
  "obrna",
  "obruba",
  "obrys",
  "obsah",
  "obsluha",
  "obstarat",
  "obuv",
  "obvaz",
  "obvinit",
  "obvod",
  "obvykle",
  "obyvatel",
  "obzor",
  "ocas",
  "ocel",
  "ocenit",
  "ochladit",
  "ochota",
  "ochrana",
  "ocitnout",
  "odboj",
  "odbyt",
  "odchod",
  "odcizit",
  "odebrat",
  "odeslat",
  "odevzdat",
  "odezva",
  "odhadce",
  "odhodit",
  "odjet",
  "odjinud",
  "odkaz",
  "odkoupit",
  "odliv",
  "odluka",
  "odmlka",
  "odolnost",
  "odpad",
  "odpis",
  "odplout",
  "odpor",
  "odpustit",
  "odpykat",
  "odrazka",
  "odsoudit",
  "odstup",
  "odsun",
  "odtok",
  "odtud",
  "odvaha",
  "odveta",
  "odvolat",
  "odvracet",
  "odznak",
  "ofina",
  "ofsajd",
  "ohlas",
  "ohnisko",
  "ohrada",
  "ohrozit",
  "ohryzek",
  "okap",
  "okenice",
  "oklika",
  "okno",
  "okouzlit",
  "okovy",
  "okrasa",
  "okres",
  "okrsek",
  "okruh",
  "okupant",
  "okurka",
  "okusit",
  "olejnina",
  "olizovat",
  "omak",
  "omeleta",
  "omezit",
  "omladina",
  "omlouvat",
  "omluva",
  "omyl",
  "onehdy",
  "opakovat",
  "opasek",
  "operace",
  "opice",
  "opilost",
  "opisovat",
  "opora",
  "opozice",
  "opravdu",
  "oproti",
  "orbital",
  "orchestr",
  "orgie",
  "orlice",
  "orloj",
  "ortel",
  "osada",
  "oschnout",
  "osika",
  "osivo",
  "oslava",
  "oslepit",
  "oslnit",
  "oslovit",
  "osnova",
  "osoba",
  "osolit",
  "ospalec",
  "osten",
  "ostraha",
  "ostuda",
  "ostych",
  "osvojit",
  "oteplit",
  "otisk",
  "otop",
  "otrhat",
  "otrlost",
  "otrok",
  "otruby",
  "otvor",
  "ovanout",
  "ovar",
  "oves",
  "ovlivnit",
  "ovoce",
  "oxid",
  "ozdoba",
  "pachatel",
  "pacient",
  "padouch",
  "pahorek",
  "pakt",
  "palanda",
  "palec",
  "palivo",
  "paluba",
  "pamflet",
  "pamlsek",
  "panenka",
  "panika",
  "panna",
  "panovat",
  "panstvo",
  "pantofle",
  "paprika",
  "parketa",
  "parodie",
  "parta",
  "paruka",
  "paryba",
  "paseka",
  "pasivita",
  "pastelka",
  "patent",
  "patrona",
  "pavouk",
  "pazneht",
  "pazourek",
  "pecka",
  "pedagog",
  "pejsek",
  "peklo",
  "peloton",
  "penalta",
  "pendrek",
  "penze",
  "periskop",
  "pero",
  "pestrost",
  "petarda",
  "petice",
  "petrolej",
  "pevnina",
  "pexeso",
  "pianista",
  "piha",
  "pijavice",
  "pikle",
  "piknik",
  "pilina",
  "pilnost",
  "pilulka",
  "pinzeta",
  "pipeta",
  "pisatel",
  "pistole",
  "pitevna",
  "pivnice",
  "pivovar",
  "placenta",
  "plakat",
  "plamen",
  "planeta",
  "plastika",
  "platit",
  "plavidlo",
  "plaz",
  "plech",
  "plemeno",
  "plenta",
  "ples",
  "pletivo",
  "plevel",
  "plivat",
  "plnit",
  "plno",
  "plocha",
  "plodina",
  "plomba",
  "plout",
  "pluk",
  "plyn",
  "pobavit",
  "pobyt",
  "pochod",
  "pocit",
  "poctivec",
  "podat",
  "podcenit",
  "podepsat",
  "podhled",
  "podivit",
  "podklad",
  "podmanit",
  "podnik",
  "podoba",
  "podpora",
  "podraz",
  "podstata",
  "podvod",
  "podzim",
  "poezie",
  "pohanka",
  "pohnutka",
  "pohovor",
  "pohroma",
  "pohyb",
  "pointa",
  "pojistka",
  "pojmout",
  "pokazit",
  "pokles",
  "pokoj",
  "pokrok",
  "pokuta",
  "pokyn",
  "poledne",
  "polibek",
  "polknout",
  "poloha",
  "polynom",
  "pomalu",
  "pominout",
  "pomlka",
  "pomoc",
  "pomsta",
  "pomyslet",
  "ponechat",
  "ponorka",
  "ponurost",
  "popadat",
  "popel",
  "popisek",
  "poplach",
  "poprosit",
  "popsat",
  "popud",
  "poradce",
  "porce",
  "porod",
  "porucha",
  "poryv",
  "posadit",
  "posed",
  "posila",
  "poskok",
  "poslanec",
  "posoudit",
  "pospolu",
  "postava",
  "posudek",
  "posyp",
  "potah",
  "potkan",
  "potlesk",
  "potomek",
  "potrava",
  "potupa",
  "potvora",
  "poukaz",
  "pouto",
  "pouzdro",
  "povaha",
  "povidla",
  "povlak",
  "povoz",
  "povrch",
  "povstat",
  "povyk",
  "povzdech",
  "pozdrav",
  "pozemek",
  "poznatek",
  "pozor",
  "pozvat",
  "pracovat",
  "prahory",
  "praktika",
  "prales",
  "praotec",
  "praporek",
  "prase",
  "pravda",
  "princip",
  "prkno",
  "probudit",
  "procento",
  "prodej",
  "profese",
  "prohra",
  "projekt",
  "prolomit",
  "promile",
  "pronikat",
  "propad",
  "prorok",
  "prosba",
  "proton",
  "proutek",
  "provaz",
  "prskavka",
  "prsten",
  "prudkost",
  "prut",
  "prvek",
  "prvohory",
  "psanec",
  "psovod",
  "pstruh",
  "ptactvo",
  "puberta",
  "puch",
  "pudl",
  "pukavec",
  "puklina",
  "pukrle",
  "pult",
  "pumpa",
  "punc",
  "pupen",
  "pusa",
  "pusinka",
  "pustina",
  "putovat",
  "putyka",
  "pyramida",
  "pysk",
  "pytel",
  "racek",
  "rachot",
  "radiace",
  "radnice",
  "radon",
  "raft",
  "ragby",
  "raketa",
  "rakovina",
  "rameno",
  "rampouch",
  "rande",
  "rarach",
  "rarita",
  "rasovna",
  "rastr",
  "ratolest",
  "razance",
  "razidlo",
  "reagovat",
  "reakce",
  "recept",
  "redaktor",
  "referent",
  "reflex",
  "rejnok",
  "reklama",
  "rekord",
  "rekrut",
  "rektor",
  "reputace",
  "revize",
  "revma",
  "revolver",
  "rezerva",
  "riskovat",
  "riziko",
  "robotika",
  "rodokmen",
  "rohovka",
  "rokle",
  "rokoko",
  "romaneto",
  "ropovod",
  "ropucha",
  "rorejs",
  "rosol",
  "rostlina",
  "rotmistr",
  "rotoped",
  "rotunda",
  "roubenka",
  "roucho",
  "roup",
  "roura",
  "rovina",
  "rovnice",
  "rozbor",
  "rozchod",
  "rozdat",
  "rozeznat",
  "rozhodce",
  "rozinka",
  "rozjezd",
  "rozkaz",
  "rozloha",
  "rozmar",
  "rozpad",
  "rozruch",
  "rozsah",
  "roztok",
  "rozum",
  "rozvod",
  "rubrika",
  "ruchadlo",
  "rukavice",
  "rukopis",
  "ryba",
  "rybolov",
  "rychlost",
  "rydlo",
  "rypadlo",
  "rytina",
  "ryzost",
  "sadista",
  "sahat",
  "sako",
  "samec",
  "samizdat",
  "samota",
  "sanitka",
  "sardinka",
  "sasanka",
  "satelit",
  "sazba",
  "sazenice",
  "sbor",
  "schovat",
  "sebranka",
  "secese",
  "sedadlo",
  "sediment",
  "sedlo",
  "sehnat",
  "sejmout",
  "sekera",
  "sekta",
  "sekunda",
  "sekvoje",
  "semeno",
  "seno",
  "servis",
  "sesadit",
  "seshora",
  "seskok",
  "seslat",
  "sestra",
  "sesuv",
  "sesypat",
  "setba",
  "setina",
  "setkat",
  "setnout",
  "setrvat",
  "sever",
  "seznam",
  "shoda",
  "shrnout",
  "sifon",
  "silnice",
  "sirka",
  "sirotek",
  "sirup",
  "situace",
  "skafandr",
  "skalisko",
  "skanzen",
  "skaut",
  "skeptik",
  "skica",
  "skladba",
  "sklenice",
  "sklo",
  "skluz",
  "skoba",
  "skokan",
  "skoro",
  "skripta",
  "skrz",
  "skupina",
  "skvost",
  "skvrna",
  "slabika",
  "sladidlo",
  "slanina",
  "slast",
  "slavnost",
  "sledovat",
  "slepec",
  "sleva",
  "slezina",
  "slib",
  "slina",
  "sliznice",
  "slon",
  "sloupek",
  "slovo",
  "sluch",
  "sluha",
  "slunce",
  "slupka",
  "slza",
  "smaragd",
  "smetana",
  "smilstvo",
  "smlouva",
  "smog",
  "smrad",
  "smrk",
  "smrtka",
  "smutek",
  "smysl",
  "snad",
  "snaha",
  "snob",
  "sobota",
  "socha",
  "sodovka",
  "sokol",
  "sopka",
  "sotva",
  "souboj",
  "soucit",
  "soudce",
  "souhlas",
  "soulad",
  "soumrak",
  "souprava",
  "soused",
  "soutok",
  "souviset",
  "spalovna",
  "spasitel",
  "spis",
  "splav",
  "spodek",
  "spojenec",
  "spolu",
  "sponzor",
  "spornost",
  "spousta",
  "sprcha",
  "spustit",
  "sranda",
  "sraz",
  "srdce",
  "srna",
  "srnec",
  "srovnat",
  "srpen",
  "srst",
  "srub",
  "stanice",
  "starosta",
  "statika",
  "stavba",
  "stehno",
  "stezka",
  "stodola",
  "stolek",
  "stopa",
  "storno",
  "stoupat",
  "strach",
  "stres",
  "strhnout",
  "strom",
  "struna",
  "studna",
  "stupnice",
  "stvol",
  "styk",
  "subjekt",
  "subtropy",
  "suchar",
  "sudost",
  "sukno",
  "sundat",
  "sunout",
  "surikata",
  "surovina",
  "svah",
  "svalstvo",
  "svetr",
  "svatba",
  "svazek",
  "svisle",
  "svitek",
  "svoboda",
  "svodidlo",
  "svorka",
  "svrab",
  "sykavka",
  "sykot",
  "synek",
  "synovec",
  "sypat",
  "sypkost",
  "syrovost",
  "sysel",
  "sytost",
  "tabletka",
  "tabule",
  "tahoun",
  "tajemno",
  "tajfun",
  "tajga",
  "tajit",
  "tajnost",
  "taktika",
  "tamhle",
  "tampon",
  "tancovat",
  "tanec",
  "tanker",
  "tapeta",
  "tavenina",
  "tazatel",
  "technika",
  "tehdy",
  "tekutina",
  "telefon",
  "temnota",
  "tendence",
  "tenista",
  "tenor",
  "teplota",
  "tepna",
  "teprve",
  "terapie",
  "termoska",
  "textil",
  "ticho",
  "tiskopis",
  "titulek",
  "tkadlec",
  "tkanina",
  "tlapka",
  "tleskat",
  "tlukot",
  "tlupa",
  "tmel",
  "toaleta",
  "topinka",
  "topol",
  "torzo",
  "touha",
  "toulec",
  "tradice",
  "traktor",
  "tramp",
  "trasa",
  "traverza",
  "trefit",
  "trest",
  "trezor",
  "trhavina",
  "trhlina",
  "trochu",
  "trojice",
  "troska",
  "trouba",
  "trpce",
  "trpitel",
  "trpkost",
  "trubec",
  "truchlit",
  "truhlice",
  "trus",
  "trvat",
  "tudy",
  "tuhnout",
  "tuhost",
  "tundra",
  "turista",
  "turnaj",
  "tuzemsko",
  "tvaroh",
  "tvorba",
  "tvrdost",
  "tvrz",
  "tygr",
  "tykev",
  "ubohost",
  "uboze",
  "ubrat",
  "ubrousek",
  "ubrus",
  "ubytovna",
  "ucho",
  "uctivost",
  "udivit",
  "uhradit",
  "ujednat",
  "ujistit",
  "ujmout",
  "ukazatel",
  "uklidnit",
  "uklonit",
  "ukotvit",
  "ukrojit",
  "ulice",
  "ulita",
  "ulovit",
  "umyvadlo",
  "unavit",
  "uniforma",
  "uniknout",
  "upadnout",
  "uplatnit",
  "uplynout",
  "upoutat",
  "upravit",
  "uran",
  "urazit",
  "usednout",
  "usilovat",
  "usmrtit",
  "usnadnit",
  "usnout",
  "usoudit",
  "ustlat",
  "ustrnout",
  "utahovat",
  "utkat",
  "utlumit",
  "utonout",
  "utopenec",
  "utrousit",
  "uvalit",
  "uvolnit",
  "uvozovka",
  "uzdravit",
  "uzel",
  "uzenina",
  "uzlina",
  "uznat",
  "vagon",
  "valcha",
  "valoun",
  "vana",
  "vandal",
  "vanilka",
  "varan",
  "varhany",
  "varovat",
  "vcelku",
  "vchod",
  "vdova",
  "vedro",
  "vegetace",
  "vejce",
  "velbloud",
  "veletrh",
  "velitel",
  "velmoc",
  "velryba",
  "venkov",
  "veranda",
  "verze",
  "veselka",
  "veskrze",
  "vesnice",
  "vespodu",
  "vesta",
  "veterina",
  "veverka",
  "vibrace",
  "vichr",
  "videohra",
  "vidina",
  "vidle",
  "vila",
  "vinice",
  "viset",
  "vitalita",
  "vize",
  "vizitka",
  "vjezd",
  "vklad",
  "vkus",
  "vlajka",
  "vlak",
  "vlasec",
  "vlevo",
  "vlhkost",
  "vliv",
  "vlnovka",
  "vloupat",
  "vnucovat",
  "vnuk",
  "voda",
  "vodivost",
  "vodoznak",
  "vodstvo",
  "vojensky",
  "vojna",
  "vojsko",
  "volant",
  "volba",
  "volit",
  "volno",
  "voskovka",
  "vozidlo",
  "vozovna",
  "vpravo",
  "vrabec",
  "vracet",
  "vrah",
  "vrata",
  "vrba",
  "vrcholek",
  "vrhat",
  "vrstva",
  "vrtule",
  "vsadit",
  "vstoupit",
  "vstup",
  "vtip",
  "vybavit",
  "vybrat",
  "vychovat",
  "vydat",
  "vydra",
  "vyfotit",
  "vyhledat",
  "vyhnout",
  "vyhodit",
  "vyhradit",
  "vyhubit",
  "vyjasnit",
  "vyjet",
  "vyjmout",
  "vyklopit",
  "vykonat",
  "vylekat",
  "vymazat",
  "vymezit",
  "vymizet",
  "vymyslet",
  "vynechat",
  "vynikat",
  "vynutit",
  "vypadat",
  "vyplatit",
  "vypravit",
  "vypustit",
  "vyrazit",
  "vyrovnat",
  "vyrvat",
  "vyslovit",
  "vysoko",
  "vystavit",
  "vysunout",
  "vysypat",
  "vytasit",
  "vytesat",
  "vytratit",
  "vyvinout",
  "vyvolat",
  "vyvrhel",
  "vyzdobit",
  "vyznat",
  "vzadu",
  "vzbudit",
  "vzchopit",
  "vzdor",
  "vzduch",
  "vzdychat",
  "vzestup",
  "vzhledem",
  "vzkaz",
  "vzlykat",
  "vznik",
  "vzorek",
  "vzpoura",
  "vztah",
  "vztek",
  "xylofon",
  "zabrat",
  "zabydlet",
  "zachovat",
  "zadarmo",
  "zadusit",
  "zafoukat",
  "zahltit",
  "zahodit",
  "zahrada",
  "zahynout",
  "zajatec",
  "zajet",
  "zajistit",
  "zaklepat",
  "zakoupit",
  "zalepit",
  "zamezit",
  "zamotat",
  "zamyslet",
  "zanechat",
  "zanikat",
  "zaplatit",
  "zapojit",
  "zapsat",
  "zarazit",
  "zastavit",
  "zasunout",
  "zatajit",
  "zatemnit",
  "zatknout",
  "zaujmout",
  "zavalit",
  "zavelet",
  "zavinit",
  "zavolat",
  "zavrtat",
  "zazvonit",
  "zbavit",
  "zbrusu",
  "zbudovat",
  "zbytek",
  "zdaleka",
  "zdarma",
  "zdatnost",
  "zdivo",
  "zdobit",
  "zdroj",
  "zdvih",
  "zdymadlo",
  "zelenina",
  "zeman",
  "zemina",
  "zeptat",
  "zezadu",
  "zezdola",
  "zhatit",
  "zhltnout",
  "zhluboka",
  "zhotovit",
  "zhruba",
  "zima",
  "zimnice",
  "zjemnit",
  "zklamat",
  "zkoumat",
  "zkratka",
  "zkumavka",
  "zlato",
  "zlehka",
  "zloba",
  "zlom",
  "zlost",
  "zlozvyk",
  "zmapovat",
  "zmar",
  "zmatek",
  "zmije",
  "zmizet",
  "zmocnit",
  "zmodrat",
  "zmrzlina",
  "zmutovat",
  "znak",
  "znalost",
  "znamenat",
  "znovu",
  "zobrazit",
  "zotavit",
  "zoubek",
  "zoufale",
  "zplodit",
  "zpomalit",
  "zprava",
  "zprostit",
  "zprudka",
  "zprvu",
  "zrada",
  "zranit",
  "zrcadlo",
  "zrnitost",
  "zrno",
  "zrovna",
  "zrychlit",
  "zrzavost",
  "zticha",
  "ztratit",
  "zubovina",
  "zubr",
  "zvednout",
  "zvenku",
  "zvesela",
  "zvon",
  "zvrat",
  "zvukovod",
  "zvyk"
], _1e = [
  "的",
  "一",
  "是",
  "在",
  "不",
  "了",
  "有",
  "和",
  "人",
  "这",
  "中",
  "大",
  "为",
  "上",
  "个",
  "国",
  "我",
  "以",
  "要",
  "他",
  "时",
  "来",
  "用",
  "们",
  "生",
  "到",
  "作",
  "地",
  "于",
  "出",
  "就",
  "分",
  "对",
  "成",
  "会",
  "可",
  "主",
  "发",
  "年",
  "动",
  "同",
  "工",
  "也",
  "能",
  "下",
  "过",
  "子",
  "说",
  "产",
  "种",
  "面",
  "而",
  "方",
  "后",
  "多",
  "定",
  "行",
  "学",
  "法",
  "所",
  "民",
  "得",
  "经",
  "十",
  "三",
  "之",
  "进",
  "着",
  "等",
  "部",
  "度",
  "家",
  "电",
  "力",
  "里",
  "如",
  "水",
  "化",
  "高",
  "自",
  "二",
  "理",
  "起",
  "小",
  "物",
  "现",
  "实",
  "加",
  "量",
  "都",
  "两",
  "体",
  "制",
  "机",
  "当",
  "使",
  "点",
  "从",
  "业",
  "本",
  "去",
  "把",
  "性",
  "好",
  "应",
  "开",
  "它",
  "合",
  "还",
  "因",
  "由",
  "其",
  "些",
  "然",
  "前",
  "外",
  "天",
  "政",
  "四",
  "日",
  "那",
  "社",
  "义",
  "事",
  "平",
  "形",
  "相",
  "全",
  "表",
  "间",
  "样",
  "与",
  "关",
  "各",
  "重",
  "新",
  "线",
  "内",
  "数",
  "正",
  "心",
  "反",
  "你",
  "明",
  "看",
  "原",
  "又",
  "么",
  "利",
  "比",
  "或",
  "但",
  "质",
  "气",
  "第",
  "向",
  "道",
  "命",
  "此",
  "变",
  "条",
  "只",
  "没",
  "结",
  "解",
  "问",
  "意",
  "建",
  "月",
  "公",
  "无",
  "系",
  "军",
  "很",
  "情",
  "者",
  "最",
  "立",
  "代",
  "想",
  "已",
  "通",
  "并",
  "提",
  "直",
  "题",
  "党",
  "程",
  "展",
  "五",
  "果",
  "料",
  "象",
  "员",
  "革",
  "位",
  "入",
  "常",
  "文",
  "总",
  "次",
  "品",
  "式",
  "活",
  "设",
  "及",
  "管",
  "特",
  "件",
  "长",
  "求",
  "老",
  "头",
  "基",
  "资",
  "边",
  "流",
  "路",
  "级",
  "少",
  "图",
  "山",
  "统",
  "接",
  "知",
  "较",
  "将",
  "组",
  "见",
  "计",
  "别",
  "她",
  "手",
  "角",
  "期",
  "根",
  "论",
  "运",
  "农",
  "指",
  "几",
  "九",
  "区",
  "强",
  "放",
  "决",
  "西",
  "被",
  "干",
  "做",
  "必",
  "战",
  "先",
  "回",
  "则",
  "任",
  "取",
  "据",
  "处",
  "队",
  "南",
  "给",
  "色",
  "光",
  "门",
  "即",
  "保",
  "治",
  "北",
  "造",
  "百",
  "规",
  "热",
  "领",
  "七",
  "海",
  "口",
  "东",
  "导",
  "器",
  "压",
  "志",
  "世",
  "金",
  "增",
  "争",
  "济",
  "阶",
  "油",
  "思",
  "术",
  "极",
  "交",
  "受",
  "联",
  "什",
  "认",
  "六",
  "共",
  "权",
  "收",
  "证",
  "改",
  "清",
  "美",
  "再",
  "采",
  "转",
  "更",
  "单",
  "风",
  "切",
  "打",
  "白",
  "教",
  "速",
  "花",
  "带",
  "安",
  "场",
  "身",
  "车",
  "例",
  "真",
  "务",
  "具",
  "万",
  "每",
  "目",
  "至",
  "达",
  "走",
  "积",
  "示",
  "议",
  "声",
  "报",
  "斗",
  "完",
  "类",
  "八",
  "离",
  "华",
  "名",
  "确",
  "才",
  "科",
  "张",
  "信",
  "马",
  "节",
  "话",
  "米",
  "整",
  "空",
  "元",
  "况",
  "今",
  "集",
  "温",
  "传",
  "土",
  "许",
  "步",
  "群",
  "广",
  "石",
  "记",
  "需",
  "段",
  "研",
  "界",
  "拉",
  "林",
  "律",
  "叫",
  "且",
  "究",
  "观",
  "越",
  "织",
  "装",
  "影",
  "算",
  "低",
  "持",
  "音",
  "众",
  "书",
  "布",
  "复",
  "容",
  "儿",
  "须",
  "际",
  "商",
  "非",
  "验",
  "连",
  "断",
  "深",
  "难",
  "近",
  "矿",
  "千",
  "周",
  "委",
  "素",
  "技",
  "备",
  "半",
  "办",
  "青",
  "省",
  "列",
  "习",
  "响",
  "约",
  "支",
  "般",
  "史",
  "感",
  "劳",
  "便",
  "团",
  "往",
  "酸",
  "历",
  "市",
  "克",
  "何",
  "除",
  "消",
  "构",
  "府",
  "称",
  "太",
  "准",
  "精",
  "值",
  "号",
  "率",
  "族",
  "维",
  "划",
  "选",
  "标",
  "写",
  "存",
  "候",
  "毛",
  "亲",
  "快",
  "效",
  "斯",
  "院",
  "查",
  "江",
  "型",
  "眼",
  "王",
  "按",
  "格",
  "养",
  "易",
  "置",
  "派",
  "层",
  "片",
  "始",
  "却",
  "专",
  "状",
  "育",
  "厂",
  "京",
  "识",
  "适",
  "属",
  "圆",
  "包",
  "火",
  "住",
  "调",
  "满",
  "县",
  "局",
  "照",
  "参",
  "红",
  "细",
  "引",
  "听",
  "该",
  "铁",
  "价",
  "严",
  "首",
  "底",
  "液",
  "官",
  "德",
  "随",
  "病",
  "苏",
  "失",
  "尔",
  "死",
  "讲",
  "配",
  "女",
  "黄",
  "推",
  "显",
  "谈",
  "罪",
  "神",
  "艺",
  "呢",
  "席",
  "含",
  "企",
  "望",
  "密",
  "批",
  "营",
  "项",
  "防",
  "举",
  "球",
  "英",
  "氧",
  "势",
  "告",
  "李",
  "台",
  "落",
  "木",
  "帮",
  "轮",
  "破",
  "亚",
  "师",
  "围",
  "注",
  "远",
  "字",
  "材",
  "排",
  "供",
  "河",
  "态",
  "封",
  "另",
  "施",
  "减",
  "树",
  "溶",
  "怎",
  "止",
  "案",
  "言",
  "士",
  "均",
  "武",
  "固",
  "叶",
  "鱼",
  "波",
  "视",
  "仅",
  "费",
  "紧",
  "爱",
  "左",
  "章",
  "早",
  "朝",
  "害",
  "续",
  "轻",
  "服",
  "试",
  "食",
  "充",
  "兵",
  "源",
  "判",
  "护",
  "司",
  "足",
  "某",
  "练",
  "差",
  "致",
  "板",
  "田",
  "降",
  "黑",
  "犯",
  "负",
  "击",
  "范",
  "继",
  "兴",
  "似",
  "余",
  "坚",
  "曲",
  "输",
  "修",
  "故",
  "城",
  "夫",
  "够",
  "送",
  "笔",
  "船",
  "占",
  "右",
  "财",
  "吃",
  "富",
  "春",
  "职",
  "觉",
  "汉",
  "画",
  "功",
  "巴",
  "跟",
  "虽",
  "杂",
  "飞",
  "检",
  "吸",
  "助",
  "升",
  "阳",
  "互",
  "初",
  "创",
  "抗",
  "考",
  "投",
  "坏",
  "策",
  "古",
  "径",
  "换",
  "未",
  "跑",
  "留",
  "钢",
  "曾",
  "端",
  "责",
  "站",
  "简",
  "述",
  "钱",
  "副",
  "尽",
  "帝",
  "射",
  "草",
  "冲",
  "承",
  "独",
  "令",
  "限",
  "阿",
  "宣",
  "环",
  "双",
  "请",
  "超",
  "微",
  "让",
  "控",
  "州",
  "良",
  "轴",
  "找",
  "否",
  "纪",
  "益",
  "依",
  "优",
  "顶",
  "础",
  "载",
  "倒",
  "房",
  "突",
  "坐",
  "粉",
  "敌",
  "略",
  "客",
  "袁",
  "冷",
  "胜",
  "绝",
  "析",
  "块",
  "剂",
  "测",
  "丝",
  "协",
  "诉",
  "念",
  "陈",
  "仍",
  "罗",
  "盐",
  "友",
  "洋",
  "错",
  "苦",
  "夜",
  "刑",
  "移",
  "频",
  "逐",
  "靠",
  "混",
  "母",
  "短",
  "皮",
  "终",
  "聚",
  "汽",
  "村",
  "云",
  "哪",
  "既",
  "距",
  "卫",
  "停",
  "烈",
  "央",
  "察",
  "烧",
  "迅",
  "境",
  "若",
  "印",
  "洲",
  "刻",
  "括",
  "激",
  "孔",
  "搞",
  "甚",
  "室",
  "待",
  "核",
  "校",
  "散",
  "侵",
  "吧",
  "甲",
  "游",
  "久",
  "菜",
  "味",
  "旧",
  "模",
  "湖",
  "货",
  "损",
  "预",
  "阻",
  "毫",
  "普",
  "稳",
  "乙",
  "妈",
  "植",
  "息",
  "扩",
  "银",
  "语",
  "挥",
  "酒",
  "守",
  "拿",
  "序",
  "纸",
  "医",
  "缺",
  "雨",
  "吗",
  "针",
  "刘",
  "啊",
  "急",
  "唱",
  "误",
  "训",
  "愿",
  "审",
  "附",
  "获",
  "茶",
  "鲜",
  "粮",
  "斤",
  "孩",
  "脱",
  "硫",
  "肥",
  "善",
  "龙",
  "演",
  "父",
  "渐",
  "血",
  "欢",
  "械",
  "掌",
  "歌",
  "沙",
  "刚",
  "攻",
  "谓",
  "盾",
  "讨",
  "晚",
  "粒",
  "乱",
  "燃",
  "矛",
  "乎",
  "杀",
  "药",
  "宁",
  "鲁",
  "贵",
  "钟",
  "煤",
  "读",
  "班",
  "伯",
  "香",
  "介",
  "迫",
  "句",
  "丰",
  "培",
  "握",
  "兰",
  "担",
  "弦",
  "蛋",
  "沉",
  "假",
  "穿",
  "执",
  "答",
  "乐",
  "谁",
  "顺",
  "烟",
  "缩",
  "征",
  "脸",
  "喜",
  "松",
  "脚",
  "困",
  "异",
  "免",
  "背",
  "星",
  "福",
  "买",
  "染",
  "井",
  "概",
  "慢",
  "怕",
  "磁",
  "倍",
  "祖",
  "皇",
  "促",
  "静",
  "补",
  "评",
  "翻",
  "肉",
  "践",
  "尼",
  "衣",
  "宽",
  "扬",
  "棉",
  "希",
  "伤",
  "操",
  "垂",
  "秋",
  "宜",
  "氢",
  "套",
  "督",
  "振",
  "架",
  "亮",
  "末",
  "宪",
  "庆",
  "编",
  "牛",
  "触",
  "映",
  "雷",
  "销",
  "诗",
  "座",
  "居",
  "抓",
  "裂",
  "胞",
  "呼",
  "娘",
  "景",
  "威",
  "绿",
  "晶",
  "厚",
  "盟",
  "衡",
  "鸡",
  "孙",
  "延",
  "危",
  "胶",
  "屋",
  "乡",
  "临",
  "陆",
  "顾",
  "掉",
  "呀",
  "灯",
  "岁",
  "措",
  "束",
  "耐",
  "剧",
  "玉",
  "赵",
  "跳",
  "哥",
  "季",
  "课",
  "凯",
  "胡",
  "额",
  "款",
  "绍",
  "卷",
  "齐",
  "伟",
  "蒸",
  "殖",
  "永",
  "宗",
  "苗",
  "川",
  "炉",
  "岩",
  "弱",
  "零",
  "杨",
  "奏",
  "沿",
  "露",
  "杆",
  "探",
  "滑",
  "镇",
  "饭",
  "浓",
  "航",
  "怀",
  "赶",
  "库",
  "夺",
  "伊",
  "灵",
  "税",
  "途",
  "灭",
  "赛",
  "归",
  "召",
  "鼓",
  "播",
  "盘",
  "裁",
  "险",
  "康",
  "唯",
  "录",
  "菌",
  "纯",
  "借",
  "糖",
  "盖",
  "横",
  "符",
  "私",
  "努",
  "堂",
  "域",
  "枪",
  "润",
  "幅",
  "哈",
  "竟",
  "熟",
  "虫",
  "泽",
  "脑",
  "壤",
  "碳",
  "欧",
  "遍",
  "侧",
  "寨",
  "敢",
  "彻",
  "虑",
  "斜",
  "薄",
  "庭",
  "纳",
  "弹",
  "饲",
  "伸",
  "折",
  "麦",
  "湿",
  "暗",
  "荷",
  "瓦",
  "塞",
  "床",
  "筑",
  "恶",
  "户",
  "访",
  "塔",
  "奇",
  "透",
  "梁",
  "刀",
  "旋",
  "迹",
  "卡",
  "氯",
  "遇",
  "份",
  "毒",
  "泥",
  "退",
  "洗",
  "摆",
  "灰",
  "彩",
  "卖",
  "耗",
  "夏",
  "择",
  "忙",
  "铜",
  "献",
  "硬",
  "予",
  "繁",
  "圈",
  "雪",
  "函",
  "亦",
  "抽",
  "篇",
  "阵",
  "阴",
  "丁",
  "尺",
  "追",
  "堆",
  "雄",
  "迎",
  "泛",
  "爸",
  "楼",
  "避",
  "谋",
  "吨",
  "野",
  "猪",
  "旗",
  "累",
  "偏",
  "典",
  "馆",
  "索",
  "秦",
  "脂",
  "潮",
  "爷",
  "豆",
  "忽",
  "托",
  "惊",
  "塑",
  "遗",
  "愈",
  "朱",
  "替",
  "纤",
  "粗",
  "倾",
  "尚",
  "痛",
  "楚",
  "谢",
  "奋",
  "购",
  "磨",
  "君",
  "池",
  "旁",
  "碎",
  "骨",
  "监",
  "捕",
  "弟",
  "暴",
  "割",
  "贯",
  "殊",
  "释",
  "词",
  "亡",
  "壁",
  "顿",
  "宝",
  "午",
  "尘",
  "闻",
  "揭",
  "炮",
  "残",
  "冬",
  "桥",
  "妇",
  "警",
  "综",
  "招",
  "吴",
  "付",
  "浮",
  "遭",
  "徐",
  "您",
  "摇",
  "谷",
  "赞",
  "箱",
  "隔",
  "订",
  "男",
  "吹",
  "园",
  "纷",
  "唐",
  "败",
  "宋",
  "玻",
  "巨",
  "耕",
  "坦",
  "荣",
  "闭",
  "湾",
  "键",
  "凡",
  "驻",
  "锅",
  "救",
  "恩",
  "剥",
  "凝",
  "碱",
  "齿",
  "截",
  "炼",
  "麻",
  "纺",
  "禁",
  "废",
  "盛",
  "版",
  "缓",
  "净",
  "睛",
  "昌",
  "婚",
  "涉",
  "筒",
  "嘴",
  "插",
  "岸",
  "朗",
  "庄",
  "街",
  "藏",
  "姑",
  "贸",
  "腐",
  "奴",
  "啦",
  "惯",
  "乘",
  "伙",
  "恢",
  "匀",
  "纱",
  "扎",
  "辩",
  "耳",
  "彪",
  "臣",
  "亿",
  "璃",
  "抵",
  "脉",
  "秀",
  "萨",
  "俄",
  "网",
  "舞",
  "店",
  "喷",
  "纵",
  "寸",
  "汗",
  "挂",
  "洪",
  "贺",
  "闪",
  "柬",
  "爆",
  "烯",
  "津",
  "稻",
  "墙",
  "软",
  "勇",
  "像",
  "滚",
  "厘",
  "蒙",
  "芳",
  "肯",
  "坡",
  "柱",
  "荡",
  "腿",
  "仪",
  "旅",
  "尾",
  "轧",
  "冰",
  "贡",
  "登",
  "黎",
  "削",
  "钻",
  "勒",
  "逃",
  "障",
  "氨",
  "郭",
  "峰",
  "币",
  "港",
  "伏",
  "轨",
  "亩",
  "毕",
  "擦",
  "莫",
  "刺",
  "浪",
  "秘",
  "援",
  "株",
  "健",
  "售",
  "股",
  "岛",
  "甘",
  "泡",
  "睡",
  "童",
  "铸",
  "汤",
  "阀",
  "休",
  "汇",
  "舍",
  "牧",
  "绕",
  "炸",
  "哲",
  "磷",
  "绩",
  "朋",
  "淡",
  "尖",
  "启",
  "陷",
  "柴",
  "呈",
  "徒",
  "颜",
  "泪",
  "稍",
  "忘",
  "泵",
  "蓝",
  "拖",
  "洞",
  "授",
  "镜",
  "辛",
  "壮",
  "锋",
  "贫",
  "虚",
  "弯",
  "摩",
  "泰",
  "幼",
  "廷",
  "尊",
  "窗",
  "纲",
  "弄",
  "隶",
  "疑",
  "氏",
  "宫",
  "姐",
  "震",
  "瑞",
  "怪",
  "尤",
  "琴",
  "循",
  "描",
  "膜",
  "违",
  "夹",
  "腰",
  "缘",
  "珠",
  "穷",
  "森",
  "枝",
  "竹",
  "沟",
  "催",
  "绳",
  "忆",
  "邦",
  "剩",
  "幸",
  "浆",
  "栏",
  "拥",
  "牙",
  "贮",
  "礼",
  "滤",
  "钠",
  "纹",
  "罢",
  "拍",
  "咱",
  "喊",
  "袖",
  "埃",
  "勤",
  "罚",
  "焦",
  "潜",
  "伍",
  "墨",
  "欲",
  "缝",
  "姓",
  "刊",
  "饱",
  "仿",
  "奖",
  "铝",
  "鬼",
  "丽",
  "跨",
  "默",
  "挖",
  "链",
  "扫",
  "喝",
  "袋",
  "炭",
  "污",
  "幕",
  "诸",
  "弧",
  "励",
  "梅",
  "奶",
  "洁",
  "灾",
  "舟",
  "鉴",
  "苯",
  "讼",
  "抱",
  "毁",
  "懂",
  "寒",
  "智",
  "埔",
  "寄",
  "届",
  "跃",
  "渡",
  "挑",
  "丹",
  "艰",
  "贝",
  "碰",
  "拔",
  "爹",
  "戴",
  "码",
  "梦",
  "芽",
  "熔",
  "赤",
  "渔",
  "哭",
  "敬",
  "颗",
  "奔",
  "铅",
  "仲",
  "虎",
  "稀",
  "妹",
  "乏",
  "珍",
  "申",
  "桌",
  "遵",
  "允",
  "隆",
  "螺",
  "仓",
  "魏",
  "锐",
  "晓",
  "氮",
  "兼",
  "隐",
  "碍",
  "赫",
  "拨",
  "忠",
  "肃",
  "缸",
  "牵",
  "抢",
  "博",
  "巧",
  "壳",
  "兄",
  "杜",
  "讯",
  "诚",
  "碧",
  "祥",
  "柯",
  "页",
  "巡",
  "矩",
  "悲",
  "灌",
  "龄",
  "伦",
  "票",
  "寻",
  "桂",
  "铺",
  "圣",
  "恐",
  "恰",
  "郑",
  "趣",
  "抬",
  "荒",
  "腾",
  "贴",
  "柔",
  "滴",
  "猛",
  "阔",
  "辆",
  "妻",
  "填",
  "撤",
  "储",
  "签",
  "闹",
  "扰",
  "紫",
  "砂",
  "递",
  "戏",
  "吊",
  "陶",
  "伐",
  "喂",
  "疗",
  "瓶",
  "婆",
  "抚",
  "臂",
  "摸",
  "忍",
  "虾",
  "蜡",
  "邻",
  "胸",
  "巩",
  "挤",
  "偶",
  "弃",
  "槽",
  "劲",
  "乳",
  "邓",
  "吉",
  "仁",
  "烂",
  "砖",
  "租",
  "乌",
  "舰",
  "伴",
  "瓜",
  "浅",
  "丙",
  "暂",
  "燥",
  "橡",
  "柳",
  "迷",
  "暖",
  "牌",
  "秧",
  "胆",
  "详",
  "簧",
  "踏",
  "瓷",
  "谱",
  "呆",
  "宾",
  "糊",
  "洛",
  "辉",
  "愤",
  "竞",
  "隙",
  "怒",
  "粘",
  "乃",
  "绪",
  "肩",
  "籍",
  "敏",
  "涂",
  "熙",
  "皆",
  "侦",
  "悬",
  "掘",
  "享",
  "纠",
  "醒",
  "狂",
  "锁",
  "淀",
  "恨",
  "牲",
  "霸",
  "爬",
  "赏",
  "逆",
  "玩",
  "陵",
  "祝",
  "秒",
  "浙",
  "貌",
  "役",
  "彼",
  "悉",
  "鸭",
  "趋",
  "凤",
  "晨",
  "畜",
  "辈",
  "秩",
  "卵",
  "署",
  "梯",
  "炎",
  "滩",
  "棋",
  "驱",
  "筛",
  "峡",
  "冒",
  "啥",
  "寿",
  "译",
  "浸",
  "泉",
  "帽",
  "迟",
  "硅",
  "疆",
  "贷",
  "漏",
  "稿",
  "冠",
  "嫩",
  "胁",
  "芯",
  "牢",
  "叛",
  "蚀",
  "奥",
  "鸣",
  "岭",
  "羊",
  "凭",
  "串",
  "塘",
  "绘",
  "酵",
  "融",
  "盆",
  "锡",
  "庙",
  "筹",
  "冻",
  "辅",
  "摄",
  "袭",
  "筋",
  "拒",
  "僚",
  "旱",
  "钾",
  "鸟",
  "漆",
  "沈",
  "眉",
  "疏",
  "添",
  "棒",
  "穗",
  "硝",
  "韩",
  "逼",
  "扭",
  "侨",
  "凉",
  "挺",
  "碗",
  "栽",
  "炒",
  "杯",
  "患",
  "馏",
  "劝",
  "豪",
  "辽",
  "勃",
  "鸿",
  "旦",
  "吏",
  "拜",
  "狗",
  "埋",
  "辊",
  "掩",
  "饮",
  "搬",
  "骂",
  "辞",
  "勾",
  "扣",
  "估",
  "蒋",
  "绒",
  "雾",
  "丈",
  "朵",
  "姆",
  "拟",
  "宇",
  "辑",
  "陕",
  "雕",
  "偿",
  "蓄",
  "崇",
  "剪",
  "倡",
  "厅",
  "咬",
  "驶",
  "薯",
  "刷",
  "斥",
  "番",
  "赋",
  "奉",
  "佛",
  "浇",
  "漫",
  "曼",
  "扇",
  "钙",
  "桃",
  "扶",
  "仔",
  "返",
  "俗",
  "亏",
  "腔",
  "鞋",
  "棱",
  "覆",
  "框",
  "悄",
  "叔",
  "撞",
  "骗",
  "勘",
  "旺",
  "沸",
  "孤",
  "吐",
  "孟",
  "渠",
  "屈",
  "疾",
  "妙",
  "惜",
  "仰",
  "狠",
  "胀",
  "谐",
  "抛",
  "霉",
  "桑",
  "岗",
  "嘛",
  "衰",
  "盗",
  "渗",
  "脏",
  "赖",
  "涌",
  "甜",
  "曹",
  "阅",
  "肌",
  "哩",
  "厉",
  "烃",
  "纬",
  "毅",
  "昨",
  "伪",
  "症",
  "煮",
  "叹",
  "钉",
  "搭",
  "茎",
  "笼",
  "酷",
  "偷",
  "弓",
  "锥",
  "恒",
  "杰",
  "坑",
  "鼻",
  "翼",
  "纶",
  "叙",
  "狱",
  "逮",
  "罐",
  "络",
  "棚",
  "抑",
  "膨",
  "蔬",
  "寺",
  "骤",
  "穆",
  "冶",
  "枯",
  "册",
  "尸",
  "凸",
  "绅",
  "坯",
  "牺",
  "焰",
  "轰",
  "欣",
  "晋",
  "瘦",
  "御",
  "锭",
  "锦",
  "丧",
  "旬",
  "锻",
  "垄",
  "搜",
  "扑",
  "邀",
  "亭",
  "酯",
  "迈",
  "舒",
  "脆",
  "酶",
  "闲",
  "忧",
  "酚",
  "顽",
  "羽",
  "涨",
  "卸",
  "仗",
  "陪",
  "辟",
  "惩",
  "杭",
  "姚",
  "肚",
  "捉",
  "飘",
  "漂",
  "昆",
  "欺",
  "吾",
  "郎",
  "烷",
  "汁",
  "呵",
  "饰",
  "萧",
  "雅",
  "邮",
  "迁",
  "燕",
  "撒",
  "姻",
  "赴",
  "宴",
  "烦",
  "债",
  "帐",
  "斑",
  "铃",
  "旨",
  "醇",
  "董",
  "饼",
  "雏",
  "姿",
  "拌",
  "傅",
  "腹",
  "妥",
  "揉",
  "贤",
  "拆",
  "歪",
  "葡",
  "胺",
  "丢",
  "浩",
  "徽",
  "昂",
  "垫",
  "挡",
  "览",
  "贪",
  "慰",
  "缴",
  "汪",
  "慌",
  "冯",
  "诺",
  "姜",
  "谊",
  "凶",
  "劣",
  "诬",
  "耀",
  "昏",
  "躺",
  "盈",
  "骑",
  "乔",
  "溪",
  "丛",
  "卢",
  "抹",
  "闷",
  "咨",
  "刮",
  "驾",
  "缆",
  "悟",
  "摘",
  "铒",
  "掷",
  "颇",
  "幻",
  "柄",
  "惠",
  "惨",
  "佳",
  "仇",
  "腊",
  "窝",
  "涤",
  "剑",
  "瞧",
  "堡",
  "泼",
  "葱",
  "罩",
  "霍",
  "捞",
  "胎",
  "苍",
  "滨",
  "俩",
  "捅",
  "湘",
  "砍",
  "霞",
  "邵",
  "萄",
  "疯",
  "淮",
  "遂",
  "熊",
  "粪",
  "烘",
  "宿",
  "档",
  "戈",
  "驳",
  "嫂",
  "裕",
  "徙",
  "箭",
  "捐",
  "肠",
  "撑",
  "晒",
  "辨",
  "殿",
  "莲",
  "摊",
  "搅",
  "酱",
  "屏",
  "疫",
  "哀",
  "蔡",
  "堵",
  "沫",
  "皱",
  "畅",
  "叠",
  "阁",
  "莱",
  "敲",
  "辖",
  "钩",
  "痕",
  "坝",
  "巷",
  "饿",
  "祸",
  "丘",
  "玄",
  "溜",
  "曰",
  "逻",
  "彭",
  "尝",
  "卿",
  "妨",
  "艇",
  "吞",
  "韦",
  "怨",
  "矮",
  "歇"
], A1e = [
  "的",
  "一",
  "是",
  "在",
  "不",
  "了",
  "有",
  "和",
  "人",
  "這",
  "中",
  "大",
  "為",
  "上",
  "個",
  "國",
  "我",
  "以",
  "要",
  "他",
  "時",
  "來",
  "用",
  "們",
  "生",
  "到",
  "作",
  "地",
  "於",
  "出",
  "就",
  "分",
  "對",
  "成",
  "會",
  "可",
  "主",
  "發",
  "年",
  "動",
  "同",
  "工",
  "也",
  "能",
  "下",
  "過",
  "子",
  "說",
  "產",
  "種",
  "面",
  "而",
  "方",
  "後",
  "多",
  "定",
  "行",
  "學",
  "法",
  "所",
  "民",
  "得",
  "經",
  "十",
  "三",
  "之",
  "進",
  "著",
  "等",
  "部",
  "度",
  "家",
  "電",
  "力",
  "裡",
  "如",
  "水",
  "化",
  "高",
  "自",
  "二",
  "理",
  "起",
  "小",
  "物",
  "現",
  "實",
  "加",
  "量",
  "都",
  "兩",
  "體",
  "制",
  "機",
  "當",
  "使",
  "點",
  "從",
  "業",
  "本",
  "去",
  "把",
  "性",
  "好",
  "應",
  "開",
  "它",
  "合",
  "還",
  "因",
  "由",
  "其",
  "些",
  "然",
  "前",
  "外",
  "天",
  "政",
  "四",
  "日",
  "那",
  "社",
  "義",
  "事",
  "平",
  "形",
  "相",
  "全",
  "表",
  "間",
  "樣",
  "與",
  "關",
  "各",
  "重",
  "新",
  "線",
  "內",
  "數",
  "正",
  "心",
  "反",
  "你",
  "明",
  "看",
  "原",
  "又",
  "麼",
  "利",
  "比",
  "或",
  "但",
  "質",
  "氣",
  "第",
  "向",
  "道",
  "命",
  "此",
  "變",
  "條",
  "只",
  "沒",
  "結",
  "解",
  "問",
  "意",
  "建",
  "月",
  "公",
  "無",
  "系",
  "軍",
  "很",
  "情",
  "者",
  "最",
  "立",
  "代",
  "想",
  "已",
  "通",
  "並",
  "提",
  "直",
  "題",
  "黨",
  "程",
  "展",
  "五",
  "果",
  "料",
  "象",
  "員",
  "革",
  "位",
  "入",
  "常",
  "文",
  "總",
  "次",
  "品",
  "式",
  "活",
  "設",
  "及",
  "管",
  "特",
  "件",
  "長",
  "求",
  "老",
  "頭",
  "基",
  "資",
  "邊",
  "流",
  "路",
  "級",
  "少",
  "圖",
  "山",
  "統",
  "接",
  "知",
  "較",
  "將",
  "組",
  "見",
  "計",
  "別",
  "她",
  "手",
  "角",
  "期",
  "根",
  "論",
  "運",
  "農",
  "指",
  "幾",
  "九",
  "區",
  "強",
  "放",
  "決",
  "西",
  "被",
  "幹",
  "做",
  "必",
  "戰",
  "先",
  "回",
  "則",
  "任",
  "取",
  "據",
  "處",
  "隊",
  "南",
  "給",
  "色",
  "光",
  "門",
  "即",
  "保",
  "治",
  "北",
  "造",
  "百",
  "規",
  "熱",
  "領",
  "七",
  "海",
  "口",
  "東",
  "導",
  "器",
  "壓",
  "志",
  "世",
  "金",
  "增",
  "爭",
  "濟",
  "階",
  "油",
  "思",
  "術",
  "極",
  "交",
  "受",
  "聯",
  "什",
  "認",
  "六",
  "共",
  "權",
  "收",
  "證",
  "改",
  "清",
  "美",
  "再",
  "採",
  "轉",
  "更",
  "單",
  "風",
  "切",
  "打",
  "白",
  "教",
  "速",
  "花",
  "帶",
  "安",
  "場",
  "身",
  "車",
  "例",
  "真",
  "務",
  "具",
  "萬",
  "每",
  "目",
  "至",
  "達",
  "走",
  "積",
  "示",
  "議",
  "聲",
  "報",
  "鬥",
  "完",
  "類",
  "八",
  "離",
  "華",
  "名",
  "確",
  "才",
  "科",
  "張",
  "信",
  "馬",
  "節",
  "話",
  "米",
  "整",
  "空",
  "元",
  "況",
  "今",
  "集",
  "溫",
  "傳",
  "土",
  "許",
  "步",
  "群",
  "廣",
  "石",
  "記",
  "需",
  "段",
  "研",
  "界",
  "拉",
  "林",
  "律",
  "叫",
  "且",
  "究",
  "觀",
  "越",
  "織",
  "裝",
  "影",
  "算",
  "低",
  "持",
  "音",
  "眾",
  "書",
  "布",
  "复",
  "容",
  "兒",
  "須",
  "際",
  "商",
  "非",
  "驗",
  "連",
  "斷",
  "深",
  "難",
  "近",
  "礦",
  "千",
  "週",
  "委",
  "素",
  "技",
  "備",
  "半",
  "辦",
  "青",
  "省",
  "列",
  "習",
  "響",
  "約",
  "支",
  "般",
  "史",
  "感",
  "勞",
  "便",
  "團",
  "往",
  "酸",
  "歷",
  "市",
  "克",
  "何",
  "除",
  "消",
  "構",
  "府",
  "稱",
  "太",
  "準",
  "精",
  "值",
  "號",
  "率",
  "族",
  "維",
  "劃",
  "選",
  "標",
  "寫",
  "存",
  "候",
  "毛",
  "親",
  "快",
  "效",
  "斯",
  "院",
  "查",
  "江",
  "型",
  "眼",
  "王",
  "按",
  "格",
  "養",
  "易",
  "置",
  "派",
  "層",
  "片",
  "始",
  "卻",
  "專",
  "狀",
  "育",
  "廠",
  "京",
  "識",
  "適",
  "屬",
  "圓",
  "包",
  "火",
  "住",
  "調",
  "滿",
  "縣",
  "局",
  "照",
  "參",
  "紅",
  "細",
  "引",
  "聽",
  "該",
  "鐵",
  "價",
  "嚴",
  "首",
  "底",
  "液",
  "官",
  "德",
  "隨",
  "病",
  "蘇",
  "失",
  "爾",
  "死",
  "講",
  "配",
  "女",
  "黃",
  "推",
  "顯",
  "談",
  "罪",
  "神",
  "藝",
  "呢",
  "席",
  "含",
  "企",
  "望",
  "密",
  "批",
  "營",
  "項",
  "防",
  "舉",
  "球",
  "英",
  "氧",
  "勢",
  "告",
  "李",
  "台",
  "落",
  "木",
  "幫",
  "輪",
  "破",
  "亞",
  "師",
  "圍",
  "注",
  "遠",
  "字",
  "材",
  "排",
  "供",
  "河",
  "態",
  "封",
  "另",
  "施",
  "減",
  "樹",
  "溶",
  "怎",
  "止",
  "案",
  "言",
  "士",
  "均",
  "武",
  "固",
  "葉",
  "魚",
  "波",
  "視",
  "僅",
  "費",
  "緊",
  "愛",
  "左",
  "章",
  "早",
  "朝",
  "害",
  "續",
  "輕",
  "服",
  "試",
  "食",
  "充",
  "兵",
  "源",
  "判",
  "護",
  "司",
  "足",
  "某",
  "練",
  "差",
  "致",
  "板",
  "田",
  "降",
  "黑",
  "犯",
  "負",
  "擊",
  "范",
  "繼",
  "興",
  "似",
  "餘",
  "堅",
  "曲",
  "輸",
  "修",
  "故",
  "城",
  "夫",
  "夠",
  "送",
  "筆",
  "船",
  "佔",
  "右",
  "財",
  "吃",
  "富",
  "春",
  "職",
  "覺",
  "漢",
  "畫",
  "功",
  "巴",
  "跟",
  "雖",
  "雜",
  "飛",
  "檢",
  "吸",
  "助",
  "昇",
  "陽",
  "互",
  "初",
  "創",
  "抗",
  "考",
  "投",
  "壞",
  "策",
  "古",
  "徑",
  "換",
  "未",
  "跑",
  "留",
  "鋼",
  "曾",
  "端",
  "責",
  "站",
  "簡",
  "述",
  "錢",
  "副",
  "盡",
  "帝",
  "射",
  "草",
  "衝",
  "承",
  "獨",
  "令",
  "限",
  "阿",
  "宣",
  "環",
  "雙",
  "請",
  "超",
  "微",
  "讓",
  "控",
  "州",
  "良",
  "軸",
  "找",
  "否",
  "紀",
  "益",
  "依",
  "優",
  "頂",
  "礎",
  "載",
  "倒",
  "房",
  "突",
  "坐",
  "粉",
  "敵",
  "略",
  "客",
  "袁",
  "冷",
  "勝",
  "絕",
  "析",
  "塊",
  "劑",
  "測",
  "絲",
  "協",
  "訴",
  "念",
  "陳",
  "仍",
  "羅",
  "鹽",
  "友",
  "洋",
  "錯",
  "苦",
  "夜",
  "刑",
  "移",
  "頻",
  "逐",
  "靠",
  "混",
  "母",
  "短",
  "皮",
  "終",
  "聚",
  "汽",
  "村",
  "雲",
  "哪",
  "既",
  "距",
  "衛",
  "停",
  "烈",
  "央",
  "察",
  "燒",
  "迅",
  "境",
  "若",
  "印",
  "洲",
  "刻",
  "括",
  "激",
  "孔",
  "搞",
  "甚",
  "室",
  "待",
  "核",
  "校",
  "散",
  "侵",
  "吧",
  "甲",
  "遊",
  "久",
  "菜",
  "味",
  "舊",
  "模",
  "湖",
  "貨",
  "損",
  "預",
  "阻",
  "毫",
  "普",
  "穩",
  "乙",
  "媽",
  "植",
  "息",
  "擴",
  "銀",
  "語",
  "揮",
  "酒",
  "守",
  "拿",
  "序",
  "紙",
  "醫",
  "缺",
  "雨",
  "嗎",
  "針",
  "劉",
  "啊",
  "急",
  "唱",
  "誤",
  "訓",
  "願",
  "審",
  "附",
  "獲",
  "茶",
  "鮮",
  "糧",
  "斤",
  "孩",
  "脫",
  "硫",
  "肥",
  "善",
  "龍",
  "演",
  "父",
  "漸",
  "血",
  "歡",
  "械",
  "掌",
  "歌",
  "沙",
  "剛",
  "攻",
  "謂",
  "盾",
  "討",
  "晚",
  "粒",
  "亂",
  "燃",
  "矛",
  "乎",
  "殺",
  "藥",
  "寧",
  "魯",
  "貴",
  "鐘",
  "煤",
  "讀",
  "班",
  "伯",
  "香",
  "介",
  "迫",
  "句",
  "豐",
  "培",
  "握",
  "蘭",
  "擔",
  "弦",
  "蛋",
  "沉",
  "假",
  "穿",
  "執",
  "答",
  "樂",
  "誰",
  "順",
  "煙",
  "縮",
  "徵",
  "臉",
  "喜",
  "松",
  "腳",
  "困",
  "異",
  "免",
  "背",
  "星",
  "福",
  "買",
  "染",
  "井",
  "概",
  "慢",
  "怕",
  "磁",
  "倍",
  "祖",
  "皇",
  "促",
  "靜",
  "補",
  "評",
  "翻",
  "肉",
  "踐",
  "尼",
  "衣",
  "寬",
  "揚",
  "棉",
  "希",
  "傷",
  "操",
  "垂",
  "秋",
  "宜",
  "氫",
  "套",
  "督",
  "振",
  "架",
  "亮",
  "末",
  "憲",
  "慶",
  "編",
  "牛",
  "觸",
  "映",
  "雷",
  "銷",
  "詩",
  "座",
  "居",
  "抓",
  "裂",
  "胞",
  "呼",
  "娘",
  "景",
  "威",
  "綠",
  "晶",
  "厚",
  "盟",
  "衡",
  "雞",
  "孫",
  "延",
  "危",
  "膠",
  "屋",
  "鄉",
  "臨",
  "陸",
  "顧",
  "掉",
  "呀",
  "燈",
  "歲",
  "措",
  "束",
  "耐",
  "劇",
  "玉",
  "趙",
  "跳",
  "哥",
  "季",
  "課",
  "凱",
  "胡",
  "額",
  "款",
  "紹",
  "卷",
  "齊",
  "偉",
  "蒸",
  "殖",
  "永",
  "宗",
  "苗",
  "川",
  "爐",
  "岩",
  "弱",
  "零",
  "楊",
  "奏",
  "沿",
  "露",
  "桿",
  "探",
  "滑",
  "鎮",
  "飯",
  "濃",
  "航",
  "懷",
  "趕",
  "庫",
  "奪",
  "伊",
  "靈",
  "稅",
  "途",
  "滅",
  "賽",
  "歸",
  "召",
  "鼓",
  "播",
  "盤",
  "裁",
  "險",
  "康",
  "唯",
  "錄",
  "菌",
  "純",
  "借",
  "糖",
  "蓋",
  "橫",
  "符",
  "私",
  "努",
  "堂",
  "域",
  "槍",
  "潤",
  "幅",
  "哈",
  "竟",
  "熟",
  "蟲",
  "澤",
  "腦",
  "壤",
  "碳",
  "歐",
  "遍",
  "側",
  "寨",
  "敢",
  "徹",
  "慮",
  "斜",
  "薄",
  "庭",
  "納",
  "彈",
  "飼",
  "伸",
  "折",
  "麥",
  "濕",
  "暗",
  "荷",
  "瓦",
  "塞",
  "床",
  "築",
  "惡",
  "戶",
  "訪",
  "塔",
  "奇",
  "透",
  "梁",
  "刀",
  "旋",
  "跡",
  "卡",
  "氯",
  "遇",
  "份",
  "毒",
  "泥",
  "退",
  "洗",
  "擺",
  "灰",
  "彩",
  "賣",
  "耗",
  "夏",
  "擇",
  "忙",
  "銅",
  "獻",
  "硬",
  "予",
  "繁",
  "圈",
  "雪",
  "函",
  "亦",
  "抽",
  "篇",
  "陣",
  "陰",
  "丁",
  "尺",
  "追",
  "堆",
  "雄",
  "迎",
  "泛",
  "爸",
  "樓",
  "避",
  "謀",
  "噸",
  "野",
  "豬",
  "旗",
  "累",
  "偏",
  "典",
  "館",
  "索",
  "秦",
  "脂",
  "潮",
  "爺",
  "豆",
  "忽",
  "托",
  "驚",
  "塑",
  "遺",
  "愈",
  "朱",
  "替",
  "纖",
  "粗",
  "傾",
  "尚",
  "痛",
  "楚",
  "謝",
  "奮",
  "購",
  "磨",
  "君",
  "池",
  "旁",
  "碎",
  "骨",
  "監",
  "捕",
  "弟",
  "暴",
  "割",
  "貫",
  "殊",
  "釋",
  "詞",
  "亡",
  "壁",
  "頓",
  "寶",
  "午",
  "塵",
  "聞",
  "揭",
  "炮",
  "殘",
  "冬",
  "橋",
  "婦",
  "警",
  "綜",
  "招",
  "吳",
  "付",
  "浮",
  "遭",
  "徐",
  "您",
  "搖",
  "谷",
  "贊",
  "箱",
  "隔",
  "訂",
  "男",
  "吹",
  "園",
  "紛",
  "唐",
  "敗",
  "宋",
  "玻",
  "巨",
  "耕",
  "坦",
  "榮",
  "閉",
  "灣",
  "鍵",
  "凡",
  "駐",
  "鍋",
  "救",
  "恩",
  "剝",
  "凝",
  "鹼",
  "齒",
  "截",
  "煉",
  "麻",
  "紡",
  "禁",
  "廢",
  "盛",
  "版",
  "緩",
  "淨",
  "睛",
  "昌",
  "婚",
  "涉",
  "筒",
  "嘴",
  "插",
  "岸",
  "朗",
  "莊",
  "街",
  "藏",
  "姑",
  "貿",
  "腐",
  "奴",
  "啦",
  "慣",
  "乘",
  "夥",
  "恢",
  "勻",
  "紗",
  "扎",
  "辯",
  "耳",
  "彪",
  "臣",
  "億",
  "璃",
  "抵",
  "脈",
  "秀",
  "薩",
  "俄",
  "網",
  "舞",
  "店",
  "噴",
  "縱",
  "寸",
  "汗",
  "掛",
  "洪",
  "賀",
  "閃",
  "柬",
  "爆",
  "烯",
  "津",
  "稻",
  "牆",
  "軟",
  "勇",
  "像",
  "滾",
  "厘",
  "蒙",
  "芳",
  "肯",
  "坡",
  "柱",
  "盪",
  "腿",
  "儀",
  "旅",
  "尾",
  "軋",
  "冰",
  "貢",
  "登",
  "黎",
  "削",
  "鑽",
  "勒",
  "逃",
  "障",
  "氨",
  "郭",
  "峰",
  "幣",
  "港",
  "伏",
  "軌",
  "畝",
  "畢",
  "擦",
  "莫",
  "刺",
  "浪",
  "秘",
  "援",
  "株",
  "健",
  "售",
  "股",
  "島",
  "甘",
  "泡",
  "睡",
  "童",
  "鑄",
  "湯",
  "閥",
  "休",
  "匯",
  "舍",
  "牧",
  "繞",
  "炸",
  "哲",
  "磷",
  "績",
  "朋",
  "淡",
  "尖",
  "啟",
  "陷",
  "柴",
  "呈",
  "徒",
  "顏",
  "淚",
  "稍",
  "忘",
  "泵",
  "藍",
  "拖",
  "洞",
  "授",
  "鏡",
  "辛",
  "壯",
  "鋒",
  "貧",
  "虛",
  "彎",
  "摩",
  "泰",
  "幼",
  "廷",
  "尊",
  "窗",
  "綱",
  "弄",
  "隸",
  "疑",
  "氏",
  "宮",
  "姐",
  "震",
  "瑞",
  "怪",
  "尤",
  "琴",
  "循",
  "描",
  "膜",
  "違",
  "夾",
  "腰",
  "緣",
  "珠",
  "窮",
  "森",
  "枝",
  "竹",
  "溝",
  "催",
  "繩",
  "憶",
  "邦",
  "剩",
  "幸",
  "漿",
  "欄",
  "擁",
  "牙",
  "貯",
  "禮",
  "濾",
  "鈉",
  "紋",
  "罷",
  "拍",
  "咱",
  "喊",
  "袖",
  "埃",
  "勤",
  "罰",
  "焦",
  "潛",
  "伍",
  "墨",
  "欲",
  "縫",
  "姓",
  "刊",
  "飽",
  "仿",
  "獎",
  "鋁",
  "鬼",
  "麗",
  "跨",
  "默",
  "挖",
  "鏈",
  "掃",
  "喝",
  "袋",
  "炭",
  "污",
  "幕",
  "諸",
  "弧",
  "勵",
  "梅",
  "奶",
  "潔",
  "災",
  "舟",
  "鑑",
  "苯",
  "訟",
  "抱",
  "毀",
  "懂",
  "寒",
  "智",
  "埔",
  "寄",
  "屆",
  "躍",
  "渡",
  "挑",
  "丹",
  "艱",
  "貝",
  "碰",
  "拔",
  "爹",
  "戴",
  "碼",
  "夢",
  "芽",
  "熔",
  "赤",
  "漁",
  "哭",
  "敬",
  "顆",
  "奔",
  "鉛",
  "仲",
  "虎",
  "稀",
  "妹",
  "乏",
  "珍",
  "申",
  "桌",
  "遵",
  "允",
  "隆",
  "螺",
  "倉",
  "魏",
  "銳",
  "曉",
  "氮",
  "兼",
  "隱",
  "礙",
  "赫",
  "撥",
  "忠",
  "肅",
  "缸",
  "牽",
  "搶",
  "博",
  "巧",
  "殼",
  "兄",
  "杜",
  "訊",
  "誠",
  "碧",
  "祥",
  "柯",
  "頁",
  "巡",
  "矩",
  "悲",
  "灌",
  "齡",
  "倫",
  "票",
  "尋",
  "桂",
  "鋪",
  "聖",
  "恐",
  "恰",
  "鄭",
  "趣",
  "抬",
  "荒",
  "騰",
  "貼",
  "柔",
  "滴",
  "猛",
  "闊",
  "輛",
  "妻",
  "填",
  "撤",
  "儲",
  "簽",
  "鬧",
  "擾",
  "紫",
  "砂",
  "遞",
  "戲",
  "吊",
  "陶",
  "伐",
  "餵",
  "療",
  "瓶",
  "婆",
  "撫",
  "臂",
  "摸",
  "忍",
  "蝦",
  "蠟",
  "鄰",
  "胸",
  "鞏",
  "擠",
  "偶",
  "棄",
  "槽",
  "勁",
  "乳",
  "鄧",
  "吉",
  "仁",
  "爛",
  "磚",
  "租",
  "烏",
  "艦",
  "伴",
  "瓜",
  "淺",
  "丙",
  "暫",
  "燥",
  "橡",
  "柳",
  "迷",
  "暖",
  "牌",
  "秧",
  "膽",
  "詳",
  "簧",
  "踏",
  "瓷",
  "譜",
  "呆",
  "賓",
  "糊",
  "洛",
  "輝",
  "憤",
  "競",
  "隙",
  "怒",
  "粘",
  "乃",
  "緒",
  "肩",
  "籍",
  "敏",
  "塗",
  "熙",
  "皆",
  "偵",
  "懸",
  "掘",
  "享",
  "糾",
  "醒",
  "狂",
  "鎖",
  "淀",
  "恨",
  "牲",
  "霸",
  "爬",
  "賞",
  "逆",
  "玩",
  "陵",
  "祝",
  "秒",
  "浙",
  "貌",
  "役",
  "彼",
  "悉",
  "鴨",
  "趨",
  "鳳",
  "晨",
  "畜",
  "輩",
  "秩",
  "卵",
  "署",
  "梯",
  "炎",
  "灘",
  "棋",
  "驅",
  "篩",
  "峽",
  "冒",
  "啥",
  "壽",
  "譯",
  "浸",
  "泉",
  "帽",
  "遲",
  "矽",
  "疆",
  "貸",
  "漏",
  "稿",
  "冠",
  "嫩",
  "脅",
  "芯",
  "牢",
  "叛",
  "蝕",
  "奧",
  "鳴",
  "嶺",
  "羊",
  "憑",
  "串",
  "塘",
  "繪",
  "酵",
  "融",
  "盆",
  "錫",
  "廟",
  "籌",
  "凍",
  "輔",
  "攝",
  "襲",
  "筋",
  "拒",
  "僚",
  "旱",
  "鉀",
  "鳥",
  "漆",
  "沈",
  "眉",
  "疏",
  "添",
  "棒",
  "穗",
  "硝",
  "韓",
  "逼",
  "扭",
  "僑",
  "涼",
  "挺",
  "碗",
  "栽",
  "炒",
  "杯",
  "患",
  "餾",
  "勸",
  "豪",
  "遼",
  "勃",
  "鴻",
  "旦",
  "吏",
  "拜",
  "狗",
  "埋",
  "輥",
  "掩",
  "飲",
  "搬",
  "罵",
  "辭",
  "勾",
  "扣",
  "估",
  "蔣",
  "絨",
  "霧",
  "丈",
  "朵",
  "姆",
  "擬",
  "宇",
  "輯",
  "陝",
  "雕",
  "償",
  "蓄",
  "崇",
  "剪",
  "倡",
  "廳",
  "咬",
  "駛",
  "薯",
  "刷",
  "斥",
  "番",
  "賦",
  "奉",
  "佛",
  "澆",
  "漫",
  "曼",
  "扇",
  "鈣",
  "桃",
  "扶",
  "仔",
  "返",
  "俗",
  "虧",
  "腔",
  "鞋",
  "棱",
  "覆",
  "框",
  "悄",
  "叔",
  "撞",
  "騙",
  "勘",
  "旺",
  "沸",
  "孤",
  "吐",
  "孟",
  "渠",
  "屈",
  "疾",
  "妙",
  "惜",
  "仰",
  "狠",
  "脹",
  "諧",
  "拋",
  "黴",
  "桑",
  "崗",
  "嘛",
  "衰",
  "盜",
  "滲",
  "臟",
  "賴",
  "湧",
  "甜",
  "曹",
  "閱",
  "肌",
  "哩",
  "厲",
  "烴",
  "緯",
  "毅",
  "昨",
  "偽",
  "症",
  "煮",
  "嘆",
  "釘",
  "搭",
  "莖",
  "籠",
  "酷",
  "偷",
  "弓",
  "錐",
  "恆",
  "傑",
  "坑",
  "鼻",
  "翼",
  "綸",
  "敘",
  "獄",
  "逮",
  "罐",
  "絡",
  "棚",
  "抑",
  "膨",
  "蔬",
  "寺",
  "驟",
  "穆",
  "冶",
  "枯",
  "冊",
  "屍",
  "凸",
  "紳",
  "坯",
  "犧",
  "焰",
  "轟",
  "欣",
  "晉",
  "瘦",
  "禦",
  "錠",
  "錦",
  "喪",
  "旬",
  "鍛",
  "壟",
  "搜",
  "撲",
  "邀",
  "亭",
  "酯",
  "邁",
  "舒",
  "脆",
  "酶",
  "閒",
  "憂",
  "酚",
  "頑",
  "羽",
  "漲",
  "卸",
  "仗",
  "陪",
  "闢",
  "懲",
  "杭",
  "姚",
  "肚",
  "捉",
  "飄",
  "漂",
  "昆",
  "欺",
  "吾",
  "郎",
  "烷",
  "汁",
  "呵",
  "飾",
  "蕭",
  "雅",
  "郵",
  "遷",
  "燕",
  "撒",
  "姻",
  "赴",
  "宴",
  "煩",
  "債",
  "帳",
  "斑",
  "鈴",
  "旨",
  "醇",
  "董",
  "餅",
  "雛",
  "姿",
  "拌",
  "傅",
  "腹",
  "妥",
  "揉",
  "賢",
  "拆",
  "歪",
  "葡",
  "胺",
  "丟",
  "浩",
  "徽",
  "昂",
  "墊",
  "擋",
  "覽",
  "貪",
  "慰",
  "繳",
  "汪",
  "慌",
  "馮",
  "諾",
  "姜",
  "誼",
  "兇",
  "劣",
  "誣",
  "耀",
  "昏",
  "躺",
  "盈",
  "騎",
  "喬",
  "溪",
  "叢",
  "盧",
  "抹",
  "悶",
  "諮",
  "刮",
  "駕",
  "纜",
  "悟",
  "摘",
  "鉺",
  "擲",
  "頗",
  "幻",
  "柄",
  "惠",
  "慘",
  "佳",
  "仇",
  "臘",
  "窩",
  "滌",
  "劍",
  "瞧",
  "堡",
  "潑",
  "蔥",
  "罩",
  "霍",
  "撈",
  "胎",
  "蒼",
  "濱",
  "倆",
  "捅",
  "湘",
  "砍",
  "霞",
  "邵",
  "萄",
  "瘋",
  "淮",
  "遂",
  "熊",
  "糞",
  "烘",
  "宿",
  "檔",
  "戈",
  "駁",
  "嫂",
  "裕",
  "徙",
  "箭",
  "捐",
  "腸",
  "撐",
  "曬",
  "辨",
  "殿",
  "蓮",
  "攤",
  "攪",
  "醬",
  "屏",
  "疫",
  "哀",
  "蔡",
  "堵",
  "沫",
  "皺",
  "暢",
  "疊",
  "閣",
  "萊",
  "敲",
  "轄",
  "鉤",
  "痕",
  "壩",
  "巷",
  "餓",
  "禍",
  "丘",
  "玄",
  "溜",
  "曰",
  "邏",
  "彭",
  "嘗",
  "卿",
  "妨",
  "艇",
  "吞",
  "韋",
  "怨",
  "矮",
  "歇"
], x1e = [
  "가격",
  "가끔",
  "가난",
  "가능",
  "가득",
  "가르침",
  "가뭄",
  "가방",
  "가상",
  "가슴",
  "가운데",
  "가을",
  "가이드",
  "가입",
  "가장",
  "가정",
  "가족",
  "가죽",
  "각오",
  "각자",
  "간격",
  "간부",
  "간섭",
  "간장",
  "간접",
  "간판",
  "갈등",
  "갈비",
  "갈색",
  "갈증",
  "감각",
  "감기",
  "감소",
  "감수성",
  "감자",
  "감정",
  "갑자기",
  "강남",
  "강당",
  "강도",
  "강력히",
  "강변",
  "강북",
  "강사",
  "강수량",
  "강아지",
  "강원도",
  "강의",
  "강제",
  "강조",
  "같이",
  "개구리",
  "개나리",
  "개방",
  "개별",
  "개선",
  "개성",
  "개인",
  "객관적",
  "거실",
  "거액",
  "거울",
  "거짓",
  "거품",
  "걱정",
  "건강",
  "건물",
  "건설",
  "건조",
  "건축",
  "걸음",
  "검사",
  "검토",
  "게시판",
  "게임",
  "겨울",
  "견해",
  "결과",
  "결국",
  "결론",
  "결석",
  "결승",
  "결심",
  "결정",
  "결혼",
  "경계",
  "경고",
  "경기",
  "경력",
  "경복궁",
  "경비",
  "경상도",
  "경영",
  "경우",
  "경쟁",
  "경제",
  "경주",
  "경찰",
  "경치",
  "경향",
  "경험",
  "계곡",
  "계단",
  "계란",
  "계산",
  "계속",
  "계약",
  "계절",
  "계층",
  "계획",
  "고객",
  "고구려",
  "고궁",
  "고급",
  "고등학생",
  "고무신",
  "고민",
  "고양이",
  "고장",
  "고전",
  "고집",
  "고춧가루",
  "고통",
  "고향",
  "곡식",
  "골목",
  "골짜기",
  "골프",
  "공간",
  "공개",
  "공격",
  "공군",
  "공급",
  "공기",
  "공동",
  "공무원",
  "공부",
  "공사",
  "공식",
  "공업",
  "공연",
  "공원",
  "공장",
  "공짜",
  "공책",
  "공통",
  "공포",
  "공항",
  "공휴일",
  "과목",
  "과일",
  "과장",
  "과정",
  "과학",
  "관객",
  "관계",
  "관광",
  "관념",
  "관람",
  "관련",
  "관리",
  "관습",
  "관심",
  "관점",
  "관찰",
  "광경",
  "광고",
  "광장",
  "광주",
  "괴로움",
  "굉장히",
  "교과서",
  "교문",
  "교복",
  "교실",
  "교양",
  "교육",
  "교장",
  "교직",
  "교통",
  "교환",
  "교훈",
  "구경",
  "구름",
  "구멍",
  "구별",
  "구분",
  "구석",
  "구성",
  "구속",
  "구역",
  "구입",
  "구청",
  "구체적",
  "국가",
  "국기",
  "국내",
  "국립",
  "국물",
  "국민",
  "국수",
  "국어",
  "국왕",
  "국적",
  "국제",
  "국회",
  "군대",
  "군사",
  "군인",
  "궁극적",
  "권리",
  "권위",
  "권투",
  "귀국",
  "귀신",
  "규정",
  "규칙",
  "균형",
  "그날",
  "그냥",
  "그늘",
  "그러나",
  "그룹",
  "그릇",
  "그림",
  "그제서야",
  "그토록",
  "극복",
  "극히",
  "근거",
  "근교",
  "근래",
  "근로",
  "근무",
  "근본",
  "근원",
  "근육",
  "근처",
  "글씨",
  "글자",
  "금강산",
  "금고",
  "금년",
  "금메달",
  "금액",
  "금연",
  "금요일",
  "금지",
  "긍정적",
  "기간",
  "기관",
  "기념",
  "기능",
  "기독교",
  "기둥",
  "기록",
  "기름",
  "기법",
  "기본",
  "기분",
  "기쁨",
  "기숙사",
  "기술",
  "기억",
  "기업",
  "기온",
  "기운",
  "기원",
  "기적",
  "기준",
  "기침",
  "기혼",
  "기획",
  "긴급",
  "긴장",
  "길이",
  "김밥",
  "김치",
  "김포공항",
  "깍두기",
  "깜빡",
  "깨달음",
  "깨소금",
  "껍질",
  "꼭대기",
  "꽃잎",
  "나들이",
  "나란히",
  "나머지",
  "나물",
  "나침반",
  "나흘",
  "낙엽",
  "난방",
  "날개",
  "날씨",
  "날짜",
  "남녀",
  "남대문",
  "남매",
  "남산",
  "남자",
  "남편",
  "남학생",
  "낭비",
  "낱말",
  "내년",
  "내용",
  "내일",
  "냄비",
  "냄새",
  "냇물",
  "냉동",
  "냉면",
  "냉방",
  "냉장고",
  "넥타이",
  "넷째",
  "노동",
  "노란색",
  "노력",
  "노인",
  "녹음",
  "녹차",
  "녹화",
  "논리",
  "논문",
  "논쟁",
  "놀이",
  "농구",
  "농담",
  "농민",
  "농부",
  "농업",
  "농장",
  "농촌",
  "높이",
  "눈동자",
  "눈물",
  "눈썹",
  "뉴욕",
  "느낌",
  "늑대",
  "능동적",
  "능력",
  "다방",
  "다양성",
  "다음",
  "다이어트",
  "다행",
  "단계",
  "단골",
  "단독",
  "단맛",
  "단순",
  "단어",
  "단위",
  "단점",
  "단체",
  "단추",
  "단편",
  "단풍",
  "달걀",
  "달러",
  "달력",
  "달리",
  "닭고기",
  "담당",
  "담배",
  "담요",
  "담임",
  "답변",
  "답장",
  "당근",
  "당분간",
  "당연히",
  "당장",
  "대규모",
  "대낮",
  "대단히",
  "대답",
  "대도시",
  "대략",
  "대량",
  "대륙",
  "대문",
  "대부분",
  "대신",
  "대응",
  "대장",
  "대전",
  "대접",
  "대중",
  "대책",
  "대출",
  "대충",
  "대통령",
  "대학",
  "대한민국",
  "대합실",
  "대형",
  "덩어리",
  "데이트",
  "도대체",
  "도덕",
  "도둑",
  "도망",
  "도서관",
  "도심",
  "도움",
  "도입",
  "도자기",
  "도저히",
  "도전",
  "도중",
  "도착",
  "독감",
  "독립",
  "독서",
  "독일",
  "독창적",
  "동화책",
  "뒷모습",
  "뒷산",
  "딸아이",
  "마누라",
  "마늘",
  "마당",
  "마라톤",
  "마련",
  "마무리",
  "마사지",
  "마약",
  "마요네즈",
  "마을",
  "마음",
  "마이크",
  "마중",
  "마지막",
  "마찬가지",
  "마찰",
  "마흔",
  "막걸리",
  "막내",
  "막상",
  "만남",
  "만두",
  "만세",
  "만약",
  "만일",
  "만점",
  "만족",
  "만화",
  "많이",
  "말기",
  "말씀",
  "말투",
  "맘대로",
  "망원경",
  "매년",
  "매달",
  "매력",
  "매번",
  "매스컴",
  "매일",
  "매장",
  "맥주",
  "먹이",
  "먼저",
  "먼지",
  "멀리",
  "메일",
  "며느리",
  "며칠",
  "면담",
  "멸치",
  "명단",
  "명령",
  "명예",
  "명의",
  "명절",
  "명칭",
  "명함",
  "모금",
  "모니터",
  "모델",
  "모든",
  "모범",
  "모습",
  "모양",
  "모임",
  "모조리",
  "모집",
  "모퉁이",
  "목걸이",
  "목록",
  "목사",
  "목소리",
  "목숨",
  "목적",
  "목표",
  "몰래",
  "몸매",
  "몸무게",
  "몸살",
  "몸속",
  "몸짓",
  "몸통",
  "몹시",
  "무관심",
  "무궁화",
  "무더위",
  "무덤",
  "무릎",
  "무슨",
  "무엇",
  "무역",
  "무용",
  "무조건",
  "무지개",
  "무척",
  "문구",
  "문득",
  "문법",
  "문서",
  "문제",
  "문학",
  "문화",
  "물가",
  "물건",
  "물결",
  "물고기",
  "물론",
  "물리학",
  "물음",
  "물질",
  "물체",
  "미국",
  "미디어",
  "미사일",
  "미술",
  "미역",
  "미용실",
  "미움",
  "미인",
  "미팅",
  "미혼",
  "민간",
  "민족",
  "민주",
  "믿음",
  "밀가루",
  "밀리미터",
  "밑바닥",
  "바가지",
  "바구니",
  "바나나",
  "바늘",
  "바닥",
  "바닷가",
  "바람",
  "바이러스",
  "바탕",
  "박물관",
  "박사",
  "박수",
  "반대",
  "반드시",
  "반말",
  "반발",
  "반성",
  "반응",
  "반장",
  "반죽",
  "반지",
  "반찬",
  "받침",
  "발가락",
  "발걸음",
  "발견",
  "발달",
  "발레",
  "발목",
  "발바닥",
  "발생",
  "발음",
  "발자국",
  "발전",
  "발톱",
  "발표",
  "밤하늘",
  "밥그릇",
  "밥맛",
  "밥상",
  "밥솥",
  "방금",
  "방면",
  "방문",
  "방바닥",
  "방법",
  "방송",
  "방식",
  "방안",
  "방울",
  "방지",
  "방학",
  "방해",
  "방향",
  "배경",
  "배꼽",
  "배달",
  "배드민턴",
  "백두산",
  "백색",
  "백성",
  "백인",
  "백제",
  "백화점",
  "버릇",
  "버섯",
  "버튼",
  "번개",
  "번역",
  "번지",
  "번호",
  "벌금",
  "벌레",
  "벌써",
  "범위",
  "범인",
  "범죄",
  "법률",
  "법원",
  "법적",
  "법칙",
  "베이징",
  "벨트",
  "변경",
  "변동",
  "변명",
  "변신",
  "변호사",
  "변화",
  "별도",
  "별명",
  "별일",
  "병실",
  "병아리",
  "병원",
  "보관",
  "보너스",
  "보라색",
  "보람",
  "보름",
  "보상",
  "보안",
  "보자기",
  "보장",
  "보전",
  "보존",
  "보통",
  "보편적",
  "보험",
  "복도",
  "복사",
  "복숭아",
  "복습",
  "볶음",
  "본격적",
  "본래",
  "본부",
  "본사",
  "본성",
  "본인",
  "본질",
  "볼펜",
  "봉사",
  "봉지",
  "봉투",
  "부근",
  "부끄러움",
  "부담",
  "부동산",
  "부문",
  "부분",
  "부산",
  "부상",
  "부엌",
  "부인",
  "부작용",
  "부장",
  "부정",
  "부족",
  "부지런히",
  "부친",
  "부탁",
  "부품",
  "부회장",
  "북부",
  "북한",
  "분노",
  "분량",
  "분리",
  "분명",
  "분석",
  "분야",
  "분위기",
  "분필",
  "분홍색",
  "불고기",
  "불과",
  "불교",
  "불꽃",
  "불만",
  "불법",
  "불빛",
  "불안",
  "불이익",
  "불행",
  "브랜드",
  "비극",
  "비난",
  "비닐",
  "비둘기",
  "비디오",
  "비로소",
  "비만",
  "비명",
  "비밀",
  "비바람",
  "비빔밥",
  "비상",
  "비용",
  "비율",
  "비중",
  "비타민",
  "비판",
  "빌딩",
  "빗물",
  "빗방울",
  "빗줄기",
  "빛깔",
  "빨간색",
  "빨래",
  "빨리",
  "사건",
  "사계절",
  "사나이",
  "사냥",
  "사람",
  "사랑",
  "사립",
  "사모님",
  "사물",
  "사방",
  "사상",
  "사생활",
  "사설",
  "사슴",
  "사실",
  "사업",
  "사용",
  "사월",
  "사장",
  "사전",
  "사진",
  "사촌",
  "사춘기",
  "사탕",
  "사투리",
  "사흘",
  "산길",
  "산부인과",
  "산업",
  "산책",
  "살림",
  "살인",
  "살짝",
  "삼계탕",
  "삼국",
  "삼십",
  "삼월",
  "삼촌",
  "상관",
  "상금",
  "상대",
  "상류",
  "상반기",
  "상상",
  "상식",
  "상업",
  "상인",
  "상자",
  "상점",
  "상처",
  "상추",
  "상태",
  "상표",
  "상품",
  "상황",
  "새벽",
  "색깔",
  "색연필",
  "생각",
  "생명",
  "생물",
  "생방송",
  "생산",
  "생선",
  "생신",
  "생일",
  "생활",
  "서랍",
  "서른",
  "서명",
  "서민",
  "서비스",
  "서양",
  "서울",
  "서적",
  "서점",
  "서쪽",
  "서클",
  "석사",
  "석유",
  "선거",
  "선물",
  "선배",
  "선생",
  "선수",
  "선원",
  "선장",
  "선전",
  "선택",
  "선풍기",
  "설거지",
  "설날",
  "설렁탕",
  "설명",
  "설문",
  "설사",
  "설악산",
  "설치",
  "설탕",
  "섭씨",
  "성공",
  "성당",
  "성명",
  "성별",
  "성인",
  "성장",
  "성적",
  "성질",
  "성함",
  "세금",
  "세미나",
  "세상",
  "세월",
  "세종대왕",
  "세탁",
  "센터",
  "센티미터",
  "셋째",
  "소규모",
  "소극적",
  "소금",
  "소나기",
  "소년",
  "소득",
  "소망",
  "소문",
  "소설",
  "소속",
  "소아과",
  "소용",
  "소원",
  "소음",
  "소중히",
  "소지품",
  "소질",
  "소풍",
  "소형",
  "속담",
  "속도",
  "속옷",
  "손가락",
  "손길",
  "손녀",
  "손님",
  "손등",
  "손목",
  "손뼉",
  "손실",
  "손질",
  "손톱",
  "손해",
  "솔직히",
  "솜씨",
  "송아지",
  "송이",
  "송편",
  "쇠고기",
  "쇼핑",
  "수건",
  "수년",
  "수단",
  "수돗물",
  "수동적",
  "수면",
  "수명",
  "수박",
  "수상",
  "수석",
  "수술",
  "수시로",
  "수업",
  "수염",
  "수영",
  "수입",
  "수준",
  "수집",
  "수출",
  "수컷",
  "수필",
  "수학",
  "수험생",
  "수화기",
  "숙녀",
  "숙소",
  "숙제",
  "순간",
  "순서",
  "순수",
  "순식간",
  "순위",
  "숟가락",
  "술병",
  "술집",
  "숫자",
  "스님",
  "스물",
  "스스로",
  "스승",
  "스웨터",
  "스위치",
  "스케이트",
  "스튜디오",
  "스트레스",
  "스포츠",
  "슬쩍",
  "슬픔",
  "습관",
  "습기",
  "승객",
  "승리",
  "승부",
  "승용차",
  "승진",
  "시각",
  "시간",
  "시골",
  "시금치",
  "시나리오",
  "시댁",
  "시리즈",
  "시멘트",
  "시민",
  "시부모",
  "시선",
  "시설",
  "시스템",
  "시아버지",
  "시어머니",
  "시월",
  "시인",
  "시일",
  "시작",
  "시장",
  "시절",
  "시점",
  "시중",
  "시즌",
  "시집",
  "시청",
  "시합",
  "시험",
  "식구",
  "식기",
  "식당",
  "식량",
  "식료품",
  "식물",
  "식빵",
  "식사",
  "식생활",
  "식초",
  "식탁",
  "식품",
  "신고",
  "신규",
  "신념",
  "신문",
  "신발",
  "신비",
  "신사",
  "신세",
  "신용",
  "신제품",
  "신청",
  "신체",
  "신화",
  "실감",
  "실내",
  "실력",
  "실례",
  "실망",
  "실수",
  "실습",
  "실시",
  "실장",
  "실정",
  "실질적",
  "실천",
  "실체",
  "실컷",
  "실태",
  "실패",
  "실험",
  "실현",
  "심리",
  "심부름",
  "심사",
  "심장",
  "심정",
  "심판",
  "쌍둥이",
  "씨름",
  "씨앗",
  "아가씨",
  "아나운서",
  "아드님",
  "아들",
  "아쉬움",
  "아스팔트",
  "아시아",
  "아울러",
  "아저씨",
  "아줌마",
  "아직",
  "아침",
  "아파트",
  "아프리카",
  "아픔",
  "아홉",
  "아흔",
  "악기",
  "악몽",
  "악수",
  "안개",
  "안경",
  "안과",
  "안내",
  "안녕",
  "안동",
  "안방",
  "안부",
  "안주",
  "알루미늄",
  "알코올",
  "암시",
  "암컷",
  "압력",
  "앞날",
  "앞문",
  "애인",
  "애정",
  "액수",
  "앨범",
  "야간",
  "야단",
  "야옹",
  "약간",
  "약국",
  "약속",
  "약수",
  "약점",
  "약품",
  "약혼녀",
  "양념",
  "양력",
  "양말",
  "양배추",
  "양주",
  "양파",
  "어둠",
  "어려움",
  "어른",
  "어젯밤",
  "어쨌든",
  "어쩌다가",
  "어쩐지",
  "언니",
  "언덕",
  "언론",
  "언어",
  "얼굴",
  "얼른",
  "얼음",
  "얼핏",
  "엄마",
  "업무",
  "업종",
  "업체",
  "엉덩이",
  "엉망",
  "엉터리",
  "엊그제",
  "에너지",
  "에어컨",
  "엔진",
  "여건",
  "여고생",
  "여관",
  "여군",
  "여권",
  "여대생",
  "여덟",
  "여동생",
  "여든",
  "여론",
  "여름",
  "여섯",
  "여성",
  "여왕",
  "여인",
  "여전히",
  "여직원",
  "여학생",
  "여행",
  "역사",
  "역시",
  "역할",
  "연결",
  "연구",
  "연극",
  "연기",
  "연락",
  "연설",
  "연세",
  "연속",
  "연습",
  "연애",
  "연예인",
  "연인",
  "연장",
  "연주",
  "연출",
  "연필",
  "연합",
  "연휴",
  "열기",
  "열매",
  "열쇠",
  "열심히",
  "열정",
  "열차",
  "열흘",
  "염려",
  "엽서",
  "영국",
  "영남",
  "영상",
  "영양",
  "영역",
  "영웅",
  "영원히",
  "영하",
  "영향",
  "영혼",
  "영화",
  "옆구리",
  "옆방",
  "옆집",
  "예감",
  "예금",
  "예방",
  "예산",
  "예상",
  "예선",
  "예술",
  "예습",
  "예식장",
  "예약",
  "예전",
  "예절",
  "예정",
  "예컨대",
  "옛날",
  "오늘",
  "오락",
  "오랫동안",
  "오렌지",
  "오로지",
  "오른발",
  "오븐",
  "오십",
  "오염",
  "오월",
  "오전",
  "오직",
  "오징어",
  "오페라",
  "오피스텔",
  "오히려",
  "옥상",
  "옥수수",
  "온갖",
  "온라인",
  "온몸",
  "온종일",
  "온통",
  "올가을",
  "올림픽",
  "올해",
  "옷차림",
  "와이셔츠",
  "와인",
  "완성",
  "완전",
  "왕비",
  "왕자",
  "왜냐하면",
  "왠지",
  "외갓집",
  "외국",
  "외로움",
  "외삼촌",
  "외출",
  "외침",
  "외할머니",
  "왼발",
  "왼손",
  "왼쪽",
  "요금",
  "요일",
  "요즘",
  "요청",
  "용기",
  "용서",
  "용어",
  "우산",
  "우선",
  "우승",
  "우연히",
  "우정",
  "우체국",
  "우편",
  "운동",
  "운명",
  "운반",
  "운전",
  "운행",
  "울산",
  "울음",
  "움직임",
  "웃어른",
  "웃음",
  "워낙",
  "원고",
  "원래",
  "원서",
  "원숭이",
  "원인",
  "원장",
  "원피스",
  "월급",
  "월드컵",
  "월세",
  "월요일",
  "웨이터",
  "위반",
  "위법",
  "위성",
  "위원",
  "위험",
  "위협",
  "윗사람",
  "유난히",
  "유럽",
  "유명",
  "유물",
  "유산",
  "유적",
  "유치원",
  "유학",
  "유행",
  "유형",
  "육군",
  "육상",
  "육십",
  "육체",
  "은행",
  "음력",
  "음료",
  "음반",
  "음성",
  "음식",
  "음악",
  "음주",
  "의견",
  "의논",
  "의문",
  "의복",
  "의식",
  "의심",
  "의외로",
  "의욕",
  "의원",
  "의학",
  "이것",
  "이곳",
  "이념",
  "이놈",
  "이달",
  "이대로",
  "이동",
  "이렇게",
  "이력서",
  "이론적",
  "이름",
  "이민",
  "이발소",
  "이별",
  "이불",
  "이빨",
  "이상",
  "이성",
  "이슬",
  "이야기",
  "이용",
  "이웃",
  "이월",
  "이윽고",
  "이익",
  "이전",
  "이중",
  "이튿날",
  "이틀",
  "이혼",
  "인간",
  "인격",
  "인공",
  "인구",
  "인근",
  "인기",
  "인도",
  "인류",
  "인물",
  "인생",
  "인쇄",
  "인연",
  "인원",
  "인재",
  "인종",
  "인천",
  "인체",
  "인터넷",
  "인하",
  "인형",
  "일곱",
  "일기",
  "일단",
  "일대",
  "일등",
  "일반",
  "일본",
  "일부",
  "일상",
  "일생",
  "일손",
  "일요일",
  "일월",
  "일정",
  "일종",
  "일주일",
  "일찍",
  "일체",
  "일치",
  "일행",
  "일회용",
  "임금",
  "임무",
  "입대",
  "입력",
  "입맛",
  "입사",
  "입술",
  "입시",
  "입원",
  "입장",
  "입학",
  "자가용",
  "자격",
  "자극",
  "자동",
  "자랑",
  "자부심",
  "자식",
  "자신",
  "자연",
  "자원",
  "자율",
  "자전거",
  "자정",
  "자존심",
  "자판",
  "작가",
  "작년",
  "작성",
  "작업",
  "작용",
  "작은딸",
  "작품",
  "잔디",
  "잔뜩",
  "잔치",
  "잘못",
  "잠깐",
  "잠수함",
  "잠시",
  "잠옷",
  "잠자리",
  "잡지",
  "장관",
  "장군",
  "장기간",
  "장래",
  "장례",
  "장르",
  "장마",
  "장면",
  "장모",
  "장미",
  "장비",
  "장사",
  "장소",
  "장식",
  "장애인",
  "장인",
  "장점",
  "장차",
  "장학금",
  "재능",
  "재빨리",
  "재산",
  "재생",
  "재작년",
  "재정",
  "재채기",
  "재판",
  "재학",
  "재활용",
  "저것",
  "저고리",
  "저곳",
  "저녁",
  "저런",
  "저렇게",
  "저번",
  "저울",
  "저절로",
  "저축",
  "적극",
  "적당히",
  "적성",
  "적용",
  "적응",
  "전개",
  "전공",
  "전기",
  "전달",
  "전라도",
  "전망",
  "전문",
  "전반",
  "전부",
  "전세",
  "전시",
  "전용",
  "전자",
  "전쟁",
  "전주",
  "전철",
  "전체",
  "전통",
  "전혀",
  "전후",
  "절대",
  "절망",
  "절반",
  "절약",
  "절차",
  "점검",
  "점수",
  "점심",
  "점원",
  "점점",
  "점차",
  "접근",
  "접시",
  "접촉",
  "젓가락",
  "정거장",
  "정도",
  "정류장",
  "정리",
  "정말",
  "정면",
  "정문",
  "정반대",
  "정보",
  "정부",
  "정비",
  "정상",
  "정성",
  "정오",
  "정원",
  "정장",
  "정지",
  "정치",
  "정확히",
  "제공",
  "제과점",
  "제대로",
  "제목",
  "제발",
  "제법",
  "제삿날",
  "제안",
  "제일",
  "제작",
  "제주도",
  "제출",
  "제품",
  "제한",
  "조각",
  "조건",
  "조금",
  "조깅",
  "조명",
  "조미료",
  "조상",
  "조선",
  "조용히",
  "조절",
  "조정",
  "조직",
  "존댓말",
  "존재",
  "졸업",
  "졸음",
  "종교",
  "종로",
  "종류",
  "종소리",
  "종업원",
  "종종",
  "종합",
  "좌석",
  "죄인",
  "주관적",
  "주름",
  "주말",
  "주머니",
  "주먹",
  "주문",
  "주민",
  "주방",
  "주변",
  "주식",
  "주인",
  "주일",
  "주장",
  "주전자",
  "주택",
  "준비",
  "줄거리",
  "줄기",
  "줄무늬",
  "중간",
  "중계방송",
  "중국",
  "중년",
  "중단",
  "중독",
  "중반",
  "중부",
  "중세",
  "중소기업",
  "중순",
  "중앙",
  "중요",
  "중학교",
  "즉석",
  "즉시",
  "즐거움",
  "증가",
  "증거",
  "증권",
  "증상",
  "증세",
  "지각",
  "지갑",
  "지경",
  "지극히",
  "지금",
  "지급",
  "지능",
  "지름길",
  "지리산",
  "지방",
  "지붕",
  "지식",
  "지역",
  "지우개",
  "지원",
  "지적",
  "지점",
  "지진",
  "지출",
  "직선",
  "직업",
  "직원",
  "직장",
  "진급",
  "진동",
  "진로",
  "진료",
  "진리",
  "진짜",
  "진찰",
  "진출",
  "진통",
  "진행",
  "질문",
  "질병",
  "질서",
  "짐작",
  "집단",
  "집안",
  "집중",
  "짜증",
  "찌꺼기",
  "차남",
  "차라리",
  "차량",
  "차림",
  "차별",
  "차선",
  "차츰",
  "착각",
  "찬물",
  "찬성",
  "참가",
  "참기름",
  "참새",
  "참석",
  "참여",
  "참외",
  "참조",
  "찻잔",
  "창가",
  "창고",
  "창구",
  "창문",
  "창밖",
  "창작",
  "창조",
  "채널",
  "채점",
  "책가방",
  "책방",
  "책상",
  "책임",
  "챔피언",
  "처벌",
  "처음",
  "천국",
  "천둥",
  "천장",
  "천재",
  "천천히",
  "철도",
  "철저히",
  "철학",
  "첫날",
  "첫째",
  "청년",
  "청바지",
  "청소",
  "청춘",
  "체계",
  "체력",
  "체온",
  "체육",
  "체중",
  "체험",
  "초등학생",
  "초반",
  "초밥",
  "초상화",
  "초순",
  "초여름",
  "초원",
  "초저녁",
  "초점",
  "초청",
  "초콜릿",
  "촛불",
  "총각",
  "총리",
  "총장",
  "촬영",
  "최근",
  "최상",
  "최선",
  "최신",
  "최악",
  "최종",
  "추석",
  "추억",
  "추진",
  "추천",
  "추측",
  "축구",
  "축소",
  "축제",
  "축하",
  "출근",
  "출발",
  "출산",
  "출신",
  "출연",
  "출입",
  "출장",
  "출판",
  "충격",
  "충고",
  "충돌",
  "충분히",
  "충청도",
  "취업",
  "취직",
  "취향",
  "치약",
  "친구",
  "친척",
  "칠십",
  "칠월",
  "칠판",
  "침대",
  "침묵",
  "침실",
  "칫솔",
  "칭찬",
  "카메라",
  "카운터",
  "칼국수",
  "캐릭터",
  "캠퍼스",
  "캠페인",
  "커튼",
  "컨디션",
  "컬러",
  "컴퓨터",
  "코끼리",
  "코미디",
  "콘서트",
  "콜라",
  "콤플렉스",
  "콩나물",
  "쾌감",
  "쿠데타",
  "크림",
  "큰길",
  "큰딸",
  "큰소리",
  "큰아들",
  "큰어머니",
  "큰일",
  "큰절",
  "클래식",
  "클럽",
  "킬로",
  "타입",
  "타자기",
  "탁구",
  "탁자",
  "탄생",
  "태권도",
  "태양",
  "태풍",
  "택시",
  "탤런트",
  "터널",
  "터미널",
  "테니스",
  "테스트",
  "테이블",
  "텔레비전",
  "토론",
  "토마토",
  "토요일",
  "통계",
  "통과",
  "통로",
  "통신",
  "통역",
  "통일",
  "통장",
  "통제",
  "통증",
  "통합",
  "통화",
  "퇴근",
  "퇴원",
  "퇴직금",
  "튀김",
  "트럭",
  "특급",
  "특별",
  "특성",
  "특수",
  "특징",
  "특히",
  "튼튼히",
  "티셔츠",
  "파란색",
  "파일",
  "파출소",
  "판결",
  "판단",
  "판매",
  "판사",
  "팔십",
  "팔월",
  "팝송",
  "패션",
  "팩스",
  "팩시밀리",
  "팬티",
  "퍼센트",
  "페인트",
  "편견",
  "편의",
  "편지",
  "편히",
  "평가",
  "평균",
  "평생",
  "평소",
  "평양",
  "평일",
  "평화",
  "포스터",
  "포인트",
  "포장",
  "포함",
  "표면",
  "표정",
  "표준",
  "표현",
  "품목",
  "품질",
  "풍경",
  "풍속",
  "풍습",
  "프랑스",
  "프린터",
  "플라스틱",
  "피곤",
  "피망",
  "피아노",
  "필름",
  "필수",
  "필요",
  "필자",
  "필통",
  "핑계",
  "하느님",
  "하늘",
  "하드웨어",
  "하룻밤",
  "하반기",
  "하숙집",
  "하순",
  "하여튼",
  "하지만",
  "하천",
  "하품",
  "하필",
  "학과",
  "학교",
  "학급",
  "학기",
  "학년",
  "학력",
  "학번",
  "학부모",
  "학비",
  "학생",
  "학술",
  "학습",
  "학용품",
  "학원",
  "학위",
  "학자",
  "학점",
  "한계",
  "한글",
  "한꺼번에",
  "한낮",
  "한눈",
  "한동안",
  "한때",
  "한라산",
  "한마디",
  "한문",
  "한번",
  "한복",
  "한식",
  "한여름",
  "한쪽",
  "할머니",
  "할아버지",
  "할인",
  "함께",
  "함부로",
  "합격",
  "합리적",
  "항공",
  "항구",
  "항상",
  "항의",
  "해결",
  "해군",
  "해답",
  "해당",
  "해물",
  "해석",
  "해설",
  "해수욕장",
  "해안",
  "핵심",
  "핸드백",
  "햄버거",
  "햇볕",
  "햇살",
  "행동",
  "행복",
  "행사",
  "행운",
  "행위",
  "향기",
  "향상",
  "향수",
  "허락",
  "허용",
  "헬기",
  "현관",
  "현금",
  "현대",
  "현상",
  "현실",
  "현장",
  "현재",
  "현지",
  "혈액",
  "협력",
  "형부",
  "형사",
  "형수",
  "형식",
  "형제",
  "형태",
  "형편",
  "혜택",
  "호기심",
  "호남",
  "호랑이",
  "호박",
  "호텔",
  "호흡",
  "혹시",
  "홀로",
  "홈페이지",
  "홍보",
  "홍수",
  "홍차",
  "화면",
  "화분",
  "화살",
  "화요일",
  "화장",
  "화학",
  "확보",
  "확인",
  "확장",
  "확정",
  "환갑",
  "환경",
  "환영",
  "환율",
  "환자",
  "활기",
  "활동",
  "활발히",
  "활용",
  "활짝",
  "회견",
  "회관",
  "회복",
  "회색",
  "회원",
  "회장",
  "회전",
  "횟수",
  "횡단보도",
  "효율적",
  "후반",
  "후춧가루",
  "훈련",
  "훨씬",
  "휴식",
  "휴일",
  "흉내",
  "흐름",
  "흑백",
  "흑인",
  "흔적",
  "흔히",
  "흥미",
  "흥분",
  "희곡",
  "희망",
  "희생",
  "흰색",
  "힘껏"
], k1e = [
  "abaisser",
  "abandon",
  "abdiquer",
  "abeille",
  "abolir",
  "aborder",
  "aboutir",
  "aboyer",
  "abrasif",
  "abreuver",
  "abriter",
  "abroger",
  "abrupt",
  "absence",
  "absolu",
  "absurde",
  "abusif",
  "abyssal",
  "académie",
  "acajou",
  "acarien",
  "accabler",
  "accepter",
  "acclamer",
  "accolade",
  "accroche",
  "accuser",
  "acerbe",
  "achat",
  "acheter",
  "aciduler",
  "acier",
  "acompte",
  "acquérir",
  "acronyme",
  "acteur",
  "actif",
  "actuel",
  "adepte",
  "adéquat",
  "adhésif",
  "adjectif",
  "adjuger",
  "admettre",
  "admirer",
  "adopter",
  "adorer",
  "adoucir",
  "adresse",
  "adroit",
  "adulte",
  "adverbe",
  "aérer",
  "aéronef",
  "affaire",
  "affecter",
  "affiche",
  "affreux",
  "affubler",
  "agacer",
  "agencer",
  "agile",
  "agiter",
  "agrafer",
  "agréable",
  "agrume",
  "aider",
  "aiguille",
  "ailier",
  "aimable",
  "aisance",
  "ajouter",
  "ajuster",
  "alarmer",
  "alchimie",
  "alerte",
  "algèbre",
  "algue",
  "aliéner",
  "aliment",
  "alléger",
  "alliage",
  "allouer",
  "allumer",
  "alourdir",
  "alpaga",
  "altesse",
  "alvéole",
  "amateur",
  "ambigu",
  "ambre",
  "aménager",
  "amertume",
  "amidon",
  "amiral",
  "amorcer",
  "amour",
  "amovible",
  "amphibie",
  "ampleur",
  "amusant",
  "analyse",
  "anaphore",
  "anarchie",
  "anatomie",
  "ancien",
  "anéantir",
  "angle",
  "angoisse",
  "anguleux",
  "animal",
  "annexer",
  "annonce",
  "annuel",
  "anodin",
  "anomalie",
  "anonyme",
  "anormal",
  "antenne",
  "antidote",
  "anxieux",
  "apaiser",
  "apéritif",
  "aplanir",
  "apologie",
  "appareil",
  "appeler",
  "apporter",
  "appuyer",
  "aquarium",
  "aqueduc",
  "arbitre",
  "arbuste",
  "ardeur",
  "ardoise",
  "argent",
  "arlequin",
  "armature",
  "armement",
  "armoire",
  "armure",
  "arpenter",
  "arracher",
  "arriver",
  "arroser",
  "arsenic",
  "artériel",
  "article",
  "aspect",
  "asphalte",
  "aspirer",
  "assaut",
  "asservir",
  "assiette",
  "associer",
  "assurer",
  "asticot",
  "astre",
  "astuce",
  "atelier",
  "atome",
  "atrium",
  "atroce",
  "attaque",
  "attentif",
  "attirer",
  "attraper",
  "aubaine",
  "auberge",
  "audace",
  "audible",
  "augurer",
  "aurore",
  "automne",
  "autruche",
  "avaler",
  "avancer",
  "avarice",
  "avenir",
  "averse",
  "aveugle",
  "aviateur",
  "avide",
  "avion",
  "aviser",
  "avoine",
  "avouer",
  "avril",
  "axial",
  "axiome",
  "badge",
  "bafouer",
  "bagage",
  "baguette",
  "baignade",
  "balancer",
  "balcon",
  "baleine",
  "balisage",
  "bambin",
  "bancaire",
  "bandage",
  "banlieue",
  "bannière",
  "banquier",
  "barbier",
  "baril",
  "baron",
  "barque",
  "barrage",
  "bassin",
  "bastion",
  "bataille",
  "bateau",
  "batterie",
  "baudrier",
  "bavarder",
  "belette",
  "bélier",
  "belote",
  "bénéfice",
  "berceau",
  "berger",
  "berline",
  "bermuda",
  "besace",
  "besogne",
  "bétail",
  "beurre",
  "biberon",
  "bicycle",
  "bidule",
  "bijou",
  "bilan",
  "bilingue",
  "billard",
  "binaire",
  "biologie",
  "biopsie",
  "biotype",
  "biscuit",
  "bison",
  "bistouri",
  "bitume",
  "bizarre",
  "blafard",
  "blague",
  "blanchir",
  "blessant",
  "blinder",
  "blond",
  "bloquer",
  "blouson",
  "bobard",
  "bobine",
  "boire",
  "boiser",
  "bolide",
  "bonbon",
  "bondir",
  "bonheur",
  "bonifier",
  "bonus",
  "bordure",
  "borne",
  "botte",
  "boucle",
  "boueux",
  "bougie",
  "boulon",
  "bouquin",
  "bourse",
  "boussole",
  "boutique",
  "boxeur",
  "branche",
  "brasier",
  "brave",
  "brebis",
  "brèche",
  "breuvage",
  "bricoler",
  "brigade",
  "brillant",
  "brioche",
  "brique",
  "brochure",
  "broder",
  "bronzer",
  "brousse",
  "broyeur",
  "brume",
  "brusque",
  "brutal",
  "bruyant",
  "buffle",
  "buisson",
  "bulletin",
  "bureau",
  "burin",
  "bustier",
  "butiner",
  "butoir",
  "buvable",
  "buvette",
  "cabanon",
  "cabine",
  "cachette",
  "cadeau",
  "cadre",
  "caféine",
  "caillou",
  "caisson",
  "calculer",
  "calepin",
  "calibre",
  "calmer",
  "calomnie",
  "calvaire",
  "camarade",
  "caméra",
  "camion",
  "campagne",
  "canal",
  "caneton",
  "canon",
  "cantine",
  "canular",
  "capable",
  "caporal",
  "caprice",
  "capsule",
  "capter",
  "capuche",
  "carabine",
  "carbone",
  "caresser",
  "caribou",
  "carnage",
  "carotte",
  "carreau",
  "carton",
  "cascade",
  "casier",
  "casque",
  "cassure",
  "causer",
  "caution",
  "cavalier",
  "caverne",
  "caviar",
  "cédille",
  "ceinture",
  "céleste",
  "cellule",
  "cendrier",
  "censurer",
  "central",
  "cercle",
  "cérébral",
  "cerise",
  "cerner",
  "cerveau",
  "cesser",
  "chagrin",
  "chaise",
  "chaleur",
  "chambre",
  "chance",
  "chapitre",
  "charbon",
  "chasseur",
  "chaton",
  "chausson",
  "chavirer",
  "chemise",
  "chenille",
  "chéquier",
  "chercher",
  "cheval",
  "chien",
  "chiffre",
  "chignon",
  "chimère",
  "chiot",
  "chlorure",
  "chocolat",
  "choisir",
  "chose",
  "chouette",
  "chrome",
  "chute",
  "cigare",
  "cigogne",
  "cimenter",
  "cinéma",
  "cintrer",
  "circuler",
  "cirer",
  "cirque",
  "citerne",
  "citoyen",
  "citron",
  "civil",
  "clairon",
  "clameur",
  "claquer",
  "classe",
  "clavier",
  "client",
  "cligner",
  "climat",
  "clivage",
  "cloche",
  "clonage",
  "cloporte",
  "cobalt",
  "cobra",
  "cocasse",
  "cocotier",
  "coder",
  "codifier",
  "coffre",
  "cogner",
  "cohésion",
  "coiffer",
  "coincer",
  "colère",
  "colibri",
  "colline",
  "colmater",
  "colonel",
  "combat",
  "comédie",
  "commande",
  "compact",
  "concert",
  "conduire",
  "confier",
  "congeler",
  "connoter",
  "consonne",
  "contact",
  "convexe",
  "copain",
  "copie",
  "corail",
  "corbeau",
  "cordage",
  "corniche",
  "corpus",
  "correct",
  "cortège",
  "cosmique",
  "costume",
  "coton",
  "coude",
  "coupure",
  "courage",
  "couteau",
  "couvrir",
  "coyote",
  "crabe",
  "crainte",
  "cravate",
  "crayon",
  "créature",
  "créditer",
  "crémeux",
  "creuser",
  "crevette",
  "cribler",
  "crier",
  "cristal",
  "critère",
  "croire",
  "croquer",
  "crotale",
  "crucial",
  "cruel",
  "crypter",
  "cubique",
  "cueillir",
  "cuillère",
  "cuisine",
  "cuivre",
  "culminer",
  "cultiver",
  "cumuler",
  "cupide",
  "curatif",
  "curseur",
  "cyanure",
  "cycle",
  "cylindre",
  "cynique",
  "daigner",
  "damier",
  "danger",
  "danseur",
  "dauphin",
  "débattre",
  "débiter",
  "déborder",
  "débrider",
  "débutant",
  "décaler",
  "décembre",
  "déchirer",
  "décider",
  "déclarer",
  "décorer",
  "décrire",
  "décupler",
  "dédale",
  "déductif",
  "déesse",
  "défensif",
  "défiler",
  "défrayer",
  "dégager",
  "dégivrer",
  "déglutir",
  "dégrafer",
  "déjeuner",
  "délice",
  "déloger",
  "demander",
  "demeurer",
  "démolir",
  "dénicher",
  "dénouer",
  "dentelle",
  "dénuder",
  "départ",
  "dépenser",
  "déphaser",
  "déplacer",
  "déposer",
  "déranger",
  "dérober",
  "désastre",
  "descente",
  "désert",
  "désigner",
  "désobéir",
  "dessiner",
  "destrier",
  "détacher",
  "détester",
  "détourer",
  "détresse",
  "devancer",
  "devenir",
  "deviner",
  "devoir",
  "diable",
  "dialogue",
  "diamant",
  "dicter",
  "différer",
  "digérer",
  "digital",
  "digne",
  "diluer",
  "dimanche",
  "diminuer",
  "dioxyde",
  "directif",
  "diriger",
  "discuter",
  "disposer",
  "dissiper",
  "distance",
  "divertir",
  "diviser",
  "docile",
  "docteur",
  "dogme",
  "doigt",
  "domaine",
  "domicile",
  "dompter",
  "donateur",
  "donjon",
  "donner",
  "dopamine",
  "dortoir",
  "dorure",
  "dosage",
  "doseur",
  "dossier",
  "dotation",
  "douanier",
  "double",
  "douceur",
  "douter",
  "doyen",
  "dragon",
  "draper",
  "dresser",
  "dribbler",
  "droiture",
  "duperie",
  "duplexe",
  "durable",
  "durcir",
  "dynastie",
  "éblouir",
  "écarter",
  "écharpe",
  "échelle",
  "éclairer",
  "éclipse",
  "éclore",
  "écluse",
  "école",
  "économie",
  "écorce",
  "écouter",
  "écraser",
  "écrémer",
  "écrivain",
  "écrou",
  "écume",
  "écureuil",
  "édifier",
  "éduquer",
  "effacer",
  "effectif",
  "effigie",
  "effort",
  "effrayer",
  "effusion",
  "égaliser",
  "égarer",
  "éjecter",
  "élaborer",
  "élargir",
  "électron",
  "élégant",
  "éléphant",
  "élève",
  "éligible",
  "élitisme",
  "éloge",
  "élucider",
  "éluder",
  "emballer",
  "embellir",
  "embryon",
  "émeraude",
  "émission",
  "emmener",
  "émotion",
  "émouvoir",
  "empereur",
  "employer",
  "emporter",
  "emprise",
  "émulsion",
  "encadrer",
  "enchère",
  "enclave",
  "encoche",
  "endiguer",
  "endosser",
  "endroit",
  "enduire",
  "énergie",
  "enfance",
  "enfermer",
  "enfouir",
  "engager",
  "engin",
  "englober",
  "énigme",
  "enjamber",
  "enjeu",
  "enlever",
  "ennemi",
  "ennuyeux",
  "enrichir",
  "enrobage",
  "enseigne",
  "entasser",
  "entendre",
  "entier",
  "entourer",
  "entraver",
  "énumérer",
  "envahir",
  "enviable",
  "envoyer",
  "enzyme",
  "éolien",
  "épaissir",
  "épargne",
  "épatant",
  "épaule",
  "épicerie",
  "épidémie",
  "épier",
  "épilogue",
  "épine",
  "épisode",
  "épitaphe",
  "époque",
  "épreuve",
  "éprouver",
  "épuisant",
  "équerre",
  "équipe",
  "ériger",
  "érosion",
  "erreur",
  "éruption",
  "escalier",
  "espadon",
  "espèce",
  "espiègle",
  "espoir",
  "esprit",
  "esquiver",
  "essayer",
  "essence",
  "essieu",
  "essorer",
  "estime",
  "estomac",
  "estrade",
  "étagère",
  "étaler",
  "étanche",
  "étatique",
  "éteindre",
  "étendoir",
  "éternel",
  "éthanol",
  "éthique",
  "ethnie",
  "étirer",
  "étoffer",
  "étoile",
  "étonnant",
  "étourdir",
  "étrange",
  "étroit",
  "étude",
  "euphorie",
  "évaluer",
  "évasion",
  "éventail",
  "évidence",
  "éviter",
  "évolutif",
  "évoquer",
  "exact",
  "exagérer",
  "exaucer",
  "exceller",
  "excitant",
  "exclusif",
  "excuse",
  "exécuter",
  "exemple",
  "exercer",
  "exhaler",
  "exhorter",
  "exigence",
  "exiler",
  "exister",
  "exotique",
  "expédier",
  "explorer",
  "exposer",
  "exprimer",
  "exquis",
  "extensif",
  "extraire",
  "exulter",
  "fable",
  "fabuleux",
  "facette",
  "facile",
  "facture",
  "faiblir",
  "falaise",
  "fameux",
  "famille",
  "farceur",
  "farfelu",
  "farine",
  "farouche",
  "fasciner",
  "fatal",
  "fatigue",
  "faucon",
  "fautif",
  "faveur",
  "favori",
  "fébrile",
  "féconder",
  "fédérer",
  "félin",
  "femme",
  "fémur",
  "fendoir",
  "féodal",
  "fermer",
  "féroce",
  "ferveur",
  "festival",
  "feuille",
  "feutre",
  "février",
  "fiasco",
  "ficeler",
  "fictif",
  "fidèle",
  "figure",
  "filature",
  "filetage",
  "filière",
  "filleul",
  "filmer",
  "filou",
  "filtrer",
  "financer",
  "finir",
  "fiole",
  "firme",
  "fissure",
  "fixer",
  "flairer",
  "flamme",
  "flasque",
  "flatteur",
  "fléau",
  "flèche",
  "fleur",
  "flexion",
  "flocon",
  "flore",
  "fluctuer",
  "fluide",
  "fluvial",
  "folie",
  "fonderie",
  "fongible",
  "fontaine",
  "forcer",
  "forgeron",
  "formuler",
  "fortune",
  "fossile",
  "foudre",
  "fougère",
  "fouiller",
  "foulure",
  "fourmi",
  "fragile",
  "fraise",
  "franchir",
  "frapper",
  "frayeur",
  "frégate",
  "freiner",
  "frelon",
  "frémir",
  "frénésie",
  "frère",
  "friable",
  "friction",
  "frisson",
  "frivole",
  "froid",
  "fromage",
  "frontal",
  "frotter",
  "fruit",
  "fugitif",
  "fuite",
  "fureur",
  "furieux",
  "furtif",
  "fusion",
  "futur",
  "gagner",
  "galaxie",
  "galerie",
  "gambader",
  "garantir",
  "gardien",
  "garnir",
  "garrigue",
  "gazelle",
  "gazon",
  "géant",
  "gélatine",
  "gélule",
  "gendarme",
  "général",
  "génie",
  "genou",
  "gentil",
  "géologie",
  "géomètre",
  "géranium",
  "germe",
  "gestuel",
  "geyser",
  "gibier",
  "gicler",
  "girafe",
  "givre",
  "glace",
  "glaive",
  "glisser",
  "globe",
  "gloire",
  "glorieux",
  "golfeur",
  "gomme",
  "gonfler",
  "gorge",
  "gorille",
  "goudron",
  "gouffre",
  "goulot",
  "goupille",
  "gourmand",
  "goutte",
  "graduel",
  "graffiti",
  "graine",
  "grand",
  "grappin",
  "gratuit",
  "gravir",
  "grenat",
  "griffure",
  "griller",
  "grimper",
  "grogner",
  "gronder",
  "grotte",
  "groupe",
  "gruger",
  "grutier",
  "gruyère",
  "guépard",
  "guerrier",
  "guide",
  "guimauve",
  "guitare",
  "gustatif",
  "gymnaste",
  "gyrostat",
  "habitude",
  "hachoir",
  "halte",
  "hameau",
  "hangar",
  "hanneton",
  "haricot",
  "harmonie",
  "harpon",
  "hasard",
  "hélium",
  "hématome",
  "herbe",
  "hérisson",
  "hermine",
  "héron",
  "hésiter",
  "heureux",
  "hiberner",
  "hibou",
  "hilarant",
  "histoire",
  "hiver",
  "homard",
  "hommage",
  "homogène",
  "honneur",
  "honorer",
  "honteux",
  "horde",
  "horizon",
  "horloge",
  "hormone",
  "horrible",
  "houleux",
  "housse",
  "hublot",
  "huileux",
  "humain",
  "humble",
  "humide",
  "humour",
  "hurler",
  "hydromel",
  "hygiène",
  "hymne",
  "hypnose",
  "idylle",
  "ignorer",
  "iguane",
  "illicite",
  "illusion",
  "image",
  "imbiber",
  "imiter",
  "immense",
  "immobile",
  "immuable",
  "impact",
  "impérial",
  "implorer",
  "imposer",
  "imprimer",
  "imputer",
  "incarner",
  "incendie",
  "incident",
  "incliner",
  "incolore",
  "indexer",
  "indice",
  "inductif",
  "inédit",
  "ineptie",
  "inexact",
  "infini",
  "infliger",
  "informer",
  "infusion",
  "ingérer",
  "inhaler",
  "inhiber",
  "injecter",
  "injure",
  "innocent",
  "inoculer",
  "inonder",
  "inscrire",
  "insecte",
  "insigne",
  "insolite",
  "inspirer",
  "instinct",
  "insulter",
  "intact",
  "intense",
  "intime",
  "intrigue",
  "intuitif",
  "inutile",
  "invasion",
  "inventer",
  "inviter",
  "invoquer",
  "ironique",
  "irradier",
  "irréel",
  "irriter",
  "isoler",
  "ivoire",
  "ivresse",
  "jaguar",
  "jaillir",
  "jambe",
  "janvier",
  "jardin",
  "jauger",
  "jaune",
  "javelot",
  "jetable",
  "jeton",
  "jeudi",
  "jeunesse",
  "joindre",
  "joncher",
  "jongler",
  "joueur",
  "jouissif",
  "journal",
  "jovial",
  "joyau",
  "joyeux",
  "jubiler",
  "jugement",
  "junior",
  "jupon",
  "juriste",
  "justice",
  "juteux",
  "juvénile",
  "kayak",
  "kimono",
  "kiosque",
  "label",
  "labial",
  "labourer",
  "lacérer",
  "lactose",
  "lagune",
  "laine",
  "laisser",
  "laitier",
  "lambeau",
  "lamelle",
  "lampe",
  "lanceur",
  "langage",
  "lanterne",
  "lapin",
  "largeur",
  "larme",
  "laurier",
  "lavabo",
  "lavoir",
  "lecture",
  "légal",
  "léger",
  "légume",
  "lessive",
  "lettre",
  "levier",
  "lexique",
  "lézard",
  "liasse",
  "libérer",
  "libre",
  "licence",
  "licorne",
  "liège",
  "lièvre",
  "ligature",
  "ligoter",
  "ligue",
  "limer",
  "limite",
  "limonade",
  "limpide",
  "linéaire",
  "lingot",
  "lionceau",
  "liquide",
  "lisière",
  "lister",
  "lithium",
  "litige",
  "littoral",
  "livreur",
  "logique",
  "lointain",
  "loisir",
  "lombric",
  "loterie",
  "louer",
  "lourd",
  "loutre",
  "louve",
  "loyal",
  "lubie",
  "lucide",
  "lucratif",
  "lueur",
  "lugubre",
  "luisant",
  "lumière",
  "lunaire",
  "lundi",
  "luron",
  "lutter",
  "luxueux",
  "machine",
  "magasin",
  "magenta",
  "magique",
  "maigre",
  "maillon",
  "maintien",
  "mairie",
  "maison",
  "majorer",
  "malaxer",
  "maléfice",
  "malheur",
  "malice",
  "mallette",
  "mammouth",
  "mandater",
  "maniable",
  "manquant",
  "manteau",
  "manuel",
  "marathon",
  "marbre",
  "marchand",
  "mardi",
  "maritime",
  "marqueur",
  "marron",
  "marteler",
  "mascotte",
  "massif",
  "matériel",
  "matière",
  "matraque",
  "maudire",
  "maussade",
  "mauve",
  "maximal",
  "méchant",
  "méconnu",
  "médaille",
  "médecin",
  "méditer",
  "méduse",
  "meilleur",
  "mélange",
  "mélodie",
  "membre",
  "mémoire",
  "menacer",
  "mener",
  "menhir",
  "mensonge",
  "mentor",
  "mercredi",
  "mérite",
  "merle",
  "messager",
  "mesure",
  "métal",
  "météore",
  "méthode",
  "métier",
  "meuble",
  "miauler",
  "microbe",
  "miette",
  "mignon",
  "migrer",
  "milieu",
  "million",
  "mimique",
  "mince",
  "minéral",
  "minimal",
  "minorer",
  "minute",
  "miracle",
  "miroiter",
  "missile",
  "mixte",
  "mobile",
  "moderne",
  "moelleux",
  "mondial",
  "moniteur",
  "monnaie",
  "monotone",
  "monstre",
  "montagne",
  "monument",
  "moqueur",
  "morceau",
  "morsure",
  "mortier",
  "moteur",
  "motif",
  "mouche",
  "moufle",
  "moulin",
  "mousson",
  "mouton",
  "mouvant",
  "multiple",
  "munition",
  "muraille",
  "murène",
  "murmure",
  "muscle",
  "muséum",
  "musicien",
  "mutation",
  "muter",
  "mutuel",
  "myriade",
  "myrtille",
  "mystère",
  "mythique",
  "nageur",
  "nappe",
  "narquois",
  "narrer",
  "natation",
  "nation",
  "nature",
  "naufrage",
  "nautique",
  "navire",
  "nébuleux",
  "nectar",
  "néfaste",
  "négation",
  "négliger",
  "négocier",
  "neige",
  "nerveux",
  "nettoyer",
  "neurone",
  "neutron",
  "neveu",
  "niche",
  "nickel",
  "nitrate",
  "niveau",
  "noble",
  "nocif",
  "nocturne",
  "noirceur",
  "noisette",
  "nomade",
  "nombreux",
  "nommer",
  "normatif",
  "notable",
  "notifier",
  "notoire",
  "nourrir",
  "nouveau",
  "novateur",
  "novembre",
  "novice",
  "nuage",
  "nuancer",
  "nuire",
  "nuisible",
  "numéro",
  "nuptial",
  "nuque",
  "nutritif",
  "obéir",
  "objectif",
  "obliger",
  "obscur",
  "observer",
  "obstacle",
  "obtenir",
  "obturer",
  "occasion",
  "occuper",
  "océan",
  "octobre",
  "octroyer",
  "octupler",
  "oculaire",
  "odeur",
  "odorant",
  "offenser",
  "officier",
  "offrir",
  "ogive",
  "oiseau",
  "oisillon",
  "olfactif",
  "olivier",
  "ombrage",
  "omettre",
  "onctueux",
  "onduler",
  "onéreux",
  "onirique",
  "opale",
  "opaque",
  "opérer",
  "opinion",
  "opportun",
  "opprimer",
  "opter",
  "optique",
  "orageux",
  "orange",
  "orbite",
  "ordonner",
  "oreille",
  "organe",
  "orgueil",
  "orifice",
  "ornement",
  "orque",
  "ortie",
  "osciller",
  "osmose",
  "ossature",
  "otarie",
  "ouragan",
  "ourson",
  "outil",
  "outrager",
  "ouvrage",
  "ovation",
  "oxyde",
  "oxygène",
  "ozone",
  "paisible",
  "palace",
  "palmarès",
  "palourde",
  "palper",
  "panache",
  "panda",
  "pangolin",
  "paniquer",
  "panneau",
  "panorama",
  "pantalon",
  "papaye",
  "papier",
  "papoter",
  "papyrus",
  "paradoxe",
  "parcelle",
  "paresse",
  "parfumer",
  "parler",
  "parole",
  "parrain",
  "parsemer",
  "partager",
  "parure",
  "parvenir",
  "passion",
  "pastèque",
  "paternel",
  "patience",
  "patron",
  "pavillon",
  "pavoiser",
  "payer",
  "paysage",
  "peigne",
  "peintre",
  "pelage",
  "pélican",
  "pelle",
  "pelouse",
  "peluche",
  "pendule",
  "pénétrer",
  "pénible",
  "pensif",
  "pénurie",
  "pépite",
  "péplum",
  "perdrix",
  "perforer",
  "période",
  "permuter",
  "perplexe",
  "persil",
  "perte",
  "peser",
  "pétale",
  "petit",
  "pétrir",
  "peuple",
  "pharaon",
  "phobie",
  "phoque",
  "photon",
  "phrase",
  "physique",
  "piano",
  "pictural",
  "pièce",
  "pierre",
  "pieuvre",
  "pilote",
  "pinceau",
  "pipette",
  "piquer",
  "pirogue",
  "piscine",
  "piston",
  "pivoter",
  "pixel",
  "pizza",
  "placard",
  "plafond",
  "plaisir",
  "planer",
  "plaque",
  "plastron",
  "plateau",
  "pleurer",
  "plexus",
  "pliage",
  "plomb",
  "plonger",
  "pluie",
  "plumage",
  "pochette",
  "poésie",
  "poète",
  "pointe",
  "poirier",
  "poisson",
  "poivre",
  "polaire",
  "policier",
  "pollen",
  "polygone",
  "pommade",
  "pompier",
  "ponctuel",
  "pondérer",
  "poney",
  "portique",
  "position",
  "posséder",
  "posture",
  "potager",
  "poteau",
  "potion",
  "pouce",
  "poulain",
  "poumon",
  "pourpre",
  "poussin",
  "pouvoir",
  "prairie",
  "pratique",
  "précieux",
  "prédire",
  "préfixe",
  "prélude",
  "prénom",
  "présence",
  "prétexte",
  "prévoir",
  "primitif",
  "prince",
  "prison",
  "priver",
  "problème",
  "procéder",
  "prodige",
  "profond",
  "progrès",
  "proie",
  "projeter",
  "prologue",
  "promener",
  "propre",
  "prospère",
  "protéger",
  "prouesse",
  "proverbe",
  "prudence",
  "pruneau",
  "psychose",
  "public",
  "puceron",
  "puiser",
  "pulpe",
  "pulsar",
  "punaise",
  "punitif",
  "pupitre",
  "purifier",
  "puzzle",
  "pyramide",
  "quasar",
  "querelle",
  "question",
  "quiétude",
  "quitter",
  "quotient",
  "racine",
  "raconter",
  "radieux",
  "ragondin",
  "raideur",
  "raisin",
  "ralentir",
  "rallonge",
  "ramasser",
  "rapide",
  "rasage",
  "ratisser",
  "ravager",
  "ravin",
  "rayonner",
  "réactif",
  "réagir",
  "réaliser",
  "réanimer",
  "recevoir",
  "réciter",
  "réclamer",
  "récolter",
  "recruter",
  "reculer",
  "recycler",
  "rédiger",
  "redouter",
  "refaire",
  "réflexe",
  "réformer",
  "refrain",
  "refuge",
  "régalien",
  "région",
  "réglage",
  "régulier",
  "réitérer",
  "rejeter",
  "rejouer",
  "relatif",
  "relever",
  "relief",
  "remarque",
  "remède",
  "remise",
  "remonter",
  "remplir",
  "remuer",
  "renard",
  "renfort",
  "renifler",
  "renoncer",
  "rentrer",
  "renvoi",
  "replier",
  "reporter",
  "reprise",
  "reptile",
  "requin",
  "réserve",
  "résineux",
  "résoudre",
  "respect",
  "rester",
  "résultat",
  "rétablir",
  "retenir",
  "réticule",
  "retomber",
  "retracer",
  "réunion",
  "réussir",
  "revanche",
  "revivre",
  "révolte",
  "révulsif",
  "richesse",
  "rideau",
  "rieur",
  "rigide",
  "rigoler",
  "rincer",
  "riposter",
  "risible",
  "risque",
  "rituel",
  "rival",
  "rivière",
  "rocheux",
  "romance",
  "rompre",
  "ronce",
  "rondin",
  "roseau",
  "rosier",
  "rotatif",
  "rotor",
  "rotule",
  "rouge",
  "rouille",
  "rouleau",
  "routine",
  "royaume",
  "ruban",
  "rubis",
  "ruche",
  "ruelle",
  "rugueux",
  "ruiner",
  "ruisseau",
  "ruser",
  "rustique",
  "rythme",
  "sabler",
  "saboter",
  "sabre",
  "sacoche",
  "safari",
  "sagesse",
  "saisir",
  "salade",
  "salive",
  "salon",
  "saluer",
  "samedi",
  "sanction",
  "sanglier",
  "sarcasme",
  "sardine",
  "saturer",
  "saugrenu",
  "saumon",
  "sauter",
  "sauvage",
  "savant",
  "savonner",
  "scalpel",
  "scandale",
  "scélérat",
  "scénario",
  "sceptre",
  "schéma",
  "science",
  "scinder",
  "score",
  "scrutin",
  "sculpter",
  "séance",
  "sécable",
  "sécher",
  "secouer",
  "sécréter",
  "sédatif",
  "séduire",
  "seigneur",
  "séjour",
  "sélectif",
  "semaine",
  "sembler",
  "semence",
  "séminal",
  "sénateur",
  "sensible",
  "sentence",
  "séparer",
  "séquence",
  "serein",
  "sergent",
  "sérieux",
  "serrure",
  "sérum",
  "service",
  "sésame",
  "sévir",
  "sevrage",
  "sextuple",
  "sidéral",
  "siècle",
  "siéger",
  "siffler",
  "sigle",
  "signal",
  "silence",
  "silicium",
  "simple",
  "sincère",
  "sinistre",
  "siphon",
  "sirop",
  "sismique",
  "situer",
  "skier",
  "social",
  "socle",
  "sodium",
  "soigneux",
  "soldat",
  "soleil",
  "solitude",
  "soluble",
  "sombre",
  "sommeil",
  "somnoler",
  "sonde",
  "songeur",
  "sonnette",
  "sonore",
  "sorcier",
  "sortir",
  "sosie",
  "sottise",
  "soucieux",
  "soudure",
  "souffle",
  "soulever",
  "soupape",
  "source",
  "soutirer",
  "souvenir",
  "spacieux",
  "spatial",
  "spécial",
  "sphère",
  "spiral",
  "stable",
  "station",
  "sternum",
  "stimulus",
  "stipuler",
  "strict",
  "studieux",
  "stupeur",
  "styliste",
  "sublime",
  "substrat",
  "subtil",
  "subvenir",
  "succès",
  "sucre",
  "suffixe",
  "suggérer",
  "suiveur",
  "sulfate",
  "superbe",
  "supplier",
  "surface",
  "suricate",
  "surmener",
  "surprise",
  "sursaut",
  "survie",
  "suspect",
  "syllabe",
  "symbole",
  "symétrie",
  "synapse",
  "syntaxe",
  "système",
  "tabac",
  "tablier",
  "tactile",
  "tailler",
  "talent",
  "talisman",
  "talonner",
  "tambour",
  "tamiser",
  "tangible",
  "tapis",
  "taquiner",
  "tarder",
  "tarif",
  "tartine",
  "tasse",
  "tatami",
  "tatouage",
  "taupe",
  "taureau",
  "taxer",
  "témoin",
  "temporel",
  "tenaille",
  "tendre",
  "teneur",
  "tenir",
  "tension",
  "terminer",
  "terne",
  "terrible",
  "tétine",
  "texte",
  "thème",
  "théorie",
  "thérapie",
  "thorax",
  "tibia",
  "tiède",
  "timide",
  "tirelire",
  "tiroir",
  "tissu",
  "titane",
  "titre",
  "tituber",
  "toboggan",
  "tolérant",
  "tomate",
  "tonique",
  "tonneau",
  "toponyme",
  "torche",
  "tordre",
  "tornade",
  "torpille",
  "torrent",
  "torse",
  "tortue",
  "totem",
  "toucher",
  "tournage",
  "tousser",
  "toxine",
  "traction",
  "trafic",
  "tragique",
  "trahir",
  "train",
  "trancher",
  "travail",
  "trèfle",
  "tremper",
  "trésor",
  "treuil",
  "triage",
  "tribunal",
  "tricoter",
  "trilogie",
  "triomphe",
  "tripler",
  "triturer",
  "trivial",
  "trombone",
  "tronc",
  "tropical",
  "troupeau",
  "tuile",
  "tulipe",
  "tumulte",
  "tunnel",
  "turbine",
  "tuteur",
  "tutoyer",
  "tuyau",
  "tympan",
  "typhon",
  "typique",
  "tyran",
  "ubuesque",
  "ultime",
  "ultrason",
  "unanime",
  "unifier",
  "union",
  "unique",
  "unitaire",
  "univers",
  "uranium",
  "urbain",
  "urticant",
  "usage",
  "usine",
  "usuel",
  "usure",
  "utile",
  "utopie",
  "vacarme",
  "vaccin",
  "vagabond",
  "vague",
  "vaillant",
  "vaincre",
  "vaisseau",
  "valable",
  "valise",
  "vallon",
  "valve",
  "vampire",
  "vanille",
  "vapeur",
  "varier",
  "vaseux",
  "vassal",
  "vaste",
  "vecteur",
  "vedette",
  "végétal",
  "véhicule",
  "veinard",
  "véloce",
  "vendredi",
  "vénérer",
  "venger",
  "venimeux",
  "ventouse",
  "verdure",
  "vérin",
  "vernir",
  "verrou",
  "verser",
  "vertu",
  "veston",
  "vétéran",
  "vétuste",
  "vexant",
  "vexer",
  "viaduc",
  "viande",
  "victoire",
  "vidange",
  "vidéo",
  "vignette",
  "vigueur",
  "vilain",
  "village",
  "vinaigre",
  "violon",
  "vipère",
  "virement",
  "virtuose",
  "virus",
  "visage",
  "viseur",
  "vision",
  "visqueux",
  "visuel",
  "vital",
  "vitesse",
  "viticole",
  "vitrine",
  "vivace",
  "vivipare",
  "vocation",
  "voguer",
  "voile",
  "voisin",
  "voiture",
  "volaille",
  "volcan",
  "voltiger",
  "volume",
  "vorace",
  "vortex",
  "voter",
  "vouloir",
  "voyage",
  "voyelle",
  "wagon",
  "xénon",
  "yacht",
  "zèbre",
  "zénith",
  "zeste",
  "zoologie"
], S1e = [
  "abaco",
  "abbaglio",
  "abbinato",
  "abete",
  "abisso",
  "abolire",
  "abrasivo",
  "abrogato",
  "accadere",
  "accenno",
  "accusato",
  "acetone",
  "achille",
  "acido",
  "acqua",
  "acre",
  "acrilico",
  "acrobata",
  "acuto",
  "adagio",
  "addebito",
  "addome",
  "adeguato",
  "aderire",
  "adipe",
  "adottare",
  "adulare",
  "affabile",
  "affetto",
  "affisso",
  "affranto",
  "aforisma",
  "afoso",
  "africano",
  "agave",
  "agente",
  "agevole",
  "aggancio",
  "agire",
  "agitare",
  "agonismo",
  "agricolo",
  "agrumeto",
  "aguzzo",
  "alabarda",
  "alato",
  "albatro",
  "alberato",
  "albo",
  "albume",
  "alce",
  "alcolico",
  "alettone",
  "alfa",
  "algebra",
  "aliante",
  "alibi",
  "alimento",
  "allagato",
  "allegro",
  "allievo",
  "allodola",
  "allusivo",
  "almeno",
  "alogeno",
  "alpaca",
  "alpestre",
  "altalena",
  "alterno",
  "alticcio",
  "altrove",
  "alunno",
  "alveolo",
  "alzare",
  "amalgama",
  "amanita",
  "amarena",
  "ambito",
  "ambrato",
  "ameba",
  "america",
  "ametista",
  "amico",
  "ammasso",
  "ammenda",
  "ammirare",
  "ammonito",
  "amore",
  "ampio",
  "ampliare",
  "amuleto",
  "anacardo",
  "anagrafe",
  "analista",
  "anarchia",
  "anatra",
  "anca",
  "ancella",
  "ancora",
  "andare",
  "andrea",
  "anello",
  "angelo",
  "angolare",
  "angusto",
  "anima",
  "annegare",
  "annidato",
  "anno",
  "annuncio",
  "anonimo",
  "anticipo",
  "anzi",
  "apatico",
  "apertura",
  "apode",
  "apparire",
  "appetito",
  "appoggio",
  "approdo",
  "appunto",
  "aprile",
  "arabica",
  "arachide",
  "aragosta",
  "araldica",
  "arancio",
  "aratura",
  "arazzo",
  "arbitro",
  "archivio",
  "ardito",
  "arenile",
  "argento",
  "argine",
  "arguto",
  "aria",
  "armonia",
  "arnese",
  "arredato",
  "arringa",
  "arrosto",
  "arsenico",
  "arso",
  "artefice",
  "arzillo",
  "asciutto",
  "ascolto",
  "asepsi",
  "asettico",
  "asfalto",
  "asino",
  "asola",
  "aspirato",
  "aspro",
  "assaggio",
  "asse",
  "assoluto",
  "assurdo",
  "asta",
  "astenuto",
  "astice",
  "astratto",
  "atavico",
  "ateismo",
  "atomico",
  "atono",
  "attesa",
  "attivare",
  "attorno",
  "attrito",
  "attuale",
  "ausilio",
  "austria",
  "autista",
  "autonomo",
  "autunno",
  "avanzato",
  "avere",
  "avvenire",
  "avviso",
  "avvolgere",
  "azione",
  "azoto",
  "azzimo",
  "azzurro",
  "babele",
  "baccano",
  "bacino",
  "baco",
  "badessa",
  "badilata",
  "bagnato",
  "baita",
  "balcone",
  "baldo",
  "balena",
  "ballata",
  "balzano",
  "bambino",
  "bandire",
  "baraonda",
  "barbaro",
  "barca",
  "baritono",
  "barlume",
  "barocco",
  "basilico",
  "basso",
  "batosta",
  "battuto",
  "baule",
  "bava",
  "bavosa",
  "becco",
  "beffa",
  "belgio",
  "belva",
  "benda",
  "benevole",
  "benigno",
  "benzina",
  "bere",
  "berlina",
  "beta",
  "bibita",
  "bici",
  "bidone",
  "bifido",
  "biga",
  "bilancia",
  "bimbo",
  "binocolo",
  "biologo",
  "bipede",
  "bipolare",
  "birbante",
  "birra",
  "biscotto",
  "bisesto",
  "bisnonno",
  "bisonte",
  "bisturi",
  "bizzarro",
  "blando",
  "blatta",
  "bollito",
  "bonifico",
  "bordo",
  "bosco",
  "botanico",
  "bottino",
  "bozzolo",
  "braccio",
  "bradipo",
  "brama",
  "branca",
  "bravura",
  "bretella",
  "brevetto",
  "brezza",
  "briglia",
  "brillante",
  "brindare",
  "broccolo",
  "brodo",
  "bronzina",
  "brullo",
  "bruno",
  "bubbone",
  "buca",
  "budino",
  "buffone",
  "buio",
  "bulbo",
  "buono",
  "burlone",
  "burrasca",
  "bussola",
  "busta",
  "cadetto",
  "caduco",
  "calamaro",
  "calcolo",
  "calesse",
  "calibro",
  "calmo",
  "caloria",
  "cambusa",
  "camerata",
  "camicia",
  "cammino",
  "camola",
  "campale",
  "canapa",
  "candela",
  "cane",
  "canino",
  "canotto",
  "cantina",
  "capace",
  "capello",
  "capitolo",
  "capogiro",
  "cappero",
  "capra",
  "capsula",
  "carapace",
  "carcassa",
  "cardo",
  "carisma",
  "carovana",
  "carretto",
  "cartolina",
  "casaccio",
  "cascata",
  "caserma",
  "caso",
  "cassone",
  "castello",
  "casuale",
  "catasta",
  "catena",
  "catrame",
  "cauto",
  "cavillo",
  "cedibile",
  "cedrata",
  "cefalo",
  "celebre",
  "cellulare",
  "cena",
  "cenone",
  "centesimo",
  "ceramica",
  "cercare",
  "certo",
  "cerume",
  "cervello",
  "cesoia",
  "cespo",
  "ceto",
  "chela",
  "chiaro",
  "chicca",
  "chiedere",
  "chimera",
  "china",
  "chirurgo",
  "chitarra",
  "ciao",
  "ciclismo",
  "cifrare",
  "cigno",
  "cilindro",
  "ciottolo",
  "circa",
  "cirrosi",
  "citrico",
  "cittadino",
  "ciuffo",
  "civetta",
  "civile",
  "classico",
  "clinica",
  "cloro",
  "cocco",
  "codardo",
  "codice",
  "coerente",
  "cognome",
  "collare",
  "colmato",
  "colore",
  "colposo",
  "coltivato",
  "colza",
  "coma",
  "cometa",
  "commando",
  "comodo",
  "computer",
  "comune",
  "conciso",
  "condurre",
  "conferma",
  "congelare",
  "coniuge",
  "connesso",
  "conoscere",
  "consumo",
  "continuo",
  "convegno",
  "coperto",
  "copione",
  "coppia",
  "copricapo",
  "corazza",
  "cordata",
  "coricato",
  "cornice",
  "corolla",
  "corpo",
  "corredo",
  "corsia",
  "cortese",
  "cosmico",
  "costante",
  "cottura",
  "covato",
  "cratere",
  "cravatta",
  "creato",
  "credere",
  "cremoso",
  "crescita",
  "creta",
  "criceto",
  "crinale",
  "crisi",
  "critico",
  "croce",
  "cronaca",
  "crostata",
  "cruciale",
  "crusca",
  "cucire",
  "cuculo",
  "cugino",
  "cullato",
  "cupola",
  "curatore",
  "cursore",
  "curvo",
  "cuscino",
  "custode",
  "dado",
  "daino",
  "dalmata",
  "damerino",
  "daniela",
  "dannoso",
  "danzare",
  "datato",
  "davanti",
  "davvero",
  "debutto",
  "decennio",
  "deciso",
  "declino",
  "decollo",
  "decreto",
  "dedicato",
  "definito",
  "deforme",
  "degno",
  "delegare",
  "delfino",
  "delirio",
  "delta",
  "demenza",
  "denotato",
  "dentro",
  "deposito",
  "derapata",
  "derivare",
  "deroga",
  "descritto",
  "deserto",
  "desiderio",
  "desumere",
  "detersivo",
  "devoto",
  "diametro",
  "dicembre",
  "diedro",
  "difeso",
  "diffuso",
  "digerire",
  "digitale",
  "diluvio",
  "dinamico",
  "dinnanzi",
  "dipinto",
  "diploma",
  "dipolo",
  "diradare",
  "dire",
  "dirotto",
  "dirupo",
  "disagio",
  "discreto",
  "disfare",
  "disgelo",
  "disposto",
  "distanza",
  "disumano",
  "dito",
  "divano",
  "divelto",
  "dividere",
  "divorato",
  "doblone",
  "docente",
  "doganale",
  "dogma",
  "dolce",
  "domato",
  "domenica",
  "dominare",
  "dondolo",
  "dono",
  "dormire",
  "dote",
  "dottore",
  "dovuto",
  "dozzina",
  "drago",
  "druido",
  "dubbio",
  "dubitare",
  "ducale",
  "duna",
  "duomo",
  "duplice",
  "duraturo",
  "ebano",
  "eccesso",
  "ecco",
  "eclissi",
  "economia",
  "edera",
  "edicola",
  "edile",
  "editoria",
  "educare",
  "egemonia",
  "egli",
  "egoismo",
  "egregio",
  "elaborato",
  "elargire",
  "elegante",
  "elencato",
  "eletto",
  "elevare",
  "elfico",
  "elica",
  "elmo",
  "elsa",
  "eluso",
  "emanato",
  "emblema",
  "emesso",
  "emiro",
  "emotivo",
  "emozione",
  "empirico",
  "emulo",
  "endemico",
  "enduro",
  "energia",
  "enfasi",
  "enoteca",
  "entrare",
  "enzima",
  "epatite",
  "epilogo",
  "episodio",
  "epocale",
  "eppure",
  "equatore",
  "erario",
  "erba",
  "erboso",
  "erede",
  "eremita",
  "erigere",
  "ermetico",
  "eroe",
  "erosivo",
  "errante",
  "esagono",
  "esame",
  "esanime",
  "esaudire",
  "esca",
  "esempio",
  "esercito",
  "esibito",
  "esigente",
  "esistere",
  "esito",
  "esofago",
  "esortato",
  "esoso",
  "espanso",
  "espresso",
  "essenza",
  "esso",
  "esteso",
  "estimare",
  "estonia",
  "estroso",
  "esultare",
  "etilico",
  "etnico",
  "etrusco",
  "etto",
  "euclideo",
  "europa",
  "evaso",
  "evidenza",
  "evitato",
  "evoluto",
  "evviva",
  "fabbrica",
  "faccenda",
  "fachiro",
  "falco",
  "famiglia",
  "fanale",
  "fanfara",
  "fango",
  "fantasma",
  "fare",
  "farfalla",
  "farinoso",
  "farmaco",
  "fascia",
  "fastoso",
  "fasullo",
  "faticare",
  "fato",
  "favoloso",
  "febbre",
  "fecola",
  "fede",
  "fegato",
  "felpa",
  "feltro",
  "femmina",
  "fendere",
  "fenomeno",
  "fermento",
  "ferro",
  "fertile",
  "fessura",
  "festivo",
  "fetta",
  "feudo",
  "fiaba",
  "fiducia",
  "fifa",
  "figurato",
  "filo",
  "finanza",
  "finestra",
  "finire",
  "fiore",
  "fiscale",
  "fisico",
  "fiume",
  "flacone",
  "flamenco",
  "flebo",
  "flemma",
  "florido",
  "fluente",
  "fluoro",
  "fobico",
  "focaccia",
  "focoso",
  "foderato",
  "foglio",
  "folata",
  "folclore",
  "folgore",
  "fondente",
  "fonetico",
  "fonia",
  "fontana",
  "forbito",
  "forchetta",
  "foresta",
  "formica",
  "fornaio",
  "foro",
  "fortezza",
  "forzare",
  "fosfato",
  "fosso",
  "fracasso",
  "frana",
  "frassino",
  "fratello",
  "freccetta",
  "frenata",
  "fresco",
  "frigo",
  "frollino",
  "fronde",
  "frugale",
  "frutta",
  "fucilata",
  "fucsia",
  "fuggente",
  "fulmine",
  "fulvo",
  "fumante",
  "fumetto",
  "fumoso",
  "fune",
  "funzione",
  "fuoco",
  "furbo",
  "furgone",
  "furore",
  "fuso",
  "futile",
  "gabbiano",
  "gaffe",
  "galateo",
  "gallina",
  "galoppo",
  "gambero",
  "gamma",
  "garanzia",
  "garbo",
  "garofano",
  "garzone",
  "gasdotto",
  "gasolio",
  "gastrico",
  "gatto",
  "gaudio",
  "gazebo",
  "gazzella",
  "geco",
  "gelatina",
  "gelso",
  "gemello",
  "gemmato",
  "gene",
  "genitore",
  "gennaio",
  "genotipo",
  "gergo",
  "ghepardo",
  "ghiaccio",
  "ghisa",
  "giallo",
  "gilda",
  "ginepro",
  "giocare",
  "gioiello",
  "giorno",
  "giove",
  "girato",
  "girone",
  "gittata",
  "giudizio",
  "giurato",
  "giusto",
  "globulo",
  "glutine",
  "gnomo",
  "gobba",
  "golf",
  "gomito",
  "gommone",
  "gonfio",
  "gonna",
  "governo",
  "gracile",
  "grado",
  "grafico",
  "grammo",
  "grande",
  "grattare",
  "gravoso",
  "grazia",
  "greca",
  "gregge",
  "grifone",
  "grigio",
  "grinza",
  "grotta",
  "gruppo",
  "guadagno",
  "guaio",
  "guanto",
  "guardare",
  "gufo",
  "guidare",
  "ibernato",
  "icona",
  "identico",
  "idillio",
  "idolo",
  "idra",
  "idrico",
  "idrogeno",
  "igiene",
  "ignaro",
  "ignorato",
  "ilare",
  "illeso",
  "illogico",
  "illudere",
  "imballo",
  "imbevuto",
  "imbocco",
  "imbuto",
  "immane",
  "immerso",
  "immolato",
  "impacco",
  "impeto",
  "impiego",
  "importo",
  "impronta",
  "inalare",
  "inarcare",
  "inattivo",
  "incanto",
  "incendio",
  "inchino",
  "incisivo",
  "incluso",
  "incontro",
  "incrocio",
  "incubo",
  "indagine",
  "india",
  "indole",
  "inedito",
  "infatti",
  "infilare",
  "inflitto",
  "ingaggio",
  "ingegno",
  "inglese",
  "ingordo",
  "ingrosso",
  "innesco",
  "inodore",
  "inoltrare",
  "inondato",
  "insano",
  "insetto",
  "insieme",
  "insonnia",
  "insulina",
  "intasato",
  "intero",
  "intonaco",
  "intuito",
  "inumidire",
  "invalido",
  "invece",
  "invito",
  "iperbole",
  "ipnotico",
  "ipotesi",
  "ippica",
  "iride",
  "irlanda",
  "ironico",
  "irrigato",
  "irrorare",
  "isolato",
  "isotopo",
  "isterico",
  "istituto",
  "istrice",
  "italia",
  "iterare",
  "labbro",
  "labirinto",
  "lacca",
  "lacerato",
  "lacrima",
  "lacuna",
  "laddove",
  "lago",
  "lampo",
  "lancetta",
  "lanterna",
  "lardoso",
  "larga",
  "laringe",
  "lastra",
  "latenza",
  "latino",
  "lattuga",
  "lavagna",
  "lavoro",
  "legale",
  "leggero",
  "lembo",
  "lentezza",
  "lenza",
  "leone",
  "lepre",
  "lesivo",
  "lessato",
  "lesto",
  "letterale",
  "leva",
  "levigato",
  "libero",
  "lido",
  "lievito",
  "lilla",
  "limatura",
  "limitare",
  "limpido",
  "lineare",
  "lingua",
  "liquido",
  "lira",
  "lirica",
  "lisca",
  "lite",
  "litigio",
  "livrea",
  "locanda",
  "lode",
  "logica",
  "lombare",
  "londra",
  "longevo",
  "loquace",
  "lorenzo",
  "loto",
  "lotteria",
  "luce",
  "lucidato",
  "lumaca",
  "luminoso",
  "lungo",
  "lupo",
  "luppolo",
  "lusinga",
  "lusso",
  "lutto",
  "macabro",
  "macchina",
  "macero",
  "macinato",
  "madama",
  "magico",
  "maglia",
  "magnete",
  "magro",
  "maiolica",
  "malafede",
  "malgrado",
  "malinteso",
  "malsano",
  "malto",
  "malumore",
  "mana",
  "mancia",
  "mandorla",
  "mangiare",
  "manifesto",
  "mannaro",
  "manovra",
  "mansarda",
  "mantide",
  "manubrio",
  "mappa",
  "maratona",
  "marcire",
  "maretta",
  "marmo",
  "marsupio",
  "maschera",
  "massaia",
  "mastino",
  "materasso",
  "matricola",
  "mattone",
  "maturo",
  "mazurca",
  "meandro",
  "meccanico",
  "mecenate",
  "medesimo",
  "meditare",
  "mega",
  "melassa",
  "melis",
  "melodia",
  "meninge",
  "meno",
  "mensola",
  "mercurio",
  "merenda",
  "merlo",
  "meschino",
  "mese",
  "messere",
  "mestolo",
  "metallo",
  "metodo",
  "mettere",
  "miagolare",
  "mica",
  "micelio",
  "michele",
  "microbo",
  "midollo",
  "miele",
  "migliore",
  "milano",
  "milite",
  "mimosa",
  "minerale",
  "mini",
  "minore",
  "mirino",
  "mirtillo",
  "miscela",
  "missiva",
  "misto",
  "misurare",
  "mitezza",
  "mitigare",
  "mitra",
  "mittente",
  "mnemonico",
  "modello",
  "modifica",
  "modulo",
  "mogano",
  "mogio",
  "mole",
  "molosso",
  "monastero",
  "monco",
  "mondina",
  "monetario",
  "monile",
  "monotono",
  "monsone",
  "montato",
  "monviso",
  "mora",
  "mordere",
  "morsicato",
  "mostro",
  "motivato",
  "motosega",
  "motto",
  "movenza",
  "movimento",
  "mozzo",
  "mucca",
  "mucosa",
  "muffa",
  "mughetto",
  "mugnaio",
  "mulatto",
  "mulinello",
  "multiplo",
  "mummia",
  "munto",
  "muovere",
  "murale",
  "musa",
  "muscolo",
  "musica",
  "mutevole",
  "muto",
  "nababbo",
  "nafta",
  "nanometro",
  "narciso",
  "narice",
  "narrato",
  "nascere",
  "nastrare",
  "naturale",
  "nautica",
  "naviglio",
  "nebulosa",
  "necrosi",
  "negativo",
  "negozio",
  "nemmeno",
  "neofita",
  "neretto",
  "nervo",
  "nessuno",
  "nettuno",
  "neutrale",
  "neve",
  "nevrotico",
  "nicchia",
  "ninfa",
  "nitido",
  "nobile",
  "nocivo",
  "nodo",
  "nome",
  "nomina",
  "nordico",
  "normale",
  "norvegese",
  "nostrano",
  "notare",
  "notizia",
  "notturno",
  "novella",
  "nucleo",
  "nulla",
  "numero",
  "nuovo",
  "nutrire",
  "nuvola",
  "nuziale",
  "oasi",
  "obbedire",
  "obbligo",
  "obelisco",
  "oblio",
  "obolo",
  "obsoleto",
  "occasione",
  "occhio",
  "occidente",
  "occorrere",
  "occultare",
  "ocra",
  "oculato",
  "odierno",
  "odorare",
  "offerta",
  "offrire",
  "offuscato",
  "oggetto",
  "oggi",
  "ognuno",
  "olandese",
  "olfatto",
  "oliato",
  "oliva",
  "ologramma",
  "oltre",
  "omaggio",
  "ombelico",
  "ombra",
  "omega",
  "omissione",
  "ondoso",
  "onere",
  "onice",
  "onnivoro",
  "onorevole",
  "onta",
  "operato",
  "opinione",
  "opposto",
  "oracolo",
  "orafo",
  "ordine",
  "orecchino",
  "orefice",
  "orfano",
  "organico",
  "origine",
  "orizzonte",
  "orma",
  "ormeggio",
  "ornativo",
  "orologio",
  "orrendo",
  "orribile",
  "ortensia",
  "ortica",
  "orzata",
  "orzo",
  "osare",
  "oscurare",
  "osmosi",
  "ospedale",
  "ospite",
  "ossa",
  "ossidare",
  "ostacolo",
  "oste",
  "otite",
  "otre",
  "ottagono",
  "ottimo",
  "ottobre",
  "ovale",
  "ovest",
  "ovino",
  "oviparo",
  "ovocito",
  "ovunque",
  "ovviare",
  "ozio",
  "pacchetto",
  "pace",
  "pacifico",
  "padella",
  "padrone",
  "paese",
  "paga",
  "pagina",
  "palazzina",
  "palesare",
  "pallido",
  "palo",
  "palude",
  "pandoro",
  "pannello",
  "paolo",
  "paonazzo",
  "paprica",
  "parabola",
  "parcella",
  "parere",
  "pargolo",
  "pari",
  "parlato",
  "parola",
  "partire",
  "parvenza",
  "parziale",
  "passivo",
  "pasticca",
  "patacca",
  "patologia",
  "pattume",
  "pavone",
  "peccato",
  "pedalare",
  "pedonale",
  "peggio",
  "peloso",
  "penare",
  "pendice",
  "penisola",
  "pennuto",
  "penombra",
  "pensare",
  "pentola",
  "pepe",
  "pepita",
  "perbene",
  "percorso",
  "perdonato",
  "perforare",
  "pergamena",
  "periodo",
  "permesso",
  "perno",
  "perplesso",
  "persuaso",
  "pertugio",
  "pervaso",
  "pesatore",
  "pesista",
  "peso",
  "pestifero",
  "petalo",
  "pettine",
  "petulante",
  "pezzo",
  "piacere",
  "pianta",
  "piattino",
  "piccino",
  "picozza",
  "piega",
  "pietra",
  "piffero",
  "pigiama",
  "pigolio",
  "pigro",
  "pila",
  "pilifero",
  "pillola",
  "pilota",
  "pimpante",
  "pineta",
  "pinna",
  "pinolo",
  "pioggia",
  "piombo",
  "piramide",
  "piretico",
  "pirite",
  "pirolisi",
  "pitone",
  "pizzico",
  "placebo",
  "planare",
  "plasma",
  "platano",
  "plenario",
  "pochezza",
  "poderoso",
  "podismo",
  "poesia",
  "poggiare",
  "polenta",
  "poligono",
  "pollice",
  "polmonite",
  "polpetta",
  "polso",
  "poltrona",
  "polvere",
  "pomice",
  "pomodoro",
  "ponte",
  "popoloso",
  "porfido",
  "poroso",
  "porpora",
  "porre",
  "portata",
  "posa",
  "positivo",
  "possesso",
  "postulato",
  "potassio",
  "potere",
  "pranzo",
  "prassi",
  "pratica",
  "precluso",
  "predica",
  "prefisso",
  "pregiato",
  "prelievo",
  "premere",
  "prenotare",
  "preparato",
  "presenza",
  "pretesto",
  "prevalso",
  "prima",
  "principe",
  "privato",
  "problema",
  "procura",
  "produrre",
  "profumo",
  "progetto",
  "prolunga",
  "promessa",
  "pronome",
  "proposta",
  "proroga",
  "proteso",
  "prova",
  "prudente",
  "prugna",
  "prurito",
  "psiche",
  "pubblico",
  "pudica",
  "pugilato",
  "pugno",
  "pulce",
  "pulito",
  "pulsante",
  "puntare",
  "pupazzo",
  "pupilla",
  "puro",
  "quadro",
  "qualcosa",
  "quasi",
  "querela",
  "quota",
  "raccolto",
  "raddoppio",
  "radicale",
  "radunato",
  "raffica",
  "ragazzo",
  "ragione",
  "ragno",
  "ramarro",
  "ramingo",
  "ramo",
  "randagio",
  "rantolare",
  "rapato",
  "rapina",
  "rappreso",
  "rasatura",
  "raschiato",
  "rasente",
  "rassegna",
  "rastrello",
  "rata",
  "ravveduto",
  "reale",
  "recepire",
  "recinto",
  "recluta",
  "recondito",
  "recupero",
  "reddito",
  "redimere",
  "regalato",
  "registro",
  "regola",
  "regresso",
  "relazione",
  "remare",
  "remoto",
  "renna",
  "replica",
  "reprimere",
  "reputare",
  "resa",
  "residente",
  "responso",
  "restauro",
  "rete",
  "retina",
  "retorica",
  "rettifica",
  "revocato",
  "riassunto",
  "ribadire",
  "ribelle",
  "ribrezzo",
  "ricarica",
  "ricco",
  "ricevere",
  "riciclato",
  "ricordo",
  "ricreduto",
  "ridicolo",
  "ridurre",
  "rifasare",
  "riflesso",
  "riforma",
  "rifugio",
  "rigare",
  "rigettato",
  "righello",
  "rilassato",
  "rilevato",
  "rimanere",
  "rimbalzo",
  "rimedio",
  "rimorchio",
  "rinascita",
  "rincaro",
  "rinforzo",
  "rinnovo",
  "rinomato",
  "rinsavito",
  "rintocco",
  "rinuncia",
  "rinvenire",
  "riparato",
  "ripetuto",
  "ripieno",
  "riportare",
  "ripresa",
  "ripulire",
  "risata",
  "rischio",
  "riserva",
  "risibile",
  "riso",
  "rispetto",
  "ristoro",
  "risultato",
  "risvolto",
  "ritardo",
  "ritegno",
  "ritmico",
  "ritrovo",
  "riunione",
  "riva",
  "riverso",
  "rivincita",
  "rivolto",
  "rizoma",
  "roba",
  "robotico",
  "robusto",
  "roccia",
  "roco",
  "rodaggio",
  "rodere",
  "roditore",
  "rogito",
  "rollio",
  "romantico",
  "rompere",
  "ronzio",
  "rosolare",
  "rospo",
  "rotante",
  "rotondo",
  "rotula",
  "rovescio",
  "rubizzo",
  "rubrica",
  "ruga",
  "rullino",
  "rumine",
  "rumoroso",
  "ruolo",
  "rupe",
  "russare",
  "rustico",
  "sabato",
  "sabbiare",
  "sabotato",
  "sagoma",
  "salasso",
  "saldatura",
  "salgemma",
  "salivare",
  "salmone",
  "salone",
  "saltare",
  "saluto",
  "salvo",
  "sapere",
  "sapido",
  "saporito",
  "saraceno",
  "sarcasmo",
  "sarto",
  "sassoso",
  "satellite",
  "satira",
  "satollo",
  "saturno",
  "savana",
  "savio",
  "saziato",
  "sbadiglio",
  "sbalzo",
  "sbancato",
  "sbarra",
  "sbattere",
  "sbavare",
  "sbendare",
  "sbirciare",
  "sbloccato",
  "sbocciato",
  "sbrinare",
  "sbruffone",
  "sbuffare",
  "scabroso",
  "scadenza",
  "scala",
  "scambiare",
  "scandalo",
  "scapola",
  "scarso",
  "scatenare",
  "scavato",
  "scelto",
  "scenico",
  "scettro",
  "scheda",
  "schiena",
  "sciarpa",
  "scienza",
  "scindere",
  "scippo",
  "sciroppo",
  "scivolo",
  "sclerare",
  "scodella",
  "scolpito",
  "scomparto",
  "sconforto",
  "scoprire",
  "scorta",
  "scossone",
  "scozzese",
  "scriba",
  "scrollare",
  "scrutinio",
  "scuderia",
  "scultore",
  "scuola",
  "scuro",
  "scusare",
  "sdebitare",
  "sdoganare",
  "seccatura",
  "secondo",
  "sedano",
  "seggiola",
  "segnalato",
  "segregato",
  "seguito",
  "selciato",
  "selettivo",
  "sella",
  "selvaggio",
  "semaforo",
  "sembrare",
  "seme",
  "seminato",
  "sempre",
  "senso",
  "sentire",
  "sepolto",
  "sequenza",
  "serata",
  "serbato",
  "sereno",
  "serio",
  "serpente",
  "serraglio",
  "servire",
  "sestina",
  "setola",
  "settimana",
  "sfacelo",
  "sfaldare",
  "sfamato",
  "sfarzoso",
  "sfaticato",
  "sfera",
  "sfida",
  "sfilato",
  "sfinge",
  "sfocato",
  "sfoderare",
  "sfogo",
  "sfoltire",
  "sforzato",
  "sfratto",
  "sfruttato",
  "sfuggito",
  "sfumare",
  "sfuso",
  "sgabello",
  "sgarbato",
  "sgonfiare",
  "sgorbio",
  "sgrassato",
  "sguardo",
  "sibilo",
  "siccome",
  "sierra",
  "sigla",
  "signore",
  "silenzio",
  "sillaba",
  "simbolo",
  "simpatico",
  "simulato",
  "sinfonia",
  "singolo",
  "sinistro",
  "sino",
  "sintesi",
  "sinusoide",
  "sipario",
  "sisma",
  "sistole",
  "situato",
  "slitta",
  "slogatura",
  "sloveno",
  "smarrito",
  "smemorato",
  "smentito",
  "smeraldo",
  "smilzo",
  "smontare",
  "smottato",
  "smussato",
  "snellire",
  "snervato",
  "snodo",
  "sobbalzo",
  "sobrio",
  "soccorso",
  "sociale",
  "sodale",
  "soffitto",
  "sogno",
  "soldato",
  "solenne",
  "solido",
  "sollazzo",
  "solo",
  "solubile",
  "solvente",
  "somatico",
  "somma",
  "sonda",
  "sonetto",
  "sonnifero",
  "sopire",
  "soppeso",
  "sopra",
  "sorgere",
  "sorpasso",
  "sorriso",
  "sorso",
  "sorteggio",
  "sorvolato",
  "sospiro",
  "sosta",
  "sottile",
  "spada",
  "spalla",
  "spargere",
  "spatola",
  "spavento",
  "spazzola",
  "specie",
  "spedire",
  "spegnere",
  "spelatura",
  "speranza",
  "spessore",
  "spettrale",
  "spezzato",
  "spia",
  "spigoloso",
  "spillato",
  "spinoso",
  "spirale",
  "splendido",
  "sportivo",
  "sposo",
  "spranga",
  "sprecare",
  "spronato",
  "spruzzo",
  "spuntino",
  "squillo",
  "sradicare",
  "srotolato",
  "stabile",
  "stacco",
  "staffa",
  "stagnare",
  "stampato",
  "stantio",
  "starnuto",
  "stasera",
  "statuto",
  "stelo",
  "steppa",
  "sterzo",
  "stiletto",
  "stima",
  "stirpe",
  "stivale",
  "stizzoso",
  "stonato",
  "storico",
  "strappo",
  "stregato",
  "stridulo",
  "strozzare",
  "strutto",
  "stuccare",
  "stufo",
  "stupendo",
  "subentro",
  "succoso",
  "sudore",
  "suggerito",
  "sugo",
  "sultano",
  "suonare",
  "superbo",
  "supporto",
  "surgelato",
  "surrogato",
  "sussurro",
  "sutura",
  "svagare",
  "svedese",
  "sveglio",
  "svelare",
  "svenuto",
  "svezia",
  "sviluppo",
  "svista",
  "svizzera",
  "svolta",
  "svuotare",
  "tabacco",
  "tabulato",
  "tacciare",
  "taciturno",
  "tale",
  "talismano",
  "tampone",
  "tannino",
  "tara",
  "tardivo",
  "targato",
  "tariffa",
  "tarpare",
  "tartaruga",
  "tasto",
  "tattico",
  "taverna",
  "tavolata",
  "tazza",
  "teca",
  "tecnico",
  "telefono",
  "temerario",
  "tempo",
  "temuto",
  "tendone",
  "tenero",
  "tensione",
  "tentacolo",
  "teorema",
  "terme",
  "terrazzo",
  "terzetto",
  "tesi",
  "tesserato",
  "testato",
  "tetro",
  "tettoia",
  "tifare",
  "tigella",
  "timbro",
  "tinto",
  "tipico",
  "tipografo",
  "tiraggio",
  "tiro",
  "titanio",
  "titolo",
  "titubante",
  "tizio",
  "tizzone",
  "toccare",
  "tollerare",
  "tolto",
  "tombola",
  "tomo",
  "tonfo",
  "tonsilla",
  "topazio",
  "topologia",
  "toppa",
  "torba",
  "tornare",
  "torrone",
  "tortora",
  "toscano",
  "tossire",
  "tostatura",
  "totano",
  "trabocco",
  "trachea",
  "trafila",
  "tragedia",
  "tralcio",
  "tramonto",
  "transito",
  "trapano",
  "trarre",
  "trasloco",
  "trattato",
  "trave",
  "treccia",
  "tremolio",
  "trespolo",
  "tributo",
  "tricheco",
  "trifoglio",
  "trillo",
  "trincea",
  "trio",
  "tristezza",
  "triturato",
  "trivella",
  "tromba",
  "trono",
  "troppo",
  "trottola",
  "trovare",
  "truccato",
  "tubatura",
  "tuffato",
  "tulipano",
  "tumulto",
  "tunisia",
  "turbare",
  "turchino",
  "tuta",
  "tutela",
  "ubicato",
  "uccello",
  "uccisore",
  "udire",
  "uditivo",
  "uffa",
  "ufficio",
  "uguale",
  "ulisse",
  "ultimato",
  "umano",
  "umile",
  "umorismo",
  "uncinetto",
  "ungere",
  "ungherese",
  "unicorno",
  "unificato",
  "unisono",
  "unitario",
  "unte",
  "uovo",
  "upupa",
  "uragano",
  "urgenza",
  "urlo",
  "usanza",
  "usato",
  "uscito",
  "usignolo",
  "usuraio",
  "utensile",
  "utilizzo",
  "utopia",
  "vacante",
  "vaccinato",
  "vagabondo",
  "vagliato",
  "valanga",
  "valgo",
  "valico",
  "valletta",
  "valoroso",
  "valutare",
  "valvola",
  "vampata",
  "vangare",
  "vanitoso",
  "vano",
  "vantaggio",
  "vanvera",
  "vapore",
  "varano",
  "varcato",
  "variante",
  "vasca",
  "vedetta",
  "vedova",
  "veduto",
  "vegetale",
  "veicolo",
  "velcro",
  "velina",
  "velluto",
  "veloce",
  "venato",
  "vendemmia",
  "vento",
  "verace",
  "verbale",
  "vergogna",
  "verifica",
  "vero",
  "verruca",
  "verticale",
  "vescica",
  "vessillo",
  "vestale",
  "veterano",
  "vetrina",
  "vetusto",
  "viandante",
  "vibrante",
  "vicenda",
  "vichingo",
  "vicinanza",
  "vidimare",
  "vigilia",
  "vigneto",
  "vigore",
  "vile",
  "villano",
  "vimini",
  "vincitore",
  "viola",
  "vipera",
  "virgola",
  "virologo",
  "virulento",
  "viscoso",
  "visione",
  "vispo",
  "vissuto",
  "visura",
  "vita",
  "vitello",
  "vittima",
  "vivanda",
  "vivido",
  "viziare",
  "voce",
  "voga",
  "volatile",
  "volere",
  "volpe",
  "voragine",
  "vulcano",
  "zampogna",
  "zanna",
  "zappato",
  "zattera",
  "zavorra",
  "zefiro",
  "zelante",
  "zelo",
  "zenzero",
  "zerbino",
  "zibetto",
  "zinco",
  "zircone",
  "zitto",
  "zolla",
  "zotico",
  "zucchero",
  "zufolo",
  "zulu",
  "zuppa"
], T1e = [
  "ábaco",
  "abdomen",
  "abeja",
  "abierto",
  "abogado",
  "abono",
  "aborto",
  "abrazo",
  "abrir",
  "abuelo",
  "abuso",
  "acabar",
  "academia",
  "acceso",
  "acción",
  "aceite",
  "acelga",
  "acento",
  "aceptar",
  "ácido",
  "aclarar",
  "acné",
  "acoger",
  "acoso",
  "activo",
  "acto",
  "actriz",
  "actuar",
  "acudir",
  "acuerdo",
  "acusar",
  "adicto",
  "admitir",
  "adoptar",
  "adorno",
  "aduana",
  "adulto",
  "aéreo",
  "afectar",
  "afición",
  "afinar",
  "afirmar",
  "ágil",
  "agitar",
  "agonía",
  "agosto",
  "agotar",
  "agregar",
  "agrio",
  "agua",
  "agudo",
  "águila",
  "aguja",
  "ahogo",
  "ahorro",
  "aire",
  "aislar",
  "ajedrez",
  "ajeno",
  "ajuste",
  "alacrán",
  "alambre",
  "alarma",
  "alba",
  "álbum",
  "alcalde",
  "aldea",
  "alegre",
  "alejar",
  "alerta",
  "aleta",
  "alfiler",
  "alga",
  "algodón",
  "aliado",
  "aliento",
  "alivio",
  "alma",
  "almeja",
  "almíbar",
  "altar",
  "alteza",
  "altivo",
  "alto",
  "altura",
  "alumno",
  "alzar",
  "amable",
  "amante",
  "amapola",
  "amargo",
  "amasar",
  "ámbar",
  "ámbito",
  "ameno",
  "amigo",
  "amistad",
  "amor",
  "amparo",
  "amplio",
  "ancho",
  "anciano",
  "ancla",
  "andar",
  "andén",
  "anemia",
  "ángulo",
  "anillo",
  "ánimo",
  "anís",
  "anotar",
  "antena",
  "antiguo",
  "antojo",
  "anual",
  "anular",
  "anuncio",
  "añadir",
  "añejo",
  "año",
  "apagar",
  "aparato",
  "apetito",
  "apio",
  "aplicar",
  "apodo",
  "aporte",
  "apoyo",
  "aprender",
  "aprobar",
  "apuesta",
  "apuro",
  "arado",
  "araña",
  "arar",
  "árbitro",
  "árbol",
  "arbusto",
  "archivo",
  "arco",
  "arder",
  "ardilla",
  "arduo",
  "área",
  "árido",
  "aries",
  "armonía",
  "arnés",
  "aroma",
  "arpa",
  "arpón",
  "arreglo",
  "arroz",
  "arruga",
  "arte",
  "artista",
  "asa",
  "asado",
  "asalto",
  "ascenso",
  "asegurar",
  "aseo",
  "asesor",
  "asiento",
  "asilo",
  "asistir",
  "asno",
  "asombro",
  "áspero",
  "astilla",
  "astro",
  "astuto",
  "asumir",
  "asunto",
  "atajo",
  "ataque",
  "atar",
  "atento",
  "ateo",
  "ático",
  "atleta",
  "átomo",
  "atraer",
  "atroz",
  "atún",
  "audaz",
  "audio",
  "auge",
  "aula",
  "aumento",
  "ausente",
  "autor",
  "aval",
  "avance",
  "avaro",
  "ave",
  "avellana",
  "avena",
  "avestruz",
  "avión",
  "aviso",
  "ayer",
  "ayuda",
  "ayuno",
  "azafrán",
  "azar",
  "azote",
  "azúcar",
  "azufre",
  "azul",
  "baba",
  "babor",
  "bache",
  "bahía",
  "baile",
  "bajar",
  "balanza",
  "balcón",
  "balde",
  "bambú",
  "banco",
  "banda",
  "baño",
  "barba",
  "barco",
  "barniz",
  "barro",
  "báscula",
  "bastón",
  "basura",
  "batalla",
  "batería",
  "batir",
  "batuta",
  "baúl",
  "bazar",
  "bebé",
  "bebida",
  "bello",
  "besar",
  "beso",
  "bestia",
  "bicho",
  "bien",
  "bingo",
  "blanco",
  "bloque",
  "blusa",
  "boa",
  "bobina",
  "bobo",
  "boca",
  "bocina",
  "boda",
  "bodega",
  "boina",
  "bola",
  "bolero",
  "bolsa",
  "bomba",
  "bondad",
  "bonito",
  "bono",
  "bonsái",
  "borde",
  "borrar",
  "bosque",
  "bote",
  "botín",
  "bóveda",
  "bozal",
  "bravo",
  "brazo",
  "brecha",
  "breve",
  "brillo",
  "brinco",
  "brisa",
  "broca",
  "broma",
  "bronce",
  "brote",
  "bruja",
  "brusco",
  "bruto",
  "buceo",
  "bucle",
  "bueno",
  "buey",
  "bufanda",
  "bufón",
  "búho",
  "buitre",
  "bulto",
  "burbuja",
  "burla",
  "burro",
  "buscar",
  "butaca",
  "buzón",
  "caballo",
  "cabeza",
  "cabina",
  "cabra",
  "cacao",
  "cadáver",
  "cadena",
  "caer",
  "café",
  "caída",
  "caimán",
  "caja",
  "cajón",
  "cal",
  "calamar",
  "calcio",
  "caldo",
  "calidad",
  "calle",
  "calma",
  "calor",
  "calvo",
  "cama",
  "cambio",
  "camello",
  "camino",
  "campo",
  "cáncer",
  "candil",
  "canela",
  "canguro",
  "canica",
  "canto",
  "caña",
  "cañón",
  "caoba",
  "caos",
  "capaz",
  "capitán",
  "capote",
  "captar",
  "capucha",
  "cara",
  "carbón",
  "cárcel",
  "careta",
  "carga",
  "cariño",
  "carne",
  "carpeta",
  "carro",
  "carta",
  "casa",
  "casco",
  "casero",
  "caspa",
  "castor",
  "catorce",
  "catre",
  "caudal",
  "causa",
  "cazo",
  "cebolla",
  "ceder",
  "cedro",
  "celda",
  "célebre",
  "celoso",
  "célula",
  "cemento",
  "ceniza",
  "centro",
  "cerca",
  "cerdo",
  "cereza",
  "cero",
  "cerrar",
  "certeza",
  "césped",
  "cetro",
  "chacal",
  "chaleco",
  "champú",
  "chancla",
  "chapa",
  "charla",
  "chico",
  "chiste",
  "chivo",
  "choque",
  "choza",
  "chuleta",
  "chupar",
  "ciclón",
  "ciego",
  "cielo",
  "cien",
  "cierto",
  "cifra",
  "cigarro",
  "cima",
  "cinco",
  "cine",
  "cinta",
  "ciprés",
  "circo",
  "ciruela",
  "cisne",
  "cita",
  "ciudad",
  "clamor",
  "clan",
  "claro",
  "clase",
  "clave",
  "cliente",
  "clima",
  "clínica",
  "cobre",
  "cocción",
  "cochino",
  "cocina",
  "coco",
  "código",
  "codo",
  "cofre",
  "coger",
  "cohete",
  "cojín",
  "cojo",
  "cola",
  "colcha",
  "colegio",
  "colgar",
  "colina",
  "collar",
  "colmo",
  "columna",
  "combate",
  "comer",
  "comida",
  "cómodo",
  "compra",
  "conde",
  "conejo",
  "conga",
  "conocer",
  "consejo",
  "contar",
  "copa",
  "copia",
  "corazón",
  "corbata",
  "corcho",
  "cordón",
  "corona",
  "correr",
  "coser",
  "cosmos",
  "costa",
  "cráneo",
  "cráter",
  "crear",
  "crecer",
  "creído",
  "crema",
  "cría",
  "crimen",
  "cripta",
  "crisis",
  "cromo",
  "crónica",
  "croqueta",
  "crudo",
  "cruz",
  "cuadro",
  "cuarto",
  "cuatro",
  "cubo",
  "cubrir",
  "cuchara",
  "cuello",
  "cuento",
  "cuerda",
  "cuesta",
  "cueva",
  "cuidar",
  "culebra",
  "culpa",
  "culto",
  "cumbre",
  "cumplir",
  "cuna",
  "cuneta",
  "cuota",
  "cupón",
  "cúpula",
  "curar",
  "curioso",
  "curso",
  "curva",
  "cutis",
  "dama",
  "danza",
  "dar",
  "dardo",
  "dátil",
  "deber",
  "débil",
  "década",
  "decir",
  "dedo",
  "defensa",
  "definir",
  "dejar",
  "delfín",
  "delgado",
  "delito",
  "demora",
  "denso",
  "dental",
  "deporte",
  "derecho",
  "derrota",
  "desayuno",
  "deseo",
  "desfile",
  "desnudo",
  "destino",
  "desvío",
  "detalle",
  "detener",
  "deuda",
  "día",
  "diablo",
  "diadema",
  "diamante",
  "diana",
  "diario",
  "dibujo",
  "dictar",
  "diente",
  "dieta",
  "diez",
  "difícil",
  "digno",
  "dilema",
  "diluir",
  "dinero",
  "directo",
  "dirigir",
  "disco",
  "diseño",
  "disfraz",
  "diva",
  "divino",
  "doble",
  "doce",
  "dolor",
  "domingo",
  "don",
  "donar",
  "dorado",
  "dormir",
  "dorso",
  "dos",
  "dosis",
  "dragón",
  "droga",
  "ducha",
  "duda",
  "duelo",
  "dueño",
  "dulce",
  "dúo",
  "duque",
  "durar",
  "dureza",
  "duro",
  "ébano",
  "ebrio",
  "echar",
  "eco",
  "ecuador",
  "edad",
  "edición",
  "edificio",
  "editor",
  "educar",
  "efecto",
  "eficaz",
  "eje",
  "ejemplo",
  "elefante",
  "elegir",
  "elemento",
  "elevar",
  "elipse",
  "élite",
  "elixir",
  "elogio",
  "eludir",
  "embudo",
  "emitir",
  "emoción",
  "empate",
  "empeño",
  "empleo",
  "empresa",
  "enano",
  "encargo",
  "enchufe",
  "encía",
  "enemigo",
  "enero",
  "enfado",
  "enfermo",
  "engaño",
  "enigma",
  "enlace",
  "enorme",
  "enredo",
  "ensayo",
  "enseñar",
  "entero",
  "entrar",
  "envase",
  "envío",
  "época",
  "equipo",
  "erizo",
  "escala",
  "escena",
  "escolar",
  "escribir",
  "escudo",
  "esencia",
  "esfera",
  "esfuerzo",
  "espada",
  "espejo",
  "espía",
  "esposa",
  "espuma",
  "esquí",
  "estar",
  "este",
  "estilo",
  "estufa",
  "etapa",
  "eterno",
  "ética",
  "etnia",
  "evadir",
  "evaluar",
  "evento",
  "evitar",
  "exacto",
  "examen",
  "exceso",
  "excusa",
  "exento",
  "exigir",
  "exilio",
  "existir",
  "éxito",
  "experto",
  "explicar",
  "exponer",
  "extremo",
  "fábrica",
  "fábula",
  "fachada",
  "fácil",
  "factor",
  "faena",
  "faja",
  "falda",
  "fallo",
  "falso",
  "faltar",
  "fama",
  "familia",
  "famoso",
  "faraón",
  "farmacia",
  "farol",
  "farsa",
  "fase",
  "fatiga",
  "fauna",
  "favor",
  "fax",
  "febrero",
  "fecha",
  "feliz",
  "feo",
  "feria",
  "feroz",
  "fértil",
  "fervor",
  "festín",
  "fiable",
  "fianza",
  "fiar",
  "fibra",
  "ficción",
  "ficha",
  "fideo",
  "fiebre",
  "fiel",
  "fiera",
  "fiesta",
  "figura",
  "fijar",
  "fijo",
  "fila",
  "filete",
  "filial",
  "filtro",
  "fin",
  "finca",
  "fingir",
  "finito",
  "firma",
  "flaco",
  "flauta",
  "flecha",
  "flor",
  "flota",
  "fluir",
  "flujo",
  "flúor",
  "fobia",
  "foca",
  "fogata",
  "fogón",
  "folio",
  "folleto",
  "fondo",
  "forma",
  "forro",
  "fortuna",
  "forzar",
  "fosa",
  "foto",
  "fracaso",
  "frágil",
  "franja",
  "frase",
  "fraude",
  "freír",
  "freno",
  "fresa",
  "frío",
  "frito",
  "fruta",
  "fuego",
  "fuente",
  "fuerza",
  "fuga",
  "fumar",
  "función",
  "funda",
  "furgón",
  "furia",
  "fusil",
  "fútbol",
  "futuro",
  "gacela",
  "gafas",
  "gaita",
  "gajo",
  "gala",
  "galería",
  "gallo",
  "gamba",
  "ganar",
  "gancho",
  "ganga",
  "ganso",
  "garaje",
  "garza",
  "gasolina",
  "gastar",
  "gato",
  "gavilán",
  "gemelo",
  "gemir",
  "gen",
  "género",
  "genio",
  "gente",
  "geranio",
  "gerente",
  "germen",
  "gesto",
  "gigante",
  "gimnasio",
  "girar",
  "giro",
  "glaciar",
  "globo",
  "gloria",
  "gol",
  "golfo",
  "goloso",
  "golpe",
  "goma",
  "gordo",
  "gorila",
  "gorra",
  "gota",
  "goteo",
  "gozar",
  "grada",
  "gráfico",
  "grano",
  "grasa",
  "gratis",
  "grave",
  "grieta",
  "grillo",
  "gripe",
  "gris",
  "grito",
  "grosor",
  "grúa",
  "grueso",
  "grumo",
  "grupo",
  "guante",
  "guapo",
  "guardia",
  "guerra",
  "guía",
  "guiño",
  "guion",
  "guiso",
  "guitarra",
  "gusano",
  "gustar",
  "haber",
  "hábil",
  "hablar",
  "hacer",
  "hacha",
  "hada",
  "hallar",
  "hamaca",
  "harina",
  "haz",
  "hazaña",
  "hebilla",
  "hebra",
  "hecho",
  "helado",
  "helio",
  "hembra",
  "herir",
  "hermano",
  "héroe",
  "hervir",
  "hielo",
  "hierro",
  "hígado",
  "higiene",
  "hijo",
  "himno",
  "historia",
  "hocico",
  "hogar",
  "hoguera",
  "hoja",
  "hombre",
  "hongo",
  "honor",
  "honra",
  "hora",
  "hormiga",
  "horno",
  "hostil",
  "hoyo",
  "hueco",
  "huelga",
  "huerta",
  "hueso",
  "huevo",
  "huida",
  "huir",
  "humano",
  "húmedo",
  "humilde",
  "humo",
  "hundir",
  "huracán",
  "hurto",
  "icono",
  "ideal",
  "idioma",
  "ídolo",
  "iglesia",
  "iglú",
  "igual",
  "ilegal",
  "ilusión",
  "imagen",
  "imán",
  "imitar",
  "impar",
  "imperio",
  "imponer",
  "impulso",
  "incapaz",
  "índice",
  "inerte",
  "infiel",
  "informe",
  "ingenio",
  "inicio",
  "inmenso",
  "inmune",
  "innato",
  "insecto",
  "instante",
  "interés",
  "íntimo",
  "intuir",
  "inútil",
  "invierno",
  "ira",
  "iris",
  "ironía",
  "isla",
  "islote",
  "jabalí",
  "jabón",
  "jamón",
  "jarabe",
  "jardín",
  "jarra",
  "jaula",
  "jazmín",
  "jefe",
  "jeringa",
  "jinete",
  "jornada",
  "joroba",
  "joven",
  "joya",
  "juerga",
  "jueves",
  "juez",
  "jugador",
  "jugo",
  "juguete",
  "juicio",
  "junco",
  "jungla",
  "junio",
  "juntar",
  "júpiter",
  "jurar",
  "justo",
  "juvenil",
  "juzgar",
  "kilo",
  "koala",
  "labio",
  "lacio",
  "lacra",
  "lado",
  "ladrón",
  "lagarto",
  "lágrima",
  "laguna",
  "laico",
  "lamer",
  "lámina",
  "lámpara",
  "lana",
  "lancha",
  "langosta",
  "lanza",
  "lápiz",
  "largo",
  "larva",
  "lástima",
  "lata",
  "látex",
  "latir",
  "laurel",
  "lavar",
  "lazo",
  "leal",
  "lección",
  "leche",
  "lector",
  "leer",
  "legión",
  "legumbre",
  "lejano",
  "lengua",
  "lento",
  "leña",
  "león",
  "leopardo",
  "lesión",
  "letal",
  "letra",
  "leve",
  "leyenda",
  "libertad",
  "libro",
  "licor",
  "líder",
  "lidiar",
  "lienzo",
  "liga",
  "ligero",
  "lima",
  "límite",
  "limón",
  "limpio",
  "lince",
  "lindo",
  "línea",
  "lingote",
  "lino",
  "linterna",
  "líquido",
  "liso",
  "lista",
  "litera",
  "litio",
  "litro",
  "llaga",
  "llama",
  "llanto",
  "llave",
  "llegar",
  "llenar",
  "llevar",
  "llorar",
  "llover",
  "lluvia",
  "lobo",
  "loción",
  "loco",
  "locura",
  "lógica",
  "logro",
  "lombriz",
  "lomo",
  "lonja",
  "lote",
  "lucha",
  "lucir",
  "lugar",
  "lujo",
  "luna",
  "lunes",
  "lupa",
  "lustro",
  "luto",
  "luz",
  "maceta",
  "macho",
  "madera",
  "madre",
  "maduro",
  "maestro",
  "mafia",
  "magia",
  "mago",
  "maíz",
  "maldad",
  "maleta",
  "malla",
  "malo",
  "mamá",
  "mambo",
  "mamut",
  "manco",
  "mando",
  "manejar",
  "manga",
  "maniquí",
  "manjar",
  "mano",
  "manso",
  "manta",
  "mañana",
  "mapa",
  "máquina",
  "mar",
  "marco",
  "marea",
  "marfil",
  "margen",
  "marido",
  "mármol",
  "marrón",
  "martes",
  "marzo",
  "masa",
  "máscara",
  "masivo",
  "matar",
  "materia",
  "matiz",
  "matriz",
  "máximo",
  "mayor",
  "mazorca",
  "mecha",
  "medalla",
  "medio",
  "médula",
  "mejilla",
  "mejor",
  "melena",
  "melón",
  "memoria",
  "menor",
  "mensaje",
  "mente",
  "menú",
  "mercado",
  "merengue",
  "mérito",
  "mes",
  "mesón",
  "meta",
  "meter",
  "método",
  "metro",
  "mezcla",
  "miedo",
  "miel",
  "miembro",
  "miga",
  "mil",
  "milagro",
  "militar",
  "millón",
  "mimo",
  "mina",
  "minero",
  "mínimo",
  "minuto",
  "miope",
  "mirar",
  "misa",
  "miseria",
  "misil",
  "mismo",
  "mitad",
  "mito",
  "mochila",
  "moción",
  "moda",
  "modelo",
  "moho",
  "mojar",
  "molde",
  "moler",
  "molino",
  "momento",
  "momia",
  "monarca",
  "moneda",
  "monja",
  "monto",
  "moño",
  "morada",
  "morder",
  "moreno",
  "morir",
  "morro",
  "morsa",
  "mortal",
  "mosca",
  "mostrar",
  "motivo",
  "mover",
  "móvil",
  "mozo",
  "mucho",
  "mudar",
  "mueble",
  "muela",
  "muerte",
  "muestra",
  "mugre",
  "mujer",
  "mula",
  "muleta",
  "multa",
  "mundo",
  "muñeca",
  "mural",
  "muro",
  "músculo",
  "museo",
  "musgo",
  "música",
  "muslo",
  "nácar",
  "nación",
  "nadar",
  "naipe",
  "naranja",
  "nariz",
  "narrar",
  "nasal",
  "natal",
  "nativo",
  "natural",
  "náusea",
  "naval",
  "nave",
  "navidad",
  "necio",
  "néctar",
  "negar",
  "negocio",
  "negro",
  "neón",
  "nervio",
  "neto",
  "neutro",
  "nevar",
  "nevera",
  "nicho",
  "nido",
  "niebla",
  "nieto",
  "niñez",
  "niño",
  "nítido",
  "nivel",
  "nobleza",
  "noche",
  "nómina",
  "noria",
  "norma",
  "norte",
  "nota",
  "noticia",
  "novato",
  "novela",
  "novio",
  "nube",
  "nuca",
  "núcleo",
  "nudillo",
  "nudo",
  "nuera",
  "nueve",
  "nuez",
  "nulo",
  "número",
  "nutria",
  "oasis",
  "obeso",
  "obispo",
  "objeto",
  "obra",
  "obrero",
  "observar",
  "obtener",
  "obvio",
  "oca",
  "ocaso",
  "océano",
  "ochenta",
  "ocho",
  "ocio",
  "ocre",
  "octavo",
  "octubre",
  "oculto",
  "ocupar",
  "ocurrir",
  "odiar",
  "odio",
  "odisea",
  "oeste",
  "ofensa",
  "oferta",
  "oficio",
  "ofrecer",
  "ogro",
  "oído",
  "oír",
  "ojo",
  "ola",
  "oleada",
  "olfato",
  "olivo",
  "olla",
  "olmo",
  "olor",
  "olvido",
  "ombligo",
  "onda",
  "onza",
  "opaco",
  "opción",
  "ópera",
  "opinar",
  "oponer",
  "optar",
  "óptica",
  "opuesto",
  "oración",
  "orador",
  "oral",
  "órbita",
  "orca",
  "orden",
  "oreja",
  "órgano",
  "orgía",
  "orgullo",
  "oriente",
  "origen",
  "orilla",
  "oro",
  "orquesta",
  "oruga",
  "osadía",
  "oscuro",
  "osezno",
  "oso",
  "ostra",
  "otoño",
  "otro",
  "oveja",
  "óvulo",
  "óxido",
  "oxígeno",
  "oyente",
  "ozono",
  "pacto",
  "padre",
  "paella",
  "página",
  "pago",
  "país",
  "pájaro",
  "palabra",
  "palco",
  "paleta",
  "pálido",
  "palma",
  "paloma",
  "palpar",
  "pan",
  "panal",
  "pánico",
  "pantera",
  "pañuelo",
  "papá",
  "papel",
  "papilla",
  "paquete",
  "parar",
  "parcela",
  "pared",
  "parir",
  "paro",
  "párpado",
  "parque",
  "párrafo",
  "parte",
  "pasar",
  "paseo",
  "pasión",
  "paso",
  "pasta",
  "pata",
  "patio",
  "patria",
  "pausa",
  "pauta",
  "pavo",
  "payaso",
  "peatón",
  "pecado",
  "pecera",
  "pecho",
  "pedal",
  "pedir",
  "pegar",
  "peine",
  "pelar",
  "peldaño",
  "pelea",
  "peligro",
  "pellejo",
  "pelo",
  "peluca",
  "pena",
  "pensar",
  "peñón",
  "peón",
  "peor",
  "pepino",
  "pequeño",
  "pera",
  "percha",
  "perder",
  "pereza",
  "perfil",
  "perico",
  "perla",
  "permiso",
  "perro",
  "persona",
  "pesa",
  "pesca",
  "pésimo",
  "pestaña",
  "pétalo",
  "petróleo",
  "pez",
  "pezuña",
  "picar",
  "pichón",
  "pie",
  "piedra",
  "pierna",
  "pieza",
  "pijama",
  "pilar",
  "piloto",
  "pimienta",
  "pino",
  "pintor",
  "pinza",
  "piña",
  "piojo",
  "pipa",
  "pirata",
  "pisar",
  "piscina",
  "piso",
  "pista",
  "pitón",
  "pizca",
  "placa",
  "plan",
  "plata",
  "playa",
  "plaza",
  "pleito",
  "pleno",
  "plomo",
  "pluma",
  "plural",
  "pobre",
  "poco",
  "poder",
  "podio",
  "poema",
  "poesía",
  "poeta",
  "polen",
  "policía",
  "pollo",
  "polvo",
  "pomada",
  "pomelo",
  "pomo",
  "pompa",
  "poner",
  "porción",
  "portal",
  "posada",
  "poseer",
  "posible",
  "poste",
  "potencia",
  "potro",
  "pozo",
  "prado",
  "precoz",
  "pregunta",
  "premio",
  "prensa",
  "preso",
  "previo",
  "primo",
  "príncipe",
  "prisión",
  "privar",
  "proa",
  "probar",
  "proceso",
  "producto",
  "proeza",
  "profesor",
  "programa",
  "prole",
  "promesa",
  "pronto",
  "propio",
  "próximo",
  "prueba",
  "público",
  "puchero",
  "pudor",
  "pueblo",
  "puerta",
  "puesto",
  "pulga",
  "pulir",
  "pulmón",
  "pulpo",
  "pulso",
  "puma",
  "punto",
  "puñal",
  "puño",
  "pupa",
  "pupila",
  "puré",
  "quedar",
  "queja",
  "quemar",
  "querer",
  "queso",
  "quieto",
  "química",
  "quince",
  "quitar",
  "rábano",
  "rabia",
  "rabo",
  "ración",
  "radical",
  "raíz",
  "rama",
  "rampa",
  "rancho",
  "rango",
  "rapaz",
  "rápido",
  "rapto",
  "rasgo",
  "raspa",
  "rato",
  "rayo",
  "raza",
  "razón",
  "reacción",
  "realidad",
  "rebaño",
  "rebote",
  "recaer",
  "receta",
  "rechazo",
  "recoger",
  "recreo",
  "recto",
  "recurso",
  "red",
  "redondo",
  "reducir",
  "reflejo",
  "reforma",
  "refrán",
  "refugio",
  "regalo",
  "regir",
  "regla",
  "regreso",
  "rehén",
  "reino",
  "reír",
  "reja",
  "relato",
  "relevo",
  "relieve",
  "relleno",
  "reloj",
  "remar",
  "remedio",
  "remo",
  "rencor",
  "rendir",
  "renta",
  "reparto",
  "repetir",
  "reposo",
  "reptil",
  "res",
  "rescate",
  "resina",
  "respeto",
  "resto",
  "resumen",
  "retiro",
  "retorno",
  "retrato",
  "reunir",
  "revés",
  "revista",
  "rey",
  "rezar",
  "rico",
  "riego",
  "rienda",
  "riesgo",
  "rifa",
  "rígido",
  "rigor",
  "rincón",
  "riñón",
  "río",
  "riqueza",
  "risa",
  "ritmo",
  "rito",
  "rizo",
  "roble",
  "roce",
  "rociar",
  "rodar",
  "rodeo",
  "rodilla",
  "roer",
  "rojizo",
  "rojo",
  "romero",
  "romper",
  "ron",
  "ronco",
  "ronda",
  "ropa",
  "ropero",
  "rosa",
  "rosca",
  "rostro",
  "rotar",
  "rubí",
  "rubor",
  "rudo",
  "rueda",
  "rugir",
  "ruido",
  "ruina",
  "ruleta",
  "rulo",
  "rumbo",
  "rumor",
  "ruptura",
  "ruta",
  "rutina",
  "sábado",
  "saber",
  "sabio",
  "sable",
  "sacar",
  "sagaz",
  "sagrado",
  "sala",
  "saldo",
  "salero",
  "salir",
  "salmón",
  "salón",
  "salsa",
  "salto",
  "salud",
  "salvar",
  "samba",
  "sanción",
  "sandía",
  "sanear",
  "sangre",
  "sanidad",
  "sano",
  "santo",
  "sapo",
  "saque",
  "sardina",
  "sartén",
  "sastre",
  "satán",
  "sauna",
  "saxofón",
  "sección",
  "seco",
  "secreto",
  "secta",
  "sed",
  "seguir",
  "seis",
  "sello",
  "selva",
  "semana",
  "semilla",
  "senda",
  "sensor",
  "señal",
  "señor",
  "separar",
  "sepia",
  "sequía",
  "ser",
  "serie",
  "sermón",
  "servir",
  "sesenta",
  "sesión",
  "seta",
  "setenta",
  "severo",
  "sexo",
  "sexto",
  "sidra",
  "siesta",
  "siete",
  "siglo",
  "signo",
  "sílaba",
  "silbar",
  "silencio",
  "silla",
  "símbolo",
  "simio",
  "sirena",
  "sistema",
  "sitio",
  "situar",
  "sobre",
  "socio",
  "sodio",
  "sol",
  "solapa",
  "soldado",
  "soledad",
  "sólido",
  "soltar",
  "solución",
  "sombra",
  "sondeo",
  "sonido",
  "sonoro",
  "sonrisa",
  "sopa",
  "soplar",
  "soporte",
  "sordo",
  "sorpresa",
  "sorteo",
  "sostén",
  "sótano",
  "suave",
  "subir",
  "suceso",
  "sudor",
  "suegra",
  "suelo",
  "sueño",
  "suerte",
  "sufrir",
  "sujeto",
  "sultán",
  "sumar",
  "superar",
  "suplir",
  "suponer",
  "supremo",
  "sur",
  "surco",
  "sureño",
  "surgir",
  "susto",
  "sutil",
  "tabaco",
  "tabique",
  "tabla",
  "tabú",
  "taco",
  "tacto",
  "tajo",
  "talar",
  "talco",
  "talento",
  "talla",
  "talón",
  "tamaño",
  "tambor",
  "tango",
  "tanque",
  "tapa",
  "tapete",
  "tapia",
  "tapón",
  "taquilla",
  "tarde",
  "tarea",
  "tarifa",
  "tarjeta",
  "tarot",
  "tarro",
  "tarta",
  "tatuaje",
  "tauro",
  "taza",
  "tazón",
  "teatro",
  "techo",
  "tecla",
  "técnica",
  "tejado",
  "tejer",
  "tejido",
  "tela",
  "teléfono",
  "tema",
  "temor",
  "templo",
  "tenaz",
  "tender",
  "tener",
  "tenis",
  "tenso",
  "teoría",
  "terapia",
  "terco",
  "término",
  "ternura",
  "terror",
  "tesis",
  "tesoro",
  "testigo",
  "tetera",
  "texto",
  "tez",
  "tibio",
  "tiburón",
  "tiempo",
  "tienda",
  "tierra",
  "tieso",
  "tigre",
  "tijera",
  "tilde",
  "timbre",
  "tímido",
  "timo",
  "tinta",
  "tío",
  "típico",
  "tipo",
  "tira",
  "tirón",
  "titán",
  "títere",
  "título",
  "tiza",
  "toalla",
  "tobillo",
  "tocar",
  "tocino",
  "todo",
  "toga",
  "toldo",
  "tomar",
  "tono",
  "tonto",
  "topar",
  "tope",
  "toque",
  "tórax",
  "torero",
  "tormenta",
  "torneo",
  "toro",
  "torpedo",
  "torre",
  "torso",
  "tortuga",
  "tos",
  "tosco",
  "toser",
  "tóxico",
  "trabajo",
  "tractor",
  "traer",
  "tráfico",
  "trago",
  "traje",
  "tramo",
  "trance",
  "trato",
  "trauma",
  "trazar",
  "trébol",
  "tregua",
  "treinta",
  "tren",
  "trepar",
  "tres",
  "tribu",
  "trigo",
  "tripa",
  "triste",
  "triunfo",
  "trofeo",
  "trompa",
  "tronco",
  "tropa",
  "trote",
  "trozo",
  "truco",
  "trueno",
  "trufa",
  "tubería",
  "tubo",
  "tuerto",
  "tumba",
  "tumor",
  "túnel",
  "túnica",
  "turbina",
  "turismo",
  "turno",
  "tutor",
  "ubicar",
  "úlcera",
  "umbral",
  "unidad",
  "unir",
  "universo",
  "uno",
  "untar",
  "uña",
  "urbano",
  "urbe",
  "urgente",
  "urna",
  "usar",
  "usuario",
  "útil",
  "utopía",
  "uva",
  "vaca",
  "vacío",
  "vacuna",
  "vagar",
  "vago",
  "vaina",
  "vajilla",
  "vale",
  "válido",
  "valle",
  "valor",
  "válvula",
  "vampiro",
  "vara",
  "variar",
  "varón",
  "vaso",
  "vecino",
  "vector",
  "vehículo",
  "veinte",
  "vejez",
  "vela",
  "velero",
  "veloz",
  "vena",
  "vencer",
  "venda",
  "veneno",
  "vengar",
  "venir",
  "venta",
  "venus",
  "ver",
  "verano",
  "verbo",
  "verde",
  "vereda",
  "verja",
  "verso",
  "verter",
  "vía",
  "viaje",
  "vibrar",
  "vicio",
  "víctima",
  "vida",
  "vídeo",
  "vidrio",
  "viejo",
  "viernes",
  "vigor",
  "vil",
  "villa",
  "vinagre",
  "vino",
  "viñedo",
  "violín",
  "viral",
  "virgo",
  "virtud",
  "visor",
  "víspera",
  "vista",
  "vitamina",
  "viudo",
  "vivaz",
  "vivero",
  "vivir",
  "vivo",
  "volcán",
  "volumen",
  "volver",
  "voraz",
  "votar",
  "voto",
  "voz",
  "vuelo",
  "vulgar",
  "yacer",
  "yate",
  "yegua",
  "yema",
  "yerno",
  "yeso",
  "yodo",
  "yoga",
  "yogur",
  "zafiro",
  "zanja",
  "zapato",
  "zarza",
  "zona",
  "zorro",
  "zumo",
  "zurdo"
], I1e = [
  "あいこくしん",
  "あいさつ",
  "あいだ",
  "あおぞら",
  "あかちゃん",
  "あきる",
  "あけがた",
  "あける",
  "あこがれる",
  "あさい",
  "あさひ",
  "あしあと",
  "あじわう",
  "あずかる",
  "あずき",
  "あそぶ",
  "あたえる",
  "あたためる",
  "あたりまえ",
  "あたる",
  "あつい",
  "あつかう",
  "あっしゅく",
  "あつまり",
  "あつめる",
  "あてな",
  "あてはまる",
  "あひる",
  "あぶら",
  "あぶる",
  "あふれる",
  "あまい",
  "あまど",
  "あまやかす",
  "あまり",
  "あみもの",
  "あめりか",
  "あやまる",
  "あゆむ",
  "あらいぐま",
  "あらし",
  "あらすじ",
  "あらためる",
  "あらゆる",
  "あらわす",
  "ありがとう",
  "あわせる",
  "あわてる",
  "あんい",
  "あんがい",
  "あんこ",
  "あんぜん",
  "あんてい",
  "あんない",
  "あんまり",
  "いいだす",
  "いおん",
  "いがい",
  "いがく",
  "いきおい",
  "いきなり",
  "いきもの",
  "いきる",
  "いくじ",
  "いくぶん",
  "いけばな",
  "いけん",
  "いこう",
  "いこく",
  "いこつ",
  "いさましい",
  "いさん",
  "いしき",
  "いじゅう",
  "いじょう",
  "いじわる",
  "いずみ",
  "いずれ",
  "いせい",
  "いせえび",
  "いせかい",
  "いせき",
  "いぜん",
  "いそうろう",
  "いそがしい",
  "いだい",
  "いだく",
  "いたずら",
  "いたみ",
  "いたりあ",
  "いちおう",
  "いちじ",
  "いちど",
  "いちば",
  "いちぶ",
  "いちりゅう",
  "いつか",
  "いっしゅん",
  "いっせい",
  "いっそう",
  "いったん",
  "いっち",
  "いってい",
  "いっぽう",
  "いてざ",
  "いてん",
  "いどう",
  "いとこ",
  "いない",
  "いなか",
  "いねむり",
  "いのち",
  "いのる",
  "いはつ",
  "いばる",
  "いはん",
  "いびき",
  "いひん",
  "いふく",
  "いへん",
  "いほう",
  "いみん",
  "いもうと",
  "いもたれ",
  "いもり",
  "いやがる",
  "いやす",
  "いよかん",
  "いよく",
  "いらい",
  "いらすと",
  "いりぐち",
  "いりょう",
  "いれい",
  "いれもの",
  "いれる",
  "いろえんぴつ",
  "いわい",
  "いわう",
  "いわかん",
  "いわば",
  "いわゆる",
  "いんげんまめ",
  "いんさつ",
  "いんしょう",
  "いんよう",
  "うえき",
  "うえる",
  "うおざ",
  "うがい",
  "うかぶ",
  "うかべる",
  "うきわ",
  "うくらいな",
  "うくれれ",
  "うけたまわる",
  "うけつけ",
  "うけとる",
  "うけもつ",
  "うける",
  "うごかす",
  "うごく",
  "うこん",
  "うさぎ",
  "うしなう",
  "うしろがみ",
  "うすい",
  "うすぎ",
  "うすぐらい",
  "うすめる",
  "うせつ",
  "うちあわせ",
  "うちがわ",
  "うちき",
  "うちゅう",
  "うっかり",
  "うつくしい",
  "うったえる",
  "うつる",
  "うどん",
  "うなぎ",
  "うなじ",
  "うなずく",
  "うなる",
  "うねる",
  "うのう",
  "うぶげ",
  "うぶごえ",
  "うまれる",
  "うめる",
  "うもう",
  "うやまう",
  "うよく",
  "うらがえす",
  "うらぐち",
  "うらない",
  "うりあげ",
  "うりきれ",
  "うるさい",
  "うれしい",
  "うれゆき",
  "うれる",
  "うろこ",
  "うわき",
  "うわさ",
  "うんこう",
  "うんちん",
  "うんてん",
  "うんどう",
  "えいえん",
  "えいが",
  "えいきょう",
  "えいご",
  "えいせい",
  "えいぶん",
  "えいよう",
  "えいわ",
  "えおり",
  "えがお",
  "えがく",
  "えきたい",
  "えくせる",
  "えしゃく",
  "えすて",
  "えつらん",
  "えのぐ",
  "えほうまき",
  "えほん",
  "えまき",
  "えもじ",
  "えもの",
  "えらい",
  "えらぶ",
  "えりあ",
  "えんえん",
  "えんかい",
  "えんぎ",
  "えんげき",
  "えんしゅう",
  "えんぜつ",
  "えんそく",
  "えんちょう",
  "えんとつ",
  "おいかける",
  "おいこす",
  "おいしい",
  "おいつく",
  "おうえん",
  "おうさま",
  "おうじ",
  "おうせつ",
  "おうたい",
  "おうふく",
  "おうべい",
  "おうよう",
  "おえる",
  "おおい",
  "おおう",
  "おおどおり",
  "おおや",
  "おおよそ",
  "おかえり",
  "おかず",
  "おがむ",
  "おかわり",
  "おぎなう",
  "おきる",
  "おくさま",
  "おくじょう",
  "おくりがな",
  "おくる",
  "おくれる",
  "おこす",
  "おこなう",
  "おこる",
  "おさえる",
  "おさない",
  "おさめる",
  "おしいれ",
  "おしえる",
  "おじぎ",
  "おじさん",
  "おしゃれ",
  "おそらく",
  "おそわる",
  "おたがい",
  "おたく",
  "おだやか",
  "おちつく",
  "おっと",
  "おつり",
  "おでかけ",
  "おとしもの",
  "おとなしい",
  "おどり",
  "おどろかす",
  "おばさん",
  "おまいり",
  "おめでとう",
  "おもいで",
  "おもう",
  "おもたい",
  "おもちゃ",
  "おやつ",
  "おやゆび",
  "およぼす",
  "おらんだ",
  "おろす",
  "おんがく",
  "おんけい",
  "おんしゃ",
  "おんせん",
  "おんだん",
  "おんちゅう",
  "おんどけい",
  "かあつ",
  "かいが",
  "がいき",
  "がいけん",
  "がいこう",
  "かいさつ",
  "かいしゃ",
  "かいすいよく",
  "かいぜん",
  "かいぞうど",
  "かいつう",
  "かいてん",
  "かいとう",
  "かいふく",
  "がいへき",
  "かいほう",
  "かいよう",
  "がいらい",
  "かいわ",
  "かえる",
  "かおり",
  "かかえる",
  "かがく",
  "かがし",
  "かがみ",
  "かくご",
  "かくとく",
  "かざる",
  "がぞう",
  "かたい",
  "かたち",
  "がちょう",
  "がっきゅう",
  "がっこう",
  "がっさん",
  "がっしょう",
  "かなざわし",
  "かのう",
  "がはく",
  "かぶか",
  "かほう",
  "かほご",
  "かまう",
  "かまぼこ",
  "かめれおん",
  "かゆい",
  "かようび",
  "からい",
  "かるい",
  "かろう",
  "かわく",
  "かわら",
  "がんか",
  "かんけい",
  "かんこう",
  "かんしゃ",
  "かんそう",
  "かんたん",
  "かんち",
  "がんばる",
  "きあい",
  "きあつ",
  "きいろ",
  "ぎいん",
  "きうい",
  "きうん",
  "きえる",
  "きおう",
  "きおく",
  "きおち",
  "きおん",
  "きかい",
  "きかく",
  "きかんしゃ",
  "ききて",
  "きくばり",
  "きくらげ",
  "きけんせい",
  "きこう",
  "きこえる",
  "きこく",
  "きさい",
  "きさく",
  "きさま",
  "きさらぎ",
  "ぎじかがく",
  "ぎしき",
  "ぎじたいけん",
  "ぎじにってい",
  "ぎじゅつしゃ",
  "きすう",
  "きせい",
  "きせき",
  "きせつ",
  "きそう",
  "きぞく",
  "きぞん",
  "きたえる",
  "きちょう",
  "きつえん",
  "ぎっちり",
  "きつつき",
  "きつね",
  "きてい",
  "きどう",
  "きどく",
  "きない",
  "きなが",
  "きなこ",
  "きぬごし",
  "きねん",
  "きのう",
  "きのした",
  "きはく",
  "きびしい",
  "きひん",
  "きふく",
  "きぶん",
  "きぼう",
  "きほん",
  "きまる",
  "きみつ",
  "きむずかしい",
  "きめる",
  "きもだめし",
  "きもち",
  "きもの",
  "きゃく",
  "きやく",
  "ぎゅうにく",
  "きよう",
  "きょうりゅう",
  "きらい",
  "きらく",
  "きりん",
  "きれい",
  "きれつ",
  "きろく",
  "ぎろん",
  "きわめる",
  "ぎんいろ",
  "きんかくじ",
  "きんじょ",
  "きんようび",
  "ぐあい",
  "くいず",
  "くうかん",
  "くうき",
  "くうぐん",
  "くうこう",
  "ぐうせい",
  "くうそう",
  "ぐうたら",
  "くうふく",
  "くうぼ",
  "くかん",
  "くきょう",
  "くげん",
  "ぐこう",
  "くさい",
  "くさき",
  "くさばな",
  "くさる",
  "くしゃみ",
  "くしょう",
  "くすのき",
  "くすりゆび",
  "くせげ",
  "くせん",
  "ぐたいてき",
  "くださる",
  "くたびれる",
  "くちこみ",
  "くちさき",
  "くつした",
  "ぐっすり",
  "くつろぐ",
  "くとうてん",
  "くどく",
  "くなん",
  "くねくね",
  "くのう",
  "くふう",
  "くみあわせ",
  "くみたてる",
  "くめる",
  "くやくしょ",
  "くらす",
  "くらべる",
  "くるま",
  "くれる",
  "くろう",
  "くわしい",
  "ぐんかん",
  "ぐんしょく",
  "ぐんたい",
  "ぐんて",
  "けあな",
  "けいかく",
  "けいけん",
  "けいこ",
  "けいさつ",
  "げいじゅつ",
  "けいたい",
  "げいのうじん",
  "けいれき",
  "けいろ",
  "けおとす",
  "けおりもの",
  "げきか",
  "げきげん",
  "げきだん",
  "げきちん",
  "げきとつ",
  "げきは",
  "げきやく",
  "げこう",
  "げこくじょう",
  "げざい",
  "けさき",
  "げざん",
  "けしき",
  "けしごむ",
  "けしょう",
  "げすと",
  "けたば",
  "けちゃっぷ",
  "けちらす",
  "けつあつ",
  "けつい",
  "けつえき",
  "けっこん",
  "けつじょ",
  "けっせき",
  "けってい",
  "けつまつ",
  "げつようび",
  "げつれい",
  "けつろん",
  "げどく",
  "けとばす",
  "けとる",
  "けなげ",
  "けなす",
  "けなみ",
  "けぬき",
  "げねつ",
  "けねん",
  "けはい",
  "げひん",
  "けぶかい",
  "げぼく",
  "けまり",
  "けみかる",
  "けむし",
  "けむり",
  "けもの",
  "けらい",
  "けろけろ",
  "けわしい",
  "けんい",
  "けんえつ",
  "けんお",
  "けんか",
  "げんき",
  "けんげん",
  "けんこう",
  "けんさく",
  "けんしゅう",
  "けんすう",
  "げんそう",
  "けんちく",
  "けんてい",
  "けんとう",
  "けんない",
  "けんにん",
  "げんぶつ",
  "けんま",
  "けんみん",
  "けんめい",
  "けんらん",
  "けんり",
  "こあくま",
  "こいぬ",
  "こいびと",
  "ごうい",
  "こうえん",
  "こうおん",
  "こうかん",
  "ごうきゅう",
  "ごうけい",
  "こうこう",
  "こうさい",
  "こうじ",
  "こうすい",
  "ごうせい",
  "こうそく",
  "こうたい",
  "こうちゃ",
  "こうつう",
  "こうてい",
  "こうどう",
  "こうない",
  "こうはい",
  "ごうほう",
  "ごうまん",
  "こうもく",
  "こうりつ",
  "こえる",
  "こおり",
  "ごかい",
  "ごがつ",
  "ごかん",
  "こくご",
  "こくさい",
  "こくとう",
  "こくない",
  "こくはく",
  "こぐま",
  "こけい",
  "こける",
  "ここのか",
  "こころ",
  "こさめ",
  "こしつ",
  "こすう",
  "こせい",
  "こせき",
  "こぜん",
  "こそだて",
  "こたい",
  "こたえる",
  "こたつ",
  "こちょう",
  "こっか",
  "こつこつ",
  "こつばん",
  "こつぶ",
  "こてい",
  "こてん",
  "ことがら",
  "ことし",
  "ことば",
  "ことり",
  "こなごな",
  "こねこね",
  "このまま",
  "このみ",
  "このよ",
  "ごはん",
  "こひつじ",
  "こふう",
  "こふん",
  "こぼれる",
  "ごまあぶら",
  "こまかい",
  "ごますり",
  "こまつな",
  "こまる",
  "こむぎこ",
  "こもじ",
  "こもち",
  "こもの",
  "こもん",
  "こやく",
  "こやま",
  "こゆう",
  "こゆび",
  "こよい",
  "こよう",
  "こりる",
  "これくしょん",
  "ころっけ",
  "こわもて",
  "こわれる",
  "こんいん",
  "こんかい",
  "こんき",
  "こんしゅう",
  "こんすい",
  "こんだて",
  "こんとん",
  "こんなん",
  "こんびに",
  "こんぽん",
  "こんまけ",
  "こんや",
  "こんれい",
  "こんわく",
  "ざいえき",
  "さいかい",
  "さいきん",
  "ざいげん",
  "ざいこ",
  "さいしょ",
  "さいせい",
  "ざいたく",
  "ざいちゅう",
  "さいてき",
  "ざいりょう",
  "さうな",
  "さかいし",
  "さがす",
  "さかな",
  "さかみち",
  "さがる",
  "さぎょう",
  "さくし",
  "さくひん",
  "さくら",
  "さこく",
  "さこつ",
  "さずかる",
  "ざせき",
  "さたん",
  "さつえい",
  "ざつおん",
  "ざっか",
  "ざつがく",
  "さっきょく",
  "ざっし",
  "さつじん",
  "ざっそう",
  "さつたば",
  "さつまいも",
  "さてい",
  "さといも",
  "さとう",
  "さとおや",
  "さとし",
  "さとる",
  "さのう",
  "さばく",
  "さびしい",
  "さべつ",
  "さほう",
  "さほど",
  "さます",
  "さみしい",
  "さみだれ",
  "さむけ",
  "さめる",
  "さやえんどう",
  "さゆう",
  "さよう",
  "さよく",
  "さらだ",
  "ざるそば",
  "さわやか",
  "さわる",
  "さんいん",
  "さんか",
  "さんきゃく",
  "さんこう",
  "さんさい",
  "ざんしょ",
  "さんすう",
  "さんせい",
  "さんそ",
  "さんち",
  "さんま",
  "さんみ",
  "さんらん",
  "しあい",
  "しあげ",
  "しあさって",
  "しあわせ",
  "しいく",
  "しいん",
  "しうち",
  "しえい",
  "しおけ",
  "しかい",
  "しかく",
  "じかん",
  "しごと",
  "しすう",
  "じだい",
  "したうけ",
  "したぎ",
  "したて",
  "したみ",
  "しちょう",
  "しちりん",
  "しっかり",
  "しつじ",
  "しつもん",
  "してい",
  "してき",
  "してつ",
  "じてん",
  "じどう",
  "しなぎれ",
  "しなもの",
  "しなん",
  "しねま",
  "しねん",
  "しのぐ",
  "しのぶ",
  "しはい",
  "しばかり",
  "しはつ",
  "しはらい",
  "しはん",
  "しひょう",
  "しふく",
  "じぶん",
  "しへい",
  "しほう",
  "しほん",
  "しまう",
  "しまる",
  "しみん",
  "しむける",
  "じむしょ",
  "しめい",
  "しめる",
  "しもん",
  "しゃいん",
  "しゃうん",
  "しゃおん",
  "じゃがいも",
  "しやくしょ",
  "しゃくほう",
  "しゃけん",
  "しゃこ",
  "しゃざい",
  "しゃしん",
  "しゃせん",
  "しゃそう",
  "しゃたい",
  "しゃちょう",
  "しゃっきん",
  "じゃま",
  "しゃりん",
  "しゃれい",
  "じゆう",
  "じゅうしょ",
  "しゅくはく",
  "じゅしん",
  "しゅっせき",
  "しゅみ",
  "しゅらば",
  "じゅんばん",
  "しょうかい",
  "しょくたく",
  "しょっけん",
  "しょどう",
  "しょもつ",
  "しらせる",
  "しらべる",
  "しんか",
  "しんこう",
  "じんじゃ",
  "しんせいじ",
  "しんちく",
  "しんりん",
  "すあげ",
  "すあし",
  "すあな",
  "ずあん",
  "すいえい",
  "すいか",
  "すいとう",
  "ずいぶん",
  "すいようび",
  "すうがく",
  "すうじつ",
  "すうせん",
  "すおどり",
  "すきま",
  "すくう",
  "すくない",
  "すける",
  "すごい",
  "すこし",
  "ずさん",
  "すずしい",
  "すすむ",
  "すすめる",
  "すっかり",
  "ずっしり",
  "ずっと",
  "すてき",
  "すてる",
  "すねる",
  "すのこ",
  "すはだ",
  "すばらしい",
  "ずひょう",
  "ずぶぬれ",
  "すぶり",
  "すふれ",
  "すべて",
  "すべる",
  "ずほう",
  "すぼん",
  "すまい",
  "すめし",
  "すもう",
  "すやき",
  "すらすら",
  "するめ",
  "すれちがう",
  "すろっと",
  "すわる",
  "すんぜん",
  "すんぽう",
  "せあぶら",
  "せいかつ",
  "せいげん",
  "せいじ",
  "せいよう",
  "せおう",
  "せかいかん",
  "せきにん",
  "せきむ",
  "せきゆ",
  "せきらんうん",
  "せけん",
  "せこう",
  "せすじ",
  "せたい",
  "せたけ",
  "せっかく",
  "せっきゃく",
  "ぜっく",
  "せっけん",
  "せっこつ",
  "せっさたくま",
  "せつぞく",
  "せつだん",
  "せつでん",
  "せっぱん",
  "せつび",
  "せつぶん",
  "せつめい",
  "せつりつ",
  "せなか",
  "せのび",
  "せはば",
  "せびろ",
  "せぼね",
  "せまい",
  "せまる",
  "せめる",
  "せもたれ",
  "せりふ",
  "ぜんあく",
  "せんい",
  "せんえい",
  "せんか",
  "せんきょ",
  "せんく",
  "せんげん",
  "ぜんご",
  "せんさい",
  "せんしゅ",
  "せんすい",
  "せんせい",
  "せんぞ",
  "せんたく",
  "せんちょう",
  "せんてい",
  "せんとう",
  "せんぬき",
  "せんねん",
  "せんぱい",
  "ぜんぶ",
  "ぜんぽう",
  "せんむ",
  "せんめんじょ",
  "せんもん",
  "せんやく",
  "せんゆう",
  "せんよう",
  "ぜんら",
  "ぜんりゃく",
  "せんれい",
  "せんろ",
  "そあく",
  "そいとげる",
  "そいね",
  "そうがんきょう",
  "そうき",
  "そうご",
  "そうしん",
  "そうだん",
  "そうなん",
  "そうび",
  "そうめん",
  "そうり",
  "そえもの",
  "そえん",
  "そがい",
  "そげき",
  "そこう",
  "そこそこ",
  "そざい",
  "そしな",
  "そせい",
  "そせん",
  "そそぐ",
  "そだてる",
  "そつう",
  "そつえん",
  "そっかん",
  "そつぎょう",
  "そっけつ",
  "そっこう",
  "そっせん",
  "そっと",
  "そとがわ",
  "そとづら",
  "そなえる",
  "そなた",
  "そふぼ",
  "そぼく",
  "そぼろ",
  "そまつ",
  "そまる",
  "そむく",
  "そむりえ",
  "そめる",
  "そもそも",
  "そよかぜ",
  "そらまめ",
  "そろう",
  "そんかい",
  "そんけい",
  "そんざい",
  "そんしつ",
  "そんぞく",
  "そんちょう",
  "ぞんび",
  "ぞんぶん",
  "そんみん",
  "たあい",
  "たいいん",
  "たいうん",
  "たいえき",
  "たいおう",
  "だいがく",
  "たいき",
  "たいぐう",
  "たいけん",
  "たいこ",
  "たいざい",
  "だいじょうぶ",
  "だいすき",
  "たいせつ",
  "たいそう",
  "だいたい",
  "たいちょう",
  "たいてい",
  "だいどころ",
  "たいない",
  "たいねつ",
  "たいのう",
  "たいはん",
  "だいひょう",
  "たいふう",
  "たいへん",
  "たいほ",
  "たいまつばな",
  "たいみんぐ",
  "たいむ",
  "たいめん",
  "たいやき",
  "たいよう",
  "たいら",
  "たいりょく",
  "たいる",
  "たいわん",
  "たうえ",
  "たえる",
  "たおす",
  "たおる",
  "たおれる",
  "たかい",
  "たかね",
  "たきび",
  "たくさん",
  "たこく",
  "たこやき",
  "たさい",
  "たしざん",
  "だじゃれ",
  "たすける",
  "たずさわる",
  "たそがれ",
  "たたかう",
  "たたく",
  "ただしい",
  "たたみ",
  "たちばな",
  "だっかい",
  "だっきゃく",
  "だっこ",
  "だっしゅつ",
  "だったい",
  "たてる",
  "たとえる",
  "たなばた",
  "たにん",
  "たぬき",
  "たのしみ",
  "たはつ",
  "たぶん",
  "たべる",
  "たぼう",
  "たまご",
  "たまる",
  "だむる",
  "ためいき",
  "ためす",
  "ためる",
  "たもつ",
  "たやすい",
  "たよる",
  "たらす",
  "たりきほんがん",
  "たりょう",
  "たりる",
  "たると",
  "たれる",
  "たれんと",
  "たろっと",
  "たわむれる",
  "だんあつ",
  "たんい",
  "たんおん",
  "たんか",
  "たんき",
  "たんけん",
  "たんご",
  "たんさん",
  "たんじょうび",
  "だんせい",
  "たんそく",
  "たんたい",
  "だんち",
  "たんてい",
  "たんとう",
  "だんな",
  "たんにん",
  "だんねつ",
  "たんのう",
  "たんぴん",
  "だんぼう",
  "たんまつ",
  "たんめい",
  "だんれつ",
  "だんろ",
  "だんわ",
  "ちあい",
  "ちあん",
  "ちいき",
  "ちいさい",
  "ちえん",
  "ちかい",
  "ちから",
  "ちきゅう",
  "ちきん",
  "ちけいず",
  "ちけん",
  "ちこく",
  "ちさい",
  "ちしき",
  "ちしりょう",
  "ちせい",
  "ちそう",
  "ちたい",
  "ちたん",
  "ちちおや",
  "ちつじょ",
  "ちてき",
  "ちてん",
  "ちぬき",
  "ちぬり",
  "ちのう",
  "ちひょう",
  "ちへいせん",
  "ちほう",
  "ちまた",
  "ちみつ",
  "ちみどろ",
  "ちめいど",
  "ちゃんこなべ",
  "ちゅうい",
  "ちゆりょく",
  "ちょうし",
  "ちょさくけん",
  "ちらし",
  "ちらみ",
  "ちりがみ",
  "ちりょう",
  "ちるど",
  "ちわわ",
  "ちんたい",
  "ちんもく",
  "ついか",
  "ついたち",
  "つうか",
  "つうじょう",
  "つうはん",
  "つうわ",
  "つかう",
  "つかれる",
  "つくね",
  "つくる",
  "つけね",
  "つける",
  "つごう",
  "つたえる",
  "つづく",
  "つつじ",
  "つつむ",
  "つとめる",
  "つながる",
  "つなみ",
  "つねづね",
  "つのる",
  "つぶす",
  "つまらない",
  "つまる",
  "つみき",
  "つめたい",
  "つもり",
  "つもる",
  "つよい",
  "つるぼ",
  "つるみく",
  "つわもの",
  "つわり",
  "てあし",
  "てあて",
  "てあみ",
  "ていおん",
  "ていか",
  "ていき",
  "ていけい",
  "ていこく",
  "ていさつ",
  "ていし",
  "ていせい",
  "ていたい",
  "ていど",
  "ていねい",
  "ていひょう",
  "ていへん",
  "ていぼう",
  "てうち",
  "ておくれ",
  "てきとう",
  "てくび",
  "でこぼこ",
  "てさぎょう",
  "てさげ",
  "てすり",
  "てそう",
  "てちがい",
  "てちょう",
  "てつがく",
  "てつづき",
  "でっぱ",
  "てつぼう",
  "てつや",
  "でぬかえ",
  "てぬき",
  "てぬぐい",
  "てのひら",
  "てはい",
  "てぶくろ",
  "てふだ",
  "てほどき",
  "てほん",
  "てまえ",
  "てまきずし",
  "てみじか",
  "てみやげ",
  "てらす",
  "てれび",
  "てわけ",
  "てわたし",
  "でんあつ",
  "てんいん",
  "てんかい",
  "てんき",
  "てんぐ",
  "てんけん",
  "てんごく",
  "てんさい",
  "てんし",
  "てんすう",
  "でんち",
  "てんてき",
  "てんとう",
  "てんない",
  "てんぷら",
  "てんぼうだい",
  "てんめつ",
  "てんらんかい",
  "でんりょく",
  "でんわ",
  "どあい",
  "といれ",
  "どうかん",
  "とうきゅう",
  "どうぐ",
  "とうし",
  "とうむぎ",
  "とおい",
  "とおか",
  "とおく",
  "とおす",
  "とおる",
  "とかい",
  "とかす",
  "ときおり",
  "ときどき",
  "とくい",
  "とくしゅう",
  "とくてん",
  "とくに",
  "とくべつ",
  "とけい",
  "とける",
  "とこや",
  "とさか",
  "としょかん",
  "とそう",
  "とたん",
  "とちゅう",
  "とっきゅう",
  "とっくん",
  "とつぜん",
  "とつにゅう",
  "とどける",
  "ととのえる",
  "とない",
  "となえる",
  "となり",
  "とのさま",
  "とばす",
  "どぶがわ",
  "とほう",
  "とまる",
  "とめる",
  "ともだち",
  "ともる",
  "どようび",
  "とらえる",
  "とんかつ",
  "どんぶり",
  "ないかく",
  "ないこう",
  "ないしょ",
  "ないす",
  "ないせん",
  "ないそう",
  "なおす",
  "ながい",
  "なくす",
  "なげる",
  "なこうど",
  "なさけ",
  "なたでここ",
  "なっとう",
  "なつやすみ",
  "ななおし",
  "なにごと",
  "なにもの",
  "なにわ",
  "なのか",
  "なふだ",
  "なまいき",
  "なまえ",
  "なまみ",
  "なみだ",
  "なめらか",
  "なめる",
  "なやむ",
  "ならう",
  "ならび",
  "ならぶ",
  "なれる",
  "なわとび",
  "なわばり",
  "にあう",
  "にいがた",
  "にうけ",
  "におい",
  "にかい",
  "にがて",
  "にきび",
  "にくしみ",
  "にくまん",
  "にげる",
  "にさんかたんそ",
  "にしき",
  "にせもの",
  "にちじょう",
  "にちようび",
  "にっか",
  "にっき",
  "にっけい",
  "にっこう",
  "にっさん",
  "にっしょく",
  "にっすう",
  "にっせき",
  "にってい",
  "になう",
  "にほん",
  "にまめ",
  "にもつ",
  "にやり",
  "にゅういん",
  "にりんしゃ",
  "にわとり",
  "にんい",
  "にんか",
  "にんき",
  "にんげん",
  "にんしき",
  "にんずう",
  "にんそう",
  "にんたい",
  "にんち",
  "にんてい",
  "にんにく",
  "にんぷ",
  "にんまり",
  "にんむ",
  "にんめい",
  "にんよう",
  "ぬいくぎ",
  "ぬかす",
  "ぬぐいとる",
  "ぬぐう",
  "ぬくもり",
  "ぬすむ",
  "ぬまえび",
  "ぬめり",
  "ぬらす",
  "ぬんちゃく",
  "ねあげ",
  "ねいき",
  "ねいる",
  "ねいろ",
  "ねぐせ",
  "ねくたい",
  "ねくら",
  "ねこぜ",
  "ねこむ",
  "ねさげ",
  "ねすごす",
  "ねそべる",
  "ねだん",
  "ねつい",
  "ねっしん",
  "ねつぞう",
  "ねったいぎょ",
  "ねぶそく",
  "ねふだ",
  "ねぼう",
  "ねほりはほり",
  "ねまき",
  "ねまわし",
  "ねみみ",
  "ねむい",
  "ねむたい",
  "ねもと",
  "ねらう",
  "ねわざ",
  "ねんいり",
  "ねんおし",
  "ねんかん",
  "ねんきん",
  "ねんぐ",
  "ねんざ",
  "ねんし",
  "ねんちゃく",
  "ねんど",
  "ねんぴ",
  "ねんぶつ",
  "ねんまつ",
  "ねんりょう",
  "ねんれい",
  "のいず",
  "のおづま",
  "のがす",
  "のきなみ",
  "のこぎり",
  "のこす",
  "のこる",
  "のせる",
  "のぞく",
  "のぞむ",
  "のたまう",
  "のちほど",
  "のっく",
  "のばす",
  "のはら",
  "のべる",
  "のぼる",
  "のみもの",
  "のやま",
  "のらいぬ",
  "のらねこ",
  "のりもの",
  "のりゆき",
  "のれん",
  "のんき",
  "ばあい",
  "はあく",
  "ばあさん",
  "ばいか",
  "ばいく",
  "はいけん",
  "はいご",
  "はいしん",
  "はいすい",
  "はいせん",
  "はいそう",
  "はいち",
  "ばいばい",
  "はいれつ",
  "はえる",
  "はおる",
  "はかい",
  "ばかり",
  "はかる",
  "はくしゅ",
  "はけん",
  "はこぶ",
  "はさみ",
  "はさん",
  "はしご",
  "ばしょ",
  "はしる",
  "はせる",
  "ぱそこん",
  "はそん",
  "はたん",
  "はちみつ",
  "はつおん",
  "はっかく",
  "はづき",
  "はっきり",
  "はっくつ",
  "はっけん",
  "はっこう",
  "はっさん",
  "はっしん",
  "はったつ",
  "はっちゅう",
  "はってん",
  "はっぴょう",
  "はっぽう",
  "はなす",
  "はなび",
  "はにかむ",
  "はぶらし",
  "はみがき",
  "はむかう",
  "はめつ",
  "はやい",
  "はやし",
  "はらう",
  "はろうぃん",
  "はわい",
  "はんい",
  "はんえい",
  "はんおん",
  "はんかく",
  "はんきょう",
  "ばんぐみ",
  "はんこ",
  "はんしゃ",
  "はんすう",
  "はんだん",
  "ぱんち",
  "ぱんつ",
  "はんてい",
  "はんとし",
  "はんのう",
  "はんぱ",
  "はんぶん",
  "はんぺん",
  "はんぼうき",
  "はんめい",
  "はんらん",
  "はんろん",
  "ひいき",
  "ひうん",
  "ひえる",
  "ひかく",
  "ひかり",
  "ひかる",
  "ひかん",
  "ひくい",
  "ひけつ",
  "ひこうき",
  "ひこく",
  "ひさい",
  "ひさしぶり",
  "ひさん",
  "びじゅつかん",
  "ひしょ",
  "ひそか",
  "ひそむ",
  "ひたむき",
  "ひだり",
  "ひたる",
  "ひつぎ",
  "ひっこし",
  "ひっし",
  "ひつじゅひん",
  "ひっす",
  "ひつぜん",
  "ぴったり",
  "ぴっちり",
  "ひつよう",
  "ひてい",
  "ひとごみ",
  "ひなまつり",
  "ひなん",
  "ひねる",
  "ひはん",
  "ひびく",
  "ひひょう",
  "ひほう",
  "ひまわり",
  "ひまん",
  "ひみつ",
  "ひめい",
  "ひめじし",
  "ひやけ",
  "ひやす",
  "ひよう",
  "びょうき",
  "ひらがな",
  "ひらく",
  "ひりつ",
  "ひりょう",
  "ひるま",
  "ひるやすみ",
  "ひれい",
  "ひろい",
  "ひろう",
  "ひろき",
  "ひろゆき",
  "ひんかく",
  "ひんけつ",
  "ひんこん",
  "ひんしゅ",
  "ひんそう",
  "ぴんち",
  "ひんぱん",
  "びんぼう",
  "ふあん",
  "ふいうち",
  "ふうけい",
  "ふうせん",
  "ぷうたろう",
  "ふうとう",
  "ふうふ",
  "ふえる",
  "ふおん",
  "ふかい",
  "ふきん",
  "ふくざつ",
  "ふくぶくろ",
  "ふこう",
  "ふさい",
  "ふしぎ",
  "ふじみ",
  "ふすま",
  "ふせい",
  "ふせぐ",
  "ふそく",
  "ぶたにく",
  "ふたん",
  "ふちょう",
  "ふつう",
  "ふつか",
  "ふっかつ",
  "ふっき",
  "ふっこく",
  "ぶどう",
  "ふとる",
  "ふとん",
  "ふのう",
  "ふはい",
  "ふひょう",
  "ふへん",
  "ふまん",
  "ふみん",
  "ふめつ",
  "ふめん",
  "ふよう",
  "ふりこ",
  "ふりる",
  "ふるい",
  "ふんいき",
  "ぶんがく",
  "ぶんぐ",
  "ふんしつ",
  "ぶんせき",
  "ふんそう",
  "ぶんぽう",
  "へいあん",
  "へいおん",
  "へいがい",
  "へいき",
  "へいげん",
  "へいこう",
  "へいさ",
  "へいしゃ",
  "へいせつ",
  "へいそ",
  "へいたく",
  "へいてん",
  "へいねつ",
  "へいわ",
  "へきが",
  "へこむ",
  "べにいろ",
  "べにしょうが",
  "へらす",
  "へんかん",
  "べんきょう",
  "べんごし",
  "へんさい",
  "へんたい",
  "べんり",
  "ほあん",
  "ほいく",
  "ぼうぎょ",
  "ほうこく",
  "ほうそう",
  "ほうほう",
  "ほうもん",
  "ほうりつ",
  "ほえる",
  "ほおん",
  "ほかん",
  "ほきょう",
  "ぼきん",
  "ほくろ",
  "ほけつ",
  "ほけん",
  "ほこう",
  "ほこる",
  "ほしい",
  "ほしつ",
  "ほしゅ",
  "ほしょう",
  "ほせい",
  "ほそい",
  "ほそく",
  "ほたて",
  "ほたる",
  "ぽちぶくろ",
  "ほっきょく",
  "ほっさ",
  "ほったん",
  "ほとんど",
  "ほめる",
  "ほんい",
  "ほんき",
  "ほんけ",
  "ほんしつ",
  "ほんやく",
  "まいにち",
  "まかい",
  "まかせる",
  "まがる",
  "まける",
  "まこと",
  "まさつ",
  "まじめ",
  "ますく",
  "まぜる",
  "まつり",
  "まとめ",
  "まなぶ",
  "まぬけ",
  "まねく",
  "まほう",
  "まもる",
  "まゆげ",
  "まよう",
  "まろやか",
  "まわす",
  "まわり",
  "まわる",
  "まんが",
  "まんきつ",
  "まんぞく",
  "まんなか",
  "みいら",
  "みうち",
  "みえる",
  "みがく",
  "みかた",
  "みかん",
  "みけん",
  "みこん",
  "みじかい",
  "みすい",
  "みすえる",
  "みせる",
  "みっか",
  "みつかる",
  "みつける",
  "みてい",
  "みとめる",
  "みなと",
  "みなみかさい",
  "みねらる",
  "みのう",
  "みのがす",
  "みほん",
  "みもと",
  "みやげ",
  "みらい",
  "みりょく",
  "みわく",
  "みんか",
  "みんぞく",
  "むいか",
  "むえき",
  "むえん",
  "むかい",
  "むかう",
  "むかえ",
  "むかし",
  "むぎちゃ",
  "むける",
  "むげん",
  "むさぼる",
  "むしあつい",
  "むしば",
  "むじゅん",
  "むしろ",
  "むすう",
  "むすこ",
  "むすぶ",
  "むすめ",
  "むせる",
  "むせん",
  "むちゅう",
  "むなしい",
  "むのう",
  "むやみ",
  "むよう",
  "むらさき",
  "むりょう",
  "むろん",
  "めいあん",
  "めいうん",
  "めいえん",
  "めいかく",
  "めいきょく",
  "めいさい",
  "めいし",
  "めいそう",
  "めいぶつ",
  "めいれい",
  "めいわく",
  "めぐまれる",
  "めざす",
  "めした",
  "めずらしい",
  "めだつ",
  "めまい",
  "めやす",
  "めんきょ",
  "めんせき",
  "めんどう",
  "もうしあげる",
  "もうどうけん",
  "もえる",
  "もくし",
  "もくてき",
  "もくようび",
  "もちろん",
  "もどる",
  "もらう",
  "もんく",
  "もんだい",
  "やおや",
  "やける",
  "やさい",
  "やさしい",
  "やすい",
  "やすたろう",
  "やすみ",
  "やせる",
  "やそう",
  "やたい",
  "やちん",
  "やっと",
  "やっぱり",
  "やぶる",
  "やめる",
  "ややこしい",
  "やよい",
  "やわらかい",
  "ゆうき",
  "ゆうびんきょく",
  "ゆうべ",
  "ゆうめい",
  "ゆけつ",
  "ゆしゅつ",
  "ゆせん",
  "ゆそう",
  "ゆたか",
  "ゆちゃく",
  "ゆでる",
  "ゆにゅう",
  "ゆびわ",
  "ゆらい",
  "ゆれる",
  "ようい",
  "ようか",
  "ようきゅう",
  "ようじ",
  "ようす",
  "ようちえん",
  "よかぜ",
  "よかん",
  "よきん",
  "よくせい",
  "よくぼう",
  "よけい",
  "よごれる",
  "よさん",
  "よしゅう",
  "よそう",
  "よそく",
  "よっか",
  "よてい",
  "よどがわく",
  "よねつ",
  "よやく",
  "よゆう",
  "よろこぶ",
  "よろしい",
  "らいう",
  "らくがき",
  "らくご",
  "らくさつ",
  "らくだ",
  "らしんばん",
  "らせん",
  "らぞく",
  "らたい",
  "らっか",
  "られつ",
  "りえき",
  "りかい",
  "りきさく",
  "りきせつ",
  "りくぐん",
  "りくつ",
  "りけん",
  "りこう",
  "りせい",
  "りそう",
  "りそく",
  "りてん",
  "りねん",
  "りゆう",
  "りゅうがく",
  "りよう",
  "りょうり",
  "りょかん",
  "りょくちゃ",
  "りょこう",
  "りりく",
  "りれき",
  "りろん",
  "りんご",
  "るいけい",
  "るいさい",
  "るいじ",
  "るいせき",
  "るすばん",
  "るりがわら",
  "れいかん",
  "れいぎ",
  "れいせい",
  "れいぞうこ",
  "れいとう",
  "れいぼう",
  "れきし",
  "れきだい",
  "れんあい",
  "れんけい",
  "れんこん",
  "れんさい",
  "れんしゅう",
  "れんぞく",
  "れんらく",
  "ろうか",
  "ろうご",
  "ろうじん",
  "ろうそく",
  "ろくが",
  "ろこつ",
  "ろじうら",
  "ろしゅつ",
  "ろせん",
  "ろてん",
  "ろめん",
  "ろれつ",
  "ろんぎ",
  "ろんぱ",
  "ろんぶん",
  "ろんり",
  "わかす",
  "わかめ",
  "わかやま",
  "わかれる",
  "わしつ",
  "わじまし",
  "わすれもの",
  "わらう",
  "われる"
], O1e = [
  "abacate",
  "abaixo",
  "abalar",
  "abater",
  "abduzir",
  "abelha",
  "aberto",
  "abismo",
  "abotoar",
  "abranger",
  "abreviar",
  "abrigar",
  "abrupto",
  "absinto",
  "absoluto",
  "absurdo",
  "abutre",
  "acabado",
  "acalmar",
  "acampar",
  "acanhar",
  "acaso",
  "aceitar",
  "acelerar",
  "acenar",
  "acervo",
  "acessar",
  "acetona",
  "achatar",
  "acidez",
  "acima",
  "acionado",
  "acirrar",
  "aclamar",
  "aclive",
  "acolhida",
  "acomodar",
  "acoplar",
  "acordar",
  "acumular",
  "acusador",
  "adaptar",
  "adega",
  "adentro",
  "adepto",
  "adequar",
  "aderente",
  "adesivo",
  "adeus",
  "adiante",
  "aditivo",
  "adjetivo",
  "adjunto",
  "admirar",
  "adorar",
  "adquirir",
  "adubo",
  "adverso",
  "advogado",
  "aeronave",
  "afastar",
  "aferir",
  "afetivo",
  "afinador",
  "afivelar",
  "aflito",
  "afluente",
  "afrontar",
  "agachar",
  "agarrar",
  "agasalho",
  "agenciar",
  "agilizar",
  "agiota",
  "agitado",
  "agora",
  "agradar",
  "agreste",
  "agrupar",
  "aguardar",
  "agulha",
  "ajoelhar",
  "ajudar",
  "ajustar",
  "alameda",
  "alarme",
  "alastrar",
  "alavanca",
  "albergue",
  "albino",
  "alcatra",
  "aldeia",
  "alecrim",
  "alegria",
  "alertar",
  "alface",
  "alfinete",
  "algum",
  "alheio",
  "aliar",
  "alicate",
  "alienar",
  "alinhar",
  "aliviar",
  "almofada",
  "alocar",
  "alpiste",
  "alterar",
  "altitude",
  "alucinar",
  "alugar",
  "aluno",
  "alusivo",
  "alvo",
  "amaciar",
  "amador",
  "amarelo",
  "amassar",
  "ambas",
  "ambiente",
  "ameixa",
  "amenizar",
  "amido",
  "amistoso",
  "amizade",
  "amolador",
  "amontoar",
  "amoroso",
  "amostra",
  "amparar",
  "ampliar",
  "ampola",
  "anagrama",
  "analisar",
  "anarquia",
  "anatomia",
  "andaime",
  "anel",
  "anexo",
  "angular",
  "animar",
  "anjo",
  "anomalia",
  "anotado",
  "ansioso",
  "anterior",
  "anuidade",
  "anunciar",
  "anzol",
  "apagador",
  "apalpar",
  "apanhado",
  "apego",
  "apelido",
  "apertada",
  "apesar",
  "apetite",
  "apito",
  "aplauso",
  "aplicada",
  "apoio",
  "apontar",
  "aposta",
  "aprendiz",
  "aprovar",
  "aquecer",
  "arame",
  "aranha",
  "arara",
  "arcada",
  "ardente",
  "areia",
  "arejar",
  "arenito",
  "aresta",
  "argiloso",
  "argola",
  "arma",
  "arquivo",
  "arraial",
  "arrebate",
  "arriscar",
  "arroba",
  "arrumar",
  "arsenal",
  "arterial",
  "artigo",
  "arvoredo",
  "asfaltar",
  "asilado",
  "aspirar",
  "assador",
  "assinar",
  "assoalho",
  "assunto",
  "astral",
  "atacado",
  "atadura",
  "atalho",
  "atarefar",
  "atear",
  "atender",
  "aterro",
  "ateu",
  "atingir",
  "atirador",
  "ativo",
  "atoleiro",
  "atracar",
  "atrevido",
  "atriz",
  "atual",
  "atum",
  "auditor",
  "aumentar",
  "aura",
  "aurora",
  "autismo",
  "autoria",
  "autuar",
  "avaliar",
  "avante",
  "avaria",
  "avental",
  "avesso",
  "aviador",
  "avisar",
  "avulso",
  "axila",
  "azarar",
  "azedo",
  "azeite",
  "azulejo",
  "babar",
  "babosa",
  "bacalhau",
  "bacharel",
  "bacia",
  "bagagem",
  "baiano",
  "bailar",
  "baioneta",
  "bairro",
  "baixista",
  "bajular",
  "baleia",
  "baliza",
  "balsa",
  "banal",
  "bandeira",
  "banho",
  "banir",
  "banquete",
  "barato",
  "barbado",
  "baronesa",
  "barraca",
  "barulho",
  "baseado",
  "bastante",
  "batata",
  "batedor",
  "batida",
  "batom",
  "batucar",
  "baunilha",
  "beber",
  "beijo",
  "beirada",
  "beisebol",
  "beldade",
  "beleza",
  "belga",
  "beliscar",
  "bendito",
  "bengala",
  "benzer",
  "berimbau",
  "berlinda",
  "berro",
  "besouro",
  "bexiga",
  "bezerro",
  "bico",
  "bicudo",
  "bienal",
  "bifocal",
  "bifurcar",
  "bigorna",
  "bilhete",
  "bimestre",
  "bimotor",
  "biologia",
  "biombo",
  "biosfera",
  "bipolar",
  "birrento",
  "biscoito",
  "bisneto",
  "bispo",
  "bissexto",
  "bitola",
  "bizarro",
  "blindado",
  "bloco",
  "bloquear",
  "boato",
  "bobagem",
  "bocado",
  "bocejo",
  "bochecha",
  "boicotar",
  "bolada",
  "boletim",
  "bolha",
  "bolo",
  "bombeiro",
  "bonde",
  "boneco",
  "bonita",
  "borbulha",
  "borda",
  "boreal",
  "borracha",
  "bovino",
  "boxeador",
  "branco",
  "brasa",
  "braveza",
  "breu",
  "briga",
  "brilho",
  "brincar",
  "broa",
  "brochura",
  "bronzear",
  "broto",
  "bruxo",
  "bucha",
  "budismo",
  "bufar",
  "bule",
  "buraco",
  "busca",
  "busto",
  "buzina",
  "cabana",
  "cabelo",
  "cabide",
  "cabo",
  "cabrito",
  "cacau",
  "cacetada",
  "cachorro",
  "cacique",
  "cadastro",
  "cadeado",
  "cafezal",
  "caiaque",
  "caipira",
  "caixote",
  "cajado",
  "caju",
  "calafrio",
  "calcular",
  "caldeira",
  "calibrar",
  "calmante",
  "calota",
  "camada",
  "cambista",
  "camisa",
  "camomila",
  "campanha",
  "camuflar",
  "canavial",
  "cancelar",
  "caneta",
  "canguru",
  "canhoto",
  "canivete",
  "canoa",
  "cansado",
  "cantar",
  "canudo",
  "capacho",
  "capela",
  "capinar",
  "capotar",
  "capricho",
  "captador",
  "capuz",
  "caracol",
  "carbono",
  "cardeal",
  "careca",
  "carimbar",
  "carneiro",
  "carpete",
  "carreira",
  "cartaz",
  "carvalho",
  "casaco",
  "casca",
  "casebre",
  "castelo",
  "casulo",
  "catarata",
  "cativar",
  "caule",
  "causador",
  "cautelar",
  "cavalo",
  "caverna",
  "cebola",
  "cedilha",
  "cegonha",
  "celebrar",
  "celular",
  "cenoura",
  "censo",
  "centeio",
  "cercar",
  "cerrado",
  "certeiro",
  "cerveja",
  "cetim",
  "cevada",
  "chacota",
  "chaleira",
  "chamado",
  "chapada",
  "charme",
  "chatice",
  "chave",
  "chefe",
  "chegada",
  "cheiro",
  "cheque",
  "chicote",
  "chifre",
  "chinelo",
  "chocalho",
  "chover",
  "chumbo",
  "chutar",
  "chuva",
  "cicatriz",
  "ciclone",
  "cidade",
  "cidreira",
  "ciente",
  "cigana",
  "cimento",
  "cinto",
  "cinza",
  "ciranda",
  "circuito",
  "cirurgia",
  "citar",
  "clareza",
  "clero",
  "clicar",
  "clone",
  "clube",
  "coado",
  "coagir",
  "cobaia",
  "cobertor",
  "cobrar",
  "cocada",
  "coelho",
  "coentro",
  "coeso",
  "cogumelo",
  "coibir",
  "coifa",
  "coiote",
  "colar",
  "coleira",
  "colher",
  "colidir",
  "colmeia",
  "colono",
  "coluna",
  "comando",
  "combinar",
  "comentar",
  "comitiva",
  "comover",
  "complexo",
  "comum",
  "concha",
  "condor",
  "conectar",
  "confuso",
  "congelar",
  "conhecer",
  "conjugar",
  "consumir",
  "contrato",
  "convite",
  "cooperar",
  "copeiro",
  "copiador",
  "copo",
  "coquetel",
  "coragem",
  "cordial",
  "corneta",
  "coronha",
  "corporal",
  "correio",
  "cortejo",
  "coruja",
  "corvo",
  "cosseno",
  "costela",
  "cotonete",
  "couro",
  "couve",
  "covil",
  "cozinha",
  "cratera",
  "cravo",
  "creche",
  "credor",
  "creme",
  "crer",
  "crespo",
  "criada",
  "criminal",
  "crioulo",
  "crise",
  "criticar",
  "crosta",
  "crua",
  "cruzeiro",
  "cubano",
  "cueca",
  "cuidado",
  "cujo",
  "culatra",
  "culminar",
  "culpar",
  "cultura",
  "cumprir",
  "cunhado",
  "cupido",
  "curativo",
  "curral",
  "cursar",
  "curto",
  "cuspir",
  "custear",
  "cutelo",
  "damasco",
  "datar",
  "debater",
  "debitar",
  "deboche",
  "debulhar",
  "decalque",
  "decimal",
  "declive",
  "decote",
  "decretar",
  "dedal",
  "dedicado",
  "deduzir",
  "defesa",
  "defumar",
  "degelo",
  "degrau",
  "degustar",
  "deitado",
  "deixar",
  "delator",
  "delegado",
  "delinear",
  "delonga",
  "demanda",
  "demitir",
  "demolido",
  "dentista",
  "depenado",
  "depilar",
  "depois",
  "depressa",
  "depurar",
  "deriva",
  "derramar",
  "desafio",
  "desbotar",
  "descanso",
  "desenho",
  "desfiado",
  "desgaste",
  "desigual",
  "deslize",
  "desmamar",
  "desova",
  "despesa",
  "destaque",
  "desviar",
  "detalhar",
  "detentor",
  "detonar",
  "detrito",
  "deusa",
  "dever",
  "devido",
  "devotado",
  "dezena",
  "diagrama",
  "dialeto",
  "didata",
  "difuso",
  "digitar",
  "dilatado",
  "diluente",
  "diminuir",
  "dinastia",
  "dinheiro",
  "diocese",
  "direto",
  "discreta",
  "disfarce",
  "disparo",
  "disquete",
  "dissipar",
  "distante",
  "ditador",
  "diurno",
  "diverso",
  "divisor",
  "divulgar",
  "dizer",
  "dobrador",
  "dolorido",
  "domador",
  "dominado",
  "donativo",
  "donzela",
  "dormente",
  "dorsal",
  "dosagem",
  "dourado",
  "doutor",
  "drenagem",
  "drible",
  "drogaria",
  "duelar",
  "duende",
  "dueto",
  "duplo",
  "duquesa",
  "durante",
  "duvidoso",
  "eclodir",
  "ecoar",
  "ecologia",
  "edificar",
  "edital",
  "educado",
  "efeito",
  "efetivar",
  "ejetar",
  "elaborar",
  "eleger",
  "eleitor",
  "elenco",
  "elevador",
  "eliminar",
  "elogiar",
  "embargo",
  "embolado",
  "embrulho",
  "embutido",
  "emenda",
  "emergir",
  "emissor",
  "empatia",
  "empenho",
  "empinado",
  "empolgar",
  "emprego",
  "empurrar",
  "emulador",
  "encaixe",
  "encenado",
  "enchente",
  "encontro",
  "endeusar",
  "endossar",
  "enfaixar",
  "enfeite",
  "enfim",
  "engajado",
  "engenho",
  "englobar",
  "engomado",
  "engraxar",
  "enguia",
  "enjoar",
  "enlatar",
  "enquanto",
  "enraizar",
  "enrolado",
  "enrugar",
  "ensaio",
  "enseada",
  "ensino",
  "ensopado",
  "entanto",
  "enteado",
  "entidade",
  "entortar",
  "entrada",
  "entulho",
  "envergar",
  "enviado",
  "envolver",
  "enxame",
  "enxerto",
  "enxofre",
  "enxuto",
  "epiderme",
  "equipar",
  "ereto",
  "erguido",
  "errata",
  "erva",
  "ervilha",
  "esbanjar",
  "esbelto",
  "escama",
  "escola",
  "escrita",
  "escuta",
  "esfinge",
  "esfolar",
  "esfregar",
  "esfumado",
  "esgrima",
  "esmalte",
  "espanto",
  "espelho",
  "espiga",
  "esponja",
  "espreita",
  "espumar",
  "esquerda",
  "estaca",
  "esteira",
  "esticar",
  "estofado",
  "estrela",
  "estudo",
  "esvaziar",
  "etanol",
  "etiqueta",
  "euforia",
  "europeu",
  "evacuar",
  "evaporar",
  "evasivo",
  "eventual",
  "evidente",
  "evoluir",
  "exagero",
  "exalar",
  "examinar",
  "exato",
  "exausto",
  "excesso",
  "excitar",
  "exclamar",
  "executar",
  "exemplo",
  "exibir",
  "exigente",
  "exonerar",
  "expandir",
  "expelir",
  "expirar",
  "explanar",
  "exposto",
  "expresso",
  "expulsar",
  "externo",
  "extinto",
  "extrato",
  "fabricar",
  "fabuloso",
  "faceta",
  "facial",
  "fada",
  "fadiga",
  "faixa",
  "falar",
  "falta",
  "familiar",
  "fandango",
  "fanfarra",
  "fantoche",
  "fardado",
  "farelo",
  "farinha",
  "farofa",
  "farpa",
  "fartura",
  "fatia",
  "fator",
  "favorita",
  "faxina",
  "fazenda",
  "fechado",
  "feijoada",
  "feirante",
  "felino",
  "feminino",
  "fenda",
  "feno",
  "fera",
  "feriado",
  "ferrugem",
  "ferver",
  "festejar",
  "fetal",
  "feudal",
  "fiapo",
  "fibrose",
  "ficar",
  "ficheiro",
  "figurado",
  "fileira",
  "filho",
  "filme",
  "filtrar",
  "firmeza",
  "fisgada",
  "fissura",
  "fita",
  "fivela",
  "fixador",
  "fixo",
  "flacidez",
  "flamingo",
  "flanela",
  "flechada",
  "flora",
  "flutuar",
  "fluxo",
  "focal",
  "focinho",
  "fofocar",
  "fogo",
  "foguete",
  "foice",
  "folgado",
  "folheto",
  "forjar",
  "formiga",
  "forno",
  "forte",
  "fosco",
  "fossa",
  "fragata",
  "fralda",
  "frango",
  "frasco",
  "fraterno",
  "freira",
  "frente",
  "fretar",
  "frieza",
  "friso",
  "fritura",
  "fronha",
  "frustrar",
  "fruteira",
  "fugir",
  "fulano",
  "fuligem",
  "fundar",
  "fungo",
  "funil",
  "furador",
  "furioso",
  "futebol",
  "gabarito",
  "gabinete",
  "gado",
  "gaiato",
  "gaiola",
  "gaivota",
  "galega",
  "galho",
  "galinha",
  "galocha",
  "ganhar",
  "garagem",
  "garfo",
  "gargalo",
  "garimpo",
  "garoupa",
  "garrafa",
  "gasoduto",
  "gasto",
  "gata",
  "gatilho",
  "gaveta",
  "gazela",
  "gelado",
  "geleia",
  "gelo",
  "gemada",
  "gemer",
  "gemido",
  "generoso",
  "gengiva",
  "genial",
  "genoma",
  "genro",
  "geologia",
  "gerador",
  "germinar",
  "gesso",
  "gestor",
  "ginasta",
  "gincana",
  "gingado",
  "girafa",
  "girino",
  "glacial",
  "glicose",
  "global",
  "glorioso",
  "goela",
  "goiaba",
  "golfe",
  "golpear",
  "gordura",
  "gorjeta",
  "gorro",
  "gostoso",
  "goteira",
  "governar",
  "gracejo",
  "gradual",
  "grafite",
  "gralha",
  "grampo",
  "granada",
  "gratuito",
  "graveto",
  "graxa",
  "grego",
  "grelhar",
  "greve",
  "grilo",
  "grisalho",
  "gritaria",
  "grosso",
  "grotesco",
  "grudado",
  "grunhido",
  "gruta",
  "guache",
  "guarani",
  "guaxinim",
  "guerrear",
  "guiar",
  "guincho",
  "guisado",
  "gula",
  "guloso",
  "guru",
  "habitar",
  "harmonia",
  "haste",
  "haver",
  "hectare",
  "herdar",
  "heresia",
  "hesitar",
  "hiato",
  "hibernar",
  "hidratar",
  "hiena",
  "hino",
  "hipismo",
  "hipnose",
  "hipoteca",
  "hoje",
  "holofote",
  "homem",
  "honesto",
  "honrado",
  "hormonal",
  "hospedar",
  "humorado",
  "iate",
  "ideia",
  "idoso",
  "ignorado",
  "igreja",
  "iguana",
  "ileso",
  "ilha",
  "iludido",
  "iluminar",
  "ilustrar",
  "imagem",
  "imediato",
  "imenso",
  "imersivo",
  "iminente",
  "imitador",
  "imortal",
  "impacto",
  "impedir",
  "implante",
  "impor",
  "imprensa",
  "impune",
  "imunizar",
  "inalador",
  "inapto",
  "inativo",
  "incenso",
  "inchar",
  "incidir",
  "incluir",
  "incolor",
  "indeciso",
  "indireto",
  "indutor",
  "ineficaz",
  "inerente",
  "infantil",
  "infestar",
  "infinito",
  "inflamar",
  "informal",
  "infrator",
  "ingerir",
  "inibido",
  "inicial",
  "inimigo",
  "injetar",
  "inocente",
  "inodoro",
  "inovador",
  "inox",
  "inquieto",
  "inscrito",
  "inseto",
  "insistir",
  "inspetor",
  "instalar",
  "insulto",
  "intacto",
  "integral",
  "intimar",
  "intocado",
  "intriga",
  "invasor",
  "inverno",
  "invicto",
  "invocar",
  "iogurte",
  "iraniano",
  "ironizar",
  "irreal",
  "irritado",
  "isca",
  "isento",
  "isolado",
  "isqueiro",
  "italiano",
  "janeiro",
  "jangada",
  "janta",
  "jararaca",
  "jardim",
  "jarro",
  "jasmim",
  "jato",
  "javali",
  "jazida",
  "jejum",
  "joaninha",
  "joelhada",
  "jogador",
  "joia",
  "jornal",
  "jorrar",
  "jovem",
  "juba",
  "judeu",
  "judoca",
  "juiz",
  "julgador",
  "julho",
  "jurado",
  "jurista",
  "juro",
  "justa",
  "labareda",
  "laboral",
  "lacre",
  "lactante",
  "ladrilho",
  "lagarta",
  "lagoa",
  "laje",
  "lamber",
  "lamentar",
  "laminar",
  "lampejo",
  "lanche",
  "lapidar",
  "lapso",
  "laranja",
  "lareira",
  "largura",
  "lasanha",
  "lastro",
  "lateral",
  "latido",
  "lavanda",
  "lavoura",
  "lavrador",
  "laxante",
  "lazer",
  "lealdade",
  "lebre",
  "legado",
  "legendar",
  "legista",
  "leigo",
  "leiloar",
  "leitura",
  "lembrete",
  "leme",
  "lenhador",
  "lentilha",
  "leoa",
  "lesma",
  "leste",
  "letivo",
  "letreiro",
  "levar",
  "leveza",
  "levitar",
  "liberal",
  "libido",
  "liderar",
  "ligar",
  "ligeiro",
  "limitar",
  "limoeiro",
  "limpador",
  "linda",
  "linear",
  "linhagem",
  "liquidez",
  "listagem",
  "lisura",
  "litoral",
  "livro",
  "lixa",
  "lixeira",
  "locador",
  "locutor",
  "lojista",
  "lombo",
  "lona",
  "longe",
  "lontra",
  "lorde",
  "lotado",
  "loteria",
  "loucura",
  "lousa",
  "louvar",
  "luar",
  "lucidez",
  "lucro",
  "luneta",
  "lustre",
  "lutador",
  "luva",
  "macaco",
  "macete",
  "machado",
  "macio",
  "madeira",
  "madrinha",
  "magnata",
  "magreza",
  "maior",
  "mais",
  "malandro",
  "malha",
  "malote",
  "maluco",
  "mamilo",
  "mamoeiro",
  "mamute",
  "manada",
  "mancha",
  "mandato",
  "manequim",
  "manhoso",
  "manivela",
  "manobrar",
  "mansa",
  "manter",
  "manusear",
  "mapeado",
  "maquinar",
  "marcador",
  "maresia",
  "marfim",
  "margem",
  "marinho",
  "marmita",
  "maroto",
  "marquise",
  "marreco",
  "martelo",
  "marujo",
  "mascote",
  "masmorra",
  "massagem",
  "mastigar",
  "matagal",
  "materno",
  "matinal",
  "matutar",
  "maxilar",
  "medalha",
  "medida",
  "medusa",
  "megafone",
  "meiga",
  "melancia",
  "melhor",
  "membro",
  "memorial",
  "menino",
  "menos",
  "mensagem",
  "mental",
  "merecer",
  "mergulho",
  "mesada",
  "mesclar",
  "mesmo",
  "mesquita",
  "mestre",
  "metade",
  "meteoro",
  "metragem",
  "mexer",
  "mexicano",
  "micro",
  "migalha",
  "migrar",
  "milagre",
  "milenar",
  "milhar",
  "mimado",
  "minerar",
  "minhoca",
  "ministro",
  "minoria",
  "miolo",
  "mirante",
  "mirtilo",
  "misturar",
  "mocidade",
  "moderno",
  "modular",
  "moeda",
  "moer",
  "moinho",
  "moita",
  "moldura",
  "moleza",
  "molho",
  "molinete",
  "molusco",
  "montanha",
  "moqueca",
  "morango",
  "morcego",
  "mordomo",
  "morena",
  "mosaico",
  "mosquete",
  "mostarda",
  "motel",
  "motim",
  "moto",
  "motriz",
  "muda",
  "muito",
  "mulata",
  "mulher",
  "multar",
  "mundial",
  "munido",
  "muralha",
  "murcho",
  "muscular",
  "museu",
  "musical",
  "nacional",
  "nadador",
  "naja",
  "namoro",
  "narina",
  "narrado",
  "nascer",
  "nativa",
  "natureza",
  "navalha",
  "navegar",
  "navio",
  "neblina",
  "nebuloso",
  "negativa",
  "negociar",
  "negrito",
  "nervoso",
  "neta",
  "neural",
  "nevasca",
  "nevoeiro",
  "ninar",
  "ninho",
  "nitidez",
  "nivelar",
  "nobreza",
  "noite",
  "noiva",
  "nomear",
  "nominal",
  "nordeste",
  "nortear",
  "notar",
  "noticiar",
  "noturno",
  "novelo",
  "novilho",
  "novo",
  "nublado",
  "nudez",
  "numeral",
  "nupcial",
  "nutrir",
  "nuvem",
  "obcecado",
  "obedecer",
  "objetivo",
  "obrigado",
  "obscuro",
  "obstetra",
  "obter",
  "obturar",
  "ocidente",
  "ocioso",
  "ocorrer",
  "oculista",
  "ocupado",
  "ofegante",
  "ofensiva",
  "oferenda",
  "oficina",
  "ofuscado",
  "ogiva",
  "olaria",
  "oleoso",
  "olhar",
  "oliveira",
  "ombro",
  "omelete",
  "omisso",
  "omitir",
  "ondulado",
  "oneroso",
  "ontem",
  "opcional",
  "operador",
  "oponente",
  "oportuno",
  "oposto",
  "orar",
  "orbitar",
  "ordem",
  "ordinal",
  "orfanato",
  "orgasmo",
  "orgulho",
  "oriental",
  "origem",
  "oriundo",
  "orla",
  "ortodoxo",
  "orvalho",
  "oscilar",
  "ossada",
  "osso",
  "ostentar",
  "otimismo",
  "ousadia",
  "outono",
  "outubro",
  "ouvido",
  "ovelha",
  "ovular",
  "oxidar",
  "oxigenar",
  "pacato",
  "paciente",
  "pacote",
  "pactuar",
  "padaria",
  "padrinho",
  "pagar",
  "pagode",
  "painel",
  "pairar",
  "paisagem",
  "palavra",
  "palestra",
  "palheta",
  "palito",
  "palmada",
  "palpitar",
  "pancada",
  "panela",
  "panfleto",
  "panqueca",
  "pantanal",
  "papagaio",
  "papelada",
  "papiro",
  "parafina",
  "parcial",
  "pardal",
  "parede",
  "partida",
  "pasmo",
  "passado",
  "pastel",
  "patamar",
  "patente",
  "patinar",
  "patrono",
  "paulada",
  "pausar",
  "peculiar",
  "pedalar",
  "pedestre",
  "pediatra",
  "pedra",
  "pegada",
  "peitoral",
  "peixe",
  "pele",
  "pelicano",
  "penca",
  "pendurar",
  "peneira",
  "penhasco",
  "pensador",
  "pente",
  "perceber",
  "perfeito",
  "pergunta",
  "perito",
  "permitir",
  "perna",
  "perplexo",
  "persiana",
  "pertence",
  "peruca",
  "pescado",
  "pesquisa",
  "pessoa",
  "petiscar",
  "piada",
  "picado",
  "piedade",
  "pigmento",
  "pilastra",
  "pilhado",
  "pilotar",
  "pimenta",
  "pincel",
  "pinguim",
  "pinha",
  "pinote",
  "pintar",
  "pioneiro",
  "pipoca",
  "piquete",
  "piranha",
  "pires",
  "pirueta",
  "piscar",
  "pistola",
  "pitanga",
  "pivete",
  "planta",
  "plaqueta",
  "platina",
  "plebeu",
  "plumagem",
  "pluvial",
  "pneu",
  "poda",
  "poeira",
  "poetisa",
  "polegada",
  "policiar",
  "poluente",
  "polvilho",
  "pomar",
  "pomba",
  "ponderar",
  "pontaria",
  "populoso",
  "porta",
  "possuir",
  "postal",
  "pote",
  "poupar",
  "pouso",
  "povoar",
  "praia",
  "prancha",
  "prato",
  "praxe",
  "prece",
  "predador",
  "prefeito",
  "premiar",
  "prensar",
  "preparar",
  "presilha",
  "pretexto",
  "prevenir",
  "prezar",
  "primata",
  "princesa",
  "prisma",
  "privado",
  "processo",
  "produto",
  "profeta",
  "proibido",
  "projeto",
  "prometer",
  "propagar",
  "prosa",
  "protetor",
  "provador",
  "publicar",
  "pudim",
  "pular",
  "pulmonar",
  "pulseira",
  "punhal",
  "punir",
  "pupilo",
  "pureza",
  "puxador",
  "quadra",
  "quantia",
  "quarto",
  "quase",
  "quebrar",
  "queda",
  "queijo",
  "quente",
  "querido",
  "quimono",
  "quina",
  "quiosque",
  "rabanada",
  "rabisco",
  "rachar",
  "racionar",
  "radial",
  "raiar",
  "rainha",
  "raio",
  "raiva",
  "rajada",
  "ralado",
  "ramal",
  "ranger",
  "ranhura",
  "rapadura",
  "rapel",
  "rapidez",
  "raposa",
  "raquete",
  "raridade",
  "rasante",
  "rascunho",
  "rasgar",
  "raspador",
  "rasteira",
  "rasurar",
  "ratazana",
  "ratoeira",
  "realeza",
  "reanimar",
  "reaver",
  "rebaixar",
  "rebelde",
  "rebolar",
  "recado",
  "recente",
  "recheio",
  "recibo",
  "recordar",
  "recrutar",
  "recuar",
  "rede",
  "redimir",
  "redonda",
  "reduzida",
  "reenvio",
  "refinar",
  "refletir",
  "refogar",
  "refresco",
  "refugiar",
  "regalia",
  "regime",
  "regra",
  "reinado",
  "reitor",
  "rejeitar",
  "relativo",
  "remador",
  "remendo",
  "remorso",
  "renovado",
  "reparo",
  "repelir",
  "repleto",
  "repolho",
  "represa",
  "repudiar",
  "requerer",
  "resenha",
  "resfriar",
  "resgatar",
  "residir",
  "resolver",
  "respeito",
  "ressaca",
  "restante",
  "resumir",
  "retalho",
  "reter",
  "retirar",
  "retomada",
  "retratar",
  "revelar",
  "revisor",
  "revolta",
  "riacho",
  "rica",
  "rigidez",
  "rigoroso",
  "rimar",
  "ringue",
  "risada",
  "risco",
  "risonho",
  "robalo",
  "rochedo",
  "rodada",
  "rodeio",
  "rodovia",
  "roedor",
  "roleta",
  "romano",
  "roncar",
  "rosado",
  "roseira",
  "rosto",
  "rota",
  "roteiro",
  "rotina",
  "rotular",
  "rouco",
  "roupa",
  "roxo",
  "rubro",
  "rugido",
  "rugoso",
  "ruivo",
  "rumo",
  "rupestre",
  "russo",
  "sabor",
  "saciar",
  "sacola",
  "sacudir",
  "sadio",
  "safira",
  "saga",
  "sagrada",
  "saibro",
  "salada",
  "saleiro",
  "salgado",
  "saliva",
  "salpicar",
  "salsicha",
  "saltar",
  "salvador",
  "sambar",
  "samurai",
  "sanar",
  "sanfona",
  "sangue",
  "sanidade",
  "sapato",
  "sarda",
  "sargento",
  "sarjeta",
  "saturar",
  "saudade",
  "saxofone",
  "sazonal",
  "secar",
  "secular",
  "seda",
  "sedento",
  "sediado",
  "sedoso",
  "sedutor",
  "segmento",
  "segredo",
  "segundo",
  "seiva",
  "seleto",
  "selvagem",
  "semanal",
  "semente",
  "senador",
  "senhor",
  "sensual",
  "sentado",
  "separado",
  "sereia",
  "seringa",
  "serra",
  "servo",
  "setembro",
  "setor",
  "sigilo",
  "silhueta",
  "silicone",
  "simetria",
  "simpatia",
  "simular",
  "sinal",
  "sincero",
  "singular",
  "sinopse",
  "sintonia",
  "sirene",
  "siri",
  "situado",
  "soberano",
  "sobra",
  "socorro",
  "sogro",
  "soja",
  "solda",
  "soletrar",
  "solteiro",
  "sombrio",
  "sonata",
  "sondar",
  "sonegar",
  "sonhador",
  "sono",
  "soprano",
  "soquete",
  "sorrir",
  "sorteio",
  "sossego",
  "sotaque",
  "soterrar",
  "sovado",
  "sozinho",
  "suavizar",
  "subida",
  "submerso",
  "subsolo",
  "subtrair",
  "sucata",
  "sucesso",
  "suco",
  "sudeste",
  "sufixo",
  "sugador",
  "sugerir",
  "sujeito",
  "sulfato",
  "sumir",
  "suor",
  "superior",
  "suplicar",
  "suposto",
  "suprimir",
  "surdina",
  "surfista",
  "surpresa",
  "surreal",
  "surtir",
  "suspiro",
  "sustento",
  "tabela",
  "tablete",
  "tabuada",
  "tacho",
  "tagarela",
  "talher",
  "talo",
  "talvez",
  "tamanho",
  "tamborim",
  "tampa",
  "tangente",
  "tanto",
  "tapar",
  "tapioca",
  "tardio",
  "tarefa",
  "tarja",
  "tarraxa",
  "tatuagem",
  "taurino",
  "taxativo",
  "taxista",
  "teatral",
  "tecer",
  "tecido",
  "teclado",
  "tedioso",
  "teia",
  "teimar",
  "telefone",
  "telhado",
  "tempero",
  "tenente",
  "tensor",
  "tentar",
  "termal",
  "terno",
  "terreno",
  "tese",
  "tesoura",
  "testado",
  "teto",
  "textura",
  "texugo",
  "tiara",
  "tigela",
  "tijolo",
  "timbrar",
  "timidez",
  "tingido",
  "tinteiro",
  "tiragem",
  "titular",
  "toalha",
  "tocha",
  "tolerar",
  "tolice",
  "tomada",
  "tomilho",
  "tonel",
  "tontura",
  "topete",
  "tora",
  "torcido",
  "torneio",
  "torque",
  "torrada",
  "torto",
  "tostar",
  "touca",
  "toupeira",
  "toxina",
  "trabalho",
  "tracejar",
  "tradutor",
  "trafegar",
  "trajeto",
  "trama",
  "trancar",
  "trapo",
  "traseiro",
  "tratador",
  "travar",
  "treino",
  "tremer",
  "trepidar",
  "trevo",
  "triagem",
  "tribo",
  "triciclo",
  "tridente",
  "trilogia",
  "trindade",
  "triplo",
  "triturar",
  "triunfal",
  "trocar",
  "trombeta",
  "trova",
  "trunfo",
  "truque",
  "tubular",
  "tucano",
  "tudo",
  "tulipa",
  "tupi",
  "turbo",
  "turma",
  "turquesa",
  "tutelar",
  "tutorial",
  "uivar",
  "umbigo",
  "unha",
  "unidade",
  "uniforme",
  "urologia",
  "urso",
  "urtiga",
  "urubu",
  "usado",
  "usina",
  "usufruir",
  "vacina",
  "vadiar",
  "vagaroso",
  "vaidoso",
  "vala",
  "valente",
  "validade",
  "valores",
  "vantagem",
  "vaqueiro",
  "varanda",
  "vareta",
  "varrer",
  "vascular",
  "vasilha",
  "vassoura",
  "vazar",
  "vazio",
  "veado",
  "vedar",
  "vegetar",
  "veicular",
  "veleiro",
  "velhice",
  "veludo",
  "vencedor",
  "vendaval",
  "venerar",
  "ventre",
  "verbal",
  "verdade",
  "vereador",
  "vergonha",
  "vermelho",
  "verniz",
  "versar",
  "vertente",
  "vespa",
  "vestido",
  "vetorial",
  "viaduto",
  "viagem",
  "viajar",
  "viatura",
  "vibrador",
  "videira",
  "vidraria",
  "viela",
  "viga",
  "vigente",
  "vigiar",
  "vigorar",
  "vilarejo",
  "vinco",
  "vinheta",
  "vinil",
  "violeta",
  "virada",
  "virtude",
  "visitar",
  "visto",
  "vitral",
  "viveiro",
  "vizinho",
  "voador",
  "voar",
  "vogal",
  "volante",
  "voleibol",
  "voltagem",
  "volumoso",
  "vontade",
  "vulto",
  "vuvuzela",
  "xadrez",
  "xarope",
  "xeque",
  "xeretar",
  "xerife",
  "xingar",
  "zangado",
  "zarpar",
  "zebu",
  "zelador",
  "zombar",
  "zoologia",
  "zumbido"
], P1e = [
  "abandon",
  "ability",
  "able",
  "about",
  "above",
  "absent",
  "absorb",
  "abstract",
  "absurd",
  "abuse",
  "access",
  "accident",
  "account",
  "accuse",
  "achieve",
  "acid",
  "acoustic",
  "acquire",
  "across",
  "act",
  "action",
  "actor",
  "actress",
  "actual",
  "adapt",
  "add",
  "addict",
  "address",
  "adjust",
  "admit",
  "adult",
  "advance",
  "advice",
  "aerobic",
  "affair",
  "afford",
  "afraid",
  "again",
  "age",
  "agent",
  "agree",
  "ahead",
  "aim",
  "air",
  "airport",
  "aisle",
  "alarm",
  "album",
  "alcohol",
  "alert",
  "alien",
  "all",
  "alley",
  "allow",
  "almost",
  "alone",
  "alpha",
  "already",
  "also",
  "alter",
  "always",
  "amateur",
  "amazing",
  "among",
  "amount",
  "amused",
  "analyst",
  "anchor",
  "ancient",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "announce",
  "annual",
  "another",
  "answer",
  "antenna",
  "antique",
  "anxiety",
  "any",
  "apart",
  "apology",
  "appear",
  "apple",
  "approve",
  "april",
  "arch",
  "arctic",
  "area",
  "arena",
  "argue",
  "arm",
  "armed",
  "armor",
  "army",
  "around",
  "arrange",
  "arrest",
  "arrive",
  "arrow",
  "art",
  "artefact",
  "artist",
  "artwork",
  "ask",
  "aspect",
  "assault",
  "asset",
  "assist",
  "assume",
  "asthma",
  "athlete",
  "atom",
  "attack",
  "attend",
  "attitude",
  "attract",
  "auction",
  "audit",
  "august",
  "aunt",
  "author",
  "auto",
  "autumn",
  "average",
  "avocado",
  "avoid",
  "awake",
  "aware",
  "away",
  "awesome",
  "awful",
  "awkward",
  "axis",
  "baby",
  "bachelor",
  "bacon",
  "badge",
  "bag",
  "balance",
  "balcony",
  "ball",
  "bamboo",
  "banana",
  "banner",
  "bar",
  "barely",
  "bargain",
  "barrel",
  "base",
  "basic",
  "basket",
  "battle",
  "beach",
  "bean",
  "beauty",
  "because",
  "become",
  "beef",
  "before",
  "begin",
  "behave",
  "behind",
  "believe",
  "below",
  "belt",
  "bench",
  "benefit",
  "best",
  "betray",
  "better",
  "between",
  "beyond",
  "bicycle",
  "bid",
  "bike",
  "bind",
  "biology",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blame",
  "blanket",
  "blast",
  "bleak",
  "bless",
  "blind",
  "blood",
  "blossom",
  "blouse",
  "blue",
  "blur",
  "blush",
  "board",
  "boat",
  "body",
  "boil",
  "bomb",
  "bone",
  "bonus",
  "book",
  "boost",
  "border",
  "boring",
  "borrow",
  "boss",
  "bottom",
  "bounce",
  "box",
  "boy",
  "bracket",
  "brain",
  "brand",
  "brass",
  "brave",
  "bread",
  "breeze",
  "brick",
  "bridge",
  "brief",
  "bright",
  "bring",
  "brisk",
  "broccoli",
  "broken",
  "bronze",
  "broom",
  "brother",
  "brown",
  "brush",
  "bubble",
  "buddy",
  "budget",
  "buffalo",
  "build",
  "bulb",
  "bulk",
  "bullet",
  "bundle",
  "bunker",
  "burden",
  "burger",
  "burst",
  "bus",
  "business",
  "busy",
  "butter",
  "buyer",
  "buzz",
  "cabbage",
  "cabin",
  "cable",
  "cactus",
  "cage",
  "cake",
  "call",
  "calm",
  "camera",
  "camp",
  "can",
  "canal",
  "cancel",
  "candy",
  "cannon",
  "canoe",
  "canvas",
  "canyon",
  "capable",
  "capital",
  "captain",
  "car",
  "carbon",
  "card",
  "cargo",
  "carpet",
  "carry",
  "cart",
  "case",
  "cash",
  "casino",
  "castle",
  "casual",
  "cat",
  "catalog",
  "catch",
  "category",
  "cattle",
  "caught",
  "cause",
  "caution",
  "cave",
  "ceiling",
  "celery",
  "cement",
  "census",
  "century",
  "cereal",
  "certain",
  "chair",
  "chalk",
  "champion",
  "change",
  "chaos",
  "chapter",
  "charge",
  "chase",
  "chat",
  "cheap",
  "check",
  "cheese",
  "chef",
  "cherry",
  "chest",
  "chicken",
  "chief",
  "child",
  "chimney",
  "choice",
  "choose",
  "chronic",
  "chuckle",
  "chunk",
  "churn",
  "cigar",
  "cinnamon",
  "circle",
  "citizen",
  "city",
  "civil",
  "claim",
  "clap",
  "clarify",
  "claw",
  "clay",
  "clean",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climb",
  "clinic",
  "clip",
  "clock",
  "clog",
  "close",
  "cloth",
  "cloud",
  "clown",
  "club",
  "clump",
  "cluster",
  "clutch",
  "coach",
  "coast",
  "coconut",
  "code",
  "coffee",
  "coil",
  "coin",
  "collect",
  "color",
  "column",
  "combine",
  "come",
  "comfort",
  "comic",
  "common",
  "company",
  "concert",
  "conduct",
  "confirm",
  "congress",
  "connect",
  "consider",
  "control",
  "convince",
  "cook",
  "cool",
  "copper",
  "copy",
  "coral",
  "core",
  "corn",
  "correct",
  "cost",
  "cotton",
  "couch",
  "country",
  "couple",
  "course",
  "cousin",
  "cover",
  "coyote",
  "crack",
  "cradle",
  "craft",
  "cram",
  "crane",
  "crash",
  "crater",
  "crawl",
  "crazy",
  "cream",
  "credit",
  "creek",
  "crew",
  "cricket",
  "crime",
  "crisp",
  "critic",
  "crop",
  "cross",
  "crouch",
  "crowd",
  "crucial",
  "cruel",
  "cruise",
  "crumble",
  "crunch",
  "crush",
  "cry",
  "crystal",
  "cube",
  "culture",
  "cup",
  "cupboard",
  "curious",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custom",
  "cute",
  "cycle",
  "dad",
  "damage",
  "damp",
  "dance",
  "danger",
  "daring",
  "dash",
  "daughter",
  "dawn",
  "day",
  "deal",
  "debate",
  "debris",
  "decade",
  "december",
  "decide",
  "decline",
  "decorate",
  "decrease",
  "deer",
  "defense",
  "define",
  "defy",
  "degree",
  "delay",
  "deliver",
  "demand",
  "demise",
  "denial",
  "dentist",
  "deny",
  "depart",
  "depend",
  "deposit",
  "depth",
  "deputy",
  "derive",
  "describe",
  "desert",
  "design",
  "desk",
  "despair",
  "destroy",
  "detail",
  "detect",
  "develop",
  "device",
  "devote",
  "diagram",
  "dial",
  "diamond",
  "diary",
  "dice",
  "diesel",
  "diet",
  "differ",
  "digital",
  "dignity",
  "dilemma",
  "dinner",
  "dinosaur",
  "direct",
  "dirt",
  "disagree",
  "discover",
  "disease",
  "dish",
  "dismiss",
  "disorder",
  "display",
  "distance",
  "divert",
  "divide",
  "divorce",
  "dizzy",
  "doctor",
  "document",
  "dog",
  "doll",
  "dolphin",
  "domain",
  "donate",
  "donkey",
  "donor",
  "door",
  "dose",
  "double",
  "dove",
  "draft",
  "dragon",
  "drama",
  "drastic",
  "draw",
  "dream",
  "dress",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "drop",
  "drum",
  "dry",
  "duck",
  "dumb",
  "dune",
  "during",
  "dust",
  "dutch",
  "duty",
  "dwarf",
  "dynamic",
  "eager",
  "eagle",
  "early",
  "earn",
  "earth",
  "easily",
  "east",
  "easy",
  "echo",
  "ecology",
  "economy",
  "edge",
  "edit",
  "educate",
  "effort",
  "egg",
  "eight",
  "either",
  "elbow",
  "elder",
  "electric",
  "elegant",
  "element",
  "elephant",
  "elevator",
  "elite",
  "else",
  "embark",
  "embody",
  "embrace",
  "emerge",
  "emotion",
  "employ",
  "empower",
  "empty",
  "enable",
  "enact",
  "end",
  "endless",
  "endorse",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "enhance",
  "enjoy",
  "enlist",
  "enough",
  "enrich",
  "enroll",
  "ensure",
  "enter",
  "entire",
  "entry",
  "envelope",
  "episode",
  "equal",
  "equip",
  "era",
  "erase",
  "erode",
  "erosion",
  "error",
  "erupt",
  "escape",
  "essay",
  "essence",
  "estate",
  "eternal",
  "ethics",
  "evidence",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "example",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "exercise",
  "exhaust",
  "exhibit",
  "exile",
  "exist",
  "exit",
  "exotic",
  "expand",
  "expect",
  "expire",
  "explain",
  "expose",
  "express",
  "extend",
  "extra",
  "eye",
  "eyebrow",
  "fabric",
  "face",
  "faculty",
  "fade",
  "faint",
  "faith",
  "fall",
  "false",
  "fame",
  "family",
  "famous",
  "fan",
  "fancy",
  "fantasy",
  "farm",
  "fashion",
  "fat",
  "fatal",
  "father",
  "fatigue",
  "fault",
  "favorite",
  "feature",
  "february",
  "federal",
  "fee",
  "feed",
  "feel",
  "female",
  "fence",
  "festival",
  "fetch",
  "fever",
  "few",
  "fiber",
  "fiction",
  "field",
  "figure",
  "file",
  "film",
  "filter",
  "final",
  "find",
  "fine",
  "finger",
  "finish",
  "fire",
  "firm",
  "first",
  "fiscal",
  "fish",
  "fit",
  "fitness",
  "fix",
  "flag",
  "flame",
  "flash",
  "flat",
  "flavor",
  "flee",
  "flight",
  "flip",
  "float",
  "flock",
  "floor",
  "flower",
  "fluid",
  "flush",
  "fly",
  "foam",
  "focus",
  "fog",
  "foil",
  "fold",
  "follow",
  "food",
  "foot",
  "force",
  "forest",
  "forget",
  "fork",
  "fortune",
  "forum",
  "forward",
  "fossil",
  "foster",
  "found",
  "fox",
  "fragile",
  "frame",
  "frequent",
  "fresh",
  "friend",
  "fringe",
  "frog",
  "front",
  "frost",
  "frown",
  "frozen",
  "fruit",
  "fuel",
  "fun",
  "funny",
  "furnace",
  "fury",
  "future",
  "gadget",
  "gain",
  "galaxy",
  "gallery",
  "game",
  "gap",
  "garage",
  "garbage",
  "garden",
  "garlic",
  "garment",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaze",
  "general",
  "genius",
  "genre",
  "gentle",
  "genuine",
  "gesture",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "ginger",
  "giraffe",
  "girl",
  "give",
  "glad",
  "glance",
  "glare",
  "glass",
  "glide",
  "glimpse",
  "globe",
  "gloom",
  "glory",
  "glove",
  "glow",
  "glue",
  "goat",
  "goddess",
  "gold",
  "good",
  "goose",
  "gorilla",
  "gospel",
  "gossip",
  "govern",
  "gown",
  "grab",
  "grace",
  "grain",
  "grant",
  "grape",
  "grass",
  "gravity",
  "great",
  "green",
  "grid",
  "grief",
  "grit",
  "grocery",
  "group",
  "grow",
  "grunt",
  "guard",
  "guess",
  "guide",
  "guilt",
  "guitar",
  "gun",
  "gym",
  "habit",
  "hair",
  "half",
  "hammer",
  "hamster",
  "hand",
  "happy",
  "harbor",
  "hard",
  "harsh",
  "harvest",
  "hat",
  "have",
  "hawk",
  "hazard",
  "head",
  "health",
  "heart",
  "heavy",
  "hedgehog",
  "height",
  "hello",
  "helmet",
  "help",
  "hen",
  "hero",
  "hidden",
  "high",
  "hill",
  "hint",
  "hip",
  "hire",
  "history",
  "hobby",
  "hockey",
  "hold",
  "hole",
  "holiday",
  "hollow",
  "home",
  "honey",
  "hood",
  "hope",
  "horn",
  "horror",
  "horse",
  "hospital",
  "host",
  "hotel",
  "hour",
  "hover",
  "hub",
  "huge",
  "human",
  "humble",
  "humor",
  "hundred",
  "hungry",
  "hunt",
  "hurdle",
  "hurry",
  "hurt",
  "husband",
  "hybrid",
  "ice",
  "icon",
  "idea",
  "identify",
  "idle",
  "ignore",
  "ill",
  "illegal",
  "illness",
  "image",
  "imitate",
  "immense",
  "immune",
  "impact",
  "impose",
  "improve",
  "impulse",
  "inch",
  "include",
  "income",
  "increase",
  "index",
  "indicate",
  "indoor",
  "industry",
  "infant",
  "inflict",
  "inform",
  "inhale",
  "inherit",
  "initial",
  "inject",
  "injury",
  "inmate",
  "inner",
  "innocent",
  "input",
  "inquiry",
  "insane",
  "insect",
  "inside",
  "inspire",
  "install",
  "intact",
  "interest",
  "into",
  "invest",
  "invite",
  "involve",
  "iron",
  "island",
  "isolate",
  "issue",
  "item",
  "ivory",
  "jacket",
  "jaguar",
  "jar",
  "jazz",
  "jealous",
  "jeans",
  "jelly",
  "jewel",
  "job",
  "join",
  "joke",
  "journey",
  "joy",
  "judge",
  "juice",
  "jump",
  "jungle",
  "junior",
  "junk",
  "just",
  "kangaroo",
  "keen",
  "keep",
  "ketchup",
  "key",
  "kick",
  "kid",
  "kidney",
  "kind",
  "kingdom",
  "kiss",
  "kit",
  "kitchen",
  "kite",
  "kitten",
  "kiwi",
  "knee",
  "knife",
  "knock",
  "know",
  "lab",
  "label",
  "labor",
  "ladder",
  "lady",
  "lake",
  "lamp",
  "language",
  "laptop",
  "large",
  "later",
  "latin",
  "laugh",
  "laundry",
  "lava",
  "law",
  "lawn",
  "lawsuit",
  "layer",
  "lazy",
  "leader",
  "leaf",
  "learn",
  "leave",
  "lecture",
  "left",
  "leg",
  "legal",
  "legend",
  "leisure",
  "lemon",
  "lend",
  "length",
  "lens",
  "leopard",
  "lesson",
  "letter",
  "level",
  "liar",
  "liberty",
  "library",
  "license",
  "life",
  "lift",
  "light",
  "like",
  "limb",
  "limit",
  "link",
  "lion",
  "liquid",
  "list",
  "little",
  "live",
  "lizard",
  "load",
  "loan",
  "lobster",
  "local",
  "lock",
  "logic",
  "lonely",
  "long",
  "loop",
  "lottery",
  "loud",
  "lounge",
  "love",
  "loyal",
  "lucky",
  "luggage",
  "lumber",
  "lunar",
  "lunch",
  "luxury",
  "lyrics",
  "machine",
  "mad",
  "magic",
  "magnet",
  "maid",
  "mail",
  "main",
  "major",
  "make",
  "mammal",
  "man",
  "manage",
  "mandate",
  "mango",
  "mansion",
  "manual",
  "maple",
  "marble",
  "march",
  "margin",
  "marine",
  "market",
  "marriage",
  "mask",
  "mass",
  "master",
  "match",
  "material",
  "math",
  "matrix",
  "matter",
  "maximum",
  "maze",
  "meadow",
  "mean",
  "measure",
  "meat",
  "mechanic",
  "medal",
  "media",
  "melody",
  "melt",
  "member",
  "memory",
  "mention",
  "menu",
  "mercy",
  "merge",
  "merit",
  "merry",
  "mesh",
  "message",
  "metal",
  "method",
  "middle",
  "midnight",
  "milk",
  "million",
  "mimic",
  "mind",
  "minimum",
  "minor",
  "minute",
  "miracle",
  "mirror",
  "misery",
  "miss",
  "mistake",
  "mix",
  "mixed",
  "mixture",
  "mobile",
  "model",
  "modify",
  "mom",
  "moment",
  "monitor",
  "monkey",
  "monster",
  "month",
  "moon",
  "moral",
  "more",
  "morning",
  "mosquito",
  "mother",
  "motion",
  "motor",
  "mountain",
  "mouse",
  "move",
  "movie",
  "much",
  "muffin",
  "mule",
  "multiply",
  "muscle",
  "museum",
  "mushroom",
  "music",
  "must",
  "mutual",
  "myself",
  "mystery",
  "myth",
  "naive",
  "name",
  "napkin",
  "narrow",
  "nasty",
  "nation",
  "nature",
  "near",
  "neck",
  "need",
  "negative",
  "neglect",
  "neither",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "neutral",
  "never",
  "news",
  "next",
  "nice",
  "night",
  "noble",
  "noise",
  "nominee",
  "noodle",
  "normal",
  "north",
  "nose",
  "notable",
  "note",
  "nothing",
  "notice",
  "novel",
  "now",
  "nuclear",
  "number",
  "nurse",
  "nut",
  "oak",
  "obey",
  "object",
  "oblige",
  "obscure",
  "observe",
  "obtain",
  "obvious",
  "occur",
  "ocean",
  "october",
  "odor",
  "off",
  "offer",
  "office",
  "often",
  "oil",
  "okay",
  "old",
  "olive",
  "olympic",
  "omit",
  "once",
  "one",
  "onion",
  "online",
  "only",
  "open",
  "opera",
  "opinion",
  "oppose",
  "option",
  "orange",
  "orbit",
  "orchard",
  "order",
  "ordinary",
  "organ",
  "orient",
  "original",
  "orphan",
  "ostrich",
  "other",
  "outdoor",
  "outer",
  "output",
  "outside",
  "oval",
  "oven",
  "over",
  "own",
  "owner",
  "oxygen",
  "oyster",
  "ozone",
  "pact",
  "paddle",
  "page",
  "pair",
  "palace",
  "palm",
  "panda",
  "panel",
  "panic",
  "panther",
  "paper",
  "parade",
  "parent",
  "park",
  "parrot",
  "party",
  "pass",
  "patch",
  "path",
  "patient",
  "patrol",
  "pattern",
  "pause",
  "pave",
  "payment",
  "peace",
  "peanut",
  "pear",
  "peasant",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "people",
  "pepper",
  "perfect",
  "permit",
  "person",
  "pet",
  "phone",
  "photo",
  "phrase",
  "physical",
  "piano",
  "picnic",
  "picture",
  "piece",
  "pig",
  "pigeon",
  "pill",
  "pilot",
  "pink",
  "pioneer",
  "pipe",
  "pistol",
  "pitch",
  "pizza",
  "place",
  "planet",
  "plastic",
  "plate",
  "play",
  "please",
  "pledge",
  "pluck",
  "plug",
  "plunge",
  "poem",
  "poet",
  "point",
  "polar",
  "pole",
  "police",
  "pond",
  "pony",
  "pool",
  "popular",
  "portion",
  "position",
  "possible",
  "post",
  "potato",
  "pottery",
  "poverty",
  "powder",
  "power",
  "practice",
  "praise",
  "predict",
  "prefer",
  "prepare",
  "present",
  "pretty",
  "prevent",
  "price",
  "pride",
  "primary",
  "print",
  "priority",
  "prison",
  "private",
  "prize",
  "problem",
  "process",
  "produce",
  "profit",
  "program",
  "project",
  "promote",
  "proof",
  "property",
  "prosper",
  "protect",
  "proud",
  "provide",
  "public",
  "pudding",
  "pull",
  "pulp",
  "pulse",
  "pumpkin",
  "punch",
  "pupil",
  "puppy",
  "purchase",
  "purity",
  "purpose",
  "purse",
  "push",
  "put",
  "puzzle",
  "pyramid",
  "quality",
  "quantum",
  "quarter",
  "question",
  "quick",
  "quit",
  "quiz",
  "quote",
  "rabbit",
  "raccoon",
  "race",
  "rack",
  "radar",
  "radio",
  "rail",
  "rain",
  "raise",
  "rally",
  "ramp",
  "ranch",
  "random",
  "range",
  "rapid",
  "rare",
  "rate",
  "rather",
  "raven",
  "raw",
  "razor",
  "ready",
  "real",
  "reason",
  "rebel",
  "rebuild",
  "recall",
  "receive",
  "recipe",
  "record",
  "recycle",
  "reduce",
  "reflect",
  "reform",
  "refuse",
  "region",
  "regret",
  "regular",
  "reject",
  "relax",
  "release",
  "relief",
  "rely",
  "remain",
  "remember",
  "remind",
  "remove",
  "render",
  "renew",
  "rent",
  "reopen",
  "repair",
  "repeat",
  "replace",
  "report",
  "require",
  "rescue",
  "resemble",
  "resist",
  "resource",
  "response",
  "result",
  "retire",
  "retreat",
  "return",
  "reunion",
  "reveal",
  "review",
  "reward",
  "rhythm",
  "rib",
  "ribbon",
  "rice",
  "rich",
  "ride",
  "ridge",
  "rifle",
  "right",
  "rigid",
  "ring",
  "riot",
  "ripple",
  "risk",
  "ritual",
  "rival",
  "river",
  "road",
  "roast",
  "robot",
  "robust",
  "rocket",
  "romance",
  "roof",
  "rookie",
  "room",
  "rose",
  "rotate",
  "rough",
  "round",
  "route",
  "royal",
  "rubber",
  "rude",
  "rug",
  "rule",
  "run",
  "runway",
  "rural",
  "sad",
  "saddle",
  "sadness",
  "safe",
  "sail",
  "salad",
  "salmon",
  "salon",
  "salt",
  "salute",
  "same",
  "sample",
  "sand",
  "satisfy",
  "satoshi",
  "sauce",
  "sausage",
  "save",
  "say",
  "scale",
  "scan",
  "scare",
  "scatter",
  "scene",
  "scheme",
  "school",
  "science",
  "scissors",
  "scorpion",
  "scout",
  "scrap",
  "screen",
  "script",
  "scrub",
  "sea",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "section",
  "security",
  "seed",
  "seek",
  "segment",
  "select",
  "sell",
  "seminar",
  "senior",
  "sense",
  "sentence",
  "series",
  "service",
  "session",
  "settle",
  "setup",
  "seven",
  "shadow",
  "shaft",
  "shallow",
  "share",
  "shed",
  "shell",
  "sheriff",
  "shield",
  "shift",
  "shine",
  "ship",
  "shiver",
  "shock",
  "shoe",
  "shoot",
  "shop",
  "short",
  "shoulder",
  "shove",
  "shrimp",
  "shrug",
  "shuffle",
  "shy",
  "sibling",
  "sick",
  "side",
  "siege",
  "sight",
  "sign",
  "silent",
  "silk",
  "silly",
  "silver",
  "similar",
  "simple",
  "since",
  "sing",
  "siren",
  "sister",
  "situate",
  "six",
  "size",
  "skate",
  "sketch",
  "ski",
  "skill",
  "skin",
  "skirt",
  "skull",
  "slab",
  "slam",
  "sleep",
  "slender",
  "slice",
  "slide",
  "slight",
  "slim",
  "slogan",
  "slot",
  "slow",
  "slush",
  "small",
  "smart",
  "smile",
  "smoke",
  "smooth",
  "snack",
  "snake",
  "snap",
  "sniff",
  "snow",
  "soap",
  "soccer",
  "social",
  "sock",
  "soda",
  "soft",
  "solar",
  "soldier",
  "solid",
  "solution",
  "solve",
  "someone",
  "song",
  "soon",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "source",
  "south",
  "space",
  "spare",
  "spatial",
  "spawn",
  "speak",
  "special",
  "speed",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spider",
  "spike",
  "spin",
  "spirit",
  "split",
  "spoil",
  "sponsor",
  "spoon",
  "sport",
  "spot",
  "spray",
  "spread",
  "spring",
  "spy",
  "square",
  "squeeze",
  "squirrel",
  "stable",
  "stadium",
  "staff",
  "stage",
  "stairs",
  "stamp",
  "stand",
  "start",
  "state",
  "stay",
  "steak",
  "steel",
  "stem",
  "step",
  "stereo",
  "stick",
  "still",
  "sting",
  "stock",
  "stomach",
  "stone",
  "stool",
  "story",
  "stove",
  "strategy",
  "street",
  "strike",
  "strong",
  "struggle",
  "student",
  "stuff",
  "stumble",
  "style",
  "subject",
  "submit",
  "subway",
  "success",
  "such",
  "sudden",
  "suffer",
  "sugar",
  "suggest",
  "suit",
  "summer",
  "sun",
  "sunny",
  "sunset",
  "super",
  "supply",
  "supreme",
  "sure",
  "surface",
  "surge",
  "surprise",
  "surround",
  "survey",
  "suspect",
  "sustain",
  "swallow",
  "swamp",
  "swap",
  "swarm",
  "swear",
  "sweet",
  "swift",
  "swim",
  "swing",
  "switch",
  "sword",
  "symbol",
  "symptom",
  "syrup",
  "system",
  "table",
  "tackle",
  "tag",
  "tail",
  "talent",
  "talk",
  "tank",
  "tape",
  "target",
  "task",
  "taste",
  "tattoo",
  "taxi",
  "teach",
  "team",
  "tell",
  "ten",
  "tenant",
  "tennis",
  "tent",
  "term",
  "test",
  "text",
  "thank",
  "that",
  "theme",
  "then",
  "theory",
  "there",
  "they",
  "thing",
  "this",
  "thought",
  "three",
  "thrive",
  "throw",
  "thumb",
  "thunder",
  "ticket",
  "tide",
  "tiger",
  "tilt",
  "timber",
  "time",
  "tiny",
  "tip",
  "tired",
  "tissue",
  "title",
  "toast",
  "tobacco",
  "today",
  "toddler",
  "toe",
  "together",
  "toilet",
  "token",
  "tomato",
  "tomorrow",
  "tone",
  "tongue",
  "tonight",
  "tool",
  "tooth",
  "top",
  "topic",
  "topple",
  "torch",
  "tornado",
  "tortoise",
  "toss",
  "total",
  "tourist",
  "toward",
  "tower",
  "town",
  "toy",
  "track",
  "trade",
  "traffic",
  "tragic",
  "train",
  "transfer",
  "trap",
  "trash",
  "travel",
  "tray",
  "treat",
  "tree",
  "trend",
  "trial",
  "tribe",
  "trick",
  "trigger",
  "trim",
  "trip",
  "trophy",
  "trouble",
  "truck",
  "true",
  "truly",
  "trumpet",
  "trust",
  "truth",
  "try",
  "tube",
  "tuition",
  "tumble",
  "tuna",
  "tunnel",
  "turkey",
  "turn",
  "turtle",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "type",
  "typical",
  "ugly",
  "umbrella",
  "unable",
  "unaware",
  "uncle",
  "uncover",
  "under",
  "undo",
  "unfair",
  "unfold",
  "unhappy",
  "uniform",
  "unique",
  "unit",
  "universe",
  "unknown",
  "unlock",
  "until",
  "unusual",
  "unveil",
  "update",
  "upgrade",
  "uphold",
  "upon",
  "upper",
  "upset",
  "urban",
  "urge",
  "usage",
  "use",
  "used",
  "useful",
  "useless",
  "usual",
  "utility",
  "vacant",
  "vacuum",
  "vague",
  "valid",
  "valley",
  "valve",
  "van",
  "vanish",
  "vapor",
  "various",
  "vast",
  "vault",
  "vehicle",
  "velvet",
  "vendor",
  "venture",
  "venue",
  "verb",
  "verify",
  "version",
  "very",
  "vessel",
  "veteran",
  "viable",
  "vibrant",
  "vicious",
  "victory",
  "video",
  "view",
  "village",
  "vintage",
  "violin",
  "virtual",
  "virus",
  "visa",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "voice",
  "void",
  "volcano",
  "volume",
  "vote",
  "voyage",
  "wage",
  "wagon",
  "wait",
  "walk",
  "wall",
  "walnut",
  "want",
  "warfare",
  "warm",
  "warrior",
  "wash",
  "wasp",
  "waste",
  "water",
  "wave",
  "way",
  "wealth",
  "weapon",
  "wear",
  "weasel",
  "weather",
  "web",
  "wedding",
  "weekend",
  "weird",
  "welcome",
  "west",
  "wet",
  "whale",
  "what",
  "wheat",
  "wheel",
  "when",
  "where",
  "whip",
  "whisper",
  "wide",
  "width",
  "wife",
  "wild",
  "will",
  "win",
  "window",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "witness",
  "wolf",
  "woman",
  "wonder",
  "wood",
  "wool",
  "word",
  "work",
  "world",
  "worry",
  "worth",
  "wrap",
  "wreck",
  "wrestle",
  "wrist",
  "write",
  "wrong",
  "yard",
  "year",
  "yellow",
  "you",
  "young",
  "youth",
  "zebra",
  "zero",
  "zone",
  "zoo"
];
Object.defineProperty(ba, "__esModule", { value: !0 });
const fs = {};
ba.wordlists = fs;
let no;
var Nc = ba._default = no;
try {
  Nc = ba._default = no = E1e, fs.czech = no;
} catch {
}
try {
  Nc = ba._default = no = _1e, fs.chinese_simplified = no;
} catch {
}
try {
  Nc = ba._default = no = A1e, fs.chinese_traditional = no;
} catch {
}
try {
  Nc = ba._default = no = x1e, fs.korean = no;
} catch {
}
try {
  Nc = ba._default = no = k1e, fs.french = no;
} catch {
}
try {
  Nc = ba._default = no = S1e, fs.italian = no;
} catch {
}
try {
  Nc = ba._default = no = T1e, fs.spanish = no;
} catch {
}
try {
  Nc = ba._default = no = I1e, fs.japanese = no, fs.JA = no;
} catch {
}
try {
  Nc = ba._default = no = O1e, fs.portuguese = no;
} catch {
}
try {
  Nc = ba._default = no = P1e, fs.english = no, fs.EN = no;
} catch {
}
Object.defineProperty(Bc, "__esModule", { value: !0 });
const C1e = Cu, pK = Qo, gK = y4, B1e = Ds, U3 = ba;
let Rw = U3._default;
const GU = "Invalid mnemonic", Gp = "Invalid entropy", N1e = "Invalid mnemonic checksum", mK = `A wordlist is required but a default could not be found.
Please pass a 2048 word array explicitly.`;
function zw(e) {
  return (e || "").normalize("NFKD");
}
function yK(e, t, r) {
  for (; e.length < r; )
    e = t + e;
  return e;
}
function bK(e) {
  return parseInt(e, 2);
}
function wK(e) {
  return e.map((t) => yK(t.toString(2), "0", 8)).join("");
}
function vK(e) {
  const t = e.length * 8 / 32, r = C1e.sha256(Uint8Array.from(e));
  return wK(Array.from(r)).slice(0, t);
}
function EK(e) {
  return "mnemonic" + (e || "");
}
function $1e(e, t) {
  const r = Uint8Array.from(Buffer.from(zw(e), "utf8")), n = Uint8Array.from(Buffer.from(EK(zw(t)), "utf8")), o = gK.pbkdf2(pK.sha512, r, n, {
    c: 2048,
    dkLen: 64
  });
  return Buffer.from(o);
}
Bc.mnemonicToSeedSync = $1e;
function U1e(e, t) {
  const r = Uint8Array.from(Buffer.from(zw(e), "utf8")), n = Uint8Array.from(Buffer.from(EK(zw(t)), "utf8"));
  return gK.pbkdf2Async(pK.sha512, r, n, {
    c: 2048,
    dkLen: 64
  }).then((o) => Buffer.from(o));
}
var R1e = Bc.mnemonicToSeed = U1e;
function _K(e, t) {
  if (t = t || Rw, !t)
    throw new Error(mK);
  const r = zw(e).split(" ");
  if (r.length % 3 !== 0)
    throw new Error(GU);
  const n = r.map((d) => {
    const f = t.indexOf(d);
    if (f === -1)
      throw new Error(GU);
    return yK(f.toString(2), "0", 11);
  }).join(""), o = Math.floor(n.length / 33) * 32, i = n.slice(0, o), a = n.slice(o), u = i.match(/(.{1,8})/g).map(bK);
  if (u.length < 16)
    throw new Error(Gp);
  if (u.length > 32)
    throw new Error(Gp);
  if (u.length % 4 !== 0)
    throw new Error(Gp);
  const l = Buffer.from(u);
  if (vK(l) !== a)
    throw new Error(N1e);
  return l.toString("hex");
}
Bc.mnemonicToEntropy = _K;
function AK(e, t) {
  if (Buffer.isBuffer(e) || (e = Buffer.from(e, "hex")), t = t || Rw, !t)
    throw new Error(mK);
  if (e.length < 16)
    throw new TypeError(Gp);
  if (e.length > 32)
    throw new TypeError(Gp);
  if (e.length % 4 !== 0)
    throw new TypeError(Gp);
  const r = wK(Array.from(e)), n = vK(e), o = (r + n).match(/(.{1,11})/g).map((i) => {
    const a = bK(i);
    return t[a];
  });
  return t[0] === "あいこくしん" ? o.join("　") : o.join(" ");
}
var z1e = Bc.entropyToMnemonic = AK;
function j1e(e, t, r) {
  if (e = e || 128, e % 32 !== 0)
    throw new TypeError(Gp);
  return t = t || ((n) => Buffer.from(B1e.randomBytes(n))), AK(t(e / 8), r);
}
Bc.generateMnemonic = j1e;
function L1e(e, t) {
  try {
    _K(e, t);
  } catch {
    return !1;
  }
  return !0;
}
Bc.validateMnemonic = L1e;
function H1e(e) {
  const t = U3.wordlists[e];
  if (t)
    Rw = t;
  else
    throw new Error('Could not find wordlist for language "' + e + '"');
}
Bc.setDefaultWordlist = H1e;
function F1e() {
  if (!Rw)
    throw new Error("No Default Wordlist set");
  return Object.keys(U3.wordlists).filter((e) => e === "JA" || e === "EN" ? !1 : U3.wordlists[e].every((t, r) => t === Rw[r]))[0];
}
Bc.getDefaultWordlist = F1e;
var M1e = ba;
Bc.wordlists = M1e.wordlists;
function D1e(e) {
  return _L(ki(e));
}
function WU(e, t) {
  return BH(qoe, e, t);
}
const pr = (e) => OQ(e);
function K1e(e) {
  if (jo(e.isPoint(pr("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"))), jo(!e.isPoint(pr("030000000000000000000000000000000000000000000000000000000000000005"))), jo(e.isPrivate(pr("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"))), jo(e.isPrivate(pr("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140"))), jo(!e.isPrivate(pr("0000000000000000000000000000000000000000000000000000000000000000"))), jo(!e.isPrivate(pr("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"))), jo(!e.isPrivate(pr("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364142"))), jo(Ol(e.pointFromScalar(pr("b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af")), pr("02b07ba9dca9523b7ef4bd97703d43d20399eb698e194704791a25ce77a400df99")) === 0), e.xOnlyPointAddTweak) {
    jo(e.xOnlyPointAddTweak(pr("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"), pr("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")) === null);
    let t = e.xOnlyPointAddTweak(pr("1617d38ed8d8657da4d4761e8057bc396ea9e4b9d29776d4be096016dbd2509b"), pr("a8397a935f0dfceba6ba9618f6451ef4d80637abf4e6af2669fbc9de6a8fd2ac"));
    jo(Ol(t.xOnlyPubkey, pr("e478f99dab91052ab39a33ea35fd5e6e4933f4d28023cd597c9a1f6760346adf")) === 0 && t.parity === 1), t = e.xOnlyPointAddTweak(pr("2c0b7cf95324a07d05398b240174dc0c2be444d96b159aa6c7f7b1e668680991"), pr("823c3cd2142744b075a87eade7e1b8678ba308d566226a0056ca2b7a76f86b47"));
  }
  jo(Ol(e.pointAddScalar(pr("0379be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"), pr("0000000000000000000000000000000000000000000000000000000000000003")), pr("02c6047f9441ed7d6d3045406e95c07cd85c778e4b8cef3ca7abac09b95c709ee5")) === 0), jo(Ol(e.privateAdd(pr("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e"), pr("0000000000000000000000000000000000000000000000000000000000000002")), pr("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")) === 0), e.privateNegate && (jo(Ol(e.privateNegate(pr("0000000000000000000000000000000000000000000000000000000000000001")), pr("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")) === 0), jo(Ol(e.privateNegate(pr("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e")), pr("0000000000000000000000000000000000000000000000000000000000000003")) === 0), jo(Ol(e.privateNegate(pr("b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af")), pr("4eede1bf775995d70a494f0a7bb6bc11e0b8cccd41cce8009ab1132c8b0a3792")) === 0)), jo(Ol(e.sign(pr("5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed"), pr("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")), pr("54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5")) === 0), jo(e.verify(pr("5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed"), pr("0379be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"), pr("54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5"))), e.signSchnorr && jo(Ol(e.signSchnorr(pr("7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c"), pr("c90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b14e5c9"), pr("c87aa53824b4d7ae2eb035a2b5bbbccc080e76cdc6d1692c4b0b62d798e6d906")), pr("5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7")) === 0), e.verifySchnorr && jo(e.verifySchnorr(pr("7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c"), pr("dd308afec5777e13121fa72b9cc1b7cc0139715309b086c960e18fd969774eb8"), pr("5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7")));
}
function jo(e) {
  if (!e)
    throw new Error("ecc library invalid");
}
/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function pO(e) {
  return e instanceof Uint8Array || ArrayBuffer.isView(e) && e.constructor.name === "Uint8Array";
}
function xK(e, t) {
  return Array.isArray(t) ? t.length === 0 ? !0 : e ? t.every((r) => typeof r == "string") : t.every((r) => Number.isSafeInteger(r)) : !1;
}
function q1e(e) {
  if (typeof e != "function")
    throw new Error("function expected");
  return !0;
}
function gO(e, t) {
  if (typeof t != "string")
    throw new Error(`${e}: string expected`);
  return !0;
}
function eB(e) {
  if (!Number.isSafeInteger(e))
    throw new Error(`invalid integer: ${e}`);
}
function mO(e) {
  if (!Array.isArray(e))
    throw new Error("array expected");
}
function kK(e, t) {
  if (!xK(!0, t))
    throw new Error(`${e}: array of strings expected`);
}
function V1e(e, t) {
  if (!xK(!1, t))
    throw new Error(`${e}: array of numbers expected`);
}
// @__NO_SIDE_EFFECTS__
function SK(...e) {
  const t = (i) => i, r = (i, a) => (u) => i(a(u)), n = e.map((i) => i.encode).reduceRight(r, t), o = e.map((i) => i.decode).reduce(r, t);
  return { encode: n, decode: o };
}
// @__NO_SIDE_EFFECTS__
function G1e(e) {
  const t = e.split(""), r = t.length;
  kK("alphabet", t);
  const n = new Map(t.map((o, i) => [o, i]));
  return {
    encode: (o) => (mO(o), o.map((i) => {
      if (!Number.isSafeInteger(i) || i < 0 || i >= r)
        throw new Error(`alphabet.encode: digit index outside alphabet "${i}". Allowed: ${e}`);
      return t[i];
    })),
    decode: (o) => (mO(o), o.map((i) => {
      gO("alphabet.decode", i);
      const a = n.get(i);
      if (a === void 0)
        throw new Error(`Unknown letter: "${i}". Allowed: ${e}`);
      return a;
    }))
  };
}
// @__NO_SIDE_EFFECTS__
function W1e(e = "") {
  return gO("join", e), {
    encode: (t) => (kK("join.decode", t), t.join(e)),
    decode: (t) => (gO("join.decode", t), t.split(e))
  };
}
function ZU(e, t, r) {
  if (t < 2)
    throw new Error(`convertRadix: invalid from=${t}, base cannot be less than 2`);
  if (r < 2)
    throw new Error(`convertRadix: invalid to=${r}, base cannot be less than 2`);
  if (mO(e), !e.length)
    return [];
  let n = 0;
  const o = [], i = Array.from(e, (u) => {
    if (eB(u), u < 0 || u >= t)
      throw new Error(`invalid integer: ${u}`);
    return u;
  }), a = i.length;
  for (; ; ) {
    let u = 0, l = !0;
    for (let d = n; d < a; d++) {
      const f = i[d], h = t * u, g = h + f;
      if (!Number.isSafeInteger(g) || h / t !== u || g - f !== h)
        throw new Error("convertRadix: carry overflow");
      const b = g / r;
      u = g % r;
      const w = Math.floor(b);
      if (i[d] = w, !Number.isSafeInteger(w) || w * r + u !== g)
        throw new Error("convertRadix: carry overflow");
      if (l)
        w ? l = !1 : n = d;
      else continue;
    }
    if (o.push(u), l)
      break;
  }
  for (let u = 0; u < e.length - 1 && e[u] === 0; u++)
    o.push(0);
  return o.reverse();
}
// @__NO_SIDE_EFFECTS__
function Z1e(e) {
  eB(e);
  const t = 2 ** 8;
  return {
    encode: (r) => {
      if (!pO(r))
        throw new Error("radix.encode input should be Uint8Array");
      return ZU(Array.from(r), t, e);
    },
    decode: (r) => (V1e("radix.decode", r), Uint8Array.from(ZU(r, e, t)))
  };
}
function X1e(e, t) {
  return eB(e), q1e(t), {
    encode(r) {
      if (!pO(r))
        throw new Error("checksum.encode: input should be Uint8Array");
      const n = t(r).slice(0, e), o = new Uint8Array(r.length + e);
      return o.set(r), o.set(n, r.length), o;
    },
    decode(r) {
      if (!pO(r))
        throw new Error("checksum.decode: input should be Uint8Array");
      const n = r.slice(0, -4), o = r.slice(-4), i = t(n).slice(0, e);
      for (let a = 0; a < e; a++)
        if (i[a] !== o[a])
          throw new Error("Invalid checksum");
      return n;
    }
  };
}
const Y1e = /* @__NO_SIDE_EFFECTS__ */ (e) => /* @__PURE__ */ SK(/* @__PURE__ */ Z1e(58), /* @__PURE__ */ G1e(e), /* @__PURE__ */ W1e("")), J1e = /* @__PURE__ */ Y1e("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), Q1e = (e) => /* @__PURE__ */ SK(X1e(4, (t) => e(e(t))), J1e), ege = Q1e;
function tge(e) {
  return {
    lang: (e == null ? void 0 : e.lang) ?? void 0,
    message: e == null ? void 0 : e.message,
    abortEarly: (e == null ? void 0 : e.abortEarly) ?? void 0,
    abortPipeEarly: (e == null ? void 0 : e.abortPipeEarly) ?? void 0
  };
}
function rge(e, t) {
  var r;
  return (r = void 0) == null ? void 0 : r.get(t);
}
function jw(e) {
  var t, r;
  const n = typeof e;
  return n === "string" ? `"${e}"` : n === "number" || n === "bigint" || n === "boolean" ? `${e}` : n === "object" || n === "function" ? (e && ((r = (t = Object.getPrototypeOf(e)) == null ? void 0 : t.constructor) == null ? void 0 : r.name)) ?? "null" : n;
}
function wf(e, t, r, n, o) {
  const i = o && "input" in o ? o.input : r.value, a = (o == null ? void 0 : o.expected) ?? e.expects ?? null, u = (o == null ? void 0 : o.received) ?? jw(i), l = {
    kind: e.kind,
    type: e.type,
    input: i,
    expected: a,
    received: u,
    message: `Invalid ${t}: ${a ? `Expected ${a} but r` : "R"}eceived ${u}`,
    // @ts-expect-error
    requirement: e.requirement,
    path: o == null ? void 0 : o.path,
    issues: o == null ? void 0 : o.issues,
    lang: n.lang,
    abortEarly: n.abortEarly,
    abortPipeEarly: n.abortPipeEarly
  }, d = e.kind === "schema", f = (o == null ? void 0 : o.message) ?? // @ts-expect-error
  e.message ?? rge(e.reference, l.lang) ?? (d ? (l.lang, void 0) : null) ?? n.message ?? (l.lang, void 0);
  f && (l.message = typeof f == "function" ? f(l) : f), d && (r.typed = !1), r.issues ? r.issues.push(l) : r.issues = [l];
}
var nge = class extends Error {
  /**
   * Creates a Valibot error with useful information.
   *
   * @param issues The error issues.
   */
  constructor(t) {
    super(t[0].message), st(this, "issues"), this.name = "ValiError", this.issues = t;
  }
};
function b4(e) {
  return {
    kind: "validation",
    type: "integer",
    reference: b4,
    async: !1,
    expects: null,
    requirement: Number.isInteger,
    message: e,
    _run(t, r) {
      return t.typed && !this.requirement(t.value) && wf(this, "integer", t, r), t;
    }
  };
}
function tB(e, t) {
  return {
    kind: "validation",
    type: "length",
    reference: tB,
    async: !1,
    expects: `${e}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && r.value.length !== this.requirement && wf(this, "length", r, n, {
        received: `${r.value.length}`
      }), r;
    }
  };
}
function w4(e, t) {
  return {
    kind: "validation",
    type: "max_value",
    reference: w4,
    async: !1,
    expects: `<=${e instanceof Date ? e.toJSON() : jw(e)}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && r.value > this.requirement && wf(this, "value", r, n, {
        received: r.value instanceof Date ? r.value.toJSON() : jw(r.value)
      }), r;
    }
  };
}
function v4(e, t) {
  return {
    kind: "validation",
    type: "min_value",
    reference: v4,
    async: !1,
    expects: `>=${e instanceof Date ? e.toJSON() : jw(e)}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && r.value < this.requirement && wf(this, "value", r, n, {
        received: r.value instanceof Date ? r.value.toJSON() : jw(r.value)
      }), r;
    }
  };
}
function TK(e, t) {
  return {
    kind: "validation",
    type: "regex",
    reference: TK,
    async: !1,
    expects: `${e}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && !this.requirement.test(r.value) && wf(this, "format", r, n), r;
    }
  };
}
function E4(e, t) {
  return {
    kind: "schema",
    type: "instance",
    reference: E4,
    expects: e.name,
    async: !1,
    class: e,
    message: t,
    _run(r, n) {
      return r.value instanceof this.class ? r.typed = !0 : wf(this, "type", r, n), r;
    }
  };
}
function _4(e) {
  return {
    kind: "schema",
    type: "number",
    reference: _4,
    expects: "number",
    async: !1,
    message: e,
    _run(t, r) {
      return typeof t.value == "number" && !isNaN(t.value) ? t.typed = !0 : wf(this, "type", t, r), t;
    }
  };
}
function yO(e, t) {
  return {
    kind: "schema",
    type: "object",
    reference: yO,
    expects: "Object",
    async: !1,
    entries: e,
    message: t,
    _run(r, n) {
      var o;
      const i = r.value;
      if (i && typeof i == "object") {
        r.typed = !0, r.value = {};
        for (const a in this.entries) {
          const u = i[a], l = this.entries[a]._run(
            { typed: !1, value: u },
            n
          );
          if (l.issues) {
            const d = {
              type: "object",
              origin: "value",
              input: i,
              key: a,
              value: u
            };
            for (const f of l.issues)
              f.path ? f.path.unshift(d) : f.path = [d], (o = r.issues) == null || o.push(f);
            if (r.issues || (r.issues = l.issues), n.abortEarly) {
              r.typed = !1;
              break;
            }
          }
          l.typed || (r.typed = !1), (l.value !== void 0 || a in i) && (r.value[a] = l.value);
        }
      } else
        wf(this, "type", r, n);
      return r;
    }
  };
}
function IK(e) {
  return {
    kind: "schema",
    type: "string",
    reference: IK,
    expects: "string",
    async: !1,
    message: e,
    _run(t, r) {
      return typeof t.value == "string" ? t.typed = !0 : wf(this, "type", t, r), t;
    }
  };
}
function Nl(e, t, r) {
  const n = e._run(
    { typed: !1, value: t },
    tge(r)
  );
  if (n.issues)
    throw new nge(n.issues);
  return n.value;
}
function xg(...e) {
  return {
    ...e[0],
    pipe: e,
    _run(t, r) {
      for (const n of e)
        if (n.kind !== "metadata") {
          if (t.issues && (n.kind === "schema" || n.kind === "transformation")) {
            t.typed = !1;
            break;
          }
          (!t.issues || !r.abortEarly && !r.abortPipeEarly) && (t = n._run(t, r));
        }
      return t;
    }
  };
}
const bO = xg(_4(), b4(), v4(0), w4(4294967295)), oge = xg(_4(), b4(), v4(0), w4(2147483647)), ige = xg(_4(), b4(), v4(0), w4(255)), aT = xg(E4(Uint8Array), tB(32)), age = xg(E4(Uint8Array), tB(33)), sge = yO({
  wif: ige,
  bip32: yO({
    public: bO,
    private: bO
  })
}), uge = xg(IK(), TK(/^(m\/)?(\d+'?\/)*\d+'?$/));
function cge(e, t, r) {
  if (t.length !== 32)
    throw new TypeError("Invalid privateKey length");
  var n = new Uint8Array(34), o = new DataView(n.buffer);
  return o.setUint8(0, e), n.set(t, 1), n[33] = 1, n;
}
function lge(e) {
  return U1.encode(cge(e.version, e.privateKey));
}
const XU = ege(ki), YU = {
  encode: (e) => XU.encode(e),
  decode: (e) => XU.decode(e)
};
function fge(e) {
  K1e(e);
  const t = {
    messagePrefix: `Bitcoin Signed Message:
`,
    bech32: "bc",
    bip32: {
      public: 76067358,
      private: 76066276
    },
    pubKeyHash: 0,
    scriptHash: 5,
    wif: 128
  }, r = 2147483648;
  function n(g) {
    return g.length === 32 ? g : g.slice(1, 33);
  }
  class o {
    constructor(b, w) {
      st(this, "__D"), st(this, "__Q"), st(this, "lowR", !1), this.__D = b, this.__Q = w;
    }
    get publicKey() {
      return this.__Q === void 0 && (this.__Q = e.pointFromScalar(this.__D, !0)), this.__Q;
    }
    get privateKey() {
      return this.__D;
    }
    sign(b, w) {
      if (!this.privateKey)
        throw new Error("Missing private key");
      if (w === void 0 && (w = this.lowR), w === !1)
        return e.sign(b, this.privateKey);
      {
        let E = e.sign(b, this.privateKey);
        const _ = new Uint8Array(32);
        let O = 0;
        for (; E[0] > 127; )
          O++, _p(_, 0, O, "LE"), E = e.sign(b, this.privateKey, _);
        return E;
      }
    }
    signSchnorr(b) {
      if (!this.privateKey)
        throw new Error("Missing private key");
      if (!e.signSchnorr)
        throw new Error("signSchnorr not supported by ecc library");
      return e.signSchnorr(b, this.privateKey);
    }
    verify(b, w) {
      return e.verify(b, this.publicKey, w);
    }
    verifySchnorr(b, w) {
      if (!e.verifySchnorr)
        throw new Error("verifySchnorr not supported by ecc library");
      return e.verifySchnorr(b, this.publicKey.subarray(1, 33), w);
    }
  }
  class i extends o {
    constructor(b, w, E, _, O = 0, C = 0, I = 0) {
      super(b, w), st(this, "chainCode"), st(this, "network"), st(this, "__DEPTH"), st(this, "__INDEX"), st(this, "__PARENT_FINGERPRINT"), this.chainCode = E, this.network = _, this.__DEPTH = O, this.__INDEX = C, this.__PARENT_FINGERPRINT = I, Nl(sge, _);
    }
    get depth() {
      return this.__DEPTH;
    }
    get index() {
      return this.__INDEX;
    }
    get parentFingerprint() {
      return this.__PARENT_FINGERPRINT;
    }
    get identifier() {
      return D1e(this.publicKey);
    }
    get fingerprint() {
      return this.identifier.slice(0, 4);
    }
    get compressed() {
      return !0;
    }
    // Private === not neutered
    // Public === neutered
    isNeutered() {
      return this.__D === void 0;
    }
    neutered() {
      return f(this.publicKey, this.chainCode, this.network, this.depth, this.index, this.parentFingerprint);
    }
    toBase58() {
      const b = this.network, w = this.isNeutered() ? b.bip32.public : b.bip32.private, E = new Uint8Array(78);
      return _p(E, 0, w, "BE"), v$(E, 4, this.depth), _p(E, 5, this.parentFingerprint, "BE"), _p(E, 9, this.index, "BE"), E.set(this.chainCode, 13), this.isNeutered() ? E.set(this.publicKey, 45) : (v$(E, 45, 0), E.set(this.privateKey, 46)), YU.encode(E);
    }
    toWIF() {
      if (!this.privateKey)
        throw new TypeError("Missing private key");
      return lge({
        version: this.network.wif,
        privateKey: this.privateKey
      });
    }
    // https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki#child-key-derivation-ckd-functions
    derive(b) {
      Nl(bO, b);
      const w = b >= r, E = new Uint8Array(37);
      if (w) {
        if (this.isNeutered())
          throw new TypeError("Missing private key for hardened child key");
        E[0] = 0, E.set(this.privateKey, 1), _p(E, 33, b, "BE");
      } else
        E.set(this.publicKey, 0), _p(E, 33, b, "BE");
      const _ = WU(this.chainCode, E), O = _.slice(0, 32), C = _.slice(32);
      if (!e.isPrivate(O))
        return this.derive(b + 1);
      let I;
      if (this.isNeutered()) {
        const S = e.pointAddScalar(this.publicKey, O, !0);
        if (S === null)
          return this.derive(b + 1);
        I = f(S, C, this.network, this.depth + 1, b, X0(this.fingerprint, 0, "BE"));
      } else {
        const S = e.privateAdd(this.privateKey, O);
        if (S == null)
          return this.derive(b + 1);
        I = l(S, C, this.network, this.depth + 1, b, X0(this.fingerprint, 0, "BE"));
      }
      return I;
    }
    deriveHardened(b) {
      if (typeof Nl(oge, b) == "number")
        return this.derive(b + r);
      throw new TypeError("Expected UInt31, got " + b);
    }
    derivePath(b) {
      Nl(uge, b);
      let w = b.split("/");
      if (w[0] === "m") {
        if (this.parentFingerprint)
          throw new TypeError("Expected master, got child");
        w = w.slice(1);
      }
      return w.reduce((E, _) => {
        let O;
        return _.slice(-1) === "'" ? (O = parseInt(_.slice(0, -1), 10), E.deriveHardened(O)) : (O = parseInt(_, 10), E.derive(O));
      }, this);
    }
    tweak(b) {
      return this.privateKey ? this.tweakFromPrivateKey(b) : this.tweakFromPublicKey(b);
    }
    tweakFromPublicKey(b) {
      const w = n(this.publicKey);
      if (!e.xOnlyPointAddTweak)
        throw new Error("xOnlyPointAddTweak not supported by ecc library");
      const E = e.xOnlyPointAddTweak(w, b);
      if (!E || E.xOnlyPubkey === null)
        throw new Error("Cannot tweak public key!");
      const _ = Uint8Array.from([
        E.parity === 0 ? 2 : 3
      ]), O = IQ([
        _,
        E.xOnlyPubkey
      ]);
      return new o(void 0, O);
    }
    tweakFromPrivateKey(b) {
      const w = this.publicKey[0] === 3 || this.publicKey[0] === 4 && (this.publicKey[64] & 1) === 1, E = (() => {
        if (w) {
          if (e.privateNegate)
            return e.privateNegate(this.privateKey);
          throw new Error("privateNegate not supported by ecc library");
        } else return this.privateKey;
      })(), _ = e.privateAdd(E, b);
      if (!_)
        throw new Error("Invalid tweaked private key!");
      return new o(_, void 0);
    }
  }
  function a(g, b) {
    const w = YU.decode(g);
    if (w.length !== 78)
      throw new TypeError("Invalid buffer length");
    b = b || t;
    const E = X0(w, 0, "BE");
    if (E !== b.bip32.private && E !== b.bip32.public)
      throw new TypeError("Invalid network version");
    const _ = w[4], O = X0(w, 5, "BE");
    if (_ === 0 && O !== 0)
      throw new TypeError("Invalid parent fingerprint");
    const C = X0(w, 9, "BE");
    if (_ === 0 && C !== 0)
      throw new TypeError("Invalid index");
    const I = w.slice(13, 45);
    let S;
    if (E === b.bip32.private) {
      if (w[45] !== 0)
        throw new TypeError("Invalid private key");
      const T = w.slice(46, 78);
      S = l(T, I, b, _, C, O);
    } else {
      const T = w.slice(45, 78);
      S = f(T, I, b, _, C, O);
    }
    return S;
  }
  function u(g, b, w) {
    return l(g, b, w);
  }
  function l(g, b, w, E, _, O) {
    if (Nl(aT, g), Nl(aT, b), w = w || t, !e.isPrivate(g))
      throw new TypeError("Private key not in range [1, n)");
    return new i(g, void 0, b, w, E, _, O);
  }
  function d(g, b, w) {
    return f(g, b, w);
  }
  function f(g, b, w, E, _, O) {
    if (Nl(age, g), Nl(aT, b), w = w || t, !e.isPoint(g))
      throw new TypeError("Point is not on the curve");
    return new i(void 0, g, b, w, E, _, O);
  }
  function h(g, b) {
    if (Nl(E4(Uint8Array), g), g.length < 16)
      throw new TypeError("Seed should be at least 128 bits");
    if (g.length > 64)
      throw new TypeError("Seed should be at most 512 bits");
    b = b || t;
    const w = WU(TQ("Bitcoin seed"), g), E = w.slice(0, 32), _ = w.slice(32);
    return u(E, _, b);
  }
  return {
    fromSeed: h,
    fromBase58: a,
    fromPublicKey: d,
    fromPrivateKey: u
  };
}
const ZUe = "text/html", XUe = "text/css", dge = "text/plain", YUe = "text/javascript", JUe = "text/markdown", QUe = "application/json", eRe = "application/javascript", tRe = "application/xml", rRe = "application/pdf", nRe = "application/zip", oRe = "application/gzip", iRe = "application/xhtml+xml", aRe = "application/rss+xml", sRe = "application/atom+xml", uRe = "application/x-www-form-urlencoded", cRe = "application/octet-stream", lRe = "image/jpeg", fRe = "image/png", dRe = "image/gif", hRe = "image/svg+xml", pRe = "image/webp", gRe = "image/x-icon", mRe = "video/mp4", yRe = "video/webm", bRe = "video/ogg", wRe = "audio/mpeg", vRe = "audio/wav", ERe = "audio/ogg", _Re = "multipart/form-data", JU = "btc", QU = "brc20", eR = "runes", ARe = "alkanes", rB = "bip322", U2 = "ecdsa", A4 = "bip322-simple", OK = async (e = Kn) => await sn.get(`${N2(e)}/api/v1/fees/recommended`, {
  headers: {
    "Content-Type": "application/json"
  }
}).then((t) => t.data), hge = fge(c4);
FP(c4);
async function pge(e) {
  const t = crypto.getRandomValues(new Uint8Array(32)), r = z1e(Buffer.from(t)), n = await R1e(r), o = hge.fromSeed(n, dn(e));
  return o == null ? void 0 : o.derivePath("m/44'/0'/0'/0/0").privateKey;
}
const x4 = (e, t) => {
  try {
    const r = dn(t), n = RL(e);
    if (n.version === r.pubKeyHash) return bJ;
    if (n.version === r.scriptHash) {
      const o = to(n.hash);
      return o && o.length === 2 && o[0] === on.OP_0 ? wJ : h2;
    }
  } catch {
    try {
      const r = DP(e);
      if (r.version === 0 && r.data.length === 20) return hI;
      if (r.version === 0 && r.data.length === 32) return vJ;
      if (r.version === 1 && r.data.length === 32) return $1;
    } catch {
      return "unknown";
    }
  }
  return "unknown";
};
function PK(e, t) {
  const r = dn(t);
  return af(e, r);
}
function R2(e, t) {
  var r;
  const n = m2({
    pubkey: Buffer.from(e, "hex"),
    network: dn(t)
  }), o = gg({
    redeem: n,
    network: dn(t)
  });
  return (r = o == null ? void 0 : o.redeem) == null ? void 0 : r.output;
}
FP(c4);
const dn = (e) => e === aa || e === ka || e === Ls ? EJ : qu, R3 = (e) => e.find(
  ({ purpose: t }) => t === "ordinals"
), z3 = (e) => e.find(
  ({ purpose: t }) => t === "payment"
), a0 = async (e, t) => {
  try {
    const r = await oB(
      e,
      t
    );
    return r ? r.reduce((n, o) => n + BigInt(o.value), 0n) : 0n;
  } catch (r) {
    throw console.error("Error fetching BTC balance:", r), new Error("Failed to fetch BTC balance");
  }
};
function nB(e, t, r) {
  const n = e * 57 + t * 41, o = r * 34;
  return 10 + n + o;
}
async function oB(e, t) {
  if (e.startsWith("t")) {
    if (t === Kn)
      return [];
    if (t === th)
      return [];
    if (t === as)
      return [];
  }
  return await sn.get(`${N2(t)}/api/address/${e}/utxo`).then((r) => r.data);
}
async function iB(e, t, r, n, o, i, a = 7) {
  const u = e === t, l = await oB(
    t,
    i
  );
  if (!l)
    throw new Error("No UTXOs found");
  const d = l.sort(
    (E, _) => _.value - E.value
  ), f = new Sn({ network: dn(i) }), h = nB(1, 0, 2), g = Math.floor(h * a) + n;
  let b = 0, w = 0;
  for await (let E of d) {
    const { txid: _, vout: O, value: C } = E, I = af(
      t,
      dn(i)
    );
    if (f.addInput({
      hash: _,
      index: O,
      witnessUtxo: {
        script: I,
        value: BigInt(C)
      }
    }), !u) {
      const S = R2(o, i);
      f.updateInput(w, { redeemScript: S });
    }
    if (b += C, b >= g)
      break;
  }
  if (b < g)
    throw new Error("Insufficient funds");
  return f.addOutput({
    address: r,
    value: BigInt(n)
  }), b > g && f.addOutput({
    address: t,
    value: BigInt(b - g)
  }), {
    psbtBase64: f.toBase64(),
    psbtHex: f.toHex()
  };
}
function k4(e) {
  return e == null ? void 0 : e.reduce((t, r) => t + r.value, 0);
}
async function S4(e, t) {
  return (await sn.post(
    `${N2(t)}/api/tx`,
    e,
    {
      headers: {
        "Content-Type": "text/plain"
      }
    }
  )).data;
}
const CK = (e) => e === aa || e === ka || e === Ls, z2 = (e) => e === Kn || e === th || e === as;
FP(c4);
const BK = async ({
  contentBase64: e,
  mimeType: t,
  quantity: r = 1,
  inscriptions: n,
  ordinalAddress: o,
  paymentAddress: i,
  paymentPublicKey: a,
  signPsbt: u,
  dataSourceManager: l,
  network: d = Kn
}) => {
  try {
    if (!e && !n)
      throw new Error("contentBase64 or inscriptions is required");
    if (!l)
      throw new Error("missing data source");
    if (!l.broadcastTransaction)
      throw new Error("missing broadcastTransaction");
    const f = await pge(d), h = Buffer.from(f).toString("hex"), g = n || Array(r).fill({
      content: e,
      mimeType: t
    }), b = await gge({
      inscriptions: g,
      paymentAddress: i,
      paymentPublicKey: a,
      privKey: h,
      dataSourceManager: l,
      network: d
    });
    if (!b || !(b != null && b.psbtHex))
      throw new Error("couldn't get commit tx");
    const w = String(b == null ? void 0 : b.psbtHex), E = String(b == null ? void 0 : b.psbtBase64), _ = await u({
      tx: w,
      psbtHex: w,
      psbtBase64: E,
      finalize: !0,
      broadcast: !1,
      network: d
    });
    if (!_) throw new Error("sign psbt failed");
    const O = Sn.fromHex((_ == null ? void 0 : _.signedPsbtHex) || "").extractTransaction(), C = await l.broadcastTransaction(O.toHex());
    if (!C) throw new Error("commit tx failed");
    return await mge({
      inscriptions: g,
      ordinalAddress: o,
      privKey: h,
      commitTxId: C,
      dataSourceManager: l
    });
  } catch (f) {
    throw f;
  }
}, gge = async ({
  inscriptions: e,
  paymentAddress: t,
  paymentPublicKey: r,
  privKey: n,
  dataSourceManager: o,
  network: i
}) => {
  try {
    const a = e.length, u = e.reduce(
      (A, $) => A + Buffer.from($.content).length,
      0
    );
    if (u > 39e4)
      throw new Error("Content size is too large, must be less than 390kb");
    if (!o)
      throw new Error("missing data source");
    if (!o.getRecommendedFees)
      throw new Error("missing getRecommendedFees");
    if (!o.getAddressUtxos)
      throw new Error("missing getAddressUtxos");
    const { fastestFee: l } = await o.getRecommendedFees(), d = NH(String(n), !0), f = new Sn({
      network: dn(i)
    }), { inscriberAddress: h } = yge(
      d,
      e,
      i
    ), g = 5 * 34 * a, b = Math.floor(g * l * a), w = Math.floor(u * l / 3) + 1e3 + 546 * a, E = Math.floor(b + w), _ = (await o.getAddressUtxos(
      t
    )).filter((A) => A.value > 3e3).sort((A, $) => $.value - A.value), O = k4(_);
    if (O === 0)
      throw new Error("insufficient funds");
    if (O < E)
      throw new Error("insufficient funds");
    let C = 0;
    const I = af(
      t,
      dn(i)
    );
    let S = 0;
    for await (const A of _) {
      const $ = x4(t, i);
      if (f.addInput({
        hash: A.txid,
        index: A.vout,
        witnessUtxo: { value: BigInt(A.value), script: I }
      }), $ === $1 && f.updateInput(S, {
        tapInternalKey: Pu(Buffer.from(r, "hex"))
      }), $ === h2) {
        let U = R2(r, i);
        f.updateInput(S, { redeemScript: U });
      }
      if (S++, C += A.value, C > E)
        break;
    }
    const T = C - E;
    return f.addOutput({
      value: BigInt(w),
      address: h
    }), T > 546 && f.addOutput({
      value: BigInt(T),
      address: t
    }), {
      psbtHex: f.toHex(),
      psbtBase64: f.toBase64()
    };
  } catch (a) {
    throw a;
  }
}, mge = async ({
  inscriptions: e,
  ordinalAddress: t,
  commitTxId: r,
  privKey: n,
  dataSourceManager: o,
  isDry: i
}) => {
  try {
    const a = Voe(n), u = NH(n, !0), l = NK(u, e), d = v3.encodeScript(l), [f, h] = v3.getPubKey(u, { target: d });
    if (!o)
      throw new Error("missing data source");
    if (!o.waitForTransaction)
      throw new Error("missing waitForTransaction");
    if (!o.getOutputValueByVOutIndex)
      throw new Error("missing waitForTransaction");
    if (!o.broadcastTransaction)
      throw new Error("missing broadcastTransaction");
    if (!await o.waitForTransaction(String(r)))
      throw new Error("ERROR WAITING FOR COMMIT TX");
    const g = await o.getOutputValueByVOutIndex(
      r,
      0
    );
    if (g === 0 || !g)
      throw new Error("ERROR GETTING FIRST INPUT VALUE");
    const b = Bu.create({
      vin: [
        {
          txid: r,
          vout: 0,
          prevout: {
            value: g,
            scriptPubKey: ["OP_1", f]
          }
        }
      ],
      vout: [
        ...Array(e.length).fill({
          value: 546,
          scriptPubKey: EM.toScriptPubKey(t)
        })
      ]
    }), w = wfe.taproot.sign(a, b, 0, { extension: d });
    return b.vin[0].witness = [w, l, h], i ? Bu.util.getTxid(b) : await o.broadcastTransaction(Bu.encode(b).hex);
  } catch (a) {
    throw a;
  }
}, NK = (e, t) => {
  const r = new TextEncoder(), n = r.encode("ord"), o = 546, i = (u, l) => {
    let d;
    if (l === dge) {
      const h = Buffer.from(u, "base64").toString("utf-8");
      d = Buffer.from(h, "utf-8");
    } else
      d = Buffer.from(u, "base64");
    const f = [];
    for (let h = 0; h < d.length; h += 520)
      f.push(d.slice(h, h + 520));
    return f;
  }, a = [e, "OP_CHECKSIG"];
  return t.forEach((u, l) => {
    const { content: d, mimeType: f } = u, h = i(d, f);
    if (a.push("OP_0", "OP_IF", n, "01", r.encode(f), "OP_0"), l > 0) {
      const g = o * (l + 1), b = Buffer.from([g]);
      a.push(Buffer.from([2])), a.push(b);
    }
    a.push(...h.map((g) => g), "OP_ENDIF");
  }), a;
}, yge = (e, t, r = Kn) => {
  const n = NK(e, t), o = v3.encodeScript(n), [i] = v3.getPubKey(e, { target: o });
  return {
    inscriberAddress: EM.p2tr.fromPubKey(
      i,
      mpe(r)
    ),
    tpubkey: i,
    tapleaf: o
  };
};
var bge = {}, j2 = {};
Object.defineProperty(j2, "__esModule", { value: !0 });
j2.isRunestone = void 0;
function wge(e) {
  return !("flaws" in e);
}
j2.isRunestone = wge;
var Mn = {}, gs = {}, aB = {}, ms = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isNone = e.isSome = e.None = e.Some = e.OptionType = void 0, e.OptionType = {
    Some: Symbol(":some"),
    None: Symbol(":none")
  };
  class t {
    constructor(u) {
      this.val = u;
    }
    get type() {
      return e.OptionType.Some;
    }
    isSome() {
      return !0;
    }
    isNone() {
      return !1;
    }
    match(u) {
      return u.some(this.val);
    }
    map(u) {
      return n(u(this.val));
    }
    inspect(u) {
      return u(this.val), this;
    }
    andThen(u) {
      return u(this.val);
    }
    or(u) {
      return this;
    }
    orElse(u) {
      return this;
    }
    and(u) {
      return u;
    }
    unwrapOr(u) {
      return this.val;
    }
    unwrap() {
      return this.val;
    }
  }
  class r {
    get type() {
      return e.OptionType.None;
    }
    isSome() {
      return !1;
    }
    isNone() {
      return !0;
    }
    match({ none: u }) {
      return typeof u == "function" ? u() : u;
    }
    map(u) {
      return new r();
    }
    inspect(u) {
      return this;
    }
    andThen(u) {
      return new r();
    }
    or(u) {
      return u;
    }
    orElse(u) {
      return u();
    }
    and(u) {
      return new r();
    }
    unwrapOr(u) {
      return u;
    }
    unwrap() {
      throw new ReferenceError("Trying to unwrap None.");
    }
  }
  function n(a) {
    return new t(a);
  }
  e.Some = n, e.None = new r();
  function o(a) {
    return a.isSome();
  }
  e.isSome = o;
  function i(a) {
    return a.isNone();
  }
  e.isNone = i;
})(ms);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.u8 = e.U8_MAX_BIGINT = void 0;
  const t = ms;
  e.U8_MAX_BIGINT = 0xffn;
  function r(n) {
    return (typeof n == "bigint" ? n : BigInt(n)) & e.U8_MAX_BIGINT;
  }
  e.u8 = r, function(n) {
    n.MAX = n(e.U8_MAX_BIGINT);
    function o(a, u) {
      const l = a + u;
      return l > n.MAX ? t.None : (0, t.Some)(n(l));
    }
    n.checkedAdd = o;
    function i(a, u) {
      const l = a - u;
      return l < 0n ? t.None : (0, t.Some)(n(l));
    }
    n.checkedSub = i;
  }(r || (e.u8 = r = {}));
})(aB);
var sB = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.u32 = e.U32_MAX_BIGINT = void 0;
  const t = ms;
  e.U32_MAX_BIGINT = 0xffffffffn;
  function r(n) {
    return (typeof n == "bigint" ? n : BigInt(n)) & e.U32_MAX_BIGINT;
  }
  e.u32 = r, function(n) {
    n.MAX = n(e.U32_MAX_BIGINT);
    function o(a, u) {
      const l = a + u;
      return l > n.MAX ? t.None : (0, t.Some)(n(l));
    }
    n.checkedAdd = o;
    function i(a, u) {
      const l = a - u;
      return l < 0n ? t.None : (0, t.Some)(n(l));
    }
    n.checkedSub = i;
  }(r || (e.u32 = r = {}));
})(sB);
var uB = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.u64 = e.U64_MAX_BIGINT = void 0;
  const t = ms;
  e.U64_MAX_BIGINT = 0xffffffffffffffffn;
  function r(n) {
    return (typeof n == "bigint" ? n : BigInt(n)) & e.U64_MAX_BIGINT;
  }
  e.u64 = r, function(n) {
    n.MAX = n(e.U64_MAX_BIGINT);
    function o(a, u) {
      const l = a + u;
      return l > n.MAX ? t.None : (0, t.Some)(n(l));
    }
    n.checkedAdd = o;
    function i(a, u) {
      const l = a - u;
      return l < 0n ? t.None : (0, t.Some)(n(l));
    }
    n.checkedSub = i;
  }(r || (e.u64 = r = {}));
})(uB);
var $K = {}, L2 = {};
Object.defineProperty(L2, "__esModule", { value: !0 });
L2.SeekBuffer = void 0;
let vge = class {
  constructor(t) {
    this.buffer = t, this.seekIndex = 0;
  }
  readUInt8() {
    if (!this.isFinished())
      return this.buffer.readUInt8(this.seekIndex++);
  }
  isFinished() {
    return this.seekIndex >= this.buffer.length;
  }
};
L2.SeekBuffer = vge;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.getAllU128 = e.u128 = e.U128_MAX_BIGINT = void 0;
  const t = ms, r = L2, n = uB, o = sB, i = aB;
  e.U128_MAX_BIGINT = 0xffffffffffffffffffffffffffffffffn;
  function a(l) {
    return (typeof l == "bigint" ? l : BigInt(l)) & e.U128_MAX_BIGINT;
  }
  e.u128 = a, function(l) {
    l.MAX = l(e.U128_MAX_BIGINT);
    function d($, U) {
      const M = $ + U;
      return M > l.MAX ? t.None : (0, t.Some)(l(M));
    }
    l.checkedAdd = d;
    function f($, U) {
      const M = l.checkedAdd($, U);
      if (M.isNone())
        throw new Error("checked add overflow");
      return M.unwrap();
    }
    l.checkedAddThrow = f;
    function h($, U) {
      const M = $ - U;
      return M < 0n ? t.None : (0, t.Some)(l(M));
    }
    l.checkedSub = h;
    function g($, U) {
      const M = l.checkedSub($, U);
      if (M.isNone())
        throw new Error("checked sub overflow");
      return M.unwrap();
    }
    l.checkedSubThrow = g;
    function b($, U) {
      const M = $ * U;
      return M > l.MAX ? t.None : (0, t.Some)(l(M));
    }
    l.checkedMultiply = b;
    function w($, U) {
      const M = $ + U;
      return M > l.MAX ? l.MAX : l(M);
    }
    l.saturatingAdd = w;
    function E($, U) {
      const M = $ * U;
      return M > l.MAX ? l.MAX : l(M);
    }
    l.saturatingMultiply = E;
    function _($, U) {
      return l($ < U ? 0 : $ - U);
    }
    l.saturatingSub = _;
    function O($) {
      try {
        return (0, t.Some)(C($));
      } catch {
        return t.None;
      }
    }
    l.decodeVarInt = O;
    function C($) {
      let U = l(0);
      for (let M = 0; M <= 18; M++) {
        const Y = $.readUInt8();
        if (Y === void 0)
          throw new Error("Unterminated");
        const L = l(Y) & 127n;
        if (M === 18 && (L & 124n) !== 0n)
          throw new Error("Overflow");
        if (U = l(U | L << l(7 * M)), !(Y & 128))
          return U;
      }
      throw new Error("Overlong");
    }
    l.tryDecodeVarInt = C;
    function I($) {
      const U = [];
      for (; $ >> 7n > 0n; )
        U.push(Number($ & 0xffn) | 128), $ = l($ >> 7n);
      return U.push(Number($ & 0xffn)), Buffer.from(U);
    }
    l.encodeVarInt = I;
    function S($) {
      return $ > n.u64.MAX ? t.None : (0, t.Some)((0, n.u64)($));
    }
    l.tryIntoU64 = S;
    function T($) {
      return $ > o.u32.MAX ? t.None : (0, t.Some)((0, o.u32)($));
    }
    l.tryIntoU32 = T;
    function A($) {
      return $ > i.u8.MAX ? t.None : (0, t.Some)((0, i.u8)($));
    }
    l.tryIntoU8 = A;
  }(a || (e.u128 = a = {}));
  function* u(l) {
    const d = new r.SeekBuffer(l);
    for (; !d.isFinished(); ) {
      const f = a.tryDecodeVarInt(d);
      if (f === void 0)
        return;
      yield f;
    }
  }
  e.getAllU128 = u;
})($K);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.u128 = e.u64 = e.u32 = e.u8 = void 0;
  var t = aB;
  Object.defineProperty(e, "u8", { enumerable: !0, get: function() {
    return t.u8;
  } });
  var r = sB;
  Object.defineProperty(e, "u32", { enumerable: !0, get: function() {
    return r.u32;
  } });
  var n = uB;
  Object.defineProperty(e, "u64", { enumerable: !0, get: function() {
    return n.u64;
  } });
  var o = $K;
  Object.defineProperty(e, "u128", { enumerable: !0, get: function() {
    return o.u128;
  } });
})(gs);
var Fd = {};
Object.defineProperty(Fd, "__esModule", { value: !0 });
Fd.script = Fd.opcodes = void 0;
var rw;
(function(e) {
  function t(o) {
    return o < $s.OP_PUSHDATA1 ? 1 : o <= 255 ? 2 : o <= 65535 ? 3 : 5;
  }
  e.encodingLength = t;
  function r(o, i, a) {
    const u = t(i);
    return u === 1 ? o.writeUInt8(i, a) : u === 2 ? (o.writeUInt8($s.OP_PUSHDATA1, a), o.writeUInt8(i, a + 1)) : u === 3 ? (o.writeUInt8($s.OP_PUSHDATA2, a), o.writeUInt16LE(i, a + 1)) : (o.writeUInt8($s.OP_PUSHDATA4, a), o.writeUInt32LE(i, a + 1)), u;
  }
  e.encode = r;
  function n(o, i) {
    const a = o.readUInt8(i);
    let u, l;
    if (a < $s.OP_PUSHDATA1)
      u = a, l = 1;
    else if (a === $s.OP_PUSHDATA1) {
      if (i + 2 > o.length)
        return null;
      u = o.readUInt8(i + 1), l = 2;
    } else if (a === $s.OP_PUSHDATA2) {
      if (i + 3 > o.length)
        return null;
      u = o.readUInt16LE(i + 1), l = 3;
    } else {
      if (i + 5 > o.length)
        return null;
      if (a !== $s.OP_PUSHDATA4)
        throw new Error("Unexpected opcode");
      u = o.readUInt32LE(i + 1), l = 5;
    }
    return {
      opcode: a,
      number: u,
      size: l
    };
  }
  e.decode = n;
})(rw || (rw = {}));
const $s = {
  OP_FALSE: 0,
  OP_0: 0,
  OP_PUSHDATA1: 76,
  OP_PUSHDATA2: 77,
  OP_PUSHDATA4: 78,
  OP_1NEGATE: 79,
  OP_RESERVED: 80,
  OP_TRUE: 81,
  OP_1: 81,
  OP_2: 82,
  OP_3: 83,
  OP_4: 84,
  OP_5: 85,
  OP_6: 86,
  OP_7: 87,
  OP_8: 88,
  OP_9: 89,
  OP_10: 90,
  OP_11: 91,
  OP_12: 92,
  OP_13: 93,
  OP_14: 94,
  OP_15: 95,
  OP_16: 96,
  OP_NOP: 97,
  OP_VER: 98,
  OP_IF: 99,
  OP_NOTIF: 100,
  OP_VERIF: 101,
  OP_VERNOTIF: 102,
  OP_ELSE: 103,
  OP_ENDIF: 104,
  OP_VERIFY: 105,
  OP_RETURN: 106,
  OP_TOALTSTACK: 107,
  OP_FROMALTSTACK: 108,
  OP_2DROP: 109,
  OP_2DUP: 110,
  OP_3DUP: 111,
  OP_2OVER: 112,
  OP_2ROT: 113,
  OP_2SWAP: 114,
  OP_IFDUP: 115,
  OP_DEPTH: 116,
  OP_DROP: 117,
  OP_DUP: 118,
  OP_NIP: 119,
  OP_OVER: 120,
  OP_PICK: 121,
  OP_ROLL: 122,
  OP_ROT: 123,
  OP_SWAP: 124,
  OP_TUCK: 125,
  OP_CAT: 126,
  OP_SUBSTR: 127,
  OP_LEFT: 128,
  OP_RIGHT: 129,
  OP_SIZE: 130,
  OP_INVERT: 131,
  OP_AND: 132,
  OP_OR: 133,
  OP_XOR: 134,
  OP_EQUAL: 135,
  OP_EQUALVERIFY: 136,
  OP_RESERVED1: 137,
  OP_RESERVED2: 138,
  OP_1ADD: 139,
  OP_1SUB: 140,
  OP_2MUL: 141,
  OP_2DIV: 142,
  OP_NEGATE: 143,
  OP_ABS: 144,
  OP_NOT: 145,
  OP_0NOTEQUAL: 146,
  OP_ADD: 147,
  OP_SUB: 148,
  OP_MUL: 149,
  OP_DIV: 150,
  OP_MOD: 151,
  OP_LSHIFT: 152,
  OP_RSHIFT: 153,
  OP_BOOLAND: 154,
  OP_BOOLOR: 155,
  OP_NUMEQUAL: 156,
  OP_NUMEQUALVERIFY: 157,
  OP_NUMNOTEQUAL: 158,
  OP_LESSTHAN: 159,
  OP_GREATERTHAN: 160,
  OP_LESSTHANOREQUAL: 161,
  OP_GREATERTHANOREQUAL: 162,
  OP_MIN: 163,
  OP_MAX: 164,
  OP_WITHIN: 165,
  OP_RIPEMD160: 166,
  OP_SHA1: 167,
  OP_SHA256: 168,
  OP_HASH160: 169,
  OP_HASH256: 170,
  OP_CODESEPARATOR: 171,
  OP_CHECKSIG: 172,
  OP_CHECKSIGVERIFY: 173,
  OP_CHECKMULTISIG: 174,
  OP_CHECKMULTISIGVERIFY: 175,
  OP_NOP1: 176,
  OP_NOP2: 177,
  OP_CHECKLOCKTIMEVERIFY: 177,
  OP_NOP3: 178,
  OP_CHECKSEQUENCEVERIFY: 178,
  OP_NOP4: 179,
  OP_NOP5: 180,
  OP_NOP6: 181,
  OP_NOP7: 182,
  OP_NOP8: 183,
  OP_NOP9: 184,
  OP_NOP10: 185,
  OP_CHECKSIGADD: 186,
  OP_PUBKEYHASH: 253,
  OP_PUBKEY: 254,
  OP_INVALIDOPCODE: 255
};
Fd.opcodes = $s;
$s.OP_RESERVED;
function tR(e) {
  return Buffer.isBuffer(e);
}
var rR;
(function(e) {
  function t(n) {
    const o = n.reduce((u, l) => tR(l) ? u + rw.encodingLength(l.length) + l.length : u + 1, 0), i = Buffer.allocUnsafe(o);
    let a = 0;
    if (n.forEach((u) => {
      tR(u) ? (a += rw.encode(i, u.length, a), u.copy(i, a), a += u.length) : (i.writeUInt8(u, a), a += 1);
    }), a !== i.length)
      throw new Error("Could not decode chunks");
    return i;
  }
  e.compile = t;
  function* r(n) {
    let o = 0;
    for (; o < n.length; ) {
      const i = n[o];
      if (i >= $s.OP_0 && i <= $s.OP_PUSHDATA4) {
        const a = rw.decode(n, o);
        if (a === null || (o += a.size, o + a.number > n.length))
          return !1;
        const u = n.slice(o, o + a.number);
        o += a.number, yield u;
      } else
        yield i, o += 1;
    }
    return !0;
  }
  e.decompile = r;
})(rR || (Fd.script = rR = {}));
Object.defineProperty(Mn, "__esModule", { value: !0 });
Mn.TAPROOT_SCRIPT_PUBKEY_TYPE = Mn.COMMIT_CONFIRMATIONS = Mn.TAPROOT_ANNEX_PREFIX = Mn.MAGIC_NUMBER = Mn.OP_RETURN = Mn.MAX_SCRIPT_ELEMENT_SIZE = Mn.SUBSIDY_HALVING_INTERVAL = Mn.RESERVED = Mn.MAX_DIVISIBILITY = void 0;
const UK = gs, RK = Fd;
Mn.MAX_DIVISIBILITY = (0, UK.u8)(38);
Mn.RESERVED = (0, UK.u128)(6402364363415443603228541259936211926n);
Mn.SUBSIDY_HALVING_INTERVAL = 21e4;
Mn.MAX_SCRIPT_ELEMENT_SIZE = 520;
Mn.OP_RETURN = RK.opcodes.OP_RETURN;
Mn.MAGIC_NUMBER = RK.opcodes.OP_13;
Mn.TAPROOT_ANNEX_PREFIX = 80;
Mn.COMMIT_CONFIRMATIONS = 6;
Mn.TAPROOT_SCRIPT_PUBKEY_TYPE = "witness_v1_taproot";
var H2 = {};
Object.defineProperty(H2, "__esModule", { value: !0 });
H2.Etching = void 0;
const nR = ms, Pb = gs;
let Ege = class {
  constructor(t, r, n, o, i, a, u) {
    this.divisibility = t, this.rune = r, this.spacers = n, this.terms = i, this.premine = a, this.turbo = u, this.symbol = o.andThen((l) => {
      const d = l.codePointAt(0);
      return d !== void 0 ? (0, nR.Some)(String.fromCodePoint(d)) : nR.None;
    });
  }
  get supply() {
    const t = this.premine.unwrapOr((0, Pb.u128)(0)), r = this.terms.andThen((o) => o.cap).unwrapOr((0, Pb.u128)(0)), n = this.terms.andThen((o) => o.amount).unwrapOr((0, Pb.u128)(0));
    return Pb.u128.checkedMultiply(r, n).andThen((o) => Pb.u128.checkedAdd(t, o));
  }
};
H2.Etching = Ege;
var kg = {};
Object.defineProperty(kg, "__esModule", { value: !0 });
kg.Flaw = void 0;
var oR;
(function(e) {
  e[e.EDICT_OUTPUT = 0] = "EDICT_OUTPUT", e[e.EDICT_RUNE_ID = 1] = "EDICT_RUNE_ID", e[e.INVALID_SCRIPT = 2] = "INVALID_SCRIPT", e[e.OPCODE = 3] = "OPCODE", e[e.SUPPLY_OVERFLOW = 4] = "SUPPLY_OVERFLOW", e[e.TRAILING_INTEGERS = 5] = "TRAILING_INTEGERS", e[e.TRUNCATED_FIELD = 6] = "TRUNCATED_FIELD", e[e.UNRECOGNIZED_EVEN_TAG = 7] = "UNRECOGNIZED_EVEN_TAG", e[e.UNRECOGNIZED_FLAG = 8] = "UNRECOGNIZED_FLAG", e[e.VARINT = 9] = "VARINT";
})(oR || (kg.Flaw = oR = {}));
var Sg = {};
Object.defineProperty(Sg, "__esModule", { value: !0 });
Sg.RuneId = void 0;
const Vf = ms, sc = gs;
let _ge = class H8 {
  constructor(t, r) {
    this.block = t, this.tx = r;
  }
  static new(t, r) {
    const n = new H8(t, r);
    return n.block === 0n && n.tx > 0 ? Vf.None : (0, Vf.Some)(n);
  }
  static sort(t) {
    return [...t].sort((r, n) => Number(r.block - n.block || r.tx - n.tx));
  }
  delta(t) {
    const r = sc.u64.checkedSub(t.block, this.block);
    if (r.isNone())
      return Vf.None;
    const n = r.unwrap();
    let o;
    if (n === 0n) {
      const i = sc.u32.checkedSub(t.tx, this.tx);
      if (i.isNone())
        return Vf.None;
      o = i.unwrap();
    } else
      o = t.tx;
    return (0, Vf.Some)([(0, sc.u128)(n), (0, sc.u128)(o)]);
  }
  next(t, r) {
    const n = sc.u128.tryIntoU64(t), o = sc.u128.tryIntoU32(r);
    if (n.isNone() || o.isNone())
      return Vf.None;
    const i = n.unwrap(), a = o.unwrap(), u = sc.u64.checkedAdd(this.block, i);
    if (u.isNone())
      return Vf.None;
    let l;
    if (i === 0n) {
      const d = sc.u32.checkedAdd(this.tx, a);
      if (d.isNone())
        return Vf.None;
      l = d.unwrap();
    } else
      l = a;
    return H8.new(u.unwrap(), l);
  }
  toString() {
    return `${this.block}:${this.tx}`;
  }
  static fromString(t) {
    const r = t.split(":");
    if (r.length !== 2)
      throw new Error(`invalid rune ID: ${t}`);
    const [n, o] = r;
    if (!/^\d+$/.test(n) || !/^\d+$/.test(o))
      throw new Error(`invalid rune ID: ${t}`);
    return new H8((0, sc.u64)(BigInt(n)), (0, sc.u32)(BigInt(o)));
  }
};
Sg.RuneId = _ge;
var cB = {}, Tg = {};
Object.defineProperty(Tg, "__esModule", { value: !0 });
Tg.Tag = void 0;
const Kv = ms, M0 = gs;
var j3;
(function(e) {
  e[e.BODY = 0] = "BODY", e[e.FLAGS = 2] = "FLAGS", e[e.RUNE = 4] = "RUNE", e[e.PREMINE = 6] = "PREMINE", e[e.CAP = 8] = "CAP", e[e.AMOUNT = 10] = "AMOUNT", e[e.HEIGHT_START = 12] = "HEIGHT_START", e[e.HEIGHT_END = 14] = "HEIGHT_END", e[e.OFFSET_START = 16] = "OFFSET_START", e[e.OFFSET_END = 18] = "OFFSET_END", e[e.MINT = 20] = "MINT", e[e.POINTER = 22] = "POINTER", e[e.CENOTAPH = 126] = "CENOTAPH", e[e.DIVISIBILITY = 1] = "DIVISIBILITY", e[e.SPACERS = 3] = "SPACERS", e[e.SYMBOL = 5] = "SYMBOL", e[e.NOP = 127] = "NOP";
})(j3 || (Tg.Tag = j3 = {}));
(function(e) {
  function t(o, i, a, u) {
    const l = i.get((0, M0.u128)(o));
    if (l === void 0)
      return Kv.None;
    const d = [];
    for (const h of [...Array(a).keys()]) {
      if (l[h] === void 0)
        return Kv.None;
      d[h] = l[h];
    }
    const f = u(d);
    return f.isNone() ? Kv.None : (l.splice(0, a), l.length === 0 && i.delete((0, M0.u128)(o)), (0, Kv.Some)(f.unwrap()));
  }
  e.take = t;
  function r(o, i) {
    return Buffer.concat(i.map((a) => [M0.u128.encodeVarInt((0, M0.u128)(o)), M0.u128.encodeVarInt(a)]).flat());
  }
  e.encode = r;
  function n(o, i) {
    return i.map((a) => e.encode(o, [(0, M0.u128)(a)])).unwrapOr(Buffer.alloc(0));
  }
  e.encodeOptionInt = n;
})(j3 || (Tg.Tag = j3 = {}));
var Ig = {}, T0 = {};
Object.defineProperty(T0, "__esModule", { value: !0 });
T0.Network = void 0;
const qv = Mn;
var L3;
(function(e) {
  e[e.MAINNET = 0] = "MAINNET", e[e.SIGNET = 1] = "SIGNET", e[e.TESTNET = 2] = "TESTNET", e[e.REGTEST = 3] = "REGTEST";
})(L3 || (T0.Network = L3 = {}));
(function(e) {
  function t(r) {
    switch (r) {
      case e.MAINNET:
        return qv.SUBSIDY_HALVING_INTERVAL * 4;
      case e.REGTEST:
        return qv.SUBSIDY_HALVING_INTERVAL * 0;
      case e.SIGNET:
        return qv.SUBSIDY_HALVING_INTERVAL * 0;
      case e.TESTNET:
        return qv.SUBSIDY_HALVING_INTERVAL * 12;
    }
  }
  e.getFirstRuneHeight = t;
})(L3 || (T0.Network = L3 = {}));
Object.defineProperty(Ig, "__esModule", { value: !0 });
Ig.Rune = void 0;
const Age = T0, Vv = Mn, Nt = gs;
class yu {
  constructor(t) {
    this.value = t;
  }
  static getMinimumAtHeight(t, r) {
    let n = Nt.u128.saturatingAdd(r, (0, Nt.u128)(1));
    const o = (0, Nt.u128)(Vv.SUBSIDY_HALVING_INTERVAL / 12);
    let i = (0, Nt.u128)(Age.Network.getFirstRuneHeight(t)), a = Nt.u128.saturatingAdd(i, (0, Nt.u128)(Vv.SUBSIDY_HALVING_INTERVAL));
    if (n < i)
      return new yu(yu.STEPS[12]);
    if (n >= a)
      return new yu((0, Nt.u128)(0));
    let u = Nt.u128.saturatingSub(n, i), l = Nt.u128.saturatingSub((0, Nt.u128)(12n), (0, Nt.u128)(u / o)), d = Number(l & (0, Nt.u128)(Nt.u32.MAX)), f = yu.STEPS[d], h = yu.STEPS[d - 1], g = (0, Nt.u128)(u % o);
    return new yu((0, Nt.u128)(f - (f - h) * g / o));
  }
  get reserved() {
    return this.value >= Vv.RESERVED;
  }
  get commitment() {
    const t = Buffer.alloc(16);
    t.writeBigUInt64LE(0xffffffffffffffffn & this.value, 0), t.writeBigUInt64LE(this.value >> 64n, 8);
    let r = t.length;
    for (; r > 0 && t.at(r - 1) === 0; )
      r--;
    return t.subarray(0, r);
  }
  static getReserved(t, r) {
    return new yu(Nt.u128.checkedAdd(Vv.RESERVED, (0, Nt.u128)(t << 32n | r)).unwrap());
  }
  toString() {
    let t = this.value;
    if (t === Nt.u128.MAX)
      return "BCGDENLQRQWDSLRUGSNLBTMFIJAV";
    t = (0, Nt.u128)(t + 1n);
    let r = "";
    for (; t > 0; )
      r = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"[Number((t - 1n) % 26n)] + r, t = (0, Nt.u128)((t - 1n) / 26n);
    return r;
  }
  static fromString(t) {
    let r = (0, Nt.u128)(0);
    for (const n of [...Array(t.length).keys()]) {
      const o = t[n];
      if (n > 0 && (r = (0, Nt.u128)(r + 1n)), r = Nt.u128.checkedMultiply(r, (0, Nt.u128)(26)).unwrap(), "A" <= o && o <= "Z")
        r = Nt.u128.checkedAdd(r, (0, Nt.u128)(o.charCodeAt(0) - 65)).unwrap();
      else
        throw new Error(`invalid character in rune name: ${o}`);
    }
    return new yu(r);
  }
}
Ig.Rune = yu;
yu.STEPS = [
  (0, Nt.u128)(0n),
  (0, Nt.u128)(26n),
  (0, Nt.u128)(702n),
  (0, Nt.u128)(18278n),
  (0, Nt.u128)(475254n),
  (0, Nt.u128)(12356630n),
  (0, Nt.u128)(321272406n),
  (0, Nt.u128)(8353082582n),
  (0, Nt.u128)(217180147158n),
  (0, Nt.u128)(5646683826134n),
  (0, Nt.u128)(146813779479510n),
  (0, Nt.u128)(3817158266467286n),
  (0, Nt.u128)(99246114928149462n),
  (0, Nt.u128)(2580398988131886038n),
  (0, Nt.u128)(67090373691429037014n),
  (0, Nt.u128)(1744349715977154962390n),
  (0, Nt.u128)(45353092615406029022166n),
  (0, Nt.u128)(1179180408000556754576342n),
  (0, Nt.u128)(30658690608014475618984918n),
  (0, Nt.u128)(797125955808376366093607894n),
  (0, Nt.u128)(20725274851017785518433805270n),
  (0, Nt.u128)(538857146126462423479278937046n),
  (0, Nt.u128)(14010285799288023010461252363222n),
  (0, Nt.u128)(364267430781488598271992561443798n),
  (0, Nt.u128)(9470953200318703555071806597538774n),
  (0, Nt.u128)(246244783208286292431866971536008150n),
  (0, Nt.u128)(6402364363415443603228541259936211926n),
  (0, Nt.u128)(166461473448801533683942072758341510102n)
];
var F2 = {};
Object.defineProperty(F2, "__esModule", { value: !0 });
F2.Flag = void 0;
const sT = gs;
var H3;
(function(e) {
  e[e.ETCHING = 0] = "ETCHING", e[e.TERMS = 1] = "TERMS", e[e.TURBO = 2] = "TURBO", e[e.CENOTAPH = 127] = "CENOTAPH";
})(H3 || (F2.Flag = H3 = {}));
(function(e) {
  function t(o) {
    return (0, sT.u128)(1n << BigInt(o));
  }
  e.mask = t;
  function r(o, i) {
    const a = e.mask(i), u = (o & a) !== 0n;
    return { set: u, flags: u ? (0, sT.u128)(o - a) : o };
  }
  e.take = r;
  function n(o, i) {
    return (0, sT.u128)(o | e.mask(i));
  }
  e.set = n;
})(H3 || (F2.Flag = H3 = {}));
var T4 = {};
Object.defineProperty(T4, "__esModule", { value: !0 });
T4.Instruction = void 0;
var iR;
(function(e) {
  function t(n) {
    return typeof n == "number";
  }
  e.isNumber = t;
  function r(n) {
    return typeof n != "number";
  }
  e.isBuffer = r;
})(iR || (T4.Instruction = iR = {}));
var I4 = {}, O4 = {};
Object.defineProperty(O4, "__esModule", { value: !0 });
O4.Edict = void 0;
const Gv = ms, xge = gs;
var aR;
(function(e) {
  function t(r, n, o, i) {
    if (n.block === 0n && n.tx > 0n)
      return Gv.None;
    const a = xge.u128.tryIntoU32(i);
    if (a.isNone())
      return Gv.None;
    const u = a.unwrap();
    return u > r ? Gv.None : (0, Gv.Some)({ id: n, amount: o, output: u });
  }
  e.fromIntegers = t;
})(aR || (O4.Edict = aR = {}));
Object.defineProperty(I4, "__esModule", { value: !0 });
I4.Message = void 0;
const kge = O4, Wv = kg, uT = gs, Sge = Sg, Tge = Tg;
class lB {
  constructor(t, r, n) {
    this.flaws = t, this.edicts = r, this.fields = n;
  }
  static fromIntegers(t, r) {
    const n = [], o = /* @__PURE__ */ new Map(), i = [];
    for (const a of [...Array(Math.ceil(r.length / 2)).keys()].map((u) => u * 2)) {
      const u = r[a];
      if ((0, uT.u128)(Tge.Tag.BODY) === u) {
        let f = new Sge.RuneId((0, uT.u64)(0), (0, uT.u32)(0));
        const h = 4, g = r.slice(a + 1);
        for (let b = 0; b < g.length; b += h) {
          const w = g.slice(b, b + h);
          if (w.length !== h) {
            i.push(Wv.Flaw.TRAILING_INTEGERS);
            break;
          }
          const E = f.next(w[0], w[1]);
          if (E.isNone()) {
            i.push(Wv.Flaw.EDICT_RUNE_ID);
            break;
          }
          const _ = E.unwrap(), O = kge.Edict.fromIntegers(t, _, w[2], w[3]);
          if (O.isNone()) {
            i.push(Wv.Flaw.EDICT_OUTPUT);
            break;
          }
          const C = O.unwrap();
          f = _, n.push(C);
        }
        break;
      }
      const l = r[a + 1];
      if (l === void 0) {
        i.push(Wv.Flaw.TRUNCATED_FIELD);
        break;
      }
      const d = o.get(u) ?? [];
      d.push(l), o.set(u, d);
    }
    return new lB(i, n, o);
  }
}
I4.Message = lB;
var P4 = {};
Object.defineProperty(P4, "__esModule", { value: !0 });
P4.Cenotaph = void 0;
const sR = ms;
let Ige = class {
  constructor(t, r = sR.None, n = sR.None) {
    this.flaws = t, this.etching = r, this.mint = n;
  }
};
P4.Cenotaph = Ige;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Runestone = e.isValidPayload = e.MAX_SPACERS = void 0;
  const t = Mn, r = H2, n = L2, o = Tg, i = gs, a = ms, u = Ig, l = F2, d = T4, f = Sg, h = Fd, g = I4, b = kg, w = P4;
  e.MAX_SPACERS = 134217727;
  function E(O) {
    return Buffer.isBuffer(O);
  }
  e.isValidPayload = E;
  class _ {
    constructor(C, I, S, T) {
      this.mint = C, this.pointer = I, this.edicts = S, this.etching = T;
    }
    static decipher(C) {
      const I = _.payload(C);
      if (I.isNone())
        return a.None;
      const S = I.unwrap();
      if (!E(S))
        return (0, a.Some)(new w.Cenotaph([S]));
      const T = _.integers(S);
      if (T.isNone())
        return (0, a.Some)(new w.Cenotaph([b.Flaw.VARINT]));
      const { flaws: A, edicts: $, fields: U } = g.Message.fromIntegers(C.vout.length, T.unwrap());
      let M = o.Tag.take(o.Tag.FLAGS, U, 1, ([D]) => (0, a.Some)(D)).unwrapOr((0, i.u128)(0));
      const Y = l.Flag.take(M, l.Flag.ETCHING), L = Y.set;
      M = Y.flags;
      const ee = L ? (() => {
        const D = o.Tag.take(o.Tag.DIVISIBILITY, U, 1, ([ve]) => i.u128.tryIntoU8(ve).andThen((Ee) => Ee <= t.MAX_DIVISIBILITY ? (0, a.Some)(Ee) : a.None)), K = o.Tag.take(o.Tag.RUNE, U, 1, ([ve]) => (0, a.Some)(new u.Rune(ve))), le = o.Tag.take(o.Tag.SPACERS, U, 1, ([ve]) => i.u128.tryIntoU32(ve).andThen((Ee) => Ee <= e.MAX_SPACERS ? (0, a.Some)(Ee) : a.None)), re = o.Tag.take(o.Tag.SYMBOL, U, 1, ([ve]) => i.u128.tryIntoU32(ve).andThen((Ee) => {
          try {
            return (0, a.Some)(String.fromCodePoint(Number(Ee)));
          } catch {
            return a.None;
          }
        })), G = l.Flag.take(M, l.Flag.TERMS), q = G.set;
        M = G.flags;
        const Q = q ? (() => {
          const ve = o.Tag.take(o.Tag.AMOUNT, U, 1, ([be]) => (0, a.Some)(be)), Ee = o.Tag.take(o.Tag.CAP, U, 1, ([be]) => (0, a.Some)(be)), _e = [
            o.Tag.take(o.Tag.OFFSET_START, U, 1, ([be]) => i.u128.tryIntoU64(be)),
            o.Tag.take(o.Tag.OFFSET_END, U, 1, ([be]) => i.u128.tryIntoU64(be))
          ], we = [
            o.Tag.take(o.Tag.HEIGHT_START, U, 1, ([be]) => i.u128.tryIntoU64(be)),
            o.Tag.take(o.Tag.HEIGHT_END, U, 1, ([be]) => i.u128.tryIntoU64(be))
          ];
          return (0, a.Some)({ amount: ve, cap: Ee, offset: _e, height: we });
        })() : a.None, se = o.Tag.take(o.Tag.PREMINE, U, 1, ([ve]) => (0, a.Some)(ve)), J = l.Flag.take(M, l.Flag.TURBO), ye = Y.set;
        return M = J.flags, (0, a.Some)(new r.Etching(D, K, le, re, Q, se, ye));
      })() : a.None, de = o.Tag.take(o.Tag.MINT, U, 2, ([D, K]) => {
        const le = i.u128.tryIntoU64(D), re = i.u128.tryIntoU32(K);
        return le.isNone() || re.isNone() ? a.None : f.RuneId.new(le.unwrap(), re.unwrap());
      }), ne = o.Tag.take(o.Tag.POINTER, U, 1, ([D]) => i.u128.tryIntoU32(D).andThen((K) => K < C.vout.length ? (0, a.Some)(K) : a.None));
      return ee.map((D) => D.supply.isNone()).unwrapOr(!1) && A.push(b.Flaw.SUPPLY_OVERFLOW), M !== 0n && A.push(b.Flaw.UNRECOGNIZED_FLAG), [...U.keys()].find((D) => D % 2n === 0n) !== void 0 && A.push(b.Flaw.UNRECOGNIZED_EVEN_TAG), A.length !== 0 ? (0, a.Some)(new w.Cenotaph(A, ee.andThen((D) => D.rune), de)) : (0, a.Some)(new _(de, ne, $, ee));
    }
    encipher() {
      const C = [];
      if (this.etching.isSome()) {
        const T = this.etching.unwrap();
        let A = (0, i.u128)(0);
        if (A = l.Flag.set(A, l.Flag.ETCHING), T.terms.isSome() && (A = l.Flag.set(A, l.Flag.TERMS)), T.turbo && (A = l.Flag.set(A, l.Flag.TURBO)), C.push(o.Tag.encode(o.Tag.FLAGS, [A])), C.push(o.Tag.encodeOptionInt(o.Tag.RUNE, T.rune.map(($) => $.value))), C.push(o.Tag.encodeOptionInt(o.Tag.DIVISIBILITY, T.divisibility.map(i.u128))), C.push(o.Tag.encodeOptionInt(o.Tag.SPACERS, T.spacers.map(i.u128))), C.push(o.Tag.encodeOptionInt(o.Tag.SYMBOL, T.symbol.map(($) => (0, i.u128)($.codePointAt(0))))), C.push(o.Tag.encodeOptionInt(o.Tag.PREMINE, T.premine)), T.terms.isSome()) {
          const $ = T.terms.unwrap();
          C.push(o.Tag.encodeOptionInt(o.Tag.AMOUNT, $.amount)), C.push(o.Tag.encodeOptionInt(o.Tag.CAP, $.cap)), C.push(o.Tag.encodeOptionInt(o.Tag.HEIGHT_START, $.height[0])), C.push(o.Tag.encodeOptionInt(o.Tag.HEIGHT_END, $.height[1])), C.push(o.Tag.encodeOptionInt(o.Tag.OFFSET_START, $.offset[0])), C.push(o.Tag.encodeOptionInt(o.Tag.OFFSET_END, $.offset[1]));
        }
      }
      if (this.mint.isSome()) {
        const T = this.mint.unwrap();
        C.push(o.Tag.encode(o.Tag.MINT, [T.block, T.tx].map(i.u128)));
      }
      if (C.push(o.Tag.encodeOptionInt(o.Tag.POINTER, this.pointer.map(i.u128))), this.edicts.length) {
        C.push(i.u128.encodeVarInt((0, i.u128)(o.Tag.BODY)));
        const T = [...this.edicts].sort(($, U) => Number($.id.block - U.id.block || $.id.tx - U.id.tx));
        let A = new f.RuneId((0, i.u64)(0), (0, i.u32)(0));
        for (const $ of T) {
          const [U, M] = A.delta($.id).unwrap();
          C.push(i.u128.encodeVarInt(U)), C.push(i.u128.encodeVarInt(M)), C.push(i.u128.encodeVarInt($.amount)), C.push(i.u128.encodeVarInt((0, i.u128)($.output))), A = $.id;
        }
      }
      const I = [];
      I.push(t.OP_RETURN), I.push(t.MAGIC_NUMBER);
      const S = Buffer.concat(C);
      for (let T = 0; T < S.length; T += t.MAX_SCRIPT_ELEMENT_SIZE)
        I.push(S.subarray(T, T + t.MAX_SCRIPT_ELEMENT_SIZE));
      return h.script.compile(I);
    }
    static payload(C) {
      for (const I of C.vout) {
        const S = h.script.decompile(Buffer.from(I.scriptPubKey.hex, "hex"));
        if (S === null)
          throw new Error("unable to decompile");
        let T = S.next();
        if (T.done || T.value !== t.OP_RETURN || (T = S.next(), T.done || d.Instruction.isBuffer(T.value) || T.value !== t.MAGIC_NUMBER))
          continue;
        let A = [];
        do {
          if (T = S.next(), T.done) {
            if (!T.value)
              return (0, a.Some)(b.Flaw.INVALID_SCRIPT);
            break;
          }
          const $ = T.value;
          if (d.Instruction.isBuffer($))
            A.push($);
          else
            return (0, a.Some)(b.Flaw.OPCODE);
        } while (!0);
        return (0, a.Some)(Buffer.concat(A));
      }
      return a.None;
    }
    static integers(C) {
      const I = [], S = new n.SeekBuffer(C);
      for (; !S.isFinished(); ) {
        const T = i.u128.decodeVarInt(S);
        if (T.isNone())
          return a.None;
        I.push(T.unwrap());
      }
      return (0, a.Some)(I);
    }
  }
  e.Runestone = _;
})(cB);
var M2 = {};
Object.defineProperty(M2, "__esModule", { value: !0 });
M2.SpacedRune = void 0;
const Oge = Ig;
class fB {
  constructor(t, r) {
    this.rune = t, this.spacers = r;
  }
  static fromString(t) {
    let r = "", n = 0;
    for (const o of t)
      if ("A" <= o && o <= "Z")
        r += o;
      else if (o === "." || o === "•") {
        if (r.length === 0)
          throw new Error("leading spacer");
        const i = 1 << r.length - 1;
        if (n & i)
          throw new Error("double spacer");
        n |= i;
      } else
        throw new Error("invalid character");
    if (n >= 1 << r.length - 1)
      throw new Error("trailing spacer");
    return new fB(Oge.Rune.fromString(r), n);
  }
  toString() {
    const t = this.rune.toString();
    let r = 0, n = "";
    for (const o of t)
      n += o, r < t.length - 1 && this.spacers & 1 << r && (n += "•"), r++;
    return n;
  }
}
M2.SpacedRune = fB;
var zK = {}, Lw = {}, D2 = {};
Object.defineProperty(D2, "__esModule", { value: !0 });
D2.RuneLocation = void 0;
var uR;
(function(e) {
  function t(r) {
    return `${r.block}:${r.tx}`;
  }
  e.toString = t;
})(uR || (D2.RuneLocation = uR = {}));
Object.defineProperty(Lw, "__esModule", { value: !0 });
Lw.RuneUpdater = void 0;
const Cb = j2, F8 = Mn, gr = gs, Ya = ms, cR = Ig, Pge = cB, Cge = Fd, lR = M2, $l = D2;
function cT(e) {
  return e && Buffer.from(e, "hex")[0] === F8.OP_RETURN;
}
let Bge = class {
  constructor(t, r, n, o, i) {
    this.reorg = n, this._storage = o, this._rpc = i, this.etchings = [], this.utxoBalances = [], this.spentBalances = [], this._mintCountsByRuneLocation = /* @__PURE__ */ new Map(), this._burnedBalancesByRuneLocation = /* @__PURE__ */ new Map(), this.block = {
      height: r.height,
      hash: r.hash,
      previousblockhash: r.previousblockhash,
      time: r.time
    }, this._minimum = cR.Rune.getMinimumAtHeight(t, (0, gr.u128)(r.height));
  }
  get mintCounts() {
    return [...this._mintCountsByRuneLocation.values()];
  }
  get burnedBalances() {
    return [...this._burnedBalancesByRuneLocation.values()];
  }
  async indexRunes(t, r) {
    const n = Pge.Runestone.decipher(t), o = await this.unallocated(t), i = [...new Array(t.vout.length)].map(() => /* @__PURE__ */ new Map());
    function a(f) {
      const h = $l.RuneLocation.toString(f), g = o.get(h) ?? { runeId: f, amount: 0n };
      return o.set(h, g), g;
    }
    function u(f, h) {
      const g = $l.RuneLocation.toString(h), b = i[f].get(g) ?? { runeId: h, amount: 0n };
      return i[f].set(g, b), b;
    }
    if (n.isSome()) {
      const f = n.unwrap(), h = f.mint;
      if (h.isSome()) {
        const b = h.unwrap(), w = {
          block: Number(b.block),
          tx: Number(b.tx)
        }, E = await this.mint(w, t.txid);
        if (E.isSome()) {
          const _ = E.unwrap(), O = a(w);
          O.amount = gr.u128.checkedAddThrow((0, gr.u128)(O.amount), (0, gr.u128)(_));
        }
      }
      const g = await this.etched(r, t, f);
      if ((0, Cb.isRunestone)(f)) {
        const b = f;
        if (g.isSome()) {
          const w = g.unwrap(), E = a(w.runeId);
          E.amount = gr.u128.checkedAddThrow((0, gr.u128)(E.amount), b.etching.unwrap().premine.unwrapOr((0, gr.u128)(0)));
        }
        for (const { id: w, amount: E, output: _ } of [...b.edicts]) {
          if (_ > t.vout.length)
            throw new Error("Runestone edict output should never exceed transaction output size");
          if (w.block === 0n && w.tx === 0n && g.isNone())
            continue;
          const O = w.block === 0n && w.tx === 0n ? g.unwrap().runeId : { block: Number(w.block), tx: Number(w.tx) }, C = $l.RuneLocation.toString(O), I = o.get(C);
          if (I === void 0)
            continue;
          let S = (T, A) => {
            if (T > 0n) {
              const $ = u(A, O);
              I.amount = gr.u128.checkedSubThrow((0, gr.u128)(I.amount), T), $.amount = gr.u128.checkedAddThrow((0, gr.u128)($.amount), T);
            }
          };
          if (Number(_) === t.vout.length) {
            const T = [...t.vout.entries()].filter(([A, $]) => !cT($.scriptPubKey.hex)).map(([A]) => A);
            if (T.length !== 0)
              if (E === 0n) {
                const A = (0, gr.u128)((0, gr.u128)(I.amount) / (0, gr.u128)(T.length)), $ = (0, gr.u128)(I.amount) % (0, gr.u128)(T.length);
                for (const [U, M] of T.entries())
                  S(U < $ ? gr.u128.checkedAddThrow(A, (0, gr.u128)(1)) : A, M);
              } else
                for (const A of T)
                  S(E < I.amount ? E : (0, gr.u128)(I.amount), A);
          } else
            S(E !== 0n && E < (0, gr.u128)(I.amount) ? E : (0, gr.u128)(I.amount), Number(_));
        }
      }
      if (g.isSome()) {
        const { runeId: b, rune: w } = g.unwrap();
        this.createEtching(t.txid, f, b, w);
      }
    }
    const l = /* @__PURE__ */ new Map();
    function d(f) {
      const h = $l.RuneLocation.toString(f), g = l.get(h) ?? { runeId: f, amount: 0n };
      return l.set(h, g), g;
    }
    if (n.isSome() && !(0, Cb.isRunestone)(n.unwrap()))
      for (const f of o.values()) {
        const h = d(f.runeId);
        h.amount = gr.u128.checkedAddThrow((0, gr.u128)(h.amount), (0, gr.u128)(f.amount));
      }
    else {
      const f = n.map((h) => {
        if (!(0, Cb.isRunestone)(h))
          throw new Error("unreachable");
        return h.pointer;
      }).unwrapOr(Ya.None).map((h) => Number(h)).inspect((h) => {
        if (h < 0 || h >= i.length)
          throw new Error("Pointer is invalid");
      }).orElse(() => {
        const h = [...t.vout.entries()].find(([g, b]) => !cT(b.scriptPubKey.hex));
        return h !== void 0 ? (0, Ya.Some)(h[0]) : Ya.None;
      });
      if (f.isSome()) {
        const h = f.unwrap();
        for (const g of o.values())
          if (g.amount > 0) {
            const b = u(h, g.runeId);
            b.amount = gr.u128.checkedAddThrow((0, gr.u128)(b.amount), (0, gr.u128)(g.amount));
          }
      } else
        for (const [h, g] of o)
          if (g.amount > 0) {
            const b = d(g.runeId);
            l.set(h, {
              runeId: g.runeId,
              amount: gr.u128.checkedAddThrow((0, gr.u128)(b.amount), (0, gr.u128)(g.amount))
            });
          }
    }
    for (const [f, h] of i.entries()) {
      if (h.size === 0)
        continue;
      const g = t.vout[f];
      if (cT(g.scriptPubKey.hex)) {
        for (const [w, E] of h) {
          const _ = d(E.runeId);
          _.amount = gr.u128.checkedAddThrow((0, gr.u128)(_.amount), (0, gr.u128)(E.amount));
        }
        continue;
      }
      const b = new Map(this.etchings.map((w) => [$l.RuneLocation.toString(w.runeId), w]));
      for (const w of h.values()) {
        const E = $l.RuneLocation.toString(w.runeId), _ = b.get(E) ?? await this._storage.getEtching(E);
        if (_ === null)
          throw new Error("Rune should exist at this point");
        this.utxoBalances.push({
          runeId: w.runeId,
          runeTicker: _.runeTicker,
          amount: w.amount,
          scriptPubKey: Buffer.from(g.scriptPubKey.hex),
          txid: t.txid,
          vout: f,
          address: g.scriptPubKey.address
        });
      }
    }
    for (const [f, h] of l)
      this._burnedBalancesByRuneLocation.set(f, h);
  }
  async etched(t, r, n) {
    let o;
    if ((0, Cb.isRunestone)(n)) {
      const a = n;
      if (a.etching.isNone())
        return Ya.None;
      o = a.etching.unwrap().rune;
    } else {
      const a = n;
      if (a.etching.isNone())
        return Ya.None;
      o = a.etching;
    }
    let i;
    if (o.isSome()) {
      if (i = o.unwrap(), i.value < this._minimum.value || i.reserved || this.etchings.find((u) => lR.SpacedRune.fromString(u.runeName).rune.toString() === i.toString()))
        return Ya.None;
      const a = await this._storage.getRuneLocation(i.toString());
      if (a && a.block < this.block.height || !await this.txCommitsToRune(r, i))
        return Ya.None;
    } else
      i = cR.Rune.getReserved((0, gr.u64)(this.block.height), (0, gr.u32)(t));
    return (0, Ya.Some)({
      runeId: {
        block: this.block.height,
        tx: t
      },
      rune: i
    });
  }
  async mint(t, r) {
    var n, o, i, a;
    const u = $l.RuneLocation.toString(t), l = new Map(this.etchings.map((I) => [$l.RuneLocation.toString(I.runeId), I])).get(u) ?? await this._storage.getEtching(u);
    if (l === null || !l.valid || !l.terms)
      return Ya.None;
    const d = l.terms, f = ((n = d.offset) == null ? void 0 : n.start) !== void 0 ? l.runeId.block + Number(d.offset.start) : null, h = ((o = d.height) == null ? void 0 : o.start) !== void 0 ? Number(d.height.start) : null, g = f !== null || h !== null ? Math.max(f ?? -1 / 0, h ?? -1 / 0) : null;
    if (g !== null && this.block.height < g)
      return Ya.None;
    const b = ((i = d.offset) == null ? void 0 : i.end) !== void 0 ? l.runeId.block + Number(d.offset.end) : null, w = ((a = d.height) == null ? void 0 : a.end) !== void 0 ? Number(d.height.end) : null, E = b !== null || w !== null ? Math.max(b ?? -1 / 0, w ?? -1 / 0) : null;
    if (E !== null && this.block.height >= E)
      return Ya.None;
    const _ = d.cap ?? 0n, O = this._mintCountsByRuneLocation.get(u) ?? {
      mint: t,
      count: 0
    };
    if (this._mintCountsByRuneLocation.set(u, O), O.count + await this._storage.getValidMintCount(u, this.block.height - 1) >= _)
      return Ya.None;
    const C = d.amount ?? 0n;
    return O.count++, (0, Ya.Some)(C);
  }
  async unallocated(t) {
    const r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
    for (const o of this.utxoBalances) {
      const i = `${o.txid}:${o.vout}`, a = n.get(i) ?? [];
      a.push(o), n.set(i, a);
    }
    for (const o of t.vin) {
      if ("coinbase" in o)
        continue;
      const i = n.get(`${o.txid}:${o.vout}`) ?? await this._storage.getUtxoBalance(o.txid, o.vout);
      for (const a of i) {
        const u = a.runeId, l = $l.RuneLocation.toString(u), d = r.get(l) ?? { runeId: u, amount: 0n };
        r.set(l, d), d.amount = gr.u128.checkedAddThrow((0, gr.u128)(d.amount), (0, gr.u128)(a.amount)), this.spentBalances.push({
          txid: o.txid,
          vout: o.vout,
          address: a.address,
          scriptPubKey: a.scriptPubKey,
          runeId: a.runeId,
          runeTicker: a.runeTicker,
          amount: a.amount,
          spentTxid: t.txid
        });
      }
    }
    return r;
  }
  async txCommitsToRune(t, r) {
    const n = r.commitment;
    for (const o of t.vin) {
      if ("coinbase" in o)
        continue;
      const i = o.txinwitness.map((f) => Buffer.from(f, "hex")), a = i[i.length - 1], u = i.length >= 2 && a[0] === F8.TAPROOT_ANNEX_PREFIX ? 3 : 2;
      if (u > i.length)
        continue;
      const l = i[i.length - u];
      if (l === void 0)
        continue;
      const d = Cge.script.decompile(l);
      for (const f of d) {
        if (!Buffer.isBuffer(f) || Buffer.compare(f, n) !== 0)
          continue;
        const h = await this._rpc.getrawtransaction({
          txid: o.txid,
          verbose: !0
        });
        if (h.error !== null)
          throw h.error;
        const g = h.result;
        if (g.vout[o.vout].scriptPubKey.type !== F8.TAPROOT_SCRIPT_PUBKEY_TYPE)
          continue;
        const b = await this._rpc.getblock({ blockhash: g.blockhash });
        if (b.error !== null)
          throw b.error;
        const w = b.result.height;
        if (gr.u128.checkedSubThrow((0, gr.u128)(this.block.height), (0, gr.u128)(w)) + 1n >= F8.COMMIT_CONFIRMATIONS)
          return !0;
      }
    }
    return !1;
  }
  createEtching(t, r, n, o) {
    if ((0, Cb.isRunestone)(r)) {
      const { divisibility: i, terms: a, premine: u, spacers: l, symbol: d } = r.etching.unwrap();
      this.etchings.push({
        valid: !0,
        runeTicker: o.toString(),
        runeName: new lR.SpacedRune(o, Number(l.map(Number).unwrapOr(0))).toString(),
        runeId: n,
        txid: t,
        ...i.isSome() ? { divisibility: i.map(Number).unwrap() } : {},
        ...u.isSome() ? { premine: u.unwrap() } : {},
        ...d.isSome() ? { symbol: d.unwrap() } : {},
        ...a.isSome() ? {
          terms: (() => {
            const f = a.unwrap();
            return {
              ...f.amount.isSome() ? { amount: f.amount.unwrap() } : {},
              ...f.cap.isSome() ? { cap: f.cap.unwrap() } : {},
              ...f.height.filter((h) => h.isSome()).length ? {
                height: {
                  ...f.height[0].isSome() ? { start: f.height[0].unwrap() } : {},
                  ...f.height[1].isSome() ? { end: f.height[1].unwrap() } : {}
                }
              } : {},
              ...f.offset.filter((h) => h.isSome()).length ? {
                offset: {
                  ...f.offset[0].isSome() ? { start: f.offset[0].unwrap() } : {},
                  ...f.offset[1].isSome() ? { end: f.offset[1].unwrap() } : {}
                }
              } : {}
            };
          })()
        } : {}
      });
    } else
      this.etchings.push({
        valid: !1,
        runeId: n,
        txid: t,
        runeTicker: o.toString(),
        runeName: o.toString()
      });
  }
};
Lw.RuneUpdater = Bge;
(function(e) {
  var t = Rt && Rt.__createBinding || (Object.create ? function(l, d, f, h) {
    h === void 0 && (h = f);
    var g = Object.getOwnPropertyDescriptor(d, f);
    (!g || ("get" in g ? !d.__esModule : g.writable || g.configurable)) && (g = { enumerable: !0, get: function() {
      return d[f];
    } }), Object.defineProperty(l, h, g);
  } : function(l, d, f, h) {
    h === void 0 && (h = f), l[h] = d[f];
  }), r = Rt && Rt.__exportStar || function(l, d) {
    for (var f in l) f !== "default" && !Object.prototype.hasOwnProperty.call(d, f) && t(d, l, f);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.RunestoneIndexer = e.RuneUpdater = void 0;
  const n = T0, o = Lw, i = gs;
  r(D2, e);
  var a = Lw;
  Object.defineProperty(e, "RuneUpdater", { enumerable: !0, get: function() {
    return a.RuneUpdater;
  } });
  class u {
    constructor(d) {
      this._started = !1, this._updateInProgress = !1, this._rpc = d.bitcoinRpcClient, this._storage = d.storage, this._network = d.network;
    }
    async start() {
      this._started || (await this._storage.connect(), this._started = !0, this._network === n.Network.MAINNET && this._storage.seedEtchings([
        {
          runeTicker: "UNCOMMONGOODS",
          runeName: "UNCOMMON•GOODS",
          runeId: { block: 1, tx: 0 },
          txid: "0000000000000000000000000000000000000000000000000000000000000000",
          valid: !0,
          symbol: "⧉",
          terms: { amount: 1n, cap: i.u128.MAX, height: { start: 840000n, end: 1050000n } }
        }
      ]));
    }
    async stop() {
      this._started && (await this._storage.disconnect(), this._started = !1);
    }
    async updateRuneUtxoBalances() {
      if (!this._started)
        throw new Error("Runestone indexer is not started");
      if (!this._updateInProgress) {
        this._updateInProgress = !0;
        try {
          await this.updateRuneUtxoBalancesImpl();
        } finally {
          this._updateInProgress = !1;
        }
      }
    }
    async updateRuneUtxoBalancesImpl() {
      const d = await this._storage.getCurrentBlock();
      if (d) {
        const g = [];
        let b = d.height, w = (await this._rpc.getblockhash({ height: b })).result, E = d.hash;
        for (; E !== w; )
          w && g.push(w), b--, w = (await this._rpc.getblockhash({ height: b })).result, E = await this._storage.getBlockhash(b);
        g.reverse();
        for (const _ of g) {
          const O = await this._rpc.getblock({ blockhash: _, verbosity: 2 });
          if (O.error !== null)
            throw O.error;
          const C = O.result, I = new o.RuneUpdater(this._network, C, !0, this._storage, this._rpc);
          for (const [S, T] of C.tx.entries())
            await I.indexRunes(T, S);
          await this._storage.saveBlockIndex(I);
        }
      }
      let f = Math.max(n.Network.getFirstRuneHeight(this._network), d ? d.height + 1 : 0), h = (await this._rpc.getblockhash({ height: f })).result;
      for (; h !== null; ) {
        const g = await this._rpc.getblock({ blockhash: h, verbosity: 2 });
        if (g.error !== null)
          throw g.error;
        const b = g.result, w = new o.RuneUpdater(this._network, b, !1, this._storage, this._rpc);
        for (const [E, _] of b.tx.entries())
          await w.indexRunes(_, E);
        await this._storage.saveBlockIndex(w), f++, h = (await this._rpc.getblockhash({ height: f })).result;
      }
    }
  }
  e.RunestoneIndexer = u;
})(zK);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.tryDecodeRunestone = e.isRunestone = e.encodeRunestone = e.Network = e.RunestoneIndexer = e.RuneUpdater = e.RuneLocation = void 0;
  const t = j2, r = Mn, n = H2, o = kg, i = gs, a = ms, u = Sg, l = cB, d = M2;
  var f = zK;
  Object.defineProperty(e, "RuneLocation", { enumerable: !0, get: function() {
    return f.RuneLocation;
  } }), Object.defineProperty(e, "RuneUpdater", { enumerable: !0, get: function() {
    return f.RuneUpdater;
  } }), Object.defineProperty(e, "RunestoneIndexer", { enumerable: !0, get: function() {
    return f.RunestoneIndexer;
  } });
  var h = T0;
  Object.defineProperty(e, "Network", { enumerable: !0, get: function() {
    return h.Network;
  } });
  function g(S) {
    switch (S) {
      case o.Flaw.EDICT_OUTPUT:
        return "edict_output";
      case o.Flaw.EDICT_RUNE_ID:
        return "edict_rune_id";
      case o.Flaw.INVALID_SCRIPT:
        return "invalid_script";
      case o.Flaw.OPCODE:
        return "opcode";
      case o.Flaw.SUPPLY_OVERFLOW:
        return "supply_overflow";
      case o.Flaw.TRAILING_INTEGERS:
        return "trailing_integers";
      case o.Flaw.TRUNCATED_FIELD:
        return "truncated_field";
      case o.Flaw.UNRECOGNIZED_EVEN_TAG:
        return "unrecognized_even_tag";
      case o.Flaw.UNRECOGNIZED_FLAG:
        return "unrecognized_flag";
      case o.Flaw.VARINT:
        return "varint";
    }
  }
  const b = (S) => {
    const T = BigInt(S);
    if (T < 0n || T > i.u8.MAX)
      throw Error("u8 overflow");
    return (0, i.u8)(T);
  }, w = (S) => {
    const T = BigInt(S);
    if (T < 0n || T > i.u32.MAX)
      throw Error("u32 overflow");
    return (0, i.u32)(T);
  }, E = (S) => {
    const T = BigInt(S);
    if (T < 0n || T > i.u64.MAX)
      throw Error("u64 overflow");
    return (0, i.u64)(T);
  }, _ = (S) => {
    const T = BigInt(S);
    if (T < 0n || T > i.u128.MAX)
      throw Error("u128 overflow");
    return (0, i.u128)(T);
  };
  function O(S) {
    const T = S.mint ? (0, a.Some)(new u.RuneId(E(S.mint.block), w(S.mint.tx))) : a.None, A = S.pointer !== void 0 ? (0, a.Some)(S.pointer).map(w) : a.None, $ = (S.edicts ?? []).map((Y) => ({
      id: new u.RuneId(E(Y.id.block), w(Y.id.tx)),
      amount: _(Y.amount),
      output: w(Y.output)
    }));
    let U = a.None, M;
    if (S.etching) {
      const Y = S.etching, L = Y.runeName ? d.SpacedRune.fromString(Y.runeName) : void 0, ee = (L == null ? void 0 : L.rune) !== void 0 ? (0, a.Some)(L.rune) : a.None;
      if (Y.symbol && !(Y.symbol.length === 1 || Y.symbol.length === 2 && Y.symbol.codePointAt(0) >= 65536))
        throw Error("Symbol must be one code point");
      const de = Y.divisibility !== void 0 ? (0, a.Some)(Y.divisibility).map(b) : a.None, ne = Y.premine !== void 0 ? (0, a.Some)(Y.premine).map(_) : a.None, D = (L == null ? void 0 : L.spacers) !== void 0 && L.spacers !== 0 ? (0, a.Some)(w(L.spacers)) : a.None, K = Y.symbol ? (0, a.Some)(Y.symbol) : a.None;
      if (de.isSome() && de.unwrap() > r.MAX_DIVISIBILITY)
        throw Error(`Divisibility is greater than protocol max ${r.MAX_DIVISIBILITY}`);
      let le = a.None;
      if (Y.terms) {
        const G = Y.terms, q = G.amount !== void 0 ? (0, a.Some)(G.amount).map(_) : a.None, Q = G.cap !== void 0 ? (0, a.Some)(G.cap).map(_) : a.None, se = G.height ? [
          G.height.start !== void 0 ? (0, a.Some)(G.height.start).map(E) : a.None,
          G.height.end !== void 0 ? (0, a.Some)(G.height.end).map(E) : a.None
        ] : [a.None, a.None], J = G.offset ? [
          G.offset.start !== void 0 ? (0, a.Some)(G.offset.start).map(E) : a.None,
          G.offset.end !== void 0 ? (0, a.Some)(G.offset.end).map(E) : a.None
        ] : [a.None, a.None];
        if (q.isSome() && Q.isSome() && q.unwrap() * Q.unwrap() > i.u128.MAX)
          throw Error("Terms overflow with amount times cap");
        le = (0, a.Some)({ amount: q, cap: Q, height: se, offset: J });
      }
      const re = Y.turbo ?? !1;
      U = (0, a.Some)(new n.Etching(de, ee, D, K, le, ne, re)), M = ee.isSome() ? ee.unwrap().commitment : void 0;
    }
    return {
      encodedRunestone: new l.Runestone(T, A, $, U).encipher(),
      etchingCommitment: M
    };
  }
  e.encodeRunestone = O;
  function C(S) {
    return !("flaws" in S);
  }
  e.isRunestone = C;
  function I(S) {
    const T = l.Runestone.decipher(S);
    if (T.isNone())
      return null;
    const A = T.unwrap();
    if ((0, t.isRunestone)(A)) {
      const $ = A, U = () => $.etching.unwrap(), M = () => U().terms.unwrap();
      return {
        ...$.etching.isSome() ? {
          etching: {
            ...U().divisibility.isSome() ? { divisibility: U().divisibility.map(Number).unwrap() } : {},
            ...U().premine.isSome() ? { premine: U().premine.unwrap() } : {},
            ...U().rune.isSome() ? {
              runeName: new d.SpacedRune(U().rune.unwrap(), U().spacers.map(Number).unwrapOr(0)).toString()
            } : {},
            ...U().symbol.isSome() ? { symbol: U().symbol.unwrap() } : {},
            ...U().terms.isSome() ? {
              terms: {
                ...M().amount.isSome() ? { amount: M().amount.unwrap() } : {},
                ...M().cap.isSome() ? { cap: M().cap.unwrap() } : {},
                ...M().height.find((Y) => Y.isSome()) ? {
                  height: {
                    ...M().height[0].isSome() ? { start: M().height[0].unwrap() } : {},
                    ...M().height[1].isSome() ? { end: M().height[1].unwrap() } : {}
                  }
                } : {},
                ...M().offset.find((Y) => Y.isSome()) ? {
                  offset: {
                    ...M().offset[0].isSome() ? { start: M().offset[0].unwrap() } : {},
                    ...M().offset[1].isSome() ? { end: M().offset[1].unwrap() } : {}
                  }
                } : {}
              }
            } : {},
            turbo: U().turbo
          }
        } : {},
        ...$.mint.isSome() ? {
          mint: {
            block: $.mint.unwrap().block,
            tx: Number($.mint.unwrap().tx)
          }
        } : {},
        ...$.pointer.isSome() ? { pointer: Number($.pointer.unwrap()) } : {},
        ...$.edicts.length ? {
          edicts: $.edicts.map((Y) => ({
            id: {
              block: Y.id.block,
              tx: Number(Y.id.tx)
            },
            amount: Y.amount,
            output: Number(Y.output)
          }))
        } : {}
      };
    } else {
      const $ = A;
      return {
        flaws: $.flaws.map(g),
        ...$.etching.isSome() ? { etching: $.etching.unwrap().toString() } : {},
        ...$.mint.isSome() ? { mint: { block: $.mint.unwrap().block, tx: Number($.mint.unwrap().tx) } } : {}
      };
    }
  }
  e.tryDecodeRunestone = I;
})(bge);
var F3 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
F3.exports;
(function(e, t) {
  (function() {
    var r, n = "4.17.21", o = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", u = "Invalid `variable` option passed into `_.template`", l = "__lodash_hash_undefined__", d = 500, f = "__lodash_placeholder__", h = 1, g = 2, b = 4, w = 1, E = 2, _ = 1, O = 2, C = 4, I = 8, S = 16, T = 32, A = 64, $ = 128, U = 256, M = 512, Y = 30, L = "...", ee = 800, de = 16, ne = 1, D = 2, K = 3, le = 1 / 0, re = 9007199254740991, G = 17976931348623157e292, q = NaN, Q = 4294967295, se = Q - 1, J = Q >>> 1, ye = [
      ["ary", $],
      ["bind", _],
      ["bindKey", O],
      ["curry", I],
      ["curryRight", S],
      ["flip", M],
      ["partial", T],
      ["partialRight", A],
      ["rearg", U]
    ], ve = "[object Arguments]", Ee = "[object Array]", _e = "[object AsyncFunction]", we = "[object Boolean]", be = "[object Date]", Ge = "[object DOMException]", Le = "[object Error]", Ne = "[object Function]", Ve = "[object GeneratorFunction]", ge = "[object Map]", Te = "[object Number]", Oe = "[object Null]", He = "[object Object]", mt = "[object Promise]", rt = "[object Proxy]", Pt = "[object RegExp]", _t = "[object Set]", yt = "[object String]", Zt = "[object Symbol]", yn = "[object Undefined]", kt = "[object WeakMap]", qr = "[object WeakSet]", m = "[object ArrayBuffer]", v = "[object DataView]", k = "[object Float32Array]", H = "[object Float64Array]", X = "[object Int8Array]", oe = "[object Int16Array]", me = "[object Int32Array]", nt = "[object Uint8Array]", Ct = "[object Uint8ClampedArray]", At = "[object Uint16Array]", vt = "[object Uint32Array]", Ht = /\b__p \+= '';/g, jc = /\b(__p \+=) '' \+/g, Lc = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Gs = /&(?:amp|lt|gt|quot|#39);/g, Hr = /[&<>"']/g, fo = RegExp(Gs.source), Ua = RegExp(Hr.source), j = /<%-([\s\S]+?)%>/g, N = /<%([\s\S]+?)%>/g, z = /<%=([\s\S]+?)%>/g, W = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ie = /^\w*$/, he = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ae = /[\\^$.*+?()[\]{}|]/g, Ie = RegExp(Ae.source), Me = /^\s+/, Fe = /\s/, We = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, it = /\{\n\/\* \[wrapped with (.+)\] \*/, ct = /,? & /, ar = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, sr = /[()=,{}\[\]\/\s]/, qn = /\\(\\)?/g, ci = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Io = /\w*$/, li = /^[-+]0x[0-9a-f]+$/i, Ra = /^0b[01]+$/i, Ws = /^\[object .+?Constructor\]$/, Vi = /^0o[0-7]+$/i, i6 = /^(?:0|[1-9]\d*)$/, a6 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Hc = /($^)/, s6 = /['\n\r\u2028\u2029\\]/g, Fc = "\\ud800-\\udfff", u6 = "\\u0300-\\u036f", c6 = "\\ufe20-\\ufe2f", l6 = "\\u20d0-\\u20ff", Yg = u6 + c6 + l6, Jg = "\\u2700-\\u27bf", Qg = "a-z\\xdf-\\xf6\\xf8-\\xff", f6 = "\\xac\\xb1\\xd7\\xf7", d6 = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", h6 = "\\u2000-\\u206f", p6 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", em = "A-Z\\xc0-\\xd6\\xd8-\\xde", tm = "\\ufe0e\\ufe0f", rm = f6 + d6 + h6 + p6, ah = "['’]", g6 = "[" + Fc + "]", nm = "[" + rm + "]", Mc = "[" + Yg + "]", om = "\\d+", m6 = "[" + Jg + "]", im = "[" + Qg + "]", am = "[^" + Fc + rm + om + Jg + Qg + em + "]", sh = "\\ud83c[\\udffb-\\udfff]", y6 = "(?:" + Mc + "|" + sh + ")", sm = "[^" + Fc + "]", uh = "(?:\\ud83c[\\udde6-\\uddff]){2}", ch = "[\\ud800-\\udbff][\\udc00-\\udfff]", za = "[" + em + "]", um = "\\u200d", cm = "(?:" + im + "|" + am + ")", b6 = "(?:" + za + "|" + am + ")", lm = "(?:" + ah + "(?:d|ll|m|re|s|t|ve))?", fm = "(?:" + ah + "(?:D|LL|M|RE|S|T|VE))?", dm = y6 + "?", hm = "[" + tm + "]?", w6 = "(?:" + um + "(?:" + [sm, uh, ch].join("|") + ")" + hm + dm + ")*", v6 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", E6 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", pm = hm + dm + w6, _6 = "(?:" + [m6, uh, ch].join("|") + ")" + pm, A6 = "(?:" + [sm + Mc + "?", Mc, uh, ch, g6].join("|") + ")", x6 = RegExp(ah, "g"), k6 = RegExp(Mc, "g"), lh = RegExp(sh + "(?=" + sh + ")|" + A6 + pm, "g"), S6 = RegExp([
      za + "?" + im + "+" + lm + "(?=" + [nm, za, "$"].join("|") + ")",
      b6 + "+" + fm + "(?=" + [nm, za + cm, "$"].join("|") + ")",
      za + "?" + cm + "+" + lm,
      za + "+" + fm,
      E6,
      v6,
      om,
      _6
    ].join("|"), "g"), T6 = RegExp("[" + um + Fc + Yg + tm + "]"), I6 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, O6 = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], P6 = -1, Ft = {};
    Ft[k] = Ft[H] = Ft[X] = Ft[oe] = Ft[me] = Ft[nt] = Ft[Ct] = Ft[At] = Ft[vt] = !0, Ft[ve] = Ft[Ee] = Ft[m] = Ft[we] = Ft[v] = Ft[be] = Ft[Le] = Ft[Ne] = Ft[ge] = Ft[Te] = Ft[He] = Ft[Pt] = Ft[_t] = Ft[yt] = Ft[kt] = !1;
    var Ut = {};
    Ut[ve] = Ut[Ee] = Ut[m] = Ut[v] = Ut[we] = Ut[be] = Ut[k] = Ut[H] = Ut[X] = Ut[oe] = Ut[me] = Ut[ge] = Ut[Te] = Ut[He] = Ut[Pt] = Ut[_t] = Ut[yt] = Ut[Zt] = Ut[nt] = Ut[Ct] = Ut[At] = Ut[vt] = !0, Ut[Le] = Ut[Ne] = Ut[kt] = !1;
    var C6 = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, B6 = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, N6 = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, $6 = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, U6 = parseFloat, R6 = parseInt, gm = typeof Rt == "object" && Rt && Rt.Object === Object && Rt, z6 = typeof self == "object" && self && self.Object === Object && self, zr = gm || z6 || Function("return this")(), fh = t && !t.nodeType && t, Gi = fh && !0 && e && !e.nodeType && e, mm = Gi && Gi.exports === fh, dh = mm && gm.process, On = function() {
      try {
        var V = Gi && Gi.require && Gi.require("util").types;
        return V || dh && dh.binding && dh.binding("util");
      } catch {
      }
    }(), ym = On && On.isArrayBuffer, bm = On && On.isDate, wm = On && On.isMap, vm = On && On.isRegExp, Em = On && On.isSet, _m = On && On.isTypedArray;
    function bn(V, ue, te) {
      switch (te.length) {
        case 0:
          return V.call(ue);
        case 1:
          return V.call(ue, te[0]);
        case 2:
          return V.call(ue, te[0], te[1]);
        case 3:
          return V.call(ue, te[0], te[1], te[2]);
      }
      return V.apply(ue, te);
    }
    function j6(V, ue, te, Pe) {
      for (var Ze = -1, Et = V == null ? 0 : V.length; ++Ze < Et; ) {
        var Ir = V[Ze];
        ue(Pe, Ir, te(Ir), V);
      }
      return Pe;
    }
    function Pn(V, ue) {
      for (var te = -1, Pe = V == null ? 0 : V.length; ++te < Pe && ue(V[te], te, V) !== !1; )
        ;
      return V;
    }
    function L6(V, ue) {
      for (var te = V == null ? 0 : V.length; te-- && ue(V[te], te, V) !== !1; )
        ;
      return V;
    }
    function Am(V, ue) {
      for (var te = -1, Pe = V == null ? 0 : V.length; ++te < Pe; )
        if (!ue(V[te], te, V))
          return !1;
      return !0;
    }
    function fi(V, ue) {
      for (var te = -1, Pe = V == null ? 0 : V.length, Ze = 0, Et = []; ++te < Pe; ) {
        var Ir = V[te];
        ue(Ir, te, V) && (Et[Ze++] = Ir);
      }
      return Et;
    }
    function Dc(V, ue) {
      var te = V == null ? 0 : V.length;
      return !!te && ja(V, ue, 0) > -1;
    }
    function hh(V, ue, te) {
      for (var Pe = -1, Ze = V == null ? 0 : V.length; ++Pe < Ze; )
        if (te(ue, V[Pe]))
          return !0;
      return !1;
    }
    function Kt(V, ue) {
      for (var te = -1, Pe = V == null ? 0 : V.length, Ze = Array(Pe); ++te < Pe; )
        Ze[te] = ue(V[te], te, V);
      return Ze;
    }
    function di(V, ue) {
      for (var te = -1, Pe = ue.length, Ze = V.length; ++te < Pe; )
        V[Ze + te] = ue[te];
      return V;
    }
    function ph(V, ue, te, Pe) {
      var Ze = -1, Et = V == null ? 0 : V.length;
      for (Pe && Et && (te = V[++Ze]); ++Ze < Et; )
        te = ue(te, V[Ze], Ze, V);
      return te;
    }
    function H6(V, ue, te, Pe) {
      var Ze = V == null ? 0 : V.length;
      for (Pe && Ze && (te = V[--Ze]); Ze--; )
        te = ue(te, V[Ze], Ze, V);
      return te;
    }
    function gh(V, ue) {
      for (var te = -1, Pe = V == null ? 0 : V.length; ++te < Pe; )
        if (ue(V[te], te, V))
          return !0;
      return !1;
    }
    var F6 = mh("length");
    function M6(V) {
      return V.split("");
    }
    function D6(V) {
      return V.match(ar) || [];
    }
    function xm(V, ue, te) {
      var Pe;
      return te(V, function(Ze, Et, Ir) {
        if (ue(Ze, Et, Ir))
          return Pe = Et, !1;
      }), Pe;
    }
    function Kc(V, ue, te, Pe) {
      for (var Ze = V.length, Et = te + (Pe ? 1 : -1); Pe ? Et-- : ++Et < Ze; )
        if (ue(V[Et], Et, V))
          return Et;
      return -1;
    }
    function ja(V, ue, te) {
      return ue === ue ? t7(V, ue, te) : Kc(V, km, te);
    }
    function K6(V, ue, te, Pe) {
      for (var Ze = te - 1, Et = V.length; ++Ze < Et; )
        if (Pe(V[Ze], ue))
          return Ze;
      return -1;
    }
    function km(V) {
      return V !== V;
    }
    function Sm(V, ue) {
      var te = V == null ? 0 : V.length;
      return te ? bh(V, ue) / te : q;
    }
    function mh(V) {
      return function(ue) {
        return ue == null ? r : ue[V];
      };
    }
    function yh(V) {
      return function(ue) {
        return V == null ? r : V[ue];
      };
    }
    function Tm(V, ue, te, Pe, Ze) {
      return Ze(V, function(Et, Ir, Bt) {
        te = Pe ? (Pe = !1, Et) : ue(te, Et, Ir, Bt);
      }), te;
    }
    function q6(V, ue) {
      var te = V.length;
      for (V.sort(ue); te--; )
        V[te] = V[te].value;
      return V;
    }
    function bh(V, ue) {
      for (var te, Pe = -1, Ze = V.length; ++Pe < Ze; ) {
        var Et = ue(V[Pe]);
        Et !== r && (te = te === r ? Et : te + Et);
      }
      return te;
    }
    function wh(V, ue) {
      for (var te = -1, Pe = Array(V); ++te < V; )
        Pe[te] = ue(te);
      return Pe;
    }
    function V6(V, ue) {
      return Kt(ue, function(te) {
        return [te, V[te]];
      });
    }
    function Im(V) {
      return V && V.slice(0, Bm(V) + 1).replace(Me, "");
    }
    function wn(V) {
      return function(ue) {
        return V(ue);
      };
    }
    function vh(V, ue) {
      return Kt(ue, function(te) {
        return V[te];
      });
    }
    function Zs(V, ue) {
      return V.has(ue);
    }
    function Om(V, ue) {
      for (var te = -1, Pe = V.length; ++te < Pe && ja(ue, V[te], 0) > -1; )
        ;
      return te;
    }
    function Pm(V, ue) {
      for (var te = V.length; te-- && ja(ue, V[te], 0) > -1; )
        ;
      return te;
    }
    function G6(V, ue) {
      for (var te = V.length, Pe = 0; te--; )
        V[te] === ue && ++Pe;
      return Pe;
    }
    var W6 = yh(C6), Z6 = yh(B6);
    function X6(V) {
      return "\\" + $6[V];
    }
    function Y6(V, ue) {
      return V == null ? r : V[ue];
    }
    function La(V) {
      return T6.test(V);
    }
    function J6(V) {
      return I6.test(V);
    }
    function Q6(V) {
      for (var ue, te = []; !(ue = V.next()).done; )
        te.push(ue.value);
      return te;
    }
    function Eh(V) {
      var ue = -1, te = Array(V.size);
      return V.forEach(function(Pe, Ze) {
        te[++ue] = [Ze, Pe];
      }), te;
    }
    function Cm(V, ue) {
      return function(te) {
        return V(ue(te));
      };
    }
    function hi(V, ue) {
      for (var te = -1, Pe = V.length, Ze = 0, Et = []; ++te < Pe; ) {
        var Ir = V[te];
        (Ir === ue || Ir === f) && (V[te] = f, Et[Ze++] = te);
      }
      return Et;
    }
    function qc(V) {
      var ue = -1, te = Array(V.size);
      return V.forEach(function(Pe) {
        te[++ue] = Pe;
      }), te;
    }
    function e7(V) {
      var ue = -1, te = Array(V.size);
      return V.forEach(function(Pe) {
        te[++ue] = [Pe, Pe];
      }), te;
    }
    function t7(V, ue, te) {
      for (var Pe = te - 1, Ze = V.length; ++Pe < Ze; )
        if (V[Pe] === ue)
          return Pe;
      return -1;
    }
    function r7(V, ue, te) {
      for (var Pe = te + 1; Pe--; )
        if (V[Pe] === ue)
          return Pe;
      return Pe;
    }
    function Ha(V) {
      return La(V) ? o7(V) : F6(V);
    }
    function Vn(V) {
      return La(V) ? i7(V) : M6(V);
    }
    function Bm(V) {
      for (var ue = V.length; ue-- && Fe.test(V.charAt(ue)); )
        ;
      return ue;
    }
    var n7 = yh(N6);
    function o7(V) {
      for (var ue = lh.lastIndex = 0; lh.test(V); )
        ++ue;
      return ue;
    }
    function i7(V) {
      return V.match(lh) || [];
    }
    function a7(V) {
      return V.match(S6) || [];
    }
    var s7 = function V(ue) {
      ue = ue == null ? zr : Fa.defaults(zr.Object(), ue, Fa.pick(zr, O6));
      var te = ue.Array, Pe = ue.Date, Ze = ue.Error, Et = ue.Function, Ir = ue.Math, Bt = ue.Object, _h = ue.RegExp, u7 = ue.String, Cn = ue.TypeError, Vc = te.prototype, c7 = Et.prototype, Ma = Bt.prototype, Gc = ue["__core-js_shared__"], Wc = c7.toString, St = Ma.hasOwnProperty, l7 = 0, Nm = function() {
        var s = /[^.]+$/.exec(Gc && Gc.keys && Gc.keys.IE_PROTO || "");
        return s ? "Symbol(src)_1." + s : "";
      }(), Zc = Ma.toString, f7 = Wc.call(Bt), d7 = zr._, h7 = _h(
        "^" + Wc.call(St).replace(Ae, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Xc = mm ? ue.Buffer : r, pi = ue.Symbol, Yc = ue.Uint8Array, $m = Xc ? Xc.allocUnsafe : r, Jc = Cm(Bt.getPrototypeOf, Bt), Um = Bt.create, Rm = Ma.propertyIsEnumerable, Qc = Vc.splice, zm = pi ? pi.isConcatSpreadable : r, Xs = pi ? pi.iterator : r, Wi = pi ? pi.toStringTag : r, el = function() {
        try {
          var s = Qi(Bt, "defineProperty");
          return s({}, "", {}), s;
        } catch {
        }
      }(), p7 = ue.clearTimeout !== zr.clearTimeout && ue.clearTimeout, g7 = Pe && Pe.now !== zr.Date.now && Pe.now, m7 = ue.setTimeout !== zr.setTimeout && ue.setTimeout, tl = Ir.ceil, rl = Ir.floor, Ah = Bt.getOwnPropertySymbols, y7 = Xc ? Xc.isBuffer : r, jm = ue.isFinite, b7 = Vc.join, w7 = Cm(Bt.keys, Bt), Or = Ir.max, Fr = Ir.min, v7 = Pe.now, E7 = ue.parseInt, Lm = Ir.random, _7 = Vc.reverse, xh = Qi(ue, "DataView"), Ys = Qi(ue, "Map"), kh = Qi(ue, "Promise"), Da = Qi(ue, "Set"), Js = Qi(ue, "WeakMap"), Qs = Qi(Bt, "create"), nl = Js && new Js(), Ka = {}, A7 = ea(xh), x7 = ea(Ys), k7 = ea(kh), S7 = ea(Da), T7 = ea(Js), ol = pi ? pi.prototype : r, eu = ol ? ol.valueOf : r, Hm = ol ? ol.toString : r;
      function P(s) {
        if (Qt(s) && !Xe(s) && !(s instanceof at)) {
          if (s instanceof Bn)
            return s;
          if (St.call(s, "__wrapped__"))
            return Fy(s);
        }
        return new Bn(s);
      }
      var qa = /* @__PURE__ */ function() {
        function s() {
        }
        return function(c) {
          if (!Xt(c))
            return {};
          if (Um)
            return Um(c);
          s.prototype = c;
          var p = new s();
          return s.prototype = r, p;
        };
      }();
      function il() {
      }
      function Bn(s, c) {
        this.__wrapped__ = s, this.__actions__ = [], this.__chain__ = !!c, this.__index__ = 0, this.__values__ = r;
      }
      P.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: j,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: N,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: z,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: P
        }
      }, P.prototype = il.prototype, P.prototype.constructor = P, Bn.prototype = qa(il.prototype), Bn.prototype.constructor = Bn;
      function at(s) {
        this.__wrapped__ = s, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Q, this.__views__ = [];
      }
      function I7() {
        var s = new at(this.__wrapped__);
        return s.__actions__ = Jr(this.__actions__), s.__dir__ = this.__dir__, s.__filtered__ = this.__filtered__, s.__iteratees__ = Jr(this.__iteratees__), s.__takeCount__ = this.__takeCount__, s.__views__ = Jr(this.__views__), s;
      }
      function O7() {
        if (this.__filtered__) {
          var s = new at(this);
          s.__dir__ = -1, s.__filtered__ = !0;
        } else
          s = this.clone(), s.__dir__ *= -1;
        return s;
      }
      function P7() {
        var s = this.__wrapped__.value(), c = this.__dir__, p = Xe(s), y = c < 0, x = p ? s.length : 0, B = M_(0, x, this.__views__), R = B.start, F = B.end, Z = F - R, ce = y ? F : R - 1, fe = this.__iteratees__, pe = fe.length, Se = 0, $e = Fr(Z, this.__takeCount__);
        if (!p || !y && x == Z && $e == Z)
          return ly(s, this.__actions__);
        var Ke = [];
        e:
          for (; Z-- && Se < $e; ) {
            ce += c;
            for (var et = -1, qe = s[ce]; ++et < pe; ) {
              var ot = fe[et], lt = ot.iteratee, _n = ot.type, Wr = lt(qe);
              if (_n == D)
                qe = Wr;
              else if (!Wr) {
                if (_n == ne)
                  continue e;
                break e;
              }
            }
            Ke[Se++] = qe;
          }
        return Ke;
      }
      at.prototype = qa(il.prototype), at.prototype.constructor = at;
      function Zi(s) {
        var c = -1, p = s == null ? 0 : s.length;
        for (this.clear(); ++c < p; ) {
          var y = s[c];
          this.set(y[0], y[1]);
        }
      }
      function C7() {
        this.__data__ = Qs ? Qs(null) : {}, this.size = 0;
      }
      function B7(s) {
        var c = this.has(s) && delete this.__data__[s];
        return this.size -= c ? 1 : 0, c;
      }
      function N7(s) {
        var c = this.__data__;
        if (Qs) {
          var p = c[s];
          return p === l ? r : p;
        }
        return St.call(c, s) ? c[s] : r;
      }
      function $7(s) {
        var c = this.__data__;
        return Qs ? c[s] !== r : St.call(c, s);
      }
      function U7(s, c) {
        var p = this.__data__;
        return this.size += this.has(s) ? 0 : 1, p[s] = Qs && c === r ? l : c, this;
      }
      Zi.prototype.clear = C7, Zi.prototype.delete = B7, Zi.prototype.get = N7, Zi.prototype.has = $7, Zi.prototype.set = U7;
      function Oo(s) {
        var c = -1, p = s == null ? 0 : s.length;
        for (this.clear(); ++c < p; ) {
          var y = s[c];
          this.set(y[0], y[1]);
        }
      }
      function R7() {
        this.__data__ = [], this.size = 0;
      }
      function z7(s) {
        var c = this.__data__, p = al(c, s);
        if (p < 0)
          return !1;
        var y = c.length - 1;
        return p == y ? c.pop() : Qc.call(c, p, 1), --this.size, !0;
      }
      function j7(s) {
        var c = this.__data__, p = al(c, s);
        return p < 0 ? r : c[p][1];
      }
      function L7(s) {
        return al(this.__data__, s) > -1;
      }
      function H7(s, c) {
        var p = this.__data__, y = al(p, s);
        return y < 0 ? (++this.size, p.push([s, c])) : p[y][1] = c, this;
      }
      Oo.prototype.clear = R7, Oo.prototype.delete = z7, Oo.prototype.get = j7, Oo.prototype.has = L7, Oo.prototype.set = H7;
      function Po(s) {
        var c = -1, p = s == null ? 0 : s.length;
        for (this.clear(); ++c < p; ) {
          var y = s[c];
          this.set(y[0], y[1]);
        }
      }
      function F7() {
        this.size = 0, this.__data__ = {
          hash: new Zi(),
          map: new (Ys || Oo)(),
          string: new Zi()
        };
      }
      function M7(s) {
        var c = bl(this, s).delete(s);
        return this.size -= c ? 1 : 0, c;
      }
      function D7(s) {
        return bl(this, s).get(s);
      }
      function K7(s) {
        return bl(this, s).has(s);
      }
      function q7(s, c) {
        var p = bl(this, s), y = p.size;
        return p.set(s, c), this.size += p.size == y ? 0 : 1, this;
      }
      Po.prototype.clear = F7, Po.prototype.delete = M7, Po.prototype.get = D7, Po.prototype.has = K7, Po.prototype.set = q7;
      function Xi(s) {
        var c = -1, p = s == null ? 0 : s.length;
        for (this.__data__ = new Po(); ++c < p; )
          this.add(s[c]);
      }
      function V7(s) {
        return this.__data__.set(s, l), this;
      }
      function G7(s) {
        return this.__data__.has(s);
      }
      Xi.prototype.add = Xi.prototype.push = V7, Xi.prototype.has = G7;
      function Gn(s) {
        var c = this.__data__ = new Oo(s);
        this.size = c.size;
      }
      function W7() {
        this.__data__ = new Oo(), this.size = 0;
      }
      function Z7(s) {
        var c = this.__data__, p = c.delete(s);
        return this.size = c.size, p;
      }
      function X7(s) {
        return this.__data__.get(s);
      }
      function Y7(s) {
        return this.__data__.has(s);
      }
      function J7(s, c) {
        var p = this.__data__;
        if (p instanceof Oo) {
          var y = p.__data__;
          if (!Ys || y.length < o - 1)
            return y.push([s, c]), this.size = ++p.size, this;
          p = this.__data__ = new Po(y);
        }
        return p.set(s, c), this.size = p.size, this;
      }
      Gn.prototype.clear = W7, Gn.prototype.delete = Z7, Gn.prototype.get = X7, Gn.prototype.has = Y7, Gn.prototype.set = J7;
      function Fm(s, c) {
        var p = Xe(s), y = !p && ta(s), x = !p && !y && wi(s), B = !p && !y && !x && Za(s), R = p || y || x || B, F = R ? wh(s.length, u7) : [], Z = F.length;
        for (var ce in s)
          (c || St.call(s, ce)) && !(R && // Safari 9 has enumerable `arguments.length` in strict mode.
          (ce == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          x && (ce == "offset" || ce == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          B && (ce == "buffer" || ce == "byteLength" || ce == "byteOffset") || // Skip index properties.
          $o(ce, Z))) && F.push(ce);
        return F;
      }
      function Mm(s) {
        var c = s.length;
        return c ? s[Rh(0, c - 1)] : r;
      }
      function Q7(s, c) {
        return wl(Jr(s), Yi(c, 0, s.length));
      }
      function e_(s) {
        return wl(Jr(s));
      }
      function Sh(s, c, p) {
        (p !== r && !Wn(s[c], p) || p === r && !(c in s)) && Co(s, c, p);
      }
      function tu(s, c, p) {
        var y = s[c];
        (!(St.call(s, c) && Wn(y, p)) || p === r && !(c in s)) && Co(s, c, p);
      }
      function al(s, c) {
        for (var p = s.length; p--; )
          if (Wn(s[p][0], c))
            return p;
        return -1;
      }
      function t_(s, c, p, y) {
        return gi(s, function(x, B, R) {
          c(y, x, p(x), R);
        }), y;
      }
      function Dm(s, c) {
        return s && po(c, $r(c), s);
      }
      function r_(s, c) {
        return s && po(c, en(c), s);
      }
      function Co(s, c, p) {
        c == "__proto__" && el ? el(s, c, {
          configurable: !0,
          enumerable: !0,
          value: p,
          writable: !0
        }) : s[c] = p;
      }
      function Th(s, c) {
        for (var p = -1, y = c.length, x = te(y), B = s == null; ++p < y; )
          x[p] = B ? r : sp(s, c[p]);
        return x;
      }
      function Yi(s, c, p) {
        return s === s && (p !== r && (s = s <= p ? s : p), c !== r && (s = s >= c ? s : c)), s;
      }
      function Nn(s, c, p, y, x, B) {
        var R, F = c & h, Z = c & g, ce = c & b;
        if (p && (R = x ? p(s, y, x, B) : p(s)), R !== r)
          return R;
        if (!Xt(s))
          return s;
        var fe = Xe(s);
        if (fe) {
          if (R = K_(s), !F)
            return Jr(s, R);
        } else {
          var pe = Mr(s), Se = pe == Ne || pe == Ve;
          if (wi(s))
            return hy(s, F);
          if (pe == He || pe == ve || Se && !x) {
            if (R = Z || Se ? {} : By(s), !F)
              return Z ? N_(s, r_(R, s)) : B_(s, Dm(R, s));
          } else {
            if (!Ut[pe])
              return x ? s : {};
            R = q_(s, pe, F);
          }
        }
        B || (B = new Gn());
        var $e = B.get(s);
        if ($e)
          return $e;
        B.set(s, R), sb(s) ? s.forEach(function(qe) {
          R.add(Nn(qe, c, p, qe, s, B));
        }) : ib(s) && s.forEach(function(qe, ot) {
          R.set(ot, Nn(qe, c, p, ot, s, B));
        });
        var Ke = ce ? Z ? Gh : Vh : Z ? en : $r, et = fe ? r : Ke(s);
        return Pn(et || s, function(qe, ot) {
          et && (ot = qe, qe = s[ot]), tu(R, ot, Nn(qe, c, p, ot, s, B));
        }), R;
      }
      function n_(s) {
        var c = $r(s);
        return function(p) {
          return Km(p, s, c);
        };
      }
      function Km(s, c, p) {
        var y = p.length;
        if (s == null)
          return !y;
        for (s = Bt(s); y--; ) {
          var x = p[y], B = c[x], R = s[x];
          if (R === r && !(x in s) || !B(R))
            return !1;
        }
        return !0;
      }
      function qm(s, c, p) {
        if (typeof s != "function")
          throw new Cn(a);
        return uu(function() {
          s.apply(r, p);
        }, c);
      }
      function ru(s, c, p, y) {
        var x = -1, B = Dc, R = !0, F = s.length, Z = [], ce = c.length;
        if (!F)
          return Z;
        p && (c = Kt(c, wn(p))), y ? (B = hh, R = !1) : c.length >= o && (B = Zs, R = !1, c = new Xi(c));
        e:
          for (; ++x < F; ) {
            var fe = s[x], pe = p == null ? fe : p(fe);
            if (fe = y || fe !== 0 ? fe : 0, R && pe === pe) {
              for (var Se = ce; Se--; )
                if (c[Se] === pe)
                  continue e;
              Z.push(fe);
            } else B(c, pe, y) || Z.push(fe);
          }
        return Z;
      }
      var gi = by(ho), Vm = by(Oh, !0);
      function o_(s, c) {
        var p = !0;
        return gi(s, function(y, x, B) {
          return p = !!c(y, x, B), p;
        }), p;
      }
      function sl(s, c, p) {
        for (var y = -1, x = s.length; ++y < x; ) {
          var B = s[y], R = c(B);
          if (R != null && (F === r ? R === R && !En(R) : p(R, F)))
            var F = R, Z = B;
        }
        return Z;
      }
      function i_(s, c, p, y) {
        var x = s.length;
        for (p = Qe(p), p < 0 && (p = -p > x ? 0 : x + p), y = y === r || y > x ? x : Qe(y), y < 0 && (y += x), y = p > y ? 0 : cb(y); p < y; )
          s[p++] = c;
        return s;
      }
      function Gm(s, c) {
        var p = [];
        return gi(s, function(y, x, B) {
          c(y, x, B) && p.push(y);
        }), p;
      }
      function jr(s, c, p, y, x) {
        var B = -1, R = s.length;
        for (p || (p = G_), x || (x = []); ++B < R; ) {
          var F = s[B];
          c > 0 && p(F) ? c > 1 ? jr(F, c - 1, p, y, x) : di(x, F) : y || (x[x.length] = F);
        }
        return x;
      }
      var Ih = wy(), Wm = wy(!0);
      function ho(s, c) {
        return s && Ih(s, c, $r);
      }
      function Oh(s, c) {
        return s && Wm(s, c, $r);
      }
      function ul(s, c) {
        return fi(c, function(p) {
          return Uo(s[p]);
        });
      }
      function Ji(s, c) {
        c = yi(c, s);
        for (var p = 0, y = c.length; s != null && p < y; )
          s = s[go(c[p++])];
        return p && p == y ? s : r;
      }
      function Zm(s, c, p) {
        var y = c(s);
        return Xe(s) ? y : di(y, p(s));
      }
      function Vr(s) {
        return s == null ? s === r ? yn : Oe : Wi && Wi in Bt(s) ? F_(s) : e9(s);
      }
      function Ph(s, c) {
        return s > c;
      }
      function a_(s, c) {
        return s != null && St.call(s, c);
      }
      function s_(s, c) {
        return s != null && c in Bt(s);
      }
      function u_(s, c, p) {
        return s >= Fr(c, p) && s < Or(c, p);
      }
      function Ch(s, c, p) {
        for (var y = p ? hh : Dc, x = s[0].length, B = s.length, R = B, F = te(B), Z = 1 / 0, ce = []; R--; ) {
          var fe = s[R];
          R && c && (fe = Kt(fe, wn(c))), Z = Fr(fe.length, Z), F[R] = !p && (c || x >= 120 && fe.length >= 120) ? new Xi(R && fe) : r;
        }
        fe = s[0];
        var pe = -1, Se = F[0];
        e:
          for (; ++pe < x && ce.length < Z; ) {
            var $e = fe[pe], Ke = c ? c($e) : $e;
            if ($e = p || $e !== 0 ? $e : 0, !(Se ? Zs(Se, Ke) : y(ce, Ke, p))) {
              for (R = B; --R; ) {
                var et = F[R];
                if (!(et ? Zs(et, Ke) : y(s[R], Ke, p)))
                  continue e;
              }
              Se && Se.push(Ke), ce.push($e);
            }
          }
        return ce;
      }
      function c_(s, c, p, y) {
        return ho(s, function(x, B, R) {
          c(y, p(x), B, R);
        }), y;
      }
      function nu(s, c, p) {
        c = yi(c, s), s = Ry(s, c);
        var y = s == null ? s : s[go(Un(c))];
        return y == null ? r : bn(y, s, p);
      }
      function Xm(s) {
        return Qt(s) && Vr(s) == ve;
      }
      function l_(s) {
        return Qt(s) && Vr(s) == m;
      }
      function f_(s) {
        return Qt(s) && Vr(s) == be;
      }
      function ou(s, c, p, y, x) {
        return s === c ? !0 : s == null || c == null || !Qt(s) && !Qt(c) ? s !== s && c !== c : d_(s, c, p, y, ou, x);
      }
      function d_(s, c, p, y, x, B) {
        var R = Xe(s), F = Xe(c), Z = R ? Ee : Mr(s), ce = F ? Ee : Mr(c);
        Z = Z == ve ? He : Z, ce = ce == ve ? He : ce;
        var fe = Z == He, pe = ce == He, Se = Z == ce;
        if (Se && wi(s)) {
          if (!wi(c))
            return !1;
          R = !0, fe = !1;
        }
        if (Se && !fe)
          return B || (B = new Gn()), R || Za(s) ? Oy(s, c, p, y, x, B) : L_(s, c, Z, p, y, x, B);
        if (!(p & w)) {
          var $e = fe && St.call(s, "__wrapped__"), Ke = pe && St.call(c, "__wrapped__");
          if ($e || Ke) {
            var et = $e ? s.value() : s, qe = Ke ? c.value() : c;
            return B || (B = new Gn()), x(et, qe, p, y, B);
          }
        }
        return Se ? (B || (B = new Gn()), H_(s, c, p, y, x, B)) : !1;
      }
      function h_(s) {
        return Qt(s) && Mr(s) == ge;
      }
      function Bh(s, c, p, y) {
        var x = p.length, B = x, R = !y;
        if (s == null)
          return !B;
        for (s = Bt(s); x--; ) {
          var F = p[x];
          if (R && F[2] ? F[1] !== s[F[0]] : !(F[0] in s))
            return !1;
        }
        for (; ++x < B; ) {
          F = p[x];
          var Z = F[0], ce = s[Z], fe = F[1];
          if (R && F[2]) {
            if (ce === r && !(Z in s))
              return !1;
          } else {
            var pe = new Gn();
            if (y)
              var Se = y(ce, fe, Z, s, c, pe);
            if (!(Se === r ? ou(fe, ce, w | E, y, pe) : Se))
              return !1;
          }
        }
        return !0;
      }
      function Ym(s) {
        if (!Xt(s) || Z_(s))
          return !1;
        var c = Uo(s) ? h7 : Ws;
        return c.test(ea(s));
      }
      function p_(s) {
        return Qt(s) && Vr(s) == Pt;
      }
      function g_(s) {
        return Qt(s) && Mr(s) == _t;
      }
      function m_(s) {
        return Qt(s) && kl(s.length) && !!Ft[Vr(s)];
      }
      function Jm(s) {
        return typeof s == "function" ? s : s == null ? tn : typeof s == "object" ? Xe(s) ? ty(s[0], s[1]) : ey(s) : vb(s);
      }
      function Nh(s) {
        if (!su(s))
          return w7(s);
        var c = [];
        for (var p in Bt(s))
          St.call(s, p) && p != "constructor" && c.push(p);
        return c;
      }
      function y_(s) {
        if (!Xt(s))
          return Q_(s);
        var c = su(s), p = [];
        for (var y in s)
          y == "constructor" && (c || !St.call(s, y)) || p.push(y);
        return p;
      }
      function $h(s, c) {
        return s < c;
      }
      function Qm(s, c) {
        var p = -1, y = Qr(s) ? te(s.length) : [];
        return gi(s, function(x, B, R) {
          y[++p] = c(x, B, R);
        }), y;
      }
      function ey(s) {
        var c = Zh(s);
        return c.length == 1 && c[0][2] ? $y(c[0][0], c[0][1]) : function(p) {
          return p === s || Bh(p, s, c);
        };
      }
      function ty(s, c) {
        return Yh(s) && Ny(c) ? $y(go(s), c) : function(p) {
          var y = sp(p, s);
          return y === r && y === c ? up(p, s) : ou(c, y, w | E);
        };
      }
      function cl(s, c, p, y, x) {
        s !== c && Ih(c, function(B, R) {
          if (x || (x = new Gn()), Xt(B))
            b_(s, c, R, p, cl, y, x);
          else {
            var F = y ? y(Qh(s, R), B, R + "", s, c, x) : r;
            F === r && (F = B), Sh(s, R, F);
          }
        }, en);
      }
      function b_(s, c, p, y, x, B, R) {
        var F = Qh(s, p), Z = Qh(c, p), ce = R.get(Z);
        if (ce) {
          Sh(s, p, ce);
          return;
        }
        var fe = B ? B(F, Z, p + "", s, c, R) : r, pe = fe === r;
        if (pe) {
          var Se = Xe(Z), $e = !Se && wi(Z), Ke = !Se && !$e && Za(Z);
          fe = Z, Se || $e || Ke ? Xe(F) ? fe = F : ur(F) ? fe = Jr(F) : $e ? (pe = !1, fe = hy(Z, !0)) : Ke ? (pe = !1, fe = py(Z, !0)) : fe = [] : cu(Z) || ta(Z) ? (fe = F, ta(F) ? fe = lb(F) : (!Xt(F) || Uo(F)) && (fe = By(Z))) : pe = !1;
        }
        pe && (R.set(Z, fe), x(fe, Z, y, B, R), R.delete(Z)), Sh(s, p, fe);
      }
      function ry(s, c) {
        var p = s.length;
        if (p)
          return c += c < 0 ? p : 0, $o(c, p) ? s[c] : r;
      }
      function ny(s, c, p) {
        c.length ? c = Kt(c, function(B) {
          return Xe(B) ? function(R) {
            return Ji(R, B.length === 1 ? B[0] : B);
          } : B;
        }) : c = [tn];
        var y = -1;
        c = Kt(c, wn(De()));
        var x = Qm(s, function(B, R, F) {
          var Z = Kt(c, function(ce) {
            return ce(B);
          });
          return { criteria: Z, index: ++y, value: B };
        });
        return q6(x, function(B, R) {
          return C_(B, R, p);
        });
      }
      function w_(s, c) {
        return oy(s, c, function(p, y) {
          return up(s, y);
        });
      }
      function oy(s, c, p) {
        for (var y = -1, x = c.length, B = {}; ++y < x; ) {
          var R = c[y], F = Ji(s, R);
          p(F, R) && iu(B, yi(R, s), F);
        }
        return B;
      }
      function v_(s) {
        return function(c) {
          return Ji(c, s);
        };
      }
      function Uh(s, c, p, y) {
        var x = y ? K6 : ja, B = -1, R = c.length, F = s;
        for (s === c && (c = Jr(c)), p && (F = Kt(s, wn(p))); ++B < R; )
          for (var Z = 0, ce = c[B], fe = p ? p(ce) : ce; (Z = x(F, fe, Z, y)) > -1; )
            F !== s && Qc.call(F, Z, 1), Qc.call(s, Z, 1);
        return s;
      }
      function iy(s, c) {
        for (var p = s ? c.length : 0, y = p - 1; p--; ) {
          var x = c[p];
          if (p == y || x !== B) {
            var B = x;
            $o(x) ? Qc.call(s, x, 1) : Lh(s, x);
          }
        }
        return s;
      }
      function Rh(s, c) {
        return s + rl(Lm() * (c - s + 1));
      }
      function E_(s, c, p, y) {
        for (var x = -1, B = Or(tl((c - s) / (p || 1)), 0), R = te(B); B--; )
          R[y ? B : ++x] = s, s += p;
        return R;
      }
      function zh(s, c) {
        var p = "";
        if (!s || c < 1 || c > re)
          return p;
        do
          c % 2 && (p += s), c = rl(c / 2), c && (s += s);
        while (c);
        return p;
      }
      function tt(s, c) {
        return ep(Uy(s, c, tn), s + "");
      }
      function __(s) {
        return Mm(Xa(s));
      }
      function A_(s, c) {
        var p = Xa(s);
        return wl(p, Yi(c, 0, p.length));
      }
      function iu(s, c, p, y) {
        if (!Xt(s))
          return s;
        c = yi(c, s);
        for (var x = -1, B = c.length, R = B - 1, F = s; F != null && ++x < B; ) {
          var Z = go(c[x]), ce = p;
          if (Z === "__proto__" || Z === "constructor" || Z === "prototype")
            return s;
          if (x != R) {
            var fe = F[Z];
            ce = y ? y(fe, Z, F) : r, ce === r && (ce = Xt(fe) ? fe : $o(c[x + 1]) ? [] : {});
          }
          tu(F, Z, ce), F = F[Z];
        }
        return s;
      }
      var ay = nl ? function(s, c) {
        return nl.set(s, c), s;
      } : tn, x_ = el ? function(s, c) {
        return el(s, "toString", {
          configurable: !0,
          enumerable: !1,
          value: lp(c),
          writable: !0
        });
      } : tn;
      function k_(s) {
        return wl(Xa(s));
      }
      function $n(s, c, p) {
        var y = -1, x = s.length;
        c < 0 && (c = -c > x ? 0 : x + c), p = p > x ? x : p, p < 0 && (p += x), x = c > p ? 0 : p - c >>> 0, c >>>= 0;
        for (var B = te(x); ++y < x; )
          B[y] = s[y + c];
        return B;
      }
      function S_(s, c) {
        var p;
        return gi(s, function(y, x, B) {
          return p = c(y, x, B), !p;
        }), !!p;
      }
      function ll(s, c, p) {
        var y = 0, x = s == null ? y : s.length;
        if (typeof c == "number" && c === c && x <= J) {
          for (; y < x; ) {
            var B = y + x >>> 1, R = s[B];
            R !== null && !En(R) && (p ? R <= c : R < c) ? y = B + 1 : x = B;
          }
          return x;
        }
        return jh(s, c, tn, p);
      }
      function jh(s, c, p, y) {
        var x = 0, B = s == null ? 0 : s.length;
        if (B === 0)
          return 0;
        c = p(c);
        for (var R = c !== c, F = c === null, Z = En(c), ce = c === r; x < B; ) {
          var fe = rl((x + B) / 2), pe = p(s[fe]), Se = pe !== r, $e = pe === null, Ke = pe === pe, et = En(pe);
          if (R)
            var qe = y || Ke;
          else ce ? qe = Ke && (y || Se) : F ? qe = Ke && Se && (y || !$e) : Z ? qe = Ke && Se && !$e && (y || !et) : $e || et ? qe = !1 : qe = y ? pe <= c : pe < c;
          qe ? x = fe + 1 : B = fe;
        }
        return Fr(B, se);
      }
      function sy(s, c) {
        for (var p = -1, y = s.length, x = 0, B = []; ++p < y; ) {
          var R = s[p], F = c ? c(R) : R;
          if (!p || !Wn(F, Z)) {
            var Z = F;
            B[x++] = R === 0 ? 0 : R;
          }
        }
        return B;
      }
      function uy(s) {
        return typeof s == "number" ? s : En(s) ? q : +s;
      }
      function vn(s) {
        if (typeof s == "string")
          return s;
        if (Xe(s))
          return Kt(s, vn) + "";
        if (En(s))
          return Hm ? Hm.call(s) : "";
        var c = s + "";
        return c == "0" && 1 / s == -1 / 0 ? "-0" : c;
      }
      function mi(s, c, p) {
        var y = -1, x = Dc, B = s.length, R = !0, F = [], Z = F;
        if (p)
          R = !1, x = hh;
        else if (B >= o) {
          var ce = c ? null : z_(s);
          if (ce)
            return qc(ce);
          R = !1, x = Zs, Z = new Xi();
        } else
          Z = c ? [] : F;
        e:
          for (; ++y < B; ) {
            var fe = s[y], pe = c ? c(fe) : fe;
            if (fe = p || fe !== 0 ? fe : 0, R && pe === pe) {
              for (var Se = Z.length; Se--; )
                if (Z[Se] === pe)
                  continue e;
              c && Z.push(pe), F.push(fe);
            } else x(Z, pe, p) || (Z !== F && Z.push(pe), F.push(fe));
          }
        return F;
      }
      function Lh(s, c) {
        return c = yi(c, s), s = Ry(s, c), s == null || delete s[go(Un(c))];
      }
      function cy(s, c, p, y) {
        return iu(s, c, p(Ji(s, c)), y);
      }
      function fl(s, c, p, y) {
        for (var x = s.length, B = y ? x : -1; (y ? B-- : ++B < x) && c(s[B], B, s); )
          ;
        return p ? $n(s, y ? 0 : B, y ? B + 1 : x) : $n(s, y ? B + 1 : 0, y ? x : B);
      }
      function ly(s, c) {
        var p = s;
        return p instanceof at && (p = p.value()), ph(c, function(y, x) {
          return x.func.apply(x.thisArg, di([y], x.args));
        }, p);
      }
      function Hh(s, c, p) {
        var y = s.length;
        if (y < 2)
          return y ? mi(s[0]) : [];
        for (var x = -1, B = te(y); ++x < y; )
          for (var R = s[x], F = -1; ++F < y; )
            F != x && (B[x] = ru(B[x] || R, s[F], c, p));
        return mi(jr(B, 1), c, p);
      }
      function fy(s, c, p) {
        for (var y = -1, x = s.length, B = c.length, R = {}; ++y < x; ) {
          var F = y < B ? c[y] : r;
          p(R, s[y], F);
        }
        return R;
      }
      function Fh(s) {
        return ur(s) ? s : [];
      }
      function Mh(s) {
        return typeof s == "function" ? s : tn;
      }
      function yi(s, c) {
        return Xe(s) ? s : Yh(s, c) ? [s] : Hy(xt(s));
      }
      var T_ = tt;
      function bi(s, c, p) {
        var y = s.length;
        return p = p === r ? y : p, !c && p >= y ? s : $n(s, c, p);
      }
      var dy = p7 || function(s) {
        return zr.clearTimeout(s);
      };
      function hy(s, c) {
        if (c)
          return s.slice();
        var p = s.length, y = $m ? $m(p) : new s.constructor(p);
        return s.copy(y), y;
      }
      function Dh(s) {
        var c = new s.constructor(s.byteLength);
        return new Yc(c).set(new Yc(s)), c;
      }
      function I_(s, c) {
        var p = c ? Dh(s.buffer) : s.buffer;
        return new s.constructor(p, s.byteOffset, s.byteLength);
      }
      function O_(s) {
        var c = new s.constructor(s.source, Io.exec(s));
        return c.lastIndex = s.lastIndex, c;
      }
      function P_(s) {
        return eu ? Bt(eu.call(s)) : {};
      }
      function py(s, c) {
        var p = c ? Dh(s.buffer) : s.buffer;
        return new s.constructor(p, s.byteOffset, s.length);
      }
      function gy(s, c) {
        if (s !== c) {
          var p = s !== r, y = s === null, x = s === s, B = En(s), R = c !== r, F = c === null, Z = c === c, ce = En(c);
          if (!F && !ce && !B && s > c || B && R && Z && !F && !ce || y && R && Z || !p && Z || !x)
            return 1;
          if (!y && !B && !ce && s < c || ce && p && x && !y && !B || F && p && x || !R && x || !Z)
            return -1;
        }
        return 0;
      }
      function C_(s, c, p) {
        for (var y = -1, x = s.criteria, B = c.criteria, R = x.length, F = p.length; ++y < R; ) {
          var Z = gy(x[y], B[y]);
          if (Z) {
            if (y >= F)
              return Z;
            var ce = p[y];
            return Z * (ce == "desc" ? -1 : 1);
          }
        }
        return s.index - c.index;
      }
      function my(s, c, p, y) {
        for (var x = -1, B = s.length, R = p.length, F = -1, Z = c.length, ce = Or(B - R, 0), fe = te(Z + ce), pe = !y; ++F < Z; )
          fe[F] = c[F];
        for (; ++x < R; )
          (pe || x < B) && (fe[p[x]] = s[x]);
        for (; ce--; )
          fe[F++] = s[x++];
        return fe;
      }
      function yy(s, c, p, y) {
        for (var x = -1, B = s.length, R = -1, F = p.length, Z = -1, ce = c.length, fe = Or(B - F, 0), pe = te(fe + ce), Se = !y; ++x < fe; )
          pe[x] = s[x];
        for (var $e = x; ++Z < ce; )
          pe[$e + Z] = c[Z];
        for (; ++R < F; )
          (Se || x < B) && (pe[$e + p[R]] = s[x++]);
        return pe;
      }
      function Jr(s, c) {
        var p = -1, y = s.length;
        for (c || (c = te(y)); ++p < y; )
          c[p] = s[p];
        return c;
      }
      function po(s, c, p, y) {
        var x = !p;
        p || (p = {});
        for (var B = -1, R = c.length; ++B < R; ) {
          var F = c[B], Z = y ? y(p[F], s[F], F, p, s) : r;
          Z === r && (Z = s[F]), x ? Co(p, F, Z) : tu(p, F, Z);
        }
        return p;
      }
      function B_(s, c) {
        return po(s, Xh(s), c);
      }
      function N_(s, c) {
        return po(s, Py(s), c);
      }
      function dl(s, c) {
        return function(p, y) {
          var x = Xe(p) ? j6 : t_, B = c ? c() : {};
          return x(p, s, De(y, 2), B);
        };
      }
      function Va(s) {
        return tt(function(c, p) {
          var y = -1, x = p.length, B = x > 1 ? p[x - 1] : r, R = x > 2 ? p[2] : r;
          for (B = s.length > 3 && typeof B == "function" ? (x--, B) : r, R && Gr(p[0], p[1], R) && (B = x < 3 ? r : B, x = 1), c = Bt(c); ++y < x; ) {
            var F = p[y];
            F && s(c, F, y, B);
          }
          return c;
        });
      }
      function by(s, c) {
        return function(p, y) {
          if (p == null)
            return p;
          if (!Qr(p))
            return s(p, y);
          for (var x = p.length, B = c ? x : -1, R = Bt(p); (c ? B-- : ++B < x) && y(R[B], B, R) !== !1; )
            ;
          return p;
        };
      }
      function wy(s) {
        return function(c, p, y) {
          for (var x = -1, B = Bt(c), R = y(c), F = R.length; F--; ) {
            var Z = R[s ? F : ++x];
            if (p(B[Z], Z, B) === !1)
              break;
          }
          return c;
        };
      }
      function $_(s, c, p) {
        var y = c & _, x = au(s);
        function B() {
          var R = this && this !== zr && this instanceof B ? x : s;
          return R.apply(y ? p : this, arguments);
        }
        return B;
      }
      function vy(s) {
        return function(c) {
          c = xt(c);
          var p = La(c) ? Vn(c) : r, y = p ? p[0] : c.charAt(0), x = p ? bi(p, 1).join("") : c.slice(1);
          return y[s]() + x;
        };
      }
      function Ga(s) {
        return function(c) {
          return ph(bb(yb(c).replace(x6, "")), s, "");
        };
      }
      function au(s) {
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return new s();
            case 1:
              return new s(c[0]);
            case 2:
              return new s(c[0], c[1]);
            case 3:
              return new s(c[0], c[1], c[2]);
            case 4:
              return new s(c[0], c[1], c[2], c[3]);
            case 5:
              return new s(c[0], c[1], c[2], c[3], c[4]);
            case 6:
              return new s(c[0], c[1], c[2], c[3], c[4], c[5]);
            case 7:
              return new s(c[0], c[1], c[2], c[3], c[4], c[5], c[6]);
          }
          var p = qa(s.prototype), y = s.apply(p, c);
          return Xt(y) ? y : p;
        };
      }
      function U_(s, c, p) {
        var y = au(s);
        function x() {
          for (var B = arguments.length, R = te(B), F = B, Z = Wa(x); F--; )
            R[F] = arguments[F];
          var ce = B < 3 && R[0] !== Z && R[B - 1] !== Z ? [] : hi(R, Z);
          if (B -= ce.length, B < p)
            return ky(
              s,
              c,
              hl,
              x.placeholder,
              r,
              R,
              ce,
              r,
              r,
              p - B
            );
          var fe = this && this !== zr && this instanceof x ? y : s;
          return bn(fe, this, R);
        }
        return x;
      }
      function Ey(s) {
        return function(c, p, y) {
          var x = Bt(c);
          if (!Qr(c)) {
            var B = De(p, 3);
            c = $r(c), p = function(F) {
              return B(x[F], F, x);
            };
          }
          var R = s(c, p, y);
          return R > -1 ? x[B ? c[R] : R] : r;
        };
      }
      function _y(s) {
        return No(function(c) {
          var p = c.length, y = p, x = Bn.prototype.thru;
          for (s && c.reverse(); y--; ) {
            var B = c[y];
            if (typeof B != "function")
              throw new Cn(a);
            if (x && !R && yl(B) == "wrapper")
              var R = new Bn([], !0);
          }
          for (y = R ? y : p; ++y < p; ) {
            B = c[y];
            var F = yl(B), Z = F == "wrapper" ? Wh(B) : r;
            Z && Jh(Z[0]) && Z[1] == ($ | I | T | U) && !Z[4].length && Z[9] == 1 ? R = R[yl(Z[0])].apply(R, Z[3]) : R = B.length == 1 && Jh(B) ? R[F]() : R.thru(B);
          }
          return function() {
            var ce = arguments, fe = ce[0];
            if (R && ce.length == 1 && Xe(fe))
              return R.plant(fe).value();
            for (var pe = 0, Se = p ? c[pe].apply(this, ce) : fe; ++pe < p; )
              Se = c[pe].call(this, Se);
            return Se;
          };
        });
      }
      function hl(s, c, p, y, x, B, R, F, Z, ce) {
        var fe = c & $, pe = c & _, Se = c & O, $e = c & (I | S), Ke = c & M, et = Se ? r : au(s);
        function qe() {
          for (var ot = arguments.length, lt = te(ot), _n = ot; _n--; )
            lt[_n] = arguments[_n];
          if ($e)
            var Wr = Wa(qe), An = G6(lt, Wr);
          if (y && (lt = my(lt, y, x, $e)), B && (lt = yy(lt, B, R, $e)), ot -= An, $e && ot < ce) {
            var cr = hi(lt, Wr);
            return ky(
              s,
              c,
              hl,
              qe.placeholder,
              p,
              lt,
              cr,
              F,
              Z,
              ce - ot
            );
          }
          var Zn = pe ? p : this, zo = Se ? Zn[s] : s;
          return ot = lt.length, F ? lt = t9(lt, F) : Ke && ot > 1 && lt.reverse(), fe && Z < ot && (lt.length = Z), this && this !== zr && this instanceof qe && (zo = et || au(zo)), zo.apply(Zn, lt);
        }
        return qe;
      }
      function Ay(s, c) {
        return function(p, y) {
          return c_(p, s, c(y), {});
        };
      }
      function pl(s, c) {
        return function(p, y) {
          var x;
          if (p === r && y === r)
            return c;
          if (p !== r && (x = p), y !== r) {
            if (x === r)
              return y;
            typeof p == "string" || typeof y == "string" ? (p = vn(p), y = vn(y)) : (p = uy(p), y = uy(y)), x = s(p, y);
          }
          return x;
        };
      }
      function Kh(s) {
        return No(function(c) {
          return c = Kt(c, wn(De())), tt(function(p) {
            var y = this;
            return s(c, function(x) {
              return bn(x, y, p);
            });
          });
        });
      }
      function gl(s, c) {
        c = c === r ? " " : vn(c);
        var p = c.length;
        if (p < 2)
          return p ? zh(c, s) : c;
        var y = zh(c, tl(s / Ha(c)));
        return La(c) ? bi(Vn(y), 0, s).join("") : y.slice(0, s);
      }
      function R_(s, c, p, y) {
        var x = c & _, B = au(s);
        function R() {
          for (var F = -1, Z = arguments.length, ce = -1, fe = y.length, pe = te(fe + Z), Se = this && this !== zr && this instanceof R ? B : s; ++ce < fe; )
            pe[ce] = y[ce];
          for (; Z--; )
            pe[ce++] = arguments[++F];
          return bn(Se, x ? p : this, pe);
        }
        return R;
      }
      function xy(s) {
        return function(c, p, y) {
          return y && typeof y != "number" && Gr(c, p, y) && (p = y = r), c = Ro(c), p === r ? (p = c, c = 0) : p = Ro(p), y = y === r ? c < p ? 1 : -1 : Ro(y), E_(c, p, y, s);
        };
      }
      function ml(s) {
        return function(c, p) {
          return typeof c == "string" && typeof p == "string" || (c = Rn(c), p = Rn(p)), s(c, p);
        };
      }
      function ky(s, c, p, y, x, B, R, F, Z, ce) {
        var fe = c & I, pe = fe ? R : r, Se = fe ? r : R, $e = fe ? B : r, Ke = fe ? r : B;
        c |= fe ? T : A, c &= ~(fe ? A : T), c & C || (c &= -4);
        var et = [
          s,
          c,
          x,
          $e,
          pe,
          Ke,
          Se,
          F,
          Z,
          ce
        ], qe = p.apply(r, et);
        return Jh(s) && zy(qe, et), qe.placeholder = y, jy(qe, s, c);
      }
      function qh(s) {
        var c = Ir[s];
        return function(p, y) {
          if (p = Rn(p), y = y == null ? 0 : Fr(Qe(y), 292), y && jm(p)) {
            var x = (xt(p) + "e").split("e"), B = c(x[0] + "e" + (+x[1] + y));
            return x = (xt(B) + "e").split("e"), +(x[0] + "e" + (+x[1] - y));
          }
          return c(p);
        };
      }
      var z_ = Da && 1 / qc(new Da([, -0]))[1] == le ? function(s) {
        return new Da(s);
      } : hp;
      function Sy(s) {
        return function(c) {
          var p = Mr(c);
          return p == ge ? Eh(c) : p == _t ? e7(c) : V6(c, s(c));
        };
      }
      function Bo(s, c, p, y, x, B, R, F) {
        var Z = c & O;
        if (!Z && typeof s != "function")
          throw new Cn(a);
        var ce = y ? y.length : 0;
        if (ce || (c &= -97, y = x = r), R = R === r ? R : Or(Qe(R), 0), F = F === r ? F : Qe(F), ce -= x ? x.length : 0, c & A) {
          var fe = y, pe = x;
          y = x = r;
        }
        var Se = Z ? r : Wh(s), $e = [
          s,
          c,
          p,
          y,
          x,
          fe,
          pe,
          B,
          R,
          F
        ];
        if (Se && J_($e, Se), s = $e[0], c = $e[1], p = $e[2], y = $e[3], x = $e[4], F = $e[9] = $e[9] === r ? Z ? 0 : s.length : Or($e[9] - ce, 0), !F && c & (I | S) && (c &= -25), !c || c == _)
          var Ke = $_(s, c, p);
        else c == I || c == S ? Ke = U_(s, c, F) : (c == T || c == (_ | T)) && !x.length ? Ke = R_(s, c, p, y) : Ke = hl.apply(r, $e);
        var et = Se ? ay : zy;
        return jy(et(Ke, $e), s, c);
      }
      function Ty(s, c, p, y) {
        return s === r || Wn(s, Ma[p]) && !St.call(y, p) ? c : s;
      }
      function Iy(s, c, p, y, x, B) {
        return Xt(s) && Xt(c) && (B.set(c, s), cl(s, c, r, Iy, B), B.delete(c)), s;
      }
      function j_(s) {
        return cu(s) ? r : s;
      }
      function Oy(s, c, p, y, x, B) {
        var R = p & w, F = s.length, Z = c.length;
        if (F != Z && !(R && Z > F))
          return !1;
        var ce = B.get(s), fe = B.get(c);
        if (ce && fe)
          return ce == c && fe == s;
        var pe = -1, Se = !0, $e = p & E ? new Xi() : r;
        for (B.set(s, c), B.set(c, s); ++pe < F; ) {
          var Ke = s[pe], et = c[pe];
          if (y)
            var qe = R ? y(et, Ke, pe, c, s, B) : y(Ke, et, pe, s, c, B);
          if (qe !== r) {
            if (qe)
              continue;
            Se = !1;
            break;
          }
          if ($e) {
            if (!gh(c, function(ot, lt) {
              if (!Zs($e, lt) && (Ke === ot || x(Ke, ot, p, y, B)))
                return $e.push(lt);
            })) {
              Se = !1;
              break;
            }
          } else if (!(Ke === et || x(Ke, et, p, y, B))) {
            Se = !1;
            break;
          }
        }
        return B.delete(s), B.delete(c), Se;
      }
      function L_(s, c, p, y, x, B, R) {
        switch (p) {
          case v:
            if (s.byteLength != c.byteLength || s.byteOffset != c.byteOffset)
              return !1;
            s = s.buffer, c = c.buffer;
          case m:
            return !(s.byteLength != c.byteLength || !B(new Yc(s), new Yc(c)));
          case we:
          case be:
          case Te:
            return Wn(+s, +c);
          case Le:
            return s.name == c.name && s.message == c.message;
          case Pt:
          case yt:
            return s == c + "";
          case ge:
            var F = Eh;
          case _t:
            var Z = y & w;
            if (F || (F = qc), s.size != c.size && !Z)
              return !1;
            var ce = R.get(s);
            if (ce)
              return ce == c;
            y |= E, R.set(s, c);
            var fe = Oy(F(s), F(c), y, x, B, R);
            return R.delete(s), fe;
          case Zt:
            if (eu)
              return eu.call(s) == eu.call(c);
        }
        return !1;
      }
      function H_(s, c, p, y, x, B) {
        var R = p & w, F = Vh(s), Z = F.length, ce = Vh(c), fe = ce.length;
        if (Z != fe && !R)
          return !1;
        for (var pe = Z; pe--; ) {
          var Se = F[pe];
          if (!(R ? Se in c : St.call(c, Se)))
            return !1;
        }
        var $e = B.get(s), Ke = B.get(c);
        if ($e && Ke)
          return $e == c && Ke == s;
        var et = !0;
        B.set(s, c), B.set(c, s);
        for (var qe = R; ++pe < Z; ) {
          Se = F[pe];
          var ot = s[Se], lt = c[Se];
          if (y)
            var _n = R ? y(lt, ot, Se, c, s, B) : y(ot, lt, Se, s, c, B);
          if (!(_n === r ? ot === lt || x(ot, lt, p, y, B) : _n)) {
            et = !1;
            break;
          }
          qe || (qe = Se == "constructor");
        }
        if (et && !qe) {
          var Wr = s.constructor, An = c.constructor;
          Wr != An && "constructor" in s && "constructor" in c && !(typeof Wr == "function" && Wr instanceof Wr && typeof An == "function" && An instanceof An) && (et = !1);
        }
        return B.delete(s), B.delete(c), et;
      }
      function No(s) {
        return ep(Uy(s, r, Ky), s + "");
      }
      function Vh(s) {
        return Zm(s, $r, Xh);
      }
      function Gh(s) {
        return Zm(s, en, Py);
      }
      var Wh = nl ? function(s) {
        return nl.get(s);
      } : hp;
      function yl(s) {
        for (var c = s.name + "", p = Ka[c], y = St.call(Ka, c) ? p.length : 0; y--; ) {
          var x = p[y], B = x.func;
          if (B == null || B == s)
            return x.name;
        }
        return c;
      }
      function Wa(s) {
        var c = St.call(P, "placeholder") ? P : s;
        return c.placeholder;
      }
      function De() {
        var s = P.iteratee || fp;
        return s = s === fp ? Jm : s, arguments.length ? s(arguments[0], arguments[1]) : s;
      }
      function bl(s, c) {
        var p = s.__data__;
        return W_(c) ? p[typeof c == "string" ? "string" : "hash"] : p.map;
      }
      function Zh(s) {
        for (var c = $r(s), p = c.length; p--; ) {
          var y = c[p], x = s[y];
          c[p] = [y, x, Ny(x)];
        }
        return c;
      }
      function Qi(s, c) {
        var p = Y6(s, c);
        return Ym(p) ? p : r;
      }
      function F_(s) {
        var c = St.call(s, Wi), p = s[Wi];
        try {
          s[Wi] = r;
          var y = !0;
        } catch {
        }
        var x = Zc.call(s);
        return y && (c ? s[Wi] = p : delete s[Wi]), x;
      }
      var Xh = Ah ? function(s) {
        return s == null ? [] : (s = Bt(s), fi(Ah(s), function(c) {
          return Rm.call(s, c);
        }));
      } : pp, Py = Ah ? function(s) {
        for (var c = []; s; )
          di(c, Xh(s)), s = Jc(s);
        return c;
      } : pp, Mr = Vr;
      (xh && Mr(new xh(new ArrayBuffer(1))) != v || Ys && Mr(new Ys()) != ge || kh && Mr(kh.resolve()) != mt || Da && Mr(new Da()) != _t || Js && Mr(new Js()) != kt) && (Mr = function(s) {
        var c = Vr(s), p = c == He ? s.constructor : r, y = p ? ea(p) : "";
        if (y)
          switch (y) {
            case A7:
              return v;
            case x7:
              return ge;
            case k7:
              return mt;
            case S7:
              return _t;
            case T7:
              return kt;
          }
        return c;
      });
      function M_(s, c, p) {
        for (var y = -1, x = p.length; ++y < x; ) {
          var B = p[y], R = B.size;
          switch (B.type) {
            case "drop":
              s += R;
              break;
            case "dropRight":
              c -= R;
              break;
            case "take":
              c = Fr(c, s + R);
              break;
            case "takeRight":
              s = Or(s, c - R);
              break;
          }
        }
        return { start: s, end: c };
      }
      function D_(s) {
        var c = s.match(it);
        return c ? c[1].split(ct) : [];
      }
      function Cy(s, c, p) {
        c = yi(c, s);
        for (var y = -1, x = c.length, B = !1; ++y < x; ) {
          var R = go(c[y]);
          if (!(B = s != null && p(s, R)))
            break;
          s = s[R];
        }
        return B || ++y != x ? B : (x = s == null ? 0 : s.length, !!x && kl(x) && $o(R, x) && (Xe(s) || ta(s)));
      }
      function K_(s) {
        var c = s.length, p = new s.constructor(c);
        return c && typeof s[0] == "string" && St.call(s, "index") && (p.index = s.index, p.input = s.input), p;
      }
      function By(s) {
        return typeof s.constructor == "function" && !su(s) ? qa(Jc(s)) : {};
      }
      function q_(s, c, p) {
        var y = s.constructor;
        switch (c) {
          case m:
            return Dh(s);
          case we:
          case be:
            return new y(+s);
          case v:
            return I_(s, p);
          case k:
          case H:
          case X:
          case oe:
          case me:
          case nt:
          case Ct:
          case At:
          case vt:
            return py(s, p);
          case ge:
            return new y();
          case Te:
          case yt:
            return new y(s);
          case Pt:
            return O_(s);
          case _t:
            return new y();
          case Zt:
            return P_(s);
        }
      }
      function V_(s, c) {
        var p = c.length;
        if (!p)
          return s;
        var y = p - 1;
        return c[y] = (p > 1 ? "& " : "") + c[y], c = c.join(p > 2 ? ", " : " "), s.replace(We, `{
/* [wrapped with ` + c + `] */
`);
      }
      function G_(s) {
        return Xe(s) || ta(s) || !!(zm && s && s[zm]);
      }
      function $o(s, c) {
        var p = typeof s;
        return c = c ?? re, !!c && (p == "number" || p != "symbol" && i6.test(s)) && s > -1 && s % 1 == 0 && s < c;
      }
      function Gr(s, c, p) {
        if (!Xt(p))
          return !1;
        var y = typeof c;
        return (y == "number" ? Qr(p) && $o(c, p.length) : y == "string" && c in p) ? Wn(p[c], s) : !1;
      }
      function Yh(s, c) {
        if (Xe(s))
          return !1;
        var p = typeof s;
        return p == "number" || p == "symbol" || p == "boolean" || s == null || En(s) ? !0 : ie.test(s) || !W.test(s) || c != null && s in Bt(c);
      }
      function W_(s) {
        var c = typeof s;
        return c == "string" || c == "number" || c == "symbol" || c == "boolean" ? s !== "__proto__" : s === null;
      }
      function Jh(s) {
        var c = yl(s), p = P[c];
        if (typeof p != "function" || !(c in at.prototype))
          return !1;
        if (s === p)
          return !0;
        var y = Wh(p);
        return !!y && s === y[0];
      }
      function Z_(s) {
        return !!Nm && Nm in s;
      }
      var X_ = Gc ? Uo : gp;
      function su(s) {
        var c = s && s.constructor, p = typeof c == "function" && c.prototype || Ma;
        return s === p;
      }
      function Ny(s) {
        return s === s && !Xt(s);
      }
      function $y(s, c) {
        return function(p) {
          return p == null ? !1 : p[s] === c && (c !== r || s in Bt(p));
        };
      }
      function Y_(s) {
        var c = Al(s, function(y) {
          return p.size === d && p.clear(), y;
        }), p = c.cache;
        return c;
      }
      function J_(s, c) {
        var p = s[1], y = c[1], x = p | y, B = x < (_ | O | $), R = y == $ && p == I || y == $ && p == U && s[7].length <= c[8] || y == ($ | U) && c[7].length <= c[8] && p == I;
        if (!(B || R))
          return s;
        y & _ && (s[2] = c[2], x |= p & _ ? 0 : C);
        var F = c[3];
        if (F) {
          var Z = s[3];
          s[3] = Z ? my(Z, F, c[4]) : F, s[4] = Z ? hi(s[3], f) : c[4];
        }
        return F = c[5], F && (Z = s[5], s[5] = Z ? yy(Z, F, c[6]) : F, s[6] = Z ? hi(s[5], f) : c[6]), F = c[7], F && (s[7] = F), y & $ && (s[8] = s[8] == null ? c[8] : Fr(s[8], c[8])), s[9] == null && (s[9] = c[9]), s[0] = c[0], s[1] = x, s;
      }
      function Q_(s) {
        var c = [];
        if (s != null)
          for (var p in Bt(s))
            c.push(p);
        return c;
      }
      function e9(s) {
        return Zc.call(s);
      }
      function Uy(s, c, p) {
        return c = Or(c === r ? s.length - 1 : c, 0), function() {
          for (var y = arguments, x = -1, B = Or(y.length - c, 0), R = te(B); ++x < B; )
            R[x] = y[c + x];
          x = -1;
          for (var F = te(c + 1); ++x < c; )
            F[x] = y[x];
          return F[c] = p(R), bn(s, this, F);
        };
      }
      function Ry(s, c) {
        return c.length < 2 ? s : Ji(s, $n(c, 0, -1));
      }
      function t9(s, c) {
        for (var p = s.length, y = Fr(c.length, p), x = Jr(s); y--; ) {
          var B = c[y];
          s[y] = $o(B, p) ? x[B] : r;
        }
        return s;
      }
      function Qh(s, c) {
        if (!(c === "constructor" && typeof s[c] == "function") && c != "__proto__")
          return s[c];
      }
      var zy = Ly(ay), uu = m7 || function(s, c) {
        return zr.setTimeout(s, c);
      }, ep = Ly(x_);
      function jy(s, c, p) {
        var y = c + "";
        return ep(s, V_(y, r9(D_(y), p)));
      }
      function Ly(s) {
        var c = 0, p = 0;
        return function() {
          var y = v7(), x = de - (y - p);
          if (p = y, x > 0) {
            if (++c >= ee)
              return arguments[0];
          } else
            c = 0;
          return s.apply(r, arguments);
        };
      }
      function wl(s, c) {
        var p = -1, y = s.length, x = y - 1;
        for (c = c === r ? y : c; ++p < c; ) {
          var B = Rh(p, x), R = s[B];
          s[B] = s[p], s[p] = R;
        }
        return s.length = c, s;
      }
      var Hy = Y_(function(s) {
        var c = [];
        return s.charCodeAt(0) === 46 && c.push(""), s.replace(he, function(p, y, x, B) {
          c.push(x ? B.replace(qn, "$1") : y || p);
        }), c;
      });
      function go(s) {
        if (typeof s == "string" || En(s))
          return s;
        var c = s + "";
        return c == "0" && 1 / s == -1 / 0 ? "-0" : c;
      }
      function ea(s) {
        if (s != null) {
          try {
            return Wc.call(s);
          } catch {
          }
          try {
            return s + "";
          } catch {
          }
        }
        return "";
      }
      function r9(s, c) {
        return Pn(ye, function(p) {
          var y = "_." + p[0];
          c & p[1] && !Dc(s, y) && s.push(y);
        }), s.sort();
      }
      function Fy(s) {
        if (s instanceof at)
          return s.clone();
        var c = new Bn(s.__wrapped__, s.__chain__);
        return c.__actions__ = Jr(s.__actions__), c.__index__ = s.__index__, c.__values__ = s.__values__, c;
      }
      function n9(s, c, p) {
        (p ? Gr(s, c, p) : c === r) ? c = 1 : c = Or(Qe(c), 0);
        var y = s == null ? 0 : s.length;
        if (!y || c < 1)
          return [];
        for (var x = 0, B = 0, R = te(tl(y / c)); x < y; )
          R[B++] = $n(s, x, x += c);
        return R;
      }
      function o9(s) {
        for (var c = -1, p = s == null ? 0 : s.length, y = 0, x = []; ++c < p; ) {
          var B = s[c];
          B && (x[y++] = B);
        }
        return x;
      }
      function i9() {
        var s = arguments.length;
        if (!s)
          return [];
        for (var c = te(s - 1), p = arguments[0], y = s; y--; )
          c[y - 1] = arguments[y];
        return di(Xe(p) ? Jr(p) : [p], jr(c, 1));
      }
      var a9 = tt(function(s, c) {
        return ur(s) ? ru(s, jr(c, 1, ur, !0)) : [];
      }), s9 = tt(function(s, c) {
        var p = Un(c);
        return ur(p) && (p = r), ur(s) ? ru(s, jr(c, 1, ur, !0), De(p, 2)) : [];
      }), u9 = tt(function(s, c) {
        var p = Un(c);
        return ur(p) && (p = r), ur(s) ? ru(s, jr(c, 1, ur, !0), r, p) : [];
      });
      function c9(s, c, p) {
        var y = s == null ? 0 : s.length;
        return y ? (c = p || c === r ? 1 : Qe(c), $n(s, c < 0 ? 0 : c, y)) : [];
      }
      function l9(s, c, p) {
        var y = s == null ? 0 : s.length;
        return y ? (c = p || c === r ? 1 : Qe(c), c = y - c, $n(s, 0, c < 0 ? 0 : c)) : [];
      }
      function f9(s, c) {
        return s && s.length ? fl(s, De(c, 3), !0, !0) : [];
      }
      function d9(s, c) {
        return s && s.length ? fl(s, De(c, 3), !0) : [];
      }
      function h9(s, c, p, y) {
        var x = s == null ? 0 : s.length;
        return x ? (p && typeof p != "number" && Gr(s, c, p) && (p = 0, y = x), i_(s, c, p, y)) : [];
      }
      function My(s, c, p) {
        var y = s == null ? 0 : s.length;
        if (!y)
          return -1;
        var x = p == null ? 0 : Qe(p);
        return x < 0 && (x = Or(y + x, 0)), Kc(s, De(c, 3), x);
      }
      function Dy(s, c, p) {
        var y = s == null ? 0 : s.length;
        if (!y)
          return -1;
        var x = y - 1;
        return p !== r && (x = Qe(p), x = p < 0 ? Or(y + x, 0) : Fr(x, y - 1)), Kc(s, De(c, 3), x, !0);
      }
      function Ky(s) {
        var c = s == null ? 0 : s.length;
        return c ? jr(s, 1) : [];
      }
      function p9(s) {
        var c = s == null ? 0 : s.length;
        return c ? jr(s, le) : [];
      }
      function g9(s, c) {
        var p = s == null ? 0 : s.length;
        return p ? (c = c === r ? 1 : Qe(c), jr(s, c)) : [];
      }
      function m9(s) {
        for (var c = -1, p = s == null ? 0 : s.length, y = {}; ++c < p; ) {
          var x = s[c];
          y[x[0]] = x[1];
        }
        return y;
      }
      function qy(s) {
        return s && s.length ? s[0] : r;
      }
      function y9(s, c, p) {
        var y = s == null ? 0 : s.length;
        if (!y)
          return -1;
        var x = p == null ? 0 : Qe(p);
        return x < 0 && (x = Or(y + x, 0)), ja(s, c, x);
      }
      function b9(s) {
        var c = s == null ? 0 : s.length;
        return c ? $n(s, 0, -1) : [];
      }
      var w9 = tt(function(s) {
        var c = Kt(s, Fh);
        return c.length && c[0] === s[0] ? Ch(c) : [];
      }), v9 = tt(function(s) {
        var c = Un(s), p = Kt(s, Fh);
        return c === Un(p) ? c = r : p.pop(), p.length && p[0] === s[0] ? Ch(p, De(c, 2)) : [];
      }), E9 = tt(function(s) {
        var c = Un(s), p = Kt(s, Fh);
        return c = typeof c == "function" ? c : r, c && p.pop(), p.length && p[0] === s[0] ? Ch(p, r, c) : [];
      });
      function _9(s, c) {
        return s == null ? "" : b7.call(s, c);
      }
      function Un(s) {
        var c = s == null ? 0 : s.length;
        return c ? s[c - 1] : r;
      }
      function A9(s, c, p) {
        var y = s == null ? 0 : s.length;
        if (!y)
          return -1;
        var x = y;
        return p !== r && (x = Qe(p), x = x < 0 ? Or(y + x, 0) : Fr(x, y - 1)), c === c ? r7(s, c, x) : Kc(s, km, x, !0);
      }
      function x9(s, c) {
        return s && s.length ? ry(s, Qe(c)) : r;
      }
      var k9 = tt(Vy);
      function Vy(s, c) {
        return s && s.length && c && c.length ? Uh(s, c) : s;
      }
      function S9(s, c, p) {
        return s && s.length && c && c.length ? Uh(s, c, De(p, 2)) : s;
      }
      function T9(s, c, p) {
        return s && s.length && c && c.length ? Uh(s, c, r, p) : s;
      }
      var I9 = No(function(s, c) {
        var p = s == null ? 0 : s.length, y = Th(s, c);
        return iy(s, Kt(c, function(x) {
          return $o(x, p) ? +x : x;
        }).sort(gy)), y;
      });
      function O9(s, c) {
        var p = [];
        if (!(s && s.length))
          return p;
        var y = -1, x = [], B = s.length;
        for (c = De(c, 3); ++y < B; ) {
          var R = s[y];
          c(R, y, s) && (p.push(R), x.push(y));
        }
        return iy(s, x), p;
      }
      function tp(s) {
        return s == null ? s : _7.call(s);
      }
      function P9(s, c, p) {
        var y = s == null ? 0 : s.length;
        return y ? (p && typeof p != "number" && Gr(s, c, p) ? (c = 0, p = y) : (c = c == null ? 0 : Qe(c), p = p === r ? y : Qe(p)), $n(s, c, p)) : [];
      }
      function C9(s, c) {
        return ll(s, c);
      }
      function B9(s, c, p) {
        return jh(s, c, De(p, 2));
      }
      function N9(s, c) {
        var p = s == null ? 0 : s.length;
        if (p) {
          var y = ll(s, c);
          if (y < p && Wn(s[y], c))
            return y;
        }
        return -1;
      }
      function $9(s, c) {
        return ll(s, c, !0);
      }
      function U9(s, c, p) {
        return jh(s, c, De(p, 2), !0);
      }
      function R9(s, c) {
        var p = s == null ? 0 : s.length;
        if (p) {
          var y = ll(s, c, !0) - 1;
          if (Wn(s[y], c))
            return y;
        }
        return -1;
      }
      function z9(s) {
        return s && s.length ? sy(s) : [];
      }
      function j9(s, c) {
        return s && s.length ? sy(s, De(c, 2)) : [];
      }
      function L9(s) {
        var c = s == null ? 0 : s.length;
        return c ? $n(s, 1, c) : [];
      }
      function H9(s, c, p) {
        return s && s.length ? (c = p || c === r ? 1 : Qe(c), $n(s, 0, c < 0 ? 0 : c)) : [];
      }
      function F9(s, c, p) {
        var y = s == null ? 0 : s.length;
        return y ? (c = p || c === r ? 1 : Qe(c), c = y - c, $n(s, c < 0 ? 0 : c, y)) : [];
      }
      function M9(s, c) {
        return s && s.length ? fl(s, De(c, 3), !1, !0) : [];
      }
      function D9(s, c) {
        return s && s.length ? fl(s, De(c, 3)) : [];
      }
      var K9 = tt(function(s) {
        return mi(jr(s, 1, ur, !0));
      }), q9 = tt(function(s) {
        var c = Un(s);
        return ur(c) && (c = r), mi(jr(s, 1, ur, !0), De(c, 2));
      }), V9 = tt(function(s) {
        var c = Un(s);
        return c = typeof c == "function" ? c : r, mi(jr(s, 1, ur, !0), r, c);
      });
      function G9(s) {
        return s && s.length ? mi(s) : [];
      }
      function W9(s, c) {
        return s && s.length ? mi(s, De(c, 2)) : [];
      }
      function Z9(s, c) {
        return c = typeof c == "function" ? c : r, s && s.length ? mi(s, r, c) : [];
      }
      function rp(s) {
        if (!(s && s.length))
          return [];
        var c = 0;
        return s = fi(s, function(p) {
          if (ur(p))
            return c = Or(p.length, c), !0;
        }), wh(c, function(p) {
          return Kt(s, mh(p));
        });
      }
      function Gy(s, c) {
        if (!(s && s.length))
          return [];
        var p = rp(s);
        return c == null ? p : Kt(p, function(y) {
          return bn(c, r, y);
        });
      }
      var X9 = tt(function(s, c) {
        return ur(s) ? ru(s, c) : [];
      }), Y9 = tt(function(s) {
        return Hh(fi(s, ur));
      }), J9 = tt(function(s) {
        var c = Un(s);
        return ur(c) && (c = r), Hh(fi(s, ur), De(c, 2));
      }), Q9 = tt(function(s) {
        var c = Un(s);
        return c = typeof c == "function" ? c : r, Hh(fi(s, ur), r, c);
      }), eA = tt(rp);
      function tA(s, c) {
        return fy(s || [], c || [], tu);
      }
      function rA(s, c) {
        return fy(s || [], c || [], iu);
      }
      var nA = tt(function(s) {
        var c = s.length, p = c > 1 ? s[c - 1] : r;
        return p = typeof p == "function" ? (s.pop(), p) : r, Gy(s, p);
      });
      function Wy(s) {
        var c = P(s);
        return c.__chain__ = !0, c;
      }
      function oA(s, c) {
        return c(s), s;
      }
      function vl(s, c) {
        return c(s);
      }
      var iA = No(function(s) {
        var c = s.length, p = c ? s[0] : 0, y = this.__wrapped__, x = function(B) {
          return Th(B, s);
        };
        return c > 1 || this.__actions__.length || !(y instanceof at) || !$o(p) ? this.thru(x) : (y = y.slice(p, +p + (c ? 1 : 0)), y.__actions__.push({
          func: vl,
          args: [x],
          thisArg: r
        }), new Bn(y, this.__chain__).thru(function(B) {
          return c && !B.length && B.push(r), B;
        }));
      });
      function aA() {
        return Wy(this);
      }
      function sA() {
        return new Bn(this.value(), this.__chain__);
      }
      function uA() {
        this.__values__ === r && (this.__values__ = ub(this.value()));
        var s = this.__index__ >= this.__values__.length, c = s ? r : this.__values__[this.__index__++];
        return { done: s, value: c };
      }
      function cA() {
        return this;
      }
      function lA(s) {
        for (var c, p = this; p instanceof il; ) {
          var y = Fy(p);
          y.__index__ = 0, y.__values__ = r, c ? x.__wrapped__ = y : c = y;
          var x = y;
          p = p.__wrapped__;
        }
        return x.__wrapped__ = s, c;
      }
      function fA() {
        var s = this.__wrapped__;
        if (s instanceof at) {
          var c = s;
          return this.__actions__.length && (c = new at(this)), c = c.reverse(), c.__actions__.push({
            func: vl,
            args: [tp],
            thisArg: r
          }), new Bn(c, this.__chain__);
        }
        return this.thru(tp);
      }
      function dA() {
        return ly(this.__wrapped__, this.__actions__);
      }
      var hA = dl(function(s, c, p) {
        St.call(s, p) ? ++s[p] : Co(s, p, 1);
      });
      function pA(s, c, p) {
        var y = Xe(s) ? Am : o_;
        return p && Gr(s, c, p) && (c = r), y(s, De(c, 3));
      }
      function gA(s, c) {
        var p = Xe(s) ? fi : Gm;
        return p(s, De(c, 3));
      }
      var mA = Ey(My), yA = Ey(Dy);
      function bA(s, c) {
        return jr(El(s, c), 1);
      }
      function wA(s, c) {
        return jr(El(s, c), le);
      }
      function vA(s, c, p) {
        return p = p === r ? 1 : Qe(p), jr(El(s, c), p);
      }
      function Zy(s, c) {
        var p = Xe(s) ? Pn : gi;
        return p(s, De(c, 3));
      }
      function Xy(s, c) {
        var p = Xe(s) ? L6 : Vm;
        return p(s, De(c, 3));
      }
      var EA = dl(function(s, c, p) {
        St.call(s, p) ? s[p].push(c) : Co(s, p, [c]);
      });
      function _A(s, c, p, y) {
        s = Qr(s) ? s : Xa(s), p = p && !y ? Qe(p) : 0;
        var x = s.length;
        return p < 0 && (p = Or(x + p, 0)), Sl(s) ? p <= x && s.indexOf(c, p) > -1 : !!x && ja(s, c, p) > -1;
      }
      var AA = tt(function(s, c, p) {
        var y = -1, x = typeof c == "function", B = Qr(s) ? te(s.length) : [];
        return gi(s, function(R) {
          B[++y] = x ? bn(c, R, p) : nu(R, c, p);
        }), B;
      }), xA = dl(function(s, c, p) {
        Co(s, p, c);
      });
      function El(s, c) {
        var p = Xe(s) ? Kt : Qm;
        return p(s, De(c, 3));
      }
      function kA(s, c, p, y) {
        return s == null ? [] : (Xe(c) || (c = c == null ? [] : [c]), p = y ? r : p, Xe(p) || (p = p == null ? [] : [p]), ny(s, c, p));
      }
      var SA = dl(function(s, c, p) {
        s[p ? 0 : 1].push(c);
      }, function() {
        return [[], []];
      });
      function TA(s, c, p) {
        var y = Xe(s) ? ph : Tm, x = arguments.length < 3;
        return y(s, De(c, 4), p, x, gi);
      }
      function IA(s, c, p) {
        var y = Xe(s) ? H6 : Tm, x = arguments.length < 3;
        return y(s, De(c, 4), p, x, Vm);
      }
      function OA(s, c) {
        var p = Xe(s) ? fi : Gm;
        return p(s, xl(De(c, 3)));
      }
      function PA(s) {
        var c = Xe(s) ? Mm : __;
        return c(s);
      }
      function CA(s, c, p) {
        (p ? Gr(s, c, p) : c === r) ? c = 1 : c = Qe(c);
        var y = Xe(s) ? Q7 : A_;
        return y(s, c);
      }
      function BA(s) {
        var c = Xe(s) ? e_ : k_;
        return c(s);
      }
      function NA(s) {
        if (s == null)
          return 0;
        if (Qr(s))
          return Sl(s) ? Ha(s) : s.length;
        var c = Mr(s);
        return c == ge || c == _t ? s.size : Nh(s).length;
      }
      function $A(s, c, p) {
        var y = Xe(s) ? gh : S_;
        return p && Gr(s, c, p) && (c = r), y(s, De(c, 3));
      }
      var UA = tt(function(s, c) {
        if (s == null)
          return [];
        var p = c.length;
        return p > 1 && Gr(s, c[0], c[1]) ? c = [] : p > 2 && Gr(c[0], c[1], c[2]) && (c = [c[0]]), ny(s, jr(c, 1), []);
      }), _l = g7 || function() {
        return zr.Date.now();
      };
      function RA(s, c) {
        if (typeof c != "function")
          throw new Cn(a);
        return s = Qe(s), function() {
          if (--s < 1)
            return c.apply(this, arguments);
        };
      }
      function Yy(s, c, p) {
        return c = p ? r : c, c = s && c == null ? s.length : c, Bo(s, $, r, r, r, r, c);
      }
      function Jy(s, c) {
        var p;
        if (typeof c != "function")
          throw new Cn(a);
        return s = Qe(s), function() {
          return --s > 0 && (p = c.apply(this, arguments)), s <= 1 && (c = r), p;
        };
      }
      var np = tt(function(s, c, p) {
        var y = _;
        if (p.length) {
          var x = hi(p, Wa(np));
          y |= T;
        }
        return Bo(s, y, c, p, x);
      }), Qy = tt(function(s, c, p) {
        var y = _ | O;
        if (p.length) {
          var x = hi(p, Wa(Qy));
          y |= T;
        }
        return Bo(c, y, s, p, x);
      });
      function eb(s, c, p) {
        c = p ? r : c;
        var y = Bo(s, I, r, r, r, r, r, c);
        return y.placeholder = eb.placeholder, y;
      }
      function tb(s, c, p) {
        c = p ? r : c;
        var y = Bo(s, S, r, r, r, r, r, c);
        return y.placeholder = tb.placeholder, y;
      }
      function rb(s, c, p) {
        var y, x, B, R, F, Z, ce = 0, fe = !1, pe = !1, Se = !0;
        if (typeof s != "function")
          throw new Cn(a);
        c = Rn(c) || 0, Xt(p) && (fe = !!p.leading, pe = "maxWait" in p, B = pe ? Or(Rn(p.maxWait) || 0, c) : B, Se = "trailing" in p ? !!p.trailing : Se);
        function $e(cr) {
          var Zn = y, zo = x;
          return y = x = r, ce = cr, R = s.apply(zo, Zn), R;
        }
        function Ke(cr) {
          return ce = cr, F = uu(ot, c), fe ? $e(cr) : R;
        }
        function et(cr) {
          var Zn = cr - Z, zo = cr - ce, Eb = c - Zn;
          return pe ? Fr(Eb, B - zo) : Eb;
        }
        function qe(cr) {
          var Zn = cr - Z, zo = cr - ce;
          return Z === r || Zn >= c || Zn < 0 || pe && zo >= B;
        }
        function ot() {
          var cr = _l();
          if (qe(cr))
            return lt(cr);
          F = uu(ot, et(cr));
        }
        function lt(cr) {
          return F = r, Se && y ? $e(cr) : (y = x = r, R);
        }
        function _n() {
          F !== r && dy(F), ce = 0, y = Z = x = F = r;
        }
        function Wr() {
          return F === r ? R : lt(_l());
        }
        function An() {
          var cr = _l(), Zn = qe(cr);
          if (y = arguments, x = this, Z = cr, Zn) {
            if (F === r)
              return Ke(Z);
            if (pe)
              return dy(F), F = uu(ot, c), $e(Z);
          }
          return F === r && (F = uu(ot, c)), R;
        }
        return An.cancel = _n, An.flush = Wr, An;
      }
      var zA = tt(function(s, c) {
        return qm(s, 1, c);
      }), jA = tt(function(s, c, p) {
        return qm(s, Rn(c) || 0, p);
      });
      function LA(s) {
        return Bo(s, M);
      }
      function Al(s, c) {
        if (typeof s != "function" || c != null && typeof c != "function")
          throw new Cn(a);
        var p = function() {
          var y = arguments, x = c ? c.apply(this, y) : y[0], B = p.cache;
          if (B.has(x))
            return B.get(x);
          var R = s.apply(this, y);
          return p.cache = B.set(x, R) || B, R;
        };
        return p.cache = new (Al.Cache || Po)(), p;
      }
      Al.Cache = Po;
      function xl(s) {
        if (typeof s != "function")
          throw new Cn(a);
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return !s.call(this);
            case 1:
              return !s.call(this, c[0]);
            case 2:
              return !s.call(this, c[0], c[1]);
            case 3:
              return !s.call(this, c[0], c[1], c[2]);
          }
          return !s.apply(this, c);
        };
      }
      function HA(s) {
        return Jy(2, s);
      }
      var FA = T_(function(s, c) {
        c = c.length == 1 && Xe(c[0]) ? Kt(c[0], wn(De())) : Kt(jr(c, 1), wn(De()));
        var p = c.length;
        return tt(function(y) {
          for (var x = -1, B = Fr(y.length, p); ++x < B; )
            y[x] = c[x].call(this, y[x]);
          return bn(s, this, y);
        });
      }), op = tt(function(s, c) {
        var p = hi(c, Wa(op));
        return Bo(s, T, r, c, p);
      }), nb = tt(function(s, c) {
        var p = hi(c, Wa(nb));
        return Bo(s, A, r, c, p);
      }), MA = No(function(s, c) {
        return Bo(s, U, r, r, r, c);
      });
      function DA(s, c) {
        if (typeof s != "function")
          throw new Cn(a);
        return c = c === r ? c : Qe(c), tt(s, c);
      }
      function KA(s, c) {
        if (typeof s != "function")
          throw new Cn(a);
        return c = c == null ? 0 : Or(Qe(c), 0), tt(function(p) {
          var y = p[c], x = bi(p, 0, c);
          return y && di(x, y), bn(s, this, x);
        });
      }
      function qA(s, c, p) {
        var y = !0, x = !0;
        if (typeof s != "function")
          throw new Cn(a);
        return Xt(p) && (y = "leading" in p ? !!p.leading : y, x = "trailing" in p ? !!p.trailing : x), rb(s, c, {
          leading: y,
          maxWait: c,
          trailing: x
        });
      }
      function VA(s) {
        return Yy(s, 1);
      }
      function GA(s, c) {
        return op(Mh(c), s);
      }
      function WA() {
        if (!arguments.length)
          return [];
        var s = arguments[0];
        return Xe(s) ? s : [s];
      }
      function ZA(s) {
        return Nn(s, b);
      }
      function XA(s, c) {
        return c = typeof c == "function" ? c : r, Nn(s, b, c);
      }
      function YA(s) {
        return Nn(s, h | b);
      }
      function JA(s, c) {
        return c = typeof c == "function" ? c : r, Nn(s, h | b, c);
      }
      function QA(s, c) {
        return c == null || Km(s, c, $r(c));
      }
      function Wn(s, c) {
        return s === c || s !== s && c !== c;
      }
      var ex = ml(Ph), tx = ml(function(s, c) {
        return s >= c;
      }), ta = Xm(/* @__PURE__ */ function() {
        return arguments;
      }()) ? Xm : function(s) {
        return Qt(s) && St.call(s, "callee") && !Rm.call(s, "callee");
      }, Xe = te.isArray, rx = ym ? wn(ym) : l_;
      function Qr(s) {
        return s != null && kl(s.length) && !Uo(s);
      }
      function ur(s) {
        return Qt(s) && Qr(s);
      }
      function nx(s) {
        return s === !0 || s === !1 || Qt(s) && Vr(s) == we;
      }
      var wi = y7 || gp, ox = bm ? wn(bm) : f_;
      function ix(s) {
        return Qt(s) && s.nodeType === 1 && !cu(s);
      }
      function ax(s) {
        if (s == null)
          return !0;
        if (Qr(s) && (Xe(s) || typeof s == "string" || typeof s.splice == "function" || wi(s) || Za(s) || ta(s)))
          return !s.length;
        var c = Mr(s);
        if (c == ge || c == _t)
          return !s.size;
        if (su(s))
          return !Nh(s).length;
        for (var p in s)
          if (St.call(s, p))
            return !1;
        return !0;
      }
      function sx(s, c) {
        return ou(s, c);
      }
      function ux(s, c, p) {
        p = typeof p == "function" ? p : r;
        var y = p ? p(s, c) : r;
        return y === r ? ou(s, c, r, p) : !!y;
      }
      function ip(s) {
        if (!Qt(s))
          return !1;
        var c = Vr(s);
        return c == Le || c == Ge || typeof s.message == "string" && typeof s.name == "string" && !cu(s);
      }
      function cx(s) {
        return typeof s == "number" && jm(s);
      }
      function Uo(s) {
        if (!Xt(s))
          return !1;
        var c = Vr(s);
        return c == Ne || c == Ve || c == _e || c == rt;
      }
      function ob(s) {
        return typeof s == "number" && s == Qe(s);
      }
      function kl(s) {
        return typeof s == "number" && s > -1 && s % 1 == 0 && s <= re;
      }
      function Xt(s) {
        var c = typeof s;
        return s != null && (c == "object" || c == "function");
      }
      function Qt(s) {
        return s != null && typeof s == "object";
      }
      var ib = wm ? wn(wm) : h_;
      function lx(s, c) {
        return s === c || Bh(s, c, Zh(c));
      }
      function fx(s, c, p) {
        return p = typeof p == "function" ? p : r, Bh(s, c, Zh(c), p);
      }
      function dx(s) {
        return ab(s) && s != +s;
      }
      function hx(s) {
        if (X_(s))
          throw new Ze(i);
        return Ym(s);
      }
      function px(s) {
        return s === null;
      }
      function gx(s) {
        return s == null;
      }
      function ab(s) {
        return typeof s == "number" || Qt(s) && Vr(s) == Te;
      }
      function cu(s) {
        if (!Qt(s) || Vr(s) != He)
          return !1;
        var c = Jc(s);
        if (c === null)
          return !0;
        var p = St.call(c, "constructor") && c.constructor;
        return typeof p == "function" && p instanceof p && Wc.call(p) == f7;
      }
      var ap = vm ? wn(vm) : p_;
      function mx(s) {
        return ob(s) && s >= -9007199254740991 && s <= re;
      }
      var sb = Em ? wn(Em) : g_;
      function Sl(s) {
        return typeof s == "string" || !Xe(s) && Qt(s) && Vr(s) == yt;
      }
      function En(s) {
        return typeof s == "symbol" || Qt(s) && Vr(s) == Zt;
      }
      var Za = _m ? wn(_m) : m_;
      function yx(s) {
        return s === r;
      }
      function bx(s) {
        return Qt(s) && Mr(s) == kt;
      }
      function wx(s) {
        return Qt(s) && Vr(s) == qr;
      }
      var vx = ml($h), Ex = ml(function(s, c) {
        return s <= c;
      });
      function ub(s) {
        if (!s)
          return [];
        if (Qr(s))
          return Sl(s) ? Vn(s) : Jr(s);
        if (Xs && s[Xs])
          return Q6(s[Xs]());
        var c = Mr(s), p = c == ge ? Eh : c == _t ? qc : Xa;
        return p(s);
      }
      function Ro(s) {
        if (!s)
          return s === 0 ? s : 0;
        if (s = Rn(s), s === le || s === -1 / 0) {
          var c = s < 0 ? -1 : 1;
          return c * G;
        }
        return s === s ? s : 0;
      }
      function Qe(s) {
        var c = Ro(s), p = c % 1;
        return c === c ? p ? c - p : c : 0;
      }
      function cb(s) {
        return s ? Yi(Qe(s), 0, Q) : 0;
      }
      function Rn(s) {
        if (typeof s == "number")
          return s;
        if (En(s))
          return q;
        if (Xt(s)) {
          var c = typeof s.valueOf == "function" ? s.valueOf() : s;
          s = Xt(c) ? c + "" : c;
        }
        if (typeof s != "string")
          return s === 0 ? s : +s;
        s = Im(s);
        var p = Ra.test(s);
        return p || Vi.test(s) ? R6(s.slice(2), p ? 2 : 8) : li.test(s) ? q : +s;
      }
      function lb(s) {
        return po(s, en(s));
      }
      function _x(s) {
        return s ? Yi(Qe(s), -9007199254740991, re) : s === 0 ? s : 0;
      }
      function xt(s) {
        return s == null ? "" : vn(s);
      }
      var Ax = Va(function(s, c) {
        if (su(c) || Qr(c)) {
          po(c, $r(c), s);
          return;
        }
        for (var p in c)
          St.call(c, p) && tu(s, p, c[p]);
      }), fb = Va(function(s, c) {
        po(c, en(c), s);
      }), Tl = Va(function(s, c, p, y) {
        po(c, en(c), s, y);
      }), xx = Va(function(s, c, p, y) {
        po(c, $r(c), s, y);
      }), kx = No(Th);
      function Sx(s, c) {
        var p = qa(s);
        return c == null ? p : Dm(p, c);
      }
      var Tx = tt(function(s, c) {
        s = Bt(s);
        var p = -1, y = c.length, x = y > 2 ? c[2] : r;
        for (x && Gr(c[0], c[1], x) && (y = 1); ++p < y; )
          for (var B = c[p], R = en(B), F = -1, Z = R.length; ++F < Z; ) {
            var ce = R[F], fe = s[ce];
            (fe === r || Wn(fe, Ma[ce]) && !St.call(s, ce)) && (s[ce] = B[ce]);
          }
        return s;
      }), Ix = tt(function(s) {
        return s.push(r, Iy), bn(db, r, s);
      });
      function Ox(s, c) {
        return xm(s, De(c, 3), ho);
      }
      function Px(s, c) {
        return xm(s, De(c, 3), Oh);
      }
      function Cx(s, c) {
        return s == null ? s : Ih(s, De(c, 3), en);
      }
      function Bx(s, c) {
        return s == null ? s : Wm(s, De(c, 3), en);
      }
      function Nx(s, c) {
        return s && ho(s, De(c, 3));
      }
      function $x(s, c) {
        return s && Oh(s, De(c, 3));
      }
      function Ux(s) {
        return s == null ? [] : ul(s, $r(s));
      }
      function Rx(s) {
        return s == null ? [] : ul(s, en(s));
      }
      function sp(s, c, p) {
        var y = s == null ? r : Ji(s, c);
        return y === r ? p : y;
      }
      function zx(s, c) {
        return s != null && Cy(s, c, a_);
      }
      function up(s, c) {
        return s != null && Cy(s, c, s_);
      }
      var jx = Ay(function(s, c, p) {
        c != null && typeof c.toString != "function" && (c = Zc.call(c)), s[c] = p;
      }, lp(tn)), Lx = Ay(function(s, c, p) {
        c != null && typeof c.toString != "function" && (c = Zc.call(c)), St.call(s, c) ? s[c].push(p) : s[c] = [p];
      }, De), Hx = tt(nu);
      function $r(s) {
        return Qr(s) ? Fm(s) : Nh(s);
      }
      function en(s) {
        return Qr(s) ? Fm(s, !0) : y_(s);
      }
      function Fx(s, c) {
        var p = {};
        return c = De(c, 3), ho(s, function(y, x, B) {
          Co(p, c(y, x, B), y);
        }), p;
      }
      function Mx(s, c) {
        var p = {};
        return c = De(c, 3), ho(s, function(y, x, B) {
          Co(p, x, c(y, x, B));
        }), p;
      }
      var Dx = Va(function(s, c, p) {
        cl(s, c, p);
      }), db = Va(function(s, c, p, y) {
        cl(s, c, p, y);
      }), Kx = No(function(s, c) {
        var p = {};
        if (s == null)
          return p;
        var y = !1;
        c = Kt(c, function(B) {
          return B = yi(B, s), y || (y = B.length > 1), B;
        }), po(s, Gh(s), p), y && (p = Nn(p, h | g | b, j_));
        for (var x = c.length; x--; )
          Lh(p, c[x]);
        return p;
      });
      function qx(s, c) {
        return hb(s, xl(De(c)));
      }
      var Vx = No(function(s, c) {
        return s == null ? {} : w_(s, c);
      });
      function hb(s, c) {
        if (s == null)
          return {};
        var p = Kt(Gh(s), function(y) {
          return [y];
        });
        return c = De(c), oy(s, p, function(y, x) {
          return c(y, x[0]);
        });
      }
      function Gx(s, c, p) {
        c = yi(c, s);
        var y = -1, x = c.length;
        for (x || (x = 1, s = r); ++y < x; ) {
          var B = s == null ? r : s[go(c[y])];
          B === r && (y = x, B = p), s = Uo(B) ? B.call(s) : B;
        }
        return s;
      }
      function Wx(s, c, p) {
        return s == null ? s : iu(s, c, p);
      }
      function Zx(s, c, p, y) {
        return y = typeof y == "function" ? y : r, s == null ? s : iu(s, c, p, y);
      }
      var pb = Sy($r), gb = Sy(en);
      function Xx(s, c, p) {
        var y = Xe(s), x = y || wi(s) || Za(s);
        if (c = De(c, 4), p == null) {
          var B = s && s.constructor;
          x ? p = y ? new B() : [] : Xt(s) ? p = Uo(B) ? qa(Jc(s)) : {} : p = {};
        }
        return (x ? Pn : ho)(s, function(R, F, Z) {
          return c(p, R, F, Z);
        }), p;
      }
      function Yx(s, c) {
        return s == null ? !0 : Lh(s, c);
      }
      function Jx(s, c, p) {
        return s == null ? s : cy(s, c, Mh(p));
      }
      function Qx(s, c, p, y) {
        return y = typeof y == "function" ? y : r, s == null ? s : cy(s, c, Mh(p), y);
      }
      function Xa(s) {
        return s == null ? [] : vh(s, $r(s));
      }
      function ek(s) {
        return s == null ? [] : vh(s, en(s));
      }
      function tk(s, c, p) {
        return p === r && (p = c, c = r), p !== r && (p = Rn(p), p = p === p ? p : 0), c !== r && (c = Rn(c), c = c === c ? c : 0), Yi(Rn(s), c, p);
      }
      function rk(s, c, p) {
        return c = Ro(c), p === r ? (p = c, c = 0) : p = Ro(p), s = Rn(s), u_(s, c, p);
      }
      function nk(s, c, p) {
        if (p && typeof p != "boolean" && Gr(s, c, p) && (c = p = r), p === r && (typeof c == "boolean" ? (p = c, c = r) : typeof s == "boolean" && (p = s, s = r)), s === r && c === r ? (s = 0, c = 1) : (s = Ro(s), c === r ? (c = s, s = 0) : c = Ro(c)), s > c) {
          var y = s;
          s = c, c = y;
        }
        if (p || s % 1 || c % 1) {
          var x = Lm();
          return Fr(s + x * (c - s + U6("1e-" + ((x + "").length - 1))), c);
        }
        return Rh(s, c);
      }
      var ok = Ga(function(s, c, p) {
        return c = c.toLowerCase(), s + (p ? mb(c) : c);
      });
      function mb(s) {
        return cp(xt(s).toLowerCase());
      }
      function yb(s) {
        return s = xt(s), s && s.replace(a6, W6).replace(k6, "");
      }
      function ik(s, c, p) {
        s = xt(s), c = vn(c);
        var y = s.length;
        p = p === r ? y : Yi(Qe(p), 0, y);
        var x = p;
        return p -= c.length, p >= 0 && s.slice(p, x) == c;
      }
      function ak(s) {
        return s = xt(s), s && Ua.test(s) ? s.replace(Hr, Z6) : s;
      }
      function sk(s) {
        return s = xt(s), s && Ie.test(s) ? s.replace(Ae, "\\$&") : s;
      }
      var uk = Ga(function(s, c, p) {
        return s + (p ? "-" : "") + c.toLowerCase();
      }), ck = Ga(function(s, c, p) {
        return s + (p ? " " : "") + c.toLowerCase();
      }), lk = vy("toLowerCase");
      function fk(s, c, p) {
        s = xt(s), c = Qe(c);
        var y = c ? Ha(s) : 0;
        if (!c || y >= c)
          return s;
        var x = (c - y) / 2;
        return gl(rl(x), p) + s + gl(tl(x), p);
      }
      function dk(s, c, p) {
        s = xt(s), c = Qe(c);
        var y = c ? Ha(s) : 0;
        return c && y < c ? s + gl(c - y, p) : s;
      }
      function hk(s, c, p) {
        s = xt(s), c = Qe(c);
        var y = c ? Ha(s) : 0;
        return c && y < c ? gl(c - y, p) + s : s;
      }
      function pk(s, c, p) {
        return p || c == null ? c = 0 : c && (c = +c), E7(xt(s).replace(Me, ""), c || 0);
      }
      function gk(s, c, p) {
        return (p ? Gr(s, c, p) : c === r) ? c = 1 : c = Qe(c), zh(xt(s), c);
      }
      function mk() {
        var s = arguments, c = xt(s[0]);
        return s.length < 3 ? c : c.replace(s[1], s[2]);
      }
      var yk = Ga(function(s, c, p) {
        return s + (p ? "_" : "") + c.toLowerCase();
      });
      function bk(s, c, p) {
        return p && typeof p != "number" && Gr(s, c, p) && (c = p = r), p = p === r ? Q : p >>> 0, p ? (s = xt(s), s && (typeof c == "string" || c != null && !ap(c)) && (c = vn(c), !c && La(s)) ? bi(Vn(s), 0, p) : s.split(c, p)) : [];
      }
      var wk = Ga(function(s, c, p) {
        return s + (p ? " " : "") + cp(c);
      });
      function vk(s, c, p) {
        return s = xt(s), p = p == null ? 0 : Yi(Qe(p), 0, s.length), c = vn(c), s.slice(p, p + c.length) == c;
      }
      function Ek(s, c, p) {
        var y = P.templateSettings;
        p && Gr(s, c, p) && (c = r), s = xt(s), c = Tl({}, c, y, Ty);
        var x = Tl({}, c.imports, y.imports, Ty), B = $r(x), R = vh(x, B), F, Z, ce = 0, fe = c.interpolate || Hc, pe = "__p += '", Se = _h(
          (c.escape || Hc).source + "|" + fe.source + "|" + (fe === z ? ci : Hc).source + "|" + (c.evaluate || Hc).source + "|$",
          "g"
        ), $e = "//# sourceURL=" + (St.call(c, "sourceURL") ? (c.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++P6 + "]") + `
`;
        s.replace(Se, function(qe, ot, lt, _n, Wr, An) {
          return lt || (lt = _n), pe += s.slice(ce, An).replace(s6, X6), ot && (F = !0, pe += `' +
__e(` + ot + `) +
'`), Wr && (Z = !0, pe += `';
` + Wr + `;
__p += '`), lt && (pe += `' +
((__t = (` + lt + `)) == null ? '' : __t) +
'`), ce = An + qe.length, qe;
        }), pe += `';
`;
        var Ke = St.call(c, "variable") && c.variable;
        if (!Ke)
          pe = `with (obj) {
` + pe + `
}
`;
        else if (sr.test(Ke))
          throw new Ze(u);
        pe = (Z ? pe.replace(Ht, "") : pe).replace(jc, "$1").replace(Lc, "$1;"), pe = "function(" + (Ke || "obj") + `) {
` + (Ke ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (F ? ", __e = _.escape" : "") + (Z ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + pe + `return __p
}`;
        var et = wb(function() {
          return Et(B, $e + "return " + pe).apply(r, R);
        });
        if (et.source = pe, ip(et))
          throw et;
        return et;
      }
      function _k(s) {
        return xt(s).toLowerCase();
      }
      function Ak(s) {
        return xt(s).toUpperCase();
      }
      function xk(s, c, p) {
        if (s = xt(s), s && (p || c === r))
          return Im(s);
        if (!s || !(c = vn(c)))
          return s;
        var y = Vn(s), x = Vn(c), B = Om(y, x), R = Pm(y, x) + 1;
        return bi(y, B, R).join("");
      }
      function kk(s, c, p) {
        if (s = xt(s), s && (p || c === r))
          return s.slice(0, Bm(s) + 1);
        if (!s || !(c = vn(c)))
          return s;
        var y = Vn(s), x = Pm(y, Vn(c)) + 1;
        return bi(y, 0, x).join("");
      }
      function Sk(s, c, p) {
        if (s = xt(s), s && (p || c === r))
          return s.replace(Me, "");
        if (!s || !(c = vn(c)))
          return s;
        var y = Vn(s), x = Om(y, Vn(c));
        return bi(y, x).join("");
      }
      function Tk(s, c) {
        var p = Y, y = L;
        if (Xt(c)) {
          var x = "separator" in c ? c.separator : x;
          p = "length" in c ? Qe(c.length) : p, y = "omission" in c ? vn(c.omission) : y;
        }
        s = xt(s);
        var B = s.length;
        if (La(s)) {
          var R = Vn(s);
          B = R.length;
        }
        if (p >= B)
          return s;
        var F = p - Ha(y);
        if (F < 1)
          return y;
        var Z = R ? bi(R, 0, F).join("") : s.slice(0, F);
        if (x === r)
          return Z + y;
        if (R && (F += Z.length - F), ap(x)) {
          if (s.slice(F).search(x)) {
            var ce, fe = Z;
            for (x.global || (x = _h(x.source, xt(Io.exec(x)) + "g")), x.lastIndex = 0; ce = x.exec(fe); )
              var pe = ce.index;
            Z = Z.slice(0, pe === r ? F : pe);
          }
        } else if (s.indexOf(vn(x), F) != F) {
          var Se = Z.lastIndexOf(x);
          Se > -1 && (Z = Z.slice(0, Se));
        }
        return Z + y;
      }
      function Ik(s) {
        return s = xt(s), s && fo.test(s) ? s.replace(Gs, n7) : s;
      }
      var Ok = Ga(function(s, c, p) {
        return s + (p ? " " : "") + c.toUpperCase();
      }), cp = vy("toUpperCase");
      function bb(s, c, p) {
        return s = xt(s), c = p ? r : c, c === r ? J6(s) ? a7(s) : D6(s) : s.match(c) || [];
      }
      var wb = tt(function(s, c) {
        try {
          return bn(s, r, c);
        } catch (p) {
          return ip(p) ? p : new Ze(p);
        }
      }), Pk = No(function(s, c) {
        return Pn(c, function(p) {
          p = go(p), Co(s, p, np(s[p], s));
        }), s;
      });
      function Ck(s) {
        var c = s == null ? 0 : s.length, p = De();
        return s = c ? Kt(s, function(y) {
          if (typeof y[1] != "function")
            throw new Cn(a);
          return [p(y[0]), y[1]];
        }) : [], tt(function(y) {
          for (var x = -1; ++x < c; ) {
            var B = s[x];
            if (bn(B[0], this, y))
              return bn(B[1], this, y);
          }
        });
      }
      function Bk(s) {
        return n_(Nn(s, h));
      }
      function lp(s) {
        return function() {
          return s;
        };
      }
      function Nk(s, c) {
        return s == null || s !== s ? c : s;
      }
      var $k = _y(), Uk = _y(!0);
      function tn(s) {
        return s;
      }
      function fp(s) {
        return Jm(typeof s == "function" ? s : Nn(s, h));
      }
      function Rk(s) {
        return ey(Nn(s, h));
      }
      function zk(s, c) {
        return ty(s, Nn(c, h));
      }
      var jk = tt(function(s, c) {
        return function(p) {
          return nu(p, s, c);
        };
      }), Lk = tt(function(s, c) {
        return function(p) {
          return nu(s, p, c);
        };
      });
      function dp(s, c, p) {
        var y = $r(c), x = ul(c, y);
        p == null && !(Xt(c) && (x.length || !y.length)) && (p = c, c = s, s = this, x = ul(c, $r(c)));
        var B = !(Xt(p) && "chain" in p) || !!p.chain, R = Uo(s);
        return Pn(x, function(F) {
          var Z = c[F];
          s[F] = Z, R && (s.prototype[F] = function() {
            var ce = this.__chain__;
            if (B || ce) {
              var fe = s(this.__wrapped__), pe = fe.__actions__ = Jr(this.__actions__);
              return pe.push({ func: Z, args: arguments, thisArg: s }), fe.__chain__ = ce, fe;
            }
            return Z.apply(s, di([this.value()], arguments));
          });
        }), s;
      }
      function Hk() {
        return zr._ === this && (zr._ = d7), this;
      }
      function hp() {
      }
      function Fk(s) {
        return s = Qe(s), tt(function(c) {
          return ry(c, s);
        });
      }
      var Mk = Kh(Kt), Dk = Kh(Am), Kk = Kh(gh);
      function vb(s) {
        return Yh(s) ? mh(go(s)) : v_(s);
      }
      function qk(s) {
        return function(c) {
          return s == null ? r : Ji(s, c);
        };
      }
      var Vk = xy(), Gk = xy(!0);
      function pp() {
        return [];
      }
      function gp() {
        return !1;
      }
      function Wk() {
        return {};
      }
      function Zk() {
        return "";
      }
      function Xk() {
        return !0;
      }
      function Yk(s, c) {
        if (s = Qe(s), s < 1 || s > re)
          return [];
        var p = Q, y = Fr(s, Q);
        c = De(c), s -= Q;
        for (var x = wh(y, c); ++p < s; )
          c(p);
        return x;
      }
      function Jk(s) {
        return Xe(s) ? Kt(s, go) : En(s) ? [s] : Jr(Hy(xt(s)));
      }
      function Qk(s) {
        var c = ++l7;
        return xt(s) + c;
      }
      var eS = pl(function(s, c) {
        return s + c;
      }, 0), tS = qh("ceil"), rS = pl(function(s, c) {
        return s / c;
      }, 1), nS = qh("floor");
      function oS(s) {
        return s && s.length ? sl(s, tn, Ph) : r;
      }
      function iS(s, c) {
        return s && s.length ? sl(s, De(c, 2), Ph) : r;
      }
      function aS(s) {
        return Sm(s, tn);
      }
      function sS(s, c) {
        return Sm(s, De(c, 2));
      }
      function uS(s) {
        return s && s.length ? sl(s, tn, $h) : r;
      }
      function cS(s, c) {
        return s && s.length ? sl(s, De(c, 2), $h) : r;
      }
      var lS = pl(function(s, c) {
        return s * c;
      }, 1), fS = qh("round"), dS = pl(function(s, c) {
        return s - c;
      }, 0);
      function hS(s) {
        return s && s.length ? bh(s, tn) : 0;
      }
      function pS(s, c) {
        return s && s.length ? bh(s, De(c, 2)) : 0;
      }
      return P.after = RA, P.ary = Yy, P.assign = Ax, P.assignIn = fb, P.assignInWith = Tl, P.assignWith = xx, P.at = kx, P.before = Jy, P.bind = np, P.bindAll = Pk, P.bindKey = Qy, P.castArray = WA, P.chain = Wy, P.chunk = n9, P.compact = o9, P.concat = i9, P.cond = Ck, P.conforms = Bk, P.constant = lp, P.countBy = hA, P.create = Sx, P.curry = eb, P.curryRight = tb, P.debounce = rb, P.defaults = Tx, P.defaultsDeep = Ix, P.defer = zA, P.delay = jA, P.difference = a9, P.differenceBy = s9, P.differenceWith = u9, P.drop = c9, P.dropRight = l9, P.dropRightWhile = f9, P.dropWhile = d9, P.fill = h9, P.filter = gA, P.flatMap = bA, P.flatMapDeep = wA, P.flatMapDepth = vA, P.flatten = Ky, P.flattenDeep = p9, P.flattenDepth = g9, P.flip = LA, P.flow = $k, P.flowRight = Uk, P.fromPairs = m9, P.functions = Ux, P.functionsIn = Rx, P.groupBy = EA, P.initial = b9, P.intersection = w9, P.intersectionBy = v9, P.intersectionWith = E9, P.invert = jx, P.invertBy = Lx, P.invokeMap = AA, P.iteratee = fp, P.keyBy = xA, P.keys = $r, P.keysIn = en, P.map = El, P.mapKeys = Fx, P.mapValues = Mx, P.matches = Rk, P.matchesProperty = zk, P.memoize = Al, P.merge = Dx, P.mergeWith = db, P.method = jk, P.methodOf = Lk, P.mixin = dp, P.negate = xl, P.nthArg = Fk, P.omit = Kx, P.omitBy = qx, P.once = HA, P.orderBy = kA, P.over = Mk, P.overArgs = FA, P.overEvery = Dk, P.overSome = Kk, P.partial = op, P.partialRight = nb, P.partition = SA, P.pick = Vx, P.pickBy = hb, P.property = vb, P.propertyOf = qk, P.pull = k9, P.pullAll = Vy, P.pullAllBy = S9, P.pullAllWith = T9, P.pullAt = I9, P.range = Vk, P.rangeRight = Gk, P.rearg = MA, P.reject = OA, P.remove = O9, P.rest = DA, P.reverse = tp, P.sampleSize = CA, P.set = Wx, P.setWith = Zx, P.shuffle = BA, P.slice = P9, P.sortBy = UA, P.sortedUniq = z9, P.sortedUniqBy = j9, P.split = bk, P.spread = KA, P.tail = L9, P.take = H9, P.takeRight = F9, P.takeRightWhile = M9, P.takeWhile = D9, P.tap = oA, P.throttle = qA, P.thru = vl, P.toArray = ub, P.toPairs = pb, P.toPairsIn = gb, P.toPath = Jk, P.toPlainObject = lb, P.transform = Xx, P.unary = VA, P.union = K9, P.unionBy = q9, P.unionWith = V9, P.uniq = G9, P.uniqBy = W9, P.uniqWith = Z9, P.unset = Yx, P.unzip = rp, P.unzipWith = Gy, P.update = Jx, P.updateWith = Qx, P.values = Xa, P.valuesIn = ek, P.without = X9, P.words = bb, P.wrap = GA, P.xor = Y9, P.xorBy = J9, P.xorWith = Q9, P.zip = eA, P.zipObject = tA, P.zipObjectDeep = rA, P.zipWith = nA, P.entries = pb, P.entriesIn = gb, P.extend = fb, P.extendWith = Tl, dp(P, P), P.add = eS, P.attempt = wb, P.camelCase = ok, P.capitalize = mb, P.ceil = tS, P.clamp = tk, P.clone = ZA, P.cloneDeep = YA, P.cloneDeepWith = JA, P.cloneWith = XA, P.conformsTo = QA, P.deburr = yb, P.defaultTo = Nk, P.divide = rS, P.endsWith = ik, P.eq = Wn, P.escape = ak, P.escapeRegExp = sk, P.every = pA, P.find = mA, P.findIndex = My, P.findKey = Ox, P.findLast = yA, P.findLastIndex = Dy, P.findLastKey = Px, P.floor = nS, P.forEach = Zy, P.forEachRight = Xy, P.forIn = Cx, P.forInRight = Bx, P.forOwn = Nx, P.forOwnRight = $x, P.get = sp, P.gt = ex, P.gte = tx, P.has = zx, P.hasIn = up, P.head = qy, P.identity = tn, P.includes = _A, P.indexOf = y9, P.inRange = rk, P.invoke = Hx, P.isArguments = ta, P.isArray = Xe, P.isArrayBuffer = rx, P.isArrayLike = Qr, P.isArrayLikeObject = ur, P.isBoolean = nx, P.isBuffer = wi, P.isDate = ox, P.isElement = ix, P.isEmpty = ax, P.isEqual = sx, P.isEqualWith = ux, P.isError = ip, P.isFinite = cx, P.isFunction = Uo, P.isInteger = ob, P.isLength = kl, P.isMap = ib, P.isMatch = lx, P.isMatchWith = fx, P.isNaN = dx, P.isNative = hx, P.isNil = gx, P.isNull = px, P.isNumber = ab, P.isObject = Xt, P.isObjectLike = Qt, P.isPlainObject = cu, P.isRegExp = ap, P.isSafeInteger = mx, P.isSet = sb, P.isString = Sl, P.isSymbol = En, P.isTypedArray = Za, P.isUndefined = yx, P.isWeakMap = bx, P.isWeakSet = wx, P.join = _9, P.kebabCase = uk, P.last = Un, P.lastIndexOf = A9, P.lowerCase = ck, P.lowerFirst = lk, P.lt = vx, P.lte = Ex, P.max = oS, P.maxBy = iS, P.mean = aS, P.meanBy = sS, P.min = uS, P.minBy = cS, P.stubArray = pp, P.stubFalse = gp, P.stubObject = Wk, P.stubString = Zk, P.stubTrue = Xk, P.multiply = lS, P.nth = x9, P.noConflict = Hk, P.noop = hp, P.now = _l, P.pad = fk, P.padEnd = dk, P.padStart = hk, P.parseInt = pk, P.random = nk, P.reduce = TA, P.reduceRight = IA, P.repeat = gk, P.replace = mk, P.result = Gx, P.round = fS, P.runInContext = V, P.sample = PA, P.size = NA, P.snakeCase = yk, P.some = $A, P.sortedIndex = C9, P.sortedIndexBy = B9, P.sortedIndexOf = N9, P.sortedLastIndex = $9, P.sortedLastIndexBy = U9, P.sortedLastIndexOf = R9, P.startCase = wk, P.startsWith = vk, P.subtract = dS, P.sum = hS, P.sumBy = pS, P.template = Ek, P.times = Yk, P.toFinite = Ro, P.toInteger = Qe, P.toLength = cb, P.toLower = _k, P.toNumber = Rn, P.toSafeInteger = _x, P.toString = xt, P.toUpper = Ak, P.trim = xk, P.trimEnd = kk, P.trimStart = Sk, P.truncate = Tk, P.unescape = Ik, P.uniqueId = Qk, P.upperCase = Ok, P.upperFirst = cp, P.each = Zy, P.eachRight = Xy, P.first = qy, dp(P, function() {
        var s = {};
        return ho(P, function(c, p) {
          St.call(P.prototype, p) || (s[p] = c);
        }), s;
      }(), { chain: !1 }), P.VERSION = n, Pn(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(s) {
        P[s].placeholder = P;
      }), Pn(["drop", "take"], function(s, c) {
        at.prototype[s] = function(p) {
          p = p === r ? 1 : Or(Qe(p), 0);
          var y = this.__filtered__ && !c ? new at(this) : this.clone();
          return y.__filtered__ ? y.__takeCount__ = Fr(p, y.__takeCount__) : y.__views__.push({
            size: Fr(p, Q),
            type: s + (y.__dir__ < 0 ? "Right" : "")
          }), y;
        }, at.prototype[s + "Right"] = function(p) {
          return this.reverse()[s](p).reverse();
        };
      }), Pn(["filter", "map", "takeWhile"], function(s, c) {
        var p = c + 1, y = p == ne || p == K;
        at.prototype[s] = function(x) {
          var B = this.clone();
          return B.__iteratees__.push({
            iteratee: De(x, 3),
            type: p
          }), B.__filtered__ = B.__filtered__ || y, B;
        };
      }), Pn(["head", "last"], function(s, c) {
        var p = "take" + (c ? "Right" : "");
        at.prototype[s] = function() {
          return this[p](1).value()[0];
        };
      }), Pn(["initial", "tail"], function(s, c) {
        var p = "drop" + (c ? "" : "Right");
        at.prototype[s] = function() {
          return this.__filtered__ ? new at(this) : this[p](1);
        };
      }), at.prototype.compact = function() {
        return this.filter(tn);
      }, at.prototype.find = function(s) {
        return this.filter(s).head();
      }, at.prototype.findLast = function(s) {
        return this.reverse().find(s);
      }, at.prototype.invokeMap = tt(function(s, c) {
        return typeof s == "function" ? new at(this) : this.map(function(p) {
          return nu(p, s, c);
        });
      }), at.prototype.reject = function(s) {
        return this.filter(xl(De(s)));
      }, at.prototype.slice = function(s, c) {
        s = Qe(s);
        var p = this;
        return p.__filtered__ && (s > 0 || c < 0) ? new at(p) : (s < 0 ? p = p.takeRight(-s) : s && (p = p.drop(s)), c !== r && (c = Qe(c), p = c < 0 ? p.dropRight(-c) : p.take(c - s)), p);
      }, at.prototype.takeRightWhile = function(s) {
        return this.reverse().takeWhile(s).reverse();
      }, at.prototype.toArray = function() {
        return this.take(Q);
      }, ho(at.prototype, function(s, c) {
        var p = /^(?:filter|find|map|reject)|While$/.test(c), y = /^(?:head|last)$/.test(c), x = P[y ? "take" + (c == "last" ? "Right" : "") : c], B = y || /^find/.test(c);
        x && (P.prototype[c] = function() {
          var R = this.__wrapped__, F = y ? [1] : arguments, Z = R instanceof at, ce = F[0], fe = Z || Xe(R), pe = function(ot) {
            var lt = x.apply(P, di([ot], F));
            return y && Se ? lt[0] : lt;
          };
          fe && p && typeof ce == "function" && ce.length != 1 && (Z = fe = !1);
          var Se = this.__chain__, $e = !!this.__actions__.length, Ke = B && !Se, et = Z && !$e;
          if (!B && fe) {
            R = et ? R : new at(this);
            var qe = s.apply(R, F);
            return qe.__actions__.push({ func: vl, args: [pe], thisArg: r }), new Bn(qe, Se);
          }
          return Ke && et ? s.apply(this, F) : (qe = this.thru(pe), Ke ? y ? qe.value()[0] : qe.value() : qe);
        });
      }), Pn(["pop", "push", "shift", "sort", "splice", "unshift"], function(s) {
        var c = Vc[s], p = /^(?:push|sort|unshift)$/.test(s) ? "tap" : "thru", y = /^(?:pop|shift)$/.test(s);
        P.prototype[s] = function() {
          var x = arguments;
          if (y && !this.__chain__) {
            var B = this.value();
            return c.apply(Xe(B) ? B : [], x);
          }
          return this[p](function(R) {
            return c.apply(Xe(R) ? R : [], x);
          });
        };
      }), ho(at.prototype, function(s, c) {
        var p = P[c];
        if (p) {
          var y = p.name + "";
          St.call(Ka, y) || (Ka[y] = []), Ka[y].push({ name: c, func: p });
        }
      }), Ka[hl(r, O).name] = [{
        name: "wrapper",
        func: r
      }], at.prototype.clone = I7, at.prototype.reverse = O7, at.prototype.value = P7, P.prototype.at = iA, P.prototype.chain = aA, P.prototype.commit = sA, P.prototype.next = uA, P.prototype.plant = lA, P.prototype.reverse = fA, P.prototype.toJSON = P.prototype.valueOf = P.prototype.value = dA, P.prototype.first = P.prototype.head, Xs && (P.prototype[Xs] = cA), P;
    }, Fa = s7();
    Gi ? ((Gi.exports = Fa)._ = Fa, fh._ = Fa) : zr._ = Fa;
  }).call(Rt);
})(F3, F3.exports);
var Nge = F3.exports;
const fR = /* @__PURE__ */ AL(Nge), $ge = (e) => /^(?:[A-Za-z0-9+\/]{4})*?(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/.test(e), Uge = (e) => /^[a-fA-F0-9]+$/.test(e), yp = (e) => {
  const t = [];
  let r = e;
  do {
    let n = r & BigInt(127);
    r >>= BigInt(7), r !== BigInt(0) && (n |= BigInt(128)), t.push(Number(n));
  } while (r !== BigInt(0));
  return { varint: Buffer.from(t) };
};
function C4(e) {
  return fR.omitBy(e, fR.isUndefined);
}
const Rge = ({
  runeId: e,
  amount: t,
  divisibility: r = 0,
  sendOutputIndex: n = 1,
  pointer: o = 0
}) => {
  r === 0 && (t = Math.floor(t));
  const i = yp(BigInt(22)).varint, a = yp(BigInt(o)).varint, u = yp(BigInt(0)).varint, l = yp(BigInt(t * 10 ** r)).varint, d = yp(BigInt(n)).varint, f = e.split(":"), h = Number(f[0]), g = Number(f[1]), b = yp(BigInt(h)).varint, w = yp(BigInt(g)).varint, E = Buffer.concat([
    i,
    a,
    u,
    b,
    w,
    l,
    d
  ]);
  let _ = E.byteLength.toString(16);
  return _.length % 2 !== 0 && (_ = "0" + E.byteLength.toString(16)), Buffer.concat([
    Buffer.from("6a", "hex"),
    Buffer.from("5d", "hex"),
    Buffer.from(_, "hex"),
    E
  ]);
}, B4 = async (e, t) => {
  const r = JSON.stringify({
    jsonrpc: "2.0",
    id: e,
    method: e,
    params: t
  });
  return await sn.post(`${JC}/${tw}`, r, {
    headers: {
      "content-type": "application/json"
    }
  }).then((n) => n.data).catch((n) => {
    throw n;
  });
}, zge = async (e) => {
  try {
    return (await B4("ord_address", [
      e
    ])).result;
  } catch (t) {
    throw t;
  }
}, jK = async (e) => {
  try {
    return (await B4("ord_rune", [e])).result;
  } catch (t) {
    throw t;
  }
}, jge = async (e) => {
  try {
    return (await B4("ord_rune", [e])).result;
  } catch (t) {
    throw t;
  }
}, Lge = async ({
  outpoints: e,
  rune_name: t
}) => {
  const r = [];
  for (let n = 0; n < e.length; n += 1e3) {
    const o = e.slice(n, n + 1e3), i = o.map((l) => ["ord_output", [l]]), { result: a } = await B4("sandshrew_multicall", i);
    for (let l = 0; l < a.length; l++)
      a[l].result.output = o[l];
    const u = a.filter(
      (l) => Object.keys(l.result.runes).includes(t)
    );
    r.push(...u);
  }
  return r;
}, Hge = async ({
  ordOutputs: e
}) => {
  var t;
  try {
    const r = [];
    for (let n = 0; n < e.length; n++) {
      const o = e[n], { result: i } = o;
      if (!((t = i.output) != null && t.split(":")))
        throw new Error("No output found");
      const { output: a, address: u, runes: l } = i, d = {
        output: a,
        wallet_addr: u,
        script: "",
        balances: [],
        decimals: [],
        rune_ids: [],
        value: i.value
      }, [f, h] = a.split(":");
      if (console.log(f, h, a), d.script = Buffer.from(
        PK(u, Kn)
      ).toString("hex"), typeof l == "object" && !Array.isArray(l))
        for (const g in l)
          d.balances.push(l[g].amount), d.decimals.push(l[g].divisibility), d.rune_ids.push((await jge(g)).id);
      r.push(d);
    }
    return r;
  } catch (r) {
    throw r;
  }
}, Fge = async ({
  address: e,
  runeId: t
}) => {
  const r = await zge(e), { entry: n } = await jK(t), o = n.spaced_rune, i = await Lge({
    outpoints: r.outputs,
    rune_name: o
  });
  return await Hge({
    ordOutputs: i
  });
}, Mge = async ({
  runeId: e,
  amount: t,
  ordinalAddress: r,
  ordinalPublicKey: n,
  paymentAddress: o,
  paymentPublicKey: i,
  toAddress: a,
  signPsbt: u,
  network: l = Kn
}) => {
  try {
    const d = await Dge({
      fromAddress: r,
      fromAddressPublicKey: n,
      fromPaymentAddress: o,
      fromPaymentPublicKey: i,
      toAddress: a,
      runeId: e,
      amount: t,
      network: l
    });
    if (!d || !(d != null && d.psbtHex))
      throw new Error("couldn't get commit tx");
    const f = String(d == null ? void 0 : d.psbtHex), h = String(d == null ? void 0 : d.psbtBase64), g = await u({
      tx: f,
      psbtHex: f,
      psbtBase64: h,
      finalize: !0,
      broadcast: !1,
      network: l
    });
    if (!g) throw new Error("sign psbt failed");
    const b = Sn.fromHex((g == null ? void 0 : g.signedPsbtHex) || "").extractTransaction();
    return await S4(b.toHex(), l);
  } catch (d) {
    throw d;
  }
}, Dge = async ({
  fromAddress: e,
  fromAddressPublicKey: t,
  fromPaymentAddress: r,
  fromPaymentPublicKey: n,
  toAddress: o,
  runeId: i,
  amount: a,
  network: u
}) => {
  try {
    const { fastestFee: l } = await OK(u);
    let d = (await oB(r, u)).sort((A, $) => $.value - A.value).filter((A) => A.value > 3e3);
    if (d.length === 0)
      throw new Error("No utxos found");
    let f = new Sn({ network: dn(u) }), h = 0;
    const g = await jK(i), b = await Fge({ runeId: i, address: e }), w = k4(d), E = nB(b.length, 2, 4);
    let _ = E * l < 250 ? 250 : E * l, O = 0;
    for await (const A of b) {
      const { output: $, value: U, script: M } = A, Y = $.split(":"), L = Y[0], ee = Y[1];
      f.addInput({
        hash: L,
        index: parseInt(ee),
        witnessUtxo: {
          value: BigInt(U),
          script: Buffer.from(M, "hex")
        },
        tapInternalKey: Pu(Buffer.from(t, "hex"))
      }), O++, h += U;
    }
    const C = x4(r, u);
    for (let A = 0; A < d.length; A++) {
      const $ = af(
        r,
        dn(Kn)
      ), U = d[A];
      if (C === $1 && f.addInput({
        hash: U.txid,
        index: U.vout,
        witnessUtxo: {
          value: BigInt(U.value),
          script: $
        },
        tapInternalKey: Pu(Buffer.from(n, "hex"))
      }), C === h2) {
        let M = R2(n, u);
        f.addInput({
          hash: U.txid,
          index: U.vout,
          witnessUtxo: {
            value: BigInt(U.value),
            script: $
          },
          redeemScript: M
        });
      }
      C === "p2wpkh" && f.addInput({
        hash: U.txid,
        index: U.vout,
        witnessUtxo: {
          value: BigInt(U.value),
          script: $
        }
      });
    }
    const I = { script: Rge({
      runeId: g.id,
      amount: a,
      divisibility: g.entry.divisibility,
      sendOutputIndex: 2,
      pointer: 1
    }), value: BigInt(0) };
    f.addOutput(I);
    const S = 546, T = w - (_ + S * 2);
    return f.addOutput({
      value: BigInt(S),
      address: e
    }), f.addOutput({
      value: BigInt(S),
      address: o
    }), f.addOutput({
      address: e,
      value: BigInt(T)
    }), { psbtBase64: f.toBase64(), psbtHex: f.toHex() };
  } catch (l) {
    throw l;
  }
}, LK = "maestro", Kge = "mempool-space", qge = "sandshrew";
function _i(e, t, r) {
  var n;
  if (!e || typeof e != "object")
    return r;
  for (const o of t)
    if (e[o] !== void 0)
      return ((n = e[o]) == null ? void 0 : n.toString()) || r;
  return r;
}
function Zv(e, t, r) {
  if (!e || typeof e != "object")
    return r;
  for (const n of t)
    if (e[n] !== void 0) {
      const o = Number(e[n]);
      return isNaN(o) ? r : o;
    }
  return r;
}
function A1(e, t = "unknown", r) {
  var n, o;
  if (!e)
    return console.warn(`Invalid inscription data from source: ${t}`), {
      id: "",
      inscriptionId: "",
      content: "",
      number: 0,
      address: "",
      contentType: "unknown",
      output: "",
      location: "",
      preview: "",
      genesisTransaction: "",
      height: 0,
      outputValue: 0
    };
  const i = _i(e, [
    "id",
    "inscription_id",
    "inscriptionId"
  ], ""), a = Zv(e, [
    "num",
    "number",
    "inscriptionNumber"
  ], 0), u = _i(e, [
    "address",
    "owner",
    "ownerAddress"
  ], ""), l = _i(e, [
    "content_type",
    "contentType",
    "mime",
    "mimeType"
  ], "unknown");
  let d = _i(e, ["utxo_txid", "txid", "transaction_id"], ""), f = Zv(e, ["vout", "utxo_vout"], 0), h = _i(e, ["output"], "");
  h || d && (h = `${d}:${f}`), h && (!d || !f) && (console.warn(`Invalid inscription location from source: ${t}`), d = h.split(":")[0], f = parseInt(h.split(":")[1]));
  const g = Zv(e, ["output_value", "value", "outputValue", "postage", "satoshis"], 0), b = Zv(e, ["height", "block_height"], 0);
  let w = _i(e, [
    "genesis_tx_id",
    "genesisTx",
    "genesis_txid",
    "genesisTransaction"
  ], ((o = (n = e.inscription_id) == null ? void 0 : n.split("i")) == null ? void 0 : o[0]) || e.txid || "");
  const E = e.utxo_sat_offset !== void 0 ? e.utxo_sat_offset : 0;
  if (!i)
    throw console.warn(`Invalid inscription data from source: ${t}`), new Error(`Invalid inscription data from source: ${t}`);
  if (!u)
    throw console.warn(`Invalid inscription address from source: ${t}`), new Error(`Invalid inscription address from source: ${t}`);
  if (!h)
    throw console.warn(`Invalid inscription output from source: ${t}`), new Error(`Invalid inscription output from source: ${t}`);
  if (!l)
    throw console.warn(`Invalid inscription content type from source: ${t}`), new Error(`Invalid inscription content type from source: ${t}`);
  return w || (w = i.split("i")[0]), {
    address: u,
    id: i,
    inscriptionId: i,
    number: a,
    outputValue: g,
    contentType: l,
    output: h,
    location: `${d}:${f}:${E}`,
    content: `${d1e(r)}/${i}`,
    preview: `${h1e(r)}/${i}`,
    genesisTransaction: w,
    height: b,
    offset: E
  };
}
function Vge(e, t = "unknown") {
  const r = [];
  if (!e)
    return console.warn(`Invalid BRC20 balance data from source: ${t}`), r;
  if (e.data && typeof e.data == "object")
    return Object.entries(e.data).forEach(([n, o]) => {
      const i = _i(o, ["overall", "overallBalance", "total", "totalBalance"], "0"), a = _i(o, ["transferable", "transferableBalance"], "na"), u = _i(o, ["available", "availableBalance"], "0");
      if (!i || !u) {
        console.warn(`Invalid BRC20 balance data from source: ${t}`);
        return;
      }
      const l = {
        ticker: n,
        overall: i,
        transferable: a ?? "na",
        available: u
      };
      r.push(l);
    }), r;
  if (Array.isArray(e))
    return e.forEach((n) => {
      const o = _i(n, ["ticker", "tick", "token"], "");
      if (!o) {
        console.warn(`Missing ticker in BRC20 balance from source: ${t}`);
        return;
      }
      const i = _i(n, ["overall", "overallBalance", "total", "totalBalance"], "0"), a = _i(n, ["transferable", "transferableBalance"], "0"), u = _i(n, ["available", "availableBalance"], "0");
      if (!i || !u) {
        console.warn(`Invalid BRC20 balance data from source: ${t}`);
        return;
      }
      const l = {
        ticker: o,
        overall: i,
        transferable: a ?? "na",
        available: u
      };
      r.push(l);
    }), r;
  if (typeof e == "object" && !Array.isArray(e)) {
    const n = _i(e, ["ticker", "tick", "token"], "");
    if (!n)
      return console.warn(`Missing ticker in BRC20 balance from source: ${t}`), r;
    const o = _i(e, ["overall", "overallBalance", "total", "totalBalance"], "0"), i = _i(e, ["transferable", "transferableBalance"], "0"), a = _i(e, ["available", "availableBalance"], "0");
    if (!o || !a)
      throw console.warn(`Invalid BRC20 balance data from source: ${t}`), new Error(`Invalid BRC20 balance data from source: ${t}`);
    const u = {
      ticker: n,
      overall: o,
      transferable: i ?? "na",
      available: a
    };
    return r.push(u), r;
  }
  return console.warn(`Unrecognized BRC20 balance format from source: ${t}`), r;
}
let Gge = class {
  constructor(t, r, n) {
    st(this, "apiUrl", ""), st(this, "apiKey"), st(this, "testnetApiKey"), this.apiKey = t, this.testnetApiKey = n, this.setNetwork(r);
  }
  getName() {
    return LK;
  }
  setNetwork(t) {
    this.apiUrl = f1e(t), this.apiUrl.includes("testnet") ? this.apiKey = this.testnetApiKey || this.apiKey : this.apiKey = this.apiKey;
  }
  async call(t, r, n) {
    const o = `${this.apiUrl}${r}`;
    try {
      const i = {
        headers: {
          "Content-Type": "application/json",
          "api-key": this.apiKey
        }
      };
      return (t === "get" ? await sn.get(o, i) : await sn.post(o, n, i)).data;
    } catch (i) {
      throw console.error("MaestroDataSource.call error:", i), i;
    }
  }
  async getAddressBtcBalance(t) {
    return (await this.call("get", `/addresses/${t}/balance`)).data;
  }
  async getAddressBrc20Balances(t) {
    return await this.call("get", `/addresses/${t}/brc20`);
  }
  async getAddressInscriptions(t, r, n) {
    const o = new URLSearchParams();
    r !== void 0 && o.append("offset", r.toString()), n !== void 0 && o.append("limit", n.toString());
    const i = `/addresses/${t}/inscriptions${o.toString() ? `?${o.toString()}` : ""}`, a = await this.call("get", i);
    return {
      ...a,
      data: a.data.map((u) => ({ ...u, address: t }))
    };
  }
  async getInscriptionInfo(t) {
    return await this.call("get", `/assets/inscriptions/${t}`);
  }
  async getBrc20ByTicker(t) {
    return this.call("get", `/assets/brc20/${t}`);
  }
  async getRuneById(t) {
    return this.call("get", `/assets/runes/${t}`);
  }
  async getRuneByName(t) {
    return this.call("get", `/assets/runes/${t}`);
  }
  async getTransactionInfo(t) {
    return this.call("get", `/rpc/transaction/${t}`);
  }
  async broadcastTransaction(t) {
    return await this.call("post", "/arpc/transaction/submit", t);
  }
  async getRawTransaction(t) {
    return this.call("get", `/raw-transactions/${t}`);
  }
  async getRecommendedFees() {
    return this.call("get", "/fees/recommended");
  }
  async getOrdAddress(t) {
    return this.call("get", `/inscriptions/${t}`);
  }
}, Wge = class {
  constructor(t, r) {
    st(this, "apiUrl", ""), this.setNetwork(r, t), console.log(this.apiUrl);
  }
  getName() {
    return Kge;
  }
  setNetwork(t, r) {
    this.apiUrl = r ? `${r}${t === "mainnet" ? "" : `/${t}`}` : N2(t);
  }
  async call(t, r, n) {
    try {
      const o = `${this.apiUrl}${r}`, i = {
        headers: {
          "Content-Type": t === "post" ? "text/plain" : "application/json"
        }
      };
      return (t === "get" ? await sn.get(o, i) : await sn.post(o, n, i)).data;
    } catch (o) {
      throw console.error("MempoolSpaceDataSource.call error:", o), o;
    }
  }
  async getOutputValueByVOutIndex(t, r) {
    const n = Date.now();
    for (; ; )
      try {
        const o = await this.getTransaction(t);
        if (o && o.vout && o.vout.length > 0)
          return Math.floor(o.vout[r].value);
        if (Date.now() - n > 6e4)
          return null;
        await new Promise((i) => setTimeout(i, 5e3));
      } catch (o) {
        if (console.error("Error fetching transaction output value:", o), Date.now() - n > 6e4)
          return null;
        await new Promise((i) => setTimeout(i, 5e3));
      }
  }
  async waitForTransaction(t) {
    const r = Date.now();
    for (; ; )
      try {
        if (await this.getTransaction(t))
          return console.log("Transaction found in mempool:", t), !0;
        if (Date.now() - r > 6e4)
          return !1;
        await new Promise((n) => setTimeout(n, 5e3));
      } catch {
        if (Date.now() - r > 6e4)
          return !1;
        await new Promise((n) => setTimeout(n, 5e3));
      }
  }
  async getAddressUtxos(t) {
    return this.call("get", `/api/address/${t}/utxo`);
  }
  async getTransaction(t) {
    return await this.call("get", `/api/tx/${t}`);
  }
  async getRecommendedFees() {
    return await this.call("get", "/api/v1/fees/recommended");
  }
  async broadcastTransaction(t) {
    return await this.call("post", "/api/tx", t);
  }
}, Zge = class {
  constructor(t, r, n) {
    st(this, "apiUrl", `${JC}/${tw}`), st(this, "apiKey", tw), this.setNetwork(n, t), this.apiKey = r;
  }
  getName() {
    return qge;
  }
  setNetwork(t, r) {
    this.apiUrl = `${this.apiUrl}/${this.apiKey || tw}`;
  }
  async call(t, r) {
    try {
      return (await sn.post(this.apiUrl, {
        jsonrpc: "2.0",
        id: t,
        method: t,
        params: r
      }, {
        headers: {
          "Content-Type": "application/json"
        }
      })).data;
    } catch (n) {
      throw console.error("SandshrewDataSource.callRPC error:", n), n;
    }
  }
  async getTransaction(t) {
    return (await this.call("esplora_tx", [t])).result;
  }
  async getRuneById(t) {
    return (await this.call("ord_rune", [t])).result;
  }
  async getRuneByName(t) {
    return (await this.call("ord_rune", [t])).result;
  }
  async broadcastTransaction(t) {
    return await this.call("broadcast_tx", [t]);
  }
  async getOrdAddress(t) {
    return (await this.call("ord_address", [t])).result;
  }
  async getTxInfo(t) {
    return (await this.call("esplora_tx", [t])).result;
  }
  async batchOrdOutput({ outpoints: t, rune_name: r }) {
    const n = [];
    for (let o = 0; o < t.length; o += 1e3) {
      const i = t.slice(o, o + 1e3), a = i.map((d) => ["ord_output", [d]]), { result: u } = await this.call("sandshrew_multicall", a);
      for (let d = 0; d < u.length; d++)
        u[d].result.output = i[d];
      const l = u.filter(
        (d) => Object.keys(d.result.runes).includes(r)
      );
      n.push(...l);
    }
    return n;
  }
  async batchOrdInscriptionInfo(t) {
    const r = [];
    for (let n = 0; n < t.length; n += 1e3) {
      const o = t.slice(n, n + 1e3).map((a) => ["ord_inscription", [a]]), { result: i } = await this.call("sandshrew_multicall", o);
      for (let a = 0; a < i.length; a++)
        r.push(i[a].result);
    }
    return r;
  }
  async getAddressRunesBalances(t) {
    try {
      const r = (await this.getOrdAddress(t)).runes_balances;
      if (!r)
        throw new Error("No runes data found");
      return r.map((n) => ({
        name: n[0],
        balance: n[1],
        symbol: n[2]
      }));
    } catch (r) {
      throw console.error("Error fetching ord address:", r), r;
    }
  }
  async getInscriptionInfo(t) {
    return (await this.call("ord_inscription", [t])).result;
  }
  async getRuneOutpoints({ address: t, runeId: r }) {
    const n = await this.getOrdAddress(t), { entry: o } = await this.getRuneById(r), i = o.spaced_rune, a = await this.batchOrdOutput({
      outpoints: n.outputs,
      rune_name: i
    });
    return await this.mapRuneBalances({
      ordOutputs: a
    });
  }
  async mapRuneBalances({ ordOutputs: t }) {
    var r;
    try {
      const n = [];
      for (let o = 0; o < t.length; o++) {
        const i = t[o], { result: a } = i;
        if (!((r = a.output) != null && r.split(":")))
          throw new Error("No output found");
        const { output: u, address: l, runes: d } = a, f = {
          output: u,
          wallet_addr: l,
          script: "",
          balances: [],
          decimals: [],
          rune_ids: [],
          value: a.value
        };
        if (f.script = Buffer.from(
          PK(l, Kn)
        ).toString("hex"), typeof d == "object" && !Array.isArray(d))
          for (const h in d)
            f.balances.push(d[h].amount), f.decimals.push(d[h].divisibility), f.rune_ids.push((await this.getRuneByName(h)).id);
        n.push(f);
      }
      return n;
    } catch (n) {
      throw n;
    }
  }
};
const xs = "Method not available on any data source", HK = class J0 {
  constructor(t) {
    st(this, "dataSources", /* @__PURE__ */ new Map()), st(this, "network");
    var r, n, o, i, a, u, l, d, f, h;
    const g = (t == null ? void 0 : t.network) || gt.MAINNET;
    this.network = g, this.dataSources.set("mempool", new Wge(
      ((n = (r = t == null ? void 0 : t.dataSources) == null ? void 0 : r.mempool) == null ? void 0 : n.url) || N2(g),
      g
    )), this.dataSources.set("sandshrew", new Zge(
      ((i = (o = t == null ? void 0 : t.dataSources) == null ? void 0 : o.sandshrew) == null ? void 0 : i.url) || JC,
      ((u = (a = t == null ? void 0 : t.dataSources) == null ? void 0 : a.sandshrew) == null ? void 0 : u.apiKey) || tw,
      g
    )), this.dataSources.set("maestro", new Gge(
      ((d = (l = t == null ? void 0 : t.dataSources) == null ? void 0 : l.maestro) == null ? void 0 : d.apiKey) || G0e,
      g,
      ((h = (f = t == null ? void 0 : t.dataSources) == null ? void 0 : f.maestro) == null ? void 0 : h.testnetApiKey) || W0e
    ));
  }
  static init(t) {
    J0.instance || (J0.instance = new J0(t));
  }
  static getInstance() {
    if (!J0.instance)
      throw new Error("DataSourceManager has not been initialized");
    return J0.instance;
  }
  updateNetwork(t) {
    var r;
    this.network = t;
    for (const n of this.dataSources.values())
      (r = n.setNetwork) == null || r.call(n, t);
  }
  registerDataSource(t, r) {
    var n, o;
    this.dataSources.set(t, r), (o = (n = this.dataSources.get(t)) == null ? void 0 : n.setNetwork) == null || o.call(n, this.network);
  }
  getSource(t) {
    return this.dataSources.get(t);
  }
  async getAddressBtcBalance(t) {
    const r = this.findAvailableSource("getAddressBtcBalance");
    if (!r || !r.getAddressBtcBalance)
      throw new Error(xs);
    return await r.getAddressBtcBalance(t);
  }
  async getAddressBrc20Balances(t) {
    const r = this.findAvailableSource("getAddressBrc20Balances");
    if (!r || !r.getAddressBrc20Balances)
      throw new Error(xs);
    const n = await r.getAddressBrc20Balances(t);
    return Vge(n);
  }
  async getAddressInscriptions(t, r, n) {
    const o = this.findAvailableSource("getAddressInscriptions");
    if (!o || !o.getAddressInscriptions)
      throw new Error(xs);
    if (!o.getInscriptionInfo)
      throw new Error(xs);
    const i = gt.MAINNET, a = await o.getAddressInscriptions(t, r, n), u = o.getName();
    return u === LK && a.data ? (await Promise.all(
      a.data.map(async (l) => {
        try {
          if (!o.getInscriptionInfo)
            throw new Error(xs);
          const d = await o.getInscriptionInfo(l.inscription_id);
          return {
            ...l,
            ...d.data
          };
        } catch (d) {
          return console.error(`Failed to fetch details for inscription ${l.inscription_id}:`, d), l;
        }
      })
    )).map(
      (l) => A1(l, u, i)
    ) : a.inscriptions ? a.inscriptions.map(
      (l) => A1(l, u, i)
    ) : Array.isArray(a) ? a.map(
      (l) => A1(l, u, i)
    ) : (console.warn("Unable to normalize inscriptions from data source", u), []);
  }
  async getInscriptionInfo(t) {
    const r = this.findAvailableSource("getInscriptionInfo");
    if (!r || !r.getInscriptionInfo)
      throw new Error(xs);
    return await r.getInscriptionInfo(t);
  }
  async getRecommendedFees() {
    const t = this.findAvailableSource("getRecommendedFees");
    if (!t || !t.getRecommendedFees)
      throw new Error(xs);
    return console.log("getting recommended fees"), await t.getRecommendedFees();
  }
  async getAddressUtxos(t) {
    const r = this.findAvailableSource("getAddressUtxos");
    if (!r || !r.getAddressUtxos)
      throw new Error(xs);
    return await r.getAddressUtxos(t);
  }
  async getOutputValueByVOutIndex(t, r) {
    const n = this.findAvailableSource("getOutputValueByVOutIndex");
    if (!n || !n.getOutputValueByVOutIndex)
      throw new Error(xs);
    return await n.getOutputValueByVOutIndex(t, r);
  }
  async waitForTransaction(t) {
    const r = this.findAvailableSource("waitForTransaction");
    if (!r || !r.waitForTransaction)
      throw new Error(xs);
    return !!await r.waitForTransaction(t);
  }
  async getAddressRunesBalances(t) {
    const r = this.findAvailableSource("getAddressRunesBalances");
    if (!r || !r.getAddressRunesBalances)
      throw new Error(xs);
    return await r.getAddressRunesBalances(t);
  }
  async broadcastTransaction(t) {
    const r = this.findAvailableSource("broadcastTransaction");
    if (!r || !r.broadcastTransaction)
      throw new Error(xs);
    return await r.broadcastTransaction(t);
  }
  async withFallback(t, r) {
    const n = [t, ...Array.from(this.dataSources.keys()).filter((o) => o !== t)];
    for (const o of n)
      try {
        const i = this.getSource(o);
        if (!i) continue;
        return await r(i);
      } catch (i) {
        console.warn(`Fallback: ${o} failed`, i);
      }
    throw new Error("All data sources failed");
  }
  findAvailableSource(t) {
    for (const r of this.dataSources.values())
      if (typeof r[t] == "function")
        return r;
  }
};
st(HK, "instance");
let Wp = HK;
const Xge = (e, t) => `{"p":"brc-20","op":"transfer","tick":"${e}","amt":"${t}"}`, Yge = async ({
  ticker: e,
  amount: t,
  ordinalAddress: r,
  ordinalPublicKey: n,
  paymentAddress: o,
  paymentPublicKey: i,
  toAddress: a,
  signPsbt: u,
  dataSourceManager: l,
  network: d = Kn
}) => {
  try {
    let f;
    if (l ? f = l : f = Wp.getInstance(), !f)
      throw new Error("Data source not found");
    if (!(f != null && f.getAddressBrc20Balances))
      throw new Error("Data source not found");
    if (!await (f == null ? void 0 : f.getAddressBrc20Balances(r)))
      throw new Error("Address balance not found");
    const h = Xge(e, t), g = await BK({
      contentBase64: btoa(h),
      mimeType: "text/plain",
      ordinalAddress: r,
      paymentAddress: o,
      paymentPublicKey: i,
      signPsbt: u,
      dataSourceManager: f,
      network: d
    });
    await f.waitForTransaction(g);
    const { fastestFee: b } = await f.getRecommendedFees(), w = 5 * 34 * 1, E = Math.floor(w * b * 1);
    await new Promise((Y) => setTimeout(Y, 1e4));
    const _ = (await f.getAddressUtxos(
      o
    )).filter((Y) => Y.value > 3e3).sort((Y, L) => L.value - Y.value);
    if (k4(_) < E)
      throw new Error("insufficient funds");
    console.log("inscriptionTxId", g);
    const O = new Sn({ network: dn(d) }), C = af(r, dn(d));
    O.addInput({
      hash: g,
      index: 0,
      witnessUtxo: {
        script: C,
        value: BigInt(546)
      },
      tapInternalKey: Pu(Buffer.from(n, "hex"))
    }), O.addOutput({
      address: a,
      value: BigInt(546)
    });
    let I = 0, S = 0;
    for await (const Y of _) {
      const L = af(o, dn(d)), ee = x4(o, d);
      if (O.addInput({
        hash: Y.txid,
        index: Y.vout,
        witnessUtxo: { value: BigInt(Y.value), script: L },
        tapInternalKey: Pu(Buffer.from(i, "hex"))
      }), ee === h2) {
        let de = R2(i, d);
        O.updateInput(I, { redeemScript: de });
      }
      if (I++, S += Y.value, S > E) {
        console.log("BREAKING");
        break;
      }
    }
    const T = S - E;
    T > 546 && O.addOutput({
      value: BigInt(T),
      address: o
    });
    const A = O == null ? void 0 : O.toHex(), $ = O == null ? void 0 : O.toBase64(), U = await u({
      tx: "",
      psbtHex: A,
      psbtBase64: $,
      finalize: !0,
      broadcast: !0,
      network: d
    });
    if (!U) throw new Error("sign psbt failed");
    const M = Sn.fromHex((U == null ? void 0 : U.signedPsbtHex) || "").extractTransaction();
    return await S4(M.toHex(), d);
  } catch (f) {
    throw f;
  }
}, Jge = async ({
  inscriptionIds: e,
  ordinalAddress: t,
  ordinalPublicKey: r,
  paymentAddress: n,
  paymentPublicKey: o,
  toAddress: i,
  signPsbt: a,
  dataSourceManager: u,
  network: l = Kn
}) => {
  try {
    const d = await Qge({
      inscriptionIds: e,
      fromAddress: t,
      fromAddressPublicKey: r,
      fromPaymentAddress: n,
      fromPaymentPublicKey: o,
      dataSourceManager: u,
      toAddress: i,
      network: l
    });
    if (!d || !(d != null && d.psbtHex))
      throw new Error("couldn't get commit tx");
    const f = String(d == null ? void 0 : d.psbtHex), h = String(d == null ? void 0 : d.psbtBase64), g = await a({
      tx: "",
      psbtHex: f,
      psbtBase64: h,
      finalize: !0,
      broadcast: !1,
      network: l
    });
    if (!g) throw new Error("sign psbt failed");
    const b = Sn.fromHex((g == null ? void 0 : g.signedPsbtHex) || "").extractTransaction();
    return await S4(b.toHex(), l);
  } catch (d) {
    throw d;
  }
}, Qge = async ({
  fromAddress: e,
  fromAddressPublicKey: t,
  fromPaymentAddress: r,
  fromPaymentPublicKey: n,
  toAddress: o,
  inscriptionIds: i,
  dataSourceManager: a,
  network: u
}) => {
  try {
    const { fastestFee: l } = await OK(u);
    let d = (await a.getAddressUtxos(r)).sort((I, S) => S.value - I.value).filter((I) => I.value > 3e3);
    if (d.length === 0)
      throw new Error("No utxos found");
    const f = a.getSource("sandshrew");
    if (!f || !f.batchOrdInscriptionInfo)
      throw new Error("Sandshrew data source not found");
    const h = await (f == null ? void 0 : f.batchOrdInscriptionInfo(i));
    console.log(h);
    let g = new Sn({ network: dn(u) });
    const b = k4(d), w = nB(h.length, 2, 4);
    let E = w * l < 250 ? 250 : w * l, _ = 0;
    for await (const I of h) {
      const { value: S, satpoint: T } = I, [A, $] = T.split(":");
      if (!S || !A || !$)
        throw new Error("Invalid satpoint or value");
      const U = af(e, dn(Kn));
      g.addInput({
        hash: A,
        index: parseInt($),
        witnessUtxo: {
          value: BigInt(S),
          script: U
        },
        tapInternalKey: Pu(Buffer.from(t, "hex"))
      }), g.addOutput({
        value: BigInt(S),
        address: o
      }), _++;
    }
    const O = x4(r, u);
    for (let I = 0; I < d.length; I++) {
      const S = af(
        r,
        dn(Kn)
      ), T = d[I];
      if (O === $1 && g.addInput({
        hash: T.txid,
        index: T.vout,
        witnessUtxo: {
          value: BigInt(T.value),
          script: S
        },
        tapInternalKey: Pu(Buffer.from(n, "hex"))
      }), O === h2) {
        let A = R2(n, u);
        g.addInput({
          hash: T.txid,
          index: T.vout,
          witnessUtxo: {
            value: BigInt(T.value),
            script: S
          },
          redeemScript: A
        });
      }
      O === "p2wpkh" && g.addInput({
        hash: T.txid,
        index: T.vout,
        witnessUtxo: {
          value: BigInt(T.value),
          script: S
        }
      });
    }
    const C = b - E;
    return g.addOutput({
      address: e,
      value: BigInt(C)
    }), { psbtBase64: g.toBase64(), psbtHex: g.toHex() };
  } catch (l) {
    throw l;
  }
}, eme = new Error(
  "The connected wallet doesn't support this method..."
), tme = new Error("Wallet is not installed");
let Gu = class {
  constructor(t, r, n) {
    st(this, "$store"), st(this, "$network"), st(this, "dataSourceManager"), this.parent = r, this.config = n, this.$store = t.$store, this.$network = t.$network;
    try {
      this.dataSourceManager = Wp.getInstance();
    } catch {
      Wp.init(n), this.dataSourceManager = Wp.getInstance();
    }
    this.initialize();
  }
  disconnect() {
  }
  async requestAccounts() {
    return this.$store.get().accounts;
  }
  async switchNetwork(t) {
    throw this.parent.disconnect(), eme;
  }
  async getNetwork() {
    const { address: t } = this.$store.get();
    return t.slice(0, 1) === "t" && [aa, ka, Ls, as].includes(this.$network.get()) ? this.$network.get() : Kn;
  }
  async getPublicKey() {
    return this.$store.get().publicKey;
  }
  async getBalance() {
    if (!this.dataSourceManager.getAddressBtcBalance)
      throw new Error("Method not found on data source");
    return await this.dataSourceManager.getAddressBtcBalance(this.$store.get().paymentAddress);
  }
  async getMetaBalances(t) {
    switch (t) {
      case JU:
        return await this.getBalance();
      case eR:
        if (this.$network.get() !== Kn)
          throw new Error("Unsupported network");
        if (!this.dataSourceManager.getAddressRunesBalances)
          throw new Error("Method not found on data source");
        return await this.dataSourceManager.getAddressRunesBalances(this.$store.get().address);
      case QU:
        if (!this.dataSourceManager.getAddressBrc20Balances)
          throw new Error("Method not found on data source");
        return await this.dataSourceManager.getAddressBrc20Balances(this.$store.get().address);
      default:
        throw new Error("Unsupported protocol");
    }
  }
  async getInscriptions(t, r) {
    if (!this.dataSourceManager.getAddressInscriptions)
      throw new Error("Method not found on data source");
    return await this.dataSourceManager.getAddressInscriptions(this.$store.get().address, t, r);
  }
  async pushPsbt(t) {
    let r = t;
    return r.startsWith("02") || (r = Sn.fromHex(r).extractTransaction().toHex()), await S4(r, this.$network.get());
  }
  async inscribe(t, r, n) {
    return await BK({
      contentBase64: t,
      mimeType: r,
      ordinalAddress: this.$store.get().address,
      paymentAddress: this.$store.get().paymentAddress,
      paymentPublicKey: this.$store.get().paymentPublicKey,
      signPsbt: this.signPsbt.bind(this),
      dataSourceManager: n || this.dataSourceManager,
      network: this.$network.get()
    });
  }
  async send(t, r) {
    switch (t) {
      case JU:
        return await this.sendBTC(r.toAddress, r.amount);
      case eR:
        if (this.$network.get() !== Kn)
          throw new Error("Unsupported network");
        const n = r;
        if (!n.runeId || !n.amount || !n.toAddress)
          throw new Error("Missing required parameters");
        return await Mge({
          runeId: n.runeId,
          amount: n.amount,
          ordinalAddress: this.$store.get().address,
          ordinalPublicKey: this.$store.get().publicKey,
          paymentAddress: this.$store.get().paymentAddress,
          paymentPublicKey: this.$store.get().paymentPublicKey,
          toAddress: n.toAddress,
          signPsbt: this.signPsbt.bind(this),
          network: this.$network.get()
        });
      case QU:
        if (this.$network.get() !== Kn)
          throw new Error("Unsupported network");
        const o = r;
        if (!o.ticker || !o.amount || !o.toAddress)
          throw new Error("Missing required parameters");
        return await Yge({
          ticker: o.ticker,
          amount: o.amount,
          ordinalAddress: this.$store.get().address,
          ordinalPublicKey: this.$store.get().publicKey,
          paymentAddress: this.$store.get().paymentAddress,
          paymentPublicKey: this.$store.get().paymentPublicKey,
          signPsbt: this.signPsbt.bind(this),
          toAddress: o.toAddress,
          dataSourceManager: this.dataSourceManager,
          network: this.$network.get()
        });
      default:
        throw new Error("Unsupported protocol");
    }
  }
  async sendInscriptions(t, r) {
    if ((await this.getInscriptions()).filter(
      (n) => t.includes(n.id)
    ).length !== t.length)
      throw new Error("Missing inscriptions");
    return await Jge({
      inscriptionIds: t,
      ordinalAddress: this.$store.get().address,
      ordinalPublicKey: this.$store.get().publicKey,
      paymentAddress: this.$store.get().paymentAddress,
      paymentPublicKey: this.$store.get().paymentPublicKey,
      toAddress: r,
      signPsbt: this.signPsbt.bind(this),
      dataSourceManager: this.dataSourceManager,
      network: this.$network.get()
    });
  }
}, rme = class extends Gu {
  constructor(t, r, n) {
    super(t, r, n), st(this, "observer");
  }
  get library() {
    return window.unisat;
  }
  get network() {
    return this.$network.get();
  }
  initialize() {
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var t;
      this.library && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [n1]: !0
      }), (t = this.observer) == null || t.disconnect());
    }), this.observer.observe(document, { childList: !0, subtree: !0 })), Ku(this.$store, ["provider"], (t) => {
      if (t.provider !== n1) {
        this.removeListeners();
        return;
      }
      this.library.getAccounts().then((r) => {
        this.handleAccountsChanged(r);
      }), this.addListeners();
    });
  }
  addListeners() {
    this.library.on("accountsChanged", this.handleAccountsChanged.bind(this)), this.library.on("networkChanged", this.handleNetworkChanged.bind(this));
  }
  removeListeners() {
    var t, r;
    this.library && ((t = this.library) == null || t.removeListener(
      "accountsChanged",
      this.handleAccountsChanged.bind(this)
    ), (r = this.library) == null || r.removeListener(
      "networkChanged",
      this.handleNetworkChanged.bind(this)
    ));
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect(), this.removeListeners();
  }
  handleAccountsChanged(t) {
    if (!t.length) {
      this.parent.disconnect();
      return;
    }
    this.$store.get().accounts[0] !== t[0] && (this.$store.setKey("accounts", t), t.length > 0 ? this.parent.connect(n1) : this.parent.disconnect());
  }
  handleNetworkChanged(t) {
    const r = B3(t);
    this.network !== r && this.switchNetwork(r), this.parent.connect(n1);
  }
  async connect(t) {
    if (!this.library) throw new Error("Unisat isn't installed");
    const r = await this.library.requestAccounts();
    if (!r) throw new Error("No accounts found");
    await this.getNetwork().then((o) => {
      this.network !== o && this.switchNetwork(this.network);
    });
    const n = await this.library.getPublicKey();
    if (!n) throw new Error("No public key found");
    this.$store.setKey("accounts", r), this.$store.setKey("address", r[0]), this.$store.setKey("paymentAddress", r[0]), this.$store.setKey("publicKey", n), this.$store.setKey("paymentPublicKey", n);
  }
  async getNetwork() {
    var t;
    const r = await ((t = this.library) == null ? void 0 : t.getChain());
    return r ? B3(r.enum) : this.network;
  }
  async sendBTC(t, r) {
    var n;
    const o = await ((n = this.library) == null ? void 0 : n.sendBitcoin(t, r));
    if (!o) throw new Error("Transaction failed");
    return o;
  }
  async signMessage(t, r) {
    var n;
    const o = (r == null ? void 0 : r.protocol) === rB ? A4 : r == null ? void 0 : r.protocol;
    return await ((n = this.library) == null ? void 0 : n.signMessage(t, o));
  }
  async signPsbt({
    psbtHex: t,
    broadcast: r,
    finalize: n,
    inputsToSign: o
  }) {
    var i;
    const a = await ((i = this.library) == null ? void 0 : i.signPsbt(
      t,
      C4({
        autoFinalized: n,
        toSignInputs: o
      })
    )), u = Sn.fromHex(a);
    if (n && r) {
      const l = await this.pushPsbt(a);
      return {
        signedPsbtHex: u.toHex(),
        signedPsbtBase64: u.toBase64(),
        txId: l
      };
    }
    return {
      signedPsbtHex: u.toHex(),
      signedPsbtBase64: u.toBase64(),
      txId: void 0
    };
  }
  async getPublicKey() {
    var t;
    return await ((t = this.library) == null ? void 0 : t.getPublicKey());
  }
  async getBalance() {
    return (await this.library.getBalance()).total;
  }
  async getInscriptions(t, r) {
    const n = t || 0, o = r || 10;
    return (await this.library.getInscriptions(n, o)).list.map((i) => A1(i, void 0, this.network));
  }
  async requestAccounts() {
    return await this.library.requestAccounts();
  }
  async switchNetwork(t) {
    var r;
    const n = yD(t);
    await ((r = this.library) == null ? void 0 : r.switchChain(n)), this.$network.set(t);
  }
};
function nme(e) {
  typeof window < "u" && typeof localStorage < "u" && setTimeout(() => {
    const t = document.createTextNode(" ");
    document.body.appendChild(t), t.remove(), Promise.resolve().then(e);
  }, 1500);
}
function NRe() {
  return {
    $store: Yj({
      provider: void 0,
      address: "",
      paymentAddress: "",
      publicKey: "",
      paymentPublicKey: "",
      connected: !1,
      isConnecting: !1,
      isInitializing: !0,
      accounts: [],
      balance: void 0,
      hasProvider: {
        [Xb]: !1,
        [n1]: !1,
        [Ed]: !1,
        [Yb]: !1,
        [Sp]: !1,
        [kp]: !1,
        [Zb]: !1,
        [a1]: !0,
        [xp]: !1,
        [i1]: !1,
        [o1]: !1
      }
    }),
    $network: dI(Kn),
    $library: dI(void 0)
  };
}
function $Re({ ...e }) {
  return {
    ...e
  };
}
const I0 = [
  "address",
  "paymentAddress",
  "publicKey",
  "paymentPublicKey",
  "balance"
];
function Og(e, t, r, n) {
  var o, i, a;
  t.provider === e && (r ? r === "balance" ? n.setKey("balance", ((o = t.balance) == null ? void 0 : o.toString()) ?? "") : I0.includes(r) && n.setKey(
    r,
    ((i = t[r]) == null ? void 0 : i.toString()) ?? ""
  ) : n.set({
    address: t.address,
    paymentAddress: t.paymentAddress,
    paymentPublicKey: t.paymentPublicKey,
    publicKey: t.publicKey,
    balance: ((a = t.balance) == null ? void 0 : a.toString()) ?? ""
  }));
}
const ome = (e) => {
  const t = e.match(/.{1,2}/g);
  if (!t)
    throw new Error("Invalid hex string");
  return Uint8Array.from(t.map((r) => parseInt(r, 16)));
};
function ime(e, t) {
  var r;
  return (r = void 0) == null ? void 0 : r.get(t);
}
function N4(e) {
  var t, r;
  const n = typeof e;
  return n === "string" ? `"${e}"` : n === "number" || n === "bigint" || n === "boolean" ? `${e}` : n === "object" || n === "function" ? (e && ((r = (t = Object.getPrototypeOf(e)) == null ? void 0 : t.constructor) == null ? void 0 : r.name)) ?? "null" : n;
}
function Vo(e, t, r, n, o) {
  const i = o && "input" in o ? o.input : r.value, a = (o == null ? void 0 : o.expected) ?? e.expects ?? null, u = (o == null ? void 0 : o.received) ?? N4(i), l = {
    kind: e.kind,
    type: e.type,
    input: i,
    expected: a,
    received: u,
    message: `Invalid ${t}: ${a ? `Expected ${a} but r` : "R"}eceived ${u}`,
    requirement: e.requirement,
    path: o == null ? void 0 : o.path,
    issues: o == null ? void 0 : o.issues,
    lang: n.lang,
    abortEarly: n.abortEarly,
    abortPipeEarly: n.abortPipeEarly
  }, d = e.kind === "schema", f = (o == null ? void 0 : o.message) ?? e.message ?? ime(e.reference, l.lang) ?? (d ? (l.lang, void 0) : null) ?? n.message ?? (l.lang, void 0);
  f && (l.message = typeof f == "function" ? (
    // @ts-expect-error
    f(l)
  ) : f), d && (r.typed = !1), r.issues ? r.issues.push(l) : r.issues = [l];
}
function FK(e, t) {
  return Object.hasOwn(e, t) && t !== "__proto__" && t !== "prototype" && t !== "constructor";
}
function $4(e, t) {
  const r = [...new Set(e)];
  return r.length > 1 ? `(${r.join(` ${t} `)})` : r[0] ?? "never";
}
function MK(e, t) {
  return {
    kind: "validation",
    type: "check",
    reference: MK,
    async: !1,
    expects: null,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && !this.requirement(r.value) && Vo(this, "input", r, n), r;
    }
  };
}
function DK(e, t) {
  return {
    kind: "validation",
    type: "max_length",
    reference: DK,
    async: !1,
    expects: `<=${e}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && r.value.length > this.requirement && Vo(this, "length", r, n, {
        received: `${r.value.length}`
      }), r;
    }
  };
}
function KK(e, t) {
  return {
    kind: "validation",
    type: "min_length",
    reference: KK,
    async: !1,
    expects: `>=${e}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && r.value.length < this.requirement && Vo(this, "length", r, n, {
        received: `${r.value.length}`
      }), r;
    }
  };
}
function qK(e, t, r) {
  return typeof e.default == "function" ? (
    // @ts-expect-error
    e.default(t, r)
  ) : (
    // @ts-expect-error
    e.default
  );
}
function dR(e, t) {
  return !e._run({ typed: !1, value: t }, { abortEarly: !0 }).issues;
}
function Go(e, t) {
  return {
    kind: "schema",
    type: "array",
    reference: Go,
    expects: "Array",
    async: !1,
    item: e,
    message: t,
    _run(r, n) {
      var o;
      const i = r.value;
      if (Array.isArray(i)) {
        r.typed = !0, r.value = [];
        for (let a = 0; a < i.length; a++) {
          const u = i[a], l = this.item._run({ typed: !1, value: u }, n);
          if (l.issues) {
            const d = {
              type: "array",
              origin: "value",
              input: i,
              key: a,
              value: u
            };
            for (const f of l.issues)
              f.path ? f.path.unshift(d) : f.path = [d], (o = r.issues) == null || o.push(f);
            if (r.issues || (r.issues = l.issues), n.abortEarly) {
              r.typed = !1;
              break;
            }
          }
          l.typed || (r.typed = !1), r.value.push(l.value);
        }
      } else
        Vo(this, "type", r, n);
      return r;
    }
  };
}
function O0(e) {
  return {
    kind: "schema",
    type: "boolean",
    reference: O0,
    expects: "boolean",
    async: !1,
    message: e,
    _run(t, r) {
      return typeof t.value == "boolean" ? t.typed = !0 : Vo(this, "type", t, r), t;
    }
  };
}
function ds(e, t) {
  const r = Object.entries(e).filter(([n]) => isNaN(+n)).map(([, n]) => n);
  return {
    kind: "schema",
    type: "enum",
    reference: ds,
    expects: $4(r.map(N4), "|"),
    async: !1,
    enum: e,
    options: r,
    message: t,
    _run(n, o) {
      return this.options.includes(n.value) ? n.typed = !0 : Vo(this, "type", n, o), n;
    }
  };
}
function vr(e, t) {
  return {
    kind: "schema",
    type: "literal",
    reference: vr,
    expects: N4(e),
    async: !1,
    literal: e,
    message: t,
    _run(r, n) {
      return r.value === this.literal ? r.typed = !0 : Vo(this, "type", r, n), r;
    }
  };
}
function VK(e, t) {
  return {
    kind: "schema",
    type: "loose_object",
    reference: VK,
    expects: "Object",
    async: !1,
    entries: e,
    message: t,
    _run(r, n) {
      var o;
      const i = r.value;
      if (i && typeof i == "object") {
        r.typed = !0, r.value = {};
        for (const a in this.entries) {
          const u = i[a], l = this.entries[a]._run(
            { typed: !1, value: u },
            n
          );
          if (l.issues) {
            const d = {
              type: "object",
              origin: "value",
              input: i,
              key: a,
              value: u
            };
            for (const f of l.issues)
              f.path ? f.path.unshift(d) : f.path = [d], (o = r.issues) == null || o.push(f);
            if (r.issues || (r.issues = l.issues), n.abortEarly) {
              r.typed = !1;
              break;
            }
          }
          l.typed || (r.typed = !1), (l.value !== void 0 || a in i) && (r.value[a] = l.value);
        }
        if (!r.issues || !n.abortEarly)
          for (const a in i)
            FK(i, a) && !(a in this.entries) && (r.value[a] = i[a]);
      } else
        Vo(this, "type", r, n);
      return r;
    }
  };
}
function dB(e, t) {
  return {
    kind: "schema",
    type: "non_optional",
    reference: dB,
    expects: "!undefined",
    async: !1,
    wrapped: e,
    message: t,
    _run(r, n) {
      return r.value === void 0 ? (Vo(this, "type", r, n), r) : this.wrapped._run(r, n);
    }
  };
}
function Ki(e) {
  return {
    kind: "schema",
    type: "null",
    reference: Ki,
    expects: "null",
    async: !1,
    message: e,
    _run(t, r) {
      return t.value === null ? t.typed = !0 : Vo(this, "type", t, r), t;
    }
  };
}
function si(e, ...t) {
  const r = {
    kind: "schema",
    type: "nullish",
    reference: si,
    expects: `(${e.expects} | null | undefined)`,
    async: !1,
    wrapped: e,
    _run(n, o) {
      return (n.value === null || n.value === void 0) && ("default" in this && (n.value = qK(
        this,
        n,
        o
      )), n.value === null || n.value === void 0) ? (n.typed = !0, n) : this.wrapped._run(n, o);
    }
  };
  return 0 in t && (r.default = t[0]), r;
}
function co(e) {
  return {
    kind: "schema",
    type: "number",
    reference: co,
    expects: "number",
    async: !1,
    message: e,
    _run(t, r) {
      return typeof t.value == "number" && !isNaN(t.value) ? t.typed = !0 : Vo(this, "type", t, r), t;
    }
  };
}
function ze(e, t) {
  return {
    kind: "schema",
    type: "object",
    reference: ze,
    expects: "Object",
    async: !1,
    entries: e,
    message: t,
    _run(r, n) {
      var o;
      const i = r.value;
      if (i && typeof i == "object") {
        r.typed = !0, r.value = {};
        for (const a in this.entries) {
          const u = i[a], l = this.entries[a]._run(
            { typed: !1, value: u },
            n
          );
          if (l.issues) {
            const d = {
              type: "object",
              origin: "value",
              input: i,
              key: a,
              value: u
            };
            for (const f of l.issues)
              f.path ? f.path.unshift(d) : f.path = [d], (o = r.issues) == null || o.push(f);
            if (r.issues || (r.issues = l.issues), n.abortEarly) {
              r.typed = !1;
              break;
            }
          }
          l.typed || (r.typed = !1), (l.value !== void 0 || a in i) && (r.value[a] = l.value);
        }
      } else
        Vo(this, "type", r, n);
      return r;
    }
  };
}
function er(e, ...t) {
  const r = {
    kind: "schema",
    type: "optional",
    reference: er,
    expects: `(${e.expects} | undefined)`,
    async: !1,
    wrapped: e,
    _run(n, o) {
      return n.value === void 0 && ("default" in this && (n.value = qK(
        this,
        n,
        o
      )), n.value === void 0) ? (n.typed = !0, n) : this.wrapped._run(n, o);
    }
  };
  return 0 in t && (r.default = t[0]), r;
}
function GK(e, t) {
  return {
    kind: "schema",
    type: "picklist",
    reference: GK,
    expects: $4(e.map(N4), "|"),
    async: !1,
    options: e,
    message: t,
    _run(r, n) {
      return this.options.includes(r.value) ? r.typed = !0 : Vo(this, "type", r, n), r;
    }
  };
}
function WK(e, t, r) {
  return {
    kind: "schema",
    type: "record",
    reference: WK,
    expects: "Object",
    async: !1,
    key: e,
    value: t,
    message: r,
    _run(n, o) {
      var i, a;
      const u = n.value;
      if (u && typeof u == "object") {
        n.typed = !0, n.value = {};
        for (const l in u)
          if (FK(u, l)) {
            const d = u[l], f = this.key._run(
              { typed: !1, value: l },
              o
            );
            if (f.issues) {
              const g = {
                type: "object",
                origin: "key",
                input: u,
                key: l,
                value: d
              };
              for (const b of f.issues)
                b.path = [g], (i = n.issues) == null || i.push(b);
              if (n.issues || (n.issues = f.issues), o.abortEarly) {
                n.typed = !1;
                break;
              }
            }
            const h = this.value._run(
              { typed: !1, value: d },
              o
            );
            if (h.issues) {
              const g = {
                type: "object",
                origin: "value",
                input: u,
                key: l,
                value: d
              };
              for (const b of h.issues)
                b.path ? b.path.unshift(g) : b.path = [g], (a = n.issues) == null || a.push(b);
              if (n.issues || (n.issues = h.issues), o.abortEarly) {
                n.typed = !1;
                break;
              }
            }
            (!f.typed || !h.typed) && (n.typed = !1), f.typed && (n.value[f.value] = h.value);
          }
      } else
        Vo(this, "type", n, o);
      return n;
    }
  };
}
function Ue(e) {
  return {
    kind: "schema",
    type: "string",
    reference: Ue,
    expects: "string",
    async: !1,
    message: e,
    _run(t, r) {
      return typeof t.value == "string" ? t.typed = !0 : Vo(this, "type", t, r), t;
    }
  };
}
function hR(e) {
  let t;
  if (e)
    for (const r of e)
      t ? t.push(...r.issues) : t = r.issues;
  return t;
}
function K2(e, t) {
  return {
    kind: "schema",
    type: "union",
    reference: K2,
    expects: $4(
      e.map((r) => r.expects),
      "|"
    ),
    async: !1,
    options: e,
    message: t,
    _run(r, n) {
      let o, i, a;
      for (const u of this.options) {
        const l = u._run(
          { typed: !1, value: r.value },
          n
        );
        if (l.typed)
          if (l.issues)
            i ? i.push(l) : i = [l];
          else {
            o = l;
            break;
          }
        else
          a ? a.push(l) : a = [l];
      }
      if (o)
        return o;
      if (i) {
        if (i.length === 1)
          return i[0];
        Vo(this, "type", r, n, {
          issues: hR(i)
        }), r.typed = !0;
      } else {
        if ((a == null ? void 0 : a.length) === 1)
          return a[0];
        Vo(this, "type", r, n, {
          issues: hR(a)
        });
      }
      return r;
    }
  };
}
function U4() {
  return {
    kind: "schema",
    type: "unknown",
    reference: U4,
    expects: "unknown",
    async: !1,
    _run(e) {
      return e.typed = !0, e;
    }
  };
}
function ZK(e, t, r) {
  return {
    kind: "schema",
    type: "variant",
    reference: ZK,
    expects: "Object",
    async: !1,
    key: e,
    options: t,
    message: r,
    _run(n, o) {
      const i = n.value;
      if (i && typeof i == "object") {
        let a, u = 0, l = this.key, d = [];
        const f = (h, g) => {
          for (const b of h.options) {
            if (b.type === "variant")
              f(b, new Set(g).add(b.key));
            else {
              let w = !0, E = 0;
              for (const _ of g) {
                if (b.entries[_]._run(
                  // @ts-expect-error
                  { typed: !1, value: i[_] },
                  o
                ).issues) {
                  w = !1, l !== _ && (u < E || u === E && _ in i && !(l in i)) && (u = E, l = _, d = []), l === _ && d.push(
                    b.entries[_].expects
                  );
                  break;
                }
                E++;
              }
              if (w) {
                const _ = b._run(
                  { typed: !1, value: i },
                  o
                );
                (!a || !a.typed && _.typed) && (a = _);
              }
            }
            if (a && !a.issues)
              break;
          }
        };
        if (f(this, /* @__PURE__ */ new Set([this.key])), a)
          return a;
        Vo(this, "type", n, o, {
          // @ts-expect-error
          input: i[l],
          expected: $4(d, "|"),
          path: [
            {
              type: "object",
              origin: "value",
              input: i,
              key: l,
              // @ts-expect-error
              value: i[l]
            }
          ]
        });
      } else
        Vo(this, "type", n, o);
      return n;
    }
  };
}
function pR(e, t) {
  const r = {
    ...e.entries
  };
  for (const n of t)
    delete r[n];
  return { ...e, entries: r };
}
function wO(...e) {
  return {
    ...e[0],
    pipe: e,
    _run(t, r) {
      for (const n of e)
        if (n.kind !== "metadata") {
          if (t.issues && (n.kind === "schema" || n.kind === "transformation")) {
            t.typed = !1;
            break;
          }
          (!t.issues || !r.abortEarly && !r.abortPipeEarly) && (t = n._run(t, r));
        }
      return t;
    }
  };
}
function ame(e) {
  return e.wrapped;
}
var ys = {}, Z1 = {}, sa = {}, Pg = {};
Pg.byteLength = cme;
Pg.toByteArray = fme;
Pg.fromByteArray = pme;
var Ec = [], Cs = [], sme = typeof Uint8Array < "u" ? Uint8Array : Array, lT = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var D0 = 0, ume = lT.length; D0 < ume; ++D0)
  Ec[D0] = lT[D0], Cs[lT.charCodeAt(D0)] = D0;
Cs[45] = 62;
Cs[95] = 63;
function XK(e) {
  var t = e.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = e.indexOf("=");
  r === -1 && (r = t);
  var n = r === t ? 0 : 4 - r % 4;
  return [r, n];
}
function cme(e) {
  var t = XK(e), r = t[0], n = t[1];
  return (r + n) * 3 / 4 - n;
}
function lme(e, t, r) {
  return (t + r) * 3 / 4 - r;
}
function fme(e) {
  var t, r = XK(e), n = r[0], o = r[1], i = new sme(lme(e, n, o)), a = 0, u = o > 0 ? n - 4 : n, l;
  for (l = 0; l < u; l += 4)
    t = Cs[e.charCodeAt(l)] << 18 | Cs[e.charCodeAt(l + 1)] << 12 | Cs[e.charCodeAt(l + 2)] << 6 | Cs[e.charCodeAt(l + 3)], i[a++] = t >> 16 & 255, i[a++] = t >> 8 & 255, i[a++] = t & 255;
  return o === 2 && (t = Cs[e.charCodeAt(l)] << 2 | Cs[e.charCodeAt(l + 1)] >> 4, i[a++] = t & 255), o === 1 && (t = Cs[e.charCodeAt(l)] << 10 | Cs[e.charCodeAt(l + 1)] << 4 | Cs[e.charCodeAt(l + 2)] >> 2, i[a++] = t >> 8 & 255, i[a++] = t & 255), i;
}
function dme(e) {
  return Ec[e >> 18 & 63] + Ec[e >> 12 & 63] + Ec[e >> 6 & 63] + Ec[e & 63];
}
function hme(e, t, r) {
  for (var n, o = [], i = t; i < r; i += 3)
    n = (e[i] << 16 & 16711680) + (e[i + 1] << 8 & 65280) + (e[i + 2] & 255), o.push(dme(n));
  return o.join("");
}
function pme(e) {
  for (var t, r = e.length, n = r % 3, o = [], i = 16383, a = 0, u = r - n; a < u; a += i)
    o.push(hme(e, a, a + i > u ? u : a + i));
  return n === 1 ? (t = e[r - 1], o.push(
    Ec[t >> 2] + Ec[t << 4 & 63] + "=="
  )) : n === 2 && (t = (e[r - 2] << 8) + e[r - 1], o.push(
    Ec[t >> 10] + Ec[t >> 4 & 63] + Ec[t << 2 & 63] + "="
  )), o.join("");
}
Object.defineProperty(sa, "__esModule", { value: !0 });
sa.decode = sa.encode = sa.unescape = sa.escape = sa.pad = void 0;
const YK = Pg;
function hB(e) {
  return `${e}${"=".repeat(4 - (e.length % 4 || 4))}`;
}
sa.pad = hB;
function JK(e) {
  return e.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
sa.escape = JK;
function QK(e) {
  return hB(e).replace(/-/g, "+").replace(/_/g, "/");
}
sa.unescape = QK;
function gme(e) {
  return JK((0, YK.fromByteArray)(new TextEncoder().encode(e)));
}
sa.encode = gme;
function mme(e) {
  return new TextDecoder().decode((0, YK.toByteArray)(hB(QK(e))));
}
sa.decode = mme;
var R4 = {}, z4 = {}, eq = {};
const yme = {}, bme = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yme
}, Symbol.toStringTag, { value: "Module" })), tq = /* @__PURE__ */ vQ(bme);
(function(e) {
  /*! noble-secp256k1 - MIT License (c) 2019 Paul Miller (paulmillr.com) */
  Object.defineProperty(e, "__esModule", { value: !0 }), e.utils = e.schnorr = e.verify = e.signSync = e.sign = e.getSharedSecret = e.recoverPublicKey = e.getPublicKey = e.Signature = e.Point = e.CURVE = void 0;
  const t = tq, r = BigInt(0), n = BigInt(1), o = BigInt(2), i = BigInt(3), a = BigInt(8), u = Object.freeze({
    a: r,
    b: BigInt(7),
    P: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"),
    n: BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"),
    h: n,
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee")
  });
  e.CURVE = u;
  const l = (j, N) => (j + N / o) / N, d = {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar(j) {
      const { n: N } = u, z = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), W = -n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), ie = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), he = z, Ae = BigInt("0x100000000000000000000000000000000"), Ie = l(he * j, N), Me = l(-W * j, N);
      let Fe = J(j - Ie * z - Me * ie, N), We = J(-Ie * W - Me * he, N);
      const it = Fe > Ae, ct = We > Ae;
      if (it && (Fe = N - Fe), ct && (We = N - We), Fe > Ae || We > Ae)
        throw new Error("splitScalarEndo: Endomorphism failed, k=" + j);
      return { k1neg: it, k1: Fe, k2neg: ct, k2: We };
    }
  }, f = 32, h = 32, g = 32, b = f + 1, w = 2 * f + 1;
  function E(j) {
    const { a: N, b: z } = u, W = J(j * j), ie = J(W * j);
    return J(ie + N * j + z);
  }
  const _ = u.a === r;
  class O extends Error {
    constructor(N) {
      super(N);
    }
  }
  function C(j) {
    if (!(j instanceof I))
      throw new TypeError("JacobianPoint expected");
  }
  class I {
    constructor(N, z, W) {
      this.x = N, this.y = z, this.z = W;
    }
    static fromAffine(N) {
      if (!(N instanceof A))
        throw new TypeError("JacobianPoint#fromAffine: expected Point");
      return N.equals(A.ZERO) ? I.ZERO : new I(N.x, N.y, n);
    }
    static toAffineBatch(N) {
      const z = _e(N.map((W) => W.z));
      return N.map((W, ie) => W.toAffine(z[ie]));
    }
    static normalizeZ(N) {
      return I.toAffineBatch(N).map(I.fromAffine);
    }
    equals(N) {
      C(N);
      const { x: z, y: W, z: ie } = this, { x: he, y: Ae, z: Ie } = N, Me = J(ie * ie), Fe = J(Ie * Ie), We = J(z * Fe), it = J(he * Me), ct = J(J(W * Ie) * Fe), ar = J(J(Ae * ie) * Me);
      return We === it && ct === ar;
    }
    negate() {
      return new I(this.x, J(-this.y), this.z);
    }
    double() {
      const { x: N, y: z, z: W } = this, ie = J(N * N), he = J(z * z), Ae = J(he * he), Ie = N + he, Me = J(o * (J(Ie * Ie) - ie - Ae)), Fe = J(i * ie), We = J(Fe * Fe), it = J(We - o * Me), ct = J(Fe * (Me - it) - a * Ae), ar = J(o * z * W);
      return new I(it, ct, ar);
    }
    add(N) {
      C(N);
      const { x: z, y: W, z: ie } = this, { x: he, y: Ae, z: Ie } = N;
      if (he === r || Ae === r)
        return this;
      if (z === r || W === r)
        return N;
      const Me = J(ie * ie), Fe = J(Ie * Ie), We = J(z * Fe), it = J(he * Me), ct = J(J(W * Ie) * Fe), ar = J(J(Ae * ie) * Me), sr = J(it - We), qn = J(ar - ct);
      if (sr === r)
        return qn === r ? this.double() : I.ZERO;
      const ci = J(sr * sr), Io = J(sr * ci), li = J(We * ci), Ra = J(qn * qn - Io - o * li), Ws = J(qn * (li - Ra) - ct * Io), Vi = J(ie * Ie * sr);
      return new I(Ra, Ws, Vi);
    }
    subtract(N) {
      return this.add(N.negate());
    }
    multiplyUnsafe(N) {
      const z = I.ZERO;
      if (typeof N == "bigint" && N === r)
        return z;
      let W = se(N);
      if (W === n)
        return this;
      if (!_) {
        let it = z, ct = this;
        for (; W > r; )
          W & n && (it = it.add(ct)), ct = ct.double(), W >>= n;
        return it;
      }
      let { k1neg: ie, k1: he, k2neg: Ae, k2: Ie } = d.splitScalar(W), Me = z, Fe = z, We = this;
      for (; he > r || Ie > r; )
        he & n && (Me = Me.add(We)), Ie & n && (Fe = Fe.add(We)), We = We.double(), he >>= n, Ie >>= n;
      return ie && (Me = Me.negate()), Ae && (Fe = Fe.negate()), Fe = new I(J(Fe.x * d.beta), Fe.y, Fe.z), Me.add(Fe);
    }
    precomputeWindow(N) {
      const z = _ ? 128 / N + 1 : 256 / N + 1, W = [];
      let ie = this, he = ie;
      for (let Ae = 0; Ae < z; Ae++) {
        he = ie, W.push(he);
        for (let Ie = 1; Ie < 2 ** (N - 1); Ie++)
          he = he.add(ie), W.push(he);
        ie = he.double();
      }
      return W;
    }
    wNAF(N, z) {
      !z && this.equals(I.BASE) && (z = A.BASE);
      const W = z && z._WINDOW_SIZE || 1;
      if (256 % W)
        throw new Error("Point#wNAF: Invalid precomputation window, must be power of 2");
      let ie = z && T.get(z);
      ie || (ie = this.precomputeWindow(W), z && W !== 1 && (ie = I.normalizeZ(ie), T.set(z, ie)));
      let he = I.ZERO, Ae = I.BASE;
      const Ie = 1 + (_ ? 128 / W : 256 / W), Me = 2 ** (W - 1), Fe = BigInt(2 ** W - 1), We = 2 ** W, it = BigInt(W);
      for (let ct = 0; ct < Ie; ct++) {
        const ar = ct * Me;
        let sr = Number(N & Fe);
        N >>= it, sr > Me && (sr -= We, N += n);
        const qn = ar, ci = ar + Math.abs(sr) - 1, Io = ct % 2 !== 0, li = sr < 0;
        sr === 0 ? Ae = Ae.add(S(Io, ie[qn])) : he = he.add(S(li, ie[ci]));
      }
      return { p: he, f: Ae };
    }
    multiply(N, z) {
      let W = se(N), ie, he;
      if (_) {
        const { k1neg: Ae, k1: Ie, k2neg: Me, k2: Fe } = d.splitScalar(W);
        let { p: We, f: it } = this.wNAF(Ie, z), { p: ct, f: ar } = this.wNAF(Fe, z);
        We = S(Ae, We), ct = S(Me, ct), ct = new I(J(ct.x * d.beta), ct.y, ct.z), ie = We.add(ct), he = it.add(ar);
      } else {
        const { p: Ae, f: Ie } = this.wNAF(W, z);
        ie = Ae, he = Ie;
      }
      return I.normalizeZ([ie, he])[0];
    }
    toAffine(N) {
      const { x: z, y: W, z: ie } = this, he = this.equals(I.ZERO);
      N == null && (N = he ? a : Ee(ie));
      const Ae = N, Ie = J(Ae * Ae), Me = J(Ie * Ae), Fe = J(z * Ie), We = J(W * Me), it = J(ie * Ae);
      if (he)
        return A.ZERO;
      if (it !== n)
        throw new Error("invZ was invalid");
      return new A(Fe, We);
    }
  }
  I.BASE = new I(u.Gx, u.Gy, n), I.ZERO = new I(r, n, r);
  function S(j, N) {
    const z = N.negate();
    return j ? z : N;
  }
  const T = /* @__PURE__ */ new WeakMap();
  class A {
    constructor(N, z) {
      this.x = N, this.y = z;
    }
    _setWindowSize(N) {
      this._WINDOW_SIZE = N, T.delete(this);
    }
    hasEvenY() {
      return this.y % o === r;
    }
    static fromCompressedHex(N) {
      const z = N.length === 32, W = q(z ? N : N.subarray(1));
      if (!ge(W))
        throw new Error("Point is not on curve");
      const ie = E(W);
      let he = ve(ie);
      const Ae = (he & n) === n;
      z ? Ae && (he = J(-he)) : (N[0] & 1) === 1 !== Ae && (he = J(-he));
      const Ie = new A(W, he);
      return Ie.assertValidity(), Ie;
    }
    static fromUncompressedHex(N) {
      const z = q(N.subarray(1, f + 1)), W = q(N.subarray(f + 1, f * 2 + 1)), ie = new A(z, W);
      return ie.assertValidity(), ie;
    }
    static fromHex(N) {
      const z = Q(N), W = z.length, ie = z[0];
      if (W === f)
        return this.fromCompressedHex(z);
      if (W === b && (ie === 2 || ie === 3))
        return this.fromCompressedHex(z);
      if (W === w && ie === 4)
        return this.fromUncompressedHex(z);
      throw new Error(`Point.fromHex: received invalid point. Expected 32-${b} compressed bytes or ${w} uncompressed bytes, not ${W}`);
    }
    static fromPrivateKey(N) {
      return A.BASE.multiply(Oe(N));
    }
    static fromSignature(N, z, W) {
      const { r: ie, s: he } = mt(z);
      if (![0, 1, 2, 3].includes(W))
        throw new Error("Cannot recover: invalid recovery bit");
      const Ae = be(Q(N)), { n: Ie } = u, Me = W === 2 || W === 3 ? ie + Ie : ie, Fe = Ee(Me, Ie), We = J(-Ae * Fe, Ie), it = J(he * Fe, Ie), ct = W & 1 ? "03" : "02", ar = A.fromHex(ct + D(Me)), sr = A.BASE.multiplyAndAddUnsafe(ar, We, it);
      if (!sr)
        throw new Error("Cannot recover signature: point at infinify");
      return sr.assertValidity(), sr;
    }
    toRawBytes(N = !1) {
      return G(this.toHex(N));
    }
    toHex(N = !1) {
      const z = D(this.x);
      return N ? `${this.hasEvenY() ? "02" : "03"}${z}` : `04${z}${D(this.y)}`;
    }
    toHexX() {
      return this.toHex(!0).slice(2);
    }
    toRawX() {
      return this.toRawBytes(!0).slice(1);
    }
    assertValidity() {
      const N = "Point is not on elliptic curve", { x: z, y: W } = this;
      if (!ge(z) || !ge(W))
        throw new Error(N);
      const ie = J(W * W), he = E(z);
      if (J(ie - he) !== r)
        throw new Error(N);
    }
    equals(N) {
      return this.x === N.x && this.y === N.y;
    }
    negate() {
      return new A(this.x, J(-this.y));
    }
    double() {
      return I.fromAffine(this).double().toAffine();
    }
    add(N) {
      return I.fromAffine(this).add(I.fromAffine(N)).toAffine();
    }
    subtract(N) {
      return this.add(N.negate());
    }
    multiply(N) {
      return I.fromAffine(this).multiply(N, this).toAffine();
    }
    multiplyAndAddUnsafe(N, z, W) {
      const ie = I.fromAffine(this), he = z === r || z === n || this !== A.BASE ? ie.multiplyUnsafe(z) : ie.multiply(z), Ae = I.fromAffine(N).multiplyUnsafe(W), Ie = he.add(Ae);
      return Ie.equals(I.ZERO) ? void 0 : Ie.toAffine();
    }
  }
  e.Point = A, A.BASE = new A(u.Gx, u.Gy), A.ZERO = new A(r, r);
  function $(j) {
    return Number.parseInt(j[0], 16) >= 8 ? "00" + j : j;
  }
  function U(j) {
    if (j.length < 2 || j[0] !== 2)
      throw new Error(`Invalid signature integer tag: ${de(j)}`);
    const N = j[1], z = j.subarray(2, N + 2);
    if (!N || z.length !== N)
      throw new Error("Invalid signature integer: wrong length");
    if (z[0] === 0 && z[1] <= 127)
      throw new Error("Invalid signature integer: trailing length");
    return { data: q(z), left: j.subarray(N + 2) };
  }
  function M(j) {
    if (j.length < 2 || j[0] != 48)
      throw new Error(`Invalid signature tag: ${de(j)}`);
    if (j[1] !== j.length - 2)
      throw new Error("Invalid signature: incorrect length");
    const { data: N, left: z } = U(j.subarray(2)), { data: W, left: ie } = U(z);
    if (ie.length)
      throw new Error(`Invalid signature: left bytes after parsing: ${de(ie)}`);
    return { r: N, s: W };
  }
  class Y {
    constructor(N, z) {
      this.r = N, this.s = z, this.assertValidity();
    }
    static fromCompact(N) {
      const z = N instanceof Uint8Array, W = "Signature.fromCompact";
      if (typeof N != "string" && !z)
        throw new TypeError(`${W}: Expected string or Uint8Array`);
      const ie = z ? de(N) : N;
      if (ie.length !== 128)
        throw new Error(`${W}: Expected 64-byte hex`);
      return new Y(re(ie.slice(0, 64)), re(ie.slice(64, 128)));
    }
    static fromDER(N) {
      const z = N instanceof Uint8Array;
      if (typeof N != "string" && !z)
        throw new TypeError("Signature.fromDER: Expected string or Uint8Array");
      const { r: W, s: ie } = M(z ? N : G(N));
      return new Y(W, ie);
    }
    static fromHex(N) {
      return this.fromDER(N);
    }
    assertValidity() {
      const { r: N, s: z } = this;
      if (!Ve(N))
        throw new Error("Invalid Signature: r must be 0 < r < n");
      if (!Ve(z))
        throw new Error("Invalid Signature: s must be 0 < s < n");
    }
    hasHighS() {
      const N = u.n >> n;
      return this.s > N;
    }
    normalizeS() {
      return this.hasHighS() ? new Y(this.r, J(-this.s, u.n)) : this;
    }
    toDERRawBytes() {
      return G(this.toDERHex());
    }
    toDERHex() {
      const N = $(le(this.s)), z = $(le(this.r)), W = N.length / 2, ie = z.length / 2, he = le(W), Ae = le(ie);
      return `30${le(ie + W + 4)}02${Ae}${z}02${he}${N}`;
    }
    toRawBytes() {
      return this.toDERRawBytes();
    }
    toHex() {
      return this.toDERHex();
    }
    toCompactRawBytes() {
      return G(this.toCompactHex());
    }
    toCompactHex() {
      return D(this.r) + D(this.s);
    }
  }
  e.Signature = Y;
  function L(...j) {
    if (!j.every((W) => W instanceof Uint8Array))
      throw new Error("Uint8Array list expected");
    if (j.length === 1)
      return j[0];
    const N = j.reduce((W, ie) => W + ie.length, 0), z = new Uint8Array(N);
    for (let W = 0, ie = 0; W < j.length; W++) {
      const he = j[W];
      z.set(he, ie), ie += he.length;
    }
    return z;
  }
  const ee = Array.from({ length: 256 }, (j, N) => N.toString(16).padStart(2, "0"));
  function de(j) {
    if (!(j instanceof Uint8Array))
      throw new Error("Expected Uint8Array");
    let N = "";
    for (let z = 0; z < j.length; z++)
      N += ee[j[z]];
    return N;
  }
  const ne = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000");
  function D(j) {
    if (typeof j != "bigint")
      throw new Error("Expected bigint");
    if (!(r <= j && j < ne))
      throw new Error("Expected number 0 <= n < 2^256");
    return j.toString(16).padStart(64, "0");
  }
  function K(j) {
    const N = G(D(j));
    if (N.length !== 32)
      throw new Error("Error: expected 32 bytes");
    return N;
  }
  function le(j) {
    const N = j.toString(16);
    return N.length & 1 ? `0${N}` : N;
  }
  function re(j) {
    if (typeof j != "string")
      throw new TypeError("hexToNumber: expected string, got " + typeof j);
    return BigInt(`0x${j}`);
  }
  function G(j) {
    if (typeof j != "string")
      throw new TypeError("hexToBytes: expected string, got " + typeof j);
    if (j.length % 2)
      throw new Error("hexToBytes: received invalid unpadded hex" + j.length);
    const N = new Uint8Array(j.length / 2);
    for (let z = 0; z < N.length; z++) {
      const W = z * 2, ie = j.slice(W, W + 2), he = Number.parseInt(ie, 16);
      if (Number.isNaN(he) || he < 0)
        throw new Error("Invalid byte sequence");
      N[z] = he;
    }
    return N;
  }
  function q(j) {
    return re(de(j));
  }
  function Q(j) {
    return j instanceof Uint8Array ? Uint8Array.from(j) : G(j);
  }
  function se(j) {
    if (typeof j == "number" && Number.isSafeInteger(j) && j > 0)
      return BigInt(j);
    if (typeof j == "bigint" && Ve(j))
      return j;
    throw new TypeError("Expected valid private scalar: 0 < scalar < curve.n");
  }
  function J(j, N = u.P) {
    const z = j % N;
    return z >= r ? z : N + z;
  }
  function ye(j, N) {
    const { P: z } = u;
    let W = j;
    for (; N-- > r; )
      W *= W, W %= z;
    return W;
  }
  function ve(j) {
    const { P: N } = u, z = BigInt(6), W = BigInt(11), ie = BigInt(22), he = BigInt(23), Ae = BigInt(44), Ie = BigInt(88), Me = j * j * j % N, Fe = Me * Me * j % N, We = ye(Fe, i) * Fe % N, it = ye(We, i) * Fe % N, ct = ye(it, o) * Me % N, ar = ye(ct, W) * ct % N, sr = ye(ar, ie) * ar % N, qn = ye(sr, Ae) * sr % N, ci = ye(qn, Ie) * qn % N, Io = ye(ci, Ae) * sr % N, li = ye(Io, i) * Fe % N, Ra = ye(li, he) * ar % N, Ws = ye(Ra, z) * Me % N, Vi = ye(Ws, o);
    if (Vi * Vi % N !== j)
      throw new Error("Cannot find square root");
    return Vi;
  }
  function Ee(j, N = u.P) {
    if (j === r || N <= r)
      throw new Error(`invert: expected positive integers, got n=${j} mod=${N}`);
    let z = J(j, N), W = N, ie = r, he = n;
    for (; z !== r; ) {
      const Ae = W / z, Ie = W % z, Me = ie - he * Ae;
      W = z, z = Ie, ie = he, he = Me;
    }
    if (W !== n)
      throw new Error("invert: does not exist");
    return J(ie, N);
  }
  function _e(j, N = u.P) {
    const z = new Array(j.length), W = j.reduce((he, Ae, Ie) => Ae === r ? he : (z[Ie] = he, J(he * Ae, N)), n), ie = Ee(W, N);
    return j.reduceRight((he, Ae, Ie) => Ae === r ? he : (z[Ie] = J(he * z[Ie], N), J(he * Ae, N)), ie), z;
  }
  function we(j) {
    const N = j.length * 8 - h * 8, z = q(j);
    return N > 0 ? z >> BigInt(N) : z;
  }
  function be(j, N = !1) {
    const z = we(j);
    if (N)
      return z;
    const { n: W } = u;
    return z >= W ? z - W : z;
  }
  let Ge, Le;
  class Ne {
    constructor(N, z) {
      if (this.hashLen = N, this.qByteLen = z, typeof N != "number" || N < 2)
        throw new Error("hashLen must be a number");
      if (typeof z != "number" || z < 2)
        throw new Error("qByteLen must be a number");
      this.v = new Uint8Array(N).fill(1), this.k = new Uint8Array(N).fill(0), this.counter = 0;
    }
    hmac(...N) {
      return e.utils.hmacSha256(this.k, ...N);
    }
    hmacSync(...N) {
      return Le(this.k, ...N);
    }
    checkSync() {
      if (typeof Le != "function")
        throw new O("hmacSha256Sync needs to be set");
    }
    incr() {
      if (this.counter >= 1e3)
        throw new Error("Tried 1,000 k values for sign(), all were invalid");
      this.counter += 1;
    }
    async reseed(N = new Uint8Array()) {
      this.k = await this.hmac(this.v, Uint8Array.from([0]), N), this.v = await this.hmac(this.v), N.length !== 0 && (this.k = await this.hmac(this.v, Uint8Array.from([1]), N), this.v = await this.hmac(this.v));
    }
    reseedSync(N = new Uint8Array()) {
      this.checkSync(), this.k = this.hmacSync(this.v, Uint8Array.from([0]), N), this.v = this.hmacSync(this.v), N.length !== 0 && (this.k = this.hmacSync(this.v, Uint8Array.from([1]), N), this.v = this.hmacSync(this.v));
    }
    async generate() {
      this.incr();
      let N = 0;
      const z = [];
      for (; N < this.qByteLen; ) {
        this.v = await this.hmac(this.v);
        const W = this.v.slice();
        z.push(W), N += this.v.length;
      }
      return L(...z);
    }
    generateSync() {
      this.checkSync(), this.incr();
      let N = 0;
      const z = [];
      for (; N < this.qByteLen; ) {
        this.v = this.hmacSync(this.v);
        const W = this.v.slice();
        z.push(W), N += this.v.length;
      }
      return L(...z);
    }
  }
  function Ve(j) {
    return r < j && j < u.n;
  }
  function ge(j) {
    return r < j && j < u.P;
  }
  function Te(j, N, z, W = !0) {
    const { n: ie } = u, he = be(j, !0);
    if (!Ve(he))
      return;
    const Ae = Ee(he, ie), Ie = A.BASE.multiply(he), Me = J(Ie.x, ie);
    if (Me === r)
      return;
    const Fe = J(Ae * J(N + z * Me, ie), ie);
    if (Fe === r)
      return;
    let We = new Y(Me, Fe), it = (Ie.x === We.r ? 0 : 2) | Number(Ie.y & n);
    return W && We.hasHighS() && (We = We.normalizeS(), it ^= 1), { sig: We, recovery: it };
  }
  function Oe(j) {
    let N;
    if (typeof j == "bigint")
      N = j;
    else if (typeof j == "number" && Number.isSafeInteger(j) && j > 0)
      N = BigInt(j);
    else if (typeof j == "string") {
      if (j.length !== 2 * h)
        throw new Error("Expected 32 bytes of private key");
      N = re(j);
    } else if (j instanceof Uint8Array) {
      if (j.length !== h)
        throw new Error("Expected 32 bytes of private key");
      N = q(j);
    } else
      throw new TypeError("Expected valid private key");
    if (!Ve(N))
      throw new Error("Expected private key: 0 < key < n");
    return N;
  }
  function He(j) {
    return j instanceof A ? (j.assertValidity(), j) : A.fromHex(j);
  }
  function mt(j) {
    if (j instanceof Y)
      return j.assertValidity(), j;
    try {
      return Y.fromDER(j);
    } catch {
      return Y.fromCompact(j);
    }
  }
  function rt(j, N = !1) {
    return A.fromPrivateKey(j).toRawBytes(N);
  }
  e.getPublicKey = rt;
  function Pt(j, N, z, W = !1) {
    return A.fromSignature(j, N, z).toRawBytes(W);
  }
  e.recoverPublicKey = Pt;
  function _t(j) {
    const N = j instanceof Uint8Array, z = typeof j == "string", W = (N || z) && j.length;
    return N ? W === b || W === w : z ? W === b * 2 || W === w * 2 : j instanceof A;
  }
  function yt(j, N, z = !1) {
    if (_t(j))
      throw new TypeError("getSharedSecret: first arg must be private key");
    if (!_t(N))
      throw new TypeError("getSharedSecret: second arg must be public key");
    const W = He(N);
    return W.assertValidity(), W.multiply(Oe(j)).toRawBytes(z);
  }
  e.getSharedSecret = yt;
  function Zt(j) {
    const N = j.length > f ? j.slice(0, f) : j;
    return q(N);
  }
  function yn(j) {
    const N = Zt(j), z = J(N, u.n);
    return kt(z < r ? N : z);
  }
  function kt(j) {
    return K(j);
  }
  function qr(j, N, z) {
    if (j == null)
      throw new Error(`sign: expected valid message hash, not "${j}"`);
    const W = Q(j), ie = Oe(N), he = [kt(ie), yn(W)];
    if (z != null) {
      z === !0 && (z = e.utils.randomBytes(f));
      const Me = Q(z);
      if (Me.length !== f)
        throw new Error(`sign: Expected ${f} bytes of extra data`);
      he.push(Me);
    }
    const Ae = L(...he), Ie = Zt(W);
    return { seed: Ae, m: Ie, d: ie };
  }
  function m(j, N) {
    const { sig: z, recovery: W } = j, { der: ie, recovered: he } = Object.assign({ canonical: !0, der: !0 }, N), Ae = ie ? z.toDERRawBytes() : z.toCompactRawBytes();
    return he ? [Ae, W] : Ae;
  }
  async function v(j, N, z = {}) {
    const { seed: W, m: ie, d: he } = qr(j, N, z.extraEntropy), Ae = new Ne(g, h);
    await Ae.reseed(W);
    let Ie;
    for (; !(Ie = Te(await Ae.generate(), ie, he, z.canonical)); )
      await Ae.reseed();
    return m(Ie, z);
  }
  e.sign = v;
  function k(j, N, z = {}) {
    const { seed: W, m: ie, d: he } = qr(j, N, z.extraEntropy), Ae = new Ne(g, h);
    Ae.reseedSync(W);
    let Ie;
    for (; !(Ie = Te(Ae.generateSync(), ie, he, z.canonical)); )
      Ae.reseedSync();
    return m(Ie, z);
  }
  e.signSync = k;
  const H = { strict: !0 };
  function X(j, N, z, W = H) {
    let ie;
    try {
      ie = mt(j), N = Q(N);
    } catch {
      return !1;
    }
    const { r: he, s: Ae } = ie;
    if (W.strict && ie.hasHighS())
      return !1;
    const Ie = be(N);
    let Me;
    try {
      Me = He(z);
    } catch {
      return !1;
    }
    const { n: Fe } = u, We = Ee(Ae, Fe), it = J(Ie * We, Fe), ct = J(he * We, Fe), ar = A.BASE.multiplyAndAddUnsafe(Me, it, ct);
    return ar ? J(ar.x, Fe) === he : !1;
  }
  e.verify = X;
  function oe(j) {
    return J(q(j), u.n);
  }
  class me {
    constructor(N, z) {
      this.r = N, this.s = z, this.assertValidity();
    }
    static fromHex(N) {
      const z = Q(N);
      if (z.length !== 64)
        throw new TypeError(`SchnorrSignature.fromHex: expected 64 bytes, not ${z.length}`);
      const W = q(z.subarray(0, 32)), ie = q(z.subarray(32, 64));
      return new me(W, ie);
    }
    assertValidity() {
      const { r: N, s: z } = this;
      if (!ge(N) || !Ve(z))
        throw new Error("Invalid signature");
    }
    toHex() {
      return D(this.r) + D(this.s);
    }
    toRawBytes() {
      return G(this.toHex());
    }
  }
  function nt(j) {
    return A.fromPrivateKey(j).toRawX();
  }
  class Ct {
    constructor(N, z, W = e.utils.randomBytes()) {
      if (N == null)
        throw new TypeError(`sign: Expected valid message, not "${N}"`);
      this.m = Q(N);
      const { x: ie, scalar: he } = this.getScalar(Oe(z));
      if (this.px = ie, this.d = he, this.rand = Q(W), this.rand.length !== 32)
        throw new TypeError("sign: Expected 32 bytes of aux randomness");
    }
    getScalar(N) {
      const z = A.fromPrivateKey(N), W = z.hasEvenY() ? N : u.n - N;
      return { point: z, scalar: W, x: z.toRawX() };
    }
    initNonce(N, z) {
      return K(N ^ q(z));
    }
    finalizeNonce(N) {
      const z = J(q(N), u.n);
      if (z === r)
        throw new Error("sign: Creation of signature failed. k is zero");
      const { point: W, x: ie, scalar: he } = this.getScalar(z);
      return { R: W, rx: ie, k: he };
    }
    finalizeSig(N, z, W, ie) {
      return new me(N.x, J(z + W * ie, u.n)).toRawBytes();
    }
    error() {
      throw new Error("sign: Invalid signature produced");
    }
    async calc() {
      const { m: N, d: z, px: W, rand: ie } = this, he = e.utils.taggedHash, Ae = this.initNonce(z, await he(fo.aux, ie)), { R: Ie, rx: Me, k: Fe } = this.finalizeNonce(await he(fo.nonce, Ae, W, N)), We = oe(await he(fo.challenge, Me, W, N)), it = this.finalizeSig(Ie, Fe, We, z);
      return await Lc(it, N, W) || this.error(), it;
    }
    calcSync() {
      const { m: N, d: z, px: W, rand: ie } = this, he = e.utils.taggedHashSync, Ae = this.initNonce(z, he(fo.aux, ie)), { R: Ie, rx: Me, k: Fe } = this.finalizeNonce(he(fo.nonce, Ae, W, N)), We = oe(he(fo.challenge, Me, W, N)), it = this.finalizeSig(Ie, Fe, We, z);
      return Gs(it, N, W) || this.error(), it;
    }
  }
  async function At(j, N, z) {
    return new Ct(j, N, z).calc();
  }
  function vt(j, N, z) {
    return new Ct(j, N, z).calcSync();
  }
  function Ht(j, N, z) {
    const W = j instanceof me, ie = W ? j : me.fromHex(j);
    return W && ie.assertValidity(), {
      ...ie,
      m: Q(N),
      P: He(z)
    };
  }
  function jc(j, N, z, W) {
    const ie = A.BASE.multiplyAndAddUnsafe(N, Oe(z), J(-W, u.n));
    return !(!ie || !ie.hasEvenY() || ie.x !== j);
  }
  async function Lc(j, N, z) {
    try {
      const { r: W, s: ie, m: he, P: Ae } = Ht(j, N, z), Ie = oe(await e.utils.taggedHash(fo.challenge, K(W), Ae.toRawX(), he));
      return jc(W, Ae, ie, Ie);
    } catch {
      return !1;
    }
  }
  function Gs(j, N, z) {
    try {
      const { r: W, s: ie, m: he, P: Ae } = Ht(j, N, z), Ie = oe(e.utils.taggedHashSync(fo.challenge, K(W), Ae.toRawX(), he));
      return jc(W, Ae, ie, Ie);
    } catch (W) {
      if (W instanceof O)
        throw W;
      return !1;
    }
  }
  e.schnorr = {
    Signature: me,
    getPublicKey: nt,
    sign: At,
    verify: Lc,
    signSync: vt,
    verifySync: Gs
  }, A.BASE._setWindowSize(8);
  const Hr = {
    node: t,
    web: typeof self == "object" && "crypto" in self ? self.crypto : void 0
  }, fo = {
    challenge: "BIP0340/challenge",
    aux: "BIP0340/aux",
    nonce: "BIP0340/nonce"
  }, Ua = {};
  e.utils = {
    bytesToHex: de,
    hexToBytes: G,
    concatBytes: L,
    mod: J,
    invert: Ee,
    isValidPrivateKey(j) {
      try {
        return Oe(j), !0;
      } catch {
        return !1;
      }
    },
    _bigintTo32Bytes: K,
    _normalizePrivateKey: Oe,
    hashToPrivateKey: (j) => {
      j = Q(j);
      const N = h + 8;
      if (j.length < N || j.length > 1024)
        throw new Error("Expected valid bytes of private key as per FIPS 186");
      const z = J(q(j), u.n - n) + n;
      return K(z);
    },
    randomBytes: (j = 32) => {
      if (Hr.web)
        return Hr.web.getRandomValues(new Uint8Array(j));
      if (Hr.node) {
        const { randomBytes: N } = Hr.node;
        return Uint8Array.from(N(j));
      } else
        throw new Error("The environment doesn't have randomBytes function");
    },
    randomPrivateKey: () => e.utils.hashToPrivateKey(e.utils.randomBytes(h + 8)),
    precompute(j = 8, N = A.BASE) {
      const z = N === A.BASE ? N : new A(N.x, N.y);
      return z._setWindowSize(j), z.multiply(i), z;
    },
    sha256: async (...j) => {
      if (Hr.web) {
        const N = await Hr.web.subtle.digest("SHA-256", L(...j));
        return new Uint8Array(N);
      } else if (Hr.node) {
        const { createHash: N } = Hr.node, z = N("sha256");
        return j.forEach((W) => z.update(W)), Uint8Array.from(z.digest());
      } else
        throw new Error("The environment doesn't have sha256 function");
    },
    hmacSha256: async (j, ...N) => {
      if (Hr.web) {
        const z = await Hr.web.subtle.importKey("raw", j, { name: "HMAC", hash: { name: "SHA-256" } }, !1, ["sign"]), W = L(...N), ie = await Hr.web.subtle.sign("HMAC", z, W);
        return new Uint8Array(ie);
      } else if (Hr.node) {
        const { createHmac: z } = Hr.node, W = z("sha256", j);
        return N.forEach((ie) => W.update(ie)), Uint8Array.from(W.digest());
      } else
        throw new Error("The environment doesn't have hmac-sha256 function");
    },
    sha256Sync: void 0,
    hmacSha256Sync: void 0,
    taggedHash: async (j, ...N) => {
      let z = Ua[j];
      if (z === void 0) {
        const W = await e.utils.sha256(Uint8Array.from(j, (ie) => ie.charCodeAt(0)));
        z = L(W, W), Ua[j] = z;
      }
      return e.utils.sha256(z, ...N);
    },
    taggedHashSync: (j, ...N) => {
      if (typeof Ge != "function")
        throw new O("sha256Sync is undefined, you need to set it");
      let z = Ua[j];
      if (z === void 0) {
        const W = Ge(Uint8Array.from(j, (ie) => ie.charCodeAt(0)));
        z = L(W, W), Ua[j] = z;
      }
      return Ge(z, ...N);
    },
    _JacobianPoint: I
  }, Object.defineProperties(e.utils, {
    sha256Sync: {
      configurable: !1,
      get() {
        return Ge;
      },
      set(j) {
        Ge || (Ge = j);
      }
    },
    hmacSha256Sync: {
      configurable: !1,
      get() {
        return Le;
      },
      set(j) {
        Le || (Le = j);
      }
    }
  });
})(eq);
var X1 = {};
Object.defineProperty(X1, "__esModule", { value: !0 });
X1.joseToDer = X1.derToJose = void 0;
const rq = Pg, nq = sa;
function fT(e) {
  return (e / 8 | 0) + (e % 8 === 0 ? 0 : 1);
}
const wme = {
  ES256: fT(256),
  ES384: fT(384),
  ES512: fT(521)
};
function oq(e) {
  const t = wme[e];
  if (t)
    return t;
  throw new Error(`Unknown algorithm "${e}"`);
}
const M3 = 128, iq = 0, vme = 32, Eme = 16, _me = 2, aq = Eme | vme | iq << 6, D3 = _me | iq << 6;
function sq(e) {
  if (e instanceof Uint8Array)
    return e;
  if (typeof e == "string")
    return (0, rq.toByteArray)((0, nq.pad)(e));
  throw new TypeError("ECDSA signature must be a Base64 string or a Uint8Array");
}
function Ame(e, t) {
  const r = sq(e), n = oq(t), o = n + 1, i = r.length;
  let a = 0;
  if (r[a++] !== aq)
    throw new Error('Could not find expected "seq"');
  let u = r[a++];
  if (u === (M3 | 1) && (u = r[a++]), i - a < u)
    throw new Error(`"seq" specified length of "${u}", only "${i - a}" remaining`);
  if (r[a++] !== D3)
    throw new Error('Could not find expected "int" for "r"');
  const l = r[a++];
  if (i - a - 2 < l)
    throw new Error(`"r" specified length of "${l}", only "${i - a - 2}" available`);
  if (o < l)
    throw new Error(`"r" specified length of "${l}", max of "${o}" is acceptable`);
  const d = a;
  if (a += l, r[a++] !== D3)
    throw new Error('Could not find expected "int" for "s"');
  const f = r[a++];
  if (i - a !== f)
    throw new Error(`"s" specified length of "${f}", expected "${i - a}"`);
  if (o < f)
    throw new Error(`"s" specified length of "${f}", max of "${o}" is acceptable`);
  const h = a;
  if (a += f, a !== i)
    throw new Error(`Expected to consume entire array, but "${i - a}" bytes remain`);
  const g = n - l, b = n - f, w = new Uint8Array(g + l + b + f);
  for (a = 0; a < g; ++a)
    w[a] = 0;
  w.set(r.subarray(d + Math.max(-g, 0), d + l), a), a = n;
  for (const E = a; a < E + b; ++a)
    w[a] = 0;
  return w.set(r.subarray(h + Math.max(-b, 0), h + f), a), (0, nq.escape)((0, rq.fromByteArray)(w));
}
X1.derToJose = Ame;
function gR(e, t, r) {
  let n = 0;
  for (; t + n < r && e[t + n] === 0; )
    ++n;
  return e[t + n] >= M3 && --n, n;
}
function xme(e, t) {
  e = sq(e);
  const r = oq(t), n = e.length;
  if (n !== r * 2)
    throw new TypeError(`"${t}" signatures must be "${r * 2}" bytes, saw "${n}"`);
  const o = gR(e, 0, r), i = gR(e, r, e.length), a = r - o, u = r - i, l = 2 + a + 1 + 1 + u, d = l < M3, f = new Uint8Array((d ? 2 : 3) + l);
  let h = 0;
  return f[h++] = aq, d ? f[h++] = l : (f[h++] = M3 | 1, f[h++] = l & 255), f[h++] = D3, f[h++] = a, o < 0 ? (f[h++] = 0, f.set(e.subarray(0, r), h), h += r) : (f.set(e.subarray(o, r), h), h += r - o), f[h++] = D3, f[h++] = u, i < 0 ? (f[h++] = 0, f.set(e.subarray(r), h)) : f.set(e.subarray(r + i), h), f;
}
X1.joseToDer = xme;
var cf = {};
Object.defineProperty(cf, "__esModule", { value: !0 });
cf.InvalidTokenError = cf.MissingParametersError = void 0;
let kme = class extends Error {
  constructor(t) {
    super(), this.name = "MissingParametersError", this.message = t || "";
  }
};
cf.MissingParametersError = kme;
let Sme = class extends Error {
  constructor(t) {
    super(), this.name = "InvalidTokenError", this.message = t || "";
  }
};
cf.InvalidTokenError = Sme;
Object.defineProperty(z4, "__esModule", { value: !0 });
z4.SECP256K1Client = void 0;
const Tme = v2, Ime = Cu, M8 = eq, mR = X1, yR = cf, bR = Ds;
M8.utils.hmacSha256Sync = (e, ...t) => {
  const r = Tme.hmac.create(Ime.sha256, e);
  return t.forEach((n) => r.update(n)), r.digest();
};
let uq = class {
  static derivePublicKey(t, r = !0) {
    return t.length === 66 && (t = t.slice(0, 64)), t.length < 64 && (t = t.padStart(64, "0")), (0, bR.bytesToHex)(M8.getPublicKey(t, r));
  }
  static signHash(t, r, n = "jose") {
    if (!t || !r)
      throw new yR.MissingParametersError("a signing input hash and private key are all required");
    const o = M8.signSync(t, r.slice(0, 64), {
      der: !0,
      canonical: !1
    });
    if (n === "der")
      return (0, bR.bytesToHex)(o);
    if (n === "jose")
      return (0, mR.derToJose)(o, "ES256");
    throw Error("Invalid signature format");
  }
  static loadSignature(t) {
    return (0, mR.joseToDer)(t, "ES256");
  }
  static verifyHash(t, r, n) {
    if (!t || !r || !n)
      throw new yR.MissingParametersError("a signing input hash, der signature, and public key are all required");
    return M8.verify(r, t, n, { strict: !1 });
  }
};
z4.SECP256K1Client = uq;
uq.algorithmName = "ES256K";
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.cryptoClients = e.SECP256K1Client = void 0;
  const t = z4;
  Object.defineProperty(e, "SECP256K1Client", { enumerable: !0, get: function() {
    return t.SECP256K1Client;
  } });
  const r = {
    ES256K: t.SECP256K1Client
  };
  e.cryptoClients = r;
})(R4);
var s0 = {}, Ome = Rt && Rt.__awaiter || function(e, t, r, n) {
  function o(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function u(f) {
      try {
        d(n.next(f));
      } catch (h) {
        a(h);
      }
    }
    function l(f) {
      try {
        d(n.throw(f));
      } catch (h) {
        a(h);
      }
    }
    function d(f) {
      f.done ? i(f.value) : o(f.value).then(u, l);
    }
    d((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty(s0, "__esModule", { value: !0 });
s0.hashSha256Async = s0.hashSha256 = void 0;
const Pme = Cu;
function cq(e) {
  return (0, Pme.sha256)(e);
}
s0.hashSha256 = cq;
function Cme(e) {
  return Ome(this, void 0, void 0, function* () {
    try {
      if (typeof crypto < "u" && typeof crypto.subtle < "u") {
        const t = typeof e == "string" ? new TextEncoder().encode(e) : e, r = yield crypto.subtle.digest("SHA-256", t);
        return new Uint8Array(r);
      } else {
        const t = tq;
        if (!t.createHash)
          throw new Error("`crypto` module does not contain `createHash`");
        return Promise.resolve(t.createHash("sha256").update(e).digest());
      }
    } catch (t) {
      return console.log(t), console.log('Crypto lib not found. Neither the global `crypto.subtle` Web Crypto API, nor the or the Node.js `require("crypto").createHash` module is available. Falling back to JS implementation.'), Promise.resolve(cq(e));
    }
  });
}
s0.hashSha256Async = Cme;
var Bme = Rt && Rt.__awaiter || function(e, t, r, n) {
  function o(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function u(f) {
      try {
        d(n.next(f));
      } catch (h) {
        a(h);
      }
    }
    function l(f) {
      try {
        d(n.throw(f));
      } catch (h) {
        a(h);
      }
    }
    function d(f) {
      f.done ? i(f.value) : o(f.value).then(u, l);
    }
    d((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty(Z1, "__esModule", { value: !0 });
Z1.TokenSigner = Z1.createUnsecuredToken = void 0;
const vO = sa, wR = R4, Nme = cf, vR = s0;
function EO(e, t) {
  const r = [], n = vO.encode(JSON.stringify(t));
  r.push(n);
  const o = vO.encode(JSON.stringify(e));
  return r.push(o), r.join(".");
}
function $me(e) {
  return EO(e, { typ: "JWT", alg: "none" }) + ".";
}
Z1.createUnsecuredToken = $me;
let Ume = class {
  constructor(t, r) {
    if (!(t && r))
      throw new Nme.MissingParametersError("a signing algorithm and private key are required");
    if (typeof t != "string")
      throw new Error("signing algorithm parameter must be a string");
    if (t = t.toUpperCase(), !wR.cryptoClients.hasOwnProperty(t))
      throw new Error("invalid signing algorithm");
    this.tokenType = "JWT", this.cryptoClient = wR.cryptoClients[t], this.rawPrivateKey = r;
  }
  header(t = {}) {
    const r = { typ: this.tokenType, alg: this.cryptoClient.algorithmName };
    return Object.assign({}, r, t);
  }
  sign(t, r = !1, n = {}) {
    const o = this.header(n), i = EO(t, o), a = (0, vR.hashSha256)(i);
    return this.createWithSignedHash(t, r, o, i, a);
  }
  signAsync(t, r = !1, n = {}) {
    return Bme(this, void 0, void 0, function* () {
      const o = this.header(n), i = EO(t, o), a = yield (0, vR.hashSha256Async)(i);
      return this.createWithSignedHash(t, r, o, i, a);
    });
  }
  createWithSignedHash(t, r, n, o, i) {
    const a = this.cryptoClient.signHash(i, this.rawPrivateKey);
    return r ? {
      header: [vO.encode(JSON.stringify(n))],
      payload: JSON.stringify(t),
      signature: [a]
    } : [o, a].join(".");
  }
};
Z1.TokenSigner = Ume;
var j4 = {};
Object.defineProperty(j4, "__esModule", { value: !0 });
j4.TokenVerifier = void 0;
const Rme = sa, ER = R4, zme = cf, Xv = s0;
let jme = class {
  constructor(t, r) {
    if (!(t && r))
      throw new zme.MissingParametersError("a signing algorithm and public key are required");
    if (typeof t != "string")
      throw "signing algorithm parameter must be a string";
    if (t = t.toUpperCase(), !ER.cryptoClients.hasOwnProperty(t))
      throw "invalid signing algorithm";
    this.tokenType = "JWT", this.cryptoClient = ER.cryptoClients[t], this.rawPublicKey = r;
  }
  verify(t) {
    return typeof t == "string" ? this.verifyCompact(t, !1) : typeof t == "object" ? this.verifyExpanded(t, !1) : !1;
  }
  verifyAsync(t) {
    return typeof t == "string" ? this.verifyCompact(t, !0) : typeof t == "object" ? this.verifyExpanded(t, !0) : Promise.resolve(!1);
  }
  verifyCompact(t, r) {
    const n = t.split("."), o = n[0] + "." + n[1], i = (a) => {
      const u = this.cryptoClient.loadSignature(n[2]);
      return this.cryptoClient.verifyHash(a, u, this.rawPublicKey);
    };
    if (r)
      return (0, Xv.hashSha256Async)(o).then((a) => i(a));
    {
      const a = (0, Xv.hashSha256)(o);
      return i(a);
    }
  }
  verifyExpanded(t, r) {
    const n = [t.header.join("."), Rme.encode(t.payload)].join(".");
    let o = !0;
    const i = (a) => (t.signature.map((u) => {
      const l = this.cryptoClient.loadSignature(u);
      this.cryptoClient.verifyHash(a, l, this.rawPublicKey) || (o = !1);
    }), o);
    if (r)
      return (0, Xv.hashSha256Async)(n).then((a) => i(a));
    {
      const a = (0, Xv.hashSha256)(n);
      return i(a);
    }
  }
};
j4.TokenVerifier = jme;
var L4 = {};
Object.defineProperty(L4, "__esModule", { value: !0 });
L4.decodeToken = void 0;
const Yv = sa;
function Lme(e) {
  if (typeof e == "string") {
    const t = e.split("."), r = JSON.parse(Yv.decode(t[0])), n = JSON.parse(Yv.decode(t[1])), o = t[2];
    return {
      header: r,
      payload: n,
      signature: o
    };
  } else if (typeof e == "object") {
    if (typeof e.payload != "string")
      throw new Error("Expected token payload to be a base64 or json string");
    let t = e.payload;
    e.payload[0] !== "{" && (t = Yv.decode(t));
    const r = [];
    return e.header.map((n) => {
      const o = JSON.parse(Yv.decode(n));
      r.push(o);
    }), {
      header: r,
      payload: JSON.parse(t),
      signature: e.signature
    };
  }
}
L4.decodeToken = Lme;
(function(e) {
  var t = Rt && Rt.__createBinding || (Object.create ? function(n, o, i, a) {
    a === void 0 && (a = i);
    var u = Object.getOwnPropertyDescriptor(o, i);
    (!u || ("get" in u ? !o.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return o[i];
    } }), Object.defineProperty(n, a, u);
  } : function(n, o, i, a) {
    a === void 0 && (a = i), n[a] = o[i];
  }), r = Rt && Rt.__exportStar || function(n, o) {
    for (var i in n) i !== "default" && !Object.prototype.hasOwnProperty.call(o, i) && t(o, n, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(Z1, e), r(j4, e), r(L4, e), r(cf, e), r(R4, e);
})(ys);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var _R = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
(() => {
  const e = Array(256).fill(-1);
  for (let t = 0; t < _R.length; ++t) e[_R.charCodeAt(t)] = t;
})();
var AR, dT, Jv, pB = (AR = function(e, t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.bech32m = t.bech32 = void 0;
  const r = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", n = {};
  for (let h = 0; h < 32; h++) {
    const g = r.charAt(h);
    n[g] = h;
  }
  function o(h) {
    const g = h >> 25;
    return (33554431 & h) << 5 ^ 996825010 & -(g >> 0 & 1) ^ 642813549 & -(g >> 1 & 1) ^ 513874426 & -(g >> 2 & 1) ^ 1027748829 & -(g >> 3 & 1) ^ 705979059 & -(g >> 4 & 1);
  }
  function i(h) {
    let g = 1;
    for (let b = 0; b < h.length; ++b) {
      const w = h.charCodeAt(b);
      if (w < 33 || w > 126) return "Invalid prefix (" + h + ")";
      g = o(g) ^ w >> 5;
    }
    g = o(g);
    for (let b = 0; b < h.length; ++b) {
      const w = h.charCodeAt(b);
      g = o(g) ^ 31 & w;
    }
    return g;
  }
  function a(h, g, b, w) {
    let E = 0, _ = 0;
    const O = (1 << b) - 1, C = [];
    for (let I = 0; I < h.length; ++I) for (E = E << g | h[I], _ += g; _ >= b; ) _ -= b, C.push(E >> _ & O);
    if (w) _ > 0 && C.push(E << b - _ & O);
    else {
      if (_ >= g) return "Excess padding";
      if (E << b - _ & O) return "Non-zero padding";
    }
    return C;
  }
  function u(h) {
    return a(h, 8, 5, !0);
  }
  function l(h) {
    const g = a(h, 5, 8, !1);
    if (Array.isArray(g)) return g;
  }
  function d(h) {
    const g = a(h, 5, 8, !1);
    if (Array.isArray(g)) return g;
    throw new Error(g);
  }
  function f(h) {
    let g;
    function b(w, E) {
      if (E = E || 90, w.length < 8) return w + " too short";
      if (w.length > E) return "Exceeds length limit";
      const _ = w.toLowerCase(), O = w.toUpperCase();
      if (w !== _ && w !== O) return "Mixed-case string " + w;
      const C = (w = _).lastIndexOf("1");
      if (C === -1) return "No separator character for " + w;
      if (C === 0) return "Missing prefix for " + w;
      const I = w.slice(0, C), S = w.slice(C + 1);
      if (S.length < 6) return "Data too short";
      let T = i(I);
      if (typeof T == "string") return T;
      const A = [];
      for (let $ = 0; $ < S.length; ++$) {
        const U = S.charAt($), M = n[U];
        if (M === void 0) return "Unknown character " + U;
        T = o(T) ^ M, $ + 6 >= S.length || A.push(M);
      }
      return T !== g ? "Invalid checksum for " + w : { prefix: I, words: A };
    }
    return g = h === "bech32" ? 1 : 734539939, { decodeUnsafe: function(w, E) {
      const _ = b(w, E);
      if (typeof _ == "object") return _;
    }, decode: function(w, E) {
      const _ = b(w, E);
      if (typeof _ == "object") return _;
      throw new Error(_);
    }, encode: function(w, E, _) {
      if (_ = _ || 90, w.length + 7 + E.length > _) throw new TypeError("Exceeds length limit");
      let O = i(w = w.toLowerCase());
      if (typeof O == "string") throw new Error(O);
      let C = w + "1";
      for (let I = 0; I < E.length; ++I) {
        const S = E[I];
        if (S >> 5) throw new Error("Non 5-bit word");
        O = o(O) ^ S, C += r.charAt(S);
      }
      for (let I = 0; I < 6; ++I) O = o(O);
      O ^= g;
      for (let I = 0; I < 6; ++I) C += r.charAt(O >> 5 * (5 - I) & 31);
      return C;
    }, toWords: u, fromWordsUnsafe: l, fromWords: d };
  }
  t.bech32 = f("bech32"), t.bech32m = f("bech32m");
}, AR(dT = { exports: {} }, dT.exports), dT.exports);
(Jv = pB) && Jv.__esModule && Object.prototype.hasOwnProperty.call(Jv, "default") && Jv.default;
pB.bech32m;
pB.bech32;
new Uint8Array(new Uint16Array([65279]).buffer)[0];
var u1, c1;
(function(e) {
  e.mainnet = "mainnet", e.testnet = "testnet", e.regtest = "regtest";
})(u1 || (u1 = {})), function(e) {
  e.p2pkh = "p2pkh", e.p2sh = "p2sh", e.p2wpkh = "p2wpkh", e.p2wsh = "p2wsh", e.p2tr = "p2tr";
}(c1 || (c1 = {}));
c1.p2pkh, u1.mainnet, c1.p2pkh, u1.testnet, c1.p2sh, u1.mainnet, c1.p2sh, u1.testnet;
var Hme = {}, gB = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
gB.read = function(e, t, r, n, o) {
  var i, a, u = o * 8 - n - 1, l = (1 << u) - 1, d = l >> 1, f = -7, h = r ? o - 1 : 0, g = r ? -1 : 1, b = e[t + h];
  for (h += g, i = b & (1 << -f) - 1, b >>= -f, f += u; f > 0; i = i * 256 + e[t + h], h += g, f -= 8)
    ;
  for (a = i & (1 << -f) - 1, i >>= -f, f += n; f > 0; a = a * 256 + e[t + h], h += g, f -= 8)
    ;
  if (i === 0)
    i = 1 - d;
  else {
    if (i === l)
      return a ? NaN : (b ? -1 : 1) * (1 / 0);
    a = a + Math.pow(2, n), i = i - d;
  }
  return (b ? -1 : 1) * a * Math.pow(2, i - n);
};
gB.write = function(e, t, r, n, o, i) {
  var a, u, l, d = i * 8 - o - 1, f = (1 << d) - 1, h = f >> 1, g = o === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, b = n ? 0 : i - 1, w = n ? 1 : -1, E = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (u = isNaN(t) ? 1 : 0, a = f) : (a = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -a)) < 1 && (a--, l *= 2), a + h >= 1 ? t += g / l : t += g * Math.pow(2, 1 - h), t * l >= 2 && (a++, l /= 2), a + h >= f ? (u = 0, a = f) : a + h >= 1 ? (u = (t * l - 1) * Math.pow(2, o), a = a + h) : (u = t * Math.pow(2, h - 1) * Math.pow(2, o), a = 0)); o >= 8; e[r + b] = u & 255, b += w, u /= 256, o -= 8)
    ;
  for (a = a << o | u, d += o; d > 0; e[r + b] = a & 255, b += w, a /= 256, d -= 8)
    ;
  e[r + b - w] |= E * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(e) {
  const t = Pg, r = gB, n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  e.Buffer = u, e.SlowBuffer = C, e.INSPECT_MAX_BYTES = 50;
  const o = 2147483647;
  e.kMaxLength = o, u.TYPED_ARRAY_SUPPORT = i(), !u.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function i() {
    try {
      const m = new Uint8Array(1), v = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(v, Uint8Array.prototype), Object.setPrototypeOf(m, v), m.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(u.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (u.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(u.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (u.isBuffer(this))
        return this.byteOffset;
    }
  });
  function a(m) {
    if (m > o)
      throw new RangeError('The value "' + m + '" is invalid for option "size"');
    const v = new Uint8Array(m);
    return Object.setPrototypeOf(v, u.prototype), v;
  }
  function u(m, v, k) {
    if (typeof m == "number") {
      if (typeof v == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return h(m);
    }
    return l(m, v, k);
  }
  u.poolSize = 8192;
  function l(m, v, k) {
    if (typeof m == "string")
      return g(m, v);
    if (ArrayBuffer.isView(m))
      return w(m);
    if (m == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof m
      );
    if (yt(m, ArrayBuffer) || m && yt(m.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (yt(m, SharedArrayBuffer) || m && yt(m.buffer, SharedArrayBuffer)))
      return E(m, v, k);
    if (typeof m == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const H = m.valueOf && m.valueOf();
    if (H != null && H !== m)
      return u.from(H, v, k);
    const X = _(m);
    if (X) return X;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof m[Symbol.toPrimitive] == "function")
      return u.from(m[Symbol.toPrimitive]("string"), v, k);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof m
    );
  }
  u.from = function(m, v, k) {
    return l(m, v, k);
  }, Object.setPrototypeOf(u.prototype, Uint8Array.prototype), Object.setPrototypeOf(u, Uint8Array);
  function d(m) {
    if (typeof m != "number")
      throw new TypeError('"size" argument must be of type number');
    if (m < 0)
      throw new RangeError('The value "' + m + '" is invalid for option "size"');
  }
  function f(m, v, k) {
    return d(m), m <= 0 ? a(m) : v !== void 0 ? typeof k == "string" ? a(m).fill(v, k) : a(m).fill(v) : a(m);
  }
  u.alloc = function(m, v, k) {
    return f(m, v, k);
  };
  function h(m) {
    return d(m), a(m < 0 ? 0 : O(m) | 0);
  }
  u.allocUnsafe = function(m) {
    return h(m);
  }, u.allocUnsafeSlow = function(m) {
    return h(m);
  };
  function g(m, v) {
    if ((typeof v != "string" || v === "") && (v = "utf8"), !u.isEncoding(v))
      throw new TypeError("Unknown encoding: " + v);
    const k = I(m, v) | 0;
    let H = a(k);
    const X = H.write(m, v);
    return X !== k && (H = H.slice(0, X)), H;
  }
  function b(m) {
    const v = m.length < 0 ? 0 : O(m.length) | 0, k = a(v);
    for (let H = 0; H < v; H += 1)
      k[H] = m[H] & 255;
    return k;
  }
  function w(m) {
    if (yt(m, Uint8Array)) {
      const v = new Uint8Array(m);
      return E(v.buffer, v.byteOffset, v.byteLength);
    }
    return b(m);
  }
  function E(m, v, k) {
    if (v < 0 || m.byteLength < v)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (m.byteLength < v + (k || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let H;
    return v === void 0 && k === void 0 ? H = new Uint8Array(m) : k === void 0 ? H = new Uint8Array(m, v) : H = new Uint8Array(m, v, k), Object.setPrototypeOf(H, u.prototype), H;
  }
  function _(m) {
    if (u.isBuffer(m)) {
      const v = O(m.length) | 0, k = a(v);
      return k.length === 0 || m.copy(k, 0, 0, v), k;
    }
    if (m.length !== void 0)
      return typeof m.length != "number" || Zt(m.length) ? a(0) : b(m);
    if (m.type === "Buffer" && Array.isArray(m.data))
      return b(m.data);
  }
  function O(m) {
    if (m >= o)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + o.toString(16) + " bytes");
    return m | 0;
  }
  function C(m) {
    return +m != m && (m = 0), u.alloc(+m);
  }
  u.isBuffer = function(m) {
    return m != null && m._isBuffer === !0 && m !== u.prototype;
  }, u.compare = function(m, v) {
    if (yt(m, Uint8Array) && (m = u.from(m, m.offset, m.byteLength)), yt(v, Uint8Array) && (v = u.from(v, v.offset, v.byteLength)), !u.isBuffer(m) || !u.isBuffer(v))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (m === v) return 0;
    let k = m.length, H = v.length;
    for (let X = 0, oe = Math.min(k, H); X < oe; ++X)
      if (m[X] !== v[X]) {
        k = m[X], H = v[X];
        break;
      }
    return k < H ? -1 : H < k ? 1 : 0;
  }, u.isEncoding = function(m) {
    switch (String(m).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, u.concat = function(m, v) {
    if (!Array.isArray(m))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (m.length === 0)
      return u.alloc(0);
    let k;
    if (v === void 0)
      for (v = 0, k = 0; k < m.length; ++k)
        v += m[k].length;
    const H = u.allocUnsafe(v);
    let X = 0;
    for (k = 0; k < m.length; ++k) {
      let oe = m[k];
      if (yt(oe, Uint8Array))
        X + oe.length > H.length ? (u.isBuffer(oe) || (oe = u.from(oe)), oe.copy(H, X)) : Uint8Array.prototype.set.call(
          H,
          oe,
          X
        );
      else if (u.isBuffer(oe))
        oe.copy(H, X);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      X += oe.length;
    }
    return H;
  };
  function I(m, v) {
    if (u.isBuffer(m))
      return m.length;
    if (ArrayBuffer.isView(m) || yt(m, ArrayBuffer))
      return m.byteLength;
    if (typeof m != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof m
      );
    const k = m.length, H = arguments.length > 2 && arguments[2] === !0;
    if (!H && k === 0) return 0;
    let X = !1;
    for (; ; )
      switch (v) {
        case "ascii":
        case "latin1":
        case "binary":
          return k;
        case "utf8":
        case "utf-8":
          return He(m).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return k * 2;
        case "hex":
          return k >>> 1;
        case "base64":
          return Pt(m).length;
        default:
          if (X)
            return H ? -1 : He(m).length;
          v = ("" + v).toLowerCase(), X = !0;
      }
  }
  u.byteLength = I;
  function S(m, v, k) {
    let H = !1;
    if ((v === void 0 || v < 0) && (v = 0), v > this.length || ((k === void 0 || k > this.length) && (k = this.length), k <= 0) || (k >>>= 0, v >>>= 0, k <= v))
      return "";
    for (m || (m = "utf8"); ; )
      switch (m) {
        case "hex":
          return G(this, v, k);
        case "utf8":
        case "utf-8":
          return ne(this, v, k);
        case "ascii":
          return le(this, v, k);
        case "latin1":
        case "binary":
          return re(this, v, k);
        case "base64":
          return de(this, v, k);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return q(this, v, k);
        default:
          if (H) throw new TypeError("Unknown encoding: " + m);
          m = (m + "").toLowerCase(), H = !0;
      }
  }
  u.prototype._isBuffer = !0;
  function T(m, v, k) {
    const H = m[v];
    m[v] = m[k], m[k] = H;
  }
  u.prototype.swap16 = function() {
    const m = this.length;
    if (m % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let v = 0; v < m; v += 2)
      T(this, v, v + 1);
    return this;
  }, u.prototype.swap32 = function() {
    const m = this.length;
    if (m % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let v = 0; v < m; v += 4)
      T(this, v, v + 3), T(this, v + 1, v + 2);
    return this;
  }, u.prototype.swap64 = function() {
    const m = this.length;
    if (m % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let v = 0; v < m; v += 8)
      T(this, v, v + 7), T(this, v + 1, v + 6), T(this, v + 2, v + 5), T(this, v + 3, v + 4);
    return this;
  }, u.prototype.toString = function() {
    const m = this.length;
    return m === 0 ? "" : arguments.length === 0 ? ne(this, 0, m) : S.apply(this, arguments);
  }, u.prototype.toLocaleString = u.prototype.toString, u.prototype.equals = function(m) {
    if (!u.isBuffer(m)) throw new TypeError("Argument must be a Buffer");
    return this === m ? !0 : u.compare(this, m) === 0;
  }, u.prototype.inspect = function() {
    let m = "";
    const v = e.INSPECT_MAX_BYTES;
    return m = this.toString("hex", 0, v).replace(/(.{2})/g, "$1 ").trim(), this.length > v && (m += " ... "), "<Buffer " + m + ">";
  }, n && (u.prototype[n] = u.prototype.inspect), u.prototype.compare = function(m, v, k, H, X) {
    if (yt(m, Uint8Array) && (m = u.from(m, m.offset, m.byteLength)), !u.isBuffer(m))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof m
      );
    if (v === void 0 && (v = 0), k === void 0 && (k = m ? m.length : 0), H === void 0 && (H = 0), X === void 0 && (X = this.length), v < 0 || k > m.length || H < 0 || X > this.length)
      throw new RangeError("out of range index");
    if (H >= X && v >= k)
      return 0;
    if (H >= X)
      return -1;
    if (v >= k)
      return 1;
    if (v >>>= 0, k >>>= 0, H >>>= 0, X >>>= 0, this === m) return 0;
    let oe = X - H, me = k - v;
    const nt = Math.min(oe, me), Ct = this.slice(H, X), At = m.slice(v, k);
    for (let vt = 0; vt < nt; ++vt)
      if (Ct[vt] !== At[vt]) {
        oe = Ct[vt], me = At[vt];
        break;
      }
    return oe < me ? -1 : me < oe ? 1 : 0;
  };
  function A(m, v, k, H, X) {
    if (m.length === 0) return -1;
    if (typeof k == "string" ? (H = k, k = 0) : k > 2147483647 ? k = 2147483647 : k < -2147483648 && (k = -2147483648), k = +k, Zt(k) && (k = X ? 0 : m.length - 1), k < 0 && (k = m.length + k), k >= m.length) {
      if (X) return -1;
      k = m.length - 1;
    } else if (k < 0)
      if (X) k = 0;
      else return -1;
    if (typeof v == "string" && (v = u.from(v, H)), u.isBuffer(v))
      return v.length === 0 ? -1 : $(m, v, k, H, X);
    if (typeof v == "number")
      return v = v & 255, typeof Uint8Array.prototype.indexOf == "function" ? X ? Uint8Array.prototype.indexOf.call(m, v, k) : Uint8Array.prototype.lastIndexOf.call(m, v, k) : $(m, [v], k, H, X);
    throw new TypeError("val must be string, number or Buffer");
  }
  function $(m, v, k, H, X) {
    let oe = 1, me = m.length, nt = v.length;
    if (H !== void 0 && (H = String(H).toLowerCase(), H === "ucs2" || H === "ucs-2" || H === "utf16le" || H === "utf-16le")) {
      if (m.length < 2 || v.length < 2)
        return -1;
      oe = 2, me /= 2, nt /= 2, k /= 2;
    }
    function Ct(vt, Ht) {
      return oe === 1 ? vt[Ht] : vt.readUInt16BE(Ht * oe);
    }
    let At;
    if (X) {
      let vt = -1;
      for (At = k; At < me; At++)
        if (Ct(m, At) === Ct(v, vt === -1 ? 0 : At - vt)) {
          if (vt === -1 && (vt = At), At - vt + 1 === nt) return vt * oe;
        } else
          vt !== -1 && (At -= At - vt), vt = -1;
    } else
      for (k + nt > me && (k = me - nt), At = k; At >= 0; At--) {
        let vt = !0;
        for (let Ht = 0; Ht < nt; Ht++)
          if (Ct(m, At + Ht) !== Ct(v, Ht)) {
            vt = !1;
            break;
          }
        if (vt) return At;
      }
    return -1;
  }
  u.prototype.includes = function(m, v, k) {
    return this.indexOf(m, v, k) !== -1;
  }, u.prototype.indexOf = function(m, v, k) {
    return A(this, m, v, k, !0);
  }, u.prototype.lastIndexOf = function(m, v, k) {
    return A(this, m, v, k, !1);
  };
  function U(m, v, k, H) {
    k = Number(k) || 0;
    const X = m.length - k;
    H ? (H = Number(H), H > X && (H = X)) : H = X;
    const oe = v.length;
    H > oe / 2 && (H = oe / 2);
    let me;
    for (me = 0; me < H; ++me) {
      const nt = parseInt(v.substr(me * 2, 2), 16);
      if (Zt(nt)) return me;
      m[k + me] = nt;
    }
    return me;
  }
  function M(m, v, k, H) {
    return _t(He(v, m.length - k), m, k, H);
  }
  function Y(m, v, k, H) {
    return _t(mt(v), m, k, H);
  }
  function L(m, v, k, H) {
    return _t(Pt(v), m, k, H);
  }
  function ee(m, v, k, H) {
    return _t(rt(v, m.length - k), m, k, H);
  }
  u.prototype.write = function(m, v, k, H) {
    if (v === void 0)
      H = "utf8", k = this.length, v = 0;
    else if (k === void 0 && typeof v == "string")
      H = v, k = this.length, v = 0;
    else if (isFinite(v))
      v = v >>> 0, isFinite(k) ? (k = k >>> 0, H === void 0 && (H = "utf8")) : (H = k, k = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const X = this.length - v;
    if ((k === void 0 || k > X) && (k = X), m.length > 0 && (k < 0 || v < 0) || v > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    H || (H = "utf8");
    let oe = !1;
    for (; ; )
      switch (H) {
        case "hex":
          return U(this, m, v, k);
        case "utf8":
        case "utf-8":
          return M(this, m, v, k);
        case "ascii":
        case "latin1":
        case "binary":
          return Y(this, m, v, k);
        case "base64":
          return L(this, m, v, k);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ee(this, m, v, k);
        default:
          if (oe) throw new TypeError("Unknown encoding: " + H);
          H = ("" + H).toLowerCase(), oe = !0;
      }
  }, u.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function de(m, v, k) {
    return v === 0 && k === m.length ? t.fromByteArray(m) : t.fromByteArray(m.slice(v, k));
  }
  function ne(m, v, k) {
    k = Math.min(m.length, k);
    const H = [];
    let X = v;
    for (; X < k; ) {
      const oe = m[X];
      let me = null, nt = oe > 239 ? 4 : oe > 223 ? 3 : oe > 191 ? 2 : 1;
      if (X + nt <= k) {
        let Ct, At, vt, Ht;
        switch (nt) {
          case 1:
            oe < 128 && (me = oe);
            break;
          case 2:
            Ct = m[X + 1], (Ct & 192) === 128 && (Ht = (oe & 31) << 6 | Ct & 63, Ht > 127 && (me = Ht));
            break;
          case 3:
            Ct = m[X + 1], At = m[X + 2], (Ct & 192) === 128 && (At & 192) === 128 && (Ht = (oe & 15) << 12 | (Ct & 63) << 6 | At & 63, Ht > 2047 && (Ht < 55296 || Ht > 57343) && (me = Ht));
            break;
          case 4:
            Ct = m[X + 1], At = m[X + 2], vt = m[X + 3], (Ct & 192) === 128 && (At & 192) === 128 && (vt & 192) === 128 && (Ht = (oe & 15) << 18 | (Ct & 63) << 12 | (At & 63) << 6 | vt & 63, Ht > 65535 && Ht < 1114112 && (me = Ht));
        }
      }
      me === null ? (me = 65533, nt = 1) : me > 65535 && (me -= 65536, H.push(me >>> 10 & 1023 | 55296), me = 56320 | me & 1023), H.push(me), X += nt;
    }
    return K(H);
  }
  const D = 4096;
  function K(m) {
    const v = m.length;
    if (v <= D)
      return String.fromCharCode.apply(String, m);
    let k = "", H = 0;
    for (; H < v; )
      k += String.fromCharCode.apply(
        String,
        m.slice(H, H += D)
      );
    return k;
  }
  function le(m, v, k) {
    let H = "";
    k = Math.min(m.length, k);
    for (let X = v; X < k; ++X)
      H += String.fromCharCode(m[X] & 127);
    return H;
  }
  function re(m, v, k) {
    let H = "";
    k = Math.min(m.length, k);
    for (let X = v; X < k; ++X)
      H += String.fromCharCode(m[X]);
    return H;
  }
  function G(m, v, k) {
    const H = m.length;
    (!v || v < 0) && (v = 0), (!k || k < 0 || k > H) && (k = H);
    let X = "";
    for (let oe = v; oe < k; ++oe)
      X += yn[m[oe]];
    return X;
  }
  function q(m, v, k) {
    const H = m.slice(v, k);
    let X = "";
    for (let oe = 0; oe < H.length - 1; oe += 2)
      X += String.fromCharCode(H[oe] + H[oe + 1] * 256);
    return X;
  }
  u.prototype.slice = function(m, v) {
    const k = this.length;
    m = ~~m, v = v === void 0 ? k : ~~v, m < 0 ? (m += k, m < 0 && (m = 0)) : m > k && (m = k), v < 0 ? (v += k, v < 0 && (v = 0)) : v > k && (v = k), v < m && (v = m);
    const H = this.subarray(m, v);
    return Object.setPrototypeOf(H, u.prototype), H;
  };
  function Q(m, v, k) {
    if (m % 1 !== 0 || m < 0) throw new RangeError("offset is not uint");
    if (m + v > k) throw new RangeError("Trying to access beyond buffer length");
  }
  u.prototype.readUintLE = u.prototype.readUIntLE = function(m, v, k) {
    m = m >>> 0, v = v >>> 0, k || Q(m, v, this.length);
    let H = this[m], X = 1, oe = 0;
    for (; ++oe < v && (X *= 256); )
      H += this[m + oe] * X;
    return H;
  }, u.prototype.readUintBE = u.prototype.readUIntBE = function(m, v, k) {
    m = m >>> 0, v = v >>> 0, k || Q(m, v, this.length);
    let H = this[m + --v], X = 1;
    for (; v > 0 && (X *= 256); )
      H += this[m + --v] * X;
    return H;
  }, u.prototype.readUint8 = u.prototype.readUInt8 = function(m, v) {
    return m = m >>> 0, v || Q(m, 1, this.length), this[m];
  }, u.prototype.readUint16LE = u.prototype.readUInt16LE = function(m, v) {
    return m = m >>> 0, v || Q(m, 2, this.length), this[m] | this[m + 1] << 8;
  }, u.prototype.readUint16BE = u.prototype.readUInt16BE = function(m, v) {
    return m = m >>> 0, v || Q(m, 2, this.length), this[m] << 8 | this[m + 1];
  }, u.prototype.readUint32LE = u.prototype.readUInt32LE = function(m, v) {
    return m = m >>> 0, v || Q(m, 4, this.length), (this[m] | this[m + 1] << 8 | this[m + 2] << 16) + this[m + 3] * 16777216;
  }, u.prototype.readUint32BE = u.prototype.readUInt32BE = function(m, v) {
    return m = m >>> 0, v || Q(m, 4, this.length), this[m] * 16777216 + (this[m + 1] << 16 | this[m + 2] << 8 | this[m + 3]);
  }, u.prototype.readBigUInt64LE = kt(function(m) {
    m = m >>> 0, Ve(m, "offset");
    const v = this[m], k = this[m + 7];
    (v === void 0 || k === void 0) && ge(m, this.length - 8);
    const H = v + this[++m] * 2 ** 8 + this[++m] * 2 ** 16 + this[++m] * 2 ** 24, X = this[++m] + this[++m] * 2 ** 8 + this[++m] * 2 ** 16 + k * 2 ** 24;
    return BigInt(H) + (BigInt(X) << BigInt(32));
  }), u.prototype.readBigUInt64BE = kt(function(m) {
    m = m >>> 0, Ve(m, "offset");
    const v = this[m], k = this[m + 7];
    (v === void 0 || k === void 0) && ge(m, this.length - 8);
    const H = v * 2 ** 24 + this[++m] * 2 ** 16 + this[++m] * 2 ** 8 + this[++m], X = this[++m] * 2 ** 24 + this[++m] * 2 ** 16 + this[++m] * 2 ** 8 + k;
    return (BigInt(H) << BigInt(32)) + BigInt(X);
  }), u.prototype.readIntLE = function(m, v, k) {
    m = m >>> 0, v = v >>> 0, k || Q(m, v, this.length);
    let H = this[m], X = 1, oe = 0;
    for (; ++oe < v && (X *= 256); )
      H += this[m + oe] * X;
    return X *= 128, H >= X && (H -= Math.pow(2, 8 * v)), H;
  }, u.prototype.readIntBE = function(m, v, k) {
    m = m >>> 0, v = v >>> 0, k || Q(m, v, this.length);
    let H = v, X = 1, oe = this[m + --H];
    for (; H > 0 && (X *= 256); )
      oe += this[m + --H] * X;
    return X *= 128, oe >= X && (oe -= Math.pow(2, 8 * v)), oe;
  }, u.prototype.readInt8 = function(m, v) {
    return m = m >>> 0, v || Q(m, 1, this.length), this[m] & 128 ? (255 - this[m] + 1) * -1 : this[m];
  }, u.prototype.readInt16LE = function(m, v) {
    m = m >>> 0, v || Q(m, 2, this.length);
    const k = this[m] | this[m + 1] << 8;
    return k & 32768 ? k | 4294901760 : k;
  }, u.prototype.readInt16BE = function(m, v) {
    m = m >>> 0, v || Q(m, 2, this.length);
    const k = this[m + 1] | this[m] << 8;
    return k & 32768 ? k | 4294901760 : k;
  }, u.prototype.readInt32LE = function(m, v) {
    return m = m >>> 0, v || Q(m, 4, this.length), this[m] | this[m + 1] << 8 | this[m + 2] << 16 | this[m + 3] << 24;
  }, u.prototype.readInt32BE = function(m, v) {
    return m = m >>> 0, v || Q(m, 4, this.length), this[m] << 24 | this[m + 1] << 16 | this[m + 2] << 8 | this[m + 3];
  }, u.prototype.readBigInt64LE = kt(function(m) {
    m = m >>> 0, Ve(m, "offset");
    const v = this[m], k = this[m + 7];
    (v === void 0 || k === void 0) && ge(m, this.length - 8);
    const H = this[m + 4] + this[m + 5] * 2 ** 8 + this[m + 6] * 2 ** 16 + (k << 24);
    return (BigInt(H) << BigInt(32)) + BigInt(v + this[++m] * 2 ** 8 + this[++m] * 2 ** 16 + this[++m] * 2 ** 24);
  }), u.prototype.readBigInt64BE = kt(function(m) {
    m = m >>> 0, Ve(m, "offset");
    const v = this[m], k = this[m + 7];
    (v === void 0 || k === void 0) && ge(m, this.length - 8);
    const H = (v << 24) + // Overflow
    this[++m] * 2 ** 16 + this[++m] * 2 ** 8 + this[++m];
    return (BigInt(H) << BigInt(32)) + BigInt(this[++m] * 2 ** 24 + this[++m] * 2 ** 16 + this[++m] * 2 ** 8 + k);
  }), u.prototype.readFloatLE = function(m, v) {
    return m = m >>> 0, v || Q(m, 4, this.length), r.read(this, m, !0, 23, 4);
  }, u.prototype.readFloatBE = function(m, v) {
    return m = m >>> 0, v || Q(m, 4, this.length), r.read(this, m, !1, 23, 4);
  }, u.prototype.readDoubleLE = function(m, v) {
    return m = m >>> 0, v || Q(m, 8, this.length), r.read(this, m, !0, 52, 8);
  }, u.prototype.readDoubleBE = function(m, v) {
    return m = m >>> 0, v || Q(m, 8, this.length), r.read(this, m, !1, 52, 8);
  };
  function se(m, v, k, H, X, oe) {
    if (!u.isBuffer(m)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (v > X || v < oe) throw new RangeError('"value" argument is out of bounds');
    if (k + H > m.length) throw new RangeError("Index out of range");
  }
  u.prototype.writeUintLE = u.prototype.writeUIntLE = function(m, v, k, H) {
    if (m = +m, v = v >>> 0, k = k >>> 0, !H) {
      const me = Math.pow(2, 8 * k) - 1;
      se(this, m, v, k, me, 0);
    }
    let X = 1, oe = 0;
    for (this[v] = m & 255; ++oe < k && (X *= 256); )
      this[v + oe] = m / X & 255;
    return v + k;
  }, u.prototype.writeUintBE = u.prototype.writeUIntBE = function(m, v, k, H) {
    if (m = +m, v = v >>> 0, k = k >>> 0, !H) {
      const me = Math.pow(2, 8 * k) - 1;
      se(this, m, v, k, me, 0);
    }
    let X = k - 1, oe = 1;
    for (this[v + X] = m & 255; --X >= 0 && (oe *= 256); )
      this[v + X] = m / oe & 255;
    return v + k;
  }, u.prototype.writeUint8 = u.prototype.writeUInt8 = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 1, 255, 0), this[v] = m & 255, v + 1;
  }, u.prototype.writeUint16LE = u.prototype.writeUInt16LE = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 2, 65535, 0), this[v] = m & 255, this[v + 1] = m >>> 8, v + 2;
  }, u.prototype.writeUint16BE = u.prototype.writeUInt16BE = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 2, 65535, 0), this[v] = m >>> 8, this[v + 1] = m & 255, v + 2;
  }, u.prototype.writeUint32LE = u.prototype.writeUInt32LE = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 4, 4294967295, 0), this[v + 3] = m >>> 24, this[v + 2] = m >>> 16, this[v + 1] = m >>> 8, this[v] = m & 255, v + 4;
  }, u.prototype.writeUint32BE = u.prototype.writeUInt32BE = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 4, 4294967295, 0), this[v] = m >>> 24, this[v + 1] = m >>> 16, this[v + 2] = m >>> 8, this[v + 3] = m & 255, v + 4;
  };
  function J(m, v, k, H, X) {
    Ne(v, H, X, m, k, 7);
    let oe = Number(v & BigInt(4294967295));
    m[k++] = oe, oe = oe >> 8, m[k++] = oe, oe = oe >> 8, m[k++] = oe, oe = oe >> 8, m[k++] = oe;
    let me = Number(v >> BigInt(32) & BigInt(4294967295));
    return m[k++] = me, me = me >> 8, m[k++] = me, me = me >> 8, m[k++] = me, me = me >> 8, m[k++] = me, k;
  }
  function ye(m, v, k, H, X) {
    Ne(v, H, X, m, k, 7);
    let oe = Number(v & BigInt(4294967295));
    m[k + 7] = oe, oe = oe >> 8, m[k + 6] = oe, oe = oe >> 8, m[k + 5] = oe, oe = oe >> 8, m[k + 4] = oe;
    let me = Number(v >> BigInt(32) & BigInt(4294967295));
    return m[k + 3] = me, me = me >> 8, m[k + 2] = me, me = me >> 8, m[k + 1] = me, me = me >> 8, m[k] = me, k + 8;
  }
  u.prototype.writeBigUInt64LE = kt(function(m, v = 0) {
    return J(this, m, v, BigInt(0), BigInt("0xffffffffffffffff"));
  }), u.prototype.writeBigUInt64BE = kt(function(m, v = 0) {
    return ye(this, m, v, BigInt(0), BigInt("0xffffffffffffffff"));
  }), u.prototype.writeIntLE = function(m, v, k, H) {
    if (m = +m, v = v >>> 0, !H) {
      const nt = Math.pow(2, 8 * k - 1);
      se(this, m, v, k, nt - 1, -nt);
    }
    let X = 0, oe = 1, me = 0;
    for (this[v] = m & 255; ++X < k && (oe *= 256); )
      m < 0 && me === 0 && this[v + X - 1] !== 0 && (me = 1), this[v + X] = (m / oe >> 0) - me & 255;
    return v + k;
  }, u.prototype.writeIntBE = function(m, v, k, H) {
    if (m = +m, v = v >>> 0, !H) {
      const nt = Math.pow(2, 8 * k - 1);
      se(this, m, v, k, nt - 1, -nt);
    }
    let X = k - 1, oe = 1, me = 0;
    for (this[v + X] = m & 255; --X >= 0 && (oe *= 256); )
      m < 0 && me === 0 && this[v + X + 1] !== 0 && (me = 1), this[v + X] = (m / oe >> 0) - me & 255;
    return v + k;
  }, u.prototype.writeInt8 = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 1, 127, -128), m < 0 && (m = 255 + m + 1), this[v] = m & 255, v + 1;
  }, u.prototype.writeInt16LE = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 2, 32767, -32768), this[v] = m & 255, this[v + 1] = m >>> 8, v + 2;
  }, u.prototype.writeInt16BE = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 2, 32767, -32768), this[v] = m >>> 8, this[v + 1] = m & 255, v + 2;
  }, u.prototype.writeInt32LE = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 4, 2147483647, -2147483648), this[v] = m & 255, this[v + 1] = m >>> 8, this[v + 2] = m >>> 16, this[v + 3] = m >>> 24, v + 4;
  }, u.prototype.writeInt32BE = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 4, 2147483647, -2147483648), m < 0 && (m = 4294967295 + m + 1), this[v] = m >>> 24, this[v + 1] = m >>> 16, this[v + 2] = m >>> 8, this[v + 3] = m & 255, v + 4;
  }, u.prototype.writeBigInt64LE = kt(function(m, v = 0) {
    return J(this, m, v, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), u.prototype.writeBigInt64BE = kt(function(m, v = 0) {
    return ye(this, m, v, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function ve(m, v, k, H, X, oe) {
    if (k + H > m.length) throw new RangeError("Index out of range");
    if (k < 0) throw new RangeError("Index out of range");
  }
  function Ee(m, v, k, H, X) {
    return v = +v, k = k >>> 0, X || ve(m, v, k, 4), r.write(m, v, k, H, 23, 4), k + 4;
  }
  u.prototype.writeFloatLE = function(m, v, k) {
    return Ee(this, m, v, !0, k);
  }, u.prototype.writeFloatBE = function(m, v, k) {
    return Ee(this, m, v, !1, k);
  };
  function _e(m, v, k, H, X) {
    return v = +v, k = k >>> 0, X || ve(m, v, k, 8), r.write(m, v, k, H, 52, 8), k + 8;
  }
  u.prototype.writeDoubleLE = function(m, v, k) {
    return _e(this, m, v, !0, k);
  }, u.prototype.writeDoubleBE = function(m, v, k) {
    return _e(this, m, v, !1, k);
  }, u.prototype.copy = function(m, v, k, H) {
    if (!u.isBuffer(m)) throw new TypeError("argument should be a Buffer");
    if (k || (k = 0), !H && H !== 0 && (H = this.length), v >= m.length && (v = m.length), v || (v = 0), H > 0 && H < k && (H = k), H === k || m.length === 0 || this.length === 0) return 0;
    if (v < 0)
      throw new RangeError("targetStart out of bounds");
    if (k < 0 || k >= this.length) throw new RangeError("Index out of range");
    if (H < 0) throw new RangeError("sourceEnd out of bounds");
    H > this.length && (H = this.length), m.length - v < H - k && (H = m.length - v + k);
    const X = H - k;
    return this === m && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(v, k, H) : Uint8Array.prototype.set.call(
      m,
      this.subarray(k, H),
      v
    ), X;
  }, u.prototype.fill = function(m, v, k, H) {
    if (typeof m == "string") {
      if (typeof v == "string" ? (H = v, v = 0, k = this.length) : typeof k == "string" && (H = k, k = this.length), H !== void 0 && typeof H != "string")
        throw new TypeError("encoding must be a string");
      if (typeof H == "string" && !u.isEncoding(H))
        throw new TypeError("Unknown encoding: " + H);
      if (m.length === 1) {
        const oe = m.charCodeAt(0);
        (H === "utf8" && oe < 128 || H === "latin1") && (m = oe);
      }
    } else typeof m == "number" ? m = m & 255 : typeof m == "boolean" && (m = Number(m));
    if (v < 0 || this.length < v || this.length < k)
      throw new RangeError("Out of range index");
    if (k <= v)
      return this;
    v = v >>> 0, k = k === void 0 ? this.length : k >>> 0, m || (m = 0);
    let X;
    if (typeof m == "number")
      for (X = v; X < k; ++X)
        this[X] = m;
    else {
      const oe = u.isBuffer(m) ? m : u.from(m, H), me = oe.length;
      if (me === 0)
        throw new TypeError('The value "' + m + '" is invalid for argument "value"');
      for (X = 0; X < k - v; ++X)
        this[X + v] = oe[X % me];
    }
    return this;
  };
  const we = {};
  function be(m, v, k) {
    we[m] = class extends k {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: v.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${m}]`, this.stack, delete this.name;
      }
      get code() {
        return m;
      }
      set code(H) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: H,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${m}]: ${this.message}`;
      }
    };
  }
  be(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(m) {
      return m ? `${m} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), be(
    "ERR_INVALID_ARG_TYPE",
    function(m, v) {
      return `The "${m}" argument must be of type number. Received type ${typeof v}`;
    },
    TypeError
  ), be(
    "ERR_OUT_OF_RANGE",
    function(m, v, k) {
      let H = `The value of "${m}" is out of range.`, X = k;
      return Number.isInteger(k) && Math.abs(k) > 2 ** 32 ? X = Ge(String(k)) : typeof k == "bigint" && (X = String(k), (k > BigInt(2) ** BigInt(32) || k < -(BigInt(2) ** BigInt(32))) && (X = Ge(X)), X += "n"), H += ` It must be ${v}. Received ${X}`, H;
    },
    RangeError
  );
  function Ge(m) {
    let v = "", k = m.length;
    const H = m[0] === "-" ? 1 : 0;
    for (; k >= H + 4; k -= 3)
      v = `_${m.slice(k - 3, k)}${v}`;
    return `${m.slice(0, k)}${v}`;
  }
  function Le(m, v, k) {
    Ve(v, "offset"), (m[v] === void 0 || m[v + k] === void 0) && ge(v, m.length - (k + 1));
  }
  function Ne(m, v, k, H, X, oe) {
    if (m > k || m < v) {
      const me = typeof v == "bigint" ? "n" : "";
      let nt;
      throw v === 0 || v === BigInt(0) ? nt = `>= 0${me} and < 2${me} ** ${(oe + 1) * 8}${me}` : nt = `>= -(2${me} ** ${(oe + 1) * 8 - 1}${me}) and < 2 ** ${(oe + 1) * 8 - 1}${me}`, new we.ERR_OUT_OF_RANGE("value", nt, m);
    }
    Le(H, X, oe);
  }
  function Ve(m, v) {
    if (typeof m != "number")
      throw new we.ERR_INVALID_ARG_TYPE(v, "number", m);
  }
  function ge(m, v, k) {
    throw Math.floor(m) !== m ? (Ve(m, k), new we.ERR_OUT_OF_RANGE("offset", "an integer", m)) : v < 0 ? new we.ERR_BUFFER_OUT_OF_BOUNDS() : new we.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${v}`,
      m
    );
  }
  const Te = /[^+/0-9A-Za-z-_]/g;
  function Oe(m) {
    if (m = m.split("=")[0], m = m.trim().replace(Te, ""), m.length < 2) return "";
    for (; m.length % 4 !== 0; )
      m = m + "=";
    return m;
  }
  function He(m, v) {
    v = v || 1 / 0;
    let k;
    const H = m.length;
    let X = null;
    const oe = [];
    for (let me = 0; me < H; ++me) {
      if (k = m.charCodeAt(me), k > 55295 && k < 57344) {
        if (!X) {
          if (k > 56319) {
            (v -= 3) > -1 && oe.push(239, 191, 189);
            continue;
          } else if (me + 1 === H) {
            (v -= 3) > -1 && oe.push(239, 191, 189);
            continue;
          }
          X = k;
          continue;
        }
        if (k < 56320) {
          (v -= 3) > -1 && oe.push(239, 191, 189), X = k;
          continue;
        }
        k = (X - 55296 << 10 | k - 56320) + 65536;
      } else X && (v -= 3) > -1 && oe.push(239, 191, 189);
      if (X = null, k < 128) {
        if ((v -= 1) < 0) break;
        oe.push(k);
      } else if (k < 2048) {
        if ((v -= 2) < 0) break;
        oe.push(
          k >> 6 | 192,
          k & 63 | 128
        );
      } else if (k < 65536) {
        if ((v -= 3) < 0) break;
        oe.push(
          k >> 12 | 224,
          k >> 6 & 63 | 128,
          k & 63 | 128
        );
      } else if (k < 1114112) {
        if ((v -= 4) < 0) break;
        oe.push(
          k >> 18 | 240,
          k >> 12 & 63 | 128,
          k >> 6 & 63 | 128,
          k & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return oe;
  }
  function mt(m) {
    const v = [];
    for (let k = 0; k < m.length; ++k)
      v.push(m.charCodeAt(k) & 255);
    return v;
  }
  function rt(m, v) {
    let k, H, X;
    const oe = [];
    for (let me = 0; me < m.length && !((v -= 2) < 0); ++me)
      k = m.charCodeAt(me), H = k >> 8, X = k % 256, oe.push(X), oe.push(H);
    return oe;
  }
  function Pt(m) {
    return t.toByteArray(Oe(m));
  }
  function _t(m, v, k, H) {
    let X;
    for (X = 0; X < H && !(X + k >= v.length || X >= m.length); ++X)
      v[X + k] = m[X];
    return X;
  }
  function yt(m, v) {
    return m instanceof v || m != null && m.constructor != null && m.constructor.name != null && m.constructor.name === v.name;
  }
  function Zt(m) {
    return m !== m;
  }
  const yn = function() {
    const m = "0123456789abcdef", v = new Array(256);
    for (let k = 0; k < 16; ++k) {
      const H = k * 16;
      for (let X = 0; X < 16; ++X)
        v[H + X] = m[k] + m[X];
    }
    return v;
  }();
  function kt(m) {
    return typeof BigInt > "u" ? qr : m;
  }
  function qr() {
    throw new Error("BigInt not supported");
  }
})(Hme);
var Ea = /* @__PURE__ */ ((e) => (e.Mainnet = "Mainnet", e.Testnet = "Testnet", e.Testnet4 = "Testnet4", e.Signet = "Signet", e.Regtest = "Regtest", e))(Ea || {}), mB = er(K2([Ue(), co(), Ki()])), Zr = ze({
  jsonrpc: vr("2.0"),
  method: Ue(),
  params: er(
    K2([
      Go(U4()),
      VK({}),
      // Note: This is to support current incorrect usage of RPC 2.0. Params need
      // to be either an array or an object when provided. Changing this now would
      // be a breaking change, so accepting null values for now. Tracking in
      // https://linear.app/xverseapp/issue/ENG-4538.
      Ki()
    ])
  ),
  id: ame(mB)
}), l1 = /* @__PURE__ */ ((e) => (e[e.PARSE_ERROR = -32700] = "PARSE_ERROR", e[e.INVALID_REQUEST = -32600] = "INVALID_REQUEST", e[e.METHOD_NOT_FOUND = -32601] = "METHOD_NOT_FOUND", e[e.INVALID_PARAMS = -32602] = "INVALID_PARAMS", e[e.INTERNAL_ERROR = -32603] = "INTERNAL_ERROR", e[e.USER_REJECTION = -32e3] = "USER_REJECTION", e[e.METHOD_NOT_SUPPORTED = -32001] = "METHOD_NOT_SUPPORTED", e[e.ACCESS_DENIED = -32002] = "ACCESS_DENIED", e))(l1 || {}), lq = ze({
  jsonrpc: vr("2.0"),
  result: dB(U4()),
  id: mB
}), fq = ze({
  jsonrpc: vr("2.0"),
  error: dB(U4()),
  id: mB
});
K2([
  lq,
  fq
]);
var Fme = "accountChange";
ze({
  type: vr(Fme)
});
var Mme = "networkChange";
ze({
  type: vr(Mme),
  bitcoin: ze({
    name: ds(Ea)
  }),
  stacks: ze({
    name: Ue()
  })
});
var Dme = "disconnect";
ze({
  type: vr(Dme)
});
async function H4(e) {
  var t;
  const r = await (e == null ? void 0 : e()) || ((t = window.XverseProviders) == null ? void 0 : t.BitcoinProvider) || window.BitcoinProvider;
  if (!r)
    throw new Error("No Bitcoin wallet installed");
  return r;
}
var Kme = "stx_callContract", qme = ze({
  /**
   * The contract principal.
   *
   * E.g. `"SPKE...GD5C.my-contract"`
   */
  contract: Ue(),
  /**
   * The name of the function to call.
   *
   * Note: spec changes ongoing,
   * https://github.com/stacksgov/sips/pull/166#pullrequestreview-1914236999
   */
  functionName: Ue(),
  /**
   * The function's arguments. The arguments are expected to be hex-encoded
   * strings of Clarity values.
   *
   * To convert Clarity values to their hex representation, the `cvToHex`
   * helper from the `@stacks/transactions` package may be helpful.
   *
   * ```js
   * import { cvToHex } from '@stacks/transactions';
   *
   * const functionArgs = [someClarityValue1, someClarityValue2];
   * const hexArgs = functionArgs.map(cvToHex);
   * ```
   */
  arguments: er(Go(Ue()))
});
ze({
  ...Zr.entries,
  ...ze({
    method: vr(Kme),
    params: qme,
    id: Ue()
  }).entries
});
var Vme = "stx_deployContract", Gme = ze({
  /**
   * Name of the contract.
   */
  name: Ue(),
  /**
   * The source code of the Clarity contract.
   */
  clarityCode: Ue(),
  /**
   * The version of the Clarity contract.
   */
  clarityVersion: er(Ue())
});
ze({
  ...Zr.entries,
  ...ze({
    method: vr(Vme),
    params: Gme,
    id: Ue()
  }).entries
});
var Wme = ["software", "ledger", "keystone"], dq = GK(Wme), u0 = /* @__PURE__ */ ((e) => (e.Ordinals = "ordinals", e.Payment = "payment", e.Stacks = "stacks", e))(u0 || {}), hq = /* @__PURE__ */ ((e) => (e.p2pkh = "p2pkh", e.p2sh = "p2sh", e.p2wpkh = "p2wpkh", e.p2wsh = "p2wsh", e.p2tr = "p2tr", e.stacks = "stacks", e))(hq || {}), Zme = ze({
  address: Ue(),
  publicKey: Ue(),
  purpose: ds(u0),
  addressType: ds(hq),
  walletType: dq
}), Xme = async (e) => {
  var t, r;
  const n = await H4(e.getProvider), { purposes: o } = e.payload;
  if (!o)
    throw new Error("Address purposes are required");
  try {
    const i = ys.createUnsecuredToken(e.payload), a = await n.connect(i);
    (t = e.onFinish) == null || t.call(e, a);
  } catch (i) {
    console.error("[Connect] Error during address request", i), (r = e.onCancel) == null || r.call(e);
  }
}, Yme = ze({
  read: er(O0())
}), Jme = ze({
  readNetwork: er(O0())
}), Qme = ze({
  type: vr("account"),
  resourceId: Ue(),
  clientId: Ue(),
  actions: Yme
}), eye = ze({
  type: vr("wallet"),
  resourceId: Ue(),
  clientId: Ue(),
  actions: Jme
}), pq = ZK("type", [
  ze({
    ...pR(Qme, ["clientId"]).entries
  }),
  ze({
    ...pR(eye, ["clientId"]).entries
  })
]), tye = "wallet_requestPermissions", rye = si(Go(pq));
vr(!0);
ze({
  ...Zr.entries,
  ...ze({
    method: vr(tye),
    params: rye,
    id: Ue()
  }).entries
});
var nye = "wallet_renouncePermissions", oye = si(Ki());
si(Ki());
ze({
  ...Zr.entries,
  ...ze({
    method: vr(nye),
    params: oye,
    id: Ue()
  }).entries
});
var iye = "wallet_disconnect", aye = si(Ki());
si(Ki());
ze({
  ...Zr.entries,
  ...ze({
    method: vr(iye),
    params: aye,
    id: Ue()
  }).entries
});
var sye = "wallet_getWalletType", uye = si(Ki());
ze({
  ...Zr.entries,
  ...ze({
    method: vr(sye),
    params: uye,
    id: Ue()
  }).entries
});
var cye = "wallet_getCurrentPermissions", lye = si(Ki());
ze({
  ...Zr.entries,
  ...ze({
    method: vr(cye),
    params: lye,
    id: Ue()
  }).entries
});
var fye = "wallet_getNetwork", dye = si(Ki());
ze({
  bitcoin: ze({
    name: ds(Ea)
  }),
  stacks: ze({
    name: Ue()
  })
});
ze({
  ...Zr.entries,
  ...ze({
    method: vr(fye),
    params: dye,
    id: Ue()
  }).entries
});
var hye = "wallet_changeNetwork", pye = ze({
  name: ds(Ea)
});
si(Ki());
ze({
  ...Zr.entries,
  ...ze({
    method: vr(hye),
    params: pye,
    id: Ue()
  }).entries
});
var gye = "wallet_getAccount", mye = si(Ki());
ze({
  ...Zr.entries,
  ...ze({
    method: vr(gye),
    params: mye,
    id: Ue()
  }).entries
});
var yye = "wallet_connect", bye = si(
  ze({
    permissions: er(Go(pq)),
    addresses: er(Go(ds(u0))),
    message: er(
      wO(Ue(), DK(80, "The message must not exceed 80 characters."))
    )
  })
);
ze({
  ...Zr.entries,
  ...ze({
    method: vr(yye),
    params: bye,
    id: Ue()
  }).entries
});
var wye = "stx_getAccounts", vye = si(Ki());
ze({
  ...Zr.entries,
  ...ze({
    method: vr(wye),
    params: vye,
    id: Ue()
  }).entries
});
var Eye = "stx_getAddresses", _ye = si(
  ze({
    /**
     * A message to be displayed to the user in the request prompt.
     */
    message: er(Ue())
  })
);
ze({
  ...Zr.entries,
  ...ze({
    method: vr(Eye),
    params: _ye,
    id: Ue()
  }).entries
});
var Aye = "stx_signMessage", xye = ze({
  /**
   * The message to sign.
   */
  message: Ue(),
  /**
   * The public key to sign the message with.
   */
  publicKey: Ue(),
  /**
   * The format version of the parameter.
   */
  parameterFormatVersion: er(co())
});
ze({
  ...Zr.entries,
  ...ze({
    method: vr(Aye),
    params: xye,
    id: Ue()
  }).entries
});
var kye = "stx_signStructuredMessage", Sye = ze({
  /**
   * The domain to be signed.
   */
  domain: Ue(),
  /**
   * Message payload to be signed.
   */
  message: Ue(),
  /**
   * The format version of the parameter.
   */
  parameterFormatVersion: er(co()),
  /**
   * The public key to sign the message with.
   */
  publicKey: er(Ue())
});
ze({
  ...Zr.entries,
  ...ze({
    method: vr(kye),
    params: Sye,
    id: Ue()
  }).entries
});
var Tye = "stx_signTransaction", Iye = ze({
  /**
   * The transaction to sign as a hex-encoded string.
   */
  transaction: Ue(),
  /**
   * The public key to sign the transaction with. The wallet may use any key
   * when not provided.
   */
  pubkey: er(Ue()),
  /**
   * Whether to broadcast the transaction after signing. Defaults to `true`.
   */
  broadcast: er(O0())
});
ze({
  ...Zr.entries,
  ...ze({
    method: vr(Tye),
    params: Iye,
    id: Ue()
  }).entries
});
var Oye = "stx_signTransactions", Pye = ze({
  /**
   * The transactions to sign as hex-encoded strings.
   */
  transactions: wO(
    Go(
      wO(
        Ue(),
        MK((e) => !0, "Invalid hex-encoded Stacks transaction.")
      )
    ),
    KK(1)
  ),
  /**
   * Whether the signed transactions should be broadcast after signing. Defaults
   * to `true`.
   */
  broadcast: er(O0())
});
ze({
  ...Zr.entries,
  ...ze({
    method: vr(Oye),
    params: Pye,
    id: Ue()
  }).entries
});
var Cye = "stx_transferStx", Bye = ze({
  /**
   * Amount of STX tokens to transfer in microstacks as a string. Anything
   * parseable by `BigInt` is acceptable.
   *
   * Example,
   *
   * ```js
   * const amount1 = 1234;
   * const amount2 = 1234n;
   * const amount3 = '1234';
   * ```
   */
  amount: K2([co(), Ue()]),
  /**
   * The recipeint's principal.
   */
  recipient: Ue(),
  /**
   * A string representing the memo.
   */
  memo: er(Ue()),
  /**
   * Version of parameter format.
   */
  version: er(Ue()),
  /**
   * The mode of the post conditions.
   */
  postConditionMode: er(co()),
  /**
   * A hex-encoded string representing the post conditions.
   *
   * A post condition may be converted to it's hex representation using the `serializePostCondition` helper from the `@stacks/transactions` package,
   *
   * ```js
   * import { serializePostCondition } from '@stacks/transactions';
   *
   * const postCondition = somePostCondition;
   * const hexPostCondition = serializePostCondition(postCondition).toString('hex');
   * ```
   */
  postConditions: er(Go(Ue())),
  /**
   * The public key to sign the transaction with. The wallet may use any key
   * when not provided.
   */
  pubkey: er(Ue())
});
ze({
  ...Zr.entries,
  ...ze({
    method: vr(Cye),
    params: Bye,
    id: Ue()
  }).entries
});
var Nye = "getInfo", $ye = si(Ki());
ze({
  /**
   * Version of the wallet.
   */
  version: Ue(),
  /**
   * [WBIP](https://wbips.netlify.app/wbips/WBIP002) methods supported by the wallet.
   */
  methods: er(Go(Ue())),
  /**
   * List of WBIP standards supported by the wallet. Not currently used.
   */
  supports: Go(Ue())
});
ze({
  ...Zr.entries,
  ...ze({
    method: vr(Nye),
    params: $ye,
    id: Ue()
  }).entries
});
var Uye = "getAddresses", Rye = ze({
  /**
   * The purposes for which to generate addresses. See
   * {@linkcode AddressPurpose} for available purposes.
   */
  purposes: Go(ds(u0)),
  /**
   * A message to be displayed to the user in the request prompt.
   */
  message: er(Ue())
});
ze({
  ...Zr.entries,
  ...ze({
    method: vr(Uye),
    params: Rye,
    id: Ue()
  }).entries
});
var zye = "signMessage", c0 = /* @__PURE__ */ ((e) => (e.ECDSA = "ECDSA", e.BIP322 = "BIP322", e))(c0 || {}), jye = ze({
  /**
   * The address used for signing.
   **/
  address: Ue(),
  /**
   * The message to sign.
   **/
  message: Ue(),
  /**
   * The protocol to use for signing the message.
   */
  protocol: er(ds(c0))
});
ze({
  /**
   * The signature of the message.
   */
  signature: Ue(),
  /**
   * hash of the message.
   */
  messageHash: Ue(),
  /**
   * The address used for signing.
   */
  address: Ue(),
  /**
   * The protocol to use for signing the message.
   */
  protocol: ds(c0)
});
ze({
  ...Zr.entries,
  ...ze({
    method: vr(zye),
    params: jye,
    id: Ue()
  }).entries
});
var Lye = "sendTransfer", Hye = ze({
  /**
   * Array of recipients to send to.
   * The amount to send to each recipient is in satoshis.
   */
  recipients: Go(
    ze({
      address: Ue(),
      amount: co()
    })
  )
});
ze({
  ...Zr.entries,
  ...ze({
    method: vr(Lye),
    params: Hye,
    id: Ue()
  }).entries
});
var Fye = "signPsbt", Mye = ze({
  /**
   * The base64 encoded PSBT to sign.
   */
  psbt: Ue(),
  /**
   * The inputs to sign.
   * The key is the address and the value is an array of indexes of the inputs to sign.
   */
  signInputs: WK(Ue(), Go(co())),
  /**
   * Whether to broadcast the transaction after signing.
   **/
  broadcast: er(O0())
});
ze({
  /**
   * The base64 encoded PSBT after signing.
   */
  psbt: Ue(),
  /**
   * The transaction id as a hex-encoded string.
   * This is only returned if the transaction was broadcast.
   **/
  txid: er(Ue())
});
ze({
  ...Zr.entries,
  ...ze({
    method: vr(Fye),
    params: Mye,
    id: Ue()
  }).entries
});
var Dye = "getAccounts", Kye = ze({
  /**
   * The purposes for which to generate addresses. See
   * {@linkcode AddressPurpose} for available purposes.
   */
  purposes: Go(ds(u0)),
  /**
   * A message to be displayed to the user in the request prompt.
   */
  message: er(Ue())
});
Go(
  ze({
    ...Zme.entries,
    ...ze({
      walletType: dq
    }).entries
  })
);
ze({
  ...Zr.entries,
  ...ze({
    method: vr(Dye),
    params: Kye,
    id: Ue()
  }).entries
});
var qye = "getBalance";
si(Ki());
ze({
  ...Zr.entries,
  ...ze({
    method: vr(qye),
    id: Ue()
  }).entries
});
var Vye = "runes_etch", Gye = ze({
  amount: Ue(),
  cap: Ue(),
  heightStart: er(Ue()),
  heightEnd: er(Ue()),
  offsetStart: er(Ue()),
  offsetEnd: er(Ue())
}), Wye = ze({
  contentType: Ue(),
  contentBase64: Ue()
}), Zye = ze({
  runeName: Ue(),
  divisibility: er(co()),
  symbol: er(Ue()),
  premine: er(Ue()),
  isMintable: O0(),
  delegateInscriptionId: er(Ue()),
  destinationAddress: Ue(),
  refundAddress: Ue(),
  feeRate: co(),
  appServiceFee: er(co()),
  appServiceFeeAddress: er(Ue()),
  terms: er(Gye),
  inscriptionDetails: er(Wye),
  network: er(ds(Ea))
});
ze({
  ...Zr.entries,
  ...ze({
    method: vr(Vye),
    params: Zye,
    id: Ue()
  }).entries
});
var Xye = "runes_getBalance", Yye = si(Ki());
ze({
  balances: Go(
    ze({
      runeName: Ue(),
      amount: Ue(),
      divisibility: co(),
      symbol: Ue(),
      inscriptionId: si(Ue())
    })
  )
});
ze({
  ...Zr.entries,
  ...ze({
    method: vr(Xye),
    params: Yye,
    id: Ue()
  }).entries
});
var Jye = "runes_mint", Qye = ze({
  appServiceFee: er(co()),
  appServiceFeeAddress: er(Ue()),
  destinationAddress: Ue(),
  feeRate: co(),
  refundAddress: Ue(),
  repeats: co(),
  runeName: Ue(),
  network: er(ds(Ea))
});
ze({
  ...Zr.entries,
  ...ze({
    method: vr(Jye),
    params: Qye,
    id: Ue()
  }).entries
});
var ebe = "runes_transfer", tbe = ze({
  recipients: Go(
    ze({
      runeName: Ue(),
      amount: Ue(),
      address: Ue()
    })
  )
});
ze({
  ...Zr.entries,
  ...ze({
    method: vr(ebe),
    params: tbe,
    id: Ue()
  }).entries
});
var rbe = "ord_getInscriptions", nbe = ze({
  offset: co(),
  limit: co()
});
ze({
  total: co(),
  limit: co(),
  offset: co(),
  inscriptions: Go(
    ze({
      inscriptionId: Ue(),
      inscriptionNumber: Ue(),
      address: Ue(),
      collectionName: er(Ue()),
      postage: Ue(),
      contentLength: Ue(),
      contentType: Ue(),
      timestamp: co(),
      offset: co(),
      genesisTransaction: Ue(),
      output: Ue()
    })
  )
});
ze({
  ...Zr.entries,
  ...ze({
    method: vr(rbe),
    params: nbe,
    id: Ue()
  }).entries
});
var obe = "ord_sendInscriptions", ibe = ze({
  transfers: Go(
    ze({
      address: Ue(),
      inscriptionId: Ue()
    })
  )
});
ze({
  ...Zr.entries,
  ...ze({
    method: vr(obe),
    params: ibe,
    id: Ue()
  }).entries
});
var bp = async (e, t, r) => {
  var n;
  let o = ((n = window.XverseProviders) == null ? void 0 : n.BitcoinProvider) || window.BitcoinProvider;
  if (!o)
    throw new Error("no wallet provider was found");
  if (!e)
    throw new Error("A wallet method is required");
  const i = await o.request(e, t);
  return dR(fq, i) ? {
    status: "error",
    error: i.error
  } : dR(lq, i) ? {
    status: "success",
    result: i.result
  } : {
    status: "error",
    error: {
      code: -32603,
      message: "Received unknown response from provider.",
      data: i
    }
  };
}, xR = (e, t, r) => {
  var n;
  let o = ((n = window.XverseProviders) == null ? void 0 : n.BitcoinProvider) || window.BitcoinProvider;
  if (!o)
    throw new Error("no wallet provider was found");
  return o.addListener ? o.addListener(e, t) : (console.error(
    "The wallet provider you are using does not support the addListener method. Please update your wallet provider."
  ), () => {
  });
}, abe = async (e) => {
  var t, r;
  const n = await H4(e.getProvider), { address: o, message: i } = e.payload;
  if (!o)
    throw new Error("An address is required to sign a message");
  if (!i)
    throw new Error("A message to be signed is required");
  try {
    const a = ys.createUnsecuredToken(e.payload), u = await n.signMessage(a);
    (t = e.onFinish) == null || t.call(e, u);
  } catch (a) {
    console.error("[Connect] Error during sign message request", a), (r = e.onCancel) == null || r.call(e);
  }
}, sbe = (e) => e.map((t) => {
  const { address: r, amountSats: n } = t;
  return {
    address: r,
    amountSats: n.toString()
  };
}), ube = async (e) => {
  var t, r;
  const n = await H4(e.getProvider), { recipients: o, senderAddress: i, network: a, message: u } = e.payload;
  if (!o || o.length === 0)
    throw new Error("At least one recipient is required");
  if (o.some(
    (l) => typeof l.address != "string" || typeof l.amountSats != "bigint"
  ))
    throw new Error("Incorrect recipient format");
  if (!i)
    throw new Error("The sender address is required");
  try {
    const l = sbe(o), d = {
      network: a,
      senderAddress: i,
      message: u,
      recipients: l
    }, f = ys.createUnsecuredToken(d), h = await n.sendBtcTransaction(f);
    (t = e.onFinish) == null || t.call(e, h);
  } catch (l) {
    console.error("[Connect] Error during send BTC transaction request", l), (r = e.onCancel) == null || r.call(e);
  }
}, cbe = async (e) => {
  var t, r;
  const n = await H4(e.getProvider), { psbtBase64: o, inputsToSign: i } = e.payload;
  if (!o)
    throw new Error("A value for psbtBase64 representing the tx hash is required");
  if (!i)
    throw new Error("An array specifying the inputs to be signed by the wallet is required");
  try {
    const a = ys.createUnsecuredToken(e.payload), u = await n.signTransaction(a);
    (t = e.onFinish) == null || t.call(e, u);
  } catch (a) {
    console.error("[Connect] Error during sign transaction request", a), (r = e.onCancel) == null || r.call(e);
  }
};
const lbe = (e) => e === Kn ? Ea.Mainnet : e === aa ? Ea.Testnet : e === Ls ? Ea.Signet : e === as ? Ea.Testnet : e === th ? Ea.Mainnet : e === ka ? Ea.Testnet4 : Ea.Mainnet;
let fbe = class extends Gu {
  constructor() {
    super(...arguments), st(this, "observer");
  }
  get network() {
    return this.$network.get();
  }
  initialize() {
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var t, r;
      (t = window == null ? void 0 : window.XverseProviders) != null && t.BitcoinProvider && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [o1]: !0
      }), (r = this.observer) == null || r.disconnect());
    }), this.observer.observe(document, { childList: !0, subtree: !0 }));
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect(), this.removeListeners();
  }
  addListeners() {
    xR("accountChange", () => {
    }), xR("networkChange", (t) => {
      t.type === "networkChange" && this.handleNetworkChanged(t.bitcoin.name);
    });
  }
  removeListeners() {
    console.log("removeListeners");
  }
  // private handleAccountsChanged(accounts: string[]) {
  //   console.log('handleAccountsChanged', accounts)
  //   if (!accounts.length) {
  //     this.parent.disconnect()
  //     return
  //   }
  //   // if (this.$store.get().accounts[0] === accounts[0]) {
  //   //   return
  //   // }
  //   // this.$store.setKey('accounts', accounts)
  //   // if (accounts.length > 0) {
  //   //   this.parent.connect(XVERSE)
  //   // } else {
  //   //   this.parent.disconnect()
  //   // }
  // }
  handleNetworkChanged(t) {
    const r = rT(t);
    this.$network.set(r), this.parent.connect(o1);
  }
  async connect(t) {
    let r, n, o;
    try {
      const i = await bp("wallet_getAccount", null);
      if (i.status === "success")
        r = R3(i.result.addresses), n = z3(i.result.addresses), o = i.result.network.bitcoin.name;
      else
        throw new Error(`Error getting account: ${i.error.message}`);
    } catch (i) {
      if (i instanceof Error && (i.message.toLowerCase().includes("failed to get") || i.message.toLowerCase().includes("access denied"))) {
        const a = await bp("wallet_connect", {
          addresses: [u0.Ordinals, u0.Payment],
          message: "Connecting with lasereyes"
        });
        if (a.status === "success")
          r = R3(a.result.addresses), n = z3(a.result.addresses), o = a.result.network.bitcoin.name;
        else
          throw a.error.code === l1.USER_REJECTION ? new Error(`User canceled lasereyes to ${o1} wallet`) : new Error(a.error.message);
      } else
        throw console.error(i), new Error(`Error connecting to ${o1} wallet`);
    }
    if (!r || !n)
      throw new Error("Could not find the addresses");
    this.$store.setKey("address", r.address), this.$store.setKey("paymentAddress", n.address), this.$store.setKey("accounts", [
      r.address,
      n.address
    ]), this.$store.setKey("publicKey", String(r.publicKey)), this.$store.setKey(
      "paymentPublicKey",
      String(n.publicKey)
    ), o && this.$network.set(rT(o));
  }
  async getNetwork() {
    try {
      const t = await bp("wallet_getNetwork", null);
      if (t.status === "success")
        return rT(t.result.bitcoin.name);
      throw new Error("Error getting network");
    } catch {
      return this.network;
    }
  }
  async switchNetwork(t) {
    if ((await bp("wallet_changeNetwork", {
      name: lbe(t)
    })).status === "success")
      this.handleNetworkChanged(t);
    else
      throw new Error("Error switching network");
  }
  async sendBTC(t, r) {
    const n = await bp("sendTransfer", {
      recipients: [
        {
          address: t,
          amount: r
        }
      ]
    });
    if (n.status === "success")
      return n.result.txid;
    throw n.error.code === l1.USER_REJECTION ? new Error("User rejected the request") : new Error(`Error sending BTC: ${n.error.message}`);
  }
  async signMessage(t, { toSignAddress: r, protocol: n }) {
    const o = r || this.$store.get().paymentAddress, i = await bp("signMessage", {
      address: o,
      message: t,
      protocol: n === U2 ? c0.ECDSA : c0.BIP322
    });
    if (i.status === "success")
      return i.result.signature;
    throw i.error.code === l1.USER_REJECTION ? new Error("User rejected the request") : new Error(`Error signing message: ${i.error.message}`);
  }
  async signPsbt({
    psbtBase64: t,
    broadcast: r,
    finalize: n,
    inputsToSign: o
  }) {
    try {
      const i = Sn.fromBase64(String(t), {
        network: dn(this.network)
      }).data.inputs;
      let a = {};
      if (o)
        a = o.reduce(
          (g, b) => ({
            ...g,
            [b.address]: [...g[b.address] || [], b.index]
          }),
          {}
        );
      else {
        const { address: g, paymentAddress: b } = this.$store.get(), w = {
          [g]: []
        }, E = {
          [b]: []
        };
        for (const _ of i.keys()) {
          const O = i[_];
          if (O.witnessUtxo === void 0) {
            E[b].push(Number(_));
            continue;
          }
          const { script: C } = O.witnessUtxo, I = w2(
            C,
            dn(this.network)
          );
          I === b ? E[b].push(Number(_)) : I === g && w[g].push(Number(_));
        }
        w[g].length > 0 && (a = { ...a, ...w }), E[b].length > 0 && (a = { ...a, ...E });
      }
      let u, l, d, f;
      const h = await bp("signPsbt", {
        psbt: t,
        broadcast: !!r,
        signInputs: a
      });
      if (h.status === "success")
        f = Sn.fromBase64(h.result.psbt, {
          network: dn(this.network)
        }), u = h.result.txid;
      else
        throw h.error.code === l1.USER_REJECTION ? new Error("User canceled the request") : new Error("Error signing psbt");
      if (!f)
        throw new Error("Error signing psbt");
      return n && !u ? (f.finalizeAllInputs(), l = f.toHex(), d = f.toBase64()) : (l = f.toHex(), d = f.toBase64()), {
        signedPsbtHex: l,
        signedPsbtBase64: d,
        txId: u
      };
    } catch (i) {
      throw console.error(i), i;
    }
  }
  // this is not working
  // TODO: Fix this
  // async getInscriptions(
  //   offset?: number,
  //   limit?: number
  // ): Promise<Inscription[]> {
  //   const offsetValue = offset || 0
  //   const limitValue = limit || 10
  //   const response = await request('ord_getInscriptions', {
  //     offset: offsetValue,
  //     limit: limitValue,
  //   })
  //   if (response.status === 'success') {
  //     const inscriptions = response.result.inscriptions.map((insc) => {
  //       return normalizeInscription(insc, undefined, this.network)
  //     })
  //     console.log(inscriptions)
  //     return inscriptions as Inscription[]
  //   }
  //   console.error(response.error)
  //   throw new Error('Error getting inscriptions')
  // }
}, dbe = class extends Gu {
  constructor(t, r, n) {
    super(t, r, n), st(this, "observer");
  }
  get library() {
    return window.wizz;
  }
  get network() {
    return this.$network.get();
  }
  handleNetworkChanged(t) {
    this.parent.connect(i1);
  }
  handleAccountsChanged(t) {
    if (!t.length) {
      this.parent.disconnect();
      return;
    }
    this.$store.get().accounts[0] !== t[0] && this.$store.setKey("accounts", t);
  }
  initialize() {
    Ku(this.$store, ["provider"], (t) => {
      t.provider === i1 ? this.addLibraryListeners() : this.removeLibraryListeners();
    }), typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var t;
      this.library && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [i1]: !0
      }), (t = this.observer) == null || t.disconnect());
    }), this.observer.observe(document, { childList: !0, subtree: !0 }));
  }
  removeLibraryListeners() {
    var t, r;
    (t = this.library) == null || t.removeListener(
      "networkChanged",
      this.handleNetworkChanged.bind(this)
    ), (r = this.library) == null || r.removeListener(
      "accountsChanged",
      this.handleAccountsChanged.bind(this)
    );
  }
  addLibraryListeners() {
    var t, r;
    (t = this.library) == null || t.on("networkChanged", this.handleNetworkChanged.bind(this)), (r = this.library) == null || r.on("accountsChanged", this.handleAccountsChanged.bind(this));
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect(), this.removeLibraryListeners();
  }
  async connect() {
    if (!this.library) throw tme;
    const t = await this.library.requestAccounts();
    if (!t) throw new Error("No accounts found");
    const r = await this.library.getPublicKey();
    if (!r) throw new Error("No public key found");
    this.$store.setKey("accounts", t), this.$store.setKey("address", t[0]), this.$store.setKey("paymentAddress", t[0]), this.$store.setKey("publicKey", r), this.$store.setKey("paymentPublicKey", r), this.$store.setKey("provider", i1), await this.getNetwork().then((n) => {
      var o;
      n && ((o = this.config) == null ? void 0 : o.network) !== n && this.parent.switchNetwork(n);
    }), this.$store.setKey("connected", !0);
  }
  async requestAccounts() {
    return await this.library.requestAccounts();
  }
  async getNetwork() {
    var t;
    const r = await ((t = this.library) == null ? void 0 : t.getNetwork());
    return r ? CU(r) : void 0;
  }
  async switchNetwork(t) {
    var r;
    if (t === as || t === th)
      return await this.library.switchNetwork(zs.MAINNET);
    const n = CU(t);
    await ((r = this.library) == null ? void 0 : r.switchNetwork(n)), this.$network.set(t), await this.parent.getBalance();
  }
  async getPublicKey() {
    var t;
    return await ((t = this.library) == null ? void 0 : t.getPublicKey());
  }
  async getBalance() {
    return (await this.library.getBalance()).total;
  }
  async getInscriptions(t, r) {
    const n = t || 0, o = r || 10;
    return (await this.library.getInscriptions(n, o)).list.map((i) => A1(i, void 0, this.network));
  }
  async sendBTC(t, r) {
    var n;
    const o = await ((n = this.library) == null ? void 0 : n.sendBitcoin(t, r));
    if (o)
      return o;
    throw new Error("Error sending BTC");
  }
  async signMessage(t, r) {
    var n;
    const o = (r == null ? void 0 : r.protocol) === rB ? A4 : r == null ? void 0 : r.protocol;
    return await ((n = this.library) == null ? void 0 : n.signMessage(t, o));
  }
  async signPsbt({
    psbtHex: t,
    broadcast: r,
    finalize: n,
    inputsToSign: o
  }) {
    var i;
    const a = await ((i = this.library) == null ? void 0 : i.signPsbt(t, C4({
      autoFinalized: n,
      broadcast: !1,
      toSignInputs: o
    }))), u = Sn.fromHex(a);
    let l;
    return n && r && (l = await this.pushPsbt(a)), {
      signedPsbtHex: u.toHex(),
      signedPsbtBase64: u.toBase64(),
      txId: l
    };
  }
}, kR = (e) => e, Vb = {}, bd = { addEventListener() {
}, removeEventListener() {
} };
function hbe() {
  try {
    return typeof localStorage < "u";
  } catch {
    return !1;
  }
}
hbe() && (Vb = localStorage);
let pbe = {
  addEventListener(e, t, r) {
    window.addEventListener("storage", t), window.addEventListener("pageshow", r);
  },
  removeEventListener(e, t, r) {
    window.removeEventListener("storage", t), window.removeEventListener("pageshow", r);
  }
};
typeof window < "u" && (bd = pbe);
function Cg(e, t = {}, r = {}) {
  let n = r.encode || kR, o = r.decode || kR, i = Yj(), a = i.setKey, u = (h, g) => {
    typeof g > "u" ? (r.listen !== !1 && bd.perKey && bd.removeEventListener(e + h, d, f), delete Vb[e + h]) : (r.listen !== !1 && bd.perKey && !(h in i.value) && bd.addEventListener(e + h, d, f), Vb[e + h] = n(g));
  };
  i.setKey = (h, g) => {
    u(h, g), a(h, g);
  };
  let l = i.set;
  i.set = function(h) {
    for (let g in h)
      u(g, h[g]);
    for (let g in i.value)
      g in h || u(g, void 0);
    l(h);
  };
  function d(h) {
    h.key ? h.key.startsWith(e) && (h.newValue === null ? a(h.key.slice(e.length), void 0) : a(h.key.slice(e.length), o(h.newValue))) : l({});
  }
  function f() {
    let h = { ...t };
    for (let g in Vb)
      g.startsWith(e) && (h[g.slice(e.length)] = o(Vb[g]));
    for (let g in h)
      i.setKey(g, h[g]);
  }
  return mJ(i, () => {
    if (f(), r.listen !== !1)
      return bd.addEventListener(e, d, f), () => {
        bd.removeEventListener(e, d, f);
        for (let h in i.value)
          bd.removeEventListener(e + h, d, f);
      };
  }), i;
}
const gbe = "OYL_CONNECTED_WALLET_STATE";
let mbe = class extends Gu {
  constructor(t, r, n) {
    super(t, r, n), st(this, "observer"), st(this, "$valueStore", Cg(
      gbe,
      {
        address: "",
        paymentAddress: "",
        paymentPublicKey: "",
        publicKey: "",
        balance: ""
      }
    )), st(this, "removeSubscriber");
  }
  get library() {
    return window.oyl;
  }
  get network() {
    return this.$network.get();
  }
  restorePersistedValues() {
    const t = this.$valueStore.get();
    for (const r of I0)
      r === "balance" && this.$store.setKey(r, BigInt(t[r])), this.$store.setKey(r, t[r]);
    this.$store.setKey(
      "accounts",
      [t.address, t.paymentAddress].filter(Boolean)
    );
  }
  watchStateChange(t, r, n) {
    Og(Zb, t, n, this.$valueStore);
  }
  initialize() {
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var t;
      window != null && window.oyl && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [Zb]: !0
      }), (t = this.observer) == null || t.disconnect());
    }), this.observer.observe(document, { childList: !0, subtree: !0 })), Ku(this.$store, ["provider"], (t) => {
      t.provider !== Zb ? this.removeSubscriber && (this.$valueStore.set({
        address: "",
        publicKey: "",
        paymentAddress: "",
        paymentPublicKey: "",
        balance: ""
      }), this.removeSubscriber(), this.removeSubscriber = void 0) : this.removeSubscriber = this.$store.subscribe(
        this.watchStateChange.bind(this)
      );
    });
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect();
  }
  async connect(t) {
    const { address: r, paymentAddress: n } = this.$valueStore.get();
    if (r)
      if (r.startsWith("tb1") && z2(this.network))
        this.disconnect();
      else {
        this.restorePersistedValues(), a0(n, this.network).then((a) => {
          this.$store.setKey("balance", a);
        });
        return;
      }
    if (!this.library) throw new Error("Oyl isn't installed");
    const { nativeSegwit: o, taproot: i } = await this.library.getAddresses();
    if (!o || !i) throw new Error("No accounts found");
    this.$store.setKey("address", i.address), this.$store.setKey("paymentAddress", o.address), this.$store.setKey("publicKey", i.publicKey), this.$store.setKey("paymentPublicKey", o.publicKey);
  }
  async getNetwork() {
    return await this.library.getNetwork();
  }
  async sendBTC(t, r) {
    const { psbtHex: n, psbtBase64: o } = await iB(
      this.$store.get().address,
      this.$store.get().paymentAddress,
      t,
      r,
      this.$store.get().paymentPublicKey,
      this.network,
      7
    ), i = await this.signPsbt({ psbtBase64: o, psbtHex: n, tx: n, broadcast: !0, finalize: !0 });
    if (!i) throw new Error("Error sending BTC");
    return i.txId;
  }
  async signMessage(t, r) {
    const n = (r == null ? void 0 : r.toSignAddress) || this.$store.get().paymentAddress;
    return (await this.library.signMessage({
      address: n,
      message: t,
      protocol: r == null ? void 0 : r.protocol
    })).signature;
  }
  async signPsbt({ psbtHex: t, broadcast: r, finalize: n }) {
    const { psbt: o, txid: i } = await this.library.signPsbt({
      psbt: t,
      finalize: n,
      broadcast: r
    }), a = Sn.fromHex(o);
    return {
      signedPsbtHex: a.toHex(),
      signedPsbtBase64: a.toBase64(),
      txId: i
    };
  }
  async pushPsbt(t) {
    return (await this.library.pushPsbt({ psbt: t })).txid;
  }
  async getPublicKey() {
    const { nativeSegwit: t, taproot: r } = await this.library.getAddresses();
    if (!t || !r) throw new Error("No accounts found");
    return this.$store.setKey("publicKey", r.publicKey), this.$store.setKey("paymentPublicKey", t.publicKey), r.publicKey;
  }
  async getBalance() {
    const { total: t } = await this.library.getBalance();
    return this.$store.setKey("balance", t), t;
  }
  async requestAccounts() {
    return [this.$store.get().address, this.$store.get().paymentAddress];
  }
  async switchNetwork(t) {
    return await this.library.switchNetwork(t);
  }
};
const ybe = "LEATHER_CONNECTED_WALLET_STATE";
let bbe = class extends Gu {
  constructor(t, r, n) {
    super(t, r, n), st(this, "observer"), st(this, "$valueStore", Cg(
      ybe,
      {
        address: "",
        publicKey: "",
        paymentAddress: "",
        paymentPublicKey: "",
        balance: ""
      }
    )), st(this, "removeSubscriber");
  }
  get library() {
    return window.LeatherProvider;
  }
  get network() {
    return this.$network.get();
  }
  restorePersistedValues() {
    const t = this.$valueStore.get();
    for (const r of I0)
      r === "balance" && this.$store.setKey(r, BigInt(t[r])), this.$store.setKey(r, t[r]);
    this.$store.setKey(
      "accounts",
      [t.address, t.paymentAddress].filter(Boolean)
    );
  }
  watchStateChange(t, r, n) {
    Og(
      Xb,
      t,
      n,
      this.$valueStore
    );
  }
  initialize() {
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var t;
      window != null && window.LeatherProvider && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [Xb]: !0
      }), (t = this.observer) == null || t.disconnect());
    }), this.observer.observe(document, { childList: !0, subtree: !0 })), Ku(this.$store, ["provider"], (t) => {
      t.provider !== Xb ? this.removeSubscriber && (this.$valueStore.set({
        address: "",
        publicKey: "",
        paymentAddress: "",
        paymentPublicKey: "",
        balance: ""
      }), this.removeSubscriber(), this.removeSubscriber = void 0) : this.removeSubscriber = this.$store.subscribe(
        this.watchStateChange.bind(this)
      );
    });
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect();
  }
  async connect(t) {
    var r;
    const { address: n, paymentAddress: o } = this.$valueStore.get();
    if (n)
      if (n.startsWith("tb1") && z2(this.network))
        this.disconnect();
      else {
        this.restorePersistedValues(), a0(o, this.network).then((f) => {
          this.$store.setKey("balance", f);
        });
        return;
      }
    if (!this.library) throw new Error("Leather isn't installed");
    const i = await this.library.request("getAddresses");
    if (!i) throw new Error("No accounts found");
    const a = i.result.addresses, u = a.map(
      (f) => f.address
    ), l = a.find(
      (f) => f.type === $1
    ), d = a.find(
      (f) => f.type === hI
    );
    if (!(l != null && l.publicKey) || !(d != null && d.publicKey))
      throw new Error("No accounts found");
    if ((r = String(l == null ? void 0 : l.address)) != null && r.startsWith("tb") && this.network !== aa && this.network !== ka && this.network !== Ls)
      throw new Error(
        `Please switch networks to ${this.network} in the wallet settings.`
      );
    this.$store.setKey("accounts", u), this.$store.setKey("address", l.address), this.$store.setKey("paymentAddress", d.address), this.$store.setKey("publicKey", l.publicKey), this.$store.setKey("paymentPublicKey", d.publicKey);
  }
  async getNetwork() {
    return this.network;
  }
  async sendBTC(t, r) {
    var n, o;
    try {
      const i = await ((n = this.library) == null ? void 0 : n.request("sendTransfer", {
        recipients: [
          {
            address: t,
            amount: String(r)
          }
        ],
        network: this.network
      }));
      if ((o = i == null ? void 0 : i.result) != null && o.txid)
        return i.result.txid;
      throw i.error.code === l1.USER_REJECTION ? new Error("User rejected the request") : new Error("Error sending BTC: " + i.error.message);
    } catch (i) {
      throw console.log(i), new Error("error sending BTC");
    }
  }
  async signMessage(t, r) {
    var n;
    const o = r == null ? void 0 : r.toSignAddress;
    if ((r == null ? void 0 : r.protocol) === U2)
      throw new Error("Leather doesn't support ECDSA message signing");
    const i = o === this.$store.get().address ? $1 : hI;
    if (o !== this.$store.get().address && o !== this.$store.get().paymentAddress)
      throw new Error("Invalid address to sign message");
    const a = await this.library.request("signMessage", {
      message: t,
      paymentType: i
    });
    return (n = a == null ? void 0 : a.result) == null ? void 0 : n.signature;
  }
  async signPsbt({
    psbtHex: t,
    broadcast: r,
    finalize: n,
    inputsToSign: o
  }) {
    const i = {
      hex: t,
      broadcast: !1,
      network: this.network,
      signAtIndex: o == null ? void 0 : o.map((l) => l.index)
    }, a = (await this.library.request(
      "signPsbt",
      i
    )).result.hex, u = Sn.fromHex(String(a));
    if (n && r) {
      const l = u.finalizeAllInputs(), d = await this.pushPsbt(l.toHex());
      return {
        signedPsbtHex: u.toHex(),
        signedPsbtBase64: u.toBase64(),
        txId: d
      };
    } else if (n) {
      const l = u.finalizeAllInputs();
      return {
        signedPsbtHex: l.toHex(),
        signedPsbtBase64: l.toBase64(),
        txId: void 0
      };
    } else
      return {
        signedPsbtHex: u.toHex(),
        signedPsbtBase64: u.toBase64(),
        txId: void 0
      };
  }
  async getPublicKey() {
    return this.$store.get().publicKey;
  }
  async getBalance() {
    const t = await a0(
      this.$store.get().paymentAddress,
      this.network
    );
    return this.$store.setKey("balance", t), t.toString();
  }
  async requestAccounts() {
    const { accounts: t } = this.$store.get();
    if (t.length > 0)
      return t;
    const { result: r } = await this.library.request(
      "getAddresses"
    ), n = r.addresses.map((o) => o.address);
    return this.$store.setKey("accounts", n), n;
  }
};
var nw = {}, gq = {}, Wu = {}, mq = {};
Object.defineProperty(mq, "__esModule", { value: !0 });
(function(e) {
  var t = Rt && Rt.__createBinding || (Object.create ? function(a, u, l, d) {
    d === void 0 && (d = l);
    var f = Object.getOwnPropertyDescriptor(u, l);
    (!f || ("get" in f ? !u.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return u[l];
    } }), Object.defineProperty(a, d, f);
  } : function(a, u, l, d) {
    d === void 0 && (d = l), a[d] = u[l];
  }), r = Rt && Rt.__exportStar || function(a, u) {
    for (var l in a) l !== "default" && !Object.prototype.hasOwnProperty.call(u, l) && t(u, a, l);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.getProviderById = e.getProviders = e.getProviderOrThrow = void 0;
  async function n(a) {
    var u, l;
    if (a) {
      const f = await a();
      if (f)
        return f;
    }
    const d = window.OrangeBitcoinProvider || ((u = window.OrangecryptoProviders) == null ? void 0 : u.BitcoinProvider) || ((l = window.OrangeWalletProviders) == null ? void 0 : l.OrangeBitcoinProvider);
    if (!d)
      throw new Error("No Orange Bitcoin wallet installed");
    return d;
  }
  e.getProviderOrThrow = n;
  function o() {
    return window.btc_providers || (window.btc_providers = []), window.btc_providers;
  }
  e.getProviders = o;
  function i(a) {
    var u;
    if (Array.isArray(window.btc_providers)) {
      const l = window.btc_providers.find((d) => d.id === a);
      return (u = l == null ? void 0 : l.id) == null ? void 0 : u.split(".").reduce((d, f) => d == null ? void 0 : d[f], window);
    } else {
      console.log("window.btc_providers is not defined or not an array");
      return;
    }
  }
  e.getProviderById = i, r(mq, e);
})(Wu);
var yq = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.AddressType = e.AddressPurpose = void 0, function(t) {
    t.Ordinals = "ordinals", t.Payment = "payment", t.Stacks = "stacks";
  }(e.AddressPurpose || (e.AddressPurpose = {})), function(t) {
    t.p2pkh = "p2pkh", t.p2sh = "p2sh", t.p2wpkh = "p2wpkh", t.p2wsh = "p2wsh", t.p2tr = "p2tr", t.stacks = "stacks";
  }(e.AddressType || (e.AddressType = {}));
})(yq);
(function(e) {
  var t = Rt && Rt.__createBinding || (Object.create ? function(a, u, l, d) {
    d === void 0 && (d = l);
    var f = Object.getOwnPropertyDescriptor(u, l);
    (!f || ("get" in f ? !u.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return u[l];
    } }), Object.defineProperty(a, d, f);
  } : function(a, u, l, d) {
    d === void 0 && (d = l), a[d] = u[l];
  }), r = Rt && Rt.__exportStar || function(a, u) {
    for (var l in a) l !== "default" && !Object.prototype.hasOwnProperty.call(u, l) && t(u, a, l);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.getAddress = void 0;
  const n = ys, o = Wu, i = async (a) => {
    var u, l;
    const d = await (0, o.getProviderOrThrow)(a.getProvider), { purposes: f } = a.payload;
    if (!f)
      throw new Error("Address purposes are required");
    try {
      const h = (0, n.createUnsecuredToken)(a.payload), g = await d.connect(h);
      (u = a.onFinish) == null || u.call(a, g);
    } catch (h) {
      console.error("[Connect] Error during address request", h), (l = a.onCancel) == null || l.call(a);
    }
  };
  e.getAddress = i, r(yq, e);
})(gq);
var bq = {}, wq = {}, vq = {};
Object.defineProperty(vq, "__esModule", { value: !0 });
var Eq = {};
Object.defineProperty(Eq, "__esModule", { value: !0 });
(function(e) {
  var t = Rt && Rt.__createBinding || (Object.create ? function(n, o, i, a) {
    a === void 0 && (a = i);
    var u = Object.getOwnPropertyDescriptor(o, i);
    (!u || ("get" in u ? !o.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return o[i];
    } }), Object.defineProperty(n, a, u);
  } : function(n, o, i, a) {
    a === void 0 && (a = i), n[a] = o[i];
  }), r = Rt && Rt.__exportStar || function(n, o) {
    for (var i in n) i !== "default" && !Object.prototype.hasOwnProperty.call(o, i) && t(o, n, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(vq, e), r(Eq, e);
})(wq);
(function(e) {
  var t = Rt && Rt.__createBinding || (Object.create ? function(a, u, l, d) {
    d === void 0 && (d = l);
    var f = Object.getOwnPropertyDescriptor(u, l);
    (!f || ("get" in f ? !u.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return u[l];
    } }), Object.defineProperty(a, d, f);
  } : function(a, u, l, d) {
    d === void 0 && (d = l), a[d] = u[l];
  }), r = Rt && Rt.__exportStar || function(a, u) {
    for (var l in a) l !== "default" && !Object.prototype.hasOwnProperty.call(u, l) && t(u, a, l);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.request = void 0;
  const n = Wu, o = async (a, u, l) => {
    var d;
    let f = ((d = window.OrangecryptoProviders) == null ? void 0 : d.BitcoinProvider) || window.OrangeBitcoinProvider;
    if (l && (f = await (0, n.getProviderById)(l)), !f)
      throw new Error("no wallet provider was found");
    if (!a)
      throw new Error("A wallet method is required");
    const h = await f.request(a, u);
    return i(h) ? {
      status: "success",
      result: h.result
    } : {
      status: "error",
      error: h.error
    };
  };
  e.request = o;
  const i = (a) => Object.hasOwn(a, "result") && !!a.result;
  r(wq, e);
})(bq);
var _q = {}, Aq = {};
Object.defineProperty(Aq, "__esModule", { value: !0 });
(function(e) {
  var t = Rt && Rt.__createBinding || (Object.create ? function(u, l, d, f) {
    f === void 0 && (f = d);
    var h = Object.getOwnPropertyDescriptor(l, d);
    (!h || ("get" in h ? !l.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return l[d];
    } }), Object.defineProperty(u, f, h);
  } : function(u, l, d, f) {
    f === void 0 && (f = d), u[f] = l[d];
  }), r = Rt && Rt.__exportStar || function(u, l) {
    for (var d in u) d !== "default" && !Object.prototype.hasOwnProperty.call(l, d) && t(l, u, d);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.getCapabilities = void 0;
  const n = ys, o = Wu, i = (u, l) => {
    const d = (h) => !(!u[h] || l && !l.has(h)), f = {
      request: d("request"),
      connect: d("connect"),
      signMessage: d("signMessage"),
      signTransaction: d("signTransaction"),
      sendBtcTransaction: d("sendBtcTransaction"),
      createInscription: d("createInscription"),
      createRepeatInscriptions: d("createRepeatInscriptions"),
      signMultipleTransactions: d("signMultipleTransactions")
    };
    return Object.entries(f).reduce((h, [g, b]) => b ? [...h, g] : h, []);
  }, a = async (u) => {
    var l, d, f;
    const h = await (0, o.getProviderOrThrow)(u.getProvider), g = (0, n.createUnsecuredToken)(u.payload);
    if (h.getCapabilities)
      try {
        const b = await h.getCapabilities(g);
        (l = u.onFinish) == null || l.call(u, i(h, new Set(b)));
      } catch (b) {
        console.error("[Connect] Error during capabilities request", b);
      }
    try {
      const b = i(h);
      (d = u.onFinish) == null || d.call(u, b);
    } catch (b) {
      console.error("[Connect] Error during capabilities request", b), (f = u.onCancel) == null || f.call(u);
    }
  };
  e.getCapabilities = a, r(Aq, e);
})(_q);
var xq = {}, F4 = {}, q2 = {};
Object.defineProperty(q2, "__esModule", { value: !0 });
q2.validateInscriptionPayload = void 0;
const wbe = 4e5, vbe = 6e4, Ebe = (e) => {
  const { contentType: t, content: r, payloadType: n, network: o, appFeeAddress: i, appFee: a } = e;
  if (!/^[a-z]+\/[a-z0-9\-\.\+]+(?=;.*|$)/.test(t))
    throw new Error("Invalid content type detected");
  if (!r || r.length === 0)
    throw new Error("Empty content not allowed");
  if (!n || n !== "BASE_64" && n !== "PLAIN_TEXT")
    throw new Error("Empty invalid payloadType specified");
  if (r.length > (o.type === "Mainnet" ? wbe : vbe))
    throw new Error("Content too large");
  if (((i == null ? void 0 : i.length) ?? 0) > 0 && (a ?? 0) <= 0)
    throw new Error("Invalid combination of app fee address and fee provided");
};
q2.validateInscriptionPayload = Ebe;
Object.defineProperty(F4, "__esModule", { value: !0 });
F4.createInscription = void 0;
const _be = ys, Abe = Wu, xbe = q2, kbe = async (e) => {
  var t, r;
  const { getProvider: n } = e, o = await (0, Abe.getProviderOrThrow)(n);
  (0, xbe.validateInscriptionPayload)(e.payload);
  try {
    const i = (0, _be.createUnsecuredToken)(e.payload), a = await o.createInscription(i);
    (t = e.onFinish) == null || t.call(e, a);
  } catch (i) {
    console.error("[Connect] Error during create inscription", i), (r = e.onCancel) == null || r.call(e);
  }
};
F4.createInscription = kbe;
var M4 = {};
Object.defineProperty(M4, "__esModule", { value: !0 });
M4.createRepeatInscriptions = void 0;
const Sbe = Wu, Tbe = ys, Ibe = q2, Obe = async (e) => {
  var t, r;
  const { getProvider: n } = e, o = await (0, Sbe.getProviderOrThrow)(n);
  (0, Ibe.validateInscriptionPayload)(e.payload);
  try {
    const i = (0, Tbe.createUnsecuredToken)(e.payload), a = await o.createRepeatInscriptions(i);
    (t = e.onFinish) == null || t.call(e, a);
  } catch (i) {
    console.error("[Connect] Error during create repeat inscriptions", i), (r = e.onCancel) == null || r.call(e);
  }
};
M4.createRepeatInscriptions = Obe;
var kq = {};
Object.defineProperty(kq, "__esModule", { value: !0 });
(function(e) {
  var t = Rt && Rt.__createBinding || (Object.create ? function(n, o, i, a) {
    a === void 0 && (a = i);
    var u = Object.getOwnPropertyDescriptor(o, i);
    (!u || ("get" in u ? !o.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return o[i];
    } }), Object.defineProperty(n, a, u);
  } : function(n, o, i, a) {
    a === void 0 && (a = i), n[a] = o[i];
  }), r = Rt && Rt.__exportStar || function(n, o) {
    for (var i in n) i !== "default" && !Object.prototype.hasOwnProperty.call(o, i) && t(o, n, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(F4, e), r(M4, e), r(kq, e);
})(xq);
var Sq = {}, Tq = {};
Object.defineProperty(Tq, "__esModule", { value: !0 });
(function(e) {
  var t = Rt && Rt.__createBinding || (Object.create ? function(a, u, l, d) {
    d === void 0 && (d = l);
    var f = Object.getOwnPropertyDescriptor(u, l);
    (!f || ("get" in f ? !u.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return u[l];
    } }), Object.defineProperty(a, d, f);
  } : function(a, u, l, d) {
    d === void 0 && (d = l), a[d] = u[l];
  }), r = Rt && Rt.__exportStar || function(a, u) {
    for (var l in a) l !== "default" && !Object.prototype.hasOwnProperty.call(u, l) && t(u, a, l);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.signMessage = void 0;
  const n = ys, o = Wu, i = async (a) => {
    var u, l;
    const d = await (0, o.getProviderOrThrow)(a.getProvider), { address: f, message: h } = a.payload;
    if (!f)
      throw new Error("An address is required to sign a message");
    if (!h)
      throw new Error("A message to be signed is required");
    try {
      const g = (0, n.createUnsecuredToken)(a.payload), b = await d.signMessage(g);
      (u = a.onFinish) == null || u.call(a, b);
    } catch (g) {
      console.error("[Connect] Error during sign message request", g), (l = a.onCancel) == null || l.call(a);
    }
  };
  e.signMessage = i, r(Tq, e);
})(Sq);
var Iq = {}, D4 = {};
Object.defineProperty(D4, "__esModule", { value: !0 });
D4.sendBtcTransaction = void 0;
const Pbe = ys, Cbe = Wu, Bbe = (e) => e.map((t) => {
  const { address: r, amountSats: n } = t;
  return {
    address: r,
    amountSats: n.toString()
  };
}), Nbe = async (e) => {
  var t, r;
  const n = await (0, Cbe.getProviderOrThrow)(e.getProvider), { recipients: o, senderAddress: i, network: a, message: u } = e.payload;
  if (!o || o.length === 0)
    throw new Error("At least one recipient is required");
  if (o.some((l) => typeof l.address != "string" || typeof l.amountSats != "bigint"))
    throw new Error("Incorrect recipient format");
  if (!i)
    throw new Error("The sender address is required");
  try {
    const l = Bbe(o), d = {
      network: a,
      senderAddress: i,
      message: u,
      recipients: l
    }, f = (0, Pbe.createUnsecuredToken)(d), h = await n.sendBtcTransaction(f);
    (t = e.onFinish) == null || t.call(e, h);
  } catch (l) {
    console.error("[Connect] Error during send BTC transaction request", l), (r = e.onCancel) == null || r.call(e);
  }
};
D4.sendBtcTransaction = Nbe;
var K4 = {};
Object.defineProperty(K4, "__esModule", { value: !0 });
K4.signTransaction = void 0;
const $be = ys, Ube = Wu, Rbe = async (e) => {
  var t, r;
  const n = await (0, Ube.getProviderOrThrow)(e.getProvider), { psbtBase64: o, inputsToSign: i } = e.payload;
  if (!o)
    throw new Error("A value for psbtBase64 representing the tx hash is required");
  if (!i)
    throw new Error("An array specifying the inputs to be signed by the wallet is required");
  try {
    const a = (0, $be.createUnsecuredToken)(e.payload), u = await n.signTransaction(a);
    (t = e.onFinish) == null || t.call(e, u);
  } catch (a) {
    console.error("[Connect] Error during sign transaction request", a), (r = e.onCancel) == null || r.call(e);
  }
};
K4.signTransaction = Rbe;
var q4 = {};
Object.defineProperty(q4, "__esModule", { value: !0 });
q4.signMultipleTransactions = void 0;
const zbe = ys, jbe = Wu, Lbe = async (e) => {
  var t, r;
  const n = await (0, jbe.getProviderOrThrow)(e.getProvider), { psbts: o } = e.payload;
  if (!o || !o.length)
    throw new Error("psbts array is required");
  if (o.length > 100)
    throw new Error("psbts array must contain less than 100 psbts");
  try {
    const i = (0, zbe.createUnsecuredToken)(e.payload), a = await n.signMultipleTransactions(i);
    (t = e.onFinish) == null || t.call(e, a);
  } catch (i) {
    console.error("[Connect] Error during sign Multiple transactions request", i), (r = e.onCancel) == null || r.call(e);
  }
};
q4.signMultipleTransactions = Lbe;
var Oq = {};
Object.defineProperty(Oq, "__esModule", { value: !0 });
(function(e) {
  var t = Rt && Rt.__createBinding || (Object.create ? function(n, o, i, a) {
    a === void 0 && (a = i);
    var u = Object.getOwnPropertyDescriptor(o, i);
    (!u || ("get" in u ? !o.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return o[i];
    } }), Object.defineProperty(n, a, u);
  } : function(n, o, i, a) {
    a === void 0 && (a = i), n[a] = o[i];
  }), r = Rt && Rt.__exportStar || function(n, o) {
    for (var i in n) i !== "default" && !Object.prototype.hasOwnProperty.call(o, i) && t(o, n, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(D4, e), r(K4, e), r(q4, e), r(Oq, e);
})(Iq);
var Pq = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.RpcErrorCode = e.BitcoinNetworkType = void 0, function(t) {
    t.Mainnet = "Mainnet", t.Testnet = "Testnet";
  }(e.BitcoinNetworkType || (e.BitcoinNetworkType = {})), function(t) {
    t[t.PARSE_ERROR = -32700] = "PARSE_ERROR", t[t.INVALID_REQUEST = -32600] = "INVALID_REQUEST", t[t.METHOD_NOT_FOUND = -32601] = "METHOD_NOT_FOUND", t[t.INVALID_PARAMS = -32602] = "INVALID_PARAMS", t[t.INTERNAL_ERROR = -32603] = "INTERNAL_ERROR", t[t.USER_REJECTION = -32e3] = "USER_REJECTION", t[t.METHOD_NOT_SUPPORTED = -32001] = "METHOD_NOT_SUPPORTED";
  }(e.RpcErrorCode || (e.RpcErrorCode = {}));
})(Pq);
(function(e) {
  var t = Rt && Rt.__createBinding || (Object.create ? function(n, o, i, a) {
    a === void 0 && (a = i);
    var u = Object.getOwnPropertyDescriptor(o, i);
    (!u || ("get" in u ? !o.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return o[i];
    } }), Object.defineProperty(n, a, u);
  } : function(n, o, i, a) {
    a === void 0 && (a = i), n[a] = o[i];
  }), r = Rt && Rt.__exportStar || function(n, o) {
    for (var i in n) i !== "default" && !Object.prototype.hasOwnProperty.call(o, i) && t(o, n, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(gq, e), r(bq, e), r(_q, e), r(xq, e), r(Sq, e), r(Wu, e), r(Iq, e), r(Pq, e);
})(nw);
const Hbe = /* @__PURE__ */ AL(nw), { signMessage: Fbe, sendBtcTransaction: Mbe } = Hbe, Dbe = "ORANGE_CONNECTED_WALLET_STATE";
let Kbe = class extends Gu {
  constructor(t, r, n) {
    super(t, r, n), st(this, "observer"), st(this, "$valueStore", Cg(
      Dbe,
      {
        address: "",
        paymentAddress: "",
        paymentPublicKey: "",
        publicKey: "",
        balance: ""
      }
    )), st(this, "removeSubscriber");
  }
  get library() {
    var t;
    return (t = window == null ? void 0 : window.OrangeWalletProviders) == null ? void 0 : t.OrangeBitcoinProvider;
  }
  get network() {
    return this.$network.get();
  }
  restorePersistedValues() {
    const t = this.$valueStore.get();
    for (const r of I0)
      r === "balance" && this.$store.setKey(r, BigInt(t[r])), this.$store.setKey(r, t[r]);
    this.$store.setKey(
      "accounts",
      [t.address, t.paymentAddress].filter(Boolean)
    );
  }
  watchStateChange(t, r, n) {
    Og(kp, t, n, this.$valueStore);
  }
  initialize() {
    var t;
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var r;
      window != null && window.OrangeBitcoinProvider && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [kp]: !0
      }), (r = this.observer) == null || r.disconnect());
    }), (t = this.observer) == null || t.observe(document, { childList: !0, subtree: !0 })), Ku(this.$store, ["provider"], (r) => {
      r.provider !== kp ? this.removeSubscriber && (this.$valueStore.set({
        address: "",
        paymentAddress: "",
        paymentPublicKey: "",
        publicKey: "",
        balance: ""
      }), this.removeSubscriber(), this.removeSubscriber = void 0) : this.removeSubscriber = this.$store.subscribe(
        this.watchStateChange.bind(this)
      );
    });
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect();
  }
  async connect(t) {
    const { address: r, paymentAddress: n } = this.$valueStore.get();
    try {
      if (r) {
        this.restorePersistedValues(), a0(n, this.network).then((a) => {
          this.$store.setKey("balance", a);
        });
        return;
      }
      let o = tT(this.network || Kn);
      const i = {
        payload: {
          purposes: ["ordinals", "payment"],
          message: "Address for receiving Ordinals and payments",
          network: {
            type: o
          }
        },
        onFinish: (a) => {
          const u = R3(a.addresses), l = z3(a.addresses);
          if (!u || !(l != null && l.address))
            throw new Error("Could not find addresses");
          u && l && (this.$store.setKey("provider", kp), this.$store.setKey("address", u.address), this.$store.setKey("paymentAddress", l.address)), this.$store.setKey("publicKey", String(u.publicKey)), this.$store.setKey(
            "paymentPublicKey",
            String(l.publicKey)
          );
        },
        onCancel: () => {
          throw new Error(`User canceled lasereyes to ${kp} wallet`);
        }
      };
      await nw.getAddress(i), this.$store.setKey("connected", !0);
    } catch (o) {
      throw o;
    }
  }
  async getNetwork() {
    const { address: t } = this.$store.get();
    return t.slice(0, 1) === "t" && [aa, ka, Ls, as].includes(this.network) ? this.network : Kn;
  }
  async sendBTC(t, r) {
    let n = "";
    const o = {
      payload: {
        network: {
          type: tT(this.network)
        },
        recipients: [
          {
            address: t,
            amountSats: BigInt(r)
          }
        ],
        senderAddress: this.$store.get().paymentAddress
      },
      onFinish: (i) => {
        n = i;
      },
      onCancel: () => {
        throw new Error("User canceled the request");
      }
    };
    return await Mbe(o), n;
  }
  async signMessage(t, r) {
    let n = "";
    const o = (r == null ? void 0 : r.toSignAddress) || this.$store.get().paymentAddress, i = {
      payload: {
        network: {
          type: tT(this.network)
        },
        address: o,
        message: t
      },
      onFinish: (a) => {
        n = a;
      },
      onCancel: () => {
        throw new Error("User canceled the request");
      }
    };
    return await Fbe(i), n;
  }
  async signPsbt({
    psbtBase64: t,
    broadcast: r,
    finalize: n,
    inputsToSign: o
  }) {
    try {
      const i = Sn.fromBase64(String(t), {
        network: dn(this.network)
      }).data.inputs;
      let a = {};
      if (o)
        a = o.reduce(
          (g, b) => ({
            ...g,
            [b.address]: [...g[b.address] || [], b.index]
          }),
          {}
        );
      else {
        const { address: g, paymentAddress: b } = this.$store.get(), w = {
          [g]: []
        }, E = {
          [b]: []
        };
        for (let _ of i.keys()) {
          const O = i[_];
          if (O.witnessUtxo === void 0) {
            E[b].push(Number(_));
            continue;
          }
          const { script: C } = O.witnessUtxo, I = w2(
            C,
            dn(this.network)
          );
          I === b ? E[b].push(Number(_)) : I === g && w[g].push(Number(_));
        }
        w[g].length > 0 && (a = { ...a, ...w }), E[b].length > 0 && (a = { ...a, ...E });
      }
      let u, l, d, f;
      const h = await nw.request("signPsbt", {
        psbt: t,
        broadcast: !!r,
        signInputs: a
      });
      if (h.status === "success")
        f = Sn.fromBase64(h.result.psbt, {
          network: dn(this.network)
        }), u = h.result.txid;
      else
        throw h.error.code === nw.RpcErrorCode.USER_REJECTION ? new Error("User canceled the request") : new Error("Error signing psbt");
      if (!f)
        throw new Error("Error signing psbt");
      return n && !u ? (f.finalizeAllInputs(), l = f.toHex(), d = f.toBase64()) : (l = f.toHex(), d = f.toBase64()), {
        signedPsbtHex: l,
        signedPsbtBase64: d,
        txId: u
      };
    } catch (i) {
      throw console.error(i), i;
    }
  }
};
const qbe = "OKX_CONNECTED_WALLET_STATE";
let Vbe = class extends Gu {
  constructor(t, r, n) {
    super(t, r, n), st(this, "observer"), st(this, "$valueStore", Cg(
      qbe,
      {
        address: "",
        paymentAddress: "",
        paymentPublicKey: "",
        publicKey: "",
        balance: ""
      }
    )), st(this, "removeSubscriber");
  }
  get library() {
    var t, r;
    let n;
    return this.network === aa || this.network === ka || this.network === Ls || this.network === as ? n = (t = window == null ? void 0 : window.okxwallet) == null ? void 0 : t.bitcoinTestnet : (this.network === Kn || this.network === th) && (n = (r = window == null ? void 0 : window.okxwallet) == null ? void 0 : r.bitcoin), n;
  }
  get network() {
    return this.$network.get();
  }
  restorePersistedValues() {
    const t = this.$valueStore.get();
    for (const r of I0)
      r === "balance" && this.$store.setKey(r, BigInt(t[r])), this.$store.setKey(r, t[r]);
    this.$store.setKey(
      "accounts",
      [t.address, t.paymentAddress].filter(Boolean)
    );
  }
  watchStateChange(t, r, n) {
    Og(Yb, t, n, this.$valueStore);
  }
  initialize() {
    var t;
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var r;
      this.library && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [Yb]: !0
      }), (r = this.observer) == null || r.disconnect());
    }), (t = this.observer) == null || t.observe(document, { childList: !0, subtree: !0 })), Ku(this.$store, ["provider"], (r) => {
      r.provider !== Yb ? this.removeSubscriber && (this.$valueStore.set({
        address: "",
        paymentAddress: "",
        paymentPublicKey: "",
        publicKey: "",
        balance: ""
      }), this.removeSubscriber(), this.removeSubscriber = void 0) : this.removeSubscriber = this.$store.subscribe(
        this.watchStateChange.bind(this)
      );
    });
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect();
  }
  async connect(t) {
    const { address: r, paymentAddress: n } = this.$valueStore.get();
    if (r)
      if (r.startsWith("tb1") && z2(this.network))
        this.disconnect();
      else {
        this.restorePersistedValues(), a0(n, this.network).then((o) => {
          this.$store.setKey("balance", o);
        });
        return;
      }
    try {
      const o = await this.library.connect();
      if (!o) throw new Error("No accounts found");
      this.$store.setKey("address", o.address), this.$store.setKey("paymentAddress", o.address), this.$store.setKey("publicKey", o.publicKey), this.$store.setKey("paymentPublicKey", o.publicKey), this.$store.setKey("accounts", [o]);
    } catch (o) {
      throw o;
    }
  }
  async requestAccounts() {
    const t = this.library, r = this.network;
    return r === aa || r === ka || r === as ? await t.connect() : await t.requestAccounts();
  }
  async getNetwork() {
    const { address: t } = this.$store.get(), r = this.network;
    if (t.slice(0, 1) === "t")
      return r === aa ? aa : r === ka ? ka : r === Ls ? Ls : r === as ? as : aa;
    const n = await this.library.getNetwork();
    return ype(n);
  }
  async getPublicKey() {
    const t = this.library;
    return await (t == null ? void 0 : t.getPublicKey());
  }
  async getInscriptions(t, r) {
    const n = t || 0, o = r || 10;
    return (await this.library.getInscriptions(n, o)).list.map((i) => A1(i, void 0, this.network));
  }
  async sendBTC(t, r) {
    const n = await this.library.sendBitcoin(t, r);
    if (!n) throw new Error("Transaction failed");
    return n;
  }
  async signMessage(t, r) {
    const n = this.library, o = (r == null ? void 0 : r.protocol) === U2 ? A4 : r == null ? void 0 : r.protocol;
    return await (n == null ? void 0 : n.signMessage(t, o));
  }
  async signPsbt({ psbtHex: t, broadcast: r, finalize: n, inputsToSign: o }) {
    const i = await this.library.signPsbt(t, C4({
      autoFinalized: n,
      toSignInputs: o
    })), a = Sn.fromHex(i);
    if (n && r) {
      const u = await this.pushPsbt(i);
      return {
        signedPsbtHex: a.toHex(),
        signedPsbtBase64: a.toBase64(),
        txId: u
      };
    }
    return {
      signedPsbtHex: a.toHex(),
      signedPsbtBase64: a.toBase64(),
      txId: void 0
    };
  }
};
const Gbe = "MAGIC_EDEN_CONNECTED_WALLET_STATE";
let Wbe = class extends Gu {
  constructor(t, r, n) {
    super(t, r, n), st(this, "observer"), st(this, "$valueStore", Cg(
      Gbe,
      {
        address: "",
        paymentAddress: "",
        paymentPublicKey: "",
        publicKey: "",
        balance: ""
      }
    )), st(this, "removeSubscriber");
  }
  get library() {
    var t;
    return (t = window == null ? void 0 : window.magicEden) == null ? void 0 : t.bitcoin;
  }
  get network() {
    return this.$network.get();
  }
  restorePersistedValues() {
    const t = this.$valueStore.get();
    for (const r of I0) {
      if (r === "balance") {
        this.$store.setKey(r, BigInt(t[r]));
        continue;
      }
      this.$store.setKey(r, t[r]);
    }
    this.$store.setKey(
      "accounts",
      [t.address, t.paymentAddress].filter(Boolean)
    );
  }
  watchStateChange(t, r, n) {
    Og(
      Ed,
      t,
      n,
      this.$valueStore
    );
  }
  initialize() {
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var t, r;
      (t = window == null ? void 0 : window.magicEden) != null && t.bitcoin && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [Ed]: !0
      }), (r = this.observer) == null || r.disconnect());
    }), this.observer.observe(document, { childList: !0, subtree: !0 })), Ku(this.$store, ["provider"], (t) => {
      t.provider !== Ed ? this.removeSubscriber && (this.$valueStore.set({
        address: "",
        paymentAddress: "",
        paymentPublicKey: "",
        publicKey: "",
        balance: ""
      }), this.removeSubscriber(), this.removeSubscriber = void 0) : this.removeSubscriber = this.$store.subscribe(
        this.watchStateChange.bind(this)
      );
    });
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect();
  }
  async connect(t) {
    const { address: r, paymentAddress: n } = this.$valueStore.get();
    try {
      if (r)
        if (r.startsWith("tb1") && z2(this.network))
          this.disconnect();
        else {
          a0(n, this.network).then((i) => {
            this.$store.setKey("balance", i);
          }), this.restorePersistedValues();
          return;
        }
      if (CK(this.network))
        throw new Error(`${this.network} is not supported by ${Ed}`);
      let o = eT(this.network || Kn);
      await Xme({
        getProvider: async () => this.library,
        payload: {
          purposes: ["ordinals", "payment"],
          message: "Connecting with lasereyes",
          network: {
            type: o
          }
        },
        onFinish: (i) => {
          const a = R3(i.addresses), u = z3(i.addresses);
          if (!a || !u)
            throw new Error("No address found");
          a && u && (this.$store.setKey("address", a.address), this.$store.setKey("paymentAddress", u.address), this.$store.setKey("accounts", [
            a.address,
            u.address
          ])), this.$store.setKey(
            "publicKey",
            String(i.addresses[0].publicKey)
          ), this.$store.setKey(
            "paymentPublicKey",
            String(i.addresses[1].publicKey)
          );
        },
        onCancel: () => {
          throw new Error(`User canceled lasereyes to ${Ed} wallet`);
        },
        onError: (i) => {
          throw new Error(`Can't lasereyes to ${Ed} wallet`);
        }
      });
    } catch (o) {
      throw o;
    }
  }
  async sendBTC(t, r) {
    let n;
    if (await ube({
      getProvider: async () => this.library,
      payload: {
        network: {
          type: eT(
            this.network
          )
        },
        recipients: [
          {
            address: t,
            amountSats: BigInt(r)
          }
        ],
        senderAddress: this.$store.get().paymentAddress
      },
      onFinish: (o) => {
        n = o;
      },
      onCancel: () => {
        throw console.error("Request canceled"), new Error("User canceled the request");
      }
    }), !n) throw new Error("Error sending BTC");
    return n.txid;
  }
  async signMessage(t, r) {
    try {
      const n = (r == null ? void 0 : r.toSignAddress) || this.$store.get().paymentAddress;
      let o = "";
      return await abe({
        getProvider: async () => this.library,
        payload: {
          network: {
            type: Ea.Mainnet
          },
          address: n,
          message: t,
          protocol: (r == null ? void 0 : r.protocol) === U2 ? c0.ECDSA : c0.BIP322
        },
        onFinish: (i) => {
          o = i;
        },
        onCancel: () => {
          throw console.error("Request canceled"), new Error("User canceled the request");
        }
      }), o;
    } catch (n) {
      throw n;
    }
  }
  async signPsbt({
    psbtBase64: t,
    broadcast: r,
    finalize: n,
    inputsToSign: o
  }) {
    const i = Sn.fromBase64(String(t), {
      network: dn(this.network)
    }), a = i.data.inputs;
    let u = [];
    if (o) {
      const w = o.reduce(
        (E, _) => ({
          ...E,
          [_.address]: [...E[_.address] || [], _.index]
        }),
        {}
      );
      u = Object.entries(w).map(
        ([E, _]) => ({
          address: E,
          signingIndexes: _
        })
      );
    } else {
      const { address: w, paymentAddress: E } = this.$store.get(), _ = {
        address: w,
        signingIndexes: []
      }, O = {
        address: E,
        signingIndexes: []
      };
      for (let C of a.keys()) {
        const I = a[C];
        if (I.witnessUtxo === void 0) {
          O.signingIndexes.push(Number(C));
          continue;
        }
        const { script: S } = I.witnessUtxo, T = w2(
          S,
          dn(this.network)
        );
        T === E ? (O.signingIndexes.push(Number(C)), I.sighashType && (console.log("Updating sigHash for paymentsAddressData"), O.sigHash = I.sighashType)) : T === w && (_.signingIndexes.push(Number(C)), I.sighashType && (console.log("Updating sigHash for ordinalAddressData"), _.sigHash = I.sighashType));
      }
      _.signingIndexes.length > 0 && u.push(_), O.signingIndexes.length > 0 && u.push(O);
    }
    let l, d, f, h;
    const g = eT(this.network), b = {
      getProvider: async () => this.library,
      payload: {
        network: {
          type: g
        },
        message: "Sign Transaction",
        psbtBase64: i.toBase64(),
        broadcast: r,
        inputsToSign: u
      },
      onFinish: async (w) => {
        w.psbtBase64 && (h = Sn.fromBase64(String(w.psbtBase64), {
          network: dn(this.network)
        }), d = h.toHex(), f = h.toBase64());
      },
      onCancel: () => {
        throw console.log("Canceled"), new Error("User canceled the request");
      },
      onError: (w) => {
        throw console.log("error", w), w;
      }
    };
    if (await cbe(b), !h)
      throw new Error("signature failed");
    return n || r ? (h.finalizeAllInputs(), {
      signedPsbtHex: h.toHex(),
      signedPsbtBase64: f,
      txId: l
    }) : {
      signedPsbtHex: d,
      signedPsbtBase64: f,
      txId: l
    };
  }
}, Zbe = class extends Gu {
  constructor(t, r, n) {
    super(t, r, n), st(this, "observer");
  }
  get library() {
    var t;
    return (t = window == null ? void 0 : window.phantom) == null ? void 0 : t.bitcoin;
  }
  get network() {
    return this.$network.get();
  }
  initialize() {
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var t;
      this.library && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [xp]: !0
      }), (t = this.observer) == null || t.disconnect());
    }), this.observer.observe(document, { childList: !0, subtree: !0 })), Ku(this.$store, ["provider"], (t) => {
      t.provider === xp && this.library.requestAccounts().then((r) => {
        this.handleAccountsChanged(r);
      });
    });
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect();
  }
  handleAccountsChanged(t) {
    if (!t.length) {
      this.parent.disconnect();
      return;
    }
    this.$store.get().accounts[0] !== t[0] && (this.$store.setKey("accounts", t), t.length > 0 ? this.parent.connect(xp) : this.parent.disconnect());
  }
  async connect(t) {
    if (!this.library) throw new Error("Phantom isn't installed");
    if (CK(this.network))
      throw new Error(`${this.network} is not supported by ${xp}`);
    const r = await this.library.requestAccounts();
    if (!r) throw new Error("No accounts found");
    this.$store.setKey("accounts", r);
    const n = r.find(
      (i) => i.purpose === "ordinals"
    ), o = r.find(
      (i) => i.purpose === "payment"
    );
    this.$store.setKey("address", n.address), this.$store.setKey("paymentAddress", o.address), this.$store.setKey("publicKey", n.publicKey), this.$store.setKey("paymentPublicKey", o.publicKey), this.$store.setKey("provider", xp), this.$store.setKey("connected", !0);
  }
  async getNetwork() {
    return this.$store.get().address.slice(0, 1) === "t" ? aa : Kn;
  }
  async sendBTC(t, r) {
    const { psbtHex: n, psbtBase64: o } = await iB(
      this.$store.get().address,
      this.$store.get().paymentAddress,
      t,
      r,
      this.$store.get().paymentPublicKey,
      this.network,
      7
    ), i = await this.signPsbt({
      psbtBase64: o,
      psbtHex: n,
      tx: n,
      broadcast: !0,
      finalize: !0
    });
    if (!i) throw new Error("Error sending BTC");
    return i.txId;
  }
  async signMessage(t, r) {
    var n;
    if ((r == null ? void 0 : r.protocol) === U2)
      throw new Error("ECDSA signing is not supported by Phantom");
    const o = new TextEncoder().encode(t), i = new Uint8Array(o), a = (r == null ? void 0 : r.toSignAddress) || this.$store.get().paymentAddress, u = await ((n = this.library) == null ? void 0 : n.signMessage(a, i)), l = String.fromCharCode(...u.signature);
    return btoa(l);
  }
  async signPsbt({
    psbtHex: t,
    broadcast: r,
    finalize: n,
    inputsToSign: o
  }) {
    const i = Sn.fromHex(String(t), {
      network: dn(this.network)
    }).data.inputs;
    let a = [];
    if (o) {
      const d = o.reduce(
        (f, h) => ({
          ...f,
          [h.address]: [...f[h.address] || [], h.index]
        }),
        {}
      );
      a = Object.entries(d).map(
        ([f, h]) => ({
          address: f,
          signingIndexes: h
        })
      );
    } else {
      const { address: d, paymentAddress: f } = this.$store.get(), h = {
        address: d,
        signingIndexes: []
      }, g = {
        address: f,
        signingIndexes: []
      };
      for (let b of i.keys()) {
        const w = i[b];
        if (w.witnessUtxo === void 0) {
          g.signingIndexes.push(Number(b));
          continue;
        }
        const { script: E } = w.witnessUtxo, _ = w2(
          E,
          dn(this.network)
        );
        _ === f ? g.signingIndexes.push(Number(b)) : _ === d && h.signingIndexes.push(Number(b));
      }
      h.signingIndexes.length > 0 && a.push(h), g.signingIndexes.length > 0 && a.push(g);
    }
    const u = await this.library.signPSBT(
      ome(t),
      {
        inputsToSign: a
      }
    ), l = Sn.fromBuffer(u);
    if (n && a.forEach((d) => {
      d.signingIndexes.forEach((f) => {
        l.finalizeInput(f);
      });
    }), r) {
      const d = await this.pushPsbt(l.toHex());
      return {
        signedPsbtHex: l.toHex(),
        signedPsbtBase64: l.toBase64(),
        txId: d
      };
    }
    return {
      signedPsbtHex: l.toHex(),
      signedPsbtBase64: l.toBase64(),
      txId: void 0
    };
  }
  async requestAccounts() {
    return await this.library.requestAccounts();
  }
}, Xbe = class extends Gu {
  constructor(t, r, n) {
    super(t, r, n), st(this, "observer");
  }
  get library() {
    return window == null ? void 0 : window.opnet;
  }
  get network() {
    return this.$network.get();
  }
  initialize() {
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var t;
      this.library && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [Sp]: !0
      }), (t = this.observer) == null || t.disconnect());
    }), this.observer.observe(document, { childList: !0, subtree: !0 })), Ku(this.$store, ["provider"], (t) => {
      if (t.provider !== Sp) {
        this.removeListeners();
        return;
      }
      this.library.getAccounts().then((r) => {
        this.handleAccountsChanged(r);
      }), this.addListeners();
    });
  }
  addListeners() {
    this.library.on("accountsChanged", this.handleAccountsChanged.bind(this)), this.library.on("networkChanged", this.handleNetworkChanged.bind(this));
  }
  removeListeners() {
    var t, r;
    this.library && ((t = this.library) == null || t.removeListener(
      "accountsChanged",
      this.handleAccountsChanged.bind(this)
    ), (r = this.library) == null || r.removeListener(
      "networkChanged",
      this.handleNetworkChanged.bind(this)
    ));
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect(), this.removeListeners();
  }
  handleAccountsChanged(t) {
    if (!t.length) {
      this.parent.disconnect();
      return;
    }
    this.$store.get().accounts[0] !== t[0] && (this.$store.setKey("accounts", t), t.length > 0 ? this.parent.connect(Sp) : this.parent.disconnect());
  }
  handleNetworkChanged(t) {
    const r = B3(t);
    this.network !== r && this.switchNetwork(r), this.parent.connect(Sp);
  }
  async connect(t) {
    if (!this.library) throw new Error("OP_NET isn't installed");
    const r = await this.library.requestAccounts();
    if (!r) throw new Error("No accounts found");
    const n = await this.library.getPublicKey();
    if (!n) throw new Error("No public key found");
    this.$store.setKey("accounts", r), this.$store.setKey("address", r[0]), this.$store.setKey("paymentAddress", r[0]), this.$store.setKey("publicKey", n), this.$store.setKey("paymentPublicKey", n), this.$store.setKey("provider", Sp), await this.getNetwork().then((o) => {
      var i;
      ((i = this.config) == null ? void 0 : i.network) !== o && this.switchNetwork(o);
    }), this.$store.setKey("connected", !0);
  }
  async getNetwork() {
    var t;
    const r = await ((t = this.library) == null ? void 0 : t.getChain());
    return r ? B3(r.enum) : this.network;
  }
  async sendBTC(t, r) {
    var n;
    const o = await ((n = this.library) == null ? void 0 : n.sendBitcoin(t, r));
    if (!o) throw new Error("Transaction failed");
    return o;
  }
  async signMessage(t, r) {
    var n;
    const o = (r == null ? void 0 : r.protocol) === rB ? A4 : r == null ? void 0 : r.protocol;
    return await ((n = this.library) == null ? void 0 : n.signMessage(t, o));
  }
  async signPsbt({ psbtHex: t, broadcast: r, finalize: n, inputsToSign: o }) {
    var i;
    const a = await ((i = this.library) == null ? void 0 : i.signPsbt(t, C4({
      autoFinalized: n,
      toSignInputs: o
    }))), u = Sn.fromHex(a);
    if (n && r) {
      const l = await this.pushPsbt(a);
      return {
        signedPsbtHex: u.toHex(),
        signedPsbtBase64: u.toBase64(),
        txId: l
      };
    }
    return {
      signedPsbtHex: u.toHex(),
      signedPsbtBase64: u.toBase64(),
      txId: void 0
    };
  }
  async getPublicKey() {
    var t;
    return await ((t = this.library) == null ? void 0 : t.getPublicKey());
  }
  async getBalance() {
    return (await this.library.getBalance()).total;
  }
  async getInscriptions(t, r) {
    return await this.library.getInscriptions(t, r);
  }
  async requestAccounts() {
    return await this.library.requestAccounts();
  }
  async switchNetwork(t) {
    var r;
    const n = yD(t);
    await ((r = this.library) == null ? void 0 : r.switchChain(n)), this.$network.set(t);
  }
};
const Qv = {};
function Bb(e) {
  if (Qv[e])
    return console.warn(`Multiple requests for "${e}" detected`), Qv[e];
  const t = new Promise((r) => {
    const n = console.log;
    console.log = (...o) => {
      o.length > 0 && typeof o[0] == "string" && (console.log = n, Qv[e] = void 0, r(o[0]));
    }, n(
      `Please log a value for "${e}" using 
 console.log('<your-value>') 
 to continue.`
    );
  });
  return Qv[e] = t, t;
}
let Ybe = class {
  async requestAccounts() {
    const t = await Bb("address");
    if (!t) throw new Error("No address provided");
    const r = await Bb("paymentAddress");
    if (!r) throw new Error("No payment address provided");
    return [t, r];
  }
  async signMessage(t) {
    return console.log("sign this message in sparrow wallet:"), console.log(""), console.log(`${t}`), console.log(""), await Bb("message to sign");
  }
  async signPsbt(t) {
    return console.log("sign this in sparrow wallet:"), console.log(""), console.log(`${t}`), console.log(""), await Bb("signed psbt hex");
  }
  async getPublicKey() {
    const t = await Bb("publicKey");
    if (!t) throw new Error("No public key provided");
    return t;
  }
  // TODO: Implement network switching between mainnet and testnet
  async getNetwork() {
    return "mainnet";
  }
  async switchNetwork(t) {
  }
};
const Jbe = "SPARROW_CONNECTED_WALLET_STATE";
let Qbe = class extends Gu {
  constructor() {
    super(...arguments), st(this, "observer"), st(this, "$valueStore", Cg(
      Jbe,
      {
        address: "",
        paymentAddress: "",
        paymentPublicKey: "",
        publicKey: "",
        balance: ""
      }
    )), st(this, "removeSubscriber");
  }
  get library() {
    return window == null ? void 0 : window.SparrowWalletProvider;
  }
  get network() {
    return this.$network.get();
  }
  initialize() {
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var t;
      this.library || (window.SparrowWalletProvider = new Ybe()), this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [a1]: !0
      }), (t = this.observer) == null || t.disconnect();
    }), this.observer.observe(document, { childList: !0, subtree: !0 })), Ku(this.$store, ["provider"], (t) => {
      t.provider !== a1 ? this.removeSubscriber && (this.$valueStore.set({
        address: "",
        paymentAddress: "",
        paymentPublicKey: "",
        publicKey: "",
        balance: ""
      }), this.removeSubscriber(), this.removeSubscriber = void 0) : this.removeSubscriber = this.$store.subscribe(
        this.watchStateChange.bind(this)
      );
    });
  }
  watchStateChange(t, r, n) {
    Og(
      a1,
      t,
      n,
      this.$valueStore
    );
  }
  restorePersistedValues() {
    const t = this.$valueStore.get();
    for (const r of I0)
      r === "balance" && this.$store.setKey(r, BigInt(t[r])), this.$store.setKey(r, t[r]);
    this.$store.setKey(
      "accounts",
      [t.address, t.paymentAddress].filter(Boolean)
    );
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect();
  }
  async connect(t) {
    try {
      const { address: r, paymentAddress: n } = this.$valueStore.get();
      if (r && n)
        if (r.startsWith("tb1") && z2(this.network))
          this.disconnect();
        else {
          this.restorePersistedValues();
          return;
        }
      if (!this.library) throw new Error("Sparrow wallet isn't supported");
      const o = await this.library.requestAccounts();
      if (!o) throw new Error("No accounts found");
      await this.getNetwork().then((a) => {
        this.network !== a && this.switchNetwork(this.network);
      });
      const i = await this.library.getPublicKey();
      if (!i) throw new Error("No public key found");
      this.$store.setKey("accounts", o), this.$store.setKey("address", o[0]), this.$store.setKey("paymentAddress", o[1]), this.$store.setKey("publicKey", i), this.$store.setKey("paymentPublicKey", i);
    } catch (r) {
      throw console.error("Error during sparrow connect:", r), r;
    }
  }
  async getNetwork() {
    return this.network;
  }
  async sendBTC(t, r) {
    const { psbtBase64: n } = await iB(
      this.$store.get().address,
      this.$store.get().paymentAddress,
      t,
      r,
      this.$store.get().paymentPublicKey,
      this.network,
      7
    ), o = await this.library.signPsbt(n);
    if (!o) throw new Error("No signed PSBT provided");
    const i = await this.pushPsbt(o);
    if (!i) throw new Error("send failed, no txid returned");
    return i;
  }
  async signMessage(t) {
    return await this.library.signMessage(t);
  }
  async signPsbt({ psbtBase64: t, broadcast: r, finalize: n }) {
    const o = Sn.fromBase64(t), i = await this.library.signPsbt(t);
    if (n && r) {
      const a = await this.pushPsbt(i);
      return {
        signedPsbtHex: i,
        signedPsbtBase64: o.toBase64(),
        txId: a
      };
    }
    return {
      signedPsbtHex: i,
      signedPsbtBase64: o.toBase64(),
      txId: void 0
    };
  }
  async getPublicKey() {
    const t = await this.library.getPublicKey();
    return this.$store.setKey("publicKey", t), t;
  }
  async getBalance() {
    const t = await a0(
      this.$store.get().paymentAddress,
      this.network
    );
    return this.$store.setKey("balance", t), t.toString();
  }
  async requestAccounts() {
    return await this.connect(a1), this.$store.get().accounts;
  }
};
class YRe {
  constructor(t, r) {
    st(this, "$store"), st(this, "$network"), st(this, "$providerMap"), st(this, "disposed", !1), st(this, "dataSourceManager"), this.config = r, this.$store = t.$store, this.$network = t.$network, yJ(this.$store), this.$providerMap = {
      [Xb]: new bbe(t, this, r),
      [Ed]: new Wbe(t, this, r),
      [Yb]: new Vbe(t, this, r),
      [Sp]: new Xbe(t, this, r),
      [kp]: new Kbe(t, this, r),
      [Zb]: new mbe(t, this, r),
      [xp]: new Zbe(t, this, r),
      [a1]: new Qbe(t, this, r),
      [n1]: new rme(t, this, r),
      [o1]: new fbe(t, this, r),
      [i1]: new dbe(t, this, r)
    };
    try {
      this.dataSourceManager = Wp.getInstance();
    } catch {
      Wp.init(r), this.dataSourceManager = Wp.getInstance();
    }
  }
  dispose() {
    this.disposed = !0;
    for (const t of Object.values(this.$providerMap))
      t.dispose();
  }
  initialize() {
    this.$network.listen(this.watchNetworkChange.bind(this)), Ku(this.$store, ["isInitializing"], (t, r) => {
      if (!this.disposed && t.isInitializing !== r.isInitializing)
        return this.handleIsInitializingChanged(t.isInitializing);
    }), this.checkNetwork(), nme(() => this.$store.setKey("isInitializing", !1));
  }
  checkNetwork() {
    this.getNetwork().then((t) => {
      var r;
      t && (this.$network.set(t), this.dataSourceManager.updateNetwork(t));
      try {
        (r = this.config) != null && r.network && this.config.network !== t && this.switchNetwork(this.config.network);
      } catch (n) {
        console.error("Couldn't enforce config network", n), this.disconnect();
      }
    });
  }
  handleIsInitializingChanged(t) {
    if (typeof window < "u" && typeof localStorage < "u" && !t) {
      const r = localStorage == null ? void 0 : localStorage.getItem(
        gS
      );
      r && this.connect(r).then(() => {
        this.checkNetwork();
      });
    }
  }
  async connect(t) {
    if (this.disposed) {
      console.warn("Client disposed, cannot connect");
      return;
    }
    this.$store.setKey("isConnecting", !0);
    try {
      if (localStorage == null || localStorage.setItem(gS, t), !this.$providerMap[t])
        throw new Error("Unsupported wallet provider");
      const r = this.$providerMap[t];
      await (r == null ? void 0 : r.connect(t)), this.$store.setKey("connected", !0), this.$store.setKey("provider", t);
    } catch (r) {
      throw console.error("Error during connect:", r), this.$store.setKey("isConnecting", !1), this.disconnect(), r;
    } finally {
      this.$store.setKey("isConnecting", !1);
    }
  }
  async requestAccounts() {
    var t;
    const r = this.$store.get().provider;
    if (!r)
      throw new Error("No wallet provider connected");
    try {
      return await ((t = this.$providerMap[r]) == null ? void 0 : t.requestAccounts());
    } catch (n) {
      throw n instanceof Error && n.message.toLowerCase().includes("not implemented") ? new Error("The connected wallet doesn't support this method") : n;
    }
  }
  disconnect() {
    this.$store.set({
      provider: void 0,
      address: "",
      paymentAddress: "",
      publicKey: "",
      paymentPublicKey: "",
      balance: void 0,
      accounts: [],
      connected: !1,
      isConnecting: !1,
      isInitializing: !1,
      hasProvider: this.$store.get().hasProvider
    }), localStorage == null || localStorage.removeItem(gS);
  }
  async switchNetwork(t) {
    var r;
    try {
      const n = this.$store.get().provider;
      n && (await ((r = this.$providerMap[n]) == null ? void 0 : r.switchNetwork(t)), this.dataSourceManager.updateNetwork(t));
    } catch (n) {
      throw n instanceof Error && n.message.toLowerCase().includes("not implemented") ? (this.disconnect(), new Error(
        "The connected wallet doesn't support programmatic network changes.."
      )) : n;
    }
  }
  watchNetworkChange() {
    this.$store.setKey("balance", void 0), this.getBalance();
  }
  async getNetwork() {
    var t;
    const r = this.$store.get().provider;
    return r && this.$providerMap[r] ? await ((t = this.$providerMap[r]) == null ? void 0 : t.getNetwork()) : this.$network.get();
  }
  async sendBTC(t, r) {
    var n;
    if (r <= 0) throw new Error("Amount must be greater than 0");
    if (!Number.isInteger(r)) throw new Error("Amount must be an integer");
    const o = this.$store.get().provider;
    if (!o) throw new Error("No wallet connected");
    if (o && this.$providerMap[o])
      try {
        return await ((n = this.$providerMap[o]) == null ? void 0 : n.sendBTC(t, r));
      } catch (i) {
        throw i instanceof Error && i.message.toLowerCase().includes("not implemented") ? new Error(
          "The connected wallet doesn't support sending BTC..."
        ) : i;
      }
  }
  async signMessage(t, r) {
    var n;
    let o = {};
    typeof r == "string" ? o = { toSignAddress: r } : r && (o = r);
    const i = this.$store.get().provider;
    if (!i) throw new Error("No wallet connected");
    if (i && this.$providerMap[i])
      try {
        return await ((n = this.$providerMap[i]) == null ? void 0 : n.signMessage(t, o));
      } catch (a) {
        throw a instanceof Error && a.message.toLowerCase().includes("not implemented") ? new Error(
          "The connected wallet doesn't support message signing..."
        ) : a;
      }
  }
  async signPsbt(t, r, n) {
    var o;
    let i, a, u, l;
    typeof t == "string" ? (i = t, a = r ?? !1, u = n ?? !1) : (i = t.tx, a = t.finalize ?? !1, u = t.broadcast ?? !1, l = t.inputsToSign ?? []);
    let d, f;
    if (!i) throw new Error("No PSBT provided");
    if (Uge(i))
      f = Sn.fromHex(i).toBase64(), d = i;
    else if ($ge(i))
      f = i, d = Sn.fromBase64(i).toHex();
    else
      throw new Error("Invalid PSBT format");
    const h = this.$store.get().provider;
    if (h && this.$providerMap[h])
      try {
        return await ((o = this.$providerMap[h]) == null ? void 0 : o.signPsbt({
          psbtHex: d,
          psbtBase64: f,
          tx: i,
          broadcast: u,
          finalize: a,
          inputsToSign: l
        }));
      } catch (g) {
        throw g instanceof Error && g.message.toLowerCase().includes("not implemented") ? new Error(
          "The connected wallet doesn't support PSBT signing..."
        ) : g;
      }
    else
      throw new Error("No wallet provider connected");
  }
  async pushPsbt(t) {
    var r;
    const n = this.$store.get().provider;
    if (n && n && this.$providerMap[n])
      try {
        return await ((r = this.$providerMap[n]) == null ? void 0 : r.pushPsbt(t));
      } catch (o) {
        throw o instanceof Error && o.message.toLowerCase().includes("not implemented") ? new Error(
          "The connected wallet doesn't support PSBT signing..."
        ) : o;
      }
  }
  async inscribe(t, r) {
    var n;
    const o = this.$store.get().provider;
    if (o && o && this.$providerMap[o])
      try {
        return await ((n = this.$providerMap[o]) == null ? void 0 : n.inscribe(t, r));
      } catch (i) {
        throw i instanceof Error && i.message.toLowerCase().includes("not implemented") ? new Error(
          "The connected wallet doesn't support inscribing..."
        ) : i;
      }
  }
  async send(t, r) {
    var n;
    const o = this.$store.get().provider;
    if (o && o && this.$providerMap[o])
      try {
        return await ((n = this.$providerMap[o]) == null ? void 0 : n.send(t, r));
      } catch (i) {
        throw i instanceof Error && i.message.toLowerCase().includes("not implemented") ? new Error(
          "The connected wallet doesn't support sending stuff..."
        ) : i;
      }
  }
  async getPublicKey() {
    var t;
    const r = this.$store.get().provider;
    if (r && r && this.$providerMap[r])
      try {
        return await ((t = this.$providerMap[r]) == null ? void 0 : t.getPublicKey());
      } catch (n) {
        throw n instanceof Error && n.message.toLowerCase().includes("not implemented") ? new Error("The connected wallet doesn't support getPublicKey") : n;
      }
  }
  async getBalance() {
    const t = this.$store.get().provider;
    if (t && t && this.$providerMap[t])
      try {
        const r = await this.$providerMap[t].getBalance();
        return this.$store.setKey("balance", BigInt(r)), r;
      } catch (r) {
        throw r instanceof Error && r.message.toLowerCase().includes("not implemented") ? new Error("The connected wallet doesn't support getBalance") : r;
      }
  }
  async getMetaBalances(t) {
    const r = this.$store.get().provider;
    if (r && r && this.$providerMap[r])
      try {
        if (!t)
          throw new Error("No protocol provided");
        return await this.$providerMap[r].getMetaBalances(t);
      } catch (n) {
        throw n instanceof Error && n.message.toLowerCase().includes("not implemented") ? new Error("The connected wallet doesn't support getBalance") : n;
      }
  }
  async getInscriptions(t, r) {
    var n;
    const o = this.$store.get().provider;
    if (o && o && this.$providerMap[o])
      try {
        return await ((n = this.$providerMap[o]) == null ? void 0 : n.getInscriptions(t, r));
      } catch (i) {
        throw i instanceof Error && i.message.toLowerCase().includes("not implemented") ? new Error("The connected wallet doesn't support this method") : i;
      }
  }
  async sendInscriptions(t, r) {
    var n;
    const o = this.$store.get().provider;
    if (o && o && this.$providerMap[o])
      try {
        return await ((n = this.$providerMap[o]) == null ? void 0 : n.sendInscriptions(
          t,
          r
        ));
      } catch (i) {
        throw i instanceof Error && i.message.toLowerCase().includes("not implemented") ? new Error("The connected wallet doesn't support this method") : i;
      }
  }
}
var ewe = Object.defineProperty, twe = (e, t, r) => t in e ? ewe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, ut = (e, t, r) => twe(e, typeof t != "symbol" ? t + "" : t, r);
function rwe(e, t) {
  for (var r = 0; r < t.length; r++) {
    const n = t[r];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const o in n)
        if (o !== "default" && !(o in e)) {
          const i = Object.getOwnPropertyDescriptor(n, o);
          i && Object.defineProperty(e, o, i.get ? i : {
            enumerable: !0,
            get: () => n[o]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
let _O = Symbol("clean"), fu = [], Gf = 0;
const e8 = 4;
let AO = (e) => {
  let t = [], r = {
    get() {
      return r.lc || r.listen(() => {
      })(), r.value;
    },
    lc: 0,
    listen(n) {
      return r.lc = t.push(n), () => {
        for (let i = Gf + e8; i < fu.length; )
          fu[i] === n ? fu.splice(i, e8) : i += e8;
        let o = t.indexOf(n);
        ~o && (t.splice(o, 1), --r.lc || r.off());
      };
    },
    notify(n, o) {
      let i = !fu.length;
      for (let a of t)
        fu.push(
          a,
          r.value,
          n,
          o
        );
      if (i) {
        for (Gf = 0; Gf < fu.length; Gf += e8)
          fu[Gf](
            fu[Gf + 1],
            fu[Gf + 2],
            fu[Gf + 3]
          );
        fu.length = 0;
      }
    },
    /* It will be called on last listener unsubscribing.
       We will redefine it in onMount and onStop. */
    off() {
    },
    set(n) {
      let o = r.value;
      o !== n && (r.value = n, r.notify(o));
    },
    subscribe(n) {
      let o = r.listen(n);
      return n(r.value), o;
    },
    value: e
  };
  return process.env.NODE_ENV !== "production" && (r[_O] = () => {
    t = [], r.lc = 0, r.off();
  }), r;
};
const nwe = 5, K0 = 6, t8 = 10;
let owe = (e, t, r, n) => (e.events = e.events || {}, e.events[r + t8] || (e.events[r + t8] = n((o) => {
  e.events[r].reduceRight((i, a) => (a(i), i), {
    shared: {},
    ...o
  });
})), e.events[r] = e.events[r] || [], e.events[r].push(t), () => {
  let o = e.events[r], i = o.indexOf(t);
  o.splice(i, 1), o.length || (delete e.events[r], e.events[r + t8](), delete e.events[r + t8]);
}), iwe = 1e3, awe = (e, t) => owe(e, (r) => {
  let n = t(r);
  n && e.events[K0].push(n);
}, nwe, (r) => {
  let n = e.listen;
  e.listen = (...i) => (!e.lc && !e.active && (e.active = !0, r()), n(...i));
  let o = e.off;
  if (e.events[K0] = [], e.off = () => {
    o(), setTimeout(() => {
      if (e.active && !e.lc) {
        e.active = !1;
        for (let i of e.events[K0]) i();
        e.events[K0] = [];
      }
    }, iwe);
  }, process.env.NODE_ENV !== "production") {
    let i = e[_O];
    e[_O] = () => {
      for (let a of e.events[K0]) a();
      e.events[K0] = [], e.active = !1, i();
    };
  }
  return () => {
    e.listen = n, e.off = o;
  };
}), swe = (e) => {
  e.listen(() => {
  });
};
function Zu(e, t, r) {
  let n = new Set(t).add(void 0);
  return e.listen((o, i, a) => {
    n.has(a) && r(o, i, a);
  });
}
let Cq = (e = {}) => {
  let t = AO(e);
  return t.setKey = function(r, n) {
    let o = t.value;
    typeof n > "u" && r in t.value ? (t.value = { ...t.value }, delete t.value[r], t.notify(o, r)) : t.value[r] !== n && (t.value = {
      ...t.value,
      [r]: n
    }, t.notify(o, r));
  }, t;
};
const x1 = "oyl", Up = "unisat", Rp = "xverse", Id = "phantom", k1 = "leather", Gl = "magic-eden", S1 = "okx", zp = "wizz", Od = "orange", Pd = "op_net", jp = "sparrow", Y1 = "p2tr", uwe = "p2pkh", cwe = "p2sh-p2wpkh", xO = "p2wpkh", lwe = "p2wsh", V2 = "p2sh", hT = "defaultWallet", Xu = {
  /**
   * The message prefix used for signing Bitcoin messages.
   */
  messagePrefix: `Bitcoin Signed Message:
`,
  /**
   * The Bech32 prefix used for Bitcoin addresses.
   */
  bech32: "bc",
  /**
   * The BIP32 key prefixes for Bitcoin.
   */
  bip32: {
    /**
     * The public key prefix for BIP32 extended public keys.
     */
    public: 76067358,
    /**
     * The private key prefix for BIP32 extended private keys.
     */
    private: 76066276
  },
  /**
   * The prefix for Bitcoin public key hashes.
   */
  pubKeyHash: 0,
  /**
   * The prefix for Bitcoin script hashes.
   */
  scriptHash: 5,
  /**
   * The prefix for Bitcoin Wallet Import Format (WIF) private keys.
   */
  wif: 128
}, fwe = {
  messagePrefix: `Bitcoin Signed Message:
`,
  bech32: "tb",
  bip32: {
    public: 70617039,
    private: 70615956
  },
  pubKeyHash: 111,
  scriptHash: 196,
  wif: 239
};
function dwe(e) {
  if (e.length < 8 || e.length > 72 || e[0] !== 48 || e[1] !== e.length - 2 || e[2] !== 2) return !1;
  const t = e[3];
  if (t === 0 || 5 + t >= e.length || e[4 + t] !== 2) return !1;
  const r = e[5 + t];
  return !(r === 0 || 6 + t + r !== e.length || e[4] & 128 || t > 1 && e[4] === 0 && !(e[5] & 128) || e[t + 6] & 128 || r > 1 && e[t + 6] === 0 && !(e[t + 7] & 128));
}
function hwe(e) {
  if (e.length < 8) throw new Error("DER sequence length is too short");
  if (e.length > 72) throw new Error("DER sequence length is too long");
  if (e[0] !== 48) throw new Error("Expected DER sequence");
  if (e[1] !== e.length - 2)
    throw new Error("DER sequence length is invalid");
  if (e[2] !== 2) throw new Error("Expected DER integer");
  const t = e[3];
  if (t === 0) throw new Error("R length is zero");
  if (5 + t >= e.length) throw new Error("R length is too long");
  if (e[4 + t] !== 2) throw new Error("Expected DER integer (2)");
  const r = e[5 + t];
  if (r === 0) throw new Error("S length is zero");
  if (6 + t + r !== e.length) throw new Error("S length is invalid");
  if (e[4] & 128) throw new Error("R value is negative");
  if (t > 1 && e[4] === 0 && !(e[5] & 128))
    throw new Error("R value excessively padded");
  if (e[t + 6] & 128) throw new Error("S value is negative");
  if (r > 1 && e[t + 6] === 0 && !(e[t + 7] & 128))
    throw new Error("S value excessively padded");
  return {
    r: e.slice(4, 4 + t),
    s: e.slice(6 + t)
  };
}
function pwe(e, t) {
  const r = e.length, n = t.length;
  if (r === 0) throw new Error("R length is zero");
  if (n === 0) throw new Error("S length is zero");
  if (r > 33) throw new Error("R length is too long");
  if (n > 33) throw new Error("S length is too long");
  if (e[0] & 128) throw new Error("R value is negative");
  if (t[0] & 128) throw new Error("S value is negative");
  if (r > 1 && e[0] === 0 && !(e[1] & 128))
    throw new Error("R value excessively padded");
  if (n > 1 && t[0] === 0 && !(t[1] & 128))
    throw new Error("S value excessively padded");
  const o = new Uint8Array(6 + r + n);
  return o[0] = 48, o[1] = o.length - 2, o[2] = 2, o[3] = e.length, o.set(e, 4), o[4 + r] = 2, o[5 + r] = t.length, o.set(t, 6 + r), o;
}
const an = {
  OP_FALSE: 0,
  OP_0: 0,
  OP_PUSHDATA1: 76,
  OP_PUSHDATA2: 77,
  OP_PUSHDATA4: 78,
  OP_1NEGATE: 79,
  OP_RESERVED: 80,
  OP_TRUE: 81,
  OP_1: 81,
  OP_2: 82,
  OP_3: 83,
  OP_4: 84,
  OP_5: 85,
  OP_6: 86,
  OP_7: 87,
  OP_8: 88,
  OP_9: 89,
  OP_10: 90,
  OP_11: 91,
  OP_12: 92,
  OP_13: 93,
  OP_14: 94,
  OP_15: 95,
  OP_16: 96,
  OP_NOP: 97,
  OP_VER: 98,
  OP_IF: 99,
  OP_NOTIF: 100,
  OP_VERIF: 101,
  OP_VERNOTIF: 102,
  OP_ELSE: 103,
  OP_ENDIF: 104,
  OP_VERIFY: 105,
  OP_RETURN: 106,
  OP_TOALTSTACK: 107,
  OP_FROMALTSTACK: 108,
  OP_2DROP: 109,
  OP_2DUP: 110,
  OP_3DUP: 111,
  OP_2OVER: 112,
  OP_2ROT: 113,
  OP_2SWAP: 114,
  OP_IFDUP: 115,
  OP_DEPTH: 116,
  OP_DROP: 117,
  OP_DUP: 118,
  OP_NIP: 119,
  OP_OVER: 120,
  OP_PICK: 121,
  OP_ROLL: 122,
  OP_ROT: 123,
  OP_SWAP: 124,
  OP_TUCK: 125,
  OP_CAT: 126,
  OP_SUBSTR: 127,
  OP_LEFT: 128,
  OP_RIGHT: 129,
  OP_SIZE: 130,
  OP_INVERT: 131,
  OP_AND: 132,
  OP_OR: 133,
  OP_XOR: 134,
  OP_EQUAL: 135,
  OP_EQUALVERIFY: 136,
  OP_RESERVED1: 137,
  OP_RESERVED2: 138,
  OP_1ADD: 139,
  OP_1SUB: 140,
  OP_2MUL: 141,
  OP_2DIV: 142,
  OP_NEGATE: 143,
  OP_ABS: 144,
  OP_NOT: 145,
  OP_0NOTEQUAL: 146,
  OP_ADD: 147,
  OP_SUB: 148,
  OP_MUL: 149,
  OP_DIV: 150,
  OP_MOD: 151,
  OP_LSHIFT: 152,
  OP_RSHIFT: 153,
  OP_BOOLAND: 154,
  OP_BOOLOR: 155,
  OP_NUMEQUAL: 156,
  OP_NUMEQUALVERIFY: 157,
  OP_NUMNOTEQUAL: 158,
  OP_LESSTHAN: 159,
  OP_GREATERTHAN: 160,
  OP_LESSTHANOREQUAL: 161,
  OP_GREATERTHANOREQUAL: 162,
  OP_MIN: 163,
  OP_MAX: 164,
  OP_WITHIN: 165,
  OP_RIPEMD160: 166,
  OP_SHA1: 167,
  OP_SHA256: 168,
  OP_HASH160: 169,
  OP_HASH256: 170,
  OP_CODESEPARATOR: 171,
  OP_CHECKSIG: 172,
  OP_CHECKSIGVERIFY: 173,
  OP_CHECKMULTISIG: 174,
  OP_CHECKMULTISIGVERIFY: 175,
  OP_NOP1: 176,
  OP_NOP2: 177,
  OP_CHECKLOCKTIMEVERIFY: 177,
  OP_NOP3: 178,
  OP_CHECKSEQUENCEVERIFY: 178,
  OP_NOP4: 179,
  OP_NOP5: 180,
  OP_NOP6: 181,
  OP_NOP7: 182,
  OP_NOP8: 183,
  OP_NOP9: 184,
  OP_NOP10: 185,
  OP_CHECKSIGADD: 186,
  OP_PUBKEYHASH: 253,
  OP_PUBKEY: 254,
  OP_INVALIDOPCODE: 255
}, Bq = {};
for (const e of Object.keys(an)) {
  const t = an[e];
  Bq[t] = e;
}
const K3 = "0123456789abcdefABCDEF", q3 = K3.split("").map((e) => e.codePointAt(0)), V3 = Array(256).fill(!0).map((e, t) => {
  const r = String.fromCodePoint(t), n = K3.indexOf(r);
  return n < 0 ? void 0 : n < 16 ? n : n - 6;
}), Nq = new TextEncoder(), $q = new TextDecoder();
function gwe(e) {
  return $q.decode(e);
}
function mwe(e) {
  return Nq.encode(e);
}
function so(e) {
  const t = e.reduce((o, i) => o + i.length, 0), r = new Uint8Array(t);
  let n = 0;
  for (const o of e)
    r.set(o, n), n += o.length;
  return r;
}
function Wt(e) {
  const t = e || new Uint8Array();
  return t.length > 512 ? bwe(t) : ywe(t);
}
function ywe(e) {
  let t = "";
  for (let r = 0; r < e.length; ++r)
    t += K3[V3[q3[e[r] >> 4]]], t += K3[V3[q3[e[r] & 15]]];
  return t;
}
function bwe(e) {
  const t = new Uint8Array(e.length * 2);
  for (let r = 0; r < e.length; ++r)
    t[r * 2] = q3[e[r] >> 4], t[r * 2 + 1] = q3[e[r] & 15];
  return $q.decode(t);
}
function vf(e) {
  const t = Nq.encode(e || ""), r = new Uint8Array(Math.floor(t.length / 2));
  let n;
  for (n = 0; n < r.length; n++) {
    const o = V3[t[n * 2]], i = V3[t[n * 2 + 1]];
    if (o === void 0 || i === void 0)
      break;
    r[n] = o << 4 | i;
  }
  return n === r.length ? r : r.slice(0, n);
}
function wwe(e) {
  return btoa(String.fromCharCode(...e));
}
function Uq(e) {
  const t = atob(e), r = new Uint8Array(t.length);
  for (let n = 0; n < t.length; n++)
    r[n] = t.charCodeAt(n);
  return r;
}
function dt(e, t) {
  const r = Math.min(e.length, t.length);
  for (let n = 0; n < r; ++n)
    if (e[n] !== t[n])
      return e[n] < t[n] ? -1 : 1;
  return e.length === t.length ? 0 : e.length > t.length ? 1 : -1;
}
function ns(e, t, r) {
  if (t + 1 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r > 255)
    throw new Error(`The value of "value" is out of range. It must be >= 0 and <= 255. Received ${r}`);
  return e[t] = r, t + 1;
}
function vwe(e, t, r, n) {
  if (t + 2 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (n = n.toUpperCase(), r > 65535)
    throw new Error(`The value of "value" is out of range. It must be >= 0 and <= 65535. Received ${r}`);
  return n === "LE" ? (e[t] = r & 255, e[t + 1] = r >> 8 & 255) : (e[t] = r >> 8 & 255, e[t + 1] = r & 255), t + 2;
}
function G2(e, t, r, n) {
  if (t + 4 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (n = n.toUpperCase(), r > 4294967295)
    throw new Error(`The value of "value" is out of range. It must be >= 0 and <= ${4294967295}. Received ${r}`);
  return n === "LE" ? (e[t] = r & 255, e[t + 1] = r >> 8 & 255, e[t + 2] = r >> 16 & 255, e[t + 3] = r >> 24 & 255) : (e[t] = r >> 24 & 255, e[t + 1] = r >> 16 & 255, e[t + 2] = r >> 8 & 255, e[t + 3] = r & 255), t + 4;
}
function Ewe(e, t, r, n) {
  if (t + 8 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (n = n.toUpperCase(), r > 0xffffffffffffffffn)
    throw new Error(`The value of "value" is out of range. It must be >= 0 and <= ${0xffffffffffffffffn}. Received ${r}`);
  return n === "LE" ? (e[t] = Number(r & 0xffn), e[t + 1] = Number(r >> 8n & 0xffn), e[t + 2] = Number(r >> 16n & 0xffn), e[t + 3] = Number(r >> 24n & 0xffn), e[t + 4] = Number(r >> 32n & 0xffn), e[t + 5] = Number(r >> 40n & 0xffn), e[t + 6] = Number(r >> 48n & 0xffn), e[t + 7] = Number(r >> 56n & 0xffn)) : (e[t] = Number(r >> 56n & 0xffn), e[t + 1] = Number(r >> 48n & 0xffn), e[t + 2] = Number(r >> 40n & 0xffn), e[t + 3] = Number(r >> 32n & 0xffn), e[t + 4] = Number(r >> 24n & 0xffn), e[t + 5] = Number(r >> 16n & 0xffn), e[t + 6] = Number(r >> 8n & 0xffn), e[t + 7] = Number(r & 0xffn)), t + 8;
}
function lf(e, t) {
  if (t + 1 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  return e[t];
}
function _we(e, t, r) {
  if (t + 2 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r = r.toUpperCase(), r === "LE") {
    let n = 0;
    return n = (n << 8) + e[t + 1], n = (n << 8) + e[t], n;
  } else {
    let n = 0;
    return n = (n << 8) + e[t], n = (n << 8) + e[t + 1], n;
  }
}
function Bg(e, t, r) {
  if (t + 4 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r = r.toUpperCase(), r === "LE") {
    let n = 0;
    return n = (n << 8) + e[t + 3] >>> 0, n = (n << 8) + e[t + 2] >>> 0, n = (n << 8) + e[t + 1] >>> 0, n = (n << 8) + e[t] >>> 0, n;
  } else {
    let n = 0;
    return n = (n << 8) + e[t] >>> 0, n = (n << 8) + e[t + 1] >>> 0, n = (n << 8) + e[t + 2] >>> 0, n = (n << 8) + e[t + 3] >>> 0, n;
  }
}
function Rq(e, t, r, n) {
  if (t + 4 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r > 2147483647 || r < -2147483648)
    throw new Error(`The value of "value" is out of range. It must be >= -2147483648 and <= 2147483647. Received ${r}`);
  return n = n.toUpperCase(), n === "LE" ? (e[t] = r & 255, e[t + 1] = r >> 8 & 255, e[t + 2] = r >> 16 & 255, e[t + 3] = r >> 24 & 255) : (e[t] = r >> 24 & 255, e[t + 1] = r >> 16 & 255, e[t + 2] = r >> 8 & 255, e[t + 3] = r & 255), t + 4;
}
function zq(e, t, r, n) {
  if (t + 8 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r > 0x7fffffffffffffffn || r < -0x8000000000000000n)
    throw new Error(`The value of "value" is out of range. It must be >= ${-0x8000000000000000n} and <= ${0x7fffffffffffffffn}. Received ${r}`);
  return n = n.toUpperCase(), n === "LE" ? (e[t] = Number(r & 0xffn), e[t + 1] = Number(r >> 8n & 0xffn), e[t + 2] = Number(r >> 16n & 0xffn), e[t + 3] = Number(r >> 24n & 0xffn), e[t + 4] = Number(r >> 32n & 0xffn), e[t + 5] = Number(r >> 40n & 0xffn), e[t + 6] = Number(r >> 48n & 0xffn), e[t + 7] = Number(r >> 56n & 0xffn)) : (e[t] = Number(r >> 56n & 0xffn), e[t + 1] = Number(r >> 48n & 0xffn), e[t + 2] = Number(r >> 40n & 0xffn), e[t + 3] = Number(r >> 32n & 0xffn), e[t + 4] = Number(r >> 24n & 0xffn), e[t + 5] = Number(r >> 16n & 0xffn), e[t + 6] = Number(r >> 8n & 0xffn), e[t + 7] = Number(r & 0xffn)), t + 8;
}
function Awe(e, t, r) {
  if (t + 4 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r = r.toUpperCase(), r === "LE") {
    const n = e[t] + (e[t + 1] << 8) + (e[t + 2] << 16) + (e[t + 3] << 24 >>> 0);
    return e[t + 3] <= 127 ? n : n - 4294967296;
  } else {
    const n = (e[t] << 24 >>> 0) + (e[t + 1] << 16) + (e[t + 2] << 8) + e[t + 3];
    return e[t] <= 127 ? n : n - 4294967296;
  }
}
function jq(e, t, r) {
  if (t + 8 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  r = r.toUpperCase();
  let n = 0n;
  if (r === "LE")
    return n = (n << 8n) + BigInt(e[t + 7]), n = (n << 8n) + BigInt(e[t + 6]), n = (n << 8n) + BigInt(e[t + 5]), n = (n << 8n) + BigInt(e[t + 4]), n = (n << 8n) + BigInt(e[t + 3]), n = (n << 8n) + BigInt(e[t + 2]), n = (n << 8n) + BigInt(e[t + 1]), n = (n << 8n) + BigInt(e[t]), e[t + 7] <= 127 ? n : n - 0x10000000000000000n;
  {
    let o = 0n;
    return o = (o << 8n) + BigInt(e[t]), o = (o << 8n) + BigInt(e[t + 1]), o = (o << 8n) + BigInt(e[t + 2]), o = (o << 8n) + BigInt(e[t + 3]), o = (o << 8n) + BigInt(e[t + 4]), o = (o << 8n) + BigInt(e[t + 5]), o = (o << 8n) + BigInt(e[t + 6]), o = (o << 8n) + BigInt(e[t + 7]), e[t] <= 127 ? o : o - 0x10000000000000000n;
  }
}
function Lq(e) {
  return e < an.OP_PUSHDATA1 ? 1 : e <= 255 ? 2 : e <= 65535 ? 3 : 5;
}
function xwe(e, t, r) {
  const n = Lq(t);
  return n === 1 ? ns(e, r, t) : n === 2 ? (ns(e, r, an.OP_PUSHDATA1), ns(e, r + 1, t)) : n === 3 ? (ns(e, r, an.OP_PUSHDATA2), vwe(e, r + 1, t, "LE")) : (ns(e, r, an.OP_PUSHDATA4), G2(e, r + 1, t, "LE")), n;
}
function kwe(e, t) {
  const r = lf(e, t);
  let n, o;
  if (r < an.OP_PUSHDATA1)
    n = r, o = 1;
  else if (r === an.OP_PUSHDATA1) {
    if (t + 2 > e.length) return null;
    n = lf(e, t + 1), o = 2;
  } else if (r === an.OP_PUSHDATA2) {
    if (t + 3 > e.length) return null;
    n = _we(e, t + 1, "LE"), o = 3;
  } else {
    if (t + 5 > e.length) return null;
    if (r !== an.OP_PUSHDATA4) throw new Error("Unexpected opcode");
    n = Bg(e, t + 1, "LE"), o = 5;
  }
  return {
    opcode: r,
    number: n,
    size: o
  };
}
function Swe(e) {
  return e > 2147483647 ? 5 : e > 8388607 ? 4 : e > 32767 ? 3 : e > 127 ? 2 : e > 0 ? 1 : 0;
}
function Twe(e) {
  let t = Math.abs(e);
  const r = Swe(t), n = new Uint8Array(r), o = e < 0;
  for (let i = 0; i < r; ++i)
    ns(n, i, t & 255), t >>= 8;
  return n[r - 1] & 128 ? ns(n, r - 1, o ? 128 : 0) : o && (n[r - 1] |= 128), n;
}
function Iwe(e) {
  return {
    lang: (e == null ? void 0 : e.lang) ?? void 0,
    message: e == null ? void 0 : e.message,
    abortEarly: (e == null ? void 0 : e.abortEarly) ?? void 0,
    abortPipeEarly: (e == null ? void 0 : e.abortPipeEarly) ?? void 0
  };
}
function Owe(e, t) {
  var r;
  return (r = void 0) == null ? void 0 : r.get(t);
}
function Hw(e) {
  var t, r;
  const n = typeof e;
  return n === "string" ? `"${e}"` : n === "number" || n === "bigint" || n === "boolean" ? `${e}` : n === "object" || n === "function" ? (e && ((r = (t = Object.getPrototypeOf(e)) == null ? void 0 : t.constructor) == null ? void 0 : r.name)) ?? "null" : n;
}
function Mi(e, t, r, n, o) {
  const i = o && "input" in o ? o.input : r.value, a = (o == null ? void 0 : o.expected) ?? e.expects ?? null, u = (o == null ? void 0 : o.received) ?? Hw(i), l = {
    kind: e.kind,
    type: e.type,
    input: i,
    expected: a,
    received: u,
    message: `Invalid ${t}: ${a ? `Expected ${a} but r` : "R"}eceived ${u}`,
    // @ts-expect-error
    requirement: e.requirement,
    path: o == null ? void 0 : o.path,
    issues: o == null ? void 0 : o.issues,
    lang: n.lang,
    abortEarly: n.abortEarly,
    abortPipeEarly: n.abortPipeEarly
  }, d = e.kind === "schema", f = (o == null ? void 0 : o.message) ?? // @ts-expect-error
  e.message ?? Owe(e.reference, l.lang) ?? (d ? (l.lang, void 0) : null) ?? n.message ?? (l.lang, void 0);
  f && (l.message = typeof f == "function" ? f(l) : f), d && (r.typed = !1), r.issues ? r.issues.push(l) : r.issues = [l];
}
function Pwe(e, t) {
  const r = [...new Set(e)];
  return r.length > 1 ? `(${r.join(` ${t} `)})` : r[0] ?? "never";
}
var Cwe = class extends Error {
  /**
   * Creates a Valibot error with useful information.
   *
   * @param issues The error issues.
   */
  constructor(e) {
    super(e[0].message), ut(this, "issues"), this.name = "ValiError", this.issues = e;
  }
};
function Hq(e, t) {
  return {
    kind: "validation",
    type: "every_item",
    reference: Hq,
    async: !1,
    expects: null,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && !r.value.every(this.requirement) && Mi(this, "item", r, n), r;
    }
  };
}
function yB(e) {
  return {
    kind: "validation",
    type: "integer",
    reference: yB,
    async: !1,
    expects: null,
    requirement: Number.isInteger,
    message: e,
    _run(t, r) {
      return t.typed && !this.requirement(t.value) && Mi(this, "integer", t, r), t;
    }
  };
}
function Fq(e, t) {
  return {
    kind: "validation",
    type: "length",
    reference: Fq,
    async: !1,
    expects: `${e}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && r.value.length !== this.requirement && Mi(this, "length", r, n, {
        received: `${r.value.length}`
      }), r;
    }
  };
}
function V4(e, t) {
  return {
    kind: "validation",
    type: "max_value",
    reference: V4,
    async: !1,
    expects: `<=${e instanceof Date ? e.toJSON() : Hw(e)}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && r.value > this.requirement && Mi(this, "value", r, n, {
        received: r.value instanceof Date ? r.value.toJSON() : Hw(r.value)
      }), r;
    }
  };
}
function G4(e, t) {
  return {
    kind: "validation",
    type: "min_value",
    reference: G4,
    async: !1,
    expects: `>=${e instanceof Date ? e.toJSON() : Hw(e)}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && r.value < this.requirement && Mi(this, "value", r, n, {
        received: r.value instanceof Date ? r.value.toJSON() : Hw(r.value)
      }), r;
    }
  };
}
function Mq(e, t) {
  return {
    kind: "validation",
    type: "regex",
    reference: Mq,
    async: !1,
    expects: `${e}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && !this.requirement.test(r.value) && Mi(this, "format", r, n), r;
    }
  };
}
function bB(e, t, r) {
  return typeof e.default == "function" ? (
    // @ts-expect-error
    e.default(t, r)
  ) : (
    // @ts-expect-error
    e.default
  );
}
function W4(e, t) {
  return !e._run({ typed: !1, value: t }, { abortEarly: !0 }).issues;
}
function Dq() {
  return {
    kind: "schema",
    type: "any",
    reference: Dq,
    expects: "any",
    async: !1,
    _run(e) {
      return e.typed = !0, e;
    }
  };
}
function Ca(e, t) {
  return {
    kind: "schema",
    type: "array",
    reference: Ca,
    expects: "Array",
    async: !1,
    item: e,
    message: t,
    _run(r, n) {
      var o;
      const i = r.value;
      if (Array.isArray(i)) {
        r.typed = !0, r.value = [];
        for (let a = 0; a < i.length; a++) {
          const u = i[a], l = this.item._run({ typed: !1, value: u }, n);
          if (l.issues) {
            const d = {
              type: "array",
              origin: "value",
              input: i,
              key: a,
              value: u
            };
            for (const f of l.issues)
              f.path ? f.path.unshift(d) : f.path = [d], (o = r.issues) == null || o.push(f);
            if (r.issues || (r.issues = l.issues), n.abortEarly) {
              r.typed = !1;
              break;
            }
          }
          l.typed || (r.typed = !1), r.value.push(l.value);
        }
      } else
        Mi(this, "type", r, n);
      return r;
    }
  };
}
function Kq(e) {
  return {
    kind: "schema",
    type: "bigint",
    reference: Kq,
    expects: "bigint",
    async: !1,
    message: e,
    _run(t, r) {
      return typeof t.value == "bigint" ? t.typed = !0 : Mi(this, "type", t, r), t;
    }
  };
}
function Mu(e, t) {
  return {
    kind: "schema",
    type: "custom",
    reference: Mu,
    expects: "unknown",
    async: !1,
    check: e,
    message: t,
    _run(r, n) {
      return this.check(r.value) ? r.typed = !0 : Mi(this, "type", r, n), r;
    }
  };
}
function Z4(e, t) {
  return {
    kind: "schema",
    type: "instance",
    reference: Z4,
    expects: e.name,
    async: !1,
    class: e,
    message: t,
    _run(r, n) {
      return r.value instanceof this.class ? r.typed = !0 : Mi(this, "type", r, n), r;
    }
  };
}
function kO(e, ...t) {
  const r = {
    kind: "schema",
    type: "nullable",
    reference: kO,
    expects: `(${e.expects} | null)`,
    async: !1,
    wrapped: e,
    _run(n, o) {
      return n.value === null && ("default" in this && (n.value = bB(
        this,
        n,
        o
      )), n.value === null) ? (n.typed = !0, n) : this.wrapped._run(n, o);
    }
  };
  return 0 in t && (r.default = t[0]), r;
}
function qq(e, ...t) {
  const r = {
    kind: "schema",
    type: "nullish",
    reference: qq,
    expects: `(${e.expects} | null | undefined)`,
    async: !1,
    wrapped: e,
    _run(n, o) {
      return (n.value === null || n.value === void 0) && ("default" in this && (n.value = bB(
        this,
        n,
        o
      )), n.value === null || n.value === void 0) ? (n.typed = !0, n) : this.wrapped._run(n, o);
    }
  };
  return 0 in t && (r.default = t[0]), r;
}
function Sa(e) {
  return {
    kind: "schema",
    type: "number",
    reference: Sa,
    expects: "number",
    async: !1,
    message: e,
    _run(t, r) {
      return typeof t.value == "number" && !isNaN(t.value) ? t.typed = !0 : Mi(this, "type", t, r), t;
    }
  };
}
function To(e, t) {
  return {
    kind: "schema",
    type: "object",
    reference: To,
    expects: "Object",
    async: !1,
    entries: e,
    message: t,
    _run(r, n) {
      var o;
      const i = r.value;
      if (i && typeof i == "object") {
        r.typed = !0, r.value = {};
        for (const a in this.entries) {
          const u = i[a], l = this.entries[a]._run(
            { typed: !1, value: u },
            n
          );
          if (l.issues) {
            const d = {
              type: "object",
              origin: "value",
              input: i,
              key: a,
              value: u
            };
            for (const f of l.issues)
              f.path ? f.path.unshift(d) : f.path = [d], (o = r.issues) == null || o.push(f);
            if (r.issues || (r.issues = l.issues), n.abortEarly) {
              r.typed = !1;
              break;
            }
          }
          l.typed || (r.typed = !1), (l.value !== void 0 || a in i) && (r.value[a] = l.value);
        }
      } else
        Mi(this, "type", r, n);
      return r;
    }
  };
}
function G3(e, ...t) {
  const r = {
    kind: "schema",
    type: "optional",
    reference: G3,
    expects: `(${e.expects} | undefined)`,
    async: !1,
    wrapped: e,
    _run(n, o) {
      return n.value === void 0 && ("default" in this && (n.value = bB(
        this,
        n,
        o
      )), n.value === void 0) ? (n.typed = !0, n) : this.wrapped._run(n, o);
    }
  };
  return 0 in t && (r.default = t[0]), r;
}
function P0(e) {
  return {
    kind: "schema",
    type: "string",
    reference: P0,
    expects: "string",
    async: !1,
    message: e,
    _run(t, r) {
      return typeof t.value == "string" ? t.typed = !0 : Mi(this, "type", t, r), t;
    }
  };
}
function wc(e, t) {
  return {
    kind: "schema",
    type: "tuple",
    reference: wc,
    expects: "Array",
    async: !1,
    items: e,
    message: t,
    _run(r, n) {
      var o;
      const i = r.value;
      if (Array.isArray(i)) {
        r.typed = !0, r.value = [];
        for (let a = 0; a < this.items.length; a++) {
          const u = i[a], l = this.items[a]._run(
            { typed: !1, value: u },
            n
          );
          if (l.issues) {
            const d = {
              type: "array",
              origin: "value",
              input: i,
              key: a,
              value: u
            };
            for (const f of l.issues)
              f.path ? f.path.unshift(d) : f.path = [d], (o = r.issues) == null || o.push(f);
            if (r.issues || (r.issues = l.issues), n.abortEarly) {
              r.typed = !1;
              break;
            }
          }
          l.typed || (r.typed = !1), r.value.push(l.value);
        }
      } else
        Mi(this, "type", r, n);
      return r;
    }
  };
}
function SR(e) {
  let t;
  if (e)
    for (const r of e)
      t ? t.push(...r.issues) : t = r.issues;
  return t;
}
function wB(e, t) {
  return {
    kind: "schema",
    type: "union",
    reference: wB,
    expects: Pwe(
      e.map((r) => r.expects),
      "|"
    ),
    async: !1,
    options: e,
    message: t,
    _run(r, n) {
      let o, i, a;
      for (const u of this.options) {
        const l = u._run(
          { typed: !1, value: r.value },
          n
        );
        if (l.typed)
          if (l.issues)
            i ? i.push(l) : i = [l];
          else {
            o = l;
            break;
          }
        else
          a ? a.push(l) : a = [l];
      }
      if (o)
        return o;
      if (i) {
        if (i.length === 1)
          return i[0];
        Mi(this, "type", r, n, {
          issues: SR(i)
        }), r.typed = !0;
      } else {
        if ((a == null ? void 0 : a.length) === 1)
          return a[0];
        Mi(this, "type", r, n, {
          issues: SR(a)
        });
      }
      return r;
    }
  };
}
function eo(e, t, r) {
  const n = e._run(
    { typed: !1, value: t },
    Iwe(r)
  );
  if (n.issues)
    throw new Cwe(n.issues);
  return n.value;
}
function Md(e, t) {
  const r = {};
  for (const n in e.entries)
    r[n] = G3(e.entries[n]);
  return { ...e, entries: r };
}
function Ng(...e) {
  return {
    ...e[0],
    pipe: e,
    _run(t, r) {
      for (const n of e)
        if (n.kind !== "metadata") {
          if (t.issues && (n.kind === "schema" || n.kind === "transformation")) {
            t.typed = !1;
            break;
          }
          (!t.issues || !r.abortEarly && !r.abortPipeEarly) && (t = n._run(t, r));
        }
      return t;
    }
  };
}
const TR = new Uint8Array(32), IR = vf(
  "fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"
), qo = (e) => Ng(Z4(Uint8Array), Fq(e));
function Fw(e, t) {
  return e.length !== t.length ? !1 : e.every((r, n) => dt(r, t[n]) === 0);
}
function $u(e) {
  if (!(e instanceof Uint8Array) || e.length < 33) return !1;
  const t = e[0], r = e.slice(1, 33);
  if (dt(TR, r) === 0 || dt(r, IR) >= 0) return !1;
  if ((t === 2 || t === 3) && e.length === 33)
    return !0;
  const n = e.slice(33);
  return dt(TR, n) === 0 || dt(n, IR) >= 0 ? !1 : t === 4 && e.length === 65;
}
const D8 = 254;
function vB(e) {
  return !e || !("output" in e) || !(e.output instanceof Uint8Array) ? !1 : e.version !== void 0 ? (e.version & D8) === e.version : !0;
}
function Vq(e) {
  return Array.isArray(e) ? e.length !== 2 ? !1 : e.every((t) => Vq(t)) : vB(e);
}
const Bwe = qo(32), Nwe = qo(20), OR = qo(32), nn = Z4(Uint8Array);
Ng(P0(), Mq(/^([0-9a-f]{2})+$/i));
const $we = Ng(
  Sa(),
  yB(),
  G4(0),
  V4(255)
), Kl = Ng(
  Sa(),
  yB(),
  G4(0),
  V4(4294967295)
), pT = Ng(
  Kq(),
  G4(0n),
  V4(0x7fffffffffffffffn)
), PR = (e) => To(
  Object.entries(e).reduce(
    (t, r) => ({ ...t, [r[0]]: qq(r[1]) }),
    {}
  )
), CR = new Uint8Array(1);
function BR(e) {
  let t = 0;
  for (; e[t] === 0; ) ++t;
  return t === e.length ? CR : (e = e.slice(t), e[0] & 128 ? so([CR, e]) : e);
}
function NR(e) {
  e[0] === 0 && (e = e.slice(1));
  const t = new Uint8Array(32), r = Math.max(0, 32 - e.length);
  return t.set(e, r), t;
}
function Uwe(e) {
  const t = lf(e, e.length - 1);
  if (!_B(t))
    throw new Error("Invalid hashType " + t);
  const r = hwe(e.subarray(0, -1)), n = NR(r.r), o = NR(r.s);
  return { signature: so([n, o]), hashType: t };
}
function Rwe(e, t) {
  if (eo(
    To({
      signature: qo(64),
      hashType: $we
    }),
    { signature: e, hashType: t }
  ), !_B(t))
    throw new Error("Invalid hashType " + t);
  const r = new Uint8Array(1);
  ns(r, 0, t);
  const n = BR(e.slice(0, 32)), o = BR(e.slice(32, 64));
  return so([pwe(n, o), r]);
}
const zwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: Uwe,
  encode: Rwe
}, Symbol.toStringTag, { value: "Module" })), Gq = an.OP_RESERVED, Wq = Ca(wB([Z4(Uint8Array), Sa()]));
function jwe(e) {
  return W4(Sa(), e) && (e === an.OP_0 || e >= an.OP_1 && e <= an.OP_16 || e === an.OP_1NEGATE);
}
function Zq(e) {
  return W4(nn, e) || jwe(e);
}
function EB(e) {
  return W4(Ng(Dq(), Hq(Zq)), e);
}
function Xq(e) {
  return e.length - e.filter(Zq).length;
}
function W3(e) {
  if (e.length === 0) return an.OP_0;
  if (e.length === 1) {
    if (e[0] >= 1 && e[0] <= 16) return Gq + e[0];
    if (e[0] === 129) return an.OP_1NEGATE;
  }
}
function Yq(e) {
  return e instanceof Uint8Array;
}
function Lwe(e) {
  return W4(Wq, e);
}
function Z3(e) {
  return e instanceof Uint8Array;
}
function Ba(e) {
  if (Yq(e)) return e;
  eo(Wq, e);
  const t = e.reduce((o, i) => Z3(i) ? i.length === 1 && W3(i) !== void 0 ? o + 1 : o + Lq(i.length) + i.length : o + 1, 0), r = new Uint8Array(t);
  let n = 0;
  if (e.forEach((o) => {
    if (Z3(o)) {
      const i = W3(o);
      if (i !== void 0) {
        ns(r, n, i), n += 1;
        return;
      }
      n += xwe(r, o.length, n), r.set(o, n), n += o.length;
    } else
      ns(r, n, o), n += 1;
  }), n !== r.length) throw new Error("Could not decode chunks");
  return r;
}
function ro(e) {
  if (Lwe(e)) return e;
  eo(nn, e);
  const t = [];
  let r = 0;
  for (; r < e.length; ) {
    const n = e[r];
    if (n > an.OP_0 && n <= an.OP_PUSHDATA4) {
      const o = kwe(e, r);
      if (o === null || (r += o.size, r + o.number > e.length)) return null;
      const i = e.slice(r, r + o.number);
      r += o.number;
      const a = W3(i);
      a !== void 0 ? t.push(a) : t.push(i);
    } else
      t.push(n), r += 1;
  }
  return t;
}
function Hwe(e) {
  if (Yq(e) && (e = ro(e)), !e)
    throw new Error("Could not convert invalid chunks to ASM");
  return e.map((t) => {
    if (Z3(t)) {
      const r = W3(t);
      if (r === void 0) return Wt(t);
      t = r;
    }
    return Bq[t];
  }).join(" ");
}
function Fwe(e) {
  return e = ro(e), eo(Mu(EB), e), e.map((t) => Z3(t) ? t : t === an.OP_0 ? new Uint8Array(0) : Twe(t - Gq));
}
function Mwe(e) {
  return $u(e);
}
function _B(e) {
  const t = e & -129;
  return t > 0 && t < 4;
}
function ff(e) {
  return !(e instanceof Uint8Array) || !_B(e[e.length - 1]) ? !1 : dwe(e.slice(0, -1));
}
const ow = zwe;
function Dt(e, t, r) {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !0,
    get() {
      const n = r.call(this);
      return this[t] = n, n;
    },
    set(n) {
      Object.defineProperty(this, t, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      });
    }
  });
}
function Hs(e) {
  let t;
  return () => (t !== void 0 || (t = e()), t);
}
const Q0 = an, r8 = Q0.OP_RESERVED;
function X4(e, t) {
  if (!e.input && !e.output && !(e.pubkeys && e.m !== void 0) && !e.signatures)
    throw new TypeError("Not enough data");
  t = Object.assign({ validate: !0 }, t || {});
  function r(u) {
    return ff(u) || (t.allowIncomplete && u === Q0.OP_0) !== void 0;
  }
  eo(
    Md(
      To({
        network: To({}),
        m: Sa(),
        n: Sa(),
        output: nn,
        pubkeys: Ca(Mu($u), "Received invalid pubkey"),
        signatures: Ca(
          Mu(r),
          "Expected signature to be of type isAcceptableSignature"
        ),
        input: nn
      })
    ),
    e
  );
  const n = { network: e.network || Xu };
  let o = [], i = !1;
  function a(u) {
    i || (i = !0, o = ro(u), n.m = o[0] - r8, n.n = o[o.length - 2] - r8, n.pubkeys = o.slice(1, -2));
  }
  if (Dt(n, "output", () => {
    if (e.m && n.n && e.pubkeys)
      return Ba(
        [].concat(
          r8 + e.m,
          e.pubkeys,
          r8 + n.n,
          Q0.OP_CHECKMULTISIG
        )
      );
  }), Dt(n, "m", () => {
    if (n.output)
      return a(n.output), n.m;
  }), Dt(n, "n", () => {
    if (n.pubkeys)
      return n.pubkeys.length;
  }), Dt(n, "pubkeys", () => {
    if (e.output)
      return a(e.output), n.pubkeys;
  }), Dt(n, "signatures", () => {
    if (e.input)
      return ro(e.input).slice(1);
  }), Dt(n, "input", () => {
    if (e.signatures)
      return Ba([Q0.OP_0].concat(e.signatures));
  }), Dt(n, "witness", () => {
    if (n.input)
      return [];
  }), Dt(n, "name", () => {
    if (!(!n.m || !n.n))
      return `p2ms(${n.m} of ${n.n})`;
  }), t.validate) {
    if (e.output) {
      if (a(e.output), eo(Sa(), o[0], { message: "Output is invalid" }), eo(Sa(), o[o.length - 2], {
        message: "Output is invalid"
      }), o[o.length - 1] !== Q0.OP_CHECKMULTISIG)
        throw new TypeError("Output is invalid");
      if (n.m <= 0 || n.n > 16 || n.m > n.n || n.n !== o.length - 3)
        throw new TypeError("Output is invalid");
      if (!n.pubkeys.every((u) => $u(u)))
        throw new TypeError("Output is invalid");
      if (e.m !== void 0 && e.m !== n.m) throw new TypeError("m mismatch");
      if (e.n !== void 0 && e.n !== n.n) throw new TypeError("n mismatch");
      if (e.pubkeys && !Fw(e.pubkeys, n.pubkeys))
        throw new TypeError("Pubkeys mismatch");
    }
    if (e.pubkeys) {
      if (e.n !== void 0 && e.n !== e.pubkeys.length)
        throw new TypeError("Pubkey count mismatch");
      if (n.n = e.pubkeys.length, n.n < n.m) throw new TypeError("Pubkey count cannot be less than m");
    }
    if (e.signatures) {
      if (e.signatures.length < n.m)
        throw new TypeError("Not enough signatures provided");
      if (e.signatures.length > n.m)
        throw new TypeError("Too many signatures provided");
    }
    if (e.input) {
      if (e.input[0] !== Q0.OP_0) throw new TypeError("Input is invalid");
      if (n.signatures.length === 0 || !n.signatures.every(r))
        throw new TypeError("Input has invalid signature(s)");
      if (e.signatures && !Fw(e.signatures, n.signatures))
        throw new TypeError("Signature mismatch");
      if (e.m !== void 0 && e.m !== e.signatures.length)
        throw new TypeError("Signature count mismatch");
    }
  }
  return Object.assign(n, e);
}
const $R = an;
function Jq(e, t) {
  if (!e.input && !e.output && !e.pubkey && !e.input && !e.signature)
    throw new TypeError("Not enough data");
  t = Object.assign({ validate: !0 }, t || {}), eo(
    Md(
      To({
        network: To({}),
        output: nn,
        pubkey: Mu($u, "invalid pubkey"),
        signature: Mu(
          ff,
          "Expected signature to be of type isCanonicalScriptSignature"
        ),
        input: nn
      })
    ),
    e
  );
  const r = Hs(() => ro(e.input)), n = { name: "p2pk", network: e.network || Xu };
  if (Dt(n, "output", () => {
    if (e.pubkey)
      return Ba([e.pubkey, $R.OP_CHECKSIG]);
  }), Dt(n, "pubkey", () => {
    if (e.output)
      return e.output.slice(1, -1);
  }), Dt(n, "signature", () => {
    if (e.input)
      return r()[0];
  }), Dt(n, "input", () => {
    if (e.signature)
      return Ba([e.signature]);
  }), Dt(n, "witness", () => {
    if (n.input)
      return [];
  }), t.validate) {
    if (e.output) {
      if (e.output[e.output.length - 1] !== $R.OP_CHECKSIG)
        throw new TypeError("Output is invalid");
      if (!$u(n.pubkey)) throw new TypeError("Output pubkey is invalid");
      if (e.pubkey && dt(e.pubkey, n.pubkey) !== 0)
        throw new TypeError("Pubkey mismatch");
    }
    if (e.signature && e.input && dt(e.input, n.input) !== 0)
      throw new TypeError("Signature mismatch");
    if (e.input) {
      if (r().length !== 1) throw new TypeError("Input is invalid");
      if (!ff(n.signature))
        throw new TypeError("Input has invalid signature");
    }
  }
  return Object.assign(n, e);
}
function UR(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error("positive integer expected, got " + e);
}
function Dwe(e) {
  return e instanceof Uint8Array || ArrayBuffer.isView(e) && e.constructor.name === "Uint8Array";
}
function AB(e, ...t) {
  if (!Dwe(e))
    throw new Error("Uint8Array expected");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error("Uint8Array expected of length " + t + ", got length=" + e.length);
}
function Kwe(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  UR(e.outputLen), UR(e.blockLen);
}
function X3(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function qwe(e, t) {
  AB(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error("digestInto() expects output buffer of length at least " + r);
}
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function gT(e) {
  return new DataView(e.buffer, e.byteOffset, e.byteLength);
}
function uc(e, t) {
  return e << 32 - t | e >>> t;
}
function n8(e, t) {
  return e << t | e >>> 32 - t >>> 0;
}
function Vwe(e) {
  if (typeof e != "string")
    throw new Error("utf8ToBytes expected string, got " + typeof e);
  return new Uint8Array(new TextEncoder().encode(e));
}
function xB(e) {
  return typeof e == "string" && (e = Vwe(e)), AB(e), e;
}
let Qq = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function kB(e) {
  const t = (n) => e().update(xB(n)).digest(), r = e();
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = () => e(), t;
}
function Gwe(e, t, r, n) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, r, n);
  const o = BigInt(32), i = BigInt(4294967295), a = Number(r >> o & i), u = Number(r & i), l = n ? 4 : 0, d = n ? 0 : 4;
  e.setUint32(t + l, a, n), e.setUint32(t + d, u, n);
}
function Wwe(e, t, r) {
  return e & t ^ ~e & r;
}
function Zwe(e, t, r) {
  return e & t ^ e & r ^ t & r;
}
let SB = class extends Qq {
  constructor(e, t, r, n) {
    super(), this.blockLen = e, this.outputLen = t, this.padOffset = r, this.isLE = n, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = gT(this.buffer);
  }
  update(e) {
    X3(this);
    const { view: t, buffer: r, blockLen: n } = this;
    e = xB(e);
    const o = e.length;
    for (let i = 0; i < o; ) {
      const a = Math.min(n - this.pos, o - i);
      if (a === n) {
        const u = gT(e);
        for (; n <= o - i; i += n)
          this.process(u, i);
        continue;
      }
      r.set(e.subarray(i, i + a), this.pos), this.pos += a, i += a, this.pos === n && (this.process(t, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    X3(this), qwe(e, this), this.finished = !0;
    const { buffer: t, view: r, blockLen: n, isLE: o } = this;
    let { pos: i } = this;
    t[i++] = 128, this.buffer.subarray(i).fill(0), this.padOffset > n - i && (this.process(r, 0), i = 0);
    for (let f = i; f < n; f++)
      t[f] = 0;
    Gwe(r, n - 8, BigInt(this.length * 8), o), this.process(r, 0);
    const a = gT(e), u = this.outputLen;
    if (u % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const l = u / 4, d = this.get();
    if (l > d.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let f = 0; f < l; f++)
      a.setUint32(4 * f, d[f], o);
  }
  digest() {
    const { buffer: e, outputLen: t } = this;
    this.digestInto(e);
    const r = e.slice(0, t);
    return this.destroy(), r;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: t, buffer: r, length: n, finished: o, destroyed: i, pos: a } = this;
    return e.length = n, e.pos = a, e.finished = o, e.destroyed = i, n % t && e.buffer.set(r), e;
  }
};
const Xwe = /* @__PURE__ */ new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]), eV = /* @__PURE__ */ new Uint8Array(new Array(16).fill(0).map((e, t) => t)), Ywe = /* @__PURE__ */ eV.map((e) => (9 * e + 5) % 16);
let TB = [eV], IB = [Ywe];
for (let e = 0; e < 4; e++)
  for (let t of [TB, IB])
    t.push(t[e].map((r) => Xwe[r]));
const tV = /* @__PURE__ */ [
  [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
  [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
  [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
  [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
  [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
].map((e) => new Uint8Array(e)), Jwe = /* @__PURE__ */ TB.map((e, t) => e.map((r) => tV[t][r])), Qwe = /* @__PURE__ */ IB.map((e, t) => e.map((r) => tV[t][r])), e2e = /* @__PURE__ */ new Uint32Array([
  0,
  1518500249,
  1859775393,
  2400959708,
  2840853838
]), t2e = /* @__PURE__ */ new Uint32Array([
  1352829926,
  1548603684,
  1836072691,
  2053994217,
  0
]);
function RR(e, t, r, n) {
  return e === 0 ? t ^ r ^ n : e === 1 ? t & r | ~t & n : e === 2 ? (t | ~r) ^ n : e === 3 ? t & n | r & ~n : t ^ (r | ~n);
}
const o8 = /* @__PURE__ */ new Uint32Array(16);
let r2e = class extends SB {
  constructor() {
    super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
  }
  get() {
    const { h0: e, h1: t, h2: r, h3: n, h4: o } = this;
    return [e, t, r, n, o];
  }
  set(e, t, r, n, o) {
    this.h0 = e | 0, this.h1 = t | 0, this.h2 = r | 0, this.h3 = n | 0, this.h4 = o | 0;
  }
  process(e, t) {
    for (let g = 0; g < 16; g++, t += 4)
      o8[g] = e.getUint32(t, !0);
    let r = this.h0 | 0, n = r, o = this.h1 | 0, i = o, a = this.h2 | 0, u = a, l = this.h3 | 0, d = l, f = this.h4 | 0, h = f;
    for (let g = 0; g < 5; g++) {
      const b = 4 - g, w = e2e[g], E = t2e[g], _ = TB[g], O = IB[g], C = Jwe[g], I = Qwe[g];
      for (let S = 0; S < 16; S++) {
        const T = n8(r + RR(g, o, a, l) + o8[_[S]] + w, C[S]) + f | 0;
        r = f, f = l, l = n8(a, 10) | 0, a = o, o = T;
      }
      for (let S = 0; S < 16; S++) {
        const T = n8(n + RR(b, i, u, d) + o8[O[S]] + E, I[S]) + h | 0;
        n = h, h = d, d = n8(u, 10) | 0, u = i, i = T;
      }
    }
    this.set(this.h1 + a + d | 0, this.h2 + l + h | 0, this.h3 + f + n | 0, this.h4 + r + i | 0, this.h0 + o + u | 0);
  }
  roundClean() {
    o8.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
  }
};
const rV = /* @__PURE__ */ kB(() => new r2e()), n2e = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), Wf = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), Zf = /* @__PURE__ */ new Uint32Array(64);
let o2e = class extends SB {
  constructor() {
    super(64, 32, 8, !1), this.A = Wf[0] | 0, this.B = Wf[1] | 0, this.C = Wf[2] | 0, this.D = Wf[3] | 0, this.E = Wf[4] | 0, this.F = Wf[5] | 0, this.G = Wf[6] | 0, this.H = Wf[7] | 0;
  }
  get() {
    const { A: e, B: t, C: r, D: n, E: o, F: i, G: a, H: u } = this;
    return [e, t, r, n, o, i, a, u];
  }
  // prettier-ignore
  set(e, t, r, n, o, i, a, u) {
    this.A = e | 0, this.B = t | 0, this.C = r | 0, this.D = n | 0, this.E = o | 0, this.F = i | 0, this.G = a | 0, this.H = u | 0;
  }
  process(e, t) {
    for (let f = 0; f < 16; f++, t += 4)
      Zf[f] = e.getUint32(t, !1);
    for (let f = 16; f < 64; f++) {
      const h = Zf[f - 15], g = Zf[f - 2], b = uc(h, 7) ^ uc(h, 18) ^ h >>> 3, w = uc(g, 17) ^ uc(g, 19) ^ g >>> 10;
      Zf[f] = w + Zf[f - 7] + b + Zf[f - 16] | 0;
    }
    let { A: r, B: n, C: o, D: i, E: a, F: u, G: l, H: d } = this;
    for (let f = 0; f < 64; f++) {
      const h = uc(a, 6) ^ uc(a, 11) ^ uc(a, 25), g = d + h + Wwe(a, u, l) + n2e[f] + Zf[f] | 0, b = (uc(r, 2) ^ uc(r, 13) ^ uc(r, 22)) + Zwe(r, n, o) | 0;
      d = l, l = u, u = a, a = i + g | 0, i = o, o = n, n = r, r = g + b | 0;
    }
    r = r + this.A | 0, n = n + this.B | 0, o = o + this.C | 0, i = i + this.D | 0, a = a + this.E | 0, u = u + this.F | 0, l = l + this.G | 0, d = d + this.H | 0, this.set(r, n, o, i, a, u, l, d);
  }
  roundClean() {
    Zf.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
};
const Si = /* @__PURE__ */ kB(() => new o2e());
function tf(e) {
  return rV(Si(e));
}
function wp(e) {
  return Si(Si(e));
}
const i2e = {
  "BIP0340/challenge": Uint8Array.from([
    123,
    181,
    45,
    122,
    159,
    239,
    88,
    50,
    62,
    177,
    191,
    122,
    64,
    125,
    179,
    130,
    210,
    243,
    242,
    216,
    27,
    177,
    34,
    79,
    73,
    254,
    81,
    143,
    109,
    72,
    211,
    124,
    123,
    181,
    45,
    122,
    159,
    239,
    88,
    50,
    62,
    177,
    191,
    122,
    64,
    125,
    179,
    130,
    210,
    243,
    242,
    216,
    27,
    177,
    34,
    79,
    73,
    254,
    81,
    143,
    109,
    72,
    211,
    124
  ]),
  "BIP0340/aux": Uint8Array.from([
    241,
    239,
    78,
    94,
    192,
    99,
    202,
    218,
    109,
    148,
    202,
    250,
    157,
    152,
    126,
    160,
    105,
    38,
    88,
    57,
    236,
    193,
    31,
    151,
    45,
    119,
    165,
    46,
    216,
    193,
    204,
    144,
    241,
    239,
    78,
    94,
    192,
    99,
    202,
    218,
    109,
    148,
    202,
    250,
    157,
    152,
    126,
    160,
    105,
    38,
    88,
    57,
    236,
    193,
    31,
    151,
    45,
    119,
    165,
    46,
    216,
    193,
    204,
    144
  ]),
  "BIP0340/nonce": Uint8Array.from([
    7,
    73,
    119,
    52,
    167,
    155,
    203,
    53,
    91,
    155,
    140,
    125,
    3,
    79,
    18,
    28,
    244,
    52,
    215,
    62,
    247,
    45,
    218,
    25,
    135,
    0,
    97,
    251,
    82,
    191,
    235,
    47,
    7,
    73,
    119,
    52,
    167,
    155,
    203,
    53,
    91,
    155,
    140,
    125,
    3,
    79,
    18,
    28,
    244,
    52,
    215,
    62,
    247,
    45,
    218,
    25,
    135,
    0,
    97,
    251,
    82,
    191,
    235,
    47
  ]),
  TapLeaf: Uint8Array.from([
    174,
    234,
    143,
    220,
    66,
    8,
    152,
    49,
    5,
    115,
    75,
    88,
    8,
    29,
    30,
    38,
    56,
    211,
    95,
    28,
    181,
    64,
    8,
    212,
    211,
    87,
    202,
    3,
    190,
    120,
    233,
    238,
    174,
    234,
    143,
    220,
    66,
    8,
    152,
    49,
    5,
    115,
    75,
    88,
    8,
    29,
    30,
    38,
    56,
    211,
    95,
    28,
    181,
    64,
    8,
    212,
    211,
    87,
    202,
    3,
    190,
    120,
    233,
    238
  ]),
  TapBranch: Uint8Array.from([
    25,
    65,
    161,
    242,
    229,
    110,
    185,
    95,
    162,
    169,
    241,
    148,
    190,
    92,
    1,
    247,
    33,
    111,
    51,
    237,
    130,
    176,
    145,
    70,
    52,
    144,
    208,
    91,
    245,
    22,
    160,
    21,
    25,
    65,
    161,
    242,
    229,
    110,
    185,
    95,
    162,
    169,
    241,
    148,
    190,
    92,
    1,
    247,
    33,
    111,
    51,
    237,
    130,
    176,
    145,
    70,
    52,
    144,
    208,
    91,
    245,
    22,
    160,
    21
  ]),
  TapSighash: Uint8Array.from([
    244,
    10,
    72,
    223,
    75,
    42,
    112,
    200,
    180,
    146,
    75,
    242,
    101,
    70,
    97,
    237,
    61,
    149,
    253,
    102,
    163,
    19,
    235,
    135,
    35,
    117,
    151,
    198,
    40,
    228,
    160,
    49,
    244,
    10,
    72,
    223,
    75,
    42,
    112,
    200,
    180,
    146,
    75,
    242,
    101,
    70,
    97,
    237,
    61,
    149,
    253,
    102,
    163,
    19,
    235,
    135,
    35,
    117,
    151,
    198,
    40,
    228,
    160,
    49
  ]),
  TapTweak: Uint8Array.from([
    232,
    15,
    225,
    99,
    156,
    156,
    160,
    80,
    227,
    175,
    27,
    57,
    193,
    67,
    198,
    62,
    66,
    156,
    188,
    235,
    21,
    217,
    64,
    251,
    181,
    197,
    161,
    244,
    175,
    87,
    197,
    233,
    232,
    15,
    225,
    99,
    156,
    156,
    160,
    80,
    227,
    175,
    27,
    57,
    193,
    67,
    198,
    62,
    66,
    156,
    188,
    235,
    21,
    217,
    64,
    251,
    181,
    197,
    161,
    244,
    175,
    87,
    197,
    233
  ]),
  "KeyAgg list": Uint8Array.from([
    72,
    28,
    151,
    28,
    60,
    11,
    70,
    215,
    240,
    178,
    117,
    174,
    89,
    141,
    78,
    44,
    126,
    215,
    49,
    156,
    89,
    74,
    92,
    110,
    199,
    158,
    160,
    212,
    153,
    2,
    148,
    240,
    72,
    28,
    151,
    28,
    60,
    11,
    70,
    215,
    240,
    178,
    117,
    174,
    89,
    141,
    78,
    44,
    126,
    215,
    49,
    156,
    89,
    74,
    92,
    110,
    199,
    158,
    160,
    212,
    153,
    2,
    148,
    240
  ]),
  "KeyAgg coefficient": Uint8Array.from([
    191,
    201,
    4,
    3,
    77,
    28,
    136,
    232,
    200,
    14,
    34,
    229,
    61,
    36,
    86,
    109,
    100,
    130,
    78,
    214,
    66,
    114,
    129,
    192,
    145,
    0,
    249,
    77,
    205,
    82,
    201,
    129,
    191,
    201,
    4,
    3,
    77,
    28,
    136,
    232,
    200,
    14,
    34,
    229,
    61,
    36,
    86,
    109,
    100,
    130,
    78,
    214,
    66,
    114,
    129,
    192,
    145,
    0,
    249,
    77,
    205,
    82,
    201,
    129
  ])
};
function Y4(e, t) {
  return Si(so([i2e[e], t]));
}
function a2e(e) {
  if (e.length >= 255)
    throw new TypeError("Alphabet too long");
  const t = new Uint8Array(256);
  for (let d = 0; d < t.length; d++)
    t[d] = 255;
  for (let d = 0; d < e.length; d++) {
    const f = e.charAt(d), h = f.charCodeAt(0);
    if (t[h] !== 255)
      throw new TypeError(f + " is ambiguous");
    t[h] = d;
  }
  const r = e.length, n = e.charAt(0), o = Math.log(r) / Math.log(256), i = Math.log(256) / Math.log(r);
  function a(d) {
    if (d instanceof Uint8Array || (ArrayBuffer.isView(d) ? d = new Uint8Array(d.buffer, d.byteOffset, d.byteLength) : Array.isArray(d) && (d = Uint8Array.from(d))), !(d instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (d.length === 0)
      return "";
    let f = 0, h = 0, g = 0;
    const b = d.length;
    for (; g !== b && d[g] === 0; )
      g++, f++;
    const w = (b - g) * i + 1 >>> 0, E = new Uint8Array(w);
    for (; g !== b; ) {
      let C = d[g], I = 0;
      for (let S = w - 1; (C !== 0 || I < h) && S !== -1; S--, I++)
        C += 256 * E[S] >>> 0, E[S] = C % r >>> 0, C = C / r >>> 0;
      if (C !== 0)
        throw new Error("Non-zero carry");
      h = I, g++;
    }
    let _ = w - h;
    for (; _ !== w && E[_] === 0; )
      _++;
    let O = n.repeat(f);
    for (; _ < w; ++_)
      O += e.charAt(E[_]);
    return O;
  }
  function u(d) {
    if (typeof d != "string")
      throw new TypeError("Expected String");
    if (d.length === 0)
      return new Uint8Array();
    let f = 0, h = 0, g = 0;
    for (; d[f] === n; )
      h++, f++;
    const b = (d.length - f) * o + 1 >>> 0, w = new Uint8Array(b);
    for (; f < d.length; ) {
      const C = d.charCodeAt(f);
      if (C > 255)
        return;
      let I = t[C];
      if (I === 255)
        return;
      let S = 0;
      for (let T = b - 1; (I !== 0 || S < g) && T !== -1; T--, S++)
        I += r * w[T] >>> 0, w[T] = I % 256 >>> 0, I = I / 256 >>> 0;
      if (I !== 0)
        throw new Error("Non-zero carry");
      g = S, f++;
    }
    let E = b - g;
    for (; E !== b && w[E] === 0; )
      E++;
    const _ = new Uint8Array(h + (b - E));
    let O = h;
    for (; E !== b; )
      _[O++] = w[E++];
    return _;
  }
  function l(d) {
    const f = u(d);
    if (f)
      return f;
    throw new Error("Non-base" + r + " character");
  }
  return {
    encode: a,
    decodeUnsafe: u,
    decode: l
  };
}
var s2e = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
const mT = a2e(s2e);
function u2e(e) {
  function t(i) {
    var a = Uint8Array.from(i), u = e(a), l = a.length + 4, d = new Uint8Array(l);
    return d.set(a, 0), d.set(u.subarray(0, 4), a.length), mT.encode(d);
  }
  function r(i) {
    var a = i.slice(0, -4), u = i.slice(-4), l = e(a);
    if (!(u[0] ^ l[0] | u[1] ^ l[1] | u[2] ^ l[2] | u[3] ^ l[3]))
      return a;
  }
  function n(i) {
    var a = mT.decodeUnsafe(i);
    if (a != null)
      return r(a);
  }
  function o(i) {
    var a = mT.decode(i), u = r(a);
    if (u == null)
      throw new Error("Invalid checksum");
    return u;
  }
  return {
    encode: t,
    decode: o,
    decodeUnsafe: n
  };
}
function c2e(e) {
  return Si(Si(e));
}
const J1 = u2e(c2e), Xf = an;
function W2(e, t) {
  if (!e.address && !e.hash && !e.output && !e.pubkey && !e.input)
    throw new TypeError("Not enough data");
  t = Object.assign({ validate: !0 }, t || {}), eo(
    Md(
      To({
        network: To({}),
        address: P0(),
        hash: Nwe,
        output: qo(25),
        pubkey: Mu($u),
        signature: Mu(ff),
        input: nn
      })
    ),
    e
  );
  const r = Hs(() => {
    const a = J1.decode(e.address), u = lf(a, 0), l = a.slice(1);
    return { version: u, hash: l };
  }), n = Hs(() => ro(e.input)), o = e.network || Xu, i = { name: "p2pkh", network: o };
  if (Dt(i, "address", () => {
    if (!i.hash) return;
    const a = new Uint8Array(21);
    return ns(a, 0, o.pubKeyHash), a.set(i.hash, 1), J1.encode(a);
  }), Dt(i, "hash", () => {
    if (e.output) return e.output.slice(3, 23);
    if (e.address) return r().hash;
    if (e.pubkey || i.pubkey) return tf(e.pubkey || i.pubkey);
  }), Dt(i, "output", () => {
    if (i.hash)
      return Ba([
        Xf.OP_DUP,
        Xf.OP_HASH160,
        i.hash,
        Xf.OP_EQUALVERIFY,
        Xf.OP_CHECKSIG
      ]);
  }), Dt(i, "pubkey", () => {
    if (e.input)
      return n()[1];
  }), Dt(i, "signature", () => {
    if (e.input)
      return n()[0];
  }), Dt(i, "input", () => {
    if (e.pubkey && e.signature)
      return Ba([e.signature, e.pubkey]);
  }), Dt(i, "witness", () => {
    if (i.input)
      return [];
  }), t.validate) {
    let a = Uint8Array.from([]);
    if (e.address) {
      if (r().version !== o.pubKeyHash)
        throw new TypeError("Invalid version or Network mismatch");
      if (r().hash.length !== 20) throw new TypeError("Invalid address");
      a = r().hash;
    }
    if (e.hash) {
      if (a.length > 0 && dt(a, e.hash) !== 0)
        throw new TypeError("Hash mismatch");
      a = e.hash;
    }
    if (e.output) {
      if (e.output.length !== 25 || e.output[0] !== Xf.OP_DUP || e.output[1] !== Xf.OP_HASH160 || e.output[2] !== 20 || e.output[23] !== Xf.OP_EQUALVERIFY || e.output[24] !== Xf.OP_CHECKSIG)
        throw new TypeError("Output is invalid");
      const u = e.output.slice(3, 23);
      if (a.length > 0 && dt(a, u) !== 0)
        throw new TypeError("Hash mismatch");
      a = u;
    }
    if (e.pubkey) {
      const u = tf(e.pubkey);
      if (a.length > 0 && dt(a, u) !== 0)
        throw new TypeError("Hash mismatch");
      a = u;
    }
    if (e.input) {
      const u = n();
      if (u.length !== 2) throw new TypeError("Input is invalid");
      if (!ff(u[0]))
        throw new TypeError("Input has invalid signature");
      if (!$u(u[1])) throw new TypeError("Input has invalid pubkey");
      if (e.signature && dt(e.signature, u[0]) !== 0)
        throw new TypeError("Signature mismatch");
      if (e.pubkey && dt(e.pubkey, u[1]) !== 0)
        throw new TypeError("Pubkey mismatch");
      const l = tf(u[1]);
      if (a.length > 0 && dt(a, l) !== 0)
        throw new TypeError("Hash mismatch");
    }
  }
  return Object.assign(i, e);
}
const Nb = an;
function $g(e, t) {
  if (!e.address && !e.hash && !e.output && !e.redeem && !e.input)
    throw new TypeError("Not enough data");
  t = Object.assign({ validate: !0 }, t || {}), eo(
    Md(
      To({
        network: To({}),
        address: P0(),
        hash: qo(20),
        output: qo(23),
        redeem: Md(
          To({
            network: To({}),
            output: nn,
            input: nn,
            witness: Ca(nn)
          })
        ),
        input: nn,
        witness: Ca(nn)
      })
    ),
    e
  );
  let r = e.network;
  r || (r = e.redeem && e.redeem.network || Xu);
  const n = { network: r }, o = Hs(() => {
    const u = J1.decode(e.address), l = lf(u, 0), d = u.slice(1);
    return { version: l, hash: d };
  }), i = Hs(() => ro(e.input)), a = Hs(() => {
    const u = i(), l = u[u.length - 1];
    return {
      network: r,
      output: l === Nb.OP_FALSE ? Uint8Array.from([]) : l,
      input: Ba(u.slice(0, -1)),
      witness: e.witness || []
    };
  });
  if (Dt(n, "address", () => {
    if (!n.hash) return;
    const u = new Uint8Array(21);
    return ns(u, 0, n.network.scriptHash), u.set(n.hash, 1), J1.encode(u);
  }), Dt(n, "hash", () => {
    if (e.output) return e.output.slice(2, 22);
    if (e.address) return o().hash;
    if (n.redeem && n.redeem.output) return tf(n.redeem.output);
  }), Dt(n, "output", () => {
    if (n.hash)
      return Ba([Nb.OP_HASH160, n.hash, Nb.OP_EQUAL]);
  }), Dt(n, "redeem", () => {
    if (e.input)
      return a();
  }), Dt(n, "input", () => {
    if (!(!e.redeem || !e.redeem.input || !e.redeem.output))
      return Ba(
        [].concat(ro(e.redeem.input), e.redeem.output)
      );
  }), Dt(n, "witness", () => {
    if (n.redeem && n.redeem.witness) return n.redeem.witness;
    if (n.input) return [];
  }), Dt(n, "name", () => {
    const u = ["p2sh"];
    return n.redeem !== void 0 && n.redeem.name !== void 0 && u.push(n.redeem.name), u.join("-");
  }), t.validate) {
    let u = Uint8Array.from([]);
    if (e.address) {
      if (o().version !== r.scriptHash)
        throw new TypeError("Invalid version or Network mismatch");
      if (o().hash.length !== 20) throw new TypeError("Invalid address");
      u = o().hash;
    }
    if (e.hash) {
      if (u.length > 0 && dt(u, e.hash) !== 0)
        throw new TypeError("Hash mismatch");
      u = e.hash;
    }
    if (e.output) {
      if (e.output.length !== 23 || e.output[0] !== Nb.OP_HASH160 || e.output[1] !== 20 || e.output[22] !== Nb.OP_EQUAL)
        throw new TypeError("Output is invalid");
      const d = e.output.slice(2, 22);
      if (u.length > 0 && dt(u, d) !== 0)
        throw new TypeError("Hash mismatch");
      u = d;
    }
    const l = (d) => {
      if (d.output) {
        const f = ro(d.output);
        if (!f || f.length < 1)
          throw new TypeError("Redeem.output too short");
        if (d.output.byteLength > 520)
          throw new TypeError(
            "Redeem.output unspendable if larger than 520 bytes"
          );
        if (Xq(f) > 201)
          throw new TypeError(
            "Redeem.output unspendable with more than 201 non-push ops"
          );
        const h = tf(d.output);
        if (u.length > 0 && dt(u, h) !== 0)
          throw new TypeError("Hash mismatch");
        u = h;
      }
      if (d.input) {
        const f = d.input.length > 0, h = d.witness && d.witness.length > 0;
        if (!f && !h) throw new TypeError("Empty input");
        if (f && h)
          throw new TypeError("Input and witness provided");
        if (f) {
          const g = ro(d.input);
          if (!EB(g))
            throw new TypeError("Non push-only scriptSig");
        }
      }
    };
    if (e.input) {
      const d = i();
      if (!d || d.length < 1) throw new TypeError("Input too short");
      if (!(a().output instanceof Uint8Array))
        throw new TypeError("Input is invalid");
      l(a());
    }
    if (e.redeem) {
      if (e.redeem.network && e.redeem.network !== r)
        throw new TypeError("Network mismatch");
      if (e.input) {
        const d = a();
        if (e.redeem.output && dt(e.redeem.output, d.output) !== 0)
          throw new TypeError("Redeem.output mismatch");
        if (e.redeem.input && dt(e.redeem.input, d.input) !== 0)
          throw new TypeError("Redeem.input mismatch");
      }
      l(e.redeem);
    }
    if (e.witness && e.redeem && e.redeem.witness && !Fw(e.redeem.witness, e.witness))
      throw new TypeError("Witness and redeem.witness mismatch");
  }
  return Object.assign(n, e);
}
var zt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function nV(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function l2e(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Mw = {};
Object.defineProperty(Mw, "__esModule", { value: !0 });
var Dw = Mw.bech32m = ss = Mw.bech32 = void 0;
const Y3 = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", oV = {};
for (let e = 0; e < Y3.length; e++) {
  const t = Y3.charAt(e);
  oV[t] = e;
}
function T1(e) {
  const t = e >> 25;
  return (e & 33554431) << 5 ^ -(t >> 0 & 1) & 996825010 ^ -(t >> 1 & 1) & 642813549 ^ -(t >> 2 & 1) & 513874426 ^ -(t >> 3 & 1) & 1027748829 ^ -(t >> 4 & 1) & 705979059;
}
function zR(e) {
  let t = 1;
  for (let r = 0; r < e.length; ++r) {
    const n = e.charCodeAt(r);
    if (n < 33 || n > 126)
      return "Invalid prefix (" + e + ")";
    t = T1(t) ^ n >> 5;
  }
  t = T1(t);
  for (let r = 0; r < e.length; ++r) {
    const n = e.charCodeAt(r);
    t = T1(t) ^ n & 31;
  }
  return t;
}
function OB(e, t, r, n) {
  let o = 0, i = 0;
  const a = (1 << r) - 1, u = [];
  for (let l = 0; l < e.length; ++l)
    for (o = o << t | e[l], i += t; i >= r; )
      i -= r, u.push(o >> i & a);
  if (n)
    i > 0 && u.push(o << r - i & a);
  else {
    if (i >= t)
      return "Excess padding";
    if (o << r - i & a)
      return "Non-zero padding";
  }
  return u;
}
function f2e(e) {
  return OB(e, 8, 5, !0);
}
function d2e(e) {
  const t = OB(e, 5, 8, !1);
  if (Array.isArray(t))
    return t;
}
function h2e(e) {
  const t = OB(e, 5, 8, !1);
  if (Array.isArray(t))
    return t;
  throw new Error(t);
}
function iV(e) {
  let t;
  e === "bech32" ? t = 1 : t = 734539939;
  function r(a, u, l) {
    if (l = l || 90, a.length + 7 + u.length > l)
      throw new TypeError("Exceeds length limit");
    a = a.toLowerCase();
    let d = zR(a);
    if (typeof d == "string")
      throw new Error(d);
    let f = a + "1";
    for (let h = 0; h < u.length; ++h) {
      const g = u[h];
      if (g >> 5)
        throw new Error("Non 5-bit word");
      d = T1(d) ^ g, f += Y3.charAt(g);
    }
    for (let h = 0; h < 6; ++h)
      d = T1(d);
    d ^= t;
    for (let h = 0; h < 6; ++h) {
      const g = d >> (5 - h) * 5 & 31;
      f += Y3.charAt(g);
    }
    return f;
  }
  function n(a, u) {
    if (u = u || 90, a.length < 8)
      return a + " too short";
    if (a.length > u)
      return "Exceeds length limit";
    const l = a.toLowerCase(), d = a.toUpperCase();
    if (a !== l && a !== d)
      return "Mixed-case string " + a;
    a = l;
    const f = a.lastIndexOf("1");
    if (f === -1)
      return "No separator character for " + a;
    if (f === 0)
      return "Missing prefix for " + a;
    const h = a.slice(0, f), g = a.slice(f + 1);
    if (g.length < 6)
      return "Data too short";
    let b = zR(h);
    if (typeof b == "string")
      return b;
    const w = [];
    for (let E = 0; E < g.length; ++E) {
      const _ = g.charAt(E), O = oV[_];
      if (O === void 0)
        return "Unknown character " + _;
      b = T1(b) ^ O, !(E + 6 >= g.length) && w.push(O);
    }
    return b !== t ? "Invalid checksum for " + a : { prefix: h, words: w };
  }
  function o(a, u) {
    const l = n(a, u);
    if (typeof l == "object")
      return l;
  }
  function i(a, u) {
    const l = n(a, u);
    if (typeof l == "object")
      return l;
    throw new Error(l);
  }
  return {
    decodeUnsafe: o,
    decode: i,
    encode: r,
    toWords: f2e,
    fromWordsUnsafe: d2e,
    fromWords: h2e
  };
}
var ss = Mw.bech32 = iV("bech32");
Dw = Mw.bech32m = iV("bech32m");
const jR = an, p2e = new Uint8Array(0);
function Z2(e, t) {
  if (!e.address && !e.hash && !e.output && !e.pubkey && !e.witness)
    throw new TypeError("Not enough data");
  t = Object.assign({ validate: !0 }, t || {}), eo(
    Md(
      To({
        address: P0(),
        hash: qo(20),
        input: qo(0),
        network: To({}),
        output: qo(22),
        pubkey: Mu($u, "Not a valid pubkey"),
        signature: Mu(ff),
        witness: Ca(nn)
      })
    ),
    e
  );
  const r = Hs(() => {
    const i = ss.decode(e.address), a = i.words.shift(), u = ss.fromWords(i.words);
    return {
      version: a,
      prefix: i.prefix,
      data: Uint8Array.from(u)
    };
  }), n = e.network || Xu, o = { name: "p2wpkh", network: n };
  if (Dt(o, "address", () => {
    if (!o.hash) return;
    const i = ss.toWords(o.hash);
    return i.unshift(0), ss.encode(n.bech32, i);
  }), Dt(o, "hash", () => {
    if (e.output) return e.output.slice(2, 22);
    if (e.address) return r().data;
    if (e.pubkey || o.pubkey) return tf(e.pubkey || o.pubkey);
  }), Dt(o, "output", () => {
    if (o.hash)
      return Ba([jR.OP_0, o.hash]);
  }), Dt(o, "pubkey", () => {
    if (e.pubkey) return e.pubkey;
    if (e.witness)
      return e.witness[1];
  }), Dt(o, "signature", () => {
    if (e.witness)
      return e.witness[0];
  }), Dt(o, "input", () => {
    if (o.witness)
      return p2e;
  }), Dt(o, "witness", () => {
    if (e.pubkey && e.signature)
      return [e.signature, e.pubkey];
  }), t.validate) {
    let i = Uint8Array.from([]);
    if (e.address) {
      if (n && n.bech32 !== r().prefix)
        throw new TypeError("Invalid prefix or Network mismatch");
      if (r().version !== 0)
        throw new TypeError("Invalid address version");
      if (r().data.length !== 20)
        throw new TypeError("Invalid address data");
      i = r().data;
    }
    if (e.hash) {
      if (i.length > 0 && dt(i, e.hash) !== 0)
        throw new TypeError("Hash mismatch");
      i = e.hash;
    }
    if (e.output) {
      if (e.output.length !== 22 || e.output[0] !== jR.OP_0 || e.output[1] !== 20)
        throw new TypeError("Output is invalid");
      if (i.length > 0 && dt(i, e.output.slice(2)) !== 0)
        throw new TypeError("Hash mismatch");
      i = e.output.slice(2);
    }
    if (e.pubkey) {
      const a = tf(e.pubkey);
      if (i.length > 0 && dt(i, a) !== 0)
        throw new TypeError("Hash mismatch");
      if (i = a, !$u(e.pubkey) || e.pubkey.length !== 33)
        throw new TypeError("Invalid pubkey for p2wpkh");
    }
    if (e.witness) {
      if (e.witness.length !== 2) throw new TypeError("Witness is invalid");
      if (!ff(e.witness[0]))
        throw new TypeError("Witness has invalid signature");
      if (!$u(e.witness[1]) || e.witness[1].length !== 33)
        throw new TypeError("Witness has invalid pubkey");
      if (e.signature && dt(e.signature, e.witness[0]) !== 0)
        throw new TypeError("Signature mismatch");
      if (e.pubkey && dt(e.pubkey, e.witness[1]) !== 0)
        throw new TypeError("Pubkey mismatch");
      const a = tf(e.witness[1]);
      if (i.length > 0 && dt(i, a) !== 0)
        throw new TypeError("Hash mismatch");
    }
  }
  return Object.assign(o, e);
}
const LR = an, yT = new Uint8Array(0);
function i8(e) {
  return !!(e instanceof Uint8Array && e.length === 65 && e[0] === 4 && $u(e));
}
function X2(e, t) {
  if (!e.address && !e.hash && !e.output && !e.redeem && !e.witness)
    throw new TypeError("Not enough data");
  t = Object.assign({ validate: !0 }, t || {}), eo(
    PR({
      network: To({}),
      address: P0(),
      hash: Bwe,
      output: qo(34),
      redeem: PR({
        input: nn,
        network: To({}),
        output: nn,
        witness: Ca(nn)
      }),
      input: qo(0),
      witness: Ca(nn)
    }),
    e
  );
  const r = Hs(() => {
    const a = ss.decode(e.address), u = a.words.shift(), l = ss.fromWords(a.words);
    return {
      version: u,
      prefix: a.prefix,
      data: Uint8Array.from(l)
    };
  }), n = Hs(() => ro(e.redeem.input));
  let o = e.network;
  o || (o = e.redeem && e.redeem.network || Xu);
  const i = { network: o };
  if (Dt(i, "address", () => {
    if (!i.hash) return;
    const a = ss.toWords(i.hash);
    return a.unshift(0), ss.encode(o.bech32, a);
  }), Dt(i, "hash", () => {
    if (e.output) return e.output.slice(2);
    if (e.address) return r().data;
    if (i.redeem && i.redeem.output) return Si(i.redeem.output);
  }), Dt(i, "output", () => {
    if (i.hash)
      return Ba([LR.OP_0, i.hash]);
  }), Dt(i, "redeem", () => {
    if (e.witness)
      return {
        output: e.witness[e.witness.length - 1],
        input: yT,
        witness: e.witness.slice(0, -1)
      };
  }), Dt(i, "input", () => {
    if (i.witness)
      return yT;
  }), Dt(i, "witness", () => {
    if (e.redeem && e.redeem.input && e.redeem.input.length > 0 && e.redeem.output && e.redeem.output.length > 0) {
      const a = Fwe(n());
      return i.redeem = Object.assign({ witness: a }, e.redeem), i.redeem.input = yT, [].concat(a, e.redeem.output);
    }
    if (e.redeem && e.redeem.output && e.redeem.witness)
      return [].concat(e.redeem.witness, e.redeem.output);
  }), Dt(i, "name", () => {
    const a = ["p2wsh"];
    return i.redeem !== void 0 && i.redeem.name !== void 0 && a.push(i.redeem.name), a.join("-");
  }), t.validate) {
    let a = Uint8Array.from([]);
    if (e.address) {
      if (r().prefix !== o.bech32)
        throw new TypeError("Invalid prefix or Network mismatch");
      if (r().version !== 0)
        throw new TypeError("Invalid address version");
      if (r().data.length !== 32)
        throw new TypeError("Invalid address data");
      a = r().data;
    }
    if (e.hash) {
      if (a.length > 0 && dt(a, e.hash) !== 0)
        throw new TypeError("Hash mismatch");
      a = e.hash;
    }
    if (e.output) {
      if (e.output.length !== 34 || e.output[0] !== LR.OP_0 || e.output[1] !== 32)
        throw new TypeError("Output is invalid");
      const u = e.output.slice(2);
      if (a.length > 0 && dt(a, u) !== 0)
        throw new TypeError("Hash mismatch");
      a = u;
    }
    if (e.redeem) {
      if (e.redeem.network && e.redeem.network !== o)
        throw new TypeError("Network mismatch");
      if (e.redeem.input && e.redeem.input.length > 0 && e.redeem.witness && e.redeem.witness.length > 0)
        throw new TypeError("Ambiguous witness source");
      if (e.redeem.output) {
        const u = ro(e.redeem.output);
        if (!u || u.length < 1)
          throw new TypeError("Redeem.output is invalid");
        if (e.redeem.output.byteLength > 3600)
          throw new TypeError(
            "Redeem.output unspendable if larger than 3600 bytes"
          );
        if (Xq(u) > 201)
          throw new TypeError(
            "Redeem.output unspendable with more than 201 non-push ops"
          );
        const l = Si(e.redeem.output);
        if (a.length > 0 && dt(a, l) !== 0)
          throw new TypeError("Hash mismatch");
        a = l;
      }
      if (e.redeem.input && !EB(n()))
        throw new TypeError("Non push-only scriptSig");
      if (e.witness && e.redeem.witness && !Fw(e.witness, e.redeem.witness))
        throw new TypeError("Witness and redeem.witness mismatch");
      if (e.redeem.input && n().some(i8) || e.redeem.output && (ro(e.redeem.output) || []).some(
        i8
      ))
        throw new TypeError(
          "redeem.input or redeem.output contains uncompressed pubkey"
        );
    }
    if (e.witness && e.witness.length > 0) {
      const u = e.witness[e.witness.length - 1];
      if (e.redeem && e.redeem.output && dt(e.redeem.output, u) !== 0)
        throw new TypeError("Witness and redeem.output mismatch");
      if (e.witness.some(i8) || (ro(u) || []).some(i8))
        throw new TypeError("Witness contains uncompressed pubkey");
    }
  }
  return Object.assign(i, e);
}
const iw = {};
function PB(e) {
  e ? e !== iw.eccLib && (g2e(e), iw.eccLib = e) : iw.eccLib = e;
}
function SO() {
  if (!iw.eccLib)
    throw new Error(
      "No ECC Library provided. You must call initEccLib() with a valid TinySecp256k1Interface instance"
    );
  return iw.eccLib;
}
const Ul = (e) => vf(e);
function g2e(e) {
  ks(typeof e.isXOnlyPoint == "function"), ks(
    e.isXOnlyPoint(
      Ul("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")
    )
  ), ks(
    e.isXOnlyPoint(
      Ul("fffffffffffffffffffffffffffffffffffffffffffffffffffffffeeffffc2e")
    )
  ), ks(
    e.isXOnlyPoint(
      Ul("f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9")
    )
  ), ks(
    e.isXOnlyPoint(
      Ul("0000000000000000000000000000000000000000000000000000000000000001")
    )
  ), ks(
    !e.isXOnlyPoint(
      Ul("0000000000000000000000000000000000000000000000000000000000000000")
    )
  ), ks(
    !e.isXOnlyPoint(
      Ul("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f")
    )
  ), ks(typeof e.xOnlyPointAddTweak == "function"), m2e.forEach((t) => {
    const r = e.xOnlyPointAddTweak(Ul(t.pubkey), Ul(t.tweak));
    t.result === null ? ks(r === null) : (ks(r !== null), ks(r.parity === t.parity), ks(dt(r.xOnlyPubkey, Ul(t.result)) === 0));
  });
}
function ks(e) {
  if (!e) throw new Error("ecc library invalid");
}
const m2e = [
  {
    pubkey: "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
    tweak: "fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140",
    parity: -1,
    result: null
  },
  {
    pubkey: "1617d38ed8d8657da4d4761e8057bc396ea9e4b9d29776d4be096016dbd2509b",
    tweak: "a8397a935f0dfceba6ba9618f6451ef4d80637abf4e6af2669fbc9de6a8fd2ac",
    parity: 1,
    result: "e478f99dab91052ab39a33ea35fd5e6e4933f4d28023cd597c9a1f6760346adf"
  },
  {
    pubkey: "2c0b7cf95324a07d05398b240174dc0c2be444d96b159aa6c7f7b1e668680991",
    tweak: "823c3cd2142744b075a87eade7e1b8678ba308d566226a0056ca2b7a76f86b47",
    parity: 0,
    result: "9534f8dc8c6deda2dc007655981c78b49c5d96c778fbf363462a11ec9dfd948c"
  }
], aV = "0123456789abcdefABCDEF";
aV.split("").map((e) => e.codePointAt(0));
const HR = Array(256).fill(!0).map((e, t) => {
  const r = String.fromCodePoint(t), n = aV.indexOf(r);
  return n < 0 ? void 0 : n < 16 ? n : n - 6;
}), sV = new TextEncoder();
new TextDecoder();
function y2e(e) {
  return sV.encode(e);
}
function b2e(e) {
  const t = e.reduce((o, i) => o + i.length, 0), r = new Uint8Array(t);
  let n = 0;
  for (const o of e)
    r.set(o, n), n += o.length;
  return r;
}
function w2e(e) {
  const t = sV.encode(e || ""), r = new Uint8Array(Math.floor(t.length / 2));
  let n;
  for (n = 0; n < r.length; n++) {
    const o = HR[t[n * 2]], i = HR[t[n * 2 + 1]];
    if (o === void 0 || i === void 0)
      break;
    r[n] = o << 4 | i;
  }
  return n === r.length ? r : r.slice(0, n);
}
function Rl(e, t) {
  const r = Math.min(e.length, t.length);
  for (let n = 0; n < r; ++n)
    if (e[n] !== t[n])
      return e[n] < t[n] ? -1 : 1;
  return e.length === t.length ? 0 : e.length > t.length ? 1 : -1;
}
function FR(e, t, r) {
  if (t + 1 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r > 255)
    throw new Error(`The value of "value" is out of range. It must be >= 0 and <= 255. Received ${r}`);
  e[t] = r;
}
function v2e(e, t, r, n) {
  if (t + 2 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (n = n.toUpperCase(), r > 65535)
    throw new Error(`The value of "value" is out of range. It must be >= 0 and <= 65535. Received ${r}`);
  n === "LE" ? (e[t] = r & 255, e[t + 1] = r >> 8 & 255) : (e[t] = r >> 8 & 255, e[t + 1] = r & 255);
}
function Ap(e, t, r, n) {
  if (t + 4 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (n = n.toUpperCase(), r > 4294967295)
    throw new Error(`The value of "value" is out of range. It must be >= 0 and <= ${4294967295}. Received ${r}`);
  n === "LE" ? (e[t] = r & 255, e[t + 1] = r >> 8 & 255, e[t + 2] = r >> 16 & 255, e[t + 3] = r >> 24 & 255) : (e[t] = r >> 24 & 255, e[t + 1] = r >> 16 & 255, e[t + 2] = r >> 8 & 255, e[t + 3] = r & 255);
}
function E2e(e, t, r, n) {
  if (t + 8 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (n = n.toUpperCase(), r > 0xffffffffffffffffn)
    throw new Error(`The value of "value" is out of range. It must be >= 0 and <= ${0xffffffffffffffffn}. Received ${r}`);
  n === "LE" ? (e[t] = Number(r & 0xffn), e[t + 1] = Number(r >> 8n & 0xffn), e[t + 2] = Number(r >> 16n & 0xffn), e[t + 3] = Number(r >> 24n & 0xffn), e[t + 4] = Number(r >> 32n & 0xffn), e[t + 5] = Number(r >> 40n & 0xffn), e[t + 6] = Number(r >> 48n & 0xffn), e[t + 7] = Number(r >> 56n & 0xffn)) : (e[t] = Number(r >> 56n & 0xffn), e[t + 1] = Number(r >> 48n & 0xffn), e[t + 2] = Number(r >> 40n & 0xffn), e[t + 3] = Number(r >> 32n & 0xffn), e[t + 4] = Number(r >> 24n & 0xffn), e[t + 5] = Number(r >> 16n & 0xffn), e[t + 6] = Number(r >> 8n & 0xffn), e[t + 7] = Number(r & 0xffn));
}
function _2e(e, t, r) {
  if (t + 2 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r = r.toUpperCase(), r === "LE") {
    let n = 0;
    return n = (n << 8) + e[t + 1], n = (n << 8) + e[t], n;
  } else {
    let n = 0;
    return n = (n << 8) + e[t], n = (n << 8) + e[t + 1], n;
  }
}
function e1(e, t, r) {
  if (t + 4 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r = r.toUpperCase(), r === "LE") {
    let n = 0;
    return n = (n << 8) + e[t + 3] >>> 0, n = (n << 8) + e[t + 2] >>> 0, n = (n << 8) + e[t + 1] >>> 0, n = (n << 8) + e[t] >>> 0, n;
  } else {
    let n = 0;
    return n = (n << 8) + e[t] >>> 0, n = (n << 8) + e[t + 1] >>> 0, n = (n << 8) + e[t + 2] >>> 0, n = (n << 8) + e[t + 3] >>> 0, n;
  }
}
function A2e(e, t, r) {
  if (t + 8 > e.length)
    throw new Error("Offset is outside the bounds of Uint8Array");
  if (r = r.toUpperCase(), r === "LE") {
    let n = 0n;
    return n = (n << 8n) + BigInt(e[t + 7]), n = (n << 8n) + BigInt(e[t + 6]), n = (n << 8n) + BigInt(e[t + 5]), n = (n << 8n) + BigInt(e[t + 4]), n = (n << 8n) + BigInt(e[t + 3]), n = (n << 8n) + BigInt(e[t + 2]), n = (n << 8n) + BigInt(e[t + 1]), n = (n << 8n) + BigInt(e[t]), n;
  } else {
    let n = 0n;
    return n = (n << 8n) + BigInt(e[t]), n = (n << 8n) + BigInt(e[t + 1]), n = (n << 8n) + BigInt(e[t + 2]), n = (n << 8n) + BigInt(e[t + 3]), n = (n << 8n) + BigInt(e[t + 4]), n = (n << 8n) + BigInt(e[t + 5]), n = (n << 8n) + BigInt(e[t + 6]), n = (n << 8n) + BigInt(e[t + 7]), n;
  }
}
const x2e = (e) => {
  if (e < 0 || e > 0xffffffffffffffffn)
    throw new RangeError("value out of range");
};
function k2e(e) {
  if (e < 0 || e > Number.MAX_SAFE_INTEGER || e % 1 !== 0)
    throw new RangeError("value out of range");
}
function uV(e) {
  typeof e == "number" ? k2e(e) : x2e(e);
}
function Dd(e, t, r) {
  uV(e), r === void 0 && (r = 0), t === void 0 && (t = new Uint8Array(qs(e)));
  let n = 0;
  return e < 253 ? (t.set([Number(e)], r), n = 1) : e <= 65535 ? (t.set([253], r), v2e(t, r + 1, Number(e), "LE"), n = 3) : e <= 4294967295 ? (t.set([254], r), Ap(t, r + 1, Number(e), "LE"), n = 5) : (t.set([255], r), E2e(t, r + 1, BigInt(e), "LE"), n = 9), { buffer: t, bytes: n };
}
function Ug(e, t) {
  t === void 0 && (t = 0);
  const r = e.at(t);
  if (r === void 0)
    throw new Error("buffer too small");
  if (r < 253)
    return { numberValue: r, bigintValue: BigInt(r), bytes: 1 };
  if (r === 253) {
    const n = _2e(e, t + 1, "LE");
    return {
      numberValue: n,
      bigintValue: BigInt(n),
      bytes: 3
    };
  } else if (r === 254) {
    const n = e1(e, t + 1, "LE");
    return {
      numberValue: n,
      bigintValue: BigInt(n),
      bytes: 5
    };
  } else {
    const n = A2e(e, t + 1, "LE");
    return { numberValue: n <= Number.MAX_SAFE_INTEGER ? Number(n) : null, bigintValue: n, bytes: 9 };
  }
}
function qs(e) {
  return uV(e), e < 253 ? 1 : e <= 65535 ? 3 : e <= 4294967295 ? 5 : 9;
}
const S2e = 9007199254740991;
function T2e(e, t) {
  if (typeof e != "number" && typeof e != "bigint")
    throw new Error("cannot write a non-number as a number");
  if (e < 0 && e < BigInt(0))
    throw new Error("specified a negative value for writing an unsigned value");
  if (e > t && e > BigInt(t))
    throw new Error("RangeError: value out of range");
  if (Math.floor(Number(e)) !== Number(e))
    throw new Error("value has a fractional component");
}
function CB(e) {
  if (e.length < 1) return e;
  let t = e.length - 1, r = 0;
  for (let n = 0; n < e.length / 2; n++)
    r = e[n], e[n] = e[t], e[t] = r, t--;
  return e;
}
function MR(e) {
  const t = new Uint8Array(e.length);
  return t.set(e), t;
}
class Bi {
  constructor(t, r = 0) {
    ut(this, "buffer"), ut(this, "offset"), this.buffer = t, this.offset = r, eo(wc([nn, Kl]), [
      t,
      r
    ]);
  }
  static withCapacity(t) {
    return new Bi(new Uint8Array(t));
  }
  writeUInt8(t) {
    this.offset = ns(this.buffer, this.offset, t);
  }
  writeInt32(t) {
    this.offset = Rq(this.buffer, this.offset, t, "LE");
  }
  writeInt64(t) {
    this.offset = zq(this.buffer, this.offset, BigInt(t), "LE");
  }
  writeUInt32(t) {
    this.offset = G2(this.buffer, this.offset, t, "LE");
  }
  writeUInt64(t) {
    this.offset = Ewe(this.buffer, this.offset, BigInt(t), "LE");
  }
  writeVarInt(t) {
    const { bytes: r } = Dd(t, this.buffer, this.offset);
    this.offset += r;
  }
  writeSlice(t) {
    if (this.buffer.length < this.offset + t.length)
      throw new Error("Cannot write slice out of bounds");
    this.buffer.set(t, this.offset), this.offset += t.length;
  }
  writeVarSlice(t) {
    this.writeVarInt(t.length), this.writeSlice(t);
  }
  writeVector(t) {
    this.writeVarInt(t.length), t.forEach((r) => this.writeVarSlice(r));
  }
  end() {
    if (this.buffer.length === this.offset)
      return this.buffer;
    throw new Error(`buffer size ${this.buffer.length}, offset ${this.offset}`);
  }
}
class I2e {
  constructor(t, r = 0) {
    ut(this, "buffer"), ut(this, "offset"), this.buffer = t, this.offset = r, eo(wc([nn, Kl]), [
      t,
      r
    ]);
  }
  readUInt8() {
    const t = lf(this.buffer, this.offset);
    return this.offset++, t;
  }
  readInt32() {
    const t = Awe(this.buffer, this.offset, "LE");
    return this.offset += 4, t;
  }
  readUInt32() {
    const t = Bg(this.buffer, this.offset, "LE");
    return this.offset += 4, t;
  }
  readInt64() {
    const t = jq(this.buffer, this.offset, "LE");
    return this.offset += 8, t;
  }
  readVarInt() {
    const { bigintValue: t, bytes: r } = Ug(this.buffer, this.offset);
    return this.offset += r, t;
  }
  readSlice(t) {
    T2e(t, S2e);
    const r = Number(t);
    if (this.buffer.length < this.offset + r)
      throw new Error("Cannot read slice out of bounds");
    const n = this.buffer.slice(this.offset, this.offset + r);
    return this.offset += r, n;
  }
  readVarSlice() {
    return this.readSlice(this.readVarInt());
  }
  readVector() {
    const t = this.readVarInt(), r = [];
    for (let n = 0; n < t; n++) r.push(this.readVarSlice());
    return r;
  }
}
const cV = 192, O2e = 128, P2e = (e) => "left" in e && "right" in e;
function TO(e, t) {
  if (e.length < 33)
    throw new TypeError(
      `The control-block length is too small. Got ${e.length}, expected min 33.`
    );
  const r = (e.length - 33) / 32;
  let n = t;
  for (let o = 0; o < r; o++) {
    const i = e.slice(33 + 32 * o, 65 + 32 * o);
    dt(n, i) < 0 ? n = OO(n, i) : n = OO(i, n);
  }
  return n;
}
function IO(e) {
  if (vB(e)) return { hash: Jl(e) };
  const t = [IO(e[0]), IO(e[1])];
  t.sort((o, i) => dt(o.hash, i.hash));
  const [r, n] = t;
  return {
    hash: OO(r.hash, n.hash),
    left: r,
    right: n
  };
}
function J3(e, t) {
  if (P2e(e)) {
    const r = J3(e.left, t);
    if (r !== void 0) return [...r, e.right.hash];
    const n = J3(e.right, t);
    if (n !== void 0) return [...n, e.left.hash];
  } else if (dt(e.hash, t) === 0)
    return [];
}
function Jl(e) {
  const t = e.version || cV;
  return Y4(
    "TapLeaf",
    so([Uint8Array.from([t]), B2e(e.output)])
  );
}
function C2e(e, t) {
  return Y4(
    "TapTweak",
    so(t ? [e, t] : [e])
  );
}
function a8(e, t) {
  if (!(e instanceof Uint8Array) || e.length !== 32 || t && t.length !== 32) return null;
  const r = C2e(e, t), n = SO().xOnlyPointAddTweak(e, r);
  return !n || n.xOnlyPubkey === null ? null : {
    parity: n.parity,
    x: Uint8Array.from(n.xOnlyPubkey)
  };
}
function OO(e, t) {
  return Y4("TapBranch", so([e, t]));
}
function B2e(e) {
  const t = qs(e.length), r = new Uint8Array(t);
  return Dd(e.length, r), so([r, e]);
}
const DR = an, KR = 1, N2e = 80;
function Y2(e, t) {
  if (!e.address && !e.output && !e.pubkey && !e.internalPubkey && !(e.witness && e.witness.length > 1))
    throw new TypeError("Not enough data");
  t = Object.assign({ validate: !0 }, t || {}), eo(
    Md(
      To({
        address: P0(),
        input: qo(0),
        network: To({}),
        output: qo(34),
        internalPubkey: qo(32),
        hash: qo(32),
        // merkle root hash, the tweak
        pubkey: qo(32),
        // tweaked with `hash` from `internalPubkey`
        signature: wB([
          qo(64),
          qo(65)
        ]),
        witness: Ca(nn),
        scriptTree: Mu(Vq, "Taptree is not of type isTaptree"),
        redeem: Md(
          To({
            output: nn,
            // tapleaf script
            redeemVersion: Sa(),
            // tapleaf version
            witness: Ca(nn)
          })
        ),
        redeemVersion: Sa()
      })
    ),
    e
  );
  const r = Hs(() => BB(e.address)), n = Hs(() => {
    if (!(!e.witness || !e.witness.length))
      return e.witness.length >= 2 && e.witness[e.witness.length - 1][0] === N2e ? e.witness.slice(0, -1) : e.witness.slice();
  }), o = Hs(() => {
    if (e.scriptTree) return IO(e.scriptTree);
    if (e.hash) return { hash: e.hash };
  }), i = e.network || Xu, a = { name: "p2tr", network: i };
  if (Dt(a, "address", () => {
    if (!a.pubkey) return;
    const u = Dw.toWords(a.pubkey);
    return u.unshift(KR), Dw.encode(i.bech32, u);
  }), Dt(a, "hash", () => {
    const u = o();
    if (u) return u.hash;
    const l = n();
    if (l && l.length > 1) {
      const d = l[l.length - 1], f = d[0] & D8, h = l[l.length - 2], g = Jl({ output: h, version: f });
      return TO(d, g);
    }
    return null;
  }), Dt(a, "output", () => {
    if (a.pubkey)
      return Ba([DR.OP_1, a.pubkey]);
  }), Dt(a, "redeemVersion", () => e.redeemVersion ? e.redeemVersion : e.redeem && e.redeem.redeemVersion !== void 0 && e.redeem.redeemVersion !== null ? e.redeem.redeemVersion : cV), Dt(a, "redeem", () => {
    const u = n();
    if (!(!u || u.length < 2))
      return {
        output: u[u.length - 2],
        witness: u.slice(0, -2),
        redeemVersion: u[u.length - 1][0] & D8
      };
  }), Dt(a, "pubkey", () => {
    if (e.pubkey) return e.pubkey;
    if (e.output) return e.output.slice(2);
    if (e.address) return r().data;
    if (a.internalPubkey) {
      const u = a8(a.internalPubkey, a.hash);
      if (u) return u.x;
    }
  }), Dt(a, "internalPubkey", () => {
    if (e.internalPubkey) return e.internalPubkey;
    const u = n();
    if (u && u.length > 1)
      return u[u.length - 1].slice(1, 33);
  }), Dt(a, "signature", () => {
    if (e.signature) return e.signature;
    const u = n();
    if (!(!u || u.length !== 1))
      return u[0];
  }), Dt(a, "witness", () => {
    if (e.witness) return e.witness;
    const u = o();
    if (u && e.redeem && e.redeem.output && e.internalPubkey) {
      const l = Jl({
        output: e.redeem.output,
        version: a.redeemVersion
      }), d = J3(u, l);
      if (!d) return;
      const f = a8(e.internalPubkey, u.hash);
      if (!f) return;
      const h = so(
        [
          Uint8Array.from([a.redeemVersion | f.parity]),
          e.internalPubkey
        ].concat(d)
      );
      return [e.redeem.output, h];
    }
    if (e.signature) return [e.signature];
  }), t.validate) {
    let u = Uint8Array.from([]);
    if (e.address) {
      if (i && i.bech32 !== r().prefix)
        throw new TypeError("Invalid prefix or Network mismatch");
      if (r().version !== KR)
        throw new TypeError("Invalid address version");
      if (r().data.length !== 32)
        throw new TypeError("Invalid address data");
      u = r().data;
    }
    if (e.pubkey) {
      if (u.length > 0 && dt(u, e.pubkey) !== 0)
        throw new TypeError("Pubkey mismatch");
      u = e.pubkey;
    }
    if (e.output) {
      if (e.output.length !== 34 || e.output[0] !== DR.OP_1 || e.output[1] !== 32)
        throw new TypeError("Output is invalid");
      if (u.length > 0 && dt(u, e.output.slice(2)) !== 0)
        throw new TypeError("Pubkey mismatch");
      u = e.output.slice(2);
    }
    if (e.internalPubkey) {
      const f = a8(e.internalPubkey, a.hash);
      if (u.length > 0 && dt(u, f.x) !== 0)
        throw new TypeError("Pubkey mismatch");
      u = f.x;
    }
    if (u && u.length && !SO().isXOnlyPoint(u))
      throw new TypeError("Invalid pubkey for p2tr");
    const l = o();
    if (e.hash && l && dt(e.hash, l.hash) !== 0)
      throw new TypeError("Hash mismatch");
    if (e.redeem && e.redeem.output && l) {
      const f = Jl({
        output: e.redeem.output,
        version: a.redeemVersion
      });
      if (!J3(l, f))
        throw new TypeError("Redeem script not in tree");
    }
    const d = n();
    if (e.redeem && a.redeem) {
      if (e.redeem.redeemVersion && e.redeem.redeemVersion !== a.redeem.redeemVersion)
        throw new TypeError("Redeem.redeemVersion and witness mismatch");
      if (e.redeem.output) {
        if (ro(e.redeem.output).length === 0)
          throw new TypeError("Redeem.output is invalid");
        if (a.redeem.output && dt(e.redeem.output, a.redeem.output) !== 0)
          throw new TypeError("Redeem.output and witness mismatch");
      }
      if (e.redeem.witness && a.redeem.witness && !Fw(e.redeem.witness, a.redeem.witness))
        throw new TypeError("Redeem.witness and witness mismatch");
    }
    if (d && d.length)
      if (d.length === 1) {
        if (e.signature && dt(e.signature, d[0]) !== 0)
          throw new TypeError("Signature mismatch");
      } else {
        const f = d[d.length - 1];
        if (f.length < 33)
          throw new TypeError(
            `The control-block length is too small. Got ${f.length}, expected min 33.`
          );
        if ((f.length - 33) % 32 !== 0)
          throw new TypeError(
            `The control-block length of ${f.length} is incorrect!`
          );
        const h = (f.length - 33) / 32;
        if (h > 128)
          throw new TypeError(
            `The script path is too long. Got ${h}, expected max 128.`
          );
        const g = f.slice(1, 33);
        if (e.internalPubkey && dt(e.internalPubkey, g) !== 0)
          throw new TypeError("Internal pubkey mismatch");
        if (!SO().isXOnlyPoint(g))
          throw new TypeError("Invalid internalPubkey for p2tr witness");
        const b = f[0] & D8, w = d[d.length - 2], E = Jl({ output: w, version: b }), _ = TO(f, E), O = a8(g, _);
        if (!O)
          throw new TypeError("Invalid outputKey for p2tr witness");
        if (u.length && dt(u, O.x) !== 0)
          throw new TypeError("Pubkey mismatch for p2tr witness");
        if (O.parity !== (f[0] & 1))
          throw new Error("Incorrect parity");
      }
  }
  return Object.assign(a, e);
}
const lV = 40, fV = 2, dV = 16, hV = 2, pV = 80, gV = "WARNING: Sending to a future segwit version address can lead to loss of funds. End users MUST be warned carefully in the GUI and asked if they wish to proceed with caution. Wallets should verify the segwit version from the output of fromBech32, then decide when it is safe to use which version of segwit.";
function $2e(e, t) {
  const r = e.slice(2);
  if (r.length < fV || r.length > lV)
    throw new TypeError("Invalid program length for segwit address");
  const n = e[0] - pV;
  if (n < hV || n > dV)
    throw new TypeError("Invalid version for segwit address");
  if (e[1] !== r.length)
    throw new TypeError("Invalid script for segwit address");
  return console.warn(gV), U2e(r, n, t.bech32);
}
function mV(e) {
  const t = J1.decode(e);
  if (t.length < 21) throw new TypeError(e + " is too short");
  if (t.length > 21) throw new TypeError(e + " is too long");
  const r = lf(t, 0), n = t.slice(1);
  return { version: r, hash: n };
}
function BB(e) {
  let t, r;
  try {
    t = ss.decode(e);
  } catch {
  }
  if (t) {
    if (r = t.words[0], r !== 0) throw new TypeError(e + " uses wrong encoding");
  } else if (t = Dw.decode(e), r = t.words[0], r === 0) throw new TypeError(e + " uses wrong encoding");
  const n = ss.fromWords(t.words.slice(1));
  return {
    version: r,
    prefix: t.prefix,
    data: Uint8Array.from(n)
  };
}
function U2e(e, t, r) {
  const n = ss.toWords(e);
  return n.unshift(t), t === 0 ? ss.encode(r, n) : Dw.encode(r, n);
}
function J2(e, t) {
  t = t || Xu;
  try {
    return W2({ output: e, network: t }).address;
  } catch {
  }
  try {
    return $g({ output: e, network: t }).address;
  } catch {
  }
  try {
    return Z2({ output: e, network: t }).address;
  } catch {
  }
  try {
    return X2({ output: e, network: t }).address;
  } catch {
  }
  try {
    return Y2({ output: e, network: t }).address;
  } catch {
  }
  try {
    return $2e(e, t);
  } catch {
  }
  throw new Error(Hwe(e) + " has no matching Address");
}
function df(e, t) {
  t = t || Xu;
  let r, n;
  try {
    r = mV(e);
  } catch {
  }
  if (r) {
    if (r.version === t.pubKeyHash)
      return W2({ hash: r.hash }).output;
    if (r.version === t.scriptHash)
      return $g({ hash: r.hash }).output;
  } else {
    try {
      n = BB(e);
    } catch {
    }
    if (n) {
      if (n.prefix !== t.bech32)
        throw new Error(e + " has an invalid prefix");
      if (n.version === 0) {
        if (n.data.length === 20)
          return Z2({ hash: n.data }).output;
        if (n.data.length === 32)
          return X2({ hash: n.data }).output;
      } else if (n.version === 1) {
        if (n.data.length === 32)
          return Y2({ pubkey: n.data }).output;
      } else if (n.version >= hV && n.version <= dV && n.data.length >= fV && n.data.length <= lV)
        return console.warn(gV), Ba([
          n.version + pV,
          n.data
        ]);
    }
  }
  throw new Error(e + " has no matching Script");
}
function yc(e) {
  const t = e.length;
  return qs(t) + t;
}
function R2e(e) {
  const t = e.length;
  return qs(t) + e.reduce((r, n) => r + yc(n), 0);
}
const wd = new Uint8Array(0), qR = [], bT = vf(
  "0000000000000000000000000000000000000000000000000000000000000000"
), VR = vf(
  "0000000000000000000000000000000000000000000000000000000000000001"
), z2e = vf("ffffffffffffffff"), j2e = {
  script: wd,
  valueBuffer: z2e
};
function L2e(e) {
  return e.value !== void 0;
}
const gu = class kn {
  constructor() {
    ut(this, "version", 1), ut(this, "locktime", 0), ut(this, "ins", []), ut(this, "outs", []);
  }
  static fromBuffer(t, r) {
    const n = new I2e(t), o = new kn();
    o.version = n.readInt32();
    const i = n.readUInt8(), a = n.readUInt8();
    let u = !1;
    i === kn.ADVANCED_TRANSACTION_MARKER && a === kn.ADVANCED_TRANSACTION_FLAG ? u = !0 : n.offset -= 2;
    const l = n.readVarInt();
    for (let f = 0; f < l; ++f)
      o.ins.push({
        hash: n.readSlice(32),
        index: n.readUInt32(),
        script: n.readVarSlice(),
        sequence: n.readUInt32(),
        witness: qR
      });
    const d = n.readVarInt();
    for (let f = 0; f < d; ++f)
      o.outs.push({
        value: n.readInt64(),
        script: n.readVarSlice()
      });
    if (u) {
      for (let f = 0; f < l; ++f)
        o.ins[f].witness = n.readVector();
      if (!o.hasWitnesses())
        throw new Error("Transaction has superfluous witness data");
    }
    if (o.locktime = n.readUInt32(), r) return o;
    if (n.offset !== t.length)
      throw new Error("Transaction has unexpected data");
    return o;
  }
  static fromHex(t) {
    return kn.fromBuffer(vf(t), !1);
  }
  static isCoinbaseHash(t) {
    eo(OR, t);
    for (let r = 0; r < 32; ++r)
      if (t[r] !== 0) return !1;
    return !0;
  }
  isCoinbase() {
    return this.ins.length === 1 && kn.isCoinbaseHash(this.ins[0].hash);
  }
  addInput(t, r, n, o) {
    return eo(
      wc([
        OR,
        Kl,
        kO(G3(Kl)),
        kO(G3(nn))
      ]),
      [t, r, n, o]
    ), n == null && (n = kn.DEFAULT_SEQUENCE), this.ins.push({
      hash: t,
      index: r,
      script: o || wd,
      sequence: n,
      witness: qR
    }) - 1;
  }
  addOutput(t, r) {
    return eo(wc([nn, pT]), [
      t,
      r
    ]), this.outs.push({
      script: t,
      value: r
    }) - 1;
  }
  hasWitnesses() {
    return this.ins.some((t) => t.witness.length !== 0);
  }
  weight() {
    const t = this.byteLength(!1), r = this.byteLength(!0);
    return t * 3 + r;
  }
  virtualSize() {
    return Math.ceil(this.weight() / 4);
  }
  byteLength(t = !0) {
    const r = t && this.hasWitnesses();
    return (r ? 10 : 8) + qs(this.ins.length) + qs(this.outs.length) + this.ins.reduce((n, o) => n + 40 + yc(o.script), 0) + this.outs.reduce((n, o) => n + 8 + yc(o.script), 0) + (r ? this.ins.reduce((n, o) => n + R2e(o.witness), 0) : 0);
  }
  clone() {
    const t = new kn();
    return t.version = this.version, t.locktime = this.locktime, t.ins = this.ins.map((r) => ({
      hash: r.hash,
      index: r.index,
      script: r.script,
      sequence: r.sequence,
      witness: r.witness
    })), t.outs = this.outs.map((r) => ({
      script: r.script,
      value: r.value
    })), t;
  }
  /**
   * Hash transaction for signing a specific input.
   *
   * Bitcoin uses a different hash for each signed transaction input.
   * This method copies the transaction, makes the necessary changes based on the
   * hashType, and then hashes the result.
   * This hash can then be used to sign the provided transaction input.
   */
  hashForSignature(t, r, n) {
    if (eo(wc([Kl, nn, Sa()]), [
      t,
      r,
      n
    ]), t >= this.ins.length) return VR;
    const o = Ba(
      ro(r).filter((u) => u !== an.OP_CODESEPARATOR)
    ), i = this.clone();
    if ((n & 31) === kn.SIGHASH_NONE)
      i.outs = [], i.ins.forEach((u, l) => {
        l !== t && (u.sequence = 0);
      });
    else if ((n & 31) === kn.SIGHASH_SINGLE) {
      if (t >= this.outs.length) return VR;
      i.outs.length = t + 1;
      for (let u = 0; u < t; u++)
        i.outs[u] = j2e;
      i.ins.forEach((u, l) => {
        l !== t && (u.sequence = 0);
      });
    }
    n & kn.SIGHASH_ANYONECANPAY ? (i.ins = [i.ins[t]], i.ins[0].script = o) : (i.ins.forEach((u) => {
      u.script = wd;
    }), i.ins[t].script = o);
    const a = new Uint8Array(i.byteLength(!1) + 4);
    return Rq(a, a.length - 4, n, "LE"), i.__toBuffer(a, 0, !1), wp(a);
  }
  hashForWitnessV1(t, r, n, o, i, a) {
    if (eo(
      wc([
        Kl,
        Ca(nn),
        Ca(pT),
        Kl
      ]),
      [t, r, n, o]
    ), n.length !== this.ins.length || r.length !== this.ins.length)
      throw new Error("Must supply prevout script and value for all inputs");
    const u = o === kn.SIGHASH_DEFAULT ? kn.SIGHASH_ALL : o & kn.SIGHASH_OUTPUT_MASK, l = (o & kn.SIGHASH_INPUT_MASK) === kn.SIGHASH_ANYONECANPAY, d = u === kn.SIGHASH_NONE, f = u === kn.SIGHASH_SINGLE;
    let h = wd, g = wd, b = wd, w = wd, E = wd;
    if (!l) {
      let I = Bi.withCapacity(36 * this.ins.length);
      this.ins.forEach((S) => {
        I.writeSlice(S.hash), I.writeUInt32(S.index);
      }), h = Si(I.end()), I = Bi.withCapacity(8 * this.ins.length), n.forEach((S) => I.writeInt64(S)), g = Si(I.end()), I = Bi.withCapacity(
        r.map(yc).reduce((S, T) => S + T)
      ), r.forEach(
        (S) => I.writeVarSlice(S)
      ), b = Si(I.end()), I = Bi.withCapacity(4 * this.ins.length), this.ins.forEach((S) => I.writeUInt32(S.sequence)), w = Si(I.end());
    }
    if (d || f) {
      if (f && t < this.outs.length) {
        const I = this.outs[t], S = Bi.withCapacity(
          8 + yc(I.script)
        );
        S.writeInt64(I.value), S.writeVarSlice(I.script), E = Si(S.end());
      }
    } else {
      if (!this.outs.length)
        throw new Error("Add outputs to the transaction before signing.");
      const I = this.outs.map((T) => 8 + yc(T.script)).reduce((T, A) => T + A), S = Bi.withCapacity(I);
      this.outs.forEach((T) => {
        S.writeInt64(T.value), S.writeVarSlice(T.script);
      }), E = Si(S.end());
    }
    const _ = (i ? 2 : 0) + (a ? 1 : 0), O = 174 - (l ? 49 : 0) - (d ? 32 : 0) + (a ? 32 : 0) + (i ? 37 : 0), C = Bi.withCapacity(O);
    if (C.writeUInt8(o), C.writeInt32(this.version), C.writeUInt32(this.locktime), C.writeSlice(h), C.writeSlice(g), C.writeSlice(b), C.writeSlice(w), d || f || C.writeSlice(E), C.writeUInt8(_), l) {
      const I = this.ins[t];
      C.writeSlice(I.hash), C.writeUInt32(I.index), C.writeInt64(n[t]), C.writeVarSlice(r[t]), C.writeUInt32(I.sequence);
    } else
      C.writeUInt32(t);
    if (a) {
      const I = Bi.withCapacity(yc(a));
      I.writeVarSlice(a), C.writeSlice(Si(I.end()));
    }
    return f && C.writeSlice(E), i && (C.writeSlice(i), C.writeUInt8(0), C.writeUInt32(4294967295)), Y4(
      "TapSighash",
      so([Uint8Array.from([0]), C.end()])
    );
  }
  hashForWitnessV0(t, r, n, o) {
    eo(
      wc([
        Kl,
        nn,
        pT,
        Kl
      ]),
      [t, r, n, o]
    );
    let i = Uint8Array.from([]), a, u = bT, l = bT, d = bT;
    if (o & kn.SIGHASH_ANYONECANPAY || (i = new Uint8Array(36 * this.ins.length), a = new Bi(i, 0), this.ins.forEach((h) => {
      a.writeSlice(h.hash), a.writeUInt32(h.index);
    }), l = wp(i)), !(o & kn.SIGHASH_ANYONECANPAY) && (o & 31) !== kn.SIGHASH_SINGLE && (o & 31) !== kn.SIGHASH_NONE && (i = new Uint8Array(4 * this.ins.length), a = new Bi(i, 0), this.ins.forEach((h) => {
      a.writeUInt32(h.sequence);
    }), d = wp(i)), (o & 31) !== kn.SIGHASH_SINGLE && (o & 31) !== kn.SIGHASH_NONE) {
      const h = this.outs.reduce((g, b) => g + 8 + yc(b.script), 0);
      i = new Uint8Array(h), a = new Bi(i, 0), this.outs.forEach((g) => {
        a.writeInt64(g.value), a.writeVarSlice(g.script);
      }), u = wp(i);
    } else if ((o & 31) === kn.SIGHASH_SINGLE && t < this.outs.length) {
      const h = this.outs[t];
      i = new Uint8Array(8 + yc(h.script)), a = new Bi(i, 0), a.writeInt64(h.value), a.writeVarSlice(h.script), u = wp(i);
    }
    i = new Uint8Array(156 + yc(r)), a = new Bi(i, 0);
    const f = this.ins[t];
    return a.writeInt32(this.version), a.writeSlice(l), a.writeSlice(d), a.writeSlice(f.hash), a.writeUInt32(f.index), a.writeVarSlice(r), a.writeInt64(n), a.writeUInt32(f.sequence), a.writeSlice(u), a.writeUInt32(this.locktime), a.writeUInt32(o), wp(i);
  }
  getHash(t) {
    return t && this.isCoinbase() ? new Uint8Array(32) : wp(this.__toBuffer(void 0, void 0, t));
  }
  getId() {
    return Wt(CB(this.getHash(!1)));
  }
  toBuffer(t, r) {
    return this.__toBuffer(t, r, !0);
  }
  toHex() {
    return Wt(this.toBuffer(void 0, void 0));
  }
  setInputScript(t, r) {
    eo(wc([Sa(), nn]), [t, r]), this.ins[t].script = r;
  }
  setWitness(t, r) {
    eo(wc([Sa(), Ca(nn)]), [
      t,
      r
    ]), this.ins[t].witness = r;
  }
  __toBuffer(t, r, n = !1) {
    t || (t = new Uint8Array(this.byteLength(n)));
    const o = new Bi(t, r || 0);
    o.writeInt32(this.version);
    const i = n && this.hasWitnesses();
    return i && (o.writeUInt8(kn.ADVANCED_TRANSACTION_MARKER), o.writeUInt8(kn.ADVANCED_TRANSACTION_FLAG)), o.writeVarInt(this.ins.length), this.ins.forEach((a) => {
      o.writeSlice(a.hash), o.writeUInt32(a.index), o.writeVarSlice(a.script), o.writeUInt32(a.sequence);
    }), o.writeVarInt(this.outs.length), this.outs.forEach((a) => {
      L2e(a) ? o.writeInt64(a.value) : o.writeSlice(a.valueBuffer), o.writeVarSlice(a.script);
    }), i && this.ins.forEach((a) => {
      o.writeVector(a.witness);
    }), o.writeUInt32(this.locktime), r !== void 0 ? t.slice(r, o.offset) : t;
  }
};
ut(gu, "DEFAULT_SEQUENCE", 4294967295), ut(gu, "SIGHASH_DEFAULT", 0), ut(gu, "SIGHASH_ALL", 1), ut(gu, "SIGHASH_NONE", 2), ut(gu, "SIGHASH_SINGLE", 3), ut(gu, "SIGHASH_ANYONECANPAY", 128), ut(gu, "SIGHASH_OUTPUT_MASK", 3), ut(gu, "SIGHASH_INPUT_MASK", 128), ut(gu, "ADVANCED_TRANSACTION_MARKER", 0), ut(gu, "ADVANCED_TRANSACTION_FLAG", 1);
let Eo = gu;
var kc;
(function(e) {
  e[e.UNSIGNED_TX = 0] = "UNSIGNED_TX", e[e.GLOBAL_XPUB = 1] = "GLOBAL_XPUB";
})(kc || (kc = {}));
var It;
(function(e) {
  e[e.NON_WITNESS_UTXO = 0] = "NON_WITNESS_UTXO", e[e.WITNESS_UTXO = 1] = "WITNESS_UTXO", e[e.PARTIAL_SIG = 2] = "PARTIAL_SIG", e[e.SIGHASH_TYPE = 3] = "SIGHASH_TYPE", e[e.REDEEM_SCRIPT = 4] = "REDEEM_SCRIPT", e[e.WITNESS_SCRIPT = 5] = "WITNESS_SCRIPT", e[e.BIP32_DERIVATION = 6] = "BIP32_DERIVATION", e[e.FINAL_SCRIPTSIG = 7] = "FINAL_SCRIPTSIG", e[e.FINAL_SCRIPTWITNESS = 8] = "FINAL_SCRIPTWITNESS", e[e.POR_COMMITMENT = 9] = "POR_COMMITMENT", e[e.TAP_KEY_SIG = 19] = "TAP_KEY_SIG", e[e.TAP_SCRIPT_SIG = 20] = "TAP_SCRIPT_SIG", e[e.TAP_LEAF_SCRIPT = 21] = "TAP_LEAF_SCRIPT", e[e.TAP_BIP32_DERIVATION = 22] = "TAP_BIP32_DERIVATION", e[e.TAP_INTERNAL_KEY = 23] = "TAP_INTERNAL_KEY", e[e.TAP_MERKLE_ROOT = 24] = "TAP_MERKLE_ROOT";
})(It || (It = {}));
var wo;
(function(e) {
  e[e.REDEEM_SCRIPT = 0] = "REDEEM_SCRIPT", e[e.WITNESS_SCRIPT = 1] = "WITNESS_SCRIPT", e[e.BIP32_DERIVATION = 2] = "BIP32_DERIVATION", e[e.TAP_INTERNAL_KEY = 5] = "TAP_INTERNAL_KEY", e[e.TAP_TREE = 6] = "TAP_TREE", e[e.TAP_BIP32_DERIVATION = 7] = "TAP_BIP32_DERIVATION";
})(wo || (wo = {}));
const H2e = (e) => [...Array(e).keys()];
function F2e(e) {
  if (e.key[0] !== kc.GLOBAL_XPUB)
    throw new Error(
      "Decode Error: could not decode globalXpub with key 0x" + Wt(e.key)
    );
  if (e.key.length !== 79 || ![2, 3].includes(e.key[46]))
    throw new Error(
      "Decode Error: globalXpub has invalid extended pubkey in key 0x" + Wt(e.key)
    );
  if (e.value.length / 4 % 1 !== 0)
    throw new Error(
      "Decode Error: Global GLOBAL_XPUB value length should be multiple of 4"
    );
  const t = e.key.slice(1), r = {
    masterFingerprint: e.value.slice(0, 4),
    extendedPubkey: t,
    path: "m"
  };
  for (const n of H2e(e.value.length / 4 - 1)) {
    const o = Bg(e.value, n * 4 + 4, "LE"), i = !!(o & 2147483648), a = o & 2147483647;
    r.path += "/" + a.toString(10) + (i ? "'" : "");
  }
  return r;
}
function M2e(e) {
  const t = new Uint8Array([kc.GLOBAL_XPUB]), r = so([t, e.extendedPubkey]), n = e.path.split("/"), o = new Uint8Array(n.length * 4);
  o.set(e.masterFingerprint, 0);
  let i = 4;
  return n.slice(1).forEach((a) => {
    const u = a.slice(-1) === "'";
    let l = 2147483647 & parseInt(u ? a.slice(0, -1) : a, 10);
    u && (l += 2147483648), G2(o, i, l, "LE"), i += 4;
  }), {
    key: r,
    value: o
  };
}
const D2e = "{ masterFingerprint: Uint8Array; extendedPubkey: Uint8Array; path: string; }";
function K2e(e) {
  const t = e.extendedPubkey, r = e.masterFingerprint, n = e.path;
  return t instanceof Uint8Array && t.length === 78 && [2, 3].indexOf(t[45]) > -1 && r instanceof Uint8Array && r.length === 4 && typeof n == "string" && !!n.match(/^m(\/\d+'?)*$/);
}
function q2e(e, t, r) {
  const n = Wt(t.extendedPubkey);
  return r.has(n) ? !1 : (r.add(n), e.filter((o) => dt(o.extendedPubkey, t.extendedPubkey)).length === 0);
}
const V2e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAddToArray: q2e,
  check: K2e,
  decode: F2e,
  encode: M2e,
  expected: D2e
}, Symbol.toStringTag, { value: "Module" }));
function G2e(e) {
  return {
    key: new Uint8Array([kc.UNSIGNED_TX]),
    value: e.toBuffer()
  };
}
const W2e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  encode: G2e
}, Symbol.toStringTag, { value: "Module" }));
function Z2e(e) {
  if (e.key[0] !== It.FINAL_SCRIPTSIG)
    throw new Error(
      "Decode Error: could not decode finalScriptSig with key 0x" + Wt(e.key)
    );
  return e.value;
}
function X2e(e) {
  return {
    key: new Uint8Array([It.FINAL_SCRIPTSIG]),
    value: e
  };
}
const Y2e = "Uint8Array";
function J2e(e) {
  return e instanceof Uint8Array;
}
function Q2e(e, t) {
  return !!e && !!t && e.finalScriptSig === void 0;
}
const eve = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAdd: Q2e,
  check: J2e,
  decode: Z2e,
  encode: X2e,
  expected: Y2e
}, Symbol.toStringTag, { value: "Module" }));
function tve(e) {
  if (e.key[0] !== It.FINAL_SCRIPTWITNESS)
    throw new Error(
      "Decode Error: could not decode finalScriptWitness with key 0x" + Wt(e.key)
    );
  return e.value;
}
function rve(e) {
  return {
    key: new Uint8Array([It.FINAL_SCRIPTWITNESS]),
    value: e
  };
}
const nve = "Uint8Array";
function ove(e) {
  return e instanceof Uint8Array;
}
function ive(e, t) {
  return !!e && !!t && e.finalScriptWitness === void 0;
}
const ave = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAdd: ive,
  check: ove,
  decode: tve,
  encode: rve,
  expected: nve
}, Symbol.toStringTag, { value: "Module" }));
function sve(e) {
  if (e.key[0] !== It.NON_WITNESS_UTXO)
    throw new Error(
      "Decode Error: could not decode nonWitnessUtxo with key 0x" + Wt(e.key)
    );
  return e.value;
}
function uve(e) {
  return {
    key: new Uint8Array([It.NON_WITNESS_UTXO]),
    value: e
  };
}
const cve = "Uint8Array";
function lve(e) {
  return e instanceof Uint8Array;
}
function fve(e, t) {
  return !!e && !!t && e.nonWitnessUtxo === void 0;
}
const dve = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAdd: fve,
  check: lve,
  decode: sve,
  encode: uve,
  expected: cve
}, Symbol.toStringTag, { value: "Module" }));
function hve(e) {
  if (e.key[0] !== It.PARTIAL_SIG)
    throw new Error(
      "Decode Error: could not decode partialSig with key 0x" + Wt(e.key)
    );
  if (!(e.key.length === 34 || e.key.length === 66) || ![2, 3, 4].includes(e.key[1]))
    throw new Error(
      "Decode Error: partialSig has invalid pubkey in key 0x" + Wt(e.key)
    );
  return {
    pubkey: e.key.slice(1),
    signature: e.value
  };
}
function pve(e) {
  const t = new Uint8Array([It.PARTIAL_SIG]);
  return {
    key: so([t, e.pubkey]),
    value: e.signature
  };
}
const gve = "{ pubkey: Uint8Array; signature: Uint8Array; }";
function mve(e) {
  return e.pubkey instanceof Uint8Array && e.signature instanceof Uint8Array && [33, 65].includes(e.pubkey.length) && [2, 3, 4].includes(e.pubkey[0]) && yve(e.signature);
}
function yve(e) {
  if (!(e instanceof Uint8Array) || e.length < 9 || e[0] !== 48 || e.length !== e[1] + 3 || e[2] !== 2) return !1;
  const t = e[3];
  if (t > 33 || t < 1 || e[3 + t + 1] !== 2) return !1;
  const r = e[3 + t + 2];
  return !(r > 33 || r < 1 || e.length !== 3 + t + 2 + r + 2);
}
function bve(e, t, r) {
  const n = Wt(t.pubkey);
  return r.has(n) ? !1 : (r.add(n), e.filter((o) => dt(o.pubkey, t.pubkey) === 0).length === 0);
}
const wve = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAddToArray: bve,
  check: mve,
  decode: hve,
  encode: pve,
  expected: gve
}, Symbol.toStringTag, { value: "Module" }));
function vve(e) {
  if (e.key[0] !== It.POR_COMMITMENT)
    throw new Error(
      "Decode Error: could not decode porCommitment with key 0x" + Wt(e.key)
    );
  return gwe(e.value);
}
function Eve(e) {
  return {
    key: new Uint8Array([It.POR_COMMITMENT]),
    value: mwe(e)
  };
}
const _ve = "string";
function Ave(e) {
  return typeof e == "string";
}
function xve(e, t) {
  return !!e && !!t && e.porCommitment === void 0;
}
const kve = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAdd: xve,
  check: Ave,
  decode: vve,
  encode: Eve,
  expected: _ve
}, Symbol.toStringTag, { value: "Module" }));
function Sve(e) {
  if (e.key[0] !== It.SIGHASH_TYPE)
    throw new Error(
      "Decode Error: could not decode sighashType with key 0x" + Wt(e.key)
    );
  return Number(Bg(e.value, 0, "LE"));
}
function Tve(e) {
  const t = Uint8Array.from([It.SIGHASH_TYPE]), r = new Uint8Array(4);
  return G2(r, 0, e, "LE"), {
    key: t,
    value: r
  };
}
const Ive = "number";
function Ove(e) {
  return typeof e == "number";
}
function Pve(e, t) {
  return !!e && !!t && e.sighashType === void 0;
}
const Cve = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAdd: Pve,
  check: Ove,
  decode: Sve,
  encode: Tve,
  expected: Ive
}, Symbol.toStringTag, { value: "Module" }));
function Bve(e) {
  if (e.key[0] !== It.TAP_KEY_SIG || e.key.length !== 1)
    throw new Error(
      "Decode Error: could not decode tapKeySig with key 0x" + Wt(e.key)
    );
  if (!yV(e.value))
    throw new Error(
      "Decode Error: tapKeySig not a valid 64-65-byte BIP340 signature"
    );
  return e.value;
}
function Nve(e) {
  return { key: Uint8Array.from([It.TAP_KEY_SIG]), value: e };
}
const $ve = "Uint8Array";
function yV(e) {
  return e instanceof Uint8Array && (e.length === 64 || e.length === 65);
}
function Uve(e, t) {
  return !!e && !!t && e.tapKeySig === void 0;
}
const Rve = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAdd: Uve,
  check: yV,
  decode: Bve,
  encode: Nve,
  expected: $ve
}, Symbol.toStringTag, { value: "Module" }));
function zve(e) {
  if (e.key[0] !== It.TAP_LEAF_SCRIPT)
    throw new Error(
      "Decode Error: could not decode tapLeafScript with key 0x" + Wt(e.key)
    );
  if ((e.key.length - 2) % 32 !== 0)
    throw new Error(
      "Decode Error: tapLeafScript has invalid control block in key 0x" + Wt(e.key)
    );
  const t = e.value[e.value.length - 1];
  if ((e.key[1] & 254) !== t)
    throw new Error(
      "Decode Error: tapLeafScript bad leaf version in key 0x" + Wt(e.key)
    );
  const r = e.value.slice(0, -1);
  return { controlBlock: e.key.slice(1), script: r, leafVersion: t };
}
function jve(e) {
  const t = Uint8Array.from([It.TAP_LEAF_SCRIPT]), r = Uint8Array.from([e.leafVersion]);
  return {
    key: so([t, e.controlBlock]),
    value: so([e.script, r])
  };
}
const Lve = "{ controlBlock: Uint8Array; leafVersion: number, script: Uint8Array; }";
function Hve(e) {
  return e.controlBlock instanceof Uint8Array && (e.controlBlock.length - 1) % 32 === 0 && (e.controlBlock[0] & 254) === e.leafVersion && e.script instanceof Uint8Array;
}
function Fve(e, t, r) {
  const n = Wt(t.controlBlock);
  return r.has(n) ? !1 : (r.add(n), e.filter((o) => dt(o.controlBlock, t.controlBlock) === 0).length === 0);
}
const Mve = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAddToArray: Fve,
  check: Hve,
  decode: zve,
  encode: jve,
  expected: Lve
}, Symbol.toStringTag, { value: "Module" }));
function Dve(e) {
  if (e.key[0] !== It.TAP_MERKLE_ROOT || e.key.length !== 1)
    throw new Error(
      "Decode Error: could not decode tapMerkleRoot with key 0x" + Wt(e.key)
    );
  if (!bV(e.value))
    throw new Error("Decode Error: tapMerkleRoot not a 32-byte hash");
  return e.value;
}
function Kve(e) {
  return { key: Uint8Array.from([It.TAP_MERKLE_ROOT]), value: e };
}
const qve = "Uint8Array";
function bV(e) {
  return e instanceof Uint8Array && e.length === 32;
}
function Vve(e, t) {
  return !!e && !!t && e.tapMerkleRoot === void 0;
}
const Gve = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAdd: Vve,
  check: bV,
  decode: Dve,
  encode: Kve,
  expected: qve
}, Symbol.toStringTag, { value: "Module" }));
function Wve(e) {
  if (e.key[0] !== It.TAP_SCRIPT_SIG)
    throw new Error(
      "Decode Error: could not decode tapScriptSig with key 0x" + Wt(e.key)
    );
  if (e.key.length !== 65)
    throw new Error(
      "Decode Error: tapScriptSig has invalid key 0x" + Wt(e.key)
    );
  if (e.value.length !== 64 && e.value.length !== 65)
    throw new Error(
      "Decode Error: tapScriptSig has invalid signature in key 0x" + Wt(e.key)
    );
  const t = e.key.slice(1, 33), r = e.key.slice(33);
  return {
    pubkey: t,
    leafHash: r,
    signature: e.value
  };
}
function Zve(e) {
  const t = Uint8Array.from([It.TAP_SCRIPT_SIG]);
  return {
    key: so([t, e.pubkey, e.leafHash]),
    value: e.signature
  };
}
const Xve = "{ pubkey: Uint8Array; leafHash: Uint8Array; signature: Uint8Array; }";
function Yve(e) {
  return e.pubkey instanceof Uint8Array && e.leafHash instanceof Uint8Array && e.signature instanceof Uint8Array && e.pubkey.length === 32 && e.leafHash.length === 32 && (e.signature.length === 64 || e.signature.length === 65);
}
function Jve(e, t, r) {
  const n = Wt(t.pubkey) + Wt(t.leafHash);
  return r.has(n) ? !1 : (r.add(n), e.filter(
    (o) => dt(o.pubkey, t.pubkey) === 0 && dt(o.leafHash, t.leafHash) === 0
  ).length === 0);
}
const Qve = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAddToArray: Jve,
  check: Yve,
  decode: Wve,
  encode: Zve,
  expected: Xve
}, Symbol.toStringTag, { value: "Module" }));
function e8e(e) {
  if (e.key[0] !== It.WITNESS_UTXO)
    throw new Error(
      "Decode Error: could not decode witnessUtxo with key 0x" + Wt(e.key)
    );
  const t = jq(e.value, 0, "LE");
  let r = 8;
  const { numberValue: n, bytes: o } = Ug(
    e.value,
    r
  );
  r += o;
  const i = e.value.slice(r);
  if (i.length !== n)
    throw new Error("Decode Error: WITNESS_UTXO script is not proper length");
  return {
    script: i,
    value: t
  };
}
function t8e(e) {
  const { script: t, value: r } = e, n = qs(t.length), o = new Uint8Array(8 + n + t.length);
  return zq(o, 0, BigInt(r), "LE"), Dd(t.length, o, 8), o.set(t, 8 + n), {
    key: Uint8Array.from([It.WITNESS_UTXO]),
    value: o
  };
}
const r8e = "{ script: Uint8Array; value: bigint; }";
function n8e(e) {
  return e.script instanceof Uint8Array && typeof e.value == "bigint";
}
function o8e(e, t) {
  return !!e && !!t && e.witnessUtxo === void 0;
}
const i8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAdd: o8e,
  check: n8e,
  decode: e8e,
  encode: t8e,
  expected: r8e
}, Symbol.toStringTag, { value: "Module" }));
function a8e(e) {
  if (e.key[0] !== wo.TAP_TREE || e.key.length !== 1)
    throw new Error(
      "Decode Error: could not decode tapTree with key 0x" + Wt(e.key)
    );
  let t = 0;
  const r = [];
  for (; t < e.value.length; ) {
    const n = e.value[t++], o = e.value[t++], { numberValue: i, bytes: a } = Ug(
      e.value,
      t
    );
    t += a, r.push({
      depth: n,
      leafVersion: o,
      script: e.value.slice(t, t + i)
    }), t += i;
  }
  return { leaves: r };
}
function s8e(e) {
  const t = Uint8Array.from([wo.TAP_TREE]), r = [].concat(
    ...e.leaves.map((n) => [
      Uint8Array.of(n.depth, n.leafVersion),
      Dd(BigInt(n.script.length)).buffer,
      n.script
    ])
  );
  return {
    key: t,
    value: so(r)
  };
}
const u8e = "{ leaves: [{ depth: number; leafVersion: number, script: Uint8Array; }] }";
function c8e(e) {
  return Array.isArray(e.leaves) && e.leaves.every(
    (t) => t.depth >= 0 && t.depth <= 128 && (t.leafVersion & 254) === t.leafVersion && t.script instanceof Uint8Array
  );
}
function l8e(e, t) {
  return !!e && !!t && e.tapTree === void 0;
}
const f8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  canAdd: l8e,
  check: c8e,
  decode: a8e,
  encode: s8e,
  expected: u8e
}, Symbol.toStringTag, { value: "Module" })), d8e = (e) => [...Array(e).keys()], h8e = (e) => e.length === 33 && [2, 3].includes(e[0]) || e.length === 65 && e[0] === 4;
function NB(e, t = h8e) {
  function r(u) {
    if (u.key[0] !== e)
      throw new Error(
        "Decode Error: could not decode bip32Derivation with key 0x" + Wt(u.key)
      );
    const l = u.key.slice(1);
    if (!t(l))
      throw new Error(
        "Decode Error: bip32Derivation has invalid pubkey in key 0x" + Wt(u.key)
      );
    if (u.value.length / 4 % 1 !== 0)
      throw new Error(
        "Decode Error: Input BIP32_DERIVATION value length should be multiple of 4"
      );
    const d = {
      masterFingerprint: u.value.slice(0, 4),
      pubkey: l,
      path: "m"
    };
    for (const f of d8e(u.value.length / 4 - 1)) {
      const h = Bg(u.value, f * 4 + 4, "LE"), g = !!(h & 2147483648), b = h & 2147483647;
      d.path += "/" + b.toString(10) + (g ? "'" : "");
    }
    return d;
  }
  function n(u) {
    const l = Uint8Array.from([e]), d = so([l, u.pubkey]), f = u.path.split("/"), h = new Uint8Array(f.length * 4);
    h.set(u.masterFingerprint, 0);
    let g = 4;
    return f.slice(1).forEach((b) => {
      const w = b.slice(-1) === "'";
      let E = 2147483647 & parseInt(w ? b.slice(0, -1) : b, 10);
      w && (E += 2147483648), G2(h, g, E, "LE"), g += 4;
    }), {
      key: d,
      value: h
    };
  }
  const o = "{ masterFingerprint: Uint8Array; pubkey: Uint8Array; path: string; }";
  function i(u) {
    return u.pubkey instanceof Uint8Array && u.masterFingerprint instanceof Uint8Array && typeof u.path == "string" && t(u.pubkey) && u.masterFingerprint.length === 4;
  }
  function a(u, l, d) {
    const f = Wt(l.pubkey);
    return d.has(f) ? !1 : (d.add(f), u.filter((h) => dt(h.pubkey, l.pubkey) === 0).length === 0);
  }
  return {
    decode: r,
    encode: n,
    check: i,
    expected: o,
    canAddToArray: a
  };
}
function $B(e) {
  return t;
  function t(r) {
    let n;
    if (e.includes(r.key[0]) && (n = r.key.slice(1), !(n.length === 33 || n.length === 65) || ![2, 3, 4].includes(n[0])))
      throw new Error(
        "Format Error: invalid pubkey in key 0x" + Wt(r.key)
      );
    return n;
  }
}
function wV(e) {
  function t(a) {
    if (a.key[0] !== e)
      throw new Error(
        "Decode Error: could not decode redeemScript with key 0x" + Wt(a.key)
      );
    return a.value;
  }
  function r(a) {
    return {
      key: Uint8Array.from([e]),
      value: a
    };
  }
  const n = "Uint8Array";
  function o(a) {
    return a instanceof Uint8Array;
  }
  function i(a, u) {
    return !!a && !!u && a.redeemScript === void 0;
  }
  return {
    decode: t,
    encode: r,
    check: o,
    expected: n,
    canAdd: i
  };
}
const p8e = (e) => e.length === 32;
function vV(e) {
  const t = NB(e, p8e);
  function r(a) {
    const { numberValue: u, bytes: l } = Ug(
      a.value
    ), d = t.decode({
      key: a.key,
      value: a.value.slice(l + Number(u) * 32)
    }), f = new Array(Number(u));
    for (let h = 0, g = l; h < u; h++, g += 32)
      f[h] = a.value.slice(g, g + 32);
    return { ...d, leafHashes: f };
  }
  function n(a) {
    const u = t.encode(a), l = qs(a.leafHashes.length), d = new Uint8Array(l);
    Dd(a.leafHashes.length, d);
    const f = so([d, ...a.leafHashes, u.value]);
    return { ...u, value: f };
  }
  const o = "{ masterFingerprint: Uint8Array; pubkey: Uint8Array; path: string; leafHashes: Uint8Array[]; }";
  function i(a) {
    return Array.isArray(a.leafHashes) && a.leafHashes.every(
      (u) => u instanceof Uint8Array && u.length === 32
    ) && t.check(a);
  }
  return {
    decode: r,
    encode: n,
    check: i,
    expected: o,
    canAddToArray: t.canAddToArray
  };
}
function EV(e) {
  function t(a) {
    if (a.key[0] !== e || a.key.length !== 1)
      throw new Error(
        "Decode Error: could not decode tapInternalKey with key 0x" + Wt(a.key)
      );
    if (a.value.length !== 32)
      throw new Error(
        "Decode Error: tapInternalKey not a 32-byte x-only pubkey"
      );
    return a.value;
  }
  function r(a) {
    return { key: Uint8Array.from([e]), value: a };
  }
  const n = "Uint8Array";
  function o(a) {
    return a instanceof Uint8Array && a.length === 32;
  }
  function i(a, u) {
    return !!a && !!u && a.tapInternalKey === void 0;
  }
  return {
    decode: t,
    encode: r,
    check: o,
    expected: n,
    canAdd: i
  };
}
function _V(e) {
  function t(a) {
    if (a.key[0] !== e)
      throw new Error(
        "Decode Error: could not decode witnessScript with key 0x" + Wt(a.key)
      );
    return a.value;
  }
  function r(a) {
    return {
      key: Uint8Array.from([e]),
      value: a
    };
  }
  const n = "Uint8Array";
  function o(a) {
    return a instanceof Uint8Array;
  }
  function i(a, u) {
    return !!a && !!u && a.witnessScript === void 0;
  }
  return {
    decode: t,
    encode: r,
    check: o,
    expected: n,
    canAdd: i
  };
}
const UB = {
  unsignedTx: W2e,
  globalXpub: V2e,
  // pass an Array of key bytes that require pubkey beside the key
  checkPubkey: $B([])
}, Fo = {
  nonWitnessUtxo: dve,
  partialSig: wve,
  sighashType: Cve,
  finalScriptSig: eve,
  finalScriptWitness: ave,
  porCommitment: kve,
  witnessUtxo: i8e,
  bip32Derivation: NB(It.BIP32_DERIVATION),
  redeemScript: wV(It.REDEEM_SCRIPT),
  witnessScript: _V(It.WITNESS_SCRIPT),
  checkPubkey: $B([
    It.PARTIAL_SIG,
    It.BIP32_DERIVATION
  ]),
  tapKeySig: Rve,
  tapScriptSig: Qve,
  tapLeafScript: Mve,
  tapBip32Derivation: vV(
    It.TAP_BIP32_DERIVATION
  ),
  tapInternalKey: EV(It.TAP_INTERNAL_KEY),
  tapMerkleRoot: Gve
}, ql = {
  bip32Derivation: NB(wo.BIP32_DERIVATION),
  redeemScript: wV(wo.REDEEM_SCRIPT),
  witnessScript: _V(wo.WITNESS_SCRIPT),
  checkPubkey: $B([wo.BIP32_DERIVATION]),
  tapBip32Derivation: vV(
    wo.TAP_BIP32_DERIVATION
  ),
  tapTree: f8e,
  tapInternalKey: EV(wo.TAP_INTERNAL_KEY)
}, g8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  globals: UB,
  inputs: Fo,
  outputs: ql
}, Symbol.toStringTag, { value: "Module" })), Q3 = (e) => [...Array(e).keys()];
function GR(e) {
  const t = e.map(m8e);
  return t.push(Uint8Array.from([0])), so(t);
}
function m8e(e) {
  const t = e.key.length, r = e.value.length, n = qs(t), o = qs(r), i = new Uint8Array(n + t + o + r);
  return Dd(t, i, 0), i.set(e.key, n), Dd(r, i, n + t), i.set(e.value, n + t + o), i;
}
function y8e(e, t) {
  let r = 0;
  function n() {
    const { numberValue: _, bytes: O } = Ug(e, r);
    r += O;
    const C = e.slice(r, r + Number(_));
    return r += Number(_), C;
  }
  function o() {
    const _ = Bg(e, r, "BE");
    return r += 4, _;
  }
  function i() {
    const _ = lf(e, r);
    return r += 1, _;
  }
  function a() {
    const _ = n(), O = n();
    return {
      key: _,
      value: O
    };
  }
  function u() {
    if (r >= e.length)
      throw new Error("Format Error: Unexpected End of PSBT");
    const _ = lf(e, r) === 0;
    return _ && r++, _;
  }
  if (o() !== 1886610036)
    throw new Error("Format Error: Invalid Magic Number");
  if (i() !== 255)
    throw new Error(
      "Format Error: Magic Number must be followed by 0xff separator"
    );
  const l = [], d = {};
  for (; !u(); ) {
    const _ = a(), O = Wt(_.key);
    if (d[O])
      throw new Error(
        "Format Error: Keys must be unique for global keymap: key " + O
      );
    d[O] = 1, l.push(_);
  }
  const f = l.filter(
    (_) => _.key[0] === kc.UNSIGNED_TX
  );
  if (f.length !== 1)
    throw new Error("Format Error: Only one UNSIGNED_TX allowed");
  const h = t(f[0].value), { inputCount: g, outputCount: b } = h.getInputOutputCounts(), w = [], E = [];
  for (const _ of Q3(g)) {
    const O = {}, C = [];
    for (; !u(); ) {
      const I = a(), S = Wt(I.key);
      if (O[S])
        throw new Error(
          "Format Error: Keys must be unique for each input: input index " + _ + " key " + S
        );
      O[S] = 1, C.push(I);
    }
    w.push(C);
  }
  for (const _ of Q3(b)) {
    const O = {}, C = [];
    for (; !u(); ) {
      const I = a(), S = Wt(I.key);
      if (O[S])
        throw new Error(
          "Format Error: Keys must be unique for each output: output index " + _ + " key " + S
        );
      O[S] = 1, C.push(I);
    }
    E.push(C);
  }
  return AV(h, {
    globalMapKeyVals: l,
    inputKeyVals: w,
    outputKeyVals: E
  });
}
function Pi(e, t, r) {
  if (dt(t, Uint8Array.from([r])))
    throw new Error(
      // `Format Error: Invalid ${type} key: ${keyBuf.toString('hex')}`,
      `Format Error: Invalid ${e} key: ${Wt(t)}`
    );
}
function AV(e, { globalMapKeyVals: t, inputKeyVals: r, outputKeyVals: n }) {
  const o = {
    unsignedTx: e
  };
  let i = 0;
  for (const f of t)
    switch (f.key[0]) {
      case kc.UNSIGNED_TX:
        if (Pi("global", f.key, kc.UNSIGNED_TX), i > 0)
          throw new Error("Format Error: GlobalMap has multiple UNSIGNED_TX");
        i++;
        break;
      case kc.GLOBAL_XPUB:
        o.globalXpub === void 0 && (o.globalXpub = []), o.globalXpub.push(UB.globalXpub.decode(f));
        break;
      default:
        o.unknownKeyVals || (o.unknownKeyVals = []), o.unknownKeyVals.push(f);
    }
  const a = r.length, u = n.length, l = [], d = [];
  for (const f of Q3(a)) {
    const h = {};
    for (const g of r[f])
      switch (Fo.checkPubkey(g), g.key[0]) {
        case It.NON_WITNESS_UTXO:
          if (Pi("input", g.key, It.NON_WITNESS_UTXO), h.nonWitnessUtxo !== void 0)
            throw new Error(
              "Format Error: Input has multiple NON_WITNESS_UTXO"
            );
          h.nonWitnessUtxo = Fo.nonWitnessUtxo.decode(g);
          break;
        case It.WITNESS_UTXO:
          if (Pi("input", g.key, It.WITNESS_UTXO), h.witnessUtxo !== void 0)
            throw new Error("Format Error: Input has multiple WITNESS_UTXO");
          h.witnessUtxo = Fo.witnessUtxo.decode(g);
          break;
        case It.PARTIAL_SIG:
          h.partialSig === void 0 && (h.partialSig = []), h.partialSig.push(Fo.partialSig.decode(g));
          break;
        case It.SIGHASH_TYPE:
          if (Pi("input", g.key, It.SIGHASH_TYPE), h.sighashType !== void 0)
            throw new Error("Format Error: Input has multiple SIGHASH_TYPE");
          h.sighashType = Fo.sighashType.decode(g);
          break;
        case It.REDEEM_SCRIPT:
          if (Pi("input", g.key, It.REDEEM_SCRIPT), h.redeemScript !== void 0)
            throw new Error("Format Error: Input has multiple REDEEM_SCRIPT");
          h.redeemScript = Fo.redeemScript.decode(g);
          break;
        case It.WITNESS_SCRIPT:
          if (Pi("input", g.key, It.WITNESS_SCRIPT), h.witnessScript !== void 0)
            throw new Error("Format Error: Input has multiple WITNESS_SCRIPT");
          h.witnessScript = Fo.witnessScript.decode(g);
          break;
        case It.BIP32_DERIVATION:
          h.bip32Derivation === void 0 && (h.bip32Derivation = []), h.bip32Derivation.push(
            Fo.bip32Derivation.decode(g)
          );
          break;
        case It.FINAL_SCRIPTSIG:
          Pi("input", g.key, It.FINAL_SCRIPTSIG), h.finalScriptSig = Fo.finalScriptSig.decode(g);
          break;
        case It.FINAL_SCRIPTWITNESS:
          Pi("input", g.key, It.FINAL_SCRIPTWITNESS), h.finalScriptWitness = Fo.finalScriptWitness.decode(
            g
          );
          break;
        case It.POR_COMMITMENT:
          Pi("input", g.key, It.POR_COMMITMENT), h.porCommitment = Fo.porCommitment.decode(g);
          break;
        case It.TAP_KEY_SIG:
          Pi("input", g.key, It.TAP_KEY_SIG), h.tapKeySig = Fo.tapKeySig.decode(g);
          break;
        case It.TAP_SCRIPT_SIG:
          h.tapScriptSig === void 0 && (h.tapScriptSig = []), h.tapScriptSig.push(Fo.tapScriptSig.decode(g));
          break;
        case It.TAP_LEAF_SCRIPT:
          h.tapLeafScript === void 0 && (h.tapLeafScript = []), h.tapLeafScript.push(Fo.tapLeafScript.decode(g));
          break;
        case It.TAP_BIP32_DERIVATION:
          h.tapBip32Derivation === void 0 && (h.tapBip32Derivation = []), h.tapBip32Derivation.push(
            Fo.tapBip32Derivation.decode(g)
          );
          break;
        case It.TAP_INTERNAL_KEY:
          Pi("input", g.key, It.TAP_INTERNAL_KEY), h.tapInternalKey = Fo.tapInternalKey.decode(g);
          break;
        case It.TAP_MERKLE_ROOT:
          Pi("input", g.key, It.TAP_MERKLE_ROOT), h.tapMerkleRoot = Fo.tapMerkleRoot.decode(g);
          break;
        default:
          h.unknownKeyVals || (h.unknownKeyVals = []), h.unknownKeyVals.push(g);
      }
    l.push(h);
  }
  for (const f of Q3(u)) {
    const h = {};
    for (const g of n[f])
      switch (ql.checkPubkey(g), g.key[0]) {
        case wo.REDEEM_SCRIPT:
          if (Pi("output", g.key, wo.REDEEM_SCRIPT), h.redeemScript !== void 0)
            throw new Error("Format Error: Output has multiple REDEEM_SCRIPT");
          h.redeemScript = ql.redeemScript.decode(g);
          break;
        case wo.WITNESS_SCRIPT:
          if (Pi("output", g.key, wo.WITNESS_SCRIPT), h.witnessScript !== void 0)
            throw new Error("Format Error: Output has multiple WITNESS_SCRIPT");
          h.witnessScript = ql.witnessScript.decode(g);
          break;
        case wo.BIP32_DERIVATION:
          h.bip32Derivation === void 0 && (h.bip32Derivation = []), h.bip32Derivation.push(
            ql.bip32Derivation.decode(g)
          );
          break;
        case wo.TAP_INTERNAL_KEY:
          Pi("output", g.key, wo.TAP_INTERNAL_KEY), h.tapInternalKey = ql.tapInternalKey.decode(g);
          break;
        case wo.TAP_TREE:
          Pi("output", g.key, wo.TAP_TREE), h.tapTree = ql.tapTree.decode(g);
          break;
        case wo.TAP_BIP32_DERIVATION:
          h.tapBip32Derivation === void 0 && (h.tapBip32Derivation = []), h.tapBip32Derivation.push(
            ql.tapBip32Derivation.decode(g)
          );
          break;
        default:
          h.unknownKeyVals || (h.unknownKeyVals = []), h.unknownKeyVals.push(g);
      }
    d.push(h);
  }
  return { globalMap: o, inputs: l, outputs: d };
}
function b8e({ globalMap: e, inputs: t, outputs: r }) {
  const { globalKeyVals: n, inputKeyVals: o, outputKeyVals: i } = PO({
    globalMap: e,
    inputs: t,
    outputs: r
  }), a = GR(n), u = (h) => h.length === 0 ? [Uint8Array.from([0])] : h.map(GR), l = u(o), d = u(i), f = new Uint8Array(5);
  return f.set([112, 115, 98, 116, 255], 0), so(
    [f, a].concat(l, d)
  );
}
const w8e = (e, t) => dt(e.key, t.key);
function wT(e, t) {
  const r = /* @__PURE__ */ new Set(), n = Object.entries(e).reduce((i, [a, u]) => {
    if (a === "unknownKeyVals") return i;
    const l = t[a];
    if (l === void 0) return i;
    const d = (Array.isArray(u) ? u : [u]).map(
      l.encode
    );
    return d.map((f) => Wt(f.key)).forEach((f) => {
      if (r.has(f))
        throw new Error("Serialize Error: Duplicate key: " + f);
      r.add(f);
    }), i.concat(d);
  }, []), o = e.unknownKeyVals ? e.unknownKeyVals.filter((i) => !r.has(Wt(i.key))) : [];
  return n.concat(o).sort(w8e);
}
function PO({ globalMap: e, inputs: t, outputs: r }) {
  return {
    globalKeyVals: wT(e, UB),
    inputKeyVals: t.map((n) => wT(n, Fo)),
    outputKeyVals: r.map((n) => wT(n, ql))
  };
}
function v8e(e) {
  const t = e[0], r = PO(t), n = e.slice(1);
  if (n.length === 0) throw new Error("Combine: Nothing to combine");
  const o = WR(t);
  if (o === void 0)
    throw new Error("Combine: Self missing transaction");
  const i = q0(r.globalKeyVals), a = r.inputKeyVals.map(q0), u = r.outputKeyVals.map(q0);
  for (const l of n) {
    const d = WR(l);
    if (d === void 0 || dt(d.toBuffer(), o.toBuffer()) !== 0)
      throw new Error(
        "Combine: One of the Psbts does not have the same transaction."
      );
    const f = PO(l);
    q0(f.globalKeyVals).forEach(
      vT(
        i,
        r.globalKeyVals,
        f.globalKeyVals
      )
    ), f.inputKeyVals.map(q0).forEach(
      (h, g) => h.forEach(
        vT(
          a[g],
          r.inputKeyVals[g],
          f.inputKeyVals[g]
        )
      )
    ), f.outputKeyVals.map(q0).forEach(
      (h, g) => h.forEach(
        vT(
          u[g],
          r.outputKeyVals[g],
          f.outputKeyVals[g]
        )
      )
    );
  }
  return AV(o, {
    globalMapKeyVals: r.globalKeyVals,
    inputKeyVals: r.inputKeyVals,
    outputKeyVals: r.outputKeyVals
  });
}
function vT(e, t, r) {
  return (n) => {
    if (e.has(n)) return;
    const o = r.filter((i) => Wt(i.key) === n)[0];
    t.push(o), e.add(n);
  };
}
function WR(e) {
  return e.globalMap.unsignedTx;
}
function q0(e) {
  const t = /* @__PURE__ */ new Set();
  return e.forEach((r) => {
    const n = Wt(r.key);
    if (t.has(n))
      throw new Error("Combine: KeyValue Map keys should be unique");
    t.add(n);
  }), t;
}
function Ai(e, t) {
  const r = e[t];
  if (r === void 0) throw new Error(`No input #${t}`);
  return r;
}
function Kw(e, t) {
  const r = e[t];
  if (r === void 0) throw new Error(`No output #${t}`);
  return r;
}
function ET(e, t, r) {
  if (e.key[0] < r)
    throw new Error(
      "Use the method for your specific key instead of addUnknownKeyVal*"
    );
  if (t && t.filter((n) => dt(n.key, e.key) === 0).length !== 0)
    throw new Error(`Duplicate Key: ${Wt(e.key)}`);
}
function _T(e) {
  let t = 0;
  return Object.keys(e).forEach((r) => {
    Number(isNaN(Number(r))) && t++;
  }), t;
}
function E8e(e, t) {
  let r = !1;
  if (t.nonWitnessUtxo || t.witnessUtxo) {
    const n = !!t.redeemScript, o = !!t.witnessScript, i = !n || !!t.finalScriptSig, a = !o || !!t.finalScriptWitness, u = !!t.finalScriptSig || !!t.finalScriptWitness;
    r = i && a && u;
  }
  if (r === !1)
    throw new Error(
      `Input #${e} has too much or too little data to clean`
    );
}
function ZR(e, t, r, n) {
  throw new Error(
    `Data for ${e} key ${t} is incorrect: Expected ${r} and got ${JSON.stringify(n)}`
  );
}
function RB(e) {
  return (t, r) => {
    for (const n of Object.keys(t)) {
      const o = t[n], { canAdd: i, canAddToArray: a, check: u, expected: l } = (
        // @ts-ignore
        g8e[e + "s"][n] || {}
      ), d = !!a;
      if (u)
        if (d) {
          if (!Array.isArray(o) || // @ts-ignore
          r[n] && !Array.isArray(r[n]))
            throw new Error(`Key type ${n} must be an array`);
          o.every(u) || ZR(e, n, l, o);
          const f = r[n] || [], h = /* @__PURE__ */ new Set();
          if (!o.every((g) => a(f, g, h)))
            throw new Error("Can not add duplicate data to array");
          r[n] = f.concat(o);
        } else {
          if (u(o) || ZR(e, n, l, o), !i(r, o))
            throw new Error(`Can not add duplicate data to ${e}`);
          r[n] = o;
        }
    }
  };
}
const _8e = RB("global"), xV = RB("input"), kV = RB("output");
function A8e(e, t) {
  const r = e.length - 1, n = Ai(e, r);
  xV(t, n);
}
function x8e(e, t) {
  const r = e.length - 1, n = Kw(e, r);
  kV(t, n);
}
let XR = class {
  constructor(e) {
    this.inputs = [], this.outputs = [], this.globalMap = {
      unsignedTx: e
    };
  }
  static fromBase64(e, t) {
    const r = Uq(e);
    return this.fromBuffer(r, t);
  }
  static fromHex(e, t) {
    const r = vf(e);
    return this.fromBuffer(r, t);
  }
  static fromBuffer(e, t) {
    const r = y8e(e, t), n = new this(r.globalMap.unsignedTx);
    return Object.assign(n, r), n;
  }
  toBase64() {
    const e = this.toBuffer();
    return wwe(e);
  }
  toHex() {
    const e = this.toBuffer();
    return Wt(e);
  }
  toBuffer() {
    return b8e(this);
  }
  updateGlobal(e) {
    return _8e(e, this.globalMap), this;
  }
  updateInput(e, t) {
    const r = Ai(this.inputs, e);
    return xV(t, r), this;
  }
  updateOutput(e, t) {
    const r = Kw(this.outputs, e);
    return kV(t, r), this;
  }
  addUnknownKeyValToGlobal(e) {
    return ET(
      e,
      this.globalMap.unknownKeyVals,
      _T(kc)
    ), this.globalMap.unknownKeyVals || (this.globalMap.unknownKeyVals = []), this.globalMap.unknownKeyVals.push(e), this;
  }
  addUnknownKeyValToInput(e, t) {
    const r = Ai(this.inputs, e);
    return ET(t, r.unknownKeyVals, _T(It)), r.unknownKeyVals || (r.unknownKeyVals = []), r.unknownKeyVals.push(t), this;
  }
  addUnknownKeyValToOutput(e, t) {
    const r = Kw(this.outputs, e);
    return ET(t, r.unknownKeyVals, _T(wo)), r.unknownKeyVals || (r.unknownKeyVals = []), r.unknownKeyVals.push(t), this;
  }
  addInput(e) {
    this.globalMap.unsignedTx.addInput(e), this.inputs.push({
      unknownKeyVals: []
    });
    const t = e.unknownKeyVals || [], r = this.inputs.length - 1;
    if (!Array.isArray(t))
      throw new Error("unknownKeyVals must be an Array");
    return t.forEach(
      (n) => this.addUnknownKeyValToInput(r, n)
    ), A8e(this.inputs, e), this;
  }
  addOutput(e) {
    this.globalMap.unsignedTx.addOutput(e), this.outputs.push({
      unknownKeyVals: []
    });
    const t = e.unknownKeyVals || [], r = this.outputs.length - 1;
    if (!Array.isArray(t))
      throw new Error("unknownKeyVals must be an Array");
    return t.forEach(
      (n) => this.addUnknownKeyValToOutput(r, n)
    ), x8e(this.outputs, e), this;
  }
  clearFinalizedInput(e) {
    const t = Ai(this.inputs, e);
    E8e(e, t);
    for (const r of Object.keys(t))
      [
        "witnessUtxo",
        "nonWitnessUtxo",
        "finalScriptSig",
        "finalScriptWitness",
        "unknownKeyVals"
      ].includes(r) || delete t[r];
    return this;
  }
  combine(...e) {
    const t = v8e([this].concat(e));
    return Object.assign(this, t), this;
  }
  getTransaction() {
    return this.globalMap.unsignedTx.toBuffer();
  }
};
function C0(e) {
  return (t) => {
    try {
      return e({ output: t }), !0;
    } catch {
      return !1;
    }
  };
}
const k8e = C0(X4), S8e = C0(Jq), T8e = C0(W2), J4 = C0(Z2), YR = C0(X2), SV = C0($g), TV = C0(Y2);
function e5(e) {
  let t = new Uint8Array(0);
  function r(a) {
    t = so([t, a]);
  }
  function n(a) {
    const u = t.length, l = qs(a);
    t = so([t, new Uint8Array(l)]), Dd(a, t, u);
  }
  function o(a) {
    n(a.length), r(a);
  }
  function i(a) {
    n(a.length), a.forEach(o);
  }
  return i(e), t;
}
function IV(e, t) {
  const r = tf(e), n = e.slice(1, 33), o = ro(t);
  if (o === null) throw new Error("Unknown script error");
  return o.findIndex((i) => typeof i == "number" ? !1 : dt(e, i) === 0 || dt(r, i) === 0 || dt(n, i) === 0);
}
function Q4(e, t) {
  return IV(e, t) !== -1;
}
function I8e(e, t) {
  return O8e(e).some(
    (r) => OV(r, ow.decode, t)
  );
}
function OV(e, t, r) {
  const { hashType: n } = t(e), o = [];
  switch (n & Eo.SIGHASH_ANYONECANPAY && o.push("addInput"), n & 31) {
    case Eo.SIGHASH_ALL:
      break;
    case Eo.SIGHASH_SINGLE:
    case Eo.SIGHASH_NONE:
      o.push("addOutput"), o.push("setInputSequence");
      break;
  }
  return o.indexOf(r) === -1;
}
function O8e(e) {
  let t = [];
  if ((e.partialSig || []).length === 0) {
    if (!e.finalScriptSig && !e.finalScriptWitness) return [];
    t = P8e(e);
  } else
    t = e.partialSig;
  return t.map((r) => r.signature);
}
function P8e(e) {
  const t = e.finalScriptSig ? ro(e.finalScriptSig) || [] : [], r = e.finalScriptWitness ? ro(e.finalScriptWitness) || [] : [];
  return t.concat(r).filter((n) => n instanceof Uint8Array && ff(n)).map((n) => ({ signature: n }));
}
const Uu = (e) => e.length === 32 ? e : e.slice(1, 33);
function JR(e, t, r) {
  const n = K8e(
    t,
    e,
    r
  );
  try {
    const o = M8e(t, n).concat(n.script).concat(n.controlBlock);
    return { finalScriptWitness: e5(o) };
  } catch (o) {
    throw new Error(`Can not finalize taproot input #${e}: ${o}`);
  }
}
function s8(e, t) {
  const r = t ? Uint8Array.from([t]) : Uint8Array.from([]);
  return so([e, r]);
}
function Eu(e) {
  return e && !!(e.tapInternalKey || e.tapMerkleRoot || e.tapLeafScript && e.tapLeafScript.length || e.tapBip32Derivation && e.tapBip32Derivation.length || e.witnessUtxo && TV(e.witnessUtxo.script));
}
function AT(e, t) {
  return e && !!(e.tapInternalKey || e.tapTree || e.tapBip32Derivation && e.tapBip32Derivation.length || t);
}
function QR(e, t, r) {
  L8e(e, t, r), F8e(e, t, r);
}
function ez(e, t, r) {
  H8e(e, t, r), C8e(e, t);
}
function C8e(e, t) {
  if (!t.tapTree && !t.tapInternalKey) return;
  const r = t.tapInternalKey || e.tapInternalKey, n = t.tapTree || e.tapTree;
  if (r) {
    const { script: o } = e, i = B8e(r, n);
    if (o && dt(i, o) !== 0)
      throw new Error("Error adding output. Script or address mismatch.");
  }
}
function B8e(e, t) {
  const r = t && N8e(t.leaves), { output: n } = Y2({
    internalPubkey: e,
    scriptTree: r
  });
  return n;
}
function N8e(e = []) {
  return e.length === 1 && e[0].depth === 0 ? {
    output: e[0].script,
    version: e[0].leafVersion
  } : j8e(e);
}
function $8e(e, t) {
  return R8e(e).some(
    (r) => OV(r, U8e, t)
  );
}
function U8e(e) {
  return {
    signature: e.slice(0, 64),
    hashType: e.slice(64)[0] || Eo.SIGHASH_DEFAULT
  };
}
function R8e(e) {
  const t = [];
  if (e.tapKeySig && t.push(e.tapKeySig), e.tapScriptSig && t.push(...e.tapScriptSig.map((r) => r.signature)), !t.length) {
    const r = z8e(e.finalScriptWitness);
    r && t.push(r);
  }
  return t;
}
function z8e(e) {
  if (!e) return;
  const t = e.slice(2);
  if (t.length === 64 || t.length === 65) return t;
}
function j8e(e) {
  let t;
  for (const r of e)
    if (t = CO(r, t), !t) throw new Error("No room left to insert tapleaf in tree");
  return t;
}
function CO(e, t, r = 0) {
  if (r > O2e) throw new Error("Max taptree depth exceeded.");
  if (e.depth === r)
    return t ? void 0 : {
      output: e.script,
      version: e.leafVersion
    };
  if (vB(t)) return;
  const n = CO(e, t && t[0], r + 1);
  if (n) return [n, t && t[1]];
  const o = CO(e, t && t[1], r + 1);
  if (o) return [t && t[0], o];
}
function L8e(e, t, r) {
  const n = Eu(e) && I1(t), o = I1(e) && Eu(t), i = e === t && Eu(t) && I1(t);
  if (n || o || i)
    throw new Error(
      `Invalid arguments for Psbt.${r}. Cannot use both taproot and non-taproot fields.`
    );
}
function H8e(e, t, r) {
  const n = AT(e) && I1(t), o = I1(e) && AT(t), i = e === t && AT(t) && I1(t);
  if (n || o || i)
    throw new Error(
      `Invalid arguments for Psbt.${r}. Cannot use both taproot and non-taproot fields.`
    );
}
function F8e(e, t, r) {
  if (t.tapMerkleRoot) {
    const n = (t.tapLeafScript || []).every(
      (i) => xT(i, t.tapMerkleRoot)
    ), o = (e.tapLeafScript || []).every(
      (i) => xT(i, t.tapMerkleRoot)
    );
    if (!n || !o)
      throw new Error(
        `Invalid arguments for Psbt.${r}. Tapleaf not part of taptree.`
      );
  } else if (e.tapMerkleRoot && !(t.tapLeafScript || []).every(
    (n) => xT(n, e.tapMerkleRoot)
  ))
    throw new Error(
      `Invalid arguments for Psbt.${r}. Tapleaf not part of taptree.`
    );
}
function xT(e, t) {
  if (!t) return !0;
  const r = Jl({
    output: e.script,
    version: e.leafVersion
  }), n = TO(e.controlBlock, r);
  return dt(n, t) === 0;
}
function M8e(e, t) {
  const r = Jl({
    output: t.script,
    version: t.leafVersion
  });
  return (e.tapScriptSig || []).filter((n) => dt(n.leafHash, r) === 0).map((n) => D8e(t.script, n)).sort((n, o) => o.positionInScript - n.positionInScript).map((n) => n.signature);
}
function D8e(e, t) {
  return Object.assign(
    {
      positionInScript: IV(t.pubkey, e)
    },
    t
  );
}
function K8e(e, t, r) {
  if (!e.tapScriptSig || !e.tapScriptSig.length)
    throw new Error(
      `Can not finalize taproot input #${t}. No tapleaf script signature provided.`
    );
  const n = (e.tapLeafScript || []).sort((o, i) => o.controlBlock.length - i.controlBlock.length).find(
    (o) => q8e(o, e.tapScriptSig, r)
  );
  if (!n)
    throw new Error(
      `Can not finalize taproot input #${t}. Signature for tapleaf script not found.`
    );
  return n;
}
function q8e(e, t, r) {
  const n = Jl({
    output: e.script,
    version: e.leafVersion
  });
  return (!r || dt(n, r) === 0) && t.find((o) => dt(o.leafHash, n) === 0) !== void 0;
}
function I1(e) {
  return e && !!(e.redeemScript || e.witnessScript || e.bip32Derivation && e.bip32Derivation.length);
}
const V8e = {
  /**
   * A bitcoinjs Network object. This is only used if you pass an `address`
   * parameter to addOutput. Otherwise it is not needed and can be left default.
   */
  network: Xu,
  /**
   * When extractTransaction is called, the fee rate is checked.
   * THIS IS NOT TO BE RELIED ON.
   * It is only here as a last ditch effort to prevent sending a 500 BTC fee etc.
   */
  maximumFeeRate: 5e3
  // satoshi per byte
};
class Yr {
  constructor(t = {}, r = new XR(new PV())) {
    ut(this, "data"), ut(this, "__CACHE"), ut(this, "opts"), this.data = r, this.opts = Object.assign({}, V8e, t), this.__CACHE = {
      __NON_WITNESS_UTXO_TX_CACHE: [],
      __NON_WITNESS_UTXO_BUF_CACHE: [],
      __TX_IN_CACHE: {},
      __TX: this.data.globalMap.unsignedTx.tx,
      // Psbt's predecessor (TransactionBuilder - now removed) behavior
      // was to not confirm input values  before signing.
      // Even though we highly encourage people to get
      // the full parent transaction to verify values, the ability to
      // sign non-segwit inputs without the full transaction was often
      // requested. So the only way to activate is to use @ts-ignore.
      // We will disable exporting the Psbt when unsafe sign is active.
      // because it is not BIP174 compliant.
      __UNSAFE_SIGN_NONSEGWIT: !1
    }, this.data.inputs.length === 0 && this.setVersion(2);
    const n = (o, i, a, u) => Object.defineProperty(o, i, {
      enumerable: a,
      writable: u
    });
    n(this, "__CACHE", !1, !0), n(this, "opts", !1, !0);
  }
  static fromBase64(t, r = {}) {
    const n = Uq(t);
    return this.fromBuffer(n, r);
  }
  static fromHex(t, r = {}) {
    const n = vf(t);
    return this.fromBuffer(n, r);
  }
  static fromBuffer(t, r = {}) {
    const n = XR.fromBuffer(t, G8e), o = new Yr(r, n);
    return J8e(o.__CACHE.__TX, o.__CACHE), o;
  }
  get inputCount() {
    return this.data.inputs.length;
  }
  get version() {
    return this.__CACHE.__TX.version;
  }
  set version(t) {
    this.setVersion(t);
  }
  get locktime() {
    return this.__CACHE.__TX.locktime;
  }
  set locktime(t) {
    this.setLocktime(t);
  }
  get txInputs() {
    return this.__CACHE.__TX.ins.map((t) => ({
      hash: MR(t.hash),
      index: t.index,
      sequence: t.sequence
    }));
  }
  get txOutputs() {
    return this.__CACHE.__TX.outs.map((t) => {
      let r;
      try {
        r = J2(t.script, this.opts.network);
      } catch {
      }
      return {
        script: MR(t.script),
        value: t.value,
        address: r
      };
    });
  }
  combine(...t) {
    return this.data.combine(...t.map((r) => r.data)), this;
  }
  clone() {
    const t = Yr.fromBuffer(this.data.toBuffer());
    return t.opts = JSON.parse(JSON.stringify(this.opts)), t;
  }
  setMaximumFeeRate(t) {
    u8(t), this.opts.maximumFeeRate = t;
  }
  setVersion(t) {
    u8(t), $b(this.data.inputs, "setVersion");
    const r = this.__CACHE;
    return r.__TX.version = t, r.__EXTRACTED_TX = void 0, this;
  }
  setLocktime(t) {
    u8(t), $b(this.data.inputs, "setLocktime");
    const r = this.__CACHE;
    return r.__TX.locktime = t, r.__EXTRACTED_TX = void 0, this;
  }
  setInputSequence(t, r) {
    u8(r), $b(this.data.inputs, "setInputSequence");
    const n = this.__CACHE;
    if (n.__TX.ins.length <= t)
      throw new Error("Input index too high");
    return n.__TX.ins[t].sequence = r, n.__EXTRACTED_TX = void 0, this;
  }
  addInputs(t) {
    return t.forEach((r) => this.addInput(r)), this;
  }
  addInput(t) {
    if (arguments.length > 1 || !t || t.hash === void 0 || t.index === void 0)
      throw new Error(
        "Invalid arguments for Psbt.addInput. Requires single object with at least [hash] and [index]"
      );
    QR(t, t, "addInput"), $b(this.data.inputs, "addInput"), t.witnessScript && t5(t.witnessScript);
    const r = this.__CACHE;
    this.data.addInput(t);
    const n = r.__TX.ins[r.__TX.ins.length - 1];
    NV(r, n);
    const o = this.data.inputs.length - 1, i = this.data.inputs[o];
    return i.nonWitnessUtxo && NO(this.__CACHE, i, o), r.__FEE = void 0, r.__FEE_RATE = void 0, r.__EXTRACTED_TX = void 0, this;
  }
  addOutputs(t) {
    return t.forEach((r) => this.addOutput(r)), this;
  }
  addOutput(t) {
    if (arguments.length > 1 || !t || t.value === void 0 || t.address === void 0 && t.script === void 0)
      throw new Error(
        "Invalid arguments for Psbt.addOutput. Requires single object with at least [script or address] and [value]"
      );
    $b(this.data.inputs, "addOutput");
    const { address: r } = t;
    if (typeof r == "string") {
      const { network: o } = this.opts, i = df(r, o);
      t = Object.assign({}, t, { script: i });
    }
    ez(t, t, "addOutput");
    const n = this.__CACHE;
    return this.data.addOutput(t), n.__FEE = void 0, n.__FEE_RATE = void 0, n.__EXTRACTED_TX = void 0, this;
  }
  extractTransaction(t) {
    if (!this.data.inputs.every(CV)) throw new Error("Not finalized");
    const r = this.__CACHE;
    if (t || Z8e(this, r, this.opts), r.__EXTRACTED_TX) return r.__EXTRACTED_TX;
    const n = r.__TX.clone();
    return LV(this.data.inputs, n, r, !0), n;
  }
  getFeeRate() {
    return iz(
      "__FEE_RATE",
      "fee rate",
      this.data.inputs,
      this.__CACHE
    );
  }
  getFee() {
    return iz("__FEE", "fee", this.data.inputs, this.__CACHE);
  }
  finalizeAllInputs() {
    return Ai(this.data.inputs, 0), Ub(this.data.inputs.length).forEach((t) => this.finalizeInput(t)), this;
  }
  finalizeInput(t, r) {
    const n = Ai(this.data.inputs, t);
    return Eu(n) ? this._finalizeTaprootInput(
      t,
      n,
      void 0,
      r
    ) : this._finalizeInput(t, n, r);
  }
  finalizeTaprootInput(t, r, n = JR) {
    const o = Ai(this.data.inputs, t);
    if (Eu(o))
      return this._finalizeTaprootInput(
        t,
        o,
        r,
        n
      );
    throw new Error(`Cannot finalize input #${t}. Not Taproot.`);
  }
  _finalizeInput(t, r, n = Q8e) {
    const { script: o, isP2SH: i, isP2WSH: a, isSegwit: u } = n3e(
      t,
      r,
      this.__CACHE
    );
    if (!o) throw new Error(`No script found for input #${t}`);
    X8e(r);
    const { finalScriptSig: l, finalScriptWitness: d } = n(
      t,
      r,
      o,
      u,
      i,
      a
    );
    if (l && this.data.updateInput(t, { finalScriptSig: l }), d && this.data.updateInput(t, { finalScriptWitness: d }), !l && !d)
      throw new Error(`Unknown error finalizing input #${t}`);
    return this.data.clearFinalizedInput(t), this;
  }
  _finalizeTaprootInput(t, r, n, o = JR) {
    if (!r.witnessUtxo)
      throw new Error(
        `Cannot finalize input #${t}. Missing withness utxo.`
      );
    if (r.tapKeySig) {
      const i = Y2({
        output: r.witnessUtxo.script,
        signature: r.tapKeySig
      }), a = e5(i.witness);
      this.data.updateInput(t, { finalScriptWitness: a });
    } else {
      const { finalScriptWitness: i } = o(
        t,
        r,
        n
      );
      this.data.updateInput(t, { finalScriptWitness: i });
    }
    return this.data.clearFinalizedInput(t), this;
  }
  getInputType(t) {
    const r = Ai(this.data.inputs, t), n = HV(t, r, this.__CACHE), o = tE(
      n,
      t,
      "input",
      r.redeemScript || u3e(r.finalScriptSig),
      r.witnessScript || c3e(r.finalScriptWitness)
    ), i = o.type === "raw" ? "" : o.type + "-", a = MV(o.meaningfulScript);
    return i + a;
  }
  inputHasPubkey(t, r) {
    const n = Ai(this.data.inputs, t);
    return a3e(r, n, t, this.__CACHE);
  }
  inputHasHDKey(t, r) {
    const n = Ai(this.data.inputs, t), o = rz(r);
    return !!n.bip32Derivation && n.bip32Derivation.some(o);
  }
  outputHasPubkey(t, r) {
    const n = Kw(this.data.outputs, t);
    return s3e(r, n, t, this.__CACHE);
  }
  outputHasHDKey(t, r) {
    const n = Kw(this.data.outputs, t), o = rz(r);
    return !!n.bip32Derivation && n.bip32Derivation.some(o);
  }
  validateSignaturesOfAllInputs(t) {
    return Ai(this.data.inputs, 0), Ub(this.data.inputs.length).map(
      (r) => this.validateSignaturesOfInput(r, t)
    ).reduce((r, n) => n === !0 && r, !0);
  }
  validateSignaturesOfInput(t, r, n) {
    const o = this.data.inputs[t];
    return Eu(o) ? this.validateSignaturesOfTaprootInput(
      t,
      r,
      n
    ) : this._validateSignaturesOfInput(t, r, n);
  }
  _validateSignaturesOfInput(t, r, n) {
    const o = this.data.inputs[t], i = (o || {}).partialSig;
    if (!o || !i || i.length < 1)
      throw new Error("No signatures to validate");
    if (typeof r != "function")
      throw new Error("Need validator function to validate signatures");
    const a = n ? i.filter((h) => dt(h.pubkey, n) === 0) : i;
    if (a.length < 1) throw new Error("No signatures for this pubkey");
    const u = [];
    let l, d, f;
    for (const h of a) {
      const g = ow.decode(h.signature), { hash: b, script: w } = f !== g.hashType ? UV(
        t,
        Object.assign({}, o, { sighashType: g.hashType }),
        this.__CACHE,
        !0
      ) : { hash: l, script: d };
      f = g.hashType, l = b, d = w, BV(h.pubkey, w, "verify"), u.push(r(h.pubkey, b, g.signature));
    }
    return u.every((h) => h === !0);
  }
  validateSignaturesOfTaprootInput(t, r, n) {
    const o = this.data.inputs[t], i = (o || {}).tapKeySig, a = (o || {}).tapScriptSig;
    if (!o && !i && !(a && !a.length))
      throw new Error("No signatures to validate");
    if (typeof r != "function")
      throw new Error("Need validator function to validate signatures");
    n = n && Uu(n);
    const u = n ? BO(
      t,
      o,
      this.data.inputs,
      n,
      this.__CACHE
    ) : t3e(
      t,
      o,
      this.data.inputs,
      this.__CACHE
    );
    if (!u.length) throw new Error("No signatures for this pubkey");
    const l = u.find((f) => !f.leafHash);
    let d = 0;
    if (i && l) {
      if (!r(
        l.pubkey,
        l.hash,
        sz(i)
      )) return !1;
      d++;
    }
    if (a)
      for (const f of a) {
        const h = u.find(
          (g) => dt(g.pubkey, f.pubkey) === 0
        );
        if (h) {
          if (!r(
            f.pubkey,
            h.hash,
            sz(f.signature)
          )) return !1;
          d++;
        }
      }
    return d > 0;
  }
  signAllInputsHD(t, r = [Eo.SIGHASH_ALL]) {
    if (!t || !t.publicKey || !t.fingerprint)
      throw new Error("Need HDSigner to sign input");
    const n = [];
    for (const o of Ub(this.data.inputs.length))
      try {
        this.signInputHD(o, t, r), n.push(!0);
      } catch {
        n.push(!1);
      }
    if (n.every((o) => o === !1))
      throw new Error("No inputs were signed");
    return this;
  }
  signAllInputsHDAsync(t, r = [Eo.SIGHASH_ALL]) {
    return new Promise((n, o) => {
      if (!t || !t.publicKey || !t.fingerprint)
        return o(new Error("Need HDSigner to sign input"));
      const i = [], a = [];
      for (const u of Ub(this.data.inputs.length))
        a.push(
          this.signInputHDAsync(u, t, r).then(
            () => {
              i.push(!0);
            },
            () => {
              i.push(!1);
            }
          )
        );
      return Promise.all(a).then(() => {
        if (i.every((u) => u === !1))
          return o(new Error("No inputs were signed"));
        n();
      });
    });
  }
  signInputHD(t, r, n = [Eo.SIGHASH_ALL]) {
    if (!r || !r.publicKey || !r.fingerprint)
      throw new Error("Need HDSigner to sign input");
    return uz(t, this.data.inputs, r).forEach((o) => this.signInput(t, o, n)), this;
  }
  signInputHDAsync(t, r, n = [Eo.SIGHASH_ALL]) {
    return new Promise((o, i) => {
      if (!r || !r.publicKey || !r.fingerprint)
        return i(new Error("Need HDSigner to sign input"));
      const a = uz(t, this.data.inputs, r).map(
        (u) => this.signInputAsync(t, u, n)
      );
      return Promise.all(a).then(() => {
        o();
      }).catch(i);
    });
  }
  signAllInputs(t, r) {
    if (!t || !t.publicKey)
      throw new Error("Need Signer to sign input");
    const n = [];
    for (const o of Ub(this.data.inputs.length))
      try {
        this.signInput(o, t, r), n.push(!0);
      } catch {
        n.push(!1);
      }
    if (n.every((o) => o === !1))
      throw new Error("No inputs were signed");
    return this;
  }
  signAllInputsAsync(t, r) {
    return new Promise((n, o) => {
      if (!t || !t.publicKey)
        return o(new Error("Need Signer to sign input"));
      const i = [], a = [];
      for (const [u] of this.data.inputs.entries())
        a.push(
          this.signInputAsync(u, t, r).then(
            () => {
              i.push(!0);
            },
            () => {
              i.push(!1);
            }
          )
        );
      return Promise.all(a).then(() => {
        if (i.every((u) => u === !1))
          return o(new Error("No inputs were signed"));
        n();
      });
    });
  }
  signInput(t, r, n) {
    if (!r || !r.publicKey)
      throw new Error("Need Signer to sign input");
    const o = Ai(this.data.inputs, t);
    return Eu(o) ? this._signTaprootInput(
      t,
      o,
      r,
      void 0,
      n
    ) : this._signInput(t, r, n);
  }
  signTaprootInput(t, r, n, o) {
    if (!r || !r.publicKey)
      throw new Error("Need Signer to sign input");
    const i = Ai(this.data.inputs, t);
    if (Eu(i))
      return this._signTaprootInput(
        t,
        i,
        r,
        n,
        o
      );
    throw new Error(`Input #${t} is not of type Taproot.`);
  }
  _signInput(t, r, n = [Eo.SIGHASH_ALL]) {
    const { hash: o, sighashType: i } = az(
      this.data.inputs,
      t,
      r.publicKey,
      this.__CACHE,
      n
    ), a = [
      {
        pubkey: r.publicKey,
        signature: ow.encode(r.sign(o), i)
      }
    ];
    return this.data.updateInput(t, { partialSig: a }), this;
  }
  _signTaprootInput(t, r, n, o, i = [Eo.SIGHASH_DEFAULT]) {
    const a = this.checkTaprootHashesForSig(
      t,
      r,
      n,
      o,
      i
    ), u = a.filter((d) => !d.leafHash).map(
      (d) => s8(
        n.signSchnorr(d.hash),
        r.sighashType
      )
    )[0], l = a.filter((d) => !!d.leafHash).map((d) => ({
      pubkey: Uu(n.publicKey),
      signature: s8(
        n.signSchnorr(d.hash),
        r.sighashType
      ),
      leafHash: d.leafHash
    }));
    return u && this.data.updateInput(t, { tapKeySig: u }), l.length && this.data.updateInput(t, { tapScriptSig: l }), this;
  }
  signInputAsync(t, r, n) {
    return Promise.resolve().then(() => {
      if (!r || !r.publicKey)
        throw new Error("Need Signer to sign input");
      const o = Ai(this.data.inputs, t);
      return Eu(o) ? this._signTaprootInputAsync(
        t,
        o,
        r,
        void 0,
        n
      ) : this._signInputAsync(t, r, n);
    });
  }
  signTaprootInputAsync(t, r, n, o) {
    return Promise.resolve().then(() => {
      if (!r || !r.publicKey)
        throw new Error("Need Signer to sign input");
      const i = Ai(this.data.inputs, t);
      if (Eu(i))
        return this._signTaprootInputAsync(
          t,
          i,
          r,
          n,
          o
        );
      throw new Error(`Input #${t} is not of type Taproot.`);
    });
  }
  _signInputAsync(t, r, n = [Eo.SIGHASH_ALL]) {
    const { hash: o, sighashType: i } = az(
      this.data.inputs,
      t,
      r.publicKey,
      this.__CACHE,
      n
    );
    return Promise.resolve(r.sign(o)).then((a) => {
      const u = [
        {
          pubkey: r.publicKey,
          signature: ow.encode(a, i)
        }
      ];
      this.data.updateInput(t, { partialSig: u });
    });
  }
  async _signTaprootInputAsync(t, r, n, o, i = [Eo.SIGHASH_DEFAULT]) {
    const a = this.checkTaprootHashesForSig(
      t,
      r,
      n,
      o,
      i
    ), u = [], l = a.filter((f) => !f.leafHash)[0];
    if (l) {
      const f = Promise.resolve(
        n.signSchnorr(l.hash)
      ).then((h) => ({ tapKeySig: s8(h, r.sighashType) }));
      u.push(f);
    }
    const d = a.filter((f) => !!f.leafHash);
    if (d.length) {
      const f = d.map((h) => Promise.resolve(n.signSchnorr(h.hash)).then(
        (g) => ({ tapScriptSig: [
          {
            pubkey: Uu(n.publicKey),
            signature: s8(
              g,
              r.sighashType
            ),
            leafHash: h.leafHash
          }
        ] })
      ));
      u.push(...f);
    }
    return Promise.all(u).then((f) => {
      f.forEach((h) => this.data.updateInput(t, h));
    });
  }
  checkTaprootHashesForSig(t, r, n, o, i) {
    if (typeof n.signSchnorr != "function")
      throw new Error(
        `Need Schnorr Signer to sign taproot input #${t}.`
      );
    const a = BO(
      t,
      r,
      this.data.inputs,
      n.publicKey,
      this.__CACHE,
      o,
      i
    );
    if (!a || !a.length)
      throw new Error(
        `Can not sign for input #${t} with the key ${Wt(n.publicKey)}`
      );
    return a;
  }
  toBuffer() {
    return kT(this.__CACHE), this.data.toBuffer();
  }
  toHex() {
    return kT(this.__CACHE), this.data.toHex();
  }
  toBase64() {
    return kT(this.__CACHE), this.data.toBase64();
  }
  updateGlobal(t) {
    return this.data.updateGlobal(t), this;
  }
  updateInput(t, r) {
    return r.witnessScript && t5(r.witnessScript), QR(
      this.data.inputs[t],
      r,
      "updateInput"
    ), this.data.updateInput(t, r), r.nonWitnessUtxo && NO(
      this.__CACHE,
      this.data.inputs[t],
      t
    ), this;
  }
  updateOutput(t, r) {
    const n = this.data.outputs[t];
    return ez(n, r, "updateOutput"), this.data.updateOutput(t, r), this;
  }
  addUnknownKeyValToGlobal(t) {
    return this.data.addUnknownKeyValToGlobal(t), this;
  }
  addUnknownKeyValToInput(t, r) {
    return this.data.addUnknownKeyValToInput(t, r), this;
  }
  addUnknownKeyValToOutput(t, r) {
    return this.data.addUnknownKeyValToOutput(t, r), this;
  }
  clearFinalizedInput(t) {
    return this.data.clearFinalizedInput(t), this;
  }
}
const G8e = (e) => new PV(e);
class PV {
  constructor(t = Uint8Array.from([2, 0, 0, 0, 0, 0, 0, 0, 0, 0])) {
    ut(this, "tx"), this.tx = Eo.fromBuffer(t), Y8e(this.tx), Object.defineProperty(this, "tx", {
      enumerable: !1,
      writable: !0
    });
  }
  getInputOutputCounts() {
    return {
      inputCount: this.tx.ins.length,
      outputCount: this.tx.outs.length
    };
  }
  addInput(t) {
    if (t.hash === void 0 || t.index === void 0 || !(t.hash instanceof Uint8Array) && typeof t.hash != "string" || typeof t.index != "number")
      throw new Error("Error adding input.");
    const r = typeof t.hash == "string" ? CB(vf(t.hash)) : t.hash;
    this.tx.addInput(r, t.index, t.sequence);
  }
  addOutput(t) {
    if (t.script === void 0 || t.value === void 0 || !(t.script instanceof Uint8Array) || typeof t.value != "bigint")
      throw new Error("Error adding output.");
    this.tx.addOutput(t.script, t.value);
  }
  toBuffer() {
    return this.tx.toBuffer();
  }
}
function W8e(e, t, r) {
  switch (r) {
    case "pubkey":
    case "pubkeyhash":
    case "witnesspubkeyhash":
      return tz(1, e.partialSig);
    case "multisig":
      const n = X4({ output: t });
      return tz(n.m, e.partialSig, n.pubkeys);
    default:
      return !1;
  }
}
function kT(e) {
  if (e.__UNSAFE_SIGN_NONSEGWIT !== !1)
    throw new Error("Not BIP174 compliant, can not export");
}
function tz(e, t, r) {
  if (!t) return !1;
  let n;
  if (r ? n = r.map((o) => {
    const i = l3e(o);
    return t.find(
      (a) => dt(a.pubkey, i) === 0
    );
  }).filter((o) => !!o) : n = t, n.length > e) throw new Error("Too many signatures");
  return n.length === e;
}
function CV(e) {
  return !!e.finalScriptSig || !!e.finalScriptWitness;
}
function rz(e) {
  return (t) => !(dt(e.fingerprint, t.masterFingerprint) || dt(e.derivePath(t.path).publicKey, t.pubkey));
}
function u8(e) {
  if (typeof e != "number" || e !== Math.floor(e) || e > 4294967295 || e < 0)
    throw new Error("Invalid 32 bit integer");
}
function Z8e(e, t, r) {
  const n = t.__FEE_RATE || e.getFeeRate(), o = t.__EXTRACTED_TX.virtualSize(), i = n * o;
  if (n >= r.maximumFeeRate)
    throw new Error(
      `Warning: You are paying around ${(i / 1e8).toFixed(8)} in fees, which is ${n} satoshi per byte for a transaction with a VSize of ${o} bytes (segwit counted as 0.25 byte per byte). Use setMaximumFeeRate method to raise your threshold, or pass true to the first arg of extractTransaction.`
    );
}
function $b(e, t) {
  e.forEach((r) => {
    if (Eu(r) ? $8e(r, t) : I8e(r, t))
      throw new Error("Can not modify transaction, signatures exist.");
  });
}
function X8e(e) {
  if (!e.sighashType || !e.partialSig) return;
  const { partialSig: t, sighashType: r } = e;
  t.forEach((n) => {
    const { hashType: o } = ow.decode(n.signature);
    if (r !== o)
      throw new Error("Signature sighash does not match input sighash type");
  });
}
function BV(e, t, r) {
  if (!Q4(e, t))
    throw new Error(
      `Can not ${r} for this input with the key ${Wt(e)}`
    );
}
function Y8e(e) {
  if (!e.ins.every(
    (t) => t.script && t.script.length === 0 && t.witness && t.witness.length === 0
  ))
    throw new Error("Format Error: Transaction ScriptSigs are not empty");
}
function J8e(e, t) {
  e.ins.forEach((r) => {
    NV(t, r);
  });
}
function NV(e, t) {
  const r = Wt(CB(Uint8Array.from(t.hash))) + ":" + t.index;
  if (e.__TX_IN_CACHE[r]) throw new Error("Duplicate input detected.");
  e.__TX_IN_CACHE[r] = 1;
}
function $V(e, t) {
  return (r, n, o, i) => {
    const a = e({
      redeem: { output: o }
    }).output;
    if (dt(n, a))
      throw new Error(
        `${t} for ${i} #${r} doesn't match the scriptPubKey in the prevout`
      );
  };
}
const nz = $V($g, "Redeem script"), oz = $V(
  X2,
  "Witness script"
);
function iz(e, t, r, n) {
  if (!r.every(CV))
    throw new Error(`PSBT must be finalized to calculate ${t}`);
  if (e === "__FEE_RATE" && n.__FEE_RATE) return n.__FEE_RATE;
  if (e === "__FEE" && n.__FEE) return n.__FEE;
  let o, i = !0;
  if (n.__EXTRACTED_TX ? (o = n.__EXTRACTED_TX, i = !1) : o = n.__TX.clone(), LV(r, o, n, i), e === "__FEE_RATE") return n.__FEE_RATE;
  if (e === "__FEE") return n.__FEE;
}
function Q8e(e, t, r, n, o, i) {
  const a = MV(r);
  if (!W8e(t, r, a))
    throw new Error(`Can not finalize input #${e}`);
  return e3e(
    r,
    a,
    t.partialSig,
    n,
    o,
    i
  );
}
function e3e(e, t, r, n, o, i) {
  let a, u;
  const l = r3e(e, t, r), d = i ? X2({ redeem: l }) : null, f = o ? $g({ redeem: d || l }) : null;
  return n ? (d ? u = e5(d.witness) : u = e5(l.witness), f && (a = f.input)) : f ? a = f.input : a = l.input, {
    finalScriptSig: a,
    finalScriptWitness: u
  };
}
function az(e, t, r, n, o) {
  const i = Ai(e, t), { hash: a, sighashType: u, script: l } = UV(
    t,
    i,
    n,
    !1,
    o
  );
  return BV(r, l, "sign"), {
    hash: a,
    sighashType: u
  };
}
function UV(e, t, r, n, o) {
  const i = r.__TX, a = t.sighashType || Eo.SIGHASH_ALL;
  zV(a, o);
  let u, l;
  if (t.nonWitnessUtxo) {
    const h = eE(
      r,
      t,
      e
    ), g = i.ins[e].hash, b = h.getHash();
    if (dt(g, b) !== 0)
      throw new Error(
        `Non-witness UTXO hash for input #${e} doesn't match the hash specified in the prevout`
      );
    const w = i.ins[e].index;
    l = h.outs[w];
  } else if (t.witnessUtxo)
    l = t.witnessUtxo;
  else
    throw new Error("Need a Utxo input item for signing");
  const { meaningfulScript: d, type: f } = tE(
    l.script,
    e,
    "input",
    t.redeemScript,
    t.witnessScript
  );
  if (["p2sh-p2wsh", "p2wsh"].indexOf(f) >= 0)
    u = i.hashForWitnessV0(
      e,
      d,
      l.value,
      a
    );
  else if (J4(d)) {
    const h = W2({
      hash: d.slice(2)
    }).output;
    u = i.hashForWitnessV0(
      e,
      h,
      l.value,
      a
    );
  } else {
    if (t.nonWitnessUtxo === void 0 && r.__UNSAFE_SIGN_NONSEGWIT === !1)
      throw new Error(
        `Input #${e} has witnessUtxo but non-segwit script: ${Wt(d)}`
      );
    !n && r.__UNSAFE_SIGN_NONSEGWIT !== !1 && console.warn(
      `Warning: Signing non-segwit inputs without the full parent transaction means there is a chance that a miner could feed you incorrect information to trick you into paying large fees. This behavior is the same as Psbt's predecessor (TransactionBuilder - now removed) when signing non-segwit scripts. You are not able to export this Psbt with toBuffer|toBase64|toHex since it is not BIP174 compliant.
*********************
PROCEED WITH CAUTION!
*********************`
    ), u = i.hashForSignature(
      e,
      d,
      a
    );
  }
  return {
    script: d,
    sighashType: a,
    hash: u
  };
}
function t3e(e, t, r, n) {
  const o = [];
  if (t.tapInternalKey) {
    const i = RV(e, t, n);
    i && o.push(i);
  }
  if (t.tapScriptSig) {
    const i = t.tapScriptSig.map((a) => a.pubkey);
    o.push(...i);
  }
  return o.map(
    (i) => BO(e, t, r, i, n)
  ).flat();
}
function RV(e, t, r) {
  const { script: n } = zB(e, t, r);
  return TV(n) ? n.subarray(2, 34) : null;
}
function sz(e) {
  return e.length === 64 ? e : e.subarray(0, 64);
}
function BO(e, t, r, n, o, i, a) {
  const u = o.__TX, l = t.sighashType || Eo.SIGHASH_DEFAULT;
  zV(l, a);
  const d = r.map(
    (w, E) => zB(E, w, o)
  ), f = d.map((w) => w.script), h = d.map((w) => w.value), g = [];
  if (t.tapInternalKey && !i) {
    const w = RV(e, t, o) || Uint8Array.from([]);
    if (dt(Uu(n), w) === 0) {
      const E = u.hashForWitnessV1(
        e,
        f,
        h,
        l
      );
      g.push({ pubkey: n, hash: E });
    }
  }
  const b = (t.tapLeafScript || []).filter((w) => Q4(n, w.script)).map((w) => {
    const E = Jl({
      output: w.script,
      version: w.leafVersion
    });
    return Object.assign({ hash: E }, w);
  }).filter(
    (w) => !i || dt(i, w.hash) === 0
  ).map((w) => {
    const E = u.hashForWitnessV1(
      e,
      f,
      h,
      l,
      w.hash
    );
    return {
      pubkey: n,
      hash: E,
      leafHash: w.hash
    };
  });
  return g.concat(b);
}
function zV(e, t) {
  if (t && t.indexOf(e) < 0) {
    const r = i3e(e);
    throw new Error(
      `Sighash type is not allowed. Retry the sign method passing the sighashTypes array of whitelisted types. Sighash type: ${r}`
    );
  }
}
function r3e(e, t, r) {
  let n;
  switch (t) {
    case "multisig":
      const o = o3e(e, r);
      n = X4({
        output: e,
        signatures: o
      });
      break;
    case "pubkey":
      n = Jq({
        output: e,
        signature: r[0].signature
      });
      break;
    case "pubkeyhash":
      n = W2({
        output: e,
        pubkey: r[0].pubkey,
        signature: r[0].signature
      });
      break;
    case "witnesspubkeyhash":
      n = Z2({
        output: e,
        pubkey: r[0].pubkey,
        signature: r[0].signature
      });
      break;
  }
  return n;
}
function n3e(e, t, r) {
  const n = r.__TX, o = {
    script: null,
    isSegwit: !1,
    isP2SH: !1,
    isP2WSH: !1
  };
  if (o.isP2SH = !!t.redeemScript, o.isP2WSH = !!t.witnessScript, t.witnessScript)
    o.script = t.witnessScript;
  else if (t.redeemScript)
    o.script = t.redeemScript;
  else if (t.nonWitnessUtxo) {
    const i = eE(
      r,
      t,
      e
    ), a = n.ins[e].index;
    o.script = i.outs[a].script;
  } else t.witnessUtxo && (o.script = t.witnessUtxo.script);
  return (t.witnessScript || J4(o.script)) && (o.isSegwit = !0), o;
}
function uz(e, t, r) {
  const n = Ai(t, e);
  if (!n.bip32Derivation || n.bip32Derivation.length === 0)
    throw new Error("Need bip32Derivation to sign with HD");
  const o = n.bip32Derivation.map((i) => {
    if (dt(i.masterFingerprint, r.fingerprint) === 0)
      return i;
  }).filter((i) => !!i);
  if (o.length === 0)
    throw new Error(
      "Need one bip32Derivation masterFingerprint to match the HDSigner fingerprint"
    );
  return o.map((i) => {
    const a = r.derivePath(i.path);
    if (dt(i.pubkey, a.publicKey) !== 0)
      throw new Error("pubkey did not match bip32Derivation");
    return a;
  });
}
function o3e(e, t) {
  return X4({ output: e }).pubkeys.map((r) => (t.filter((n) => dt(n.pubkey, r) === 0)[0] || {}).signature).filter((r) => !!r);
}
function jV(e) {
  let t = 0;
  function r(a) {
    return t += a, e.slice(t - a, t);
  }
  function n() {
    const a = Ug(e, t);
    return t += qs(a.bigintValue), a.numberValue;
  }
  function o() {
    return r(n());
  }
  function i() {
    const a = n(), u = [];
    for (let l = 0; l < a; l++) u.push(o());
    return u;
  }
  return i();
}
function i3e(e) {
  let t = e & Eo.SIGHASH_ANYONECANPAY ? "SIGHASH_ANYONECANPAY | " : "";
  switch (e & 31) {
    case Eo.SIGHASH_ALL:
      t += "SIGHASH_ALL";
      break;
    case Eo.SIGHASH_SINGLE:
      t += "SIGHASH_SINGLE";
      break;
    case Eo.SIGHASH_NONE:
      t += "SIGHASH_NONE";
      break;
  }
  return t;
}
function NO(e, t, r) {
  e.__NON_WITNESS_UTXO_BUF_CACHE[r] = t.nonWitnessUtxo;
  const n = Eo.fromBuffer(t.nonWitnessUtxo);
  e.__NON_WITNESS_UTXO_TX_CACHE[r] = n;
  const o = e, i = r;
  delete t.nonWitnessUtxo, Object.defineProperty(t, "nonWitnessUtxo", {
    enumerable: !0,
    get() {
      const a = o.__NON_WITNESS_UTXO_BUF_CACHE[i], u = o.__NON_WITNESS_UTXO_TX_CACHE[i];
      if (a !== void 0)
        return a;
      {
        const l = u.toBuffer();
        return o.__NON_WITNESS_UTXO_BUF_CACHE[i] = l, l;
      }
    },
    set(a) {
      o.__NON_WITNESS_UTXO_BUF_CACHE[i] = a;
    }
  });
}
function LV(e, t, r, n) {
  let o = 0n;
  e.forEach((l, d) => {
    if (n && l.finalScriptSig && (t.ins[d].script = l.finalScriptSig), n && l.finalScriptWitness && (t.ins[d].witness = jV(
      l.finalScriptWitness
    )), l.witnessUtxo)
      o += l.witnessUtxo.value;
    else if (l.nonWitnessUtxo) {
      const f = eE(r, l, d), h = t.ins[d].index, g = f.outs[h];
      o += g.value;
    }
  });
  const i = t.outs.reduce((l, d) => l + d.value, 0n), a = o - i;
  if (a < 0)
    throw new Error("Outputs are spending more than Inputs");
  const u = t.virtualSize();
  r.__FEE = a, r.__EXTRACTED_TX = t, r.__FEE_RATE = Math.floor(Number(a / BigInt(u)));
}
function eE(e, t, r) {
  const n = e.__NON_WITNESS_UTXO_TX_CACHE;
  return n[r] || NO(e, t, r), n[r];
}
function HV(e, t, r) {
  const { script: n } = zB(e, t, r);
  return n;
}
function zB(e, t, r) {
  if (t.witnessUtxo !== void 0)
    return {
      script: t.witnessUtxo.script,
      value: t.witnessUtxo.value
    };
  if (t.nonWitnessUtxo !== void 0) {
    const n = eE(
      r,
      t,
      e
    ).outs[r.__TX.ins[e].index];
    return { script: n.script, value: n.value };
  } else
    throw new Error("Can't find pubkey in input without Utxo data");
}
function a3e(e, t, r, n) {
  const o = HV(r, t, n), { meaningfulScript: i } = tE(
    o,
    r,
    "input",
    t.redeemScript,
    t.witnessScript
  );
  return Q4(e, i);
}
function s3e(e, t, r, n) {
  const o = n.__TX.outs[r].script, { meaningfulScript: i } = tE(
    o,
    r,
    "output",
    t.redeemScript,
    t.witnessScript
  );
  return Q4(e, i);
}
function u3e(e) {
  if (!e) return;
  const t = ro(e);
  if (!t) return;
  const r = t[t.length - 1];
  if (!(!(r instanceof Uint8Array) || FV(r) || f3e(r) || !ro(r)))
    return r;
}
function c3e(e) {
  if (!e) return;
  const t = jV(e), r = t[t.length - 1];
  if (!(FV(r) || !ro(r)))
    return r;
}
function l3e(e) {
  if (e.length === 65) {
    const t = e[64] & 1, r = e.slice(0, 33);
    return r[0] = 2 | t, r;
  }
  return e.slice();
}
function FV(e) {
  return e.length === 33 && Mwe(e);
}
function f3e(e) {
  return ff(e);
}
function tE(e, t, r, n, o) {
  const i = SV(e), a = i && n && YR(n), u = YR(e);
  if (i && n === void 0)
    throw new Error("scriptPubkey is P2SH but redeemScript missing");
  if ((u || a) && o === void 0)
    throw new Error(
      "scriptPubkey or redeemScript is P2WSH but witnessScript missing"
    );
  let l;
  return a ? (l = o, nz(t, e, n, r), oz(t, n, o, r), t5(l)) : u ? (l = o, oz(t, e, o, r), t5(l)) : i ? (l = n, nz(t, e, n, r)) : l = e, {
    meaningfulScript: l,
    type: a ? "p2sh-p2wsh" : i ? "p2sh" : u ? "p2wsh" : "raw"
  };
}
function t5(e) {
  if (J4(e) || SV(e))
    throw new Error("P2WPKH or P2SH can not be contained within P2WSH");
}
function MV(e) {
  return J4(e) ? "witnesspubkeyhash" : T8e(e) ? "pubkeyhash" : k8e(e) ? "multisig" : S8e(e) ? "pubkey" : "nonstandard";
}
function Ub(e) {
  return [...Array(e).keys()];
}
var Ru = {}, rh = {}, $c = {};
Object.defineProperty($c, "__esModule", { value: !0 });
$c.anumber = $O;
$c.abytes = DV;
$c.ahash = h3e;
$c.aexists = p3e;
$c.aoutput = g3e;
function $O(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error("positive integer expected, got " + e);
}
function d3e(e) {
  return e instanceof Uint8Array || ArrayBuffer.isView(e) && e.constructor.name === "Uint8Array";
}
function DV(e, ...t) {
  if (!d3e(e))
    throw new Error("Uint8Array expected");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error("Uint8Array expected of length " + t + ", got length=" + e.length);
}
function h3e(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  $O(e.outputLen), $O(e.blockLen);
}
function p3e(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function g3e(e, t) {
  DV(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error("digestInto() expects output buffer of length at least " + r);
}
var Vs = {}, rE = {};
Object.defineProperty(rE, "__esModule", { value: !0 });
rE.crypto = void 0;
rE.crypto = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
(function(e) {
  /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Hash = e.nextTick = e.byteSwapIfBE = e.isLE = void 0, e.isBytes = n, e.u8 = o, e.u32 = i, e.createView = a, e.rotr = u, e.rotl = l, e.byteSwap = d, e.byteSwap32 = f, e.bytesToHex = g, e.hexToBytes = E, e.asyncLoop = O, e.utf8ToBytes = C, e.toBytes = I, e.concatBytes = S, e.checkOpts = A, e.wrapConstructor = $, e.wrapConstructorWithOpts = U, e.wrapXOFConstructorWithOpts = M, e.randomBytes = Y;
  const t = rE, r = $c;
  function n(L) {
    return L instanceof Uint8Array || ArrayBuffer.isView(L) && L.constructor.name === "Uint8Array";
  }
  function o(L) {
    return new Uint8Array(L.buffer, L.byteOffset, L.byteLength);
  }
  function i(L) {
    return new Uint32Array(L.buffer, L.byteOffset, Math.floor(L.byteLength / 4));
  }
  function a(L) {
    return new DataView(L.buffer, L.byteOffset, L.byteLength);
  }
  function u(L, ee) {
    return L << 32 - ee | L >>> ee;
  }
  function l(L, ee) {
    return L << ee | L >>> 32 - ee >>> 0;
  }
  e.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
  function d(L) {
    return L << 24 & 4278190080 | L << 8 & 16711680 | L >>> 8 & 65280 | L >>> 24 & 255;
  }
  e.byteSwapIfBE = e.isLE ? (L) => L : (L) => d(L);
  function f(L) {
    for (let ee = 0; ee < L.length; ee++)
      L[ee] = d(L[ee]);
  }
  const h = /* @__PURE__ */ Array.from({ length: 256 }, (L, ee) => ee.toString(16).padStart(2, "0"));
  function g(L) {
    (0, r.abytes)(L);
    let ee = "";
    for (let de = 0; de < L.length; de++)
      ee += h[L[de]];
    return ee;
  }
  const b = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
  function w(L) {
    if (L >= b._0 && L <= b._9)
      return L - b._0;
    if (L >= b.A && L <= b.F)
      return L - (b.A - 10);
    if (L >= b.a && L <= b.f)
      return L - (b.a - 10);
  }
  function E(L) {
    if (typeof L != "string")
      throw new Error("hex string expected, got " + typeof L);
    const ee = L.length, de = ee / 2;
    if (ee % 2)
      throw new Error("hex string expected, got unpadded hex of length " + ee);
    const ne = new Uint8Array(de);
    for (let D = 0, K = 0; D < de; D++, K += 2) {
      const le = w(L.charCodeAt(K)), re = w(L.charCodeAt(K + 1));
      if (le === void 0 || re === void 0) {
        const G = L[K] + L[K + 1];
        throw new Error('hex string expected, got non-hex character "' + G + '" at index ' + K);
      }
      ne[D] = le * 16 + re;
    }
    return ne;
  }
  const _ = async () => {
  };
  e.nextTick = _;
  async function O(L, ee, de) {
    let ne = Date.now();
    for (let D = 0; D < L; D++) {
      de(D);
      const K = Date.now() - ne;
      K >= 0 && K < ee || (await (0, e.nextTick)(), ne += K);
    }
  }
  function C(L) {
    if (typeof L != "string")
      throw new Error("utf8ToBytes expected string, got " + typeof L);
    return new Uint8Array(new TextEncoder().encode(L));
  }
  function I(L) {
    return typeof L == "string" && (L = C(L)), (0, r.abytes)(L), L;
  }
  function S(...L) {
    let ee = 0;
    for (let ne = 0; ne < L.length; ne++) {
      const D = L[ne];
      (0, r.abytes)(D), ee += D.length;
    }
    const de = new Uint8Array(ee);
    for (let ne = 0, D = 0; ne < L.length; ne++) {
      const K = L[ne];
      de.set(K, D), D += K.length;
    }
    return de;
  }
  class T {
    // Safe version that clones internal state
    clone() {
      return this._cloneInto();
    }
  }
  e.Hash = T;
  function A(L, ee) {
    if (ee !== void 0 && {}.toString.call(ee) !== "[object Object]")
      throw new Error("Options should be object or undefined");
    return Object.assign(L, ee);
  }
  function $(L) {
    const ee = (ne) => L().update(I(ne)).digest(), de = L();
    return ee.outputLen = de.outputLen, ee.blockLen = de.blockLen, ee.create = () => L(), ee;
  }
  function U(L) {
    const ee = (ne, D) => L(D).update(I(ne)).digest(), de = L({});
    return ee.outputLen = de.outputLen, ee.blockLen = de.blockLen, ee.create = (ne) => L(ne), ee;
  }
  function M(L) {
    const ee = (ne, D) => L(D).update(I(ne)).digest(), de = L({});
    return ee.outputLen = de.outputLen, ee.blockLen = de.blockLen, ee.create = (ne) => L(ne), ee;
  }
  function Y(L = 32) {
    if (t.crypto && typeof t.crypto.getRandomValues == "function")
      return t.crypto.getRandomValues(new Uint8Array(L));
    if (t.crypto && typeof t.crypto.randomBytes == "function")
      return t.crypto.randomBytes(L);
    throw new Error("crypto.getRandomValues must be defined");
  }
})(Vs);
Object.defineProperty(rh, "__esModule", { value: !0 });
rh.HashMD = void 0;
rh.setBigUint64 = KV;
rh.Chi = m3e;
rh.Maj = y3e;
const ST = $c, Rb = Vs;
function KV(e, t, r, n) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, r, n);
  const o = BigInt(32), i = BigInt(4294967295), a = Number(r >> o & i), u = Number(r & i), l = n ? 4 : 0, d = n ? 0 : 4;
  e.setUint32(t + l, a, n), e.setUint32(t + d, u, n);
}
function m3e(e, t, r) {
  return e & t ^ ~e & r;
}
function y3e(e, t, r) {
  return e & t ^ e & r ^ t & r;
}
class b3e extends Rb.Hash {
  constructor(t, r, n, o) {
    super(), this.blockLen = t, this.outputLen = r, this.padOffset = n, this.isLE = o, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = (0, Rb.createView)(this.buffer);
  }
  update(t) {
    (0, ST.aexists)(this);
    const { view: r, buffer: n, blockLen: o } = this;
    t = (0, Rb.toBytes)(t);
    const i = t.length;
    for (let a = 0; a < i; ) {
      const u = Math.min(o - this.pos, i - a);
      if (u === o) {
        const l = (0, Rb.createView)(t);
        for (; o <= i - a; a += o)
          this.process(l, a);
        continue;
      }
      n.set(t.subarray(a, a + u), this.pos), this.pos += u, a += u, this.pos === o && (this.process(r, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    (0, ST.aexists)(this), (0, ST.aoutput)(t, this), this.finished = !0;
    const { buffer: r, view: n, blockLen: o, isLE: i } = this;
    let { pos: a } = this;
    r[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > o - a && (this.process(n, 0), a = 0);
    for (let h = a; h < o; h++)
      r[h] = 0;
    KV(n, o - 8, BigInt(this.length * 8), i), this.process(n, 0);
    const u = (0, Rb.createView)(t), l = this.outputLen;
    if (l % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const d = l / 4, f = this.get();
    if (d > f.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let h = 0; h < d; h++)
      u.setUint32(4 * h, f[h], i);
  }
  digest() {
    const { buffer: t, outputLen: r } = this;
    this.digestInto(t);
    const n = t.slice(0, r);
    return this.destroy(), n;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: r, buffer: n, length: o, finished: i, destroyed: a, pos: u } = this;
    return t.length = o, t.pos = u, t.finished = i, t.destroyed = a, o % r && t.buffer.set(n), t;
  }
}
rh.HashMD = b3e;
Object.defineProperty(Ru, "__esModule", { value: !0 });
Ru.sha224 = qV = Ru.sha256 = Ru.SHA256 = void 0;
const TT = rh, Ps = Vs, w3e = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), Yf = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), Jf = /* @__PURE__ */ new Uint32Array(64);
let jB = class extends TT.HashMD {
  constructor() {
    super(64, 32, 8, !1), this.A = Yf[0] | 0, this.B = Yf[1] | 0, this.C = Yf[2] | 0, this.D = Yf[3] | 0, this.E = Yf[4] | 0, this.F = Yf[5] | 0, this.G = Yf[6] | 0, this.H = Yf[7] | 0;
  }
  get() {
    const { A: e, B: t, C: r, D: n, E: o, F: i, G: a, H: u } = this;
    return [e, t, r, n, o, i, a, u];
  }
  // prettier-ignore
  set(e, t, r, n, o, i, a, u) {
    this.A = e | 0, this.B = t | 0, this.C = r | 0, this.D = n | 0, this.E = o | 0, this.F = i | 0, this.G = a | 0, this.H = u | 0;
  }
  process(e, t) {
    for (let f = 0; f < 16; f++, t += 4)
      Jf[f] = e.getUint32(t, !1);
    for (let f = 16; f < 64; f++) {
      const h = Jf[f - 15], g = Jf[f - 2], b = (0, Ps.rotr)(h, 7) ^ (0, Ps.rotr)(h, 18) ^ h >>> 3, w = (0, Ps.rotr)(g, 17) ^ (0, Ps.rotr)(g, 19) ^ g >>> 10;
      Jf[f] = w + Jf[f - 7] + b + Jf[f - 16] | 0;
    }
    let { A: r, B: n, C: o, D: i, E: a, F: u, G: l, H: d } = this;
    for (let f = 0; f < 64; f++) {
      const h = (0, Ps.rotr)(a, 6) ^ (0, Ps.rotr)(a, 11) ^ (0, Ps.rotr)(a, 25), g = d + h + (0, TT.Chi)(a, u, l) + w3e[f] + Jf[f] | 0, b = ((0, Ps.rotr)(r, 2) ^ (0, Ps.rotr)(r, 13) ^ (0, Ps.rotr)(r, 22)) + (0, TT.Maj)(r, n, o) | 0;
      d = l, l = u, u = a, a = i + g | 0, i = o, o = n, n = r, r = g + b | 0;
    }
    r = r + this.A | 0, n = n + this.B | 0, o = o + this.C | 0, i = i + this.D | 0, a = a + this.E | 0, u = u + this.F | 0, l = l + this.G | 0, d = d + this.H | 0, this.set(r, n, o, i, a, u, l, d);
  }
  roundClean() {
    Jf.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
};
Ru.SHA256 = jB;
let v3e = class extends jB {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
};
var qV = Ru.sha256 = (0, Ps.wrapConstructor)(() => new jB());
Ru.sha224 = (0, Ps.wrapConstructor)(() => new v3e());
var Q2 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.hmac = e.HMAC = void 0;
  const t = $c, r = Vs;
  class n extends r.Hash {
    constructor(a, u) {
      super(), this.finished = !1, this.destroyed = !1, (0, t.ahash)(a);
      const l = (0, r.toBytes)(u);
      if (this.iHash = a.create(), typeof this.iHash.update != "function")
        throw new Error("Expected instance of class which extends utils.Hash");
      this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
      const d = this.blockLen, f = new Uint8Array(d);
      f.set(l.length > d ? a.create().update(l).digest() : l);
      for (let h = 0; h < f.length; h++)
        f[h] ^= 54;
      this.iHash.update(f), this.oHash = a.create();
      for (let h = 0; h < f.length; h++)
        f[h] ^= 106;
      this.oHash.update(f), f.fill(0);
    }
    update(a) {
      return (0, t.aexists)(this), this.iHash.update(a), this;
    }
    digestInto(a) {
      (0, t.aexists)(this), (0, t.abytes)(a, this.outputLen), this.finished = !0, this.iHash.digestInto(a), this.oHash.update(a), this.oHash.digestInto(a), this.destroy();
    }
    digest() {
      const a = new Uint8Array(this.oHash.outputLen);
      return this.digestInto(a), a;
    }
    _cloneInto(a) {
      a || (a = Object.create(Object.getPrototypeOf(this), {}));
      const { oHash: u, iHash: l, finished: d, destroyed: f, blockLen: h, outputLen: g } = this;
      return a = a, a.finished = d, a.destroyed = f, a.blockLen = h, a.outputLen = g, a.oHash = u._cloneInto(a.oHash), a.iHash = l._cloneInto(a.iHash), a;
    }
    destroy() {
      this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
    }
  }
  e.HMAC = n;
  const o = (i, a, u) => new n(i, a).update(u).digest();
  e.hmac = o, e.hmac.create = (i, a) => new n(i, a);
})(Q2);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const nE = /* @__PURE__ */ BigInt(0), oE = /* @__PURE__ */ BigInt(1), E3e = /* @__PURE__ */ BigInt(2);
function l0(e) {
  return e instanceof Uint8Array || ArrayBuffer.isView(e) && e.constructor.name === "Uint8Array";
}
function ev(e) {
  if (!l0(e))
    throw new Error("Uint8Array expected");
}
function Q1(e, t) {
  if (typeof t != "boolean")
    throw new Error(e + " boolean expected, got " + t);
}
const _3e = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function eg(e) {
  ev(e);
  let t = "";
  for (let r = 0; r < e.length; r++)
    t += _3e[e[r]];
  return t;
}
function f1(e) {
  const t = e.toString(16);
  return t.length & 1 ? "0" + t : t;
}
function LB(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  return e === "" ? nE : BigInt("0x" + e);
}
const zl = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function cz(e) {
  if (e >= zl._0 && e <= zl._9)
    return e - zl._0;
  if (e >= zl.A && e <= zl.F)
    return e - (zl.A - 10);
  if (e >= zl.a && e <= zl.f)
    return e - (zl.a - 10);
}
function tg(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  const t = e.length, r = t / 2;
  if (t % 2)
    throw new Error("hex string expected, got unpadded hex of length " + t);
  const n = new Uint8Array(r);
  for (let o = 0, i = 0; o < r; o++, i += 2) {
    const a = cz(e.charCodeAt(i)), u = cz(e.charCodeAt(i + 1));
    if (a === void 0 || u === void 0) {
      const l = e[i] + e[i + 1];
      throw new Error('hex string expected, got non-hex character "' + l + '" at index ' + i);
    }
    n[o] = a * 16 + u;
  }
  return n;
}
function Zp(e) {
  return LB(eg(e));
}
function HB(e) {
  return ev(e), LB(eg(Uint8Array.from(e).reverse()));
}
function rg(e, t) {
  return tg(e.toString(16).padStart(t * 2, "0"));
}
function FB(e, t) {
  return rg(e, t).reverse();
}
function A3e(e) {
  return tg(f1(e));
}
function bu(e, t, r) {
  let n;
  if (typeof t == "string")
    try {
      n = tg(t);
    } catch (i) {
      throw new Error(e + " must be hex string or Uint8Array, cause: " + i);
    }
  else if (l0(t))
    n = Uint8Array.from(t);
  else
    throw new Error(e + " must be hex string or Uint8Array");
  const o = n.length;
  if (typeof r == "number" && o !== r)
    throw new Error(e + " of length " + r + " expected, got " + o);
  return n;
}
function qw(...e) {
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    ev(o), t += o.length;
  }
  const r = new Uint8Array(t);
  for (let n = 0, o = 0; n < e.length; n++) {
    const i = e[n];
    r.set(i, o), o += i.length;
  }
  return r;
}
function x3e(e, t) {
  if (e.length !== t.length)
    return !1;
  let r = 0;
  for (let n = 0; n < e.length; n++)
    r |= e[n] ^ t[n];
  return r === 0;
}
function k3e(e) {
  if (typeof e != "string")
    throw new Error("string expected");
  return new Uint8Array(new TextEncoder().encode(e));
}
const IT = (e) => typeof e == "bigint" && nE <= e;
function iE(e, t, r) {
  return IT(e) && IT(t) && IT(r) && t <= e && e < r;
}
function Xp(e, t, r, n) {
  if (!iE(t, r, n))
    throw new Error("expected valid " + e + ": " + r + " <= n < " + n + ", got " + t);
}
function VV(e) {
  let t;
  for (t = 0; e > nE; e >>= oE, t += 1)
    ;
  return t;
}
function S3e(e, t) {
  return e >> BigInt(t) & oE;
}
function T3e(e, t, r) {
  return e | (r ? oE : nE) << BigInt(t);
}
const MB = (e) => (E3e << BigInt(e - 1)) - oE, OT = (e) => new Uint8Array(e), lz = (e) => Uint8Array.from(e);
function GV(e, t, r) {
  if (typeof e != "number" || e < 2)
    throw new Error("hashLen must be a number");
  if (typeof t != "number" || t < 2)
    throw new Error("qByteLen must be a number");
  if (typeof r != "function")
    throw new Error("hmacFn must be a function");
  let n = OT(e), o = OT(e), i = 0;
  const a = () => {
    n.fill(1), o.fill(0), i = 0;
  }, u = (...f) => r(o, n, ...f), l = (f = OT()) => {
    o = u(lz([0]), f), n = u(), f.length !== 0 && (o = u(lz([1]), f), n = u());
  }, d = () => {
    if (i++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let f = 0;
    const h = [];
    for (; f < t; ) {
      n = u();
      const g = n.slice();
      h.push(g), f += n.length;
    }
    return qw(...h);
  };
  return (f, h) => {
    a(), l(f);
    let g;
    for (; !(g = h(d())); )
      l();
    return a(), g;
  };
}
const I3e = {
  bigint: (e) => typeof e == "bigint",
  function: (e) => typeof e == "function",
  boolean: (e) => typeof e == "boolean",
  string: (e) => typeof e == "string",
  stringOrUint8Array: (e) => typeof e == "string" || l0(e),
  isSafeInteger: (e) => Number.isSafeInteger(e),
  array: (e) => Array.isArray(e),
  field: (e, t) => t.Fp.isValid(e),
  hash: (e) => typeof e == "function" && Number.isSafeInteger(e.outputLen)
};
function tv(e, t, r = {}) {
  const n = (o, i, a) => {
    const u = I3e[i];
    if (typeof u != "function")
      throw new Error("invalid validator function");
    const l = e[o];
    if (!(a && l === void 0) && !u(l, e))
      throw new Error("param " + String(o) + " is invalid. Expected " + i + ", got " + l);
  };
  for (const [o, i] of Object.entries(t))
    n(o, i, !1);
  for (const [o, i] of Object.entries(r))
    n(o, i, !0);
  return e;
}
const O3e = () => {
  throw new Error("not implemented");
};
function UO(e) {
  const t = /* @__PURE__ */ new WeakMap();
  return (r, ...n) => {
    const o = t.get(r);
    if (o !== void 0)
      return o;
    const i = e(r, ...n);
    return t.set(r, i), i;
  };
}
const P3e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  aInRange: Xp,
  abool: Q1,
  abytes: ev,
  bitGet: S3e,
  bitLen: VV,
  bitMask: MB,
  bitSet: T3e,
  bytesToHex: eg,
  bytesToNumberBE: Zp,
  bytesToNumberLE: HB,
  concatBytes: qw,
  createHmacDrbg: GV,
  ensureBytes: bu,
  equalBytes: x3e,
  hexToBytes: tg,
  hexToNumber: LB,
  inRange: iE,
  isBytes: l0,
  memoized: UO,
  notImplemented: O3e,
  numberToBytesBE: rg,
  numberToBytesLE: FB,
  numberToHexUnpadded: f1,
  numberToVarBytesBE: A3e,
  utf8ToBytes: k3e,
  validateObject: tv
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const oi = BigInt(0), xo = BigInt(1), Op = /* @__PURE__ */ BigInt(2), C3e = /* @__PURE__ */ BigInt(3), RO = /* @__PURE__ */ BigInt(4), fz = /* @__PURE__ */ BigInt(5), dz = /* @__PURE__ */ BigInt(8);
function ia(e, t) {
  const r = e % t;
  return r >= oi ? r : t + r;
}
function B3e(e, t, r) {
  if (t < oi)
    throw new Error("invalid exponent, negatives unsupported");
  if (r <= oi)
    throw new Error("invalid modulus");
  if (r === xo)
    return oi;
  let n = xo;
  for (; t > oi; )
    t & xo && (n = n * e % r), e = e * e % r, t >>= xo;
  return n;
}
function Ss(e, t, r) {
  let n = e;
  for (; t-- > oi; )
    n *= n, n %= r;
  return n;
}
function zO(e, t) {
  if (e === oi)
    throw new Error("invert: expected non-zero number");
  if (t <= oi)
    throw new Error("invert: expected positive modulus, got " + t);
  let r = ia(e, t), n = t, o = oi, i = xo;
  for (; r !== oi; ) {
    const a = n / r, u = n % r, l = o - i * a;
    n = r, r = u, o = i, i = l;
  }
  if (n !== xo)
    throw new Error("invert: does not exist");
  return ia(o, t);
}
function N3e(e) {
  const t = (e - xo) / Op;
  let r, n, o;
  for (r = e - xo, n = 0; r % Op === oi; r /= Op, n++)
    ;
  for (o = Op; o < e && B3e(o, t, e) !== e - xo; o++)
    if (o > 1e3)
      throw new Error("Cannot find square root: likely non-prime P");
  if (n === 1) {
    const a = (e + xo) / RO;
    return function(u, l) {
      const d = u.pow(l, a);
      if (!u.eql(u.sqr(d), l))
        throw new Error("Cannot find square root");
      return d;
    };
  }
  const i = (r + xo) / Op;
  return function(a, u) {
    if (a.pow(u, t) === a.neg(a.ONE))
      throw new Error("Cannot find square root");
    let l = n, d = a.pow(a.mul(a.ONE, o), r), f = a.pow(u, i), h = a.pow(u, r);
    for (; !a.eql(h, a.ONE); ) {
      if (a.eql(h, a.ZERO))
        return a.ZERO;
      let g = 1;
      for (let w = a.sqr(h); g < l && !a.eql(w, a.ONE); g++)
        w = a.sqr(w);
      const b = a.pow(d, xo << BigInt(l - g - 1));
      d = a.sqr(b), f = a.mul(f, b), h = a.mul(h, d), l = g;
    }
    return f;
  };
}
function $3e(e) {
  if (e % RO === C3e) {
    const t = (e + xo) / RO;
    return function(r, n) {
      const o = r.pow(n, t);
      if (!r.eql(r.sqr(o), n))
        throw new Error("Cannot find square root");
      return o;
    };
  }
  if (e % dz === fz) {
    const t = (e - fz) / dz;
    return function(r, n) {
      const o = r.mul(n, Op), i = r.pow(o, t), a = r.mul(n, i), u = r.mul(r.mul(a, Op), i), l = r.mul(a, r.sub(u, r.ONE));
      if (!r.eql(r.sqr(l), n))
        throw new Error("Cannot find square root");
      return l;
    };
  }
  return N3e(e);
}
const U3e = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function R3e(e) {
  const t = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, r = U3e.reduce((n, o) => (n[o] = "function", n), t);
  return tv(e, r);
}
function z3e(e, t, r) {
  if (r < oi)
    throw new Error("invalid exponent, negatives unsupported");
  if (r === oi)
    return e.ONE;
  if (r === xo)
    return t;
  let n = e.ONE, o = t;
  for (; r > oi; )
    r & xo && (n = e.mul(n, o)), o = e.sqr(o), r >>= xo;
  return n;
}
function j3e(e, t) {
  const r = new Array(t.length), n = t.reduce((i, a, u) => e.is0(a) ? i : (r[u] = i, e.mul(i, a)), e.ONE), o = e.inv(n);
  return t.reduceRight((i, a, u) => e.is0(a) ? i : (r[u] = e.mul(i, r[u]), e.mul(i, a)), o), r;
}
function WV(e, t) {
  const r = t !== void 0 ? t : e.toString(2).length, n = Math.ceil(r / 8);
  return { nBitLength: r, nByteLength: n };
}
function DB(e, t, r = !1, n = {}) {
  if (e <= oi)
    throw new Error("invalid field: expected ORDER > 0, got " + e);
  const { nBitLength: o, nByteLength: i } = WV(e, t);
  if (i > 2048)
    throw new Error("invalid field: expected ORDER of <= 2048 bytes");
  let a;
  const u = Object.freeze({
    ORDER: e,
    isLE: r,
    BITS: o,
    BYTES: i,
    MASK: MB(o),
    ZERO: oi,
    ONE: xo,
    create: (l) => ia(l, e),
    isValid: (l) => {
      if (typeof l != "bigint")
        throw new Error("invalid field element: expected bigint, got " + typeof l);
      return oi <= l && l < e;
    },
    is0: (l) => l === oi,
    isOdd: (l) => (l & xo) === xo,
    neg: (l) => ia(-l, e),
    eql: (l, d) => l === d,
    sqr: (l) => ia(l * l, e),
    add: (l, d) => ia(l + d, e),
    sub: (l, d) => ia(l - d, e),
    mul: (l, d) => ia(l * d, e),
    pow: (l, d) => z3e(u, l, d),
    div: (l, d) => ia(l * zO(d, e), e),
    // Same as above, but doesn't normalize
    sqrN: (l) => l * l,
    addN: (l, d) => l + d,
    subN: (l, d) => l - d,
    mulN: (l, d) => l * d,
    inv: (l) => zO(l, e),
    sqrt: n.sqrt || ((l) => (a || (a = $3e(e)), a(u, l))),
    invertBatch: (l) => j3e(u, l),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (l, d, f) => f ? d : l,
    toBytes: (l) => r ? FB(l, i) : rg(l, i),
    fromBytes: (l) => {
      if (l.length !== i)
        throw new Error("Field.fromBytes: expected " + i + " bytes, got " + l.length);
      return r ? HB(l) : Zp(l);
    }
  });
  return Object.freeze(u);
}
function ZV(e) {
  if (typeof e != "bigint")
    throw new Error("field order must be bigint");
  const t = e.toString(2).length;
  return Math.ceil(t / 8);
}
function XV(e) {
  const t = ZV(e);
  return t + Math.ceil(t / 2);
}
function L3e(e, t, r = !1) {
  const n = e.length, o = ZV(t), i = XV(t);
  if (n < 16 || n < i || n > 1024)
    throw new Error("expected " + i + "-1024 bytes of input, got " + n);
  const a = r ? HB(e) : Zp(e), u = ia(a, t - xo) + xo;
  return r ? FB(u, o) : rg(u, o);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const hz = BigInt(0), c8 = BigInt(1);
function PT(e, t) {
  const r = t.negate();
  return e ? r : t;
}
function YV(e, t) {
  if (!Number.isSafeInteger(e) || e <= 0 || e > t)
    throw new Error("invalid window size, expected [1.." + t + "], got W=" + e);
}
function CT(e, t) {
  YV(e, t);
  const r = Math.ceil(t / e) + 1, n = 2 ** (e - 1);
  return { windows: r, windowSize: n };
}
function H3e(e, t) {
  if (!Array.isArray(e))
    throw new Error("array expected");
  e.forEach((r, n) => {
    if (!(r instanceof t))
      throw new Error("invalid point at index " + n);
  });
}
function F3e(e, t) {
  if (!Array.isArray(e))
    throw new Error("array of scalars expected");
  e.forEach((r, n) => {
    if (!t.isValid(r))
      throw new Error("invalid scalar at index " + n);
  });
}
const BT = /* @__PURE__ */ new WeakMap(), JV = /* @__PURE__ */ new WeakMap();
function NT(e) {
  return JV.get(e) || 1;
}
function M3e(e, t) {
  return {
    constTimeNegate: PT,
    hasPrecomputes(r) {
      return NT(r) !== 1;
    },
    // non-const time multiplication ladder
    unsafeLadder(r, n, o = e.ZERO) {
      let i = r;
      for (; n > hz; )
        n & c8 && (o = o.add(i)), i = i.double(), n >>= c8;
      return o;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param elm Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(r, n) {
      const { windows: o, windowSize: i } = CT(n, t), a = [];
      let u = r, l = u;
      for (let d = 0; d < o; d++) {
        l = u, a.push(l);
        for (let f = 1; f < i; f++)
          l = l.add(u), a.push(l);
        u = l.double();
      }
      return a;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(r, n, o) {
      const { windows: i, windowSize: a } = CT(r, t);
      let u = e.ZERO, l = e.BASE;
      const d = BigInt(2 ** r - 1), f = 2 ** r, h = BigInt(r);
      for (let g = 0; g < i; g++) {
        const b = g * a;
        let w = Number(o & d);
        o >>= h, w > a && (w -= f, o += c8);
        const E = b, _ = b + Math.abs(w) - 1, O = g % 2 !== 0, C = w < 0;
        w === 0 ? l = l.add(PT(O, n[E])) : u = u.add(PT(C, n[_]));
      }
      return { p: u, f: l };
    },
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */
    wNAFUnsafe(r, n, o, i = e.ZERO) {
      const { windows: a, windowSize: u } = CT(r, t), l = BigInt(2 ** r - 1), d = 2 ** r, f = BigInt(r);
      for (let h = 0; h < a; h++) {
        const g = h * u;
        if (o === hz)
          break;
        let b = Number(o & l);
        if (o >>= f, b > u && (b -= d, o += c8), b === 0)
          continue;
        let w = n[g + Math.abs(b) - 1];
        b < 0 && (w = w.negate()), i = i.add(w);
      }
      return i;
    },
    getPrecomputes(r, n, o) {
      let i = BT.get(n);
      return i || (i = this.precomputeWindow(n, r), r !== 1 && BT.set(n, o(i))), i;
    },
    wNAFCached(r, n, o) {
      const i = NT(r);
      return this.wNAF(i, this.getPrecomputes(i, r, o), n);
    },
    wNAFCachedUnsafe(r, n, o, i) {
      const a = NT(r);
      return a === 1 ? this.unsafeLadder(r, n, i) : this.wNAFUnsafe(a, this.getPrecomputes(a, r, o), n, i);
    },
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    setWindowSize(r, n) {
      YV(n, t), JV.set(r, n), BT.delete(r);
    }
  };
}
function D3e(e, t, r, n) {
  if (H3e(r, e), F3e(n, t), r.length !== n.length)
    throw new Error("arrays of points and scalars must have equal length");
  const o = e.ZERO, i = VV(BigInt(r.length)), a = i > 12 ? i - 3 : i > 4 ? i - 2 : i ? 2 : 1, u = (1 << a) - 1, l = new Array(u + 1).fill(o), d = Math.floor((t.BITS - 1) / a) * a;
  let f = o;
  for (let h = d; h >= 0; h -= a) {
    l.fill(o);
    for (let b = 0; b < n.length; b++) {
      const w = n[b], E = Number(w >> BigInt(h) & BigInt(u));
      l[E] = l[E].add(r[b]);
    }
    let g = o;
    for (let b = l.length - 1, w = o; b > 0; b--)
      w = w.add(l[b]), g = g.add(w);
    if (f = f.add(g), h !== 0)
      for (let b = 0; b < a; b++)
        f = f.double();
  }
  return f;
}
function QV(e) {
  return R3e(e.Fp), tv(e, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...WV(e.n, e.nBitLength),
    ...e,
    p: e.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function pz(e) {
  e.lowS !== void 0 && Q1("lowS", e.lowS), e.prehash !== void 0 && Q1("prehash", e.prehash);
}
function K3e(e) {
  const t = QV(e);
  tv(t, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: r, Fp: n, a: o } = t;
  if (r) {
    if (!n.eql(o, n.ZERO))
      throw new Error("invalid endomorphism, can only be defined for Koblitz curves that have a=0");
    if (typeof r != "object" || typeof r.beta != "bigint" || typeof r.splitScalar != "function")
      throw new Error("invalid endomorphism, expected beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...t });
}
const { bytesToNumberBE: q3e, hexToBytes: V3e } = P3e;
class G3e extends Error {
  constructor(t = "") {
    super(t);
  }
}
const Wl = {
  // asn.1 DER encoding utils
  Err: G3e,
  // Basic building block is TLV (Tag-Length-Value)
  _tlv: {
    encode: (e, t) => {
      const { Err: r } = Wl;
      if (e < 0 || e > 256)
        throw new r("tlv.encode: wrong tag");
      if (t.length & 1)
        throw new r("tlv.encode: unpadded data");
      const n = t.length / 2, o = f1(n);
      if (o.length / 2 & 128)
        throw new r("tlv.encode: long form length too big");
      const i = n > 127 ? f1(o.length / 2 | 128) : "";
      return f1(e) + i + o + t;
    },
    // v - value, l - left bytes (unparsed)
    decode(e, t) {
      const { Err: r } = Wl;
      let n = 0;
      if (e < 0 || e > 256)
        throw new r("tlv.encode: wrong tag");
      if (t.length < 2 || t[n++] !== e)
        throw new r("tlv.decode: wrong tlv");
      const o = t[n++], i = !!(o & 128);
      let a = 0;
      if (!i)
        a = o;
      else {
        const l = o & 127;
        if (!l)
          throw new r("tlv.decode(long): indefinite length not supported");
        if (l > 4)
          throw new r("tlv.decode(long): byte length is too big");
        const d = t.subarray(n, n + l);
        if (d.length !== l)
          throw new r("tlv.decode: length bytes not complete");
        if (d[0] === 0)
          throw new r("tlv.decode(long): zero leftmost byte");
        for (const f of d)
          a = a << 8 | f;
        if (n += l, a < 128)
          throw new r("tlv.decode(long): not minimal encoding");
      }
      const u = t.subarray(n, n + a);
      if (u.length !== a)
        throw new r("tlv.decode: wrong value length");
      return { v: u, l: t.subarray(n + a) };
    }
  },
  // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
  // since we always use positive integers here. It must always be empty:
  // - add zero byte if exists
  // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
  _int: {
    encode(e) {
      const { Err: t } = Wl;
      if (e < Xl)
        throw new t("integer: negative integers are not allowed");
      let r = f1(e);
      if (Number.parseInt(r[0], 16) & 8 && (r = "00" + r), r.length & 1)
        throw new t("unexpected DER parsing assertion: unpadded hex");
      return r;
    },
    decode(e) {
      const { Err: t } = Wl;
      if (e[0] & 128)
        throw new t("invalid signature integer: negative");
      if (e[0] === 0 && !(e[1] & 128))
        throw new t("invalid signature integer: unnecessary leading zero");
      return q3e(e);
    }
  },
  toSig(e) {
    const { Err: t, _int: r, _tlv: n } = Wl, o = typeof e == "string" ? V3e(e) : e;
    ev(o);
    const { v: i, l: a } = n.decode(48, o);
    if (a.length)
      throw new t("invalid signature: left bytes after parsing");
    const { v: u, l } = n.decode(2, i), { v: d, l: f } = n.decode(2, l);
    if (f.length)
      throw new t("invalid signature: left bytes after parsing");
    return { r: r.decode(u), s: r.decode(d) };
  },
  hexFromSig(e) {
    const { _tlv: t, _int: r } = Wl, n = t.encode(2, r.encode(e.r)), o = t.encode(2, r.encode(e.s)), i = n + o;
    return t.encode(48, i);
  }
}, Xl = BigInt(0), Jo = BigInt(1);
BigInt(2);
const gz = BigInt(3);
BigInt(4);
function W3e(e) {
  const t = K3e(e), { Fp: r } = t, n = DB(t.n, t.nBitLength), o = t.toBytes || ((E, _, O) => {
    const C = _.toAffine();
    return qw(Uint8Array.from([4]), r.toBytes(C.x), r.toBytes(C.y));
  }), i = t.fromBytes || ((E) => {
    const _ = E.subarray(1), O = r.fromBytes(_.subarray(0, r.BYTES)), C = r.fromBytes(_.subarray(r.BYTES, 2 * r.BYTES));
    return { x: O, y: C };
  });
  function a(E) {
    const { a: _, b: O } = t, C = r.sqr(E), I = r.mul(C, E);
    return r.add(r.add(I, r.mul(E, _)), O);
  }
  if (!r.eql(r.sqr(t.Gy), a(t.Gx)))
    throw new Error("bad generator point: equation left != right");
  function u(E) {
    return iE(E, Jo, t.n);
  }
  function l(E) {
    const { allowedPrivateKeyLengths: _, nByteLength: O, wrapPrivateKey: C, n: I } = t;
    if (_ && typeof E != "bigint") {
      if (l0(E) && (E = eg(E)), typeof E != "string" || !_.includes(E.length))
        throw new Error("invalid private key");
      E = E.padStart(O * 2, "0");
    }
    let S;
    try {
      S = typeof E == "bigint" ? E : Zp(bu("private key", E, O));
    } catch {
      throw new Error("invalid private key, expected hex or " + O + " bytes, got " + typeof E);
    }
    return C && (S = ia(S, I)), Xp("private key", S, Jo, I), S;
  }
  function d(E) {
    if (!(E instanceof g))
      throw new Error("ProjectivePoint expected");
  }
  const f = UO((E, _) => {
    const { px: O, py: C, pz: I } = E;
    if (r.eql(I, r.ONE))
      return { x: O, y: C };
    const S = E.is0();
    _ == null && (_ = S ? r.ONE : r.inv(I));
    const T = r.mul(O, _), A = r.mul(C, _), $ = r.mul(I, _);
    if (S)
      return { x: r.ZERO, y: r.ZERO };
    if (!r.eql($, r.ONE))
      throw new Error("invZ was invalid");
    return { x: T, y: A };
  }), h = UO((E) => {
    if (E.is0()) {
      if (t.allowInfinityPoint && !r.is0(E.py))
        return;
      throw new Error("bad point: ZERO");
    }
    const { x: _, y: O } = E.toAffine();
    if (!r.isValid(_) || !r.isValid(O))
      throw new Error("bad point: x or y not FE");
    const C = r.sqr(O), I = a(_);
    if (!r.eql(C, I))
      throw new Error("bad point: equation left != right");
    if (!E.isTorsionFree())
      throw new Error("bad point: not in prime-order subgroup");
    return !0;
  });
  class g {
    constructor(_, O, C) {
      if (this.px = _, this.py = O, this.pz = C, _ == null || !r.isValid(_))
        throw new Error("x required");
      if (O == null || !r.isValid(O))
        throw new Error("y required");
      if (C == null || !r.isValid(C))
        throw new Error("z required");
      Object.freeze(this);
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(_) {
      const { x: O, y: C } = _ || {};
      if (!_ || !r.isValid(O) || !r.isValid(C))
        throw new Error("invalid affine point");
      if (_ instanceof g)
        throw new Error("projective point not allowed");
      const I = (S) => r.eql(S, r.ZERO);
      return I(O) && I(C) ? g.ZERO : new g(O, C, r.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(_) {
      const O = r.invertBatch(_.map((C) => C.pz));
      return _.map((C, I) => C.toAffine(O[I])).map(g.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(_) {
      const O = g.fromAffine(i(bu("pointHex", _)));
      return O.assertValidity(), O;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(_) {
      return g.BASE.multiply(l(_));
    }
    // Multiscalar Multiplication
    static msm(_, O) {
      return D3e(g, n, _, O);
    }
    // "Private method", don't use it directly
    _setWindowSize(_) {
      w.setWindowSize(this, _);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      h(this);
    }
    hasEvenY() {
      const { y: _ } = this.toAffine();
      if (r.isOdd)
        return !r.isOdd(_);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(_) {
      d(_);
      const { px: O, py: C, pz: I } = this, { px: S, py: T, pz: A } = _, $ = r.eql(r.mul(O, A), r.mul(S, I)), U = r.eql(r.mul(C, A), r.mul(T, I));
      return $ && U;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new g(this.px, r.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: _, b: O } = t, C = r.mul(O, gz), { px: I, py: S, pz: T } = this;
      let A = r.ZERO, $ = r.ZERO, U = r.ZERO, M = r.mul(I, I), Y = r.mul(S, S), L = r.mul(T, T), ee = r.mul(I, S);
      return ee = r.add(ee, ee), U = r.mul(I, T), U = r.add(U, U), A = r.mul(_, U), $ = r.mul(C, L), $ = r.add(A, $), A = r.sub(Y, $), $ = r.add(Y, $), $ = r.mul(A, $), A = r.mul(ee, A), U = r.mul(C, U), L = r.mul(_, L), ee = r.sub(M, L), ee = r.mul(_, ee), ee = r.add(ee, U), U = r.add(M, M), M = r.add(U, M), M = r.add(M, L), M = r.mul(M, ee), $ = r.add($, M), L = r.mul(S, T), L = r.add(L, L), M = r.mul(L, ee), A = r.sub(A, M), U = r.mul(L, Y), U = r.add(U, U), U = r.add(U, U), new g(A, $, U);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(_) {
      d(_);
      const { px: O, py: C, pz: I } = this, { px: S, py: T, pz: A } = _;
      let $ = r.ZERO, U = r.ZERO, M = r.ZERO;
      const Y = t.a, L = r.mul(t.b, gz);
      let ee = r.mul(O, S), de = r.mul(C, T), ne = r.mul(I, A), D = r.add(O, C), K = r.add(S, T);
      D = r.mul(D, K), K = r.add(ee, de), D = r.sub(D, K), K = r.add(O, I);
      let le = r.add(S, A);
      return K = r.mul(K, le), le = r.add(ee, ne), K = r.sub(K, le), le = r.add(C, I), $ = r.add(T, A), le = r.mul(le, $), $ = r.add(de, ne), le = r.sub(le, $), M = r.mul(Y, K), $ = r.mul(L, ne), M = r.add($, M), $ = r.sub(de, M), M = r.add(de, M), U = r.mul($, M), de = r.add(ee, ee), de = r.add(de, ee), ne = r.mul(Y, ne), K = r.mul(L, K), de = r.add(de, ne), ne = r.sub(ee, ne), ne = r.mul(Y, ne), K = r.add(K, ne), ee = r.mul(de, K), U = r.add(U, ee), ee = r.mul(le, K), $ = r.mul(D, $), $ = r.sub($, ee), ee = r.mul(D, de), M = r.mul(le, M), M = r.add(M, ee), new g($, U, M);
    }
    subtract(_) {
      return this.add(_.negate());
    }
    is0() {
      return this.equals(g.ZERO);
    }
    wNAF(_) {
      return w.wNAFCached(this, _, g.normalizeZ);
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(_) {
      const { endo: O, n: C } = t;
      Xp("scalar", _, Xl, C);
      const I = g.ZERO;
      if (_ === Xl)
        return I;
      if (this.is0() || _ === Jo)
        return this;
      if (!O || w.hasPrecomputes(this))
        return w.wNAFCachedUnsafe(this, _, g.normalizeZ);
      let { k1neg: S, k1: T, k2neg: A, k2: $ } = O.splitScalar(_), U = I, M = I, Y = this;
      for (; T > Xl || $ > Xl; )
        T & Jo && (U = U.add(Y)), $ & Jo && (M = M.add(Y)), Y = Y.double(), T >>= Jo, $ >>= Jo;
      return S && (U = U.negate()), A && (M = M.negate()), M = new g(r.mul(M.px, O.beta), M.py, M.pz), U.add(M);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(_) {
      const { endo: O, n: C } = t;
      Xp("scalar", _, Jo, C);
      let I, S;
      if (O) {
        const { k1neg: T, k1: A, k2neg: $, k2: U } = O.splitScalar(_);
        let { p: M, f: Y } = this.wNAF(A), { p: L, f: ee } = this.wNAF(U);
        M = w.constTimeNegate(T, M), L = w.constTimeNegate($, L), L = new g(r.mul(L.px, O.beta), L.py, L.pz), I = M.add(L), S = Y.add(ee);
      } else {
        const { p: T, f: A } = this.wNAF(_);
        I = T, S = A;
      }
      return g.normalizeZ([I, S])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(_, O, C) {
      const I = g.BASE, S = (A, $) => $ === Xl || $ === Jo || !A.equals(I) ? A.multiplyUnsafe($) : A.multiply($), T = S(this, O).add(S(_, C));
      return T.is0() ? void 0 : T;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(_) {
      return f(this, _);
    }
    isTorsionFree() {
      const { h: _, isTorsionFree: O } = t;
      if (_ === Jo)
        return !0;
      if (O)
        return O(g, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: _, clearCofactor: O } = t;
      return _ === Jo ? this : O ? O(g, this) : this.multiplyUnsafe(t.h);
    }
    toRawBytes(_ = !0) {
      return Q1("isCompressed", _), this.assertValidity(), o(g, this, _);
    }
    toHex(_ = !0) {
      return Q1("isCompressed", _), eg(this.toRawBytes(_));
    }
  }
  g.BASE = new g(t.Gx, t.Gy, r.ONE), g.ZERO = new g(r.ZERO, r.ONE, r.ZERO);
  const b = t.nBitLength, w = M3e(g, t.endo ? Math.ceil(b / 2) : b);
  return {
    CURVE: t,
    ProjectivePoint: g,
    normPrivateKeyToScalar: l,
    weierstrassEquation: a,
    isWithinCurveOrder: u
  };
}
function Z3e(e) {
  const t = QV(e);
  return tv(t, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...t });
}
function X3e(e) {
  const t = Z3e(e), { Fp: r, n } = t, o = r.BYTES + 1, i = 2 * r.BYTES + 1;
  function a(ne) {
    return ia(ne, n);
  }
  function u(ne) {
    return zO(ne, n);
  }
  const { ProjectivePoint: l, normPrivateKeyToScalar: d, weierstrassEquation: f, isWithinCurveOrder: h } = W3e({
    ...t,
    toBytes(ne, D, K) {
      const le = D.toAffine(), re = r.toBytes(le.x), G = qw;
      return Q1("isCompressed", K), K ? G(Uint8Array.from([D.hasEvenY() ? 2 : 3]), re) : G(Uint8Array.from([4]), re, r.toBytes(le.y));
    },
    fromBytes(ne) {
      const D = ne.length, K = ne[0], le = ne.subarray(1);
      if (D === o && (K === 2 || K === 3)) {
        const re = Zp(le);
        if (!iE(re, Jo, r.ORDER))
          throw new Error("Point is not on curve");
        const G = f(re);
        let q;
        try {
          q = r.sqrt(G);
        } catch (se) {
          const J = se instanceof Error ? ": " + se.message : "";
          throw new Error("Point is not on curve" + J);
        }
        const Q = (q & Jo) === Jo;
        return (K & 1) === 1 !== Q && (q = r.neg(q)), { x: re, y: q };
      } else if (D === i && K === 4) {
        const re = r.fromBytes(le.subarray(0, r.BYTES)), G = r.fromBytes(le.subarray(r.BYTES, 2 * r.BYTES));
        return { x: re, y: G };
      } else {
        const re = o, G = i;
        throw new Error("invalid Point, expected length of " + re + ", or uncompressed " + G + ", got " + D);
      }
    }
  }), g = (ne) => eg(rg(ne, t.nByteLength));
  function b(ne) {
    const D = n >> Jo;
    return ne > D;
  }
  function w(ne) {
    return b(ne) ? a(-ne) : ne;
  }
  const E = (ne, D, K) => Zp(ne.slice(D, K));
  class _ {
    constructor(D, K, le) {
      this.r = D, this.s = K, this.recovery = le, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(D) {
      const K = t.nByteLength;
      return D = bu("compactSignature", D, K * 2), new _(E(D, 0, K), E(D, K, 2 * K));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(D) {
      const { r: K, s: le } = Wl.toSig(bu("DER", D));
      return new _(K, le);
    }
    assertValidity() {
      Xp("r", this.r, Jo, n), Xp("s", this.s, Jo, n);
    }
    addRecoveryBit(D) {
      return new _(this.r, this.s, D);
    }
    recoverPublicKey(D) {
      const { r: K, s: le, recovery: re } = this, G = A(bu("msgHash", D));
      if (re == null || ![0, 1, 2, 3].includes(re))
        throw new Error("recovery id invalid");
      const q = re === 2 || re === 3 ? K + t.n : K;
      if (q >= r.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const Q = re & 1 ? "03" : "02", se = l.fromHex(Q + g(q)), J = u(q), ye = a(-G * J), ve = a(le * J), Ee = l.BASE.multiplyAndAddUnsafe(se, ye, ve);
      if (!Ee)
        throw new Error("point at infinify");
      return Ee.assertValidity(), Ee;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return b(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new _(this.r, a(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return tg(this.toDERHex());
    }
    toDERHex() {
      return Wl.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return tg(this.toCompactHex());
    }
    toCompactHex() {
      return g(this.r) + g(this.s);
    }
  }
  const O = {
    isValidPrivateKey(ne) {
      try {
        return d(ne), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: d,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const ne = XV(t.n);
      return L3e(t.randomBytes(ne), t.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(ne = 8, D = l.BASE) {
      return D._setWindowSize(ne), D.multiply(BigInt(3)), D;
    }
  };
  function C(ne, D = !0) {
    return l.fromPrivateKey(ne).toRawBytes(D);
  }
  function I(ne) {
    const D = l0(ne), K = typeof ne == "string", le = (D || K) && ne.length;
    return D ? le === o || le === i : K ? le === 2 * o || le === 2 * i : ne instanceof l;
  }
  function S(ne, D, K = !0) {
    if (I(ne))
      throw new Error("first arg must be private key");
    if (!I(D))
      throw new Error("second arg must be public key");
    return l.fromHex(D).multiply(d(ne)).toRawBytes(K);
  }
  const T = t.bits2int || function(ne) {
    if (ne.length > 8192)
      throw new Error("input is too large");
    const D = Zp(ne), K = ne.length * 8 - t.nBitLength;
    return K > 0 ? D >> BigInt(K) : D;
  }, A = t.bits2int_modN || function(ne) {
    return a(T(ne));
  }, $ = MB(t.nBitLength);
  function U(ne) {
    return Xp("num < 2^" + t.nBitLength, ne, Xl, $), rg(ne, t.nByteLength);
  }
  function M(ne, D, K = Y) {
    if (["recovered", "canonical"].some((we) => we in K))
      throw new Error("sign() legacy options not supported");
    const { hash: le, randomBytes: re } = t;
    let { lowS: G, prehash: q, extraEntropy: Q } = K;
    G == null && (G = !0), ne = bu("msgHash", ne), pz(K), q && (ne = bu("prehashed msgHash", le(ne)));
    const se = A(ne), J = d(D), ye = [U(J), U(se)];
    if (Q != null && Q !== !1) {
      const we = Q === !0 ? re(r.BYTES) : Q;
      ye.push(bu("extraEntropy", we));
    }
    const ve = qw(...ye), Ee = se;
    function _e(we) {
      const be = T(we);
      if (!h(be))
        return;
      const Ge = u(be), Le = l.BASE.multiply(be).toAffine(), Ne = a(Le.x);
      if (Ne === Xl)
        return;
      const Ve = a(Ge * a(Ee + Ne * J));
      if (Ve === Xl)
        return;
      let ge = (Le.x === Ne ? 0 : 2) | Number(Le.y & Jo), Te = Ve;
      return G && b(Ve) && (Te = w(Ve), ge ^= 1), new _(Ne, Te, ge);
    }
    return { seed: ve, k2sig: _e };
  }
  const Y = { lowS: t.lowS, prehash: !1 }, L = { lowS: t.lowS, prehash: !1 };
  function ee(ne, D, K = Y) {
    const { seed: le, k2sig: re } = M(ne, D, K), G = t;
    return GV(G.hash.outputLen, G.nByteLength, G.hmac)(le, re);
  }
  l.BASE._setWindowSize(8);
  function de(ne, D, K, le = L) {
    var re;
    const G = ne;
    D = bu("msgHash", D), K = bu("publicKey", K);
    const { lowS: q, prehash: Q, format: se } = le;
    if (pz(le), "strict" in le)
      throw new Error("options.strict was renamed to lowS");
    if (se !== void 0 && se !== "compact" && se !== "der")
      throw new Error("format must be compact or der");
    const J = typeof G == "string" || l0(G), ye = !J && !se && typeof G == "object" && G !== null && typeof G.r == "bigint" && typeof G.s == "bigint";
    if (!J && !ye)
      throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
    let ve, Ee;
    try {
      if (ye && (ve = new _(G.r, G.s)), J) {
        try {
          se !== "compact" && (ve = _.fromDER(G));
        } catch (ge) {
          if (!(ge instanceof Wl.Err))
            throw ge;
        }
        !ve && se !== "der" && (ve = _.fromCompact(G));
      }
      Ee = l.fromHex(K);
    } catch {
      return !1;
    }
    if (!ve || q && ve.hasHighS())
      return !1;
    Q && (D = t.hash(D));
    const { r: _e, s: we } = ve, be = A(D), Ge = u(we), Le = a(be * Ge), Ne = a(_e * Ge), Ve = (re = l.BASE.multiplyAndAddUnsafe(Ee, Le, Ne)) == null ? void 0 : re.toAffine();
    return Ve ? a(Ve.x) === _e : !1;
  }
  return {
    CURVE: t,
    getPublicKey: C,
    getSharedSecret: S,
    sign: ee,
    verify: de,
    ProjectivePoint: l,
    Signature: _,
    utils: O
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function Y3e(e) {
  return {
    hash: e,
    hmac: (t, ...r) => Q2.hmac(e, t, Vs.concatBytes(...r)),
    randomBytes: Vs.randomBytes
  };
}
function J3e(e, t) {
  const r = (n) => X3e({ ...e, ...Y3e(n) });
  return { ...r(t), create: r };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const eG = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), mz = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), Q3e = BigInt(1), jO = BigInt(2), yz = (e, t) => (e + t / jO) / t;
function e5e(e) {
  const t = eG, r = BigInt(3), n = BigInt(6), o = BigInt(11), i = BigInt(22), a = BigInt(23), u = BigInt(44), l = BigInt(88), d = e * e * e % t, f = d * d * e % t, h = Ss(f, r, t) * f % t, g = Ss(h, r, t) * f % t, b = Ss(g, jO, t) * d % t, w = Ss(b, o, t) * b % t, E = Ss(w, i, t) * w % t, _ = Ss(E, u, t) * E % t, O = Ss(_, l, t) * _ % t, C = Ss(O, u, t) * E % t, I = Ss(C, r, t) * f % t, S = Ss(I, a, t) * w % t, T = Ss(S, n, t) * d % t, A = Ss(T, jO, t);
  if (!LO.eql(LO.sqr(A), e))
    throw new Error("Cannot find square root");
  return A;
}
const LO = DB(eG, void 0, void 0, { sqrt: e5e }), Vw = J3e({
  a: BigInt(0),
  // equation params: a, b
  b: BigInt(7),
  Fp: LO,
  // Field's prime: 2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n
  n: mz,
  // Curve order, total count of valid points in the field
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  // Cofactor
  lowS: !0,
  // Allow only low-S signatures by default in sign() and verify()
  endo: {
    // Endomorphism, see above
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (e) => {
      const t = mz, r = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), n = -Q3e * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), o = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), i = r, a = BigInt("0x100000000000000000000000000000000"), u = yz(i * e, t), l = yz(-n * e, t);
      let d = ia(e - u * r - l * o, t), f = ia(-u * n - l * i, t);
      const h = d > a, g = f > a;
      if (h && (d = t - d), g && (f = t - f), d > a || f > a)
        throw new Error("splitScalar: Endomorphism failed, k=" + e);
      return { k1neg: h, k1: d, k2neg: g, k2: f };
    }
  }
}, qV);
BigInt(0);
function t5e(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function bz(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function r5e(e, t) {
  t5e(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error(`digestInto() expects output buffer of length at least ${r}`);
}
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const n5e = (e) => e instanceof Uint8Array, $T = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), cc = (e, t) => e << 32 - t | e >>> t, o5e = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!o5e)
  throw new Error("Non little-endian hardware is not supported");
function i5e(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function tG(e) {
  if (typeof e == "string" && (e = i5e(e)), !n5e(e))
    throw new Error(`expected Uint8Array, got ${typeof e}`);
  return e;
}
let a5e = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function s5e(e) {
  const t = (n) => e().update(tG(n)).digest(), r = e();
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = () => e(), t;
}
function u5e(e, t, r, n) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, r, n);
  const o = BigInt(32), i = BigInt(4294967295), a = Number(r >> o & i), u = Number(r & i), l = n ? 4 : 0, d = n ? 0 : 4;
  e.setUint32(t + l, a, n), e.setUint32(t + d, u, n);
}
let c5e = class extends a5e {
  constructor(e, t, r, n) {
    super(), this.blockLen = e, this.outputLen = t, this.padOffset = r, this.isLE = n, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = $T(this.buffer);
  }
  update(e) {
    bz(this);
    const { view: t, buffer: r, blockLen: n } = this;
    e = tG(e);
    const o = e.length;
    for (let i = 0; i < o; ) {
      const a = Math.min(n - this.pos, o - i);
      if (a === n) {
        const u = $T(e);
        for (; n <= o - i; i += n)
          this.process(u, i);
        continue;
      }
      r.set(e.subarray(i, i + a), this.pos), this.pos += a, i += a, this.pos === n && (this.process(t, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    bz(this), r5e(e, this), this.finished = !0;
    const { buffer: t, view: r, blockLen: n, isLE: o } = this;
    let { pos: i } = this;
    t[i++] = 128, this.buffer.subarray(i).fill(0), this.padOffset > n - i && (this.process(r, 0), i = 0);
    for (let f = i; f < n; f++)
      t[f] = 0;
    u5e(r, n - 8, BigInt(this.length * 8), o), this.process(r, 0);
    const a = $T(e), u = this.outputLen;
    if (u % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const l = u / 4, d = this.get();
    if (l > d.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let f = 0; f < l; f++)
      a.setUint32(4 * f, d[f], o);
  }
  digest() {
    const { buffer: e, outputLen: t } = this;
    this.digestInto(e);
    const r = e.slice(0, t);
    return this.destroy(), r;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: t, buffer: r, length: n, finished: o, destroyed: i, pos: a } = this;
    return e.length = n, e.pos = a, e.finished = o, e.destroyed = i, n % t && e.buffer.set(r), e;
  }
};
const l5e = (e, t, r) => e & t ^ ~e & r, f5e = (e, t, r) => e & t ^ e & r ^ t & r, d5e = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), Qf = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), ed = /* @__PURE__ */ new Uint32Array(64);
let h5e = class extends c5e {
  constructor() {
    super(64, 32, 8, !1), this.A = Qf[0] | 0, this.B = Qf[1] | 0, this.C = Qf[2] | 0, this.D = Qf[3] | 0, this.E = Qf[4] | 0, this.F = Qf[5] | 0, this.G = Qf[6] | 0, this.H = Qf[7] | 0;
  }
  get() {
    const { A: e, B: t, C: r, D: n, E: o, F: i, G: a, H: u } = this;
    return [e, t, r, n, o, i, a, u];
  }
  // prettier-ignore
  set(e, t, r, n, o, i, a, u) {
    this.A = e | 0, this.B = t | 0, this.C = r | 0, this.D = n | 0, this.E = o | 0, this.F = i | 0, this.G = a | 0, this.H = u | 0;
  }
  process(e, t) {
    for (let f = 0; f < 16; f++, t += 4)
      ed[f] = e.getUint32(t, !1);
    for (let f = 16; f < 64; f++) {
      const h = ed[f - 15], g = ed[f - 2], b = cc(h, 7) ^ cc(h, 18) ^ h >>> 3, w = cc(g, 17) ^ cc(g, 19) ^ g >>> 10;
      ed[f] = w + ed[f - 7] + b + ed[f - 16] | 0;
    }
    let { A: r, B: n, C: o, D: i, E: a, F: u, G: l, H: d } = this;
    for (let f = 0; f < 64; f++) {
      const h = cc(a, 6) ^ cc(a, 11) ^ cc(a, 25), g = d + h + l5e(a, u, l) + d5e[f] + ed[f] | 0, b = (cc(r, 2) ^ cc(r, 13) ^ cc(r, 22)) + f5e(r, n, o) | 0;
      d = l, l = u, u = a, a = i + g | 0, i = o, o = n, n = r, r = g + b | 0;
    }
    r = r + this.A | 0, n = n + this.B | 0, o = o + this.C | 0, i = i + this.D | 0, a = a + this.E | 0, u = u + this.F | 0, l = l + this.G | 0, d = d + this.H | 0, this.set(r, n, o, i, a, u, l, d);
  }
  roundClean() {
    ed.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
};
const HO = /* @__PURE__ */ s5e(() => new h5e());
/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// @__NO_SIDE_EFFECTS__
function rv(...e) {
  const t = (o, i) => (a) => o(i(a)), r = Array.from(e).reverse().reduce((o, i) => o ? t(o, i.encode) : i.encode, void 0), n = e.reduce((o, i) => o ? t(o, i.decode) : i.decode, void 0);
  return { encode: r, decode: n };
}
// @__NO_SIDE_EFFECTS__
function aE(e) {
  return {
    encode: (t) => {
      if (!Array.isArray(t) || t.length && typeof t[0] != "number")
        throw new Error("alphabet.encode input should be an array of numbers");
      return t.map((r) => {
        if (r < 0 || r >= e.length)
          throw new Error(`Digit index outside alphabet: ${r} (alphabet: ${e.length})`);
        return e[r];
      });
    },
    decode: (t) => {
      if (!Array.isArray(t) || t.length && typeof t[0] != "string")
        throw new Error("alphabet.decode input should be array of strings");
      return t.map((r) => {
        if (typeof r != "string")
          throw new Error(`alphabet.decode: not string element=${r}`);
        const n = e.indexOf(r);
        if (n === -1)
          throw new Error(`Unknown letter: "${r}". Allowed: ${e}`);
        return n;
      });
    }
  };
}
// @__NO_SIDE_EFFECTS__
function sE(e = "") {
  if (typeof e != "string")
    throw new Error("join separator should be string");
  return {
    encode: (t) => {
      if (!Array.isArray(t) || t.length && typeof t[0] != "string")
        throw new Error("join.encode input should be array of strings");
      for (let r of t)
        if (typeof r != "string")
          throw new Error(`join.encode: non-string input=${r}`);
      return t.join(e);
    },
    decode: (t) => {
      if (typeof t != "string")
        throw new Error("join.decode input should be string");
      return t.split(e);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function rG(e, t = "=") {
  if (typeof t != "string")
    throw new Error("padding chr should be string");
  return {
    encode(r) {
      if (!Array.isArray(r) || r.length && typeof r[0] != "string")
        throw new Error("padding.encode input should be array of strings");
      for (let n of r)
        if (typeof n != "string")
          throw new Error(`padding.encode: non-string input=${n}`);
      for (; r.length * e % 8; )
        r.push(t);
      return r;
    },
    decode(r) {
      if (!Array.isArray(r) || r.length && typeof r[0] != "string")
        throw new Error("padding.encode input should be array of strings");
      for (let o of r)
        if (typeof o != "string")
          throw new Error(`padding.decode: non-string input=${o}`);
      let n = r.length;
      if (n * e % 8)
        throw new Error("Invalid padding: string should have whole number of bytes");
      for (; n > 0 && r[n - 1] === t; n--)
        if (!((n - 1) * e % 8))
          throw new Error("Invalid padding: string has too much padding");
      return r.slice(0, n);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function wz(e, t, r) {
  if (t < 2)
    throw new Error(`convertRadix: wrong from=${t}, base cannot be less than 2`);
  if (r < 2)
    throw new Error(`convertRadix: wrong to=${r}, base cannot be less than 2`);
  if (!Array.isArray(e))
    throw new Error("convertRadix: data should be array");
  if (!e.length)
    return [];
  let n = 0;
  const o = [], i = Array.from(e);
  for (i.forEach((a) => {
    if (a < 0 || a >= t)
      throw new Error(`Wrong integer: ${a}`);
  }); ; ) {
    let a = 0, u = !0;
    for (let l = n; l < i.length; l++) {
      const d = i[l], f = t * a + d;
      if (!Number.isSafeInteger(f) || t * a / t !== a || f - d !== t * a)
        throw new Error("convertRadix: carry overflow");
      a = f % r;
      const h = Math.floor(f / r);
      if (i[l] = h, !Number.isSafeInteger(h) || h * r + a !== f)
        throw new Error("convertRadix: carry overflow");
      if (u)
        h ? u = !1 : n = l;
      else continue;
    }
    if (o.push(a), u)
      break;
  }
  for (let a = 0; a < e.length - 1 && e[a] === 0; a++)
    o.push(0);
  return o.reverse();
}
const nG = /* @__NO_SIDE_EFFECTS__ */ (e, t) => t ? /* @__PURE__ */ nG(t, e % t) : e, r5 = /* @__NO_SIDE_EFFECTS__ */ (e, t) => e + (t - /* @__PURE__ */ nG(e, t));
// @__NO_SIDE_EFFECTS__
function FO(e, t, r, n) {
  if (!Array.isArray(e))
    throw new Error("convertRadix2: data should be array");
  if (t <= 0 || t > 32)
    throw new Error(`convertRadix2: wrong from=${t}`);
  if (r <= 0 || r > 32)
    throw new Error(`convertRadix2: wrong to=${r}`);
  if (/* @__PURE__ */ r5(t, r) > 32)
    throw new Error(`convertRadix2: carry overflow from=${t} to=${r} carryBits=${/* @__PURE__ */ r5(t, r)}`);
  let o = 0, i = 0;
  const a = 2 ** r - 1, u = [];
  for (const l of e) {
    if (l >= 2 ** t)
      throw new Error(`convertRadix2: invalid data word=${l} from=${t}`);
    if (o = o << t | l, i + t > 32)
      throw new Error(`convertRadix2: carry overflow pos=${i} from=${t}`);
    for (i += t; i >= r; i -= r)
      u.push((o >> i - r & a) >>> 0);
    o &= 2 ** i - 1;
  }
  if (o = o << r - i & a, !n && i >= t)
    throw new Error("Excess padding");
  if (!n && o)
    throw new Error(`Non-zero padding: ${o}`);
  return n && i > 0 && u.push(o >>> 0), u;
}
// @__NO_SIDE_EFFECTS__
function p5e(e) {
  return {
    encode: (t) => {
      if (!(t instanceof Uint8Array))
        throw new Error("radix.encode input should be Uint8Array");
      return /* @__PURE__ */ wz(Array.from(t), 2 ** 8, e);
    },
    decode: (t) => {
      if (!Array.isArray(t) || t.length && typeof t[0] != "number")
        throw new Error("radix.decode input should be array of strings");
      return Uint8Array.from(/* @__PURE__ */ wz(t, e, 2 ** 8));
    }
  };
}
// @__NO_SIDE_EFFECTS__
function KB(e, t = !1) {
  if (e <= 0 || e > 32)
    throw new Error("radix2: bits should be in (0..32]");
  if (/* @__PURE__ */ r5(8, e) > 32 || /* @__PURE__ */ r5(e, 8) > 32)
    throw new Error("radix2: carry overflow");
  return {
    encode: (r) => {
      if (!(r instanceof Uint8Array))
        throw new Error("radix2.encode input should be Uint8Array");
      return /* @__PURE__ */ FO(Array.from(r), 8, e, !t);
    },
    decode: (r) => {
      if (!Array.isArray(r) || r.length && typeof r[0] != "number")
        throw new Error("radix2.decode input should be array of strings");
      return Uint8Array.from(/* @__PURE__ */ FO(r, e, 8, t));
    }
  };
}
// @__NO_SIDE_EFFECTS__
function vz(e) {
  if (typeof e != "function")
    throw new Error("unsafeWrapper fn should be function");
  return function(...t) {
    try {
      return e.apply(null, t);
    } catch {
    }
  };
}
// @__NO_SIDE_EFFECTS__
function g5e(e, t) {
  if (typeof t != "function")
    throw new Error("checksum fn should be function");
  return {
    encode(r) {
      if (!(r instanceof Uint8Array))
        throw new Error("checksum.encode: input should be Uint8Array");
      const n = t(r).slice(0, e), o = new Uint8Array(r.length + e);
      return o.set(r), o.set(n, r.length), o;
    },
    decode(r) {
      if (!(r instanceof Uint8Array))
        throw new Error("checksum.decode: input should be Uint8Array");
      const n = r.slice(0, -4), o = t(n).slice(0, e), i = r.slice(-4);
      for (let a = 0; a < e; a++)
        if (o[a] !== i[a])
          throw new Error("Invalid checksum");
      return n;
    }
  };
}
const Ez = /* @__PURE__ */ rv(/* @__PURE__ */ KB(6), /* @__PURE__ */ aE("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), /* @__PURE__ */ rG(6), /* @__PURE__ */ sE("")), _z = /* @__PURE__ */ rv(/* @__PURE__ */ KB(6), /* @__PURE__ */ aE("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), /* @__PURE__ */ rG(6), /* @__PURE__ */ sE("")), m5e = (e) => /* @__PURE__ */ rv(/* @__PURE__ */ p5e(58), /* @__PURE__ */ aE(e), /* @__PURE__ */ sE("")), y5e = /* @__PURE__ */ m5e("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), Az = (e) => /* @__PURE__ */ rv(/* @__PURE__ */ g5e(4, (t) => e(e(t))), y5e), MO = /* @__PURE__ */ rv(/* @__PURE__ */ aE("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), /* @__PURE__ */ sE("")), xz = [996825010, 642813549, 513874426, 1027748829, 705979059];
// @__NO_SIDE_EFFECTS__
function zb(e) {
  const t = e >> 25;
  let r = (e & 33554431) << 5;
  for (let n = 0; n < xz.length; n++)
    (t >> n & 1) === 1 && (r ^= xz[n]);
  return r;
}
// @__NO_SIDE_EFFECTS__
function kz(e, t, r = 1) {
  const n = e.length;
  let o = 1;
  for (let i = 0; i < n; i++) {
    const a = e.charCodeAt(i);
    if (a < 33 || a > 126)
      throw new Error(`Invalid prefix (${e})`);
    o = /* @__PURE__ */ zb(o) ^ a >> 5;
  }
  o = /* @__PURE__ */ zb(o);
  for (let i = 0; i < n; i++)
    o = /* @__PURE__ */ zb(o) ^ e.charCodeAt(i) & 31;
  for (let i of t)
    o = /* @__PURE__ */ zb(o) ^ i;
  for (let i = 0; i < 6; i++)
    o = /* @__PURE__ */ zb(o);
  return o ^= r, MO.encode(/* @__PURE__ */ FO([o % 2 ** 30], 30, 5, !1));
}
// @__NO_SIDE_EFFECTS__
function oG(e) {
  const t = e === "bech32" ? 1 : 734539939, r = /* @__PURE__ */ KB(5), n = r.decode, o = r.encode, i = /* @__PURE__ */ vz(n);
  function a(f, h, g = 90) {
    if (typeof f != "string")
      throw new Error(`bech32.encode prefix should be string, not ${typeof f}`);
    if (!Array.isArray(h) || h.length && typeof h[0] != "number")
      throw new Error(`bech32.encode words should be array of numbers, not ${typeof h}`);
    const b = f.length + 7 + h.length;
    if (g !== !1 && b > g)
      throw new TypeError(`Length ${b} exceeds limit ${g}`);
    const w = f.toLowerCase(), E = /* @__PURE__ */ kz(w, h, t);
    return `${w}1${MO.encode(h)}${E}`;
  }
  function u(f, h = 90) {
    if (typeof f != "string")
      throw new Error(`bech32.decode input should be string, not ${typeof f}`);
    if (f.length < 8 || h !== !1 && f.length > h)
      throw new TypeError(`Wrong string length: ${f.length} (${f}). Expected (8..${h})`);
    const g = f.toLowerCase();
    if (f !== g && f !== f.toUpperCase())
      throw new Error("String must be lowercase or uppercase");
    f = g;
    const b = f.lastIndexOf("1");
    if (b === 0 || b === -1)
      throw new Error('Letter "1" must be present between prefix and data only');
    const w = f.slice(0, b), E = f.slice(b + 1);
    if (E.length < 6)
      throw new Error("Data must be at least 6 characters long");
    const _ = MO.decode(E).slice(0, -6), O = /* @__PURE__ */ kz(w, _, t);
    if (!E.endsWith(O))
      throw new Error(`Invalid checksum in ${f}: expected "${O}"`);
    return { prefix: w, words: _ };
  }
  const l = /* @__PURE__ */ vz(u);
  function d(f) {
    const { prefix: h, words: g } = u(f, !1);
    return { prefix: h, words: g, bytes: n(g) };
  }
  return { encode: a, decode: u, decodeToBytes: d, decodeUnsafe: l, fromWords: n, fromWordsUnsafe: i, toWords: o };
}
const l8 = /* @__PURE__ */ oG("bech32"), f8 = /* @__PURE__ */ oG("bech32m"), _c = {
  b58chk: {
    encode: (e) => Az(HO).encode(e),
    decode: (e) => Az(HO).decode(e)
  },
  base64: {
    encode: (e) => Ez.encode(e),
    decode: (e) => Ez.decode(e)
  },
  b64url: {
    encode: (e) => _z.encode(e),
    decode: (e) => _z.decode(e)
  },
  bech32: {
    to_words: l8.toWords,
    to_bytes: l8.fromWords,
    encode: (e, t, r = !1) => l8.encode(e, t, r),
    decode: (e, t = !1) => {
      const { prefix: r, words: n } = l8.decode(e, t);
      return { prefix: r, words: n };
    }
  },
  bech32m: {
    to_words: f8.toWords,
    to_bytes: f8.fromWords,
    encode: (e, t, r = !1) => f8.encode(e, t, r),
    decode: (e, t = !1) => {
      const { prefix: r, words: n } = f8.decode(e, t);
      return { prefix: r, words: n };
    }
  }
};
function b5e(e, t) {
  if (e.length > t)
    throw new TypeError(`Data is larger than array size: ${e.length} > ${t}`);
}
function w5e(e) {
  if (e.match(/[^a-fA-f0-9]/) !== null)
    throw new TypeError("Invalid characters in hex string: " + e);
  if (e.length % 2 !== 0)
    throw new Error(`Length of hex string is invalid: ${e.length}`);
}
function v5e(e) {
  if (e > Number.MAX_SAFE_INTEGER)
    throw new TypeError("Number exceeds safe bounds!");
}
function iG(e, t) {
  if (e !== t)
    throw new TypeError(`Bech32 prefix does not match: ${e} !== ${t}`);
}
const E5e = BigInt(0), _5e = BigInt(255), aG = BigInt(256);
function A5e(e) {
  if (e <= 0xffn)
    return 1;
  if (e <= 0xffffn)
    return 2;
  if (e <= 0xffffffffn)
    return 4;
  if (e <= 0xffffffffffffffffn)
    return 8;
  if (e <= 0xffffffffffffffffffffffffffffffffn)
    return 16;
  if (e <= 0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffn)
    return 32;
  throw new TypeError("Must specify a fixed buffer size for bigints greater than 32 bytes.");
}
function x5e(e, t, r = "be") {
  t === void 0 && (t = A5e(e));
  const n = r === "le", o = new ArrayBuffer(t), i = new DataView(o);
  let a = n ? 0 : t - 1;
  for (; e > E5e; ) {
    const u = e & _5e, l = Number(u);
    n ? i.setUint8(a++, l) : i.setUint8(a--, l), e = (e - u) / aG;
  }
  return new Uint8Array(o);
}
function k5e(e) {
  let t = BigInt(0);
  for (let r = e.length - 1; r >= 0; r--)
    t = t * aG + BigInt(e[r]);
  return BigInt(t);
}
function S5e(e) {
  const t = e.split("").map(Number);
  if (t.length % 8 !== 0)
    throw new Error(`Binary array is invalid length: ${e.length}`);
  const r = new Uint8Array(t.length / 8);
  for (let n = 0, o = 0; n < t.length; n += 8, o++) {
    let i = 0;
    for (let a = 0; a < 8; a++)
      i |= t[n + a] << 7 - a;
    r[o] = i;
  }
  return r;
}
function T5e(e) {
  const t = new Array(e.length * 8);
  let r = 0;
  for (const n of e) {
    if (n > 255)
      throw new Error(`Invalid byte value: ${n}. Byte values must be between 0 and 255.`);
    for (let o = 7; o >= 0; o--, r++)
      t[r] = n >> o & 1;
  }
  return t.join("");
}
function I5e(e) {
  if (e <= 255)
    return 1;
  if (e <= 65535)
    return 2;
  if (e <= 4294967295)
    return 4;
  throw new TypeError("Numbers larger than 4 bytes must specify a fixed size!");
}
function O5e(e, t, r = "be") {
  t === void 0 && (t = I5e(e));
  const n = r === "le", o = new ArrayBuffer(t), i = new DataView(o);
  let a = n ? 0 : t - 1;
  for (; e > 0; ) {
    const u = e & 255;
    n ? i.setUint8(a++, e) : i.setUint8(a--, e), e = (e - u) / 256;
  }
  return new Uint8Array(o);
}
function P5e(e) {
  let t = 0;
  for (let r = e.length - 1; r >= 0; r--)
    t = t * 256 + e[r], v5e(t);
  return t;
}
const C5e = new TextEncoder(), B5e = new TextDecoder();
function qB(e) {
  return C5e.encode(e);
}
function UT(e) {
  return B5e.decode(e);
}
function N5e(e, t) {
  w5e(e);
  const r = e.length / 2;
  if (t === void 0 && (t = r), r > t)
    throw new TypeError(`Hex string is larger than array size: ${r} > ${t}`);
  return t;
}
function $5e(e, t, r = "le") {
  t = N5e(e, t);
  const n = r === "le", o = new ArrayBuffer(t), i = new DataView(o);
  let a = n ? 0 : t - 1;
  for (let u = 0; u < e.length; u += 2) {
    const l = e.substring(u, u + 2), d = parseInt(l, 16);
    n ? i.setUint8(a++, d) : i.setUint8(a--, d);
  }
  return new Uint8Array(o);
}
function U5e(e) {
  let t = "";
  for (let r = 0; r < e.length; r++)
    t += e[r].toString(16).padStart(2, "0");
  return t;
}
const { getRandomValues: R5e } = crypto ?? globalThis.crypto ?? window.crypto;
function z5e(e = 32) {
  if (typeof R5e == "function")
    return crypto.getRandomValues(new Uint8Array(e));
  throw new Error("Crypto module missing getRandomValues!");
}
function sG(e) {
  return e.match(/[^a-fA-f0-9]/) === null && e.length % 2 === 0;
}
function j5e(e) {
  return typeof e == "string" && sG(e) || typeof e == "number" || typeof e == "bigint" || e instanceof Uint8Array ? !0 : !!(Array.isArray(e) && e.every((t) => typeof t == "number"));
}
function L5e(e, t, r = "be") {
  t === void 0 && (t = e.length), b5e(e, t);
  const n = new Uint8Array(t).fill(0), o = r === "be" ? 0 : t - e.length;
  return n.set(e, o), n;
}
function uG(e) {
  let t, r = 0;
  const n = e.reduce((i, a) => i + a.length, 0), o = new Uint8Array(n);
  for (t = 0; t < e.length; t++) {
    const i = e[t];
    o.set(i, r), r += i.length;
  }
  return o;
}
function H5e(e, t) {
  return typeof t == "bigint" ? `${t}n` : t;
}
function F5e(e, t) {
  return typeof t == "string" && /n$/.test(t) ? BigInt(t.slice(0, -1)) : t;
}
function M5e(e, t, r) {
  const n = e.length, o = r / t;
  if (r % t !== 0)
    throw new TypeError(`Invalid parameters: ${r} % ${t} !== 0`);
  if (n !== r)
    throw new TypeError(`Invalid data stream: ${n} !== ${r}`);
  if (n % t !== 0)
    throw new TypeError(`Invalid data stream: ${n} % ${t} !== 0`);
  const i = new Array(o);
  for (let a = 0; a < o; a++) {
    const u = a * t;
    i[a] = e.subarray(u, u + t);
  }
  return i;
}
function VB(e, t, r) {
  if (e instanceof ArrayBuffer)
    return new Uint8Array(e);
  if (e instanceof Uint8Array)
    return L5e(e, t, r);
  if (Array.isArray(e)) {
    const n = e.map((o) => VB(o, t, r));
    return uG(n);
  } else {
    if (typeof e == "string")
      return $5e(e, t, r);
    if (typeof e == "bigint")
      return x5e(e, t, r);
    if (typeof e == "number")
      return O5e(e, t, r);
    if (typeof e == "boolean")
      return Uint8Array.of(e ? 1 : 0);
  }
  throw new TypeError("Unsupported format:" + typeof e);
}
var Jt;
let hn = (Jt = class extends Uint8Array {
  static random(e = 32) {
    const t = z5e(e);
    return new Jt(t, e);
  }
  static now(e = 4) {
    const t = Math.floor(Date.now() / 1e3);
    return new Jt(t, e);
  }
  constructor(e, t, r) {
    if (e instanceof Jt && t === void 0)
      return e;
    const n = VB(e, t, r);
    super(n);
  }
  get arr() {
    return [...this];
  }
  get num() {
    return this.to_num();
  }
  get big() {
    return this.to_big();
  }
  get str() {
    return this.to_str();
  }
  get hex() {
    return this.to_hex();
  }
  get raw() {
    return new Uint8Array(this);
  }
  get bin() {
    return this.to_bin();
  }
  get b58chk() {
    return this.to_b58chk();
  }
  get base64() {
    return this.to_base64();
  }
  get b64url() {
    return this.to_b64url();
  }
  get digest() {
    return this.to_hash();
  }
  get id() {
    return this.to_hash().hex;
  }
  get stream() {
    return new r4e(this);
  }
  to_num(e = "be") {
    const t = e === "be" ? this.reverse() : this;
    return P5e(t);
  }
  to_big(e = "be") {
    const t = e === "be" ? this.reverse() : this;
    return k5e(t);
  }
  to_bin() {
    return T5e(this);
  }
  to_hash() {
    const e = HO(this);
    return new Jt(e);
  }
  to_json(e) {
    e === void 0 && (e = F5e);
    const t = UT(this);
    return JSON.parse(t, e);
  }
  to_bech32(e, t) {
    const { encode: r, to_words: n } = _c.bech32, o = n(this);
    return r(e, o, t);
  }
  to_bech32m(e, t) {
    const { encode: r, to_words: n } = _c.bech32m, o = n(this);
    return r(e, o, t);
  }
  to_str() {
    return UT(this);
  }
  to_hex() {
    return U5e(this);
  }
  to_bytes() {
    return new Uint8Array(this);
  }
  to_b58chk() {
    return _c.b58chk.encode(this);
  }
  to_base64() {
    return _c.base64.encode(this);
  }
  to_b64url() {
    return _c.b64url.encode(this);
  }
  append(e) {
    return Jt.join([this, Jt.bytes(e)]);
  }
  prepend(e) {
    return Jt.join([Jt.bytes(e), this]);
  }
  reverse() {
    const e = new Uint8Array(this).reverse();
    return new Jt(e);
  }
  slice(e, t) {
    const r = new Uint8Array(this).slice(e, t);
    return new Jt(r);
  }
  set(e, t) {
    this.set(e, t);
  }
  subarray(e, t) {
    const r = new Uint8Array(this).subarray(e, t);
    return new Jt(r);
  }
  write(e, t) {
    const r = Jt.bytes(e);
    this.set(r, t);
  }
  add_varint(e) {
    const t = Jt.calc_varint(this.length, e);
    return Jt.join([t, this]);
  }
  static from(e) {
    return new Jt(Uint8Array.from(e));
  }
  static of(...e) {
    return new Jt(Uint8Array.of(...e));
  }
  static join(e) {
    const t = e.map((n) => Jt.bytes(n)), r = uG(t);
    return new Jt(r);
  }
  static sort(e, t) {
    const r = e.map((n) => Sz(n, t).hex);
    return r.sort(), r.map((n) => Jt.hex(n, t));
  }
  static calc_varint(e, t) {
    if (e < 253)
      return Jt.num(e, 1);
    if (e < 65536)
      return Jt.of(253, ...Jt.num(e, 2, t));
    if (e < 4294967296)
      return Jt.of(254, ...Jt.num(e, 4, t));
    if (BigInt(e) < 0x10000000000000000n)
      return Jt.of(255, ...Jt.num(e, 8, t));
    throw new Error(`Value is too large: ${e}`);
  }
}, Jt.num = D5e, Jt.big = q5e, Jt.bin = K5e, Jt.raw = V5e, Jt.str = G5e, Jt.hex = W5e, Jt.bytes = Sz, Jt.json = Z5e, Jt.base64 = X5e, Jt.b64url = Y5e, Jt.bech32 = J5e, Jt.bech32m = Q5e, Jt.b58chk = e4e, Jt.encode = qB, Jt.decode = UT, Jt.parse = t4e, Jt.is_bytes = j5e, Jt.is_hex = sG, Jt);
function D5e(e, t, r) {
  return new hn(e, t, r);
}
function K5e(e, t, r) {
  return new hn(S5e(e), t, r);
}
function q5e(e, t, r) {
  return new hn(e, t, r);
}
function V5e(e, t, r) {
  return new hn(e, t, r);
}
function G5e(e, t, r) {
  return new hn(qB(e), t, r);
}
function W5e(e, t, r) {
  return new hn(e, t, r);
}
function Z5e(e, t) {
  t === void 0 && (t = H5e);
  const r = JSON.stringify(e, t);
  return new hn(qB(r));
}
function X5e(e) {
  return new hn(_c.base64.decode(e));
}
function Y5e(e) {
  return new hn(_c.b64url.decode(e));
}
function J5e(e, t, r) {
  const { decode: n, to_bytes: o } = _c.bech32, { prefix: i, words: a } = n(e, t), u = o(a);
  return typeof r == "string" && iG(i, r), new hn(u);
}
function Q5e(e, t, r) {
  const { decode: n, to_bytes: o } = _c.bech32m, { prefix: i, words: a } = n(e, t), u = o(a);
  return typeof r == "string" && iG(i, r), new hn(u);
}
function e4e(e) {
  return new hn(_c.b58chk.decode(e));
}
function t4e(e, t, r) {
  const n = VB(e);
  return M5e(n, t, r).map((o) => hn.bytes(o));
}
let r4e = class {
  constructor(e) {
    this.data = hn.bytes(e), this.size = this.data.length;
  }
  peek(e) {
    if (e > this.size)
      throw new Error(`Size greater than stream: ${e} > ${this.size}`);
    return new hn(this.data.slice(0, e));
  }
  read(e) {
    const t = this.peek(e);
    return this.data = this.data.slice(e), this.size = this.data.length, t;
  }
  read_varint(e) {
    const t = this.read(1).num;
    switch (!0) {
      case (t >= 0 && t < 253):
        return t;
      case t === 253:
        return this.read(2).to_num(e);
      case t === 254:
        return this.read(4).to_num(e);
      case t === 255:
        return this.read(8).to_num(e);
      default:
        throw new Error(`Varint is out of range: ${t}`);
    }
  }
};
function Sz(e, t, r) {
  return new hn(e, t, r);
}
const n5 = Vw.CURVE, uE = n5.n, n4e = n5.p, Tz = { x: n5.Gx, y: n5.Gy }, o4e = BigInt(0);
BigInt(1);
BigInt(2);
BigInt(3);
BigInt(4);
const i4e = (e) => ia(e, uE);
function cG(e, t = !1) {
  if (!t)
    return !1;
  throw new Error(e);
}
function a4e(e, t, r) {
  const n = hn.bytes(e);
  return n.length !== t ? cG(`Invalid byte size: ${n.hex} !== ${t}`, r) : !0;
}
function s4e(e, t) {
  return typeof e == "bigint" && o4e < e && e < uE || cG("x value is not in the field!", t), !0;
}
const u4e = DB(uE, 32, !0), Iz = Vw.ProjectivePoint, jb = u4e;
var Yn;
let ng = (Yn = class extends Uint8Array {
  static add(e) {
    return e.map((t) => Yn.mod(t)).reduce((t, r) => t.add(r));
  }
  static mod(e) {
    return new Yn(e);
  }
  static mul(e) {
    return e.map((t) => Yn.mod(t)).reduce((t, r) => t.mul(r));
  }
  static is_valid(e, t) {
    const r = hn.bytes(e, 32).big;
    return s4e(r, t);
  }
  constructor(e) {
    const t = i4e(c4e(e));
    Yn.is_valid(t, !0), super(hn.big(t, 32), 32);
  }
  get buff() {
    return new hn(this);
  }
  get raw() {
    return this.buff.raw;
  }
  get big() {
    return this.buff.big;
  }
  get hex() {
    return this.buff.hex;
  }
  get point() {
    return this.generate();
  }
  get hasOddY() {
    return this.point.hasOddY;
  }
  get negated() {
    return this.hasOddY ? this.negate() : this;
  }
  gt(e) {
    return new Yn(e).big > this.big;
  }
  lt(e) {
    return new Yn(e).big < this.big;
  }
  eq(e) {
    return new Yn(e).big === this.big;
  }
  ne(e) {
    return new Yn(e).big !== this.big;
  }
  add(e) {
    const t = Yn.mod(e), r = jb.add(this.big, t.big);
    return new Yn(r);
  }
  sub(e) {
    const t = Yn.mod(e), r = jb.sub(this.big, t.big);
    return new Yn(r);
  }
  mul(e) {
    const t = Yn.mod(e), r = jb.mul(this.big, t.big);
    return new Yn(r);
  }
  pow(e) {
    const t = Yn.mod(e), r = jb.pow(this.big, t.big);
    return new Yn(r);
  }
  div(e) {
    const t = Yn.mod(e), r = jb.div(this.big, t.big);
    return new Yn(r);
  }
  negate() {
    return new Yn(Yn.N - this.big);
  }
  generate() {
    const e = Vw.ProjectivePoint.BASE.multiply(this.big);
    return GB.import(e);
  }
}, Yn.N = uE, Yn);
var ln;
let GB = (ln = class {
  static from_x(e, t = !1) {
    let r = l4e(e);
    r.length === 32 ? r = r.prepend(2) : t && (r[0] = 2), a4e(r, 33);
    const n = Iz.fromHex(r.hex);
    return n.assertValidity(), new ln(n.x, n.y);
  }
  static generate(e) {
    const t = ng.mod(e), r = ln.base.multiply(t.big);
    return ln.import(r);
  }
  static import(e) {
    const t = e instanceof ln ? { x: e.x.big, y: e.y.big } : { x: e.x, y: e.y };
    return new ln(t.x, t.y);
  }
  constructor(e, t) {
    this._p = new Iz(e, t, 1n), this.p.assertValidity();
  }
  get p() {
    return this._p;
  }
  get x() {
    return hn.big(this.p.x, 32);
  }
  get y() {
    return hn.big(this.p.y, 32);
  }
  get buff() {
    return hn.raw(this.p.toRawBytes(!0));
  }
  get raw() {
    return this.buff.raw;
  }
  get hex() {
    return this.buff.hex;
  }
  get hasEvenY() {
    return this.p.hasEvenY();
  }
  get hasOddY() {
    return !this.p.hasEvenY();
  }
  get negated() {
    return this.hasOddY ? this.negate() : this;
  }
  eq(e) {
    const t = e instanceof ln ? e : ln.from_x(e);
    return this.x.big === t.x.big && this.y.big === t.y.big;
  }
  add(e) {
    return e instanceof ln ? ln.import(this.p.add(e.p)) : ln.import(this.p.add(ln.generate(e).p));
  }
  sub(e) {
    return e instanceof ln ? ln.import(this.p.subtract(e.p)) : ln.import(this.p.subtract(ln.generate(e).p));
  }
  mul(e) {
    return e instanceof ln ? ln.import(this.p.multiply(e.x.big)) : ln.import(this.p.multiply(ng.mod(e).big));
  }
  negate() {
    return ln.import(this.p.negate());
  }
}, ln.P = n4e, ln.G = new ln(Tz.x, Tz.y), ln.curve = Vw.CURVE, ln.base = Vw.ProjectivePoint.BASE, ln.mul = ln.generate, ln);
function c4e(e) {
  if (e instanceof ng)
    return e.big;
  if (e instanceof GB)
    return e.x.big;
  if (e instanceof Uint8Array)
    return hn.raw(e).big;
  if (typeof e == "string")
    return hn.hex(e).big;
  if (typeof e == "number")
    return hn.num(e).big;
  if (typeof e == "bigint")
    return BigInt(e);
  throw TypeError("Invalid input type:" + typeof e);
}
function l4e(e) {
  if (e instanceof ng)
    return e.point.buff;
  if (e instanceof GB)
    return e.buff;
  if (e instanceof Uint8Array || typeof e == "string")
    return hn.bytes(e);
  if (typeof e == "number" || typeof e == "bigint")
    return hn.bytes(e, 32);
  throw new TypeError(`Unknown type: ${typeof e}`);
}
const d8 = /* @__PURE__ */ BigInt(2 ** 32 - 1), DO = /* @__PURE__ */ BigInt(32);
function lG(e, t = !1) {
  return t ? { h: Number(e & d8), l: Number(e >> DO & d8) } : { h: Number(e >> DO & d8) | 0, l: Number(e & d8) | 0 };
}
function f4e(e, t = !1) {
  let r = new Uint32Array(e.length), n = new Uint32Array(e.length);
  for (let o = 0; o < e.length; o++) {
    const { h: i, l: a } = lG(e[o], t);
    [r[o], n[o]] = [i, a];
  }
  return [r, n];
}
const d4e = (e, t) => BigInt(e >>> 0) << DO | BigInt(t >>> 0), h4e = (e, t, r) => e >>> r, p4e = (e, t, r) => e << 32 - r | t >>> r, g4e = (e, t, r) => e >>> r | t << 32 - r, m4e = (e, t, r) => e << 32 - r | t >>> r, y4e = (e, t, r) => e << 64 - r | t >>> r - 32, b4e = (e, t, r) => e >>> r - 32 | t << 64 - r, w4e = (e, t) => t, v4e = (e, t) => e, E4e = (e, t, r) => e << r | t >>> 32 - r, _4e = (e, t, r) => t << r | e >>> 32 - r, A4e = (e, t, r) => t << r - 32 | e >>> 64 - r, x4e = (e, t, r) => e << r - 32 | t >>> 64 - r;
function k4e(e, t, r, n) {
  const o = (t >>> 0) + (n >>> 0);
  return { h: e + r + (o / 2 ** 32 | 0) | 0, l: o | 0 };
}
const S4e = (e, t, r) => (e >>> 0) + (t >>> 0) + (r >>> 0), T4e = (e, t, r, n) => t + r + n + (e / 2 ** 32 | 0) | 0, I4e = (e, t, r, n) => (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0), O4e = (e, t, r, n, o) => t + r + n + o + (e / 2 ** 32 | 0) | 0, P4e = (e, t, r, n, o) => (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0) + (o >>> 0), C4e = (e, t, r, n, o, i) => t + r + n + o + i + (e / 2 ** 32 | 0) | 0, kr = {
  fromBig: lG,
  split: f4e,
  toBig: d4e,
  shrSH: h4e,
  shrSL: p4e,
  rotrSH: g4e,
  rotrSL: m4e,
  rotrBH: y4e,
  rotrBL: b4e,
  rotr32H: w4e,
  rotr32L: v4e,
  rotlSH: E4e,
  rotlSL: _4e,
  rotlBH: A4e,
  rotlBL: x4e,
  add: k4e,
  add3L: S4e,
  add3H: T4e,
  add4L: I4e,
  add4H: O4e,
  add5H: C4e,
  add5L: P4e
}, [B4e, N4e] = kr.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((e) => BigInt(e))), td = /* @__PURE__ */ new Uint32Array(80), rd = /* @__PURE__ */ new Uint32Array(80);
let $4e = class extends SB {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: e, Al: t, Bh: r, Bl: n, Ch: o, Cl: i, Dh: a, Dl: u, Eh: l, El: d, Fh: f, Fl: h, Gh: g, Gl: b, Hh: w, Hl: E } = this;
    return [e, t, r, n, o, i, a, u, l, d, f, h, g, b, w, E];
  }
  // prettier-ignore
  set(e, t, r, n, o, i, a, u, l, d, f, h, g, b, w, E) {
    this.Ah = e | 0, this.Al = t | 0, this.Bh = r | 0, this.Bl = n | 0, this.Ch = o | 0, this.Cl = i | 0, this.Dh = a | 0, this.Dl = u | 0, this.Eh = l | 0, this.El = d | 0, this.Fh = f | 0, this.Fl = h | 0, this.Gh = g | 0, this.Gl = b | 0, this.Hh = w | 0, this.Hl = E | 0;
  }
  process(e, t) {
    for (let C = 0; C < 16; C++, t += 4)
      td[C] = e.getUint32(t), rd[C] = e.getUint32(t += 4);
    for (let C = 16; C < 80; C++) {
      const I = td[C - 15] | 0, S = rd[C - 15] | 0, T = kr.rotrSH(I, S, 1) ^ kr.rotrSH(I, S, 8) ^ kr.shrSH(I, S, 7), A = kr.rotrSL(I, S, 1) ^ kr.rotrSL(I, S, 8) ^ kr.shrSL(I, S, 7), $ = td[C - 2] | 0, U = rd[C - 2] | 0, M = kr.rotrSH($, U, 19) ^ kr.rotrBH($, U, 61) ^ kr.shrSH($, U, 6), Y = kr.rotrSL($, U, 19) ^ kr.rotrBL($, U, 61) ^ kr.shrSL($, U, 6), L = kr.add4L(A, Y, rd[C - 7], rd[C - 16]), ee = kr.add4H(L, T, M, td[C - 7], td[C - 16]);
      td[C] = ee | 0, rd[C] = L | 0;
    }
    let { Ah: r, Al: n, Bh: o, Bl: i, Ch: a, Cl: u, Dh: l, Dl: d, Eh: f, El: h, Fh: g, Fl: b, Gh: w, Gl: E, Hh: _, Hl: O } = this;
    for (let C = 0; C < 80; C++) {
      const I = kr.rotrSH(f, h, 14) ^ kr.rotrSH(f, h, 18) ^ kr.rotrBH(f, h, 41), S = kr.rotrSL(f, h, 14) ^ kr.rotrSL(f, h, 18) ^ kr.rotrBL(f, h, 41), T = f & g ^ ~f & w, A = h & b ^ ~h & E, $ = kr.add5L(O, S, A, N4e[C], rd[C]), U = kr.add5H($, _, I, T, B4e[C], td[C]), M = $ | 0, Y = kr.rotrSH(r, n, 28) ^ kr.rotrBH(r, n, 34) ^ kr.rotrBH(r, n, 39), L = kr.rotrSL(r, n, 28) ^ kr.rotrBL(r, n, 34) ^ kr.rotrBL(r, n, 39), ee = r & o ^ r & a ^ o & a, de = n & i ^ n & u ^ i & u;
      _ = w | 0, O = E | 0, w = g | 0, E = b | 0, g = f | 0, b = h | 0, { h: f, l: h } = kr.add(l | 0, d | 0, U | 0, M | 0), l = a | 0, d = u | 0, a = o | 0, u = i | 0, o = r | 0, i = n | 0;
      const ne = kr.add3L(M, L, de);
      r = kr.add3H(ne, U, Y, ee), n = ne | 0;
    }
    ({ h: r, l: n } = kr.add(this.Ah | 0, this.Al | 0, r | 0, n | 0)), { h: o, l: i } = kr.add(this.Bh | 0, this.Bl | 0, o | 0, i | 0), { h: a, l: u } = kr.add(this.Ch | 0, this.Cl | 0, a | 0, u | 0), { h: l, l: d } = kr.add(this.Dh | 0, this.Dl | 0, l | 0, d | 0), { h: f, l: h } = kr.add(this.Eh | 0, this.El | 0, f | 0, h | 0), { h: g, l: b } = kr.add(this.Fh | 0, this.Fl | 0, g | 0, b | 0), { h: w, l: E } = kr.add(this.Gh | 0, this.Gl | 0, w | 0, E | 0), { h: _, l: O } = kr.add(this.Hh | 0, this.Hl | 0, _ | 0, O | 0), this.set(r, n, o, i, a, u, l, d, f, h, g, b, w, E, _, O);
  }
  roundClean() {
    td.fill(0), rd.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
};
const U4e = /* @__PURE__ */ kB(() => new $4e());
let fG = class extends Qq {
  constructor(e, t) {
    super(), this.finished = !1, this.destroyed = !1, Kwe(e);
    const r = xB(t);
    if (this.iHash = e.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const n = this.blockLen, o = new Uint8Array(n);
    o.set(r.length > n ? e.create().update(r).digest() : r);
    for (let i = 0; i < o.length; i++)
      o[i] ^= 54;
    this.iHash.update(o), this.oHash = e.create();
    for (let i = 0; i < o.length; i++)
      o[i] ^= 106;
    this.oHash.update(o), o.fill(0);
  }
  update(e) {
    return X3(this), this.iHash.update(e), this;
  }
  digestInto(e) {
    X3(this), AB(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
  }
  digest() {
    const e = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(e), e;
  }
  _cloneInto(e) {
    e || (e = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: t, iHash: r, finished: n, destroyed: o, blockLen: i, outputLen: a } = this;
    return e = e, e.finished = n, e.destroyed = o, e.blockLen = i, e.outputLen = a, e.oHash = t._cloneInto(e.oHash), e.iHash = r._cloneInto(e.iHash), e;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
};
const dG = (e, t, r) => new fG(e, t).update(r).digest();
dG.create = (e, t) => new fG(e, t);
function R4e(e, t = !1) {
  const r = ng.mod(e);
  return t ? r.negated.buff : r.buff;
}
function hG(e, t = !1) {
  const r = ng.mod(e).point;
  return t ? r.x : r.buff;
}
function KO(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function z4e(e) {
  if (typeof e != "boolean")
    throw new Error(`Expected boolean, not ${e}`);
}
function pG(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new TypeError(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function j4e(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  KO(e.outputLen), KO(e.blockLen);
}
function L4e(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function H4e(e, t) {
  pG(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error(`digestInto() expects output buffer of length at least ${r}`);
}
const F4e = {
  number: KO,
  bool: z4e,
  bytes: pG,
  hash: j4e,
  exists: L4e,
  output: H4e
};
var RT = F4e;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const zT = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), lc = (e, t) => e << 32 - t | e >>> t, M4e = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!M4e)
  throw new Error("Non little-endian hardware is not supported");
Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function D4e(e) {
  if (typeof e != "string")
    throw new TypeError(`utf8ToBytes expected string, got ${typeof e}`);
  return new TextEncoder().encode(e);
}
function gG(e) {
  if (typeof e == "string" && (e = D4e(e)), !(e instanceof Uint8Array))
    throw new TypeError(`Expected input type is Uint8Array (got ${typeof e})`);
  return e;
}
let K4e = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function mG(e) {
  const t = (n) => e().update(gG(n)).digest(), r = e();
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = () => e(), t;
}
function q4e(e, t, r, n) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, r, n);
  const o = BigInt(32), i = BigInt(4294967295), a = Number(r >> o & i), u = Number(r & i), l = n ? 4 : 0, d = n ? 0 : 4;
  e.setUint32(t + l, a, n), e.setUint32(t + d, u, n);
}
let V4e = class extends K4e {
  constructor(e, t, r, n) {
    super(), this.blockLen = e, this.outputLen = t, this.padOffset = r, this.isLE = n, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = zT(this.buffer);
  }
  update(e) {
    RT.exists(this);
    const { view: t, buffer: r, blockLen: n } = this;
    e = gG(e);
    const o = e.length;
    for (let i = 0; i < o; ) {
      const a = Math.min(n - this.pos, o - i);
      if (a === n) {
        const u = zT(e);
        for (; n <= o - i; i += n)
          this.process(u, i);
        continue;
      }
      r.set(e.subarray(i, i + a), this.pos), this.pos += a, i += a, this.pos === n && (this.process(t, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    RT.exists(this), RT.output(e, this), this.finished = !0;
    const { buffer: t, view: r, blockLen: n, isLE: o } = this;
    let { pos: i } = this;
    t[i++] = 128, this.buffer.subarray(i).fill(0), this.padOffset > n - i && (this.process(r, 0), i = 0);
    for (let f = i; f < n; f++)
      t[f] = 0;
    q4e(r, n - 8, BigInt(this.length * 8), o), this.process(r, 0);
    const a = zT(e), u = this.outputLen;
    if (u % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const l = u / 4, d = this.get();
    if (l > d.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let f = 0; f < l; f++)
      a.setUint32(4 * f, d[f], o);
  }
  digest() {
    const { buffer: e, outputLen: t } = this;
    this.digestInto(e);
    const r = e.slice(0, t);
    return this.destroy(), r;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: t, buffer: r, length: n, finished: o, destroyed: i, pos: a } = this;
    return e.length = n, e.pos = a, e.finished = o, e.destroyed = i, n % t && e.buffer.set(r), e;
  }
};
const G4e = (e, t, r) => e & t ^ ~e & r, W4e = (e, t, r) => e & t ^ e & r ^ t & r, Z4e = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), nd = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), od = new Uint32Array(64);
let yG = class extends V4e {
  constructor() {
    super(64, 32, 8, !1), this.A = nd[0] | 0, this.B = nd[1] | 0, this.C = nd[2] | 0, this.D = nd[3] | 0, this.E = nd[4] | 0, this.F = nd[5] | 0, this.G = nd[6] | 0, this.H = nd[7] | 0;
  }
  get() {
    const { A: e, B: t, C: r, D: n, E: o, F: i, G: a, H: u } = this;
    return [e, t, r, n, o, i, a, u];
  }
  // prettier-ignore
  set(e, t, r, n, o, i, a, u) {
    this.A = e | 0, this.B = t | 0, this.C = r | 0, this.D = n | 0, this.E = o | 0, this.F = i | 0, this.G = a | 0, this.H = u | 0;
  }
  process(e, t) {
    for (let f = 0; f < 16; f++, t += 4)
      od[f] = e.getUint32(t, !1);
    for (let f = 16; f < 64; f++) {
      const h = od[f - 15], g = od[f - 2], b = lc(h, 7) ^ lc(h, 18) ^ h >>> 3, w = lc(g, 17) ^ lc(g, 19) ^ g >>> 10;
      od[f] = w + od[f - 7] + b + od[f - 16] | 0;
    }
    let { A: r, B: n, C: o, D: i, E: a, F: u, G: l, H: d } = this;
    for (let f = 0; f < 64; f++) {
      const h = lc(a, 6) ^ lc(a, 11) ^ lc(a, 25), g = d + h + G4e(a, u, l) + Z4e[f] + od[f] | 0, b = (lc(r, 2) ^ lc(r, 13) ^ lc(r, 22)) + W4e(r, n, o) | 0;
      d = l, l = u, u = a, a = i + g | 0, i = o, o = n, n = r, r = g + b | 0;
    }
    r = r + this.A | 0, n = n + this.B | 0, o = o + this.C | 0, i = i + this.D | 0, a = a + this.E | 0, u = u + this.F | 0, l = l + this.G | 0, d = d + this.H | 0, this.set(r, n, o, i, a, u, l, d);
  }
  roundClean() {
    od.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}, X4e = class extends yG {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
};
const qO = mG(() => new yG());
mG(() => new X4e());
function Y4e(e, t) {
  if (e.length > t)
    throw new TypeError(`Data is larger than array size: ${e.length} > ${t}`);
}
function J4e(e) {
  if (e.match(/[^a-fA-f0-9]/) !== null)
    throw new TypeError("Invalid characters in hex string: " + e);
  if (e.length % 2 !== 0)
    throw new Error(`Length of hex string is invalid: ${e.length}`);
}
function Q4e(e) {
  if (e > Number.MAX_SAFE_INTEGER)
    throw new TypeError("Number exceeds safe bounds!");
}
const { getRandomValues: eEe } = crypto ?? globalThis.crypto ?? window.crypto;
function tEe(e = 32) {
  if (typeof eEe == "function")
    return crypto.getRandomValues(new Uint8Array(e));
  throw new Error("Crypto module missing getRandomValues!");
}
function rEe(e, t, r = "be") {
  t === void 0 && (t = e.length), Y4e(e, t);
  const n = new Uint8Array(t).fill(0), o = r === "be" ? 0 : t - e.length;
  return n.set(e, o), n;
}
function bG(e) {
  let t, r = 0;
  const n = e.reduce((i, a) => i + a.length, 0), o = new Uint8Array(n);
  for (t = 0; t < e.length; t++) {
    const i = e[t];
    o.set(i, r), r += i.length;
  }
  return o;
}
const nEe = new TextEncoder(), oEe = [
  {
    name: "base58",
    charset: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
  }
];
function wG(e) {
  for (const t of oEe)
    if (t.name === e)
      return t.charset;
  throw TypeError("Charset does not exist: " + e);
}
function iEe(e, t, r = !1) {
  typeof e == "string" && (e = nEe.encode(e));
  const n = wG(t), o = n.length, i = [];
  let a = "", u, l = 0, d, f;
  for (u = 0; u < e.length; u++)
    for (l = 0, d = e[u], a += d > 0 || (a.length ^ u) > 0 ? "" : "1"; l in i || d > 0; )
      f = i[l], f = f > 0 ? f * 256 + d : d, d = f / o | 0, i[l] = f % o, l++;
  for (; l-- > 0; )
    a += n[i[l]];
  return r && a.length % 4 > 0 ? a + "=".repeat(4 - a.length % 4) : a;
}
function aEe(e, t) {
  const r = wG(t), n = r.length, o = [], i = [];
  e = e.replace("=", "");
  let a, u = 0, l, d;
  for (a = 0; a < e.length; a++) {
    if (u = 0, l = r.indexOf(e[a]), l < 0)
      throw new Error(`Character range out of bounds: ${l}`);
    for (l > 0 || (i.length ^ a) > 0 || i.push(0); u in o || l > 0; )
      d = o[u], d = d > 0 ? d * n + l : l, l = d >> 8, o[u] = d % 256, u++;
  }
  for (; u-- > 0; )
    i.push(o[u]);
  return new Uint8Array(i);
}
function vG(e) {
  return qO(qO(e));
}
function sEe(e) {
  const t = vG(e);
  return bG([e, t.slice(0, 4)]);
}
function uEe(e) {
  const t = e.slice(0, -4), r = e.slice(-4);
  if (vG(t).slice(0, 4).toString() !== r.toString())
    throw new Error("Invalid checksum!");
  return t;
}
const Oz = {
  encode: iEe,
  decode: aEe
}, EG = {
  encode: (e) => {
    const t = sEe(e);
    return Oz.encode(t, "base58");
  },
  decode: (e) => {
    const t = Oz.decode(e, "base58");
    return uEe(t);
  }
}, _G = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", cEe = [996825010, 642813549, 513874426, 1027748829, 705979059], o5 = [
  { version: 0, name: "bech32", const: 1 },
  { version: 1, name: "bech32m", const: 734539939 }
];
function AG(e) {
  let t = 1;
  for (let r = 0; r < e.length; ++r) {
    const n = t >> 25;
    t = (t & 33554431) << 5 ^ e[r];
    for (let o = 0; o < 5; ++o)
      n >> o & 1 && (t ^= cEe[o]);
  }
  return t;
}
function xG(e) {
  const t = [];
  let r;
  for (r = 0; r < e.length; ++r)
    t.push(e.charCodeAt(r) >> 5);
  for (t.push(0), r = 0; r < e.length; ++r)
    t.push(e.charCodeAt(r) & 31);
  return t;
}
function lEe(e, t, r) {
  const n = xG(e).concat(t);
  return AG(n) === r.const;
}
function fEe(e, t, r) {
  const n = xG(e).concat(t).concat([0, 0, 0, 0, 0, 0]), o = AG(n) ^ r.const, i = [];
  for (let a = 0; a < 6; ++a)
    i.push(o >> 5 * (5 - a) & 31);
  return i;
}
function kG(e, t, r, n = !0) {
  const o = [];
  let i = 0, a = 0;
  const u = (1 << r) - 1, l = (1 << t + r - 1) - 1;
  for (const d of e) {
    if (d < 0 || d >> t > 0)
      throw new Error("Failed to perform base conversion. Invalid value: " + String(d));
    for (i = (i << t | d) & l, a += t; a >= r; )
      a -= r, o.push(i >> a & u);
  }
  if (n)
    a > 0 && o.push(i << r - a & u);
  else if (a >= t || (i << r - a & u) > 0)
    throw new Error("Failed to perform base conversion. Invalid Size!");
  return o;
}
function dEe(e, t, r) {
  const n = t.concat(fEe(e, t, r));
  let o = e + "1";
  for (let i = 0; i < n.length; ++i)
    o += _G.charAt(n[i]);
  return o;
}
function SG(e) {
  if (!hEe(e))
    throw new Error("Encoded string goes out of bounds!");
  if (e = e.toLowerCase(), !pEe(e))
    throw new Error("Encoded string has invalid separator!");
  const t = [], r = e.lastIndexOf("1"), n = e.substring(0, r);
  for (let i = r + 1; i < e.length; ++i) {
    const a = _G.indexOf(e.charAt(i));
    if (a === -1)
      throw new Error("Character idx out of bounds: " + String(i));
    t.push(a);
  }
  const o = o5.find((i) => i.version === t[0]) ?? o5[0];
  if (!lEe(n, t, o))
    throw new Error("Checksum verification failed!");
  return [n, t.slice(0, t.length - 6)];
}
function hEe(e) {
  let t, r, n = !1, o = !1;
  for (t = 0; t < e.length; ++t) {
    if (r = e.charCodeAt(t), r < 33 || r > 126)
      return !1;
    r >= 97 && r <= 122 && (n = !0), r >= 65 && r <= 90 && (o = !0);
  }
  return !(n && o);
}
function pEe(e) {
  const t = e.lastIndexOf("1");
  return !(t < 1 || t + 7 > e.length || e.length > 90);
}
function gEe(e, t = "bc", r = 0) {
  const n = [r, ...kG([...e], 8, 5)], o = o5.find((a) => a.version === r) ?? o5[0], i = dEe(t, n, o);
  return TG(i), i;
}
function TG(e) {
  e = e.toLowerCase();
  const t = e.split("1", 1)[0], [r, n] = SG(e), o = kG(n.slice(1), 5, 8, !1), i = o.length;
  switch (!0) {
    case t !== r:
      throw new Error("Returned hrp string is invalid.");
    case (o === null || i < 2 || i > 40):
      throw new Error("Decoded string is invalid or out of spec.");
    case n[0] > 16:
      throw new Error("Returned version bit is out of range.");
    default:
      return Uint8Array.from(o);
  }
}
function mEe(e) {
  e = e.toLowerCase();
  const [t, r] = SG(e);
  return r[0];
}
const IG = {
  encode: gEe,
  decode: TG,
  version: mEe
}, OG = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", PG = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", yEe = new TextEncoder();
function CG(e, t = !1, r = !0) {
  typeof e == "string" && (e = yEe.encode(e));
  const n = t ? PG : OG;
  let o = "", i = 0, a = 0;
  for (let u = 0; u < e.length; u++)
    for (a = a << 8 | e[u], i += 8; i >= 6; )
      i -= 6, o += n[a >> i & 63];
  if (i > 0)
    for (a <<= 6 - i, o += n[a & 63]; i < 6; )
      o += r ? "=" : "", i += 2;
  return o;
}
function BG(e, t = !1) {
  const r = t || e.includes("-") || e.includes("_") ? PG.split("") : OG.split("");
  e = e.replace(/=+$/, "");
  const n = e.split("");
  let o = 0, i = 0;
  const a = [];
  for (let u = 0; u < n.length; u++) {
    const l = n[u], d = r.indexOf(l);
    if (d === -1)
      throw new Error("Invalid character: " + l);
    o += 6, i <<= 6, i |= d, o >= 8 && (o -= 8, a.push(i >>> o & 255));
  }
  return new Uint8Array(a);
}
const NG = {
  encode: CG,
  decode: BG
}, $G = {
  encode: (e) => CG(e, !0, !1),
  decode: (e) => BG(e, !0)
}, bEe = BigInt(0), wEe = BigInt(255), UG = BigInt(256);
function vEe(e) {
  if (e <= 0xffn)
    return 1;
  if (e <= 0xffffn)
    return 2;
  if (e <= 0xffffffffn)
    return 4;
  if (e <= 0xffffffffffffffffn)
    return 8;
  if (e <= 0xffffffffffffffffffffffffffffffffn)
    return 16;
  if (e <= 0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffn)
    return 32;
  throw new TypeError("Must specify a fixed buffer size for bigints greater than 32 bytes.");
}
function EEe(e, t, r = "be") {
  t === void 0 && (t = vEe(e));
  const n = r === "le", o = new ArrayBuffer(t), i = new DataView(o);
  let a = n ? 0 : t - 1;
  for (; e > bEe; ) {
    const u = e & wEe, l = Number(u);
    n ? i.setUint8(a++, l) : i.setUint8(a--, l), e = (e - u) / UG;
  }
  return new Uint8Array(o);
}
function _Ee(e) {
  let t = BigInt(0);
  for (let r = e.length - 1; r >= 0; r--)
    t = t * UG + BigInt(e[r]);
  return BigInt(t);
}
function AEe(e) {
  const t = e.split("").map(Number);
  if (t.length % 8 !== 0)
    throw new Error(`Binary array is invalid length: ${e.length}`);
  const r = new Uint8Array(t.length / 8);
  for (let n = 0, o = 0; n < t.length; n += 8, o++) {
    let i = 0;
    for (let a = 0; a < 8; a++)
      i |= t[n + a] << 7 - a;
    r[o] = i;
  }
  return r;
}
function xEe(e) {
  const t = new Array(e.length * 8);
  let r = 0;
  for (const n of e) {
    if (n > 255)
      throw new Error(`Invalid byte value: ${n}. Byte values must be between 0 and 255.`);
    for (let o = 7; o >= 0; o--, r++)
      t[r] = n >> o & 1;
  }
  return t.join("");
}
function kEe(e) {
  if (e <= 255)
    return 1;
  if (e <= 65535)
    return 2;
  if (e <= 4294967295)
    return 4;
  throw new TypeError("Numbers larger than 4 bytes must specify a fixed size!");
}
function SEe(e, t, r = "be") {
  t === void 0 && (t = kEe(e));
  const n = r === "le", o = new ArrayBuffer(t), i = new DataView(o);
  let a = n ? 0 : t - 1;
  for (; e > 0; ) {
    const u = e & 255;
    n ? i.setUint8(a++, e) : i.setUint8(a--, e), e = (e - u) / 256;
  }
  return new Uint8Array(o);
}
function TEe(e) {
  let t = 0;
  for (let r = e.length - 1; r >= 0; r--)
    t = t * 256 + e[r], Q4e(t);
  return t;
}
const IEe = new TextEncoder(), OEe = new TextDecoder();
function WB(e) {
  return IEe.encode(e);
}
function jT(e) {
  return OEe.decode(e);
}
function PEe(e, t) {
  J4e(e);
  const r = e.length / 2;
  if (t === void 0 && (t = r), r > t)
    throw new TypeError(`Hex string is larger than array size: ${r} > ${t}`);
  return t;
}
function CEe(e, t, r = "le") {
  t = PEe(e, t);
  const n = r === "le", o = new ArrayBuffer(t), i = new DataView(o);
  let a = n ? 0 : t - 1;
  for (let u = 0; u < e.length; u += 2) {
    const l = e.substring(u, u + 2), d = parseInt(l, 16);
    n ? i.setUint8(a++, d) : i.setUint8(a--, d);
  }
  return new Uint8Array(o);
}
function BEe(e) {
  let t = "";
  for (let r = 0; r < e.length; r++)
    t += e[r].toString(16).padStart(2, "0");
  return t;
}
function NEe(e) {
  const t = JSON.stringify(e, (r, n) => typeof n == "bigint" ? `${n}n` : n);
  return WB(t);
}
function $Ee(e, t, r) {
  if (e instanceof ArrayBuffer)
    return new Uint8Array(e);
  if (e instanceof Uint8Array)
    return rEe(e, t, r);
  if (typeof e == "string")
    return CEe(e, t, r);
  if (typeof e == "bigint")
    return EEe(e, t, r);
  if (typeof e == "number")
    return SEe(e, t, r);
  if (typeof e == "boolean")
    return Uint8Array.of(e ? 1 : 0);
  throw TypeError("Unsupported format:" + typeof e);
}
var Cr;
let ke = (Cr = class extends Uint8Array {
  static random(e = 32) {
    const t = tEe(e);
    return new Cr(t, e);
  }
  constructor(e, t, r) {
    const n = $Ee(e, t, r);
    super(n);
  }
  get arr() {
    return [...this];
  }
  get num() {
    return this.toNum();
  }
  get big() {
    return this.toBig();
  }
  get str() {
    return this.toStr();
  }
  get hex() {
    return this.toHex();
  }
  get raw() {
    return new Uint8Array(this);
  }
  get bin() {
    return this.toBin();
  }
  get b58chk() {
    return this.tob58chk();
  }
  get base64() {
    return this.toBase64();
  }
  get b64url() {
    return this.toB64url();
  }
  get digest() {
    return this.toHash();
  }
  get id() {
    return this.toHash().hex;
  }
  get stream() {
    return new Rg(this);
  }
  toNum(e = "be") {
    const t = e === "be" ? this.reverse() : this;
    return TEe(t);
  }
  toBin() {
    return xEe(this);
  }
  toBig(e = "be") {
    const t = e === "be" ? this.reverse() : this;
    return _Ee(t);
  }
  toHash() {
    const e = qO(this);
    return new Cr(e);
  }
  toJson() {
    const e = jT(this);
    return JSON.parse(e);
  }
  toBech32(e, t = 0) {
    return IG.encode(this, e, t);
  }
  toStr() {
    return jT(this);
  }
  toHex() {
    return BEe(this);
  }
  toBytes() {
    return new Uint8Array(this);
  }
  tob58chk() {
    return EG.encode(this);
  }
  toBase64() {
    return NG.encode(this);
  }
  toB64url() {
    return $G.encode(this);
  }
  prepend(e) {
    return Cr.join([Cr.bytes(e), this]);
  }
  append(e) {
    return Cr.join([this, Cr.bytes(e)]);
  }
  slice(e, t) {
    const r = new Uint8Array(this).slice(e, t);
    return new Cr(r);
  }
  subarray(e, t) {
    const r = new Uint8Array(this).subarray(e, t);
    return new Cr(r);
  }
  reverse() {
    const e = new Uint8Array(this).reverse();
    return new Cr(e);
  }
  write(e, t) {
    const r = Cr.bytes(e);
    this.set(r, t);
  }
  prefixSize(e) {
    const t = Cr.varInt(this.length, e);
    return Cr.join([t, this]);
  }
  static from(e) {
    return new Cr(Uint8Array.from(e));
  }
  static of(...e) {
    return new Cr(Uint8Array.of(...e));
  }
  static join(e) {
    const t = e.map((n) => Cr.bytes(n)), r = bG(t);
    return new Cr(r);
  }
  static varInt(e, t) {
    if (e < 253)
      return Cr.num(e, 1);
    if (e < 65536)
      return Cr.of(253, ...Cr.num(e, 2, t));
    if (e < 4294967296)
      return Cr.of(254, ...Cr.num(e, 4, t));
    if (BigInt(e) < 0x10000000000000000n)
      return Cr.of(255, ...Cr.num(e, 8, t));
    throw new Error(`Value is too large: ${e}`);
  }
}, Cr.num = UEe, Cr.big = zEe, Cr.bin = REe, Cr.raw = jEe, Cr.str = LEe, Cr.hex = HEe, Cr.bytes = FEe, Cr.json = MEe, Cr.base64 = DEe, Cr.b64url = KEe, Cr.bech32 = qEe, Cr.b58chk = VEe, Cr.encode = WB, Cr.decode = jT, Cr);
function UEe(e, t, r) {
  return new ke(e, t, r);
}
function REe(e, t, r) {
  return new ke(AEe(e), t, r);
}
function zEe(e, t, r) {
  return new ke(e, t, r);
}
function jEe(e, t, r) {
  return new ke(e, t, r);
}
function LEe(e, t, r) {
  return new ke(WB(e), t, r);
}
function HEe(e, t, r) {
  return new ke(e, t, r);
}
function FEe(e, t, r) {
  return new ke(e, t, r);
}
function MEe(e) {
  return new ke(NEe(e));
}
function DEe(e) {
  return new ke(NG.decode(e));
}
function KEe(e) {
  return new ke($G.decode(e));
}
function qEe(e) {
  return new ke(IG.decode(e));
}
function VEe(e) {
  return new ke(EG.decode(e));
}
let Rg = class {
  constructor(e) {
    this.data = ke.bytes(e), this.size = this.data.length;
  }
  peek(e) {
    if (e > this.size)
      throw new Error(`Size greater than stream: ${e} > ${this.size}`);
    return new ke(this.data.slice(0, e));
  }
  read(e) {
    e = e ?? this.readSize();
    const t = this.peek(e);
    return this.data = this.data.slice(e), this.size = this.data.length, t;
  }
  readSize(e) {
    const t = this.read(1).num;
    switch (!0) {
      case (t >= 0 && t < 253):
        return t;
      case t === 253:
        return this.read(2).toNum(e);
      case t === 254:
        return this.read(4).toNum(e);
      case t === 255:
        return this.read(8).toNum(e);
      default:
        throw new Error(`Varint is out of range: ${t}`);
    }
  }
};
function Uc(e, t) {
  const r = ke.bytes(e);
  if (r.length !== t)
    throw new Error(`Invalid input size: ${r.hex} !== ${t}`);
}
function zi(e, t) {
  if (t)
    throw new Error(e);
  return !1;
}
function K8(e, ...t) {
  const r = ke.str(e).digest.raw, n = t.map((o) => ke.bytes(o));
  return ke.join([r, r, ke.join(n)]).digest;
}
const RG = {
  OP_0: 0,
  OP_PUSHDATA1: 76,
  OP_PUSHDATA2: 77,
  OP_PUSHDATA4: 78,
  OP_1NEGATE: 79,
  OP_SUCCESS80: 80,
  OP_1: 81,
  OP_2: 82,
  OP_3: 83,
  OP_4: 84,
  OP_5: 85,
  OP_6: 86,
  OP_7: 87,
  OP_8: 88,
  OP_9: 89,
  OP_10: 90,
  OP_11: 91,
  OP_12: 92,
  OP_13: 93,
  OP_14: 94,
  OP_15: 95,
  OP_16: 96,
  OP_NOP: 97,
  OP_SUCCESS98: 98,
  OP_IF: 99,
  OP_NOTIF: 100,
  OP_ELSE: 103,
  OP_ENDIF: 104,
  OP_VERIFY: 105,
  OP_RETURN: 106,
  OP_TOALTSTACK: 107,
  OP_FROMALTSTACK: 108,
  OP_2DROP: 109,
  OP_2DUP: 110,
  OP_3DUP: 111,
  OP_2OVER: 112,
  OP_2ROT: 113,
  OP_2SWAP: 114,
  OP_IFDUP: 115,
  OP_DEPTH: 116,
  OP_DROP: 117,
  OP_DUP: 118,
  OP_NIP: 119,
  OP_OVER: 120,
  OP_PICK: 121,
  OP_ROLL: 122,
  OP_ROT: 123,
  OP_SWAP: 124,
  OP_TUCK: 125,
  OP_SUCCESS126: 126,
  OP_SUCCESS127: 127,
  OP_SUCCESS128: 128,
  OP_SUCCESS129: 129,
  OP_SIZE: 130,
  OP_SUCCESS131: 131,
  OP_SUCCESS132: 132,
  OP_SUCCESS133: 133,
  OP_SUCCESS134: 134,
  OP_EQUAL: 135,
  OP_EQUALVERIFY: 136,
  OP_SUCCESS137: 137,
  OP_SUCCESS138: 138,
  OP_1ADD: 139,
  OP_1SUB: 140,
  OP_SUCCESS141: 141,
  OP_SUCCESS142: 142,
  OP_NEGATE: 143,
  OP_ABS: 144,
  OP_NOT: 145,
  OP_0NOTEQUAL: 146,
  OP_ADD: 147,
  OP_SUB: 148,
  OP_SUCCESS149: 149,
  OP_SUCCESS150: 150,
  OP_SUCCESS151: 151,
  OP_SUCCESS152: 152,
  OP_SUCCESS153: 153,
  OP_BOOLAND: 154,
  OP_BOOLOR: 155,
  OP_NUMEQUAL: 156,
  OP_NUMEQUALVERIFY: 157,
  OP_NUMNOTEQUAL: 158,
  OP_LESSTHAN: 159,
  OP_GREATERTHAN: 160,
  OP_LESSTHANOREQUAL: 161,
  OP_GREATERTHANOREQUAL: 162,
  OP_MIN: 163,
  OP_MAX: 164,
  OP_WITHIN: 165,
  OP_RIPEMD160: 166,
  OP_SHA1: 167,
  OP_SHA256: 168,
  OP_HASH160: 169,
  OP_HASH256: 170,
  OP_CODESEPARATOR: 171,
  OP_CHECKSIG: 172,
  OP_CHECKSIGVERIFY: 173,
  OP_CHECKMULTISIG: 174,
  OP_CHECKMULTISIGVERIFY: 175,
  OP_NOP1: 176,
  OP_CHECKLOCKTIMEVERIFY: 177,
  OP_CHECKSEQUENCEVERIFY: 178,
  OP_NOP4: 179,
  OP_NOP5: 180,
  OP_NOP6: 181,
  OP_NOP7: 182,
  OP_NOP8: 183,
  OP_NOP9: 184,
  OP_NOP10: 185,
  OP_CHECKSIGADD: 186,
  OP_SUCCESS187: 187,
  OP_SUCCESS188: 188,
  OP_SUCCESS189: 189,
  OP_SUCCESS190: 190,
  OP_SUCCESS191: 191,
  OP_SUCCESS192: 192,
  OP_SUCCESS193: 193,
  OP_SUCCESS194: 194,
  OP_SUCCESS195: 195,
  OP_SUCCESS196: 196,
  OP_SUCCESS197: 197,
  OP_SUCCESS198: 198,
  OP_SUCCESS199: 199,
  OP_SUCCESS200: 200,
  OP_SUCCESS201: 201,
  OP_SUCCESS202: 202,
  OP_SUCCESS203: 203,
  OP_SUCCESS204: 204,
  OP_SUCCESS205: 205,
  OP_SUCCESS206: 206,
  OP_SUCCESS207: 207,
  OP_SUCCESS208: 208,
  OP_SUCCESS209: 209,
  OP_SUCCESS210: 210,
  OP_SUCCESS211: 211,
  OP_SUCCESS212: 212,
  OP_SUCCESS213: 213,
  OP_SUCCESS214: 214,
  OP_SUCCESS215: 215,
  OP_SUCCESS216: 216,
  OP_SUCCESS217: 217,
  OP_SUCCESS218: 218,
  OP_SUCCESS219: 219,
  OP_SUCCESS220: 220,
  OP_SUCCESS221: 221,
  OP_SUCCESS222: 222,
  OP_SUCCESS223: 223,
  OP_SUCCESS224: 224,
  OP_SUCCESS225: 225,
  OP_SUCCESS226: 226,
  OP_SUCCESS227: 227,
  OP_SUCCESS228: 228,
  OP_SUCCESS229: 229,
  OP_SUCCESS230: 230,
  OP_SUCCESS231: 231,
  OP_SUCCESS232: 232,
  OP_SUCCESS233: 233,
  OP_SUCCESS234: 234,
  OP_SUCCESS235: 235,
  OP_SUCCESS236: 236,
  OP_SUCCESS237: 237,
  OP_SUCCESS238: 238,
  OP_SUCCESS239: 239,
  OP_SUCCESS240: 240,
  OP_SUCCESS241: 241,
  OP_SUCCESS242: 242,
  OP_SUCCESS243: 243,
  OP_SUCCESS244: 244,
  OP_SUCCESS245: 245,
  OP_SUCCESS246: 246,
  OP_SUCCESS247: 247,
  OP_SUCCESS248: 248,
  OP_SUCCESS249: 249,
  OP_SUCCESS250: 250,
  OP_SUCCESS251: 251,
  OP_SUCCESS252: 252,
  OP_SUCCESS253: 253,
  OP_SUCCESS254: 254
};
function GEe(e) {
  if (e > 186 && e < 255)
    return "OP_SUCCESS" + String(e);
  for (const [t, r] of Object.entries(RG))
    if (r === e)
      return t;
  throw new Error("OPCODE not found:" + String(e));
}
function WEe(e) {
  for (const [t, r] of Object.entries(RG))
    if (t === e)
      return Number(r);
  throw new Error("OPCODE not found:" + e);
}
function ZEe(e) {
  switch (!0) {
    case e === 0:
      return "opcode";
    case (e >= 1 && e <= 75):
      return "varint";
    case e === 76:
      return "pushdata1";
    case e === 77:
      return "pushdata2";
    case e === 78:
      return "pushdata4";
    case e <= 254:
      return "opcode";
    default:
      throw new Error(`Invalid word range: ${e}`);
  }
}
function XEe(e) {
  const t = [];
  switch (!0) {
    case typeof e != "number":
      return !1;
    case e === 0:
      return !0;
    case t.includes(e):
      return !1;
    case (75 < e && e < 254):
      return !0;
    default:
      return !1;
  }
}
function Ef(e) {
  return typeof e == "string" && e.length % 2 === 0 && /[0-9a-fA-F]/.test(e);
}
function zG(e) {
  return Ef(e) || e instanceof Uint8Array;
}
const i5 = 520;
function B0(e = [], t = !0) {
  let r = ke.num(0);
  return Array.isArray(e) && (r = ke.raw(jG(e))), Ef(e) && (r = ke.hex(e)), e instanceof Uint8Array && (r = ke.raw(e)), t && (r = r.prefixSize("le")), r;
}
function jG(e) {
  const t = [];
  for (const r of e)
    t.push(YEe(r));
  return t.length > 0 ? ke.join(t) : new Uint8Array();
}
function YEe(e) {
  let t = new Uint8Array();
  if (typeof e == "string") {
    if (e.startsWith("OP_"))
      return ke.num(WEe(e), 1);
    Ef(e) ? t = ke.hex(e) : t = ke.str(e);
  } else
    t = ke.bytes(e);
  if (t.length === 1)
    return t[0] !== 0 && t[0] <= 16 ? (t[0] += 80, t) : (t[0] > 128 && t[0] <= 255 && (t = new Uint8Array([t[0], 0])), ke.join([Pz(t.length), t]));
  if (t.length > i5) {
    const r = JEe(t);
    return jG(r);
  } else
    return ke.join([Pz(t.length), t]);
}
function Pz(e) {
  const t = ke.num(76, 1), r = ke.num(77, 1);
  switch (!0) {
    case e <= 75:
      return ke.num(e);
    case (e > 75 && e < 256):
      return ke.join([t, ke.num(e, 1, "le")]);
    case (e >= 256 && e <= i5):
      return ke.join([r, ke.num(e, 2, "le")]);
    default:
      throw new Error("Invalid word size:" + e.toString());
  }
}
function JEe(e) {
  const t = [], r = new Rg(e);
  for (; r.size > i5; )
    t.push(r.read(i5));
  return t.push(r.read(r.size)), t;
}
function ZB(e, t = !1) {
  let r = ke.bytes(e);
  if (t) {
    const n = r.stream.readSize("le");
    if (r = r.slice(1), r.length !== n)
      throw new Error(`Varint does not match stream size: ${n} !== ${r.length}`);
  }
  return QEe(r);
}
function QEe(e) {
  const t = new Rg(e), r = [], n = t.size;
  let o, i, a, u = 0;
  for (; u < n; )
    switch (o = t.read(1).num, i = ZEe(o), u++, i) {
      case "varint":
        r.push(t.read(o).hex), u += o;
        break;
      case "pushdata1":
        a = t.read(1).reverse().num, r.push(t.read(a).hex), u += a + 1;
        break;
      case "pushdata2":
        a = t.read(2).reverse().num, r.push(t.read(a).hex), u += a + 2;
        break;
      case "pushdata4":
        a = t.read(4).reverse().num, r.push(t.read(a).hex), u += a + 4;
        break;
      case "opcode":
        if (!XEe(o))
          throw new Error(`Invalid OPCODE: ${o}`);
        r.push(GEe(o));
        break;
      default:
        throw new Error(`Word type undefined: ${o}`);
    }
  return r;
}
function e6e(e, t) {
  if (Array.isArray(e) && (e = B0(e, t)), e instanceof Uint8Array || Ef(e))
    return ZB(e, t);
  throw new Error("Invalid format: " + typeof e);
}
function t6e(e, t) {
  if ((e instanceof Uint8Array || Ef(e)) && (e = ZB(e, t)), Array.isArray(e))
    return B0(e, t);
  throw new Error("Invalid format: " + typeof e);
}
function r6e(e) {
  if (!Array.isArray(e))
    return ke.bytes(e);
  throw new Error("Invalid format: " + typeof e);
}
const n6e = {
  toAsm: e6e,
  toBytes: t6e,
  toParam: r6e
}, ma = {
  encode: B0,
  decode: ZB,
  fmt: n6e
};
function VO(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function o6e(e) {
  if (typeof e != "boolean")
    throw new Error(`Expected boolean, not ${e}`);
}
function LG(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new TypeError(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function i6e(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  VO(e.outputLen), VO(e.blockLen);
}
function a6e(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function s6e(e, t) {
  LG(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error(`digestInto() expects output buffer of length at least ${r}`);
}
const u6e = {
  number: VO,
  bool: o6e,
  bytes: LG,
  hash: i6e,
  exists: a6e,
  output: s6e
};
var Lp = u6e;
const LT = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const HT = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), fc = (e, t) => e << 32 - t | e >>> t, c6e = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!c6e)
  throw new Error("Non little-endian hardware is not supported");
Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function l6e(e) {
  if (typeof e != "string")
    throw new TypeError(`utf8ToBytes expected string, got ${typeof e}`);
  return new TextEncoder().encode(e);
}
function XB(e) {
  if (typeof e == "string" && (e = l6e(e)), !(e instanceof Uint8Array))
    throw new TypeError(`Expected input type is Uint8Array (got ${typeof e})`);
  return e;
}
function f6e(...e) {
  if (!e.every((n) => n instanceof Uint8Array))
    throw new Error("Uint8Array list expected");
  if (e.length === 1)
    return e[0];
  const t = e.reduce((n, o) => n + o.length, 0), r = new Uint8Array(t);
  for (let n = 0, o = 0; n < e.length; n++) {
    const i = e[n];
    r.set(i, o), o += i.length;
  }
  return r;
}
let HG = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function FG(e) {
  const t = (n) => e().update(XB(n)).digest(), r = e();
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = () => e(), t;
}
function d6e(e = 32) {
  if (LT && typeof LT.getRandomValues == "function")
    return LT.getRandomValues(new Uint8Array(e));
  throw new Error("crypto.getRandomValues must be defined");
}
function h6e(e, t, r, n) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, r, n);
  const o = BigInt(32), i = BigInt(4294967295), a = Number(r >> o & i), u = Number(r & i), l = n ? 4 : 0, d = n ? 0 : 4;
  e.setUint32(t + l, a, n), e.setUint32(t + d, u, n);
}
let p6e = class extends HG {
  constructor(e, t, r, n) {
    super(), this.blockLen = e, this.outputLen = t, this.padOffset = r, this.isLE = n, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = HT(this.buffer);
  }
  update(e) {
    Lp.exists(this);
    const { view: t, buffer: r, blockLen: n } = this;
    e = XB(e);
    const o = e.length;
    for (let i = 0; i < o; ) {
      const a = Math.min(n - this.pos, o - i);
      if (a === n) {
        const u = HT(e);
        for (; n <= o - i; i += n)
          this.process(u, i);
        continue;
      }
      r.set(e.subarray(i, i + a), this.pos), this.pos += a, i += a, this.pos === n && (this.process(t, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    Lp.exists(this), Lp.output(e, this), this.finished = !0;
    const { buffer: t, view: r, blockLen: n, isLE: o } = this;
    let { pos: i } = this;
    t[i++] = 128, this.buffer.subarray(i).fill(0), this.padOffset > n - i && (this.process(r, 0), i = 0);
    for (let f = i; f < n; f++)
      t[f] = 0;
    h6e(r, n - 8, BigInt(this.length * 8), o), this.process(r, 0);
    const a = HT(e), u = this.outputLen;
    if (u % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const l = u / 4, d = this.get();
    if (l > d.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let f = 0; f < l; f++)
      a.setUint32(4 * f, d[f], o);
  }
  digest() {
    const { buffer: e, outputLen: t } = this;
    this.digestInto(e);
    const r = e.slice(0, t);
    return this.destroy(), r;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: t, buffer: r, length: n, finished: o, destroyed: i, pos: a } = this;
    return e.length = n, e.pos = a, e.finished = o, e.destroyed = i, n % t && e.buffer.set(r), e;
  }
};
const g6e = (e, t, r) => e & t ^ ~e & r, m6e = (e, t, r) => e & t ^ e & r ^ t & r, y6e = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), id = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), ad = new Uint32Array(64);
let MG = class extends p6e {
  constructor() {
    super(64, 32, 8, !1), this.A = id[0] | 0, this.B = id[1] | 0, this.C = id[2] | 0, this.D = id[3] | 0, this.E = id[4] | 0, this.F = id[5] | 0, this.G = id[6] | 0, this.H = id[7] | 0;
  }
  get() {
    const { A: e, B: t, C: r, D: n, E: o, F: i, G: a, H: u } = this;
    return [e, t, r, n, o, i, a, u];
  }
  // prettier-ignore
  set(e, t, r, n, o, i, a, u) {
    this.A = e | 0, this.B = t | 0, this.C = r | 0, this.D = n | 0, this.E = o | 0, this.F = i | 0, this.G = a | 0, this.H = u | 0;
  }
  process(e, t) {
    for (let f = 0; f < 16; f++, t += 4)
      ad[f] = e.getUint32(t, !1);
    for (let f = 16; f < 64; f++) {
      const h = ad[f - 15], g = ad[f - 2], b = fc(h, 7) ^ fc(h, 18) ^ h >>> 3, w = fc(g, 17) ^ fc(g, 19) ^ g >>> 10;
      ad[f] = w + ad[f - 7] + b + ad[f - 16] | 0;
    }
    let { A: r, B: n, C: o, D: i, E: a, F: u, G: l, H: d } = this;
    for (let f = 0; f < 64; f++) {
      const h = fc(a, 6) ^ fc(a, 11) ^ fc(a, 25), g = d + h + g6e(a, u, l) + y6e[f] + ad[f] | 0, b = (fc(r, 2) ^ fc(r, 13) ^ fc(r, 22)) + m6e(r, n, o) | 0;
      d = l, l = u, u = a, a = i + g | 0, i = o, o = n, n = r, r = g + b | 0;
    }
    r = r + this.A | 0, n = n + this.B | 0, o = o + this.C | 0, i = i + this.D | 0, a = a + this.E | 0, u = u + this.F | 0, l = l + this.G | 0, d = d + this.H | 0, this.set(r, n, o, i, a, u, l, d);
  }
  roundClean() {
    ad.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}, b6e = class extends MG {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
};
const DG = FG(() => new MG());
FG(() => new b6e());
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const w6e = BigInt(0), YB = BigInt(1), v6e = BigInt(2), cE = (e) => e instanceof Uint8Array, E6e = Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function og(e) {
  if (!cE(e))
    throw new Error("Uint8Array expected");
  let t = "";
  for (let r = 0; r < e.length; r++)
    t += E6e[e[r]];
  return t;
}
function KG(e) {
  const t = e.toString(16);
  return t.length & 1 ? `0${t}` : t;
}
function JB(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  return BigInt(e === "" ? "0" : `0x${e}`);
}
function ig(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  if (e.length % 2)
    throw new Error("hex string is invalid: unpadded " + e.length);
  const t = new Uint8Array(e.length / 2);
  for (let r = 0; r < t.length; r++) {
    const n = r * 2, o = e.slice(n, n + 2), i = Number.parseInt(o, 16);
    if (Number.isNaN(i) || i < 0)
      throw new Error("invalid byte sequence");
    t[r] = i;
  }
  return t;
}
function $d(e) {
  return JB(og(e));
}
function QB(e) {
  if (!cE(e))
    throw new Error("Uint8Array expected");
  return JB(og(Uint8Array.from(e).reverse()));
}
const O1 = (e, t) => ig(e.toString(16).padStart(t * 2, "0")), qG = (e, t) => O1(e, t).reverse(), _6e = (e) => ig(KG(e));
function Us(e, t, r) {
  let n;
  if (typeof t == "string")
    try {
      n = ig(t);
    } catch (i) {
      throw new Error(`${e} must be valid hex string, got "${t}". Cause: ${i}`);
    }
  else if (cE(t))
    n = Uint8Array.from(t);
  else
    throw new Error(`${e} must be hex string or Uint8Array`);
  const o = n.length;
  if (typeof r == "number" && o !== r)
    throw new Error(`${e} expected ${r} bytes, got ${o}`);
  return n;
}
function xu(...e) {
  const t = new Uint8Array(e.reduce((n, o) => n + o.length, 0));
  let r = 0;
  return e.forEach((n) => {
    if (!cE(n))
      throw new Error("Uint8Array expected");
    t.set(n, r), r += n.length;
  }), t;
}
function A6e(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function lE(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new TextEncoder().encode(e);
}
function x6e(e) {
  let t;
  for (t = 0; e > 0n; e >>= YB, t += 1)
    ;
  return t;
}
const k6e = (e, t) => e >> BigInt(t) & 1n, S6e = (e, t, r) => e | (r ? YB : w6e) << BigInt(t), eN = (e) => (v6e << BigInt(e - 1)) - YB, FT = (e) => new Uint8Array(e), Cz = (e) => Uint8Array.from(e);
function VG(e, t, r) {
  if (typeof e != "number" || e < 2)
    throw new Error("hashLen must be a number");
  if (typeof t != "number" || t < 2)
    throw new Error("qByteLen must be a number");
  if (typeof r != "function")
    throw new Error("hmacFn must be a function");
  let n = FT(e), o = FT(e), i = 0;
  const a = () => {
    n.fill(1), o.fill(0), i = 0;
  }, u = (...f) => r(o, n, ...f), l = (f = FT()) => {
    o = u(Cz([0]), f), n = u(), f.length !== 0 && (o = u(Cz([1]), f), n = u());
  }, d = () => {
    if (i++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let f = 0;
    const h = [];
    for (; f < t; ) {
      n = u();
      const g = n.slice();
      h.push(g), f += n.length;
    }
    return xu(...h);
  };
  return (f, h) => {
    a(), l(f);
    let g;
    for (; !(g = h(d())); )
      l();
    return a(), g;
  };
}
const T6e = {
  bigint: (e) => typeof e == "bigint",
  function: (e) => typeof e == "function",
  boolean: (e) => typeof e == "boolean",
  string: (e) => typeof e == "string",
  isSafeInteger: (e) => Number.isSafeInteger(e),
  array: (e) => Array.isArray(e),
  field: (e, t) => t.Fp.isValid(e),
  hash: (e) => typeof e == "function" && Number.isSafeInteger(e.outputLen)
};
function zg(e, t, r = {}) {
  const n = (o, i, a) => {
    const u = T6e[i];
    if (typeof u != "function")
      throw new Error(`Invalid validator "${i}", expected function`);
    const l = e[o];
    if (!(a && l === void 0) && !u(l, e))
      throw new Error(`Invalid param ${String(o)}=${l} (${typeof l}), expected ${i}`);
  };
  for (const [o, i] of Object.entries(t))
    n(o, i, !1);
  for (const [o, i] of Object.entries(r))
    n(o, i, !0);
  return e;
}
var I6e = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  bitGet: k6e,
  bitLen: x6e,
  bitMask: eN,
  bitSet: S6e,
  bytesToHex: og,
  bytesToNumberBE: $d,
  bytesToNumberLE: QB,
  concatBytes: xu,
  createHmacDrbg: VG,
  ensureBytes: Us,
  equalBytes: A6e,
  hexToBytes: ig,
  hexToNumber: JB,
  numberToBytesBE: O1,
  numberToBytesLE: qG,
  numberToHexUnpadded: KG,
  numberToVarBytesBE: _6e,
  utf8ToBytes: lE,
  validateObject: zg
});
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const ii = BigInt(0), ko = BigInt(1), Pp = BigInt(2), O6e = BigInt(3), GO = BigInt(4), Bz = BigInt(5), Nz = BigInt(8);
BigInt(9);
BigInt(16);
function ji(e, t) {
  const r = e % t;
  return r >= ii ? r : t + r;
}
function P6e(e, t, r) {
  if (r <= ii || t < ii)
    throw new Error("Expected power/modulo > 0");
  if (r === ko)
    return ii;
  let n = ko;
  for (; t > ii; )
    t & ko && (n = n * e % r), e = e * e % r, t >>= ko;
  return n;
}
function Ts(e, t, r) {
  let n = e;
  for (; t-- > ii; )
    n *= n, n %= r;
  return n;
}
function WO(e, t) {
  if (e === ii || t <= ii)
    throw new Error(`invert: expected positive integers, got n=${e} mod=${t}`);
  let r = ji(e, t), n = t, o = ii, i = ko;
  for (; r !== ii; ) {
    const a = n / r, u = n % r, l = o - i * a;
    n = r, r = u, o = i, i = l;
  }
  if (n !== ko)
    throw new Error("invert: does not exist");
  return ji(o, t);
}
function C6e(e) {
  const t = (e - ko) / Pp;
  let r, n, o;
  for (r = e - ko, n = 0; r % Pp === ii; r /= Pp, n++)
    ;
  for (o = Pp; o < e && P6e(o, t, e) !== e - ko; o++)
    ;
  if (n === 1) {
    const a = (e + ko) / GO;
    return function(u, l) {
      const d = u.pow(l, a);
      if (!u.eql(u.sqr(d), l))
        throw new Error("Cannot find square root");
      return d;
    };
  }
  const i = (r + ko) / Pp;
  return function(a, u) {
    if (a.pow(u, t) === a.neg(a.ONE))
      throw new Error("Cannot find square root");
    let l = n, d = a.pow(a.mul(a.ONE, o), r), f = a.pow(u, i), h = a.pow(u, r);
    for (; !a.eql(h, a.ONE); ) {
      if (a.eql(h, a.ZERO))
        return a.ZERO;
      let g = 1;
      for (let w = a.sqr(h); g < l && !a.eql(w, a.ONE); g++)
        w = a.sqr(w);
      const b = a.pow(d, ko << BigInt(l - g - 1));
      d = a.sqr(b), f = a.mul(f, b), h = a.mul(h, d), l = g;
    }
    return f;
  };
}
function B6e(e) {
  if (e % GO === O6e) {
    const t = (e + ko) / GO;
    return function(r, n) {
      const o = r.pow(n, t);
      if (!r.eql(r.sqr(o), n))
        throw new Error("Cannot find square root");
      return o;
    };
  }
  if (e % Nz === Bz) {
    const t = (e - Bz) / Nz;
    return function(r, n) {
      const o = r.mul(n, Pp), i = r.pow(o, t), a = r.mul(n, i), u = r.mul(r.mul(a, Pp), i), l = r.mul(a, r.sub(u, r.ONE));
      if (!r.eql(r.sqr(l), n))
        throw new Error("Cannot find square root");
      return l;
    };
  }
  return C6e(e);
}
const N6e = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function GG(e) {
  const t = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, r = N6e.reduce((n, o) => (n[o] = "function", n), t);
  return zg(e, r);
}
function $6e(e, t, r) {
  if (r < ii)
    throw new Error("Expected power > 0");
  if (r === ii)
    return e.ONE;
  if (r === ko)
    return t;
  let n = e.ONE, o = t;
  for (; r > ii; )
    r & ko && (n = e.mul(n, o)), o = e.sqr(o), r >>= ko;
  return n;
}
function U6e(e, t) {
  const r = new Array(t.length), n = t.reduce((i, a, u) => e.is0(a) ? i : (r[u] = i, e.mul(i, a)), e.ONE), o = e.inv(n);
  return t.reduceRight((i, a, u) => e.is0(a) ? i : (r[u] = e.mul(i, r[u]), e.mul(i, a)), o), r;
}
function tN(e, t) {
  const r = t !== void 0 ? t : e.toString(2).length, n = Math.ceil(r / 8);
  return { nBitLength: r, nByteLength: n };
}
function WG(e, t, r = !1, n = {}) {
  if (e <= ii)
    throw new Error(`Expected Fp ORDER > 0, got ${e}`);
  const { nBitLength: o, nByteLength: i } = tN(e, t);
  if (i > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const a = B6e(e), u = Object.freeze({
    ORDER: e,
    BITS: o,
    BYTES: i,
    MASK: eN(o),
    ZERO: ii,
    ONE: ko,
    create: (l) => ji(l, e),
    isValid: (l) => {
      if (typeof l != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof l}`);
      return ii <= l && l < e;
    },
    is0: (l) => l === ii,
    isOdd: (l) => (l & ko) === ko,
    neg: (l) => ji(-l, e),
    eql: (l, d) => l === d,
    sqr: (l) => ji(l * l, e),
    add: (l, d) => ji(l + d, e),
    sub: (l, d) => ji(l - d, e),
    mul: (l, d) => ji(l * d, e),
    pow: (l, d) => $6e(u, l, d),
    div: (l, d) => ji(l * WO(d, e), e),
    // Same as above, but doesn't normalize
    sqrN: (l) => l * l,
    addN: (l, d) => l + d,
    subN: (l, d) => l - d,
    mulN: (l, d) => l * d,
    inv: (l) => WO(l, e),
    sqrt: n.sqrt || ((l) => a(u, l)),
    invertBatch: (l) => U6e(u, l),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (l, d, f) => f ? d : l,
    toBytes: (l) => r ? qG(l, i) : O1(l, i),
    fromBytes: (l) => {
      if (l.length !== i)
        throw new Error(`Fp.fromBytes: expected ${i}, got ${l.length}`);
      return r ? QB(l) : $d(l);
    }
  });
  return Object.freeze(u);
}
function R6e(e, t, r = !1) {
  e = Us("privateHash", e);
  const n = e.length, o = tN(t).nByteLength + 8;
  if (o < 24 || n < o || n > 1024)
    throw new Error(`hashToPrivateScalar: expected ${o}-1024 bytes of input, got ${n}`);
  const i = r ? QB(e) : $d(e);
  return ji(i, t - ko) + ko;
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const z6e = BigInt(0), MT = BigInt(1);
function j6e(e, t) {
  const r = (o, i) => {
    const a = i.negate();
    return o ? a : i;
  }, n = (o) => {
    const i = Math.ceil(t / o) + 1, a = 2 ** (o - 1);
    return { windows: i, windowSize: a };
  };
  return {
    constTimeNegate: r,
    // non-const time multiplication ladder
    unsafeLadder(o, i) {
      let a = e.ZERO, u = o;
      for (; i > z6e; )
        i & MT && (a = a.add(u)), u = u.double(), i >>= MT;
      return a;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(o, i) {
      const { windows: a, windowSize: u } = n(i), l = [];
      let d = o, f = d;
      for (let h = 0; h < a; h++) {
        f = d, l.push(f);
        for (let g = 1; g < u; g++)
          f = f.add(d), l.push(f);
        d = f.double();
      }
      return l;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(o, i, a) {
      const { windows: u, windowSize: l } = n(o);
      let d = e.ZERO, f = e.BASE;
      const h = BigInt(2 ** o - 1), g = 2 ** o, b = BigInt(o);
      for (let w = 0; w < u; w++) {
        const E = w * l;
        let _ = Number(a & h);
        a >>= b, _ > l && (_ -= g, a += MT);
        const O = E, C = E + Math.abs(_) - 1, I = w % 2 !== 0, S = _ < 0;
        _ === 0 ? f = f.add(r(I, i[O])) : d = d.add(r(S, i[C]));
      }
      return { p: d, f };
    },
    wNAFCached(o, i, a, u) {
      const l = o._WINDOW_SIZE || 1;
      let d = i.get(o);
      return d || (d = this.precomputeWindow(o, l), l !== 1 && i.set(o, u(d))), this.wNAF(l, d, a);
    }
  };
}
function ZG(e) {
  return GG(e.Fp), zg(e, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...tN(e.n, e.nBitLength),
    ...e,
    p: e.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function L6e(e) {
  const t = ZG(e);
  zg(t, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: r, Fp: n, a: o } = t;
  if (r) {
    if (!n.eql(o, n.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof r != "object" || typeof r.beta != "bigint" || typeof r.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...t });
}
const { bytesToNumberBE: H6e, hexToBytes: F6e } = I6e, Hp = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(e = "") {
      super(e);
    }
  },
  _parseInt(e) {
    const { Err: t } = Hp;
    if (e.length < 2 || e[0] !== 2)
      throw new t("Invalid signature integer tag");
    const r = e[1], n = e.subarray(2, r + 2);
    if (!r || n.length !== r)
      throw new t("Invalid signature integer: wrong length");
    if (n[0] === 0 && n[1] <= 127)
      throw new t("Invalid signature integer: trailing length");
    return { d: H6e(n), l: e.subarray(r + 2) };
  },
  toSig(e) {
    const { Err: t } = Hp, r = typeof e == "string" ? F6e(e) : e;
    if (!(r instanceof Uint8Array))
      throw new Error("ui8a expected");
    let n = r.length;
    if (n < 2 || r[0] != 48)
      throw new t("Invalid signature tag");
    if (r[1] !== n - 2)
      throw new t("Invalid signature: incorrect length");
    const { d: o, l: i } = Hp._parseInt(r.subarray(2)), { d: a, l: u } = Hp._parseInt(i);
    if (u.length)
      throw new t("Invalid signature: left bytes after parsing");
    return { r: o, s: a };
  },
  hexFromSig(e) {
    const t = (d) => Number.parseInt(d[0], 16) >= 8 ? "00" + d : d, r = (d) => {
      const f = d.toString(16);
      return f.length & 1 ? `0${f}` : f;
    }, n = t(r(e.s)), o = t(r(e.r)), i = n.length / 2, a = o.length / 2, u = r(i), l = r(a);
    return `30${r(a + i + 4)}02${l}${o}02${u}${n}`;
  }
}, Tu = BigInt(0), Do = BigInt(1), jl = BigInt(2), a5 = BigInt(3), $z = BigInt(4);
function M6e(e) {
  const t = L6e(e), { Fp: r } = t, n = t.toBytes || ((w, E, _) => {
    const O = E.toAffine();
    return xu(Uint8Array.from([4]), r.toBytes(O.x), r.toBytes(O.y));
  }), o = t.fromBytes || ((w) => {
    const E = w.subarray(1), _ = r.fromBytes(E.subarray(0, r.BYTES)), O = r.fromBytes(E.subarray(r.BYTES, 2 * r.BYTES));
    return { x: _, y: O };
  });
  function i(w) {
    const { a: E, b: _ } = t, O = r.sqr(w), C = r.mul(O, w);
    return r.add(r.add(C, r.mul(w, E)), _);
  }
  function a(w) {
    return typeof w == "bigint" && Tu < w && w < t.n;
  }
  function u(w) {
    if (!a(w))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function l(w) {
    const { allowedPrivateKeyLengths: E, nByteLength: _, wrapPrivateKey: O, n: C } = t;
    if (E && typeof w != "bigint") {
      if (w instanceof Uint8Array && (w = og(w)), typeof w != "string" || !E.includes(w.length))
        throw new Error("Invalid key");
      w = w.padStart(_ * 2, "0");
    }
    let I;
    try {
      I = typeof w == "bigint" ? w : $d(Us("private key", w, _));
    } catch {
      throw new Error(`private key must be ${_} bytes, hex or bigint, not ${typeof w}`);
    }
    return O && (I = ji(I, C)), u(I), I;
  }
  const d = /* @__PURE__ */ new Map();
  function f(w) {
    if (!(w instanceof h))
      throw new Error("ProjectivePoint expected");
  }
  class h {
    constructor(E, _, O) {
      if (this.px = E, this.py = _, this.pz = O, E == null || !r.isValid(E))
        throw new Error("x required");
      if (_ == null || !r.isValid(_))
        throw new Error("y required");
      if (O == null || !r.isValid(O))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(E) {
      const { x: _, y: O } = E || {};
      if (!E || !r.isValid(_) || !r.isValid(O))
        throw new Error("invalid affine point");
      if (E instanceof h)
        throw new Error("projective point not allowed");
      const C = (I) => r.eql(I, r.ZERO);
      return C(_) && C(O) ? h.ZERO : new h(_, O, r.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(E) {
      const _ = r.invertBatch(E.map((O) => O.pz));
      return E.map((O, C) => O.toAffine(_[C])).map(h.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(E) {
      const _ = h.fromAffine(o(Us("pointHex", E)));
      return _.assertValidity(), _;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(E) {
      return h.BASE.multiply(l(E));
    }
    // "Private method", don't use it directly
    _setWindowSize(E) {
      this._WINDOW_SIZE = E, d.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (t.allowInfinityPoint)
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: E, y: _ } = this.toAffine();
      if (!r.isValid(E) || !r.isValid(_))
        throw new Error("bad point: x or y not FE");
      const O = r.sqr(_), C = i(E);
      if (!r.eql(O, C))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: E } = this.toAffine();
      if (r.isOdd)
        return !r.isOdd(E);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(E) {
      f(E);
      const { px: _, py: O, pz: C } = this, { px: I, py: S, pz: T } = E, A = r.eql(r.mul(_, T), r.mul(I, C)), $ = r.eql(r.mul(O, T), r.mul(S, C));
      return A && $;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new h(this.px, r.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: E, b: _ } = t, O = r.mul(_, a5), { px: C, py: I, pz: S } = this;
      let T = r.ZERO, A = r.ZERO, $ = r.ZERO, U = r.mul(C, C), M = r.mul(I, I), Y = r.mul(S, S), L = r.mul(C, I);
      return L = r.add(L, L), $ = r.mul(C, S), $ = r.add($, $), T = r.mul(E, $), A = r.mul(O, Y), A = r.add(T, A), T = r.sub(M, A), A = r.add(M, A), A = r.mul(T, A), T = r.mul(L, T), $ = r.mul(O, $), Y = r.mul(E, Y), L = r.sub(U, Y), L = r.mul(E, L), L = r.add(L, $), $ = r.add(U, U), U = r.add($, U), U = r.add(U, Y), U = r.mul(U, L), A = r.add(A, U), Y = r.mul(I, S), Y = r.add(Y, Y), U = r.mul(Y, L), T = r.sub(T, U), $ = r.mul(Y, M), $ = r.add($, $), $ = r.add($, $), new h(T, A, $);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(E) {
      f(E);
      const { px: _, py: O, pz: C } = this, { px: I, py: S, pz: T } = E;
      let A = r.ZERO, $ = r.ZERO, U = r.ZERO;
      const M = t.a, Y = r.mul(t.b, a5);
      let L = r.mul(_, I), ee = r.mul(O, S), de = r.mul(C, T), ne = r.add(_, O), D = r.add(I, S);
      ne = r.mul(ne, D), D = r.add(L, ee), ne = r.sub(ne, D), D = r.add(_, C);
      let K = r.add(I, T);
      return D = r.mul(D, K), K = r.add(L, de), D = r.sub(D, K), K = r.add(O, C), A = r.add(S, T), K = r.mul(K, A), A = r.add(ee, de), K = r.sub(K, A), U = r.mul(M, D), A = r.mul(Y, de), U = r.add(A, U), A = r.sub(ee, U), U = r.add(ee, U), $ = r.mul(A, U), ee = r.add(L, L), ee = r.add(ee, L), de = r.mul(M, de), D = r.mul(Y, D), ee = r.add(ee, de), de = r.sub(L, de), de = r.mul(M, de), D = r.add(D, de), L = r.mul(ee, D), $ = r.add($, L), L = r.mul(K, D), A = r.mul(ne, A), A = r.sub(A, L), L = r.mul(ne, ee), U = r.mul(K, U), U = r.add(U, L), new h(A, $, U);
    }
    subtract(E) {
      return this.add(E.negate());
    }
    is0() {
      return this.equals(h.ZERO);
    }
    wNAF(E) {
      return b.wNAFCached(this, d, E, (_) => {
        const O = r.invertBatch(_.map((C) => C.pz));
        return _.map((C, I) => C.toAffine(O[I])).map(h.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(E) {
      const _ = h.ZERO;
      if (E === Tu)
        return _;
      if (u(E), E === Do)
        return this;
      const { endo: O } = t;
      if (!O)
        return b.unsafeLadder(this, E);
      let { k1neg: C, k1: I, k2neg: S, k2: T } = O.splitScalar(E), A = _, $ = _, U = this;
      for (; I > Tu || T > Tu; )
        I & Do && (A = A.add(U)), T & Do && ($ = $.add(U)), U = U.double(), I >>= Do, T >>= Do;
      return C && (A = A.negate()), S && ($ = $.negate()), $ = new h(r.mul($.px, O.beta), $.py, $.pz), A.add($);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(E) {
      u(E);
      let _ = E, O, C;
      const { endo: I } = t;
      if (I) {
        const { k1neg: S, k1: T, k2neg: A, k2: $ } = I.splitScalar(_);
        let { p: U, f: M } = this.wNAF(T), { p: Y, f: L } = this.wNAF($);
        U = b.constTimeNegate(S, U), Y = b.constTimeNegate(A, Y), Y = new h(r.mul(Y.px, I.beta), Y.py, Y.pz), O = U.add(Y), C = M.add(L);
      } else {
        const { p: S, f: T } = this.wNAF(_);
        O = S, C = T;
      }
      return h.normalizeZ([O, C])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(E, _, O) {
      const C = h.BASE, I = (T, A) => A === Tu || A === Do || !T.equals(C) ? T.multiplyUnsafe(A) : T.multiply(A), S = I(this, _).add(I(E, O));
      return S.is0() ? void 0 : S;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(E) {
      const { px: _, py: O, pz: C } = this, I = this.is0();
      E == null && (E = I ? r.ONE : r.inv(C));
      const S = r.mul(_, E), T = r.mul(O, E), A = r.mul(C, E);
      if (I)
        return { x: r.ZERO, y: r.ZERO };
      if (!r.eql(A, r.ONE))
        throw new Error("invZ was invalid");
      return { x: S, y: T };
    }
    isTorsionFree() {
      const { h: E, isTorsionFree: _ } = t;
      if (E === Do)
        return !0;
      if (_)
        return _(h, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: E, clearCofactor: _ } = t;
      return E === Do ? this : _ ? _(h, this) : this.multiplyUnsafe(t.h);
    }
    toRawBytes(E = !0) {
      return this.assertValidity(), n(h, this, E);
    }
    toHex(E = !0) {
      return og(this.toRawBytes(E));
    }
  }
  h.BASE = new h(t.Gx, t.Gy, r.ONE), h.ZERO = new h(r.ZERO, r.ONE, r.ZERO);
  const g = t.nBitLength, b = j6e(h, t.endo ? Math.ceil(g / 2) : g);
  return {
    CURVE: t,
    ProjectivePoint: h,
    normPrivateKeyToScalar: l,
    weierstrassEquation: i,
    isWithinCurveOrder: a
  };
}
function D6e(e) {
  const t = ZG(e);
  return zg(t, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...t });
}
function K6e(e) {
  const t = D6e(e), { Fp: r, n } = t, o = r.BYTES + 1, i = 2 * r.BYTES + 1;
  function a(D) {
    return Tu < D && D < r.ORDER;
  }
  function u(D) {
    return ji(D, n);
  }
  function l(D) {
    return WO(D, n);
  }
  const { ProjectivePoint: d, normPrivateKeyToScalar: f, weierstrassEquation: h, isWithinCurveOrder: g } = M6e({
    ...t,
    toBytes(D, K, le) {
      const re = K.toAffine(), G = r.toBytes(re.x), q = xu;
      return le ? q(Uint8Array.from([K.hasEvenY() ? 2 : 3]), G) : q(Uint8Array.from([4]), G, r.toBytes(re.y));
    },
    fromBytes(D) {
      const K = D.length, le = D[0], re = D.subarray(1);
      if (K === o && (le === 2 || le === 3)) {
        const G = $d(re);
        if (!a(G))
          throw new Error("Point is not on curve");
        const q = h(G);
        let Q = r.sqrt(q);
        const se = (Q & Do) === Do;
        return (le & 1) === 1 !== se && (Q = r.neg(Q)), { x: G, y: Q };
      } else if (K === i && le === 4) {
        const G = r.fromBytes(re.subarray(0, r.BYTES)), q = r.fromBytes(re.subarray(r.BYTES, 2 * r.BYTES));
        return { x: G, y: q };
      } else
        throw new Error(`Point of length ${K} was invalid. Expected ${o} compressed bytes or ${i} uncompressed bytes`);
    }
  }), b = (D) => og(O1(D, t.nByteLength));
  function w(D) {
    const K = n >> Do;
    return D > K;
  }
  function E(D) {
    return w(D) ? u(-D) : D;
  }
  const _ = (D, K, le) => $d(D.slice(K, le));
  class O {
    constructor(K, le, re) {
      this.r = K, this.s = le, this.recovery = re, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(K) {
      const le = t.nByteLength;
      return K = Us("compactSignature", K, le * 2), new O(_(K, 0, le), _(K, le, 2 * le));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(K) {
      const { r: le, s: re } = Hp.toSig(Us("DER", K));
      return new O(le, re);
    }
    assertValidity() {
      if (!g(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!g(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(K) {
      return new O(this.r, this.s, K);
    }
    recoverPublicKey(K) {
      const { r: le, s: re, recovery: G } = this, q = $(Us("msgHash", K));
      if (G == null || ![0, 1, 2, 3].includes(G))
        throw new Error("recovery id invalid");
      const Q = G === 2 || G === 3 ? le + t.n : le;
      if (Q >= r.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const se = G & 1 ? "03" : "02", J = d.fromHex(se + b(Q)), ye = l(Q), ve = u(-q * ye), Ee = u(re * ye), _e = d.BASE.multiplyAndAddUnsafe(J, ve, Ee);
      if (!_e)
        throw new Error("point at infinify");
      return _e.assertValidity(), _e;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return w(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new O(this.r, u(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return ig(this.toDERHex());
    }
    toDERHex() {
      return Hp.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return ig(this.toCompactHex());
    }
    toCompactHex() {
      return b(this.r) + b(this.s);
    }
  }
  const C = {
    isValidPrivateKey(D) {
      try {
        return f(D), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: f,
    /**
     * Produces cryptographically secure private key from random of size (nBitLength+64)
     * as per FIPS 186 B.4.1 with modulo bias being neglible.
     */
    randomPrivateKey: () => {
      const D = t.randomBytes(r.BYTES + 8), K = R6e(D, n);
      return O1(K, t.nByteLength);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(D = 8, K = d.BASE) {
      return K._setWindowSize(D), K.multiply(BigInt(3)), K;
    }
  };
  function I(D, K = !0) {
    return d.fromPrivateKey(D).toRawBytes(K);
  }
  function S(D) {
    const K = D instanceof Uint8Array, le = typeof D == "string", re = (K || le) && D.length;
    return K ? re === o || re === i : le ? re === 2 * o || re === 2 * i : D instanceof d;
  }
  function T(D, K, le = !0) {
    if (S(D))
      throw new Error("first arg must be private key");
    if (!S(K))
      throw new Error("second arg must be public key");
    return d.fromHex(K).multiply(f(D)).toRawBytes(le);
  }
  const A = t.bits2int || function(D) {
    const K = $d(D), le = D.length * 8 - t.nBitLength;
    return le > 0 ? K >> BigInt(le) : K;
  }, $ = t.bits2int_modN || function(D) {
    return u(A(D));
  }, U = eN(t.nBitLength);
  function M(D) {
    if (typeof D != "bigint")
      throw new Error("bigint expected");
    if (!(Tu <= D && D < U))
      throw new Error(`bigint expected < 2^${t.nBitLength}`);
    return O1(D, t.nByteLength);
  }
  function Y(D, K, le = L) {
    if (["recovered", "canonical"].some((be) => be in le))
      throw new Error("sign() legacy options not supported");
    const { hash: re, randomBytes: G } = t;
    let { lowS: q, prehash: Q, extraEntropy: se } = le;
    q == null && (q = !0), D = Us("msgHash", D), Q && (D = Us("prehashed msgHash", re(D)));
    const J = $(D), ye = f(K), ve = [M(ye), M(J)];
    if (se != null) {
      const be = se === !0 ? G(r.BYTES) : se;
      ve.push(Us("extraEntropy", be, r.BYTES));
    }
    const Ee = xu(...ve), _e = J;
    function we(be) {
      const Ge = A(be);
      if (!g(Ge))
        return;
      const Le = l(Ge), Ne = d.BASE.multiply(Ge).toAffine(), Ve = u(Ne.x);
      if (Ve === Tu)
        return;
      const ge = u(Le * u(_e + Ve * ye));
      if (ge === Tu)
        return;
      let Te = (Ne.x === Ve ? 0 : 2) | Number(Ne.y & Do), Oe = ge;
      return q && w(ge) && (Oe = E(ge), Te ^= 1), new O(Ve, Oe, Te);
    }
    return { seed: Ee, k2sig: we };
  }
  const L = { lowS: t.lowS, prehash: !1 }, ee = { lowS: t.lowS, prehash: !1 };
  function de(D, K, le = L) {
    const { seed: re, k2sig: G } = Y(D, K, le);
    return VG(t.hash.outputLen, t.nByteLength, t.hmac)(re, G);
  }
  d.BASE._setWindowSize(8);
  function ne(D, K, le, re = ee) {
    var G;
    const q = D;
    if (K = Us("msgHash", K), le = Us("publicKey", le), "strict" in re)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: Q, prehash: se } = re;
    let J, ye;
    try {
      if (typeof q == "string" || q instanceof Uint8Array)
        try {
          J = O.fromDER(q);
        } catch (Ne) {
          if (!(Ne instanceof Hp.Err))
            throw Ne;
          J = O.fromCompact(q);
        }
      else if (typeof q == "object" && typeof q.r == "bigint" && typeof q.s == "bigint") {
        const { r: Ne, s: Ve } = q;
        J = new O(Ne, Ve);
      } else
        throw new Error("PARSE");
      ye = d.fromHex(le);
    } catch (Ne) {
      if (Ne.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (Q && J.hasHighS())
      return !1;
    se && (K = t.hash(K));
    const { r: ve, s: Ee } = J, _e = $(K), we = l(Ee), be = u(_e * we), Ge = u(ve * we), Le = (G = d.BASE.multiplyAndAddUnsafe(ye, be, Ge)) == null ? void 0 : G.toAffine();
    return Le ? u(Le.x) === ve : !1;
  }
  return {
    CURVE: t,
    getPublicKey: I,
    getSharedSecret: T,
    sign: de,
    verify: ne,
    ProjectivePoint: d,
    Signature: O,
    utils: C
  };
}
function q6e(e, t) {
  const r = e.ORDER;
  let n = Tu;
  for (let g = r - Do; g % jl === Tu; g /= jl)
    n += Do;
  const o = n, i = (r - Do) / jl ** o, a = (i - Do) / jl, u = jl ** o - Do, l = jl ** (o - Do), d = e.pow(t, i), f = e.pow(t, (i + Do) / jl);
  let h = (g, b) => {
    let w = d, E = e.pow(b, u), _ = e.sqr(E);
    _ = e.mul(_, b);
    let O = e.mul(g, _);
    O = e.pow(O, a), O = e.mul(O, E), E = e.mul(O, b), _ = e.mul(O, g);
    let C = e.mul(_, E);
    O = e.pow(C, l);
    let I = e.eql(O, e.ONE);
    E = e.mul(_, f), O = e.mul(C, w), _ = e.cmov(E, _, I), C = e.cmov(O, C, I);
    for (let S = o; S > 1; S--) {
      let T = jl ** (S - jl), A = e.pow(C, T);
      const $ = e.eql(A, e.ONE);
      E = e.mul(_, w), w = e.mul(w, w), A = e.mul(C, w), _ = e.cmov(E, _, $), C = e.cmov(A, C, $);
    }
    return { isValid: I, value: _ };
  };
  if (e.ORDER % $z === a5) {
    const g = (e.ORDER - a5) / $z, b = e.sqrt(e.neg(t));
    h = (w, E) => {
      let _ = e.sqr(E);
      const O = e.mul(w, E);
      _ = e.mul(_, O);
      let C = e.pow(_, g);
      C = e.mul(C, O);
      const I = e.mul(C, b), S = e.mul(e.sqr(C), E), T = e.eql(S, w);
      let A = e.cmov(I, C, T);
      return { isValid: T, value: A };
    };
  }
  return h;
}
function V6e(e, t) {
  if (GG(e), !e.isValid(t.A) || !e.isValid(t.B) || !e.isValid(t.Z))
    throw new Error("mapToCurveSimpleSWU: invalid opts");
  const r = q6e(e, t.Z);
  if (!e.isOdd)
    throw new Error("Fp.isOdd is not implemented!");
  return (n) => {
    let o, i, a, u, l, d, f, h;
    o = e.sqr(n), o = e.mul(o, t.Z), i = e.sqr(o), i = e.add(i, o), a = e.add(i, e.ONE), a = e.mul(a, t.B), u = e.cmov(t.Z, e.neg(i), !e.eql(i, e.ZERO)), u = e.mul(u, t.A), i = e.sqr(a), d = e.sqr(u), l = e.mul(d, t.A), i = e.add(i, l), i = e.mul(i, a), d = e.mul(d, u), l = e.mul(d, t.B), i = e.add(i, l), f = e.mul(o, a);
    const { isValid: g, value: b } = r(i, d);
    h = e.mul(o, n), h = e.mul(h, b), f = e.cmov(f, a, g), h = e.cmov(h, b, g);
    const w = e.isOdd(n) === e.isOdd(h);
    return h = e.cmov(e.neg(h), h, w), f = e.div(f, u), { x: f, y: h };
  };
}
function G6e(e) {
  if (e instanceof Uint8Array)
    return e;
  if (typeof e == "string")
    return lE(e);
  throw new Error("DST must be Uint8Array or string");
}
const W6e = $d;
function xd(e, t) {
  if (e < 0 || e >= 1 << 8 * t)
    throw new Error(`bad I2OSP call: value=${e} length=${t}`);
  const r = Array.from({ length: t }).fill(0);
  for (let n = t - 1; n >= 0; n--)
    r[n] = e & 255, e >>>= 8;
  return new Uint8Array(r);
}
function Z6e(e, t) {
  const r = new Uint8Array(e.length);
  for (let n = 0; n < e.length; n++)
    r[n] = e[n] ^ t[n];
  return r;
}
function Gw(e) {
  if (!(e instanceof Uint8Array))
    throw new Error("Uint8Array expected");
}
function rN(e) {
  if (!Number.isSafeInteger(e))
    throw new Error("number expected");
}
function X6e(e, t, r, n) {
  Gw(e), Gw(t), rN(r), t.length > 255 && (t = n(xu(lE("H2C-OVERSIZE-DST-"), t)));
  const { outputLen: o, blockLen: i } = n, a = Math.ceil(r / o);
  if (a > 255)
    throw new Error("Invalid xmd length");
  const u = xu(t, xd(t.length, 1)), l = xd(0, i), d = xd(r, 2), f = new Array(a), h = n(xu(l, e, d, xd(0, 1), u));
  f[0] = n(xu(h, xd(1, 1), u));
  for (let g = 1; g <= a; g++) {
    const b = [Z6e(h, f[g - 1]), xd(g + 1, 1), u];
    f[g] = n(xu(...b));
  }
  return xu(...f).slice(0, r);
}
function Y6e(e, t, r, n, o) {
  if (Gw(e), Gw(t), rN(r), t.length > 255) {
    const i = Math.ceil(2 * n / 8);
    t = o.create({ dkLen: i }).update(lE("H2C-OVERSIZE-DST-")).update(t).digest();
  }
  if (r > 65535 || t.length > 255)
    throw new Error("expand_message_xof: invalid lenInBytes");
  return o.create({ dkLen: r }).update(e).update(xd(r, 2)).update(t).update(xd(t.length, 1)).digest();
}
function Uz(e, t, r) {
  zg(r, {
    DST: "string",
    p: "bigint",
    m: "isSafeInteger",
    k: "isSafeInteger",
    hash: "hash"
  });
  const { p: n, k: o, m: i, hash: a, expand: u, DST: l } = r;
  Gw(e), rN(t);
  const d = G6e(l), f = n.toString(2).length, h = Math.ceil((f + o) / 8), g = t * i * h;
  let b;
  if (u === "xmd")
    b = X6e(e, d, g, a);
  else if (u === "xof")
    b = Y6e(e, d, g, o, a);
  else if (u === void 0)
    b = e;
  else
    throw new Error('expand must be "xmd", "xof" or undefined');
  const w = new Array(t);
  for (let E = 0; E < t; E++) {
    const _ = new Array(i);
    for (let O = 0; O < i; O++) {
      const C = h * (O + E * i), I = b.subarray(C, C + h);
      _[O] = ji(W6e(I), n);
    }
    w[E] = _;
  }
  return w;
}
function J6e(e, t) {
  const r = t.map((n) => Array.from(n).reverse());
  return (n, o) => {
    const [i, a, u, l] = r.map((d) => d.reduce((f, h) => e.add(e.mul(f, n), h)));
    return n = e.div(i, a), o = e.mul(o, e.div(u, l)), { x: n, y: o };
  };
}
function Q6e(e, t, r) {
  if (typeof t != "function")
    throw new Error("mapToCurve() must be defined");
  return {
    // Encodes byte string to elliptic curve
    // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-3
    hashToCurve(n, o) {
      const i = Uz(n, 2, { ...r, DST: r.DST, ...o }), a = e.fromAffine(t(i[0])), u = e.fromAffine(t(i[1])), l = a.add(u).clearCofactor();
      return l.assertValidity(), l;
    },
    // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-3
    encodeToCurve(n, o) {
      const i = Uz(n, 1, { ...r, DST: r.encodeDST, ...o }), a = e.fromAffine(t(i[0])).clearCofactor();
      return a.assertValidity(), a;
    }
  };
}
let XG = class extends HG {
  constructor(e, t) {
    super(), this.finished = !1, this.destroyed = !1, Lp.hash(e);
    const r = XB(t);
    if (this.iHash = e.create(), typeof this.iHash.update != "function")
      throw new TypeError("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const n = this.blockLen, o = new Uint8Array(n);
    o.set(r.length > n ? e.create().update(r).digest() : r);
    for (let i = 0; i < o.length; i++)
      o[i] ^= 54;
    this.iHash.update(o), this.oHash = e.create();
    for (let i = 0; i < o.length; i++)
      o[i] ^= 106;
    this.oHash.update(o), o.fill(0);
  }
  update(e) {
    return Lp.exists(this), this.iHash.update(e), this;
  }
  digestInto(e) {
    Lp.exists(this), Lp.bytes(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
  }
  digest() {
    const e = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(e), e;
  }
  _cloneInto(e) {
    e || (e = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: t, iHash: r, finished: n, destroyed: o, blockLen: i, outputLen: a } = this;
    return e = e, e.finished = n, e.destroyed = o, e.blockLen = i, e.outputLen = a, e.oHash = t._cloneInto(e.oHash), e.iHash = r._cloneInto(e.iHash), e;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
};
const YG = (e, t, r) => new XG(e, t).update(r).digest();
YG.create = (e, t) => new XG(e, t);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function e7e(e) {
  return {
    hash: e,
    hmac: (t, ...r) => YG(e, t, f6e(...r)),
    randomBytes: d6e
  };
}
function t7e(e, t) {
  const r = (n) => K6e({ ...e, ...e7e(n) });
  return Object.freeze({ ...r(t), create: r });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const JG = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), Rz = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), r7e = BigInt(1), ZO = BigInt(2), zz = (e, t) => (e + t / ZO) / t;
function n7e(e) {
  const t = JG, r = BigInt(3), n = BigInt(6), o = BigInt(11), i = BigInt(22), a = BigInt(23), u = BigInt(44), l = BigInt(88), d = e * e * e % t, f = d * d * e % t, h = Ts(f, r, t) * f % t, g = Ts(h, r, t) * f % t, b = Ts(g, ZO, t) * d % t, w = Ts(b, o, t) * b % t, E = Ts(w, i, t) * w % t, _ = Ts(E, u, t) * E % t, O = Ts(_, l, t) * _ % t, C = Ts(O, u, t) * E % t, I = Ts(C, r, t) * f % t, S = Ts(I, a, t) * w % t, T = Ts(S, n, t) * d % t, A = Ts(T, ZO, t);
  if (!Kd.eql(Kd.sqr(A), e))
    throw new Error("Cannot find square root");
  return A;
}
const Kd = WG(JG, void 0, void 0, { sqrt: n7e }), hf = t7e({
  a: BigInt(0),
  b: BigInt(7),
  Fp: Kd,
  n: Rz,
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  lowS: !0,
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (e) => {
      const t = Rz, r = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), n = -r7e * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), o = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), i = r, a = BigInt("0x100000000000000000000000000000000"), u = zz(i * e, t), l = zz(-n * e, t);
      let d = ji(e - u * r - l * o, t), f = ji(-u * n - l * i, t);
      const h = d > a, g = f > a;
      if (h && (d = t - d), g && (f = t - f), d > a || f > a)
        throw new Error("splitScalar: Endomorphism failed, k=" + e);
      return { k1neg: h, k1: d, k2neg: g, k2: f };
    }
  }
}, DG);
BigInt(0);
hf.ProjectivePoint;
hf.utils.randomPrivateKey;
const o7e = J6e(Kd, [
  // xNum
  [
    "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
    "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
    "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
    "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
  ],
  // xDen
  [
    "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
    "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
    "0x0000000000000000000000000000000000000000000000000000000000000001"
    // LAST 1
  ],
  // yNum
  [
    "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
    "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
    "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
    "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
  ],
  // yDen
  [
    "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
    "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
    "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
    "0x0000000000000000000000000000000000000000000000000000000000000001"
    // LAST 1
  ]
].map((e) => e.map((t) => BigInt(t)))), i7e = V6e(Kd, {
  A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
  B: BigInt("1771"),
  Z: Kd.create(BigInt("-11"))
});
Q6e(hf.ProjectivePoint, (e) => {
  const { x: t, y: r } = i7e(Kd.create(e[0]));
  return o7e(t, r);
}, {
  DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
  encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
  p: Kd.ORDER,
  m: 1,
  k: 128,
  expand: "xmd",
  hash: DG
});
function XO(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function a7e(e) {
  if (typeof e != "boolean")
    throw new Error(`Expected boolean, not ${e}`);
}
function QG(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new TypeError(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function s7e(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  XO(e.outputLen), XO(e.blockLen);
}
function u7e(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function c7e(e, t) {
  QG(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error(`digestInto() expects output buffer of length at least ${r}`);
}
const l7e = {
  number: XO,
  bool: a7e,
  bytes: QG,
  hash: s7e,
  exists: u7e,
  output: c7e
};
var DT = l7e;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const KT = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), dc = (e, t) => e << 32 - t | e >>> t, f7e = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!f7e)
  throw new Error("Non little-endian hardware is not supported");
Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function d7e(e) {
  if (typeof e != "string")
    throw new TypeError(`utf8ToBytes expected string, got ${typeof e}`);
  return new TextEncoder().encode(e);
}
function eW(e) {
  if (typeof e == "string" && (e = d7e(e)), !(e instanceof Uint8Array))
    throw new TypeError(`Expected input type is Uint8Array (got ${typeof e})`);
  return e;
}
let h7e = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function tW(e) {
  const t = (n) => e().update(eW(n)).digest(), r = e();
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = () => e(), t;
}
function p7e(e, t, r, n) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, r, n);
  const o = BigInt(32), i = BigInt(4294967295), a = Number(r >> o & i), u = Number(r & i), l = n ? 4 : 0, d = n ? 0 : 4;
  e.setUint32(t + l, a, n), e.setUint32(t + d, u, n);
}
let g7e = class extends h7e {
  constructor(e, t, r, n) {
    super(), this.blockLen = e, this.outputLen = t, this.padOffset = r, this.isLE = n, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = KT(this.buffer);
  }
  update(e) {
    DT.exists(this);
    const { view: t, buffer: r, blockLen: n } = this;
    e = eW(e);
    const o = e.length;
    for (let i = 0; i < o; ) {
      const a = Math.min(n - this.pos, o - i);
      if (a === n) {
        const u = KT(e);
        for (; n <= o - i; i += n)
          this.process(u, i);
        continue;
      }
      r.set(e.subarray(i, i + a), this.pos), this.pos += a, i += a, this.pos === n && (this.process(t, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    DT.exists(this), DT.output(e, this), this.finished = !0;
    const { buffer: t, view: r, blockLen: n, isLE: o } = this;
    let { pos: i } = this;
    t[i++] = 128, this.buffer.subarray(i).fill(0), this.padOffset > n - i && (this.process(r, 0), i = 0);
    for (let f = i; f < n; f++)
      t[f] = 0;
    p7e(r, n - 8, BigInt(this.length * 8), o), this.process(r, 0);
    const a = KT(e), u = this.outputLen;
    if (u % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const l = u / 4, d = this.get();
    if (l > d.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let f = 0; f < l; f++)
      a.setUint32(4 * f, d[f], o);
  }
  digest() {
    const { buffer: e, outputLen: t } = this;
    this.digestInto(e);
    const r = e.slice(0, t);
    return this.destroy(), r;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: t, buffer: r, length: n, finished: o, destroyed: i, pos: a } = this;
    return e.length = n, e.pos = a, e.finished = o, e.destroyed = i, n % t && e.buffer.set(r), e;
  }
};
const m7e = (e, t, r) => e & t ^ ~e & r, y7e = (e, t, r) => e & t ^ e & r ^ t & r, b7e = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), sd = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), ud = new Uint32Array(64);
let rW = class extends g7e {
  constructor() {
    super(64, 32, 8, !1), this.A = sd[0] | 0, this.B = sd[1] | 0, this.C = sd[2] | 0, this.D = sd[3] | 0, this.E = sd[4] | 0, this.F = sd[5] | 0, this.G = sd[6] | 0, this.H = sd[7] | 0;
  }
  get() {
    const { A: e, B: t, C: r, D: n, E: o, F: i, G: a, H: u } = this;
    return [e, t, r, n, o, i, a, u];
  }
  // prettier-ignore
  set(e, t, r, n, o, i, a, u) {
    this.A = e | 0, this.B = t | 0, this.C = r | 0, this.D = n | 0, this.E = o | 0, this.F = i | 0, this.G = a | 0, this.H = u | 0;
  }
  process(e, t) {
    for (let f = 0; f < 16; f++, t += 4)
      ud[f] = e.getUint32(t, !1);
    for (let f = 16; f < 64; f++) {
      const h = ud[f - 15], g = ud[f - 2], b = dc(h, 7) ^ dc(h, 18) ^ h >>> 3, w = dc(g, 17) ^ dc(g, 19) ^ g >>> 10;
      ud[f] = w + ud[f - 7] + b + ud[f - 16] | 0;
    }
    let { A: r, B: n, C: o, D: i, E: a, F: u, G: l, H: d } = this;
    for (let f = 0; f < 64; f++) {
      const h = dc(a, 6) ^ dc(a, 11) ^ dc(a, 25), g = d + h + m7e(a, u, l) + b7e[f] + ud[f] | 0, b = (dc(r, 2) ^ dc(r, 13) ^ dc(r, 22)) + y7e(r, n, o) | 0;
      d = l, l = u, u = a, a = i + g | 0, i = o, o = n, n = r, r = g + b | 0;
    }
    r = r + this.A | 0, n = n + this.B | 0, o = o + this.C | 0, i = i + this.D | 0, a = a + this.E | 0, u = u + this.F | 0, l = l + this.G | 0, d = d + this.H | 0, this.set(r, n, o, i, a, u, l, d);
  }
  roundClean() {
    ud.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}, w7e = class extends rW {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
};
const YO = tW(() => new rW());
tW(() => new w7e());
function v7e(e, t) {
  if (e.length > t)
    throw new TypeError(`Data is larger than array size: ${e.length} > ${t}`);
}
function E7e(e) {
  if (e.match(/[^a-fA-f0-9]/) !== null)
    throw new TypeError("Invalid characters in hex string: " + e);
  if (e.length % 2 !== 0)
    throw new Error(`Length of hex string is invalid: ${e.length}`);
}
function _7e(e) {
  if (e > Number.MAX_SAFE_INTEGER)
    throw new TypeError("Number exceeds safe bounds!");
}
const { getRandomValues: A7e } = crypto ?? globalThis.crypto ?? window.crypto;
function x7e(e = 32) {
  if (typeof A7e == "function")
    return crypto.getRandomValues(new Uint8Array(e));
  throw new Error("Crypto module missing getRandomValues!");
}
function k7e(e, t, r = "be") {
  t === void 0 && (t = e.length), v7e(e, t);
  const n = new Uint8Array(t).fill(0), o = r === "be" ? 0 : t - e.length;
  return n.set(e, o), n;
}
function nW(e) {
  let t, r = 0;
  const n = e.reduce((i, a) => i + a.length, 0), o = new Uint8Array(n);
  for (t = 0; t < e.length; t++) {
    const i = e[t];
    o.set(i, r), r += i.length;
  }
  return o;
}
const S7e = new TextEncoder(), T7e = [
  {
    name: "base58",
    charset: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
  }
];
function oW(e) {
  for (const t of T7e)
    if (t.name === e)
      return t.charset;
  throw TypeError("Charset does not exist: " + e);
}
function I7e(e, t, r = !1) {
  typeof e == "string" && (e = S7e.encode(e));
  const n = oW(t), o = n.length, i = [];
  let a = "", u, l = 0, d, f;
  for (u = 0; u < e.length; u++)
    for (l = 0, d = e[u], a += d > 0 || (a.length ^ u) > 0 ? "" : "1"; l in i || d > 0; )
      f = i[l], f = f > 0 ? f * 256 + d : d, d = f / o | 0, i[l] = f % o, l++;
  for (; l-- > 0; )
    a += n[i[l]];
  return r && a.length % 4 > 0 ? a + "=".repeat(4 - a.length % 4) : a;
}
function O7e(e, t) {
  const r = oW(t), n = r.length, o = [], i = [];
  e = e.replace("=", "");
  let a, u = 0, l, d;
  for (a = 0; a < e.length; a++) {
    if (u = 0, l = r.indexOf(e[a]), l < 0)
      throw new Error(`Character range out of bounds: ${l}`);
    for (l > 0 || (i.length ^ a) > 0 || i.push(0); u in o || l > 0; )
      d = o[u], d = d > 0 ? d * n + l : l, l = d >> 8, o[u] = d % 256, u++;
  }
  for (; u-- > 0; )
    i.push(o[u]);
  return new Uint8Array(i);
}
function iW(e) {
  return YO(YO(e));
}
function P7e(e) {
  const t = iW(e);
  return nW([e, t.slice(0, 4)]);
}
function C7e(e) {
  const t = e.slice(0, -4), r = e.slice(-4);
  if (iW(t).slice(0, 4).toString() !== r.toString())
    throw new Error("Invalid checksum!");
  return t;
}
const jz = {
  encode: I7e,
  decode: O7e
}, aW = {
  encode: (e) => {
    const t = P7e(e);
    return jz.encode(t, "base58");
  },
  decode: (e) => {
    const t = jz.decode(e, "base58");
    return C7e(t);
  }
}, sW = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", B7e = [996825010, 642813549, 513874426, 1027748829, 705979059], s5 = [
  { version: 0, name: "bech32", const: 1 },
  { version: 1, name: "bech32m", const: 734539939 }
];
function uW(e) {
  let t = 1;
  for (let r = 0; r < e.length; ++r) {
    const n = t >> 25;
    t = (t & 33554431) << 5 ^ e[r];
    for (let o = 0; o < 5; ++o)
      n >> o & 1 && (t ^= B7e[o]);
  }
  return t;
}
function cW(e) {
  const t = [];
  let r;
  for (r = 0; r < e.length; ++r)
    t.push(e.charCodeAt(r) >> 5);
  for (t.push(0), r = 0; r < e.length; ++r)
    t.push(e.charCodeAt(r) & 31);
  return t;
}
function N7e(e, t, r) {
  const n = cW(e).concat(t);
  return uW(n) === r.const;
}
function $7e(e, t, r) {
  const n = cW(e).concat(t).concat([0, 0, 0, 0, 0, 0]), o = uW(n) ^ r.const, i = [];
  for (let a = 0; a < 6; ++a)
    i.push(o >> 5 * (5 - a) & 31);
  return i;
}
function lW(e, t, r, n = !0) {
  const o = [];
  let i = 0, a = 0;
  const u = (1 << r) - 1, l = (1 << t + r - 1) - 1;
  for (const d of e) {
    if (d < 0 || d >> t > 0)
      throw new Error("Failed to perform base conversion. Invalid value: " + String(d));
    for (i = (i << t | d) & l, a += t; a >= r; )
      a -= r, o.push(i >> a & u);
  }
  if (n)
    a > 0 && o.push(i << r - a & u);
  else if (a >= t || (i << r - a & u) > 0)
    throw new Error("Failed to perform base conversion. Invalid Size!");
  return o;
}
function U7e(e, t, r) {
  const n = t.concat($7e(e, t, r));
  let o = e + "1";
  for (let i = 0; i < n.length; ++i)
    o += sW.charAt(n[i]);
  return o;
}
function fW(e) {
  if (!R7e(e))
    throw new Error("Encoded string goes out of bounds!");
  if (e = e.toLowerCase(), !z7e(e))
    throw new Error("Encoded string has invalid separator!");
  const t = [], r = e.lastIndexOf("1"), n = e.substring(0, r);
  for (let i = r + 1; i < e.length; ++i) {
    const a = sW.indexOf(e.charAt(i));
    if (a === -1)
      throw new Error("Character idx out of bounds: " + String(i));
    t.push(a);
  }
  const o = s5.find((i) => i.version === t[0]) ?? s5[0];
  if (!N7e(n, t, o))
    throw new Error("Checksum verification failed!");
  return [n, t.slice(0, t.length - 6)];
}
function R7e(e) {
  let t, r, n = !1, o = !1;
  for (t = 0; t < e.length; ++t) {
    if (r = e.charCodeAt(t), r < 33 || r > 126)
      return !1;
    r >= 97 && r <= 122 && (n = !0), r >= 65 && r <= 90 && (o = !0);
  }
  return !(n && o);
}
function z7e(e) {
  const t = e.lastIndexOf("1");
  return !(t < 1 || t + 7 > e.length || e.length > 90);
}
function j7e(e, t = "bc", r = 0) {
  const n = [r, ...lW([...e], 8, 5)], o = s5.find((a) => a.version === r) ?? s5[0], i = U7e(t, n, o);
  return dW(i), i;
}
function dW(e) {
  e = e.toLowerCase();
  const t = e.split("1", 1)[0], [r, n] = fW(e), o = lW(n.slice(1), 5, 8, !1), i = o.length;
  switch (!0) {
    case t !== r:
      throw new Error("Returned hrp string is invalid.");
    case (o === null || i < 2 || i > 40):
      throw new Error("Decoded string is invalid or out of spec.");
    case n[0] > 16:
      throw new Error("Returned version bit is out of range.");
    default:
      return Uint8Array.from(o);
  }
}
function L7e(e) {
  e = e.toLowerCase();
  const [t, r] = fW(e);
  return r[0];
}
const hW = {
  encode: j7e,
  decode: dW,
  version: L7e
}, pW = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", gW = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", H7e = new TextEncoder();
function mW(e, t = !1, r = !0) {
  typeof e == "string" && (e = H7e.encode(e));
  const n = t ? gW : pW;
  let o = "", i = 0, a = 0;
  for (let u = 0; u < e.length; u++)
    for (a = a << 8 | e[u], i += 8; i >= 6; )
      i -= 6, o += n[a >> i & 63];
  if (i > 0)
    for (a <<= 6 - i, o += n[a & 63]; i < 6; )
      o += r ? "=" : "", i += 2;
  return o;
}
function yW(e, t = !1) {
  const r = t || e.includes("-") || e.includes("_") ? gW.split("") : pW.split("");
  e = e.replace(/=+$/, "");
  const n = e.split("");
  let o = 0, i = 0;
  const a = [];
  for (let u = 0; u < n.length; u++) {
    const l = n[u], d = r.indexOf(l);
    if (d === -1)
      throw new Error("Invalid character: " + l);
    o += 6, i <<= 6, i |= d, o >= 8 && (o -= 8, a.push(i >>> o & 255));
  }
  return new Uint8Array(a);
}
const bW = {
  encode: mW,
  decode: yW
}, wW = {
  encode: (e) => mW(e, !0, !1),
  decode: (e) => yW(e, !0)
}, F7e = BigInt(0), M7e = BigInt(255), vW = BigInt(256);
function D7e(e) {
  if (e <= 0xffn)
    return 1;
  if (e <= 0xffffn)
    return 2;
  if (e <= 0xffffffffn)
    return 4;
  if (e <= 0xffffffffffffffffn)
    return 8;
  if (e <= 0xffffffffffffffffffffffffffffffffn)
    return 16;
  if (e <= 0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffn)
    return 32;
  throw new TypeError("Must specify a fixed buffer size for bigints greater than 32 bytes.");
}
function K7e(e, t, r = "be") {
  t === void 0 && (t = D7e(e));
  const n = r === "le", o = new ArrayBuffer(t), i = new DataView(o);
  let a = n ? 0 : t - 1;
  for (; e > F7e; ) {
    const u = e & M7e, l = Number(u);
    n ? i.setUint8(a++, l) : i.setUint8(a--, l), e = (e - u) / vW;
  }
  return new Uint8Array(o);
}
function q7e(e) {
  let t = BigInt(0);
  for (let r = e.length - 1; r >= 0; r--)
    t = t * vW + BigInt(e[r]);
  return BigInt(t);
}
function V7e(e) {
  const t = e.split("").map(Number);
  if (t.length % 8 !== 0)
    throw new Error(`Binary array is invalid length: ${e.length}`);
  const r = new Uint8Array(t.length / 8);
  for (let n = 0, o = 0; n < t.length; n += 8, o++) {
    let i = 0;
    for (let a = 0; a < 8; a++)
      i |= t[n + a] << 7 - a;
    r[o] = i;
  }
  return r;
}
function G7e(e) {
  const t = new Array(e.length * 8);
  let r = 0;
  for (const n of e) {
    if (n > 255)
      throw new Error(`Invalid byte value: ${n}. Byte values must be between 0 and 255.`);
    for (let o = 7; o >= 0; o--, r++)
      t[r] = n >> o & 1;
  }
  return t.join("");
}
function W7e(e) {
  if (e <= 255)
    return 1;
  if (e <= 65535)
    return 2;
  if (e <= 4294967295)
    return 4;
  throw new TypeError("Numbers larger than 4 bytes must specify a fixed size!");
}
function Z7e(e, t, r = "be") {
  t === void 0 && (t = W7e(e));
  const n = r === "le", o = new ArrayBuffer(t), i = new DataView(o);
  let a = n ? 0 : t - 1;
  for (; e > 0; ) {
    const u = e & 255;
    n ? i.setUint8(a++, e) : i.setUint8(a--, e), e = (e - u) / 256;
  }
  return new Uint8Array(o);
}
function X7e(e) {
  let t = 0;
  for (let r = e.length - 1; r >= 0; r--)
    t = t * 256 + e[r], _7e(t);
  return t;
}
const Y7e = new TextEncoder(), J7e = new TextDecoder();
function nN(e) {
  return Y7e.encode(e);
}
function JO(e) {
  return J7e.decode(e);
}
function Q7e(e, t) {
  E7e(e);
  const r = e.length / 2;
  if (t === void 0 && (t = r), r > t)
    throw new TypeError(`Hex string is larger than array size: ${r} > ${t}`);
  return t;
}
function e_e(e, t, r = "le") {
  t = Q7e(e, t);
  const n = r === "le", o = new ArrayBuffer(t), i = new DataView(o);
  let a = n ? 0 : t - 1;
  for (let u = 0; u < e.length; u += 2) {
    const l = e.substring(u, u + 2), d = parseInt(l, 16);
    n ? i.setUint8(a++, d) : i.setUint8(a--, d);
  }
  return new Uint8Array(o);
}
function t_e(e) {
  let t = "";
  for (let r = 0; r < e.length; r++)
    t += e[r].toString(16).padStart(2, "0");
  return t;
}
function r_e(e) {
  const t = JSON.stringify(e, (r, n) => typeof n == "bigint" ? `${n}n` : n);
  return nN(t);
}
function n_e(e, t, r) {
  if (e instanceof ArrayBuffer)
    return new Uint8Array(e);
  if (e instanceof Uint8Array)
    return k7e(e, t, r);
  if (typeof e == "string")
    return e_e(e, t, r);
  if (typeof e == "bigint")
    return K7e(e, t, r);
  if (typeof e == "number")
    return Z7e(e, t, r);
  if (typeof e == "boolean")
    return Uint8Array.of(e ? 1 : 0);
  throw TypeError("Unsupported format:" + typeof e);
}
const na = class Fn extends Uint8Array {
  static random(t = 32) {
    const r = x7e(t);
    return new Fn(r, t);
  }
  constructor(t, r, n) {
    const o = n_e(t, r, n);
    super(o);
  }
  get arr() {
    return [...this];
  }
  get num() {
    return this.toNum();
  }
  get big() {
    return this.toBig();
  }
  get str() {
    return this.toStr();
  }
  get hex() {
    return this.toHex();
  }
  get raw() {
    return new Uint8Array(this);
  }
  get bin() {
    return this.toBin();
  }
  get b58chk() {
    return this.tob58chk();
  }
  get base64() {
    return this.toBase64();
  }
  get b64url() {
    return this.toB64url();
  }
  get digest() {
    return this.toHash();
  }
  get id() {
    return this.toHash().hex;
  }
  get stream() {
    return new m_e(this);
  }
  toNum(t = "be") {
    const r = t === "be" ? this.reverse() : this;
    return X7e(r);
  }
  toBin() {
    return G7e(this);
  }
  toBig(t = "be") {
    const r = t === "be" ? this.reverse() : this;
    return q7e(r);
  }
  toHash() {
    const t = YO(this);
    return new Fn(t);
  }
  toJson() {
    const t = JO(this);
    return JSON.parse(t);
  }
  toBech32(t, r = 0) {
    return hW.encode(this, t, r);
  }
  toStr() {
    return JO(this);
  }
  toHex() {
    return t_e(this);
  }
  toBytes() {
    return new Uint8Array(this);
  }
  tob58chk() {
    return aW.encode(this);
  }
  toBase64() {
    return bW.encode(this);
  }
  toB64url() {
    return wW.encode(this);
  }
  prepend(t) {
    return Fn.join([Fn.bytes(t), this]);
  }
  append(t) {
    return Fn.join([this, Fn.bytes(t)]);
  }
  slice(t, r) {
    const n = new Uint8Array(this).slice(t, r);
    return new Fn(n);
  }
  subarray(t, r) {
    const n = new Uint8Array(this).subarray(t, r);
    return new Fn(n);
  }
  reverse() {
    const t = new Uint8Array(this).reverse();
    return new Fn(t);
  }
  write(t, r) {
    const n = Fn.bytes(t);
    this.set(n, r);
  }
  prefixSize(t) {
    const r = Fn.varInt(this.length, t);
    return Fn.join([r, this]);
  }
  static from(t) {
    return new Fn(Uint8Array.from(t));
  }
  static of(...t) {
    return new Fn(Uint8Array.of(...t));
  }
  static join(t) {
    const r = t.map((o) => Fn.bytes(o)), n = nW(r);
    return new Fn(n);
  }
  static varInt(t, r) {
    if (t < 253)
      return Fn.num(t, 1);
    if (t < 65536)
      return Fn.of(253, ...Fn.num(t, 2, r));
    if (t < 4294967296)
      return Fn.of(254, ...Fn.num(t, 4, r));
    if (BigInt(t) < 0x10000000000000000n)
      return Fn.of(255, ...Fn.num(t, 8, r));
    throw new Error(`Value is too large: ${t}`);
  }
};
na.num = o_e, na.big = a_e, na.bin = i_e, na.raw = s_e, na.str = u_e, na.hex = c_e, na.bytes = l_e, na.json = f_e, na.base64 = d_e, na.b64url = h_e, na.bech32 = p_e, na.b58chk = g_e, na.encode = nN, na.decode = JO;
let nr = na;
function o_e(e, t, r) {
  return new nr(e, t, r);
}
function i_e(e, t, r) {
  return new nr(V7e(e), t, r);
}
function a_e(e, t, r) {
  return new nr(e, t, r);
}
function s_e(e, t, r) {
  return new nr(e, t, r);
}
function u_e(e, t, r) {
  return new nr(nN(e), t, r);
}
function c_e(e, t, r) {
  return new nr(e, t, r);
}
function l_e(e, t, r) {
  return new nr(e, t, r);
}
function f_e(e) {
  return new nr(r_e(e));
}
function d_e(e) {
  return new nr(bW.decode(e));
}
function h_e(e) {
  return new nr(wW.decode(e));
}
function p_e(e) {
  return new nr(hW.decode(e));
}
function g_e(e) {
  return new nr(aW.decode(e));
}
class m_e {
  constructor(t) {
    this.data = nr.bytes(t), this.size = this.data.length;
  }
  peek(t) {
    if (t > this.size)
      throw new Error(`Size greater than stream: ${t} > ${this.size}`);
    return new nr(this.data.slice(0, t));
  }
  read(t) {
    t = t ?? this.readSize();
    const r = this.peek(t);
    return this.data = this.data.slice(t), this.size = this.data.length, r;
  }
  readSize(t) {
    const r = this.read(1).num;
    switch (!0) {
      case (r >= 0 && r < 253):
        return r;
      case r === 253:
        return this.read(2).toNum(t);
      case r === 254:
        return this.read(4).toNum(t);
      case r === 255:
        return this.read(8).toNum(t);
      default:
        throw new Error(`Varint is out of range: ${r}`);
    }
  }
}
const u5 = hf.CURVE, oN = u5.n, y_e = u5.p, b_e = { x: u5.Gx, y: u5.Gy }, w_e = BigInt(0);
BigInt(1);
BigInt(2);
BigInt(3);
BigInt(4);
const QO = { N: oN, P: y_e, G: b_e, _0n: w_e }, Lb = WG(oN, 32, !0), EW = (e) => ji(e, oN);
function iN(e, t = !1) {
  if (t)
    throw new Error(e);
  return !1;
}
function _W(e) {
  return nr.random(e);
}
function v_e(e) {
  const t = nr.bytes(e).big;
  return nr.big(EW(t), 32);
}
var E_e = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  fail: iN,
  mod_bytes: v_e,
  random: _W
});
const { N: __e, _0n: A_e } = QO;
function x_e(e, t, r) {
  const n = nr.bytes(e);
  return n.length !== t ? iN(`Invalid byte size: ${n.hex} !== ${t}`, r) : !0;
}
function k_e(e, t) {
  return typeof e == "bigint" && A_e < e && e < __e || iN("x value is not in the field!", t), !0;
}
const Lz = hf.ProjectivePoint;
var yo;
let fa = (yo = class extends Uint8Array {
  static mod(e) {
    return new yo(e);
  }
  static is_valid(e, t) {
    const r = nr.bytes(e, 32).big;
    return k_e(r, t);
  }
  constructor(e) {
    let t = S_e(e);
    t = EW(t), yo.is_valid(t, !0), super(nr.big(t, 32), 32);
  }
  get buff() {
    return new nr(this);
  }
  get raw() {
    return this.buff.raw;
  }
  get big() {
    return this.buff.big;
  }
  get hex() {
    return this.buff.hex;
  }
  get point() {
    return this.generate();
  }
  get hasOddY() {
    return this.point.hasOddY;
  }
  get negated() {
    return this.hasOddY ? this.negate() : this;
  }
  gt(e) {
    return new yo(e).big > this.big;
  }
  lt(e) {
    return new yo(e).big < this.big;
  }
  eq(e) {
    return new yo(e).big === this.big;
  }
  ne(e) {
    return new yo(e).big !== this.big;
  }
  add(e) {
    const t = yo.mod(e), r = Lb.add(this.big, t.big);
    return new yo(r);
  }
  sub(e) {
    const t = yo.mod(e), r = Lb.sub(this.big, t.big);
    return new yo(r);
  }
  mul(e) {
    const t = yo.mod(e), r = Lb.mul(this.big, t.big);
    return new yo(r);
  }
  pow(e) {
    const t = yo.mod(e), r = Lb.pow(this.big, t.big);
    return new yo(r);
  }
  div(e) {
    const t = yo.mod(e), r = Lb.div(this.big, t.big);
    return new yo(r);
  }
  negate() {
    return new yo(yo.N - this.big);
  }
  generate() {
    const e = hf.ProjectivePoint.BASE.multiply(this.big);
    return N0.import(e);
  }
}, yo.N = hf.CURVE.n, yo);
var Ln;
let N0 = (Ln = class {
  static from_x(e) {
    let t = T_e(e);
    t.length === 32 && (t = t.prepend(2)), x_e(t, 33);
    const r = Lz.fromHex(t.hex);
    return r.assertValidity(), new Ln(r.x, r.y);
  }
  static generate(e) {
    const t = fa.mod(e), r = Ln.base.multiply(t.big);
    return Ln.import(r);
  }
  static import(e) {
    const t = e instanceof Ln ? { x: e.x.big, y: e.y.big } : { x: e.x, y: e.y };
    return new Ln(t.x, t.y);
  }
  constructor(e, t) {
    this._p = new Lz(e, t, 1n), this.p.assertValidity();
  }
  get p() {
    return this._p;
  }
  get x() {
    return nr.big(this.p.x, 32);
  }
  get y() {
    return nr.big(this.p.y, 32);
  }
  get buff() {
    return nr.raw(this.p.toRawBytes(!0));
  }
  get raw() {
    return this.buff.raw;
  }
  get hex() {
    return this.buff.hex;
  }
  get hasEvenY() {
    return this.p.hasEvenY();
  }
  get hasOddY() {
    return !this.p.hasEvenY();
  }
  eq(e) {
    const t = e instanceof Ln ? e : Ln.from_x(e);
    return this.x.big === t.x.big && this.y.big === t.y.big;
  }
  add(e) {
    return e instanceof Ln ? Ln.import(this.p.add(e.p)) : Ln.import(this.p.add(Ln.generate(e).p));
  }
  sub(e) {
    return e instanceof Ln ? Ln.import(this.p.subtract(e.p)) : Ln.import(this.p.subtract(Ln.generate(e).p));
  }
  mul(e) {
    return e instanceof Ln ? Ln.import(this.p.multiply(e.x.big)) : Ln.import(this.p.multiply(fa.mod(e).big));
  }
  negate() {
    return Ln.import(this.p.negate());
  }
}, Ln.P = QO.P, Ln.G = QO.G, Ln.base = hf.ProjectivePoint.BASE, Ln);
function S_e(e) {
  if (e instanceof fa)
    return e.big;
  if (e instanceof N0)
    return e.x.big;
  if (e instanceof Uint8Array)
    return nr.raw(e).big;
  if (typeof e == "string")
    return nr.hex(e).big;
  if (typeof e == "number")
    return nr.num(e).big;
  if (typeof e == "bigint")
    return BigInt(e);
  throw TypeError("Invalid input type:" + typeof e);
}
function T_e(e) {
  if (e instanceof fa)
    return e.point.buff;
  if (e instanceof N0)
    return e.buff;
  if (e instanceof Uint8Array || typeof e == "string")
    return nr.bytes(e);
  if (typeof e == "number" || typeof e == "bigint")
    return nr.bytes(e, 32);
  throw new TypeError(`Unknown type: ${typeof e}`);
}
function eP(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function I_e(e) {
  if (typeof e != "boolean")
    throw new Error(`Expected boolean, not ${e}`);
}
function AW(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function O_e(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  eP(e.outputLen), eP(e.blockLen);
}
function P_e(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function C_e(e, t) {
  AW(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error(`digestInto() expects output buffer of length at least ${r}`);
}
const B_e = {
  number: eP,
  bool: I_e,
  bytes: AW,
  hash: O_e,
  exists: P_e,
  output: C_e
};
var Fp = B_e;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const N_e = (e) => e instanceof Uint8Array, qT = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), hc = (e, t) => e << 32 - t | e >>> t, $_e = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!$_e)
  throw new Error("Non little-endian hardware is not supported");
Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function U_e(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function aN(e) {
  if (typeof e == "string" && (e = U_e(e)), !N_e(e))
    throw new Error(`expected Uint8Array, got ${typeof e}`);
  return e;
}
class xW {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function $0(e) {
  const t = (n) => e().update(aN(n)).digest(), r = e();
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = () => e(), t;
}
function R_e(e, t, r, n) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, r, n);
  const o = BigInt(32), i = BigInt(4294967295), a = Number(r >> o & i), u = Number(r & i), l = n ? 4 : 0, d = n ? 0 : 4;
  e.setUint32(t + l, a, n), e.setUint32(t + d, u, n);
}
class sN extends xW {
  constructor(t, r, n, o) {
    super(), this.blockLen = t, this.outputLen = r, this.padOffset = n, this.isLE = o, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = qT(this.buffer);
  }
  update(t) {
    Fp.exists(this);
    const { view: r, buffer: n, blockLen: o } = this;
    t = aN(t);
    const i = t.length;
    for (let a = 0; a < i; ) {
      const u = Math.min(o - this.pos, i - a);
      if (u === o) {
        const l = qT(t);
        for (; o <= i - a; a += o)
          this.process(l, a);
        continue;
      }
      n.set(t.subarray(a, a + u), this.pos), this.pos += u, a += u, this.pos === o && (this.process(r, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    Fp.exists(this), Fp.output(t, this), this.finished = !0;
    const { buffer: r, view: n, blockLen: o, isLE: i } = this;
    let { pos: a } = this;
    r[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > o - a && (this.process(n, 0), a = 0);
    for (let h = a; h < o; h++)
      r[h] = 0;
    R_e(n, o - 8, BigInt(this.length * 8), i), this.process(n, 0);
    const u = qT(t), l = this.outputLen;
    if (l % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const d = l / 4, f = this.get();
    if (d > f.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let h = 0; h < d; h++)
      u.setUint32(4 * h, f[h], i);
  }
  digest() {
    const { buffer: t, outputLen: r } = this;
    this.digestInto(t);
    const n = t.slice(0, r);
    return this.destroy(), n;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: r, buffer: n, length: o, finished: i, destroyed: a, pos: u } = this;
    return t.length = o, t.pos = u, t.finished = i, t.destroyed = a, o % r && t.buffer.set(n), t;
  }
}
const z_e = (e, t, r) => e & t ^ ~e & r, j_e = (e, t, r) => e & t ^ e & r ^ t & r, L_e = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), cd = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), ld = new Uint32Array(64);
class kW extends sN {
  constructor() {
    super(64, 32, 8, !1), this.A = cd[0] | 0, this.B = cd[1] | 0, this.C = cd[2] | 0, this.D = cd[3] | 0, this.E = cd[4] | 0, this.F = cd[5] | 0, this.G = cd[6] | 0, this.H = cd[7] | 0;
  }
  get() {
    const { A: t, B: r, C: n, D: o, E: i, F: a, G: u, H: l } = this;
    return [t, r, n, o, i, a, u, l];
  }
  // prettier-ignore
  set(t, r, n, o, i, a, u, l) {
    this.A = t | 0, this.B = r | 0, this.C = n | 0, this.D = o | 0, this.E = i | 0, this.F = a | 0, this.G = u | 0, this.H = l | 0;
  }
  process(t, r) {
    for (let h = 0; h < 16; h++, r += 4)
      ld[h] = t.getUint32(r, !1);
    for (let h = 16; h < 64; h++) {
      const g = ld[h - 15], b = ld[h - 2], w = hc(g, 7) ^ hc(g, 18) ^ g >>> 3, E = hc(b, 17) ^ hc(b, 19) ^ b >>> 10;
      ld[h] = E + ld[h - 7] + w + ld[h - 16] | 0;
    }
    let { A: n, B: o, C: i, D: a, E: u, F: l, G: d, H: f } = this;
    for (let h = 0; h < 64; h++) {
      const g = hc(u, 6) ^ hc(u, 11) ^ hc(u, 25), b = f + g + z_e(u, l, d) + L_e[h] + ld[h] | 0, w = (hc(n, 2) ^ hc(n, 13) ^ hc(n, 22)) + j_e(n, o, i) | 0;
      f = d, d = l, l = u, u = a + b | 0, a = i, i = o, o = n, n = b + w | 0;
    }
    n = n + this.A | 0, o = o + this.B | 0, i = i + this.C | 0, a = a + this.D | 0, u = u + this.E | 0, l = l + this.F | 0, d = d + this.G | 0, f = f + this.H | 0, this.set(n, o, i, a, u, l, d, f);
  }
  roundClean() {
    ld.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
class H_e extends kW {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
}
const c5 = $0(() => new kW());
$0(() => new H_e());
const h8 = BigInt(2 ** 32 - 1), tP = BigInt(32);
function SW(e, t = !1) {
  return t ? { h: Number(e & h8), l: Number(e >> tP & h8) } : { h: Number(e >> tP & h8) | 0, l: Number(e & h8) | 0 };
}
function F_e(e, t = !1) {
  let r = new Uint32Array(e.length), n = new Uint32Array(e.length);
  for (let o = 0; o < e.length; o++) {
    const { h: i, l: a } = SW(e[o], t);
    [r[o], n[o]] = [i, a];
  }
  return [r, n];
}
const M_e = (e, t) => BigInt(e >>> 0) << tP | BigInt(t >>> 0), D_e = (e, t, r) => e >>> r, K_e = (e, t, r) => e << 32 - r | t >>> r, q_e = (e, t, r) => e >>> r | t << 32 - r, V_e = (e, t, r) => e << 32 - r | t >>> r, G_e = (e, t, r) => e << 64 - r | t >>> r - 32, W_e = (e, t, r) => e >>> r - 32 | t << 64 - r, Z_e = (e, t) => t, X_e = (e, t) => e, Y_e = (e, t, r) => e << r | t >>> 32 - r, J_e = (e, t, r) => t << r | e >>> 32 - r, Q_e = (e, t, r) => t << r - 32 | e >>> 64 - r, e9e = (e, t, r) => e << r - 32 | t >>> 64 - r;
function t9e(e, t, r, n) {
  const o = (t >>> 0) + (n >>> 0);
  return { h: e + r + (o / 2 ** 32 | 0) | 0, l: o | 0 };
}
const r9e = (e, t, r) => (e >>> 0) + (t >>> 0) + (r >>> 0), n9e = (e, t, r, n) => t + r + n + (e / 2 ** 32 | 0) | 0, o9e = (e, t, r, n) => (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0), i9e = (e, t, r, n, o) => t + r + n + o + (e / 2 ** 32 | 0) | 0, a9e = (e, t, r, n, o) => (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0) + (o >>> 0), s9e = (e, t, r, n, o, i) => t + r + n + o + i + (e / 2 ** 32 | 0) | 0, u9e = {
  fromBig: SW,
  split: F_e,
  toBig: M_e,
  shrSH: D_e,
  shrSL: K_e,
  rotrSH: q_e,
  rotrSL: V_e,
  rotrBH: G_e,
  rotrBL: W_e,
  rotr32H: Z_e,
  rotr32L: X_e,
  rotlSH: Y_e,
  rotlSL: J_e,
  rotlBH: Q_e,
  rotlBL: e9e,
  add: t9e,
  add3L: r9e,
  add3H: n9e,
  add4L: o9e,
  add4H: i9e,
  add5H: s9e,
  add5L: a9e
};
var Sr = u9e;
const [c9e, l9e] = Sr.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((e) => BigInt(e))), fd = new Uint32Array(80), dd = new Uint32Array(80);
let fE = class extends sN {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: e, Al: t, Bh: r, Bl: n, Ch: o, Cl: i, Dh: a, Dl: u, Eh: l, El: d, Fh: f, Fl: h, Gh: g, Gl: b, Hh: w, Hl: E } = this;
    return [e, t, r, n, o, i, a, u, l, d, f, h, g, b, w, E];
  }
  // prettier-ignore
  set(e, t, r, n, o, i, a, u, l, d, f, h, g, b, w, E) {
    this.Ah = e | 0, this.Al = t | 0, this.Bh = r | 0, this.Bl = n | 0, this.Ch = o | 0, this.Cl = i | 0, this.Dh = a | 0, this.Dl = u | 0, this.Eh = l | 0, this.El = d | 0, this.Fh = f | 0, this.Fl = h | 0, this.Gh = g | 0, this.Gl = b | 0, this.Hh = w | 0, this.Hl = E | 0;
  }
  process(e, t) {
    for (let C = 0; C < 16; C++, t += 4)
      fd[C] = e.getUint32(t), dd[C] = e.getUint32(t += 4);
    for (let C = 16; C < 80; C++) {
      const I = fd[C - 15] | 0, S = dd[C - 15] | 0, T = Sr.rotrSH(I, S, 1) ^ Sr.rotrSH(I, S, 8) ^ Sr.shrSH(I, S, 7), A = Sr.rotrSL(I, S, 1) ^ Sr.rotrSL(I, S, 8) ^ Sr.shrSL(I, S, 7), $ = fd[C - 2] | 0, U = dd[C - 2] | 0, M = Sr.rotrSH($, U, 19) ^ Sr.rotrBH($, U, 61) ^ Sr.shrSH($, U, 6), Y = Sr.rotrSL($, U, 19) ^ Sr.rotrBL($, U, 61) ^ Sr.shrSL($, U, 6), L = Sr.add4L(A, Y, dd[C - 7], dd[C - 16]), ee = Sr.add4H(L, T, M, fd[C - 7], fd[C - 16]);
      fd[C] = ee | 0, dd[C] = L | 0;
    }
    let { Ah: r, Al: n, Bh: o, Bl: i, Ch: a, Cl: u, Dh: l, Dl: d, Eh: f, El: h, Fh: g, Fl: b, Gh: w, Gl: E, Hh: _, Hl: O } = this;
    for (let C = 0; C < 80; C++) {
      const I = Sr.rotrSH(f, h, 14) ^ Sr.rotrSH(f, h, 18) ^ Sr.rotrBH(f, h, 41), S = Sr.rotrSL(f, h, 14) ^ Sr.rotrSL(f, h, 18) ^ Sr.rotrBL(f, h, 41), T = f & g ^ ~f & w, A = h & b ^ ~h & E, $ = Sr.add5L(O, S, A, l9e[C], dd[C]), U = Sr.add5H($, _, I, T, c9e[C], fd[C]), M = $ | 0, Y = Sr.rotrSH(r, n, 28) ^ Sr.rotrBH(r, n, 34) ^ Sr.rotrBH(r, n, 39), L = Sr.rotrSL(r, n, 28) ^ Sr.rotrBL(r, n, 34) ^ Sr.rotrBL(r, n, 39), ee = r & o ^ r & a ^ o & a, de = n & i ^ n & u ^ i & u;
      _ = w | 0, O = E | 0, w = g | 0, E = b | 0, g = f | 0, b = h | 0, { h: f, l: h } = Sr.add(l | 0, d | 0, U | 0, M | 0), l = a | 0, d = u | 0, a = o | 0, u = i | 0, o = r | 0, i = n | 0;
      const ne = Sr.add3L(M, L, de);
      r = Sr.add3H(ne, U, Y, ee), n = ne | 0;
    }
    ({ h: r, l: n } = Sr.add(this.Ah | 0, this.Al | 0, r | 0, n | 0)), { h: o, l: i } = Sr.add(this.Bh | 0, this.Bl | 0, o | 0, i | 0), { h: a, l: u } = Sr.add(this.Ch | 0, this.Cl | 0, a | 0, u | 0), { h: l, l: d } = Sr.add(this.Dh | 0, this.Dl | 0, l | 0, d | 0), { h: f, l: h } = Sr.add(this.Eh | 0, this.El | 0, f | 0, h | 0), { h: g, l: b } = Sr.add(this.Fh | 0, this.Fl | 0, g | 0, b | 0), { h: w, l: E } = Sr.add(this.Gh | 0, this.Gl | 0, w | 0, E | 0), { h: _, l: O } = Sr.add(this.Hh | 0, this.Hl | 0, _ | 0, O | 0), this.set(r, n, o, i, a, u, l, d, f, h, g, b, w, E, _, O);
  }
  roundClean() {
    fd.fill(0), dd.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}, f9e = class extends fE {
  constructor() {
    super(), this.Ah = -1942145080, this.Al = 424955298, this.Bh = 1944164710, this.Bl = -1982016298, this.Ch = 502970286, this.Cl = 855612546, this.Dh = 1738396948, this.Dl = 1479516111, this.Eh = 258812777, this.El = 2077511080, this.Fh = 2011393907, this.Fl = 79989058, this.Gh = 1067287976, this.Gl = 1780299464, this.Hh = 286451373, this.Hl = -1848208735, this.outputLen = 28;
  }
}, d9e = class extends fE {
  constructor() {
    super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
  }
}, h9e = class extends fE {
  constructor() {
    super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
  }
};
const p9e = $0(() => new fE());
$0(() => new f9e());
$0(() => new d9e());
$0(() => new h9e());
const g9e = new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]), TW = Uint8Array.from({ length: 16 }, (e, t) => t), m9e = TW.map((e) => (9 * e + 5) % 16);
let uN = [TW], cN = [m9e];
for (let e = 0; e < 4; e++)
  for (let t of [uN, cN])
    t.push(t[e].map((r) => g9e[r]));
const IW = [
  [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
  [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
  [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
  [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
  [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
].map((e) => new Uint8Array(e)), y9e = uN.map((e, t) => e.map((r) => IW[t][r])), b9e = cN.map((e, t) => e.map((r) => IW[t][r])), w9e = new Uint32Array([0, 1518500249, 1859775393, 2400959708, 2840853838]), v9e = new Uint32Array([1352829926, 1548603684, 1836072691, 2053994217, 0]), p8 = (e, t) => e << t | e >>> 32 - t;
function Hz(e, t, r, n) {
  return e === 0 ? t ^ r ^ n : e === 1 ? t & r | ~t & n : e === 2 ? (t | ~r) ^ n : e === 3 ? t & n | r & ~n : t ^ (r | ~n);
}
const g8 = new Uint32Array(16);
class E9e extends sN {
  constructor() {
    super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
  }
  get() {
    const { h0: t, h1: r, h2: n, h3: o, h4: i } = this;
    return [t, r, n, o, i];
  }
  set(t, r, n, o, i) {
    this.h0 = t | 0, this.h1 = r | 0, this.h2 = n | 0, this.h3 = o | 0, this.h4 = i | 0;
  }
  process(t, r) {
    for (let b = 0; b < 16; b++, r += 4)
      g8[b] = t.getUint32(r, !0);
    let n = this.h0 | 0, o = n, i = this.h1 | 0, a = i, u = this.h2 | 0, l = u, d = this.h3 | 0, f = d, h = this.h4 | 0, g = h;
    for (let b = 0; b < 5; b++) {
      const w = 4 - b, E = w9e[b], _ = v9e[b], O = uN[b], C = cN[b], I = y9e[b], S = b9e[b];
      for (let T = 0; T < 16; T++) {
        const A = p8(n + Hz(b, i, u, d) + g8[O[T]] + E, I[T]) + h | 0;
        n = h, h = d, d = p8(u, 10) | 0, u = i, i = A;
      }
      for (let T = 0; T < 16; T++) {
        const A = p8(o + Hz(w, a, l, f) + g8[C[T]] + _, S[T]) + g | 0;
        o = g, g = f, f = p8(l, 10) | 0, l = a, a = A;
      }
    }
    this.set(this.h1 + u + f | 0, this.h2 + d + g | 0, this.h3 + h + o | 0, this.h4 + n + a | 0, this.h0 + i + l | 0);
  }
  roundClean() {
    g8.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
  }
}
const _9e = $0(() => new E9e());
class OW extends xW {
  constructor(t, r) {
    super(), this.finished = !1, this.destroyed = !1, Fp.hash(t);
    const n = aN(r);
    if (this.iHash = t.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const o = this.blockLen, i = new Uint8Array(o);
    i.set(n.length > o ? t.create().update(n).digest() : n);
    for (let a = 0; a < i.length; a++)
      i[a] ^= 54;
    this.iHash.update(i), this.oHash = t.create();
    for (let a = 0; a < i.length; a++)
      i[a] ^= 106;
    this.oHash.update(i), i.fill(0);
  }
  update(t) {
    return Fp.exists(this), this.iHash.update(t), this;
  }
  digestInto(t) {
    Fp.exists(this), Fp.bytes(t, this.outputLen), this.finished = !0, this.iHash.digestInto(t), this.oHash.update(t), this.oHash.digestInto(t), this.destroy();
  }
  digest() {
    const t = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(t), t;
  }
  _cloneInto(t) {
    t || (t = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: r, iHash: n, finished: o, destroyed: i, blockLen: a, outputLen: u } = this;
    return t = t, t.finished = o, t.destroyed = i, t.blockLen = a, t.outputLen = u, t.oHash = r._cloneInto(t.oHash), t.iHash = n._cloneInto(t.iHash), t;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const PW = (e, t, r) => new OW(e, t).update(r).digest();
PW.create = (e, t) => new OW(e, t);
function A9e(e) {
  const t = nr.bytes(e);
  return nr.raw(c5(t));
}
function ag(e) {
  const t = nr.bytes(e);
  return nr.raw(c5(c5(t)));
}
function lN(e) {
  const t = nr.bytes(e);
  return nr.raw(_9e(c5(t)));
}
function x9e(e, t) {
  const r = nr.bytes(e), n = nr.bytes(t);
  return nr.raw(PW(p9e, r, n));
}
function k9e(e) {
  const t = nr.str(e).digest;
  return nr.join([t, t]);
}
function S9e(e = 32) {
  return fN(_W(e));
}
function fN(e) {
  return fa.mod(e).buff;
}
function CW(e, t = !1) {
  const r = fa.mod(e).point;
  return t ? r.x : r.buff;
}
function BW(e, t) {
  const r = N0.from_x(t), n = fa.mod(e);
  return r.mul(n).buff;
}
function T9e(e, t, r = "ecdh/code") {
  const n = k9e(r), o = fN(e), i = CW(o), a = nr.bytes(t), u = BW(o, a), l = [i.hex, a.hex];
  return l.sort(), x9e(u, nr.join([n, ...l]));
}
function I9e(e) {
  const t = nr.bytes(e);
  switch (!0) {
    case t.length === 32:
      return !0;
    case (t.length === 33 && t[0] === 2):
      return !0;
    case (t.length === 33 && t[0] === 3):
      return !1;
    default:
      throw new TypeError(`Invalid public key: ${t.hex}`);
  }
}
function O9e(e) {
  const t = nr.bytes(e);
  switch (t.length) {
    case 32:
      return t;
    case 33:
      return t.slice(1, 33);
    default:
      throw new Error(`Invalid key length: ${t.length}`);
  }
}
var P9e = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  genSecretKey: S9e,
  getPublicKey: CW,
  getSecretKey: fN,
  getSharedCode: T9e,
  getSharedKey: BW,
  is_even_pub: I9e,
  xonly_pub: O9e
});
nr.random(32);
const NW = { secp: hf }, rP = { ...P9e, ...E_e };
function dE(e) {
  const t = ke.bytes(e);
  return Uc(t, 33), lN(t);
}
function $W(e) {
  const t = ma.fmt.toBytes(e, !1);
  return lN(t);
}
function UW(e) {
  const t = ma.fmt.toBytes(e, !1);
  return A9e(t);
}
function RW(e, t = "main") {
  const r = t === "main" ? ["1"] : ["m", "n"];
  for (const n of r)
    if (e.startsWith(n))
      return !0;
  return !1;
}
function zW(e, t = "main") {
  const r = ke.bytes(e), n = t === "main" ? ke.num(0) : ke.num(111);
  return Uc(e, 20), r.prepend(n).tob58chk();
}
function C9e(e, t = "main") {
  if (!RW(e, t))
    throw new TypeError("Invalid p2pkh address!");
  return ke.b58chk(e).slice(1);
}
function B9e(e) {
  const t = ke.bytes(e);
  return Uc(t, 20), ["OP_DUP", "OP_HASH160", t.hex, "OP_EQUALVERIFY", "OP_CHECKSIG"];
}
function N9e(e, t) {
  const r = dE(e);
  return zW(r, t);
}
const jW = { check: RW, encode: zW, decode: C9e, hash: dE, scriptPubKey: B9e, fromPubKey: N9e };
function LW(e, t = "main") {
  const r = t === "main" ? ["3"] : ["2"];
  for (const n of r)
    if (e.startsWith(n))
      return !0;
  return !1;
}
function HW(e, t = "main") {
  const r = t === "main" ? ke.num(5) : ke.num(196), n = ke.bytes(e);
  return Uc(n, 20), n.prepend(r).tob58chk();
}
function $9e(e, t = "main") {
  if (!LW(e, t))
    throw new TypeError(`Invalid p2sh address for network ${t}:` + e);
  return ke.b58chk(e).slice(1);
}
function U9e(e) {
  return ["OP_HASH160", ke.bytes(e).hex, "OP_EQUAL"];
}
function R9e(e, t) {
  const r = $W(e);
  return HW(r, t);
}
const FW = { check: LW, encode: HW, decode: $9e, hash: $W, scriptPubKey: U9e, fromScript: R9e }, dN = {
  main: "bc",
  testnet: "tb",
  signet: "tb",
  regtest: "bcrt"
}, z9e = ["bc1q", "tb1q", "bcrt1q"];
function MW(e) {
  for (const t of z9e)
    if (e.startsWith(t))
      return !0;
  return !1;
}
function DW(e, t = "main") {
  const r = dN[t], n = ke.bytes(e);
  return Uc(n, 20), n.toBech32(r, 0);
}
function j9e(e) {
  if (!MW(e))
    throw new TypeError("Invalid segwit address!");
  return ke.bech32(e);
}
function L9e(e) {
  const t = ke.bytes(e);
  return Uc(t, 20), ["OP_0", t.hex];
}
function H9e(e, t) {
  const r = dE(e);
  return DW(r, t);
}
const KW = { check: MW, encode: DW, decode: j9e, hash: dE, scriptPubKey: L9e, fromPubKey: H9e }, F9e = ["bc1q", "tb1q", "bcrt1q"];
function qW(e) {
  for (const t of F9e)
    if (e.startsWith(t))
      return !0;
  return !1;
}
function VW(e, t = "main") {
  const r = dN[t], n = ke.bytes(e);
  return Uc(n, 32), n.toBech32(r, 0);
}
function M9e(e) {
  if (!qW(e))
    throw new TypeError("Invalid segwit address!");
  return ke.bech32(e);
}
function D9e(e) {
  const t = ke.bytes(e);
  return Uc(t, 32), ["OP_0", t.hex];
}
function K9e(e, t) {
  const r = UW(e);
  return VW(r, t);
}
const GW = { check: qW, encode: VW, decode: M9e, hash: UW, scriptPubKey: D9e, fromScript: K9e };
function f0(e) {
  const t = ke.bytes(e);
  return t.length > 32 ? t.slice(1, 33) : t;
}
const q9e = ["bc1p", "tb1p", "bcrt1p"];
function WW(e) {
  for (const t of q9e)
    if (e.startsWith(t))
      return !0;
  return !1;
}
function ZW(e, t = "main") {
  const r = dN[t], n = ke.bytes(e);
  return Uc(n, 32), n.toBech32(r, 1);
}
function V9e(e) {
  if (!WW(e))
    throw new TypeError("Invalid taproot address!");
  return ke.bech32(e);
}
function G9e(e) {
  const t = ke.bytes(e);
  return Uc(t, 32), ["OP_1", t.hex];
}
function W9e(e, t) {
  const r = f0(e);
  return ZW(r, t);
}
const XW = { check: WW, encode: ZW, decode: V9e, scriptPubKey: G9e, fromPubKey: W9e }, Z9e = {
  version: 2,
  vin: [],
  vout: [],
  locktime: 0
}, X9e = {
  scriptSig: [],
  sequence: 4294967293,
  witness: []
}, Y9e = {
  value: 0n,
  scriptPubKey: []
};
function hN(e) {
  const t = { ...Z9e, ...e };
  return t.vin = t.vin.map((r) => ({ ...X9e, ...r })), t.vout = t.vout.map((r) => ({ ...Y9e, ...r })), t;
}
function sg(e, t) {
  const { version: r, vin: n, vout: o, locktime: i } = hN(e), a = t !== !0 && J9e(n), u = [pN(r)];
  a && u.push(ke.hex("0001")), u.push(Q9e(n)), u.push(eAe(o));
  for (const l of n)
    a && u.push(rAe(l.witness));
  return u.push(gN(i)), ke.join(u);
}
function J9e(e) {
  for (const t of e) {
    const { witness: r } = t;
    if (typeof r == "string" || r instanceof Uint8Array || Array.isArray(r) && r.length > 0)
      return !0;
  }
  return !1;
}
function pN(e) {
  return ke.num(e, 4).reverse();
}
function nv(e) {
  return ke.hex(e, 32).reverse();
}
function ov(e) {
  return ke.num(e, 4).reverse();
}
function iv(e) {
  if (typeof e == "string")
    return ke.hex(e, 4).reverse();
  if (typeof e == "number")
    return ke.num(e, 4).reverse();
  throw new Error("Unrecognized format: " + String(e));
}
function Q9e(e) {
  const t = [ke.varInt(e.length, "le")];
  for (const r of e) {
    const { txid: n, vout: o, scriptSig: i, sequence: a } = r;
    t.push(nv(n)), t.push(ov(o)), t.push(B0(i, !0)), t.push(iv(a));
  }
  return ke.join(t);
}
function qd(e) {
  if (typeof e == "number") {
    if (e % 1 !== 0)
      throw new Error("Value must be an integer:" + String(e));
    return ke.num(e, 8).reverse();
  }
  return ke.big(e, 8).reverse();
}
function eAe(e) {
  const t = [ke.varInt(e.length, "le")];
  for (const r of e)
    t.push(tAe(r));
  return ke.join(t);
}
function tAe(e) {
  const { value: t, scriptPubKey: r } = e, n = [];
  return n.push(qd(t)), n.push(B0(r, !0)), ke.join(n);
}
function rAe(e = []) {
  const t = [];
  if (Array.isArray(e)) {
    const r = ke.varInt(e.length);
    t.push(r);
    for (const n of e)
      t.push(nAe(n));
    return ke.join(t);
  } else
    return ke.bytes(e);
}
function nAe(e) {
  return oAe(e) ? new ke(0) : B0(e, !0);
}
function oAe(e) {
  if (Array.isArray(e))
    return e.length === 0;
  if (typeof e == "string" && e === "")
    return !0;
  const t = ke.bytes(e);
  return t.length === 1 && t[0] === 0;
}
function gN(e) {
  if (typeof e == "string")
    return ke.hex(e, 4);
  if (typeof e == "number")
    return ke.num(e, 4).reverse();
  throw new Error("Unrecognized format: " + String(e));
}
function mN(e) {
  typeof e == "string" && (e = ke.hex(e).raw);
  const t = new Rg(e), r = iAe(t), n = aAe(t), o = sAe(t), i = cAe(t);
  if (n)
    for (const u of o)
      u.witness = fAe(t);
  const a = dAe(t);
  return { version: r, vin: o, vout: i, locktime: a };
}
function iAe(e) {
  return e.read(4).reverse().toNum();
}
function aAe(e) {
  const [t, r] = [...e.peek(2)];
  if (t === 0) {
    if (e.read(2), r === 1)
      return !0;
    throw new Error(`Invalid witness flag: ${r}`);
  }
  return !1;
}
function sAe(e) {
  const t = [], r = e.readSize("le");
  for (let n = 0; n < r; n++)
    t.push(uAe(e));
  return t;
}
function uAe(e) {
  return {
    txid: e.read(32).reverse().toHex(),
    vout: e.read(4).reverse().toNum(),
    scriptSig: JW(e),
    sequence: e.read(4).reverse().toHex(),
    witness: []
  };
}
function cAe(e) {
  const t = [], r = e.readSize("le");
  for (let n = 0; n < r; n++)
    t.push(lAe(e));
  return t;
}
function lAe(e) {
  return {
    value: e.read(8).reverse().big,
    scriptPubKey: JW(e)
  };
}
function fAe(e) {
  const t = [], r = e.readSize();
  for (let n = 0; n < r; n++) {
    const o = YW(e);
    t.push(o ?? "");
  }
  return t;
}
function YW(e, t) {
  const r = e.readSize("le");
  return r > 0 ? e.read(r).hex : null;
}
function JW(e, t) {
  const r = YW(e);
  return r !== null ? r : [];
}
function dAe(e) {
  return e.read(4).reverse().toNum();
}
function hAe(e) {
  if (zG(e))
    return mN(e);
  if (typeof e == "object" && !(e instanceof Uint8Array))
    return sg(e), hN(e);
  throw new Error("Invalid format: " + typeof e);
}
function pAe(e) {
  if (zG(e))
    return mN(e), ke.bytes(e);
  if (typeof e == "object")
    return sg(e);
  throw new Error("Invalid format: " + typeof e);
}
const yN = {
  toBytes: pAe,
  toJson: hAe
}, gAe = [
  ["p2pkh", /^76a914(?<hash>\w{40})88ac$/],
  ["p2sh", /^a914(?<hash>\w{40})87$/],
  ["p2w-pkh", /^0014(?<hash>\w{40})$/],
  ["p2w-sh", /^0020(?<hash>\w{64})$/],
  ["p2tr", /^5120(?<hash>\w{64})$/]
], mAe = [
  192,
  194,
  196,
  198,
  200,
  202,
  204,
  206,
  208,
  210,
  212,
  214,
  216,
  218,
  220,
  222,
  224,
  226,
  228,
  230,
  232,
  234,
  236,
  238,
  240,
  242,
  244,
  246,
  248,
  250,
  252,
  254,
  102,
  126,
  128,
  132,
  150,
  152,
  186,
  188,
  190
];
function yAe(e) {
  let t = e.at(-1);
  return Ef(t) && (t = ke.hex(t)), e.length > 1 && t instanceof Uint8Array && t[0] === 80 ? (e.pop(), ke.raw(t)) : null;
}
function bAe(e) {
  let t = e.at(-1);
  return Ef(t) && (t = ke.hex(t)), e.length > 1 && t instanceof Uint8Array && t.length > 32 && mAe.includes(t[0] & 254) ? (e.pop(), ke.raw(t)) : null;
}
function wAe(e) {
  if (e.length > 1) {
    const t = e.at(-1);
    try {
      const r = ma.fmt.toBytes(t);
      return e.pop(), r;
    } catch {
      return null;
    }
  }
  return null;
}
function vAe(e) {
  const t = [];
  for (const r of e)
    if (Ef(r) || r instanceof Uint8Array || typeof r == "number")
      t.push(ke.bytes(r));
    else
      throw new Error("unrecognized value: " + String(r));
  return t;
}
function EAe(e = []) {
  const t = [...e], r = yAe(t), n = bAe(t), o = wAe(t), i = vAe(t);
  return { annex: r, cblock: n, script: o, params: i };
}
function _Ae(e) {
  const t = ma.fmt.toBytes(e, !1).hex;
  for (const [r, n] of gAe) {
    const o = r, { groups: i } = n.exec(t) ?? {}, { hash: a } = i ?? {};
    if (Ef(a))
      return { type: o, data: ke.hex(a) };
  }
  return { type: "raw", data: ke.hex(t) };
}
function AAe(e) {
  const t = yN.toJson(e), r = sg(t, !0);
  return ag(r).reverse().hex;
}
function xAe(e) {
  const t = yN.toJson(e), r = sg(t, !0).length, n = sg(t, !1).length, o = r * 3 + n, i = o % 4 > 0 ? 1 : 0, a = Math.floor(o / 4) + i;
  return { size: n, bsize: r, vsize: a, weight: o };
}
const zu = {
  create: hN,
  encode: sg,
  decode: mN,
  fmt: yN,
  util: {
    getTxSize: xAe,
    getTxid: AAe,
    readScriptPubKey: _Ae,
    readWitness: EAe
  }
}, kAe = [
  ["1", "p2pkh", "main", 20, "base58"],
  ["3", "p2sh", "main", 20, "base58"],
  ["m", "p2pkh", "testnet", 20, "base58"],
  ["n", "p2pkh", "testnet", 20, "base58"],
  ["2", "p2sh", "testnet", 20, "base58"],
  ["bc1q", "p2w-pkh", "main", 20, "bech32"],
  ["tb1q", "p2w-pkh", "testnet", 20, "bech32"],
  ["bcrt1q", "p2w-pkh", "regtest", 20, "bech32"],
  ["bc1q", "p2w-sh", "main", 32, "bech32"],
  ["tb1q", "p2w-sh", "testnet", 32, "bech32"],
  ["bcrt1q", "p2w-sh", "regtest", 32, "bech32"],
  ["bc1p", "p2tr", "main", 32, "bech32m"],
  ["tb1p", "p2tr", "testnet", 32, "bech32m"],
  ["bcrt1p", "p2tr", "regtest", 32, "bech32m"]
];
function SAe(e, t) {
  switch (t) {
    case "base58":
      return ke.b58chk(e).slice(1);
    case "bech32":
      return ke.bech32(e);
    case "bech32m":
      return ke.bech32(e);
    default:
      throw new Error("Invalid address format: " + t);
  }
}
function TAe(e) {
  for (const t of kAe) {
    const [r, n, o, i, a] = t;
    if (e.startsWith(r) && SAe(e, a).length === i)
      return t;
  }
  throw new Error("Invalid address: " + e);
}
function QW(e) {
  switch (e) {
    case "p2pkh":
      return jW;
    case "p2sh":
      return FW;
    case "p2w-pkh":
      return KW;
    case "p2w-sh":
      return GW;
    case "p2tr":
      return XW;
    default:
      throw new Error("Invalid address type: " + e);
  }
}
function eZ(e) {
  const [t, r, n] = TAe(e), o = QW(r), i = o.decode(e, n), a = o.scriptPubKey(i);
  return { prefix: t, type: r, network: n, data: i, script: a };
}
function IAe(e, t) {
  const { type: r, data: n } = zu.util.readScriptPubKey(e);
  return QW(r).encode(n, t);
}
function OAe(e) {
  const { script: t } = eZ(e);
  return ma.fmt.toAsm(t, !1);
}
const tZ = {
  p2pkh: jW,
  p2sh: FW,
  p2wpkh: KW,
  p2wsh: GW,
  p2tr: XW,
  decode: eZ,
  fromScriptPubKey: IAe,
  toScriptPubKey: OAe
}, PAe = [1, 2, 3];
function bN(e, t, r = {}) {
  const { sigflag: n = 1 } = r, o = (n & 128) === 128, i = n % 128;
  if (!PAe.includes(i))
    throw new Error("Invalid hash type: " + String(n));
  const a = zu.fmt.toJson(e), { version: u, vin: l, vout: d, locktime: f } = a, { txid: h, vout: g, prevout: b, sequence: w } = l[t], { value: E } = b ?? {};
  if (E === void 0)
    throw new Error("Prevout value is empty!");
  let _ = r.script;
  if (_ === void 0 && r.pubkey !== void 0 && (_ = `76a914${lN(r.pubkey).hex}88ac`), _ === void 0)
    throw new Error("No pubkey / script has been set!");
  if (ma.fmt.toAsm(_).includes("OP_CODESEPARATOR"))
    throw new Error("This library does not currently support the use of OP_CODESEPARATOR in segwit scripts.");
  const O = [
    pN(u),
    CAe(l, o),
    BAe(l, i, o),
    nv(h),
    ov(g),
    ma.encode(_, !0),
    qd(E),
    iv(w),
    NAe(d, t, i),
    gN(f),
    ke.num(n, 4).reverse()
  ];
  return ag(ke.join(O));
}
function CAe(e, t) {
  if (t === !0)
    return ke.num(0, 32);
  const r = [];
  for (const { txid: n, vout: o } of e)
    r.push(nv(n)), r.push(ov(o));
  return ag(ke.join(r));
}
function BAe(e, t, r) {
  if (r || t !== 1)
    return ke.num(0, 32);
  const n = [];
  for (const { sequence: o } of e)
    n.push(iv(o));
  return ag(ke.join(n));
}
function NAe(e, t, r) {
  const n = [];
  if (r === 1) {
    for (const { value: o, scriptPubKey: i } of e)
      n.push(qd(o)), n.push(ma.encode(i, !0));
    return ag(ke.join(n));
  }
  if (r === 3 && t < e.length) {
    const { value: o, scriptPubKey: i } = e[t];
    return n.push(qd(o)), n.push(ma.encode(i, !0)), ag(ke.join(n));
  }
  return ke.num(0, 32);
}
function $Ae(e, t, r, n = {}) {
  const { sigflag: o = 1 } = n, i = bN(t, r, n), a = NW.secp.sign(i, e).toDERRawBytes(!0);
  return ke.join([a, o]);
}
function UAe(e, t, r = {}) {
  const n = zu.fmt.toJson(e), { throws: o = !1 } = r, { witness: i = [] } = n.vin[t], a = zu.util.readWitness(i), { script: u, params: l } = a;
  let d = null;
  if (l.length < 1)
    return zi("Invalid witness data: " + String(i), o);
  if (r.script === void 0 && u !== null && (r.script = u), r.pubkey !== void 0)
    d = ke.bytes(r.pubkey);
  else if (l.length > 1 && l[1].length === 33)
    d = ke.bytes(l[1]);
  else
    return zi("No pubkey provided!", o);
  const f = ma.fmt.toParam(l[0]), h = f.slice(0, -1), g = f.slice(-1)[0], b = bN(n, t, { ...r, sigflag: g });
  return NW.secp.verify(h, b, d) ? !0 : zi("Invalid signature!", o);
}
const RAe = {
  hash: bN,
  sign: $Ae,
  verify: UAe
}, zAe = [0, 1, 2, 3, 129, 130, 131];
function wN(e, t, r = {}) {
  const { extension: n, sigflag: o = 0, extflag: i = 0, key_version: a = 0, separator_pos: u = 4294967295 } = r, l = zu.fmt.toJson(e), { version: d, vin: f, vout: h, locktime: g } = l;
  if (t >= f.length)
    throw new Error("Index out of bounds: " + String(t));
  if (!zAe.includes(o))
    throw new Error("Invalid hash type: " + String(o));
  if (i < 0 || i > 127)
    throw new Error("Extention flag out of range: " + String(i));
  const { txid: b, vout: w, sequence: E, witness: _ = [] } = f[t], O = (o & 128) === 128, C = KAe(_), I = C !== void 0 ? 1 : 0, S = (i + (n !== void 0 ? 1 : 0)) * 2 + I, T = ke.str("TapSighash").digest, A = [
    T,
    T,
    ke.num(0, 1),
    ke.num(o, 1),
    pN(d),
    gN(g)
  ];
  if (!O) {
    const $ = f.map((U) => Fz(U));
    A.push(jAe(f), HAe($), FAe($), LAe(f));
  }
  if (((o & 3) < 2 || (o & 3) > 3) && A.push(MAe(h)), A.push(ke.num(S, 1)), O) {
    const { value: $, scriptPubKey: U } = Fz(f[t]);
    A.push(nv(b), ov(w), qd($), ma.encode(U, !0), iv(E));
  } else
    A.push(ke.num(t, 4).reverse());
  return C !== void 0 && A.push(C), (o & 3) === 3 && A.push(DAe(h[t])), n !== void 0 && A.push(ke.bytes(n), ke.num(a), ke.num(u, 4, "le")), ke.join(A).digest;
}
function jAe(e) {
  const t = [];
  for (const { txid: r, vout: n } of e)
    t.push(nv(r)), t.push(ov(n));
  return ke.join(t).digest;
}
function LAe(e) {
  const t = [];
  for (const { sequence: r } of e)
    t.push(iv(r));
  return ke.join(t).digest;
}
function HAe(e) {
  const t = [];
  for (const { value: r } of e)
    t.push(qd(r));
  return ke.join(t).digest;
}
function FAe(e) {
  const t = [];
  for (const { scriptPubKey: r } of e)
    t.push(B0(r, !0));
  return ke.join(t).digest;
}
function MAe(e) {
  const t = [];
  for (const { value: r, scriptPubKey: n } of e)
    t.push(qd(r)), t.push(ma.encode(n, !0));
  return ke.join(t).digest;
}
function DAe(e) {
  return ke.join([
    qd(e.value),
    ma.encode(e.scriptPubKey, !0)
  ]).digest;
}
function KAe(e) {
  if (e === void 0 || e.length < 2)
    return;
  let t = e.at(-1);
  if (typeof t == "string" && (t = ke.hex(t)), t instanceof Uint8Array && t[0] === 80)
    return ke.raw(t).prefixSize("be").digest;
}
function Fz(e) {
  if (e.prevout === void 0)
    throw new Error("Prevout data missing for input: " + String(e.txid));
  return e.prevout;
}
const qAe = 0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2fn, VAe = 0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141n;
function GAe(e, t, r, n = {}) {
  const { sigflag: o = 0 } = n, i = wN(t, r, n), a = WAe(e, i);
  return o === 0 ? ke.raw(a) : ke.join([a, o]);
}
function WAe(e, t, r = ke.random(32)) {
  const n = ke.bytes(t), o = new fa(e), i = o.point, a = i.hasEvenY ? o.big : o.negated.big, u = K8("BIP0340/aux", ke.bytes(r)), l = a ^ u.big, d = K8("BIP0340/nonce", l, i.x.raw, n), f = new fa(d), h = f.point, g = h.hasEvenY ? f.big : f.negated.big, b = new fa(K8("BIP0340/challenge", h.x.raw, i.x.raw, n)), w = new fa(g + b.big * a);
  return ke.join([h.x.raw, w.raw]);
}
function ZAe(e, t, r, n = !1) {
  const o = N0.from_x(f0(r)), i = ke.bytes(t), a = ke.bytes(e).stream;
  a.size < 64 && zi("Signature length is too small: " + String(a.size), n);
  const u = a.read(32);
  u.big > qAe && zi("Signature r value greater than field size!", n);
  const l = a.read(32);
  l.big > VAe && zi("Signature s value greater than curve order!", n);
  const d = new fa(K8("BIP0340/challenge", u.raw, o.x.raw, i)), f = new fa(l).point, h = o.mul(d.big), g = f.sub(h);
  return g.hasOddY && zi("Signature R value has odd Y coordinate!", n), g.x.big === 0n && zi("Signature R value is infinite!", n), g.x.big === u.big;
}
const XAe = 192;
function hE(e) {
  const t = ke.str(e).digest;
  return ke.join([t, t]);
}
function vN(e, t = XAe) {
  return ke.join([
    hE("TapLeaf"),
    QAe(t),
    ke.bytes(e)
  ]).digest.hex;
}
function YAe(e, t) {
  return vN(ma.fmt.toBytes(e), t);
}
function EN(e, t) {
  return t < e && ([e, t] = [t, e]), ke.join([
    hE("TapBranch"),
    ke.hex(e).raw,
    ke.hex(t).raw
  ]).digest.hex;
}
function JAe(e) {
  return ke.hex(l5(e)[0]);
}
function l5(e, t, r = []) {
  const n = [], o = [];
  if (e.length < 1)
    throw new Error("Tree is empty!");
  for (let i = 0; i < e.length; i++) {
    const a = e[i];
    if (Array.isArray(a)) {
      const [u, l, d] = l5(a, t);
      t = l, n.push(u);
      for (const f of d)
        r.push(f);
    } else
      n.push(a);
  }
  if (n.length === 1)
    return [n[0], t, r];
  n.sort(), n.length % 2 !== 0 && n.push(n[n.length - 1]);
  for (let i = 0; i < n.length - 1; i += 2) {
    const a = EN(n[i], n[i + 1]);
    o.push(a), typeof t == "string" && (t === n[i] ? (r.push(n[i + 1]), t = a) : t === n[i + 1] && (r.push(n[i]), t = a));
  }
  return l5(o, t, r);
}
function QAe(e = 192) {
  return e & 254;
}
function rZ(e, t = new Uint8Array(), r = !1) {
  const n = r ? new fa(e).point.x.raw : f0(e);
  return ke.join([hE("TapTweak"), n, ke.bytes(t)]).digest;
}
function P1(e, t, r = !1) {
  t === void 0 && (t = new Uint8Array());
  const n = ke.bytes(e), o = rZ(e, t, r);
  return r ? nZ(n, o) : oZ(n, o);
}
function exe(e, t) {
  return P1(e, t);
}
function txe(e, t) {
  return P1(e, t, !0);
}
function nZ(e, t) {
  let r = new fa(e);
  return r.point.hasOddY && (r = r.negate()), ke.raw(r.add(t).raw);
}
function oZ(e, t) {
  e = f0(e);
  const r = N0.from_x(e).add(t);
  return ke.raw(r.raw);
}
function rxe() {
  const e = ke.hex("0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8");
  return N0.from_x(e.digest).x;
}
const nxe = rxe(), oxe = 192;
function ixe(e, t = {}) {
  return iZ(e, { ...t, isPrivate: !0 });
}
function axe(e, t = {}) {
  return iZ(e, { ...t, isPrivate: !1 });
}
function iZ(e, t = {}) {
  const { isPrivate: r = !1, tree: n = [], version: o = oxe } = t, i = r ? rP.getPublicKey(e, !0) : f0(e);
  let { target: a } = t;
  a !== void 0 && (a = ke.bytes(a).hex);
  let u, l = [];
  if (n.length > 0) {
    const [g, b, w] = l5(n, a);
    l = w, u = P1(e, g, r);
  } else
    a !== void 0 ? u = P1(e, a, r) : u = P1(e, void 0, r);
  const d = r ? rP.getPublicKey(u)[0] : u[0], f = [ke.num(o + sZ(d)), i];
  l.length > 0 && l.forEach((g) => f.push(ke.hex(g)));
  const h = ke.join(f);
  if (a !== void 0 && !_N(u, a, h, t))
    throw new Error("Path checking failed! Unable to generate path.");
  return [f0(u).hex, h.hex];
}
function _N(e, t, r, n = {}) {
  const { isPrivate: o = !1, throws: i = !1 } = n, { parity: a, paths: u, intkey: l } = aZ(r), d = o ? rP.getPublicKey(e, !0) : f0(e), f = ke.join([a, d]);
  if (f.length !== 33)
    return zi("Invalid tapkey: " + f.hex, i);
  let h = ke.bytes(t).hex;
  for (const b of u)
    h = EN(h, b);
  const g = P1(l, h);
  return ke.raw(g).hex === ke.raw(f).hex;
}
function aZ(e) {
  const t = new Rg(ke.bytes(e)), r = t.read(1).num, n = t.read(32), [o, i] = r % 2 === 0 ? [r, 2] : [r - 1, 3], a = [];
  for (; t.size >= 32; )
    a.push(t.read(32).hex);
  if (t.size !== 0)
    throw new Error("Non-empty buffer on control block: " + String(t));
  return { intkey: n, paths: a, parity: i, version: o };
}
function sZ(e = 2) {
  if (e === 0 || e === 1)
    return e;
  if (e === 2 || e === "02")
    return 0;
  if (e === 3 || e === "03")
    return 1;
  throw new Error("Invalid parity bit: " + String(e));
}
function sxe(e, t, r = {}) {
  const n = zu.fmt.toJson(e), { throws: o = !1 } = r, { prevout: i, witness: a = [] } = n.vin[t], u = zu.util.readWitness(a), { cblock: l, script: d, params: f } = u;
  let h;
  if (f.length < 1)
    return zi("Invalid witness data: " + String(a), o);
  const { scriptPubKey: g } = i ?? {};
  if (g === void 0)
    return zi("Prevout scriptPubKey is empty!", o);
  const { type: b, data: w } = zu.util.readScriptPubKey(g);
  if (b !== "p2tr")
    return zi("Prevout script is not a valid taproot output:" + w.hex, o);
  if (w.length !== 32)
    return zi("Invalid tapkey length: " + String(w.length), o);
  if (l !== null && d !== null) {
    const I = l[0] & 254, S = vN(d, I);
    if (r.extension = S, !_N(w, S, l, { throws: o }))
      return zi("cblock verification failed!", o);
  }
  r.pubkey !== void 0 ? h = ke.bytes(r.pubkey) : f.length > 1 && f[1].length === 32 ? h = ke.bytes(f[1]) : h = ke.bytes(w);
  const E = ma.fmt.toParam(f[0]), _ = new Rg(E), O = _.read(64).raw;
  if (_.size === 1 && (r.sigflag = _.read(1).num, r.sigflag === 0))
    return zi("0x00 is not a valid appended sigflag!", o);
  const C = wN(n, t, r);
  return ZAe(O, C, h, o) ? !0 : zi("Invalid signature!", o);
}
const uxe = {
  hash: wN,
  sign: GAe,
  verify: sxe
}, cxe = {
  segwit: RAe,
  taproot: uxe
}, lxe = {
  getTag: hE,
  getLeaf: vN,
  getBranch: EN,
  getRoot: JAe
}, fxe = {
  readCtrlBlock: aZ,
  readParityBit: sZ
}, dxe = {
  getPubKey: exe,
  getSecKey: txe,
  getTweak: rZ,
  tweakSecKey: nZ,
  tweakPubKey: oZ
}, f5 = {
  getPubKey: axe,
  getSecKey: ixe,
  encodeScript: YAe,
  checkPath: _N,
  tree: lxe,
  tweak: dxe,
  util: fxe,
  SCRIPT_PUBKEY: nxe
};
var Kr;
(function(e) {
  e.assertEqual = (o) => o;
  function t(o) {
  }
  e.assertIs = t;
  function r(o) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (o) => {
    const i = {};
    for (const a of o)
      i[a] = a;
    return i;
  }, e.getValidEnumValues = (o) => {
    const i = e.objectKeys(o).filter((u) => typeof o[o[u]] != "number"), a = {};
    for (const u of i)
      a[u] = o[u];
    return e.objectValues(a);
  }, e.objectValues = (o) => e.objectKeys(o).map(function(i) {
    return o[i];
  }), e.objectKeys = typeof Object.keys == "function" ? (o) => Object.keys(o) : (o) => {
    const i = [];
    for (const a in o)
      Object.prototype.hasOwnProperty.call(o, a) && i.push(a);
    return i;
  }, e.find = (o, i) => {
    for (const a of o)
      if (i(a))
        return a;
  }, e.isInteger = typeof Number.isInteger == "function" ? (o) => Number.isInteger(o) : (o) => typeof o == "number" && isFinite(o) && Math.floor(o) === o;
  function n(o, i = " | ") {
    return o.map((a) => typeof a == "string" ? `'${a}'` : a).join(i);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (o, i) => typeof i == "bigint" ? i.toString() : i;
})(Kr || (Kr = {}));
var nP;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(nP || (nP = {}));
const pt = Kr.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Cd = (e) => {
  switch (typeof e) {
    case "undefined":
      return pt.undefined;
    case "string":
      return pt.string;
    case "number":
      return isNaN(e) ? pt.nan : pt.number;
    case "boolean":
      return pt.boolean;
    case "function":
      return pt.function;
    case "bigint":
      return pt.bigint;
    case "symbol":
      return pt.symbol;
    case "object":
      return Array.isArray(e) ? pt.array : e === null ? pt.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? pt.promise : typeof Map < "u" && e instanceof Map ? pt.map : typeof Set < "u" && e instanceof Set ? pt.set : typeof Date < "u" && e instanceof Date ? pt.date : pt.object;
    default:
      return pt.unknown;
  }
}, Je = Kr.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), hxe = (e) => JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
class ju extends Error {
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  get errors() {
    return this.issues;
  }
  format(t) {
    const r = t || function(i) {
      return i.message;
    }, n = { _errors: [] }, o = (i) => {
      for (const a of i.issues)
        if (a.code === "invalid_union")
          a.unionErrors.map(o);
        else if (a.code === "invalid_return_type")
          o(a.returnTypeError);
        else if (a.code === "invalid_arguments")
          o(a.argumentsError);
        else if (a.path.length === 0)
          n._errors.push(r(a));
        else {
          let u = n, l = 0;
          for (; l < a.path.length; ) {
            const d = a.path[l];
            l === a.path.length - 1 ? (u[d] = u[d] || { _errors: [] }, u[d]._errors.push(r(a))) : u[d] = u[d] || { _errors: [] }, u = u[d], l++;
          }
        }
    };
    return o(this), n;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Kr.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, n = [];
    for (const o of this.issues)
      o.path.length > 0 ? (r[o.path[0]] = r[o.path[0]] || [], r[o.path[0]].push(t(o))) : n.push(t(o));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
ju.create = (e) => new ju(e);
const Ww = (e, t) => {
  let r;
  switch (e.code) {
    case Je.invalid_type:
      e.received === pt.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case Je.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, Kr.jsonStringifyReplacer)}`;
      break;
    case Je.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${Kr.joinValues(e.keys, ", ")}`;
      break;
    case Je.invalid_union:
      r = "Invalid input";
      break;
    case Je.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${Kr.joinValues(e.options)}`;
      break;
    case Je.invalid_enum_value:
      r = `Invalid enum value. Expected ${Kr.joinValues(e.options)}, received '${e.received}'`;
      break;
    case Je.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case Je.invalid_return_type:
      r = "Invalid function return type";
      break;
    case Je.invalid_date:
      r = "Invalid date";
      break;
    case Je.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : Kr.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case Je.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case Je.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case Je.custom:
      r = "Invalid input";
      break;
    case Je.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case Je.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case Je.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, Kr.assertNever(e);
  }
  return { message: r };
};
let uZ = Ww;
function pxe(e) {
  uZ = e;
}
function d5() {
  return uZ;
}
const h5 = (e) => {
  const { data: t, path: r, errorMaps: n, issueData: o } = e, i = [...r, ...o.path || []], a = {
    ...o,
    path: i
  };
  let u = "";
  const l = n.filter((d) => !!d).slice().reverse();
  for (const d of l)
    u = d(a, { data: t, defaultError: u }).message;
  return {
    ...o,
    path: i,
    message: o.message || u
  };
}, gxe = [];
function wt(e, t) {
  const r = h5({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      e.schemaErrorMap,
      d5(),
      Ww
      // then global default map
    ].filter((n) => !!n)
  });
  e.common.issues.push(r);
}
class Di {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const n = [];
    for (const o of r) {
      if (o.status === "aborted")
        return fr;
      o.status === "dirty" && t.dirty(), n.push(o.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, r) {
    const n = [];
    for (const o of r)
      n.push({
        key: await o.key,
        value: await o.value
      });
    return Di.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, r) {
    const n = {};
    for (const o of r) {
      const { key: i, value: a } = o;
      if (i.status === "aborted" || a.status === "aborted")
        return fr;
      i.status === "dirty" && t.dirty(), a.status === "dirty" && t.dirty(), (typeof a.value < "u" || o.alwaysSet) && (n[i.value] = a.value);
    }
    return { status: t.value, value: n };
  }
}
const fr = Object.freeze({
  status: "aborted"
}), cZ = (e) => ({ status: "dirty", value: e }), ya = (e) => ({ status: "valid", value: e }), oP = (e) => e.status === "aborted", iP = (e) => e.status === "dirty", p5 = (e) => e.status === "valid", g5 = (e) => typeof Promise < "u" && e instanceof Promise;
var Lt;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(Lt || (Lt = {}));
class Ic {
  constructor(t, r, n, o) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = n, this._key = o;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Mz = (e, t) => {
  if (p5(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new ju(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function wr(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: n, description: o } = e;
  if (t && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: o } : { errorMap: (i, a) => i.code !== "invalid_type" ? { message: a.defaultError } : typeof a.data > "u" ? { message: n ?? a.defaultError } : { message: r ?? a.defaultError }, description: o };
}
class Nr {
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return Cd(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: Cd(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new Di(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: Cd(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (g5(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const n = this.safeParse(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, r) {
    var n;
    const o = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Cd(t)
    }, i = this._parseSync({ data: t, path: o.path, parent: o });
    return Mz(o, i);
  }
  async parseAsync(t, r) {
    const n = await this.safeParseAsync(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Cd(t)
    }, o = this._parse({ data: t, path: n.path, parent: n }), i = await (g5(o) ? o : Promise.resolve(o));
    return Mz(n, i);
  }
  refine(t, r) {
    const n = (o) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(o) : r;
    return this._refinement((o, i) => {
      const a = t(o), u = () => i.addIssue({
        code: Je.custom,
        ...n(o)
      });
      return typeof Promise < "u" && a instanceof Promise ? a.then((l) => l ? !0 : (u(), !1)) : a ? !0 : (u(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((n, o) => t(n) ? !0 : (o.addIssue(typeof r == "function" ? r(n, o) : r), !1));
  }
  _refinement(t) {
    return new Du({
      schema: this,
      typeName: Vt.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  optional() {
    return rf.create(this, this._def);
  }
  nullable() {
    return p0.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Lu.create(this, this._def);
  }
  promise() {
    return cg.create(this, this._def);
  }
  or(t) {
    return Jw.create([this, t], this._def);
  }
  and(t) {
    return Qw.create(this, t, this._def);
  }
  transform(t) {
    return new Du({
      ...wr(this._def),
      schema: this,
      typeName: Vt.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new o2({
      ...wr(this._def),
      innerType: this,
      defaultValue: r,
      typeName: Vt.ZodDefault
    });
  }
  brand() {
    return new fZ({
      typeName: Vt.ZodBranded,
      type: this,
      ...wr(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new w5({
      ...wr(this._def),
      innerType: this,
      catchValue: r,
      typeName: Vt.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return av.create(this, t);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const mxe = /^c[^\s-]{8,}$/i, yxe = /^[a-z][a-z0-9]*$/, bxe = /[0-9A-HJKMNP-TV-Z]{26}/, wxe = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i, vxe = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/, Exe = new RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u"), _xe = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, Axe = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, xxe = (e) => e.precision ? e.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${e.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${e.precision}}Z$`) : e.precision === 0 ? e.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : e.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function kxe(e, t) {
  return !!((t === "v4" || !t) && _xe.test(e) || (t === "v6" || !t) && Axe.test(e));
}
class Iu extends Nr {
  constructor() {
    super(...arguments), this._regex = (t, r, n) => this.refinement((o) => t.test(o), {
      validation: r,
      code: Je.invalid_string,
      ...Lt.errToObj(n)
    }), this.nonempty = (t) => this.min(1, Lt.errToObj(t)), this.trim = () => new Iu({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    }), this.toLowerCase = () => new Iu({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    }), this.toUpperCase = () => new Iu({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== pt.string) {
      const o = this._getOrReturnCtx(t);
      return wt(
        o,
        {
          code: Je.invalid_type,
          expected: pt.string,
          received: o.parsedType
        }
        //
      ), fr;
    }
    const r = new Di();
    let n;
    for (const o of this._def.checks)
      if (o.kind === "min")
        t.data.length < o.value && (n = this._getOrReturnCtx(t, n), wt(n, {
          code: Je.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), r.dirty());
      else if (o.kind === "max")
        t.data.length > o.value && (n = this._getOrReturnCtx(t, n), wt(n, {
          code: Je.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), r.dirty());
      else if (o.kind === "length") {
        const i = t.data.length > o.value, a = t.data.length < o.value;
        (i || a) && (n = this._getOrReturnCtx(t, n), i ? wt(n, {
          code: Je.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }) : a && wt(n, {
          code: Je.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }), r.dirty());
      } else if (o.kind === "email")
        vxe.test(t.data) || (n = this._getOrReturnCtx(t, n), wt(n, {
          validation: "email",
          code: Je.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "emoji")
        Exe.test(t.data) || (n = this._getOrReturnCtx(t, n), wt(n, {
          validation: "emoji",
          code: Je.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "uuid")
        wxe.test(t.data) || (n = this._getOrReturnCtx(t, n), wt(n, {
          validation: "uuid",
          code: Je.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "cuid")
        mxe.test(t.data) || (n = this._getOrReturnCtx(t, n), wt(n, {
          validation: "cuid",
          code: Je.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "cuid2")
        yxe.test(t.data) || (n = this._getOrReturnCtx(t, n), wt(n, {
          validation: "cuid2",
          code: Je.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "ulid")
        bxe.test(t.data) || (n = this._getOrReturnCtx(t, n), wt(n, {
          validation: "ulid",
          code: Je.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "url")
        try {
          new URL(t.data);
        } catch {
          n = this._getOrReturnCtx(t, n), wt(n, {
            validation: "url",
            code: Je.invalid_string,
            message: o.message
          }), r.dirty();
        }
      else o.kind === "regex" ? (o.regex.lastIndex = 0, o.regex.test(t.data) || (n = this._getOrReturnCtx(t, n), wt(n, {
        validation: "regex",
        code: Je.invalid_string,
        message: o.message
      }), r.dirty())) : o.kind === "trim" ? t.data = t.data.trim() : o.kind === "includes" ? t.data.includes(o.value, o.position) || (n = this._getOrReturnCtx(t, n), wt(n, {
        code: Je.invalid_string,
        validation: { includes: o.value, position: o.position },
        message: o.message
      }), r.dirty()) : o.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : o.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : o.kind === "startsWith" ? t.data.startsWith(o.value) || (n = this._getOrReturnCtx(t, n), wt(n, {
        code: Je.invalid_string,
        validation: { startsWith: o.value },
        message: o.message
      }), r.dirty()) : o.kind === "endsWith" ? t.data.endsWith(o.value) || (n = this._getOrReturnCtx(t, n), wt(n, {
        code: Je.invalid_string,
        validation: { endsWith: o.value },
        message: o.message
      }), r.dirty()) : o.kind === "datetime" ? xxe(o).test(t.data) || (n = this._getOrReturnCtx(t, n), wt(n, {
        code: Je.invalid_string,
        validation: "datetime",
        message: o.message
      }), r.dirty()) : o.kind === "ip" ? kxe(t.data, o.version) || (n = this._getOrReturnCtx(t, n), wt(n, {
        validation: "ip",
        code: Je.invalid_string,
        message: o.message
      }), r.dirty()) : Kr.assertNever(o);
    return { status: r.value, value: t.data };
  }
  _addCheck(t) {
    return new Iu({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...Lt.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...Lt.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...Lt.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...Lt.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...Lt.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...Lt.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...Lt.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...Lt.errToObj(t) });
  }
  datetime(t) {
    var r;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (r = t == null ? void 0 : t.offset) !== null && r !== void 0 ? r : !1,
      ...Lt.errToObj(t == null ? void 0 : t.message)
    });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...Lt.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r == null ? void 0 : r.position,
      ...Lt.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...Lt.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...Lt.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...Lt.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...Lt.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...Lt.errToObj(r)
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
Iu.create = (e) => {
  var t;
  return new Iu({
    checks: [],
    typeName: Vt.ZodString,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...wr(e)
  });
};
function Sxe(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, o = r > n ? r : n, i = parseInt(e.toFixed(o).replace(".", "")), a = parseInt(t.toFixed(o).replace(".", ""));
  return i % a / Math.pow(10, o);
}
class Vd extends Nr {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== pt.number) {
      const o = this._getOrReturnCtx(t);
      return wt(o, {
        code: Je.invalid_type,
        expected: pt.number,
        received: o.parsedType
      }), fr;
    }
    let r;
    const n = new Di();
    for (const o of this._def.checks)
      o.kind === "int" ? Kr.isInteger(t.data) || (r = this._getOrReturnCtx(t, r), wt(r, {
        code: Je.invalid_type,
        expected: "integer",
        received: "float",
        message: o.message
      }), n.dirty()) : o.kind === "min" ? (o.inclusive ? t.data < o.value : t.data <= o.value) && (r = this._getOrReturnCtx(t, r), wt(r, {
        code: Je.too_small,
        minimum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), n.dirty()) : o.kind === "max" ? (o.inclusive ? t.data > o.value : t.data >= o.value) && (r = this._getOrReturnCtx(t, r), wt(r, {
        code: Je.too_big,
        maximum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), n.dirty()) : o.kind === "multipleOf" ? Sxe(t.data, o.value) !== 0 && (r = this._getOrReturnCtx(t, r), wt(r, {
        code: Je.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), n.dirty()) : o.kind === "finite" ? Number.isFinite(t.data) || (r = this._getOrReturnCtx(t, r), wt(r, {
        code: Je.not_finite,
        message: o.message
      }), n.dirty()) : Kr.assertNever(o);
    return { status: n.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, Lt.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, Lt.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, Lt.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, Lt.toString(r));
  }
  setLimit(t, r, n, o) {
    return new Vd({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: Lt.toString(o)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Vd({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: Lt.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Lt.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Lt.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Lt.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Lt.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Lt.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: Lt.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Lt.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Lt.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && Kr.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
Vd.create = (e) => new Vd({
  checks: [],
  typeName: Vt.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...wr(e)
});
class Gd extends Nr {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = BigInt(t.data)), this._getType(t) !== pt.bigint) {
      const o = this._getOrReturnCtx(t);
      return wt(o, {
        code: Je.invalid_type,
        expected: pt.bigint,
        received: o.parsedType
      }), fr;
    }
    let r;
    const n = new Di();
    for (const o of this._def.checks)
      o.kind === "min" ? (o.inclusive ? t.data < o.value : t.data <= o.value) && (r = this._getOrReturnCtx(t, r), wt(r, {
        code: Je.too_small,
        type: "bigint",
        minimum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), n.dirty()) : o.kind === "max" ? (o.inclusive ? t.data > o.value : t.data >= o.value) && (r = this._getOrReturnCtx(t, r), wt(r, {
        code: Je.too_big,
        type: "bigint",
        maximum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), n.dirty()) : o.kind === "multipleOf" ? t.data % o.value !== BigInt(0) && (r = this._getOrReturnCtx(t, r), wt(r, {
        code: Je.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), n.dirty()) : Kr.assertNever(o);
    return { status: n.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, Lt.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, Lt.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, Lt.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, Lt.toString(r));
  }
  setLimit(t, r, n, o) {
    return new Gd({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: Lt.toString(o)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Gd({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Lt.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Lt.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Lt.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Lt.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Lt.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
Gd.create = (e) => {
  var t;
  return new Gd({
    checks: [],
    typeName: Vt.ZodBigInt,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...wr(e)
  });
};
class Zw extends Nr {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== pt.boolean) {
      const r = this._getOrReturnCtx(t);
      return wt(r, {
        code: Je.invalid_type,
        expected: pt.boolean,
        received: r.parsedType
      }), fr;
    }
    return ya(t.data);
  }
}
Zw.create = (e) => new Zw({
  typeName: Vt.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...wr(e)
});
class d0 extends Nr {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== pt.date) {
      const o = this._getOrReturnCtx(t);
      return wt(o, {
        code: Je.invalid_type,
        expected: pt.date,
        received: o.parsedType
      }), fr;
    }
    if (isNaN(t.data.getTime())) {
      const o = this._getOrReturnCtx(t);
      return wt(o, {
        code: Je.invalid_date
      }), fr;
    }
    const r = new Di();
    let n;
    for (const o of this._def.checks)
      o.kind === "min" ? t.data.getTime() < o.value && (n = this._getOrReturnCtx(t, n), wt(n, {
        code: Je.too_small,
        message: o.message,
        inclusive: !0,
        exact: !1,
        minimum: o.value,
        type: "date"
      }), r.dirty()) : o.kind === "max" ? t.data.getTime() > o.value && (n = this._getOrReturnCtx(t, n), wt(n, {
        code: Je.too_big,
        message: o.message,
        inclusive: !0,
        exact: !1,
        maximum: o.value,
        type: "date"
      }), r.dirty()) : Kr.assertNever(o);
    return {
      status: r.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new d0({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: Lt.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: Lt.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
d0.create = (e) => new d0({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: Vt.ZodDate,
  ...wr(e)
});
class m5 extends Nr {
  _parse(t) {
    if (this._getType(t) !== pt.symbol) {
      const r = this._getOrReturnCtx(t);
      return wt(r, {
        code: Je.invalid_type,
        expected: pt.symbol,
        received: r.parsedType
      }), fr;
    }
    return ya(t.data);
  }
}
m5.create = (e) => new m5({
  typeName: Vt.ZodSymbol,
  ...wr(e)
});
class Xw extends Nr {
  _parse(t) {
    if (this._getType(t) !== pt.undefined) {
      const r = this._getOrReturnCtx(t);
      return wt(r, {
        code: Je.invalid_type,
        expected: pt.undefined,
        received: r.parsedType
      }), fr;
    }
    return ya(t.data);
  }
}
Xw.create = (e) => new Xw({
  typeName: Vt.ZodUndefined,
  ...wr(e)
});
class Yw extends Nr {
  _parse(t) {
    if (this._getType(t) !== pt.null) {
      const r = this._getOrReturnCtx(t);
      return wt(r, {
        code: Je.invalid_type,
        expected: pt.null,
        received: r.parsedType
      }), fr;
    }
    return ya(t.data);
  }
}
Yw.create = (e) => new Yw({
  typeName: Vt.ZodNull,
  ...wr(e)
});
class ug extends Nr {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return ya(t.data);
  }
}
ug.create = (e) => new ug({
  typeName: Vt.ZodAny,
  ...wr(e)
});
class Yp extends Nr {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return ya(t.data);
  }
}
Yp.create = (e) => new Yp({
  typeName: Vt.ZodUnknown,
  ...wr(e)
});
class pf extends Nr {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return wt(r, {
      code: Je.invalid_type,
      expected: pt.never,
      received: r.parsedType
    }), fr;
  }
}
pf.create = (e) => new pf({
  typeName: Vt.ZodNever,
  ...wr(e)
});
class y5 extends Nr {
  _parse(t) {
    if (this._getType(t) !== pt.undefined) {
      const r = this._getOrReturnCtx(t);
      return wt(r, {
        code: Je.invalid_type,
        expected: pt.void,
        received: r.parsedType
      }), fr;
    }
    return ya(t.data);
  }
}
y5.create = (e) => new y5({
  typeName: Vt.ZodVoid,
  ...wr(e)
});
class Lu extends Nr {
  _parse(t) {
    const { ctx: r, status: n } = this._processInputParams(t), o = this._def;
    if (r.parsedType !== pt.array)
      return wt(r, {
        code: Je.invalid_type,
        expected: pt.array,
        received: r.parsedType
      }), fr;
    if (o.exactLength !== null) {
      const a = r.data.length > o.exactLength.value, u = r.data.length < o.exactLength.value;
      (a || u) && (wt(r, {
        code: a ? Je.too_big : Je.too_small,
        minimum: u ? o.exactLength.value : void 0,
        maximum: a ? o.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: o.exactLength.message
      }), n.dirty());
    }
    if (o.minLength !== null && r.data.length < o.minLength.value && (wt(r, {
      code: Je.too_small,
      minimum: o.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: o.minLength.message
    }), n.dirty()), o.maxLength !== null && r.data.length > o.maxLength.value && (wt(r, {
      code: Je.too_big,
      maximum: o.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: o.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((a, u) => o.type._parseAsync(new Ic(r, a, r.path, u)))).then((a) => Di.mergeArray(n, a));
    const i = [...r.data].map((a, u) => o.type._parseSync(new Ic(r, a, r.path, u)));
    return Di.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new Lu({
      ...this._def,
      minLength: { value: t, message: Lt.toString(r) }
    });
  }
  max(t, r) {
    return new Lu({
      ...this._def,
      maxLength: { value: t, message: Lt.toString(r) }
    });
  }
  length(t, r) {
    return new Lu({
      ...this._def,
      exactLength: { value: t, message: Lt.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Lu.create = (e, t) => new Lu({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Vt.ZodArray,
  ...wr(t)
});
function t1(e) {
  if (e instanceof Jn) {
    const t = {};
    for (const r in e.shape) {
      const n = e.shape[r];
      t[r] = rf.create(t1(n));
    }
    return new Jn({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof Lu ? new Lu({
    ...e._def,
    type: t1(e.element)
  }) : e instanceof rf ? rf.create(t1(e.unwrap())) : e instanceof p0 ? p0.create(t1(e.unwrap())) : e instanceof Oc ? Oc.create(e.items.map((t) => t1(t))) : e;
}
class Jn extends Nr {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = Kr.objectKeys(t);
    return this._cached = { shape: t, keys: r };
  }
  _parse(t) {
    if (this._getType(t) !== pt.object) {
      const l = this._getOrReturnCtx(t);
      return wt(l, {
        code: Je.invalid_type,
        expected: pt.object,
        received: l.parsedType
      }), fr;
    }
    const { status: r, ctx: n } = this._processInputParams(t), { shape: o, keys: i } = this._getCached(), a = [];
    if (!(this._def.catchall instanceof pf && this._def.unknownKeys === "strip"))
      for (const l in n.data)
        i.includes(l) || a.push(l);
    const u = [];
    for (const l of i) {
      const d = o[l], f = n.data[l];
      u.push({
        key: { status: "valid", value: l },
        value: d._parse(new Ic(n, f, n.path, l)),
        alwaysSet: l in n.data
      });
    }
    if (this._def.catchall instanceof pf) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const d of a)
          u.push({
            key: { status: "valid", value: d },
            value: { status: "valid", value: n.data[d] }
          });
      else if (l === "strict")
        a.length > 0 && (wt(n, {
          code: Je.unrecognized_keys,
          keys: a
        }), r.dirty());
      else if (l !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const d of a) {
        const f = n.data[d];
        u.push({
          key: { status: "valid", value: d },
          value: l._parse(
            new Ic(n, f, n.path, d)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: d in n.data
        });
      }
    }
    return n.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const d of u) {
        const f = await d.key;
        l.push({
          key: f,
          value: await d.value,
          alwaysSet: d.alwaysSet
        });
      }
      return l;
    }).then((l) => Di.mergeObjectSync(r, l)) : Di.mergeObjectSync(r, u);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return new Jn({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, n) => {
          var o, i, a, u;
          const l = (a = (i = (o = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(o, r, n).message) !== null && a !== void 0 ? a : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (u = Lt.errToObj(t).message) !== null && u !== void 0 ? u : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new Jn({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Jn({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new Jn({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new Jn({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: Vt.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new Jn({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    return Kr.objectKeys(t).forEach((n) => {
      t[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new Jn({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    return Kr.objectKeys(this.shape).forEach((n) => {
      t[n] || (r[n] = this.shape[n]);
    }), new Jn({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return t1(this);
  }
  partial(t) {
    const r = {};
    return Kr.objectKeys(this.shape).forEach((n) => {
      const o = this.shape[n];
      t && !t[n] ? r[n] = o : r[n] = o.optional();
    }), new Jn({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    return Kr.objectKeys(this.shape).forEach((n) => {
      if (t && !t[n])
        r[n] = this.shape[n];
      else {
        let o = this.shape[n];
        for (; o instanceof rf; )
          o = o._def.innerType;
        r[n] = o;
      }
    }), new Jn({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return lZ(Kr.objectKeys(this.shape));
  }
}
Jn.create = (e, t) => new Jn({
  shape: () => e,
  unknownKeys: "strip",
  catchall: pf.create(),
  typeName: Vt.ZodObject,
  ...wr(t)
});
Jn.strictCreate = (e, t) => new Jn({
  shape: () => e,
  unknownKeys: "strict",
  catchall: pf.create(),
  typeName: Vt.ZodObject,
  ...wr(t)
});
Jn.lazycreate = (e, t) => new Jn({
  shape: e,
  unknownKeys: "strip",
  catchall: pf.create(),
  typeName: Vt.ZodObject,
  ...wr(t)
});
class Jw extends Nr {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = this._def.options;
    function o(i) {
      for (const u of i)
        if (u.result.status === "valid")
          return u.result;
      for (const u of i)
        if (u.result.status === "dirty")
          return r.common.issues.push(...u.ctx.common.issues), u.result;
      const a = i.map((u) => new ju(u.ctx.common.issues));
      return wt(r, {
        code: Je.invalid_union,
        unionErrors: a
      }), fr;
    }
    if (r.common.async)
      return Promise.all(n.map(async (i) => {
        const a = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: r.data,
            path: r.path,
            parent: a
          }),
          ctx: a
        };
      })).then(o);
    {
      let i;
      const a = [];
      for (const l of n) {
        const d = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, f = l._parseSync({
          data: r.data,
          path: r.path,
          parent: d
        });
        if (f.status === "valid")
          return f;
        f.status === "dirty" && !i && (i = { result: f, ctx: d }), d.common.issues.length && a.push(d.common.issues);
      }
      if (i)
        return r.common.issues.push(...i.ctx.common.issues), i.result;
      const u = a.map((l) => new ju(l));
      return wt(r, {
        code: Je.invalid_union,
        unionErrors: u
      }), fr;
    }
  }
  get options() {
    return this._def.options;
  }
}
Jw.create = (e, t) => new Jw({
  options: e,
  typeName: Vt.ZodUnion,
  ...wr(t)
});
const q8 = (e) => e instanceof t2 ? q8(e.schema) : e instanceof Du ? q8(e.innerType()) : e instanceof r2 ? [e.value] : e instanceof Wd ? e.options : e instanceof n2 ? Object.keys(e.enum) : e instanceof o2 ? q8(e._def.innerType) : e instanceof Xw ? [void 0] : e instanceof Yw ? [null] : null;
class pE extends Nr {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== pt.object)
      return wt(r, {
        code: Je.invalid_type,
        expected: pt.object,
        received: r.parsedType
      }), fr;
    const n = this.discriminator, o = r.data[n], i = this.optionsMap.get(o);
    return i ? r.common.async ? i._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : i._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (wt(r, {
      code: Je.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), fr);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, r, n) {
    const o = /* @__PURE__ */ new Map();
    for (const i of r) {
      const a = q8(i.shape[t]);
      if (!a)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const u of a) {
        if (o.has(u))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(u)}`);
        o.set(u, i);
      }
    }
    return new pE({
      typeName: Vt.ZodDiscriminatedUnion,
      discriminator: t,
      options: r,
      optionsMap: o,
      ...wr(n)
    });
  }
}
function aP(e, t) {
  const r = Cd(e), n = Cd(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === pt.object && n === pt.object) {
    const o = Kr.objectKeys(t), i = Kr.objectKeys(e).filter((u) => o.indexOf(u) !== -1), a = { ...e, ...t };
    for (const u of i) {
      const l = aP(e[u], t[u]);
      if (!l.valid)
        return { valid: !1 };
      a[u] = l.data;
    }
    return { valid: !0, data: a };
  } else if (r === pt.array && n === pt.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const o = [];
    for (let i = 0; i < e.length; i++) {
      const a = e[i], u = t[i], l = aP(a, u);
      if (!l.valid)
        return { valid: !1 };
      o.push(l.data);
    }
    return { valid: !0, data: o };
  } else return r === pt.date && n === pt.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class Qw extends Nr {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), o = (i, a) => {
      if (oP(i) || oP(a))
        return fr;
      const u = aP(i.value, a.value);
      return u.valid ? ((iP(i) || iP(a)) && r.dirty(), { status: r.value, value: u.data }) : (wt(n, {
        code: Je.invalid_intersection_types
      }), fr);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([i, a]) => o(i, a)) : o(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
Qw.create = (e, t, r) => new Qw({
  left: e,
  right: t,
  typeName: Vt.ZodIntersection,
  ...wr(r)
});
class Oc extends Nr {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== pt.array)
      return wt(n, {
        code: Je.invalid_type,
        expected: pt.array,
        received: n.parsedType
      }), fr;
    if (n.data.length < this._def.items.length)
      return wt(n, {
        code: Je.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), fr;
    !this._def.rest && n.data.length > this._def.items.length && (wt(n, {
      code: Je.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const o = [...n.data].map((i, a) => {
      const u = this._def.items[a] || this._def.rest;
      return u ? u._parse(new Ic(n, i, n.path, a)) : null;
    }).filter((i) => !!i);
    return n.common.async ? Promise.all(o).then((i) => Di.mergeArray(r, i)) : Di.mergeArray(r, o);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new Oc({
      ...this._def,
      rest: t
    });
  }
}
Oc.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Oc({
    items: e,
    typeName: Vt.ZodTuple,
    rest: null,
    ...wr(t)
  });
};
class e2 extends Nr {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== pt.object)
      return wt(n, {
        code: Je.invalid_type,
        expected: pt.object,
        received: n.parsedType
      }), fr;
    const o = [], i = this._def.keyType, a = this._def.valueType;
    for (const u in n.data)
      o.push({
        key: i._parse(new Ic(n, u, n.path, u)),
        value: a._parse(new Ic(n, n.data[u], n.path, u))
      });
    return n.common.async ? Di.mergeObjectAsync(r, o) : Di.mergeObjectSync(r, o);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, r, n) {
    return r instanceof Nr ? new e2({
      keyType: t,
      valueType: r,
      typeName: Vt.ZodRecord,
      ...wr(n)
    }) : new e2({
      keyType: Iu.create(),
      valueType: t,
      typeName: Vt.ZodRecord,
      ...wr(r)
    });
  }
}
class b5 extends Nr {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== pt.map)
      return wt(n, {
        code: Je.invalid_type,
        expected: pt.map,
        received: n.parsedType
      }), fr;
    const o = this._def.keyType, i = this._def.valueType, a = [...n.data.entries()].map(([u, l], d) => ({
      key: o._parse(new Ic(n, u, n.path, [d, "key"])),
      value: i._parse(new Ic(n, l, n.path, [d, "value"]))
    }));
    if (n.common.async) {
      const u = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of a) {
          const d = await l.key, f = await l.value;
          if (d.status === "aborted" || f.status === "aborted")
            return fr;
          (d.status === "dirty" || f.status === "dirty") && r.dirty(), u.set(d.value, f.value);
        }
        return { status: r.value, value: u };
      });
    } else {
      const u = /* @__PURE__ */ new Map();
      for (const l of a) {
        const d = l.key, f = l.value;
        if (d.status === "aborted" || f.status === "aborted")
          return fr;
        (d.status === "dirty" || f.status === "dirty") && r.dirty(), u.set(d.value, f.value);
      }
      return { status: r.value, value: u };
    }
  }
}
b5.create = (e, t, r) => new b5({
  valueType: t,
  keyType: e,
  typeName: Vt.ZodMap,
  ...wr(r)
});
class h0 extends Nr {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== pt.set)
      return wt(n, {
        code: Je.invalid_type,
        expected: pt.set,
        received: n.parsedType
      }), fr;
    const o = this._def;
    o.minSize !== null && n.data.size < o.minSize.value && (wt(n, {
      code: Je.too_small,
      minimum: o.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: o.minSize.message
    }), r.dirty()), o.maxSize !== null && n.data.size > o.maxSize.value && (wt(n, {
      code: Je.too_big,
      maximum: o.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: o.maxSize.message
    }), r.dirty());
    const i = this._def.valueType;
    function a(l) {
      const d = /* @__PURE__ */ new Set();
      for (const f of l) {
        if (f.status === "aborted")
          return fr;
        f.status === "dirty" && r.dirty(), d.add(f.value);
      }
      return { status: r.value, value: d };
    }
    const u = [...n.data.values()].map((l, d) => i._parse(new Ic(n, l, n.path, d)));
    return n.common.async ? Promise.all(u).then((l) => a(l)) : a(u);
  }
  min(t, r) {
    return new h0({
      ...this._def,
      minSize: { value: t, message: Lt.toString(r) }
    });
  }
  max(t, r) {
    return new h0({
      ...this._def,
      maxSize: { value: t, message: Lt.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
h0.create = (e, t) => new h0({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: Vt.ZodSet,
  ...wr(t)
});
class C1 extends Nr {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== pt.function)
      return wt(r, {
        code: Je.invalid_type,
        expected: pt.function,
        received: r.parsedType
      }), fr;
    function n(u, l) {
      return h5({
        data: u,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          d5(),
          Ww
        ].filter((d) => !!d),
        issueData: {
          code: Je.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function o(u, l) {
      return h5({
        data: u,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          d5(),
          Ww
        ].filter((d) => !!d),
        issueData: {
          code: Je.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const i = { errorMap: r.common.contextualErrorMap }, a = r.data;
    return this._def.returns instanceof cg ? ya(async (...u) => {
      const l = new ju([]), d = await this._def.args.parseAsync(u, i).catch((h) => {
        throw l.addIssue(n(u, h)), l;
      }), f = await a(...d);
      return await this._def.returns._def.type.parseAsync(f, i).catch((h) => {
        throw l.addIssue(o(f, h)), l;
      });
    }) : ya((...u) => {
      const l = this._def.args.safeParse(u, i);
      if (!l.success)
        throw new ju([n(u, l.error)]);
      const d = a(...l.data), f = this._def.returns.safeParse(d, i);
      if (!f.success)
        throw new ju([o(d, f.error)]);
      return f.data;
    });
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new C1({
      ...this._def,
      args: Oc.create(t).rest(Yp.create())
    });
  }
  returns(t) {
    return new C1({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, r, n) {
    return new C1({
      args: t || Oc.create([]).rest(Yp.create()),
      returns: r || Yp.create(),
      typeName: Vt.ZodFunction,
      ...wr(n)
    });
  }
}
class t2 extends Nr {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
t2.create = (e, t) => new t2({
  getter: e,
  typeName: Vt.ZodLazy,
  ...wr(t)
});
class r2 extends Nr {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return wt(r, {
        received: r.data,
        code: Je.invalid_literal,
        expected: this._def.value
      }), fr;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
r2.create = (e, t) => new r2({
  value: e,
  typeName: Vt.ZodLiteral,
  ...wr(t)
});
function lZ(e, t) {
  return new Wd({
    values: e,
    typeName: Vt.ZodEnum,
    ...wr(t)
  });
}
class Wd extends Nr {
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return wt(r, {
        expected: Kr.joinValues(n),
        received: r.parsedType,
        code: Je.invalid_type
      }), fr;
    }
    if (this._def.values.indexOf(t.data) === -1) {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return wt(r, {
        received: r.data,
        code: Je.invalid_enum_value,
        options: n
      }), fr;
    }
    return ya(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t) {
    return Wd.create(t);
  }
  exclude(t) {
    return Wd.create(this.options.filter((r) => !t.includes(r)));
  }
}
Wd.create = lZ;
class n2 extends Nr {
  _parse(t) {
    const r = Kr.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== pt.string && n.parsedType !== pt.number) {
      const o = Kr.objectValues(r);
      return wt(n, {
        expected: Kr.joinValues(o),
        received: n.parsedType,
        code: Je.invalid_type
      }), fr;
    }
    if (r.indexOf(t.data) === -1) {
      const o = Kr.objectValues(r);
      return wt(n, {
        received: n.data,
        code: Je.invalid_enum_value,
        options: o
      }), fr;
    }
    return ya(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
n2.create = (e, t) => new n2({
  values: e,
  typeName: Vt.ZodNativeEnum,
  ...wr(t)
});
class cg extends Nr {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== pt.promise && r.common.async === !1)
      return wt(r, {
        code: Je.invalid_type,
        expected: pt.promise,
        received: r.parsedType
      }), fr;
    const n = r.parsedType === pt.promise ? r.data : Promise.resolve(r.data);
    return ya(n.then((o) => this._def.type.parseAsync(o, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
cg.create = (e, t) => new cg({
  type: e,
  typeName: Vt.ZodPromise,
  ...wr(t)
});
class Du extends Nr {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Vt.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), o = this._def.effect || null;
    if (o.type === "preprocess") {
      const a = o.transform(n.data);
      return n.common.async ? Promise.resolve(a).then((u) => this._def.schema._parseAsync({
        data: u,
        path: n.path,
        parent: n
      })) : this._def.schema._parseSync({
        data: a,
        path: n.path,
        parent: n
      });
    }
    const i = {
      addIssue: (a) => {
        wt(n, a), a.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), o.type === "refinement") {
      const a = (u) => {
        const l = o.refinement(u, i);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return u;
      };
      if (n.common.async === !1) {
        const u = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return u.status === "aborted" ? fr : (u.status === "dirty" && r.dirty(), a(u.value), { status: r.value, value: u.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((u) => u.status === "aborted" ? fr : (u.status === "dirty" && r.dirty(), a(u.value).then(() => ({ status: r.value, value: u.value }))));
    }
    if (o.type === "transform")
      if (n.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!p5(a))
          return a;
        const u = o.transform(a.value, i);
        if (u instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: u };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((a) => p5(a) ? Promise.resolve(o.transform(a.value, i)).then((u) => ({ status: r.value, value: u })) : a);
    Kr.assertNever(o);
  }
}
Du.create = (e, t, r) => new Du({
  schema: e,
  typeName: Vt.ZodEffects,
  effect: t,
  ...wr(r)
});
Du.createWithPreprocess = (e, t, r) => new Du({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: Vt.ZodEffects,
  ...wr(r)
});
class rf extends Nr {
  _parse(t) {
    return this._getType(t) === pt.undefined ? ya(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
rf.create = (e, t) => new rf({
  innerType: e,
  typeName: Vt.ZodOptional,
  ...wr(t)
});
class p0 extends Nr {
  _parse(t) {
    return this._getType(t) === pt.null ? ya(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
p0.create = (e, t) => new p0({
  innerType: e,
  typeName: Vt.ZodNullable,
  ...wr(t)
});
class o2 extends Nr {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let n = r.data;
    return r.parsedType === pt.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
o2.create = (e, t) => new o2({
  innerType: e,
  typeName: Vt.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...wr(t)
});
class w5 extends Nr {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, o = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return g5(o) ? o.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new ju(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: o.status === "valid" ? o.value : this._def.catchValue({
        get error() {
          return new ju(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
w5.create = (e, t) => new w5({
  innerType: e,
  typeName: Vt.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...wr(t)
});
class v5 extends Nr {
  _parse(t) {
    if (this._getType(t) !== pt.nan) {
      const r = this._getOrReturnCtx(t);
      return wt(r, {
        code: Je.invalid_type,
        expected: pt.nan,
        received: r.parsedType
      }), fr;
    }
    return { status: "valid", value: t.data };
  }
}
v5.create = (e) => new v5({
  typeName: Vt.ZodNaN,
  ...wr(e)
});
const Txe = Symbol("zod_brand");
class fZ extends Nr {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class av extends Nr {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const o = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? fr : o.status === "dirty" ? (r.dirty(), cZ(o.value)) : this._def.out._parseAsync({
          data: o.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const o = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return o.status === "aborted" ? fr : o.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: o.value
      }) : this._def.out._parseSync({
        data: o.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, r) {
    return new av({
      in: t,
      out: r,
      typeName: Vt.ZodPipeline
    });
  }
}
const dZ = (e, t = {}, r) => e ? ug.create().superRefine((n, o) => {
  var i, a;
  if (!e(n)) {
    const u = typeof t == "function" ? t(n) : typeof t == "string" ? { message: t } : t, l = (a = (i = u.fatal) !== null && i !== void 0 ? i : r) !== null && a !== void 0 ? a : !0, d = typeof u == "string" ? { message: u } : u;
    o.addIssue({ code: "custom", ...d, fatal: l });
  }
}) : ug.create(), Ixe = {
  object: Jn.lazycreate
};
var Vt;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline";
})(Vt || (Vt = {}));
const Oxe = (e, t = {
  message: `Input not instance of ${e.name}`
}) => dZ((r) => r instanceof e, t), hZ = Iu.create, pZ = Vd.create, Pxe = v5.create, Cxe = Gd.create, gZ = Zw.create, Bxe = d0.create, Nxe = m5.create, $xe = Xw.create, Uxe = Yw.create, Rxe = ug.create, zxe = Yp.create, jxe = pf.create, Lxe = y5.create, Hxe = Lu.create, Fxe = Jn.create, Mxe = Jn.strictCreate, Dxe = Jw.create, Kxe = pE.create, qxe = Qw.create, Vxe = Oc.create, Gxe = e2.create, Wxe = b5.create, Zxe = h0.create, Xxe = C1.create, Yxe = t2.create, Jxe = r2.create, Qxe = Wd.create, eke = n2.create, tke = cg.create, Dz = Du.create, rke = rf.create, nke = p0.create, oke = Du.createWithPreprocess, ike = av.create, ake = () => hZ().optional(), ske = () => pZ().optional(), uke = () => gZ().optional(), cke = {
  string: (e) => Iu.create({ ...e, coerce: !0 }),
  number: (e) => Vd.create({ ...e, coerce: !0 }),
  boolean: (e) => Zw.create({
    ...e,
    coerce: !0
  }),
  bigint: (e) => Gd.create({ ...e, coerce: !0 }),
  date: (e) => d0.create({ ...e, coerce: !0 })
}, lke = fr;
var ha = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: Ww,
  setErrorMap: pxe,
  getErrorMap: d5,
  makeIssue: h5,
  EMPTY_PATH: gxe,
  addIssueToContext: wt,
  ParseStatus: Di,
  INVALID: fr,
  DIRTY: cZ,
  OK: ya,
  isAborted: oP,
  isDirty: iP,
  isValid: p5,
  isAsync: g5,
  get util() {
    return Kr;
  },
  get objectUtil() {
    return nP;
  },
  ZodParsedType: pt,
  getParsedType: Cd,
  ZodType: Nr,
  ZodString: Iu,
  ZodNumber: Vd,
  ZodBigInt: Gd,
  ZodBoolean: Zw,
  ZodDate: d0,
  ZodSymbol: m5,
  ZodUndefined: Xw,
  ZodNull: Yw,
  ZodAny: ug,
  ZodUnknown: Yp,
  ZodNever: pf,
  ZodVoid: y5,
  ZodArray: Lu,
  ZodObject: Jn,
  ZodUnion: Jw,
  ZodDiscriminatedUnion: pE,
  ZodIntersection: Qw,
  ZodTuple: Oc,
  ZodRecord: e2,
  ZodMap: b5,
  ZodSet: h0,
  ZodFunction: C1,
  ZodLazy: t2,
  ZodLiteral: r2,
  ZodEnum: Wd,
  ZodNativeEnum: n2,
  ZodPromise: cg,
  ZodEffects: Du,
  ZodTransformer: Du,
  ZodOptional: rf,
  ZodNullable: p0,
  ZodDefault: o2,
  ZodCatch: w5,
  ZodNaN: v5,
  BRAND: Txe,
  ZodBranded: fZ,
  ZodPipeline: av,
  custom: dZ,
  Schema: Nr,
  ZodSchema: Nr,
  late: Ixe,
  get ZodFirstPartyTypeKind() {
    return Vt;
  },
  coerce: cke,
  any: Rxe,
  array: Hxe,
  bigint: Cxe,
  boolean: gZ,
  date: Bxe,
  discriminatedUnion: Kxe,
  effect: Dz,
  enum: Qxe,
  function: Xxe,
  instanceof: Oxe,
  intersection: qxe,
  lazy: Yxe,
  literal: Jxe,
  map: Wxe,
  nan: Pxe,
  nativeEnum: eke,
  never: jxe,
  null: Uxe,
  nullable: nke,
  number: pZ,
  object: Fxe,
  oboolean: uke,
  onumber: ske,
  optional: rke,
  ostring: ake,
  pipeline: ike,
  preprocess: oke,
  promise: tke,
  record: Gxe,
  set: Zxe,
  strictObject: Mxe,
  string: hZ,
  symbol: Nxe,
  transformer: Dz,
  tuple: Vxe,
  undefined: $xe,
  union: Dxe,
  unknown: zxe,
  void: Lxe,
  NEVER: lke,
  ZodIssueCode: Je,
  quotelessJson: hxe,
  ZodError: ju
});
const mZ = ha.string().regex(/^[a-fA-F0-9]$/), fke = ha.string().regex(/^[a-fA-F0-9]{64}$/), lg = ha.number().min(0).max(4294967295), dke = ha.bigint(), yZ = ha.instanceof(Uint8Array), hke = ha.union([mZ, lg, ha.string(), yZ]).array(), AN = ha.union([hke, mZ, yZ]), pke = ha.array(AN), bZ = ha.object({
  value: ha.union([lg, dke]),
  scriptPubKey: AN
}), gke = ha.object({
  txid: fke,
  vout: lg,
  scriptSig: AN,
  sequence: lg,
  prevout: bZ.optional(),
  witness: pke
});
ha.object({
  version: lg,
  vin: ha.array(gke),
  vout: ha.array(bZ),
  locktime: lg
});
var uo = {}, wZ = {}, gE = {}, xN = {}, jg = {}, mn = {}, Rr = {};
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
Object.defineProperty(Rr, "__esModule", { value: !0 });
Rr.notImplemented = Rr.bitMask = void 0;
Rr.isBytes = bE;
Rr.abytes = wE;
Rr.abool = yke;
Rr.bytesToHex = kN;
Rr.numberToHexUnpadded = vZ;
Rr.hexToNumber = SN;
Rr.hexToBytes = vE;
Rr.bytesToNumberBE = wke;
Rr.bytesToNumberLE = vke;
Rr.numberToBytesBE = EZ;
Rr.numberToBytesLE = Eke;
Rr.numberToVarBytesBE = _ke;
Rr.ensureBytes = Ake;
Rr.concatBytes = _Z;
Rr.equalBytes = xke;
Rr.utf8ToBytes = kke;
Rr.inRange = AZ;
Rr.aInRange = Ske;
Rr.bitLen = Tke;
Rr.bitGet = Ike;
Rr.bitSet = Oke;
Rr.createHmacDrbg = Cke;
Rr.validateObject = Nke;
Rr.memoized = Uke;
const mE = /* @__PURE__ */ BigInt(0), yE = /* @__PURE__ */ BigInt(1), mke = /* @__PURE__ */ BigInt(2);
function bE(e) {
  return e instanceof Uint8Array || ArrayBuffer.isView(e) && e.constructor.name === "Uint8Array";
}
function wE(e) {
  if (!bE(e))
    throw new Error("Uint8Array expected");
}
function yke(e, t) {
  if (typeof t != "boolean")
    throw new Error(e + " boolean expected, got " + t);
}
const bke = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function kN(e) {
  wE(e);
  let t = "";
  for (let r = 0; r < e.length; r++)
    t += bke[e[r]];
  return t;
}
function vZ(e) {
  const t = e.toString(16);
  return t.length & 1 ? "0" + t : t;
}
function SN(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  return e === "" ? mE : BigInt("0x" + e);
}
const Ll = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function Kz(e) {
  if (e >= Ll._0 && e <= Ll._9)
    return e - Ll._0;
  if (e >= Ll.A && e <= Ll.F)
    return e - (Ll.A - 10);
  if (e >= Ll.a && e <= Ll.f)
    return e - (Ll.a - 10);
}
function vE(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  const t = e.length, r = t / 2;
  if (t % 2)
    throw new Error("hex string expected, got unpadded hex of length " + t);
  const n = new Uint8Array(r);
  for (let o = 0, i = 0; o < r; o++, i += 2) {
    const a = Kz(e.charCodeAt(i)), u = Kz(e.charCodeAt(i + 1));
    if (a === void 0 || u === void 0) {
      const l = e[i] + e[i + 1];
      throw new Error('hex string expected, got non-hex character "' + l + '" at index ' + i);
    }
    n[o] = a * 16 + u;
  }
  return n;
}
function wke(e) {
  return SN(kN(e));
}
function vke(e) {
  return wE(e), SN(kN(Uint8Array.from(e).reverse()));
}
function EZ(e, t) {
  return vE(e.toString(16).padStart(t * 2, "0"));
}
function Eke(e, t) {
  return EZ(e, t).reverse();
}
function _ke(e) {
  return vE(vZ(e));
}
function Ake(e, t, r) {
  let n;
  if (typeof t == "string")
    try {
      n = vE(t);
    } catch (i) {
      throw new Error(e + " must be hex string or Uint8Array, cause: " + i);
    }
  else if (bE(t))
    n = Uint8Array.from(t);
  else
    throw new Error(e + " must be hex string or Uint8Array");
  const o = n.length;
  if (typeof r == "number" && o !== r)
    throw new Error(e + " of length " + r + " expected, got " + o);
  return n;
}
function _Z(...e) {
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    wE(o), t += o.length;
  }
  const r = new Uint8Array(t);
  for (let n = 0, o = 0; n < e.length; n++) {
    const i = e[n];
    r.set(i, o), o += i.length;
  }
  return r;
}
function xke(e, t) {
  if (e.length !== t.length)
    return !1;
  let r = 0;
  for (let n = 0; n < e.length; n++)
    r |= e[n] ^ t[n];
  return r === 0;
}
function kke(e) {
  if (typeof e != "string")
    throw new Error("string expected");
  return new Uint8Array(new TextEncoder().encode(e));
}
const VT = (e) => typeof e == "bigint" && mE <= e;
function AZ(e, t, r) {
  return VT(e) && VT(t) && VT(r) && t <= e && e < r;
}
function Ske(e, t, r, n) {
  if (!AZ(t, r, n))
    throw new Error("expected valid " + e + ": " + r + " <= n < " + n + ", got " + t);
}
function Tke(e) {
  let t;
  for (t = 0; e > mE; e >>= yE, t += 1)
    ;
  return t;
}
function Ike(e, t) {
  return e >> BigInt(t) & yE;
}
function Oke(e, t, r) {
  return e | (r ? yE : mE) << BigInt(t);
}
const Pke = (e) => (mke << BigInt(e - 1)) - yE;
Rr.bitMask = Pke;
const GT = (e) => new Uint8Array(e), qz = (e) => Uint8Array.from(e);
function Cke(e, t, r) {
  if (typeof e != "number" || e < 2)
    throw new Error("hashLen must be a number");
  if (typeof t != "number" || t < 2)
    throw new Error("qByteLen must be a number");
  if (typeof r != "function")
    throw new Error("hmacFn must be a function");
  let n = GT(e), o = GT(e), i = 0;
  const a = () => {
    n.fill(1), o.fill(0), i = 0;
  }, u = (...f) => r(o, n, ...f), l = (f = GT()) => {
    o = u(qz([0]), f), n = u(), f.length !== 0 && (o = u(qz([1]), f), n = u());
  }, d = () => {
    if (i++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let f = 0;
    const h = [];
    for (; f < t; ) {
      n = u();
      const g = n.slice();
      h.push(g), f += n.length;
    }
    return _Z(...h);
  };
  return (f, h) => {
    a(), l(f);
    let g;
    for (; !(g = h(d())); )
      l();
    return a(), g;
  };
}
const Bke = {
  bigint: (e) => typeof e == "bigint",
  function: (e) => typeof e == "function",
  boolean: (e) => typeof e == "boolean",
  string: (e) => typeof e == "string",
  stringOrUint8Array: (e) => typeof e == "string" || bE(e),
  isSafeInteger: (e) => Number.isSafeInteger(e),
  array: (e) => Array.isArray(e),
  field: (e, t) => t.Fp.isValid(e),
  hash: (e) => typeof e == "function" && Number.isSafeInteger(e.outputLen)
};
function Nke(e, t, r = {}) {
  const n = (o, i, a) => {
    const u = Bke[i];
    if (typeof u != "function")
      throw new Error("invalid validator function");
    const l = e[o];
    if (!(a && l === void 0) && !u(l, e))
      throw new Error("param " + String(o) + " is invalid. Expected " + i + ", got " + l);
  };
  for (const [o, i] of Object.entries(t))
    n(o, i, !1);
  for (const [o, i] of Object.entries(r))
    n(o, i, !0);
  return e;
}
const $ke = () => {
  throw new Error("not implemented");
};
Rr.notImplemented = $ke;
function Uke(e) {
  const t = /* @__PURE__ */ new WeakMap();
  return (r, ...n) => {
    const o = t.get(r);
    if (o !== void 0)
      return o;
    const i = e(r, ...n);
    return t.set(r, i), i;
  };
}
Object.defineProperty(mn, "__esModule", { value: !0 });
mn.isNegativeLE = void 0;
mn.mod = es;
mn.pow = xZ;
mn.pow2 = zke;
mn.invert = E5;
mn.tonelliShanks = kZ;
mn.FpSqrt = SZ;
mn.validateField = Hke;
mn.FpPow = TZ;
mn.FpInvertBatch = IZ;
mn.FpDiv = Fke;
mn.FpLegendre = OZ;
mn.FpIsSquare = Mke;
mn.nLength = TN;
mn.Field = Dke;
mn.FpSqrtOdd = Kke;
mn.FpSqrtEven = qke;
mn.hashToPrivateScalar = Vke;
mn.getFieldBytesLength = IN;
mn.getMinHashLength = PZ;
mn.mapHashToField = Gke;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const os = Rr, ai = BigInt(0), In = BigInt(1), Bd = /* @__PURE__ */ BigInt(2), Rke = /* @__PURE__ */ BigInt(3), sP = /* @__PURE__ */ BigInt(4), Vz = /* @__PURE__ */ BigInt(5), Gz = /* @__PURE__ */ BigInt(8);
function es(e, t) {
  const r = e % t;
  return r >= ai ? r : t + r;
}
function xZ(e, t, r) {
  if (t < ai)
    throw new Error("invalid exponent, negatives unsupported");
  if (r <= ai)
    throw new Error("invalid modulus");
  if (r === In)
    return ai;
  let n = In;
  for (; t > ai; )
    t & In && (n = n * e % r), e = e * e % r, t >>= In;
  return n;
}
function zke(e, t, r) {
  let n = e;
  for (; t-- > ai; )
    n *= n, n %= r;
  return n;
}
function E5(e, t) {
  if (e === ai)
    throw new Error("invert: expected non-zero number");
  if (t <= ai)
    throw new Error("invert: expected positive modulus, got " + t);
  let r = es(e, t), n = t, o = ai, i = In;
  for (; r !== ai; ) {
    const a = n / r, u = n % r, l = o - i * a;
    n = r, r = u, o = i, i = l;
  }
  if (n !== In)
    throw new Error("invert: does not exist");
  return es(o, t);
}
function kZ(e) {
  const t = (e - In) / Bd;
  let r, n, o;
  for (r = e - In, n = 0; r % Bd === ai; r /= Bd, n++)
    ;
  for (o = Bd; o < e && xZ(o, t, e) !== e - In; o++)
    if (o > 1e3)
      throw new Error("Cannot find square root: likely non-prime P");
  if (n === 1) {
    const a = (e + In) / sP;
    return function(u, l) {
      const d = u.pow(l, a);
      if (!u.eql(u.sqr(d), l))
        throw new Error("Cannot find square root");
      return d;
    };
  }
  const i = (r + In) / Bd;
  return function(a, u) {
    if (a.pow(u, t) === a.neg(a.ONE))
      throw new Error("Cannot find square root");
    let l = n, d = a.pow(a.mul(a.ONE, o), r), f = a.pow(u, i), h = a.pow(u, r);
    for (; !a.eql(h, a.ONE); ) {
      if (a.eql(h, a.ZERO))
        return a.ZERO;
      let g = 1;
      for (let w = a.sqr(h); g < l && !a.eql(w, a.ONE); g++)
        w = a.sqr(w);
      const b = a.pow(d, In << BigInt(l - g - 1));
      d = a.sqr(b), f = a.mul(f, b), h = a.mul(h, d), l = g;
    }
    return f;
  };
}
function SZ(e) {
  if (e % sP === Rke) {
    const t = (e + In) / sP;
    return function(r, n) {
      const o = r.pow(n, t);
      if (!r.eql(r.sqr(o), n))
        throw new Error("Cannot find square root");
      return o;
    };
  }
  if (e % Gz === Vz) {
    const t = (e - Vz) / Gz;
    return function(r, n) {
      const o = r.mul(n, Bd), i = r.pow(o, t), a = r.mul(n, i), u = r.mul(r.mul(a, Bd), i), l = r.mul(a, r.sub(u, r.ONE));
      if (!r.eql(r.sqr(l), n))
        throw new Error("Cannot find square root");
      return l;
    };
  }
  return kZ(e);
}
const jke = (e, t) => (es(e, t) & In) === In;
mn.isNegativeLE = jke;
const Lke = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function Hke(e) {
  const t = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, r = Lke.reduce((n, o) => (n[o] = "function", n), t);
  return (0, os.validateObject)(e, r);
}
function TZ(e, t, r) {
  if (r < ai)
    throw new Error("invalid exponent, negatives unsupported");
  if (r === ai)
    return e.ONE;
  if (r === In)
    return t;
  let n = e.ONE, o = t;
  for (; r > ai; )
    r & In && (n = e.mul(n, o)), o = e.sqr(o), r >>= In;
  return n;
}
function IZ(e, t) {
  const r = new Array(t.length), n = t.reduce((i, a, u) => e.is0(a) ? i : (r[u] = i, e.mul(i, a)), e.ONE), o = e.inv(n);
  return t.reduceRight((i, a, u) => e.is0(a) ? i : (r[u] = e.mul(i, r[u]), e.mul(i, a)), o), r;
}
function Fke(e, t, r) {
  return e.mul(t, typeof r == "bigint" ? E5(r, e.ORDER) : e.inv(r));
}
function OZ(e) {
  const t = (e - In) / Bd;
  return (r, n) => r.pow(n, t);
}
function Mke(e) {
  const t = OZ(e.ORDER);
  return (r) => {
    const n = t(e, r);
    return e.eql(n, e.ZERO) || e.eql(n, e.ONE);
  };
}
function TN(e, t) {
  const r = t !== void 0 ? t : e.toString(2).length, n = Math.ceil(r / 8);
  return { nBitLength: r, nByteLength: n };
}
function Dke(e, t, r = !1, n = {}) {
  if (e <= ai)
    throw new Error("invalid field: expected ORDER > 0, got " + e);
  const { nBitLength: o, nByteLength: i } = TN(e, t);
  if (i > 2048)
    throw new Error("invalid field: expected ORDER of <= 2048 bytes");
  let a;
  const u = Object.freeze({
    ORDER: e,
    isLE: r,
    BITS: o,
    BYTES: i,
    MASK: (0, os.bitMask)(o),
    ZERO: ai,
    ONE: In,
    create: (l) => es(l, e),
    isValid: (l) => {
      if (typeof l != "bigint")
        throw new Error("invalid field element: expected bigint, got " + typeof l);
      return ai <= l && l < e;
    },
    is0: (l) => l === ai,
    isOdd: (l) => (l & In) === In,
    neg: (l) => es(-l, e),
    eql: (l, d) => l === d,
    sqr: (l) => es(l * l, e),
    add: (l, d) => es(l + d, e),
    sub: (l, d) => es(l - d, e),
    mul: (l, d) => es(l * d, e),
    pow: (l, d) => TZ(u, l, d),
    div: (l, d) => es(l * E5(d, e), e),
    // Same as above, but doesn't normalize
    sqrN: (l) => l * l,
    addN: (l, d) => l + d,
    subN: (l, d) => l - d,
    mulN: (l, d) => l * d,
    inv: (l) => E5(l, e),
    sqrt: n.sqrt || ((l) => (a || (a = SZ(e)), a(u, l))),
    invertBatch: (l) => IZ(u, l),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (l, d, f) => f ? d : l,
    toBytes: (l) => r ? (0, os.numberToBytesLE)(l, i) : (0, os.numberToBytesBE)(l, i),
    fromBytes: (l) => {
      if (l.length !== i)
        throw new Error("Field.fromBytes: expected " + i + " bytes, got " + l.length);
      return r ? (0, os.bytesToNumberLE)(l) : (0, os.bytesToNumberBE)(l);
    }
  });
  return Object.freeze(u);
}
function Kke(e, t) {
  if (!e.isOdd)
    throw new Error("Field doesn't have isOdd");
  const r = e.sqrt(t);
  return e.isOdd(r) ? r : e.neg(r);
}
function qke(e, t) {
  if (!e.isOdd)
    throw new Error("Field doesn't have isOdd");
  const r = e.sqrt(t);
  return e.isOdd(r) ? e.neg(r) : r;
}
function Vke(e, t, r = !1) {
  e = (0, os.ensureBytes)("privateHash", e);
  const n = e.length, o = TN(t).nByteLength + 8;
  if (o < 24 || n < o || n > 1024)
    throw new Error("hashToPrivateScalar: expected " + o + "-1024 bytes of input, got " + n);
  const i = r ? (0, os.bytesToNumberLE)(e) : (0, os.bytesToNumberBE)(e);
  return es(i, t - In) + In;
}
function IN(e) {
  if (typeof e != "bigint")
    throw new Error("field order must be bigint");
  const t = e.toString(2).length;
  return Math.ceil(t / 8);
}
function PZ(e) {
  const t = IN(e);
  return t + Math.ceil(t / 2);
}
function Gke(e, t, r = !1) {
  const n = e.length, o = IN(t), i = PZ(t);
  if (n < 16 || n < i || n > 1024)
    throw new Error("expected " + i + "-1024 bytes of input, got " + n);
  const a = r ? (0, os.bytesToNumberLE)(e) : (0, os.bytesToNumberBE)(e), u = es(a, t - In) + In;
  return r ? (0, os.numberToBytesLE)(u, o) : (0, os.numberToBytesBE)(u, o);
}
Object.defineProperty(jg, "__esModule", { value: !0 });
jg.wNAF = Wke;
jg.pippenger = Zke;
jg.precomputeMSMUnsafe = Xke;
jg.validateBasic = Yke;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Wz = mn, CZ = Rr, Zz = BigInt(0), m8 = BigInt(1);
function WT(e, t) {
  const r = t.negate();
  return e ? r : t;
}
function ON(e, t) {
  if (!Number.isSafeInteger(e) || e <= 0 || e > t)
    throw new Error("invalid window size, expected [1.." + t + "], got W=" + e);
}
function ZT(e, t) {
  ON(e, t);
  const r = Math.ceil(t / e) + 1, n = 2 ** (e - 1);
  return { windows: r, windowSize: n };
}
function BZ(e, t) {
  if (!Array.isArray(e))
    throw new Error("array expected");
  e.forEach((r, n) => {
    if (!(r instanceof t))
      throw new Error("invalid point at index " + n);
  });
}
function NZ(e, t) {
  if (!Array.isArray(e))
    throw new Error("array of scalars expected");
  e.forEach((r, n) => {
    if (!t.isValid(r))
      throw new Error("invalid scalar at index " + n);
  });
}
const XT = /* @__PURE__ */ new WeakMap(), $Z = /* @__PURE__ */ new WeakMap();
function YT(e) {
  return $Z.get(e) || 1;
}
function Wke(e, t) {
  return {
    constTimeNegate: WT,
    hasPrecomputes(r) {
      return YT(r) !== 1;
    },
    // non-const time multiplication ladder
    unsafeLadder(r, n, o = e.ZERO) {
      let i = r;
      for (; n > Zz; )
        n & m8 && (o = o.add(i)), i = i.double(), n >>= m8;
      return o;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param elm Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(r, n) {
      const { windows: o, windowSize: i } = ZT(n, t), a = [];
      let u = r, l = u;
      for (let d = 0; d < o; d++) {
        l = u, a.push(l);
        for (let f = 1; f < i; f++)
          l = l.add(u), a.push(l);
        u = l.double();
      }
      return a;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(r, n, o) {
      const { windows: i, windowSize: a } = ZT(r, t);
      let u = e.ZERO, l = e.BASE;
      const d = BigInt(2 ** r - 1), f = 2 ** r, h = BigInt(r);
      for (let g = 0; g < i; g++) {
        const b = g * a;
        let w = Number(o & d);
        o >>= h, w > a && (w -= f, o += m8);
        const E = b, _ = b + Math.abs(w) - 1, O = g % 2 !== 0, C = w < 0;
        w === 0 ? l = l.add(WT(O, n[E])) : u = u.add(WT(C, n[_]));
      }
      return { p: u, f: l };
    },
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */
    wNAFUnsafe(r, n, o, i = e.ZERO) {
      const { windows: a, windowSize: u } = ZT(r, t), l = BigInt(2 ** r - 1), d = 2 ** r, f = BigInt(r);
      for (let h = 0; h < a; h++) {
        const g = h * u;
        if (o === Zz)
          break;
        let b = Number(o & l);
        if (o >>= f, b > u && (b -= d, o += m8), b === 0)
          continue;
        let w = n[g + Math.abs(b) - 1];
        b < 0 && (w = w.negate()), i = i.add(w);
      }
      return i;
    },
    getPrecomputes(r, n, o) {
      let i = XT.get(n);
      return i || (i = this.precomputeWindow(n, r), r !== 1 && XT.set(n, o(i))), i;
    },
    wNAFCached(r, n, o) {
      const i = YT(r);
      return this.wNAF(i, this.getPrecomputes(i, r, o), n);
    },
    wNAFCachedUnsafe(r, n, o, i) {
      const a = YT(r);
      return a === 1 ? this.unsafeLadder(r, n, i) : this.wNAFUnsafe(a, this.getPrecomputes(a, r, o), n, i);
    },
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    setWindowSize(r, n) {
      ON(n, t), $Z.set(r, n), XT.delete(r);
    }
  };
}
function Zke(e, t, r, n) {
  if (BZ(r, e), NZ(n, t), r.length !== n.length)
    throw new Error("arrays of points and scalars must have equal length");
  const o = e.ZERO, i = (0, CZ.bitLen)(BigInt(r.length)), a = i > 12 ? i - 3 : i > 4 ? i - 2 : i ? 2 : 1, u = (1 << a) - 1, l = new Array(u + 1).fill(o), d = Math.floor((t.BITS - 1) / a) * a;
  let f = o;
  for (let h = d; h >= 0; h -= a) {
    l.fill(o);
    for (let b = 0; b < n.length; b++) {
      const w = n[b], E = Number(w >> BigInt(h) & BigInt(u));
      l[E] = l[E].add(r[b]);
    }
    let g = o;
    for (let b = l.length - 1, w = o; b > 0; b--)
      w = w.add(l[b]), g = g.add(w);
    if (f = f.add(g), h !== 0)
      for (let b = 0; b < a; b++)
        f = f.double();
  }
  return f;
}
function Xke(e, t, r, n) {
  ON(n, t.BITS), BZ(r, e);
  const o = e.ZERO, i = 2 ** n - 1, a = Math.ceil(t.BITS / n), u = BigInt((1 << n) - 1), l = r.map((d) => {
    const f = [];
    for (let h = 0, g = d; h < i; h++)
      f.push(g), g = g.add(d);
    return f;
  });
  return (d) => {
    if (NZ(d, t), d.length > r.length)
      throw new Error("array of scalars must be smaller than array of points");
    let f = o;
    for (let h = 0; h < a; h++) {
      if (f !== o)
        for (let b = 0; b < n; b++)
          f = f.double();
      const g = BigInt(a * n - (h + 1) * n);
      for (let b = 0; b < d.length; b++) {
        const w = d[b], E = Number(w >> g & u);
        E && (f = f.add(l[b][E - 1]));
      }
    }
    return f;
  };
}
function Yke(e) {
  return (0, Wz.validateField)(e.Fp), (0, CZ.validateObject)(e, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...(0, Wz.nLength)(e.n, e.nBitLength),
    ...e,
    p: e.Fp.ORDER
  });
}
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.DER = e.DERErr = void 0, e.weierstrassPoints = E, e.weierstrass = O, e.SWUFpSqrtRatio = C, e.mapToCurveSimpleSWU = I;
  /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  const t = jg, r = mn, n = Rr, o = Rr;
  function i(S) {
    S.lowS !== void 0 && (0, o.abool)("lowS", S.lowS), S.prehash !== void 0 && (0, o.abool)("prehash", S.prehash);
  }
  function a(S) {
    const T = (0, t.validateBasic)(S);
    n.validateObject(T, {
      a: "field",
      b: "field"
    }, {
      allowedPrivateKeyLengths: "array",
      wrapPrivateKey: "boolean",
      isTorsionFree: "function",
      clearCofactor: "function",
      allowInfinityPoint: "boolean",
      fromBytes: "function",
      toBytes: "function"
    });
    const { endo: A, Fp: $, a: U } = T;
    if (A) {
      if (!$.eql(U, $.ZERO))
        throw new Error("invalid endomorphism, can only be defined for Koblitz curves that have a=0");
      if (typeof A != "object" || typeof A.beta != "bigint" || typeof A.splitScalar != "function")
        throw new Error("invalid endomorphism, expected beta: bigint and splitScalar: function");
    }
    return Object.freeze({ ...T });
  }
  const { bytesToNumberBE: u, hexToBytes: l } = n;
  class d extends Error {
    constructor(T = "") {
      super(T);
    }
  }
  e.DERErr = d, e.DER = {
    // asn.1 DER encoding utils
    Err: d,
    // Basic building block is TLV (Tag-Length-Value)
    _tlv: {
      encode: (S, T) => {
        const { Err: A } = e.DER;
        if (S < 0 || S > 256)
          throw new A("tlv.encode: wrong tag");
        if (T.length & 1)
          throw new A("tlv.encode: unpadded data");
        const $ = T.length / 2, U = n.numberToHexUnpadded($);
        if (U.length / 2 & 128)
          throw new A("tlv.encode: long form length too big");
        const M = $ > 127 ? n.numberToHexUnpadded(U.length / 2 | 128) : "";
        return n.numberToHexUnpadded(S) + M + U + T;
      },
      // v - value, l - left bytes (unparsed)
      decode(S, T) {
        const { Err: A } = e.DER;
        let $ = 0;
        if (S < 0 || S > 256)
          throw new A("tlv.encode: wrong tag");
        if (T.length < 2 || T[$++] !== S)
          throw new A("tlv.decode: wrong tlv");
        const U = T[$++], M = !!(U & 128);
        let Y = 0;
        if (!M)
          Y = U;
        else {
          const ee = U & 127;
          if (!ee)
            throw new A("tlv.decode(long): indefinite length not supported");
          if (ee > 4)
            throw new A("tlv.decode(long): byte length is too big");
          const de = T.subarray($, $ + ee);
          if (de.length !== ee)
            throw new A("tlv.decode: length bytes not complete");
          if (de[0] === 0)
            throw new A("tlv.decode(long): zero leftmost byte");
          for (const ne of de)
            Y = Y << 8 | ne;
          if ($ += ee, Y < 128)
            throw new A("tlv.decode(long): not minimal encoding");
        }
        const L = T.subarray($, $ + Y);
        if (L.length !== Y)
          throw new A("tlv.decode: wrong value length");
        return { v: L, l: T.subarray($ + Y) };
      }
    },
    // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
    // since we always use positive integers here. It must always be empty:
    // - add zero byte if exists
    // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
    _int: {
      encode(S) {
        const { Err: T } = e.DER;
        if (S < f)
          throw new T("integer: negative integers are not allowed");
        let A = n.numberToHexUnpadded(S);
        if (Number.parseInt(A[0], 16) & 8 && (A = "00" + A), A.length & 1)
          throw new T("unexpected DER parsing assertion: unpadded hex");
        return A;
      },
      decode(S) {
        const { Err: T } = e.DER;
        if (S[0] & 128)
          throw new T("invalid signature integer: negative");
        if (S[0] === 0 && !(S[1] & 128))
          throw new T("invalid signature integer: unnecessary leading zero");
        return u(S);
      }
    },
    toSig(S) {
      const { Err: T, _int: A, _tlv: $ } = e.DER, U = typeof S == "string" ? l(S) : S;
      n.abytes(U);
      const { v: M, l: Y } = $.decode(48, U);
      if (Y.length)
        throw new T("invalid signature: left bytes after parsing");
      const { v: L, l: ee } = $.decode(2, M), { v: de, l: ne } = $.decode(2, ee);
      if (ne.length)
        throw new T("invalid signature: left bytes after parsing");
      return { r: A.decode(L), s: A.decode(de) };
    },
    hexFromSig(S) {
      const { _tlv: T, _int: A } = e.DER, $ = T.encode(2, A.encode(S.r)), U = T.encode(2, A.encode(S.s)), M = $ + U;
      return T.encode(48, M);
    }
  };
  const f = BigInt(0), h = BigInt(1), g = BigInt(2), b = BigInt(3), w = BigInt(4);
  function E(S) {
    const T = a(S), { Fp: A } = T, $ = (0, r.Field)(T.n, T.nBitLength), U = T.toBytes || ((G, q, Q) => {
      const se = q.toAffine();
      return n.concatBytes(Uint8Array.from([4]), A.toBytes(se.x), A.toBytes(se.y));
    }), M = T.fromBytes || ((G) => {
      const q = G.subarray(1), Q = A.fromBytes(q.subarray(0, A.BYTES)), se = A.fromBytes(q.subarray(A.BYTES, 2 * A.BYTES));
      return { x: Q, y: se };
    });
    function Y(G) {
      const { a: q, b: Q } = T, se = A.sqr(G), J = A.mul(se, G);
      return A.add(A.add(J, A.mul(G, q)), Q);
    }
    if (!A.eql(A.sqr(T.Gy), Y(T.Gx)))
      throw new Error("bad generator point: equation left != right");
    function L(G) {
      return n.inRange(G, h, T.n);
    }
    function ee(G) {
      const { allowedPrivateKeyLengths: q, nByteLength: Q, wrapPrivateKey: se, n: J } = T;
      if (q && typeof G != "bigint") {
        if (n.isBytes(G) && (G = n.bytesToHex(G)), typeof G != "string" || !q.includes(G.length))
          throw new Error("invalid private key");
        G = G.padStart(Q * 2, "0");
      }
      let ye;
      try {
        ye = typeof G == "bigint" ? G : n.bytesToNumberBE((0, o.ensureBytes)("private key", G, Q));
      } catch {
        throw new Error("invalid private key, expected hex or " + Q + " bytes, got " + typeof G);
      }
      return se && (ye = (0, r.mod)(ye, J)), n.aInRange("private key", ye, h, J), ye;
    }
    function de(G) {
      if (!(G instanceof K))
        throw new Error("ProjectivePoint expected");
    }
    const ne = (0, o.memoized)((G, q) => {
      const { px: Q, py: se, pz: J } = G;
      if (A.eql(J, A.ONE))
        return { x: Q, y: se };
      const ye = G.is0();
      q == null && (q = ye ? A.ONE : A.inv(J));
      const ve = A.mul(Q, q), Ee = A.mul(se, q), _e = A.mul(J, q);
      if (ye)
        return { x: A.ZERO, y: A.ZERO };
      if (!A.eql(_e, A.ONE))
        throw new Error("invZ was invalid");
      return { x: ve, y: Ee };
    }), D = (0, o.memoized)((G) => {
      if (G.is0()) {
        if (T.allowInfinityPoint && !A.is0(G.py))
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: q, y: Q } = G.toAffine();
      if (!A.isValid(q) || !A.isValid(Q))
        throw new Error("bad point: x or y not FE");
      const se = A.sqr(Q), J = Y(q);
      if (!A.eql(se, J))
        throw new Error("bad point: equation left != right");
      if (!G.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
      return !0;
    });
    class K {
      constructor(q, Q, se) {
        if (this.px = q, this.py = Q, this.pz = se, q == null || !A.isValid(q))
          throw new Error("x required");
        if (Q == null || !A.isValid(Q))
          throw new Error("y required");
        if (se == null || !A.isValid(se))
          throw new Error("z required");
        Object.freeze(this);
      }
      // Does not validate if the point is on-curve.
      // Use fromHex instead, or call assertValidity() later.
      static fromAffine(q) {
        const { x: Q, y: se } = q || {};
        if (!q || !A.isValid(Q) || !A.isValid(se))
          throw new Error("invalid affine point");
        if (q instanceof K)
          throw new Error("projective point not allowed");
        const J = (ye) => A.eql(ye, A.ZERO);
        return J(Q) && J(se) ? K.ZERO : new K(Q, se, A.ONE);
      }
      get x() {
        return this.toAffine().x;
      }
      get y() {
        return this.toAffine().y;
      }
      /**
       * Takes a bunch of Projective Points but executes only one
       * inversion on all of them. Inversion is very slow operation,
       * so this improves performance massively.
       * Optimization: converts a list of projective points to a list of identical points with Z=1.
       */
      static normalizeZ(q) {
        const Q = A.invertBatch(q.map((se) => se.pz));
        return q.map((se, J) => se.toAffine(Q[J])).map(K.fromAffine);
      }
      /**
       * Converts hash string or Uint8Array to Point.
       * @param hex short/long ECDSA hex
       */
      static fromHex(q) {
        const Q = K.fromAffine(M((0, o.ensureBytes)("pointHex", q)));
        return Q.assertValidity(), Q;
      }
      // Multiplies generator point by privateKey.
      static fromPrivateKey(q) {
        return K.BASE.multiply(ee(q));
      }
      // Multiscalar Multiplication
      static msm(q, Q) {
        return (0, t.pippenger)(K, $, q, Q);
      }
      // "Private method", don't use it directly
      _setWindowSize(q) {
        re.setWindowSize(this, q);
      }
      // A point on curve is valid if it conforms to equation.
      assertValidity() {
        D(this);
      }
      hasEvenY() {
        const { y: q } = this.toAffine();
        if (A.isOdd)
          return !A.isOdd(q);
        throw new Error("Field doesn't support isOdd");
      }
      /**
       * Compare one point to another.
       */
      equals(q) {
        de(q);
        const { px: Q, py: se, pz: J } = this, { px: ye, py: ve, pz: Ee } = q, _e = A.eql(A.mul(Q, Ee), A.mul(ye, J)), we = A.eql(A.mul(se, Ee), A.mul(ve, J));
        return _e && we;
      }
      /**
       * Flips point to one corresponding to (x, -y) in Affine coordinates.
       */
      negate() {
        return new K(this.px, A.neg(this.py), this.pz);
      }
      // Renes-Costello-Batina exception-free doubling formula.
      // There is 30% faster Jacobian formula, but it is not complete.
      // https://eprint.iacr.org/2015/1060, algorithm 3
      // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
      double() {
        const { a: q, b: Q } = T, se = A.mul(Q, b), { px: J, py: ye, pz: ve } = this;
        let Ee = A.ZERO, _e = A.ZERO, we = A.ZERO, be = A.mul(J, J), Ge = A.mul(ye, ye), Le = A.mul(ve, ve), Ne = A.mul(J, ye);
        return Ne = A.add(Ne, Ne), we = A.mul(J, ve), we = A.add(we, we), Ee = A.mul(q, we), _e = A.mul(se, Le), _e = A.add(Ee, _e), Ee = A.sub(Ge, _e), _e = A.add(Ge, _e), _e = A.mul(Ee, _e), Ee = A.mul(Ne, Ee), we = A.mul(se, we), Le = A.mul(q, Le), Ne = A.sub(be, Le), Ne = A.mul(q, Ne), Ne = A.add(Ne, we), we = A.add(be, be), be = A.add(we, be), be = A.add(be, Le), be = A.mul(be, Ne), _e = A.add(_e, be), Le = A.mul(ye, ve), Le = A.add(Le, Le), be = A.mul(Le, Ne), Ee = A.sub(Ee, be), we = A.mul(Le, Ge), we = A.add(we, we), we = A.add(we, we), new K(Ee, _e, we);
      }
      // Renes-Costello-Batina exception-free addition formula.
      // There is 30% faster Jacobian formula, but it is not complete.
      // https://eprint.iacr.org/2015/1060, algorithm 1
      // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
      add(q) {
        de(q);
        const { px: Q, py: se, pz: J } = this, { px: ye, py: ve, pz: Ee } = q;
        let _e = A.ZERO, we = A.ZERO, be = A.ZERO;
        const Ge = T.a, Le = A.mul(T.b, b);
        let Ne = A.mul(Q, ye), Ve = A.mul(se, ve), ge = A.mul(J, Ee), Te = A.add(Q, se), Oe = A.add(ye, ve);
        Te = A.mul(Te, Oe), Oe = A.add(Ne, Ve), Te = A.sub(Te, Oe), Oe = A.add(Q, J);
        let He = A.add(ye, Ee);
        return Oe = A.mul(Oe, He), He = A.add(Ne, ge), Oe = A.sub(Oe, He), He = A.add(se, J), _e = A.add(ve, Ee), He = A.mul(He, _e), _e = A.add(Ve, ge), He = A.sub(He, _e), be = A.mul(Ge, Oe), _e = A.mul(Le, ge), be = A.add(_e, be), _e = A.sub(Ve, be), be = A.add(Ve, be), we = A.mul(_e, be), Ve = A.add(Ne, Ne), Ve = A.add(Ve, Ne), ge = A.mul(Ge, ge), Oe = A.mul(Le, Oe), Ve = A.add(Ve, ge), ge = A.sub(Ne, ge), ge = A.mul(Ge, ge), Oe = A.add(Oe, ge), Ne = A.mul(Ve, Oe), we = A.add(we, Ne), Ne = A.mul(He, Oe), _e = A.mul(Te, _e), _e = A.sub(_e, Ne), Ne = A.mul(Te, Ve), be = A.mul(He, be), be = A.add(be, Ne), new K(_e, we, be);
      }
      subtract(q) {
        return this.add(q.negate());
      }
      is0() {
        return this.equals(K.ZERO);
      }
      wNAF(q) {
        return re.wNAFCached(this, q, K.normalizeZ);
      }
      /**
       * Non-constant-time multiplication. Uses double-and-add algorithm.
       * It's faster, but should only be used when you don't care about
       * an exposed private key e.g. sig verification, which works over *public* keys.
       */
      multiplyUnsafe(q) {
        const { endo: Q, n: se } = T;
        n.aInRange("scalar", q, f, se);
        const J = K.ZERO;
        if (q === f)
          return J;
        if (this.is0() || q === h)
          return this;
        if (!Q || re.hasPrecomputes(this))
          return re.wNAFCachedUnsafe(this, q, K.normalizeZ);
        let { k1neg: ye, k1: ve, k2neg: Ee, k2: _e } = Q.splitScalar(q), we = J, be = J, Ge = this;
        for (; ve > f || _e > f; )
          ve & h && (we = we.add(Ge)), _e & h && (be = be.add(Ge)), Ge = Ge.double(), ve >>= h, _e >>= h;
        return ye && (we = we.negate()), Ee && (be = be.negate()), be = new K(A.mul(be.px, Q.beta), be.py, be.pz), we.add(be);
      }
      /**
       * Constant time multiplication.
       * Uses wNAF method. Windowed method may be 10% faster,
       * but takes 2x longer to generate and consumes 2x memory.
       * Uses precomputes when available.
       * Uses endomorphism for Koblitz curves.
       * @param scalar by which the point would be multiplied
       * @returns New point
       */
      multiply(q) {
        const { endo: Q, n: se } = T;
        n.aInRange("scalar", q, h, se);
        let J, ye;
        if (Q) {
          const { k1neg: ve, k1: Ee, k2neg: _e, k2: we } = Q.splitScalar(q);
          let { p: be, f: Ge } = this.wNAF(Ee), { p: Le, f: Ne } = this.wNAF(we);
          be = re.constTimeNegate(ve, be), Le = re.constTimeNegate(_e, Le), Le = new K(A.mul(Le.px, Q.beta), Le.py, Le.pz), J = be.add(Le), ye = Ge.add(Ne);
        } else {
          const { p: ve, f: Ee } = this.wNAF(q);
          J = ve, ye = Ee;
        }
        return K.normalizeZ([J, ye])[0];
      }
      /**
       * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
       * Not using Strauss-Shamir trick: precomputation tables are faster.
       * The trick could be useful if both P and Q are not G (not in our case).
       * @returns non-zero affine point
       */
      multiplyAndAddUnsafe(q, Q, se) {
        const J = K.BASE, ye = (Ee, _e) => _e === f || _e === h || !Ee.equals(J) ? Ee.multiplyUnsafe(_e) : Ee.multiply(_e), ve = ye(this, Q).add(ye(q, se));
        return ve.is0() ? void 0 : ve;
      }
      // Converts Projective point to affine (x, y) coordinates.
      // Can accept precomputed Z^-1 - for example, from invertBatch.
      // (x, y, z) ∋ (x=x/z, y=y/z)
      toAffine(q) {
        return ne(this, q);
      }
      isTorsionFree() {
        const { h: q, isTorsionFree: Q } = T;
        if (q === h)
          return !0;
        if (Q)
          return Q(K, this);
        throw new Error("isTorsionFree() has not been declared for the elliptic curve");
      }
      clearCofactor() {
        const { h: q, clearCofactor: Q } = T;
        return q === h ? this : Q ? Q(K, this) : this.multiplyUnsafe(T.h);
      }
      toRawBytes(q = !0) {
        return (0, o.abool)("isCompressed", q), this.assertValidity(), U(K, this, q);
      }
      toHex(q = !0) {
        return (0, o.abool)("isCompressed", q), n.bytesToHex(this.toRawBytes(q));
      }
    }
    K.BASE = new K(T.Gx, T.Gy, A.ONE), K.ZERO = new K(A.ZERO, A.ONE, A.ZERO);
    const le = T.nBitLength, re = (0, t.wNAF)(K, T.endo ? Math.ceil(le / 2) : le);
    return {
      CURVE: T,
      ProjectivePoint: K,
      normPrivateKeyToScalar: ee,
      weierstrassEquation: Y,
      isWithinCurveOrder: L
    };
  }
  function _(S) {
    const T = (0, t.validateBasic)(S);
    return n.validateObject(T, {
      hash: "hash",
      hmac: "function",
      randomBytes: "function"
    }, {
      bits2int: "function",
      bits2int_modN: "function",
      lowS: "boolean"
    }), Object.freeze({ lowS: !0, ...T });
  }
  function O(S) {
    const T = _(S), { Fp: A, n: $ } = T, U = A.BYTES + 1, M = 2 * A.BYTES + 1;
    function Y(ge) {
      return (0, r.mod)(ge, $);
    }
    function L(ge) {
      return (0, r.invert)(ge, $);
    }
    const { ProjectivePoint: ee, normPrivateKeyToScalar: de, weierstrassEquation: ne, isWithinCurveOrder: D } = E({
      ...T,
      toBytes(ge, Te, Oe) {
        const He = Te.toAffine(), mt = A.toBytes(He.x), rt = n.concatBytes;
        return (0, o.abool)("isCompressed", Oe), Oe ? rt(Uint8Array.from([Te.hasEvenY() ? 2 : 3]), mt) : rt(Uint8Array.from([4]), mt, A.toBytes(He.y));
      },
      fromBytes(ge) {
        const Te = ge.length, Oe = ge[0], He = ge.subarray(1);
        if (Te === U && (Oe === 2 || Oe === 3)) {
          const mt = n.bytesToNumberBE(He);
          if (!n.inRange(mt, h, A.ORDER))
            throw new Error("Point is not on curve");
          const rt = ne(mt);
          let Pt;
          try {
            Pt = A.sqrt(rt);
          } catch (yt) {
            const Zt = yt instanceof Error ? ": " + yt.message : "";
            throw new Error("Point is not on curve" + Zt);
          }
          const _t = (Pt & h) === h;
          return (Oe & 1) === 1 !== _t && (Pt = A.neg(Pt)), { x: mt, y: Pt };
        } else if (Te === M && Oe === 4) {
          const mt = A.fromBytes(He.subarray(0, A.BYTES)), rt = A.fromBytes(He.subarray(A.BYTES, 2 * A.BYTES));
          return { x: mt, y: rt };
        } else {
          const mt = U, rt = M;
          throw new Error("invalid Point, expected length of " + mt + ", or uncompressed " + rt + ", got " + Te);
        }
      }
    }), K = (ge) => n.bytesToHex(n.numberToBytesBE(ge, T.nByteLength));
    function le(ge) {
      const Te = $ >> h;
      return ge > Te;
    }
    function re(ge) {
      return le(ge) ? Y(-ge) : ge;
    }
    const G = (ge, Te, Oe) => n.bytesToNumberBE(ge.slice(Te, Oe));
    class q {
      constructor(Te, Oe, He) {
        this.r = Te, this.s = Oe, this.recovery = He, this.assertValidity();
      }
      // pair (bytes of r, bytes of s)
      static fromCompact(Te) {
        const Oe = T.nByteLength;
        return Te = (0, o.ensureBytes)("compactSignature", Te, Oe * 2), new q(G(Te, 0, Oe), G(Te, Oe, 2 * Oe));
      }
      // DER encoded ECDSA signature
      // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
      static fromDER(Te) {
        const { r: Oe, s: He } = e.DER.toSig((0, o.ensureBytes)("DER", Te));
        return new q(Oe, He);
      }
      assertValidity() {
        n.aInRange("r", this.r, h, $), n.aInRange("s", this.s, h, $);
      }
      addRecoveryBit(Te) {
        return new q(this.r, this.s, Te);
      }
      recoverPublicKey(Te) {
        const { r: Oe, s: He, recovery: mt } = this, rt = Ee((0, o.ensureBytes)("msgHash", Te));
        if (mt == null || ![0, 1, 2, 3].includes(mt))
          throw new Error("recovery id invalid");
        const Pt = mt === 2 || mt === 3 ? Oe + T.n : Oe;
        if (Pt >= A.ORDER)
          throw new Error("recovery id 2 or 3 invalid");
        const _t = mt & 1 ? "03" : "02", yt = ee.fromHex(_t + K(Pt)), Zt = L(Pt), yn = Y(-rt * Zt), kt = Y(He * Zt), qr = ee.BASE.multiplyAndAddUnsafe(yt, yn, kt);
        if (!qr)
          throw new Error("point at infinify");
        return qr.assertValidity(), qr;
      }
      // Signatures should be low-s, to prevent malleability.
      hasHighS() {
        return le(this.s);
      }
      normalizeS() {
        return this.hasHighS() ? new q(this.r, Y(-this.s), this.recovery) : this;
      }
      // DER-encoded
      toDERRawBytes() {
        return n.hexToBytes(this.toDERHex());
      }
      toDERHex() {
        return e.DER.hexFromSig({ r: this.r, s: this.s });
      }
      // padded bytes of r, then padded bytes of s
      toCompactRawBytes() {
        return n.hexToBytes(this.toCompactHex());
      }
      toCompactHex() {
        return K(this.r) + K(this.s);
      }
    }
    const Q = {
      isValidPrivateKey(ge) {
        try {
          return de(ge), !0;
        } catch {
          return !1;
        }
      },
      normPrivateKeyToScalar: de,
      /**
       * Produces cryptographically secure private key from random of size
       * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
       */
      randomPrivateKey: () => {
        const ge = (0, r.getMinHashLength)(T.n);
        return (0, r.mapHashToField)(T.randomBytes(ge), T.n);
      },
      /**
       * Creates precompute table for an arbitrary EC point. Makes point "cached".
       * Allows to massively speed-up `point.multiply(scalar)`.
       * @returns cached point
       * @example
       * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
       * fast.multiply(privKey); // much faster ECDH now
       */
      precompute(ge = 8, Te = ee.BASE) {
        return Te._setWindowSize(ge), Te.multiply(BigInt(3)), Te;
      }
    };
    function se(ge, Te = !0) {
      return ee.fromPrivateKey(ge).toRawBytes(Te);
    }
    function J(ge) {
      const Te = n.isBytes(ge), Oe = typeof ge == "string", He = (Te || Oe) && ge.length;
      return Te ? He === U || He === M : Oe ? He === 2 * U || He === 2 * M : ge instanceof ee;
    }
    function ye(ge, Te, Oe = !0) {
      if (J(ge))
        throw new Error("first arg must be private key");
      if (!J(Te))
        throw new Error("second arg must be public key");
      return ee.fromHex(Te).multiply(de(ge)).toRawBytes(Oe);
    }
    const ve = T.bits2int || function(ge) {
      if (ge.length > 8192)
        throw new Error("input is too large");
      const Te = n.bytesToNumberBE(ge), Oe = ge.length * 8 - T.nBitLength;
      return Oe > 0 ? Te >> BigInt(Oe) : Te;
    }, Ee = T.bits2int_modN || function(ge) {
      return Y(ve(ge));
    }, _e = n.bitMask(T.nBitLength);
    function we(ge) {
      return n.aInRange("num < 2^" + T.nBitLength, ge, f, _e), n.numberToBytesBE(ge, T.nByteLength);
    }
    function be(ge, Te, Oe = Ge) {
      if (["recovered", "canonical"].some((v) => v in Oe))
        throw new Error("sign() legacy options not supported");
      const { hash: He, randomBytes: mt } = T;
      let { lowS: rt, prehash: Pt, extraEntropy: _t } = Oe;
      rt == null && (rt = !0), ge = (0, o.ensureBytes)("msgHash", ge), i(Oe), Pt && (ge = (0, o.ensureBytes)("prehashed msgHash", He(ge)));
      const yt = Ee(ge), Zt = de(Te), yn = [we(Zt), we(yt)];
      if (_t != null && _t !== !1) {
        const v = _t === !0 ? mt(A.BYTES) : _t;
        yn.push((0, o.ensureBytes)("extraEntropy", v));
      }
      const kt = n.concatBytes(...yn), qr = yt;
      function m(v) {
        const k = ve(v);
        if (!D(k))
          return;
        const H = L(k), X = ee.BASE.multiply(k).toAffine(), oe = Y(X.x);
        if (oe === f)
          return;
        const me = Y(H * Y(qr + oe * Zt));
        if (me === f)
          return;
        let nt = (X.x === oe ? 0 : 2) | Number(X.y & h), Ct = me;
        return rt && le(me) && (Ct = re(me), nt ^= 1), new q(oe, Ct, nt);
      }
      return { seed: kt, k2sig: m };
    }
    const Ge = { lowS: T.lowS, prehash: !1 }, Le = { lowS: T.lowS, prehash: !1 };
    function Ne(ge, Te, Oe = Ge) {
      const { seed: He, k2sig: mt } = be(ge, Te, Oe), rt = T;
      return n.createHmacDrbg(rt.hash.outputLen, rt.nByteLength, rt.hmac)(He, mt);
    }
    ee.BASE._setWindowSize(8);
    function Ve(ge, Te, Oe, He = Le) {
      var mt;
      const rt = ge;
      Te = (0, o.ensureBytes)("msgHash", Te), Oe = (0, o.ensureBytes)("publicKey", Oe);
      const { lowS: Pt, prehash: _t, format: yt } = He;
      if (i(He), "strict" in He)
        throw new Error("options.strict was renamed to lowS");
      if (yt !== void 0 && yt !== "compact" && yt !== "der")
        throw new Error("format must be compact or der");
      const Zt = typeof rt == "string" || n.isBytes(rt), yn = !Zt && !yt && typeof rt == "object" && rt !== null && typeof rt.r == "bigint" && typeof rt.s == "bigint";
      if (!Zt && !yn)
        throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
      let kt, qr;
      try {
        if (yn && (kt = new q(rt.r, rt.s)), Zt) {
          try {
            yt !== "compact" && (kt = q.fromDER(rt));
          } catch (nt) {
            if (!(nt instanceof e.DER.Err))
              throw nt;
          }
          !kt && yt !== "der" && (kt = q.fromCompact(rt));
        }
        qr = ee.fromHex(Oe);
      } catch {
        return !1;
      }
      if (!kt || Pt && kt.hasHighS())
        return !1;
      _t && (Te = T.hash(Te));
      const { r: m, s: v } = kt, k = Ee(Te), H = L(v), X = Y(k * H), oe = Y(m * H), me = (mt = ee.BASE.multiplyAndAddUnsafe(qr, X, oe)) == null ? void 0 : mt.toAffine();
      return me ? Y(me.x) === m : !1;
    }
    return {
      CURVE: T,
      getPublicKey: se,
      getSharedSecret: ye,
      sign: Ne,
      verify: Ve,
      ProjectivePoint: ee,
      Signature: q,
      utils: Q
    };
  }
  function C(S, T) {
    const A = S.ORDER;
    let $ = f;
    for (let re = A - h; re % g === f; re /= g)
      $ += h;
    const U = $, M = g << U - h - h, Y = M * g, L = (A - h) / Y, ee = (L - h) / g, de = Y - h, ne = M, D = S.pow(T, L), K = S.pow(T, (L + h) / g);
    let le = (re, G) => {
      let q = D, Q = S.pow(G, de), se = S.sqr(Q);
      se = S.mul(se, G);
      let J = S.mul(re, se);
      J = S.pow(J, ee), J = S.mul(J, Q), Q = S.mul(J, G), se = S.mul(J, re);
      let ye = S.mul(se, Q);
      J = S.pow(ye, ne);
      let ve = S.eql(J, S.ONE);
      Q = S.mul(se, K), J = S.mul(ye, q), se = S.cmov(Q, se, ve), ye = S.cmov(J, ye, ve);
      for (let Ee = U; Ee > h; Ee--) {
        let _e = Ee - g;
        _e = g << _e - h;
        let we = S.pow(ye, _e);
        const be = S.eql(we, S.ONE);
        Q = S.mul(se, q), q = S.mul(q, q), we = S.mul(ye, q), se = S.cmov(Q, se, be), ye = S.cmov(we, ye, be);
      }
      return { isValid: ve, value: se };
    };
    if (S.ORDER % w === b) {
      const re = (S.ORDER - b) / w, G = S.sqrt(S.neg(T));
      le = (q, Q) => {
        let se = S.sqr(Q);
        const J = S.mul(q, Q);
        se = S.mul(se, J);
        let ye = S.pow(se, re);
        ye = S.mul(ye, J);
        const ve = S.mul(ye, G), Ee = S.mul(S.sqr(ye), Q), _e = S.eql(Ee, q);
        let we = S.cmov(ve, ye, _e);
        return { isValid: _e, value: we };
      };
    }
    return le;
  }
  function I(S, T) {
    if ((0, r.validateField)(S), !S.isValid(T.A) || !S.isValid(T.B) || !S.isValid(T.Z))
      throw new Error("mapToCurveSimpleSWU: invalid opts");
    const A = C(S, T.Z);
    if (!S.isOdd)
      throw new Error("Fp.isOdd is not implemented!");
    return ($) => {
      let U, M, Y, L, ee, de, ne, D;
      U = S.sqr($), U = S.mul(U, T.Z), M = S.sqr(U), M = S.add(M, U), Y = S.add(M, S.ONE), Y = S.mul(Y, T.B), L = S.cmov(T.Z, S.neg(M), !S.eql(M, S.ZERO)), L = S.mul(L, T.A), M = S.sqr(Y), de = S.sqr(L), ee = S.mul(de, T.A), M = S.add(M, ee), M = S.mul(M, Y), de = S.mul(de, L), ee = S.mul(de, T.B), M = S.add(M, ee), ne = S.mul(U, Y);
      const { isValid: K, value: le } = A(M, de);
      D = S.mul(U, $), D = S.mul(D, le), ne = S.cmov(ne, Y, K), D = S.cmov(D, le, K);
      const re = S.isOdd($) === S.isOdd(D);
      return D = S.cmov(S.neg(D), D, re), ne = S.div(ne, L), { x: ne, y: D };
    };
  }
})(xN);
Object.defineProperty(gE, "__esModule", { value: !0 });
gE.getHash = UZ;
gE.createCurve = eSe;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Jke = Q2, Xz = Vs, Qke = xN;
function UZ(e) {
  return {
    hash: e,
    hmac: (t, ...r) => (0, Jke.hmac)(e, t, (0, Xz.concatBytes)(...r)),
    randomBytes: Xz.randomBytes
  };
}
function eSe(e, t) {
  const r = (n) => (0, Qke.weierstrass)({ ...e, ...UZ(n) });
  return { ...r(t), create: r };
}
var U0 = {};
Object.defineProperty(U0, "__esModule", { value: !0 });
U0.expand_message_xmd = RZ;
U0.expand_message_xof = zZ;
U0.hash_to_field = uP;
U0.isogenyMap = oSe;
U0.createHasher = iSe;
const tSe = mn, $i = Rr, rSe = $i.bytesToNumberBE;
function kd(e, t) {
  if (i2(e), i2(t), e < 0 || e >= 1 << 8 * t)
    throw new Error("invalid I2OSP input: " + e);
  const r = Array.from({ length: t }).fill(0);
  for (let n = t - 1; n >= 0; n--)
    r[n] = e & 255, e >>>= 8;
  return new Uint8Array(r);
}
function nSe(e, t) {
  const r = new Uint8Array(e.length);
  for (let n = 0; n < e.length; n++)
    r[n] = e[n] ^ t[n];
  return r;
}
function i2(e) {
  if (!Number.isSafeInteger(e))
    throw new Error("number expected");
}
function RZ(e, t, r, n) {
  (0, $i.abytes)(e), (0, $i.abytes)(t), i2(r), t.length > 255 && (t = n((0, $i.concatBytes)((0, $i.utf8ToBytes)("H2C-OVERSIZE-DST-"), t)));
  const { outputLen: o, blockLen: i } = n, a = Math.ceil(r / o);
  if (r > 65535 || a > 255)
    throw new Error("expand_message_xmd: invalid lenInBytes");
  const u = (0, $i.concatBytes)(t, kd(t.length, 1)), l = kd(0, i), d = kd(r, 2), f = new Array(a), h = n((0, $i.concatBytes)(l, e, d, kd(0, 1), u));
  f[0] = n((0, $i.concatBytes)(h, kd(1, 1), u));
  for (let g = 1; g <= a; g++) {
    const b = [nSe(h, f[g - 1]), kd(g + 1, 1), u];
    f[g] = n((0, $i.concatBytes)(...b));
  }
  return (0, $i.concatBytes)(...f).slice(0, r);
}
function zZ(e, t, r, n, o) {
  if ((0, $i.abytes)(e), (0, $i.abytes)(t), i2(r), t.length > 255) {
    const i = Math.ceil(2 * n / 8);
    t = o.create({ dkLen: i }).update((0, $i.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(t).digest();
  }
  if (r > 65535 || t.length > 255)
    throw new Error("expand_message_xof: invalid lenInBytes");
  return o.create({ dkLen: r }).update(e).update(kd(r, 2)).update(t).update(kd(t.length, 1)).digest();
}
function uP(e, t, r) {
  (0, $i.validateObject)(r, {
    DST: "stringOrUint8Array",
    p: "bigint",
    m: "isSafeInteger",
    k: "isSafeInteger",
    hash: "hash"
  });
  const { p: n, k: o, m: i, hash: a, expand: u, DST: l } = r;
  (0, $i.abytes)(e), i2(t);
  const d = typeof l == "string" ? (0, $i.utf8ToBytes)(l) : l, f = n.toString(2).length, h = Math.ceil((f + o) / 8), g = t * i * h;
  let b;
  if (u === "xmd")
    b = RZ(e, d, g, a);
  else if (u === "xof")
    b = zZ(e, d, g, o, a);
  else if (u === "_internal_pass")
    b = e;
  else
    throw new Error('expand must be "xmd" or "xof"');
  const w = new Array(t);
  for (let E = 0; E < t; E++) {
    const _ = new Array(i);
    for (let O = 0; O < i; O++) {
      const C = h * (O + E * i), I = b.subarray(C, C + h);
      _[O] = (0, tSe.mod)(rSe(I), n);
    }
    w[E] = _;
  }
  return w;
}
function oSe(e, t) {
  const r = t.map((n) => Array.from(n).reverse());
  return (n, o) => {
    const [i, a, u, l] = r.map((d) => d.reduce((f, h) => e.add(e.mul(f, n), h)));
    return n = e.div(i, a), o = e.mul(o, e.div(u, l)), { x: n, y: o };
  };
}
function iSe(e, t, r) {
  if (typeof t != "function")
    throw new Error("mapToCurve() must be defined");
  return {
    // Encodes byte string to elliptic curve.
    // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
    hashToCurve(n, o) {
      const i = uP(n, 2, { ...r, DST: r.DST, ...o }), a = e.fromAffine(t(i[0])), u = e.fromAffine(t(i[1])), l = a.add(u).clearCofactor();
      return l.assertValidity(), l;
    },
    // Encodes byte string to elliptic curve.
    // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
    encodeToCurve(n, o) {
      const i = uP(n, 1, { ...r, DST: r.encodeDST, ...o }), a = e.fromAffine(t(i[0])).clearCofactor();
      return a.assertValidity(), a;
    },
    // Same as encodeToCurve, but without hash
    mapToCurve(n) {
      if (!Array.isArray(n))
        throw new Error("mapToCurve: expected array of bigints");
      for (const i of n)
        if (typeof i != "bigint")
          throw new Error("mapToCurve: expected array of bigints");
      const o = e.fromAffine(t(n)).clearCofactor();
      return o.assertValidity(), o;
    }
  };
}
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.encodeToCurve = e.hashToCurve = e.schnorr = e.secp256k1 = void 0;
  /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  const t = Ru, r = Vs, n = gE, o = U0, i = mn, a = Rr, u = xN, l = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), d = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), f = BigInt(1), h = BigInt(2), g = (re, G) => (re + G / h) / G;
  function b(re) {
    const G = l, q = BigInt(3), Q = BigInt(6), se = BigInt(11), J = BigInt(22), ye = BigInt(23), ve = BigInt(44), Ee = BigInt(88), _e = re * re * re % G, we = _e * _e * re % G, be = (0, i.pow2)(we, q, G) * we % G, Ge = (0, i.pow2)(be, q, G) * we % G, Le = (0, i.pow2)(Ge, h, G) * _e % G, Ne = (0, i.pow2)(Le, se, G) * Le % G, Ve = (0, i.pow2)(Ne, J, G) * Ne % G, ge = (0, i.pow2)(Ve, ve, G) * Ve % G, Te = (0, i.pow2)(ge, Ee, G) * ge % G, Oe = (0, i.pow2)(Te, ve, G) * Ve % G, He = (0, i.pow2)(Oe, q, G) * we % G, mt = (0, i.pow2)(He, ye, G) * Ne % G, rt = (0, i.pow2)(mt, Q, G) * _e % G, Pt = (0, i.pow2)(rt, h, G);
    if (!w.eql(w.sqr(Pt), re))
      throw new Error("Cannot find square root");
    return Pt;
  }
  const w = (0, i.Field)(l, void 0, void 0, { sqrt: b });
  e.secp256k1 = (0, n.createCurve)({
    a: BigInt(0),
    // equation params: a, b
    b: BigInt(7),
    Fp: w,
    // Field's prime: 2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n
    n: d,
    // Curve order, total count of valid points in the field
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    // Cofactor
    lowS: !0,
    // Allow only low-S signatures by default in sign() and verify()
    endo: {
      // Endomorphism, see above
      beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
      splitScalar: (re) => {
        const G = d, q = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), Q = -f * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), se = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), J = q, ye = BigInt("0x100000000000000000000000000000000"), ve = g(J * re, G), Ee = g(-Q * re, G);
        let _e = (0, i.mod)(re - ve * q - Ee * se, G), we = (0, i.mod)(-ve * Q - Ee * J, G);
        const be = _e > ye, Ge = we > ye;
        if (be && (_e = G - _e), Ge && (we = G - we), _e > ye || we > ye)
          throw new Error("splitScalar: Endomorphism failed, k=" + re);
        return { k1neg: be, k1: _e, k2neg: Ge, k2: we };
      }
    }
  }, t.sha256);
  const E = BigInt(0), _ = {};
  function O(re, ...G) {
    let q = _[re];
    if (q === void 0) {
      const Q = (0, t.sha256)(Uint8Array.from(re, (se) => se.charCodeAt(0)));
      q = (0, a.concatBytes)(Q, Q), _[re] = q;
    }
    return (0, t.sha256)((0, a.concatBytes)(q, ...G));
  }
  const C = (re) => re.toRawBytes(!0).slice(1), I = (re) => (0, a.numberToBytesBE)(re, 32), S = (re) => (0, i.mod)(re, l), T = (re) => (0, i.mod)(re, d), A = e.secp256k1.ProjectivePoint, $ = (re, G, q) => A.BASE.multiplyAndAddUnsafe(re, G, q);
  function U(re) {
    let G = e.secp256k1.utils.normPrivateKeyToScalar(re), q = A.fromPrivateKey(G);
    return { scalar: q.hasEvenY() ? G : T(-G), bytes: C(q) };
  }
  function M(re) {
    (0, a.aInRange)("x", re, f, l);
    const G = S(re * re), q = S(G * re + BigInt(7));
    let Q = b(q);
    Q % h !== E && (Q = S(-Q));
    const se = new A(re, Q, f);
    return se.assertValidity(), se;
  }
  const Y = a.bytesToNumberBE;
  function L(...re) {
    return T(Y(O("BIP0340/challenge", ...re)));
  }
  function ee(re) {
    return U(re).bytes;
  }
  function de(re, G, q = (0, r.randomBytes)(32)) {
    const Q = (0, a.ensureBytes)("message", re), { bytes: se, scalar: J } = U(G), ye = (0, a.ensureBytes)("auxRand", q, 32), ve = I(J ^ Y(O("BIP0340/aux", ye))), Ee = O("BIP0340/nonce", ve, se, Q), _e = T(Y(Ee));
    if (_e === E)
      throw new Error("sign failed: k is zero");
    const { bytes: we, scalar: be } = U(_e), Ge = L(we, se, Q), Le = new Uint8Array(64);
    if (Le.set(we, 0), Le.set(I(T(be + Ge * J)), 32), !ne(Le, Q, se))
      throw new Error("sign: Invalid signature produced");
    return Le;
  }
  function ne(re, G, q) {
    const Q = (0, a.ensureBytes)("signature", re, 64), se = (0, a.ensureBytes)("message", G), J = (0, a.ensureBytes)("publicKey", q, 32);
    try {
      const ye = M(Y(J)), ve = Y(Q.subarray(0, 32));
      if (!(0, a.inRange)(ve, f, l))
        return !1;
      const Ee = Y(Q.subarray(32, 64));
      if (!(0, a.inRange)(Ee, f, d))
        return !1;
      const _e = L(I(ve), C(ye), se), we = $(ye, Ee, T(-_e));
      return !(!we || !we.hasEvenY() || we.toAffine().x !== ve);
    } catch {
      return !1;
    }
  }
  e.schnorr = {
    getPublicKey: ee,
    sign: de,
    verify: ne,
    utils: {
      randomPrivateKey: e.secp256k1.utils.randomPrivateKey,
      lift_x: M,
      pointToBytes: C,
      numberToBytesBE: a.numberToBytesBE,
      bytesToNumberBE: a.bytesToNumberBE,
      taggedHash: O,
      mod: i.mod
    }
  };
  const D = (0, o.isogenyMap)(w, [
    // xNum
    [
      "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
      "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
      "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
      "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
    ],
    // xDen
    [
      "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
      "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
      "0x0000000000000000000000000000000000000000000000000000000000000001"
      // LAST 1
    ],
    // yNum
    [
      "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
      "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
      "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
      "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
    ],
    // yDen
    [
      "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
      "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
      "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
      "0x0000000000000000000000000000000000000000000000000000000000000001"
      // LAST 1
    ]
  ].map((re) => re.map((G) => BigInt(G)))), K = (0, u.mapToCurveSimpleSWU)(w, {
    A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
    B: BigInt("1771"),
    Z: w.create(BigInt("-11"))
  }), le = (0, o.createHasher)(e.secp256k1.ProjectivePoint, (re) => {
    const { x: G, y: q } = K(w.create(re[0]));
    return D(G, q);
  }, {
    DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
    encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
    p: w.ORDER,
    m: 1,
    k: 128,
    expand: "xmd",
    hash: t.sha256
  });
  e.hashToCurve = le.hashToCurve, e.encodeToCurve = le.encodeToCurve;
})(wZ);
var Ii = wZ, aSe = mn, sSe = Rr;
function jZ(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return e && Object.keys(e).forEach(function(r) {
    if (r !== "default") {
      var n = Object.getOwnPropertyDescriptor(e, r);
      Object.defineProperty(t, r, n.get ? n : {
        enumerable: !0,
        get: function() {
          return e[r];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}
var LZ = /* @__PURE__ */ jZ(aSe), Zd = /* @__PURE__ */ jZ(sSe);
const PN = Ii.secp256k1.ProjectivePoint, nh = "Expected Private", oh = "Expected Point", sv = "Expected Tweak", uSe = "Expected Hash", aw = "Expected Signature", CN = "Expected Extra Data (32 bytes)", uv = "Expected Scalar", cSe = "Bad Recovery Id", lSe = 32, fSe = 32, cP = new Uint8Array([
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  254,
  186,
  174,
  220,
  230,
  175,
  72,
  160,
  59,
  191,
  210,
  94,
  140,
  208,
  54,
  65,
  65
]), dSe = 32, hSe = new Uint8Array(32), pSe = new Uint8Array([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  69,
  81,
  35,
  25,
  80,
  183,
  95,
  196,
  64,
  45,
  161,
  114,
  47,
  201,
  186,
  238
]), gSe = BigInt(1);
function mSe(e) {
  return e instanceof Uint8Array;
}
function a2(e, t) {
  for (let r = 0; r < 32; ++r)
    if (e[r] !== t[r])
      return e[r] < t[r] ? -1 : 1;
  return 0;
}
function Yz(e) {
  return a2(e, hSe) === 0;
}
function cv(e) {
  return !(!(e instanceof Uint8Array) || e.length !== fSe || a2(e, cP) >= 0);
}
function BN(e) {
  return e instanceof Uint8Array && e.length === 64 && a2(e.subarray(0, 32), cP) < 0 && a2(e.subarray(32, 64), cP) < 0;
}
function ySe(e) {
  return mSe(e) && e.length === 64 && a2(e.subarray(0, 32), pSe) < 0;
}
function bSe(e) {
  return !(Yz(e.subarray(0, 32)) || Yz(e.subarray(32, 64)));
}
function Lg(e) {
  return e instanceof Uint8Array && e.length === lSe;
}
function NN(e) {
  return e === void 0 || e instanceof Uint8Array && e.length === dSe;
}
function $N(e) {
  let t;
  if (typeof e == "bigint")
    t = e;
  else if (typeof e == "number" && Number.isSafeInteger(e) && e >= 0)
    t = BigInt(e);
  else if (typeof e == "string") {
    if (e.length !== 64)
      throw new Error("Expected 32 bytes of private scalar");
    t = Zd.hexToNumber(e);
  } else if (e instanceof Uint8Array) {
    if (e.length !== 32)
      throw new Error("Expected 32 bytes of private scalar");
    t = Zd.bytesToNumberBE(e);
  } else
    throw new TypeError("Expected valid private scalar");
  if (t < 0) throw new Error("Expected private scalar >= 0");
  return t;
}
function UN(e) {
  return Ii.secp256k1.utils.normPrivateKeyToScalar(e);
}
function wSe(e, t) {
  const r = UN(e), n = $N(t), o = Zd.numberToBytesBE(LZ.mod(r + n, Ii.secp256k1.CURVE.n), 32);
  return Ii.secp256k1.utils.isValidPrivateKey(o) ? o : null;
}
function vSe(e, t) {
  const r = UN(e), n = $N(t), o = Zd.numberToBytesBE(LZ.mod(r - n, Ii.secp256k1.CURVE.n), 32);
  return Ii.secp256k1.utils.isValidPrivateKey(o) ? o : null;
}
function ESe(e) {
  const t = UN(e), r = Zd.numberToBytesBE(Ii.secp256k1.CURVE.n - t, 32);
  return Ii.secp256k1.utils.isValidPrivateKey(r) ? r : null;
}
function HZ(e, t, r) {
  const n = s2(e), o = $N(t), i = PN.BASE.multiplyAndAddUnsafe(n, o, gSe);
  if (!i) throw new Error("Tweaked point at infinity");
  return i.toRawBytes(r);
}
function _Se(e, t, r) {
  const n = s2(e), o = typeof t == "string" ? t : Zd.bytesToHex(t), i = Zd.hexToNumber(o);
  return n.multiply(i).toRawBytes(r);
}
function Hg(e, t) {
  return e === void 0 ? t !== void 0 ? MZ(t) : !0 : !!e;
}
function R0(e) {
  try {
    return e();
  } catch {
    return null;
  }
}
function FZ(e) {
  return Ii.schnorr.utils.lift_x(Zd.bytesToNumberBE(e));
}
function s2(e) {
  return e.length === 32 ? FZ(e) : PN.fromHex(e);
}
function RN(e, t) {
  if (e.length === 32 !== t) return !1;
  try {
    return t ? !!FZ(e) : !!PN.fromHex(e);
  } catch {
    return !1;
  }
}
function Xd(e) {
  return RN(e, !1);
}
function MZ(e) {
  return RN(e, !1) && e.length === 33;
}
function _f(e) {
  return Ii.secp256k1.utils.isValidPrivateKey(e);
}
function EE(e) {
  return RN(e, !0);
}
function ASe(e, t) {
  if (!EE(e))
    throw new Error(oh);
  if (!cv(t))
    throw new Error(sv);
  return R0(() => {
    const r = HZ(e, t, !0);
    return { parity: r[0] % 2 === 1 ? 1 : 0, xOnlyPubkey: r.slice(1) };
  });
}
function DZ(e) {
  if (!Xd(e))
    throw new Error(oh);
  return e.slice(1, 33);
}
function KZ(e, t) {
  if (!_f(e))
    throw new Error(nh);
  return R0(
    () => Ii.secp256k1.getPublicKey(e, Hg(t))
  );
}
function xSe(e) {
  if (!_f(e))
    throw new Error(nh);
  return DZ(KZ(e));
}
function kSe(e, t) {
  if (!Xd(e))
    throw new Error(oh);
  return s2(e).toRawBytes(Hg(t, e));
}
function SSe(e, t, r) {
  if (!Xd(e))
    throw new Error(oh);
  if (!cv(t))
    throw new Error(sv);
  return R0(
    () => _Se(e, t, Hg(r, e))
  );
}
function TSe(e, t, r) {
  if (!Xd(e) || !Xd(t))
    throw new Error(oh);
  return R0(() => {
    const n = s2(e), o = s2(t);
    return n.equals(o.negate()) ? null : n.add(o).toRawBytes(Hg(r, e));
  });
}
function ISe(e, t, r) {
  if (!Xd(e))
    throw new Error(oh);
  if (!cv(t))
    throw new Error(sv);
  return R0(
    () => HZ(e, t, Hg(r, e))
  );
}
function OSe(e, t) {
  if (!_f(e))
    throw new Error(nh);
  if (!cv(t))
    throw new Error(sv);
  return R0(() => wSe(e, t));
}
function PSe(e, t) {
  if (!_f(e))
    throw new Error(nh);
  if (!cv(t))
    throw new Error(sv);
  return R0(() => vSe(e, t));
}
function CSe(e) {
  if (!_f(e))
    throw new Error(nh);
  return ESe(e);
}
function BSe(e, t, r) {
  if (!_f(t))
    throw new Error(nh);
  if (!Lg(e))
    throw new Error(uv);
  if (!NN(r))
    throw new Error(CN);
  return Ii.secp256k1.sign(e, t, { extraEntropy: r }).toCompactRawBytes();
}
function NSe(e, t, r) {
  if (!_f(t))
    throw new Error(nh);
  if (!Lg(e))
    throw new Error(uv);
  if (!NN(r))
    throw new Error(CN);
  const n = Ii.secp256k1.sign(e, t, { extraEntropy: r });
  return {
    signature: n.toCompactRawBytes(),
    recoveryId: n.recovery
  };
}
function $Se(e, t, r) {
  if (!_f(t))
    throw new Error(nh);
  if (!Lg(e))
    throw new Error(uv);
  if (!NN(r))
    throw new Error(CN);
  return Ii.schnorr.sign(e, t, r);
}
function USe(e, t, r, n) {
  if (!Lg(e))
    throw new Error(uSe);
  if (!BN(t) || !bSe(t))
    throw new Error(aw);
  if (r & 2 && !ySe(t))
    throw new Error(cSe);
  if (!EE(t.subarray(0, 32)))
    throw new Error(aw);
  const o = Ii.secp256k1.Signature.fromCompact(t).addRecoveryBit(r).recoverPublicKey(e);
  if (!o) throw new Error(aw);
  return o.toRawBytes(Hg(n));
}
function RSe(e, t, r, n) {
  if (!Xd(t))
    throw new Error(oh);
  if (!BN(r))
    throw new Error(aw);
  if (!Lg(e))
    throw new Error(uv);
  return Ii.secp256k1.verify(r, e, t, { lowS: n });
}
function zSe(e, t, r) {
  if (!EE(t))
    throw new Error(oh);
  if (!BN(r))
    throw new Error(aw);
  if (!Lg(e))
    throw new Error(uv);
  return Ii.schnorr.verify(r, e, t);
}
var jSe = uo.isPoint = Xd, LSe = uo.isPointCompressed = MZ, HSe = uo.isPrivate = _f, FSe = uo.isXOnlyPoint = EE, MSe = uo.pointAdd = TSe, DSe = uo.pointAddScalar = ISe, KSe = uo.pointCompress = kSe, qSe = uo.pointFromScalar = KZ, VSe = uo.pointMultiply = SSe, GSe = uo.privateAdd = OSe, WSe = uo.privateNegate = CSe, ZSe = uo.privateSub = PSe, XSe = uo.recover = USe, YSe = uo.sign = BSe, JSe = uo.signRecoverable = NSe, QSe = uo.signSchnorr = $Se, eTe = uo.verify = RSe, tTe = uo.verifySchnorr = zSe, rTe = uo.xOnlyPointAddTweak = ASe, nTe = uo.xOnlyPointFromPoint = DZ, oTe = uo.xOnlyPointFromScalar = xSe;
const _E = /* @__PURE__ */ rwe({
  __proto__: null,
  default: uo,
  isPoint: jSe,
  isPointCompressed: LSe,
  isPrivate: HSe,
  isXOnlyPoint: FSe,
  pointAdd: MSe,
  pointAddScalar: DSe,
  pointCompress: KSe,
  pointFromScalar: qSe,
  pointMultiply: VSe,
  privateAdd: GSe,
  privateNegate: WSe,
  privateSub: ZSe,
  recover: XSe,
  sign: YSe,
  signRecoverable: JSe,
  signSchnorr: QSe,
  verify: eTe,
  verifySchnorr: tTe,
  xOnlyPointAddTweak: rTe,
  xOnlyPointFromPoint: nTe,
  xOnlyPointFromScalar: oTe
}, [uo]);
var lP = /* @__PURE__ */ ((e) => (e.MAINNET = "fractal_mainnet", e.TESTNET = "fractal_testnet", e))(lP || {}), Gb = /* @__PURE__ */ ((e) => (e.MAINNET = "main", e.TESTNET = "testnet", e.SIGNET = "signet", e))(Gb || {}), _a = /* @__PURE__ */ ((e) => (e.MAINNET = "BITCOIN_MAINNET", e.TESTNET = "BITCOIN_TESTNET", e.TESTNET4 = "BITCOIN_TESTNET4", e.SIGNET = "BITCOIN_SIGNET", e.FRACTAL_MAINNET = "FRACTAL_BITCOIN_MAINNET", e.FRACTAL_TESTNET = "FRACTAL_BITCOIN_TESTNET", e))(_a || {}), ku = /* @__PURE__ */ ((e) => (e.MAINNET = "Mainnet", e.TESTNET = "Testnet", e.SIGNET = "Signet", e.FRACTAL_MAINNET = "fractal mainnet", e.FRACTAL_TESTNET = "fractal testnet", e.TESTNET4 = "Testnet4", e))(ku || {}), fP = /* @__PURE__ */ ((e) => (e.MAINNET = "livenet", e.TESTNET = "testnet", e))(fP || {}), d1 = /* @__PURE__ */ ((e) => (e.MAINNET = "livenet", e.TESTNET = "testnet", e.TESTNET4 = "testnet4", e.SIGNET = "signet", e))(d1 || {}), V8 = /* @__PURE__ */ ((e) => (e.MAINNET = "Mainnet", e.TESTNET = "Testnet", e))(V8 || {}), Ot = /* @__PURE__ */ ((e) => (e.MAINNET = "mainnet", e.SIGNET = "signet", e.TESTNET = "testnet", e.TESTNET4 = "testnet4", e.REGTEST = "regtest", e.FRACTAL_MAINNET = "fractal_mainnet", e.FRACTAL_TESTNET = "fractal_testnet", e))(Ot || {});
const zn = Ot.MAINNET, Fs = Ot.SIGNET, ua = Ot.TESTNET, Ta = Ot.TESTNET4, ih = Ot.FRACTAL_MAINNET, us = Ot.FRACTAL_TESTNET;
Ot.REGTEST;
const JT = (e) => e === Ot.MAINNET ? ku.MAINNET : e === Ot.TESTNET || e === Ot.TESTNET4 ? ku.TESTNET : e === Ot.SIGNET ? ku.SIGNET : (e === Ot.FRACTAL_MAINNET || Ot.FRACTAL_TESTNET, ku.MAINNET), qZ = (e) => e === Ot.MAINNET ? _a.MAINNET : e === Ot.TESTNET ? _a.TESTNET : e === Ot.TESTNET4 ? _a.TESTNET4 : e === Ot.SIGNET ? _a.SIGNET : e === Ot.FRACTAL_MAINNET ? _a.FRACTAL_MAINNET : e === Ot.FRACTAL_TESTNET ? _a.FRACTAL_TESTNET : _a.MAINNET, QT = (e) => e === Ot.MAINNET ? V8.MAINNET : e === Ot.TESTNET || e === Ot.TESTNET4 || e === Ot.SIGNET ? V8.TESTNET : (e === Ot.FRACTAL_MAINNET || Ot.FRACTAL_TESTNET, V8.MAINNET), iTe = (e) => e === Ot.MAINNET ? Gb.MAINNET : e === Ot.TESTNET4 || e === Ot.TESTNET ? Gb.TESTNET : e === Ot.SIGNET ? Gb.SIGNET : (e === Ot.MAINNET || Ot.TESTNET, Gb.MAINNET), _5 = (e) => e === _a.MAINNET ? Ot.MAINNET : e === _a.TESTNET ? Ot.TESTNET : e === _a.TESTNET4 ? Ot.TESTNET4 : e === _a.SIGNET ? Ot.SIGNET : e === _a.FRACTAL_MAINNET ? Ot.FRACTAL_MAINNET : e === _a.FRACTAL_TESTNET ? Ot.TESTNET : Ot.MAINNET, eI = (e) => e === ku.MAINNET ? Ot.MAINNET : e === ku.TESTNET ? Ot.TESTNET : e === ku.TESTNET4 ? Ot.TESTNET4 : e === ku.SIGNET ? Ot.SIGNET : e === ku.FRACTAL_MAINNET ? Ot.FRACTAL_MAINNET : e === ku.FRACTAL_TESTNET ? Ot.FRACTAL_TESTNET : Ot.MAINNET, aTe = (e) => e === fP.MAINNET ? Ot.MAINNET : e === fP.TESTNET ? Ot.TESTNET : Ot.MAINNET, Jz = (e) => e === d1.MAINNET ? Ot.MAINNET : e === d1.TESTNET ? Ot.TESTNET : e === d1.TESTNET4 ? Ot.TESTNET4 : e === d1.SIGNET ? Ot.SIGNET : e === lP.TESTNET ? Ot.TESTNET : (lP.MAINNET, Ot.MAINNET);
function VZ(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: sTe } = Object.prototype, { getPrototypeOf: zN } = Object, AE = /* @__PURE__ */ ((e) => (t) => {
  const r = sTe.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Yu = (e) => (e = e.toLowerCase(), (t) => AE(t) === e), xE = (e) => (t) => typeof t === e, { isArray: Fg } = Array, u2 = xE("undefined");
function uTe(e) {
  return e !== null && !u2(e) && e.constructor !== null && !u2(e.constructor) && ls(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const GZ = Yu("ArrayBuffer");
function cTe(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && GZ(e.buffer), t;
}
const lTe = xE("string"), ls = xE("function"), WZ = xE("number"), kE = (e) => e !== null && typeof e == "object", fTe = (e) => e === !0 || e === !1, G8 = (e) => {
  if (AE(e) !== "object")
    return !1;
  const t = zN(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, dTe = Yu("Date"), hTe = Yu("File"), pTe = Yu("Blob"), gTe = Yu("FileList"), mTe = (e) => kE(e) && ls(e.pipe), yTe = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || ls(e.append) && ((t = AE(e)) === "formdata" || // detect form-data instance
  t === "object" && ls(e.toString) && e.toString() === "[object FormData]"));
}, bTe = Yu("URLSearchParams"), [wTe, vTe, ETe, _Te] = ["ReadableStream", "Request", "Response", "Headers"].map(Yu), ATe = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function lv(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, o;
  if (typeof e != "object" && (e = [e]), Fg(e))
    for (n = 0, o = e.length; n < o; n++)
      t.call(null, e[n], n, e);
  else {
    const i = r ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length;
    let u;
    for (n = 0; n < a; n++)
      u = i[n], t.call(null, e[u], u, e);
  }
}
function ZZ(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, o;
  for (; n-- > 0; )
    if (o = r[n], t === o.toLowerCase())
      return o;
  return null;
}
const Mp = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, XZ = (e) => !u2(e) && e !== Mp;
function dP() {
  const { caseless: e } = XZ(this) && this || {}, t = {}, r = (n, o) => {
    const i = e && ZZ(t, o) || o;
    G8(t[i]) && G8(n) ? t[i] = dP(t[i], n) : G8(n) ? t[i] = dP({}, n) : Fg(n) ? t[i] = n.slice() : t[i] = n;
  };
  for (let n = 0, o = arguments.length; n < o; n++)
    arguments[n] && lv(arguments[n], r);
  return t;
}
const xTe = (e, t, r, { allOwnKeys: n } = {}) => (lv(t, (o, i) => {
  r && ls(o) ? e[i] = VZ(o, r) : e[i] = o;
}, { allOwnKeys: n }), e), kTe = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), STe = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, TTe = (e, t, r, n) => {
  let o, i, a;
  const u = {};
  if (t = t || {}, e == null) return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      a = o[i], (!n || n(a, e, t)) && !u[a] && (t[a] = e[a], u[a] = !0);
    e = r !== !1 && zN(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, ITe = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, OTe = (e) => {
  if (!e) return null;
  if (Fg(e)) return e;
  let t = e.length;
  if (!WZ(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, PTe = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && zN(Uint8Array)), CTe = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let n;
  for (; (n = r.next()) && !n.done; ) {
    const o = n.value;
    t.call(e, o[0], o[1]);
  }
}, BTe = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, NTe = Yu("HTMLFormElement"), $Te = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, r, n) {
    return r.toUpperCase() + n;
  }
), Qz = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), UTe = Yu("RegExp"), YZ = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  lv(r, (o, i) => {
    let a;
    (a = t(o, i, e)) !== !1 && (n[i] = a || o);
  }), Object.defineProperties(e, n);
}, RTe = (e) => {
  YZ(e, (t, r) => {
    if (ls(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (ls(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, zTe = (e, t) => {
  const r = {}, n = (o) => {
    o.forEach((i) => {
      r[i] = !0;
    });
  };
  return Fg(e) ? n(e) : n(String(e).split(t)), r;
}, jTe = () => {
}, LTe = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function HTe(e) {
  return !!(e && ls(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const FTe = (e) => {
  const t = new Array(10), r = (n, o) => {
    if (kE(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[o] = n;
        const i = Fg(n) ? [] : {};
        return lv(n, (a, u) => {
          const l = r(a, o + 1);
          !u2(l) && (i[u] = l);
        }), t[o] = void 0, i;
      }
    }
    return n;
  };
  return r(e, 0);
}, MTe = Yu("AsyncFunction"), DTe = (e) => e && (kE(e) || ls(e)) && ls(e.then) && ls(e.catch), JZ = ((e, t) => e ? setImmediate : t ? ((r, n) => (Mp.addEventListener("message", ({ source: o, data: i }) => {
  o === Mp && i === r && n.length && n.shift()();
}, !1), (o) => {
  n.push(o), Mp.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  ls(Mp.postMessage)
), KTe = typeof queueMicrotask < "u" ? queueMicrotask.bind(Mp) : typeof process < "u" && process.nextTick || JZ, Be = {
  isArray: Fg,
  isArrayBuffer: GZ,
  isBuffer: uTe,
  isFormData: yTe,
  isArrayBufferView: cTe,
  isString: lTe,
  isNumber: WZ,
  isBoolean: fTe,
  isObject: kE,
  isPlainObject: G8,
  isReadableStream: wTe,
  isRequest: vTe,
  isResponse: ETe,
  isHeaders: _Te,
  isUndefined: u2,
  isDate: dTe,
  isFile: hTe,
  isBlob: pTe,
  isRegExp: UTe,
  isFunction: ls,
  isStream: mTe,
  isURLSearchParams: bTe,
  isTypedArray: PTe,
  isFileList: gTe,
  forEach: lv,
  merge: dP,
  extend: xTe,
  trim: ATe,
  stripBOM: kTe,
  inherits: STe,
  toFlatObject: TTe,
  kindOf: AE,
  kindOfTest: Yu,
  endsWith: ITe,
  toArray: OTe,
  forEachEntry: CTe,
  matchAll: BTe,
  isHTMLForm: NTe,
  hasOwnProperty: Qz,
  hasOwnProp: Qz,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: YZ,
  freezeMethods: RTe,
  toObjectSet: zTe,
  toCamelCase: $Te,
  noop: jTe,
  toFiniteNumber: LTe,
  findKey: ZZ,
  global: Mp,
  isContextDefined: XZ,
  isSpecCompliantForm: HTe,
  toJSONObject: FTe,
  isAsyncFn: MTe,
  isThenable: DTe,
  setImmediate: JZ,
  asap: KTe
};
function hr(e, t, r, n, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), o && (this.response = o, this.status = o.status ? o.status : null);
}
Be.inherits(hr, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: Be.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const QZ = hr.prototype, eX = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  eX[e] = { value: e };
});
Object.defineProperties(hr, eX);
Object.defineProperty(QZ, "isAxiosError", { value: !0 });
hr.from = (e, t, r, n, o, i) => {
  const a = Object.create(QZ);
  return Be.toFlatObject(e, a, function(u) {
    return u !== Error.prototype;
  }, (u) => u !== "isAxiosError"), hr.call(a, e.message, t, r, n, o), a.cause = e, a.name = e.name, i && Object.assign(a, i), a;
};
const qTe = null;
function hP(e) {
  return Be.isPlainObject(e) || Be.isArray(e);
}
function tX(e) {
  return Be.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function ej(e, t, r) {
  return e ? e.concat(t).map(function(n, o) {
    return n = tX(n), !r && o ? "[" + n + "]" : n;
  }).join(r ? "." : "") : t;
}
function VTe(e) {
  return Be.isArray(e) && !e.some(hP);
}
const GTe = Be.toFlatObject(Be, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function SE(e, t, r) {
  if (!Be.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = Be.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(b, w) {
    return !Be.isUndefined(w[b]);
  });
  const n = r.metaTokens, o = r.visitor || d, i = r.dots, a = r.indexes, u = (r.Blob || typeof Blob < "u" && Blob) && Be.isSpecCompliantForm(t);
  if (!Be.isFunction(o))
    throw new TypeError("visitor must be a function");
  function l(b) {
    if (b === null) return "";
    if (Be.isDate(b))
      return b.toISOString();
    if (!u && Be.isBlob(b))
      throw new hr("Blob is not supported. Use a Buffer instead.");
    return Be.isArrayBuffer(b) || Be.isTypedArray(b) ? u && typeof Blob == "function" ? new Blob([b]) : Buffer.from(b) : b;
  }
  function d(b, w, E) {
    let _ = b;
    if (b && !E && typeof b == "object") {
      if (Be.endsWith(w, "{}"))
        w = n ? w : w.slice(0, -2), b = JSON.stringify(b);
      else if (Be.isArray(b) && VTe(b) || (Be.isFileList(b) || Be.endsWith(w, "[]")) && (_ = Be.toArray(b)))
        return w = tX(w), _.forEach(function(O, C) {
          !(Be.isUndefined(O) || O === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? ej([w], C, i) : a === null ? w : w + "[]",
            l(O)
          );
        }), !1;
    }
    return hP(b) ? !0 : (t.append(ej(E, w, i), l(b)), !1);
  }
  const f = [], h = Object.assign(GTe, {
    defaultVisitor: d,
    convertValue: l,
    isVisitable: hP
  });
  function g(b, w) {
    if (!Be.isUndefined(b)) {
      if (f.indexOf(b) !== -1)
        throw Error("Circular reference detected in " + w.join("."));
      f.push(b), Be.forEach(b, function(E, _) {
        (!(Be.isUndefined(E) || E === null) && o.call(
          t,
          E,
          Be.isString(_) ? _.trim() : _,
          w,
          h
        )) === !0 && g(E, w ? w.concat(_) : [_]);
      }), f.pop();
    }
  }
  if (!Be.isObject(e))
    throw new TypeError("data must be an object");
  return g(e), t;
}
function tj(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function jN(e, t) {
  this._pairs = [], e && SE(e, this, t);
}
const rX = jN.prototype;
rX.append = function(e, t) {
  this._pairs.push([e, t]);
};
rX.toString = function(e) {
  const t = e ? function(r) {
    return e.call(this, r, tj);
  } : tj;
  return this._pairs.map(function(r) {
    return t(r[0]) + "=" + t(r[1]);
  }, "").join("&");
};
function WTe(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function nX(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || WTe;
  Be.isFunction(r) && (r = {
    serialize: r
  });
  const o = r && r.serialize;
  let i;
  if (o ? i = o(t, r) : i = Be.isURLSearchParams(t) ? t.toString() : new jN(t, r).toString(n), i) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class rj {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    Be.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const oX = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, ZTe = typeof URLSearchParams < "u" ? URLSearchParams : jN, XTe = typeof FormData < "u" ? FormData : null, YTe = typeof Blob < "u" ? Blob : null, JTe = {
  isBrowser: !0,
  classes: {
    URLSearchParams: ZTe,
    FormData: XTe,
    Blob: YTe
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, LN = typeof window < "u" && typeof document < "u", pP = typeof navigator == "object" && navigator || void 0, QTe = LN && (!pP || ["ReactNative", "NativeScript", "NS"].indexOf(pP.product) < 0), eIe = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", tIe = LN && window.location.href || "http://localhost", rIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: LN,
  hasStandardBrowserEnv: QTe,
  hasStandardBrowserWebWorkerEnv: eIe,
  navigator: pP,
  origin: tIe
}, Symbol.toStringTag, { value: "Module" })), Hi = {
  ...rIe,
  ...JTe
};
function nIe(e, t) {
  return SE(e, new Hi.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, o, i) {
      return Hi.isNode && Be.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function oIe(e) {
  return Be.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function iIe(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const o = r.length;
  let i;
  for (n = 0; n < o; n++)
    i = r[n], t[i] = e[i];
  return t;
}
function iX(e) {
  function t(r, n, o, i) {
    let a = r[i++];
    if (a === "__proto__") return !0;
    const u = Number.isFinite(+a), l = i >= r.length;
    return a = !a && Be.isArray(o) ? o.length : a, l ? (Be.hasOwnProp(o, a) ? o[a] = [o[a], n] : o[a] = n, !u) : ((!o[a] || !Be.isObject(o[a])) && (o[a] = []), t(r, n, o[a], i) && Be.isArray(o[a]) && (o[a] = iIe(o[a])), !u);
  }
  if (Be.isFormData(e) && Be.isFunction(e.entries)) {
    const r = {};
    return Be.forEachEntry(e, (n, o) => {
      t(oIe(n), o, r, 0);
    }), r;
  }
  return null;
}
function aIe(e, t, r) {
  if (Be.isString(e))
    try {
      return (t || JSON.parse)(e), Be.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const fv = {
  transitional: oX,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const r = t.getContentType() || "", n = r.indexOf("application/json") > -1, o = Be.isObject(e);
    if (o && Be.isHTMLForm(e) && (e = new FormData(e)), Be.isFormData(e))
      return n ? JSON.stringify(iX(e)) : e;
    if (Be.isArrayBuffer(e) || Be.isBuffer(e) || Be.isStream(e) || Be.isFile(e) || Be.isBlob(e) || Be.isReadableStream(e))
      return e;
    if (Be.isArrayBufferView(e))
      return e.buffer;
    if (Be.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let i;
    if (o) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return nIe(e, this.formSerializer).toString();
      if ((i = Be.isFileList(e)) || r.indexOf("multipart/form-data") > -1) {
        const a = this.env && this.env.FormData;
        return SE(
          i ? { "files[]": e } : e,
          a && new a(),
          this.formSerializer
        );
      }
    }
    return o || n ? (t.setContentType("application/json", !1), aIe(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || fv.transitional, r = t && t.forcedJSONParsing, n = this.responseType === "json";
    if (Be.isResponse(e) || Be.isReadableStream(e))
      return e;
    if (e && Be.isString(e) && (r && !this.responseType || n)) {
      const o = !(t && t.silentJSONParsing) && n;
      try {
        return JSON.parse(e);
      } catch (i) {
        if (o)
          throw i.name === "SyntaxError" ? hr.from(i, hr.ERR_BAD_RESPONSE, this, null, this.response) : i;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Hi.classes.FormData,
    Blob: Hi.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
Be.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  fv.headers[e] = {};
});
const sIe = Be.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), uIe = (e) => {
  const t = {};
  let r, n, o;
  return e && e.split(`
`).forEach(function(i) {
    o = i.indexOf(":"), r = i.substring(0, o).trim().toLowerCase(), n = i.substring(o + 1).trim(), !(!r || t[r] && sIe[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, nj = Symbol("internals");
function Hb(e) {
  return e && String(e).trim().toLowerCase();
}
function W8(e) {
  return e === !1 || e == null ? e : Be.isArray(e) ? e.map(W8) : String(e);
}
function cIe(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const lIe = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function tI(e, t, r, n, o) {
  if (Be.isFunction(n))
    return n.call(this, t, r);
  if (o && (t = r), !!Be.isString(t)) {
    if (Be.isString(n))
      return t.indexOf(n) !== -1;
    if (Be.isRegExp(n))
      return n.test(t);
  }
}
function fIe(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function dIe(e, t) {
  const r = Be.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(o, i, a) {
        return this[n].call(this, t, o, i, a);
      },
      configurable: !0
    });
  });
}
let Na = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, r) {
    const n = this;
    function o(a, u, l) {
      const d = Hb(u);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const f = Be.findKey(n, d);
      (!f || n[f] === void 0 || l === !0 || l === void 0 && n[f] !== !1) && (n[f || u] = W8(a));
    }
    const i = (a, u) => Be.forEach(a, (l, d) => o(l, d, u));
    if (Be.isPlainObject(e) || e instanceof this.constructor)
      i(e, t);
    else if (Be.isString(e) && (e = e.trim()) && !lIe(e))
      i(uIe(e), t);
    else if (Be.isHeaders(e))
      for (const [a, u] of e.entries())
        o(u, a, r);
    else
      e != null && o(t, e, r);
    return this;
  }
  get(e, t) {
    if (e = Hb(e), e) {
      const r = Be.findKey(this, e);
      if (r) {
        const n = this[r];
        if (!t)
          return n;
        if (t === !0)
          return cIe(n);
        if (Be.isFunction(t))
          return t.call(this, n, r);
        if (Be.isRegExp(t))
          return t.exec(n);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = Hb(e), e) {
      const r = Be.findKey(this, e);
      return !!(r && this[r] !== void 0 && (!t || tI(this, this[r], r, t)));
    }
    return !1;
  }
  delete(e, t) {
    const r = this;
    let n = !1;
    function o(i) {
      if (i = Hb(i), i) {
        const a = Be.findKey(r, i);
        a && (!t || tI(r, r[a], a, t)) && (delete r[a], n = !0);
      }
    }
    return Be.isArray(e) ? e.forEach(o) : o(e), n;
  }
  clear(e) {
    const t = Object.keys(this);
    let r = t.length, n = !1;
    for (; r--; ) {
      const o = t[r];
      (!e || tI(this, this[o], o, e, !0)) && (delete this[o], n = !0);
    }
    return n;
  }
  normalize(e) {
    const t = this, r = {};
    return Be.forEach(this, (n, o) => {
      const i = Be.findKey(r, o);
      if (i) {
        t[i] = W8(n), delete t[o];
        return;
      }
      const a = e ? fIe(o) : String(o).trim();
      a !== o && delete t[o], t[a] = W8(n), r[a] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return Be.forEach(this, (r, n) => {
      r != null && r !== !1 && (t[n] = e && Be.isArray(r) ? r.join(", ") : r);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const r = new this(e);
    return t.forEach((n) => r.set(n)), r;
  }
  static accessor(e) {
    const t = (this[nj] = this[nj] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function n(o) {
      const i = Hb(o);
      t[i] || (dIe(r, o), t[i] = !0);
    }
    return Be.isArray(e) ? e.forEach(n) : n(e), this;
  }
};
Na.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
Be.reduceDescriptors(Na.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
Be.freezeMethods(Na);
function rI(e, t) {
  const r = this || fv, n = t || r, o = Na.from(n.headers);
  let i = n.data;
  return Be.forEach(e, function(a) {
    i = a.call(r, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function aX(e) {
  return !!(e && e.__CANCEL__);
}
function Mg(e, t, r) {
  hr.call(this, e ?? "canceled", hr.ERR_CANCELED, t, r), this.name = "CanceledError";
}
Be.inherits(Mg, hr, {
  __CANCEL__: !0
});
function sX(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new hr(
    "Request failed with status code " + r.status,
    [hr.ERR_BAD_REQUEST, hr.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function hIe(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function pIe(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let o = 0, i = 0, a;
  return t = t !== void 0 ? t : 1e3, function(u) {
    const l = Date.now(), d = n[i];
    a || (a = l), r[o] = u, n[o] = l;
    let f = i, h = 0;
    for (; f !== o; )
      h += r[f++], f = f % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), l - a < t)
      return;
    const g = d && l - d;
    return g ? Math.round(h * 1e3 / g) : void 0;
  };
}
function gIe(e, t) {
  let r = 0, n = 1e3 / t, o, i;
  const a = (u, l = Date.now()) => {
    r = l, o = null, i && (clearTimeout(i), i = null), e.apply(null, u);
  };
  return [(...u) => {
    const l = Date.now(), d = l - r;
    d >= n ? a(u, l) : (o = u, i || (i = setTimeout(() => {
      i = null, a(o);
    }, n - d)));
  }, () => o && a(o)];
}
const A5 = (e, t, r = 3) => {
  let n = 0;
  const o = pIe(50, 250);
  return gIe((i) => {
    const a = i.loaded, u = i.lengthComputable ? i.total : void 0, l = a - n, d = o(l), f = a <= u;
    n = a;
    const h = {
      loaded: a,
      total: u,
      progress: u ? a / u : void 0,
      bytes: l,
      rate: d || void 0,
      estimated: d && u && f ? (u - a) / d : void 0,
      event: i,
      lengthComputable: u != null,
      [t ? "download" : "upload"]: !0
    };
    e(h);
  }, r);
}, oj = (e, t) => {
  const r = e != null;
  return [(n) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: n
  }), t[1]];
}, ij = (e) => (...t) => Be.asap(() => e(...t)), mIe = Hi.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (r) => (r = new URL(r, Hi.origin), e.protocol === r.protocol && e.host === r.host && (t || e.port === r.port)))(
  new URL(Hi.origin),
  Hi.navigator && /(msie|trident)/i.test(Hi.navigator.userAgent)
) : () => !0, yIe = Hi.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, o, i) {
      const a = [e + "=" + encodeURIComponent(t)];
      Be.isNumber(r) && a.push("expires=" + new Date(r).toGMTString()), Be.isString(n) && a.push("path=" + n), Be.isString(o) && a.push("domain=" + o), i === !0 && a.push("secure"), document.cookie = a.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function bIe(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function wIe(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function uX(e, t, r) {
  let n = !bIe(t);
  return e && (n || r == !1) ? wIe(e, t) : t;
}
const aj = (e) => e instanceof Na ? { ...e } : e;
function g0(e, t) {
  t = t || {};
  const r = {};
  function n(d, f, h, g) {
    return Be.isPlainObject(d) && Be.isPlainObject(f) ? Be.merge.call({ caseless: g }, d, f) : Be.isPlainObject(f) ? Be.merge({}, f) : Be.isArray(f) ? f.slice() : f;
  }
  function o(d, f, h, g) {
    if (Be.isUndefined(f)) {
      if (!Be.isUndefined(d))
        return n(void 0, d, h, g);
    } else return n(d, f, h, g);
  }
  function i(d, f) {
    if (!Be.isUndefined(f))
      return n(void 0, f);
  }
  function a(d, f) {
    if (Be.isUndefined(f)) {
      if (!Be.isUndefined(d))
        return n(void 0, d);
    } else return n(void 0, f);
  }
  function u(d, f, h) {
    if (h in t)
      return n(d, f);
    if (h in e)
      return n(void 0, d);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: u,
    headers: (d, f, h) => o(aj(d), aj(f), h, !0)
  };
  return Be.forEach(Object.keys(Object.assign({}, e, t)), function(d) {
    const f = l[d] || o, h = f(e[d], t[d], d);
    Be.isUndefined(h) && f !== u || (r[d] = h);
  }), r;
}
const cX = (e) => {
  const t = g0({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: o, xsrfCookieName: i, headers: a, auth: u } = t;
  t.headers = a = Na.from(a), t.url = nX(uX(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), u && a.set(
    "Authorization",
    "Basic " + btoa((u.username || "") + ":" + (u.password ? unescape(encodeURIComponent(u.password)) : ""))
  );
  let l;
  if (Be.isFormData(r)) {
    if (Hi.hasStandardBrowserEnv || Hi.hasStandardBrowserWebWorkerEnv)
      a.setContentType(void 0);
    else if ((l = a.getContentType()) !== !1) {
      const [d, ...f] = l ? l.split(";").map((h) => h.trim()).filter(Boolean) : [];
      a.setContentType([d || "multipart/form-data", ...f].join("; "));
    }
  }
  if (Hi.hasStandardBrowserEnv && (n && Be.isFunction(n) && (n = n(t)), n || n !== !1 && mIe(t.url))) {
    const d = o && i && yIe.read(i);
    d && a.set(o, d);
  }
  return t;
}, vIe = typeof XMLHttpRequest < "u", EIe = vIe && function(e) {
  return new Promise(function(t, r) {
    const n = cX(e);
    let o = n.data;
    const i = Na.from(n.headers).normalize();
    let { responseType: a, onUploadProgress: u, onDownloadProgress: l } = n, d, f, h, g, b;
    function w() {
      g && g(), b && b(), n.cancelToken && n.cancelToken.unsubscribe(d), n.signal && n.signal.removeEventListener("abort", d);
    }
    let E = new XMLHttpRequest();
    E.open(n.method.toUpperCase(), n.url, !0), E.timeout = n.timeout;
    function _() {
      if (!E)
        return;
      const C = Na.from(
        "getAllResponseHeaders" in E && E.getAllResponseHeaders()
      ), I = {
        data: !a || a === "text" || a === "json" ? E.responseText : E.response,
        status: E.status,
        statusText: E.statusText,
        headers: C,
        config: e,
        request: E
      };
      sX(function(S) {
        t(S), w();
      }, function(S) {
        r(S), w();
      }, I), E = null;
    }
    "onloadend" in E ? E.onloadend = _ : E.onreadystatechange = function() {
      !E || E.readyState !== 4 || E.status === 0 && !(E.responseURL && E.responseURL.indexOf("file:") === 0) || setTimeout(_);
    }, E.onabort = function() {
      E && (r(new hr("Request aborted", hr.ECONNABORTED, e, E)), E = null);
    }, E.onerror = function() {
      r(new hr("Network Error", hr.ERR_NETWORK, e, E)), E = null;
    }, E.ontimeout = function() {
      let C = n.timeout ? "timeout of " + n.timeout + "ms exceeded" : "timeout exceeded";
      const I = n.transitional || oX;
      n.timeoutErrorMessage && (C = n.timeoutErrorMessage), r(new hr(
        C,
        I.clarifyTimeoutError ? hr.ETIMEDOUT : hr.ECONNABORTED,
        e,
        E
      )), E = null;
    }, o === void 0 && i.setContentType(null), "setRequestHeader" in E && Be.forEach(i.toJSON(), function(C, I) {
      E.setRequestHeader(I, C);
    }), Be.isUndefined(n.withCredentials) || (E.withCredentials = !!n.withCredentials), a && a !== "json" && (E.responseType = n.responseType), l && ([h, b] = A5(l, !0), E.addEventListener("progress", h)), u && E.upload && ([f, g] = A5(u), E.upload.addEventListener("progress", f), E.upload.addEventListener("loadend", g)), (n.cancelToken || n.signal) && (d = (C) => {
      E && (r(!C || C.type ? new Mg(null, e, E) : C), E.abort(), E = null);
    }, n.cancelToken && n.cancelToken.subscribe(d), n.signal && (n.signal.aborted ? d() : n.signal.addEventListener("abort", d)));
    const O = hIe(n.url);
    if (O && Hi.protocols.indexOf(O) === -1) {
      r(new hr("Unsupported protocol " + O + ":", hr.ERR_BAD_REQUEST, e));
      return;
    }
    E.send(o || null);
  });
}, _Ie = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let n = new AbortController(), o;
    const i = function(d) {
      if (!o) {
        o = !0, u();
        const f = d instanceof Error ? d : this.reason;
        n.abort(f instanceof hr ? f : new Mg(f instanceof Error ? f.message : f));
      }
    };
    let a = t && setTimeout(() => {
      a = null, i(new hr(`timeout ${t} of ms exceeded`, hr.ETIMEDOUT));
    }, t);
    const u = () => {
      e && (a && clearTimeout(a), a = null, e.forEach((d) => {
        d.unsubscribe ? d.unsubscribe(i) : d.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((d) => d.addEventListener("abort", i));
    const { signal: l } = n;
    return l.unsubscribe = () => Be.asap(u), l;
  }
}, AIe = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, o;
  for (; n < r; )
    o = n + t, yield e.slice(n, o), n = o;
}, xIe = async function* (e, t) {
  for await (const r of kIe(e))
    yield* AIe(r, t);
}, kIe = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await t.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, sj = (e, t, r, n) => {
  const o = xIe(e, t);
  let i = 0, a, u = (l) => {
    a || (a = !0, n && n(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: d, value: f } = await o.next();
        if (d) {
          u(), l.close();
          return;
        }
        let h = f.byteLength;
        if (r) {
          let g = i += h;
          r(g);
        }
        l.enqueue(new Uint8Array(f));
      } catch (d) {
        throw u(d), d;
      }
    },
    cancel(l) {
      return u(l), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, TE = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", lX = TE && typeof ReadableStream == "function", SIe = TE && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), fX = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, TIe = lX && fX(() => {
  let e = !1;
  const t = new Request(Hi.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), uj = 64 * 1024, gP = lX && fX(() => Be.isReadableStream(new Response("").body)), x5 = {
  stream: gP && ((e) => e.body)
};
TE && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !x5[t] && (x5[t] = Be.isFunction(e[t]) ? (r) => r[t]() : (r, n) => {
      throw new hr(`Response type '${t}' is not supported`, hr.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const IIe = async (e) => {
  if (e == null)
    return 0;
  if (Be.isBlob(e))
    return e.size;
  if (Be.isSpecCompliantForm(e))
    return (await new Request(Hi.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (Be.isArrayBufferView(e) || Be.isArrayBuffer(e))
    return e.byteLength;
  if (Be.isURLSearchParams(e) && (e = e + ""), Be.isString(e))
    return (await SIe(e)).byteLength;
}, OIe = async (e, t) => Be.toFiniteNumber(e.getContentLength()) ?? IIe(t), PIe = TE && (async (e) => {
  let {
    url: t,
    method: r,
    data: n,
    signal: o,
    cancelToken: i,
    timeout: a,
    onDownloadProgress: u,
    onUploadProgress: l,
    responseType: d,
    headers: f,
    withCredentials: h = "same-origin",
    fetchOptions: g
  } = cX(e);
  d = d ? (d + "").toLowerCase() : "text";
  let b = _Ie([o, i && i.toAbortSignal()], a), w;
  const E = b && b.unsubscribe && (() => {
    b.unsubscribe();
  });
  let _;
  try {
    if (l && TIe && r !== "get" && r !== "head" && (_ = await OIe(f, n)) !== 0) {
      let T = new Request(t, {
        method: "POST",
        body: n,
        duplex: "half"
      }), A;
      if (Be.isFormData(n) && (A = T.headers.get("content-type")) && f.setContentType(A), T.body) {
        const [$, U] = oj(
          _,
          A5(ij(l))
        );
        n = sj(T.body, uj, $, U);
      }
    }
    Be.isString(h) || (h = h ? "include" : "omit");
    const O = "credentials" in Request.prototype;
    w = new Request(t, {
      ...g,
      signal: b,
      method: r.toUpperCase(),
      headers: f.normalize().toJSON(),
      body: n,
      duplex: "half",
      credentials: O ? h : void 0
    });
    let C = await fetch(w);
    const I = gP && (d === "stream" || d === "response");
    if (gP && (u || I && E)) {
      const T = {};
      ["status", "statusText", "headers"].forEach((M) => {
        T[M] = C[M];
      });
      const A = Be.toFiniteNumber(C.headers.get("content-length")), [$, U] = u && oj(
        A,
        A5(ij(u), !0)
      ) || [];
      C = new Response(
        sj(C.body, uj, $, () => {
          U && U(), E && E();
        }),
        T
      );
    }
    d = d || "text";
    let S = await x5[Be.findKey(x5, d) || "text"](C, e);
    return !I && E && E(), await new Promise((T, A) => {
      sX(T, A, {
        data: S,
        headers: Na.from(C.headers),
        status: C.status,
        statusText: C.statusText,
        config: e,
        request: w
      });
    });
  } catch (O) {
    throw E && E(), O && O.name === "TypeError" && /fetch/i.test(O.message) ? Object.assign(
      new hr("Network Error", hr.ERR_NETWORK, e, w),
      {
        cause: O.cause || O
      }
    ) : hr.from(O, O && O.code, e, w);
  }
}), mP = {
  http: qTe,
  xhr: EIe,
  fetch: PIe
};
Be.forEach(mP, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const cj = (e) => `- ${e}`, CIe = (e) => Be.isFunction(e) || e === null || e === !1, dX = {
  getAdapter: (e) => {
    e = Be.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    const o = {};
    for (let i = 0; i < t; i++) {
      r = e[i];
      let a;
      if (n = r, !CIe(r) && (n = mP[(a = String(r)).toLowerCase()], n === void 0))
        throw new hr(`Unknown adapter '${a}'`);
      if (n)
        break;
      o[a || "#" + i] = n;
    }
    if (!n) {
      const i = Object.entries(o).map(
        ([u, l]) => `adapter ${u} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = t ? i.length > 1 ? `since :
` + i.map(cj).join(`
`) : " " + cj(i[0]) : "as no adapter specified";
      throw new hr(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: mP
};
function nI(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Mg(null, e);
}
function lj(e) {
  return nI(e), e.headers = Na.from(e.headers), e.data = rI.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), dX.getAdapter(e.adapter || fv.adapter)(e).then(function(t) {
    return nI(e), t.data = rI.call(
      e,
      e.transformResponse,
      t
    ), t.headers = Na.from(t.headers), t;
  }, function(t) {
    return aX(t) || (nI(e), t && t.response && (t.response.data = rI.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = Na.from(t.response.headers))), Promise.reject(t);
  });
}
const hX = "1.8.4", IE = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  IE[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const fj = {};
IE.transitional = function(e, t, r) {
  function n(o, i) {
    return "[Axios v" + hX + "] Transitional option '" + o + "'" + i + (r ? ". " + r : "");
  }
  return (o, i, a) => {
    if (e === !1)
      throw new hr(
        n(i, " has been removed" + (t ? " in " + t : "")),
        hr.ERR_DEPRECATED
      );
    return t && !fj[i] && (fj[i] = !0, console.warn(
      n(
        i,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(o, i, a) : !0;
  };
};
IE.spelling = function(e) {
  return (t, r) => (console.warn(`${r} is likely a misspelling of ${e}`), !0);
};
function BIe(e, t, r) {
  if (typeof e != "object")
    throw new hr("options must be an object", hr.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let o = n.length;
  for (; o-- > 0; ) {
    const i = n[o], a = t[i];
    if (a) {
      const u = e[i], l = u === void 0 || a(u, i, e);
      if (l !== !0)
        throw new hr("option " + i + " must be " + l, hr.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new hr("Unknown option " + i, hr.ERR_BAD_OPTION);
  }
}
const Z8 = {
  assertOptions: BIe,
  validators: IE
}, pc = Z8.validators;
let Jp = class {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new rj(),
      response: new rj()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (r) {
      if (r instanceof Error) {
        let n = {};
        Error.captureStackTrace ? Error.captureStackTrace(n) : n = new Error();
        const o = n.stack ? n.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? o && !String(r.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + o) : r.stack = o;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = g0(this.defaults, t);
    const { transitional: r, paramsSerializer: n, headers: o } = t;
    r !== void 0 && Z8.assertOptions(r, {
      silentJSONParsing: pc.transitional(pc.boolean),
      forcedJSONParsing: pc.transitional(pc.boolean),
      clarifyTimeoutError: pc.transitional(pc.boolean)
    }, !1), n != null && (Be.isFunction(n) ? t.paramsSerializer = {
      serialize: n
    } : Z8.assertOptions(n, {
      encode: pc.function,
      serialize: pc.function
    }, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), Z8.assertOptions(t, {
      baseUrl: pc.spelling("baseURL"),
      withXsrfToken: pc.spelling("withXSRFToken")
    }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let i = o && Be.merge(
      o.common,
      o[t.method]
    );
    o && Be.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (b) => {
        delete o[b];
      }
    ), t.headers = Na.concat(i, o);
    const a = [];
    let u = !0;
    this.interceptors.request.forEach(function(b) {
      typeof b.runWhen == "function" && b.runWhen(t) === !1 || (u = u && b.synchronous, a.unshift(b.fulfilled, b.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(b) {
      l.push(b.fulfilled, b.rejected);
    });
    let d, f = 0, h;
    if (!u) {
      const b = [lj.bind(this), void 0];
      for (b.unshift.apply(b, a), b.push.apply(b, l), h = b.length, d = Promise.resolve(t); f < h; )
        d = d.then(b[f++], b[f++]);
      return d;
    }
    h = a.length;
    let g = t;
    for (f = 0; f < h; ) {
      const b = a[f++], w = a[f++];
      try {
        g = b(g);
      } catch (E) {
        w.call(this, E);
        break;
      }
    }
    try {
      d = lj.call(this, g);
    } catch (b) {
      return Promise.reject(b);
    }
    for (f = 0, h = l.length; f < h; )
      d = d.then(l[f++], l[f++]);
    return d;
  }
  getUri(e) {
    e = g0(this.defaults, e);
    const t = uX(e.baseURL, e.url, e.allowAbsoluteUrls);
    return nX(t, e.params, e.paramsSerializer);
  }
};
Be.forEach(["delete", "get", "head", "options"], function(e) {
  Jp.prototype[e] = function(t, r) {
    return this.request(g0(r || {}, {
      method: e,
      url: t,
      data: (r || {}).data
    }));
  };
});
Be.forEach(["post", "put", "patch"], function(e) {
  function t(r) {
    return function(n, o, i) {
      return this.request(g0(i || {}, {
        method: e,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: n,
        data: o
      }));
    };
  }
  Jp.prototype[e] = t(), Jp.prototype[e + "Form"] = t(!0);
});
let NIe = class pX {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const n = this;
    this.promise.then((o) => {
      if (!n._listeners) return;
      let i = n._listeners.length;
      for (; i-- > 0; )
        n._listeners[i](o);
      n._listeners = null;
    }), this.promise.then = (o) => {
      let i;
      const a = new Promise((u) => {
        n.subscribe(u), i = u;
      }).then(o);
      return a.cancel = function() {
        n.unsubscribe(i);
      }, a;
    }, t(function(o, i, a) {
      n.reason || (n.reason = new Mg(o, i, a), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (n) => {
      t.abort(n);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new pX(function(r) {
        t = r;
      }),
      cancel: t
    };
  }
};
function $Ie(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function UIe(e) {
  return Be.isObject(e) && e.isAxiosError === !0;
}
const yP = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(yP).forEach(([e, t]) => {
  yP[t] = e;
});
function gX(e) {
  const t = new Jp(e), r = VZ(Jp.prototype.request, t);
  return Be.extend(r, Jp.prototype, t, { allOwnKeys: !0 }), Be.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(n) {
    return gX(g0(e, n));
  }, r;
}
const un = gX(fv);
un.Axios = Jp;
un.CanceledError = Mg;
un.CancelToken = NIe;
un.isCancel = aX;
un.VERSION = hX;
un.toFormData = SE;
un.AxiosError = hr;
un.Cancel = un.CanceledError;
un.all = function(e) {
  return Promise.all(e);
};
un.spread = $Ie;
un.isAxiosError = UIe;
un.mergeConfig = g0;
un.AxiosHeaders = Na;
un.formToJSON = (e) => iX(Be.isHTMLForm(e) ? new FormData(e) : e);
un.getAdapter = dX.getAdapter;
un.HttpStatusCode = yP;
un.default = un;
const {
  Axios: JRe,
  AxiosError: QRe,
  CanceledError: eze,
  isCancel: tze,
  CancelToken: rze,
  VERSION: nze,
  all: oze,
  Cancel: ize,
  isAxiosError: aze,
  spread: sze,
  toFormData: uze,
  AxiosHeaders: cze,
  HttpStatusCode: lze,
  formToJSON: fze,
  getAdapter: dze,
  mergeConfig: hze
} = un, HN = "https://mainnet.sandshrew.io/v1/", sw = "lasereyes", RIe = "VIOi9IApvUkDFWBQ7I9oHsfUMWOIfDeO", zIe = "bVG4GSXShooC9f67hq5YQWAJfZyRPrEN", jIe = "https://xbt-mainnet.gomaestro-api.org/v0", LIe = "https://xbt-testnet.gomaestro-api.org/v0", HIe = "https://mempool.space", FIe = "https://mempool.space/testnet", MIe = "https://mempool.space/testnet4", DIe = "https://mempool.space/signet", KIe = "https://mempool.fractalbitcoin.io", qIe = "https://mempool-testnet.fractalbitcoin.io", VIe = "https://static.unisat.io/content", dj = "https://static-testnet.unisat.io/content", GIe = "https://ordinals-testnet4.unisat.io/content", WIe = "https://ordinals.fractalbitcoin.io/content", ZIe = "https://ordinals-testnet.fractalbitcoin.io/content", XIe = "https://static.unisat.io/preview", hj = "https://static-testnet.unisat.io/preview", YIe = "https://ordinals-testnet4.unisat.io/preview", JIe = "https://ordinals.fractalbitcoin.io/preview", QIe = "https://ordinals-testnet.fractalbitcoin.io/preview", dv = (e) => e === ua ? FIe : e === Ta ? MIe : e === Fs ? DIe : e === ih ? KIe : e === us ? qIe : HIe, eOe = (e) => e === Ta ? LIe : jIe, tOe = (e) => e === ua ? dj : e === Ta ? GIe : e === Fs ? dj : e === ih ? WIe : e === us ? ZIe : VIe, rOe = (e) => e === ua ? hj : e === Ta ? YIe : e === Fs ? hj : e === ih ? JIe : e === us ? QIe : XIe;
var Rc = {}, ei = {}, ir = {};
Object.defineProperty(ir, "__esModule", { value: !0 });
ir.add5L = ir.add5H = ir.add4H = ir.add4L = ir.add3H = ir.add3L = ir.rotlBL = ir.rotlBH = ir.rotlSL = ir.rotlSH = ir.rotr32L = ir.rotr32H = ir.rotrBL = ir.rotrBH = ir.rotrSL = ir.rotrSH = ir.shrSL = ir.shrSH = ir.toBig = void 0;
ir.fromBig = FN;
ir.split = mX;
ir.add = PX;
const y8 = /* @__PURE__ */ BigInt(2 ** 32 - 1), bP = /* @__PURE__ */ BigInt(32);
function FN(e, t = !1) {
  return t ? { h: Number(e & y8), l: Number(e >> bP & y8) } : { h: Number(e >> bP & y8) | 0, l: Number(e & y8) | 0 };
}
function mX(e, t = !1) {
  let r = new Uint32Array(e.length), n = new Uint32Array(e.length);
  for (let o = 0; o < e.length; o++) {
    const { h: i, l: a } = FN(e[o], t);
    [r[o], n[o]] = [i, a];
  }
  return [r, n];
}
const yX = (e, t) => BigInt(e >>> 0) << bP | BigInt(t >>> 0);
ir.toBig = yX;
const bX = (e, t, r) => e >>> r;
ir.shrSH = bX;
const wX = (e, t, r) => e << 32 - r | t >>> r;
ir.shrSL = wX;
const vX = (e, t, r) => e >>> r | t << 32 - r;
ir.rotrSH = vX;
const EX = (e, t, r) => e << 32 - r | t >>> r;
ir.rotrSL = EX;
const _X = (e, t, r) => e << 64 - r | t >>> r - 32;
ir.rotrBH = _X;
const AX = (e, t, r) => e >>> r - 32 | t << 64 - r;
ir.rotrBL = AX;
const xX = (e, t) => t;
ir.rotr32H = xX;
const kX = (e, t) => e;
ir.rotr32L = kX;
const SX = (e, t, r) => e << r | t >>> 32 - r;
ir.rotlSH = SX;
const TX = (e, t, r) => t << r | e >>> 32 - r;
ir.rotlSL = TX;
const IX = (e, t, r) => t << r - 32 | e >>> 64 - r;
ir.rotlBH = IX;
const OX = (e, t, r) => e << r - 32 | t >>> 64 - r;
ir.rotlBL = OX;
function PX(e, t, r, n) {
  const o = (t >>> 0) + (n >>> 0);
  return { h: e + r + (o / 2 ** 32 | 0) | 0, l: o | 0 };
}
const CX = (e, t, r) => (e >>> 0) + (t >>> 0) + (r >>> 0);
ir.add3L = CX;
const BX = (e, t, r, n) => t + r + n + (e / 2 ** 32 | 0) | 0;
ir.add3H = BX;
const NX = (e, t, r, n) => (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0);
ir.add4L = NX;
const $X = (e, t, r, n, o) => t + r + n + o + (e / 2 ** 32 | 0) | 0;
ir.add4H = $X;
const UX = (e, t, r, n, o) => (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0) + (o >>> 0);
ir.add5L = UX;
const RX = (e, t, r, n, o, i) => t + r + n + o + i + (e / 2 ** 32 | 0) | 0;
ir.add5H = RX;
const nOe = {
  fromBig: FN,
  split: mX,
  toBig: yX,
  shrSH: bX,
  shrSL: wX,
  rotrSH: vX,
  rotrSL: EX,
  rotrBH: _X,
  rotrBL: AX,
  rotr32H: xX,
  rotr32L: kX,
  rotlSH: SX,
  rotlSL: TX,
  rotlBH: IX,
  rotlBL: OX,
  add: PX,
  add3L: CX,
  add3H: BX,
  add4L: NX,
  add4H: $X,
  add5H: RX,
  add5L: UX
};
ir.default = nOe;
Object.defineProperty(ei, "__esModule", { value: !0 });
ei.sha384 = ei.sha512_256 = ei.sha512_224 = ei.sha512 = ei.SHA384 = ei.SHA512_256 = ei.SHA512_224 = ei.SHA512 = void 0;
const oOe = rh, Tr = ir, OE = Vs, [iOe, aOe] = Tr.default.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((e) => BigInt(e))), hd = /* @__PURE__ */ new Uint32Array(80), pd = /* @__PURE__ */ new Uint32Array(80);
class hv extends oOe.HashMD {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: t, Al: r, Bh: n, Bl: o, Ch: i, Cl: a, Dh: u, Dl: l, Eh: d, El: f, Fh: h, Fl: g, Gh: b, Gl: w, Hh: E, Hl: _ } = this;
    return [t, r, n, o, i, a, u, l, d, f, h, g, b, w, E, _];
  }
  // prettier-ignore
  set(t, r, n, o, i, a, u, l, d, f, h, g, b, w, E, _) {
    this.Ah = t | 0, this.Al = r | 0, this.Bh = n | 0, this.Bl = o | 0, this.Ch = i | 0, this.Cl = a | 0, this.Dh = u | 0, this.Dl = l | 0, this.Eh = d | 0, this.El = f | 0, this.Fh = h | 0, this.Fl = g | 0, this.Gh = b | 0, this.Gl = w | 0, this.Hh = E | 0, this.Hl = _ | 0;
  }
  process(t, r) {
    for (let I = 0; I < 16; I++, r += 4)
      hd[I] = t.getUint32(r), pd[I] = t.getUint32(r += 4);
    for (let I = 16; I < 80; I++) {
      const S = hd[I - 15] | 0, T = pd[I - 15] | 0, A = Tr.default.rotrSH(S, T, 1) ^ Tr.default.rotrSH(S, T, 8) ^ Tr.default.shrSH(S, T, 7), $ = Tr.default.rotrSL(S, T, 1) ^ Tr.default.rotrSL(S, T, 8) ^ Tr.default.shrSL(S, T, 7), U = hd[I - 2] | 0, M = pd[I - 2] | 0, Y = Tr.default.rotrSH(U, M, 19) ^ Tr.default.rotrBH(U, M, 61) ^ Tr.default.shrSH(U, M, 6), L = Tr.default.rotrSL(U, M, 19) ^ Tr.default.rotrBL(U, M, 61) ^ Tr.default.shrSL(U, M, 6), ee = Tr.default.add4L($, L, pd[I - 7], pd[I - 16]), de = Tr.default.add4H(ee, A, Y, hd[I - 7], hd[I - 16]);
      hd[I] = de | 0, pd[I] = ee | 0;
    }
    let { Ah: n, Al: o, Bh: i, Bl: a, Ch: u, Cl: l, Dh: d, Dl: f, Eh: h, El: g, Fh: b, Fl: w, Gh: E, Gl: _, Hh: O, Hl: C } = this;
    for (let I = 0; I < 80; I++) {
      const S = Tr.default.rotrSH(h, g, 14) ^ Tr.default.rotrSH(h, g, 18) ^ Tr.default.rotrBH(h, g, 41), T = Tr.default.rotrSL(h, g, 14) ^ Tr.default.rotrSL(h, g, 18) ^ Tr.default.rotrBL(h, g, 41), A = h & b ^ ~h & E, $ = g & w ^ ~g & _, U = Tr.default.add5L(C, T, $, aOe[I], pd[I]), M = Tr.default.add5H(U, O, S, A, iOe[I], hd[I]), Y = U | 0, L = Tr.default.rotrSH(n, o, 28) ^ Tr.default.rotrBH(n, o, 34) ^ Tr.default.rotrBH(n, o, 39), ee = Tr.default.rotrSL(n, o, 28) ^ Tr.default.rotrBL(n, o, 34) ^ Tr.default.rotrBL(n, o, 39), de = n & i ^ n & u ^ i & u, ne = o & a ^ o & l ^ a & l;
      O = E | 0, C = _ | 0, E = b | 0, _ = w | 0, b = h | 0, w = g | 0, { h, l: g } = Tr.default.add(d | 0, f | 0, M | 0, Y | 0), d = u | 0, f = l | 0, u = i | 0, l = a | 0, i = n | 0, a = o | 0;
      const D = Tr.default.add3L(Y, ee, ne);
      n = Tr.default.add3H(D, M, L, de), o = D | 0;
    }
    ({ h: n, l: o } = Tr.default.add(this.Ah | 0, this.Al | 0, n | 0, o | 0)), { h: i, l: a } = Tr.default.add(this.Bh | 0, this.Bl | 0, i | 0, a | 0), { h: u, l } = Tr.default.add(this.Ch | 0, this.Cl | 0, u | 0, l | 0), { h: d, l: f } = Tr.default.add(this.Dh | 0, this.Dl | 0, d | 0, f | 0), { h, l: g } = Tr.default.add(this.Eh | 0, this.El | 0, h | 0, g | 0), { h: b, l: w } = Tr.default.add(this.Fh | 0, this.Fl | 0, b | 0, w | 0), { h: E, l: _ } = Tr.default.add(this.Gh | 0, this.Gl | 0, E | 0, _ | 0), { h: O, l: C } = Tr.default.add(this.Hh | 0, this.Hl | 0, O | 0, C | 0), this.set(n, o, i, a, u, l, d, f, h, g, b, w, E, _, O, C);
  }
  roundClean() {
    hd.fill(0), pd.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
ei.SHA512 = hv;
class zX extends hv {
  constructor() {
    super(), this.Ah = -1942145080, this.Al = 424955298, this.Bh = 1944164710, this.Bl = -1982016298, this.Ch = 502970286, this.Cl = 855612546, this.Dh = 1738396948, this.Dl = 1479516111, this.Eh = 258812777, this.El = 2077511080, this.Fh = 2011393907, this.Fl = 79989058, this.Gh = 1067287976, this.Gl = 1780299464, this.Hh = 286451373, this.Hl = -1848208735, this.outputLen = 28;
  }
}
ei.SHA512_224 = zX;
class jX extends hv {
  constructor() {
    super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
  }
}
ei.SHA512_256 = jX;
class LX extends hv {
  constructor() {
    super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
  }
}
ei.SHA384 = LX;
ei.sha512 = (0, OE.wrapConstructor)(() => new hv());
ei.sha512_224 = (0, OE.wrapConstructor)(() => new zX());
ei.sha512_256 = (0, OE.wrapConstructor)(() => new jX());
ei.sha384 = (0, OE.wrapConstructor)(() => new LX());
var PE = {};
Object.defineProperty(PE, "__esModule", { value: !0 });
PE.pbkdf2 = uOe;
PE.pbkdf2Async = cOe;
const b8 = $c, sOe = Q2, B1 = Vs;
function HX(e, t, r, n) {
  (0, b8.ahash)(e);
  const o = (0, B1.checkOpts)({ dkLen: 32, asyncTick: 10 }, n), { c: i, dkLen: a, asyncTick: u } = o;
  if ((0, b8.anumber)(i), (0, b8.anumber)(a), (0, b8.anumber)(u), i < 1)
    throw new Error("PBKDF2: iterations (c) should be >= 1");
  const l = (0, B1.toBytes)(t), d = (0, B1.toBytes)(r), f = new Uint8Array(a), h = sOe.hmac.create(e, l), g = h._cloneInto().update(d);
  return { c: i, dkLen: a, asyncTick: u, DK: f, PRF: h, PRFSalt: g };
}
function FX(e, t, r, n, o) {
  return e.destroy(), t.destroy(), n && n.destroy(), o.fill(0), r;
}
function uOe(e, t, r, n) {
  const { c: o, dkLen: i, DK: a, PRF: u, PRFSalt: l } = HX(e, t, r, n);
  let d;
  const f = new Uint8Array(4), h = (0, B1.createView)(f), g = new Uint8Array(u.outputLen);
  for (let b = 1, w = 0; w < i; b++, w += u.outputLen) {
    const E = a.subarray(w, w + u.outputLen);
    h.setInt32(0, b, !1), (d = l._cloneInto(d)).update(f).digestInto(g), E.set(g.subarray(0, E.length));
    for (let _ = 1; _ < o; _++) {
      u._cloneInto(d).update(g).digestInto(g);
      for (let O = 0; O < E.length; O++)
        E[O] ^= g[O];
    }
  }
  return FX(u, l, a, d, g);
}
async function cOe(e, t, r, n) {
  const { c: o, dkLen: i, asyncTick: a, DK: u, PRF: l, PRFSalt: d } = HX(e, t, r, n);
  let f;
  const h = new Uint8Array(4), g = (0, B1.createView)(h), b = new Uint8Array(l.outputLen);
  for (let w = 1, E = 0; E < i; w++, E += l.outputLen) {
    const _ = u.subarray(E, E + l.outputLen);
    g.setInt32(0, w, !1), (f = d._cloneInto(f)).update(h).digestInto(b), _.set(b.subarray(0, _.length)), await (0, B1.asyncLoop)(o - 1, a, () => {
      l._cloneInto(f).update(b).digestInto(b);
      for (let O = 0; O < _.length; O++)
        _[O] ^= b[O];
    });
  }
  return FX(l, d, u, f, b);
}
var wa = {};
const lOe = [
  "abdikace",
  "abeceda",
  "adresa",
  "agrese",
  "akce",
  "aktovka",
  "alej",
  "alkohol",
  "amputace",
  "ananas",
  "andulka",
  "anekdota",
  "anketa",
  "antika",
  "anulovat",
  "archa",
  "arogance",
  "asfalt",
  "asistent",
  "aspirace",
  "astma",
  "astronom",
  "atlas",
  "atletika",
  "atol",
  "autobus",
  "azyl",
  "babka",
  "bachor",
  "bacil",
  "baculka",
  "badatel",
  "bageta",
  "bagr",
  "bahno",
  "bakterie",
  "balada",
  "baletka",
  "balkon",
  "balonek",
  "balvan",
  "balza",
  "bambus",
  "bankomat",
  "barbar",
  "baret",
  "barman",
  "baroko",
  "barva",
  "baterka",
  "batoh",
  "bavlna",
  "bazalka",
  "bazilika",
  "bazuka",
  "bedna",
  "beran",
  "beseda",
  "bestie",
  "beton",
  "bezinka",
  "bezmoc",
  "beztak",
  "bicykl",
  "bidlo",
  "biftek",
  "bikiny",
  "bilance",
  "biograf",
  "biolog",
  "bitva",
  "bizon",
  "blahobyt",
  "blatouch",
  "blecha",
  "bledule",
  "blesk",
  "blikat",
  "blizna",
  "blokovat",
  "bloudit",
  "blud",
  "bobek",
  "bobr",
  "bodlina",
  "bodnout",
  "bohatost",
  "bojkot",
  "bojovat",
  "bokorys",
  "bolest",
  "borec",
  "borovice",
  "bota",
  "boubel",
  "bouchat",
  "bouda",
  "boule",
  "bourat",
  "boxer",
  "bradavka",
  "brambora",
  "branka",
  "bratr",
  "brepta",
  "briketa",
  "brko",
  "brloh",
  "bronz",
  "broskev",
  "brunetka",
  "brusinka",
  "brzda",
  "brzy",
  "bublina",
  "bubnovat",
  "buchta",
  "buditel",
  "budka",
  "budova",
  "bufet",
  "bujarost",
  "bukvice",
  "buldok",
  "bulva",
  "bunda",
  "bunkr",
  "burza",
  "butik",
  "buvol",
  "buzola",
  "bydlet",
  "bylina",
  "bytovka",
  "bzukot",
  "capart",
  "carevna",
  "cedr",
  "cedule",
  "cejch",
  "cejn",
  "cela",
  "celer",
  "celkem",
  "celnice",
  "cenina",
  "cennost",
  "cenovka",
  "centrum",
  "cenzor",
  "cestopis",
  "cetka",
  "chalupa",
  "chapadlo",
  "charita",
  "chata",
  "chechtat",
  "chemie",
  "chichot",
  "chirurg",
  "chlad",
  "chleba",
  "chlubit",
  "chmel",
  "chmura",
  "chobot",
  "chochol",
  "chodba",
  "cholera",
  "chomout",
  "chopit",
  "choroba",
  "chov",
  "chrapot",
  "chrlit",
  "chrt",
  "chrup",
  "chtivost",
  "chudina",
  "chutnat",
  "chvat",
  "chvilka",
  "chvost",
  "chyba",
  "chystat",
  "chytit",
  "cibule",
  "cigareta",
  "cihelna",
  "cihla",
  "cinkot",
  "cirkus",
  "cisterna",
  "citace",
  "citrus",
  "cizinec",
  "cizost",
  "clona",
  "cokoliv",
  "couvat",
  "ctitel",
  "ctnost",
  "cudnost",
  "cuketa",
  "cukr",
  "cupot",
  "cvaknout",
  "cval",
  "cvik",
  "cvrkot",
  "cyklista",
  "daleko",
  "dareba",
  "datel",
  "datum",
  "dcera",
  "debata",
  "dechovka",
  "decibel",
  "deficit",
  "deflace",
  "dekl",
  "dekret",
  "demokrat",
  "deprese",
  "derby",
  "deska",
  "detektiv",
  "dikobraz",
  "diktovat",
  "dioda",
  "diplom",
  "disk",
  "displej",
  "divadlo",
  "divoch",
  "dlaha",
  "dlouho",
  "dluhopis",
  "dnes",
  "dobro",
  "dobytek",
  "docent",
  "dochutit",
  "dodnes",
  "dohled",
  "dohoda",
  "dohra",
  "dojem",
  "dojnice",
  "doklad",
  "dokola",
  "doktor",
  "dokument",
  "dolar",
  "doleva",
  "dolina",
  "doma",
  "dominant",
  "domluvit",
  "domov",
  "donutit",
  "dopad",
  "dopis",
  "doplnit",
  "doposud",
  "doprovod",
  "dopustit",
  "dorazit",
  "dorost",
  "dort",
  "dosah",
  "doslov",
  "dostatek",
  "dosud",
  "dosyta",
  "dotaz",
  "dotek",
  "dotknout",
  "doufat",
  "doutnat",
  "dovozce",
  "dozadu",
  "doznat",
  "dozorce",
  "drahota",
  "drak",
  "dramatik",
  "dravec",
  "draze",
  "drdol",
  "drobnost",
  "drogerie",
  "drozd",
  "drsnost",
  "drtit",
  "drzost",
  "duben",
  "duchovno",
  "dudek",
  "duha",
  "duhovka",
  "dusit",
  "dusno",
  "dutost",
  "dvojice",
  "dvorec",
  "dynamit",
  "ekolog",
  "ekonomie",
  "elektron",
  "elipsa",
  "email",
  "emise",
  "emoce",
  "empatie",
  "epizoda",
  "epocha",
  "epopej",
  "epos",
  "esej",
  "esence",
  "eskorta",
  "eskymo",
  "etiketa",
  "euforie",
  "evoluce",
  "exekuce",
  "exkurze",
  "expedice",
  "exploze",
  "export",
  "extrakt",
  "facka",
  "fajfka",
  "fakulta",
  "fanatik",
  "fantazie",
  "farmacie",
  "favorit",
  "fazole",
  "federace",
  "fejeton",
  "fenka",
  "fialka",
  "figurant",
  "filozof",
  "filtr",
  "finance",
  "finta",
  "fixace",
  "fjord",
  "flanel",
  "flirt",
  "flotila",
  "fond",
  "fosfor",
  "fotbal",
  "fotka",
  "foton",
  "frakce",
  "freska",
  "fronta",
  "fukar",
  "funkce",
  "fyzika",
  "galeje",
  "garant",
  "genetika",
  "geolog",
  "gilotina",
  "glazura",
  "glejt",
  "golem",
  "golfista",
  "gotika",
  "graf",
  "gramofon",
  "granule",
  "grep",
  "gril",
  "grog",
  "groteska",
  "guma",
  "hadice",
  "hadr",
  "hala",
  "halenka",
  "hanba",
  "hanopis",
  "harfa",
  "harpuna",
  "havran",
  "hebkost",
  "hejkal",
  "hejno",
  "hejtman",
  "hektar",
  "helma",
  "hematom",
  "herec",
  "herna",
  "heslo",
  "hezky",
  "historik",
  "hladovka",
  "hlasivky",
  "hlava",
  "hledat",
  "hlen",
  "hlodavec",
  "hloh",
  "hloupost",
  "hltat",
  "hlubina",
  "hluchota",
  "hmat",
  "hmota",
  "hmyz",
  "hnis",
  "hnojivo",
  "hnout",
  "hoblina",
  "hoboj",
  "hoch",
  "hodiny",
  "hodlat",
  "hodnota",
  "hodovat",
  "hojnost",
  "hokej",
  "holinka",
  "holka",
  "holub",
  "homole",
  "honitba",
  "honorace",
  "horal",
  "horda",
  "horizont",
  "horko",
  "horlivec",
  "hormon",
  "hornina",
  "horoskop",
  "horstvo",
  "hospoda",
  "hostina",
  "hotovost",
  "houba",
  "houf",
  "houpat",
  "houska",
  "hovor",
  "hradba",
  "hranice",
  "hravost",
  "hrazda",
  "hrbolek",
  "hrdina",
  "hrdlo",
  "hrdost",
  "hrnek",
  "hrobka",
  "hromada",
  "hrot",
  "hrouda",
  "hrozen",
  "hrstka",
  "hrubost",
  "hryzat",
  "hubenost",
  "hubnout",
  "hudba",
  "hukot",
  "humr",
  "husita",
  "hustota",
  "hvozd",
  "hybnost",
  "hydrant",
  "hygiena",
  "hymna",
  "hysterik",
  "idylka",
  "ihned",
  "ikona",
  "iluze",
  "imunita",
  "infekce",
  "inflace",
  "inkaso",
  "inovace",
  "inspekce",
  "internet",
  "invalida",
  "investor",
  "inzerce",
  "ironie",
  "jablko",
  "jachta",
  "jahoda",
  "jakmile",
  "jakost",
  "jalovec",
  "jantar",
  "jarmark",
  "jaro",
  "jasan",
  "jasno",
  "jatka",
  "javor",
  "jazyk",
  "jedinec",
  "jedle",
  "jednatel",
  "jehlan",
  "jekot",
  "jelen",
  "jelito",
  "jemnost",
  "jenom",
  "jepice",
  "jeseter",
  "jevit",
  "jezdec",
  "jezero",
  "jinak",
  "jindy",
  "jinoch",
  "jiskra",
  "jistota",
  "jitrnice",
  "jizva",
  "jmenovat",
  "jogurt",
  "jurta",
  "kabaret",
  "kabel",
  "kabinet",
  "kachna",
  "kadet",
  "kadidlo",
  "kahan",
  "kajak",
  "kajuta",
  "kakao",
  "kaktus",
  "kalamita",
  "kalhoty",
  "kalibr",
  "kalnost",
  "kamera",
  "kamkoliv",
  "kamna",
  "kanibal",
  "kanoe",
  "kantor",
  "kapalina",
  "kapela",
  "kapitola",
  "kapka",
  "kaple",
  "kapota",
  "kapr",
  "kapusta",
  "kapybara",
  "karamel",
  "karotka",
  "karton",
  "kasa",
  "katalog",
  "katedra",
  "kauce",
  "kauza",
  "kavalec",
  "kazajka",
  "kazeta",
  "kazivost",
  "kdekoliv",
  "kdesi",
  "kedluben",
  "kemp",
  "keramika",
  "kino",
  "klacek",
  "kladivo",
  "klam",
  "klapot",
  "klasika",
  "klaun",
  "klec",
  "klenba",
  "klepat",
  "klesnout",
  "klid",
  "klima",
  "klisna",
  "klobouk",
  "klokan",
  "klopa",
  "kloub",
  "klubovna",
  "klusat",
  "kluzkost",
  "kmen",
  "kmitat",
  "kmotr",
  "kniha",
  "knot",
  "koalice",
  "koberec",
  "kobka",
  "kobliha",
  "kobyla",
  "kocour",
  "kohout",
  "kojenec",
  "kokos",
  "koktejl",
  "kolaps",
  "koleda",
  "kolize",
  "kolo",
  "komando",
  "kometa",
  "komik",
  "komnata",
  "komora",
  "kompas",
  "komunita",
  "konat",
  "koncept",
  "kondice",
  "konec",
  "konfese",
  "kongres",
  "konina",
  "konkurs",
  "kontakt",
  "konzerva",
  "kopanec",
  "kopie",
  "kopnout",
  "koprovka",
  "korbel",
  "korektor",
  "kormidlo",
  "koroptev",
  "korpus",
  "koruna",
  "koryto",
  "korzet",
  "kosatec",
  "kostka",
  "kotel",
  "kotleta",
  "kotoul",
  "koukat",
  "koupelna",
  "kousek",
  "kouzlo",
  "kovboj",
  "koza",
  "kozoroh",
  "krabice",
  "krach",
  "krajina",
  "kralovat",
  "krasopis",
  "kravata",
  "kredit",
  "krejcar",
  "kresba",
  "kreveta",
  "kriket",
  "kritik",
  "krize",
  "krkavec",
  "krmelec",
  "krmivo",
  "krocan",
  "krok",
  "kronika",
  "kropit",
  "kroupa",
  "krovka",
  "krtek",
  "kruhadlo",
  "krupice",
  "krutost",
  "krvinka",
  "krychle",
  "krypta",
  "krystal",
  "kryt",
  "kudlanka",
  "kufr",
  "kujnost",
  "kukla",
  "kulajda",
  "kulich",
  "kulka",
  "kulomet",
  "kultura",
  "kuna",
  "kupodivu",
  "kurt",
  "kurzor",
  "kutil",
  "kvalita",
  "kvasinka",
  "kvestor",
  "kynolog",
  "kyselina",
  "kytara",
  "kytice",
  "kytka",
  "kytovec",
  "kyvadlo",
  "labrador",
  "lachtan",
  "ladnost",
  "laik",
  "lakomec",
  "lamela",
  "lampa",
  "lanovka",
  "lasice",
  "laso",
  "lastura",
  "latinka",
  "lavina",
  "lebka",
  "leckdy",
  "leden",
  "lednice",
  "ledovka",
  "ledvina",
  "legenda",
  "legie",
  "legrace",
  "lehce",
  "lehkost",
  "lehnout",
  "lektvar",
  "lenochod",
  "lentilka",
  "lepenka",
  "lepidlo",
  "letadlo",
  "letec",
  "letmo",
  "letokruh",
  "levhart",
  "levitace",
  "levobok",
  "libra",
  "lichotka",
  "lidojed",
  "lidskost",
  "lihovina",
  "lijavec",
  "lilek",
  "limetka",
  "linie",
  "linka",
  "linoleum",
  "listopad",
  "litina",
  "litovat",
  "lobista",
  "lodivod",
  "logika",
  "logoped",
  "lokalita",
  "loket",
  "lomcovat",
  "lopata",
  "lopuch",
  "lord",
  "losos",
  "lotr",
  "loudal",
  "louh",
  "louka",
  "louskat",
  "lovec",
  "lstivost",
  "lucerna",
  "lucifer",
  "lump",
  "lusk",
  "lustrace",
  "lvice",
  "lyra",
  "lyrika",
  "lysina",
  "madam",
  "madlo",
  "magistr",
  "mahagon",
  "majetek",
  "majitel",
  "majorita",
  "makak",
  "makovice",
  "makrela",
  "malba",
  "malina",
  "malovat",
  "malvice",
  "maminka",
  "mandle",
  "manko",
  "marnost",
  "masakr",
  "maskot",
  "masopust",
  "matice",
  "matrika",
  "maturita",
  "mazanec",
  "mazivo",
  "mazlit",
  "mazurka",
  "mdloba",
  "mechanik",
  "meditace",
  "medovina",
  "melasa",
  "meloun",
  "mentolka",
  "metla",
  "metoda",
  "metr",
  "mezera",
  "migrace",
  "mihnout",
  "mihule",
  "mikina",
  "mikrofon",
  "milenec",
  "milimetr",
  "milost",
  "mimika",
  "mincovna",
  "minibar",
  "minomet",
  "minulost",
  "miska",
  "mistr",
  "mixovat",
  "mladost",
  "mlha",
  "mlhovina",
  "mlok",
  "mlsat",
  "mluvit",
  "mnich",
  "mnohem",
  "mobil",
  "mocnost",
  "modelka",
  "modlitba",
  "mohyla",
  "mokro",
  "molekula",
  "momentka",
  "monarcha",
  "monokl",
  "monstrum",
  "montovat",
  "monzun",
  "mosaz",
  "moskyt",
  "most",
  "motivace",
  "motorka",
  "motyka",
  "moucha",
  "moudrost",
  "mozaika",
  "mozek",
  "mozol",
  "mramor",
  "mravenec",
  "mrkev",
  "mrtvola",
  "mrzet",
  "mrzutost",
  "mstitel",
  "mudrc",
  "muflon",
  "mulat",
  "mumie",
  "munice",
  "muset",
  "mutace",
  "muzeum",
  "muzikant",
  "myslivec",
  "mzda",
  "nabourat",
  "nachytat",
  "nadace",
  "nadbytek",
  "nadhoz",
  "nadobro",
  "nadpis",
  "nahlas",
  "nahnat",
  "nahodile",
  "nahradit",
  "naivita",
  "najednou",
  "najisto",
  "najmout",
  "naklonit",
  "nakonec",
  "nakrmit",
  "nalevo",
  "namazat",
  "namluvit",
  "nanometr",
  "naoko",
  "naopak",
  "naostro",
  "napadat",
  "napevno",
  "naplnit",
  "napnout",
  "naposled",
  "naprosto",
  "narodit",
  "naruby",
  "narychlo",
  "nasadit",
  "nasekat",
  "naslepo",
  "nastat",
  "natolik",
  "navenek",
  "navrch",
  "navzdory",
  "nazvat",
  "nebe",
  "nechat",
  "necky",
  "nedaleko",
  "nedbat",
  "neduh",
  "negace",
  "nehet",
  "nehoda",
  "nejen",
  "nejprve",
  "neklid",
  "nelibost",
  "nemilost",
  "nemoc",
  "neochota",
  "neonka",
  "nepokoj",
  "nerost",
  "nerv",
  "nesmysl",
  "nesoulad",
  "netvor",
  "neuron",
  "nevina",
  "nezvykle",
  "nicota",
  "nijak",
  "nikam",
  "nikdy",
  "nikl",
  "nikterak",
  "nitro",
  "nocleh",
  "nohavice",
  "nominace",
  "nora",
  "norek",
  "nositel",
  "nosnost",
  "nouze",
  "noviny",
  "novota",
  "nozdra",
  "nuda",
  "nudle",
  "nuget",
  "nutit",
  "nutnost",
  "nutrie",
  "nymfa",
  "obal",
  "obarvit",
  "obava",
  "obdiv",
  "obec",
  "obehnat",
  "obejmout",
  "obezita",
  "obhajoba",
  "obilnice",
  "objasnit",
  "objekt",
  "obklopit",
  "oblast",
  "oblek",
  "obliba",
  "obloha",
  "obluda",
  "obnos",
  "obohatit",
  "obojek",
  "obout",
  "obrazec",
  "obrna",
  "obruba",
  "obrys",
  "obsah",
  "obsluha",
  "obstarat",
  "obuv",
  "obvaz",
  "obvinit",
  "obvod",
  "obvykle",
  "obyvatel",
  "obzor",
  "ocas",
  "ocel",
  "ocenit",
  "ochladit",
  "ochota",
  "ochrana",
  "ocitnout",
  "odboj",
  "odbyt",
  "odchod",
  "odcizit",
  "odebrat",
  "odeslat",
  "odevzdat",
  "odezva",
  "odhadce",
  "odhodit",
  "odjet",
  "odjinud",
  "odkaz",
  "odkoupit",
  "odliv",
  "odluka",
  "odmlka",
  "odolnost",
  "odpad",
  "odpis",
  "odplout",
  "odpor",
  "odpustit",
  "odpykat",
  "odrazka",
  "odsoudit",
  "odstup",
  "odsun",
  "odtok",
  "odtud",
  "odvaha",
  "odveta",
  "odvolat",
  "odvracet",
  "odznak",
  "ofina",
  "ofsajd",
  "ohlas",
  "ohnisko",
  "ohrada",
  "ohrozit",
  "ohryzek",
  "okap",
  "okenice",
  "oklika",
  "okno",
  "okouzlit",
  "okovy",
  "okrasa",
  "okres",
  "okrsek",
  "okruh",
  "okupant",
  "okurka",
  "okusit",
  "olejnina",
  "olizovat",
  "omak",
  "omeleta",
  "omezit",
  "omladina",
  "omlouvat",
  "omluva",
  "omyl",
  "onehdy",
  "opakovat",
  "opasek",
  "operace",
  "opice",
  "opilost",
  "opisovat",
  "opora",
  "opozice",
  "opravdu",
  "oproti",
  "orbital",
  "orchestr",
  "orgie",
  "orlice",
  "orloj",
  "ortel",
  "osada",
  "oschnout",
  "osika",
  "osivo",
  "oslava",
  "oslepit",
  "oslnit",
  "oslovit",
  "osnova",
  "osoba",
  "osolit",
  "ospalec",
  "osten",
  "ostraha",
  "ostuda",
  "ostych",
  "osvojit",
  "oteplit",
  "otisk",
  "otop",
  "otrhat",
  "otrlost",
  "otrok",
  "otruby",
  "otvor",
  "ovanout",
  "ovar",
  "oves",
  "ovlivnit",
  "ovoce",
  "oxid",
  "ozdoba",
  "pachatel",
  "pacient",
  "padouch",
  "pahorek",
  "pakt",
  "palanda",
  "palec",
  "palivo",
  "paluba",
  "pamflet",
  "pamlsek",
  "panenka",
  "panika",
  "panna",
  "panovat",
  "panstvo",
  "pantofle",
  "paprika",
  "parketa",
  "parodie",
  "parta",
  "paruka",
  "paryba",
  "paseka",
  "pasivita",
  "pastelka",
  "patent",
  "patrona",
  "pavouk",
  "pazneht",
  "pazourek",
  "pecka",
  "pedagog",
  "pejsek",
  "peklo",
  "peloton",
  "penalta",
  "pendrek",
  "penze",
  "periskop",
  "pero",
  "pestrost",
  "petarda",
  "petice",
  "petrolej",
  "pevnina",
  "pexeso",
  "pianista",
  "piha",
  "pijavice",
  "pikle",
  "piknik",
  "pilina",
  "pilnost",
  "pilulka",
  "pinzeta",
  "pipeta",
  "pisatel",
  "pistole",
  "pitevna",
  "pivnice",
  "pivovar",
  "placenta",
  "plakat",
  "plamen",
  "planeta",
  "plastika",
  "platit",
  "plavidlo",
  "plaz",
  "plech",
  "plemeno",
  "plenta",
  "ples",
  "pletivo",
  "plevel",
  "plivat",
  "plnit",
  "plno",
  "plocha",
  "plodina",
  "plomba",
  "plout",
  "pluk",
  "plyn",
  "pobavit",
  "pobyt",
  "pochod",
  "pocit",
  "poctivec",
  "podat",
  "podcenit",
  "podepsat",
  "podhled",
  "podivit",
  "podklad",
  "podmanit",
  "podnik",
  "podoba",
  "podpora",
  "podraz",
  "podstata",
  "podvod",
  "podzim",
  "poezie",
  "pohanka",
  "pohnutka",
  "pohovor",
  "pohroma",
  "pohyb",
  "pointa",
  "pojistka",
  "pojmout",
  "pokazit",
  "pokles",
  "pokoj",
  "pokrok",
  "pokuta",
  "pokyn",
  "poledne",
  "polibek",
  "polknout",
  "poloha",
  "polynom",
  "pomalu",
  "pominout",
  "pomlka",
  "pomoc",
  "pomsta",
  "pomyslet",
  "ponechat",
  "ponorka",
  "ponurost",
  "popadat",
  "popel",
  "popisek",
  "poplach",
  "poprosit",
  "popsat",
  "popud",
  "poradce",
  "porce",
  "porod",
  "porucha",
  "poryv",
  "posadit",
  "posed",
  "posila",
  "poskok",
  "poslanec",
  "posoudit",
  "pospolu",
  "postava",
  "posudek",
  "posyp",
  "potah",
  "potkan",
  "potlesk",
  "potomek",
  "potrava",
  "potupa",
  "potvora",
  "poukaz",
  "pouto",
  "pouzdro",
  "povaha",
  "povidla",
  "povlak",
  "povoz",
  "povrch",
  "povstat",
  "povyk",
  "povzdech",
  "pozdrav",
  "pozemek",
  "poznatek",
  "pozor",
  "pozvat",
  "pracovat",
  "prahory",
  "praktika",
  "prales",
  "praotec",
  "praporek",
  "prase",
  "pravda",
  "princip",
  "prkno",
  "probudit",
  "procento",
  "prodej",
  "profese",
  "prohra",
  "projekt",
  "prolomit",
  "promile",
  "pronikat",
  "propad",
  "prorok",
  "prosba",
  "proton",
  "proutek",
  "provaz",
  "prskavka",
  "prsten",
  "prudkost",
  "prut",
  "prvek",
  "prvohory",
  "psanec",
  "psovod",
  "pstruh",
  "ptactvo",
  "puberta",
  "puch",
  "pudl",
  "pukavec",
  "puklina",
  "pukrle",
  "pult",
  "pumpa",
  "punc",
  "pupen",
  "pusa",
  "pusinka",
  "pustina",
  "putovat",
  "putyka",
  "pyramida",
  "pysk",
  "pytel",
  "racek",
  "rachot",
  "radiace",
  "radnice",
  "radon",
  "raft",
  "ragby",
  "raketa",
  "rakovina",
  "rameno",
  "rampouch",
  "rande",
  "rarach",
  "rarita",
  "rasovna",
  "rastr",
  "ratolest",
  "razance",
  "razidlo",
  "reagovat",
  "reakce",
  "recept",
  "redaktor",
  "referent",
  "reflex",
  "rejnok",
  "reklama",
  "rekord",
  "rekrut",
  "rektor",
  "reputace",
  "revize",
  "revma",
  "revolver",
  "rezerva",
  "riskovat",
  "riziko",
  "robotika",
  "rodokmen",
  "rohovka",
  "rokle",
  "rokoko",
  "romaneto",
  "ropovod",
  "ropucha",
  "rorejs",
  "rosol",
  "rostlina",
  "rotmistr",
  "rotoped",
  "rotunda",
  "roubenka",
  "roucho",
  "roup",
  "roura",
  "rovina",
  "rovnice",
  "rozbor",
  "rozchod",
  "rozdat",
  "rozeznat",
  "rozhodce",
  "rozinka",
  "rozjezd",
  "rozkaz",
  "rozloha",
  "rozmar",
  "rozpad",
  "rozruch",
  "rozsah",
  "roztok",
  "rozum",
  "rozvod",
  "rubrika",
  "ruchadlo",
  "rukavice",
  "rukopis",
  "ryba",
  "rybolov",
  "rychlost",
  "rydlo",
  "rypadlo",
  "rytina",
  "ryzost",
  "sadista",
  "sahat",
  "sako",
  "samec",
  "samizdat",
  "samota",
  "sanitka",
  "sardinka",
  "sasanka",
  "satelit",
  "sazba",
  "sazenice",
  "sbor",
  "schovat",
  "sebranka",
  "secese",
  "sedadlo",
  "sediment",
  "sedlo",
  "sehnat",
  "sejmout",
  "sekera",
  "sekta",
  "sekunda",
  "sekvoje",
  "semeno",
  "seno",
  "servis",
  "sesadit",
  "seshora",
  "seskok",
  "seslat",
  "sestra",
  "sesuv",
  "sesypat",
  "setba",
  "setina",
  "setkat",
  "setnout",
  "setrvat",
  "sever",
  "seznam",
  "shoda",
  "shrnout",
  "sifon",
  "silnice",
  "sirka",
  "sirotek",
  "sirup",
  "situace",
  "skafandr",
  "skalisko",
  "skanzen",
  "skaut",
  "skeptik",
  "skica",
  "skladba",
  "sklenice",
  "sklo",
  "skluz",
  "skoba",
  "skokan",
  "skoro",
  "skripta",
  "skrz",
  "skupina",
  "skvost",
  "skvrna",
  "slabika",
  "sladidlo",
  "slanina",
  "slast",
  "slavnost",
  "sledovat",
  "slepec",
  "sleva",
  "slezina",
  "slib",
  "slina",
  "sliznice",
  "slon",
  "sloupek",
  "slovo",
  "sluch",
  "sluha",
  "slunce",
  "slupka",
  "slza",
  "smaragd",
  "smetana",
  "smilstvo",
  "smlouva",
  "smog",
  "smrad",
  "smrk",
  "smrtka",
  "smutek",
  "smysl",
  "snad",
  "snaha",
  "snob",
  "sobota",
  "socha",
  "sodovka",
  "sokol",
  "sopka",
  "sotva",
  "souboj",
  "soucit",
  "soudce",
  "souhlas",
  "soulad",
  "soumrak",
  "souprava",
  "soused",
  "soutok",
  "souviset",
  "spalovna",
  "spasitel",
  "spis",
  "splav",
  "spodek",
  "spojenec",
  "spolu",
  "sponzor",
  "spornost",
  "spousta",
  "sprcha",
  "spustit",
  "sranda",
  "sraz",
  "srdce",
  "srna",
  "srnec",
  "srovnat",
  "srpen",
  "srst",
  "srub",
  "stanice",
  "starosta",
  "statika",
  "stavba",
  "stehno",
  "stezka",
  "stodola",
  "stolek",
  "stopa",
  "storno",
  "stoupat",
  "strach",
  "stres",
  "strhnout",
  "strom",
  "struna",
  "studna",
  "stupnice",
  "stvol",
  "styk",
  "subjekt",
  "subtropy",
  "suchar",
  "sudost",
  "sukno",
  "sundat",
  "sunout",
  "surikata",
  "surovina",
  "svah",
  "svalstvo",
  "svetr",
  "svatba",
  "svazek",
  "svisle",
  "svitek",
  "svoboda",
  "svodidlo",
  "svorka",
  "svrab",
  "sykavka",
  "sykot",
  "synek",
  "synovec",
  "sypat",
  "sypkost",
  "syrovost",
  "sysel",
  "sytost",
  "tabletka",
  "tabule",
  "tahoun",
  "tajemno",
  "tajfun",
  "tajga",
  "tajit",
  "tajnost",
  "taktika",
  "tamhle",
  "tampon",
  "tancovat",
  "tanec",
  "tanker",
  "tapeta",
  "tavenina",
  "tazatel",
  "technika",
  "tehdy",
  "tekutina",
  "telefon",
  "temnota",
  "tendence",
  "tenista",
  "tenor",
  "teplota",
  "tepna",
  "teprve",
  "terapie",
  "termoska",
  "textil",
  "ticho",
  "tiskopis",
  "titulek",
  "tkadlec",
  "tkanina",
  "tlapka",
  "tleskat",
  "tlukot",
  "tlupa",
  "tmel",
  "toaleta",
  "topinka",
  "topol",
  "torzo",
  "touha",
  "toulec",
  "tradice",
  "traktor",
  "tramp",
  "trasa",
  "traverza",
  "trefit",
  "trest",
  "trezor",
  "trhavina",
  "trhlina",
  "trochu",
  "trojice",
  "troska",
  "trouba",
  "trpce",
  "trpitel",
  "trpkost",
  "trubec",
  "truchlit",
  "truhlice",
  "trus",
  "trvat",
  "tudy",
  "tuhnout",
  "tuhost",
  "tundra",
  "turista",
  "turnaj",
  "tuzemsko",
  "tvaroh",
  "tvorba",
  "tvrdost",
  "tvrz",
  "tygr",
  "tykev",
  "ubohost",
  "uboze",
  "ubrat",
  "ubrousek",
  "ubrus",
  "ubytovna",
  "ucho",
  "uctivost",
  "udivit",
  "uhradit",
  "ujednat",
  "ujistit",
  "ujmout",
  "ukazatel",
  "uklidnit",
  "uklonit",
  "ukotvit",
  "ukrojit",
  "ulice",
  "ulita",
  "ulovit",
  "umyvadlo",
  "unavit",
  "uniforma",
  "uniknout",
  "upadnout",
  "uplatnit",
  "uplynout",
  "upoutat",
  "upravit",
  "uran",
  "urazit",
  "usednout",
  "usilovat",
  "usmrtit",
  "usnadnit",
  "usnout",
  "usoudit",
  "ustlat",
  "ustrnout",
  "utahovat",
  "utkat",
  "utlumit",
  "utonout",
  "utopenec",
  "utrousit",
  "uvalit",
  "uvolnit",
  "uvozovka",
  "uzdravit",
  "uzel",
  "uzenina",
  "uzlina",
  "uznat",
  "vagon",
  "valcha",
  "valoun",
  "vana",
  "vandal",
  "vanilka",
  "varan",
  "varhany",
  "varovat",
  "vcelku",
  "vchod",
  "vdova",
  "vedro",
  "vegetace",
  "vejce",
  "velbloud",
  "veletrh",
  "velitel",
  "velmoc",
  "velryba",
  "venkov",
  "veranda",
  "verze",
  "veselka",
  "veskrze",
  "vesnice",
  "vespodu",
  "vesta",
  "veterina",
  "veverka",
  "vibrace",
  "vichr",
  "videohra",
  "vidina",
  "vidle",
  "vila",
  "vinice",
  "viset",
  "vitalita",
  "vize",
  "vizitka",
  "vjezd",
  "vklad",
  "vkus",
  "vlajka",
  "vlak",
  "vlasec",
  "vlevo",
  "vlhkost",
  "vliv",
  "vlnovka",
  "vloupat",
  "vnucovat",
  "vnuk",
  "voda",
  "vodivost",
  "vodoznak",
  "vodstvo",
  "vojensky",
  "vojna",
  "vojsko",
  "volant",
  "volba",
  "volit",
  "volno",
  "voskovka",
  "vozidlo",
  "vozovna",
  "vpravo",
  "vrabec",
  "vracet",
  "vrah",
  "vrata",
  "vrba",
  "vrcholek",
  "vrhat",
  "vrstva",
  "vrtule",
  "vsadit",
  "vstoupit",
  "vstup",
  "vtip",
  "vybavit",
  "vybrat",
  "vychovat",
  "vydat",
  "vydra",
  "vyfotit",
  "vyhledat",
  "vyhnout",
  "vyhodit",
  "vyhradit",
  "vyhubit",
  "vyjasnit",
  "vyjet",
  "vyjmout",
  "vyklopit",
  "vykonat",
  "vylekat",
  "vymazat",
  "vymezit",
  "vymizet",
  "vymyslet",
  "vynechat",
  "vynikat",
  "vynutit",
  "vypadat",
  "vyplatit",
  "vypravit",
  "vypustit",
  "vyrazit",
  "vyrovnat",
  "vyrvat",
  "vyslovit",
  "vysoko",
  "vystavit",
  "vysunout",
  "vysypat",
  "vytasit",
  "vytesat",
  "vytratit",
  "vyvinout",
  "vyvolat",
  "vyvrhel",
  "vyzdobit",
  "vyznat",
  "vzadu",
  "vzbudit",
  "vzchopit",
  "vzdor",
  "vzduch",
  "vzdychat",
  "vzestup",
  "vzhledem",
  "vzkaz",
  "vzlykat",
  "vznik",
  "vzorek",
  "vzpoura",
  "vztah",
  "vztek",
  "xylofon",
  "zabrat",
  "zabydlet",
  "zachovat",
  "zadarmo",
  "zadusit",
  "zafoukat",
  "zahltit",
  "zahodit",
  "zahrada",
  "zahynout",
  "zajatec",
  "zajet",
  "zajistit",
  "zaklepat",
  "zakoupit",
  "zalepit",
  "zamezit",
  "zamotat",
  "zamyslet",
  "zanechat",
  "zanikat",
  "zaplatit",
  "zapojit",
  "zapsat",
  "zarazit",
  "zastavit",
  "zasunout",
  "zatajit",
  "zatemnit",
  "zatknout",
  "zaujmout",
  "zavalit",
  "zavelet",
  "zavinit",
  "zavolat",
  "zavrtat",
  "zazvonit",
  "zbavit",
  "zbrusu",
  "zbudovat",
  "zbytek",
  "zdaleka",
  "zdarma",
  "zdatnost",
  "zdivo",
  "zdobit",
  "zdroj",
  "zdvih",
  "zdymadlo",
  "zelenina",
  "zeman",
  "zemina",
  "zeptat",
  "zezadu",
  "zezdola",
  "zhatit",
  "zhltnout",
  "zhluboka",
  "zhotovit",
  "zhruba",
  "zima",
  "zimnice",
  "zjemnit",
  "zklamat",
  "zkoumat",
  "zkratka",
  "zkumavka",
  "zlato",
  "zlehka",
  "zloba",
  "zlom",
  "zlost",
  "zlozvyk",
  "zmapovat",
  "zmar",
  "zmatek",
  "zmije",
  "zmizet",
  "zmocnit",
  "zmodrat",
  "zmrzlina",
  "zmutovat",
  "znak",
  "znalost",
  "znamenat",
  "znovu",
  "zobrazit",
  "zotavit",
  "zoubek",
  "zoufale",
  "zplodit",
  "zpomalit",
  "zprava",
  "zprostit",
  "zprudka",
  "zprvu",
  "zrada",
  "zranit",
  "zrcadlo",
  "zrnitost",
  "zrno",
  "zrovna",
  "zrychlit",
  "zrzavost",
  "zticha",
  "ztratit",
  "zubovina",
  "zubr",
  "zvednout",
  "zvenku",
  "zvesela",
  "zvon",
  "zvrat",
  "zvukovod",
  "zvyk"
], fOe = [
  "的",
  "一",
  "是",
  "在",
  "不",
  "了",
  "有",
  "和",
  "人",
  "这",
  "中",
  "大",
  "为",
  "上",
  "个",
  "国",
  "我",
  "以",
  "要",
  "他",
  "时",
  "来",
  "用",
  "们",
  "生",
  "到",
  "作",
  "地",
  "于",
  "出",
  "就",
  "分",
  "对",
  "成",
  "会",
  "可",
  "主",
  "发",
  "年",
  "动",
  "同",
  "工",
  "也",
  "能",
  "下",
  "过",
  "子",
  "说",
  "产",
  "种",
  "面",
  "而",
  "方",
  "后",
  "多",
  "定",
  "行",
  "学",
  "法",
  "所",
  "民",
  "得",
  "经",
  "十",
  "三",
  "之",
  "进",
  "着",
  "等",
  "部",
  "度",
  "家",
  "电",
  "力",
  "里",
  "如",
  "水",
  "化",
  "高",
  "自",
  "二",
  "理",
  "起",
  "小",
  "物",
  "现",
  "实",
  "加",
  "量",
  "都",
  "两",
  "体",
  "制",
  "机",
  "当",
  "使",
  "点",
  "从",
  "业",
  "本",
  "去",
  "把",
  "性",
  "好",
  "应",
  "开",
  "它",
  "合",
  "还",
  "因",
  "由",
  "其",
  "些",
  "然",
  "前",
  "外",
  "天",
  "政",
  "四",
  "日",
  "那",
  "社",
  "义",
  "事",
  "平",
  "形",
  "相",
  "全",
  "表",
  "间",
  "样",
  "与",
  "关",
  "各",
  "重",
  "新",
  "线",
  "内",
  "数",
  "正",
  "心",
  "反",
  "你",
  "明",
  "看",
  "原",
  "又",
  "么",
  "利",
  "比",
  "或",
  "但",
  "质",
  "气",
  "第",
  "向",
  "道",
  "命",
  "此",
  "变",
  "条",
  "只",
  "没",
  "结",
  "解",
  "问",
  "意",
  "建",
  "月",
  "公",
  "无",
  "系",
  "军",
  "很",
  "情",
  "者",
  "最",
  "立",
  "代",
  "想",
  "已",
  "通",
  "并",
  "提",
  "直",
  "题",
  "党",
  "程",
  "展",
  "五",
  "果",
  "料",
  "象",
  "员",
  "革",
  "位",
  "入",
  "常",
  "文",
  "总",
  "次",
  "品",
  "式",
  "活",
  "设",
  "及",
  "管",
  "特",
  "件",
  "长",
  "求",
  "老",
  "头",
  "基",
  "资",
  "边",
  "流",
  "路",
  "级",
  "少",
  "图",
  "山",
  "统",
  "接",
  "知",
  "较",
  "将",
  "组",
  "见",
  "计",
  "别",
  "她",
  "手",
  "角",
  "期",
  "根",
  "论",
  "运",
  "农",
  "指",
  "几",
  "九",
  "区",
  "强",
  "放",
  "决",
  "西",
  "被",
  "干",
  "做",
  "必",
  "战",
  "先",
  "回",
  "则",
  "任",
  "取",
  "据",
  "处",
  "队",
  "南",
  "给",
  "色",
  "光",
  "门",
  "即",
  "保",
  "治",
  "北",
  "造",
  "百",
  "规",
  "热",
  "领",
  "七",
  "海",
  "口",
  "东",
  "导",
  "器",
  "压",
  "志",
  "世",
  "金",
  "增",
  "争",
  "济",
  "阶",
  "油",
  "思",
  "术",
  "极",
  "交",
  "受",
  "联",
  "什",
  "认",
  "六",
  "共",
  "权",
  "收",
  "证",
  "改",
  "清",
  "美",
  "再",
  "采",
  "转",
  "更",
  "单",
  "风",
  "切",
  "打",
  "白",
  "教",
  "速",
  "花",
  "带",
  "安",
  "场",
  "身",
  "车",
  "例",
  "真",
  "务",
  "具",
  "万",
  "每",
  "目",
  "至",
  "达",
  "走",
  "积",
  "示",
  "议",
  "声",
  "报",
  "斗",
  "完",
  "类",
  "八",
  "离",
  "华",
  "名",
  "确",
  "才",
  "科",
  "张",
  "信",
  "马",
  "节",
  "话",
  "米",
  "整",
  "空",
  "元",
  "况",
  "今",
  "集",
  "温",
  "传",
  "土",
  "许",
  "步",
  "群",
  "广",
  "石",
  "记",
  "需",
  "段",
  "研",
  "界",
  "拉",
  "林",
  "律",
  "叫",
  "且",
  "究",
  "观",
  "越",
  "织",
  "装",
  "影",
  "算",
  "低",
  "持",
  "音",
  "众",
  "书",
  "布",
  "复",
  "容",
  "儿",
  "须",
  "际",
  "商",
  "非",
  "验",
  "连",
  "断",
  "深",
  "难",
  "近",
  "矿",
  "千",
  "周",
  "委",
  "素",
  "技",
  "备",
  "半",
  "办",
  "青",
  "省",
  "列",
  "习",
  "响",
  "约",
  "支",
  "般",
  "史",
  "感",
  "劳",
  "便",
  "团",
  "往",
  "酸",
  "历",
  "市",
  "克",
  "何",
  "除",
  "消",
  "构",
  "府",
  "称",
  "太",
  "准",
  "精",
  "值",
  "号",
  "率",
  "族",
  "维",
  "划",
  "选",
  "标",
  "写",
  "存",
  "候",
  "毛",
  "亲",
  "快",
  "效",
  "斯",
  "院",
  "查",
  "江",
  "型",
  "眼",
  "王",
  "按",
  "格",
  "养",
  "易",
  "置",
  "派",
  "层",
  "片",
  "始",
  "却",
  "专",
  "状",
  "育",
  "厂",
  "京",
  "识",
  "适",
  "属",
  "圆",
  "包",
  "火",
  "住",
  "调",
  "满",
  "县",
  "局",
  "照",
  "参",
  "红",
  "细",
  "引",
  "听",
  "该",
  "铁",
  "价",
  "严",
  "首",
  "底",
  "液",
  "官",
  "德",
  "随",
  "病",
  "苏",
  "失",
  "尔",
  "死",
  "讲",
  "配",
  "女",
  "黄",
  "推",
  "显",
  "谈",
  "罪",
  "神",
  "艺",
  "呢",
  "席",
  "含",
  "企",
  "望",
  "密",
  "批",
  "营",
  "项",
  "防",
  "举",
  "球",
  "英",
  "氧",
  "势",
  "告",
  "李",
  "台",
  "落",
  "木",
  "帮",
  "轮",
  "破",
  "亚",
  "师",
  "围",
  "注",
  "远",
  "字",
  "材",
  "排",
  "供",
  "河",
  "态",
  "封",
  "另",
  "施",
  "减",
  "树",
  "溶",
  "怎",
  "止",
  "案",
  "言",
  "士",
  "均",
  "武",
  "固",
  "叶",
  "鱼",
  "波",
  "视",
  "仅",
  "费",
  "紧",
  "爱",
  "左",
  "章",
  "早",
  "朝",
  "害",
  "续",
  "轻",
  "服",
  "试",
  "食",
  "充",
  "兵",
  "源",
  "判",
  "护",
  "司",
  "足",
  "某",
  "练",
  "差",
  "致",
  "板",
  "田",
  "降",
  "黑",
  "犯",
  "负",
  "击",
  "范",
  "继",
  "兴",
  "似",
  "余",
  "坚",
  "曲",
  "输",
  "修",
  "故",
  "城",
  "夫",
  "够",
  "送",
  "笔",
  "船",
  "占",
  "右",
  "财",
  "吃",
  "富",
  "春",
  "职",
  "觉",
  "汉",
  "画",
  "功",
  "巴",
  "跟",
  "虽",
  "杂",
  "飞",
  "检",
  "吸",
  "助",
  "升",
  "阳",
  "互",
  "初",
  "创",
  "抗",
  "考",
  "投",
  "坏",
  "策",
  "古",
  "径",
  "换",
  "未",
  "跑",
  "留",
  "钢",
  "曾",
  "端",
  "责",
  "站",
  "简",
  "述",
  "钱",
  "副",
  "尽",
  "帝",
  "射",
  "草",
  "冲",
  "承",
  "独",
  "令",
  "限",
  "阿",
  "宣",
  "环",
  "双",
  "请",
  "超",
  "微",
  "让",
  "控",
  "州",
  "良",
  "轴",
  "找",
  "否",
  "纪",
  "益",
  "依",
  "优",
  "顶",
  "础",
  "载",
  "倒",
  "房",
  "突",
  "坐",
  "粉",
  "敌",
  "略",
  "客",
  "袁",
  "冷",
  "胜",
  "绝",
  "析",
  "块",
  "剂",
  "测",
  "丝",
  "协",
  "诉",
  "念",
  "陈",
  "仍",
  "罗",
  "盐",
  "友",
  "洋",
  "错",
  "苦",
  "夜",
  "刑",
  "移",
  "频",
  "逐",
  "靠",
  "混",
  "母",
  "短",
  "皮",
  "终",
  "聚",
  "汽",
  "村",
  "云",
  "哪",
  "既",
  "距",
  "卫",
  "停",
  "烈",
  "央",
  "察",
  "烧",
  "迅",
  "境",
  "若",
  "印",
  "洲",
  "刻",
  "括",
  "激",
  "孔",
  "搞",
  "甚",
  "室",
  "待",
  "核",
  "校",
  "散",
  "侵",
  "吧",
  "甲",
  "游",
  "久",
  "菜",
  "味",
  "旧",
  "模",
  "湖",
  "货",
  "损",
  "预",
  "阻",
  "毫",
  "普",
  "稳",
  "乙",
  "妈",
  "植",
  "息",
  "扩",
  "银",
  "语",
  "挥",
  "酒",
  "守",
  "拿",
  "序",
  "纸",
  "医",
  "缺",
  "雨",
  "吗",
  "针",
  "刘",
  "啊",
  "急",
  "唱",
  "误",
  "训",
  "愿",
  "审",
  "附",
  "获",
  "茶",
  "鲜",
  "粮",
  "斤",
  "孩",
  "脱",
  "硫",
  "肥",
  "善",
  "龙",
  "演",
  "父",
  "渐",
  "血",
  "欢",
  "械",
  "掌",
  "歌",
  "沙",
  "刚",
  "攻",
  "谓",
  "盾",
  "讨",
  "晚",
  "粒",
  "乱",
  "燃",
  "矛",
  "乎",
  "杀",
  "药",
  "宁",
  "鲁",
  "贵",
  "钟",
  "煤",
  "读",
  "班",
  "伯",
  "香",
  "介",
  "迫",
  "句",
  "丰",
  "培",
  "握",
  "兰",
  "担",
  "弦",
  "蛋",
  "沉",
  "假",
  "穿",
  "执",
  "答",
  "乐",
  "谁",
  "顺",
  "烟",
  "缩",
  "征",
  "脸",
  "喜",
  "松",
  "脚",
  "困",
  "异",
  "免",
  "背",
  "星",
  "福",
  "买",
  "染",
  "井",
  "概",
  "慢",
  "怕",
  "磁",
  "倍",
  "祖",
  "皇",
  "促",
  "静",
  "补",
  "评",
  "翻",
  "肉",
  "践",
  "尼",
  "衣",
  "宽",
  "扬",
  "棉",
  "希",
  "伤",
  "操",
  "垂",
  "秋",
  "宜",
  "氢",
  "套",
  "督",
  "振",
  "架",
  "亮",
  "末",
  "宪",
  "庆",
  "编",
  "牛",
  "触",
  "映",
  "雷",
  "销",
  "诗",
  "座",
  "居",
  "抓",
  "裂",
  "胞",
  "呼",
  "娘",
  "景",
  "威",
  "绿",
  "晶",
  "厚",
  "盟",
  "衡",
  "鸡",
  "孙",
  "延",
  "危",
  "胶",
  "屋",
  "乡",
  "临",
  "陆",
  "顾",
  "掉",
  "呀",
  "灯",
  "岁",
  "措",
  "束",
  "耐",
  "剧",
  "玉",
  "赵",
  "跳",
  "哥",
  "季",
  "课",
  "凯",
  "胡",
  "额",
  "款",
  "绍",
  "卷",
  "齐",
  "伟",
  "蒸",
  "殖",
  "永",
  "宗",
  "苗",
  "川",
  "炉",
  "岩",
  "弱",
  "零",
  "杨",
  "奏",
  "沿",
  "露",
  "杆",
  "探",
  "滑",
  "镇",
  "饭",
  "浓",
  "航",
  "怀",
  "赶",
  "库",
  "夺",
  "伊",
  "灵",
  "税",
  "途",
  "灭",
  "赛",
  "归",
  "召",
  "鼓",
  "播",
  "盘",
  "裁",
  "险",
  "康",
  "唯",
  "录",
  "菌",
  "纯",
  "借",
  "糖",
  "盖",
  "横",
  "符",
  "私",
  "努",
  "堂",
  "域",
  "枪",
  "润",
  "幅",
  "哈",
  "竟",
  "熟",
  "虫",
  "泽",
  "脑",
  "壤",
  "碳",
  "欧",
  "遍",
  "侧",
  "寨",
  "敢",
  "彻",
  "虑",
  "斜",
  "薄",
  "庭",
  "纳",
  "弹",
  "饲",
  "伸",
  "折",
  "麦",
  "湿",
  "暗",
  "荷",
  "瓦",
  "塞",
  "床",
  "筑",
  "恶",
  "户",
  "访",
  "塔",
  "奇",
  "透",
  "梁",
  "刀",
  "旋",
  "迹",
  "卡",
  "氯",
  "遇",
  "份",
  "毒",
  "泥",
  "退",
  "洗",
  "摆",
  "灰",
  "彩",
  "卖",
  "耗",
  "夏",
  "择",
  "忙",
  "铜",
  "献",
  "硬",
  "予",
  "繁",
  "圈",
  "雪",
  "函",
  "亦",
  "抽",
  "篇",
  "阵",
  "阴",
  "丁",
  "尺",
  "追",
  "堆",
  "雄",
  "迎",
  "泛",
  "爸",
  "楼",
  "避",
  "谋",
  "吨",
  "野",
  "猪",
  "旗",
  "累",
  "偏",
  "典",
  "馆",
  "索",
  "秦",
  "脂",
  "潮",
  "爷",
  "豆",
  "忽",
  "托",
  "惊",
  "塑",
  "遗",
  "愈",
  "朱",
  "替",
  "纤",
  "粗",
  "倾",
  "尚",
  "痛",
  "楚",
  "谢",
  "奋",
  "购",
  "磨",
  "君",
  "池",
  "旁",
  "碎",
  "骨",
  "监",
  "捕",
  "弟",
  "暴",
  "割",
  "贯",
  "殊",
  "释",
  "词",
  "亡",
  "壁",
  "顿",
  "宝",
  "午",
  "尘",
  "闻",
  "揭",
  "炮",
  "残",
  "冬",
  "桥",
  "妇",
  "警",
  "综",
  "招",
  "吴",
  "付",
  "浮",
  "遭",
  "徐",
  "您",
  "摇",
  "谷",
  "赞",
  "箱",
  "隔",
  "订",
  "男",
  "吹",
  "园",
  "纷",
  "唐",
  "败",
  "宋",
  "玻",
  "巨",
  "耕",
  "坦",
  "荣",
  "闭",
  "湾",
  "键",
  "凡",
  "驻",
  "锅",
  "救",
  "恩",
  "剥",
  "凝",
  "碱",
  "齿",
  "截",
  "炼",
  "麻",
  "纺",
  "禁",
  "废",
  "盛",
  "版",
  "缓",
  "净",
  "睛",
  "昌",
  "婚",
  "涉",
  "筒",
  "嘴",
  "插",
  "岸",
  "朗",
  "庄",
  "街",
  "藏",
  "姑",
  "贸",
  "腐",
  "奴",
  "啦",
  "惯",
  "乘",
  "伙",
  "恢",
  "匀",
  "纱",
  "扎",
  "辩",
  "耳",
  "彪",
  "臣",
  "亿",
  "璃",
  "抵",
  "脉",
  "秀",
  "萨",
  "俄",
  "网",
  "舞",
  "店",
  "喷",
  "纵",
  "寸",
  "汗",
  "挂",
  "洪",
  "贺",
  "闪",
  "柬",
  "爆",
  "烯",
  "津",
  "稻",
  "墙",
  "软",
  "勇",
  "像",
  "滚",
  "厘",
  "蒙",
  "芳",
  "肯",
  "坡",
  "柱",
  "荡",
  "腿",
  "仪",
  "旅",
  "尾",
  "轧",
  "冰",
  "贡",
  "登",
  "黎",
  "削",
  "钻",
  "勒",
  "逃",
  "障",
  "氨",
  "郭",
  "峰",
  "币",
  "港",
  "伏",
  "轨",
  "亩",
  "毕",
  "擦",
  "莫",
  "刺",
  "浪",
  "秘",
  "援",
  "株",
  "健",
  "售",
  "股",
  "岛",
  "甘",
  "泡",
  "睡",
  "童",
  "铸",
  "汤",
  "阀",
  "休",
  "汇",
  "舍",
  "牧",
  "绕",
  "炸",
  "哲",
  "磷",
  "绩",
  "朋",
  "淡",
  "尖",
  "启",
  "陷",
  "柴",
  "呈",
  "徒",
  "颜",
  "泪",
  "稍",
  "忘",
  "泵",
  "蓝",
  "拖",
  "洞",
  "授",
  "镜",
  "辛",
  "壮",
  "锋",
  "贫",
  "虚",
  "弯",
  "摩",
  "泰",
  "幼",
  "廷",
  "尊",
  "窗",
  "纲",
  "弄",
  "隶",
  "疑",
  "氏",
  "宫",
  "姐",
  "震",
  "瑞",
  "怪",
  "尤",
  "琴",
  "循",
  "描",
  "膜",
  "违",
  "夹",
  "腰",
  "缘",
  "珠",
  "穷",
  "森",
  "枝",
  "竹",
  "沟",
  "催",
  "绳",
  "忆",
  "邦",
  "剩",
  "幸",
  "浆",
  "栏",
  "拥",
  "牙",
  "贮",
  "礼",
  "滤",
  "钠",
  "纹",
  "罢",
  "拍",
  "咱",
  "喊",
  "袖",
  "埃",
  "勤",
  "罚",
  "焦",
  "潜",
  "伍",
  "墨",
  "欲",
  "缝",
  "姓",
  "刊",
  "饱",
  "仿",
  "奖",
  "铝",
  "鬼",
  "丽",
  "跨",
  "默",
  "挖",
  "链",
  "扫",
  "喝",
  "袋",
  "炭",
  "污",
  "幕",
  "诸",
  "弧",
  "励",
  "梅",
  "奶",
  "洁",
  "灾",
  "舟",
  "鉴",
  "苯",
  "讼",
  "抱",
  "毁",
  "懂",
  "寒",
  "智",
  "埔",
  "寄",
  "届",
  "跃",
  "渡",
  "挑",
  "丹",
  "艰",
  "贝",
  "碰",
  "拔",
  "爹",
  "戴",
  "码",
  "梦",
  "芽",
  "熔",
  "赤",
  "渔",
  "哭",
  "敬",
  "颗",
  "奔",
  "铅",
  "仲",
  "虎",
  "稀",
  "妹",
  "乏",
  "珍",
  "申",
  "桌",
  "遵",
  "允",
  "隆",
  "螺",
  "仓",
  "魏",
  "锐",
  "晓",
  "氮",
  "兼",
  "隐",
  "碍",
  "赫",
  "拨",
  "忠",
  "肃",
  "缸",
  "牵",
  "抢",
  "博",
  "巧",
  "壳",
  "兄",
  "杜",
  "讯",
  "诚",
  "碧",
  "祥",
  "柯",
  "页",
  "巡",
  "矩",
  "悲",
  "灌",
  "龄",
  "伦",
  "票",
  "寻",
  "桂",
  "铺",
  "圣",
  "恐",
  "恰",
  "郑",
  "趣",
  "抬",
  "荒",
  "腾",
  "贴",
  "柔",
  "滴",
  "猛",
  "阔",
  "辆",
  "妻",
  "填",
  "撤",
  "储",
  "签",
  "闹",
  "扰",
  "紫",
  "砂",
  "递",
  "戏",
  "吊",
  "陶",
  "伐",
  "喂",
  "疗",
  "瓶",
  "婆",
  "抚",
  "臂",
  "摸",
  "忍",
  "虾",
  "蜡",
  "邻",
  "胸",
  "巩",
  "挤",
  "偶",
  "弃",
  "槽",
  "劲",
  "乳",
  "邓",
  "吉",
  "仁",
  "烂",
  "砖",
  "租",
  "乌",
  "舰",
  "伴",
  "瓜",
  "浅",
  "丙",
  "暂",
  "燥",
  "橡",
  "柳",
  "迷",
  "暖",
  "牌",
  "秧",
  "胆",
  "详",
  "簧",
  "踏",
  "瓷",
  "谱",
  "呆",
  "宾",
  "糊",
  "洛",
  "辉",
  "愤",
  "竞",
  "隙",
  "怒",
  "粘",
  "乃",
  "绪",
  "肩",
  "籍",
  "敏",
  "涂",
  "熙",
  "皆",
  "侦",
  "悬",
  "掘",
  "享",
  "纠",
  "醒",
  "狂",
  "锁",
  "淀",
  "恨",
  "牲",
  "霸",
  "爬",
  "赏",
  "逆",
  "玩",
  "陵",
  "祝",
  "秒",
  "浙",
  "貌",
  "役",
  "彼",
  "悉",
  "鸭",
  "趋",
  "凤",
  "晨",
  "畜",
  "辈",
  "秩",
  "卵",
  "署",
  "梯",
  "炎",
  "滩",
  "棋",
  "驱",
  "筛",
  "峡",
  "冒",
  "啥",
  "寿",
  "译",
  "浸",
  "泉",
  "帽",
  "迟",
  "硅",
  "疆",
  "贷",
  "漏",
  "稿",
  "冠",
  "嫩",
  "胁",
  "芯",
  "牢",
  "叛",
  "蚀",
  "奥",
  "鸣",
  "岭",
  "羊",
  "凭",
  "串",
  "塘",
  "绘",
  "酵",
  "融",
  "盆",
  "锡",
  "庙",
  "筹",
  "冻",
  "辅",
  "摄",
  "袭",
  "筋",
  "拒",
  "僚",
  "旱",
  "钾",
  "鸟",
  "漆",
  "沈",
  "眉",
  "疏",
  "添",
  "棒",
  "穗",
  "硝",
  "韩",
  "逼",
  "扭",
  "侨",
  "凉",
  "挺",
  "碗",
  "栽",
  "炒",
  "杯",
  "患",
  "馏",
  "劝",
  "豪",
  "辽",
  "勃",
  "鸿",
  "旦",
  "吏",
  "拜",
  "狗",
  "埋",
  "辊",
  "掩",
  "饮",
  "搬",
  "骂",
  "辞",
  "勾",
  "扣",
  "估",
  "蒋",
  "绒",
  "雾",
  "丈",
  "朵",
  "姆",
  "拟",
  "宇",
  "辑",
  "陕",
  "雕",
  "偿",
  "蓄",
  "崇",
  "剪",
  "倡",
  "厅",
  "咬",
  "驶",
  "薯",
  "刷",
  "斥",
  "番",
  "赋",
  "奉",
  "佛",
  "浇",
  "漫",
  "曼",
  "扇",
  "钙",
  "桃",
  "扶",
  "仔",
  "返",
  "俗",
  "亏",
  "腔",
  "鞋",
  "棱",
  "覆",
  "框",
  "悄",
  "叔",
  "撞",
  "骗",
  "勘",
  "旺",
  "沸",
  "孤",
  "吐",
  "孟",
  "渠",
  "屈",
  "疾",
  "妙",
  "惜",
  "仰",
  "狠",
  "胀",
  "谐",
  "抛",
  "霉",
  "桑",
  "岗",
  "嘛",
  "衰",
  "盗",
  "渗",
  "脏",
  "赖",
  "涌",
  "甜",
  "曹",
  "阅",
  "肌",
  "哩",
  "厉",
  "烃",
  "纬",
  "毅",
  "昨",
  "伪",
  "症",
  "煮",
  "叹",
  "钉",
  "搭",
  "茎",
  "笼",
  "酷",
  "偷",
  "弓",
  "锥",
  "恒",
  "杰",
  "坑",
  "鼻",
  "翼",
  "纶",
  "叙",
  "狱",
  "逮",
  "罐",
  "络",
  "棚",
  "抑",
  "膨",
  "蔬",
  "寺",
  "骤",
  "穆",
  "冶",
  "枯",
  "册",
  "尸",
  "凸",
  "绅",
  "坯",
  "牺",
  "焰",
  "轰",
  "欣",
  "晋",
  "瘦",
  "御",
  "锭",
  "锦",
  "丧",
  "旬",
  "锻",
  "垄",
  "搜",
  "扑",
  "邀",
  "亭",
  "酯",
  "迈",
  "舒",
  "脆",
  "酶",
  "闲",
  "忧",
  "酚",
  "顽",
  "羽",
  "涨",
  "卸",
  "仗",
  "陪",
  "辟",
  "惩",
  "杭",
  "姚",
  "肚",
  "捉",
  "飘",
  "漂",
  "昆",
  "欺",
  "吾",
  "郎",
  "烷",
  "汁",
  "呵",
  "饰",
  "萧",
  "雅",
  "邮",
  "迁",
  "燕",
  "撒",
  "姻",
  "赴",
  "宴",
  "烦",
  "债",
  "帐",
  "斑",
  "铃",
  "旨",
  "醇",
  "董",
  "饼",
  "雏",
  "姿",
  "拌",
  "傅",
  "腹",
  "妥",
  "揉",
  "贤",
  "拆",
  "歪",
  "葡",
  "胺",
  "丢",
  "浩",
  "徽",
  "昂",
  "垫",
  "挡",
  "览",
  "贪",
  "慰",
  "缴",
  "汪",
  "慌",
  "冯",
  "诺",
  "姜",
  "谊",
  "凶",
  "劣",
  "诬",
  "耀",
  "昏",
  "躺",
  "盈",
  "骑",
  "乔",
  "溪",
  "丛",
  "卢",
  "抹",
  "闷",
  "咨",
  "刮",
  "驾",
  "缆",
  "悟",
  "摘",
  "铒",
  "掷",
  "颇",
  "幻",
  "柄",
  "惠",
  "惨",
  "佳",
  "仇",
  "腊",
  "窝",
  "涤",
  "剑",
  "瞧",
  "堡",
  "泼",
  "葱",
  "罩",
  "霍",
  "捞",
  "胎",
  "苍",
  "滨",
  "俩",
  "捅",
  "湘",
  "砍",
  "霞",
  "邵",
  "萄",
  "疯",
  "淮",
  "遂",
  "熊",
  "粪",
  "烘",
  "宿",
  "档",
  "戈",
  "驳",
  "嫂",
  "裕",
  "徙",
  "箭",
  "捐",
  "肠",
  "撑",
  "晒",
  "辨",
  "殿",
  "莲",
  "摊",
  "搅",
  "酱",
  "屏",
  "疫",
  "哀",
  "蔡",
  "堵",
  "沫",
  "皱",
  "畅",
  "叠",
  "阁",
  "莱",
  "敲",
  "辖",
  "钩",
  "痕",
  "坝",
  "巷",
  "饿",
  "祸",
  "丘",
  "玄",
  "溜",
  "曰",
  "逻",
  "彭",
  "尝",
  "卿",
  "妨",
  "艇",
  "吞",
  "韦",
  "怨",
  "矮",
  "歇"
], dOe = [
  "的",
  "一",
  "是",
  "在",
  "不",
  "了",
  "有",
  "和",
  "人",
  "這",
  "中",
  "大",
  "為",
  "上",
  "個",
  "國",
  "我",
  "以",
  "要",
  "他",
  "時",
  "來",
  "用",
  "們",
  "生",
  "到",
  "作",
  "地",
  "於",
  "出",
  "就",
  "分",
  "對",
  "成",
  "會",
  "可",
  "主",
  "發",
  "年",
  "動",
  "同",
  "工",
  "也",
  "能",
  "下",
  "過",
  "子",
  "說",
  "產",
  "種",
  "面",
  "而",
  "方",
  "後",
  "多",
  "定",
  "行",
  "學",
  "法",
  "所",
  "民",
  "得",
  "經",
  "十",
  "三",
  "之",
  "進",
  "著",
  "等",
  "部",
  "度",
  "家",
  "電",
  "力",
  "裡",
  "如",
  "水",
  "化",
  "高",
  "自",
  "二",
  "理",
  "起",
  "小",
  "物",
  "現",
  "實",
  "加",
  "量",
  "都",
  "兩",
  "體",
  "制",
  "機",
  "當",
  "使",
  "點",
  "從",
  "業",
  "本",
  "去",
  "把",
  "性",
  "好",
  "應",
  "開",
  "它",
  "合",
  "還",
  "因",
  "由",
  "其",
  "些",
  "然",
  "前",
  "外",
  "天",
  "政",
  "四",
  "日",
  "那",
  "社",
  "義",
  "事",
  "平",
  "形",
  "相",
  "全",
  "表",
  "間",
  "樣",
  "與",
  "關",
  "各",
  "重",
  "新",
  "線",
  "內",
  "數",
  "正",
  "心",
  "反",
  "你",
  "明",
  "看",
  "原",
  "又",
  "麼",
  "利",
  "比",
  "或",
  "但",
  "質",
  "氣",
  "第",
  "向",
  "道",
  "命",
  "此",
  "變",
  "條",
  "只",
  "沒",
  "結",
  "解",
  "問",
  "意",
  "建",
  "月",
  "公",
  "無",
  "系",
  "軍",
  "很",
  "情",
  "者",
  "最",
  "立",
  "代",
  "想",
  "已",
  "通",
  "並",
  "提",
  "直",
  "題",
  "黨",
  "程",
  "展",
  "五",
  "果",
  "料",
  "象",
  "員",
  "革",
  "位",
  "入",
  "常",
  "文",
  "總",
  "次",
  "品",
  "式",
  "活",
  "設",
  "及",
  "管",
  "特",
  "件",
  "長",
  "求",
  "老",
  "頭",
  "基",
  "資",
  "邊",
  "流",
  "路",
  "級",
  "少",
  "圖",
  "山",
  "統",
  "接",
  "知",
  "較",
  "將",
  "組",
  "見",
  "計",
  "別",
  "她",
  "手",
  "角",
  "期",
  "根",
  "論",
  "運",
  "農",
  "指",
  "幾",
  "九",
  "區",
  "強",
  "放",
  "決",
  "西",
  "被",
  "幹",
  "做",
  "必",
  "戰",
  "先",
  "回",
  "則",
  "任",
  "取",
  "據",
  "處",
  "隊",
  "南",
  "給",
  "色",
  "光",
  "門",
  "即",
  "保",
  "治",
  "北",
  "造",
  "百",
  "規",
  "熱",
  "領",
  "七",
  "海",
  "口",
  "東",
  "導",
  "器",
  "壓",
  "志",
  "世",
  "金",
  "增",
  "爭",
  "濟",
  "階",
  "油",
  "思",
  "術",
  "極",
  "交",
  "受",
  "聯",
  "什",
  "認",
  "六",
  "共",
  "權",
  "收",
  "證",
  "改",
  "清",
  "美",
  "再",
  "採",
  "轉",
  "更",
  "單",
  "風",
  "切",
  "打",
  "白",
  "教",
  "速",
  "花",
  "帶",
  "安",
  "場",
  "身",
  "車",
  "例",
  "真",
  "務",
  "具",
  "萬",
  "每",
  "目",
  "至",
  "達",
  "走",
  "積",
  "示",
  "議",
  "聲",
  "報",
  "鬥",
  "完",
  "類",
  "八",
  "離",
  "華",
  "名",
  "確",
  "才",
  "科",
  "張",
  "信",
  "馬",
  "節",
  "話",
  "米",
  "整",
  "空",
  "元",
  "況",
  "今",
  "集",
  "溫",
  "傳",
  "土",
  "許",
  "步",
  "群",
  "廣",
  "石",
  "記",
  "需",
  "段",
  "研",
  "界",
  "拉",
  "林",
  "律",
  "叫",
  "且",
  "究",
  "觀",
  "越",
  "織",
  "裝",
  "影",
  "算",
  "低",
  "持",
  "音",
  "眾",
  "書",
  "布",
  "复",
  "容",
  "兒",
  "須",
  "際",
  "商",
  "非",
  "驗",
  "連",
  "斷",
  "深",
  "難",
  "近",
  "礦",
  "千",
  "週",
  "委",
  "素",
  "技",
  "備",
  "半",
  "辦",
  "青",
  "省",
  "列",
  "習",
  "響",
  "約",
  "支",
  "般",
  "史",
  "感",
  "勞",
  "便",
  "團",
  "往",
  "酸",
  "歷",
  "市",
  "克",
  "何",
  "除",
  "消",
  "構",
  "府",
  "稱",
  "太",
  "準",
  "精",
  "值",
  "號",
  "率",
  "族",
  "維",
  "劃",
  "選",
  "標",
  "寫",
  "存",
  "候",
  "毛",
  "親",
  "快",
  "效",
  "斯",
  "院",
  "查",
  "江",
  "型",
  "眼",
  "王",
  "按",
  "格",
  "養",
  "易",
  "置",
  "派",
  "層",
  "片",
  "始",
  "卻",
  "專",
  "狀",
  "育",
  "廠",
  "京",
  "識",
  "適",
  "屬",
  "圓",
  "包",
  "火",
  "住",
  "調",
  "滿",
  "縣",
  "局",
  "照",
  "參",
  "紅",
  "細",
  "引",
  "聽",
  "該",
  "鐵",
  "價",
  "嚴",
  "首",
  "底",
  "液",
  "官",
  "德",
  "隨",
  "病",
  "蘇",
  "失",
  "爾",
  "死",
  "講",
  "配",
  "女",
  "黃",
  "推",
  "顯",
  "談",
  "罪",
  "神",
  "藝",
  "呢",
  "席",
  "含",
  "企",
  "望",
  "密",
  "批",
  "營",
  "項",
  "防",
  "舉",
  "球",
  "英",
  "氧",
  "勢",
  "告",
  "李",
  "台",
  "落",
  "木",
  "幫",
  "輪",
  "破",
  "亞",
  "師",
  "圍",
  "注",
  "遠",
  "字",
  "材",
  "排",
  "供",
  "河",
  "態",
  "封",
  "另",
  "施",
  "減",
  "樹",
  "溶",
  "怎",
  "止",
  "案",
  "言",
  "士",
  "均",
  "武",
  "固",
  "葉",
  "魚",
  "波",
  "視",
  "僅",
  "費",
  "緊",
  "愛",
  "左",
  "章",
  "早",
  "朝",
  "害",
  "續",
  "輕",
  "服",
  "試",
  "食",
  "充",
  "兵",
  "源",
  "判",
  "護",
  "司",
  "足",
  "某",
  "練",
  "差",
  "致",
  "板",
  "田",
  "降",
  "黑",
  "犯",
  "負",
  "擊",
  "范",
  "繼",
  "興",
  "似",
  "餘",
  "堅",
  "曲",
  "輸",
  "修",
  "故",
  "城",
  "夫",
  "夠",
  "送",
  "筆",
  "船",
  "佔",
  "右",
  "財",
  "吃",
  "富",
  "春",
  "職",
  "覺",
  "漢",
  "畫",
  "功",
  "巴",
  "跟",
  "雖",
  "雜",
  "飛",
  "檢",
  "吸",
  "助",
  "昇",
  "陽",
  "互",
  "初",
  "創",
  "抗",
  "考",
  "投",
  "壞",
  "策",
  "古",
  "徑",
  "換",
  "未",
  "跑",
  "留",
  "鋼",
  "曾",
  "端",
  "責",
  "站",
  "簡",
  "述",
  "錢",
  "副",
  "盡",
  "帝",
  "射",
  "草",
  "衝",
  "承",
  "獨",
  "令",
  "限",
  "阿",
  "宣",
  "環",
  "雙",
  "請",
  "超",
  "微",
  "讓",
  "控",
  "州",
  "良",
  "軸",
  "找",
  "否",
  "紀",
  "益",
  "依",
  "優",
  "頂",
  "礎",
  "載",
  "倒",
  "房",
  "突",
  "坐",
  "粉",
  "敵",
  "略",
  "客",
  "袁",
  "冷",
  "勝",
  "絕",
  "析",
  "塊",
  "劑",
  "測",
  "絲",
  "協",
  "訴",
  "念",
  "陳",
  "仍",
  "羅",
  "鹽",
  "友",
  "洋",
  "錯",
  "苦",
  "夜",
  "刑",
  "移",
  "頻",
  "逐",
  "靠",
  "混",
  "母",
  "短",
  "皮",
  "終",
  "聚",
  "汽",
  "村",
  "雲",
  "哪",
  "既",
  "距",
  "衛",
  "停",
  "烈",
  "央",
  "察",
  "燒",
  "迅",
  "境",
  "若",
  "印",
  "洲",
  "刻",
  "括",
  "激",
  "孔",
  "搞",
  "甚",
  "室",
  "待",
  "核",
  "校",
  "散",
  "侵",
  "吧",
  "甲",
  "遊",
  "久",
  "菜",
  "味",
  "舊",
  "模",
  "湖",
  "貨",
  "損",
  "預",
  "阻",
  "毫",
  "普",
  "穩",
  "乙",
  "媽",
  "植",
  "息",
  "擴",
  "銀",
  "語",
  "揮",
  "酒",
  "守",
  "拿",
  "序",
  "紙",
  "醫",
  "缺",
  "雨",
  "嗎",
  "針",
  "劉",
  "啊",
  "急",
  "唱",
  "誤",
  "訓",
  "願",
  "審",
  "附",
  "獲",
  "茶",
  "鮮",
  "糧",
  "斤",
  "孩",
  "脫",
  "硫",
  "肥",
  "善",
  "龍",
  "演",
  "父",
  "漸",
  "血",
  "歡",
  "械",
  "掌",
  "歌",
  "沙",
  "剛",
  "攻",
  "謂",
  "盾",
  "討",
  "晚",
  "粒",
  "亂",
  "燃",
  "矛",
  "乎",
  "殺",
  "藥",
  "寧",
  "魯",
  "貴",
  "鐘",
  "煤",
  "讀",
  "班",
  "伯",
  "香",
  "介",
  "迫",
  "句",
  "豐",
  "培",
  "握",
  "蘭",
  "擔",
  "弦",
  "蛋",
  "沉",
  "假",
  "穿",
  "執",
  "答",
  "樂",
  "誰",
  "順",
  "煙",
  "縮",
  "徵",
  "臉",
  "喜",
  "松",
  "腳",
  "困",
  "異",
  "免",
  "背",
  "星",
  "福",
  "買",
  "染",
  "井",
  "概",
  "慢",
  "怕",
  "磁",
  "倍",
  "祖",
  "皇",
  "促",
  "靜",
  "補",
  "評",
  "翻",
  "肉",
  "踐",
  "尼",
  "衣",
  "寬",
  "揚",
  "棉",
  "希",
  "傷",
  "操",
  "垂",
  "秋",
  "宜",
  "氫",
  "套",
  "督",
  "振",
  "架",
  "亮",
  "末",
  "憲",
  "慶",
  "編",
  "牛",
  "觸",
  "映",
  "雷",
  "銷",
  "詩",
  "座",
  "居",
  "抓",
  "裂",
  "胞",
  "呼",
  "娘",
  "景",
  "威",
  "綠",
  "晶",
  "厚",
  "盟",
  "衡",
  "雞",
  "孫",
  "延",
  "危",
  "膠",
  "屋",
  "鄉",
  "臨",
  "陸",
  "顧",
  "掉",
  "呀",
  "燈",
  "歲",
  "措",
  "束",
  "耐",
  "劇",
  "玉",
  "趙",
  "跳",
  "哥",
  "季",
  "課",
  "凱",
  "胡",
  "額",
  "款",
  "紹",
  "卷",
  "齊",
  "偉",
  "蒸",
  "殖",
  "永",
  "宗",
  "苗",
  "川",
  "爐",
  "岩",
  "弱",
  "零",
  "楊",
  "奏",
  "沿",
  "露",
  "桿",
  "探",
  "滑",
  "鎮",
  "飯",
  "濃",
  "航",
  "懷",
  "趕",
  "庫",
  "奪",
  "伊",
  "靈",
  "稅",
  "途",
  "滅",
  "賽",
  "歸",
  "召",
  "鼓",
  "播",
  "盤",
  "裁",
  "險",
  "康",
  "唯",
  "錄",
  "菌",
  "純",
  "借",
  "糖",
  "蓋",
  "橫",
  "符",
  "私",
  "努",
  "堂",
  "域",
  "槍",
  "潤",
  "幅",
  "哈",
  "竟",
  "熟",
  "蟲",
  "澤",
  "腦",
  "壤",
  "碳",
  "歐",
  "遍",
  "側",
  "寨",
  "敢",
  "徹",
  "慮",
  "斜",
  "薄",
  "庭",
  "納",
  "彈",
  "飼",
  "伸",
  "折",
  "麥",
  "濕",
  "暗",
  "荷",
  "瓦",
  "塞",
  "床",
  "築",
  "惡",
  "戶",
  "訪",
  "塔",
  "奇",
  "透",
  "梁",
  "刀",
  "旋",
  "跡",
  "卡",
  "氯",
  "遇",
  "份",
  "毒",
  "泥",
  "退",
  "洗",
  "擺",
  "灰",
  "彩",
  "賣",
  "耗",
  "夏",
  "擇",
  "忙",
  "銅",
  "獻",
  "硬",
  "予",
  "繁",
  "圈",
  "雪",
  "函",
  "亦",
  "抽",
  "篇",
  "陣",
  "陰",
  "丁",
  "尺",
  "追",
  "堆",
  "雄",
  "迎",
  "泛",
  "爸",
  "樓",
  "避",
  "謀",
  "噸",
  "野",
  "豬",
  "旗",
  "累",
  "偏",
  "典",
  "館",
  "索",
  "秦",
  "脂",
  "潮",
  "爺",
  "豆",
  "忽",
  "托",
  "驚",
  "塑",
  "遺",
  "愈",
  "朱",
  "替",
  "纖",
  "粗",
  "傾",
  "尚",
  "痛",
  "楚",
  "謝",
  "奮",
  "購",
  "磨",
  "君",
  "池",
  "旁",
  "碎",
  "骨",
  "監",
  "捕",
  "弟",
  "暴",
  "割",
  "貫",
  "殊",
  "釋",
  "詞",
  "亡",
  "壁",
  "頓",
  "寶",
  "午",
  "塵",
  "聞",
  "揭",
  "炮",
  "殘",
  "冬",
  "橋",
  "婦",
  "警",
  "綜",
  "招",
  "吳",
  "付",
  "浮",
  "遭",
  "徐",
  "您",
  "搖",
  "谷",
  "贊",
  "箱",
  "隔",
  "訂",
  "男",
  "吹",
  "園",
  "紛",
  "唐",
  "敗",
  "宋",
  "玻",
  "巨",
  "耕",
  "坦",
  "榮",
  "閉",
  "灣",
  "鍵",
  "凡",
  "駐",
  "鍋",
  "救",
  "恩",
  "剝",
  "凝",
  "鹼",
  "齒",
  "截",
  "煉",
  "麻",
  "紡",
  "禁",
  "廢",
  "盛",
  "版",
  "緩",
  "淨",
  "睛",
  "昌",
  "婚",
  "涉",
  "筒",
  "嘴",
  "插",
  "岸",
  "朗",
  "莊",
  "街",
  "藏",
  "姑",
  "貿",
  "腐",
  "奴",
  "啦",
  "慣",
  "乘",
  "夥",
  "恢",
  "勻",
  "紗",
  "扎",
  "辯",
  "耳",
  "彪",
  "臣",
  "億",
  "璃",
  "抵",
  "脈",
  "秀",
  "薩",
  "俄",
  "網",
  "舞",
  "店",
  "噴",
  "縱",
  "寸",
  "汗",
  "掛",
  "洪",
  "賀",
  "閃",
  "柬",
  "爆",
  "烯",
  "津",
  "稻",
  "牆",
  "軟",
  "勇",
  "像",
  "滾",
  "厘",
  "蒙",
  "芳",
  "肯",
  "坡",
  "柱",
  "盪",
  "腿",
  "儀",
  "旅",
  "尾",
  "軋",
  "冰",
  "貢",
  "登",
  "黎",
  "削",
  "鑽",
  "勒",
  "逃",
  "障",
  "氨",
  "郭",
  "峰",
  "幣",
  "港",
  "伏",
  "軌",
  "畝",
  "畢",
  "擦",
  "莫",
  "刺",
  "浪",
  "秘",
  "援",
  "株",
  "健",
  "售",
  "股",
  "島",
  "甘",
  "泡",
  "睡",
  "童",
  "鑄",
  "湯",
  "閥",
  "休",
  "匯",
  "舍",
  "牧",
  "繞",
  "炸",
  "哲",
  "磷",
  "績",
  "朋",
  "淡",
  "尖",
  "啟",
  "陷",
  "柴",
  "呈",
  "徒",
  "顏",
  "淚",
  "稍",
  "忘",
  "泵",
  "藍",
  "拖",
  "洞",
  "授",
  "鏡",
  "辛",
  "壯",
  "鋒",
  "貧",
  "虛",
  "彎",
  "摩",
  "泰",
  "幼",
  "廷",
  "尊",
  "窗",
  "綱",
  "弄",
  "隸",
  "疑",
  "氏",
  "宮",
  "姐",
  "震",
  "瑞",
  "怪",
  "尤",
  "琴",
  "循",
  "描",
  "膜",
  "違",
  "夾",
  "腰",
  "緣",
  "珠",
  "窮",
  "森",
  "枝",
  "竹",
  "溝",
  "催",
  "繩",
  "憶",
  "邦",
  "剩",
  "幸",
  "漿",
  "欄",
  "擁",
  "牙",
  "貯",
  "禮",
  "濾",
  "鈉",
  "紋",
  "罷",
  "拍",
  "咱",
  "喊",
  "袖",
  "埃",
  "勤",
  "罰",
  "焦",
  "潛",
  "伍",
  "墨",
  "欲",
  "縫",
  "姓",
  "刊",
  "飽",
  "仿",
  "獎",
  "鋁",
  "鬼",
  "麗",
  "跨",
  "默",
  "挖",
  "鏈",
  "掃",
  "喝",
  "袋",
  "炭",
  "污",
  "幕",
  "諸",
  "弧",
  "勵",
  "梅",
  "奶",
  "潔",
  "災",
  "舟",
  "鑑",
  "苯",
  "訟",
  "抱",
  "毀",
  "懂",
  "寒",
  "智",
  "埔",
  "寄",
  "屆",
  "躍",
  "渡",
  "挑",
  "丹",
  "艱",
  "貝",
  "碰",
  "拔",
  "爹",
  "戴",
  "碼",
  "夢",
  "芽",
  "熔",
  "赤",
  "漁",
  "哭",
  "敬",
  "顆",
  "奔",
  "鉛",
  "仲",
  "虎",
  "稀",
  "妹",
  "乏",
  "珍",
  "申",
  "桌",
  "遵",
  "允",
  "隆",
  "螺",
  "倉",
  "魏",
  "銳",
  "曉",
  "氮",
  "兼",
  "隱",
  "礙",
  "赫",
  "撥",
  "忠",
  "肅",
  "缸",
  "牽",
  "搶",
  "博",
  "巧",
  "殼",
  "兄",
  "杜",
  "訊",
  "誠",
  "碧",
  "祥",
  "柯",
  "頁",
  "巡",
  "矩",
  "悲",
  "灌",
  "齡",
  "倫",
  "票",
  "尋",
  "桂",
  "鋪",
  "聖",
  "恐",
  "恰",
  "鄭",
  "趣",
  "抬",
  "荒",
  "騰",
  "貼",
  "柔",
  "滴",
  "猛",
  "闊",
  "輛",
  "妻",
  "填",
  "撤",
  "儲",
  "簽",
  "鬧",
  "擾",
  "紫",
  "砂",
  "遞",
  "戲",
  "吊",
  "陶",
  "伐",
  "餵",
  "療",
  "瓶",
  "婆",
  "撫",
  "臂",
  "摸",
  "忍",
  "蝦",
  "蠟",
  "鄰",
  "胸",
  "鞏",
  "擠",
  "偶",
  "棄",
  "槽",
  "勁",
  "乳",
  "鄧",
  "吉",
  "仁",
  "爛",
  "磚",
  "租",
  "烏",
  "艦",
  "伴",
  "瓜",
  "淺",
  "丙",
  "暫",
  "燥",
  "橡",
  "柳",
  "迷",
  "暖",
  "牌",
  "秧",
  "膽",
  "詳",
  "簧",
  "踏",
  "瓷",
  "譜",
  "呆",
  "賓",
  "糊",
  "洛",
  "輝",
  "憤",
  "競",
  "隙",
  "怒",
  "粘",
  "乃",
  "緒",
  "肩",
  "籍",
  "敏",
  "塗",
  "熙",
  "皆",
  "偵",
  "懸",
  "掘",
  "享",
  "糾",
  "醒",
  "狂",
  "鎖",
  "淀",
  "恨",
  "牲",
  "霸",
  "爬",
  "賞",
  "逆",
  "玩",
  "陵",
  "祝",
  "秒",
  "浙",
  "貌",
  "役",
  "彼",
  "悉",
  "鴨",
  "趨",
  "鳳",
  "晨",
  "畜",
  "輩",
  "秩",
  "卵",
  "署",
  "梯",
  "炎",
  "灘",
  "棋",
  "驅",
  "篩",
  "峽",
  "冒",
  "啥",
  "壽",
  "譯",
  "浸",
  "泉",
  "帽",
  "遲",
  "矽",
  "疆",
  "貸",
  "漏",
  "稿",
  "冠",
  "嫩",
  "脅",
  "芯",
  "牢",
  "叛",
  "蝕",
  "奧",
  "鳴",
  "嶺",
  "羊",
  "憑",
  "串",
  "塘",
  "繪",
  "酵",
  "融",
  "盆",
  "錫",
  "廟",
  "籌",
  "凍",
  "輔",
  "攝",
  "襲",
  "筋",
  "拒",
  "僚",
  "旱",
  "鉀",
  "鳥",
  "漆",
  "沈",
  "眉",
  "疏",
  "添",
  "棒",
  "穗",
  "硝",
  "韓",
  "逼",
  "扭",
  "僑",
  "涼",
  "挺",
  "碗",
  "栽",
  "炒",
  "杯",
  "患",
  "餾",
  "勸",
  "豪",
  "遼",
  "勃",
  "鴻",
  "旦",
  "吏",
  "拜",
  "狗",
  "埋",
  "輥",
  "掩",
  "飲",
  "搬",
  "罵",
  "辭",
  "勾",
  "扣",
  "估",
  "蔣",
  "絨",
  "霧",
  "丈",
  "朵",
  "姆",
  "擬",
  "宇",
  "輯",
  "陝",
  "雕",
  "償",
  "蓄",
  "崇",
  "剪",
  "倡",
  "廳",
  "咬",
  "駛",
  "薯",
  "刷",
  "斥",
  "番",
  "賦",
  "奉",
  "佛",
  "澆",
  "漫",
  "曼",
  "扇",
  "鈣",
  "桃",
  "扶",
  "仔",
  "返",
  "俗",
  "虧",
  "腔",
  "鞋",
  "棱",
  "覆",
  "框",
  "悄",
  "叔",
  "撞",
  "騙",
  "勘",
  "旺",
  "沸",
  "孤",
  "吐",
  "孟",
  "渠",
  "屈",
  "疾",
  "妙",
  "惜",
  "仰",
  "狠",
  "脹",
  "諧",
  "拋",
  "黴",
  "桑",
  "崗",
  "嘛",
  "衰",
  "盜",
  "滲",
  "臟",
  "賴",
  "湧",
  "甜",
  "曹",
  "閱",
  "肌",
  "哩",
  "厲",
  "烴",
  "緯",
  "毅",
  "昨",
  "偽",
  "症",
  "煮",
  "嘆",
  "釘",
  "搭",
  "莖",
  "籠",
  "酷",
  "偷",
  "弓",
  "錐",
  "恆",
  "傑",
  "坑",
  "鼻",
  "翼",
  "綸",
  "敘",
  "獄",
  "逮",
  "罐",
  "絡",
  "棚",
  "抑",
  "膨",
  "蔬",
  "寺",
  "驟",
  "穆",
  "冶",
  "枯",
  "冊",
  "屍",
  "凸",
  "紳",
  "坯",
  "犧",
  "焰",
  "轟",
  "欣",
  "晉",
  "瘦",
  "禦",
  "錠",
  "錦",
  "喪",
  "旬",
  "鍛",
  "壟",
  "搜",
  "撲",
  "邀",
  "亭",
  "酯",
  "邁",
  "舒",
  "脆",
  "酶",
  "閒",
  "憂",
  "酚",
  "頑",
  "羽",
  "漲",
  "卸",
  "仗",
  "陪",
  "闢",
  "懲",
  "杭",
  "姚",
  "肚",
  "捉",
  "飄",
  "漂",
  "昆",
  "欺",
  "吾",
  "郎",
  "烷",
  "汁",
  "呵",
  "飾",
  "蕭",
  "雅",
  "郵",
  "遷",
  "燕",
  "撒",
  "姻",
  "赴",
  "宴",
  "煩",
  "債",
  "帳",
  "斑",
  "鈴",
  "旨",
  "醇",
  "董",
  "餅",
  "雛",
  "姿",
  "拌",
  "傅",
  "腹",
  "妥",
  "揉",
  "賢",
  "拆",
  "歪",
  "葡",
  "胺",
  "丟",
  "浩",
  "徽",
  "昂",
  "墊",
  "擋",
  "覽",
  "貪",
  "慰",
  "繳",
  "汪",
  "慌",
  "馮",
  "諾",
  "姜",
  "誼",
  "兇",
  "劣",
  "誣",
  "耀",
  "昏",
  "躺",
  "盈",
  "騎",
  "喬",
  "溪",
  "叢",
  "盧",
  "抹",
  "悶",
  "諮",
  "刮",
  "駕",
  "纜",
  "悟",
  "摘",
  "鉺",
  "擲",
  "頗",
  "幻",
  "柄",
  "惠",
  "慘",
  "佳",
  "仇",
  "臘",
  "窩",
  "滌",
  "劍",
  "瞧",
  "堡",
  "潑",
  "蔥",
  "罩",
  "霍",
  "撈",
  "胎",
  "蒼",
  "濱",
  "倆",
  "捅",
  "湘",
  "砍",
  "霞",
  "邵",
  "萄",
  "瘋",
  "淮",
  "遂",
  "熊",
  "糞",
  "烘",
  "宿",
  "檔",
  "戈",
  "駁",
  "嫂",
  "裕",
  "徙",
  "箭",
  "捐",
  "腸",
  "撐",
  "曬",
  "辨",
  "殿",
  "蓮",
  "攤",
  "攪",
  "醬",
  "屏",
  "疫",
  "哀",
  "蔡",
  "堵",
  "沫",
  "皺",
  "暢",
  "疊",
  "閣",
  "萊",
  "敲",
  "轄",
  "鉤",
  "痕",
  "壩",
  "巷",
  "餓",
  "禍",
  "丘",
  "玄",
  "溜",
  "曰",
  "邏",
  "彭",
  "嘗",
  "卿",
  "妨",
  "艇",
  "吞",
  "韋",
  "怨",
  "矮",
  "歇"
], hOe = [
  "가격",
  "가끔",
  "가난",
  "가능",
  "가득",
  "가르침",
  "가뭄",
  "가방",
  "가상",
  "가슴",
  "가운데",
  "가을",
  "가이드",
  "가입",
  "가장",
  "가정",
  "가족",
  "가죽",
  "각오",
  "각자",
  "간격",
  "간부",
  "간섭",
  "간장",
  "간접",
  "간판",
  "갈등",
  "갈비",
  "갈색",
  "갈증",
  "감각",
  "감기",
  "감소",
  "감수성",
  "감자",
  "감정",
  "갑자기",
  "강남",
  "강당",
  "강도",
  "강력히",
  "강변",
  "강북",
  "강사",
  "강수량",
  "강아지",
  "강원도",
  "강의",
  "강제",
  "강조",
  "같이",
  "개구리",
  "개나리",
  "개방",
  "개별",
  "개선",
  "개성",
  "개인",
  "객관적",
  "거실",
  "거액",
  "거울",
  "거짓",
  "거품",
  "걱정",
  "건강",
  "건물",
  "건설",
  "건조",
  "건축",
  "걸음",
  "검사",
  "검토",
  "게시판",
  "게임",
  "겨울",
  "견해",
  "결과",
  "결국",
  "결론",
  "결석",
  "결승",
  "결심",
  "결정",
  "결혼",
  "경계",
  "경고",
  "경기",
  "경력",
  "경복궁",
  "경비",
  "경상도",
  "경영",
  "경우",
  "경쟁",
  "경제",
  "경주",
  "경찰",
  "경치",
  "경향",
  "경험",
  "계곡",
  "계단",
  "계란",
  "계산",
  "계속",
  "계약",
  "계절",
  "계층",
  "계획",
  "고객",
  "고구려",
  "고궁",
  "고급",
  "고등학생",
  "고무신",
  "고민",
  "고양이",
  "고장",
  "고전",
  "고집",
  "고춧가루",
  "고통",
  "고향",
  "곡식",
  "골목",
  "골짜기",
  "골프",
  "공간",
  "공개",
  "공격",
  "공군",
  "공급",
  "공기",
  "공동",
  "공무원",
  "공부",
  "공사",
  "공식",
  "공업",
  "공연",
  "공원",
  "공장",
  "공짜",
  "공책",
  "공통",
  "공포",
  "공항",
  "공휴일",
  "과목",
  "과일",
  "과장",
  "과정",
  "과학",
  "관객",
  "관계",
  "관광",
  "관념",
  "관람",
  "관련",
  "관리",
  "관습",
  "관심",
  "관점",
  "관찰",
  "광경",
  "광고",
  "광장",
  "광주",
  "괴로움",
  "굉장히",
  "교과서",
  "교문",
  "교복",
  "교실",
  "교양",
  "교육",
  "교장",
  "교직",
  "교통",
  "교환",
  "교훈",
  "구경",
  "구름",
  "구멍",
  "구별",
  "구분",
  "구석",
  "구성",
  "구속",
  "구역",
  "구입",
  "구청",
  "구체적",
  "국가",
  "국기",
  "국내",
  "국립",
  "국물",
  "국민",
  "국수",
  "국어",
  "국왕",
  "국적",
  "국제",
  "국회",
  "군대",
  "군사",
  "군인",
  "궁극적",
  "권리",
  "권위",
  "권투",
  "귀국",
  "귀신",
  "규정",
  "규칙",
  "균형",
  "그날",
  "그냥",
  "그늘",
  "그러나",
  "그룹",
  "그릇",
  "그림",
  "그제서야",
  "그토록",
  "극복",
  "극히",
  "근거",
  "근교",
  "근래",
  "근로",
  "근무",
  "근본",
  "근원",
  "근육",
  "근처",
  "글씨",
  "글자",
  "금강산",
  "금고",
  "금년",
  "금메달",
  "금액",
  "금연",
  "금요일",
  "금지",
  "긍정적",
  "기간",
  "기관",
  "기념",
  "기능",
  "기독교",
  "기둥",
  "기록",
  "기름",
  "기법",
  "기본",
  "기분",
  "기쁨",
  "기숙사",
  "기술",
  "기억",
  "기업",
  "기온",
  "기운",
  "기원",
  "기적",
  "기준",
  "기침",
  "기혼",
  "기획",
  "긴급",
  "긴장",
  "길이",
  "김밥",
  "김치",
  "김포공항",
  "깍두기",
  "깜빡",
  "깨달음",
  "깨소금",
  "껍질",
  "꼭대기",
  "꽃잎",
  "나들이",
  "나란히",
  "나머지",
  "나물",
  "나침반",
  "나흘",
  "낙엽",
  "난방",
  "날개",
  "날씨",
  "날짜",
  "남녀",
  "남대문",
  "남매",
  "남산",
  "남자",
  "남편",
  "남학생",
  "낭비",
  "낱말",
  "내년",
  "내용",
  "내일",
  "냄비",
  "냄새",
  "냇물",
  "냉동",
  "냉면",
  "냉방",
  "냉장고",
  "넥타이",
  "넷째",
  "노동",
  "노란색",
  "노력",
  "노인",
  "녹음",
  "녹차",
  "녹화",
  "논리",
  "논문",
  "논쟁",
  "놀이",
  "농구",
  "농담",
  "농민",
  "농부",
  "농업",
  "농장",
  "농촌",
  "높이",
  "눈동자",
  "눈물",
  "눈썹",
  "뉴욕",
  "느낌",
  "늑대",
  "능동적",
  "능력",
  "다방",
  "다양성",
  "다음",
  "다이어트",
  "다행",
  "단계",
  "단골",
  "단독",
  "단맛",
  "단순",
  "단어",
  "단위",
  "단점",
  "단체",
  "단추",
  "단편",
  "단풍",
  "달걀",
  "달러",
  "달력",
  "달리",
  "닭고기",
  "담당",
  "담배",
  "담요",
  "담임",
  "답변",
  "답장",
  "당근",
  "당분간",
  "당연히",
  "당장",
  "대규모",
  "대낮",
  "대단히",
  "대답",
  "대도시",
  "대략",
  "대량",
  "대륙",
  "대문",
  "대부분",
  "대신",
  "대응",
  "대장",
  "대전",
  "대접",
  "대중",
  "대책",
  "대출",
  "대충",
  "대통령",
  "대학",
  "대한민국",
  "대합실",
  "대형",
  "덩어리",
  "데이트",
  "도대체",
  "도덕",
  "도둑",
  "도망",
  "도서관",
  "도심",
  "도움",
  "도입",
  "도자기",
  "도저히",
  "도전",
  "도중",
  "도착",
  "독감",
  "독립",
  "독서",
  "독일",
  "독창적",
  "동화책",
  "뒷모습",
  "뒷산",
  "딸아이",
  "마누라",
  "마늘",
  "마당",
  "마라톤",
  "마련",
  "마무리",
  "마사지",
  "마약",
  "마요네즈",
  "마을",
  "마음",
  "마이크",
  "마중",
  "마지막",
  "마찬가지",
  "마찰",
  "마흔",
  "막걸리",
  "막내",
  "막상",
  "만남",
  "만두",
  "만세",
  "만약",
  "만일",
  "만점",
  "만족",
  "만화",
  "많이",
  "말기",
  "말씀",
  "말투",
  "맘대로",
  "망원경",
  "매년",
  "매달",
  "매력",
  "매번",
  "매스컴",
  "매일",
  "매장",
  "맥주",
  "먹이",
  "먼저",
  "먼지",
  "멀리",
  "메일",
  "며느리",
  "며칠",
  "면담",
  "멸치",
  "명단",
  "명령",
  "명예",
  "명의",
  "명절",
  "명칭",
  "명함",
  "모금",
  "모니터",
  "모델",
  "모든",
  "모범",
  "모습",
  "모양",
  "모임",
  "모조리",
  "모집",
  "모퉁이",
  "목걸이",
  "목록",
  "목사",
  "목소리",
  "목숨",
  "목적",
  "목표",
  "몰래",
  "몸매",
  "몸무게",
  "몸살",
  "몸속",
  "몸짓",
  "몸통",
  "몹시",
  "무관심",
  "무궁화",
  "무더위",
  "무덤",
  "무릎",
  "무슨",
  "무엇",
  "무역",
  "무용",
  "무조건",
  "무지개",
  "무척",
  "문구",
  "문득",
  "문법",
  "문서",
  "문제",
  "문학",
  "문화",
  "물가",
  "물건",
  "물결",
  "물고기",
  "물론",
  "물리학",
  "물음",
  "물질",
  "물체",
  "미국",
  "미디어",
  "미사일",
  "미술",
  "미역",
  "미용실",
  "미움",
  "미인",
  "미팅",
  "미혼",
  "민간",
  "민족",
  "민주",
  "믿음",
  "밀가루",
  "밀리미터",
  "밑바닥",
  "바가지",
  "바구니",
  "바나나",
  "바늘",
  "바닥",
  "바닷가",
  "바람",
  "바이러스",
  "바탕",
  "박물관",
  "박사",
  "박수",
  "반대",
  "반드시",
  "반말",
  "반발",
  "반성",
  "반응",
  "반장",
  "반죽",
  "반지",
  "반찬",
  "받침",
  "발가락",
  "발걸음",
  "발견",
  "발달",
  "발레",
  "발목",
  "발바닥",
  "발생",
  "발음",
  "발자국",
  "발전",
  "발톱",
  "발표",
  "밤하늘",
  "밥그릇",
  "밥맛",
  "밥상",
  "밥솥",
  "방금",
  "방면",
  "방문",
  "방바닥",
  "방법",
  "방송",
  "방식",
  "방안",
  "방울",
  "방지",
  "방학",
  "방해",
  "방향",
  "배경",
  "배꼽",
  "배달",
  "배드민턴",
  "백두산",
  "백색",
  "백성",
  "백인",
  "백제",
  "백화점",
  "버릇",
  "버섯",
  "버튼",
  "번개",
  "번역",
  "번지",
  "번호",
  "벌금",
  "벌레",
  "벌써",
  "범위",
  "범인",
  "범죄",
  "법률",
  "법원",
  "법적",
  "법칙",
  "베이징",
  "벨트",
  "변경",
  "변동",
  "변명",
  "변신",
  "변호사",
  "변화",
  "별도",
  "별명",
  "별일",
  "병실",
  "병아리",
  "병원",
  "보관",
  "보너스",
  "보라색",
  "보람",
  "보름",
  "보상",
  "보안",
  "보자기",
  "보장",
  "보전",
  "보존",
  "보통",
  "보편적",
  "보험",
  "복도",
  "복사",
  "복숭아",
  "복습",
  "볶음",
  "본격적",
  "본래",
  "본부",
  "본사",
  "본성",
  "본인",
  "본질",
  "볼펜",
  "봉사",
  "봉지",
  "봉투",
  "부근",
  "부끄러움",
  "부담",
  "부동산",
  "부문",
  "부분",
  "부산",
  "부상",
  "부엌",
  "부인",
  "부작용",
  "부장",
  "부정",
  "부족",
  "부지런히",
  "부친",
  "부탁",
  "부품",
  "부회장",
  "북부",
  "북한",
  "분노",
  "분량",
  "분리",
  "분명",
  "분석",
  "분야",
  "분위기",
  "분필",
  "분홍색",
  "불고기",
  "불과",
  "불교",
  "불꽃",
  "불만",
  "불법",
  "불빛",
  "불안",
  "불이익",
  "불행",
  "브랜드",
  "비극",
  "비난",
  "비닐",
  "비둘기",
  "비디오",
  "비로소",
  "비만",
  "비명",
  "비밀",
  "비바람",
  "비빔밥",
  "비상",
  "비용",
  "비율",
  "비중",
  "비타민",
  "비판",
  "빌딩",
  "빗물",
  "빗방울",
  "빗줄기",
  "빛깔",
  "빨간색",
  "빨래",
  "빨리",
  "사건",
  "사계절",
  "사나이",
  "사냥",
  "사람",
  "사랑",
  "사립",
  "사모님",
  "사물",
  "사방",
  "사상",
  "사생활",
  "사설",
  "사슴",
  "사실",
  "사업",
  "사용",
  "사월",
  "사장",
  "사전",
  "사진",
  "사촌",
  "사춘기",
  "사탕",
  "사투리",
  "사흘",
  "산길",
  "산부인과",
  "산업",
  "산책",
  "살림",
  "살인",
  "살짝",
  "삼계탕",
  "삼국",
  "삼십",
  "삼월",
  "삼촌",
  "상관",
  "상금",
  "상대",
  "상류",
  "상반기",
  "상상",
  "상식",
  "상업",
  "상인",
  "상자",
  "상점",
  "상처",
  "상추",
  "상태",
  "상표",
  "상품",
  "상황",
  "새벽",
  "색깔",
  "색연필",
  "생각",
  "생명",
  "생물",
  "생방송",
  "생산",
  "생선",
  "생신",
  "생일",
  "생활",
  "서랍",
  "서른",
  "서명",
  "서민",
  "서비스",
  "서양",
  "서울",
  "서적",
  "서점",
  "서쪽",
  "서클",
  "석사",
  "석유",
  "선거",
  "선물",
  "선배",
  "선생",
  "선수",
  "선원",
  "선장",
  "선전",
  "선택",
  "선풍기",
  "설거지",
  "설날",
  "설렁탕",
  "설명",
  "설문",
  "설사",
  "설악산",
  "설치",
  "설탕",
  "섭씨",
  "성공",
  "성당",
  "성명",
  "성별",
  "성인",
  "성장",
  "성적",
  "성질",
  "성함",
  "세금",
  "세미나",
  "세상",
  "세월",
  "세종대왕",
  "세탁",
  "센터",
  "센티미터",
  "셋째",
  "소규모",
  "소극적",
  "소금",
  "소나기",
  "소년",
  "소득",
  "소망",
  "소문",
  "소설",
  "소속",
  "소아과",
  "소용",
  "소원",
  "소음",
  "소중히",
  "소지품",
  "소질",
  "소풍",
  "소형",
  "속담",
  "속도",
  "속옷",
  "손가락",
  "손길",
  "손녀",
  "손님",
  "손등",
  "손목",
  "손뼉",
  "손실",
  "손질",
  "손톱",
  "손해",
  "솔직히",
  "솜씨",
  "송아지",
  "송이",
  "송편",
  "쇠고기",
  "쇼핑",
  "수건",
  "수년",
  "수단",
  "수돗물",
  "수동적",
  "수면",
  "수명",
  "수박",
  "수상",
  "수석",
  "수술",
  "수시로",
  "수업",
  "수염",
  "수영",
  "수입",
  "수준",
  "수집",
  "수출",
  "수컷",
  "수필",
  "수학",
  "수험생",
  "수화기",
  "숙녀",
  "숙소",
  "숙제",
  "순간",
  "순서",
  "순수",
  "순식간",
  "순위",
  "숟가락",
  "술병",
  "술집",
  "숫자",
  "스님",
  "스물",
  "스스로",
  "스승",
  "스웨터",
  "스위치",
  "스케이트",
  "스튜디오",
  "스트레스",
  "스포츠",
  "슬쩍",
  "슬픔",
  "습관",
  "습기",
  "승객",
  "승리",
  "승부",
  "승용차",
  "승진",
  "시각",
  "시간",
  "시골",
  "시금치",
  "시나리오",
  "시댁",
  "시리즈",
  "시멘트",
  "시민",
  "시부모",
  "시선",
  "시설",
  "시스템",
  "시아버지",
  "시어머니",
  "시월",
  "시인",
  "시일",
  "시작",
  "시장",
  "시절",
  "시점",
  "시중",
  "시즌",
  "시집",
  "시청",
  "시합",
  "시험",
  "식구",
  "식기",
  "식당",
  "식량",
  "식료품",
  "식물",
  "식빵",
  "식사",
  "식생활",
  "식초",
  "식탁",
  "식품",
  "신고",
  "신규",
  "신념",
  "신문",
  "신발",
  "신비",
  "신사",
  "신세",
  "신용",
  "신제품",
  "신청",
  "신체",
  "신화",
  "실감",
  "실내",
  "실력",
  "실례",
  "실망",
  "실수",
  "실습",
  "실시",
  "실장",
  "실정",
  "실질적",
  "실천",
  "실체",
  "실컷",
  "실태",
  "실패",
  "실험",
  "실현",
  "심리",
  "심부름",
  "심사",
  "심장",
  "심정",
  "심판",
  "쌍둥이",
  "씨름",
  "씨앗",
  "아가씨",
  "아나운서",
  "아드님",
  "아들",
  "아쉬움",
  "아스팔트",
  "아시아",
  "아울러",
  "아저씨",
  "아줌마",
  "아직",
  "아침",
  "아파트",
  "아프리카",
  "아픔",
  "아홉",
  "아흔",
  "악기",
  "악몽",
  "악수",
  "안개",
  "안경",
  "안과",
  "안내",
  "안녕",
  "안동",
  "안방",
  "안부",
  "안주",
  "알루미늄",
  "알코올",
  "암시",
  "암컷",
  "압력",
  "앞날",
  "앞문",
  "애인",
  "애정",
  "액수",
  "앨범",
  "야간",
  "야단",
  "야옹",
  "약간",
  "약국",
  "약속",
  "약수",
  "약점",
  "약품",
  "약혼녀",
  "양념",
  "양력",
  "양말",
  "양배추",
  "양주",
  "양파",
  "어둠",
  "어려움",
  "어른",
  "어젯밤",
  "어쨌든",
  "어쩌다가",
  "어쩐지",
  "언니",
  "언덕",
  "언론",
  "언어",
  "얼굴",
  "얼른",
  "얼음",
  "얼핏",
  "엄마",
  "업무",
  "업종",
  "업체",
  "엉덩이",
  "엉망",
  "엉터리",
  "엊그제",
  "에너지",
  "에어컨",
  "엔진",
  "여건",
  "여고생",
  "여관",
  "여군",
  "여권",
  "여대생",
  "여덟",
  "여동생",
  "여든",
  "여론",
  "여름",
  "여섯",
  "여성",
  "여왕",
  "여인",
  "여전히",
  "여직원",
  "여학생",
  "여행",
  "역사",
  "역시",
  "역할",
  "연결",
  "연구",
  "연극",
  "연기",
  "연락",
  "연설",
  "연세",
  "연속",
  "연습",
  "연애",
  "연예인",
  "연인",
  "연장",
  "연주",
  "연출",
  "연필",
  "연합",
  "연휴",
  "열기",
  "열매",
  "열쇠",
  "열심히",
  "열정",
  "열차",
  "열흘",
  "염려",
  "엽서",
  "영국",
  "영남",
  "영상",
  "영양",
  "영역",
  "영웅",
  "영원히",
  "영하",
  "영향",
  "영혼",
  "영화",
  "옆구리",
  "옆방",
  "옆집",
  "예감",
  "예금",
  "예방",
  "예산",
  "예상",
  "예선",
  "예술",
  "예습",
  "예식장",
  "예약",
  "예전",
  "예절",
  "예정",
  "예컨대",
  "옛날",
  "오늘",
  "오락",
  "오랫동안",
  "오렌지",
  "오로지",
  "오른발",
  "오븐",
  "오십",
  "오염",
  "오월",
  "오전",
  "오직",
  "오징어",
  "오페라",
  "오피스텔",
  "오히려",
  "옥상",
  "옥수수",
  "온갖",
  "온라인",
  "온몸",
  "온종일",
  "온통",
  "올가을",
  "올림픽",
  "올해",
  "옷차림",
  "와이셔츠",
  "와인",
  "완성",
  "완전",
  "왕비",
  "왕자",
  "왜냐하면",
  "왠지",
  "외갓집",
  "외국",
  "외로움",
  "외삼촌",
  "외출",
  "외침",
  "외할머니",
  "왼발",
  "왼손",
  "왼쪽",
  "요금",
  "요일",
  "요즘",
  "요청",
  "용기",
  "용서",
  "용어",
  "우산",
  "우선",
  "우승",
  "우연히",
  "우정",
  "우체국",
  "우편",
  "운동",
  "운명",
  "운반",
  "운전",
  "운행",
  "울산",
  "울음",
  "움직임",
  "웃어른",
  "웃음",
  "워낙",
  "원고",
  "원래",
  "원서",
  "원숭이",
  "원인",
  "원장",
  "원피스",
  "월급",
  "월드컵",
  "월세",
  "월요일",
  "웨이터",
  "위반",
  "위법",
  "위성",
  "위원",
  "위험",
  "위협",
  "윗사람",
  "유난히",
  "유럽",
  "유명",
  "유물",
  "유산",
  "유적",
  "유치원",
  "유학",
  "유행",
  "유형",
  "육군",
  "육상",
  "육십",
  "육체",
  "은행",
  "음력",
  "음료",
  "음반",
  "음성",
  "음식",
  "음악",
  "음주",
  "의견",
  "의논",
  "의문",
  "의복",
  "의식",
  "의심",
  "의외로",
  "의욕",
  "의원",
  "의학",
  "이것",
  "이곳",
  "이념",
  "이놈",
  "이달",
  "이대로",
  "이동",
  "이렇게",
  "이력서",
  "이론적",
  "이름",
  "이민",
  "이발소",
  "이별",
  "이불",
  "이빨",
  "이상",
  "이성",
  "이슬",
  "이야기",
  "이용",
  "이웃",
  "이월",
  "이윽고",
  "이익",
  "이전",
  "이중",
  "이튿날",
  "이틀",
  "이혼",
  "인간",
  "인격",
  "인공",
  "인구",
  "인근",
  "인기",
  "인도",
  "인류",
  "인물",
  "인생",
  "인쇄",
  "인연",
  "인원",
  "인재",
  "인종",
  "인천",
  "인체",
  "인터넷",
  "인하",
  "인형",
  "일곱",
  "일기",
  "일단",
  "일대",
  "일등",
  "일반",
  "일본",
  "일부",
  "일상",
  "일생",
  "일손",
  "일요일",
  "일월",
  "일정",
  "일종",
  "일주일",
  "일찍",
  "일체",
  "일치",
  "일행",
  "일회용",
  "임금",
  "임무",
  "입대",
  "입력",
  "입맛",
  "입사",
  "입술",
  "입시",
  "입원",
  "입장",
  "입학",
  "자가용",
  "자격",
  "자극",
  "자동",
  "자랑",
  "자부심",
  "자식",
  "자신",
  "자연",
  "자원",
  "자율",
  "자전거",
  "자정",
  "자존심",
  "자판",
  "작가",
  "작년",
  "작성",
  "작업",
  "작용",
  "작은딸",
  "작품",
  "잔디",
  "잔뜩",
  "잔치",
  "잘못",
  "잠깐",
  "잠수함",
  "잠시",
  "잠옷",
  "잠자리",
  "잡지",
  "장관",
  "장군",
  "장기간",
  "장래",
  "장례",
  "장르",
  "장마",
  "장면",
  "장모",
  "장미",
  "장비",
  "장사",
  "장소",
  "장식",
  "장애인",
  "장인",
  "장점",
  "장차",
  "장학금",
  "재능",
  "재빨리",
  "재산",
  "재생",
  "재작년",
  "재정",
  "재채기",
  "재판",
  "재학",
  "재활용",
  "저것",
  "저고리",
  "저곳",
  "저녁",
  "저런",
  "저렇게",
  "저번",
  "저울",
  "저절로",
  "저축",
  "적극",
  "적당히",
  "적성",
  "적용",
  "적응",
  "전개",
  "전공",
  "전기",
  "전달",
  "전라도",
  "전망",
  "전문",
  "전반",
  "전부",
  "전세",
  "전시",
  "전용",
  "전자",
  "전쟁",
  "전주",
  "전철",
  "전체",
  "전통",
  "전혀",
  "전후",
  "절대",
  "절망",
  "절반",
  "절약",
  "절차",
  "점검",
  "점수",
  "점심",
  "점원",
  "점점",
  "점차",
  "접근",
  "접시",
  "접촉",
  "젓가락",
  "정거장",
  "정도",
  "정류장",
  "정리",
  "정말",
  "정면",
  "정문",
  "정반대",
  "정보",
  "정부",
  "정비",
  "정상",
  "정성",
  "정오",
  "정원",
  "정장",
  "정지",
  "정치",
  "정확히",
  "제공",
  "제과점",
  "제대로",
  "제목",
  "제발",
  "제법",
  "제삿날",
  "제안",
  "제일",
  "제작",
  "제주도",
  "제출",
  "제품",
  "제한",
  "조각",
  "조건",
  "조금",
  "조깅",
  "조명",
  "조미료",
  "조상",
  "조선",
  "조용히",
  "조절",
  "조정",
  "조직",
  "존댓말",
  "존재",
  "졸업",
  "졸음",
  "종교",
  "종로",
  "종류",
  "종소리",
  "종업원",
  "종종",
  "종합",
  "좌석",
  "죄인",
  "주관적",
  "주름",
  "주말",
  "주머니",
  "주먹",
  "주문",
  "주민",
  "주방",
  "주변",
  "주식",
  "주인",
  "주일",
  "주장",
  "주전자",
  "주택",
  "준비",
  "줄거리",
  "줄기",
  "줄무늬",
  "중간",
  "중계방송",
  "중국",
  "중년",
  "중단",
  "중독",
  "중반",
  "중부",
  "중세",
  "중소기업",
  "중순",
  "중앙",
  "중요",
  "중학교",
  "즉석",
  "즉시",
  "즐거움",
  "증가",
  "증거",
  "증권",
  "증상",
  "증세",
  "지각",
  "지갑",
  "지경",
  "지극히",
  "지금",
  "지급",
  "지능",
  "지름길",
  "지리산",
  "지방",
  "지붕",
  "지식",
  "지역",
  "지우개",
  "지원",
  "지적",
  "지점",
  "지진",
  "지출",
  "직선",
  "직업",
  "직원",
  "직장",
  "진급",
  "진동",
  "진로",
  "진료",
  "진리",
  "진짜",
  "진찰",
  "진출",
  "진통",
  "진행",
  "질문",
  "질병",
  "질서",
  "짐작",
  "집단",
  "집안",
  "집중",
  "짜증",
  "찌꺼기",
  "차남",
  "차라리",
  "차량",
  "차림",
  "차별",
  "차선",
  "차츰",
  "착각",
  "찬물",
  "찬성",
  "참가",
  "참기름",
  "참새",
  "참석",
  "참여",
  "참외",
  "참조",
  "찻잔",
  "창가",
  "창고",
  "창구",
  "창문",
  "창밖",
  "창작",
  "창조",
  "채널",
  "채점",
  "책가방",
  "책방",
  "책상",
  "책임",
  "챔피언",
  "처벌",
  "처음",
  "천국",
  "천둥",
  "천장",
  "천재",
  "천천히",
  "철도",
  "철저히",
  "철학",
  "첫날",
  "첫째",
  "청년",
  "청바지",
  "청소",
  "청춘",
  "체계",
  "체력",
  "체온",
  "체육",
  "체중",
  "체험",
  "초등학생",
  "초반",
  "초밥",
  "초상화",
  "초순",
  "초여름",
  "초원",
  "초저녁",
  "초점",
  "초청",
  "초콜릿",
  "촛불",
  "총각",
  "총리",
  "총장",
  "촬영",
  "최근",
  "최상",
  "최선",
  "최신",
  "최악",
  "최종",
  "추석",
  "추억",
  "추진",
  "추천",
  "추측",
  "축구",
  "축소",
  "축제",
  "축하",
  "출근",
  "출발",
  "출산",
  "출신",
  "출연",
  "출입",
  "출장",
  "출판",
  "충격",
  "충고",
  "충돌",
  "충분히",
  "충청도",
  "취업",
  "취직",
  "취향",
  "치약",
  "친구",
  "친척",
  "칠십",
  "칠월",
  "칠판",
  "침대",
  "침묵",
  "침실",
  "칫솔",
  "칭찬",
  "카메라",
  "카운터",
  "칼국수",
  "캐릭터",
  "캠퍼스",
  "캠페인",
  "커튼",
  "컨디션",
  "컬러",
  "컴퓨터",
  "코끼리",
  "코미디",
  "콘서트",
  "콜라",
  "콤플렉스",
  "콩나물",
  "쾌감",
  "쿠데타",
  "크림",
  "큰길",
  "큰딸",
  "큰소리",
  "큰아들",
  "큰어머니",
  "큰일",
  "큰절",
  "클래식",
  "클럽",
  "킬로",
  "타입",
  "타자기",
  "탁구",
  "탁자",
  "탄생",
  "태권도",
  "태양",
  "태풍",
  "택시",
  "탤런트",
  "터널",
  "터미널",
  "테니스",
  "테스트",
  "테이블",
  "텔레비전",
  "토론",
  "토마토",
  "토요일",
  "통계",
  "통과",
  "통로",
  "통신",
  "통역",
  "통일",
  "통장",
  "통제",
  "통증",
  "통합",
  "통화",
  "퇴근",
  "퇴원",
  "퇴직금",
  "튀김",
  "트럭",
  "특급",
  "특별",
  "특성",
  "특수",
  "특징",
  "특히",
  "튼튼히",
  "티셔츠",
  "파란색",
  "파일",
  "파출소",
  "판결",
  "판단",
  "판매",
  "판사",
  "팔십",
  "팔월",
  "팝송",
  "패션",
  "팩스",
  "팩시밀리",
  "팬티",
  "퍼센트",
  "페인트",
  "편견",
  "편의",
  "편지",
  "편히",
  "평가",
  "평균",
  "평생",
  "평소",
  "평양",
  "평일",
  "평화",
  "포스터",
  "포인트",
  "포장",
  "포함",
  "표면",
  "표정",
  "표준",
  "표현",
  "품목",
  "품질",
  "풍경",
  "풍속",
  "풍습",
  "프랑스",
  "프린터",
  "플라스틱",
  "피곤",
  "피망",
  "피아노",
  "필름",
  "필수",
  "필요",
  "필자",
  "필통",
  "핑계",
  "하느님",
  "하늘",
  "하드웨어",
  "하룻밤",
  "하반기",
  "하숙집",
  "하순",
  "하여튼",
  "하지만",
  "하천",
  "하품",
  "하필",
  "학과",
  "학교",
  "학급",
  "학기",
  "학년",
  "학력",
  "학번",
  "학부모",
  "학비",
  "학생",
  "학술",
  "학습",
  "학용품",
  "학원",
  "학위",
  "학자",
  "학점",
  "한계",
  "한글",
  "한꺼번에",
  "한낮",
  "한눈",
  "한동안",
  "한때",
  "한라산",
  "한마디",
  "한문",
  "한번",
  "한복",
  "한식",
  "한여름",
  "한쪽",
  "할머니",
  "할아버지",
  "할인",
  "함께",
  "함부로",
  "합격",
  "합리적",
  "항공",
  "항구",
  "항상",
  "항의",
  "해결",
  "해군",
  "해답",
  "해당",
  "해물",
  "해석",
  "해설",
  "해수욕장",
  "해안",
  "핵심",
  "핸드백",
  "햄버거",
  "햇볕",
  "햇살",
  "행동",
  "행복",
  "행사",
  "행운",
  "행위",
  "향기",
  "향상",
  "향수",
  "허락",
  "허용",
  "헬기",
  "현관",
  "현금",
  "현대",
  "현상",
  "현실",
  "현장",
  "현재",
  "현지",
  "혈액",
  "협력",
  "형부",
  "형사",
  "형수",
  "형식",
  "형제",
  "형태",
  "형편",
  "혜택",
  "호기심",
  "호남",
  "호랑이",
  "호박",
  "호텔",
  "호흡",
  "혹시",
  "홀로",
  "홈페이지",
  "홍보",
  "홍수",
  "홍차",
  "화면",
  "화분",
  "화살",
  "화요일",
  "화장",
  "화학",
  "확보",
  "확인",
  "확장",
  "확정",
  "환갑",
  "환경",
  "환영",
  "환율",
  "환자",
  "활기",
  "활동",
  "활발히",
  "활용",
  "활짝",
  "회견",
  "회관",
  "회복",
  "회색",
  "회원",
  "회장",
  "회전",
  "횟수",
  "횡단보도",
  "효율적",
  "후반",
  "후춧가루",
  "훈련",
  "훨씬",
  "휴식",
  "휴일",
  "흉내",
  "흐름",
  "흑백",
  "흑인",
  "흔적",
  "흔히",
  "흥미",
  "흥분",
  "희곡",
  "희망",
  "희생",
  "흰색",
  "힘껏"
], pOe = [
  "abaisser",
  "abandon",
  "abdiquer",
  "abeille",
  "abolir",
  "aborder",
  "aboutir",
  "aboyer",
  "abrasif",
  "abreuver",
  "abriter",
  "abroger",
  "abrupt",
  "absence",
  "absolu",
  "absurde",
  "abusif",
  "abyssal",
  "académie",
  "acajou",
  "acarien",
  "accabler",
  "accepter",
  "acclamer",
  "accolade",
  "accroche",
  "accuser",
  "acerbe",
  "achat",
  "acheter",
  "aciduler",
  "acier",
  "acompte",
  "acquérir",
  "acronyme",
  "acteur",
  "actif",
  "actuel",
  "adepte",
  "adéquat",
  "adhésif",
  "adjectif",
  "adjuger",
  "admettre",
  "admirer",
  "adopter",
  "adorer",
  "adoucir",
  "adresse",
  "adroit",
  "adulte",
  "adverbe",
  "aérer",
  "aéronef",
  "affaire",
  "affecter",
  "affiche",
  "affreux",
  "affubler",
  "agacer",
  "agencer",
  "agile",
  "agiter",
  "agrafer",
  "agréable",
  "agrume",
  "aider",
  "aiguille",
  "ailier",
  "aimable",
  "aisance",
  "ajouter",
  "ajuster",
  "alarmer",
  "alchimie",
  "alerte",
  "algèbre",
  "algue",
  "aliéner",
  "aliment",
  "alléger",
  "alliage",
  "allouer",
  "allumer",
  "alourdir",
  "alpaga",
  "altesse",
  "alvéole",
  "amateur",
  "ambigu",
  "ambre",
  "aménager",
  "amertume",
  "amidon",
  "amiral",
  "amorcer",
  "amour",
  "amovible",
  "amphibie",
  "ampleur",
  "amusant",
  "analyse",
  "anaphore",
  "anarchie",
  "anatomie",
  "ancien",
  "anéantir",
  "angle",
  "angoisse",
  "anguleux",
  "animal",
  "annexer",
  "annonce",
  "annuel",
  "anodin",
  "anomalie",
  "anonyme",
  "anormal",
  "antenne",
  "antidote",
  "anxieux",
  "apaiser",
  "apéritif",
  "aplanir",
  "apologie",
  "appareil",
  "appeler",
  "apporter",
  "appuyer",
  "aquarium",
  "aqueduc",
  "arbitre",
  "arbuste",
  "ardeur",
  "ardoise",
  "argent",
  "arlequin",
  "armature",
  "armement",
  "armoire",
  "armure",
  "arpenter",
  "arracher",
  "arriver",
  "arroser",
  "arsenic",
  "artériel",
  "article",
  "aspect",
  "asphalte",
  "aspirer",
  "assaut",
  "asservir",
  "assiette",
  "associer",
  "assurer",
  "asticot",
  "astre",
  "astuce",
  "atelier",
  "atome",
  "atrium",
  "atroce",
  "attaque",
  "attentif",
  "attirer",
  "attraper",
  "aubaine",
  "auberge",
  "audace",
  "audible",
  "augurer",
  "aurore",
  "automne",
  "autruche",
  "avaler",
  "avancer",
  "avarice",
  "avenir",
  "averse",
  "aveugle",
  "aviateur",
  "avide",
  "avion",
  "aviser",
  "avoine",
  "avouer",
  "avril",
  "axial",
  "axiome",
  "badge",
  "bafouer",
  "bagage",
  "baguette",
  "baignade",
  "balancer",
  "balcon",
  "baleine",
  "balisage",
  "bambin",
  "bancaire",
  "bandage",
  "banlieue",
  "bannière",
  "banquier",
  "barbier",
  "baril",
  "baron",
  "barque",
  "barrage",
  "bassin",
  "bastion",
  "bataille",
  "bateau",
  "batterie",
  "baudrier",
  "bavarder",
  "belette",
  "bélier",
  "belote",
  "bénéfice",
  "berceau",
  "berger",
  "berline",
  "bermuda",
  "besace",
  "besogne",
  "bétail",
  "beurre",
  "biberon",
  "bicycle",
  "bidule",
  "bijou",
  "bilan",
  "bilingue",
  "billard",
  "binaire",
  "biologie",
  "biopsie",
  "biotype",
  "biscuit",
  "bison",
  "bistouri",
  "bitume",
  "bizarre",
  "blafard",
  "blague",
  "blanchir",
  "blessant",
  "blinder",
  "blond",
  "bloquer",
  "blouson",
  "bobard",
  "bobine",
  "boire",
  "boiser",
  "bolide",
  "bonbon",
  "bondir",
  "bonheur",
  "bonifier",
  "bonus",
  "bordure",
  "borne",
  "botte",
  "boucle",
  "boueux",
  "bougie",
  "boulon",
  "bouquin",
  "bourse",
  "boussole",
  "boutique",
  "boxeur",
  "branche",
  "brasier",
  "brave",
  "brebis",
  "brèche",
  "breuvage",
  "bricoler",
  "brigade",
  "brillant",
  "brioche",
  "brique",
  "brochure",
  "broder",
  "bronzer",
  "brousse",
  "broyeur",
  "brume",
  "brusque",
  "brutal",
  "bruyant",
  "buffle",
  "buisson",
  "bulletin",
  "bureau",
  "burin",
  "bustier",
  "butiner",
  "butoir",
  "buvable",
  "buvette",
  "cabanon",
  "cabine",
  "cachette",
  "cadeau",
  "cadre",
  "caféine",
  "caillou",
  "caisson",
  "calculer",
  "calepin",
  "calibre",
  "calmer",
  "calomnie",
  "calvaire",
  "camarade",
  "caméra",
  "camion",
  "campagne",
  "canal",
  "caneton",
  "canon",
  "cantine",
  "canular",
  "capable",
  "caporal",
  "caprice",
  "capsule",
  "capter",
  "capuche",
  "carabine",
  "carbone",
  "caresser",
  "caribou",
  "carnage",
  "carotte",
  "carreau",
  "carton",
  "cascade",
  "casier",
  "casque",
  "cassure",
  "causer",
  "caution",
  "cavalier",
  "caverne",
  "caviar",
  "cédille",
  "ceinture",
  "céleste",
  "cellule",
  "cendrier",
  "censurer",
  "central",
  "cercle",
  "cérébral",
  "cerise",
  "cerner",
  "cerveau",
  "cesser",
  "chagrin",
  "chaise",
  "chaleur",
  "chambre",
  "chance",
  "chapitre",
  "charbon",
  "chasseur",
  "chaton",
  "chausson",
  "chavirer",
  "chemise",
  "chenille",
  "chéquier",
  "chercher",
  "cheval",
  "chien",
  "chiffre",
  "chignon",
  "chimère",
  "chiot",
  "chlorure",
  "chocolat",
  "choisir",
  "chose",
  "chouette",
  "chrome",
  "chute",
  "cigare",
  "cigogne",
  "cimenter",
  "cinéma",
  "cintrer",
  "circuler",
  "cirer",
  "cirque",
  "citerne",
  "citoyen",
  "citron",
  "civil",
  "clairon",
  "clameur",
  "claquer",
  "classe",
  "clavier",
  "client",
  "cligner",
  "climat",
  "clivage",
  "cloche",
  "clonage",
  "cloporte",
  "cobalt",
  "cobra",
  "cocasse",
  "cocotier",
  "coder",
  "codifier",
  "coffre",
  "cogner",
  "cohésion",
  "coiffer",
  "coincer",
  "colère",
  "colibri",
  "colline",
  "colmater",
  "colonel",
  "combat",
  "comédie",
  "commande",
  "compact",
  "concert",
  "conduire",
  "confier",
  "congeler",
  "connoter",
  "consonne",
  "contact",
  "convexe",
  "copain",
  "copie",
  "corail",
  "corbeau",
  "cordage",
  "corniche",
  "corpus",
  "correct",
  "cortège",
  "cosmique",
  "costume",
  "coton",
  "coude",
  "coupure",
  "courage",
  "couteau",
  "couvrir",
  "coyote",
  "crabe",
  "crainte",
  "cravate",
  "crayon",
  "créature",
  "créditer",
  "crémeux",
  "creuser",
  "crevette",
  "cribler",
  "crier",
  "cristal",
  "critère",
  "croire",
  "croquer",
  "crotale",
  "crucial",
  "cruel",
  "crypter",
  "cubique",
  "cueillir",
  "cuillère",
  "cuisine",
  "cuivre",
  "culminer",
  "cultiver",
  "cumuler",
  "cupide",
  "curatif",
  "curseur",
  "cyanure",
  "cycle",
  "cylindre",
  "cynique",
  "daigner",
  "damier",
  "danger",
  "danseur",
  "dauphin",
  "débattre",
  "débiter",
  "déborder",
  "débrider",
  "débutant",
  "décaler",
  "décembre",
  "déchirer",
  "décider",
  "déclarer",
  "décorer",
  "décrire",
  "décupler",
  "dédale",
  "déductif",
  "déesse",
  "défensif",
  "défiler",
  "défrayer",
  "dégager",
  "dégivrer",
  "déglutir",
  "dégrafer",
  "déjeuner",
  "délice",
  "déloger",
  "demander",
  "demeurer",
  "démolir",
  "dénicher",
  "dénouer",
  "dentelle",
  "dénuder",
  "départ",
  "dépenser",
  "déphaser",
  "déplacer",
  "déposer",
  "déranger",
  "dérober",
  "désastre",
  "descente",
  "désert",
  "désigner",
  "désobéir",
  "dessiner",
  "destrier",
  "détacher",
  "détester",
  "détourer",
  "détresse",
  "devancer",
  "devenir",
  "deviner",
  "devoir",
  "diable",
  "dialogue",
  "diamant",
  "dicter",
  "différer",
  "digérer",
  "digital",
  "digne",
  "diluer",
  "dimanche",
  "diminuer",
  "dioxyde",
  "directif",
  "diriger",
  "discuter",
  "disposer",
  "dissiper",
  "distance",
  "divertir",
  "diviser",
  "docile",
  "docteur",
  "dogme",
  "doigt",
  "domaine",
  "domicile",
  "dompter",
  "donateur",
  "donjon",
  "donner",
  "dopamine",
  "dortoir",
  "dorure",
  "dosage",
  "doseur",
  "dossier",
  "dotation",
  "douanier",
  "double",
  "douceur",
  "douter",
  "doyen",
  "dragon",
  "draper",
  "dresser",
  "dribbler",
  "droiture",
  "duperie",
  "duplexe",
  "durable",
  "durcir",
  "dynastie",
  "éblouir",
  "écarter",
  "écharpe",
  "échelle",
  "éclairer",
  "éclipse",
  "éclore",
  "écluse",
  "école",
  "économie",
  "écorce",
  "écouter",
  "écraser",
  "écrémer",
  "écrivain",
  "écrou",
  "écume",
  "écureuil",
  "édifier",
  "éduquer",
  "effacer",
  "effectif",
  "effigie",
  "effort",
  "effrayer",
  "effusion",
  "égaliser",
  "égarer",
  "éjecter",
  "élaborer",
  "élargir",
  "électron",
  "élégant",
  "éléphant",
  "élève",
  "éligible",
  "élitisme",
  "éloge",
  "élucider",
  "éluder",
  "emballer",
  "embellir",
  "embryon",
  "émeraude",
  "émission",
  "emmener",
  "émotion",
  "émouvoir",
  "empereur",
  "employer",
  "emporter",
  "emprise",
  "émulsion",
  "encadrer",
  "enchère",
  "enclave",
  "encoche",
  "endiguer",
  "endosser",
  "endroit",
  "enduire",
  "énergie",
  "enfance",
  "enfermer",
  "enfouir",
  "engager",
  "engin",
  "englober",
  "énigme",
  "enjamber",
  "enjeu",
  "enlever",
  "ennemi",
  "ennuyeux",
  "enrichir",
  "enrobage",
  "enseigne",
  "entasser",
  "entendre",
  "entier",
  "entourer",
  "entraver",
  "énumérer",
  "envahir",
  "enviable",
  "envoyer",
  "enzyme",
  "éolien",
  "épaissir",
  "épargne",
  "épatant",
  "épaule",
  "épicerie",
  "épidémie",
  "épier",
  "épilogue",
  "épine",
  "épisode",
  "épitaphe",
  "époque",
  "épreuve",
  "éprouver",
  "épuisant",
  "équerre",
  "équipe",
  "ériger",
  "érosion",
  "erreur",
  "éruption",
  "escalier",
  "espadon",
  "espèce",
  "espiègle",
  "espoir",
  "esprit",
  "esquiver",
  "essayer",
  "essence",
  "essieu",
  "essorer",
  "estime",
  "estomac",
  "estrade",
  "étagère",
  "étaler",
  "étanche",
  "étatique",
  "éteindre",
  "étendoir",
  "éternel",
  "éthanol",
  "éthique",
  "ethnie",
  "étirer",
  "étoffer",
  "étoile",
  "étonnant",
  "étourdir",
  "étrange",
  "étroit",
  "étude",
  "euphorie",
  "évaluer",
  "évasion",
  "éventail",
  "évidence",
  "éviter",
  "évolutif",
  "évoquer",
  "exact",
  "exagérer",
  "exaucer",
  "exceller",
  "excitant",
  "exclusif",
  "excuse",
  "exécuter",
  "exemple",
  "exercer",
  "exhaler",
  "exhorter",
  "exigence",
  "exiler",
  "exister",
  "exotique",
  "expédier",
  "explorer",
  "exposer",
  "exprimer",
  "exquis",
  "extensif",
  "extraire",
  "exulter",
  "fable",
  "fabuleux",
  "facette",
  "facile",
  "facture",
  "faiblir",
  "falaise",
  "fameux",
  "famille",
  "farceur",
  "farfelu",
  "farine",
  "farouche",
  "fasciner",
  "fatal",
  "fatigue",
  "faucon",
  "fautif",
  "faveur",
  "favori",
  "fébrile",
  "féconder",
  "fédérer",
  "félin",
  "femme",
  "fémur",
  "fendoir",
  "féodal",
  "fermer",
  "féroce",
  "ferveur",
  "festival",
  "feuille",
  "feutre",
  "février",
  "fiasco",
  "ficeler",
  "fictif",
  "fidèle",
  "figure",
  "filature",
  "filetage",
  "filière",
  "filleul",
  "filmer",
  "filou",
  "filtrer",
  "financer",
  "finir",
  "fiole",
  "firme",
  "fissure",
  "fixer",
  "flairer",
  "flamme",
  "flasque",
  "flatteur",
  "fléau",
  "flèche",
  "fleur",
  "flexion",
  "flocon",
  "flore",
  "fluctuer",
  "fluide",
  "fluvial",
  "folie",
  "fonderie",
  "fongible",
  "fontaine",
  "forcer",
  "forgeron",
  "formuler",
  "fortune",
  "fossile",
  "foudre",
  "fougère",
  "fouiller",
  "foulure",
  "fourmi",
  "fragile",
  "fraise",
  "franchir",
  "frapper",
  "frayeur",
  "frégate",
  "freiner",
  "frelon",
  "frémir",
  "frénésie",
  "frère",
  "friable",
  "friction",
  "frisson",
  "frivole",
  "froid",
  "fromage",
  "frontal",
  "frotter",
  "fruit",
  "fugitif",
  "fuite",
  "fureur",
  "furieux",
  "furtif",
  "fusion",
  "futur",
  "gagner",
  "galaxie",
  "galerie",
  "gambader",
  "garantir",
  "gardien",
  "garnir",
  "garrigue",
  "gazelle",
  "gazon",
  "géant",
  "gélatine",
  "gélule",
  "gendarme",
  "général",
  "génie",
  "genou",
  "gentil",
  "géologie",
  "géomètre",
  "géranium",
  "germe",
  "gestuel",
  "geyser",
  "gibier",
  "gicler",
  "girafe",
  "givre",
  "glace",
  "glaive",
  "glisser",
  "globe",
  "gloire",
  "glorieux",
  "golfeur",
  "gomme",
  "gonfler",
  "gorge",
  "gorille",
  "goudron",
  "gouffre",
  "goulot",
  "goupille",
  "gourmand",
  "goutte",
  "graduel",
  "graffiti",
  "graine",
  "grand",
  "grappin",
  "gratuit",
  "gravir",
  "grenat",
  "griffure",
  "griller",
  "grimper",
  "grogner",
  "gronder",
  "grotte",
  "groupe",
  "gruger",
  "grutier",
  "gruyère",
  "guépard",
  "guerrier",
  "guide",
  "guimauve",
  "guitare",
  "gustatif",
  "gymnaste",
  "gyrostat",
  "habitude",
  "hachoir",
  "halte",
  "hameau",
  "hangar",
  "hanneton",
  "haricot",
  "harmonie",
  "harpon",
  "hasard",
  "hélium",
  "hématome",
  "herbe",
  "hérisson",
  "hermine",
  "héron",
  "hésiter",
  "heureux",
  "hiberner",
  "hibou",
  "hilarant",
  "histoire",
  "hiver",
  "homard",
  "hommage",
  "homogène",
  "honneur",
  "honorer",
  "honteux",
  "horde",
  "horizon",
  "horloge",
  "hormone",
  "horrible",
  "houleux",
  "housse",
  "hublot",
  "huileux",
  "humain",
  "humble",
  "humide",
  "humour",
  "hurler",
  "hydromel",
  "hygiène",
  "hymne",
  "hypnose",
  "idylle",
  "ignorer",
  "iguane",
  "illicite",
  "illusion",
  "image",
  "imbiber",
  "imiter",
  "immense",
  "immobile",
  "immuable",
  "impact",
  "impérial",
  "implorer",
  "imposer",
  "imprimer",
  "imputer",
  "incarner",
  "incendie",
  "incident",
  "incliner",
  "incolore",
  "indexer",
  "indice",
  "inductif",
  "inédit",
  "ineptie",
  "inexact",
  "infini",
  "infliger",
  "informer",
  "infusion",
  "ingérer",
  "inhaler",
  "inhiber",
  "injecter",
  "injure",
  "innocent",
  "inoculer",
  "inonder",
  "inscrire",
  "insecte",
  "insigne",
  "insolite",
  "inspirer",
  "instinct",
  "insulter",
  "intact",
  "intense",
  "intime",
  "intrigue",
  "intuitif",
  "inutile",
  "invasion",
  "inventer",
  "inviter",
  "invoquer",
  "ironique",
  "irradier",
  "irréel",
  "irriter",
  "isoler",
  "ivoire",
  "ivresse",
  "jaguar",
  "jaillir",
  "jambe",
  "janvier",
  "jardin",
  "jauger",
  "jaune",
  "javelot",
  "jetable",
  "jeton",
  "jeudi",
  "jeunesse",
  "joindre",
  "joncher",
  "jongler",
  "joueur",
  "jouissif",
  "journal",
  "jovial",
  "joyau",
  "joyeux",
  "jubiler",
  "jugement",
  "junior",
  "jupon",
  "juriste",
  "justice",
  "juteux",
  "juvénile",
  "kayak",
  "kimono",
  "kiosque",
  "label",
  "labial",
  "labourer",
  "lacérer",
  "lactose",
  "lagune",
  "laine",
  "laisser",
  "laitier",
  "lambeau",
  "lamelle",
  "lampe",
  "lanceur",
  "langage",
  "lanterne",
  "lapin",
  "largeur",
  "larme",
  "laurier",
  "lavabo",
  "lavoir",
  "lecture",
  "légal",
  "léger",
  "légume",
  "lessive",
  "lettre",
  "levier",
  "lexique",
  "lézard",
  "liasse",
  "libérer",
  "libre",
  "licence",
  "licorne",
  "liège",
  "lièvre",
  "ligature",
  "ligoter",
  "ligue",
  "limer",
  "limite",
  "limonade",
  "limpide",
  "linéaire",
  "lingot",
  "lionceau",
  "liquide",
  "lisière",
  "lister",
  "lithium",
  "litige",
  "littoral",
  "livreur",
  "logique",
  "lointain",
  "loisir",
  "lombric",
  "loterie",
  "louer",
  "lourd",
  "loutre",
  "louve",
  "loyal",
  "lubie",
  "lucide",
  "lucratif",
  "lueur",
  "lugubre",
  "luisant",
  "lumière",
  "lunaire",
  "lundi",
  "luron",
  "lutter",
  "luxueux",
  "machine",
  "magasin",
  "magenta",
  "magique",
  "maigre",
  "maillon",
  "maintien",
  "mairie",
  "maison",
  "majorer",
  "malaxer",
  "maléfice",
  "malheur",
  "malice",
  "mallette",
  "mammouth",
  "mandater",
  "maniable",
  "manquant",
  "manteau",
  "manuel",
  "marathon",
  "marbre",
  "marchand",
  "mardi",
  "maritime",
  "marqueur",
  "marron",
  "marteler",
  "mascotte",
  "massif",
  "matériel",
  "matière",
  "matraque",
  "maudire",
  "maussade",
  "mauve",
  "maximal",
  "méchant",
  "méconnu",
  "médaille",
  "médecin",
  "méditer",
  "méduse",
  "meilleur",
  "mélange",
  "mélodie",
  "membre",
  "mémoire",
  "menacer",
  "mener",
  "menhir",
  "mensonge",
  "mentor",
  "mercredi",
  "mérite",
  "merle",
  "messager",
  "mesure",
  "métal",
  "météore",
  "méthode",
  "métier",
  "meuble",
  "miauler",
  "microbe",
  "miette",
  "mignon",
  "migrer",
  "milieu",
  "million",
  "mimique",
  "mince",
  "minéral",
  "minimal",
  "minorer",
  "minute",
  "miracle",
  "miroiter",
  "missile",
  "mixte",
  "mobile",
  "moderne",
  "moelleux",
  "mondial",
  "moniteur",
  "monnaie",
  "monotone",
  "monstre",
  "montagne",
  "monument",
  "moqueur",
  "morceau",
  "morsure",
  "mortier",
  "moteur",
  "motif",
  "mouche",
  "moufle",
  "moulin",
  "mousson",
  "mouton",
  "mouvant",
  "multiple",
  "munition",
  "muraille",
  "murène",
  "murmure",
  "muscle",
  "muséum",
  "musicien",
  "mutation",
  "muter",
  "mutuel",
  "myriade",
  "myrtille",
  "mystère",
  "mythique",
  "nageur",
  "nappe",
  "narquois",
  "narrer",
  "natation",
  "nation",
  "nature",
  "naufrage",
  "nautique",
  "navire",
  "nébuleux",
  "nectar",
  "néfaste",
  "négation",
  "négliger",
  "négocier",
  "neige",
  "nerveux",
  "nettoyer",
  "neurone",
  "neutron",
  "neveu",
  "niche",
  "nickel",
  "nitrate",
  "niveau",
  "noble",
  "nocif",
  "nocturne",
  "noirceur",
  "noisette",
  "nomade",
  "nombreux",
  "nommer",
  "normatif",
  "notable",
  "notifier",
  "notoire",
  "nourrir",
  "nouveau",
  "novateur",
  "novembre",
  "novice",
  "nuage",
  "nuancer",
  "nuire",
  "nuisible",
  "numéro",
  "nuptial",
  "nuque",
  "nutritif",
  "obéir",
  "objectif",
  "obliger",
  "obscur",
  "observer",
  "obstacle",
  "obtenir",
  "obturer",
  "occasion",
  "occuper",
  "océan",
  "octobre",
  "octroyer",
  "octupler",
  "oculaire",
  "odeur",
  "odorant",
  "offenser",
  "officier",
  "offrir",
  "ogive",
  "oiseau",
  "oisillon",
  "olfactif",
  "olivier",
  "ombrage",
  "omettre",
  "onctueux",
  "onduler",
  "onéreux",
  "onirique",
  "opale",
  "opaque",
  "opérer",
  "opinion",
  "opportun",
  "opprimer",
  "opter",
  "optique",
  "orageux",
  "orange",
  "orbite",
  "ordonner",
  "oreille",
  "organe",
  "orgueil",
  "orifice",
  "ornement",
  "orque",
  "ortie",
  "osciller",
  "osmose",
  "ossature",
  "otarie",
  "ouragan",
  "ourson",
  "outil",
  "outrager",
  "ouvrage",
  "ovation",
  "oxyde",
  "oxygène",
  "ozone",
  "paisible",
  "palace",
  "palmarès",
  "palourde",
  "palper",
  "panache",
  "panda",
  "pangolin",
  "paniquer",
  "panneau",
  "panorama",
  "pantalon",
  "papaye",
  "papier",
  "papoter",
  "papyrus",
  "paradoxe",
  "parcelle",
  "paresse",
  "parfumer",
  "parler",
  "parole",
  "parrain",
  "parsemer",
  "partager",
  "parure",
  "parvenir",
  "passion",
  "pastèque",
  "paternel",
  "patience",
  "patron",
  "pavillon",
  "pavoiser",
  "payer",
  "paysage",
  "peigne",
  "peintre",
  "pelage",
  "pélican",
  "pelle",
  "pelouse",
  "peluche",
  "pendule",
  "pénétrer",
  "pénible",
  "pensif",
  "pénurie",
  "pépite",
  "péplum",
  "perdrix",
  "perforer",
  "période",
  "permuter",
  "perplexe",
  "persil",
  "perte",
  "peser",
  "pétale",
  "petit",
  "pétrir",
  "peuple",
  "pharaon",
  "phobie",
  "phoque",
  "photon",
  "phrase",
  "physique",
  "piano",
  "pictural",
  "pièce",
  "pierre",
  "pieuvre",
  "pilote",
  "pinceau",
  "pipette",
  "piquer",
  "pirogue",
  "piscine",
  "piston",
  "pivoter",
  "pixel",
  "pizza",
  "placard",
  "plafond",
  "plaisir",
  "planer",
  "plaque",
  "plastron",
  "plateau",
  "pleurer",
  "plexus",
  "pliage",
  "plomb",
  "plonger",
  "pluie",
  "plumage",
  "pochette",
  "poésie",
  "poète",
  "pointe",
  "poirier",
  "poisson",
  "poivre",
  "polaire",
  "policier",
  "pollen",
  "polygone",
  "pommade",
  "pompier",
  "ponctuel",
  "pondérer",
  "poney",
  "portique",
  "position",
  "posséder",
  "posture",
  "potager",
  "poteau",
  "potion",
  "pouce",
  "poulain",
  "poumon",
  "pourpre",
  "poussin",
  "pouvoir",
  "prairie",
  "pratique",
  "précieux",
  "prédire",
  "préfixe",
  "prélude",
  "prénom",
  "présence",
  "prétexte",
  "prévoir",
  "primitif",
  "prince",
  "prison",
  "priver",
  "problème",
  "procéder",
  "prodige",
  "profond",
  "progrès",
  "proie",
  "projeter",
  "prologue",
  "promener",
  "propre",
  "prospère",
  "protéger",
  "prouesse",
  "proverbe",
  "prudence",
  "pruneau",
  "psychose",
  "public",
  "puceron",
  "puiser",
  "pulpe",
  "pulsar",
  "punaise",
  "punitif",
  "pupitre",
  "purifier",
  "puzzle",
  "pyramide",
  "quasar",
  "querelle",
  "question",
  "quiétude",
  "quitter",
  "quotient",
  "racine",
  "raconter",
  "radieux",
  "ragondin",
  "raideur",
  "raisin",
  "ralentir",
  "rallonge",
  "ramasser",
  "rapide",
  "rasage",
  "ratisser",
  "ravager",
  "ravin",
  "rayonner",
  "réactif",
  "réagir",
  "réaliser",
  "réanimer",
  "recevoir",
  "réciter",
  "réclamer",
  "récolter",
  "recruter",
  "reculer",
  "recycler",
  "rédiger",
  "redouter",
  "refaire",
  "réflexe",
  "réformer",
  "refrain",
  "refuge",
  "régalien",
  "région",
  "réglage",
  "régulier",
  "réitérer",
  "rejeter",
  "rejouer",
  "relatif",
  "relever",
  "relief",
  "remarque",
  "remède",
  "remise",
  "remonter",
  "remplir",
  "remuer",
  "renard",
  "renfort",
  "renifler",
  "renoncer",
  "rentrer",
  "renvoi",
  "replier",
  "reporter",
  "reprise",
  "reptile",
  "requin",
  "réserve",
  "résineux",
  "résoudre",
  "respect",
  "rester",
  "résultat",
  "rétablir",
  "retenir",
  "réticule",
  "retomber",
  "retracer",
  "réunion",
  "réussir",
  "revanche",
  "revivre",
  "révolte",
  "révulsif",
  "richesse",
  "rideau",
  "rieur",
  "rigide",
  "rigoler",
  "rincer",
  "riposter",
  "risible",
  "risque",
  "rituel",
  "rival",
  "rivière",
  "rocheux",
  "romance",
  "rompre",
  "ronce",
  "rondin",
  "roseau",
  "rosier",
  "rotatif",
  "rotor",
  "rotule",
  "rouge",
  "rouille",
  "rouleau",
  "routine",
  "royaume",
  "ruban",
  "rubis",
  "ruche",
  "ruelle",
  "rugueux",
  "ruiner",
  "ruisseau",
  "ruser",
  "rustique",
  "rythme",
  "sabler",
  "saboter",
  "sabre",
  "sacoche",
  "safari",
  "sagesse",
  "saisir",
  "salade",
  "salive",
  "salon",
  "saluer",
  "samedi",
  "sanction",
  "sanglier",
  "sarcasme",
  "sardine",
  "saturer",
  "saugrenu",
  "saumon",
  "sauter",
  "sauvage",
  "savant",
  "savonner",
  "scalpel",
  "scandale",
  "scélérat",
  "scénario",
  "sceptre",
  "schéma",
  "science",
  "scinder",
  "score",
  "scrutin",
  "sculpter",
  "séance",
  "sécable",
  "sécher",
  "secouer",
  "sécréter",
  "sédatif",
  "séduire",
  "seigneur",
  "séjour",
  "sélectif",
  "semaine",
  "sembler",
  "semence",
  "séminal",
  "sénateur",
  "sensible",
  "sentence",
  "séparer",
  "séquence",
  "serein",
  "sergent",
  "sérieux",
  "serrure",
  "sérum",
  "service",
  "sésame",
  "sévir",
  "sevrage",
  "sextuple",
  "sidéral",
  "siècle",
  "siéger",
  "siffler",
  "sigle",
  "signal",
  "silence",
  "silicium",
  "simple",
  "sincère",
  "sinistre",
  "siphon",
  "sirop",
  "sismique",
  "situer",
  "skier",
  "social",
  "socle",
  "sodium",
  "soigneux",
  "soldat",
  "soleil",
  "solitude",
  "soluble",
  "sombre",
  "sommeil",
  "somnoler",
  "sonde",
  "songeur",
  "sonnette",
  "sonore",
  "sorcier",
  "sortir",
  "sosie",
  "sottise",
  "soucieux",
  "soudure",
  "souffle",
  "soulever",
  "soupape",
  "source",
  "soutirer",
  "souvenir",
  "spacieux",
  "spatial",
  "spécial",
  "sphère",
  "spiral",
  "stable",
  "station",
  "sternum",
  "stimulus",
  "stipuler",
  "strict",
  "studieux",
  "stupeur",
  "styliste",
  "sublime",
  "substrat",
  "subtil",
  "subvenir",
  "succès",
  "sucre",
  "suffixe",
  "suggérer",
  "suiveur",
  "sulfate",
  "superbe",
  "supplier",
  "surface",
  "suricate",
  "surmener",
  "surprise",
  "sursaut",
  "survie",
  "suspect",
  "syllabe",
  "symbole",
  "symétrie",
  "synapse",
  "syntaxe",
  "système",
  "tabac",
  "tablier",
  "tactile",
  "tailler",
  "talent",
  "talisman",
  "talonner",
  "tambour",
  "tamiser",
  "tangible",
  "tapis",
  "taquiner",
  "tarder",
  "tarif",
  "tartine",
  "tasse",
  "tatami",
  "tatouage",
  "taupe",
  "taureau",
  "taxer",
  "témoin",
  "temporel",
  "tenaille",
  "tendre",
  "teneur",
  "tenir",
  "tension",
  "terminer",
  "terne",
  "terrible",
  "tétine",
  "texte",
  "thème",
  "théorie",
  "thérapie",
  "thorax",
  "tibia",
  "tiède",
  "timide",
  "tirelire",
  "tiroir",
  "tissu",
  "titane",
  "titre",
  "tituber",
  "toboggan",
  "tolérant",
  "tomate",
  "tonique",
  "tonneau",
  "toponyme",
  "torche",
  "tordre",
  "tornade",
  "torpille",
  "torrent",
  "torse",
  "tortue",
  "totem",
  "toucher",
  "tournage",
  "tousser",
  "toxine",
  "traction",
  "trafic",
  "tragique",
  "trahir",
  "train",
  "trancher",
  "travail",
  "trèfle",
  "tremper",
  "trésor",
  "treuil",
  "triage",
  "tribunal",
  "tricoter",
  "trilogie",
  "triomphe",
  "tripler",
  "triturer",
  "trivial",
  "trombone",
  "tronc",
  "tropical",
  "troupeau",
  "tuile",
  "tulipe",
  "tumulte",
  "tunnel",
  "turbine",
  "tuteur",
  "tutoyer",
  "tuyau",
  "tympan",
  "typhon",
  "typique",
  "tyran",
  "ubuesque",
  "ultime",
  "ultrason",
  "unanime",
  "unifier",
  "union",
  "unique",
  "unitaire",
  "univers",
  "uranium",
  "urbain",
  "urticant",
  "usage",
  "usine",
  "usuel",
  "usure",
  "utile",
  "utopie",
  "vacarme",
  "vaccin",
  "vagabond",
  "vague",
  "vaillant",
  "vaincre",
  "vaisseau",
  "valable",
  "valise",
  "vallon",
  "valve",
  "vampire",
  "vanille",
  "vapeur",
  "varier",
  "vaseux",
  "vassal",
  "vaste",
  "vecteur",
  "vedette",
  "végétal",
  "véhicule",
  "veinard",
  "véloce",
  "vendredi",
  "vénérer",
  "venger",
  "venimeux",
  "ventouse",
  "verdure",
  "vérin",
  "vernir",
  "verrou",
  "verser",
  "vertu",
  "veston",
  "vétéran",
  "vétuste",
  "vexant",
  "vexer",
  "viaduc",
  "viande",
  "victoire",
  "vidange",
  "vidéo",
  "vignette",
  "vigueur",
  "vilain",
  "village",
  "vinaigre",
  "violon",
  "vipère",
  "virement",
  "virtuose",
  "virus",
  "visage",
  "viseur",
  "vision",
  "visqueux",
  "visuel",
  "vital",
  "vitesse",
  "viticole",
  "vitrine",
  "vivace",
  "vivipare",
  "vocation",
  "voguer",
  "voile",
  "voisin",
  "voiture",
  "volaille",
  "volcan",
  "voltiger",
  "volume",
  "vorace",
  "vortex",
  "voter",
  "vouloir",
  "voyage",
  "voyelle",
  "wagon",
  "xénon",
  "yacht",
  "zèbre",
  "zénith",
  "zeste",
  "zoologie"
], gOe = [
  "abaco",
  "abbaglio",
  "abbinato",
  "abete",
  "abisso",
  "abolire",
  "abrasivo",
  "abrogato",
  "accadere",
  "accenno",
  "accusato",
  "acetone",
  "achille",
  "acido",
  "acqua",
  "acre",
  "acrilico",
  "acrobata",
  "acuto",
  "adagio",
  "addebito",
  "addome",
  "adeguato",
  "aderire",
  "adipe",
  "adottare",
  "adulare",
  "affabile",
  "affetto",
  "affisso",
  "affranto",
  "aforisma",
  "afoso",
  "africano",
  "agave",
  "agente",
  "agevole",
  "aggancio",
  "agire",
  "agitare",
  "agonismo",
  "agricolo",
  "agrumeto",
  "aguzzo",
  "alabarda",
  "alato",
  "albatro",
  "alberato",
  "albo",
  "albume",
  "alce",
  "alcolico",
  "alettone",
  "alfa",
  "algebra",
  "aliante",
  "alibi",
  "alimento",
  "allagato",
  "allegro",
  "allievo",
  "allodola",
  "allusivo",
  "almeno",
  "alogeno",
  "alpaca",
  "alpestre",
  "altalena",
  "alterno",
  "alticcio",
  "altrove",
  "alunno",
  "alveolo",
  "alzare",
  "amalgama",
  "amanita",
  "amarena",
  "ambito",
  "ambrato",
  "ameba",
  "america",
  "ametista",
  "amico",
  "ammasso",
  "ammenda",
  "ammirare",
  "ammonito",
  "amore",
  "ampio",
  "ampliare",
  "amuleto",
  "anacardo",
  "anagrafe",
  "analista",
  "anarchia",
  "anatra",
  "anca",
  "ancella",
  "ancora",
  "andare",
  "andrea",
  "anello",
  "angelo",
  "angolare",
  "angusto",
  "anima",
  "annegare",
  "annidato",
  "anno",
  "annuncio",
  "anonimo",
  "anticipo",
  "anzi",
  "apatico",
  "apertura",
  "apode",
  "apparire",
  "appetito",
  "appoggio",
  "approdo",
  "appunto",
  "aprile",
  "arabica",
  "arachide",
  "aragosta",
  "araldica",
  "arancio",
  "aratura",
  "arazzo",
  "arbitro",
  "archivio",
  "ardito",
  "arenile",
  "argento",
  "argine",
  "arguto",
  "aria",
  "armonia",
  "arnese",
  "arredato",
  "arringa",
  "arrosto",
  "arsenico",
  "arso",
  "artefice",
  "arzillo",
  "asciutto",
  "ascolto",
  "asepsi",
  "asettico",
  "asfalto",
  "asino",
  "asola",
  "aspirato",
  "aspro",
  "assaggio",
  "asse",
  "assoluto",
  "assurdo",
  "asta",
  "astenuto",
  "astice",
  "astratto",
  "atavico",
  "ateismo",
  "atomico",
  "atono",
  "attesa",
  "attivare",
  "attorno",
  "attrito",
  "attuale",
  "ausilio",
  "austria",
  "autista",
  "autonomo",
  "autunno",
  "avanzato",
  "avere",
  "avvenire",
  "avviso",
  "avvolgere",
  "azione",
  "azoto",
  "azzimo",
  "azzurro",
  "babele",
  "baccano",
  "bacino",
  "baco",
  "badessa",
  "badilata",
  "bagnato",
  "baita",
  "balcone",
  "baldo",
  "balena",
  "ballata",
  "balzano",
  "bambino",
  "bandire",
  "baraonda",
  "barbaro",
  "barca",
  "baritono",
  "barlume",
  "barocco",
  "basilico",
  "basso",
  "batosta",
  "battuto",
  "baule",
  "bava",
  "bavosa",
  "becco",
  "beffa",
  "belgio",
  "belva",
  "benda",
  "benevole",
  "benigno",
  "benzina",
  "bere",
  "berlina",
  "beta",
  "bibita",
  "bici",
  "bidone",
  "bifido",
  "biga",
  "bilancia",
  "bimbo",
  "binocolo",
  "biologo",
  "bipede",
  "bipolare",
  "birbante",
  "birra",
  "biscotto",
  "bisesto",
  "bisnonno",
  "bisonte",
  "bisturi",
  "bizzarro",
  "blando",
  "blatta",
  "bollito",
  "bonifico",
  "bordo",
  "bosco",
  "botanico",
  "bottino",
  "bozzolo",
  "braccio",
  "bradipo",
  "brama",
  "branca",
  "bravura",
  "bretella",
  "brevetto",
  "brezza",
  "briglia",
  "brillante",
  "brindare",
  "broccolo",
  "brodo",
  "bronzina",
  "brullo",
  "bruno",
  "bubbone",
  "buca",
  "budino",
  "buffone",
  "buio",
  "bulbo",
  "buono",
  "burlone",
  "burrasca",
  "bussola",
  "busta",
  "cadetto",
  "caduco",
  "calamaro",
  "calcolo",
  "calesse",
  "calibro",
  "calmo",
  "caloria",
  "cambusa",
  "camerata",
  "camicia",
  "cammino",
  "camola",
  "campale",
  "canapa",
  "candela",
  "cane",
  "canino",
  "canotto",
  "cantina",
  "capace",
  "capello",
  "capitolo",
  "capogiro",
  "cappero",
  "capra",
  "capsula",
  "carapace",
  "carcassa",
  "cardo",
  "carisma",
  "carovana",
  "carretto",
  "cartolina",
  "casaccio",
  "cascata",
  "caserma",
  "caso",
  "cassone",
  "castello",
  "casuale",
  "catasta",
  "catena",
  "catrame",
  "cauto",
  "cavillo",
  "cedibile",
  "cedrata",
  "cefalo",
  "celebre",
  "cellulare",
  "cena",
  "cenone",
  "centesimo",
  "ceramica",
  "cercare",
  "certo",
  "cerume",
  "cervello",
  "cesoia",
  "cespo",
  "ceto",
  "chela",
  "chiaro",
  "chicca",
  "chiedere",
  "chimera",
  "china",
  "chirurgo",
  "chitarra",
  "ciao",
  "ciclismo",
  "cifrare",
  "cigno",
  "cilindro",
  "ciottolo",
  "circa",
  "cirrosi",
  "citrico",
  "cittadino",
  "ciuffo",
  "civetta",
  "civile",
  "classico",
  "clinica",
  "cloro",
  "cocco",
  "codardo",
  "codice",
  "coerente",
  "cognome",
  "collare",
  "colmato",
  "colore",
  "colposo",
  "coltivato",
  "colza",
  "coma",
  "cometa",
  "commando",
  "comodo",
  "computer",
  "comune",
  "conciso",
  "condurre",
  "conferma",
  "congelare",
  "coniuge",
  "connesso",
  "conoscere",
  "consumo",
  "continuo",
  "convegno",
  "coperto",
  "copione",
  "coppia",
  "copricapo",
  "corazza",
  "cordata",
  "coricato",
  "cornice",
  "corolla",
  "corpo",
  "corredo",
  "corsia",
  "cortese",
  "cosmico",
  "costante",
  "cottura",
  "covato",
  "cratere",
  "cravatta",
  "creato",
  "credere",
  "cremoso",
  "crescita",
  "creta",
  "criceto",
  "crinale",
  "crisi",
  "critico",
  "croce",
  "cronaca",
  "crostata",
  "cruciale",
  "crusca",
  "cucire",
  "cuculo",
  "cugino",
  "cullato",
  "cupola",
  "curatore",
  "cursore",
  "curvo",
  "cuscino",
  "custode",
  "dado",
  "daino",
  "dalmata",
  "damerino",
  "daniela",
  "dannoso",
  "danzare",
  "datato",
  "davanti",
  "davvero",
  "debutto",
  "decennio",
  "deciso",
  "declino",
  "decollo",
  "decreto",
  "dedicato",
  "definito",
  "deforme",
  "degno",
  "delegare",
  "delfino",
  "delirio",
  "delta",
  "demenza",
  "denotato",
  "dentro",
  "deposito",
  "derapata",
  "derivare",
  "deroga",
  "descritto",
  "deserto",
  "desiderio",
  "desumere",
  "detersivo",
  "devoto",
  "diametro",
  "dicembre",
  "diedro",
  "difeso",
  "diffuso",
  "digerire",
  "digitale",
  "diluvio",
  "dinamico",
  "dinnanzi",
  "dipinto",
  "diploma",
  "dipolo",
  "diradare",
  "dire",
  "dirotto",
  "dirupo",
  "disagio",
  "discreto",
  "disfare",
  "disgelo",
  "disposto",
  "distanza",
  "disumano",
  "dito",
  "divano",
  "divelto",
  "dividere",
  "divorato",
  "doblone",
  "docente",
  "doganale",
  "dogma",
  "dolce",
  "domato",
  "domenica",
  "dominare",
  "dondolo",
  "dono",
  "dormire",
  "dote",
  "dottore",
  "dovuto",
  "dozzina",
  "drago",
  "druido",
  "dubbio",
  "dubitare",
  "ducale",
  "duna",
  "duomo",
  "duplice",
  "duraturo",
  "ebano",
  "eccesso",
  "ecco",
  "eclissi",
  "economia",
  "edera",
  "edicola",
  "edile",
  "editoria",
  "educare",
  "egemonia",
  "egli",
  "egoismo",
  "egregio",
  "elaborato",
  "elargire",
  "elegante",
  "elencato",
  "eletto",
  "elevare",
  "elfico",
  "elica",
  "elmo",
  "elsa",
  "eluso",
  "emanato",
  "emblema",
  "emesso",
  "emiro",
  "emotivo",
  "emozione",
  "empirico",
  "emulo",
  "endemico",
  "enduro",
  "energia",
  "enfasi",
  "enoteca",
  "entrare",
  "enzima",
  "epatite",
  "epilogo",
  "episodio",
  "epocale",
  "eppure",
  "equatore",
  "erario",
  "erba",
  "erboso",
  "erede",
  "eremita",
  "erigere",
  "ermetico",
  "eroe",
  "erosivo",
  "errante",
  "esagono",
  "esame",
  "esanime",
  "esaudire",
  "esca",
  "esempio",
  "esercito",
  "esibito",
  "esigente",
  "esistere",
  "esito",
  "esofago",
  "esortato",
  "esoso",
  "espanso",
  "espresso",
  "essenza",
  "esso",
  "esteso",
  "estimare",
  "estonia",
  "estroso",
  "esultare",
  "etilico",
  "etnico",
  "etrusco",
  "etto",
  "euclideo",
  "europa",
  "evaso",
  "evidenza",
  "evitato",
  "evoluto",
  "evviva",
  "fabbrica",
  "faccenda",
  "fachiro",
  "falco",
  "famiglia",
  "fanale",
  "fanfara",
  "fango",
  "fantasma",
  "fare",
  "farfalla",
  "farinoso",
  "farmaco",
  "fascia",
  "fastoso",
  "fasullo",
  "faticare",
  "fato",
  "favoloso",
  "febbre",
  "fecola",
  "fede",
  "fegato",
  "felpa",
  "feltro",
  "femmina",
  "fendere",
  "fenomeno",
  "fermento",
  "ferro",
  "fertile",
  "fessura",
  "festivo",
  "fetta",
  "feudo",
  "fiaba",
  "fiducia",
  "fifa",
  "figurato",
  "filo",
  "finanza",
  "finestra",
  "finire",
  "fiore",
  "fiscale",
  "fisico",
  "fiume",
  "flacone",
  "flamenco",
  "flebo",
  "flemma",
  "florido",
  "fluente",
  "fluoro",
  "fobico",
  "focaccia",
  "focoso",
  "foderato",
  "foglio",
  "folata",
  "folclore",
  "folgore",
  "fondente",
  "fonetico",
  "fonia",
  "fontana",
  "forbito",
  "forchetta",
  "foresta",
  "formica",
  "fornaio",
  "foro",
  "fortezza",
  "forzare",
  "fosfato",
  "fosso",
  "fracasso",
  "frana",
  "frassino",
  "fratello",
  "freccetta",
  "frenata",
  "fresco",
  "frigo",
  "frollino",
  "fronde",
  "frugale",
  "frutta",
  "fucilata",
  "fucsia",
  "fuggente",
  "fulmine",
  "fulvo",
  "fumante",
  "fumetto",
  "fumoso",
  "fune",
  "funzione",
  "fuoco",
  "furbo",
  "furgone",
  "furore",
  "fuso",
  "futile",
  "gabbiano",
  "gaffe",
  "galateo",
  "gallina",
  "galoppo",
  "gambero",
  "gamma",
  "garanzia",
  "garbo",
  "garofano",
  "garzone",
  "gasdotto",
  "gasolio",
  "gastrico",
  "gatto",
  "gaudio",
  "gazebo",
  "gazzella",
  "geco",
  "gelatina",
  "gelso",
  "gemello",
  "gemmato",
  "gene",
  "genitore",
  "gennaio",
  "genotipo",
  "gergo",
  "ghepardo",
  "ghiaccio",
  "ghisa",
  "giallo",
  "gilda",
  "ginepro",
  "giocare",
  "gioiello",
  "giorno",
  "giove",
  "girato",
  "girone",
  "gittata",
  "giudizio",
  "giurato",
  "giusto",
  "globulo",
  "glutine",
  "gnomo",
  "gobba",
  "golf",
  "gomito",
  "gommone",
  "gonfio",
  "gonna",
  "governo",
  "gracile",
  "grado",
  "grafico",
  "grammo",
  "grande",
  "grattare",
  "gravoso",
  "grazia",
  "greca",
  "gregge",
  "grifone",
  "grigio",
  "grinza",
  "grotta",
  "gruppo",
  "guadagno",
  "guaio",
  "guanto",
  "guardare",
  "gufo",
  "guidare",
  "ibernato",
  "icona",
  "identico",
  "idillio",
  "idolo",
  "idra",
  "idrico",
  "idrogeno",
  "igiene",
  "ignaro",
  "ignorato",
  "ilare",
  "illeso",
  "illogico",
  "illudere",
  "imballo",
  "imbevuto",
  "imbocco",
  "imbuto",
  "immane",
  "immerso",
  "immolato",
  "impacco",
  "impeto",
  "impiego",
  "importo",
  "impronta",
  "inalare",
  "inarcare",
  "inattivo",
  "incanto",
  "incendio",
  "inchino",
  "incisivo",
  "incluso",
  "incontro",
  "incrocio",
  "incubo",
  "indagine",
  "india",
  "indole",
  "inedito",
  "infatti",
  "infilare",
  "inflitto",
  "ingaggio",
  "ingegno",
  "inglese",
  "ingordo",
  "ingrosso",
  "innesco",
  "inodore",
  "inoltrare",
  "inondato",
  "insano",
  "insetto",
  "insieme",
  "insonnia",
  "insulina",
  "intasato",
  "intero",
  "intonaco",
  "intuito",
  "inumidire",
  "invalido",
  "invece",
  "invito",
  "iperbole",
  "ipnotico",
  "ipotesi",
  "ippica",
  "iride",
  "irlanda",
  "ironico",
  "irrigato",
  "irrorare",
  "isolato",
  "isotopo",
  "isterico",
  "istituto",
  "istrice",
  "italia",
  "iterare",
  "labbro",
  "labirinto",
  "lacca",
  "lacerato",
  "lacrima",
  "lacuna",
  "laddove",
  "lago",
  "lampo",
  "lancetta",
  "lanterna",
  "lardoso",
  "larga",
  "laringe",
  "lastra",
  "latenza",
  "latino",
  "lattuga",
  "lavagna",
  "lavoro",
  "legale",
  "leggero",
  "lembo",
  "lentezza",
  "lenza",
  "leone",
  "lepre",
  "lesivo",
  "lessato",
  "lesto",
  "letterale",
  "leva",
  "levigato",
  "libero",
  "lido",
  "lievito",
  "lilla",
  "limatura",
  "limitare",
  "limpido",
  "lineare",
  "lingua",
  "liquido",
  "lira",
  "lirica",
  "lisca",
  "lite",
  "litigio",
  "livrea",
  "locanda",
  "lode",
  "logica",
  "lombare",
  "londra",
  "longevo",
  "loquace",
  "lorenzo",
  "loto",
  "lotteria",
  "luce",
  "lucidato",
  "lumaca",
  "luminoso",
  "lungo",
  "lupo",
  "luppolo",
  "lusinga",
  "lusso",
  "lutto",
  "macabro",
  "macchina",
  "macero",
  "macinato",
  "madama",
  "magico",
  "maglia",
  "magnete",
  "magro",
  "maiolica",
  "malafede",
  "malgrado",
  "malinteso",
  "malsano",
  "malto",
  "malumore",
  "mana",
  "mancia",
  "mandorla",
  "mangiare",
  "manifesto",
  "mannaro",
  "manovra",
  "mansarda",
  "mantide",
  "manubrio",
  "mappa",
  "maratona",
  "marcire",
  "maretta",
  "marmo",
  "marsupio",
  "maschera",
  "massaia",
  "mastino",
  "materasso",
  "matricola",
  "mattone",
  "maturo",
  "mazurca",
  "meandro",
  "meccanico",
  "mecenate",
  "medesimo",
  "meditare",
  "mega",
  "melassa",
  "melis",
  "melodia",
  "meninge",
  "meno",
  "mensola",
  "mercurio",
  "merenda",
  "merlo",
  "meschino",
  "mese",
  "messere",
  "mestolo",
  "metallo",
  "metodo",
  "mettere",
  "miagolare",
  "mica",
  "micelio",
  "michele",
  "microbo",
  "midollo",
  "miele",
  "migliore",
  "milano",
  "milite",
  "mimosa",
  "minerale",
  "mini",
  "minore",
  "mirino",
  "mirtillo",
  "miscela",
  "missiva",
  "misto",
  "misurare",
  "mitezza",
  "mitigare",
  "mitra",
  "mittente",
  "mnemonico",
  "modello",
  "modifica",
  "modulo",
  "mogano",
  "mogio",
  "mole",
  "molosso",
  "monastero",
  "monco",
  "mondina",
  "monetario",
  "monile",
  "monotono",
  "monsone",
  "montato",
  "monviso",
  "mora",
  "mordere",
  "morsicato",
  "mostro",
  "motivato",
  "motosega",
  "motto",
  "movenza",
  "movimento",
  "mozzo",
  "mucca",
  "mucosa",
  "muffa",
  "mughetto",
  "mugnaio",
  "mulatto",
  "mulinello",
  "multiplo",
  "mummia",
  "munto",
  "muovere",
  "murale",
  "musa",
  "muscolo",
  "musica",
  "mutevole",
  "muto",
  "nababbo",
  "nafta",
  "nanometro",
  "narciso",
  "narice",
  "narrato",
  "nascere",
  "nastrare",
  "naturale",
  "nautica",
  "naviglio",
  "nebulosa",
  "necrosi",
  "negativo",
  "negozio",
  "nemmeno",
  "neofita",
  "neretto",
  "nervo",
  "nessuno",
  "nettuno",
  "neutrale",
  "neve",
  "nevrotico",
  "nicchia",
  "ninfa",
  "nitido",
  "nobile",
  "nocivo",
  "nodo",
  "nome",
  "nomina",
  "nordico",
  "normale",
  "norvegese",
  "nostrano",
  "notare",
  "notizia",
  "notturno",
  "novella",
  "nucleo",
  "nulla",
  "numero",
  "nuovo",
  "nutrire",
  "nuvola",
  "nuziale",
  "oasi",
  "obbedire",
  "obbligo",
  "obelisco",
  "oblio",
  "obolo",
  "obsoleto",
  "occasione",
  "occhio",
  "occidente",
  "occorrere",
  "occultare",
  "ocra",
  "oculato",
  "odierno",
  "odorare",
  "offerta",
  "offrire",
  "offuscato",
  "oggetto",
  "oggi",
  "ognuno",
  "olandese",
  "olfatto",
  "oliato",
  "oliva",
  "ologramma",
  "oltre",
  "omaggio",
  "ombelico",
  "ombra",
  "omega",
  "omissione",
  "ondoso",
  "onere",
  "onice",
  "onnivoro",
  "onorevole",
  "onta",
  "operato",
  "opinione",
  "opposto",
  "oracolo",
  "orafo",
  "ordine",
  "orecchino",
  "orefice",
  "orfano",
  "organico",
  "origine",
  "orizzonte",
  "orma",
  "ormeggio",
  "ornativo",
  "orologio",
  "orrendo",
  "orribile",
  "ortensia",
  "ortica",
  "orzata",
  "orzo",
  "osare",
  "oscurare",
  "osmosi",
  "ospedale",
  "ospite",
  "ossa",
  "ossidare",
  "ostacolo",
  "oste",
  "otite",
  "otre",
  "ottagono",
  "ottimo",
  "ottobre",
  "ovale",
  "ovest",
  "ovino",
  "oviparo",
  "ovocito",
  "ovunque",
  "ovviare",
  "ozio",
  "pacchetto",
  "pace",
  "pacifico",
  "padella",
  "padrone",
  "paese",
  "paga",
  "pagina",
  "palazzina",
  "palesare",
  "pallido",
  "palo",
  "palude",
  "pandoro",
  "pannello",
  "paolo",
  "paonazzo",
  "paprica",
  "parabola",
  "parcella",
  "parere",
  "pargolo",
  "pari",
  "parlato",
  "parola",
  "partire",
  "parvenza",
  "parziale",
  "passivo",
  "pasticca",
  "patacca",
  "patologia",
  "pattume",
  "pavone",
  "peccato",
  "pedalare",
  "pedonale",
  "peggio",
  "peloso",
  "penare",
  "pendice",
  "penisola",
  "pennuto",
  "penombra",
  "pensare",
  "pentola",
  "pepe",
  "pepita",
  "perbene",
  "percorso",
  "perdonato",
  "perforare",
  "pergamena",
  "periodo",
  "permesso",
  "perno",
  "perplesso",
  "persuaso",
  "pertugio",
  "pervaso",
  "pesatore",
  "pesista",
  "peso",
  "pestifero",
  "petalo",
  "pettine",
  "petulante",
  "pezzo",
  "piacere",
  "pianta",
  "piattino",
  "piccino",
  "picozza",
  "piega",
  "pietra",
  "piffero",
  "pigiama",
  "pigolio",
  "pigro",
  "pila",
  "pilifero",
  "pillola",
  "pilota",
  "pimpante",
  "pineta",
  "pinna",
  "pinolo",
  "pioggia",
  "piombo",
  "piramide",
  "piretico",
  "pirite",
  "pirolisi",
  "pitone",
  "pizzico",
  "placebo",
  "planare",
  "plasma",
  "platano",
  "plenario",
  "pochezza",
  "poderoso",
  "podismo",
  "poesia",
  "poggiare",
  "polenta",
  "poligono",
  "pollice",
  "polmonite",
  "polpetta",
  "polso",
  "poltrona",
  "polvere",
  "pomice",
  "pomodoro",
  "ponte",
  "popoloso",
  "porfido",
  "poroso",
  "porpora",
  "porre",
  "portata",
  "posa",
  "positivo",
  "possesso",
  "postulato",
  "potassio",
  "potere",
  "pranzo",
  "prassi",
  "pratica",
  "precluso",
  "predica",
  "prefisso",
  "pregiato",
  "prelievo",
  "premere",
  "prenotare",
  "preparato",
  "presenza",
  "pretesto",
  "prevalso",
  "prima",
  "principe",
  "privato",
  "problema",
  "procura",
  "produrre",
  "profumo",
  "progetto",
  "prolunga",
  "promessa",
  "pronome",
  "proposta",
  "proroga",
  "proteso",
  "prova",
  "prudente",
  "prugna",
  "prurito",
  "psiche",
  "pubblico",
  "pudica",
  "pugilato",
  "pugno",
  "pulce",
  "pulito",
  "pulsante",
  "puntare",
  "pupazzo",
  "pupilla",
  "puro",
  "quadro",
  "qualcosa",
  "quasi",
  "querela",
  "quota",
  "raccolto",
  "raddoppio",
  "radicale",
  "radunato",
  "raffica",
  "ragazzo",
  "ragione",
  "ragno",
  "ramarro",
  "ramingo",
  "ramo",
  "randagio",
  "rantolare",
  "rapato",
  "rapina",
  "rappreso",
  "rasatura",
  "raschiato",
  "rasente",
  "rassegna",
  "rastrello",
  "rata",
  "ravveduto",
  "reale",
  "recepire",
  "recinto",
  "recluta",
  "recondito",
  "recupero",
  "reddito",
  "redimere",
  "regalato",
  "registro",
  "regola",
  "regresso",
  "relazione",
  "remare",
  "remoto",
  "renna",
  "replica",
  "reprimere",
  "reputare",
  "resa",
  "residente",
  "responso",
  "restauro",
  "rete",
  "retina",
  "retorica",
  "rettifica",
  "revocato",
  "riassunto",
  "ribadire",
  "ribelle",
  "ribrezzo",
  "ricarica",
  "ricco",
  "ricevere",
  "riciclato",
  "ricordo",
  "ricreduto",
  "ridicolo",
  "ridurre",
  "rifasare",
  "riflesso",
  "riforma",
  "rifugio",
  "rigare",
  "rigettato",
  "righello",
  "rilassato",
  "rilevato",
  "rimanere",
  "rimbalzo",
  "rimedio",
  "rimorchio",
  "rinascita",
  "rincaro",
  "rinforzo",
  "rinnovo",
  "rinomato",
  "rinsavito",
  "rintocco",
  "rinuncia",
  "rinvenire",
  "riparato",
  "ripetuto",
  "ripieno",
  "riportare",
  "ripresa",
  "ripulire",
  "risata",
  "rischio",
  "riserva",
  "risibile",
  "riso",
  "rispetto",
  "ristoro",
  "risultato",
  "risvolto",
  "ritardo",
  "ritegno",
  "ritmico",
  "ritrovo",
  "riunione",
  "riva",
  "riverso",
  "rivincita",
  "rivolto",
  "rizoma",
  "roba",
  "robotico",
  "robusto",
  "roccia",
  "roco",
  "rodaggio",
  "rodere",
  "roditore",
  "rogito",
  "rollio",
  "romantico",
  "rompere",
  "ronzio",
  "rosolare",
  "rospo",
  "rotante",
  "rotondo",
  "rotula",
  "rovescio",
  "rubizzo",
  "rubrica",
  "ruga",
  "rullino",
  "rumine",
  "rumoroso",
  "ruolo",
  "rupe",
  "russare",
  "rustico",
  "sabato",
  "sabbiare",
  "sabotato",
  "sagoma",
  "salasso",
  "saldatura",
  "salgemma",
  "salivare",
  "salmone",
  "salone",
  "saltare",
  "saluto",
  "salvo",
  "sapere",
  "sapido",
  "saporito",
  "saraceno",
  "sarcasmo",
  "sarto",
  "sassoso",
  "satellite",
  "satira",
  "satollo",
  "saturno",
  "savana",
  "savio",
  "saziato",
  "sbadiglio",
  "sbalzo",
  "sbancato",
  "sbarra",
  "sbattere",
  "sbavare",
  "sbendare",
  "sbirciare",
  "sbloccato",
  "sbocciato",
  "sbrinare",
  "sbruffone",
  "sbuffare",
  "scabroso",
  "scadenza",
  "scala",
  "scambiare",
  "scandalo",
  "scapola",
  "scarso",
  "scatenare",
  "scavato",
  "scelto",
  "scenico",
  "scettro",
  "scheda",
  "schiena",
  "sciarpa",
  "scienza",
  "scindere",
  "scippo",
  "sciroppo",
  "scivolo",
  "sclerare",
  "scodella",
  "scolpito",
  "scomparto",
  "sconforto",
  "scoprire",
  "scorta",
  "scossone",
  "scozzese",
  "scriba",
  "scrollare",
  "scrutinio",
  "scuderia",
  "scultore",
  "scuola",
  "scuro",
  "scusare",
  "sdebitare",
  "sdoganare",
  "seccatura",
  "secondo",
  "sedano",
  "seggiola",
  "segnalato",
  "segregato",
  "seguito",
  "selciato",
  "selettivo",
  "sella",
  "selvaggio",
  "semaforo",
  "sembrare",
  "seme",
  "seminato",
  "sempre",
  "senso",
  "sentire",
  "sepolto",
  "sequenza",
  "serata",
  "serbato",
  "sereno",
  "serio",
  "serpente",
  "serraglio",
  "servire",
  "sestina",
  "setola",
  "settimana",
  "sfacelo",
  "sfaldare",
  "sfamato",
  "sfarzoso",
  "sfaticato",
  "sfera",
  "sfida",
  "sfilato",
  "sfinge",
  "sfocato",
  "sfoderare",
  "sfogo",
  "sfoltire",
  "sforzato",
  "sfratto",
  "sfruttato",
  "sfuggito",
  "sfumare",
  "sfuso",
  "sgabello",
  "sgarbato",
  "sgonfiare",
  "sgorbio",
  "sgrassato",
  "sguardo",
  "sibilo",
  "siccome",
  "sierra",
  "sigla",
  "signore",
  "silenzio",
  "sillaba",
  "simbolo",
  "simpatico",
  "simulato",
  "sinfonia",
  "singolo",
  "sinistro",
  "sino",
  "sintesi",
  "sinusoide",
  "sipario",
  "sisma",
  "sistole",
  "situato",
  "slitta",
  "slogatura",
  "sloveno",
  "smarrito",
  "smemorato",
  "smentito",
  "smeraldo",
  "smilzo",
  "smontare",
  "smottato",
  "smussato",
  "snellire",
  "snervato",
  "snodo",
  "sobbalzo",
  "sobrio",
  "soccorso",
  "sociale",
  "sodale",
  "soffitto",
  "sogno",
  "soldato",
  "solenne",
  "solido",
  "sollazzo",
  "solo",
  "solubile",
  "solvente",
  "somatico",
  "somma",
  "sonda",
  "sonetto",
  "sonnifero",
  "sopire",
  "soppeso",
  "sopra",
  "sorgere",
  "sorpasso",
  "sorriso",
  "sorso",
  "sorteggio",
  "sorvolato",
  "sospiro",
  "sosta",
  "sottile",
  "spada",
  "spalla",
  "spargere",
  "spatola",
  "spavento",
  "spazzola",
  "specie",
  "spedire",
  "spegnere",
  "spelatura",
  "speranza",
  "spessore",
  "spettrale",
  "spezzato",
  "spia",
  "spigoloso",
  "spillato",
  "spinoso",
  "spirale",
  "splendido",
  "sportivo",
  "sposo",
  "spranga",
  "sprecare",
  "spronato",
  "spruzzo",
  "spuntino",
  "squillo",
  "sradicare",
  "srotolato",
  "stabile",
  "stacco",
  "staffa",
  "stagnare",
  "stampato",
  "stantio",
  "starnuto",
  "stasera",
  "statuto",
  "stelo",
  "steppa",
  "sterzo",
  "stiletto",
  "stima",
  "stirpe",
  "stivale",
  "stizzoso",
  "stonato",
  "storico",
  "strappo",
  "stregato",
  "stridulo",
  "strozzare",
  "strutto",
  "stuccare",
  "stufo",
  "stupendo",
  "subentro",
  "succoso",
  "sudore",
  "suggerito",
  "sugo",
  "sultano",
  "suonare",
  "superbo",
  "supporto",
  "surgelato",
  "surrogato",
  "sussurro",
  "sutura",
  "svagare",
  "svedese",
  "sveglio",
  "svelare",
  "svenuto",
  "svezia",
  "sviluppo",
  "svista",
  "svizzera",
  "svolta",
  "svuotare",
  "tabacco",
  "tabulato",
  "tacciare",
  "taciturno",
  "tale",
  "talismano",
  "tampone",
  "tannino",
  "tara",
  "tardivo",
  "targato",
  "tariffa",
  "tarpare",
  "tartaruga",
  "tasto",
  "tattico",
  "taverna",
  "tavolata",
  "tazza",
  "teca",
  "tecnico",
  "telefono",
  "temerario",
  "tempo",
  "temuto",
  "tendone",
  "tenero",
  "tensione",
  "tentacolo",
  "teorema",
  "terme",
  "terrazzo",
  "terzetto",
  "tesi",
  "tesserato",
  "testato",
  "tetro",
  "tettoia",
  "tifare",
  "tigella",
  "timbro",
  "tinto",
  "tipico",
  "tipografo",
  "tiraggio",
  "tiro",
  "titanio",
  "titolo",
  "titubante",
  "tizio",
  "tizzone",
  "toccare",
  "tollerare",
  "tolto",
  "tombola",
  "tomo",
  "tonfo",
  "tonsilla",
  "topazio",
  "topologia",
  "toppa",
  "torba",
  "tornare",
  "torrone",
  "tortora",
  "toscano",
  "tossire",
  "tostatura",
  "totano",
  "trabocco",
  "trachea",
  "trafila",
  "tragedia",
  "tralcio",
  "tramonto",
  "transito",
  "trapano",
  "trarre",
  "trasloco",
  "trattato",
  "trave",
  "treccia",
  "tremolio",
  "trespolo",
  "tributo",
  "tricheco",
  "trifoglio",
  "trillo",
  "trincea",
  "trio",
  "tristezza",
  "triturato",
  "trivella",
  "tromba",
  "trono",
  "troppo",
  "trottola",
  "trovare",
  "truccato",
  "tubatura",
  "tuffato",
  "tulipano",
  "tumulto",
  "tunisia",
  "turbare",
  "turchino",
  "tuta",
  "tutela",
  "ubicato",
  "uccello",
  "uccisore",
  "udire",
  "uditivo",
  "uffa",
  "ufficio",
  "uguale",
  "ulisse",
  "ultimato",
  "umano",
  "umile",
  "umorismo",
  "uncinetto",
  "ungere",
  "ungherese",
  "unicorno",
  "unificato",
  "unisono",
  "unitario",
  "unte",
  "uovo",
  "upupa",
  "uragano",
  "urgenza",
  "urlo",
  "usanza",
  "usato",
  "uscito",
  "usignolo",
  "usuraio",
  "utensile",
  "utilizzo",
  "utopia",
  "vacante",
  "vaccinato",
  "vagabondo",
  "vagliato",
  "valanga",
  "valgo",
  "valico",
  "valletta",
  "valoroso",
  "valutare",
  "valvola",
  "vampata",
  "vangare",
  "vanitoso",
  "vano",
  "vantaggio",
  "vanvera",
  "vapore",
  "varano",
  "varcato",
  "variante",
  "vasca",
  "vedetta",
  "vedova",
  "veduto",
  "vegetale",
  "veicolo",
  "velcro",
  "velina",
  "velluto",
  "veloce",
  "venato",
  "vendemmia",
  "vento",
  "verace",
  "verbale",
  "vergogna",
  "verifica",
  "vero",
  "verruca",
  "verticale",
  "vescica",
  "vessillo",
  "vestale",
  "veterano",
  "vetrina",
  "vetusto",
  "viandante",
  "vibrante",
  "vicenda",
  "vichingo",
  "vicinanza",
  "vidimare",
  "vigilia",
  "vigneto",
  "vigore",
  "vile",
  "villano",
  "vimini",
  "vincitore",
  "viola",
  "vipera",
  "virgola",
  "virologo",
  "virulento",
  "viscoso",
  "visione",
  "vispo",
  "vissuto",
  "visura",
  "vita",
  "vitello",
  "vittima",
  "vivanda",
  "vivido",
  "viziare",
  "voce",
  "voga",
  "volatile",
  "volere",
  "volpe",
  "voragine",
  "vulcano",
  "zampogna",
  "zanna",
  "zappato",
  "zattera",
  "zavorra",
  "zefiro",
  "zelante",
  "zelo",
  "zenzero",
  "zerbino",
  "zibetto",
  "zinco",
  "zircone",
  "zitto",
  "zolla",
  "zotico",
  "zucchero",
  "zufolo",
  "zulu",
  "zuppa"
], mOe = [
  "ábaco",
  "abdomen",
  "abeja",
  "abierto",
  "abogado",
  "abono",
  "aborto",
  "abrazo",
  "abrir",
  "abuelo",
  "abuso",
  "acabar",
  "academia",
  "acceso",
  "acción",
  "aceite",
  "acelga",
  "acento",
  "aceptar",
  "ácido",
  "aclarar",
  "acné",
  "acoger",
  "acoso",
  "activo",
  "acto",
  "actriz",
  "actuar",
  "acudir",
  "acuerdo",
  "acusar",
  "adicto",
  "admitir",
  "adoptar",
  "adorno",
  "aduana",
  "adulto",
  "aéreo",
  "afectar",
  "afición",
  "afinar",
  "afirmar",
  "ágil",
  "agitar",
  "agonía",
  "agosto",
  "agotar",
  "agregar",
  "agrio",
  "agua",
  "agudo",
  "águila",
  "aguja",
  "ahogo",
  "ahorro",
  "aire",
  "aislar",
  "ajedrez",
  "ajeno",
  "ajuste",
  "alacrán",
  "alambre",
  "alarma",
  "alba",
  "álbum",
  "alcalde",
  "aldea",
  "alegre",
  "alejar",
  "alerta",
  "aleta",
  "alfiler",
  "alga",
  "algodón",
  "aliado",
  "aliento",
  "alivio",
  "alma",
  "almeja",
  "almíbar",
  "altar",
  "alteza",
  "altivo",
  "alto",
  "altura",
  "alumno",
  "alzar",
  "amable",
  "amante",
  "amapola",
  "amargo",
  "amasar",
  "ámbar",
  "ámbito",
  "ameno",
  "amigo",
  "amistad",
  "amor",
  "amparo",
  "amplio",
  "ancho",
  "anciano",
  "ancla",
  "andar",
  "andén",
  "anemia",
  "ángulo",
  "anillo",
  "ánimo",
  "anís",
  "anotar",
  "antena",
  "antiguo",
  "antojo",
  "anual",
  "anular",
  "anuncio",
  "añadir",
  "añejo",
  "año",
  "apagar",
  "aparato",
  "apetito",
  "apio",
  "aplicar",
  "apodo",
  "aporte",
  "apoyo",
  "aprender",
  "aprobar",
  "apuesta",
  "apuro",
  "arado",
  "araña",
  "arar",
  "árbitro",
  "árbol",
  "arbusto",
  "archivo",
  "arco",
  "arder",
  "ardilla",
  "arduo",
  "área",
  "árido",
  "aries",
  "armonía",
  "arnés",
  "aroma",
  "arpa",
  "arpón",
  "arreglo",
  "arroz",
  "arruga",
  "arte",
  "artista",
  "asa",
  "asado",
  "asalto",
  "ascenso",
  "asegurar",
  "aseo",
  "asesor",
  "asiento",
  "asilo",
  "asistir",
  "asno",
  "asombro",
  "áspero",
  "astilla",
  "astro",
  "astuto",
  "asumir",
  "asunto",
  "atajo",
  "ataque",
  "atar",
  "atento",
  "ateo",
  "ático",
  "atleta",
  "átomo",
  "atraer",
  "atroz",
  "atún",
  "audaz",
  "audio",
  "auge",
  "aula",
  "aumento",
  "ausente",
  "autor",
  "aval",
  "avance",
  "avaro",
  "ave",
  "avellana",
  "avena",
  "avestruz",
  "avión",
  "aviso",
  "ayer",
  "ayuda",
  "ayuno",
  "azafrán",
  "azar",
  "azote",
  "azúcar",
  "azufre",
  "azul",
  "baba",
  "babor",
  "bache",
  "bahía",
  "baile",
  "bajar",
  "balanza",
  "balcón",
  "balde",
  "bambú",
  "banco",
  "banda",
  "baño",
  "barba",
  "barco",
  "barniz",
  "barro",
  "báscula",
  "bastón",
  "basura",
  "batalla",
  "batería",
  "batir",
  "batuta",
  "baúl",
  "bazar",
  "bebé",
  "bebida",
  "bello",
  "besar",
  "beso",
  "bestia",
  "bicho",
  "bien",
  "bingo",
  "blanco",
  "bloque",
  "blusa",
  "boa",
  "bobina",
  "bobo",
  "boca",
  "bocina",
  "boda",
  "bodega",
  "boina",
  "bola",
  "bolero",
  "bolsa",
  "bomba",
  "bondad",
  "bonito",
  "bono",
  "bonsái",
  "borde",
  "borrar",
  "bosque",
  "bote",
  "botín",
  "bóveda",
  "bozal",
  "bravo",
  "brazo",
  "brecha",
  "breve",
  "brillo",
  "brinco",
  "brisa",
  "broca",
  "broma",
  "bronce",
  "brote",
  "bruja",
  "brusco",
  "bruto",
  "buceo",
  "bucle",
  "bueno",
  "buey",
  "bufanda",
  "bufón",
  "búho",
  "buitre",
  "bulto",
  "burbuja",
  "burla",
  "burro",
  "buscar",
  "butaca",
  "buzón",
  "caballo",
  "cabeza",
  "cabina",
  "cabra",
  "cacao",
  "cadáver",
  "cadena",
  "caer",
  "café",
  "caída",
  "caimán",
  "caja",
  "cajón",
  "cal",
  "calamar",
  "calcio",
  "caldo",
  "calidad",
  "calle",
  "calma",
  "calor",
  "calvo",
  "cama",
  "cambio",
  "camello",
  "camino",
  "campo",
  "cáncer",
  "candil",
  "canela",
  "canguro",
  "canica",
  "canto",
  "caña",
  "cañón",
  "caoba",
  "caos",
  "capaz",
  "capitán",
  "capote",
  "captar",
  "capucha",
  "cara",
  "carbón",
  "cárcel",
  "careta",
  "carga",
  "cariño",
  "carne",
  "carpeta",
  "carro",
  "carta",
  "casa",
  "casco",
  "casero",
  "caspa",
  "castor",
  "catorce",
  "catre",
  "caudal",
  "causa",
  "cazo",
  "cebolla",
  "ceder",
  "cedro",
  "celda",
  "célebre",
  "celoso",
  "célula",
  "cemento",
  "ceniza",
  "centro",
  "cerca",
  "cerdo",
  "cereza",
  "cero",
  "cerrar",
  "certeza",
  "césped",
  "cetro",
  "chacal",
  "chaleco",
  "champú",
  "chancla",
  "chapa",
  "charla",
  "chico",
  "chiste",
  "chivo",
  "choque",
  "choza",
  "chuleta",
  "chupar",
  "ciclón",
  "ciego",
  "cielo",
  "cien",
  "cierto",
  "cifra",
  "cigarro",
  "cima",
  "cinco",
  "cine",
  "cinta",
  "ciprés",
  "circo",
  "ciruela",
  "cisne",
  "cita",
  "ciudad",
  "clamor",
  "clan",
  "claro",
  "clase",
  "clave",
  "cliente",
  "clima",
  "clínica",
  "cobre",
  "cocción",
  "cochino",
  "cocina",
  "coco",
  "código",
  "codo",
  "cofre",
  "coger",
  "cohete",
  "cojín",
  "cojo",
  "cola",
  "colcha",
  "colegio",
  "colgar",
  "colina",
  "collar",
  "colmo",
  "columna",
  "combate",
  "comer",
  "comida",
  "cómodo",
  "compra",
  "conde",
  "conejo",
  "conga",
  "conocer",
  "consejo",
  "contar",
  "copa",
  "copia",
  "corazón",
  "corbata",
  "corcho",
  "cordón",
  "corona",
  "correr",
  "coser",
  "cosmos",
  "costa",
  "cráneo",
  "cráter",
  "crear",
  "crecer",
  "creído",
  "crema",
  "cría",
  "crimen",
  "cripta",
  "crisis",
  "cromo",
  "crónica",
  "croqueta",
  "crudo",
  "cruz",
  "cuadro",
  "cuarto",
  "cuatro",
  "cubo",
  "cubrir",
  "cuchara",
  "cuello",
  "cuento",
  "cuerda",
  "cuesta",
  "cueva",
  "cuidar",
  "culebra",
  "culpa",
  "culto",
  "cumbre",
  "cumplir",
  "cuna",
  "cuneta",
  "cuota",
  "cupón",
  "cúpula",
  "curar",
  "curioso",
  "curso",
  "curva",
  "cutis",
  "dama",
  "danza",
  "dar",
  "dardo",
  "dátil",
  "deber",
  "débil",
  "década",
  "decir",
  "dedo",
  "defensa",
  "definir",
  "dejar",
  "delfín",
  "delgado",
  "delito",
  "demora",
  "denso",
  "dental",
  "deporte",
  "derecho",
  "derrota",
  "desayuno",
  "deseo",
  "desfile",
  "desnudo",
  "destino",
  "desvío",
  "detalle",
  "detener",
  "deuda",
  "día",
  "diablo",
  "diadema",
  "diamante",
  "diana",
  "diario",
  "dibujo",
  "dictar",
  "diente",
  "dieta",
  "diez",
  "difícil",
  "digno",
  "dilema",
  "diluir",
  "dinero",
  "directo",
  "dirigir",
  "disco",
  "diseño",
  "disfraz",
  "diva",
  "divino",
  "doble",
  "doce",
  "dolor",
  "domingo",
  "don",
  "donar",
  "dorado",
  "dormir",
  "dorso",
  "dos",
  "dosis",
  "dragón",
  "droga",
  "ducha",
  "duda",
  "duelo",
  "dueño",
  "dulce",
  "dúo",
  "duque",
  "durar",
  "dureza",
  "duro",
  "ébano",
  "ebrio",
  "echar",
  "eco",
  "ecuador",
  "edad",
  "edición",
  "edificio",
  "editor",
  "educar",
  "efecto",
  "eficaz",
  "eje",
  "ejemplo",
  "elefante",
  "elegir",
  "elemento",
  "elevar",
  "elipse",
  "élite",
  "elixir",
  "elogio",
  "eludir",
  "embudo",
  "emitir",
  "emoción",
  "empate",
  "empeño",
  "empleo",
  "empresa",
  "enano",
  "encargo",
  "enchufe",
  "encía",
  "enemigo",
  "enero",
  "enfado",
  "enfermo",
  "engaño",
  "enigma",
  "enlace",
  "enorme",
  "enredo",
  "ensayo",
  "enseñar",
  "entero",
  "entrar",
  "envase",
  "envío",
  "época",
  "equipo",
  "erizo",
  "escala",
  "escena",
  "escolar",
  "escribir",
  "escudo",
  "esencia",
  "esfera",
  "esfuerzo",
  "espada",
  "espejo",
  "espía",
  "esposa",
  "espuma",
  "esquí",
  "estar",
  "este",
  "estilo",
  "estufa",
  "etapa",
  "eterno",
  "ética",
  "etnia",
  "evadir",
  "evaluar",
  "evento",
  "evitar",
  "exacto",
  "examen",
  "exceso",
  "excusa",
  "exento",
  "exigir",
  "exilio",
  "existir",
  "éxito",
  "experto",
  "explicar",
  "exponer",
  "extremo",
  "fábrica",
  "fábula",
  "fachada",
  "fácil",
  "factor",
  "faena",
  "faja",
  "falda",
  "fallo",
  "falso",
  "faltar",
  "fama",
  "familia",
  "famoso",
  "faraón",
  "farmacia",
  "farol",
  "farsa",
  "fase",
  "fatiga",
  "fauna",
  "favor",
  "fax",
  "febrero",
  "fecha",
  "feliz",
  "feo",
  "feria",
  "feroz",
  "fértil",
  "fervor",
  "festín",
  "fiable",
  "fianza",
  "fiar",
  "fibra",
  "ficción",
  "ficha",
  "fideo",
  "fiebre",
  "fiel",
  "fiera",
  "fiesta",
  "figura",
  "fijar",
  "fijo",
  "fila",
  "filete",
  "filial",
  "filtro",
  "fin",
  "finca",
  "fingir",
  "finito",
  "firma",
  "flaco",
  "flauta",
  "flecha",
  "flor",
  "flota",
  "fluir",
  "flujo",
  "flúor",
  "fobia",
  "foca",
  "fogata",
  "fogón",
  "folio",
  "folleto",
  "fondo",
  "forma",
  "forro",
  "fortuna",
  "forzar",
  "fosa",
  "foto",
  "fracaso",
  "frágil",
  "franja",
  "frase",
  "fraude",
  "freír",
  "freno",
  "fresa",
  "frío",
  "frito",
  "fruta",
  "fuego",
  "fuente",
  "fuerza",
  "fuga",
  "fumar",
  "función",
  "funda",
  "furgón",
  "furia",
  "fusil",
  "fútbol",
  "futuro",
  "gacela",
  "gafas",
  "gaita",
  "gajo",
  "gala",
  "galería",
  "gallo",
  "gamba",
  "ganar",
  "gancho",
  "ganga",
  "ganso",
  "garaje",
  "garza",
  "gasolina",
  "gastar",
  "gato",
  "gavilán",
  "gemelo",
  "gemir",
  "gen",
  "género",
  "genio",
  "gente",
  "geranio",
  "gerente",
  "germen",
  "gesto",
  "gigante",
  "gimnasio",
  "girar",
  "giro",
  "glaciar",
  "globo",
  "gloria",
  "gol",
  "golfo",
  "goloso",
  "golpe",
  "goma",
  "gordo",
  "gorila",
  "gorra",
  "gota",
  "goteo",
  "gozar",
  "grada",
  "gráfico",
  "grano",
  "grasa",
  "gratis",
  "grave",
  "grieta",
  "grillo",
  "gripe",
  "gris",
  "grito",
  "grosor",
  "grúa",
  "grueso",
  "grumo",
  "grupo",
  "guante",
  "guapo",
  "guardia",
  "guerra",
  "guía",
  "guiño",
  "guion",
  "guiso",
  "guitarra",
  "gusano",
  "gustar",
  "haber",
  "hábil",
  "hablar",
  "hacer",
  "hacha",
  "hada",
  "hallar",
  "hamaca",
  "harina",
  "haz",
  "hazaña",
  "hebilla",
  "hebra",
  "hecho",
  "helado",
  "helio",
  "hembra",
  "herir",
  "hermano",
  "héroe",
  "hervir",
  "hielo",
  "hierro",
  "hígado",
  "higiene",
  "hijo",
  "himno",
  "historia",
  "hocico",
  "hogar",
  "hoguera",
  "hoja",
  "hombre",
  "hongo",
  "honor",
  "honra",
  "hora",
  "hormiga",
  "horno",
  "hostil",
  "hoyo",
  "hueco",
  "huelga",
  "huerta",
  "hueso",
  "huevo",
  "huida",
  "huir",
  "humano",
  "húmedo",
  "humilde",
  "humo",
  "hundir",
  "huracán",
  "hurto",
  "icono",
  "ideal",
  "idioma",
  "ídolo",
  "iglesia",
  "iglú",
  "igual",
  "ilegal",
  "ilusión",
  "imagen",
  "imán",
  "imitar",
  "impar",
  "imperio",
  "imponer",
  "impulso",
  "incapaz",
  "índice",
  "inerte",
  "infiel",
  "informe",
  "ingenio",
  "inicio",
  "inmenso",
  "inmune",
  "innato",
  "insecto",
  "instante",
  "interés",
  "íntimo",
  "intuir",
  "inútil",
  "invierno",
  "ira",
  "iris",
  "ironía",
  "isla",
  "islote",
  "jabalí",
  "jabón",
  "jamón",
  "jarabe",
  "jardín",
  "jarra",
  "jaula",
  "jazmín",
  "jefe",
  "jeringa",
  "jinete",
  "jornada",
  "joroba",
  "joven",
  "joya",
  "juerga",
  "jueves",
  "juez",
  "jugador",
  "jugo",
  "juguete",
  "juicio",
  "junco",
  "jungla",
  "junio",
  "juntar",
  "júpiter",
  "jurar",
  "justo",
  "juvenil",
  "juzgar",
  "kilo",
  "koala",
  "labio",
  "lacio",
  "lacra",
  "lado",
  "ladrón",
  "lagarto",
  "lágrima",
  "laguna",
  "laico",
  "lamer",
  "lámina",
  "lámpara",
  "lana",
  "lancha",
  "langosta",
  "lanza",
  "lápiz",
  "largo",
  "larva",
  "lástima",
  "lata",
  "látex",
  "latir",
  "laurel",
  "lavar",
  "lazo",
  "leal",
  "lección",
  "leche",
  "lector",
  "leer",
  "legión",
  "legumbre",
  "lejano",
  "lengua",
  "lento",
  "leña",
  "león",
  "leopardo",
  "lesión",
  "letal",
  "letra",
  "leve",
  "leyenda",
  "libertad",
  "libro",
  "licor",
  "líder",
  "lidiar",
  "lienzo",
  "liga",
  "ligero",
  "lima",
  "límite",
  "limón",
  "limpio",
  "lince",
  "lindo",
  "línea",
  "lingote",
  "lino",
  "linterna",
  "líquido",
  "liso",
  "lista",
  "litera",
  "litio",
  "litro",
  "llaga",
  "llama",
  "llanto",
  "llave",
  "llegar",
  "llenar",
  "llevar",
  "llorar",
  "llover",
  "lluvia",
  "lobo",
  "loción",
  "loco",
  "locura",
  "lógica",
  "logro",
  "lombriz",
  "lomo",
  "lonja",
  "lote",
  "lucha",
  "lucir",
  "lugar",
  "lujo",
  "luna",
  "lunes",
  "lupa",
  "lustro",
  "luto",
  "luz",
  "maceta",
  "macho",
  "madera",
  "madre",
  "maduro",
  "maestro",
  "mafia",
  "magia",
  "mago",
  "maíz",
  "maldad",
  "maleta",
  "malla",
  "malo",
  "mamá",
  "mambo",
  "mamut",
  "manco",
  "mando",
  "manejar",
  "manga",
  "maniquí",
  "manjar",
  "mano",
  "manso",
  "manta",
  "mañana",
  "mapa",
  "máquina",
  "mar",
  "marco",
  "marea",
  "marfil",
  "margen",
  "marido",
  "mármol",
  "marrón",
  "martes",
  "marzo",
  "masa",
  "máscara",
  "masivo",
  "matar",
  "materia",
  "matiz",
  "matriz",
  "máximo",
  "mayor",
  "mazorca",
  "mecha",
  "medalla",
  "medio",
  "médula",
  "mejilla",
  "mejor",
  "melena",
  "melón",
  "memoria",
  "menor",
  "mensaje",
  "mente",
  "menú",
  "mercado",
  "merengue",
  "mérito",
  "mes",
  "mesón",
  "meta",
  "meter",
  "método",
  "metro",
  "mezcla",
  "miedo",
  "miel",
  "miembro",
  "miga",
  "mil",
  "milagro",
  "militar",
  "millón",
  "mimo",
  "mina",
  "minero",
  "mínimo",
  "minuto",
  "miope",
  "mirar",
  "misa",
  "miseria",
  "misil",
  "mismo",
  "mitad",
  "mito",
  "mochila",
  "moción",
  "moda",
  "modelo",
  "moho",
  "mojar",
  "molde",
  "moler",
  "molino",
  "momento",
  "momia",
  "monarca",
  "moneda",
  "monja",
  "monto",
  "moño",
  "morada",
  "morder",
  "moreno",
  "morir",
  "morro",
  "morsa",
  "mortal",
  "mosca",
  "mostrar",
  "motivo",
  "mover",
  "móvil",
  "mozo",
  "mucho",
  "mudar",
  "mueble",
  "muela",
  "muerte",
  "muestra",
  "mugre",
  "mujer",
  "mula",
  "muleta",
  "multa",
  "mundo",
  "muñeca",
  "mural",
  "muro",
  "músculo",
  "museo",
  "musgo",
  "música",
  "muslo",
  "nácar",
  "nación",
  "nadar",
  "naipe",
  "naranja",
  "nariz",
  "narrar",
  "nasal",
  "natal",
  "nativo",
  "natural",
  "náusea",
  "naval",
  "nave",
  "navidad",
  "necio",
  "néctar",
  "negar",
  "negocio",
  "negro",
  "neón",
  "nervio",
  "neto",
  "neutro",
  "nevar",
  "nevera",
  "nicho",
  "nido",
  "niebla",
  "nieto",
  "niñez",
  "niño",
  "nítido",
  "nivel",
  "nobleza",
  "noche",
  "nómina",
  "noria",
  "norma",
  "norte",
  "nota",
  "noticia",
  "novato",
  "novela",
  "novio",
  "nube",
  "nuca",
  "núcleo",
  "nudillo",
  "nudo",
  "nuera",
  "nueve",
  "nuez",
  "nulo",
  "número",
  "nutria",
  "oasis",
  "obeso",
  "obispo",
  "objeto",
  "obra",
  "obrero",
  "observar",
  "obtener",
  "obvio",
  "oca",
  "ocaso",
  "océano",
  "ochenta",
  "ocho",
  "ocio",
  "ocre",
  "octavo",
  "octubre",
  "oculto",
  "ocupar",
  "ocurrir",
  "odiar",
  "odio",
  "odisea",
  "oeste",
  "ofensa",
  "oferta",
  "oficio",
  "ofrecer",
  "ogro",
  "oído",
  "oír",
  "ojo",
  "ola",
  "oleada",
  "olfato",
  "olivo",
  "olla",
  "olmo",
  "olor",
  "olvido",
  "ombligo",
  "onda",
  "onza",
  "opaco",
  "opción",
  "ópera",
  "opinar",
  "oponer",
  "optar",
  "óptica",
  "opuesto",
  "oración",
  "orador",
  "oral",
  "órbita",
  "orca",
  "orden",
  "oreja",
  "órgano",
  "orgía",
  "orgullo",
  "oriente",
  "origen",
  "orilla",
  "oro",
  "orquesta",
  "oruga",
  "osadía",
  "oscuro",
  "osezno",
  "oso",
  "ostra",
  "otoño",
  "otro",
  "oveja",
  "óvulo",
  "óxido",
  "oxígeno",
  "oyente",
  "ozono",
  "pacto",
  "padre",
  "paella",
  "página",
  "pago",
  "país",
  "pájaro",
  "palabra",
  "palco",
  "paleta",
  "pálido",
  "palma",
  "paloma",
  "palpar",
  "pan",
  "panal",
  "pánico",
  "pantera",
  "pañuelo",
  "papá",
  "papel",
  "papilla",
  "paquete",
  "parar",
  "parcela",
  "pared",
  "parir",
  "paro",
  "párpado",
  "parque",
  "párrafo",
  "parte",
  "pasar",
  "paseo",
  "pasión",
  "paso",
  "pasta",
  "pata",
  "patio",
  "patria",
  "pausa",
  "pauta",
  "pavo",
  "payaso",
  "peatón",
  "pecado",
  "pecera",
  "pecho",
  "pedal",
  "pedir",
  "pegar",
  "peine",
  "pelar",
  "peldaño",
  "pelea",
  "peligro",
  "pellejo",
  "pelo",
  "peluca",
  "pena",
  "pensar",
  "peñón",
  "peón",
  "peor",
  "pepino",
  "pequeño",
  "pera",
  "percha",
  "perder",
  "pereza",
  "perfil",
  "perico",
  "perla",
  "permiso",
  "perro",
  "persona",
  "pesa",
  "pesca",
  "pésimo",
  "pestaña",
  "pétalo",
  "petróleo",
  "pez",
  "pezuña",
  "picar",
  "pichón",
  "pie",
  "piedra",
  "pierna",
  "pieza",
  "pijama",
  "pilar",
  "piloto",
  "pimienta",
  "pino",
  "pintor",
  "pinza",
  "piña",
  "piojo",
  "pipa",
  "pirata",
  "pisar",
  "piscina",
  "piso",
  "pista",
  "pitón",
  "pizca",
  "placa",
  "plan",
  "plata",
  "playa",
  "plaza",
  "pleito",
  "pleno",
  "plomo",
  "pluma",
  "plural",
  "pobre",
  "poco",
  "poder",
  "podio",
  "poema",
  "poesía",
  "poeta",
  "polen",
  "policía",
  "pollo",
  "polvo",
  "pomada",
  "pomelo",
  "pomo",
  "pompa",
  "poner",
  "porción",
  "portal",
  "posada",
  "poseer",
  "posible",
  "poste",
  "potencia",
  "potro",
  "pozo",
  "prado",
  "precoz",
  "pregunta",
  "premio",
  "prensa",
  "preso",
  "previo",
  "primo",
  "príncipe",
  "prisión",
  "privar",
  "proa",
  "probar",
  "proceso",
  "producto",
  "proeza",
  "profesor",
  "programa",
  "prole",
  "promesa",
  "pronto",
  "propio",
  "próximo",
  "prueba",
  "público",
  "puchero",
  "pudor",
  "pueblo",
  "puerta",
  "puesto",
  "pulga",
  "pulir",
  "pulmón",
  "pulpo",
  "pulso",
  "puma",
  "punto",
  "puñal",
  "puño",
  "pupa",
  "pupila",
  "puré",
  "quedar",
  "queja",
  "quemar",
  "querer",
  "queso",
  "quieto",
  "química",
  "quince",
  "quitar",
  "rábano",
  "rabia",
  "rabo",
  "ración",
  "radical",
  "raíz",
  "rama",
  "rampa",
  "rancho",
  "rango",
  "rapaz",
  "rápido",
  "rapto",
  "rasgo",
  "raspa",
  "rato",
  "rayo",
  "raza",
  "razón",
  "reacción",
  "realidad",
  "rebaño",
  "rebote",
  "recaer",
  "receta",
  "rechazo",
  "recoger",
  "recreo",
  "recto",
  "recurso",
  "red",
  "redondo",
  "reducir",
  "reflejo",
  "reforma",
  "refrán",
  "refugio",
  "regalo",
  "regir",
  "regla",
  "regreso",
  "rehén",
  "reino",
  "reír",
  "reja",
  "relato",
  "relevo",
  "relieve",
  "relleno",
  "reloj",
  "remar",
  "remedio",
  "remo",
  "rencor",
  "rendir",
  "renta",
  "reparto",
  "repetir",
  "reposo",
  "reptil",
  "res",
  "rescate",
  "resina",
  "respeto",
  "resto",
  "resumen",
  "retiro",
  "retorno",
  "retrato",
  "reunir",
  "revés",
  "revista",
  "rey",
  "rezar",
  "rico",
  "riego",
  "rienda",
  "riesgo",
  "rifa",
  "rígido",
  "rigor",
  "rincón",
  "riñón",
  "río",
  "riqueza",
  "risa",
  "ritmo",
  "rito",
  "rizo",
  "roble",
  "roce",
  "rociar",
  "rodar",
  "rodeo",
  "rodilla",
  "roer",
  "rojizo",
  "rojo",
  "romero",
  "romper",
  "ron",
  "ronco",
  "ronda",
  "ropa",
  "ropero",
  "rosa",
  "rosca",
  "rostro",
  "rotar",
  "rubí",
  "rubor",
  "rudo",
  "rueda",
  "rugir",
  "ruido",
  "ruina",
  "ruleta",
  "rulo",
  "rumbo",
  "rumor",
  "ruptura",
  "ruta",
  "rutina",
  "sábado",
  "saber",
  "sabio",
  "sable",
  "sacar",
  "sagaz",
  "sagrado",
  "sala",
  "saldo",
  "salero",
  "salir",
  "salmón",
  "salón",
  "salsa",
  "salto",
  "salud",
  "salvar",
  "samba",
  "sanción",
  "sandía",
  "sanear",
  "sangre",
  "sanidad",
  "sano",
  "santo",
  "sapo",
  "saque",
  "sardina",
  "sartén",
  "sastre",
  "satán",
  "sauna",
  "saxofón",
  "sección",
  "seco",
  "secreto",
  "secta",
  "sed",
  "seguir",
  "seis",
  "sello",
  "selva",
  "semana",
  "semilla",
  "senda",
  "sensor",
  "señal",
  "señor",
  "separar",
  "sepia",
  "sequía",
  "ser",
  "serie",
  "sermón",
  "servir",
  "sesenta",
  "sesión",
  "seta",
  "setenta",
  "severo",
  "sexo",
  "sexto",
  "sidra",
  "siesta",
  "siete",
  "siglo",
  "signo",
  "sílaba",
  "silbar",
  "silencio",
  "silla",
  "símbolo",
  "simio",
  "sirena",
  "sistema",
  "sitio",
  "situar",
  "sobre",
  "socio",
  "sodio",
  "sol",
  "solapa",
  "soldado",
  "soledad",
  "sólido",
  "soltar",
  "solución",
  "sombra",
  "sondeo",
  "sonido",
  "sonoro",
  "sonrisa",
  "sopa",
  "soplar",
  "soporte",
  "sordo",
  "sorpresa",
  "sorteo",
  "sostén",
  "sótano",
  "suave",
  "subir",
  "suceso",
  "sudor",
  "suegra",
  "suelo",
  "sueño",
  "suerte",
  "sufrir",
  "sujeto",
  "sultán",
  "sumar",
  "superar",
  "suplir",
  "suponer",
  "supremo",
  "sur",
  "surco",
  "sureño",
  "surgir",
  "susto",
  "sutil",
  "tabaco",
  "tabique",
  "tabla",
  "tabú",
  "taco",
  "tacto",
  "tajo",
  "talar",
  "talco",
  "talento",
  "talla",
  "talón",
  "tamaño",
  "tambor",
  "tango",
  "tanque",
  "tapa",
  "tapete",
  "tapia",
  "tapón",
  "taquilla",
  "tarde",
  "tarea",
  "tarifa",
  "tarjeta",
  "tarot",
  "tarro",
  "tarta",
  "tatuaje",
  "tauro",
  "taza",
  "tazón",
  "teatro",
  "techo",
  "tecla",
  "técnica",
  "tejado",
  "tejer",
  "tejido",
  "tela",
  "teléfono",
  "tema",
  "temor",
  "templo",
  "tenaz",
  "tender",
  "tener",
  "tenis",
  "tenso",
  "teoría",
  "terapia",
  "terco",
  "término",
  "ternura",
  "terror",
  "tesis",
  "tesoro",
  "testigo",
  "tetera",
  "texto",
  "tez",
  "tibio",
  "tiburón",
  "tiempo",
  "tienda",
  "tierra",
  "tieso",
  "tigre",
  "tijera",
  "tilde",
  "timbre",
  "tímido",
  "timo",
  "tinta",
  "tío",
  "típico",
  "tipo",
  "tira",
  "tirón",
  "titán",
  "títere",
  "título",
  "tiza",
  "toalla",
  "tobillo",
  "tocar",
  "tocino",
  "todo",
  "toga",
  "toldo",
  "tomar",
  "tono",
  "tonto",
  "topar",
  "tope",
  "toque",
  "tórax",
  "torero",
  "tormenta",
  "torneo",
  "toro",
  "torpedo",
  "torre",
  "torso",
  "tortuga",
  "tos",
  "tosco",
  "toser",
  "tóxico",
  "trabajo",
  "tractor",
  "traer",
  "tráfico",
  "trago",
  "traje",
  "tramo",
  "trance",
  "trato",
  "trauma",
  "trazar",
  "trébol",
  "tregua",
  "treinta",
  "tren",
  "trepar",
  "tres",
  "tribu",
  "trigo",
  "tripa",
  "triste",
  "triunfo",
  "trofeo",
  "trompa",
  "tronco",
  "tropa",
  "trote",
  "trozo",
  "truco",
  "trueno",
  "trufa",
  "tubería",
  "tubo",
  "tuerto",
  "tumba",
  "tumor",
  "túnel",
  "túnica",
  "turbina",
  "turismo",
  "turno",
  "tutor",
  "ubicar",
  "úlcera",
  "umbral",
  "unidad",
  "unir",
  "universo",
  "uno",
  "untar",
  "uña",
  "urbano",
  "urbe",
  "urgente",
  "urna",
  "usar",
  "usuario",
  "útil",
  "utopía",
  "uva",
  "vaca",
  "vacío",
  "vacuna",
  "vagar",
  "vago",
  "vaina",
  "vajilla",
  "vale",
  "válido",
  "valle",
  "valor",
  "válvula",
  "vampiro",
  "vara",
  "variar",
  "varón",
  "vaso",
  "vecino",
  "vector",
  "vehículo",
  "veinte",
  "vejez",
  "vela",
  "velero",
  "veloz",
  "vena",
  "vencer",
  "venda",
  "veneno",
  "vengar",
  "venir",
  "venta",
  "venus",
  "ver",
  "verano",
  "verbo",
  "verde",
  "vereda",
  "verja",
  "verso",
  "verter",
  "vía",
  "viaje",
  "vibrar",
  "vicio",
  "víctima",
  "vida",
  "vídeo",
  "vidrio",
  "viejo",
  "viernes",
  "vigor",
  "vil",
  "villa",
  "vinagre",
  "vino",
  "viñedo",
  "violín",
  "viral",
  "virgo",
  "virtud",
  "visor",
  "víspera",
  "vista",
  "vitamina",
  "viudo",
  "vivaz",
  "vivero",
  "vivir",
  "vivo",
  "volcán",
  "volumen",
  "volver",
  "voraz",
  "votar",
  "voto",
  "voz",
  "vuelo",
  "vulgar",
  "yacer",
  "yate",
  "yegua",
  "yema",
  "yerno",
  "yeso",
  "yodo",
  "yoga",
  "yogur",
  "zafiro",
  "zanja",
  "zapato",
  "zarza",
  "zona",
  "zorro",
  "zumo",
  "zurdo"
], yOe = [
  "あいこくしん",
  "あいさつ",
  "あいだ",
  "あおぞら",
  "あかちゃん",
  "あきる",
  "あけがた",
  "あける",
  "あこがれる",
  "あさい",
  "あさひ",
  "あしあと",
  "あじわう",
  "あずかる",
  "あずき",
  "あそぶ",
  "あたえる",
  "あたためる",
  "あたりまえ",
  "あたる",
  "あつい",
  "あつかう",
  "あっしゅく",
  "あつまり",
  "あつめる",
  "あてな",
  "あてはまる",
  "あひる",
  "あぶら",
  "あぶる",
  "あふれる",
  "あまい",
  "あまど",
  "あまやかす",
  "あまり",
  "あみもの",
  "あめりか",
  "あやまる",
  "あゆむ",
  "あらいぐま",
  "あらし",
  "あらすじ",
  "あらためる",
  "あらゆる",
  "あらわす",
  "ありがとう",
  "あわせる",
  "あわてる",
  "あんい",
  "あんがい",
  "あんこ",
  "あんぜん",
  "あんてい",
  "あんない",
  "あんまり",
  "いいだす",
  "いおん",
  "いがい",
  "いがく",
  "いきおい",
  "いきなり",
  "いきもの",
  "いきる",
  "いくじ",
  "いくぶん",
  "いけばな",
  "いけん",
  "いこう",
  "いこく",
  "いこつ",
  "いさましい",
  "いさん",
  "いしき",
  "いじゅう",
  "いじょう",
  "いじわる",
  "いずみ",
  "いずれ",
  "いせい",
  "いせえび",
  "いせかい",
  "いせき",
  "いぜん",
  "いそうろう",
  "いそがしい",
  "いだい",
  "いだく",
  "いたずら",
  "いたみ",
  "いたりあ",
  "いちおう",
  "いちじ",
  "いちど",
  "いちば",
  "いちぶ",
  "いちりゅう",
  "いつか",
  "いっしゅん",
  "いっせい",
  "いっそう",
  "いったん",
  "いっち",
  "いってい",
  "いっぽう",
  "いてざ",
  "いてん",
  "いどう",
  "いとこ",
  "いない",
  "いなか",
  "いねむり",
  "いのち",
  "いのる",
  "いはつ",
  "いばる",
  "いはん",
  "いびき",
  "いひん",
  "いふく",
  "いへん",
  "いほう",
  "いみん",
  "いもうと",
  "いもたれ",
  "いもり",
  "いやがる",
  "いやす",
  "いよかん",
  "いよく",
  "いらい",
  "いらすと",
  "いりぐち",
  "いりょう",
  "いれい",
  "いれもの",
  "いれる",
  "いろえんぴつ",
  "いわい",
  "いわう",
  "いわかん",
  "いわば",
  "いわゆる",
  "いんげんまめ",
  "いんさつ",
  "いんしょう",
  "いんよう",
  "うえき",
  "うえる",
  "うおざ",
  "うがい",
  "うかぶ",
  "うかべる",
  "うきわ",
  "うくらいな",
  "うくれれ",
  "うけたまわる",
  "うけつけ",
  "うけとる",
  "うけもつ",
  "うける",
  "うごかす",
  "うごく",
  "うこん",
  "うさぎ",
  "うしなう",
  "うしろがみ",
  "うすい",
  "うすぎ",
  "うすぐらい",
  "うすめる",
  "うせつ",
  "うちあわせ",
  "うちがわ",
  "うちき",
  "うちゅう",
  "うっかり",
  "うつくしい",
  "うったえる",
  "うつる",
  "うどん",
  "うなぎ",
  "うなじ",
  "うなずく",
  "うなる",
  "うねる",
  "うのう",
  "うぶげ",
  "うぶごえ",
  "うまれる",
  "うめる",
  "うもう",
  "うやまう",
  "うよく",
  "うらがえす",
  "うらぐち",
  "うらない",
  "うりあげ",
  "うりきれ",
  "うるさい",
  "うれしい",
  "うれゆき",
  "うれる",
  "うろこ",
  "うわき",
  "うわさ",
  "うんこう",
  "うんちん",
  "うんてん",
  "うんどう",
  "えいえん",
  "えいが",
  "えいきょう",
  "えいご",
  "えいせい",
  "えいぶん",
  "えいよう",
  "えいわ",
  "えおり",
  "えがお",
  "えがく",
  "えきたい",
  "えくせる",
  "えしゃく",
  "えすて",
  "えつらん",
  "えのぐ",
  "えほうまき",
  "えほん",
  "えまき",
  "えもじ",
  "えもの",
  "えらい",
  "えらぶ",
  "えりあ",
  "えんえん",
  "えんかい",
  "えんぎ",
  "えんげき",
  "えんしゅう",
  "えんぜつ",
  "えんそく",
  "えんちょう",
  "えんとつ",
  "おいかける",
  "おいこす",
  "おいしい",
  "おいつく",
  "おうえん",
  "おうさま",
  "おうじ",
  "おうせつ",
  "おうたい",
  "おうふく",
  "おうべい",
  "おうよう",
  "おえる",
  "おおい",
  "おおう",
  "おおどおり",
  "おおや",
  "おおよそ",
  "おかえり",
  "おかず",
  "おがむ",
  "おかわり",
  "おぎなう",
  "おきる",
  "おくさま",
  "おくじょう",
  "おくりがな",
  "おくる",
  "おくれる",
  "おこす",
  "おこなう",
  "おこる",
  "おさえる",
  "おさない",
  "おさめる",
  "おしいれ",
  "おしえる",
  "おじぎ",
  "おじさん",
  "おしゃれ",
  "おそらく",
  "おそわる",
  "おたがい",
  "おたく",
  "おだやか",
  "おちつく",
  "おっと",
  "おつり",
  "おでかけ",
  "おとしもの",
  "おとなしい",
  "おどり",
  "おどろかす",
  "おばさん",
  "おまいり",
  "おめでとう",
  "おもいで",
  "おもう",
  "おもたい",
  "おもちゃ",
  "おやつ",
  "おやゆび",
  "およぼす",
  "おらんだ",
  "おろす",
  "おんがく",
  "おんけい",
  "おんしゃ",
  "おんせん",
  "おんだん",
  "おんちゅう",
  "おんどけい",
  "かあつ",
  "かいが",
  "がいき",
  "がいけん",
  "がいこう",
  "かいさつ",
  "かいしゃ",
  "かいすいよく",
  "かいぜん",
  "かいぞうど",
  "かいつう",
  "かいてん",
  "かいとう",
  "かいふく",
  "がいへき",
  "かいほう",
  "かいよう",
  "がいらい",
  "かいわ",
  "かえる",
  "かおり",
  "かかえる",
  "かがく",
  "かがし",
  "かがみ",
  "かくご",
  "かくとく",
  "かざる",
  "がぞう",
  "かたい",
  "かたち",
  "がちょう",
  "がっきゅう",
  "がっこう",
  "がっさん",
  "がっしょう",
  "かなざわし",
  "かのう",
  "がはく",
  "かぶか",
  "かほう",
  "かほご",
  "かまう",
  "かまぼこ",
  "かめれおん",
  "かゆい",
  "かようび",
  "からい",
  "かるい",
  "かろう",
  "かわく",
  "かわら",
  "がんか",
  "かんけい",
  "かんこう",
  "かんしゃ",
  "かんそう",
  "かんたん",
  "かんち",
  "がんばる",
  "きあい",
  "きあつ",
  "きいろ",
  "ぎいん",
  "きうい",
  "きうん",
  "きえる",
  "きおう",
  "きおく",
  "きおち",
  "きおん",
  "きかい",
  "きかく",
  "きかんしゃ",
  "ききて",
  "きくばり",
  "きくらげ",
  "きけんせい",
  "きこう",
  "きこえる",
  "きこく",
  "きさい",
  "きさく",
  "きさま",
  "きさらぎ",
  "ぎじかがく",
  "ぎしき",
  "ぎじたいけん",
  "ぎじにってい",
  "ぎじゅつしゃ",
  "きすう",
  "きせい",
  "きせき",
  "きせつ",
  "きそう",
  "きぞく",
  "きぞん",
  "きたえる",
  "きちょう",
  "きつえん",
  "ぎっちり",
  "きつつき",
  "きつね",
  "きてい",
  "きどう",
  "きどく",
  "きない",
  "きなが",
  "きなこ",
  "きぬごし",
  "きねん",
  "きのう",
  "きのした",
  "きはく",
  "きびしい",
  "きひん",
  "きふく",
  "きぶん",
  "きぼう",
  "きほん",
  "きまる",
  "きみつ",
  "きむずかしい",
  "きめる",
  "きもだめし",
  "きもち",
  "きもの",
  "きゃく",
  "きやく",
  "ぎゅうにく",
  "きよう",
  "きょうりゅう",
  "きらい",
  "きらく",
  "きりん",
  "きれい",
  "きれつ",
  "きろく",
  "ぎろん",
  "きわめる",
  "ぎんいろ",
  "きんかくじ",
  "きんじょ",
  "きんようび",
  "ぐあい",
  "くいず",
  "くうかん",
  "くうき",
  "くうぐん",
  "くうこう",
  "ぐうせい",
  "くうそう",
  "ぐうたら",
  "くうふく",
  "くうぼ",
  "くかん",
  "くきょう",
  "くげん",
  "ぐこう",
  "くさい",
  "くさき",
  "くさばな",
  "くさる",
  "くしゃみ",
  "くしょう",
  "くすのき",
  "くすりゆび",
  "くせげ",
  "くせん",
  "ぐたいてき",
  "くださる",
  "くたびれる",
  "くちこみ",
  "くちさき",
  "くつした",
  "ぐっすり",
  "くつろぐ",
  "くとうてん",
  "くどく",
  "くなん",
  "くねくね",
  "くのう",
  "くふう",
  "くみあわせ",
  "くみたてる",
  "くめる",
  "くやくしょ",
  "くらす",
  "くらべる",
  "くるま",
  "くれる",
  "くろう",
  "くわしい",
  "ぐんかん",
  "ぐんしょく",
  "ぐんたい",
  "ぐんて",
  "けあな",
  "けいかく",
  "けいけん",
  "けいこ",
  "けいさつ",
  "げいじゅつ",
  "けいたい",
  "げいのうじん",
  "けいれき",
  "けいろ",
  "けおとす",
  "けおりもの",
  "げきか",
  "げきげん",
  "げきだん",
  "げきちん",
  "げきとつ",
  "げきは",
  "げきやく",
  "げこう",
  "げこくじょう",
  "げざい",
  "けさき",
  "げざん",
  "けしき",
  "けしごむ",
  "けしょう",
  "げすと",
  "けたば",
  "けちゃっぷ",
  "けちらす",
  "けつあつ",
  "けつい",
  "けつえき",
  "けっこん",
  "けつじょ",
  "けっせき",
  "けってい",
  "けつまつ",
  "げつようび",
  "げつれい",
  "けつろん",
  "げどく",
  "けとばす",
  "けとる",
  "けなげ",
  "けなす",
  "けなみ",
  "けぬき",
  "げねつ",
  "けねん",
  "けはい",
  "げひん",
  "けぶかい",
  "げぼく",
  "けまり",
  "けみかる",
  "けむし",
  "けむり",
  "けもの",
  "けらい",
  "けろけろ",
  "けわしい",
  "けんい",
  "けんえつ",
  "けんお",
  "けんか",
  "げんき",
  "けんげん",
  "けんこう",
  "けんさく",
  "けんしゅう",
  "けんすう",
  "げんそう",
  "けんちく",
  "けんてい",
  "けんとう",
  "けんない",
  "けんにん",
  "げんぶつ",
  "けんま",
  "けんみん",
  "けんめい",
  "けんらん",
  "けんり",
  "こあくま",
  "こいぬ",
  "こいびと",
  "ごうい",
  "こうえん",
  "こうおん",
  "こうかん",
  "ごうきゅう",
  "ごうけい",
  "こうこう",
  "こうさい",
  "こうじ",
  "こうすい",
  "ごうせい",
  "こうそく",
  "こうたい",
  "こうちゃ",
  "こうつう",
  "こうてい",
  "こうどう",
  "こうない",
  "こうはい",
  "ごうほう",
  "ごうまん",
  "こうもく",
  "こうりつ",
  "こえる",
  "こおり",
  "ごかい",
  "ごがつ",
  "ごかん",
  "こくご",
  "こくさい",
  "こくとう",
  "こくない",
  "こくはく",
  "こぐま",
  "こけい",
  "こける",
  "ここのか",
  "こころ",
  "こさめ",
  "こしつ",
  "こすう",
  "こせい",
  "こせき",
  "こぜん",
  "こそだて",
  "こたい",
  "こたえる",
  "こたつ",
  "こちょう",
  "こっか",
  "こつこつ",
  "こつばん",
  "こつぶ",
  "こてい",
  "こてん",
  "ことがら",
  "ことし",
  "ことば",
  "ことり",
  "こなごな",
  "こねこね",
  "このまま",
  "このみ",
  "このよ",
  "ごはん",
  "こひつじ",
  "こふう",
  "こふん",
  "こぼれる",
  "ごまあぶら",
  "こまかい",
  "ごますり",
  "こまつな",
  "こまる",
  "こむぎこ",
  "こもじ",
  "こもち",
  "こもの",
  "こもん",
  "こやく",
  "こやま",
  "こゆう",
  "こゆび",
  "こよい",
  "こよう",
  "こりる",
  "これくしょん",
  "ころっけ",
  "こわもて",
  "こわれる",
  "こんいん",
  "こんかい",
  "こんき",
  "こんしゅう",
  "こんすい",
  "こんだて",
  "こんとん",
  "こんなん",
  "こんびに",
  "こんぽん",
  "こんまけ",
  "こんや",
  "こんれい",
  "こんわく",
  "ざいえき",
  "さいかい",
  "さいきん",
  "ざいげん",
  "ざいこ",
  "さいしょ",
  "さいせい",
  "ざいたく",
  "ざいちゅう",
  "さいてき",
  "ざいりょう",
  "さうな",
  "さかいし",
  "さがす",
  "さかな",
  "さかみち",
  "さがる",
  "さぎょう",
  "さくし",
  "さくひん",
  "さくら",
  "さこく",
  "さこつ",
  "さずかる",
  "ざせき",
  "さたん",
  "さつえい",
  "ざつおん",
  "ざっか",
  "ざつがく",
  "さっきょく",
  "ざっし",
  "さつじん",
  "ざっそう",
  "さつたば",
  "さつまいも",
  "さてい",
  "さといも",
  "さとう",
  "さとおや",
  "さとし",
  "さとる",
  "さのう",
  "さばく",
  "さびしい",
  "さべつ",
  "さほう",
  "さほど",
  "さます",
  "さみしい",
  "さみだれ",
  "さむけ",
  "さめる",
  "さやえんどう",
  "さゆう",
  "さよう",
  "さよく",
  "さらだ",
  "ざるそば",
  "さわやか",
  "さわる",
  "さんいん",
  "さんか",
  "さんきゃく",
  "さんこう",
  "さんさい",
  "ざんしょ",
  "さんすう",
  "さんせい",
  "さんそ",
  "さんち",
  "さんま",
  "さんみ",
  "さんらん",
  "しあい",
  "しあげ",
  "しあさって",
  "しあわせ",
  "しいく",
  "しいん",
  "しうち",
  "しえい",
  "しおけ",
  "しかい",
  "しかく",
  "じかん",
  "しごと",
  "しすう",
  "じだい",
  "したうけ",
  "したぎ",
  "したて",
  "したみ",
  "しちょう",
  "しちりん",
  "しっかり",
  "しつじ",
  "しつもん",
  "してい",
  "してき",
  "してつ",
  "じてん",
  "じどう",
  "しなぎれ",
  "しなもの",
  "しなん",
  "しねま",
  "しねん",
  "しのぐ",
  "しのぶ",
  "しはい",
  "しばかり",
  "しはつ",
  "しはらい",
  "しはん",
  "しひょう",
  "しふく",
  "じぶん",
  "しへい",
  "しほう",
  "しほん",
  "しまう",
  "しまる",
  "しみん",
  "しむける",
  "じむしょ",
  "しめい",
  "しめる",
  "しもん",
  "しゃいん",
  "しゃうん",
  "しゃおん",
  "じゃがいも",
  "しやくしょ",
  "しゃくほう",
  "しゃけん",
  "しゃこ",
  "しゃざい",
  "しゃしん",
  "しゃせん",
  "しゃそう",
  "しゃたい",
  "しゃちょう",
  "しゃっきん",
  "じゃま",
  "しゃりん",
  "しゃれい",
  "じゆう",
  "じゅうしょ",
  "しゅくはく",
  "じゅしん",
  "しゅっせき",
  "しゅみ",
  "しゅらば",
  "じゅんばん",
  "しょうかい",
  "しょくたく",
  "しょっけん",
  "しょどう",
  "しょもつ",
  "しらせる",
  "しらべる",
  "しんか",
  "しんこう",
  "じんじゃ",
  "しんせいじ",
  "しんちく",
  "しんりん",
  "すあげ",
  "すあし",
  "すあな",
  "ずあん",
  "すいえい",
  "すいか",
  "すいとう",
  "ずいぶん",
  "すいようび",
  "すうがく",
  "すうじつ",
  "すうせん",
  "すおどり",
  "すきま",
  "すくう",
  "すくない",
  "すける",
  "すごい",
  "すこし",
  "ずさん",
  "すずしい",
  "すすむ",
  "すすめる",
  "すっかり",
  "ずっしり",
  "ずっと",
  "すてき",
  "すてる",
  "すねる",
  "すのこ",
  "すはだ",
  "すばらしい",
  "ずひょう",
  "ずぶぬれ",
  "すぶり",
  "すふれ",
  "すべて",
  "すべる",
  "ずほう",
  "すぼん",
  "すまい",
  "すめし",
  "すもう",
  "すやき",
  "すらすら",
  "するめ",
  "すれちがう",
  "すろっと",
  "すわる",
  "すんぜん",
  "すんぽう",
  "せあぶら",
  "せいかつ",
  "せいげん",
  "せいじ",
  "せいよう",
  "せおう",
  "せかいかん",
  "せきにん",
  "せきむ",
  "せきゆ",
  "せきらんうん",
  "せけん",
  "せこう",
  "せすじ",
  "せたい",
  "せたけ",
  "せっかく",
  "せっきゃく",
  "ぜっく",
  "せっけん",
  "せっこつ",
  "せっさたくま",
  "せつぞく",
  "せつだん",
  "せつでん",
  "せっぱん",
  "せつび",
  "せつぶん",
  "せつめい",
  "せつりつ",
  "せなか",
  "せのび",
  "せはば",
  "せびろ",
  "せぼね",
  "せまい",
  "せまる",
  "せめる",
  "せもたれ",
  "せりふ",
  "ぜんあく",
  "せんい",
  "せんえい",
  "せんか",
  "せんきょ",
  "せんく",
  "せんげん",
  "ぜんご",
  "せんさい",
  "せんしゅ",
  "せんすい",
  "せんせい",
  "せんぞ",
  "せんたく",
  "せんちょう",
  "せんてい",
  "せんとう",
  "せんぬき",
  "せんねん",
  "せんぱい",
  "ぜんぶ",
  "ぜんぽう",
  "せんむ",
  "せんめんじょ",
  "せんもん",
  "せんやく",
  "せんゆう",
  "せんよう",
  "ぜんら",
  "ぜんりゃく",
  "せんれい",
  "せんろ",
  "そあく",
  "そいとげる",
  "そいね",
  "そうがんきょう",
  "そうき",
  "そうご",
  "そうしん",
  "そうだん",
  "そうなん",
  "そうび",
  "そうめん",
  "そうり",
  "そえもの",
  "そえん",
  "そがい",
  "そげき",
  "そこう",
  "そこそこ",
  "そざい",
  "そしな",
  "そせい",
  "そせん",
  "そそぐ",
  "そだてる",
  "そつう",
  "そつえん",
  "そっかん",
  "そつぎょう",
  "そっけつ",
  "そっこう",
  "そっせん",
  "そっと",
  "そとがわ",
  "そとづら",
  "そなえる",
  "そなた",
  "そふぼ",
  "そぼく",
  "そぼろ",
  "そまつ",
  "そまる",
  "そむく",
  "そむりえ",
  "そめる",
  "そもそも",
  "そよかぜ",
  "そらまめ",
  "そろう",
  "そんかい",
  "そんけい",
  "そんざい",
  "そんしつ",
  "そんぞく",
  "そんちょう",
  "ぞんび",
  "ぞんぶん",
  "そんみん",
  "たあい",
  "たいいん",
  "たいうん",
  "たいえき",
  "たいおう",
  "だいがく",
  "たいき",
  "たいぐう",
  "たいけん",
  "たいこ",
  "たいざい",
  "だいじょうぶ",
  "だいすき",
  "たいせつ",
  "たいそう",
  "だいたい",
  "たいちょう",
  "たいてい",
  "だいどころ",
  "たいない",
  "たいねつ",
  "たいのう",
  "たいはん",
  "だいひょう",
  "たいふう",
  "たいへん",
  "たいほ",
  "たいまつばな",
  "たいみんぐ",
  "たいむ",
  "たいめん",
  "たいやき",
  "たいよう",
  "たいら",
  "たいりょく",
  "たいる",
  "たいわん",
  "たうえ",
  "たえる",
  "たおす",
  "たおる",
  "たおれる",
  "たかい",
  "たかね",
  "たきび",
  "たくさん",
  "たこく",
  "たこやき",
  "たさい",
  "たしざん",
  "だじゃれ",
  "たすける",
  "たずさわる",
  "たそがれ",
  "たたかう",
  "たたく",
  "ただしい",
  "たたみ",
  "たちばな",
  "だっかい",
  "だっきゃく",
  "だっこ",
  "だっしゅつ",
  "だったい",
  "たてる",
  "たとえる",
  "たなばた",
  "たにん",
  "たぬき",
  "たのしみ",
  "たはつ",
  "たぶん",
  "たべる",
  "たぼう",
  "たまご",
  "たまる",
  "だむる",
  "ためいき",
  "ためす",
  "ためる",
  "たもつ",
  "たやすい",
  "たよる",
  "たらす",
  "たりきほんがん",
  "たりょう",
  "たりる",
  "たると",
  "たれる",
  "たれんと",
  "たろっと",
  "たわむれる",
  "だんあつ",
  "たんい",
  "たんおん",
  "たんか",
  "たんき",
  "たんけん",
  "たんご",
  "たんさん",
  "たんじょうび",
  "だんせい",
  "たんそく",
  "たんたい",
  "だんち",
  "たんてい",
  "たんとう",
  "だんな",
  "たんにん",
  "だんねつ",
  "たんのう",
  "たんぴん",
  "だんぼう",
  "たんまつ",
  "たんめい",
  "だんれつ",
  "だんろ",
  "だんわ",
  "ちあい",
  "ちあん",
  "ちいき",
  "ちいさい",
  "ちえん",
  "ちかい",
  "ちから",
  "ちきゅう",
  "ちきん",
  "ちけいず",
  "ちけん",
  "ちこく",
  "ちさい",
  "ちしき",
  "ちしりょう",
  "ちせい",
  "ちそう",
  "ちたい",
  "ちたん",
  "ちちおや",
  "ちつじょ",
  "ちてき",
  "ちてん",
  "ちぬき",
  "ちぬり",
  "ちのう",
  "ちひょう",
  "ちへいせん",
  "ちほう",
  "ちまた",
  "ちみつ",
  "ちみどろ",
  "ちめいど",
  "ちゃんこなべ",
  "ちゅうい",
  "ちゆりょく",
  "ちょうし",
  "ちょさくけん",
  "ちらし",
  "ちらみ",
  "ちりがみ",
  "ちりょう",
  "ちるど",
  "ちわわ",
  "ちんたい",
  "ちんもく",
  "ついか",
  "ついたち",
  "つうか",
  "つうじょう",
  "つうはん",
  "つうわ",
  "つかう",
  "つかれる",
  "つくね",
  "つくる",
  "つけね",
  "つける",
  "つごう",
  "つたえる",
  "つづく",
  "つつじ",
  "つつむ",
  "つとめる",
  "つながる",
  "つなみ",
  "つねづね",
  "つのる",
  "つぶす",
  "つまらない",
  "つまる",
  "つみき",
  "つめたい",
  "つもり",
  "つもる",
  "つよい",
  "つるぼ",
  "つるみく",
  "つわもの",
  "つわり",
  "てあし",
  "てあて",
  "てあみ",
  "ていおん",
  "ていか",
  "ていき",
  "ていけい",
  "ていこく",
  "ていさつ",
  "ていし",
  "ていせい",
  "ていたい",
  "ていど",
  "ていねい",
  "ていひょう",
  "ていへん",
  "ていぼう",
  "てうち",
  "ておくれ",
  "てきとう",
  "てくび",
  "でこぼこ",
  "てさぎょう",
  "てさげ",
  "てすり",
  "てそう",
  "てちがい",
  "てちょう",
  "てつがく",
  "てつづき",
  "でっぱ",
  "てつぼう",
  "てつや",
  "でぬかえ",
  "てぬき",
  "てぬぐい",
  "てのひら",
  "てはい",
  "てぶくろ",
  "てふだ",
  "てほどき",
  "てほん",
  "てまえ",
  "てまきずし",
  "てみじか",
  "てみやげ",
  "てらす",
  "てれび",
  "てわけ",
  "てわたし",
  "でんあつ",
  "てんいん",
  "てんかい",
  "てんき",
  "てんぐ",
  "てんけん",
  "てんごく",
  "てんさい",
  "てんし",
  "てんすう",
  "でんち",
  "てんてき",
  "てんとう",
  "てんない",
  "てんぷら",
  "てんぼうだい",
  "てんめつ",
  "てんらんかい",
  "でんりょく",
  "でんわ",
  "どあい",
  "といれ",
  "どうかん",
  "とうきゅう",
  "どうぐ",
  "とうし",
  "とうむぎ",
  "とおい",
  "とおか",
  "とおく",
  "とおす",
  "とおる",
  "とかい",
  "とかす",
  "ときおり",
  "ときどき",
  "とくい",
  "とくしゅう",
  "とくてん",
  "とくに",
  "とくべつ",
  "とけい",
  "とける",
  "とこや",
  "とさか",
  "としょかん",
  "とそう",
  "とたん",
  "とちゅう",
  "とっきゅう",
  "とっくん",
  "とつぜん",
  "とつにゅう",
  "とどける",
  "ととのえる",
  "とない",
  "となえる",
  "となり",
  "とのさま",
  "とばす",
  "どぶがわ",
  "とほう",
  "とまる",
  "とめる",
  "ともだち",
  "ともる",
  "どようび",
  "とらえる",
  "とんかつ",
  "どんぶり",
  "ないかく",
  "ないこう",
  "ないしょ",
  "ないす",
  "ないせん",
  "ないそう",
  "なおす",
  "ながい",
  "なくす",
  "なげる",
  "なこうど",
  "なさけ",
  "なたでここ",
  "なっとう",
  "なつやすみ",
  "ななおし",
  "なにごと",
  "なにもの",
  "なにわ",
  "なのか",
  "なふだ",
  "なまいき",
  "なまえ",
  "なまみ",
  "なみだ",
  "なめらか",
  "なめる",
  "なやむ",
  "ならう",
  "ならび",
  "ならぶ",
  "なれる",
  "なわとび",
  "なわばり",
  "にあう",
  "にいがた",
  "にうけ",
  "におい",
  "にかい",
  "にがて",
  "にきび",
  "にくしみ",
  "にくまん",
  "にげる",
  "にさんかたんそ",
  "にしき",
  "にせもの",
  "にちじょう",
  "にちようび",
  "にっか",
  "にっき",
  "にっけい",
  "にっこう",
  "にっさん",
  "にっしょく",
  "にっすう",
  "にっせき",
  "にってい",
  "になう",
  "にほん",
  "にまめ",
  "にもつ",
  "にやり",
  "にゅういん",
  "にりんしゃ",
  "にわとり",
  "にんい",
  "にんか",
  "にんき",
  "にんげん",
  "にんしき",
  "にんずう",
  "にんそう",
  "にんたい",
  "にんち",
  "にんてい",
  "にんにく",
  "にんぷ",
  "にんまり",
  "にんむ",
  "にんめい",
  "にんよう",
  "ぬいくぎ",
  "ぬかす",
  "ぬぐいとる",
  "ぬぐう",
  "ぬくもり",
  "ぬすむ",
  "ぬまえび",
  "ぬめり",
  "ぬらす",
  "ぬんちゃく",
  "ねあげ",
  "ねいき",
  "ねいる",
  "ねいろ",
  "ねぐせ",
  "ねくたい",
  "ねくら",
  "ねこぜ",
  "ねこむ",
  "ねさげ",
  "ねすごす",
  "ねそべる",
  "ねだん",
  "ねつい",
  "ねっしん",
  "ねつぞう",
  "ねったいぎょ",
  "ねぶそく",
  "ねふだ",
  "ねぼう",
  "ねほりはほり",
  "ねまき",
  "ねまわし",
  "ねみみ",
  "ねむい",
  "ねむたい",
  "ねもと",
  "ねらう",
  "ねわざ",
  "ねんいり",
  "ねんおし",
  "ねんかん",
  "ねんきん",
  "ねんぐ",
  "ねんざ",
  "ねんし",
  "ねんちゃく",
  "ねんど",
  "ねんぴ",
  "ねんぶつ",
  "ねんまつ",
  "ねんりょう",
  "ねんれい",
  "のいず",
  "のおづま",
  "のがす",
  "のきなみ",
  "のこぎり",
  "のこす",
  "のこる",
  "のせる",
  "のぞく",
  "のぞむ",
  "のたまう",
  "のちほど",
  "のっく",
  "のばす",
  "のはら",
  "のべる",
  "のぼる",
  "のみもの",
  "のやま",
  "のらいぬ",
  "のらねこ",
  "のりもの",
  "のりゆき",
  "のれん",
  "のんき",
  "ばあい",
  "はあく",
  "ばあさん",
  "ばいか",
  "ばいく",
  "はいけん",
  "はいご",
  "はいしん",
  "はいすい",
  "はいせん",
  "はいそう",
  "はいち",
  "ばいばい",
  "はいれつ",
  "はえる",
  "はおる",
  "はかい",
  "ばかり",
  "はかる",
  "はくしゅ",
  "はけん",
  "はこぶ",
  "はさみ",
  "はさん",
  "はしご",
  "ばしょ",
  "はしる",
  "はせる",
  "ぱそこん",
  "はそん",
  "はたん",
  "はちみつ",
  "はつおん",
  "はっかく",
  "はづき",
  "はっきり",
  "はっくつ",
  "はっけん",
  "はっこう",
  "はっさん",
  "はっしん",
  "はったつ",
  "はっちゅう",
  "はってん",
  "はっぴょう",
  "はっぽう",
  "はなす",
  "はなび",
  "はにかむ",
  "はぶらし",
  "はみがき",
  "はむかう",
  "はめつ",
  "はやい",
  "はやし",
  "はらう",
  "はろうぃん",
  "はわい",
  "はんい",
  "はんえい",
  "はんおん",
  "はんかく",
  "はんきょう",
  "ばんぐみ",
  "はんこ",
  "はんしゃ",
  "はんすう",
  "はんだん",
  "ぱんち",
  "ぱんつ",
  "はんてい",
  "はんとし",
  "はんのう",
  "はんぱ",
  "はんぶん",
  "はんぺん",
  "はんぼうき",
  "はんめい",
  "はんらん",
  "はんろん",
  "ひいき",
  "ひうん",
  "ひえる",
  "ひかく",
  "ひかり",
  "ひかる",
  "ひかん",
  "ひくい",
  "ひけつ",
  "ひこうき",
  "ひこく",
  "ひさい",
  "ひさしぶり",
  "ひさん",
  "びじゅつかん",
  "ひしょ",
  "ひそか",
  "ひそむ",
  "ひたむき",
  "ひだり",
  "ひたる",
  "ひつぎ",
  "ひっこし",
  "ひっし",
  "ひつじゅひん",
  "ひっす",
  "ひつぜん",
  "ぴったり",
  "ぴっちり",
  "ひつよう",
  "ひてい",
  "ひとごみ",
  "ひなまつり",
  "ひなん",
  "ひねる",
  "ひはん",
  "ひびく",
  "ひひょう",
  "ひほう",
  "ひまわり",
  "ひまん",
  "ひみつ",
  "ひめい",
  "ひめじし",
  "ひやけ",
  "ひやす",
  "ひよう",
  "びょうき",
  "ひらがな",
  "ひらく",
  "ひりつ",
  "ひりょう",
  "ひるま",
  "ひるやすみ",
  "ひれい",
  "ひろい",
  "ひろう",
  "ひろき",
  "ひろゆき",
  "ひんかく",
  "ひんけつ",
  "ひんこん",
  "ひんしゅ",
  "ひんそう",
  "ぴんち",
  "ひんぱん",
  "びんぼう",
  "ふあん",
  "ふいうち",
  "ふうけい",
  "ふうせん",
  "ぷうたろう",
  "ふうとう",
  "ふうふ",
  "ふえる",
  "ふおん",
  "ふかい",
  "ふきん",
  "ふくざつ",
  "ふくぶくろ",
  "ふこう",
  "ふさい",
  "ふしぎ",
  "ふじみ",
  "ふすま",
  "ふせい",
  "ふせぐ",
  "ふそく",
  "ぶたにく",
  "ふたん",
  "ふちょう",
  "ふつう",
  "ふつか",
  "ふっかつ",
  "ふっき",
  "ふっこく",
  "ぶどう",
  "ふとる",
  "ふとん",
  "ふのう",
  "ふはい",
  "ふひょう",
  "ふへん",
  "ふまん",
  "ふみん",
  "ふめつ",
  "ふめん",
  "ふよう",
  "ふりこ",
  "ふりる",
  "ふるい",
  "ふんいき",
  "ぶんがく",
  "ぶんぐ",
  "ふんしつ",
  "ぶんせき",
  "ふんそう",
  "ぶんぽう",
  "へいあん",
  "へいおん",
  "へいがい",
  "へいき",
  "へいげん",
  "へいこう",
  "へいさ",
  "へいしゃ",
  "へいせつ",
  "へいそ",
  "へいたく",
  "へいてん",
  "へいねつ",
  "へいわ",
  "へきが",
  "へこむ",
  "べにいろ",
  "べにしょうが",
  "へらす",
  "へんかん",
  "べんきょう",
  "べんごし",
  "へんさい",
  "へんたい",
  "べんり",
  "ほあん",
  "ほいく",
  "ぼうぎょ",
  "ほうこく",
  "ほうそう",
  "ほうほう",
  "ほうもん",
  "ほうりつ",
  "ほえる",
  "ほおん",
  "ほかん",
  "ほきょう",
  "ぼきん",
  "ほくろ",
  "ほけつ",
  "ほけん",
  "ほこう",
  "ほこる",
  "ほしい",
  "ほしつ",
  "ほしゅ",
  "ほしょう",
  "ほせい",
  "ほそい",
  "ほそく",
  "ほたて",
  "ほたる",
  "ぽちぶくろ",
  "ほっきょく",
  "ほっさ",
  "ほったん",
  "ほとんど",
  "ほめる",
  "ほんい",
  "ほんき",
  "ほんけ",
  "ほんしつ",
  "ほんやく",
  "まいにち",
  "まかい",
  "まかせる",
  "まがる",
  "まける",
  "まこと",
  "まさつ",
  "まじめ",
  "ますく",
  "まぜる",
  "まつり",
  "まとめ",
  "まなぶ",
  "まぬけ",
  "まねく",
  "まほう",
  "まもる",
  "まゆげ",
  "まよう",
  "まろやか",
  "まわす",
  "まわり",
  "まわる",
  "まんが",
  "まんきつ",
  "まんぞく",
  "まんなか",
  "みいら",
  "みうち",
  "みえる",
  "みがく",
  "みかた",
  "みかん",
  "みけん",
  "みこん",
  "みじかい",
  "みすい",
  "みすえる",
  "みせる",
  "みっか",
  "みつかる",
  "みつける",
  "みてい",
  "みとめる",
  "みなと",
  "みなみかさい",
  "みねらる",
  "みのう",
  "みのがす",
  "みほん",
  "みもと",
  "みやげ",
  "みらい",
  "みりょく",
  "みわく",
  "みんか",
  "みんぞく",
  "むいか",
  "むえき",
  "むえん",
  "むかい",
  "むかう",
  "むかえ",
  "むかし",
  "むぎちゃ",
  "むける",
  "むげん",
  "むさぼる",
  "むしあつい",
  "むしば",
  "むじゅん",
  "むしろ",
  "むすう",
  "むすこ",
  "むすぶ",
  "むすめ",
  "むせる",
  "むせん",
  "むちゅう",
  "むなしい",
  "むのう",
  "むやみ",
  "むよう",
  "むらさき",
  "むりょう",
  "むろん",
  "めいあん",
  "めいうん",
  "めいえん",
  "めいかく",
  "めいきょく",
  "めいさい",
  "めいし",
  "めいそう",
  "めいぶつ",
  "めいれい",
  "めいわく",
  "めぐまれる",
  "めざす",
  "めした",
  "めずらしい",
  "めだつ",
  "めまい",
  "めやす",
  "めんきょ",
  "めんせき",
  "めんどう",
  "もうしあげる",
  "もうどうけん",
  "もえる",
  "もくし",
  "もくてき",
  "もくようび",
  "もちろん",
  "もどる",
  "もらう",
  "もんく",
  "もんだい",
  "やおや",
  "やける",
  "やさい",
  "やさしい",
  "やすい",
  "やすたろう",
  "やすみ",
  "やせる",
  "やそう",
  "やたい",
  "やちん",
  "やっと",
  "やっぱり",
  "やぶる",
  "やめる",
  "ややこしい",
  "やよい",
  "やわらかい",
  "ゆうき",
  "ゆうびんきょく",
  "ゆうべ",
  "ゆうめい",
  "ゆけつ",
  "ゆしゅつ",
  "ゆせん",
  "ゆそう",
  "ゆたか",
  "ゆちゃく",
  "ゆでる",
  "ゆにゅう",
  "ゆびわ",
  "ゆらい",
  "ゆれる",
  "ようい",
  "ようか",
  "ようきゅう",
  "ようじ",
  "ようす",
  "ようちえん",
  "よかぜ",
  "よかん",
  "よきん",
  "よくせい",
  "よくぼう",
  "よけい",
  "よごれる",
  "よさん",
  "よしゅう",
  "よそう",
  "よそく",
  "よっか",
  "よてい",
  "よどがわく",
  "よねつ",
  "よやく",
  "よゆう",
  "よろこぶ",
  "よろしい",
  "らいう",
  "らくがき",
  "らくご",
  "らくさつ",
  "らくだ",
  "らしんばん",
  "らせん",
  "らぞく",
  "らたい",
  "らっか",
  "られつ",
  "りえき",
  "りかい",
  "りきさく",
  "りきせつ",
  "りくぐん",
  "りくつ",
  "りけん",
  "りこう",
  "りせい",
  "りそう",
  "りそく",
  "りてん",
  "りねん",
  "りゆう",
  "りゅうがく",
  "りよう",
  "りょうり",
  "りょかん",
  "りょくちゃ",
  "りょこう",
  "りりく",
  "りれき",
  "りろん",
  "りんご",
  "るいけい",
  "るいさい",
  "るいじ",
  "るいせき",
  "るすばん",
  "るりがわら",
  "れいかん",
  "れいぎ",
  "れいせい",
  "れいぞうこ",
  "れいとう",
  "れいぼう",
  "れきし",
  "れきだい",
  "れんあい",
  "れんけい",
  "れんこん",
  "れんさい",
  "れんしゅう",
  "れんぞく",
  "れんらく",
  "ろうか",
  "ろうご",
  "ろうじん",
  "ろうそく",
  "ろくが",
  "ろこつ",
  "ろじうら",
  "ろしゅつ",
  "ろせん",
  "ろてん",
  "ろめん",
  "ろれつ",
  "ろんぎ",
  "ろんぱ",
  "ろんぶん",
  "ろんり",
  "わかす",
  "わかめ",
  "わかやま",
  "わかれる",
  "わしつ",
  "わじまし",
  "わすれもの",
  "わらう",
  "われる"
], bOe = [
  "abacate",
  "abaixo",
  "abalar",
  "abater",
  "abduzir",
  "abelha",
  "aberto",
  "abismo",
  "abotoar",
  "abranger",
  "abreviar",
  "abrigar",
  "abrupto",
  "absinto",
  "absoluto",
  "absurdo",
  "abutre",
  "acabado",
  "acalmar",
  "acampar",
  "acanhar",
  "acaso",
  "aceitar",
  "acelerar",
  "acenar",
  "acervo",
  "acessar",
  "acetona",
  "achatar",
  "acidez",
  "acima",
  "acionado",
  "acirrar",
  "aclamar",
  "aclive",
  "acolhida",
  "acomodar",
  "acoplar",
  "acordar",
  "acumular",
  "acusador",
  "adaptar",
  "adega",
  "adentro",
  "adepto",
  "adequar",
  "aderente",
  "adesivo",
  "adeus",
  "adiante",
  "aditivo",
  "adjetivo",
  "adjunto",
  "admirar",
  "adorar",
  "adquirir",
  "adubo",
  "adverso",
  "advogado",
  "aeronave",
  "afastar",
  "aferir",
  "afetivo",
  "afinador",
  "afivelar",
  "aflito",
  "afluente",
  "afrontar",
  "agachar",
  "agarrar",
  "agasalho",
  "agenciar",
  "agilizar",
  "agiota",
  "agitado",
  "agora",
  "agradar",
  "agreste",
  "agrupar",
  "aguardar",
  "agulha",
  "ajoelhar",
  "ajudar",
  "ajustar",
  "alameda",
  "alarme",
  "alastrar",
  "alavanca",
  "albergue",
  "albino",
  "alcatra",
  "aldeia",
  "alecrim",
  "alegria",
  "alertar",
  "alface",
  "alfinete",
  "algum",
  "alheio",
  "aliar",
  "alicate",
  "alienar",
  "alinhar",
  "aliviar",
  "almofada",
  "alocar",
  "alpiste",
  "alterar",
  "altitude",
  "alucinar",
  "alugar",
  "aluno",
  "alusivo",
  "alvo",
  "amaciar",
  "amador",
  "amarelo",
  "amassar",
  "ambas",
  "ambiente",
  "ameixa",
  "amenizar",
  "amido",
  "amistoso",
  "amizade",
  "amolador",
  "amontoar",
  "amoroso",
  "amostra",
  "amparar",
  "ampliar",
  "ampola",
  "anagrama",
  "analisar",
  "anarquia",
  "anatomia",
  "andaime",
  "anel",
  "anexo",
  "angular",
  "animar",
  "anjo",
  "anomalia",
  "anotado",
  "ansioso",
  "anterior",
  "anuidade",
  "anunciar",
  "anzol",
  "apagador",
  "apalpar",
  "apanhado",
  "apego",
  "apelido",
  "apertada",
  "apesar",
  "apetite",
  "apito",
  "aplauso",
  "aplicada",
  "apoio",
  "apontar",
  "aposta",
  "aprendiz",
  "aprovar",
  "aquecer",
  "arame",
  "aranha",
  "arara",
  "arcada",
  "ardente",
  "areia",
  "arejar",
  "arenito",
  "aresta",
  "argiloso",
  "argola",
  "arma",
  "arquivo",
  "arraial",
  "arrebate",
  "arriscar",
  "arroba",
  "arrumar",
  "arsenal",
  "arterial",
  "artigo",
  "arvoredo",
  "asfaltar",
  "asilado",
  "aspirar",
  "assador",
  "assinar",
  "assoalho",
  "assunto",
  "astral",
  "atacado",
  "atadura",
  "atalho",
  "atarefar",
  "atear",
  "atender",
  "aterro",
  "ateu",
  "atingir",
  "atirador",
  "ativo",
  "atoleiro",
  "atracar",
  "atrevido",
  "atriz",
  "atual",
  "atum",
  "auditor",
  "aumentar",
  "aura",
  "aurora",
  "autismo",
  "autoria",
  "autuar",
  "avaliar",
  "avante",
  "avaria",
  "avental",
  "avesso",
  "aviador",
  "avisar",
  "avulso",
  "axila",
  "azarar",
  "azedo",
  "azeite",
  "azulejo",
  "babar",
  "babosa",
  "bacalhau",
  "bacharel",
  "bacia",
  "bagagem",
  "baiano",
  "bailar",
  "baioneta",
  "bairro",
  "baixista",
  "bajular",
  "baleia",
  "baliza",
  "balsa",
  "banal",
  "bandeira",
  "banho",
  "banir",
  "banquete",
  "barato",
  "barbado",
  "baronesa",
  "barraca",
  "barulho",
  "baseado",
  "bastante",
  "batata",
  "batedor",
  "batida",
  "batom",
  "batucar",
  "baunilha",
  "beber",
  "beijo",
  "beirada",
  "beisebol",
  "beldade",
  "beleza",
  "belga",
  "beliscar",
  "bendito",
  "bengala",
  "benzer",
  "berimbau",
  "berlinda",
  "berro",
  "besouro",
  "bexiga",
  "bezerro",
  "bico",
  "bicudo",
  "bienal",
  "bifocal",
  "bifurcar",
  "bigorna",
  "bilhete",
  "bimestre",
  "bimotor",
  "biologia",
  "biombo",
  "biosfera",
  "bipolar",
  "birrento",
  "biscoito",
  "bisneto",
  "bispo",
  "bissexto",
  "bitola",
  "bizarro",
  "blindado",
  "bloco",
  "bloquear",
  "boato",
  "bobagem",
  "bocado",
  "bocejo",
  "bochecha",
  "boicotar",
  "bolada",
  "boletim",
  "bolha",
  "bolo",
  "bombeiro",
  "bonde",
  "boneco",
  "bonita",
  "borbulha",
  "borda",
  "boreal",
  "borracha",
  "bovino",
  "boxeador",
  "branco",
  "brasa",
  "braveza",
  "breu",
  "briga",
  "brilho",
  "brincar",
  "broa",
  "brochura",
  "bronzear",
  "broto",
  "bruxo",
  "bucha",
  "budismo",
  "bufar",
  "bule",
  "buraco",
  "busca",
  "busto",
  "buzina",
  "cabana",
  "cabelo",
  "cabide",
  "cabo",
  "cabrito",
  "cacau",
  "cacetada",
  "cachorro",
  "cacique",
  "cadastro",
  "cadeado",
  "cafezal",
  "caiaque",
  "caipira",
  "caixote",
  "cajado",
  "caju",
  "calafrio",
  "calcular",
  "caldeira",
  "calibrar",
  "calmante",
  "calota",
  "camada",
  "cambista",
  "camisa",
  "camomila",
  "campanha",
  "camuflar",
  "canavial",
  "cancelar",
  "caneta",
  "canguru",
  "canhoto",
  "canivete",
  "canoa",
  "cansado",
  "cantar",
  "canudo",
  "capacho",
  "capela",
  "capinar",
  "capotar",
  "capricho",
  "captador",
  "capuz",
  "caracol",
  "carbono",
  "cardeal",
  "careca",
  "carimbar",
  "carneiro",
  "carpete",
  "carreira",
  "cartaz",
  "carvalho",
  "casaco",
  "casca",
  "casebre",
  "castelo",
  "casulo",
  "catarata",
  "cativar",
  "caule",
  "causador",
  "cautelar",
  "cavalo",
  "caverna",
  "cebola",
  "cedilha",
  "cegonha",
  "celebrar",
  "celular",
  "cenoura",
  "censo",
  "centeio",
  "cercar",
  "cerrado",
  "certeiro",
  "cerveja",
  "cetim",
  "cevada",
  "chacota",
  "chaleira",
  "chamado",
  "chapada",
  "charme",
  "chatice",
  "chave",
  "chefe",
  "chegada",
  "cheiro",
  "cheque",
  "chicote",
  "chifre",
  "chinelo",
  "chocalho",
  "chover",
  "chumbo",
  "chutar",
  "chuva",
  "cicatriz",
  "ciclone",
  "cidade",
  "cidreira",
  "ciente",
  "cigana",
  "cimento",
  "cinto",
  "cinza",
  "ciranda",
  "circuito",
  "cirurgia",
  "citar",
  "clareza",
  "clero",
  "clicar",
  "clone",
  "clube",
  "coado",
  "coagir",
  "cobaia",
  "cobertor",
  "cobrar",
  "cocada",
  "coelho",
  "coentro",
  "coeso",
  "cogumelo",
  "coibir",
  "coifa",
  "coiote",
  "colar",
  "coleira",
  "colher",
  "colidir",
  "colmeia",
  "colono",
  "coluna",
  "comando",
  "combinar",
  "comentar",
  "comitiva",
  "comover",
  "complexo",
  "comum",
  "concha",
  "condor",
  "conectar",
  "confuso",
  "congelar",
  "conhecer",
  "conjugar",
  "consumir",
  "contrato",
  "convite",
  "cooperar",
  "copeiro",
  "copiador",
  "copo",
  "coquetel",
  "coragem",
  "cordial",
  "corneta",
  "coronha",
  "corporal",
  "correio",
  "cortejo",
  "coruja",
  "corvo",
  "cosseno",
  "costela",
  "cotonete",
  "couro",
  "couve",
  "covil",
  "cozinha",
  "cratera",
  "cravo",
  "creche",
  "credor",
  "creme",
  "crer",
  "crespo",
  "criada",
  "criminal",
  "crioulo",
  "crise",
  "criticar",
  "crosta",
  "crua",
  "cruzeiro",
  "cubano",
  "cueca",
  "cuidado",
  "cujo",
  "culatra",
  "culminar",
  "culpar",
  "cultura",
  "cumprir",
  "cunhado",
  "cupido",
  "curativo",
  "curral",
  "cursar",
  "curto",
  "cuspir",
  "custear",
  "cutelo",
  "damasco",
  "datar",
  "debater",
  "debitar",
  "deboche",
  "debulhar",
  "decalque",
  "decimal",
  "declive",
  "decote",
  "decretar",
  "dedal",
  "dedicado",
  "deduzir",
  "defesa",
  "defumar",
  "degelo",
  "degrau",
  "degustar",
  "deitado",
  "deixar",
  "delator",
  "delegado",
  "delinear",
  "delonga",
  "demanda",
  "demitir",
  "demolido",
  "dentista",
  "depenado",
  "depilar",
  "depois",
  "depressa",
  "depurar",
  "deriva",
  "derramar",
  "desafio",
  "desbotar",
  "descanso",
  "desenho",
  "desfiado",
  "desgaste",
  "desigual",
  "deslize",
  "desmamar",
  "desova",
  "despesa",
  "destaque",
  "desviar",
  "detalhar",
  "detentor",
  "detonar",
  "detrito",
  "deusa",
  "dever",
  "devido",
  "devotado",
  "dezena",
  "diagrama",
  "dialeto",
  "didata",
  "difuso",
  "digitar",
  "dilatado",
  "diluente",
  "diminuir",
  "dinastia",
  "dinheiro",
  "diocese",
  "direto",
  "discreta",
  "disfarce",
  "disparo",
  "disquete",
  "dissipar",
  "distante",
  "ditador",
  "diurno",
  "diverso",
  "divisor",
  "divulgar",
  "dizer",
  "dobrador",
  "dolorido",
  "domador",
  "dominado",
  "donativo",
  "donzela",
  "dormente",
  "dorsal",
  "dosagem",
  "dourado",
  "doutor",
  "drenagem",
  "drible",
  "drogaria",
  "duelar",
  "duende",
  "dueto",
  "duplo",
  "duquesa",
  "durante",
  "duvidoso",
  "eclodir",
  "ecoar",
  "ecologia",
  "edificar",
  "edital",
  "educado",
  "efeito",
  "efetivar",
  "ejetar",
  "elaborar",
  "eleger",
  "eleitor",
  "elenco",
  "elevador",
  "eliminar",
  "elogiar",
  "embargo",
  "embolado",
  "embrulho",
  "embutido",
  "emenda",
  "emergir",
  "emissor",
  "empatia",
  "empenho",
  "empinado",
  "empolgar",
  "emprego",
  "empurrar",
  "emulador",
  "encaixe",
  "encenado",
  "enchente",
  "encontro",
  "endeusar",
  "endossar",
  "enfaixar",
  "enfeite",
  "enfim",
  "engajado",
  "engenho",
  "englobar",
  "engomado",
  "engraxar",
  "enguia",
  "enjoar",
  "enlatar",
  "enquanto",
  "enraizar",
  "enrolado",
  "enrugar",
  "ensaio",
  "enseada",
  "ensino",
  "ensopado",
  "entanto",
  "enteado",
  "entidade",
  "entortar",
  "entrada",
  "entulho",
  "envergar",
  "enviado",
  "envolver",
  "enxame",
  "enxerto",
  "enxofre",
  "enxuto",
  "epiderme",
  "equipar",
  "ereto",
  "erguido",
  "errata",
  "erva",
  "ervilha",
  "esbanjar",
  "esbelto",
  "escama",
  "escola",
  "escrita",
  "escuta",
  "esfinge",
  "esfolar",
  "esfregar",
  "esfumado",
  "esgrima",
  "esmalte",
  "espanto",
  "espelho",
  "espiga",
  "esponja",
  "espreita",
  "espumar",
  "esquerda",
  "estaca",
  "esteira",
  "esticar",
  "estofado",
  "estrela",
  "estudo",
  "esvaziar",
  "etanol",
  "etiqueta",
  "euforia",
  "europeu",
  "evacuar",
  "evaporar",
  "evasivo",
  "eventual",
  "evidente",
  "evoluir",
  "exagero",
  "exalar",
  "examinar",
  "exato",
  "exausto",
  "excesso",
  "excitar",
  "exclamar",
  "executar",
  "exemplo",
  "exibir",
  "exigente",
  "exonerar",
  "expandir",
  "expelir",
  "expirar",
  "explanar",
  "exposto",
  "expresso",
  "expulsar",
  "externo",
  "extinto",
  "extrato",
  "fabricar",
  "fabuloso",
  "faceta",
  "facial",
  "fada",
  "fadiga",
  "faixa",
  "falar",
  "falta",
  "familiar",
  "fandango",
  "fanfarra",
  "fantoche",
  "fardado",
  "farelo",
  "farinha",
  "farofa",
  "farpa",
  "fartura",
  "fatia",
  "fator",
  "favorita",
  "faxina",
  "fazenda",
  "fechado",
  "feijoada",
  "feirante",
  "felino",
  "feminino",
  "fenda",
  "feno",
  "fera",
  "feriado",
  "ferrugem",
  "ferver",
  "festejar",
  "fetal",
  "feudal",
  "fiapo",
  "fibrose",
  "ficar",
  "ficheiro",
  "figurado",
  "fileira",
  "filho",
  "filme",
  "filtrar",
  "firmeza",
  "fisgada",
  "fissura",
  "fita",
  "fivela",
  "fixador",
  "fixo",
  "flacidez",
  "flamingo",
  "flanela",
  "flechada",
  "flora",
  "flutuar",
  "fluxo",
  "focal",
  "focinho",
  "fofocar",
  "fogo",
  "foguete",
  "foice",
  "folgado",
  "folheto",
  "forjar",
  "formiga",
  "forno",
  "forte",
  "fosco",
  "fossa",
  "fragata",
  "fralda",
  "frango",
  "frasco",
  "fraterno",
  "freira",
  "frente",
  "fretar",
  "frieza",
  "friso",
  "fritura",
  "fronha",
  "frustrar",
  "fruteira",
  "fugir",
  "fulano",
  "fuligem",
  "fundar",
  "fungo",
  "funil",
  "furador",
  "furioso",
  "futebol",
  "gabarito",
  "gabinete",
  "gado",
  "gaiato",
  "gaiola",
  "gaivota",
  "galega",
  "galho",
  "galinha",
  "galocha",
  "ganhar",
  "garagem",
  "garfo",
  "gargalo",
  "garimpo",
  "garoupa",
  "garrafa",
  "gasoduto",
  "gasto",
  "gata",
  "gatilho",
  "gaveta",
  "gazela",
  "gelado",
  "geleia",
  "gelo",
  "gemada",
  "gemer",
  "gemido",
  "generoso",
  "gengiva",
  "genial",
  "genoma",
  "genro",
  "geologia",
  "gerador",
  "germinar",
  "gesso",
  "gestor",
  "ginasta",
  "gincana",
  "gingado",
  "girafa",
  "girino",
  "glacial",
  "glicose",
  "global",
  "glorioso",
  "goela",
  "goiaba",
  "golfe",
  "golpear",
  "gordura",
  "gorjeta",
  "gorro",
  "gostoso",
  "goteira",
  "governar",
  "gracejo",
  "gradual",
  "grafite",
  "gralha",
  "grampo",
  "granada",
  "gratuito",
  "graveto",
  "graxa",
  "grego",
  "grelhar",
  "greve",
  "grilo",
  "grisalho",
  "gritaria",
  "grosso",
  "grotesco",
  "grudado",
  "grunhido",
  "gruta",
  "guache",
  "guarani",
  "guaxinim",
  "guerrear",
  "guiar",
  "guincho",
  "guisado",
  "gula",
  "guloso",
  "guru",
  "habitar",
  "harmonia",
  "haste",
  "haver",
  "hectare",
  "herdar",
  "heresia",
  "hesitar",
  "hiato",
  "hibernar",
  "hidratar",
  "hiena",
  "hino",
  "hipismo",
  "hipnose",
  "hipoteca",
  "hoje",
  "holofote",
  "homem",
  "honesto",
  "honrado",
  "hormonal",
  "hospedar",
  "humorado",
  "iate",
  "ideia",
  "idoso",
  "ignorado",
  "igreja",
  "iguana",
  "ileso",
  "ilha",
  "iludido",
  "iluminar",
  "ilustrar",
  "imagem",
  "imediato",
  "imenso",
  "imersivo",
  "iminente",
  "imitador",
  "imortal",
  "impacto",
  "impedir",
  "implante",
  "impor",
  "imprensa",
  "impune",
  "imunizar",
  "inalador",
  "inapto",
  "inativo",
  "incenso",
  "inchar",
  "incidir",
  "incluir",
  "incolor",
  "indeciso",
  "indireto",
  "indutor",
  "ineficaz",
  "inerente",
  "infantil",
  "infestar",
  "infinito",
  "inflamar",
  "informal",
  "infrator",
  "ingerir",
  "inibido",
  "inicial",
  "inimigo",
  "injetar",
  "inocente",
  "inodoro",
  "inovador",
  "inox",
  "inquieto",
  "inscrito",
  "inseto",
  "insistir",
  "inspetor",
  "instalar",
  "insulto",
  "intacto",
  "integral",
  "intimar",
  "intocado",
  "intriga",
  "invasor",
  "inverno",
  "invicto",
  "invocar",
  "iogurte",
  "iraniano",
  "ironizar",
  "irreal",
  "irritado",
  "isca",
  "isento",
  "isolado",
  "isqueiro",
  "italiano",
  "janeiro",
  "jangada",
  "janta",
  "jararaca",
  "jardim",
  "jarro",
  "jasmim",
  "jato",
  "javali",
  "jazida",
  "jejum",
  "joaninha",
  "joelhada",
  "jogador",
  "joia",
  "jornal",
  "jorrar",
  "jovem",
  "juba",
  "judeu",
  "judoca",
  "juiz",
  "julgador",
  "julho",
  "jurado",
  "jurista",
  "juro",
  "justa",
  "labareda",
  "laboral",
  "lacre",
  "lactante",
  "ladrilho",
  "lagarta",
  "lagoa",
  "laje",
  "lamber",
  "lamentar",
  "laminar",
  "lampejo",
  "lanche",
  "lapidar",
  "lapso",
  "laranja",
  "lareira",
  "largura",
  "lasanha",
  "lastro",
  "lateral",
  "latido",
  "lavanda",
  "lavoura",
  "lavrador",
  "laxante",
  "lazer",
  "lealdade",
  "lebre",
  "legado",
  "legendar",
  "legista",
  "leigo",
  "leiloar",
  "leitura",
  "lembrete",
  "leme",
  "lenhador",
  "lentilha",
  "leoa",
  "lesma",
  "leste",
  "letivo",
  "letreiro",
  "levar",
  "leveza",
  "levitar",
  "liberal",
  "libido",
  "liderar",
  "ligar",
  "ligeiro",
  "limitar",
  "limoeiro",
  "limpador",
  "linda",
  "linear",
  "linhagem",
  "liquidez",
  "listagem",
  "lisura",
  "litoral",
  "livro",
  "lixa",
  "lixeira",
  "locador",
  "locutor",
  "lojista",
  "lombo",
  "lona",
  "longe",
  "lontra",
  "lorde",
  "lotado",
  "loteria",
  "loucura",
  "lousa",
  "louvar",
  "luar",
  "lucidez",
  "lucro",
  "luneta",
  "lustre",
  "lutador",
  "luva",
  "macaco",
  "macete",
  "machado",
  "macio",
  "madeira",
  "madrinha",
  "magnata",
  "magreza",
  "maior",
  "mais",
  "malandro",
  "malha",
  "malote",
  "maluco",
  "mamilo",
  "mamoeiro",
  "mamute",
  "manada",
  "mancha",
  "mandato",
  "manequim",
  "manhoso",
  "manivela",
  "manobrar",
  "mansa",
  "manter",
  "manusear",
  "mapeado",
  "maquinar",
  "marcador",
  "maresia",
  "marfim",
  "margem",
  "marinho",
  "marmita",
  "maroto",
  "marquise",
  "marreco",
  "martelo",
  "marujo",
  "mascote",
  "masmorra",
  "massagem",
  "mastigar",
  "matagal",
  "materno",
  "matinal",
  "matutar",
  "maxilar",
  "medalha",
  "medida",
  "medusa",
  "megafone",
  "meiga",
  "melancia",
  "melhor",
  "membro",
  "memorial",
  "menino",
  "menos",
  "mensagem",
  "mental",
  "merecer",
  "mergulho",
  "mesada",
  "mesclar",
  "mesmo",
  "mesquita",
  "mestre",
  "metade",
  "meteoro",
  "metragem",
  "mexer",
  "mexicano",
  "micro",
  "migalha",
  "migrar",
  "milagre",
  "milenar",
  "milhar",
  "mimado",
  "minerar",
  "minhoca",
  "ministro",
  "minoria",
  "miolo",
  "mirante",
  "mirtilo",
  "misturar",
  "mocidade",
  "moderno",
  "modular",
  "moeda",
  "moer",
  "moinho",
  "moita",
  "moldura",
  "moleza",
  "molho",
  "molinete",
  "molusco",
  "montanha",
  "moqueca",
  "morango",
  "morcego",
  "mordomo",
  "morena",
  "mosaico",
  "mosquete",
  "mostarda",
  "motel",
  "motim",
  "moto",
  "motriz",
  "muda",
  "muito",
  "mulata",
  "mulher",
  "multar",
  "mundial",
  "munido",
  "muralha",
  "murcho",
  "muscular",
  "museu",
  "musical",
  "nacional",
  "nadador",
  "naja",
  "namoro",
  "narina",
  "narrado",
  "nascer",
  "nativa",
  "natureza",
  "navalha",
  "navegar",
  "navio",
  "neblina",
  "nebuloso",
  "negativa",
  "negociar",
  "negrito",
  "nervoso",
  "neta",
  "neural",
  "nevasca",
  "nevoeiro",
  "ninar",
  "ninho",
  "nitidez",
  "nivelar",
  "nobreza",
  "noite",
  "noiva",
  "nomear",
  "nominal",
  "nordeste",
  "nortear",
  "notar",
  "noticiar",
  "noturno",
  "novelo",
  "novilho",
  "novo",
  "nublado",
  "nudez",
  "numeral",
  "nupcial",
  "nutrir",
  "nuvem",
  "obcecado",
  "obedecer",
  "objetivo",
  "obrigado",
  "obscuro",
  "obstetra",
  "obter",
  "obturar",
  "ocidente",
  "ocioso",
  "ocorrer",
  "oculista",
  "ocupado",
  "ofegante",
  "ofensiva",
  "oferenda",
  "oficina",
  "ofuscado",
  "ogiva",
  "olaria",
  "oleoso",
  "olhar",
  "oliveira",
  "ombro",
  "omelete",
  "omisso",
  "omitir",
  "ondulado",
  "oneroso",
  "ontem",
  "opcional",
  "operador",
  "oponente",
  "oportuno",
  "oposto",
  "orar",
  "orbitar",
  "ordem",
  "ordinal",
  "orfanato",
  "orgasmo",
  "orgulho",
  "oriental",
  "origem",
  "oriundo",
  "orla",
  "ortodoxo",
  "orvalho",
  "oscilar",
  "ossada",
  "osso",
  "ostentar",
  "otimismo",
  "ousadia",
  "outono",
  "outubro",
  "ouvido",
  "ovelha",
  "ovular",
  "oxidar",
  "oxigenar",
  "pacato",
  "paciente",
  "pacote",
  "pactuar",
  "padaria",
  "padrinho",
  "pagar",
  "pagode",
  "painel",
  "pairar",
  "paisagem",
  "palavra",
  "palestra",
  "palheta",
  "palito",
  "palmada",
  "palpitar",
  "pancada",
  "panela",
  "panfleto",
  "panqueca",
  "pantanal",
  "papagaio",
  "papelada",
  "papiro",
  "parafina",
  "parcial",
  "pardal",
  "parede",
  "partida",
  "pasmo",
  "passado",
  "pastel",
  "patamar",
  "patente",
  "patinar",
  "patrono",
  "paulada",
  "pausar",
  "peculiar",
  "pedalar",
  "pedestre",
  "pediatra",
  "pedra",
  "pegada",
  "peitoral",
  "peixe",
  "pele",
  "pelicano",
  "penca",
  "pendurar",
  "peneira",
  "penhasco",
  "pensador",
  "pente",
  "perceber",
  "perfeito",
  "pergunta",
  "perito",
  "permitir",
  "perna",
  "perplexo",
  "persiana",
  "pertence",
  "peruca",
  "pescado",
  "pesquisa",
  "pessoa",
  "petiscar",
  "piada",
  "picado",
  "piedade",
  "pigmento",
  "pilastra",
  "pilhado",
  "pilotar",
  "pimenta",
  "pincel",
  "pinguim",
  "pinha",
  "pinote",
  "pintar",
  "pioneiro",
  "pipoca",
  "piquete",
  "piranha",
  "pires",
  "pirueta",
  "piscar",
  "pistola",
  "pitanga",
  "pivete",
  "planta",
  "plaqueta",
  "platina",
  "plebeu",
  "plumagem",
  "pluvial",
  "pneu",
  "poda",
  "poeira",
  "poetisa",
  "polegada",
  "policiar",
  "poluente",
  "polvilho",
  "pomar",
  "pomba",
  "ponderar",
  "pontaria",
  "populoso",
  "porta",
  "possuir",
  "postal",
  "pote",
  "poupar",
  "pouso",
  "povoar",
  "praia",
  "prancha",
  "prato",
  "praxe",
  "prece",
  "predador",
  "prefeito",
  "premiar",
  "prensar",
  "preparar",
  "presilha",
  "pretexto",
  "prevenir",
  "prezar",
  "primata",
  "princesa",
  "prisma",
  "privado",
  "processo",
  "produto",
  "profeta",
  "proibido",
  "projeto",
  "prometer",
  "propagar",
  "prosa",
  "protetor",
  "provador",
  "publicar",
  "pudim",
  "pular",
  "pulmonar",
  "pulseira",
  "punhal",
  "punir",
  "pupilo",
  "pureza",
  "puxador",
  "quadra",
  "quantia",
  "quarto",
  "quase",
  "quebrar",
  "queda",
  "queijo",
  "quente",
  "querido",
  "quimono",
  "quina",
  "quiosque",
  "rabanada",
  "rabisco",
  "rachar",
  "racionar",
  "radial",
  "raiar",
  "rainha",
  "raio",
  "raiva",
  "rajada",
  "ralado",
  "ramal",
  "ranger",
  "ranhura",
  "rapadura",
  "rapel",
  "rapidez",
  "raposa",
  "raquete",
  "raridade",
  "rasante",
  "rascunho",
  "rasgar",
  "raspador",
  "rasteira",
  "rasurar",
  "ratazana",
  "ratoeira",
  "realeza",
  "reanimar",
  "reaver",
  "rebaixar",
  "rebelde",
  "rebolar",
  "recado",
  "recente",
  "recheio",
  "recibo",
  "recordar",
  "recrutar",
  "recuar",
  "rede",
  "redimir",
  "redonda",
  "reduzida",
  "reenvio",
  "refinar",
  "refletir",
  "refogar",
  "refresco",
  "refugiar",
  "regalia",
  "regime",
  "regra",
  "reinado",
  "reitor",
  "rejeitar",
  "relativo",
  "remador",
  "remendo",
  "remorso",
  "renovado",
  "reparo",
  "repelir",
  "repleto",
  "repolho",
  "represa",
  "repudiar",
  "requerer",
  "resenha",
  "resfriar",
  "resgatar",
  "residir",
  "resolver",
  "respeito",
  "ressaca",
  "restante",
  "resumir",
  "retalho",
  "reter",
  "retirar",
  "retomada",
  "retratar",
  "revelar",
  "revisor",
  "revolta",
  "riacho",
  "rica",
  "rigidez",
  "rigoroso",
  "rimar",
  "ringue",
  "risada",
  "risco",
  "risonho",
  "robalo",
  "rochedo",
  "rodada",
  "rodeio",
  "rodovia",
  "roedor",
  "roleta",
  "romano",
  "roncar",
  "rosado",
  "roseira",
  "rosto",
  "rota",
  "roteiro",
  "rotina",
  "rotular",
  "rouco",
  "roupa",
  "roxo",
  "rubro",
  "rugido",
  "rugoso",
  "ruivo",
  "rumo",
  "rupestre",
  "russo",
  "sabor",
  "saciar",
  "sacola",
  "sacudir",
  "sadio",
  "safira",
  "saga",
  "sagrada",
  "saibro",
  "salada",
  "saleiro",
  "salgado",
  "saliva",
  "salpicar",
  "salsicha",
  "saltar",
  "salvador",
  "sambar",
  "samurai",
  "sanar",
  "sanfona",
  "sangue",
  "sanidade",
  "sapato",
  "sarda",
  "sargento",
  "sarjeta",
  "saturar",
  "saudade",
  "saxofone",
  "sazonal",
  "secar",
  "secular",
  "seda",
  "sedento",
  "sediado",
  "sedoso",
  "sedutor",
  "segmento",
  "segredo",
  "segundo",
  "seiva",
  "seleto",
  "selvagem",
  "semanal",
  "semente",
  "senador",
  "senhor",
  "sensual",
  "sentado",
  "separado",
  "sereia",
  "seringa",
  "serra",
  "servo",
  "setembro",
  "setor",
  "sigilo",
  "silhueta",
  "silicone",
  "simetria",
  "simpatia",
  "simular",
  "sinal",
  "sincero",
  "singular",
  "sinopse",
  "sintonia",
  "sirene",
  "siri",
  "situado",
  "soberano",
  "sobra",
  "socorro",
  "sogro",
  "soja",
  "solda",
  "soletrar",
  "solteiro",
  "sombrio",
  "sonata",
  "sondar",
  "sonegar",
  "sonhador",
  "sono",
  "soprano",
  "soquete",
  "sorrir",
  "sorteio",
  "sossego",
  "sotaque",
  "soterrar",
  "sovado",
  "sozinho",
  "suavizar",
  "subida",
  "submerso",
  "subsolo",
  "subtrair",
  "sucata",
  "sucesso",
  "suco",
  "sudeste",
  "sufixo",
  "sugador",
  "sugerir",
  "sujeito",
  "sulfato",
  "sumir",
  "suor",
  "superior",
  "suplicar",
  "suposto",
  "suprimir",
  "surdina",
  "surfista",
  "surpresa",
  "surreal",
  "surtir",
  "suspiro",
  "sustento",
  "tabela",
  "tablete",
  "tabuada",
  "tacho",
  "tagarela",
  "talher",
  "talo",
  "talvez",
  "tamanho",
  "tamborim",
  "tampa",
  "tangente",
  "tanto",
  "tapar",
  "tapioca",
  "tardio",
  "tarefa",
  "tarja",
  "tarraxa",
  "tatuagem",
  "taurino",
  "taxativo",
  "taxista",
  "teatral",
  "tecer",
  "tecido",
  "teclado",
  "tedioso",
  "teia",
  "teimar",
  "telefone",
  "telhado",
  "tempero",
  "tenente",
  "tensor",
  "tentar",
  "termal",
  "terno",
  "terreno",
  "tese",
  "tesoura",
  "testado",
  "teto",
  "textura",
  "texugo",
  "tiara",
  "tigela",
  "tijolo",
  "timbrar",
  "timidez",
  "tingido",
  "tinteiro",
  "tiragem",
  "titular",
  "toalha",
  "tocha",
  "tolerar",
  "tolice",
  "tomada",
  "tomilho",
  "tonel",
  "tontura",
  "topete",
  "tora",
  "torcido",
  "torneio",
  "torque",
  "torrada",
  "torto",
  "tostar",
  "touca",
  "toupeira",
  "toxina",
  "trabalho",
  "tracejar",
  "tradutor",
  "trafegar",
  "trajeto",
  "trama",
  "trancar",
  "trapo",
  "traseiro",
  "tratador",
  "travar",
  "treino",
  "tremer",
  "trepidar",
  "trevo",
  "triagem",
  "tribo",
  "triciclo",
  "tridente",
  "trilogia",
  "trindade",
  "triplo",
  "triturar",
  "triunfal",
  "trocar",
  "trombeta",
  "trova",
  "trunfo",
  "truque",
  "tubular",
  "tucano",
  "tudo",
  "tulipa",
  "tupi",
  "turbo",
  "turma",
  "turquesa",
  "tutelar",
  "tutorial",
  "uivar",
  "umbigo",
  "unha",
  "unidade",
  "uniforme",
  "urologia",
  "urso",
  "urtiga",
  "urubu",
  "usado",
  "usina",
  "usufruir",
  "vacina",
  "vadiar",
  "vagaroso",
  "vaidoso",
  "vala",
  "valente",
  "validade",
  "valores",
  "vantagem",
  "vaqueiro",
  "varanda",
  "vareta",
  "varrer",
  "vascular",
  "vasilha",
  "vassoura",
  "vazar",
  "vazio",
  "veado",
  "vedar",
  "vegetar",
  "veicular",
  "veleiro",
  "velhice",
  "veludo",
  "vencedor",
  "vendaval",
  "venerar",
  "ventre",
  "verbal",
  "verdade",
  "vereador",
  "vergonha",
  "vermelho",
  "verniz",
  "versar",
  "vertente",
  "vespa",
  "vestido",
  "vetorial",
  "viaduto",
  "viagem",
  "viajar",
  "viatura",
  "vibrador",
  "videira",
  "vidraria",
  "viela",
  "viga",
  "vigente",
  "vigiar",
  "vigorar",
  "vilarejo",
  "vinco",
  "vinheta",
  "vinil",
  "violeta",
  "virada",
  "virtude",
  "visitar",
  "visto",
  "vitral",
  "viveiro",
  "vizinho",
  "voador",
  "voar",
  "vogal",
  "volante",
  "voleibol",
  "voltagem",
  "volumoso",
  "vontade",
  "vulto",
  "vuvuzela",
  "xadrez",
  "xarope",
  "xeque",
  "xeretar",
  "xerife",
  "xingar",
  "zangado",
  "zarpar",
  "zebu",
  "zelador",
  "zombar",
  "zoologia",
  "zumbido"
], wOe = [
  "abandon",
  "ability",
  "able",
  "about",
  "above",
  "absent",
  "absorb",
  "abstract",
  "absurd",
  "abuse",
  "access",
  "accident",
  "account",
  "accuse",
  "achieve",
  "acid",
  "acoustic",
  "acquire",
  "across",
  "act",
  "action",
  "actor",
  "actress",
  "actual",
  "adapt",
  "add",
  "addict",
  "address",
  "adjust",
  "admit",
  "adult",
  "advance",
  "advice",
  "aerobic",
  "affair",
  "afford",
  "afraid",
  "again",
  "age",
  "agent",
  "agree",
  "ahead",
  "aim",
  "air",
  "airport",
  "aisle",
  "alarm",
  "album",
  "alcohol",
  "alert",
  "alien",
  "all",
  "alley",
  "allow",
  "almost",
  "alone",
  "alpha",
  "already",
  "also",
  "alter",
  "always",
  "amateur",
  "amazing",
  "among",
  "amount",
  "amused",
  "analyst",
  "anchor",
  "ancient",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "announce",
  "annual",
  "another",
  "answer",
  "antenna",
  "antique",
  "anxiety",
  "any",
  "apart",
  "apology",
  "appear",
  "apple",
  "approve",
  "april",
  "arch",
  "arctic",
  "area",
  "arena",
  "argue",
  "arm",
  "armed",
  "armor",
  "army",
  "around",
  "arrange",
  "arrest",
  "arrive",
  "arrow",
  "art",
  "artefact",
  "artist",
  "artwork",
  "ask",
  "aspect",
  "assault",
  "asset",
  "assist",
  "assume",
  "asthma",
  "athlete",
  "atom",
  "attack",
  "attend",
  "attitude",
  "attract",
  "auction",
  "audit",
  "august",
  "aunt",
  "author",
  "auto",
  "autumn",
  "average",
  "avocado",
  "avoid",
  "awake",
  "aware",
  "away",
  "awesome",
  "awful",
  "awkward",
  "axis",
  "baby",
  "bachelor",
  "bacon",
  "badge",
  "bag",
  "balance",
  "balcony",
  "ball",
  "bamboo",
  "banana",
  "banner",
  "bar",
  "barely",
  "bargain",
  "barrel",
  "base",
  "basic",
  "basket",
  "battle",
  "beach",
  "bean",
  "beauty",
  "because",
  "become",
  "beef",
  "before",
  "begin",
  "behave",
  "behind",
  "believe",
  "below",
  "belt",
  "bench",
  "benefit",
  "best",
  "betray",
  "better",
  "between",
  "beyond",
  "bicycle",
  "bid",
  "bike",
  "bind",
  "biology",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blame",
  "blanket",
  "blast",
  "bleak",
  "bless",
  "blind",
  "blood",
  "blossom",
  "blouse",
  "blue",
  "blur",
  "blush",
  "board",
  "boat",
  "body",
  "boil",
  "bomb",
  "bone",
  "bonus",
  "book",
  "boost",
  "border",
  "boring",
  "borrow",
  "boss",
  "bottom",
  "bounce",
  "box",
  "boy",
  "bracket",
  "brain",
  "brand",
  "brass",
  "brave",
  "bread",
  "breeze",
  "brick",
  "bridge",
  "brief",
  "bright",
  "bring",
  "brisk",
  "broccoli",
  "broken",
  "bronze",
  "broom",
  "brother",
  "brown",
  "brush",
  "bubble",
  "buddy",
  "budget",
  "buffalo",
  "build",
  "bulb",
  "bulk",
  "bullet",
  "bundle",
  "bunker",
  "burden",
  "burger",
  "burst",
  "bus",
  "business",
  "busy",
  "butter",
  "buyer",
  "buzz",
  "cabbage",
  "cabin",
  "cable",
  "cactus",
  "cage",
  "cake",
  "call",
  "calm",
  "camera",
  "camp",
  "can",
  "canal",
  "cancel",
  "candy",
  "cannon",
  "canoe",
  "canvas",
  "canyon",
  "capable",
  "capital",
  "captain",
  "car",
  "carbon",
  "card",
  "cargo",
  "carpet",
  "carry",
  "cart",
  "case",
  "cash",
  "casino",
  "castle",
  "casual",
  "cat",
  "catalog",
  "catch",
  "category",
  "cattle",
  "caught",
  "cause",
  "caution",
  "cave",
  "ceiling",
  "celery",
  "cement",
  "census",
  "century",
  "cereal",
  "certain",
  "chair",
  "chalk",
  "champion",
  "change",
  "chaos",
  "chapter",
  "charge",
  "chase",
  "chat",
  "cheap",
  "check",
  "cheese",
  "chef",
  "cherry",
  "chest",
  "chicken",
  "chief",
  "child",
  "chimney",
  "choice",
  "choose",
  "chronic",
  "chuckle",
  "chunk",
  "churn",
  "cigar",
  "cinnamon",
  "circle",
  "citizen",
  "city",
  "civil",
  "claim",
  "clap",
  "clarify",
  "claw",
  "clay",
  "clean",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climb",
  "clinic",
  "clip",
  "clock",
  "clog",
  "close",
  "cloth",
  "cloud",
  "clown",
  "club",
  "clump",
  "cluster",
  "clutch",
  "coach",
  "coast",
  "coconut",
  "code",
  "coffee",
  "coil",
  "coin",
  "collect",
  "color",
  "column",
  "combine",
  "come",
  "comfort",
  "comic",
  "common",
  "company",
  "concert",
  "conduct",
  "confirm",
  "congress",
  "connect",
  "consider",
  "control",
  "convince",
  "cook",
  "cool",
  "copper",
  "copy",
  "coral",
  "core",
  "corn",
  "correct",
  "cost",
  "cotton",
  "couch",
  "country",
  "couple",
  "course",
  "cousin",
  "cover",
  "coyote",
  "crack",
  "cradle",
  "craft",
  "cram",
  "crane",
  "crash",
  "crater",
  "crawl",
  "crazy",
  "cream",
  "credit",
  "creek",
  "crew",
  "cricket",
  "crime",
  "crisp",
  "critic",
  "crop",
  "cross",
  "crouch",
  "crowd",
  "crucial",
  "cruel",
  "cruise",
  "crumble",
  "crunch",
  "crush",
  "cry",
  "crystal",
  "cube",
  "culture",
  "cup",
  "cupboard",
  "curious",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custom",
  "cute",
  "cycle",
  "dad",
  "damage",
  "damp",
  "dance",
  "danger",
  "daring",
  "dash",
  "daughter",
  "dawn",
  "day",
  "deal",
  "debate",
  "debris",
  "decade",
  "december",
  "decide",
  "decline",
  "decorate",
  "decrease",
  "deer",
  "defense",
  "define",
  "defy",
  "degree",
  "delay",
  "deliver",
  "demand",
  "demise",
  "denial",
  "dentist",
  "deny",
  "depart",
  "depend",
  "deposit",
  "depth",
  "deputy",
  "derive",
  "describe",
  "desert",
  "design",
  "desk",
  "despair",
  "destroy",
  "detail",
  "detect",
  "develop",
  "device",
  "devote",
  "diagram",
  "dial",
  "diamond",
  "diary",
  "dice",
  "diesel",
  "diet",
  "differ",
  "digital",
  "dignity",
  "dilemma",
  "dinner",
  "dinosaur",
  "direct",
  "dirt",
  "disagree",
  "discover",
  "disease",
  "dish",
  "dismiss",
  "disorder",
  "display",
  "distance",
  "divert",
  "divide",
  "divorce",
  "dizzy",
  "doctor",
  "document",
  "dog",
  "doll",
  "dolphin",
  "domain",
  "donate",
  "donkey",
  "donor",
  "door",
  "dose",
  "double",
  "dove",
  "draft",
  "dragon",
  "drama",
  "drastic",
  "draw",
  "dream",
  "dress",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "drop",
  "drum",
  "dry",
  "duck",
  "dumb",
  "dune",
  "during",
  "dust",
  "dutch",
  "duty",
  "dwarf",
  "dynamic",
  "eager",
  "eagle",
  "early",
  "earn",
  "earth",
  "easily",
  "east",
  "easy",
  "echo",
  "ecology",
  "economy",
  "edge",
  "edit",
  "educate",
  "effort",
  "egg",
  "eight",
  "either",
  "elbow",
  "elder",
  "electric",
  "elegant",
  "element",
  "elephant",
  "elevator",
  "elite",
  "else",
  "embark",
  "embody",
  "embrace",
  "emerge",
  "emotion",
  "employ",
  "empower",
  "empty",
  "enable",
  "enact",
  "end",
  "endless",
  "endorse",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "enhance",
  "enjoy",
  "enlist",
  "enough",
  "enrich",
  "enroll",
  "ensure",
  "enter",
  "entire",
  "entry",
  "envelope",
  "episode",
  "equal",
  "equip",
  "era",
  "erase",
  "erode",
  "erosion",
  "error",
  "erupt",
  "escape",
  "essay",
  "essence",
  "estate",
  "eternal",
  "ethics",
  "evidence",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "example",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "exercise",
  "exhaust",
  "exhibit",
  "exile",
  "exist",
  "exit",
  "exotic",
  "expand",
  "expect",
  "expire",
  "explain",
  "expose",
  "express",
  "extend",
  "extra",
  "eye",
  "eyebrow",
  "fabric",
  "face",
  "faculty",
  "fade",
  "faint",
  "faith",
  "fall",
  "false",
  "fame",
  "family",
  "famous",
  "fan",
  "fancy",
  "fantasy",
  "farm",
  "fashion",
  "fat",
  "fatal",
  "father",
  "fatigue",
  "fault",
  "favorite",
  "feature",
  "february",
  "federal",
  "fee",
  "feed",
  "feel",
  "female",
  "fence",
  "festival",
  "fetch",
  "fever",
  "few",
  "fiber",
  "fiction",
  "field",
  "figure",
  "file",
  "film",
  "filter",
  "final",
  "find",
  "fine",
  "finger",
  "finish",
  "fire",
  "firm",
  "first",
  "fiscal",
  "fish",
  "fit",
  "fitness",
  "fix",
  "flag",
  "flame",
  "flash",
  "flat",
  "flavor",
  "flee",
  "flight",
  "flip",
  "float",
  "flock",
  "floor",
  "flower",
  "fluid",
  "flush",
  "fly",
  "foam",
  "focus",
  "fog",
  "foil",
  "fold",
  "follow",
  "food",
  "foot",
  "force",
  "forest",
  "forget",
  "fork",
  "fortune",
  "forum",
  "forward",
  "fossil",
  "foster",
  "found",
  "fox",
  "fragile",
  "frame",
  "frequent",
  "fresh",
  "friend",
  "fringe",
  "frog",
  "front",
  "frost",
  "frown",
  "frozen",
  "fruit",
  "fuel",
  "fun",
  "funny",
  "furnace",
  "fury",
  "future",
  "gadget",
  "gain",
  "galaxy",
  "gallery",
  "game",
  "gap",
  "garage",
  "garbage",
  "garden",
  "garlic",
  "garment",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaze",
  "general",
  "genius",
  "genre",
  "gentle",
  "genuine",
  "gesture",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "ginger",
  "giraffe",
  "girl",
  "give",
  "glad",
  "glance",
  "glare",
  "glass",
  "glide",
  "glimpse",
  "globe",
  "gloom",
  "glory",
  "glove",
  "glow",
  "glue",
  "goat",
  "goddess",
  "gold",
  "good",
  "goose",
  "gorilla",
  "gospel",
  "gossip",
  "govern",
  "gown",
  "grab",
  "grace",
  "grain",
  "grant",
  "grape",
  "grass",
  "gravity",
  "great",
  "green",
  "grid",
  "grief",
  "grit",
  "grocery",
  "group",
  "grow",
  "grunt",
  "guard",
  "guess",
  "guide",
  "guilt",
  "guitar",
  "gun",
  "gym",
  "habit",
  "hair",
  "half",
  "hammer",
  "hamster",
  "hand",
  "happy",
  "harbor",
  "hard",
  "harsh",
  "harvest",
  "hat",
  "have",
  "hawk",
  "hazard",
  "head",
  "health",
  "heart",
  "heavy",
  "hedgehog",
  "height",
  "hello",
  "helmet",
  "help",
  "hen",
  "hero",
  "hidden",
  "high",
  "hill",
  "hint",
  "hip",
  "hire",
  "history",
  "hobby",
  "hockey",
  "hold",
  "hole",
  "holiday",
  "hollow",
  "home",
  "honey",
  "hood",
  "hope",
  "horn",
  "horror",
  "horse",
  "hospital",
  "host",
  "hotel",
  "hour",
  "hover",
  "hub",
  "huge",
  "human",
  "humble",
  "humor",
  "hundred",
  "hungry",
  "hunt",
  "hurdle",
  "hurry",
  "hurt",
  "husband",
  "hybrid",
  "ice",
  "icon",
  "idea",
  "identify",
  "idle",
  "ignore",
  "ill",
  "illegal",
  "illness",
  "image",
  "imitate",
  "immense",
  "immune",
  "impact",
  "impose",
  "improve",
  "impulse",
  "inch",
  "include",
  "income",
  "increase",
  "index",
  "indicate",
  "indoor",
  "industry",
  "infant",
  "inflict",
  "inform",
  "inhale",
  "inherit",
  "initial",
  "inject",
  "injury",
  "inmate",
  "inner",
  "innocent",
  "input",
  "inquiry",
  "insane",
  "insect",
  "inside",
  "inspire",
  "install",
  "intact",
  "interest",
  "into",
  "invest",
  "invite",
  "involve",
  "iron",
  "island",
  "isolate",
  "issue",
  "item",
  "ivory",
  "jacket",
  "jaguar",
  "jar",
  "jazz",
  "jealous",
  "jeans",
  "jelly",
  "jewel",
  "job",
  "join",
  "joke",
  "journey",
  "joy",
  "judge",
  "juice",
  "jump",
  "jungle",
  "junior",
  "junk",
  "just",
  "kangaroo",
  "keen",
  "keep",
  "ketchup",
  "key",
  "kick",
  "kid",
  "kidney",
  "kind",
  "kingdom",
  "kiss",
  "kit",
  "kitchen",
  "kite",
  "kitten",
  "kiwi",
  "knee",
  "knife",
  "knock",
  "know",
  "lab",
  "label",
  "labor",
  "ladder",
  "lady",
  "lake",
  "lamp",
  "language",
  "laptop",
  "large",
  "later",
  "latin",
  "laugh",
  "laundry",
  "lava",
  "law",
  "lawn",
  "lawsuit",
  "layer",
  "lazy",
  "leader",
  "leaf",
  "learn",
  "leave",
  "lecture",
  "left",
  "leg",
  "legal",
  "legend",
  "leisure",
  "lemon",
  "lend",
  "length",
  "lens",
  "leopard",
  "lesson",
  "letter",
  "level",
  "liar",
  "liberty",
  "library",
  "license",
  "life",
  "lift",
  "light",
  "like",
  "limb",
  "limit",
  "link",
  "lion",
  "liquid",
  "list",
  "little",
  "live",
  "lizard",
  "load",
  "loan",
  "lobster",
  "local",
  "lock",
  "logic",
  "lonely",
  "long",
  "loop",
  "lottery",
  "loud",
  "lounge",
  "love",
  "loyal",
  "lucky",
  "luggage",
  "lumber",
  "lunar",
  "lunch",
  "luxury",
  "lyrics",
  "machine",
  "mad",
  "magic",
  "magnet",
  "maid",
  "mail",
  "main",
  "major",
  "make",
  "mammal",
  "man",
  "manage",
  "mandate",
  "mango",
  "mansion",
  "manual",
  "maple",
  "marble",
  "march",
  "margin",
  "marine",
  "market",
  "marriage",
  "mask",
  "mass",
  "master",
  "match",
  "material",
  "math",
  "matrix",
  "matter",
  "maximum",
  "maze",
  "meadow",
  "mean",
  "measure",
  "meat",
  "mechanic",
  "medal",
  "media",
  "melody",
  "melt",
  "member",
  "memory",
  "mention",
  "menu",
  "mercy",
  "merge",
  "merit",
  "merry",
  "mesh",
  "message",
  "metal",
  "method",
  "middle",
  "midnight",
  "milk",
  "million",
  "mimic",
  "mind",
  "minimum",
  "minor",
  "minute",
  "miracle",
  "mirror",
  "misery",
  "miss",
  "mistake",
  "mix",
  "mixed",
  "mixture",
  "mobile",
  "model",
  "modify",
  "mom",
  "moment",
  "monitor",
  "monkey",
  "monster",
  "month",
  "moon",
  "moral",
  "more",
  "morning",
  "mosquito",
  "mother",
  "motion",
  "motor",
  "mountain",
  "mouse",
  "move",
  "movie",
  "much",
  "muffin",
  "mule",
  "multiply",
  "muscle",
  "museum",
  "mushroom",
  "music",
  "must",
  "mutual",
  "myself",
  "mystery",
  "myth",
  "naive",
  "name",
  "napkin",
  "narrow",
  "nasty",
  "nation",
  "nature",
  "near",
  "neck",
  "need",
  "negative",
  "neglect",
  "neither",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "neutral",
  "never",
  "news",
  "next",
  "nice",
  "night",
  "noble",
  "noise",
  "nominee",
  "noodle",
  "normal",
  "north",
  "nose",
  "notable",
  "note",
  "nothing",
  "notice",
  "novel",
  "now",
  "nuclear",
  "number",
  "nurse",
  "nut",
  "oak",
  "obey",
  "object",
  "oblige",
  "obscure",
  "observe",
  "obtain",
  "obvious",
  "occur",
  "ocean",
  "october",
  "odor",
  "off",
  "offer",
  "office",
  "often",
  "oil",
  "okay",
  "old",
  "olive",
  "olympic",
  "omit",
  "once",
  "one",
  "onion",
  "online",
  "only",
  "open",
  "opera",
  "opinion",
  "oppose",
  "option",
  "orange",
  "orbit",
  "orchard",
  "order",
  "ordinary",
  "organ",
  "orient",
  "original",
  "orphan",
  "ostrich",
  "other",
  "outdoor",
  "outer",
  "output",
  "outside",
  "oval",
  "oven",
  "over",
  "own",
  "owner",
  "oxygen",
  "oyster",
  "ozone",
  "pact",
  "paddle",
  "page",
  "pair",
  "palace",
  "palm",
  "panda",
  "panel",
  "panic",
  "panther",
  "paper",
  "parade",
  "parent",
  "park",
  "parrot",
  "party",
  "pass",
  "patch",
  "path",
  "patient",
  "patrol",
  "pattern",
  "pause",
  "pave",
  "payment",
  "peace",
  "peanut",
  "pear",
  "peasant",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "people",
  "pepper",
  "perfect",
  "permit",
  "person",
  "pet",
  "phone",
  "photo",
  "phrase",
  "physical",
  "piano",
  "picnic",
  "picture",
  "piece",
  "pig",
  "pigeon",
  "pill",
  "pilot",
  "pink",
  "pioneer",
  "pipe",
  "pistol",
  "pitch",
  "pizza",
  "place",
  "planet",
  "plastic",
  "plate",
  "play",
  "please",
  "pledge",
  "pluck",
  "plug",
  "plunge",
  "poem",
  "poet",
  "point",
  "polar",
  "pole",
  "police",
  "pond",
  "pony",
  "pool",
  "popular",
  "portion",
  "position",
  "possible",
  "post",
  "potato",
  "pottery",
  "poverty",
  "powder",
  "power",
  "practice",
  "praise",
  "predict",
  "prefer",
  "prepare",
  "present",
  "pretty",
  "prevent",
  "price",
  "pride",
  "primary",
  "print",
  "priority",
  "prison",
  "private",
  "prize",
  "problem",
  "process",
  "produce",
  "profit",
  "program",
  "project",
  "promote",
  "proof",
  "property",
  "prosper",
  "protect",
  "proud",
  "provide",
  "public",
  "pudding",
  "pull",
  "pulp",
  "pulse",
  "pumpkin",
  "punch",
  "pupil",
  "puppy",
  "purchase",
  "purity",
  "purpose",
  "purse",
  "push",
  "put",
  "puzzle",
  "pyramid",
  "quality",
  "quantum",
  "quarter",
  "question",
  "quick",
  "quit",
  "quiz",
  "quote",
  "rabbit",
  "raccoon",
  "race",
  "rack",
  "radar",
  "radio",
  "rail",
  "rain",
  "raise",
  "rally",
  "ramp",
  "ranch",
  "random",
  "range",
  "rapid",
  "rare",
  "rate",
  "rather",
  "raven",
  "raw",
  "razor",
  "ready",
  "real",
  "reason",
  "rebel",
  "rebuild",
  "recall",
  "receive",
  "recipe",
  "record",
  "recycle",
  "reduce",
  "reflect",
  "reform",
  "refuse",
  "region",
  "regret",
  "regular",
  "reject",
  "relax",
  "release",
  "relief",
  "rely",
  "remain",
  "remember",
  "remind",
  "remove",
  "render",
  "renew",
  "rent",
  "reopen",
  "repair",
  "repeat",
  "replace",
  "report",
  "require",
  "rescue",
  "resemble",
  "resist",
  "resource",
  "response",
  "result",
  "retire",
  "retreat",
  "return",
  "reunion",
  "reveal",
  "review",
  "reward",
  "rhythm",
  "rib",
  "ribbon",
  "rice",
  "rich",
  "ride",
  "ridge",
  "rifle",
  "right",
  "rigid",
  "ring",
  "riot",
  "ripple",
  "risk",
  "ritual",
  "rival",
  "river",
  "road",
  "roast",
  "robot",
  "robust",
  "rocket",
  "romance",
  "roof",
  "rookie",
  "room",
  "rose",
  "rotate",
  "rough",
  "round",
  "route",
  "royal",
  "rubber",
  "rude",
  "rug",
  "rule",
  "run",
  "runway",
  "rural",
  "sad",
  "saddle",
  "sadness",
  "safe",
  "sail",
  "salad",
  "salmon",
  "salon",
  "salt",
  "salute",
  "same",
  "sample",
  "sand",
  "satisfy",
  "satoshi",
  "sauce",
  "sausage",
  "save",
  "say",
  "scale",
  "scan",
  "scare",
  "scatter",
  "scene",
  "scheme",
  "school",
  "science",
  "scissors",
  "scorpion",
  "scout",
  "scrap",
  "screen",
  "script",
  "scrub",
  "sea",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "section",
  "security",
  "seed",
  "seek",
  "segment",
  "select",
  "sell",
  "seminar",
  "senior",
  "sense",
  "sentence",
  "series",
  "service",
  "session",
  "settle",
  "setup",
  "seven",
  "shadow",
  "shaft",
  "shallow",
  "share",
  "shed",
  "shell",
  "sheriff",
  "shield",
  "shift",
  "shine",
  "ship",
  "shiver",
  "shock",
  "shoe",
  "shoot",
  "shop",
  "short",
  "shoulder",
  "shove",
  "shrimp",
  "shrug",
  "shuffle",
  "shy",
  "sibling",
  "sick",
  "side",
  "siege",
  "sight",
  "sign",
  "silent",
  "silk",
  "silly",
  "silver",
  "similar",
  "simple",
  "since",
  "sing",
  "siren",
  "sister",
  "situate",
  "six",
  "size",
  "skate",
  "sketch",
  "ski",
  "skill",
  "skin",
  "skirt",
  "skull",
  "slab",
  "slam",
  "sleep",
  "slender",
  "slice",
  "slide",
  "slight",
  "slim",
  "slogan",
  "slot",
  "slow",
  "slush",
  "small",
  "smart",
  "smile",
  "smoke",
  "smooth",
  "snack",
  "snake",
  "snap",
  "sniff",
  "snow",
  "soap",
  "soccer",
  "social",
  "sock",
  "soda",
  "soft",
  "solar",
  "soldier",
  "solid",
  "solution",
  "solve",
  "someone",
  "song",
  "soon",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "source",
  "south",
  "space",
  "spare",
  "spatial",
  "spawn",
  "speak",
  "special",
  "speed",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spider",
  "spike",
  "spin",
  "spirit",
  "split",
  "spoil",
  "sponsor",
  "spoon",
  "sport",
  "spot",
  "spray",
  "spread",
  "spring",
  "spy",
  "square",
  "squeeze",
  "squirrel",
  "stable",
  "stadium",
  "staff",
  "stage",
  "stairs",
  "stamp",
  "stand",
  "start",
  "state",
  "stay",
  "steak",
  "steel",
  "stem",
  "step",
  "stereo",
  "stick",
  "still",
  "sting",
  "stock",
  "stomach",
  "stone",
  "stool",
  "story",
  "stove",
  "strategy",
  "street",
  "strike",
  "strong",
  "struggle",
  "student",
  "stuff",
  "stumble",
  "style",
  "subject",
  "submit",
  "subway",
  "success",
  "such",
  "sudden",
  "suffer",
  "sugar",
  "suggest",
  "suit",
  "summer",
  "sun",
  "sunny",
  "sunset",
  "super",
  "supply",
  "supreme",
  "sure",
  "surface",
  "surge",
  "surprise",
  "surround",
  "survey",
  "suspect",
  "sustain",
  "swallow",
  "swamp",
  "swap",
  "swarm",
  "swear",
  "sweet",
  "swift",
  "swim",
  "swing",
  "switch",
  "sword",
  "symbol",
  "symptom",
  "syrup",
  "system",
  "table",
  "tackle",
  "tag",
  "tail",
  "talent",
  "talk",
  "tank",
  "tape",
  "target",
  "task",
  "taste",
  "tattoo",
  "taxi",
  "teach",
  "team",
  "tell",
  "ten",
  "tenant",
  "tennis",
  "tent",
  "term",
  "test",
  "text",
  "thank",
  "that",
  "theme",
  "then",
  "theory",
  "there",
  "they",
  "thing",
  "this",
  "thought",
  "three",
  "thrive",
  "throw",
  "thumb",
  "thunder",
  "ticket",
  "tide",
  "tiger",
  "tilt",
  "timber",
  "time",
  "tiny",
  "tip",
  "tired",
  "tissue",
  "title",
  "toast",
  "tobacco",
  "today",
  "toddler",
  "toe",
  "together",
  "toilet",
  "token",
  "tomato",
  "tomorrow",
  "tone",
  "tongue",
  "tonight",
  "tool",
  "tooth",
  "top",
  "topic",
  "topple",
  "torch",
  "tornado",
  "tortoise",
  "toss",
  "total",
  "tourist",
  "toward",
  "tower",
  "town",
  "toy",
  "track",
  "trade",
  "traffic",
  "tragic",
  "train",
  "transfer",
  "trap",
  "trash",
  "travel",
  "tray",
  "treat",
  "tree",
  "trend",
  "trial",
  "tribe",
  "trick",
  "trigger",
  "trim",
  "trip",
  "trophy",
  "trouble",
  "truck",
  "true",
  "truly",
  "trumpet",
  "trust",
  "truth",
  "try",
  "tube",
  "tuition",
  "tumble",
  "tuna",
  "tunnel",
  "turkey",
  "turn",
  "turtle",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "type",
  "typical",
  "ugly",
  "umbrella",
  "unable",
  "unaware",
  "uncle",
  "uncover",
  "under",
  "undo",
  "unfair",
  "unfold",
  "unhappy",
  "uniform",
  "unique",
  "unit",
  "universe",
  "unknown",
  "unlock",
  "until",
  "unusual",
  "unveil",
  "update",
  "upgrade",
  "uphold",
  "upon",
  "upper",
  "upset",
  "urban",
  "urge",
  "usage",
  "use",
  "used",
  "useful",
  "useless",
  "usual",
  "utility",
  "vacant",
  "vacuum",
  "vague",
  "valid",
  "valley",
  "valve",
  "van",
  "vanish",
  "vapor",
  "various",
  "vast",
  "vault",
  "vehicle",
  "velvet",
  "vendor",
  "venture",
  "venue",
  "verb",
  "verify",
  "version",
  "very",
  "vessel",
  "veteran",
  "viable",
  "vibrant",
  "vicious",
  "victory",
  "video",
  "view",
  "village",
  "vintage",
  "violin",
  "virtual",
  "virus",
  "visa",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "voice",
  "void",
  "volcano",
  "volume",
  "vote",
  "voyage",
  "wage",
  "wagon",
  "wait",
  "walk",
  "wall",
  "walnut",
  "want",
  "warfare",
  "warm",
  "warrior",
  "wash",
  "wasp",
  "waste",
  "water",
  "wave",
  "way",
  "wealth",
  "weapon",
  "wear",
  "weasel",
  "weather",
  "web",
  "wedding",
  "weekend",
  "weird",
  "welcome",
  "west",
  "wet",
  "whale",
  "what",
  "wheat",
  "wheel",
  "when",
  "where",
  "whip",
  "whisper",
  "wide",
  "width",
  "wife",
  "wild",
  "will",
  "win",
  "window",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "witness",
  "wolf",
  "woman",
  "wonder",
  "wood",
  "wool",
  "word",
  "work",
  "world",
  "worry",
  "worth",
  "wrap",
  "wreck",
  "wrestle",
  "wrist",
  "write",
  "wrong",
  "yard",
  "year",
  "yellow",
  "you",
  "young",
  "youth",
  "zebra",
  "zero",
  "zone",
  "zoo"
];
Object.defineProperty(wa, "__esModule", { value: !0 });
const hs = {};
wa.wordlists = hs;
let oo;
var zc = wa._default = oo;
try {
  zc = wa._default = oo = lOe, hs.czech = oo;
} catch {
}
try {
  zc = wa._default = oo = fOe, hs.chinese_simplified = oo;
} catch {
}
try {
  zc = wa._default = oo = dOe, hs.chinese_traditional = oo;
} catch {
}
try {
  zc = wa._default = oo = hOe, hs.korean = oo;
} catch {
}
try {
  zc = wa._default = oo = pOe, hs.french = oo;
} catch {
}
try {
  zc = wa._default = oo = gOe, hs.italian = oo;
} catch {
}
try {
  zc = wa._default = oo = mOe, hs.spanish = oo;
} catch {
}
try {
  zc = wa._default = oo = yOe, hs.japanese = oo, hs.JA = oo;
} catch {
}
try {
  zc = wa._default = oo = bOe, hs.portuguese = oo;
} catch {
}
try {
  zc = wa._default = oo = wOe, hs.english = oo, hs.EN = oo;
} catch {
}
Object.defineProperty(Rc, "__esModule", { value: !0 });
const vOe = Ru, MX = ei, DX = PE, EOe = Vs, k5 = wa;
let c2 = k5._default;
const pj = "Invalid mnemonic", Qp = "Invalid entropy", _Oe = "Invalid mnemonic checksum", KX = `A wordlist is required but a default could not be found.
Please pass a 2048 word array explicitly.`;
function l2(e) {
  return (e || "").normalize("NFKD");
}
function qX(e, t, r) {
  for (; e.length < r; )
    e = t + e;
  return e;
}
function VX(e) {
  return parseInt(e, 2);
}
function GX(e) {
  return e.map((t) => qX(t.toString(2), "0", 8)).join("");
}
function WX(e) {
  const t = e.length * 8 / 32, r = vOe.sha256(Uint8Array.from(e));
  return GX(Array.from(r)).slice(0, t);
}
function ZX(e) {
  return "mnemonic" + (e || "");
}
function AOe(e, t) {
  const r = Uint8Array.from(Buffer.from(l2(e), "utf8")), n = Uint8Array.from(Buffer.from(ZX(l2(t)), "utf8")), o = DX.pbkdf2(MX.sha512, r, n, {
    c: 2048,
    dkLen: 64
  });
  return Buffer.from(o);
}
Rc.mnemonicToSeedSync = AOe;
function xOe(e, t) {
  const r = Uint8Array.from(Buffer.from(l2(e), "utf8")), n = Uint8Array.from(Buffer.from(ZX(l2(t)), "utf8"));
  return DX.pbkdf2Async(MX.sha512, r, n, {
    c: 2048,
    dkLen: 64
  }).then((o) => Buffer.from(o));
}
var kOe = Rc.mnemonicToSeed = xOe;
function XX(e, t) {
  if (t = t || c2, !t)
    throw new Error(KX);
  const r = l2(e).split(" ");
  if (r.length % 3 !== 0)
    throw new Error(pj);
  const n = r.map((d) => {
    const f = t.indexOf(d);
    if (f === -1)
      throw new Error(pj);
    return qX(f.toString(2), "0", 11);
  }).join(""), o = Math.floor(n.length / 33) * 32, i = n.slice(0, o), a = n.slice(o), u = i.match(/(.{1,8})/g).map(VX);
  if (u.length < 16)
    throw new Error(Qp);
  if (u.length > 32)
    throw new Error(Qp);
  if (u.length % 4 !== 0)
    throw new Error(Qp);
  const l = Buffer.from(u);
  if (WX(l) !== a)
    throw new Error(_Oe);
  return l.toString("hex");
}
Rc.mnemonicToEntropy = XX;
function YX(e, t) {
  if (Buffer.isBuffer(e) || (e = Buffer.from(e, "hex")), t = t || c2, !t)
    throw new Error(KX);
  if (e.length < 16)
    throw new TypeError(Qp);
  if (e.length > 32)
    throw new TypeError(Qp);
  if (e.length % 4 !== 0)
    throw new TypeError(Qp);
  const r = GX(Array.from(e)), n = WX(e), o = (r + n).match(/(.{1,11})/g).map((i) => {
    const a = VX(i);
    return t[a];
  });
  return t[0] === "あいこくしん" ? o.join("　") : o.join(" ");
}
var SOe = Rc.entropyToMnemonic = YX;
function TOe(e, t, r) {
  if (e = e || 128, e % 32 !== 0)
    throw new TypeError(Qp);
  return t = t || ((n) => Buffer.from(EOe.randomBytes(n))), YX(t(e / 8), r);
}
Rc.generateMnemonic = TOe;
function IOe(e, t) {
  try {
    XX(e, t);
  } catch {
    return !1;
  }
  return !0;
}
Rc.validateMnemonic = IOe;
function OOe(e) {
  const t = k5.wordlists[e];
  if (t)
    c2 = t;
  else
    throw new Error('Could not find wordlist for language "' + e + '"');
}
Rc.setDefaultWordlist = OOe;
function POe() {
  if (!c2)
    throw new Error("No Default Wordlist set");
  return Object.keys(k5.wordlists).filter((e) => e === "JA" || e === "EN" ? !1 : k5.wordlists[e].every((t, r) => t === c2[r]))[0];
}
Rc.getDefaultWordlist = POe;
var COe = wa;
Rc.wordlists = COe.wordlists;
function BOe(e) {
  return rV(Si(e));
}
function gj(e, t) {
  return dG(U4e, e, t);
}
const mr = (e) => w2e(e);
function NOe(e) {
  if (Lo(e.isPoint(mr("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"))), Lo(!e.isPoint(mr("030000000000000000000000000000000000000000000000000000000000000005"))), Lo(e.isPrivate(mr("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"))), Lo(e.isPrivate(mr("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140"))), Lo(!e.isPrivate(mr("0000000000000000000000000000000000000000000000000000000000000000"))), Lo(!e.isPrivate(mr("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"))), Lo(!e.isPrivate(mr("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364142"))), Lo(Rl(e.pointFromScalar(mr("b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af")), mr("02b07ba9dca9523b7ef4bd97703d43d20399eb698e194704791a25ce77a400df99")) === 0), e.xOnlyPointAddTweak) {
    Lo(e.xOnlyPointAddTweak(mr("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"), mr("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")) === null);
    let t = e.xOnlyPointAddTweak(mr("1617d38ed8d8657da4d4761e8057bc396ea9e4b9d29776d4be096016dbd2509b"), mr("a8397a935f0dfceba6ba9618f6451ef4d80637abf4e6af2669fbc9de6a8fd2ac"));
    Lo(Rl(t.xOnlyPubkey, mr("e478f99dab91052ab39a33ea35fd5e6e4933f4d28023cd597c9a1f6760346adf")) === 0 && t.parity === 1), t = e.xOnlyPointAddTweak(mr("2c0b7cf95324a07d05398b240174dc0c2be444d96b159aa6c7f7b1e668680991"), mr("823c3cd2142744b075a87eade7e1b8678ba308d566226a0056ca2b7a76f86b47"));
  }
  Lo(Rl(e.pointAddScalar(mr("0379be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"), mr("0000000000000000000000000000000000000000000000000000000000000003")), mr("02c6047f9441ed7d6d3045406e95c07cd85c778e4b8cef3ca7abac09b95c709ee5")) === 0), Lo(Rl(e.privateAdd(mr("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e"), mr("0000000000000000000000000000000000000000000000000000000000000002")), mr("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")) === 0), e.privateNegate && (Lo(Rl(e.privateNegate(mr("0000000000000000000000000000000000000000000000000000000000000001")), mr("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")) === 0), Lo(Rl(e.privateNegate(mr("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e")), mr("0000000000000000000000000000000000000000000000000000000000000003")) === 0), Lo(Rl(e.privateNegate(mr("b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af")), mr("4eede1bf775995d70a494f0a7bb6bc11e0b8cccd41cce8009ab1132c8b0a3792")) === 0)), Lo(Rl(e.sign(mr("5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed"), mr("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")), mr("54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5")) === 0), Lo(e.verify(mr("5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed"), mr("0379be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"), mr("54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5"))), e.signSchnorr && Lo(Rl(e.signSchnorr(mr("7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c"), mr("c90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b14e5c9"), mr("c87aa53824b4d7ae2eb035a2b5bbbccc080e76cdc6d1692c4b0b62d798e6d906")), mr("5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7")) === 0), e.verifySchnorr && Lo(e.verifySchnorr(mr("7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c"), mr("dd308afec5777e13121fa72b9cc1b7cc0139715309b086c960e18fd969774eb8"), mr("5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7")));
}
function Lo(e) {
  if (!e)
    throw new Error("ecc library invalid");
}
/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function wP(e) {
  return e instanceof Uint8Array || ArrayBuffer.isView(e) && e.constructor.name === "Uint8Array";
}
function JX(e, t) {
  return Array.isArray(t) ? t.length === 0 ? !0 : e ? t.every((r) => typeof r == "string") : t.every((r) => Number.isSafeInteger(r)) : !1;
}
function $Oe(e) {
  if (typeof e != "function")
    throw new Error("function expected");
  return !0;
}
function vP(e, t) {
  if (typeof t != "string")
    throw new Error(`${e}: string expected`);
  return !0;
}
function MN(e) {
  if (!Number.isSafeInteger(e))
    throw new Error(`invalid integer: ${e}`);
}
function EP(e) {
  if (!Array.isArray(e))
    throw new Error("array expected");
}
function QX(e, t) {
  if (!JX(!0, t))
    throw new Error(`${e}: array of strings expected`);
}
function UOe(e, t) {
  if (!JX(!1, t))
    throw new Error(`${e}: array of numbers expected`);
}
// @__NO_SIDE_EFFECTS__
function eY(...e) {
  const t = (i) => i, r = (i, a) => (u) => i(a(u)), n = e.map((i) => i.encode).reduceRight(r, t), o = e.map((i) => i.decode).reduce(r, t);
  return { encode: n, decode: o };
}
// @__NO_SIDE_EFFECTS__
function ROe(e) {
  const t = e.split(""), r = t.length;
  QX("alphabet", t);
  const n = new Map(t.map((o, i) => [o, i]));
  return {
    encode: (o) => (EP(o), o.map((i) => {
      if (!Number.isSafeInteger(i) || i < 0 || i >= r)
        throw new Error(`alphabet.encode: digit index outside alphabet "${i}". Allowed: ${e}`);
      return t[i];
    })),
    decode: (o) => (EP(o), o.map((i) => {
      vP("alphabet.decode", i);
      const a = n.get(i);
      if (a === void 0)
        throw new Error(`Unknown letter: "${i}". Allowed: ${e}`);
      return a;
    }))
  };
}
// @__NO_SIDE_EFFECTS__
function zOe(e = "") {
  return vP("join", e), {
    encode: (t) => (QX("join.decode", t), t.join(e)),
    decode: (t) => (vP("join.decode", t), t.split(e))
  };
}
function mj(e, t, r) {
  if (t < 2)
    throw new Error(`convertRadix: invalid from=${t}, base cannot be less than 2`);
  if (r < 2)
    throw new Error(`convertRadix: invalid to=${r}, base cannot be less than 2`);
  if (EP(e), !e.length)
    return [];
  let n = 0;
  const o = [], i = Array.from(e, (u) => {
    if (MN(u), u < 0 || u >= t)
      throw new Error(`invalid integer: ${u}`);
    return u;
  }), a = i.length;
  for (; ; ) {
    let u = 0, l = !0;
    for (let d = n; d < a; d++) {
      const f = i[d], h = t * u, g = h + f;
      if (!Number.isSafeInteger(g) || h / t !== u || g - f !== h)
        throw new Error("convertRadix: carry overflow");
      const b = g / r;
      u = g % r;
      const w = Math.floor(b);
      if (i[d] = w, !Number.isSafeInteger(w) || w * r + u !== g)
        throw new Error("convertRadix: carry overflow");
      if (l)
        w ? l = !1 : n = d;
      else continue;
    }
    if (o.push(u), l)
      break;
  }
  for (let u = 0; u < e.length - 1 && e[u] === 0; u++)
    o.push(0);
  return o.reverse();
}
// @__NO_SIDE_EFFECTS__
function jOe(e) {
  MN(e);
  const t = 2 ** 8;
  return {
    encode: (r) => {
      if (!wP(r))
        throw new Error("radix.encode input should be Uint8Array");
      return mj(Array.from(r), t, e);
    },
    decode: (r) => (UOe("radix.decode", r), Uint8Array.from(mj(r, e, t)))
  };
}
function LOe(e, t) {
  return MN(e), $Oe(t), {
    encode(r) {
      if (!wP(r))
        throw new Error("checksum.encode: input should be Uint8Array");
      const n = t(r).slice(0, e), o = new Uint8Array(r.length + e);
      return o.set(r), o.set(n, r.length), o;
    },
    decode(r) {
      if (!wP(r))
        throw new Error("checksum.decode: input should be Uint8Array");
      const n = r.slice(0, -4), o = r.slice(-4), i = t(n).slice(0, e);
      for (let a = 0; a < e; a++)
        if (i[a] !== o[a])
          throw new Error("Invalid checksum");
      return n;
    }
  };
}
const HOe = /* @__NO_SIDE_EFFECTS__ */ (e) => /* @__PURE__ */ eY(/* @__PURE__ */ jOe(58), /* @__PURE__ */ ROe(e), /* @__PURE__ */ zOe("")), FOe = /* @__PURE__ */ HOe("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), MOe = (e) => /* @__PURE__ */ eY(LOe(4, (t) => e(e(t))), FOe), DOe = MOe;
function KOe(e) {
  return {
    lang: (e == null ? void 0 : e.lang) ?? void 0,
    message: e == null ? void 0 : e.message,
    abortEarly: (e == null ? void 0 : e.abortEarly) ?? void 0,
    abortPipeEarly: (e == null ? void 0 : e.abortPipeEarly) ?? void 0
  };
}
function qOe(e, t) {
  var r;
  return (r = void 0) == null ? void 0 : r.get(t);
}
function f2(e) {
  var t, r;
  const n = typeof e;
  return n === "string" ? `"${e}"` : n === "number" || n === "bigint" || n === "boolean" ? `${e}` : n === "object" || n === "function" ? (e && ((r = (t = Object.getPrototypeOf(e)) == null ? void 0 : t.constructor) == null ? void 0 : r.name)) ?? "null" : n;
}
function Af(e, t, r, n, o) {
  const i = o && "input" in o ? o.input : r.value, a = (o == null ? void 0 : o.expected) ?? e.expects ?? null, u = (o == null ? void 0 : o.received) ?? f2(i), l = {
    kind: e.kind,
    type: e.type,
    input: i,
    expected: a,
    received: u,
    message: `Invalid ${t}: ${a ? `Expected ${a} but r` : "R"}eceived ${u}`,
    // @ts-expect-error
    requirement: e.requirement,
    path: o == null ? void 0 : o.path,
    issues: o == null ? void 0 : o.issues,
    lang: n.lang,
    abortEarly: n.abortEarly,
    abortPipeEarly: n.abortPipeEarly
  }, d = e.kind === "schema", f = (o == null ? void 0 : o.message) ?? // @ts-expect-error
  e.message ?? qOe(e.reference, l.lang) ?? (d ? (l.lang, void 0) : null) ?? n.message ?? (l.lang, void 0);
  f && (l.message = typeof f == "function" ? f(l) : f), d && (r.typed = !1), r.issues ? r.issues.push(l) : r.issues = [l];
}
var VOe = class extends Error {
  /**
   * Creates a Valibot error with useful information.
   *
   * @param issues The error issues.
   */
  constructor(e) {
    super(e[0].message), ut(this, "issues"), this.name = "ValiError", this.issues = e;
  }
};
function CE(e) {
  return {
    kind: "validation",
    type: "integer",
    reference: CE,
    async: !1,
    expects: null,
    requirement: Number.isInteger,
    message: e,
    _run(t, r) {
      return t.typed && !this.requirement(t.value) && Af(this, "integer", t, r), t;
    }
  };
}
function DN(e, t) {
  return {
    kind: "validation",
    type: "length",
    reference: DN,
    async: !1,
    expects: `${e}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && r.value.length !== this.requirement && Af(this, "length", r, n, {
        received: `${r.value.length}`
      }), r;
    }
  };
}
function BE(e, t) {
  return {
    kind: "validation",
    type: "max_value",
    reference: BE,
    async: !1,
    expects: `<=${e instanceof Date ? e.toJSON() : f2(e)}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && r.value > this.requirement && Af(this, "value", r, n, {
        received: r.value instanceof Date ? r.value.toJSON() : f2(r.value)
      }), r;
    }
  };
}
function NE(e, t) {
  return {
    kind: "validation",
    type: "min_value",
    reference: NE,
    async: !1,
    expects: `>=${e instanceof Date ? e.toJSON() : f2(e)}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && r.value < this.requirement && Af(this, "value", r, n, {
        received: r.value instanceof Date ? r.value.toJSON() : f2(r.value)
      }), r;
    }
  };
}
function tY(e, t) {
  return {
    kind: "validation",
    type: "regex",
    reference: tY,
    async: !1,
    expects: `${e}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && !this.requirement.test(r.value) && Af(this, "format", r, n), r;
    }
  };
}
function $E(e, t) {
  return {
    kind: "schema",
    type: "instance",
    reference: $E,
    expects: e.name,
    async: !1,
    class: e,
    message: t,
    _run(r, n) {
      return r.value instanceof this.class ? r.typed = !0 : Af(this, "type", r, n), r;
    }
  };
}
function UE(e) {
  return {
    kind: "schema",
    type: "number",
    reference: UE,
    expects: "number",
    async: !1,
    message: e,
    _run(t, r) {
      return typeof t.value == "number" && !isNaN(t.value) ? t.typed = !0 : Af(this, "type", t, r), t;
    }
  };
}
function _P(e, t) {
  return {
    kind: "schema",
    type: "object",
    reference: _P,
    expects: "Object",
    async: !1,
    entries: e,
    message: t,
    _run(r, n) {
      var o;
      const i = r.value;
      if (i && typeof i == "object") {
        r.typed = !0, r.value = {};
        for (const a in this.entries) {
          const u = i[a], l = this.entries[a]._run(
            { typed: !1, value: u },
            n
          );
          if (l.issues) {
            const d = {
              type: "object",
              origin: "value",
              input: i,
              key: a,
              value: u
            };
            for (const f of l.issues)
              f.path ? f.path.unshift(d) : f.path = [d], (o = r.issues) == null || o.push(f);
            if (r.issues || (r.issues = l.issues), n.abortEarly) {
              r.typed = !1;
              break;
            }
          }
          l.typed || (r.typed = !1), (l.value !== void 0 || a in i) && (r.value[a] = l.value);
        }
      } else
        Af(this, "type", r, n);
      return r;
    }
  };
}
function rY(e) {
  return {
    kind: "schema",
    type: "string",
    reference: rY,
    expects: "string",
    async: !1,
    message: e,
    _run(t, r) {
      return typeof t.value == "string" ? t.typed = !0 : Af(this, "type", t, r), t;
    }
  };
}
function Hl(e, t, r) {
  const n = e._run(
    { typed: !1, value: t },
    KOe(r)
  );
  if (n.issues)
    throw new VOe(n.issues);
  return n.value;
}
function Dg(...e) {
  return {
    ...e[0],
    pipe: e,
    _run(t, r) {
      for (const n of e)
        if (n.kind !== "metadata") {
          if (t.issues && (n.kind === "schema" || n.kind === "transformation")) {
            t.typed = !1;
            break;
          }
          (!t.issues || !r.abortEarly && !r.abortPipeEarly) && (t = n._run(t, r));
        }
      return t;
    }
  };
}
const AP = Dg(UE(), CE(), NE(0), BE(4294967295)), GOe = Dg(UE(), CE(), NE(0), BE(2147483647)), WOe = Dg(UE(), CE(), NE(0), BE(255)), oI = Dg($E(Uint8Array), DN(32)), ZOe = Dg($E(Uint8Array), DN(33)), XOe = _P({
  wif: WOe,
  bip32: _P({
    public: AP,
    private: AP
  })
}), YOe = Dg(rY(), tY(/^(m\/)?(\d+'?\/)*\d+'?$/));
function JOe(e, t, r) {
  if (t.length !== 32)
    throw new TypeError("Invalid privateKey length");
  var n = new Uint8Array(34), o = new DataView(n.buffer);
  return o.setUint8(0, e), n.set(t, 1), n[33] = 1, n;
}
function QOe(e) {
  return J1.encode(JOe(e.version, e.privateKey));
}
const yj = DOe(Si), bj = {
  encode: (e) => yj.encode(e),
  decode: (e) => yj.decode(e)
};
function ePe(e) {
  NOe(e);
  const t = {
    messagePrefix: `Bitcoin Signed Message:
`,
    bech32: "bc",
    bip32: {
      public: 76067358,
      private: 76066276
    },
    pubKeyHash: 0,
    scriptHash: 5,
    wif: 128
  }, r = 2147483648;
  function n(g) {
    return g.length === 32 ? g : g.slice(1, 33);
  }
  class o {
    constructor(b, w) {
      ut(this, "__D"), ut(this, "__Q"), ut(this, "lowR", !1), this.__D = b, this.__Q = w;
    }
    get publicKey() {
      return this.__Q === void 0 && (this.__Q = e.pointFromScalar(this.__D, !0)), this.__Q;
    }
    get privateKey() {
      return this.__D;
    }
    sign(b, w) {
      if (!this.privateKey)
        throw new Error("Missing private key");
      if (w === void 0 && (w = this.lowR), w === !1)
        return e.sign(b, this.privateKey);
      {
        let E = e.sign(b, this.privateKey);
        const _ = new Uint8Array(32);
        let O = 0;
        for (; E[0] > 127; )
          O++, Ap(_, 0, O, "LE"), E = e.sign(b, this.privateKey, _);
        return E;
      }
    }
    signSchnorr(b) {
      if (!this.privateKey)
        throw new Error("Missing private key");
      if (!e.signSchnorr)
        throw new Error("signSchnorr not supported by ecc library");
      return e.signSchnorr(b, this.privateKey);
    }
    verify(b, w) {
      return e.verify(b, this.publicKey, w);
    }
    verifySchnorr(b, w) {
      if (!e.verifySchnorr)
        throw new Error("verifySchnorr not supported by ecc library");
      return e.verifySchnorr(b, this.publicKey.subarray(1, 33), w);
    }
  }
  class i extends o {
    constructor(b, w, E, _, O = 0, C = 0, I = 0) {
      super(b, w), ut(this, "chainCode"), ut(this, "network"), ut(this, "__DEPTH"), ut(this, "__INDEX"), ut(this, "__PARENT_FINGERPRINT"), this.chainCode = E, this.network = _, this.__DEPTH = O, this.__INDEX = C, this.__PARENT_FINGERPRINT = I, Hl(XOe, _);
    }
    get depth() {
      return this.__DEPTH;
    }
    get index() {
      return this.__INDEX;
    }
    get parentFingerprint() {
      return this.__PARENT_FINGERPRINT;
    }
    get identifier() {
      return BOe(this.publicKey);
    }
    get fingerprint() {
      return this.identifier.slice(0, 4);
    }
    get compressed() {
      return !0;
    }
    // Private === not neutered
    // Public === neutered
    isNeutered() {
      return this.__D === void 0;
    }
    neutered() {
      return f(this.publicKey, this.chainCode, this.network, this.depth, this.index, this.parentFingerprint);
    }
    toBase58() {
      const b = this.network, w = this.isNeutered() ? b.bip32.public : b.bip32.private, E = new Uint8Array(78);
      return Ap(E, 0, w, "BE"), FR(E, 4, this.depth), Ap(E, 5, this.parentFingerprint, "BE"), Ap(E, 9, this.index, "BE"), E.set(this.chainCode, 13), this.isNeutered() ? E.set(this.publicKey, 45) : (FR(E, 45, 0), E.set(this.privateKey, 46)), bj.encode(E);
    }
    toWIF() {
      if (!this.privateKey)
        throw new TypeError("Missing private key");
      return QOe({
        version: this.network.wif,
        privateKey: this.privateKey
      });
    }
    // https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki#child-key-derivation-ckd-functions
    derive(b) {
      Hl(AP, b);
      const w = b >= r, E = new Uint8Array(37);
      if (w) {
        if (this.isNeutered())
          throw new TypeError("Missing private key for hardened child key");
        E[0] = 0, E.set(this.privateKey, 1), Ap(E, 33, b, "BE");
      } else
        E.set(this.publicKey, 0), Ap(E, 33, b, "BE");
      const _ = gj(this.chainCode, E), O = _.slice(0, 32), C = _.slice(32);
      if (!e.isPrivate(O))
        return this.derive(b + 1);
      let I;
      if (this.isNeutered()) {
        const S = e.pointAddScalar(this.publicKey, O, !0);
        if (S === null)
          return this.derive(b + 1);
        I = f(S, C, this.network, this.depth + 1, b, e1(this.fingerprint, 0, "BE"));
      } else {
        const S = e.privateAdd(this.privateKey, O);
        if (S == null)
          return this.derive(b + 1);
        I = l(S, C, this.network, this.depth + 1, b, e1(this.fingerprint, 0, "BE"));
      }
      return I;
    }
    deriveHardened(b) {
      if (typeof Hl(GOe, b) == "number")
        return this.derive(b + r);
      throw new TypeError("Expected UInt31, got " + b);
    }
    derivePath(b) {
      Hl(YOe, b);
      let w = b.split("/");
      if (w[0] === "m") {
        if (this.parentFingerprint)
          throw new TypeError("Expected master, got child");
        w = w.slice(1);
      }
      return w.reduce((E, _) => {
        let O;
        return _.slice(-1) === "'" ? (O = parseInt(_.slice(0, -1), 10), E.deriveHardened(O)) : (O = parseInt(_, 10), E.derive(O));
      }, this);
    }
    tweak(b) {
      return this.privateKey ? this.tweakFromPrivateKey(b) : this.tweakFromPublicKey(b);
    }
    tweakFromPublicKey(b) {
      const w = n(this.publicKey);
      if (!e.xOnlyPointAddTweak)
        throw new Error("xOnlyPointAddTweak not supported by ecc library");
      const E = e.xOnlyPointAddTweak(w, b);
      if (!E || E.xOnlyPubkey === null)
        throw new Error("Cannot tweak public key!");
      const _ = Uint8Array.from([
        E.parity === 0 ? 2 : 3
      ]), O = b2e([
        _,
        E.xOnlyPubkey
      ]);
      return new o(void 0, O);
    }
    tweakFromPrivateKey(b) {
      const w = this.publicKey[0] === 3 || this.publicKey[0] === 4 && (this.publicKey[64] & 1) === 1, E = (() => {
        if (w) {
          if (e.privateNegate)
            return e.privateNegate(this.privateKey);
          throw new Error("privateNegate not supported by ecc library");
        } else return this.privateKey;
      })(), _ = e.privateAdd(E, b);
      if (!_)
        throw new Error("Invalid tweaked private key!");
      return new o(_, void 0);
    }
  }
  function a(g, b) {
    const w = bj.decode(g);
    if (w.length !== 78)
      throw new TypeError("Invalid buffer length");
    b = b || t;
    const E = e1(w, 0, "BE");
    if (E !== b.bip32.private && E !== b.bip32.public)
      throw new TypeError("Invalid network version");
    const _ = w[4], O = e1(w, 5, "BE");
    if (_ === 0 && O !== 0)
      throw new TypeError("Invalid parent fingerprint");
    const C = e1(w, 9, "BE");
    if (_ === 0 && C !== 0)
      throw new TypeError("Invalid index");
    const I = w.slice(13, 45);
    let S;
    if (E === b.bip32.private) {
      if (w[45] !== 0)
        throw new TypeError("Invalid private key");
      const T = w.slice(46, 78);
      S = l(T, I, b, _, C, O);
    } else {
      const T = w.slice(45, 78);
      S = f(T, I, b, _, C, O);
    }
    return S;
  }
  function u(g, b, w) {
    return l(g, b, w);
  }
  function l(g, b, w, E, _, O) {
    if (Hl(oI, g), Hl(oI, b), w = w || t, !e.isPrivate(g))
      throw new TypeError("Private key not in range [1, n)");
    return new i(g, void 0, b, w, E, _, O);
  }
  function d(g, b, w) {
    return f(g, b, w);
  }
  function f(g, b, w, E, _, O) {
    if (Hl(ZOe, g), Hl(oI, b), w = w || t, !e.isPoint(g))
      throw new TypeError("Point is not on the curve");
    return new i(void 0, g, b, w, E, _, O);
  }
  function h(g, b) {
    if (Hl($E(Uint8Array), g), g.length < 16)
      throw new TypeError("Seed should be at least 128 bits");
    if (g.length > 64)
      throw new TypeError("Seed should be at most 512 bits");
    b = b || t;
    const w = gj(y2e("Bitcoin seed"), g), E = w.slice(0, 32), _ = w.slice(32);
    return u(E, _, b);
  }
  return {
    fromSeed: h,
    fromBase58: a,
    fromPublicKey: d,
    fromPrivateKey: u
  };
}
const tPe = "text/plain", wj = "btc", vj = "brc20", Ej = "runes", KN = "bip322", pv = "ecdsa", RE = "bip322-simple", nY = async (e = zn) => await un.get(`${dv(e)}/api/v1/fees/recommended`, {
  headers: {
    "Content-Type": "application/json"
  }
}).then((t) => t.data), rPe = ePe(_E);
PB(_E);
async function nPe(e) {
  const t = crypto.getRandomValues(new Uint8Array(32)), r = SOe(Buffer.from(t)), n = await kOe(r), o = rPe.fromSeed(n, pn(e));
  return o == null ? void 0 : o.derivePath("m/44'/0'/0'/0/0").privateKey;
}
const zE = (e, t) => {
  try {
    const r = pn(t), n = mV(e);
    if (n.version === r.pubKeyHash) return uwe;
    if (n.version === r.scriptHash) {
      const o = ro(n.hash);
      return o && o.length === 2 && o[0] === an.OP_0 ? cwe : V2;
    }
  } catch {
    try {
      const r = BB(e);
      if (r.version === 0 && r.data.length === 20) return xO;
      if (r.version === 0 && r.data.length === 32) return lwe;
      if (r.version === 1 && r.data.length === 32) return Y1;
    } catch {
      return "unknown";
    }
  }
  return "unknown";
};
function oY(e, t) {
  const r = pn(t);
  return df(e, r);
}
function gv(e, t) {
  var r;
  const n = Z2({
    pubkey: Buffer.from(e, "hex"),
    network: pn(t)
  }), o = $g({
    redeem: n,
    network: pn(t)
  });
  return (r = o == null ? void 0 : o.redeem) == null ? void 0 : r.output;
}
PB(_E);
const pn = (e) => e === ua || e === Ta || e === Fs ? fwe : Xu, S5 = (e) => e.find(
  ({ purpose: t }) => t === "ordinals"
), T5 = (e) => e.find(
  ({ purpose: t }) => t === "payment"
), m0 = async (e, t) => {
  try {
    const r = await VN(
      e,
      t
    );
    return r ? r.reduce((n, o) => n + BigInt(o.value), 0n) : 0n;
  } catch (r) {
    throw console.error("Error fetching BTC balance:", r), new Error("Failed to fetch BTC balance");
  }
};
function qN(e, t, r) {
  const n = e * 57 + t * 41, o = r * 34;
  return 10 + n + o;
}
async function VN(e, t) {
  if (e.startsWith("t")) {
    if (t === zn)
      return [];
    if (t === ih)
      return [];
    if (t === us)
      return [];
  }
  return await un.get(`${dv(t)}/api/address/${e}/utxo`).then((r) => r.data);
}
async function GN(e, t, r, n, o, i, a = 7) {
  const u = e === t, l = await VN(
    t,
    i
  );
  if (!l)
    throw new Error("No UTXOs found");
  const d = l.sort(
    (E, _) => _.value - E.value
  ), f = new Yr({ network: pn(i) }), h = qN(1, 0, 2), g = Math.floor(h * a) + n;
  let b = 0, w = 0;
  for await (let E of d) {
    const { txid: _, vout: O, value: C } = E, I = df(
      t,
      pn(i)
    );
    if (f.addInput({
      hash: _,
      index: O,
      witnessUtxo: {
        script: I,
        value: BigInt(C)
      }
    }), !u) {
      const S = gv(o, i);
      f.updateInput(w, { redeemScript: S });
    }
    if (b += C, b >= g)
      break;
  }
  if (b < g)
    throw new Error("Insufficient funds");
  return f.addOutput({
    address: r,
    value: BigInt(n)
  }), b > g && f.addOutput({
    address: t,
    value: BigInt(b - g)
  }), {
    psbtBase64: f.toBase64(),
    psbtHex: f.toHex()
  };
}
function jE(e) {
  return e == null ? void 0 : e.reduce((t, r) => t + r.value, 0);
}
async function LE(e, t) {
  return (await un.post(
    `${dv(t)}/api/tx`,
    e,
    {
      headers: {
        "Content-Type": "text/plain"
      }
    }
  )).data;
}
const iY = (e) => e === ua || e === Ta || e === Fs, mv = (e) => e === zn || e === ih || e === us;
PB(_E);
const aY = async ({
  contentBase64: e,
  mimeType: t,
  quantity: r = 1,
  inscriptions: n,
  ordinalAddress: o,
  paymentAddress: i,
  paymentPublicKey: a,
  signPsbt: u,
  dataSourceManager: l,
  network: d = zn
}) => {
  try {
    if (!e && !n)
      throw new Error("contentBase64 or inscriptions is required");
    if (!l)
      throw new Error("missing data source");
    if (!l.broadcastTransaction)
      throw new Error("missing broadcastTransaction");
    const f = await nPe(d), h = Buffer.from(f).toString("hex"), g = n || Array(r).fill({
      content: e,
      mimeType: t
    }), b = await oPe({
      inscriptions: g,
      paymentAddress: i,
      paymentPublicKey: a,
      privKey: h,
      dataSourceManager: l,
      network: d
    });
    if (!b || !(b != null && b.psbtHex))
      throw new Error("couldn't get commit tx");
    const w = String(b == null ? void 0 : b.psbtHex), E = String(b == null ? void 0 : b.psbtBase64), _ = await u({
      tx: w,
      psbtHex: w,
      psbtBase64: E,
      finalize: !0,
      broadcast: !1,
      network: d
    });
    if (!_) throw new Error("sign psbt failed");
    const O = Yr.fromHex((_ == null ? void 0 : _.signedPsbtHex) || "").extractTransaction(), C = await l.broadcastTransaction(O.toHex());
    if (!C) throw new Error("commit tx failed");
    return await iPe({
      inscriptions: g,
      ordinalAddress: o,
      privKey: h,
      commitTxId: C,
      dataSourceManager: l
    });
  } catch (f) {
    throw f;
  }
}, oPe = async ({
  inscriptions: e,
  paymentAddress: t,
  paymentPublicKey: r,
  privKey: n,
  dataSourceManager: o,
  network: i
}) => {
  try {
    const a = e.length, u = e.reduce(
      (A, $) => A + Buffer.from($.content).length,
      0
    );
    if (u > 39e4)
      throw new Error("Content size is too large, must be less than 390kb");
    if (!o)
      throw new Error("missing data source");
    if (!o.getRecommendedFees)
      throw new Error("missing getRecommendedFees");
    if (!o.getAddressUtxos)
      throw new Error("missing getAddressUtxos");
    const { fastestFee: l } = await o.getRecommendedFees(), d = hG(String(n), !0), f = new Yr({
      network: pn(i)
    }), { inscriberAddress: h } = aPe(
      d,
      e,
      i
    ), g = 5 * 34 * a, b = Math.floor(g * l * a), w = Math.floor(u * l / 3) + 1e3 + 546 * a, E = Math.floor(b + w), _ = (await o.getAddressUtxos(
      t
    )).filter((A) => A.value > 3e3).sort((A, $) => $.value - A.value), O = jE(_);
    if (O === 0)
      throw new Error("insufficient funds");
    if (O < E)
      throw new Error("insufficient funds");
    let C = 0;
    const I = df(
      t,
      pn(i)
    );
    let S = 0;
    for await (const A of _) {
      const $ = zE(t, i);
      if (f.addInput({
        hash: A.txid,
        index: A.vout,
        witnessUtxo: { value: BigInt(A.value), script: I }
      }), $ === Y1 && f.updateInput(S, {
        tapInternalKey: Uu(Buffer.from(r, "hex"))
      }), $ === V2) {
        let U = gv(r, i);
        f.updateInput(S, { redeemScript: U });
      }
      if (S++, C += A.value, C > E)
        break;
    }
    const T = C - E;
    return f.addOutput({
      value: BigInt(w),
      address: h
    }), T > 546 && f.addOutput({
      value: BigInt(T),
      address: t
    }), {
      psbtHex: f.toHex(),
      psbtBase64: f.toBase64()
    };
  } catch (a) {
    throw a;
  }
}, iPe = async ({
  inscriptions: e,
  ordinalAddress: t,
  commitTxId: r,
  privKey: n,
  dataSourceManager: o,
  isDry: i
}) => {
  try {
    const a = R4e(n), u = hG(n, !0), l = sY(u, e), d = f5.encodeScript(l), [f, h] = f5.getPubKey(u, { target: d });
    if (!o)
      throw new Error("missing data source");
    if (!o.waitForTransaction)
      throw new Error("missing waitForTransaction");
    if (!o.getOutputValueByVOutIndex)
      throw new Error("missing waitForTransaction");
    if (!o.broadcastTransaction)
      throw new Error("missing broadcastTransaction");
    if (!await o.waitForTransaction(String(r)))
      throw new Error("ERROR WAITING FOR COMMIT TX");
    const g = await o.getOutputValueByVOutIndex(
      r,
      0
    );
    if (g === 0 || !g)
      throw new Error("ERROR GETTING FIRST INPUT VALUE");
    const b = zu.create({
      vin: [
        {
          txid: r,
          vout: 0,
          prevout: {
            value: g,
            scriptPubKey: ["OP_1", f]
          }
        }
      ],
      vout: [
        ...Array(e.length).fill({
          value: 546,
          scriptPubKey: tZ.toScriptPubKey(t)
        })
      ]
    }), w = cxe.taproot.sign(a, b, 0, { extension: d });
    return b.vin[0].witness = [w, l, h], i ? zu.util.getTxid(b) : await o.broadcastTransaction(zu.encode(b).hex);
  } catch (a) {
    throw a;
  }
}, sY = (e, t) => {
  const r = new TextEncoder(), n = r.encode("ord"), o = 546, i = (u, l) => {
    let d;
    if (l === tPe) {
      const h = Buffer.from(u, "base64").toString("utf-8");
      d = Buffer.from(h, "utf-8");
    } else
      d = Buffer.from(u, "base64");
    const f = [];
    for (let h = 0; h < d.length; h += 520)
      f.push(d.slice(h, h + 520));
    return f;
  }, a = [e, "OP_CHECKSIG"];
  return t.forEach((u, l) => {
    const { content: d, mimeType: f } = u, h = i(d, f);
    if (a.push("OP_0", "OP_IF", n, "01", r.encode(f), "OP_0"), l > 0) {
      const g = o * (l + 1), b = Buffer.from([g]);
      a.push(Buffer.from([2])), a.push(b);
    }
    a.push(...h.map((g) => g), "OP_ENDIF");
  }), a;
}, aPe = (e, t, r = zn) => {
  const n = sY(e, t), o = f5.encodeScript(n), [i] = f5.getPubKey(e, { target: o });
  return {
    inscriberAddress: tZ.p2tr.fromPubKey(
      i,
      iTe(r)
    ),
    tpubkey: i,
    tapleaf: o
  };
};
var sPe = {}, yv = {};
Object.defineProperty(yv, "__esModule", { value: !0 });
yv.isRunestone = void 0;
function uPe(e) {
  return !("flaws" in e);
}
yv.isRunestone = uPe;
var Dn = {}, bs = {}, WN = {}, ws = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isNone = e.isSome = e.None = e.Some = e.OptionType = void 0, e.OptionType = {
    Some: Symbol(":some"),
    None: Symbol(":none")
  };
  class t {
    constructor(u) {
      this.val = u;
    }
    get type() {
      return e.OptionType.Some;
    }
    isSome() {
      return !0;
    }
    isNone() {
      return !1;
    }
    match(u) {
      return u.some(this.val);
    }
    map(u) {
      return n(u(this.val));
    }
    inspect(u) {
      return u(this.val), this;
    }
    andThen(u) {
      return u(this.val);
    }
    or(u) {
      return this;
    }
    orElse(u) {
      return this;
    }
    and(u) {
      return u;
    }
    unwrapOr(u) {
      return this.val;
    }
    unwrap() {
      return this.val;
    }
  }
  class r {
    get type() {
      return e.OptionType.None;
    }
    isSome() {
      return !1;
    }
    isNone() {
      return !0;
    }
    match({ none: u }) {
      return typeof u == "function" ? u() : u;
    }
    map(u) {
      return new r();
    }
    inspect(u) {
      return this;
    }
    andThen(u) {
      return new r();
    }
    or(u) {
      return u;
    }
    orElse(u) {
      return u();
    }
    and(u) {
      return new r();
    }
    unwrapOr(u) {
      return u;
    }
    unwrap() {
      throw new ReferenceError("Trying to unwrap None.");
    }
  }
  function n(a) {
    return new t(a);
  }
  e.Some = n, e.None = new r();
  function o(a) {
    return a.isSome();
  }
  e.isSome = o;
  function i(a) {
    return a.isNone();
  }
  e.isNone = i;
})(ws);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.u8 = e.U8_MAX_BIGINT = void 0;
  const t = ws;
  e.U8_MAX_BIGINT = 0xffn;
  function r(n) {
    return (typeof n == "bigint" ? n : BigInt(n)) & e.U8_MAX_BIGINT;
  }
  e.u8 = r, function(n) {
    n.MAX = n(e.U8_MAX_BIGINT);
    function o(a, u) {
      const l = a + u;
      return l > n.MAX ? t.None : (0, t.Some)(n(l));
    }
    n.checkedAdd = o;
    function i(a, u) {
      const l = a - u;
      return l < 0n ? t.None : (0, t.Some)(n(l));
    }
    n.checkedSub = i;
  }(r || (e.u8 = r = {}));
})(WN);
var ZN = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.u32 = e.U32_MAX_BIGINT = void 0;
  const t = ws;
  e.U32_MAX_BIGINT = 0xffffffffn;
  function r(n) {
    return (typeof n == "bigint" ? n : BigInt(n)) & e.U32_MAX_BIGINT;
  }
  e.u32 = r, function(n) {
    n.MAX = n(e.U32_MAX_BIGINT);
    function o(a, u) {
      const l = a + u;
      return l > n.MAX ? t.None : (0, t.Some)(n(l));
    }
    n.checkedAdd = o;
    function i(a, u) {
      const l = a - u;
      return l < 0n ? t.None : (0, t.Some)(n(l));
    }
    n.checkedSub = i;
  }(r || (e.u32 = r = {}));
})(ZN);
var XN = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.u64 = e.U64_MAX_BIGINT = void 0;
  const t = ws;
  e.U64_MAX_BIGINT = 0xffffffffffffffffn;
  function r(n) {
    return (typeof n == "bigint" ? n : BigInt(n)) & e.U64_MAX_BIGINT;
  }
  e.u64 = r, function(n) {
    n.MAX = n(e.U64_MAX_BIGINT);
    function o(a, u) {
      const l = a + u;
      return l > n.MAX ? t.None : (0, t.Some)(n(l));
    }
    n.checkedAdd = o;
    function i(a, u) {
      const l = a - u;
      return l < 0n ? t.None : (0, t.Some)(n(l));
    }
    n.checkedSub = i;
  }(r || (e.u64 = r = {}));
})(XN);
var uY = {}, bv = {};
Object.defineProperty(bv, "__esModule", { value: !0 });
bv.SeekBuffer = void 0;
class cPe {
  constructor(t) {
    this.buffer = t, this.seekIndex = 0;
  }
  readUInt8() {
    if (!this.isFinished())
      return this.buffer.readUInt8(this.seekIndex++);
  }
  isFinished() {
    return this.seekIndex >= this.buffer.length;
  }
}
bv.SeekBuffer = cPe;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.getAllU128 = e.u128 = e.U128_MAX_BIGINT = void 0;
  const t = ws, r = bv, n = XN, o = ZN, i = WN;
  e.U128_MAX_BIGINT = 0xffffffffffffffffffffffffffffffffn;
  function a(l) {
    return (typeof l == "bigint" ? l : BigInt(l)) & e.U128_MAX_BIGINT;
  }
  e.u128 = a, function(l) {
    l.MAX = l(e.U128_MAX_BIGINT);
    function d($, U) {
      const M = $ + U;
      return M > l.MAX ? t.None : (0, t.Some)(l(M));
    }
    l.checkedAdd = d;
    function f($, U) {
      const M = l.checkedAdd($, U);
      if (M.isNone())
        throw new Error("checked add overflow");
      return M.unwrap();
    }
    l.checkedAddThrow = f;
    function h($, U) {
      const M = $ - U;
      return M < 0n ? t.None : (0, t.Some)(l(M));
    }
    l.checkedSub = h;
    function g($, U) {
      const M = l.checkedSub($, U);
      if (M.isNone())
        throw new Error("checked sub overflow");
      return M.unwrap();
    }
    l.checkedSubThrow = g;
    function b($, U) {
      const M = $ * U;
      return M > l.MAX ? t.None : (0, t.Some)(l(M));
    }
    l.checkedMultiply = b;
    function w($, U) {
      const M = $ + U;
      return M > l.MAX ? l.MAX : l(M);
    }
    l.saturatingAdd = w;
    function E($, U) {
      const M = $ * U;
      return M > l.MAX ? l.MAX : l(M);
    }
    l.saturatingMultiply = E;
    function _($, U) {
      return l($ < U ? 0 : $ - U);
    }
    l.saturatingSub = _;
    function O($) {
      try {
        return (0, t.Some)(C($));
      } catch {
        return t.None;
      }
    }
    l.decodeVarInt = O;
    function C($) {
      let U = l(0);
      for (let M = 0; M <= 18; M++) {
        const Y = $.readUInt8();
        if (Y === void 0)
          throw new Error("Unterminated");
        const L = l(Y) & 127n;
        if (M === 18 && (L & 124n) !== 0n)
          throw new Error("Overflow");
        if (U = l(U | L << l(7 * M)), !(Y & 128))
          return U;
      }
      throw new Error("Overlong");
    }
    l.tryDecodeVarInt = C;
    function I($) {
      const U = [];
      for (; $ >> 7n > 0n; )
        U.push(Number($ & 0xffn) | 128), $ = l($ >> 7n);
      return U.push(Number($ & 0xffn)), Buffer.from(U);
    }
    l.encodeVarInt = I;
    function S($) {
      return $ > n.u64.MAX ? t.None : (0, t.Some)((0, n.u64)($));
    }
    l.tryIntoU64 = S;
    function T($) {
      return $ > o.u32.MAX ? t.None : (0, t.Some)((0, o.u32)($));
    }
    l.tryIntoU32 = T;
    function A($) {
      return $ > i.u8.MAX ? t.None : (0, t.Some)((0, i.u8)($));
    }
    l.tryIntoU8 = A;
  }(a || (e.u128 = a = {}));
  function* u(l) {
    const d = new r.SeekBuffer(l);
    for (; !d.isFinished(); ) {
      const f = a.tryDecodeVarInt(d);
      if (f === void 0)
        return;
      yield f;
    }
  }
  e.getAllU128 = u;
})(uY);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.u128 = e.u64 = e.u32 = e.u8 = void 0;
  var t = WN;
  Object.defineProperty(e, "u8", { enumerable: !0, get: function() {
    return t.u8;
  } });
  var r = ZN;
  Object.defineProperty(e, "u32", { enumerable: !0, get: function() {
    return r.u32;
  } });
  var n = XN;
  Object.defineProperty(e, "u64", { enumerable: !0, get: function() {
    return n.u64;
  } });
  var o = uY;
  Object.defineProperty(e, "u128", { enumerable: !0, get: function() {
    return o.u128;
  } });
})(bs);
var Yd = {};
Object.defineProperty(Yd, "__esModule", { value: !0 });
Yd.script = Yd.opcodes = void 0;
var uw;
(function(e) {
  function t(o) {
    return o < Rs.OP_PUSHDATA1 ? 1 : o <= 255 ? 2 : o <= 65535 ? 3 : 5;
  }
  e.encodingLength = t;
  function r(o, i, a) {
    const u = t(i);
    return u === 1 ? o.writeUInt8(i, a) : u === 2 ? (o.writeUInt8(Rs.OP_PUSHDATA1, a), o.writeUInt8(i, a + 1)) : u === 3 ? (o.writeUInt8(Rs.OP_PUSHDATA2, a), o.writeUInt16LE(i, a + 1)) : (o.writeUInt8(Rs.OP_PUSHDATA4, a), o.writeUInt32LE(i, a + 1)), u;
  }
  e.encode = r;
  function n(o, i) {
    const a = o.readUInt8(i);
    let u, l;
    if (a < Rs.OP_PUSHDATA1)
      u = a, l = 1;
    else if (a === Rs.OP_PUSHDATA1) {
      if (i + 2 > o.length)
        return null;
      u = o.readUInt8(i + 1), l = 2;
    } else if (a === Rs.OP_PUSHDATA2) {
      if (i + 3 > o.length)
        return null;
      u = o.readUInt16LE(i + 1), l = 3;
    } else {
      if (i + 5 > o.length)
        return null;
      if (a !== Rs.OP_PUSHDATA4)
        throw new Error("Unexpected opcode");
      u = o.readUInt32LE(i + 1), l = 5;
    }
    return {
      opcode: a,
      number: u,
      size: l
    };
  }
  e.decode = n;
})(uw || (uw = {}));
const Rs = {
  OP_FALSE: 0,
  OP_0: 0,
  OP_PUSHDATA1: 76,
  OP_PUSHDATA2: 77,
  OP_PUSHDATA4: 78,
  OP_1NEGATE: 79,
  OP_RESERVED: 80,
  OP_TRUE: 81,
  OP_1: 81,
  OP_2: 82,
  OP_3: 83,
  OP_4: 84,
  OP_5: 85,
  OP_6: 86,
  OP_7: 87,
  OP_8: 88,
  OP_9: 89,
  OP_10: 90,
  OP_11: 91,
  OP_12: 92,
  OP_13: 93,
  OP_14: 94,
  OP_15: 95,
  OP_16: 96,
  OP_NOP: 97,
  OP_VER: 98,
  OP_IF: 99,
  OP_NOTIF: 100,
  OP_VERIF: 101,
  OP_VERNOTIF: 102,
  OP_ELSE: 103,
  OP_ENDIF: 104,
  OP_VERIFY: 105,
  OP_RETURN: 106,
  OP_TOALTSTACK: 107,
  OP_FROMALTSTACK: 108,
  OP_2DROP: 109,
  OP_2DUP: 110,
  OP_3DUP: 111,
  OP_2OVER: 112,
  OP_2ROT: 113,
  OP_2SWAP: 114,
  OP_IFDUP: 115,
  OP_DEPTH: 116,
  OP_DROP: 117,
  OP_DUP: 118,
  OP_NIP: 119,
  OP_OVER: 120,
  OP_PICK: 121,
  OP_ROLL: 122,
  OP_ROT: 123,
  OP_SWAP: 124,
  OP_TUCK: 125,
  OP_CAT: 126,
  OP_SUBSTR: 127,
  OP_LEFT: 128,
  OP_RIGHT: 129,
  OP_SIZE: 130,
  OP_INVERT: 131,
  OP_AND: 132,
  OP_OR: 133,
  OP_XOR: 134,
  OP_EQUAL: 135,
  OP_EQUALVERIFY: 136,
  OP_RESERVED1: 137,
  OP_RESERVED2: 138,
  OP_1ADD: 139,
  OP_1SUB: 140,
  OP_2MUL: 141,
  OP_2DIV: 142,
  OP_NEGATE: 143,
  OP_ABS: 144,
  OP_NOT: 145,
  OP_0NOTEQUAL: 146,
  OP_ADD: 147,
  OP_SUB: 148,
  OP_MUL: 149,
  OP_DIV: 150,
  OP_MOD: 151,
  OP_LSHIFT: 152,
  OP_RSHIFT: 153,
  OP_BOOLAND: 154,
  OP_BOOLOR: 155,
  OP_NUMEQUAL: 156,
  OP_NUMEQUALVERIFY: 157,
  OP_NUMNOTEQUAL: 158,
  OP_LESSTHAN: 159,
  OP_GREATERTHAN: 160,
  OP_LESSTHANOREQUAL: 161,
  OP_GREATERTHANOREQUAL: 162,
  OP_MIN: 163,
  OP_MAX: 164,
  OP_WITHIN: 165,
  OP_RIPEMD160: 166,
  OP_SHA1: 167,
  OP_SHA256: 168,
  OP_HASH160: 169,
  OP_HASH256: 170,
  OP_CODESEPARATOR: 171,
  OP_CHECKSIG: 172,
  OP_CHECKSIGVERIFY: 173,
  OP_CHECKMULTISIG: 174,
  OP_CHECKMULTISIGVERIFY: 175,
  OP_NOP1: 176,
  OP_NOP2: 177,
  OP_CHECKLOCKTIMEVERIFY: 177,
  OP_NOP3: 178,
  OP_CHECKSEQUENCEVERIFY: 178,
  OP_NOP4: 179,
  OP_NOP5: 180,
  OP_NOP6: 181,
  OP_NOP7: 182,
  OP_NOP8: 183,
  OP_NOP9: 184,
  OP_NOP10: 185,
  OP_CHECKSIGADD: 186,
  OP_PUBKEYHASH: 253,
  OP_PUBKEY: 254,
  OP_INVALIDOPCODE: 255
};
Yd.opcodes = Rs;
Rs.OP_RESERVED;
function _j(e) {
  return Buffer.isBuffer(e);
}
var Aj;
(function(e) {
  function t(n) {
    const o = n.reduce((u, l) => _j(l) ? u + uw.encodingLength(l.length) + l.length : u + 1, 0), i = Buffer.allocUnsafe(o);
    let a = 0;
    if (n.forEach((u) => {
      _j(u) ? (a += uw.encode(i, u.length, a), u.copy(i, a), a += u.length) : (i.writeUInt8(u, a), a += 1);
    }), a !== i.length)
      throw new Error("Could not decode chunks");
    return i;
  }
  e.compile = t;
  function* r(n) {
    let o = 0;
    for (; o < n.length; ) {
      const i = n[o];
      if (i >= Rs.OP_0 && i <= Rs.OP_PUSHDATA4) {
        const a = uw.decode(n, o);
        if (a === null || (o += a.size, o + a.number > n.length))
          return !1;
        const u = n.slice(o, o + a.number);
        o += a.number, yield u;
      } else
        yield i, o += 1;
    }
    return !0;
  }
  e.decompile = r;
})(Aj || (Yd.script = Aj = {}));
Object.defineProperty(Dn, "__esModule", { value: !0 });
Dn.TAPROOT_SCRIPT_PUBKEY_TYPE = Dn.COMMIT_CONFIRMATIONS = Dn.TAPROOT_ANNEX_PREFIX = Dn.MAGIC_NUMBER = Dn.OP_RETURN = Dn.MAX_SCRIPT_ELEMENT_SIZE = Dn.SUBSIDY_HALVING_INTERVAL = Dn.RESERVED = Dn.MAX_DIVISIBILITY = void 0;
const cY = bs, lY = Yd;
Dn.MAX_DIVISIBILITY = (0, cY.u8)(38);
Dn.RESERVED = (0, cY.u128)(6402364363415443603228541259936211926n);
Dn.SUBSIDY_HALVING_INTERVAL = 21e4;
Dn.MAX_SCRIPT_ELEMENT_SIZE = 520;
Dn.OP_RETURN = lY.opcodes.OP_RETURN;
Dn.MAGIC_NUMBER = lY.opcodes.OP_13;
Dn.TAPROOT_ANNEX_PREFIX = 80;
Dn.COMMIT_CONFIRMATIONS = 6;
Dn.TAPROOT_SCRIPT_PUBKEY_TYPE = "witness_v1_taproot";
var wv = {};
Object.defineProperty(wv, "__esModule", { value: !0 });
wv.Etching = void 0;
const xj = ws, Fb = bs;
class lPe {
  constructor(t, r, n, o, i, a, u) {
    this.divisibility = t, this.rune = r, this.spacers = n, this.terms = i, this.premine = a, this.turbo = u, this.symbol = o.andThen((l) => {
      const d = l.codePointAt(0);
      return d !== void 0 ? (0, xj.Some)(String.fromCodePoint(d)) : xj.None;
    });
  }
  get supply() {
    const t = this.premine.unwrapOr((0, Fb.u128)(0)), r = this.terms.andThen((o) => o.cap).unwrapOr((0, Fb.u128)(0)), n = this.terms.andThen((o) => o.amount).unwrapOr((0, Fb.u128)(0));
    return Fb.u128.checkedMultiply(r, n).andThen((o) => Fb.u128.checkedAdd(t, o));
  }
}
wv.Etching = lPe;
var Kg = {};
Object.defineProperty(Kg, "__esModule", { value: !0 });
Kg.Flaw = void 0;
var kj;
(function(e) {
  e[e.EDICT_OUTPUT = 0] = "EDICT_OUTPUT", e[e.EDICT_RUNE_ID = 1] = "EDICT_RUNE_ID", e[e.INVALID_SCRIPT = 2] = "INVALID_SCRIPT", e[e.OPCODE = 3] = "OPCODE", e[e.SUPPLY_OVERFLOW = 4] = "SUPPLY_OVERFLOW", e[e.TRAILING_INTEGERS = 5] = "TRAILING_INTEGERS", e[e.TRUNCATED_FIELD = 6] = "TRUNCATED_FIELD", e[e.UNRECOGNIZED_EVEN_TAG = 7] = "UNRECOGNIZED_EVEN_TAG", e[e.UNRECOGNIZED_FLAG = 8] = "UNRECOGNIZED_FLAG", e[e.VARINT = 9] = "VARINT";
})(kj || (Kg.Flaw = kj = {}));
var qg = {};
Object.defineProperty(qg, "__esModule", { value: !0 });
qg.RuneId = void 0;
const gd = ws, gc = bs;
class cw {
  constructor(t, r) {
    this.block = t, this.tx = r;
  }
  static new(t, r) {
    const n = new cw(t, r);
    return n.block === 0n && n.tx > 0 ? gd.None : (0, gd.Some)(n);
  }
  static sort(t) {
    return [...t].sort((r, n) => Number(r.block - n.block || r.tx - n.tx));
  }
  delta(t) {
    const r = gc.u64.checkedSub(t.block, this.block);
    if (r.isNone())
      return gd.None;
    const n = r.unwrap();
    let o;
    if (n === 0n) {
      const i = gc.u32.checkedSub(t.tx, this.tx);
      if (i.isNone())
        return gd.None;
      o = i.unwrap();
    } else
      o = t.tx;
    return (0, gd.Some)([(0, gc.u128)(n), (0, gc.u128)(o)]);
  }
  next(t, r) {
    const n = gc.u128.tryIntoU64(t), o = gc.u128.tryIntoU32(r);
    if (n.isNone() || o.isNone())
      return gd.None;
    const i = n.unwrap(), a = o.unwrap(), u = gc.u64.checkedAdd(this.block, i);
    if (u.isNone())
      return gd.None;
    let l;
    if (i === 0n) {
      const d = gc.u32.checkedAdd(this.tx, a);
      if (d.isNone())
        return gd.None;
      l = d.unwrap();
    } else
      l = a;
    return cw.new(u.unwrap(), l);
  }
  toString() {
    return `${this.block}:${this.tx}`;
  }
  static fromString(t) {
    const r = t.split(":");
    if (r.length !== 2)
      throw new Error(`invalid rune ID: ${t}`);
    const [n, o] = r;
    if (!/^\d+$/.test(n) || !/^\d+$/.test(o))
      throw new Error(`invalid rune ID: ${t}`);
    return new cw((0, gc.u64)(BigInt(n)), (0, gc.u32)(BigInt(o)));
  }
}
qg.RuneId = cw;
var YN = {}, Vg = {};
Object.defineProperty(Vg, "__esModule", { value: !0 });
Vg.Tag = void 0;
const w8 = ws, V0 = bs;
var I5;
(function(e) {
  e[e.BODY = 0] = "BODY", e[e.FLAGS = 2] = "FLAGS", e[e.RUNE = 4] = "RUNE", e[e.PREMINE = 6] = "PREMINE", e[e.CAP = 8] = "CAP", e[e.AMOUNT = 10] = "AMOUNT", e[e.HEIGHT_START = 12] = "HEIGHT_START", e[e.HEIGHT_END = 14] = "HEIGHT_END", e[e.OFFSET_START = 16] = "OFFSET_START", e[e.OFFSET_END = 18] = "OFFSET_END", e[e.MINT = 20] = "MINT", e[e.POINTER = 22] = "POINTER", e[e.CENOTAPH = 126] = "CENOTAPH", e[e.DIVISIBILITY = 1] = "DIVISIBILITY", e[e.SPACERS = 3] = "SPACERS", e[e.SYMBOL = 5] = "SYMBOL", e[e.NOP = 127] = "NOP";
})(I5 || (Vg.Tag = I5 = {}));
(function(e) {
  function t(o, i, a, u) {
    const l = i.get((0, V0.u128)(o));
    if (l === void 0)
      return w8.None;
    const d = [];
    for (const h of [...Array(a).keys()]) {
      if (l[h] === void 0)
        return w8.None;
      d[h] = l[h];
    }
    const f = u(d);
    return f.isNone() ? w8.None : (l.splice(0, a), l.length === 0 && i.delete((0, V0.u128)(o)), (0, w8.Some)(f.unwrap()));
  }
  e.take = t;
  function r(o, i) {
    return Buffer.concat(i.map((a) => [V0.u128.encodeVarInt((0, V0.u128)(o)), V0.u128.encodeVarInt(a)]).flat());
  }
  e.encode = r;
  function n(o, i) {
    return i.map((a) => e.encode(o, [(0, V0.u128)(a)])).unwrapOr(Buffer.alloc(0));
  }
  e.encodeOptionInt = n;
})(I5 || (Vg.Tag = I5 = {}));
var Gg = {}, z0 = {};
Object.defineProperty(z0, "__esModule", { value: !0 });
z0.Network = void 0;
const v8 = Dn;
var O5;
(function(e) {
  e[e.MAINNET = 0] = "MAINNET", e[e.SIGNET = 1] = "SIGNET", e[e.TESTNET = 2] = "TESTNET", e[e.REGTEST = 3] = "REGTEST";
})(O5 || (z0.Network = O5 = {}));
(function(e) {
  function t(r) {
    switch (r) {
      case e.MAINNET:
        return v8.SUBSIDY_HALVING_INTERVAL * 4;
      case e.REGTEST:
        return v8.SUBSIDY_HALVING_INTERVAL * 0;
      case e.SIGNET:
        return v8.SUBSIDY_HALVING_INTERVAL * 0;
      case e.TESTNET:
        return v8.SUBSIDY_HALVING_INTERVAL * 12;
    }
  }
  e.getFirstRuneHeight = t;
})(O5 || (z0.Network = O5 = {}));
Object.defineProperty(Gg, "__esModule", { value: !0 });
Gg.Rune = void 0;
const fPe = z0, E8 = Dn, $t = bs;
class wu {
  constructor(t) {
    this.value = t;
  }
  static getMinimumAtHeight(t, r) {
    let n = $t.u128.saturatingAdd(r, (0, $t.u128)(1));
    const o = (0, $t.u128)(E8.SUBSIDY_HALVING_INTERVAL / 12);
    let i = (0, $t.u128)(fPe.Network.getFirstRuneHeight(t)), a = $t.u128.saturatingAdd(i, (0, $t.u128)(E8.SUBSIDY_HALVING_INTERVAL));
    if (n < i)
      return new wu(wu.STEPS[12]);
    if (n >= a)
      return new wu((0, $t.u128)(0));
    let u = $t.u128.saturatingSub(n, i), l = $t.u128.saturatingSub((0, $t.u128)(12n), (0, $t.u128)(u / o)), d = Number(l & (0, $t.u128)($t.u32.MAX)), f = wu.STEPS[d], h = wu.STEPS[d - 1], g = (0, $t.u128)(u % o);
    return new wu((0, $t.u128)(f - (f - h) * g / o));
  }
  get reserved() {
    return this.value >= E8.RESERVED;
  }
  get commitment() {
    const t = Buffer.alloc(16);
    t.writeBigUInt64LE(0xffffffffffffffffn & this.value, 0), t.writeBigUInt64LE(this.value >> 64n, 8);
    let r = t.length;
    for (; r > 0 && t.at(r - 1) === 0; )
      r--;
    return t.subarray(0, r);
  }
  static getReserved(t, r) {
    return new wu($t.u128.checkedAdd(E8.RESERVED, (0, $t.u128)(t << 32n | r)).unwrap());
  }
  toString() {
    let t = this.value;
    if (t === $t.u128.MAX)
      return "BCGDENLQRQWDSLRUGSNLBTMFIJAV";
    t = (0, $t.u128)(t + 1n);
    let r = "";
    for (; t > 0; )
      r = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"[Number((t - 1n) % 26n)] + r, t = (0, $t.u128)((t - 1n) / 26n);
    return r;
  }
  static fromString(t) {
    let r = (0, $t.u128)(0);
    for (const n of [...Array(t.length).keys()]) {
      const o = t[n];
      if (n > 0 && (r = (0, $t.u128)(r + 1n)), r = $t.u128.checkedMultiply(r, (0, $t.u128)(26)).unwrap(), "A" <= o && o <= "Z")
        r = $t.u128.checkedAdd(r, (0, $t.u128)(o.charCodeAt(0) - 65)).unwrap();
      else
        throw new Error(`invalid character in rune name: ${o}`);
    }
    return new wu(r);
  }
}
Gg.Rune = wu;
wu.STEPS = [
  (0, $t.u128)(0n),
  (0, $t.u128)(26n),
  (0, $t.u128)(702n),
  (0, $t.u128)(18278n),
  (0, $t.u128)(475254n),
  (0, $t.u128)(12356630n),
  (0, $t.u128)(321272406n),
  (0, $t.u128)(8353082582n),
  (0, $t.u128)(217180147158n),
  (0, $t.u128)(5646683826134n),
  (0, $t.u128)(146813779479510n),
  (0, $t.u128)(3817158266467286n),
  (0, $t.u128)(99246114928149462n),
  (0, $t.u128)(2580398988131886038n),
  (0, $t.u128)(67090373691429037014n),
  (0, $t.u128)(1744349715977154962390n),
  (0, $t.u128)(45353092615406029022166n),
  (0, $t.u128)(1179180408000556754576342n),
  (0, $t.u128)(30658690608014475618984918n),
  (0, $t.u128)(797125955808376366093607894n),
  (0, $t.u128)(20725274851017785518433805270n),
  (0, $t.u128)(538857146126462423479278937046n),
  (0, $t.u128)(14010285799288023010461252363222n),
  (0, $t.u128)(364267430781488598271992561443798n),
  (0, $t.u128)(9470953200318703555071806597538774n),
  (0, $t.u128)(246244783208286292431866971536008150n),
  (0, $t.u128)(6402364363415443603228541259936211926n),
  (0, $t.u128)(166461473448801533683942072758341510102n)
];
var vv = {};
Object.defineProperty(vv, "__esModule", { value: !0 });
vv.Flag = void 0;
const iI = bs;
var P5;
(function(e) {
  e[e.ETCHING = 0] = "ETCHING", e[e.TERMS = 1] = "TERMS", e[e.TURBO = 2] = "TURBO", e[e.CENOTAPH = 127] = "CENOTAPH";
})(P5 || (vv.Flag = P5 = {}));
(function(e) {
  function t(o) {
    return (0, iI.u128)(1n << BigInt(o));
  }
  e.mask = t;
  function r(o, i) {
    const a = e.mask(i), u = (o & a) !== 0n;
    return { set: u, flags: u ? (0, iI.u128)(o - a) : o };
  }
  e.take = r;
  function n(o, i) {
    return (0, iI.u128)(o | e.mask(i));
  }
  e.set = n;
})(P5 || (vv.Flag = P5 = {}));
var HE = {};
Object.defineProperty(HE, "__esModule", { value: !0 });
HE.Instruction = void 0;
var Sj;
(function(e) {
  function t(n) {
    return typeof n == "number";
  }
  e.isNumber = t;
  function r(n) {
    return typeof n != "number";
  }
  e.isBuffer = r;
})(Sj || (HE.Instruction = Sj = {}));
var FE = {}, ME = {};
Object.defineProperty(ME, "__esModule", { value: !0 });
ME.Edict = void 0;
const _8 = ws, dPe = bs;
var Tj;
(function(e) {
  function t(r, n, o, i) {
    if (n.block === 0n && n.tx > 0n)
      return _8.None;
    const a = dPe.u128.tryIntoU32(i);
    if (a.isNone())
      return _8.None;
    const u = a.unwrap();
    return u > r ? _8.None : (0, _8.Some)({ id: n, amount: o, output: u });
  }
  e.fromIntegers = t;
})(Tj || (ME.Edict = Tj = {}));
Object.defineProperty(FE, "__esModule", { value: !0 });
FE.Message = void 0;
const hPe = ME, A8 = Kg, aI = bs, pPe = qg, gPe = Vg;
class JN {
  constructor(t, r, n) {
    this.flaws = t, this.edicts = r, this.fields = n;
  }
  static fromIntegers(t, r) {
    const n = [], o = /* @__PURE__ */ new Map(), i = [];
    for (const a of [...Array(Math.ceil(r.length / 2)).keys()].map((u) => u * 2)) {
      const u = r[a];
      if ((0, aI.u128)(gPe.Tag.BODY) === u) {
        let f = new pPe.RuneId((0, aI.u64)(0), (0, aI.u32)(0));
        const h = 4, g = r.slice(a + 1);
        for (let b = 0; b < g.length; b += h) {
          const w = g.slice(b, b + h);
          if (w.length !== h) {
            i.push(A8.Flaw.TRAILING_INTEGERS);
            break;
          }
          const E = f.next(w[0], w[1]);
          if (E.isNone()) {
            i.push(A8.Flaw.EDICT_RUNE_ID);
            break;
          }
          const _ = E.unwrap(), O = hPe.Edict.fromIntegers(t, _, w[2], w[3]);
          if (O.isNone()) {
            i.push(A8.Flaw.EDICT_OUTPUT);
            break;
          }
          const C = O.unwrap();
          f = _, n.push(C);
        }
        break;
      }
      const l = r[a + 1];
      if (l === void 0) {
        i.push(A8.Flaw.TRUNCATED_FIELD);
        break;
      }
      const d = o.get(u) ?? [];
      d.push(l), o.set(u, d);
    }
    return new JN(i, n, o);
  }
}
FE.Message = JN;
var DE = {};
Object.defineProperty(DE, "__esModule", { value: !0 });
DE.Cenotaph = void 0;
const Ij = ws;
class mPe {
  constructor(t, r = Ij.None, n = Ij.None) {
    this.flaws = t, this.etching = r, this.mint = n;
  }
}
DE.Cenotaph = mPe;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Runestone = e.isValidPayload = e.MAX_SPACERS = void 0;
  const t = Dn, r = wv, n = bv, o = Vg, i = bs, a = ws, u = Gg, l = vv, d = HE, f = qg, h = Yd, g = FE, b = Kg, w = DE;
  e.MAX_SPACERS = 134217727;
  function E(O) {
    return Buffer.isBuffer(O);
  }
  e.isValidPayload = E;
  class _ {
    constructor(C, I, S, T) {
      this.mint = C, this.pointer = I, this.edicts = S, this.etching = T;
    }
    static decipher(C) {
      const I = _.payload(C);
      if (I.isNone())
        return a.None;
      const S = I.unwrap();
      if (!E(S))
        return (0, a.Some)(new w.Cenotaph([S]));
      const T = _.integers(S);
      if (T.isNone())
        return (0, a.Some)(new w.Cenotaph([b.Flaw.VARINT]));
      const { flaws: A, edicts: $, fields: U } = g.Message.fromIntegers(C.vout.length, T.unwrap());
      let M = o.Tag.take(o.Tag.FLAGS, U, 1, ([D]) => (0, a.Some)(D)).unwrapOr((0, i.u128)(0));
      const Y = l.Flag.take(M, l.Flag.ETCHING), L = Y.set;
      M = Y.flags;
      const ee = L ? (() => {
        const D = o.Tag.take(o.Tag.DIVISIBILITY, U, 1, ([ve]) => i.u128.tryIntoU8(ve).andThen((Ee) => Ee <= t.MAX_DIVISIBILITY ? (0, a.Some)(Ee) : a.None)), K = o.Tag.take(o.Tag.RUNE, U, 1, ([ve]) => (0, a.Some)(new u.Rune(ve))), le = o.Tag.take(o.Tag.SPACERS, U, 1, ([ve]) => i.u128.tryIntoU32(ve).andThen((Ee) => Ee <= e.MAX_SPACERS ? (0, a.Some)(Ee) : a.None)), re = o.Tag.take(o.Tag.SYMBOL, U, 1, ([ve]) => i.u128.tryIntoU32(ve).andThen((Ee) => {
          try {
            return (0, a.Some)(String.fromCodePoint(Number(Ee)));
          } catch {
            return a.None;
          }
        })), G = l.Flag.take(M, l.Flag.TERMS), q = G.set;
        M = G.flags;
        const Q = q ? (() => {
          const ve = o.Tag.take(o.Tag.AMOUNT, U, 1, ([be]) => (0, a.Some)(be)), Ee = o.Tag.take(o.Tag.CAP, U, 1, ([be]) => (0, a.Some)(be)), _e = [
            o.Tag.take(o.Tag.OFFSET_START, U, 1, ([be]) => i.u128.tryIntoU64(be)),
            o.Tag.take(o.Tag.OFFSET_END, U, 1, ([be]) => i.u128.tryIntoU64(be))
          ], we = [
            o.Tag.take(o.Tag.HEIGHT_START, U, 1, ([be]) => i.u128.tryIntoU64(be)),
            o.Tag.take(o.Tag.HEIGHT_END, U, 1, ([be]) => i.u128.tryIntoU64(be))
          ];
          return (0, a.Some)({ amount: ve, cap: Ee, offset: _e, height: we });
        })() : a.None, se = o.Tag.take(o.Tag.PREMINE, U, 1, ([ve]) => (0, a.Some)(ve)), J = l.Flag.take(M, l.Flag.TURBO), ye = Y.set;
        return M = J.flags, (0, a.Some)(new r.Etching(D, K, le, re, Q, se, ye));
      })() : a.None, de = o.Tag.take(o.Tag.MINT, U, 2, ([D, K]) => {
        const le = i.u128.tryIntoU64(D), re = i.u128.tryIntoU32(K);
        return le.isNone() || re.isNone() ? a.None : f.RuneId.new(le.unwrap(), re.unwrap());
      }), ne = o.Tag.take(o.Tag.POINTER, U, 1, ([D]) => i.u128.tryIntoU32(D).andThen((K) => K < C.vout.length ? (0, a.Some)(K) : a.None));
      return ee.map((D) => D.supply.isNone()).unwrapOr(!1) && A.push(b.Flaw.SUPPLY_OVERFLOW), M !== 0n && A.push(b.Flaw.UNRECOGNIZED_FLAG), [...U.keys()].find((D) => D % 2n === 0n) !== void 0 && A.push(b.Flaw.UNRECOGNIZED_EVEN_TAG), A.length !== 0 ? (0, a.Some)(new w.Cenotaph(A, ee.andThen((D) => D.rune), de)) : (0, a.Some)(new _(de, ne, $, ee));
    }
    encipher() {
      const C = [];
      if (this.etching.isSome()) {
        const T = this.etching.unwrap();
        let A = (0, i.u128)(0);
        if (A = l.Flag.set(A, l.Flag.ETCHING), T.terms.isSome() && (A = l.Flag.set(A, l.Flag.TERMS)), T.turbo && (A = l.Flag.set(A, l.Flag.TURBO)), C.push(o.Tag.encode(o.Tag.FLAGS, [A])), C.push(o.Tag.encodeOptionInt(o.Tag.RUNE, T.rune.map(($) => $.value))), C.push(o.Tag.encodeOptionInt(o.Tag.DIVISIBILITY, T.divisibility.map(i.u128))), C.push(o.Tag.encodeOptionInt(o.Tag.SPACERS, T.spacers.map(i.u128))), C.push(o.Tag.encodeOptionInt(o.Tag.SYMBOL, T.symbol.map(($) => (0, i.u128)($.codePointAt(0))))), C.push(o.Tag.encodeOptionInt(o.Tag.PREMINE, T.premine)), T.terms.isSome()) {
          const $ = T.terms.unwrap();
          C.push(o.Tag.encodeOptionInt(o.Tag.AMOUNT, $.amount)), C.push(o.Tag.encodeOptionInt(o.Tag.CAP, $.cap)), C.push(o.Tag.encodeOptionInt(o.Tag.HEIGHT_START, $.height[0])), C.push(o.Tag.encodeOptionInt(o.Tag.HEIGHT_END, $.height[1])), C.push(o.Tag.encodeOptionInt(o.Tag.OFFSET_START, $.offset[0])), C.push(o.Tag.encodeOptionInt(o.Tag.OFFSET_END, $.offset[1]));
        }
      }
      if (this.mint.isSome()) {
        const T = this.mint.unwrap();
        C.push(o.Tag.encode(o.Tag.MINT, [T.block, T.tx].map(i.u128)));
      }
      if (C.push(o.Tag.encodeOptionInt(o.Tag.POINTER, this.pointer.map(i.u128))), this.edicts.length) {
        C.push(i.u128.encodeVarInt((0, i.u128)(o.Tag.BODY)));
        const T = [...this.edicts].sort(($, U) => Number($.id.block - U.id.block || $.id.tx - U.id.tx));
        let A = new f.RuneId((0, i.u64)(0), (0, i.u32)(0));
        for (const $ of T) {
          const [U, M] = A.delta($.id).unwrap();
          C.push(i.u128.encodeVarInt(U)), C.push(i.u128.encodeVarInt(M)), C.push(i.u128.encodeVarInt($.amount)), C.push(i.u128.encodeVarInt((0, i.u128)($.output))), A = $.id;
        }
      }
      const I = [];
      I.push(t.OP_RETURN), I.push(t.MAGIC_NUMBER);
      const S = Buffer.concat(C);
      for (let T = 0; T < S.length; T += t.MAX_SCRIPT_ELEMENT_SIZE)
        I.push(S.subarray(T, T + t.MAX_SCRIPT_ELEMENT_SIZE));
      return h.script.compile(I);
    }
    static payload(C) {
      for (const I of C.vout) {
        const S = h.script.decompile(Buffer.from(I.scriptPubKey.hex, "hex"));
        if (S === null)
          throw new Error("unable to decompile");
        let T = S.next();
        if (T.done || T.value !== t.OP_RETURN || (T = S.next(), T.done || d.Instruction.isBuffer(T.value) || T.value !== t.MAGIC_NUMBER))
          continue;
        let A = [];
        do {
          if (T = S.next(), T.done) {
            if (!T.value)
              return (0, a.Some)(b.Flaw.INVALID_SCRIPT);
            break;
          }
          const $ = T.value;
          if (d.Instruction.isBuffer($))
            A.push($);
          else
            return (0, a.Some)(b.Flaw.OPCODE);
        } while (!0);
        return (0, a.Some)(Buffer.concat(A));
      }
      return a.None;
    }
    static integers(C) {
      const I = [], S = new n.SeekBuffer(C);
      for (; !S.isFinished(); ) {
        const T = i.u128.decodeVarInt(S);
        if (T.isNone())
          return a.None;
        I.push(T.unwrap());
      }
      return (0, a.Some)(I);
    }
  }
  e.Runestone = _;
})(YN);
var Ev = {};
Object.defineProperty(Ev, "__esModule", { value: !0 });
Ev.SpacedRune = void 0;
const yPe = Gg;
class QN {
  constructor(t, r) {
    this.rune = t, this.spacers = r;
  }
  static fromString(t) {
    let r = "", n = 0;
    for (const o of t)
      if ("A" <= o && o <= "Z")
        r += o;
      else if (o === "." || o === "•") {
        if (r.length === 0)
          throw new Error("leading spacer");
        const i = 1 << r.length - 1;
        if (n & i)
          throw new Error("double spacer");
        n |= i;
      } else
        throw new Error("invalid character");
    if (n >= 1 << r.length - 1)
      throw new Error("trailing spacer");
    return new QN(yPe.Rune.fromString(r), n);
  }
  toString() {
    const t = this.rune.toString();
    let r = 0, n = "";
    for (const o of t)
      n += o, r < t.length - 1 && this.spacers & 1 << r && (n += "•"), r++;
    return n;
  }
}
Ev.SpacedRune = QN;
var fY = {}, d2 = {}, _v = {};
Object.defineProperty(_v, "__esModule", { value: !0 });
_v.RuneLocation = void 0;
var Oj;
(function(e) {
  function t(r) {
    return `${r.block}:${r.tx}`;
  }
  e.toString = t;
})(Oj || (_v.RuneLocation = Oj = {}));
Object.defineProperty(d2, "__esModule", { value: !0 });
d2.RuneUpdater = void 0;
const Mb = yv, X8 = Dn, yr = bs, Ja = ws, Pj = Gg, bPe = YN, wPe = Yd, Cj = Ev, Fl = _v;
function sI(e) {
  return e && Buffer.from(e, "hex")[0] === X8.OP_RETURN;
}
class vPe {
  constructor(t, r, n, o, i) {
    this.reorg = n, this._storage = o, this._rpc = i, this.etchings = [], this.utxoBalances = [], this.spentBalances = [], this._mintCountsByRuneLocation = /* @__PURE__ */ new Map(), this._burnedBalancesByRuneLocation = /* @__PURE__ */ new Map(), this.block = {
      height: r.height,
      hash: r.hash,
      previousblockhash: r.previousblockhash,
      time: r.time
    }, this._minimum = Pj.Rune.getMinimumAtHeight(t, (0, yr.u128)(r.height));
  }
  get mintCounts() {
    return [...this._mintCountsByRuneLocation.values()];
  }
  get burnedBalances() {
    return [...this._burnedBalancesByRuneLocation.values()];
  }
  async indexRunes(t, r) {
    const n = bPe.Runestone.decipher(t), o = await this.unallocated(t), i = [...new Array(t.vout.length)].map(() => /* @__PURE__ */ new Map());
    function a(f) {
      const h = Fl.RuneLocation.toString(f), g = o.get(h) ?? { runeId: f, amount: 0n };
      return o.set(h, g), g;
    }
    function u(f, h) {
      const g = Fl.RuneLocation.toString(h), b = i[f].get(g) ?? { runeId: h, amount: 0n };
      return i[f].set(g, b), b;
    }
    if (n.isSome()) {
      const f = n.unwrap(), h = f.mint;
      if (h.isSome()) {
        const b = h.unwrap(), w = {
          block: Number(b.block),
          tx: Number(b.tx)
        }, E = await this.mint(w, t.txid);
        if (E.isSome()) {
          const _ = E.unwrap(), O = a(w);
          O.amount = yr.u128.checkedAddThrow((0, yr.u128)(O.amount), (0, yr.u128)(_));
        }
      }
      const g = await this.etched(r, t, f);
      if ((0, Mb.isRunestone)(f)) {
        const b = f;
        if (g.isSome()) {
          const w = g.unwrap(), E = a(w.runeId);
          E.amount = yr.u128.checkedAddThrow((0, yr.u128)(E.amount), b.etching.unwrap().premine.unwrapOr((0, yr.u128)(0)));
        }
        for (const { id: w, amount: E, output: _ } of [...b.edicts]) {
          if (_ > t.vout.length)
            throw new Error("Runestone edict output should never exceed transaction output size");
          if (w.block === 0n && w.tx === 0n && g.isNone())
            continue;
          const O = w.block === 0n && w.tx === 0n ? g.unwrap().runeId : { block: Number(w.block), tx: Number(w.tx) }, C = Fl.RuneLocation.toString(O), I = o.get(C);
          if (I === void 0)
            continue;
          let S = (T, A) => {
            if (T > 0n) {
              const $ = u(A, O);
              I.amount = yr.u128.checkedSubThrow((0, yr.u128)(I.amount), T), $.amount = yr.u128.checkedAddThrow((0, yr.u128)($.amount), T);
            }
          };
          if (Number(_) === t.vout.length) {
            const T = [...t.vout.entries()].filter(([A, $]) => !sI($.scriptPubKey.hex)).map(([A]) => A);
            if (T.length !== 0)
              if (E === 0n) {
                const A = (0, yr.u128)((0, yr.u128)(I.amount) / (0, yr.u128)(T.length)), $ = (0, yr.u128)(I.amount) % (0, yr.u128)(T.length);
                for (const [U, M] of T.entries())
                  S(U < $ ? yr.u128.checkedAddThrow(A, (0, yr.u128)(1)) : A, M);
              } else
                for (const A of T)
                  S(E < I.amount ? E : (0, yr.u128)(I.amount), A);
          } else
            S(E !== 0n && E < (0, yr.u128)(I.amount) ? E : (0, yr.u128)(I.amount), Number(_));
        }
      }
      if (g.isSome()) {
        const { runeId: b, rune: w } = g.unwrap();
        this.createEtching(t.txid, f, b, w);
      }
    }
    const l = /* @__PURE__ */ new Map();
    function d(f) {
      const h = Fl.RuneLocation.toString(f), g = l.get(h) ?? { runeId: f, amount: 0n };
      return l.set(h, g), g;
    }
    if (n.isSome() && !(0, Mb.isRunestone)(n.unwrap()))
      for (const f of o.values()) {
        const h = d(f.runeId);
        h.amount = yr.u128.checkedAddThrow((0, yr.u128)(h.amount), (0, yr.u128)(f.amount));
      }
    else {
      const f = n.map((h) => {
        if (!(0, Mb.isRunestone)(h))
          throw new Error("unreachable");
        return h.pointer;
      }).unwrapOr(Ja.None).map((h) => Number(h)).inspect((h) => {
        if (h < 0 || h >= i.length)
          throw new Error("Pointer is invalid");
      }).orElse(() => {
        const h = [...t.vout.entries()].find(([g, b]) => !sI(b.scriptPubKey.hex));
        return h !== void 0 ? (0, Ja.Some)(h[0]) : Ja.None;
      });
      if (f.isSome()) {
        const h = f.unwrap();
        for (const g of o.values())
          if (g.amount > 0) {
            const b = u(h, g.runeId);
            b.amount = yr.u128.checkedAddThrow((0, yr.u128)(b.amount), (0, yr.u128)(g.amount));
          }
      } else
        for (const [h, g] of o)
          if (g.amount > 0) {
            const b = d(g.runeId);
            l.set(h, {
              runeId: g.runeId,
              amount: yr.u128.checkedAddThrow((0, yr.u128)(b.amount), (0, yr.u128)(g.amount))
            });
          }
    }
    for (const [f, h] of i.entries()) {
      if (h.size === 0)
        continue;
      const g = t.vout[f];
      if (sI(g.scriptPubKey.hex)) {
        for (const [w, E] of h) {
          const _ = d(E.runeId);
          _.amount = yr.u128.checkedAddThrow((0, yr.u128)(_.amount), (0, yr.u128)(E.amount));
        }
        continue;
      }
      const b = new Map(this.etchings.map((w) => [Fl.RuneLocation.toString(w.runeId), w]));
      for (const w of h.values()) {
        const E = Fl.RuneLocation.toString(w.runeId), _ = b.get(E) ?? await this._storage.getEtching(E);
        if (_ === null)
          throw new Error("Rune should exist at this point");
        this.utxoBalances.push({
          runeId: w.runeId,
          runeTicker: _.runeTicker,
          amount: w.amount,
          scriptPubKey: Buffer.from(g.scriptPubKey.hex),
          txid: t.txid,
          vout: f,
          address: g.scriptPubKey.address
        });
      }
    }
    for (const [f, h] of l)
      this._burnedBalancesByRuneLocation.set(f, h);
  }
  async etched(t, r, n) {
    let o;
    if ((0, Mb.isRunestone)(n)) {
      const a = n;
      if (a.etching.isNone())
        return Ja.None;
      o = a.etching.unwrap().rune;
    } else {
      const a = n;
      if (a.etching.isNone())
        return Ja.None;
      o = a.etching;
    }
    let i;
    if (o.isSome()) {
      if (i = o.unwrap(), i.value < this._minimum.value || i.reserved || this.etchings.find((u) => Cj.SpacedRune.fromString(u.runeName).rune.toString() === i.toString()))
        return Ja.None;
      const a = await this._storage.getRuneLocation(i.toString());
      if (a && a.block < this.block.height || !await this.txCommitsToRune(r, i))
        return Ja.None;
    } else
      i = Pj.Rune.getReserved((0, yr.u64)(this.block.height), (0, yr.u32)(t));
    return (0, Ja.Some)({
      runeId: {
        block: this.block.height,
        tx: t
      },
      rune: i
    });
  }
  async mint(t, r) {
    var n, o, i, a;
    const u = Fl.RuneLocation.toString(t), l = new Map(this.etchings.map((I) => [Fl.RuneLocation.toString(I.runeId), I])).get(u) ?? await this._storage.getEtching(u);
    if (l === null || !l.valid || !l.terms)
      return Ja.None;
    const d = l.terms, f = ((n = d.offset) == null ? void 0 : n.start) !== void 0 ? l.runeId.block + Number(d.offset.start) : null, h = ((o = d.height) == null ? void 0 : o.start) !== void 0 ? Number(d.height.start) : null, g = f !== null || h !== null ? Math.max(f ?? -1 / 0, h ?? -1 / 0) : null;
    if (g !== null && this.block.height < g)
      return Ja.None;
    const b = ((i = d.offset) == null ? void 0 : i.end) !== void 0 ? l.runeId.block + Number(d.offset.end) : null, w = ((a = d.height) == null ? void 0 : a.end) !== void 0 ? Number(d.height.end) : null, E = b !== null || w !== null ? Math.max(b ?? -1 / 0, w ?? -1 / 0) : null;
    if (E !== null && this.block.height >= E)
      return Ja.None;
    const _ = d.cap ?? 0n, O = this._mintCountsByRuneLocation.get(u) ?? {
      mint: t,
      count: 0
    };
    if (this._mintCountsByRuneLocation.set(u, O), O.count + await this._storage.getValidMintCount(u, this.block.height - 1) >= _)
      return Ja.None;
    const C = d.amount ?? 0n;
    return O.count++, (0, Ja.Some)(C);
  }
  async unallocated(t) {
    const r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
    for (const o of this.utxoBalances) {
      const i = `${o.txid}:${o.vout}`, a = n.get(i) ?? [];
      a.push(o), n.set(i, a);
    }
    for (const o of t.vin) {
      if ("coinbase" in o)
        continue;
      const i = n.get(`${o.txid}:${o.vout}`) ?? await this._storage.getUtxoBalance(o.txid, o.vout);
      for (const a of i) {
        const u = a.runeId, l = Fl.RuneLocation.toString(u), d = r.get(l) ?? { runeId: u, amount: 0n };
        r.set(l, d), d.amount = yr.u128.checkedAddThrow((0, yr.u128)(d.amount), (0, yr.u128)(a.amount)), this.spentBalances.push({
          txid: o.txid,
          vout: o.vout,
          address: a.address,
          scriptPubKey: a.scriptPubKey,
          runeId: a.runeId,
          runeTicker: a.runeTicker,
          amount: a.amount,
          spentTxid: t.txid
        });
      }
    }
    return r;
  }
  async txCommitsToRune(t, r) {
    const n = r.commitment;
    for (const o of t.vin) {
      if ("coinbase" in o)
        continue;
      const i = o.txinwitness.map((f) => Buffer.from(f, "hex")), a = i[i.length - 1], u = i.length >= 2 && a[0] === X8.TAPROOT_ANNEX_PREFIX ? 3 : 2;
      if (u > i.length)
        continue;
      const l = i[i.length - u];
      if (l === void 0)
        continue;
      const d = wPe.script.decompile(l);
      for (const f of d) {
        if (!Buffer.isBuffer(f) || Buffer.compare(f, n) !== 0)
          continue;
        const h = await this._rpc.getrawtransaction({
          txid: o.txid,
          verbose: !0
        });
        if (h.error !== null)
          throw h.error;
        const g = h.result;
        if (g.vout[o.vout].scriptPubKey.type !== X8.TAPROOT_SCRIPT_PUBKEY_TYPE)
          continue;
        const b = await this._rpc.getblock({ blockhash: g.blockhash });
        if (b.error !== null)
          throw b.error;
        const w = b.result.height;
        if (yr.u128.checkedSubThrow((0, yr.u128)(this.block.height), (0, yr.u128)(w)) + 1n >= X8.COMMIT_CONFIRMATIONS)
          return !0;
      }
    }
    return !1;
  }
  createEtching(t, r, n, o) {
    if ((0, Mb.isRunestone)(r)) {
      const { divisibility: i, terms: a, premine: u, spacers: l, symbol: d } = r.etching.unwrap();
      this.etchings.push({
        valid: !0,
        runeTicker: o.toString(),
        runeName: new Cj.SpacedRune(o, Number(l.map(Number).unwrapOr(0))).toString(),
        runeId: n,
        txid: t,
        ...i.isSome() ? { divisibility: i.map(Number).unwrap() } : {},
        ...u.isSome() ? { premine: u.unwrap() } : {},
        ...d.isSome() ? { symbol: d.unwrap() } : {},
        ...a.isSome() ? {
          terms: (() => {
            const f = a.unwrap();
            return {
              ...f.amount.isSome() ? { amount: f.amount.unwrap() } : {},
              ...f.cap.isSome() ? { cap: f.cap.unwrap() } : {},
              ...f.height.filter((h) => h.isSome()).length ? {
                height: {
                  ...f.height[0].isSome() ? { start: f.height[0].unwrap() } : {},
                  ...f.height[1].isSome() ? { end: f.height[1].unwrap() } : {}
                }
              } : {},
              ...f.offset.filter((h) => h.isSome()).length ? {
                offset: {
                  ...f.offset[0].isSome() ? { start: f.offset[0].unwrap() } : {},
                  ...f.offset[1].isSome() ? { end: f.offset[1].unwrap() } : {}
                }
              } : {}
            };
          })()
        } : {}
      });
    } else
      this.etchings.push({
        valid: !1,
        runeId: n,
        txid: t,
        runeTicker: o.toString(),
        runeName: o.toString()
      });
  }
}
d2.RuneUpdater = vPe;
(function(e) {
  var t = zt && zt.__createBinding || (Object.create ? function(l, d, f, h) {
    h === void 0 && (h = f);
    var g = Object.getOwnPropertyDescriptor(d, f);
    (!g || ("get" in g ? !d.__esModule : g.writable || g.configurable)) && (g = { enumerable: !0, get: function() {
      return d[f];
    } }), Object.defineProperty(l, h, g);
  } : function(l, d, f, h) {
    h === void 0 && (h = f), l[h] = d[f];
  }), r = zt && zt.__exportStar || function(l, d) {
    for (var f in l) f !== "default" && !Object.prototype.hasOwnProperty.call(d, f) && t(d, l, f);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.RunestoneIndexer = e.RuneUpdater = void 0;
  const n = z0, o = d2, i = bs;
  r(_v, e);
  var a = d2;
  Object.defineProperty(e, "RuneUpdater", { enumerable: !0, get: function() {
    return a.RuneUpdater;
  } });
  class u {
    constructor(d) {
      this._started = !1, this._updateInProgress = !1, this._rpc = d.bitcoinRpcClient, this._storage = d.storage, this._network = d.network;
    }
    async start() {
      this._started || (await this._storage.connect(), this._started = !0, this._network === n.Network.MAINNET && this._storage.seedEtchings([
        {
          runeTicker: "UNCOMMONGOODS",
          runeName: "UNCOMMON•GOODS",
          runeId: { block: 1, tx: 0 },
          txid: "0000000000000000000000000000000000000000000000000000000000000000",
          valid: !0,
          symbol: "⧉",
          terms: { amount: 1n, cap: i.u128.MAX, height: { start: 840000n, end: 1050000n } }
        }
      ]));
    }
    async stop() {
      this._started && (await this._storage.disconnect(), this._started = !1);
    }
    async updateRuneUtxoBalances() {
      if (!this._started)
        throw new Error("Runestone indexer is not started");
      if (!this._updateInProgress) {
        this._updateInProgress = !0;
        try {
          await this.updateRuneUtxoBalancesImpl();
        } finally {
          this._updateInProgress = !1;
        }
      }
    }
    async updateRuneUtxoBalancesImpl() {
      const d = await this._storage.getCurrentBlock();
      if (d) {
        const g = [];
        let b = d.height, w = (await this._rpc.getblockhash({ height: b })).result, E = d.hash;
        for (; E !== w; )
          w && g.push(w), b--, w = (await this._rpc.getblockhash({ height: b })).result, E = await this._storage.getBlockhash(b);
        g.reverse();
        for (const _ of g) {
          const O = await this._rpc.getblock({ blockhash: _, verbosity: 2 });
          if (O.error !== null)
            throw O.error;
          const C = O.result, I = new o.RuneUpdater(this._network, C, !0, this._storage, this._rpc);
          for (const [S, T] of C.tx.entries())
            await I.indexRunes(T, S);
          await this._storage.saveBlockIndex(I);
        }
      }
      let f = Math.max(n.Network.getFirstRuneHeight(this._network), d ? d.height + 1 : 0), h = (await this._rpc.getblockhash({ height: f })).result;
      for (; h !== null; ) {
        const g = await this._rpc.getblock({ blockhash: h, verbosity: 2 });
        if (g.error !== null)
          throw g.error;
        const b = g.result, w = new o.RuneUpdater(this._network, b, !1, this._storage, this._rpc);
        for (const [E, _] of b.tx.entries())
          await w.indexRunes(_, E);
        await this._storage.saveBlockIndex(w), f++, h = (await this._rpc.getblockhash({ height: f })).result;
      }
    }
  }
  e.RunestoneIndexer = u;
})(fY);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.tryDecodeRunestone = e.isRunestone = e.encodeRunestone = e.Network = e.RunestoneIndexer = e.RuneUpdater = e.RuneLocation = void 0;
  const t = yv, r = Dn, n = wv, o = Kg, i = bs, a = ws, u = qg, l = YN, d = Ev;
  var f = fY;
  Object.defineProperty(e, "RuneLocation", { enumerable: !0, get: function() {
    return f.RuneLocation;
  } }), Object.defineProperty(e, "RuneUpdater", { enumerable: !0, get: function() {
    return f.RuneUpdater;
  } }), Object.defineProperty(e, "RunestoneIndexer", { enumerable: !0, get: function() {
    return f.RunestoneIndexer;
  } });
  var h = z0;
  Object.defineProperty(e, "Network", { enumerable: !0, get: function() {
    return h.Network;
  } });
  function g(S) {
    switch (S) {
      case o.Flaw.EDICT_OUTPUT:
        return "edict_output";
      case o.Flaw.EDICT_RUNE_ID:
        return "edict_rune_id";
      case o.Flaw.INVALID_SCRIPT:
        return "invalid_script";
      case o.Flaw.OPCODE:
        return "opcode";
      case o.Flaw.SUPPLY_OVERFLOW:
        return "supply_overflow";
      case o.Flaw.TRAILING_INTEGERS:
        return "trailing_integers";
      case o.Flaw.TRUNCATED_FIELD:
        return "truncated_field";
      case o.Flaw.UNRECOGNIZED_EVEN_TAG:
        return "unrecognized_even_tag";
      case o.Flaw.UNRECOGNIZED_FLAG:
        return "unrecognized_flag";
      case o.Flaw.VARINT:
        return "varint";
    }
  }
  const b = (S) => {
    const T = BigInt(S);
    if (T < 0n || T > i.u8.MAX)
      throw Error("u8 overflow");
    return (0, i.u8)(T);
  }, w = (S) => {
    const T = BigInt(S);
    if (T < 0n || T > i.u32.MAX)
      throw Error("u32 overflow");
    return (0, i.u32)(T);
  }, E = (S) => {
    const T = BigInt(S);
    if (T < 0n || T > i.u64.MAX)
      throw Error("u64 overflow");
    return (0, i.u64)(T);
  }, _ = (S) => {
    const T = BigInt(S);
    if (T < 0n || T > i.u128.MAX)
      throw Error("u128 overflow");
    return (0, i.u128)(T);
  };
  function O(S) {
    const T = S.mint ? (0, a.Some)(new u.RuneId(E(S.mint.block), w(S.mint.tx))) : a.None, A = S.pointer !== void 0 ? (0, a.Some)(S.pointer).map(w) : a.None, $ = (S.edicts ?? []).map((Y) => ({
      id: new u.RuneId(E(Y.id.block), w(Y.id.tx)),
      amount: _(Y.amount),
      output: w(Y.output)
    }));
    let U = a.None, M;
    if (S.etching) {
      const Y = S.etching, L = Y.runeName ? d.SpacedRune.fromString(Y.runeName) : void 0, ee = (L == null ? void 0 : L.rune) !== void 0 ? (0, a.Some)(L.rune) : a.None;
      if (Y.symbol && !(Y.symbol.length === 1 || Y.symbol.length === 2 && Y.symbol.codePointAt(0) >= 65536))
        throw Error("Symbol must be one code point");
      const de = Y.divisibility !== void 0 ? (0, a.Some)(Y.divisibility).map(b) : a.None, ne = Y.premine !== void 0 ? (0, a.Some)(Y.premine).map(_) : a.None, D = (L == null ? void 0 : L.spacers) !== void 0 && L.spacers !== 0 ? (0, a.Some)(w(L.spacers)) : a.None, K = Y.symbol ? (0, a.Some)(Y.symbol) : a.None;
      if (de.isSome() && de.unwrap() > r.MAX_DIVISIBILITY)
        throw Error(`Divisibility is greater than protocol max ${r.MAX_DIVISIBILITY}`);
      let le = a.None;
      if (Y.terms) {
        const G = Y.terms, q = G.amount !== void 0 ? (0, a.Some)(G.amount).map(_) : a.None, Q = G.cap !== void 0 ? (0, a.Some)(G.cap).map(_) : a.None, se = G.height ? [
          G.height.start !== void 0 ? (0, a.Some)(G.height.start).map(E) : a.None,
          G.height.end !== void 0 ? (0, a.Some)(G.height.end).map(E) : a.None
        ] : [a.None, a.None], J = G.offset ? [
          G.offset.start !== void 0 ? (0, a.Some)(G.offset.start).map(E) : a.None,
          G.offset.end !== void 0 ? (0, a.Some)(G.offset.end).map(E) : a.None
        ] : [a.None, a.None];
        if (q.isSome() && Q.isSome() && q.unwrap() * Q.unwrap() > i.u128.MAX)
          throw Error("Terms overflow with amount times cap");
        le = (0, a.Some)({ amount: q, cap: Q, height: se, offset: J });
      }
      const re = Y.turbo ?? !1;
      U = (0, a.Some)(new n.Etching(de, ee, D, K, le, ne, re)), M = ee.isSome() ? ee.unwrap().commitment : void 0;
    }
    return {
      encodedRunestone: new l.Runestone(T, A, $, U).encipher(),
      etchingCommitment: M
    };
  }
  e.encodeRunestone = O;
  function C(S) {
    return !("flaws" in S);
  }
  e.isRunestone = C;
  function I(S) {
    const T = l.Runestone.decipher(S);
    if (T.isNone())
      return null;
    const A = T.unwrap();
    if ((0, t.isRunestone)(A)) {
      const $ = A, U = () => $.etching.unwrap(), M = () => U().terms.unwrap();
      return {
        ...$.etching.isSome() ? {
          etching: {
            ...U().divisibility.isSome() ? { divisibility: U().divisibility.map(Number).unwrap() } : {},
            ...U().premine.isSome() ? { premine: U().premine.unwrap() } : {},
            ...U().rune.isSome() ? {
              runeName: new d.SpacedRune(U().rune.unwrap(), U().spacers.map(Number).unwrapOr(0)).toString()
            } : {},
            ...U().symbol.isSome() ? { symbol: U().symbol.unwrap() } : {},
            ...U().terms.isSome() ? {
              terms: {
                ...M().amount.isSome() ? { amount: M().amount.unwrap() } : {},
                ...M().cap.isSome() ? { cap: M().cap.unwrap() } : {},
                ...M().height.find((Y) => Y.isSome()) ? {
                  height: {
                    ...M().height[0].isSome() ? { start: M().height[0].unwrap() } : {},
                    ...M().height[1].isSome() ? { end: M().height[1].unwrap() } : {}
                  }
                } : {},
                ...M().offset.find((Y) => Y.isSome()) ? {
                  offset: {
                    ...M().offset[0].isSome() ? { start: M().offset[0].unwrap() } : {},
                    ...M().offset[1].isSome() ? { end: M().offset[1].unwrap() } : {}
                  }
                } : {}
              }
            } : {},
            turbo: U().turbo
          }
        } : {},
        ...$.mint.isSome() ? {
          mint: {
            block: $.mint.unwrap().block,
            tx: Number($.mint.unwrap().tx)
          }
        } : {},
        ...$.pointer.isSome() ? { pointer: Number($.pointer.unwrap()) } : {},
        ...$.edicts.length ? {
          edicts: $.edicts.map((Y) => ({
            id: {
              block: Y.id.block,
              tx: Number(Y.id.tx)
            },
            amount: Y.amount,
            output: Number(Y.output)
          }))
        } : {}
      };
    } else {
      const $ = A;
      return {
        flaws: $.flaws.map(g),
        ...$.etching.isSome() ? { etching: $.etching.unwrap().toString() } : {},
        ...$.mint.isSome() ? { mint: { block: $.mint.unwrap().block, tx: Number($.mint.unwrap().tx) } } : {}
      };
    }
  }
  e.tryDecodeRunestone = I;
})(sPe);
var C5 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
C5.exports;
(function(e, t) {
  (function() {
    var r, n = "4.17.21", o = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", u = "Invalid `variable` option passed into `_.template`", l = "__lodash_hash_undefined__", d = 500, f = "__lodash_placeholder__", h = 1, g = 2, b = 4, w = 1, E = 2, _ = 1, O = 2, C = 4, I = 8, S = 16, T = 32, A = 64, $ = 128, U = 256, M = 512, Y = 30, L = "...", ee = 800, de = 16, ne = 1, D = 2, K = 3, le = 1 / 0, re = 9007199254740991, G = 17976931348623157e292, q = NaN, Q = 4294967295, se = Q - 1, J = Q >>> 1, ye = [
      ["ary", $],
      ["bind", _],
      ["bindKey", O],
      ["curry", I],
      ["curryRight", S],
      ["flip", M],
      ["partial", T],
      ["partialRight", A],
      ["rearg", U]
    ], ve = "[object Arguments]", Ee = "[object Array]", _e = "[object AsyncFunction]", we = "[object Boolean]", be = "[object Date]", Ge = "[object DOMException]", Le = "[object Error]", Ne = "[object Function]", Ve = "[object GeneratorFunction]", ge = "[object Map]", Te = "[object Number]", Oe = "[object Null]", He = "[object Object]", mt = "[object Promise]", rt = "[object Proxy]", Pt = "[object RegExp]", _t = "[object Set]", yt = "[object String]", Zt = "[object Symbol]", yn = "[object Undefined]", kt = "[object WeakMap]", qr = "[object WeakSet]", m = "[object ArrayBuffer]", v = "[object DataView]", k = "[object Float32Array]", H = "[object Float64Array]", X = "[object Int8Array]", oe = "[object Int16Array]", me = "[object Int32Array]", nt = "[object Uint8Array]", Ct = "[object Uint8ClampedArray]", At = "[object Uint16Array]", vt = "[object Uint32Array]", Ht = /\b__p \+= '';/g, jc = /\b(__p \+=) '' \+/g, Lc = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Gs = /&(?:amp|lt|gt|quot|#39);/g, Hr = /[&<>"']/g, fo = RegExp(Gs.source), Ua = RegExp(Hr.source), j = /<%-([\s\S]+?)%>/g, N = /<%([\s\S]+?)%>/g, z = /<%=([\s\S]+?)%>/g, W = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ie = /^\w*$/, he = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ae = /[\\^$.*+?()[\]{}|]/g, Ie = RegExp(Ae.source), Me = /^\s+/, Fe = /\s/, We = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, it = /\{\n\/\* \[wrapped with (.+)\] \*/, ct = /,? & /, ar = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, sr = /[()=,{}\[\]\/\s]/, qn = /\\(\\)?/g, ci = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Io = /\w*$/, li = /^[-+]0x[0-9a-f]+$/i, Ra = /^0b[01]+$/i, Ws = /^\[object .+?Constructor\]$/, Vi = /^0o[0-7]+$/i, i6 = /^(?:0|[1-9]\d*)$/, a6 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Hc = /($^)/, s6 = /['\n\r\u2028\u2029\\]/g, Fc = "\\ud800-\\udfff", u6 = "\\u0300-\\u036f", c6 = "\\ufe20-\\ufe2f", l6 = "\\u20d0-\\u20ff", Yg = u6 + c6 + l6, Jg = "\\u2700-\\u27bf", Qg = "a-z\\xdf-\\xf6\\xf8-\\xff", f6 = "\\xac\\xb1\\xd7\\xf7", d6 = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", h6 = "\\u2000-\\u206f", p6 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", em = "A-Z\\xc0-\\xd6\\xd8-\\xde", tm = "\\ufe0e\\ufe0f", rm = f6 + d6 + h6 + p6, ah = "['’]", g6 = "[" + Fc + "]", nm = "[" + rm + "]", Mc = "[" + Yg + "]", om = "\\d+", m6 = "[" + Jg + "]", im = "[" + Qg + "]", am = "[^" + Fc + rm + om + Jg + Qg + em + "]", sh = "\\ud83c[\\udffb-\\udfff]", y6 = "(?:" + Mc + "|" + sh + ")", sm = "[^" + Fc + "]", uh = "(?:\\ud83c[\\udde6-\\uddff]){2}", ch = "[\\ud800-\\udbff][\\udc00-\\udfff]", za = "[" + em + "]", um = "\\u200d", cm = "(?:" + im + "|" + am + ")", b6 = "(?:" + za + "|" + am + ")", lm = "(?:" + ah + "(?:d|ll|m|re|s|t|ve))?", fm = "(?:" + ah + "(?:D|LL|M|RE|S|T|VE))?", dm = y6 + "?", hm = "[" + tm + "]?", w6 = "(?:" + um + "(?:" + [sm, uh, ch].join("|") + ")" + hm + dm + ")*", v6 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", E6 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", pm = hm + dm + w6, _6 = "(?:" + [m6, uh, ch].join("|") + ")" + pm, A6 = "(?:" + [sm + Mc + "?", Mc, uh, ch, g6].join("|") + ")", x6 = RegExp(ah, "g"), k6 = RegExp(Mc, "g"), lh = RegExp(sh + "(?=" + sh + ")|" + A6 + pm, "g"), S6 = RegExp([
      za + "?" + im + "+" + lm + "(?=" + [nm, za, "$"].join("|") + ")",
      b6 + "+" + fm + "(?=" + [nm, za + cm, "$"].join("|") + ")",
      za + "?" + cm + "+" + lm,
      za + "+" + fm,
      E6,
      v6,
      om,
      _6
    ].join("|"), "g"), T6 = RegExp("[" + um + Fc + Yg + tm + "]"), I6 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, O6 = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], P6 = -1, Ft = {};
    Ft[k] = Ft[H] = Ft[X] = Ft[oe] = Ft[me] = Ft[nt] = Ft[Ct] = Ft[At] = Ft[vt] = !0, Ft[ve] = Ft[Ee] = Ft[m] = Ft[we] = Ft[v] = Ft[be] = Ft[Le] = Ft[Ne] = Ft[ge] = Ft[Te] = Ft[He] = Ft[Pt] = Ft[_t] = Ft[yt] = Ft[kt] = !1;
    var Ut = {};
    Ut[ve] = Ut[Ee] = Ut[m] = Ut[v] = Ut[we] = Ut[be] = Ut[k] = Ut[H] = Ut[X] = Ut[oe] = Ut[me] = Ut[ge] = Ut[Te] = Ut[He] = Ut[Pt] = Ut[_t] = Ut[yt] = Ut[Zt] = Ut[nt] = Ut[Ct] = Ut[At] = Ut[vt] = !0, Ut[Le] = Ut[Ne] = Ut[kt] = !1;
    var C6 = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, B6 = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, N6 = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, $6 = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, U6 = parseFloat, R6 = parseInt, gm = typeof zt == "object" && zt && zt.Object === Object && zt, z6 = typeof self == "object" && self && self.Object === Object && self, zr = gm || z6 || Function("return this")(), fh = t && !t.nodeType && t, Gi = fh && !0 && e && !e.nodeType && e, mm = Gi && Gi.exports === fh, dh = mm && gm.process, On = function() {
      try {
        var V = Gi && Gi.require && Gi.require("util").types;
        return V || dh && dh.binding && dh.binding("util");
      } catch {
      }
    }(), ym = On && On.isArrayBuffer, bm = On && On.isDate, wm = On && On.isMap, vm = On && On.isRegExp, Em = On && On.isSet, _m = On && On.isTypedArray;
    function bn(V, ue, te) {
      switch (te.length) {
        case 0:
          return V.call(ue);
        case 1:
          return V.call(ue, te[0]);
        case 2:
          return V.call(ue, te[0], te[1]);
        case 3:
          return V.call(ue, te[0], te[1], te[2]);
      }
      return V.apply(ue, te);
    }
    function j6(V, ue, te, Pe) {
      for (var Ze = -1, Et = V == null ? 0 : V.length; ++Ze < Et; ) {
        var Ir = V[Ze];
        ue(Pe, Ir, te(Ir), V);
      }
      return Pe;
    }
    function Pn(V, ue) {
      for (var te = -1, Pe = V == null ? 0 : V.length; ++te < Pe && ue(V[te], te, V) !== !1; )
        ;
      return V;
    }
    function L6(V, ue) {
      for (var te = V == null ? 0 : V.length; te-- && ue(V[te], te, V) !== !1; )
        ;
      return V;
    }
    function Am(V, ue) {
      for (var te = -1, Pe = V == null ? 0 : V.length; ++te < Pe; )
        if (!ue(V[te], te, V))
          return !1;
      return !0;
    }
    function fi(V, ue) {
      for (var te = -1, Pe = V == null ? 0 : V.length, Ze = 0, Et = []; ++te < Pe; ) {
        var Ir = V[te];
        ue(Ir, te, V) && (Et[Ze++] = Ir);
      }
      return Et;
    }
    function Dc(V, ue) {
      var te = V == null ? 0 : V.length;
      return !!te && ja(V, ue, 0) > -1;
    }
    function hh(V, ue, te) {
      for (var Pe = -1, Ze = V == null ? 0 : V.length; ++Pe < Ze; )
        if (te(ue, V[Pe]))
          return !0;
      return !1;
    }
    function Kt(V, ue) {
      for (var te = -1, Pe = V == null ? 0 : V.length, Ze = Array(Pe); ++te < Pe; )
        Ze[te] = ue(V[te], te, V);
      return Ze;
    }
    function di(V, ue) {
      for (var te = -1, Pe = ue.length, Ze = V.length; ++te < Pe; )
        V[Ze + te] = ue[te];
      return V;
    }
    function ph(V, ue, te, Pe) {
      var Ze = -1, Et = V == null ? 0 : V.length;
      for (Pe && Et && (te = V[++Ze]); ++Ze < Et; )
        te = ue(te, V[Ze], Ze, V);
      return te;
    }
    function H6(V, ue, te, Pe) {
      var Ze = V == null ? 0 : V.length;
      for (Pe && Ze && (te = V[--Ze]); Ze--; )
        te = ue(te, V[Ze], Ze, V);
      return te;
    }
    function gh(V, ue) {
      for (var te = -1, Pe = V == null ? 0 : V.length; ++te < Pe; )
        if (ue(V[te], te, V))
          return !0;
      return !1;
    }
    var F6 = mh("length");
    function M6(V) {
      return V.split("");
    }
    function D6(V) {
      return V.match(ar) || [];
    }
    function xm(V, ue, te) {
      var Pe;
      return te(V, function(Ze, Et, Ir) {
        if (ue(Ze, Et, Ir))
          return Pe = Et, !1;
      }), Pe;
    }
    function Kc(V, ue, te, Pe) {
      for (var Ze = V.length, Et = te + (Pe ? 1 : -1); Pe ? Et-- : ++Et < Ze; )
        if (ue(V[Et], Et, V))
          return Et;
      return -1;
    }
    function ja(V, ue, te) {
      return ue === ue ? t7(V, ue, te) : Kc(V, km, te);
    }
    function K6(V, ue, te, Pe) {
      for (var Ze = te - 1, Et = V.length; ++Ze < Et; )
        if (Pe(V[Ze], ue))
          return Ze;
      return -1;
    }
    function km(V) {
      return V !== V;
    }
    function Sm(V, ue) {
      var te = V == null ? 0 : V.length;
      return te ? bh(V, ue) / te : q;
    }
    function mh(V) {
      return function(ue) {
        return ue == null ? r : ue[V];
      };
    }
    function yh(V) {
      return function(ue) {
        return V == null ? r : V[ue];
      };
    }
    function Tm(V, ue, te, Pe, Ze) {
      return Ze(V, function(Et, Ir, Bt) {
        te = Pe ? (Pe = !1, Et) : ue(te, Et, Ir, Bt);
      }), te;
    }
    function q6(V, ue) {
      var te = V.length;
      for (V.sort(ue); te--; )
        V[te] = V[te].value;
      return V;
    }
    function bh(V, ue) {
      for (var te, Pe = -1, Ze = V.length; ++Pe < Ze; ) {
        var Et = ue(V[Pe]);
        Et !== r && (te = te === r ? Et : te + Et);
      }
      return te;
    }
    function wh(V, ue) {
      for (var te = -1, Pe = Array(V); ++te < V; )
        Pe[te] = ue(te);
      return Pe;
    }
    function V6(V, ue) {
      return Kt(ue, function(te) {
        return [te, V[te]];
      });
    }
    function Im(V) {
      return V && V.slice(0, Bm(V) + 1).replace(Me, "");
    }
    function wn(V) {
      return function(ue) {
        return V(ue);
      };
    }
    function vh(V, ue) {
      return Kt(ue, function(te) {
        return V[te];
      });
    }
    function Zs(V, ue) {
      return V.has(ue);
    }
    function Om(V, ue) {
      for (var te = -1, Pe = V.length; ++te < Pe && ja(ue, V[te], 0) > -1; )
        ;
      return te;
    }
    function Pm(V, ue) {
      for (var te = V.length; te-- && ja(ue, V[te], 0) > -1; )
        ;
      return te;
    }
    function G6(V, ue) {
      for (var te = V.length, Pe = 0; te--; )
        V[te] === ue && ++Pe;
      return Pe;
    }
    var W6 = yh(C6), Z6 = yh(B6);
    function X6(V) {
      return "\\" + $6[V];
    }
    function Y6(V, ue) {
      return V == null ? r : V[ue];
    }
    function La(V) {
      return T6.test(V);
    }
    function J6(V) {
      return I6.test(V);
    }
    function Q6(V) {
      for (var ue, te = []; !(ue = V.next()).done; )
        te.push(ue.value);
      return te;
    }
    function Eh(V) {
      var ue = -1, te = Array(V.size);
      return V.forEach(function(Pe, Ze) {
        te[++ue] = [Ze, Pe];
      }), te;
    }
    function Cm(V, ue) {
      return function(te) {
        return V(ue(te));
      };
    }
    function hi(V, ue) {
      for (var te = -1, Pe = V.length, Ze = 0, Et = []; ++te < Pe; ) {
        var Ir = V[te];
        (Ir === ue || Ir === f) && (V[te] = f, Et[Ze++] = te);
      }
      return Et;
    }
    function qc(V) {
      var ue = -1, te = Array(V.size);
      return V.forEach(function(Pe) {
        te[++ue] = Pe;
      }), te;
    }
    function e7(V) {
      var ue = -1, te = Array(V.size);
      return V.forEach(function(Pe) {
        te[++ue] = [Pe, Pe];
      }), te;
    }
    function t7(V, ue, te) {
      for (var Pe = te - 1, Ze = V.length; ++Pe < Ze; )
        if (V[Pe] === ue)
          return Pe;
      return -1;
    }
    function r7(V, ue, te) {
      for (var Pe = te + 1; Pe--; )
        if (V[Pe] === ue)
          return Pe;
      return Pe;
    }
    function Ha(V) {
      return La(V) ? o7(V) : F6(V);
    }
    function Vn(V) {
      return La(V) ? i7(V) : M6(V);
    }
    function Bm(V) {
      for (var ue = V.length; ue-- && Fe.test(V.charAt(ue)); )
        ;
      return ue;
    }
    var n7 = yh(N6);
    function o7(V) {
      for (var ue = lh.lastIndex = 0; lh.test(V); )
        ++ue;
      return ue;
    }
    function i7(V) {
      return V.match(lh) || [];
    }
    function a7(V) {
      return V.match(S6) || [];
    }
    var s7 = function V(ue) {
      ue = ue == null ? zr : Fa.defaults(zr.Object(), ue, Fa.pick(zr, O6));
      var te = ue.Array, Pe = ue.Date, Ze = ue.Error, Et = ue.Function, Ir = ue.Math, Bt = ue.Object, _h = ue.RegExp, u7 = ue.String, Cn = ue.TypeError, Vc = te.prototype, c7 = Et.prototype, Ma = Bt.prototype, Gc = ue["__core-js_shared__"], Wc = c7.toString, St = Ma.hasOwnProperty, l7 = 0, Nm = function() {
        var s = /[^.]+$/.exec(Gc && Gc.keys && Gc.keys.IE_PROTO || "");
        return s ? "Symbol(src)_1." + s : "";
      }(), Zc = Ma.toString, f7 = Wc.call(Bt), d7 = zr._, h7 = _h(
        "^" + Wc.call(St).replace(Ae, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Xc = mm ? ue.Buffer : r, pi = ue.Symbol, Yc = ue.Uint8Array, $m = Xc ? Xc.allocUnsafe : r, Jc = Cm(Bt.getPrototypeOf, Bt), Um = Bt.create, Rm = Ma.propertyIsEnumerable, Qc = Vc.splice, zm = pi ? pi.isConcatSpreadable : r, Xs = pi ? pi.iterator : r, Wi = pi ? pi.toStringTag : r, el = function() {
        try {
          var s = Qi(Bt, "defineProperty");
          return s({}, "", {}), s;
        } catch {
        }
      }(), p7 = ue.clearTimeout !== zr.clearTimeout && ue.clearTimeout, g7 = Pe && Pe.now !== zr.Date.now && Pe.now, m7 = ue.setTimeout !== zr.setTimeout && ue.setTimeout, tl = Ir.ceil, rl = Ir.floor, Ah = Bt.getOwnPropertySymbols, y7 = Xc ? Xc.isBuffer : r, jm = ue.isFinite, b7 = Vc.join, w7 = Cm(Bt.keys, Bt), Or = Ir.max, Fr = Ir.min, v7 = Pe.now, E7 = ue.parseInt, Lm = Ir.random, _7 = Vc.reverse, xh = Qi(ue, "DataView"), Ys = Qi(ue, "Map"), kh = Qi(ue, "Promise"), Da = Qi(ue, "Set"), Js = Qi(ue, "WeakMap"), Qs = Qi(Bt, "create"), nl = Js && new Js(), Ka = {}, A7 = ea(xh), x7 = ea(Ys), k7 = ea(kh), S7 = ea(Da), T7 = ea(Js), ol = pi ? pi.prototype : r, eu = ol ? ol.valueOf : r, Hm = ol ? ol.toString : r;
      function P(s) {
        if (Qt(s) && !Xe(s) && !(s instanceof at)) {
          if (s instanceof Bn)
            return s;
          if (St.call(s, "__wrapped__"))
            return Fy(s);
        }
        return new Bn(s);
      }
      var qa = /* @__PURE__ */ function() {
        function s() {
        }
        return function(c) {
          if (!Xt(c))
            return {};
          if (Um)
            return Um(c);
          s.prototype = c;
          var p = new s();
          return s.prototype = r, p;
        };
      }();
      function il() {
      }
      function Bn(s, c) {
        this.__wrapped__ = s, this.__actions__ = [], this.__chain__ = !!c, this.__index__ = 0, this.__values__ = r;
      }
      P.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: j,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: N,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: z,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: P
        }
      }, P.prototype = il.prototype, P.prototype.constructor = P, Bn.prototype = qa(il.prototype), Bn.prototype.constructor = Bn;
      function at(s) {
        this.__wrapped__ = s, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Q, this.__views__ = [];
      }
      function I7() {
        var s = new at(this.__wrapped__);
        return s.__actions__ = Jr(this.__actions__), s.__dir__ = this.__dir__, s.__filtered__ = this.__filtered__, s.__iteratees__ = Jr(this.__iteratees__), s.__takeCount__ = this.__takeCount__, s.__views__ = Jr(this.__views__), s;
      }
      function O7() {
        if (this.__filtered__) {
          var s = new at(this);
          s.__dir__ = -1, s.__filtered__ = !0;
        } else
          s = this.clone(), s.__dir__ *= -1;
        return s;
      }
      function P7() {
        var s = this.__wrapped__.value(), c = this.__dir__, p = Xe(s), y = c < 0, x = p ? s.length : 0, B = M_(0, x, this.__views__), R = B.start, F = B.end, Z = F - R, ce = y ? F : R - 1, fe = this.__iteratees__, pe = fe.length, Se = 0, $e = Fr(Z, this.__takeCount__);
        if (!p || !y && x == Z && $e == Z)
          return ly(s, this.__actions__);
        var Ke = [];
        e:
          for (; Z-- && Se < $e; ) {
            ce += c;
            for (var et = -1, qe = s[ce]; ++et < pe; ) {
              var ot = fe[et], lt = ot.iteratee, _n = ot.type, Wr = lt(qe);
              if (_n == D)
                qe = Wr;
              else if (!Wr) {
                if (_n == ne)
                  continue e;
                break e;
              }
            }
            Ke[Se++] = qe;
          }
        return Ke;
      }
      at.prototype = qa(il.prototype), at.prototype.constructor = at;
      function Zi(s) {
        var c = -1, p = s == null ? 0 : s.length;
        for (this.clear(); ++c < p; ) {
          var y = s[c];
          this.set(y[0], y[1]);
        }
      }
      function C7() {
        this.__data__ = Qs ? Qs(null) : {}, this.size = 0;
      }
      function B7(s) {
        var c = this.has(s) && delete this.__data__[s];
        return this.size -= c ? 1 : 0, c;
      }
      function N7(s) {
        var c = this.__data__;
        if (Qs) {
          var p = c[s];
          return p === l ? r : p;
        }
        return St.call(c, s) ? c[s] : r;
      }
      function $7(s) {
        var c = this.__data__;
        return Qs ? c[s] !== r : St.call(c, s);
      }
      function U7(s, c) {
        var p = this.__data__;
        return this.size += this.has(s) ? 0 : 1, p[s] = Qs && c === r ? l : c, this;
      }
      Zi.prototype.clear = C7, Zi.prototype.delete = B7, Zi.prototype.get = N7, Zi.prototype.has = $7, Zi.prototype.set = U7;
      function Oo(s) {
        var c = -1, p = s == null ? 0 : s.length;
        for (this.clear(); ++c < p; ) {
          var y = s[c];
          this.set(y[0], y[1]);
        }
      }
      function R7() {
        this.__data__ = [], this.size = 0;
      }
      function z7(s) {
        var c = this.__data__, p = al(c, s);
        if (p < 0)
          return !1;
        var y = c.length - 1;
        return p == y ? c.pop() : Qc.call(c, p, 1), --this.size, !0;
      }
      function j7(s) {
        var c = this.__data__, p = al(c, s);
        return p < 0 ? r : c[p][1];
      }
      function L7(s) {
        return al(this.__data__, s) > -1;
      }
      function H7(s, c) {
        var p = this.__data__, y = al(p, s);
        return y < 0 ? (++this.size, p.push([s, c])) : p[y][1] = c, this;
      }
      Oo.prototype.clear = R7, Oo.prototype.delete = z7, Oo.prototype.get = j7, Oo.prototype.has = L7, Oo.prototype.set = H7;
      function Po(s) {
        var c = -1, p = s == null ? 0 : s.length;
        for (this.clear(); ++c < p; ) {
          var y = s[c];
          this.set(y[0], y[1]);
        }
      }
      function F7() {
        this.size = 0, this.__data__ = {
          hash: new Zi(),
          map: new (Ys || Oo)(),
          string: new Zi()
        };
      }
      function M7(s) {
        var c = bl(this, s).delete(s);
        return this.size -= c ? 1 : 0, c;
      }
      function D7(s) {
        return bl(this, s).get(s);
      }
      function K7(s) {
        return bl(this, s).has(s);
      }
      function q7(s, c) {
        var p = bl(this, s), y = p.size;
        return p.set(s, c), this.size += p.size == y ? 0 : 1, this;
      }
      Po.prototype.clear = F7, Po.prototype.delete = M7, Po.prototype.get = D7, Po.prototype.has = K7, Po.prototype.set = q7;
      function Xi(s) {
        var c = -1, p = s == null ? 0 : s.length;
        for (this.__data__ = new Po(); ++c < p; )
          this.add(s[c]);
      }
      function V7(s) {
        return this.__data__.set(s, l), this;
      }
      function G7(s) {
        return this.__data__.has(s);
      }
      Xi.prototype.add = Xi.prototype.push = V7, Xi.prototype.has = G7;
      function Gn(s) {
        var c = this.__data__ = new Oo(s);
        this.size = c.size;
      }
      function W7() {
        this.__data__ = new Oo(), this.size = 0;
      }
      function Z7(s) {
        var c = this.__data__, p = c.delete(s);
        return this.size = c.size, p;
      }
      function X7(s) {
        return this.__data__.get(s);
      }
      function Y7(s) {
        return this.__data__.has(s);
      }
      function J7(s, c) {
        var p = this.__data__;
        if (p instanceof Oo) {
          var y = p.__data__;
          if (!Ys || y.length < o - 1)
            return y.push([s, c]), this.size = ++p.size, this;
          p = this.__data__ = new Po(y);
        }
        return p.set(s, c), this.size = p.size, this;
      }
      Gn.prototype.clear = W7, Gn.prototype.delete = Z7, Gn.prototype.get = X7, Gn.prototype.has = Y7, Gn.prototype.set = J7;
      function Fm(s, c) {
        var p = Xe(s), y = !p && ta(s), x = !p && !y && wi(s), B = !p && !y && !x && Za(s), R = p || y || x || B, F = R ? wh(s.length, u7) : [], Z = F.length;
        for (var ce in s)
          (c || St.call(s, ce)) && !(R && // Safari 9 has enumerable `arguments.length` in strict mode.
          (ce == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          x && (ce == "offset" || ce == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          B && (ce == "buffer" || ce == "byteLength" || ce == "byteOffset") || // Skip index properties.
          $o(ce, Z))) && F.push(ce);
        return F;
      }
      function Mm(s) {
        var c = s.length;
        return c ? s[Rh(0, c - 1)] : r;
      }
      function Q7(s, c) {
        return wl(Jr(s), Yi(c, 0, s.length));
      }
      function e_(s) {
        return wl(Jr(s));
      }
      function Sh(s, c, p) {
        (p !== r && !Wn(s[c], p) || p === r && !(c in s)) && Co(s, c, p);
      }
      function tu(s, c, p) {
        var y = s[c];
        (!(St.call(s, c) && Wn(y, p)) || p === r && !(c in s)) && Co(s, c, p);
      }
      function al(s, c) {
        for (var p = s.length; p--; )
          if (Wn(s[p][0], c))
            return p;
        return -1;
      }
      function t_(s, c, p, y) {
        return gi(s, function(x, B, R) {
          c(y, x, p(x), R);
        }), y;
      }
      function Dm(s, c) {
        return s && po(c, $r(c), s);
      }
      function r_(s, c) {
        return s && po(c, en(c), s);
      }
      function Co(s, c, p) {
        c == "__proto__" && el ? el(s, c, {
          configurable: !0,
          enumerable: !0,
          value: p,
          writable: !0
        }) : s[c] = p;
      }
      function Th(s, c) {
        for (var p = -1, y = c.length, x = te(y), B = s == null; ++p < y; )
          x[p] = B ? r : sp(s, c[p]);
        return x;
      }
      function Yi(s, c, p) {
        return s === s && (p !== r && (s = s <= p ? s : p), c !== r && (s = s >= c ? s : c)), s;
      }
      function Nn(s, c, p, y, x, B) {
        var R, F = c & h, Z = c & g, ce = c & b;
        if (p && (R = x ? p(s, y, x, B) : p(s)), R !== r)
          return R;
        if (!Xt(s))
          return s;
        var fe = Xe(s);
        if (fe) {
          if (R = K_(s), !F)
            return Jr(s, R);
        } else {
          var pe = Mr(s), Se = pe == Ne || pe == Ve;
          if (wi(s))
            return hy(s, F);
          if (pe == He || pe == ve || Se && !x) {
            if (R = Z || Se ? {} : By(s), !F)
              return Z ? N_(s, r_(R, s)) : B_(s, Dm(R, s));
          } else {
            if (!Ut[pe])
              return x ? s : {};
            R = q_(s, pe, F);
          }
        }
        B || (B = new Gn());
        var $e = B.get(s);
        if ($e)
          return $e;
        B.set(s, R), sb(s) ? s.forEach(function(qe) {
          R.add(Nn(qe, c, p, qe, s, B));
        }) : ib(s) && s.forEach(function(qe, ot) {
          R.set(ot, Nn(qe, c, p, ot, s, B));
        });
        var Ke = ce ? Z ? Gh : Vh : Z ? en : $r, et = fe ? r : Ke(s);
        return Pn(et || s, function(qe, ot) {
          et && (ot = qe, qe = s[ot]), tu(R, ot, Nn(qe, c, p, ot, s, B));
        }), R;
      }
      function n_(s) {
        var c = $r(s);
        return function(p) {
          return Km(p, s, c);
        };
      }
      function Km(s, c, p) {
        var y = p.length;
        if (s == null)
          return !y;
        for (s = Bt(s); y--; ) {
          var x = p[y], B = c[x], R = s[x];
          if (R === r && !(x in s) || !B(R))
            return !1;
        }
        return !0;
      }
      function qm(s, c, p) {
        if (typeof s != "function")
          throw new Cn(a);
        return uu(function() {
          s.apply(r, p);
        }, c);
      }
      function ru(s, c, p, y) {
        var x = -1, B = Dc, R = !0, F = s.length, Z = [], ce = c.length;
        if (!F)
          return Z;
        p && (c = Kt(c, wn(p))), y ? (B = hh, R = !1) : c.length >= o && (B = Zs, R = !1, c = new Xi(c));
        e:
          for (; ++x < F; ) {
            var fe = s[x], pe = p == null ? fe : p(fe);
            if (fe = y || fe !== 0 ? fe : 0, R && pe === pe) {
              for (var Se = ce; Se--; )
                if (c[Se] === pe)
                  continue e;
              Z.push(fe);
            } else B(c, pe, y) || Z.push(fe);
          }
        return Z;
      }
      var gi = by(ho), Vm = by(Oh, !0);
      function o_(s, c) {
        var p = !0;
        return gi(s, function(y, x, B) {
          return p = !!c(y, x, B), p;
        }), p;
      }
      function sl(s, c, p) {
        for (var y = -1, x = s.length; ++y < x; ) {
          var B = s[y], R = c(B);
          if (R != null && (F === r ? R === R && !En(R) : p(R, F)))
            var F = R, Z = B;
        }
        return Z;
      }
      function i_(s, c, p, y) {
        var x = s.length;
        for (p = Qe(p), p < 0 && (p = -p > x ? 0 : x + p), y = y === r || y > x ? x : Qe(y), y < 0 && (y += x), y = p > y ? 0 : cb(y); p < y; )
          s[p++] = c;
        return s;
      }
      function Gm(s, c) {
        var p = [];
        return gi(s, function(y, x, B) {
          c(y, x, B) && p.push(y);
        }), p;
      }
      function jr(s, c, p, y, x) {
        var B = -1, R = s.length;
        for (p || (p = G_), x || (x = []); ++B < R; ) {
          var F = s[B];
          c > 0 && p(F) ? c > 1 ? jr(F, c - 1, p, y, x) : di(x, F) : y || (x[x.length] = F);
        }
        return x;
      }
      var Ih = wy(), Wm = wy(!0);
      function ho(s, c) {
        return s && Ih(s, c, $r);
      }
      function Oh(s, c) {
        return s && Wm(s, c, $r);
      }
      function ul(s, c) {
        return fi(c, function(p) {
          return Uo(s[p]);
        });
      }
      function Ji(s, c) {
        c = yi(c, s);
        for (var p = 0, y = c.length; s != null && p < y; )
          s = s[go(c[p++])];
        return p && p == y ? s : r;
      }
      function Zm(s, c, p) {
        var y = c(s);
        return Xe(s) ? y : di(y, p(s));
      }
      function Vr(s) {
        return s == null ? s === r ? yn : Oe : Wi && Wi in Bt(s) ? F_(s) : e9(s);
      }
      function Ph(s, c) {
        return s > c;
      }
      function a_(s, c) {
        return s != null && St.call(s, c);
      }
      function s_(s, c) {
        return s != null && c in Bt(s);
      }
      function u_(s, c, p) {
        return s >= Fr(c, p) && s < Or(c, p);
      }
      function Ch(s, c, p) {
        for (var y = p ? hh : Dc, x = s[0].length, B = s.length, R = B, F = te(B), Z = 1 / 0, ce = []; R--; ) {
          var fe = s[R];
          R && c && (fe = Kt(fe, wn(c))), Z = Fr(fe.length, Z), F[R] = !p && (c || x >= 120 && fe.length >= 120) ? new Xi(R && fe) : r;
        }
        fe = s[0];
        var pe = -1, Se = F[0];
        e:
          for (; ++pe < x && ce.length < Z; ) {
            var $e = fe[pe], Ke = c ? c($e) : $e;
            if ($e = p || $e !== 0 ? $e : 0, !(Se ? Zs(Se, Ke) : y(ce, Ke, p))) {
              for (R = B; --R; ) {
                var et = F[R];
                if (!(et ? Zs(et, Ke) : y(s[R], Ke, p)))
                  continue e;
              }
              Se && Se.push(Ke), ce.push($e);
            }
          }
        return ce;
      }
      function c_(s, c, p, y) {
        return ho(s, function(x, B, R) {
          c(y, p(x), B, R);
        }), y;
      }
      function nu(s, c, p) {
        c = yi(c, s), s = Ry(s, c);
        var y = s == null ? s : s[go(Un(c))];
        return y == null ? r : bn(y, s, p);
      }
      function Xm(s) {
        return Qt(s) && Vr(s) == ve;
      }
      function l_(s) {
        return Qt(s) && Vr(s) == m;
      }
      function f_(s) {
        return Qt(s) && Vr(s) == be;
      }
      function ou(s, c, p, y, x) {
        return s === c ? !0 : s == null || c == null || !Qt(s) && !Qt(c) ? s !== s && c !== c : d_(s, c, p, y, ou, x);
      }
      function d_(s, c, p, y, x, B) {
        var R = Xe(s), F = Xe(c), Z = R ? Ee : Mr(s), ce = F ? Ee : Mr(c);
        Z = Z == ve ? He : Z, ce = ce == ve ? He : ce;
        var fe = Z == He, pe = ce == He, Se = Z == ce;
        if (Se && wi(s)) {
          if (!wi(c))
            return !1;
          R = !0, fe = !1;
        }
        if (Se && !fe)
          return B || (B = new Gn()), R || Za(s) ? Oy(s, c, p, y, x, B) : L_(s, c, Z, p, y, x, B);
        if (!(p & w)) {
          var $e = fe && St.call(s, "__wrapped__"), Ke = pe && St.call(c, "__wrapped__");
          if ($e || Ke) {
            var et = $e ? s.value() : s, qe = Ke ? c.value() : c;
            return B || (B = new Gn()), x(et, qe, p, y, B);
          }
        }
        return Se ? (B || (B = new Gn()), H_(s, c, p, y, x, B)) : !1;
      }
      function h_(s) {
        return Qt(s) && Mr(s) == ge;
      }
      function Bh(s, c, p, y) {
        var x = p.length, B = x, R = !y;
        if (s == null)
          return !B;
        for (s = Bt(s); x--; ) {
          var F = p[x];
          if (R && F[2] ? F[1] !== s[F[0]] : !(F[0] in s))
            return !1;
        }
        for (; ++x < B; ) {
          F = p[x];
          var Z = F[0], ce = s[Z], fe = F[1];
          if (R && F[2]) {
            if (ce === r && !(Z in s))
              return !1;
          } else {
            var pe = new Gn();
            if (y)
              var Se = y(ce, fe, Z, s, c, pe);
            if (!(Se === r ? ou(fe, ce, w | E, y, pe) : Se))
              return !1;
          }
        }
        return !0;
      }
      function Ym(s) {
        if (!Xt(s) || Z_(s))
          return !1;
        var c = Uo(s) ? h7 : Ws;
        return c.test(ea(s));
      }
      function p_(s) {
        return Qt(s) && Vr(s) == Pt;
      }
      function g_(s) {
        return Qt(s) && Mr(s) == _t;
      }
      function m_(s) {
        return Qt(s) && kl(s.length) && !!Ft[Vr(s)];
      }
      function Jm(s) {
        return typeof s == "function" ? s : s == null ? tn : typeof s == "object" ? Xe(s) ? ty(s[0], s[1]) : ey(s) : vb(s);
      }
      function Nh(s) {
        if (!su(s))
          return w7(s);
        var c = [];
        for (var p in Bt(s))
          St.call(s, p) && p != "constructor" && c.push(p);
        return c;
      }
      function y_(s) {
        if (!Xt(s))
          return Q_(s);
        var c = su(s), p = [];
        for (var y in s)
          y == "constructor" && (c || !St.call(s, y)) || p.push(y);
        return p;
      }
      function $h(s, c) {
        return s < c;
      }
      function Qm(s, c) {
        var p = -1, y = Qr(s) ? te(s.length) : [];
        return gi(s, function(x, B, R) {
          y[++p] = c(x, B, R);
        }), y;
      }
      function ey(s) {
        var c = Zh(s);
        return c.length == 1 && c[0][2] ? $y(c[0][0], c[0][1]) : function(p) {
          return p === s || Bh(p, s, c);
        };
      }
      function ty(s, c) {
        return Yh(s) && Ny(c) ? $y(go(s), c) : function(p) {
          var y = sp(p, s);
          return y === r && y === c ? up(p, s) : ou(c, y, w | E);
        };
      }
      function cl(s, c, p, y, x) {
        s !== c && Ih(c, function(B, R) {
          if (x || (x = new Gn()), Xt(B))
            b_(s, c, R, p, cl, y, x);
          else {
            var F = y ? y(Qh(s, R), B, R + "", s, c, x) : r;
            F === r && (F = B), Sh(s, R, F);
          }
        }, en);
      }
      function b_(s, c, p, y, x, B, R) {
        var F = Qh(s, p), Z = Qh(c, p), ce = R.get(Z);
        if (ce) {
          Sh(s, p, ce);
          return;
        }
        var fe = B ? B(F, Z, p + "", s, c, R) : r, pe = fe === r;
        if (pe) {
          var Se = Xe(Z), $e = !Se && wi(Z), Ke = !Se && !$e && Za(Z);
          fe = Z, Se || $e || Ke ? Xe(F) ? fe = F : ur(F) ? fe = Jr(F) : $e ? (pe = !1, fe = hy(Z, !0)) : Ke ? (pe = !1, fe = py(Z, !0)) : fe = [] : cu(Z) || ta(Z) ? (fe = F, ta(F) ? fe = lb(F) : (!Xt(F) || Uo(F)) && (fe = By(Z))) : pe = !1;
        }
        pe && (R.set(Z, fe), x(fe, Z, y, B, R), R.delete(Z)), Sh(s, p, fe);
      }
      function ry(s, c) {
        var p = s.length;
        if (p)
          return c += c < 0 ? p : 0, $o(c, p) ? s[c] : r;
      }
      function ny(s, c, p) {
        c.length ? c = Kt(c, function(B) {
          return Xe(B) ? function(R) {
            return Ji(R, B.length === 1 ? B[0] : B);
          } : B;
        }) : c = [tn];
        var y = -1;
        c = Kt(c, wn(De()));
        var x = Qm(s, function(B, R, F) {
          var Z = Kt(c, function(ce) {
            return ce(B);
          });
          return { criteria: Z, index: ++y, value: B };
        });
        return q6(x, function(B, R) {
          return C_(B, R, p);
        });
      }
      function w_(s, c) {
        return oy(s, c, function(p, y) {
          return up(s, y);
        });
      }
      function oy(s, c, p) {
        for (var y = -1, x = c.length, B = {}; ++y < x; ) {
          var R = c[y], F = Ji(s, R);
          p(F, R) && iu(B, yi(R, s), F);
        }
        return B;
      }
      function v_(s) {
        return function(c) {
          return Ji(c, s);
        };
      }
      function Uh(s, c, p, y) {
        var x = y ? K6 : ja, B = -1, R = c.length, F = s;
        for (s === c && (c = Jr(c)), p && (F = Kt(s, wn(p))); ++B < R; )
          for (var Z = 0, ce = c[B], fe = p ? p(ce) : ce; (Z = x(F, fe, Z, y)) > -1; )
            F !== s && Qc.call(F, Z, 1), Qc.call(s, Z, 1);
        return s;
      }
      function iy(s, c) {
        for (var p = s ? c.length : 0, y = p - 1; p--; ) {
          var x = c[p];
          if (p == y || x !== B) {
            var B = x;
            $o(x) ? Qc.call(s, x, 1) : Lh(s, x);
          }
        }
        return s;
      }
      function Rh(s, c) {
        return s + rl(Lm() * (c - s + 1));
      }
      function E_(s, c, p, y) {
        for (var x = -1, B = Or(tl((c - s) / (p || 1)), 0), R = te(B); B--; )
          R[y ? B : ++x] = s, s += p;
        return R;
      }
      function zh(s, c) {
        var p = "";
        if (!s || c < 1 || c > re)
          return p;
        do
          c % 2 && (p += s), c = rl(c / 2), c && (s += s);
        while (c);
        return p;
      }
      function tt(s, c) {
        return ep(Uy(s, c, tn), s + "");
      }
      function __(s) {
        return Mm(Xa(s));
      }
      function A_(s, c) {
        var p = Xa(s);
        return wl(p, Yi(c, 0, p.length));
      }
      function iu(s, c, p, y) {
        if (!Xt(s))
          return s;
        c = yi(c, s);
        for (var x = -1, B = c.length, R = B - 1, F = s; F != null && ++x < B; ) {
          var Z = go(c[x]), ce = p;
          if (Z === "__proto__" || Z === "constructor" || Z === "prototype")
            return s;
          if (x != R) {
            var fe = F[Z];
            ce = y ? y(fe, Z, F) : r, ce === r && (ce = Xt(fe) ? fe : $o(c[x + 1]) ? [] : {});
          }
          tu(F, Z, ce), F = F[Z];
        }
        return s;
      }
      var ay = nl ? function(s, c) {
        return nl.set(s, c), s;
      } : tn, x_ = el ? function(s, c) {
        return el(s, "toString", {
          configurable: !0,
          enumerable: !1,
          value: lp(c),
          writable: !0
        });
      } : tn;
      function k_(s) {
        return wl(Xa(s));
      }
      function $n(s, c, p) {
        var y = -1, x = s.length;
        c < 0 && (c = -c > x ? 0 : x + c), p = p > x ? x : p, p < 0 && (p += x), x = c > p ? 0 : p - c >>> 0, c >>>= 0;
        for (var B = te(x); ++y < x; )
          B[y] = s[y + c];
        return B;
      }
      function S_(s, c) {
        var p;
        return gi(s, function(y, x, B) {
          return p = c(y, x, B), !p;
        }), !!p;
      }
      function ll(s, c, p) {
        var y = 0, x = s == null ? y : s.length;
        if (typeof c == "number" && c === c && x <= J) {
          for (; y < x; ) {
            var B = y + x >>> 1, R = s[B];
            R !== null && !En(R) && (p ? R <= c : R < c) ? y = B + 1 : x = B;
          }
          return x;
        }
        return jh(s, c, tn, p);
      }
      function jh(s, c, p, y) {
        var x = 0, B = s == null ? 0 : s.length;
        if (B === 0)
          return 0;
        c = p(c);
        for (var R = c !== c, F = c === null, Z = En(c), ce = c === r; x < B; ) {
          var fe = rl((x + B) / 2), pe = p(s[fe]), Se = pe !== r, $e = pe === null, Ke = pe === pe, et = En(pe);
          if (R)
            var qe = y || Ke;
          else ce ? qe = Ke && (y || Se) : F ? qe = Ke && Se && (y || !$e) : Z ? qe = Ke && Se && !$e && (y || !et) : $e || et ? qe = !1 : qe = y ? pe <= c : pe < c;
          qe ? x = fe + 1 : B = fe;
        }
        return Fr(B, se);
      }
      function sy(s, c) {
        for (var p = -1, y = s.length, x = 0, B = []; ++p < y; ) {
          var R = s[p], F = c ? c(R) : R;
          if (!p || !Wn(F, Z)) {
            var Z = F;
            B[x++] = R === 0 ? 0 : R;
          }
        }
        return B;
      }
      function uy(s) {
        return typeof s == "number" ? s : En(s) ? q : +s;
      }
      function vn(s) {
        if (typeof s == "string")
          return s;
        if (Xe(s))
          return Kt(s, vn) + "";
        if (En(s))
          return Hm ? Hm.call(s) : "";
        var c = s + "";
        return c == "0" && 1 / s == -1 / 0 ? "-0" : c;
      }
      function mi(s, c, p) {
        var y = -1, x = Dc, B = s.length, R = !0, F = [], Z = F;
        if (p)
          R = !1, x = hh;
        else if (B >= o) {
          var ce = c ? null : z_(s);
          if (ce)
            return qc(ce);
          R = !1, x = Zs, Z = new Xi();
        } else
          Z = c ? [] : F;
        e:
          for (; ++y < B; ) {
            var fe = s[y], pe = c ? c(fe) : fe;
            if (fe = p || fe !== 0 ? fe : 0, R && pe === pe) {
              for (var Se = Z.length; Se--; )
                if (Z[Se] === pe)
                  continue e;
              c && Z.push(pe), F.push(fe);
            } else x(Z, pe, p) || (Z !== F && Z.push(pe), F.push(fe));
          }
        return F;
      }
      function Lh(s, c) {
        return c = yi(c, s), s = Ry(s, c), s == null || delete s[go(Un(c))];
      }
      function cy(s, c, p, y) {
        return iu(s, c, p(Ji(s, c)), y);
      }
      function fl(s, c, p, y) {
        for (var x = s.length, B = y ? x : -1; (y ? B-- : ++B < x) && c(s[B], B, s); )
          ;
        return p ? $n(s, y ? 0 : B, y ? B + 1 : x) : $n(s, y ? B + 1 : 0, y ? x : B);
      }
      function ly(s, c) {
        var p = s;
        return p instanceof at && (p = p.value()), ph(c, function(y, x) {
          return x.func.apply(x.thisArg, di([y], x.args));
        }, p);
      }
      function Hh(s, c, p) {
        var y = s.length;
        if (y < 2)
          return y ? mi(s[0]) : [];
        for (var x = -1, B = te(y); ++x < y; )
          for (var R = s[x], F = -1; ++F < y; )
            F != x && (B[x] = ru(B[x] || R, s[F], c, p));
        return mi(jr(B, 1), c, p);
      }
      function fy(s, c, p) {
        for (var y = -1, x = s.length, B = c.length, R = {}; ++y < x; ) {
          var F = y < B ? c[y] : r;
          p(R, s[y], F);
        }
        return R;
      }
      function Fh(s) {
        return ur(s) ? s : [];
      }
      function Mh(s) {
        return typeof s == "function" ? s : tn;
      }
      function yi(s, c) {
        return Xe(s) ? s : Yh(s, c) ? [s] : Hy(xt(s));
      }
      var T_ = tt;
      function bi(s, c, p) {
        var y = s.length;
        return p = p === r ? y : p, !c && p >= y ? s : $n(s, c, p);
      }
      var dy = p7 || function(s) {
        return zr.clearTimeout(s);
      };
      function hy(s, c) {
        if (c)
          return s.slice();
        var p = s.length, y = $m ? $m(p) : new s.constructor(p);
        return s.copy(y), y;
      }
      function Dh(s) {
        var c = new s.constructor(s.byteLength);
        return new Yc(c).set(new Yc(s)), c;
      }
      function I_(s, c) {
        var p = c ? Dh(s.buffer) : s.buffer;
        return new s.constructor(p, s.byteOffset, s.byteLength);
      }
      function O_(s) {
        var c = new s.constructor(s.source, Io.exec(s));
        return c.lastIndex = s.lastIndex, c;
      }
      function P_(s) {
        return eu ? Bt(eu.call(s)) : {};
      }
      function py(s, c) {
        var p = c ? Dh(s.buffer) : s.buffer;
        return new s.constructor(p, s.byteOffset, s.length);
      }
      function gy(s, c) {
        if (s !== c) {
          var p = s !== r, y = s === null, x = s === s, B = En(s), R = c !== r, F = c === null, Z = c === c, ce = En(c);
          if (!F && !ce && !B && s > c || B && R && Z && !F && !ce || y && R && Z || !p && Z || !x)
            return 1;
          if (!y && !B && !ce && s < c || ce && p && x && !y && !B || F && p && x || !R && x || !Z)
            return -1;
        }
        return 0;
      }
      function C_(s, c, p) {
        for (var y = -1, x = s.criteria, B = c.criteria, R = x.length, F = p.length; ++y < R; ) {
          var Z = gy(x[y], B[y]);
          if (Z) {
            if (y >= F)
              return Z;
            var ce = p[y];
            return Z * (ce == "desc" ? -1 : 1);
          }
        }
        return s.index - c.index;
      }
      function my(s, c, p, y) {
        for (var x = -1, B = s.length, R = p.length, F = -1, Z = c.length, ce = Or(B - R, 0), fe = te(Z + ce), pe = !y; ++F < Z; )
          fe[F] = c[F];
        for (; ++x < R; )
          (pe || x < B) && (fe[p[x]] = s[x]);
        for (; ce--; )
          fe[F++] = s[x++];
        return fe;
      }
      function yy(s, c, p, y) {
        for (var x = -1, B = s.length, R = -1, F = p.length, Z = -1, ce = c.length, fe = Or(B - F, 0), pe = te(fe + ce), Se = !y; ++x < fe; )
          pe[x] = s[x];
        for (var $e = x; ++Z < ce; )
          pe[$e + Z] = c[Z];
        for (; ++R < F; )
          (Se || x < B) && (pe[$e + p[R]] = s[x++]);
        return pe;
      }
      function Jr(s, c) {
        var p = -1, y = s.length;
        for (c || (c = te(y)); ++p < y; )
          c[p] = s[p];
        return c;
      }
      function po(s, c, p, y) {
        var x = !p;
        p || (p = {});
        for (var B = -1, R = c.length; ++B < R; ) {
          var F = c[B], Z = y ? y(p[F], s[F], F, p, s) : r;
          Z === r && (Z = s[F]), x ? Co(p, F, Z) : tu(p, F, Z);
        }
        return p;
      }
      function B_(s, c) {
        return po(s, Xh(s), c);
      }
      function N_(s, c) {
        return po(s, Py(s), c);
      }
      function dl(s, c) {
        return function(p, y) {
          var x = Xe(p) ? j6 : t_, B = c ? c() : {};
          return x(p, s, De(y, 2), B);
        };
      }
      function Va(s) {
        return tt(function(c, p) {
          var y = -1, x = p.length, B = x > 1 ? p[x - 1] : r, R = x > 2 ? p[2] : r;
          for (B = s.length > 3 && typeof B == "function" ? (x--, B) : r, R && Gr(p[0], p[1], R) && (B = x < 3 ? r : B, x = 1), c = Bt(c); ++y < x; ) {
            var F = p[y];
            F && s(c, F, y, B);
          }
          return c;
        });
      }
      function by(s, c) {
        return function(p, y) {
          if (p == null)
            return p;
          if (!Qr(p))
            return s(p, y);
          for (var x = p.length, B = c ? x : -1, R = Bt(p); (c ? B-- : ++B < x) && y(R[B], B, R) !== !1; )
            ;
          return p;
        };
      }
      function wy(s) {
        return function(c, p, y) {
          for (var x = -1, B = Bt(c), R = y(c), F = R.length; F--; ) {
            var Z = R[s ? F : ++x];
            if (p(B[Z], Z, B) === !1)
              break;
          }
          return c;
        };
      }
      function $_(s, c, p) {
        var y = c & _, x = au(s);
        function B() {
          var R = this && this !== zr && this instanceof B ? x : s;
          return R.apply(y ? p : this, arguments);
        }
        return B;
      }
      function vy(s) {
        return function(c) {
          c = xt(c);
          var p = La(c) ? Vn(c) : r, y = p ? p[0] : c.charAt(0), x = p ? bi(p, 1).join("") : c.slice(1);
          return y[s]() + x;
        };
      }
      function Ga(s) {
        return function(c) {
          return ph(bb(yb(c).replace(x6, "")), s, "");
        };
      }
      function au(s) {
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return new s();
            case 1:
              return new s(c[0]);
            case 2:
              return new s(c[0], c[1]);
            case 3:
              return new s(c[0], c[1], c[2]);
            case 4:
              return new s(c[0], c[1], c[2], c[3]);
            case 5:
              return new s(c[0], c[1], c[2], c[3], c[4]);
            case 6:
              return new s(c[0], c[1], c[2], c[3], c[4], c[5]);
            case 7:
              return new s(c[0], c[1], c[2], c[3], c[4], c[5], c[6]);
          }
          var p = qa(s.prototype), y = s.apply(p, c);
          return Xt(y) ? y : p;
        };
      }
      function U_(s, c, p) {
        var y = au(s);
        function x() {
          for (var B = arguments.length, R = te(B), F = B, Z = Wa(x); F--; )
            R[F] = arguments[F];
          var ce = B < 3 && R[0] !== Z && R[B - 1] !== Z ? [] : hi(R, Z);
          if (B -= ce.length, B < p)
            return ky(
              s,
              c,
              hl,
              x.placeholder,
              r,
              R,
              ce,
              r,
              r,
              p - B
            );
          var fe = this && this !== zr && this instanceof x ? y : s;
          return bn(fe, this, R);
        }
        return x;
      }
      function Ey(s) {
        return function(c, p, y) {
          var x = Bt(c);
          if (!Qr(c)) {
            var B = De(p, 3);
            c = $r(c), p = function(F) {
              return B(x[F], F, x);
            };
          }
          var R = s(c, p, y);
          return R > -1 ? x[B ? c[R] : R] : r;
        };
      }
      function _y(s) {
        return No(function(c) {
          var p = c.length, y = p, x = Bn.prototype.thru;
          for (s && c.reverse(); y--; ) {
            var B = c[y];
            if (typeof B != "function")
              throw new Cn(a);
            if (x && !R && yl(B) == "wrapper")
              var R = new Bn([], !0);
          }
          for (y = R ? y : p; ++y < p; ) {
            B = c[y];
            var F = yl(B), Z = F == "wrapper" ? Wh(B) : r;
            Z && Jh(Z[0]) && Z[1] == ($ | I | T | U) && !Z[4].length && Z[9] == 1 ? R = R[yl(Z[0])].apply(R, Z[3]) : R = B.length == 1 && Jh(B) ? R[F]() : R.thru(B);
          }
          return function() {
            var ce = arguments, fe = ce[0];
            if (R && ce.length == 1 && Xe(fe))
              return R.plant(fe).value();
            for (var pe = 0, Se = p ? c[pe].apply(this, ce) : fe; ++pe < p; )
              Se = c[pe].call(this, Se);
            return Se;
          };
        });
      }
      function hl(s, c, p, y, x, B, R, F, Z, ce) {
        var fe = c & $, pe = c & _, Se = c & O, $e = c & (I | S), Ke = c & M, et = Se ? r : au(s);
        function qe() {
          for (var ot = arguments.length, lt = te(ot), _n = ot; _n--; )
            lt[_n] = arguments[_n];
          if ($e)
            var Wr = Wa(qe), An = G6(lt, Wr);
          if (y && (lt = my(lt, y, x, $e)), B && (lt = yy(lt, B, R, $e)), ot -= An, $e && ot < ce) {
            var cr = hi(lt, Wr);
            return ky(
              s,
              c,
              hl,
              qe.placeholder,
              p,
              lt,
              cr,
              F,
              Z,
              ce - ot
            );
          }
          var Zn = pe ? p : this, zo = Se ? Zn[s] : s;
          return ot = lt.length, F ? lt = t9(lt, F) : Ke && ot > 1 && lt.reverse(), fe && Z < ot && (lt.length = Z), this && this !== zr && this instanceof qe && (zo = et || au(zo)), zo.apply(Zn, lt);
        }
        return qe;
      }
      function Ay(s, c) {
        return function(p, y) {
          return c_(p, s, c(y), {});
        };
      }
      function pl(s, c) {
        return function(p, y) {
          var x;
          if (p === r && y === r)
            return c;
          if (p !== r && (x = p), y !== r) {
            if (x === r)
              return y;
            typeof p == "string" || typeof y == "string" ? (p = vn(p), y = vn(y)) : (p = uy(p), y = uy(y)), x = s(p, y);
          }
          return x;
        };
      }
      function Kh(s) {
        return No(function(c) {
          return c = Kt(c, wn(De())), tt(function(p) {
            var y = this;
            return s(c, function(x) {
              return bn(x, y, p);
            });
          });
        });
      }
      function gl(s, c) {
        c = c === r ? " " : vn(c);
        var p = c.length;
        if (p < 2)
          return p ? zh(c, s) : c;
        var y = zh(c, tl(s / Ha(c)));
        return La(c) ? bi(Vn(y), 0, s).join("") : y.slice(0, s);
      }
      function R_(s, c, p, y) {
        var x = c & _, B = au(s);
        function R() {
          for (var F = -1, Z = arguments.length, ce = -1, fe = y.length, pe = te(fe + Z), Se = this && this !== zr && this instanceof R ? B : s; ++ce < fe; )
            pe[ce] = y[ce];
          for (; Z--; )
            pe[ce++] = arguments[++F];
          return bn(Se, x ? p : this, pe);
        }
        return R;
      }
      function xy(s) {
        return function(c, p, y) {
          return y && typeof y != "number" && Gr(c, p, y) && (p = y = r), c = Ro(c), p === r ? (p = c, c = 0) : p = Ro(p), y = y === r ? c < p ? 1 : -1 : Ro(y), E_(c, p, y, s);
        };
      }
      function ml(s) {
        return function(c, p) {
          return typeof c == "string" && typeof p == "string" || (c = Rn(c), p = Rn(p)), s(c, p);
        };
      }
      function ky(s, c, p, y, x, B, R, F, Z, ce) {
        var fe = c & I, pe = fe ? R : r, Se = fe ? r : R, $e = fe ? B : r, Ke = fe ? r : B;
        c |= fe ? T : A, c &= ~(fe ? A : T), c & C || (c &= -4);
        var et = [
          s,
          c,
          x,
          $e,
          pe,
          Ke,
          Se,
          F,
          Z,
          ce
        ], qe = p.apply(r, et);
        return Jh(s) && zy(qe, et), qe.placeholder = y, jy(qe, s, c);
      }
      function qh(s) {
        var c = Ir[s];
        return function(p, y) {
          if (p = Rn(p), y = y == null ? 0 : Fr(Qe(y), 292), y && jm(p)) {
            var x = (xt(p) + "e").split("e"), B = c(x[0] + "e" + (+x[1] + y));
            return x = (xt(B) + "e").split("e"), +(x[0] + "e" + (+x[1] - y));
          }
          return c(p);
        };
      }
      var z_ = Da && 1 / qc(new Da([, -0]))[1] == le ? function(s) {
        return new Da(s);
      } : hp;
      function Sy(s) {
        return function(c) {
          var p = Mr(c);
          return p == ge ? Eh(c) : p == _t ? e7(c) : V6(c, s(c));
        };
      }
      function Bo(s, c, p, y, x, B, R, F) {
        var Z = c & O;
        if (!Z && typeof s != "function")
          throw new Cn(a);
        var ce = y ? y.length : 0;
        if (ce || (c &= -97, y = x = r), R = R === r ? R : Or(Qe(R), 0), F = F === r ? F : Qe(F), ce -= x ? x.length : 0, c & A) {
          var fe = y, pe = x;
          y = x = r;
        }
        var Se = Z ? r : Wh(s), $e = [
          s,
          c,
          p,
          y,
          x,
          fe,
          pe,
          B,
          R,
          F
        ];
        if (Se && J_($e, Se), s = $e[0], c = $e[1], p = $e[2], y = $e[3], x = $e[4], F = $e[9] = $e[9] === r ? Z ? 0 : s.length : Or($e[9] - ce, 0), !F && c & (I | S) && (c &= -25), !c || c == _)
          var Ke = $_(s, c, p);
        else c == I || c == S ? Ke = U_(s, c, F) : (c == T || c == (_ | T)) && !x.length ? Ke = R_(s, c, p, y) : Ke = hl.apply(r, $e);
        var et = Se ? ay : zy;
        return jy(et(Ke, $e), s, c);
      }
      function Ty(s, c, p, y) {
        return s === r || Wn(s, Ma[p]) && !St.call(y, p) ? c : s;
      }
      function Iy(s, c, p, y, x, B) {
        return Xt(s) && Xt(c) && (B.set(c, s), cl(s, c, r, Iy, B), B.delete(c)), s;
      }
      function j_(s) {
        return cu(s) ? r : s;
      }
      function Oy(s, c, p, y, x, B) {
        var R = p & w, F = s.length, Z = c.length;
        if (F != Z && !(R && Z > F))
          return !1;
        var ce = B.get(s), fe = B.get(c);
        if (ce && fe)
          return ce == c && fe == s;
        var pe = -1, Se = !0, $e = p & E ? new Xi() : r;
        for (B.set(s, c), B.set(c, s); ++pe < F; ) {
          var Ke = s[pe], et = c[pe];
          if (y)
            var qe = R ? y(et, Ke, pe, c, s, B) : y(Ke, et, pe, s, c, B);
          if (qe !== r) {
            if (qe)
              continue;
            Se = !1;
            break;
          }
          if ($e) {
            if (!gh(c, function(ot, lt) {
              if (!Zs($e, lt) && (Ke === ot || x(Ke, ot, p, y, B)))
                return $e.push(lt);
            })) {
              Se = !1;
              break;
            }
          } else if (!(Ke === et || x(Ke, et, p, y, B))) {
            Se = !1;
            break;
          }
        }
        return B.delete(s), B.delete(c), Se;
      }
      function L_(s, c, p, y, x, B, R) {
        switch (p) {
          case v:
            if (s.byteLength != c.byteLength || s.byteOffset != c.byteOffset)
              return !1;
            s = s.buffer, c = c.buffer;
          case m:
            return !(s.byteLength != c.byteLength || !B(new Yc(s), new Yc(c)));
          case we:
          case be:
          case Te:
            return Wn(+s, +c);
          case Le:
            return s.name == c.name && s.message == c.message;
          case Pt:
          case yt:
            return s == c + "";
          case ge:
            var F = Eh;
          case _t:
            var Z = y & w;
            if (F || (F = qc), s.size != c.size && !Z)
              return !1;
            var ce = R.get(s);
            if (ce)
              return ce == c;
            y |= E, R.set(s, c);
            var fe = Oy(F(s), F(c), y, x, B, R);
            return R.delete(s), fe;
          case Zt:
            if (eu)
              return eu.call(s) == eu.call(c);
        }
        return !1;
      }
      function H_(s, c, p, y, x, B) {
        var R = p & w, F = Vh(s), Z = F.length, ce = Vh(c), fe = ce.length;
        if (Z != fe && !R)
          return !1;
        for (var pe = Z; pe--; ) {
          var Se = F[pe];
          if (!(R ? Se in c : St.call(c, Se)))
            return !1;
        }
        var $e = B.get(s), Ke = B.get(c);
        if ($e && Ke)
          return $e == c && Ke == s;
        var et = !0;
        B.set(s, c), B.set(c, s);
        for (var qe = R; ++pe < Z; ) {
          Se = F[pe];
          var ot = s[Se], lt = c[Se];
          if (y)
            var _n = R ? y(lt, ot, Se, c, s, B) : y(ot, lt, Se, s, c, B);
          if (!(_n === r ? ot === lt || x(ot, lt, p, y, B) : _n)) {
            et = !1;
            break;
          }
          qe || (qe = Se == "constructor");
        }
        if (et && !qe) {
          var Wr = s.constructor, An = c.constructor;
          Wr != An && "constructor" in s && "constructor" in c && !(typeof Wr == "function" && Wr instanceof Wr && typeof An == "function" && An instanceof An) && (et = !1);
        }
        return B.delete(s), B.delete(c), et;
      }
      function No(s) {
        return ep(Uy(s, r, Ky), s + "");
      }
      function Vh(s) {
        return Zm(s, $r, Xh);
      }
      function Gh(s) {
        return Zm(s, en, Py);
      }
      var Wh = nl ? function(s) {
        return nl.get(s);
      } : hp;
      function yl(s) {
        for (var c = s.name + "", p = Ka[c], y = St.call(Ka, c) ? p.length : 0; y--; ) {
          var x = p[y], B = x.func;
          if (B == null || B == s)
            return x.name;
        }
        return c;
      }
      function Wa(s) {
        var c = St.call(P, "placeholder") ? P : s;
        return c.placeholder;
      }
      function De() {
        var s = P.iteratee || fp;
        return s = s === fp ? Jm : s, arguments.length ? s(arguments[0], arguments[1]) : s;
      }
      function bl(s, c) {
        var p = s.__data__;
        return W_(c) ? p[typeof c == "string" ? "string" : "hash"] : p.map;
      }
      function Zh(s) {
        for (var c = $r(s), p = c.length; p--; ) {
          var y = c[p], x = s[y];
          c[p] = [y, x, Ny(x)];
        }
        return c;
      }
      function Qi(s, c) {
        var p = Y6(s, c);
        return Ym(p) ? p : r;
      }
      function F_(s) {
        var c = St.call(s, Wi), p = s[Wi];
        try {
          s[Wi] = r;
          var y = !0;
        } catch {
        }
        var x = Zc.call(s);
        return y && (c ? s[Wi] = p : delete s[Wi]), x;
      }
      var Xh = Ah ? function(s) {
        return s == null ? [] : (s = Bt(s), fi(Ah(s), function(c) {
          return Rm.call(s, c);
        }));
      } : pp, Py = Ah ? function(s) {
        for (var c = []; s; )
          di(c, Xh(s)), s = Jc(s);
        return c;
      } : pp, Mr = Vr;
      (xh && Mr(new xh(new ArrayBuffer(1))) != v || Ys && Mr(new Ys()) != ge || kh && Mr(kh.resolve()) != mt || Da && Mr(new Da()) != _t || Js && Mr(new Js()) != kt) && (Mr = function(s) {
        var c = Vr(s), p = c == He ? s.constructor : r, y = p ? ea(p) : "";
        if (y)
          switch (y) {
            case A7:
              return v;
            case x7:
              return ge;
            case k7:
              return mt;
            case S7:
              return _t;
            case T7:
              return kt;
          }
        return c;
      });
      function M_(s, c, p) {
        for (var y = -1, x = p.length; ++y < x; ) {
          var B = p[y], R = B.size;
          switch (B.type) {
            case "drop":
              s += R;
              break;
            case "dropRight":
              c -= R;
              break;
            case "take":
              c = Fr(c, s + R);
              break;
            case "takeRight":
              s = Or(s, c - R);
              break;
          }
        }
        return { start: s, end: c };
      }
      function D_(s) {
        var c = s.match(it);
        return c ? c[1].split(ct) : [];
      }
      function Cy(s, c, p) {
        c = yi(c, s);
        for (var y = -1, x = c.length, B = !1; ++y < x; ) {
          var R = go(c[y]);
          if (!(B = s != null && p(s, R)))
            break;
          s = s[R];
        }
        return B || ++y != x ? B : (x = s == null ? 0 : s.length, !!x && kl(x) && $o(R, x) && (Xe(s) || ta(s)));
      }
      function K_(s) {
        var c = s.length, p = new s.constructor(c);
        return c && typeof s[0] == "string" && St.call(s, "index") && (p.index = s.index, p.input = s.input), p;
      }
      function By(s) {
        return typeof s.constructor == "function" && !su(s) ? qa(Jc(s)) : {};
      }
      function q_(s, c, p) {
        var y = s.constructor;
        switch (c) {
          case m:
            return Dh(s);
          case we:
          case be:
            return new y(+s);
          case v:
            return I_(s, p);
          case k:
          case H:
          case X:
          case oe:
          case me:
          case nt:
          case Ct:
          case At:
          case vt:
            return py(s, p);
          case ge:
            return new y();
          case Te:
          case yt:
            return new y(s);
          case Pt:
            return O_(s);
          case _t:
            return new y();
          case Zt:
            return P_(s);
        }
      }
      function V_(s, c) {
        var p = c.length;
        if (!p)
          return s;
        var y = p - 1;
        return c[y] = (p > 1 ? "& " : "") + c[y], c = c.join(p > 2 ? ", " : " "), s.replace(We, `{
/* [wrapped with ` + c + `] */
`);
      }
      function G_(s) {
        return Xe(s) || ta(s) || !!(zm && s && s[zm]);
      }
      function $o(s, c) {
        var p = typeof s;
        return c = c ?? re, !!c && (p == "number" || p != "symbol" && i6.test(s)) && s > -1 && s % 1 == 0 && s < c;
      }
      function Gr(s, c, p) {
        if (!Xt(p))
          return !1;
        var y = typeof c;
        return (y == "number" ? Qr(p) && $o(c, p.length) : y == "string" && c in p) ? Wn(p[c], s) : !1;
      }
      function Yh(s, c) {
        if (Xe(s))
          return !1;
        var p = typeof s;
        return p == "number" || p == "symbol" || p == "boolean" || s == null || En(s) ? !0 : ie.test(s) || !W.test(s) || c != null && s in Bt(c);
      }
      function W_(s) {
        var c = typeof s;
        return c == "string" || c == "number" || c == "symbol" || c == "boolean" ? s !== "__proto__" : s === null;
      }
      function Jh(s) {
        var c = yl(s), p = P[c];
        if (typeof p != "function" || !(c in at.prototype))
          return !1;
        if (s === p)
          return !0;
        var y = Wh(p);
        return !!y && s === y[0];
      }
      function Z_(s) {
        return !!Nm && Nm in s;
      }
      var X_ = Gc ? Uo : gp;
      function su(s) {
        var c = s && s.constructor, p = typeof c == "function" && c.prototype || Ma;
        return s === p;
      }
      function Ny(s) {
        return s === s && !Xt(s);
      }
      function $y(s, c) {
        return function(p) {
          return p == null ? !1 : p[s] === c && (c !== r || s in Bt(p));
        };
      }
      function Y_(s) {
        var c = Al(s, function(y) {
          return p.size === d && p.clear(), y;
        }), p = c.cache;
        return c;
      }
      function J_(s, c) {
        var p = s[1], y = c[1], x = p | y, B = x < (_ | O | $), R = y == $ && p == I || y == $ && p == U && s[7].length <= c[8] || y == ($ | U) && c[7].length <= c[8] && p == I;
        if (!(B || R))
          return s;
        y & _ && (s[2] = c[2], x |= p & _ ? 0 : C);
        var F = c[3];
        if (F) {
          var Z = s[3];
          s[3] = Z ? my(Z, F, c[4]) : F, s[4] = Z ? hi(s[3], f) : c[4];
        }
        return F = c[5], F && (Z = s[5], s[5] = Z ? yy(Z, F, c[6]) : F, s[6] = Z ? hi(s[5], f) : c[6]), F = c[7], F && (s[7] = F), y & $ && (s[8] = s[8] == null ? c[8] : Fr(s[8], c[8])), s[9] == null && (s[9] = c[9]), s[0] = c[0], s[1] = x, s;
      }
      function Q_(s) {
        var c = [];
        if (s != null)
          for (var p in Bt(s))
            c.push(p);
        return c;
      }
      function e9(s) {
        return Zc.call(s);
      }
      function Uy(s, c, p) {
        return c = Or(c === r ? s.length - 1 : c, 0), function() {
          for (var y = arguments, x = -1, B = Or(y.length - c, 0), R = te(B); ++x < B; )
            R[x] = y[c + x];
          x = -1;
          for (var F = te(c + 1); ++x < c; )
            F[x] = y[x];
          return F[c] = p(R), bn(s, this, F);
        };
      }
      function Ry(s, c) {
        return c.length < 2 ? s : Ji(s, $n(c, 0, -1));
      }
      function t9(s, c) {
        for (var p = s.length, y = Fr(c.length, p), x = Jr(s); y--; ) {
          var B = c[y];
          s[y] = $o(B, p) ? x[B] : r;
        }
        return s;
      }
      function Qh(s, c) {
        if (!(c === "constructor" && typeof s[c] == "function") && c != "__proto__")
          return s[c];
      }
      var zy = Ly(ay), uu = m7 || function(s, c) {
        return zr.setTimeout(s, c);
      }, ep = Ly(x_);
      function jy(s, c, p) {
        var y = c + "";
        return ep(s, V_(y, r9(D_(y), p)));
      }
      function Ly(s) {
        var c = 0, p = 0;
        return function() {
          var y = v7(), x = de - (y - p);
          if (p = y, x > 0) {
            if (++c >= ee)
              return arguments[0];
          } else
            c = 0;
          return s.apply(r, arguments);
        };
      }
      function wl(s, c) {
        var p = -1, y = s.length, x = y - 1;
        for (c = c === r ? y : c; ++p < c; ) {
          var B = Rh(p, x), R = s[B];
          s[B] = s[p], s[p] = R;
        }
        return s.length = c, s;
      }
      var Hy = Y_(function(s) {
        var c = [];
        return s.charCodeAt(0) === 46 && c.push(""), s.replace(he, function(p, y, x, B) {
          c.push(x ? B.replace(qn, "$1") : y || p);
        }), c;
      });
      function go(s) {
        if (typeof s == "string" || En(s))
          return s;
        var c = s + "";
        return c == "0" && 1 / s == -1 / 0 ? "-0" : c;
      }
      function ea(s) {
        if (s != null) {
          try {
            return Wc.call(s);
          } catch {
          }
          try {
            return s + "";
          } catch {
          }
        }
        return "";
      }
      function r9(s, c) {
        return Pn(ye, function(p) {
          var y = "_." + p[0];
          c & p[1] && !Dc(s, y) && s.push(y);
        }), s.sort();
      }
      function Fy(s) {
        if (s instanceof at)
          return s.clone();
        var c = new Bn(s.__wrapped__, s.__chain__);
        return c.__actions__ = Jr(s.__actions__), c.__index__ = s.__index__, c.__values__ = s.__values__, c;
      }
      function n9(s, c, p) {
        (p ? Gr(s, c, p) : c === r) ? c = 1 : c = Or(Qe(c), 0);
        var y = s == null ? 0 : s.length;
        if (!y || c < 1)
          return [];
        for (var x = 0, B = 0, R = te(tl(y / c)); x < y; )
          R[B++] = $n(s, x, x += c);
        return R;
      }
      function o9(s) {
        for (var c = -1, p = s == null ? 0 : s.length, y = 0, x = []; ++c < p; ) {
          var B = s[c];
          B && (x[y++] = B);
        }
        return x;
      }
      function i9() {
        var s = arguments.length;
        if (!s)
          return [];
        for (var c = te(s - 1), p = arguments[0], y = s; y--; )
          c[y - 1] = arguments[y];
        return di(Xe(p) ? Jr(p) : [p], jr(c, 1));
      }
      var a9 = tt(function(s, c) {
        return ur(s) ? ru(s, jr(c, 1, ur, !0)) : [];
      }), s9 = tt(function(s, c) {
        var p = Un(c);
        return ur(p) && (p = r), ur(s) ? ru(s, jr(c, 1, ur, !0), De(p, 2)) : [];
      }), u9 = tt(function(s, c) {
        var p = Un(c);
        return ur(p) && (p = r), ur(s) ? ru(s, jr(c, 1, ur, !0), r, p) : [];
      });
      function c9(s, c, p) {
        var y = s == null ? 0 : s.length;
        return y ? (c = p || c === r ? 1 : Qe(c), $n(s, c < 0 ? 0 : c, y)) : [];
      }
      function l9(s, c, p) {
        var y = s == null ? 0 : s.length;
        return y ? (c = p || c === r ? 1 : Qe(c), c = y - c, $n(s, 0, c < 0 ? 0 : c)) : [];
      }
      function f9(s, c) {
        return s && s.length ? fl(s, De(c, 3), !0, !0) : [];
      }
      function d9(s, c) {
        return s && s.length ? fl(s, De(c, 3), !0) : [];
      }
      function h9(s, c, p, y) {
        var x = s == null ? 0 : s.length;
        return x ? (p && typeof p != "number" && Gr(s, c, p) && (p = 0, y = x), i_(s, c, p, y)) : [];
      }
      function My(s, c, p) {
        var y = s == null ? 0 : s.length;
        if (!y)
          return -1;
        var x = p == null ? 0 : Qe(p);
        return x < 0 && (x = Or(y + x, 0)), Kc(s, De(c, 3), x);
      }
      function Dy(s, c, p) {
        var y = s == null ? 0 : s.length;
        if (!y)
          return -1;
        var x = y - 1;
        return p !== r && (x = Qe(p), x = p < 0 ? Or(y + x, 0) : Fr(x, y - 1)), Kc(s, De(c, 3), x, !0);
      }
      function Ky(s) {
        var c = s == null ? 0 : s.length;
        return c ? jr(s, 1) : [];
      }
      function p9(s) {
        var c = s == null ? 0 : s.length;
        return c ? jr(s, le) : [];
      }
      function g9(s, c) {
        var p = s == null ? 0 : s.length;
        return p ? (c = c === r ? 1 : Qe(c), jr(s, c)) : [];
      }
      function m9(s) {
        for (var c = -1, p = s == null ? 0 : s.length, y = {}; ++c < p; ) {
          var x = s[c];
          y[x[0]] = x[1];
        }
        return y;
      }
      function qy(s) {
        return s && s.length ? s[0] : r;
      }
      function y9(s, c, p) {
        var y = s == null ? 0 : s.length;
        if (!y)
          return -1;
        var x = p == null ? 0 : Qe(p);
        return x < 0 && (x = Or(y + x, 0)), ja(s, c, x);
      }
      function b9(s) {
        var c = s == null ? 0 : s.length;
        return c ? $n(s, 0, -1) : [];
      }
      var w9 = tt(function(s) {
        var c = Kt(s, Fh);
        return c.length && c[0] === s[0] ? Ch(c) : [];
      }), v9 = tt(function(s) {
        var c = Un(s), p = Kt(s, Fh);
        return c === Un(p) ? c = r : p.pop(), p.length && p[0] === s[0] ? Ch(p, De(c, 2)) : [];
      }), E9 = tt(function(s) {
        var c = Un(s), p = Kt(s, Fh);
        return c = typeof c == "function" ? c : r, c && p.pop(), p.length && p[0] === s[0] ? Ch(p, r, c) : [];
      });
      function _9(s, c) {
        return s == null ? "" : b7.call(s, c);
      }
      function Un(s) {
        var c = s == null ? 0 : s.length;
        return c ? s[c - 1] : r;
      }
      function A9(s, c, p) {
        var y = s == null ? 0 : s.length;
        if (!y)
          return -1;
        var x = y;
        return p !== r && (x = Qe(p), x = x < 0 ? Or(y + x, 0) : Fr(x, y - 1)), c === c ? r7(s, c, x) : Kc(s, km, x, !0);
      }
      function x9(s, c) {
        return s && s.length ? ry(s, Qe(c)) : r;
      }
      var k9 = tt(Vy);
      function Vy(s, c) {
        return s && s.length && c && c.length ? Uh(s, c) : s;
      }
      function S9(s, c, p) {
        return s && s.length && c && c.length ? Uh(s, c, De(p, 2)) : s;
      }
      function T9(s, c, p) {
        return s && s.length && c && c.length ? Uh(s, c, r, p) : s;
      }
      var I9 = No(function(s, c) {
        var p = s == null ? 0 : s.length, y = Th(s, c);
        return iy(s, Kt(c, function(x) {
          return $o(x, p) ? +x : x;
        }).sort(gy)), y;
      });
      function O9(s, c) {
        var p = [];
        if (!(s && s.length))
          return p;
        var y = -1, x = [], B = s.length;
        for (c = De(c, 3); ++y < B; ) {
          var R = s[y];
          c(R, y, s) && (p.push(R), x.push(y));
        }
        return iy(s, x), p;
      }
      function tp(s) {
        return s == null ? s : _7.call(s);
      }
      function P9(s, c, p) {
        var y = s == null ? 0 : s.length;
        return y ? (p && typeof p != "number" && Gr(s, c, p) ? (c = 0, p = y) : (c = c == null ? 0 : Qe(c), p = p === r ? y : Qe(p)), $n(s, c, p)) : [];
      }
      function C9(s, c) {
        return ll(s, c);
      }
      function B9(s, c, p) {
        return jh(s, c, De(p, 2));
      }
      function N9(s, c) {
        var p = s == null ? 0 : s.length;
        if (p) {
          var y = ll(s, c);
          if (y < p && Wn(s[y], c))
            return y;
        }
        return -1;
      }
      function $9(s, c) {
        return ll(s, c, !0);
      }
      function U9(s, c, p) {
        return jh(s, c, De(p, 2), !0);
      }
      function R9(s, c) {
        var p = s == null ? 0 : s.length;
        if (p) {
          var y = ll(s, c, !0) - 1;
          if (Wn(s[y], c))
            return y;
        }
        return -1;
      }
      function z9(s) {
        return s && s.length ? sy(s) : [];
      }
      function j9(s, c) {
        return s && s.length ? sy(s, De(c, 2)) : [];
      }
      function L9(s) {
        var c = s == null ? 0 : s.length;
        return c ? $n(s, 1, c) : [];
      }
      function H9(s, c, p) {
        return s && s.length ? (c = p || c === r ? 1 : Qe(c), $n(s, 0, c < 0 ? 0 : c)) : [];
      }
      function F9(s, c, p) {
        var y = s == null ? 0 : s.length;
        return y ? (c = p || c === r ? 1 : Qe(c), c = y - c, $n(s, c < 0 ? 0 : c, y)) : [];
      }
      function M9(s, c) {
        return s && s.length ? fl(s, De(c, 3), !1, !0) : [];
      }
      function D9(s, c) {
        return s && s.length ? fl(s, De(c, 3)) : [];
      }
      var K9 = tt(function(s) {
        return mi(jr(s, 1, ur, !0));
      }), q9 = tt(function(s) {
        var c = Un(s);
        return ur(c) && (c = r), mi(jr(s, 1, ur, !0), De(c, 2));
      }), V9 = tt(function(s) {
        var c = Un(s);
        return c = typeof c == "function" ? c : r, mi(jr(s, 1, ur, !0), r, c);
      });
      function G9(s) {
        return s && s.length ? mi(s) : [];
      }
      function W9(s, c) {
        return s && s.length ? mi(s, De(c, 2)) : [];
      }
      function Z9(s, c) {
        return c = typeof c == "function" ? c : r, s && s.length ? mi(s, r, c) : [];
      }
      function rp(s) {
        if (!(s && s.length))
          return [];
        var c = 0;
        return s = fi(s, function(p) {
          if (ur(p))
            return c = Or(p.length, c), !0;
        }), wh(c, function(p) {
          return Kt(s, mh(p));
        });
      }
      function Gy(s, c) {
        if (!(s && s.length))
          return [];
        var p = rp(s);
        return c == null ? p : Kt(p, function(y) {
          return bn(c, r, y);
        });
      }
      var X9 = tt(function(s, c) {
        return ur(s) ? ru(s, c) : [];
      }), Y9 = tt(function(s) {
        return Hh(fi(s, ur));
      }), J9 = tt(function(s) {
        var c = Un(s);
        return ur(c) && (c = r), Hh(fi(s, ur), De(c, 2));
      }), Q9 = tt(function(s) {
        var c = Un(s);
        return c = typeof c == "function" ? c : r, Hh(fi(s, ur), r, c);
      }), eA = tt(rp);
      function tA(s, c) {
        return fy(s || [], c || [], tu);
      }
      function rA(s, c) {
        return fy(s || [], c || [], iu);
      }
      var nA = tt(function(s) {
        var c = s.length, p = c > 1 ? s[c - 1] : r;
        return p = typeof p == "function" ? (s.pop(), p) : r, Gy(s, p);
      });
      function Wy(s) {
        var c = P(s);
        return c.__chain__ = !0, c;
      }
      function oA(s, c) {
        return c(s), s;
      }
      function vl(s, c) {
        return c(s);
      }
      var iA = No(function(s) {
        var c = s.length, p = c ? s[0] : 0, y = this.__wrapped__, x = function(B) {
          return Th(B, s);
        };
        return c > 1 || this.__actions__.length || !(y instanceof at) || !$o(p) ? this.thru(x) : (y = y.slice(p, +p + (c ? 1 : 0)), y.__actions__.push({
          func: vl,
          args: [x],
          thisArg: r
        }), new Bn(y, this.__chain__).thru(function(B) {
          return c && !B.length && B.push(r), B;
        }));
      });
      function aA() {
        return Wy(this);
      }
      function sA() {
        return new Bn(this.value(), this.__chain__);
      }
      function uA() {
        this.__values__ === r && (this.__values__ = ub(this.value()));
        var s = this.__index__ >= this.__values__.length, c = s ? r : this.__values__[this.__index__++];
        return { done: s, value: c };
      }
      function cA() {
        return this;
      }
      function lA(s) {
        for (var c, p = this; p instanceof il; ) {
          var y = Fy(p);
          y.__index__ = 0, y.__values__ = r, c ? x.__wrapped__ = y : c = y;
          var x = y;
          p = p.__wrapped__;
        }
        return x.__wrapped__ = s, c;
      }
      function fA() {
        var s = this.__wrapped__;
        if (s instanceof at) {
          var c = s;
          return this.__actions__.length && (c = new at(this)), c = c.reverse(), c.__actions__.push({
            func: vl,
            args: [tp],
            thisArg: r
          }), new Bn(c, this.__chain__);
        }
        return this.thru(tp);
      }
      function dA() {
        return ly(this.__wrapped__, this.__actions__);
      }
      var hA = dl(function(s, c, p) {
        St.call(s, p) ? ++s[p] : Co(s, p, 1);
      });
      function pA(s, c, p) {
        var y = Xe(s) ? Am : o_;
        return p && Gr(s, c, p) && (c = r), y(s, De(c, 3));
      }
      function gA(s, c) {
        var p = Xe(s) ? fi : Gm;
        return p(s, De(c, 3));
      }
      var mA = Ey(My), yA = Ey(Dy);
      function bA(s, c) {
        return jr(El(s, c), 1);
      }
      function wA(s, c) {
        return jr(El(s, c), le);
      }
      function vA(s, c, p) {
        return p = p === r ? 1 : Qe(p), jr(El(s, c), p);
      }
      function Zy(s, c) {
        var p = Xe(s) ? Pn : gi;
        return p(s, De(c, 3));
      }
      function Xy(s, c) {
        var p = Xe(s) ? L6 : Vm;
        return p(s, De(c, 3));
      }
      var EA = dl(function(s, c, p) {
        St.call(s, p) ? s[p].push(c) : Co(s, p, [c]);
      });
      function _A(s, c, p, y) {
        s = Qr(s) ? s : Xa(s), p = p && !y ? Qe(p) : 0;
        var x = s.length;
        return p < 0 && (p = Or(x + p, 0)), Sl(s) ? p <= x && s.indexOf(c, p) > -1 : !!x && ja(s, c, p) > -1;
      }
      var AA = tt(function(s, c, p) {
        var y = -1, x = typeof c == "function", B = Qr(s) ? te(s.length) : [];
        return gi(s, function(R) {
          B[++y] = x ? bn(c, R, p) : nu(R, c, p);
        }), B;
      }), xA = dl(function(s, c, p) {
        Co(s, p, c);
      });
      function El(s, c) {
        var p = Xe(s) ? Kt : Qm;
        return p(s, De(c, 3));
      }
      function kA(s, c, p, y) {
        return s == null ? [] : (Xe(c) || (c = c == null ? [] : [c]), p = y ? r : p, Xe(p) || (p = p == null ? [] : [p]), ny(s, c, p));
      }
      var SA = dl(function(s, c, p) {
        s[p ? 0 : 1].push(c);
      }, function() {
        return [[], []];
      });
      function TA(s, c, p) {
        var y = Xe(s) ? ph : Tm, x = arguments.length < 3;
        return y(s, De(c, 4), p, x, gi);
      }
      function IA(s, c, p) {
        var y = Xe(s) ? H6 : Tm, x = arguments.length < 3;
        return y(s, De(c, 4), p, x, Vm);
      }
      function OA(s, c) {
        var p = Xe(s) ? fi : Gm;
        return p(s, xl(De(c, 3)));
      }
      function PA(s) {
        var c = Xe(s) ? Mm : __;
        return c(s);
      }
      function CA(s, c, p) {
        (p ? Gr(s, c, p) : c === r) ? c = 1 : c = Qe(c);
        var y = Xe(s) ? Q7 : A_;
        return y(s, c);
      }
      function BA(s) {
        var c = Xe(s) ? e_ : k_;
        return c(s);
      }
      function NA(s) {
        if (s == null)
          return 0;
        if (Qr(s))
          return Sl(s) ? Ha(s) : s.length;
        var c = Mr(s);
        return c == ge || c == _t ? s.size : Nh(s).length;
      }
      function $A(s, c, p) {
        var y = Xe(s) ? gh : S_;
        return p && Gr(s, c, p) && (c = r), y(s, De(c, 3));
      }
      var UA = tt(function(s, c) {
        if (s == null)
          return [];
        var p = c.length;
        return p > 1 && Gr(s, c[0], c[1]) ? c = [] : p > 2 && Gr(c[0], c[1], c[2]) && (c = [c[0]]), ny(s, jr(c, 1), []);
      }), _l = g7 || function() {
        return zr.Date.now();
      };
      function RA(s, c) {
        if (typeof c != "function")
          throw new Cn(a);
        return s = Qe(s), function() {
          if (--s < 1)
            return c.apply(this, arguments);
        };
      }
      function Yy(s, c, p) {
        return c = p ? r : c, c = s && c == null ? s.length : c, Bo(s, $, r, r, r, r, c);
      }
      function Jy(s, c) {
        var p;
        if (typeof c != "function")
          throw new Cn(a);
        return s = Qe(s), function() {
          return --s > 0 && (p = c.apply(this, arguments)), s <= 1 && (c = r), p;
        };
      }
      var np = tt(function(s, c, p) {
        var y = _;
        if (p.length) {
          var x = hi(p, Wa(np));
          y |= T;
        }
        return Bo(s, y, c, p, x);
      }), Qy = tt(function(s, c, p) {
        var y = _ | O;
        if (p.length) {
          var x = hi(p, Wa(Qy));
          y |= T;
        }
        return Bo(c, y, s, p, x);
      });
      function eb(s, c, p) {
        c = p ? r : c;
        var y = Bo(s, I, r, r, r, r, r, c);
        return y.placeholder = eb.placeholder, y;
      }
      function tb(s, c, p) {
        c = p ? r : c;
        var y = Bo(s, S, r, r, r, r, r, c);
        return y.placeholder = tb.placeholder, y;
      }
      function rb(s, c, p) {
        var y, x, B, R, F, Z, ce = 0, fe = !1, pe = !1, Se = !0;
        if (typeof s != "function")
          throw new Cn(a);
        c = Rn(c) || 0, Xt(p) && (fe = !!p.leading, pe = "maxWait" in p, B = pe ? Or(Rn(p.maxWait) || 0, c) : B, Se = "trailing" in p ? !!p.trailing : Se);
        function $e(cr) {
          var Zn = y, zo = x;
          return y = x = r, ce = cr, R = s.apply(zo, Zn), R;
        }
        function Ke(cr) {
          return ce = cr, F = uu(ot, c), fe ? $e(cr) : R;
        }
        function et(cr) {
          var Zn = cr - Z, zo = cr - ce, Eb = c - Zn;
          return pe ? Fr(Eb, B - zo) : Eb;
        }
        function qe(cr) {
          var Zn = cr - Z, zo = cr - ce;
          return Z === r || Zn >= c || Zn < 0 || pe && zo >= B;
        }
        function ot() {
          var cr = _l();
          if (qe(cr))
            return lt(cr);
          F = uu(ot, et(cr));
        }
        function lt(cr) {
          return F = r, Se && y ? $e(cr) : (y = x = r, R);
        }
        function _n() {
          F !== r && dy(F), ce = 0, y = Z = x = F = r;
        }
        function Wr() {
          return F === r ? R : lt(_l());
        }
        function An() {
          var cr = _l(), Zn = qe(cr);
          if (y = arguments, x = this, Z = cr, Zn) {
            if (F === r)
              return Ke(Z);
            if (pe)
              return dy(F), F = uu(ot, c), $e(Z);
          }
          return F === r && (F = uu(ot, c)), R;
        }
        return An.cancel = _n, An.flush = Wr, An;
      }
      var zA = tt(function(s, c) {
        return qm(s, 1, c);
      }), jA = tt(function(s, c, p) {
        return qm(s, Rn(c) || 0, p);
      });
      function LA(s) {
        return Bo(s, M);
      }
      function Al(s, c) {
        if (typeof s != "function" || c != null && typeof c != "function")
          throw new Cn(a);
        var p = function() {
          var y = arguments, x = c ? c.apply(this, y) : y[0], B = p.cache;
          if (B.has(x))
            return B.get(x);
          var R = s.apply(this, y);
          return p.cache = B.set(x, R) || B, R;
        };
        return p.cache = new (Al.Cache || Po)(), p;
      }
      Al.Cache = Po;
      function xl(s) {
        if (typeof s != "function")
          throw new Cn(a);
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return !s.call(this);
            case 1:
              return !s.call(this, c[0]);
            case 2:
              return !s.call(this, c[0], c[1]);
            case 3:
              return !s.call(this, c[0], c[1], c[2]);
          }
          return !s.apply(this, c);
        };
      }
      function HA(s) {
        return Jy(2, s);
      }
      var FA = T_(function(s, c) {
        c = c.length == 1 && Xe(c[0]) ? Kt(c[0], wn(De())) : Kt(jr(c, 1), wn(De()));
        var p = c.length;
        return tt(function(y) {
          for (var x = -1, B = Fr(y.length, p); ++x < B; )
            y[x] = c[x].call(this, y[x]);
          return bn(s, this, y);
        });
      }), op = tt(function(s, c) {
        var p = hi(c, Wa(op));
        return Bo(s, T, r, c, p);
      }), nb = tt(function(s, c) {
        var p = hi(c, Wa(nb));
        return Bo(s, A, r, c, p);
      }), MA = No(function(s, c) {
        return Bo(s, U, r, r, r, c);
      });
      function DA(s, c) {
        if (typeof s != "function")
          throw new Cn(a);
        return c = c === r ? c : Qe(c), tt(s, c);
      }
      function KA(s, c) {
        if (typeof s != "function")
          throw new Cn(a);
        return c = c == null ? 0 : Or(Qe(c), 0), tt(function(p) {
          var y = p[c], x = bi(p, 0, c);
          return y && di(x, y), bn(s, this, x);
        });
      }
      function qA(s, c, p) {
        var y = !0, x = !0;
        if (typeof s != "function")
          throw new Cn(a);
        return Xt(p) && (y = "leading" in p ? !!p.leading : y, x = "trailing" in p ? !!p.trailing : x), rb(s, c, {
          leading: y,
          maxWait: c,
          trailing: x
        });
      }
      function VA(s) {
        return Yy(s, 1);
      }
      function GA(s, c) {
        return op(Mh(c), s);
      }
      function WA() {
        if (!arguments.length)
          return [];
        var s = arguments[0];
        return Xe(s) ? s : [s];
      }
      function ZA(s) {
        return Nn(s, b);
      }
      function XA(s, c) {
        return c = typeof c == "function" ? c : r, Nn(s, b, c);
      }
      function YA(s) {
        return Nn(s, h | b);
      }
      function JA(s, c) {
        return c = typeof c == "function" ? c : r, Nn(s, h | b, c);
      }
      function QA(s, c) {
        return c == null || Km(s, c, $r(c));
      }
      function Wn(s, c) {
        return s === c || s !== s && c !== c;
      }
      var ex = ml(Ph), tx = ml(function(s, c) {
        return s >= c;
      }), ta = Xm(/* @__PURE__ */ function() {
        return arguments;
      }()) ? Xm : function(s) {
        return Qt(s) && St.call(s, "callee") && !Rm.call(s, "callee");
      }, Xe = te.isArray, rx = ym ? wn(ym) : l_;
      function Qr(s) {
        return s != null && kl(s.length) && !Uo(s);
      }
      function ur(s) {
        return Qt(s) && Qr(s);
      }
      function nx(s) {
        return s === !0 || s === !1 || Qt(s) && Vr(s) == we;
      }
      var wi = y7 || gp, ox = bm ? wn(bm) : f_;
      function ix(s) {
        return Qt(s) && s.nodeType === 1 && !cu(s);
      }
      function ax(s) {
        if (s == null)
          return !0;
        if (Qr(s) && (Xe(s) || typeof s == "string" || typeof s.splice == "function" || wi(s) || Za(s) || ta(s)))
          return !s.length;
        var c = Mr(s);
        if (c == ge || c == _t)
          return !s.size;
        if (su(s))
          return !Nh(s).length;
        for (var p in s)
          if (St.call(s, p))
            return !1;
        return !0;
      }
      function sx(s, c) {
        return ou(s, c);
      }
      function ux(s, c, p) {
        p = typeof p == "function" ? p : r;
        var y = p ? p(s, c) : r;
        return y === r ? ou(s, c, r, p) : !!y;
      }
      function ip(s) {
        if (!Qt(s))
          return !1;
        var c = Vr(s);
        return c == Le || c == Ge || typeof s.message == "string" && typeof s.name == "string" && !cu(s);
      }
      function cx(s) {
        return typeof s == "number" && jm(s);
      }
      function Uo(s) {
        if (!Xt(s))
          return !1;
        var c = Vr(s);
        return c == Ne || c == Ve || c == _e || c == rt;
      }
      function ob(s) {
        return typeof s == "number" && s == Qe(s);
      }
      function kl(s) {
        return typeof s == "number" && s > -1 && s % 1 == 0 && s <= re;
      }
      function Xt(s) {
        var c = typeof s;
        return s != null && (c == "object" || c == "function");
      }
      function Qt(s) {
        return s != null && typeof s == "object";
      }
      var ib = wm ? wn(wm) : h_;
      function lx(s, c) {
        return s === c || Bh(s, c, Zh(c));
      }
      function fx(s, c, p) {
        return p = typeof p == "function" ? p : r, Bh(s, c, Zh(c), p);
      }
      function dx(s) {
        return ab(s) && s != +s;
      }
      function hx(s) {
        if (X_(s))
          throw new Ze(i);
        return Ym(s);
      }
      function px(s) {
        return s === null;
      }
      function gx(s) {
        return s == null;
      }
      function ab(s) {
        return typeof s == "number" || Qt(s) && Vr(s) == Te;
      }
      function cu(s) {
        if (!Qt(s) || Vr(s) != He)
          return !1;
        var c = Jc(s);
        if (c === null)
          return !0;
        var p = St.call(c, "constructor") && c.constructor;
        return typeof p == "function" && p instanceof p && Wc.call(p) == f7;
      }
      var ap = vm ? wn(vm) : p_;
      function mx(s) {
        return ob(s) && s >= -9007199254740991 && s <= re;
      }
      var sb = Em ? wn(Em) : g_;
      function Sl(s) {
        return typeof s == "string" || !Xe(s) && Qt(s) && Vr(s) == yt;
      }
      function En(s) {
        return typeof s == "symbol" || Qt(s) && Vr(s) == Zt;
      }
      var Za = _m ? wn(_m) : m_;
      function yx(s) {
        return s === r;
      }
      function bx(s) {
        return Qt(s) && Mr(s) == kt;
      }
      function wx(s) {
        return Qt(s) && Vr(s) == qr;
      }
      var vx = ml($h), Ex = ml(function(s, c) {
        return s <= c;
      });
      function ub(s) {
        if (!s)
          return [];
        if (Qr(s))
          return Sl(s) ? Vn(s) : Jr(s);
        if (Xs && s[Xs])
          return Q6(s[Xs]());
        var c = Mr(s), p = c == ge ? Eh : c == _t ? qc : Xa;
        return p(s);
      }
      function Ro(s) {
        if (!s)
          return s === 0 ? s : 0;
        if (s = Rn(s), s === le || s === -1 / 0) {
          var c = s < 0 ? -1 : 1;
          return c * G;
        }
        return s === s ? s : 0;
      }
      function Qe(s) {
        var c = Ro(s), p = c % 1;
        return c === c ? p ? c - p : c : 0;
      }
      function cb(s) {
        return s ? Yi(Qe(s), 0, Q) : 0;
      }
      function Rn(s) {
        if (typeof s == "number")
          return s;
        if (En(s))
          return q;
        if (Xt(s)) {
          var c = typeof s.valueOf == "function" ? s.valueOf() : s;
          s = Xt(c) ? c + "" : c;
        }
        if (typeof s != "string")
          return s === 0 ? s : +s;
        s = Im(s);
        var p = Ra.test(s);
        return p || Vi.test(s) ? R6(s.slice(2), p ? 2 : 8) : li.test(s) ? q : +s;
      }
      function lb(s) {
        return po(s, en(s));
      }
      function _x(s) {
        return s ? Yi(Qe(s), -9007199254740991, re) : s === 0 ? s : 0;
      }
      function xt(s) {
        return s == null ? "" : vn(s);
      }
      var Ax = Va(function(s, c) {
        if (su(c) || Qr(c)) {
          po(c, $r(c), s);
          return;
        }
        for (var p in c)
          St.call(c, p) && tu(s, p, c[p]);
      }), fb = Va(function(s, c) {
        po(c, en(c), s);
      }), Tl = Va(function(s, c, p, y) {
        po(c, en(c), s, y);
      }), xx = Va(function(s, c, p, y) {
        po(c, $r(c), s, y);
      }), kx = No(Th);
      function Sx(s, c) {
        var p = qa(s);
        return c == null ? p : Dm(p, c);
      }
      var Tx = tt(function(s, c) {
        s = Bt(s);
        var p = -1, y = c.length, x = y > 2 ? c[2] : r;
        for (x && Gr(c[0], c[1], x) && (y = 1); ++p < y; )
          for (var B = c[p], R = en(B), F = -1, Z = R.length; ++F < Z; ) {
            var ce = R[F], fe = s[ce];
            (fe === r || Wn(fe, Ma[ce]) && !St.call(s, ce)) && (s[ce] = B[ce]);
          }
        return s;
      }), Ix = tt(function(s) {
        return s.push(r, Iy), bn(db, r, s);
      });
      function Ox(s, c) {
        return xm(s, De(c, 3), ho);
      }
      function Px(s, c) {
        return xm(s, De(c, 3), Oh);
      }
      function Cx(s, c) {
        return s == null ? s : Ih(s, De(c, 3), en);
      }
      function Bx(s, c) {
        return s == null ? s : Wm(s, De(c, 3), en);
      }
      function Nx(s, c) {
        return s && ho(s, De(c, 3));
      }
      function $x(s, c) {
        return s && Oh(s, De(c, 3));
      }
      function Ux(s) {
        return s == null ? [] : ul(s, $r(s));
      }
      function Rx(s) {
        return s == null ? [] : ul(s, en(s));
      }
      function sp(s, c, p) {
        var y = s == null ? r : Ji(s, c);
        return y === r ? p : y;
      }
      function zx(s, c) {
        return s != null && Cy(s, c, a_);
      }
      function up(s, c) {
        return s != null && Cy(s, c, s_);
      }
      var jx = Ay(function(s, c, p) {
        c != null && typeof c.toString != "function" && (c = Zc.call(c)), s[c] = p;
      }, lp(tn)), Lx = Ay(function(s, c, p) {
        c != null && typeof c.toString != "function" && (c = Zc.call(c)), St.call(s, c) ? s[c].push(p) : s[c] = [p];
      }, De), Hx = tt(nu);
      function $r(s) {
        return Qr(s) ? Fm(s) : Nh(s);
      }
      function en(s) {
        return Qr(s) ? Fm(s, !0) : y_(s);
      }
      function Fx(s, c) {
        var p = {};
        return c = De(c, 3), ho(s, function(y, x, B) {
          Co(p, c(y, x, B), y);
        }), p;
      }
      function Mx(s, c) {
        var p = {};
        return c = De(c, 3), ho(s, function(y, x, B) {
          Co(p, x, c(y, x, B));
        }), p;
      }
      var Dx = Va(function(s, c, p) {
        cl(s, c, p);
      }), db = Va(function(s, c, p, y) {
        cl(s, c, p, y);
      }), Kx = No(function(s, c) {
        var p = {};
        if (s == null)
          return p;
        var y = !1;
        c = Kt(c, function(B) {
          return B = yi(B, s), y || (y = B.length > 1), B;
        }), po(s, Gh(s), p), y && (p = Nn(p, h | g | b, j_));
        for (var x = c.length; x--; )
          Lh(p, c[x]);
        return p;
      });
      function qx(s, c) {
        return hb(s, xl(De(c)));
      }
      var Vx = No(function(s, c) {
        return s == null ? {} : w_(s, c);
      });
      function hb(s, c) {
        if (s == null)
          return {};
        var p = Kt(Gh(s), function(y) {
          return [y];
        });
        return c = De(c), oy(s, p, function(y, x) {
          return c(y, x[0]);
        });
      }
      function Gx(s, c, p) {
        c = yi(c, s);
        var y = -1, x = c.length;
        for (x || (x = 1, s = r); ++y < x; ) {
          var B = s == null ? r : s[go(c[y])];
          B === r && (y = x, B = p), s = Uo(B) ? B.call(s) : B;
        }
        return s;
      }
      function Wx(s, c, p) {
        return s == null ? s : iu(s, c, p);
      }
      function Zx(s, c, p, y) {
        return y = typeof y == "function" ? y : r, s == null ? s : iu(s, c, p, y);
      }
      var pb = Sy($r), gb = Sy(en);
      function Xx(s, c, p) {
        var y = Xe(s), x = y || wi(s) || Za(s);
        if (c = De(c, 4), p == null) {
          var B = s && s.constructor;
          x ? p = y ? new B() : [] : Xt(s) ? p = Uo(B) ? qa(Jc(s)) : {} : p = {};
        }
        return (x ? Pn : ho)(s, function(R, F, Z) {
          return c(p, R, F, Z);
        }), p;
      }
      function Yx(s, c) {
        return s == null ? !0 : Lh(s, c);
      }
      function Jx(s, c, p) {
        return s == null ? s : cy(s, c, Mh(p));
      }
      function Qx(s, c, p, y) {
        return y = typeof y == "function" ? y : r, s == null ? s : cy(s, c, Mh(p), y);
      }
      function Xa(s) {
        return s == null ? [] : vh(s, $r(s));
      }
      function ek(s) {
        return s == null ? [] : vh(s, en(s));
      }
      function tk(s, c, p) {
        return p === r && (p = c, c = r), p !== r && (p = Rn(p), p = p === p ? p : 0), c !== r && (c = Rn(c), c = c === c ? c : 0), Yi(Rn(s), c, p);
      }
      function rk(s, c, p) {
        return c = Ro(c), p === r ? (p = c, c = 0) : p = Ro(p), s = Rn(s), u_(s, c, p);
      }
      function nk(s, c, p) {
        if (p && typeof p != "boolean" && Gr(s, c, p) && (c = p = r), p === r && (typeof c == "boolean" ? (p = c, c = r) : typeof s == "boolean" && (p = s, s = r)), s === r && c === r ? (s = 0, c = 1) : (s = Ro(s), c === r ? (c = s, s = 0) : c = Ro(c)), s > c) {
          var y = s;
          s = c, c = y;
        }
        if (p || s % 1 || c % 1) {
          var x = Lm();
          return Fr(s + x * (c - s + U6("1e-" + ((x + "").length - 1))), c);
        }
        return Rh(s, c);
      }
      var ok = Ga(function(s, c, p) {
        return c = c.toLowerCase(), s + (p ? mb(c) : c);
      });
      function mb(s) {
        return cp(xt(s).toLowerCase());
      }
      function yb(s) {
        return s = xt(s), s && s.replace(a6, W6).replace(k6, "");
      }
      function ik(s, c, p) {
        s = xt(s), c = vn(c);
        var y = s.length;
        p = p === r ? y : Yi(Qe(p), 0, y);
        var x = p;
        return p -= c.length, p >= 0 && s.slice(p, x) == c;
      }
      function ak(s) {
        return s = xt(s), s && Ua.test(s) ? s.replace(Hr, Z6) : s;
      }
      function sk(s) {
        return s = xt(s), s && Ie.test(s) ? s.replace(Ae, "\\$&") : s;
      }
      var uk = Ga(function(s, c, p) {
        return s + (p ? "-" : "") + c.toLowerCase();
      }), ck = Ga(function(s, c, p) {
        return s + (p ? " " : "") + c.toLowerCase();
      }), lk = vy("toLowerCase");
      function fk(s, c, p) {
        s = xt(s), c = Qe(c);
        var y = c ? Ha(s) : 0;
        if (!c || y >= c)
          return s;
        var x = (c - y) / 2;
        return gl(rl(x), p) + s + gl(tl(x), p);
      }
      function dk(s, c, p) {
        s = xt(s), c = Qe(c);
        var y = c ? Ha(s) : 0;
        return c && y < c ? s + gl(c - y, p) : s;
      }
      function hk(s, c, p) {
        s = xt(s), c = Qe(c);
        var y = c ? Ha(s) : 0;
        return c && y < c ? gl(c - y, p) + s : s;
      }
      function pk(s, c, p) {
        return p || c == null ? c = 0 : c && (c = +c), E7(xt(s).replace(Me, ""), c || 0);
      }
      function gk(s, c, p) {
        return (p ? Gr(s, c, p) : c === r) ? c = 1 : c = Qe(c), zh(xt(s), c);
      }
      function mk() {
        var s = arguments, c = xt(s[0]);
        return s.length < 3 ? c : c.replace(s[1], s[2]);
      }
      var yk = Ga(function(s, c, p) {
        return s + (p ? "_" : "") + c.toLowerCase();
      });
      function bk(s, c, p) {
        return p && typeof p != "number" && Gr(s, c, p) && (c = p = r), p = p === r ? Q : p >>> 0, p ? (s = xt(s), s && (typeof c == "string" || c != null && !ap(c)) && (c = vn(c), !c && La(s)) ? bi(Vn(s), 0, p) : s.split(c, p)) : [];
      }
      var wk = Ga(function(s, c, p) {
        return s + (p ? " " : "") + cp(c);
      });
      function vk(s, c, p) {
        return s = xt(s), p = p == null ? 0 : Yi(Qe(p), 0, s.length), c = vn(c), s.slice(p, p + c.length) == c;
      }
      function Ek(s, c, p) {
        var y = P.templateSettings;
        p && Gr(s, c, p) && (c = r), s = xt(s), c = Tl({}, c, y, Ty);
        var x = Tl({}, c.imports, y.imports, Ty), B = $r(x), R = vh(x, B), F, Z, ce = 0, fe = c.interpolate || Hc, pe = "__p += '", Se = _h(
          (c.escape || Hc).source + "|" + fe.source + "|" + (fe === z ? ci : Hc).source + "|" + (c.evaluate || Hc).source + "|$",
          "g"
        ), $e = "//# sourceURL=" + (St.call(c, "sourceURL") ? (c.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++P6 + "]") + `
`;
        s.replace(Se, function(qe, ot, lt, _n, Wr, An) {
          return lt || (lt = _n), pe += s.slice(ce, An).replace(s6, X6), ot && (F = !0, pe += `' +
__e(` + ot + `) +
'`), Wr && (Z = !0, pe += `';
` + Wr + `;
__p += '`), lt && (pe += `' +
((__t = (` + lt + `)) == null ? '' : __t) +
'`), ce = An + qe.length, qe;
        }), pe += `';
`;
        var Ke = St.call(c, "variable") && c.variable;
        if (!Ke)
          pe = `with (obj) {
` + pe + `
}
`;
        else if (sr.test(Ke))
          throw new Ze(u);
        pe = (Z ? pe.replace(Ht, "") : pe).replace(jc, "$1").replace(Lc, "$1;"), pe = "function(" + (Ke || "obj") + `) {
` + (Ke ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (F ? ", __e = _.escape" : "") + (Z ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + pe + `return __p
}`;
        var et = wb(function() {
          return Et(B, $e + "return " + pe).apply(r, R);
        });
        if (et.source = pe, ip(et))
          throw et;
        return et;
      }
      function _k(s) {
        return xt(s).toLowerCase();
      }
      function Ak(s) {
        return xt(s).toUpperCase();
      }
      function xk(s, c, p) {
        if (s = xt(s), s && (p || c === r))
          return Im(s);
        if (!s || !(c = vn(c)))
          return s;
        var y = Vn(s), x = Vn(c), B = Om(y, x), R = Pm(y, x) + 1;
        return bi(y, B, R).join("");
      }
      function kk(s, c, p) {
        if (s = xt(s), s && (p || c === r))
          return s.slice(0, Bm(s) + 1);
        if (!s || !(c = vn(c)))
          return s;
        var y = Vn(s), x = Pm(y, Vn(c)) + 1;
        return bi(y, 0, x).join("");
      }
      function Sk(s, c, p) {
        if (s = xt(s), s && (p || c === r))
          return s.replace(Me, "");
        if (!s || !(c = vn(c)))
          return s;
        var y = Vn(s), x = Om(y, Vn(c));
        return bi(y, x).join("");
      }
      function Tk(s, c) {
        var p = Y, y = L;
        if (Xt(c)) {
          var x = "separator" in c ? c.separator : x;
          p = "length" in c ? Qe(c.length) : p, y = "omission" in c ? vn(c.omission) : y;
        }
        s = xt(s);
        var B = s.length;
        if (La(s)) {
          var R = Vn(s);
          B = R.length;
        }
        if (p >= B)
          return s;
        var F = p - Ha(y);
        if (F < 1)
          return y;
        var Z = R ? bi(R, 0, F).join("") : s.slice(0, F);
        if (x === r)
          return Z + y;
        if (R && (F += Z.length - F), ap(x)) {
          if (s.slice(F).search(x)) {
            var ce, fe = Z;
            for (x.global || (x = _h(x.source, xt(Io.exec(x)) + "g")), x.lastIndex = 0; ce = x.exec(fe); )
              var pe = ce.index;
            Z = Z.slice(0, pe === r ? F : pe);
          }
        } else if (s.indexOf(vn(x), F) != F) {
          var Se = Z.lastIndexOf(x);
          Se > -1 && (Z = Z.slice(0, Se));
        }
        return Z + y;
      }
      function Ik(s) {
        return s = xt(s), s && fo.test(s) ? s.replace(Gs, n7) : s;
      }
      var Ok = Ga(function(s, c, p) {
        return s + (p ? " " : "") + c.toUpperCase();
      }), cp = vy("toUpperCase");
      function bb(s, c, p) {
        return s = xt(s), c = p ? r : c, c === r ? J6(s) ? a7(s) : D6(s) : s.match(c) || [];
      }
      var wb = tt(function(s, c) {
        try {
          return bn(s, r, c);
        } catch (p) {
          return ip(p) ? p : new Ze(p);
        }
      }), Pk = No(function(s, c) {
        return Pn(c, function(p) {
          p = go(p), Co(s, p, np(s[p], s));
        }), s;
      });
      function Ck(s) {
        var c = s == null ? 0 : s.length, p = De();
        return s = c ? Kt(s, function(y) {
          if (typeof y[1] != "function")
            throw new Cn(a);
          return [p(y[0]), y[1]];
        }) : [], tt(function(y) {
          for (var x = -1; ++x < c; ) {
            var B = s[x];
            if (bn(B[0], this, y))
              return bn(B[1], this, y);
          }
        });
      }
      function Bk(s) {
        return n_(Nn(s, h));
      }
      function lp(s) {
        return function() {
          return s;
        };
      }
      function Nk(s, c) {
        return s == null || s !== s ? c : s;
      }
      var $k = _y(), Uk = _y(!0);
      function tn(s) {
        return s;
      }
      function fp(s) {
        return Jm(typeof s == "function" ? s : Nn(s, h));
      }
      function Rk(s) {
        return ey(Nn(s, h));
      }
      function zk(s, c) {
        return ty(s, Nn(c, h));
      }
      var jk = tt(function(s, c) {
        return function(p) {
          return nu(p, s, c);
        };
      }), Lk = tt(function(s, c) {
        return function(p) {
          return nu(s, p, c);
        };
      });
      function dp(s, c, p) {
        var y = $r(c), x = ul(c, y);
        p == null && !(Xt(c) && (x.length || !y.length)) && (p = c, c = s, s = this, x = ul(c, $r(c)));
        var B = !(Xt(p) && "chain" in p) || !!p.chain, R = Uo(s);
        return Pn(x, function(F) {
          var Z = c[F];
          s[F] = Z, R && (s.prototype[F] = function() {
            var ce = this.__chain__;
            if (B || ce) {
              var fe = s(this.__wrapped__), pe = fe.__actions__ = Jr(this.__actions__);
              return pe.push({ func: Z, args: arguments, thisArg: s }), fe.__chain__ = ce, fe;
            }
            return Z.apply(s, di([this.value()], arguments));
          });
        }), s;
      }
      function Hk() {
        return zr._ === this && (zr._ = d7), this;
      }
      function hp() {
      }
      function Fk(s) {
        return s = Qe(s), tt(function(c) {
          return ry(c, s);
        });
      }
      var Mk = Kh(Kt), Dk = Kh(Am), Kk = Kh(gh);
      function vb(s) {
        return Yh(s) ? mh(go(s)) : v_(s);
      }
      function qk(s) {
        return function(c) {
          return s == null ? r : Ji(s, c);
        };
      }
      var Vk = xy(), Gk = xy(!0);
      function pp() {
        return [];
      }
      function gp() {
        return !1;
      }
      function Wk() {
        return {};
      }
      function Zk() {
        return "";
      }
      function Xk() {
        return !0;
      }
      function Yk(s, c) {
        if (s = Qe(s), s < 1 || s > re)
          return [];
        var p = Q, y = Fr(s, Q);
        c = De(c), s -= Q;
        for (var x = wh(y, c); ++p < s; )
          c(p);
        return x;
      }
      function Jk(s) {
        return Xe(s) ? Kt(s, go) : En(s) ? [s] : Jr(Hy(xt(s)));
      }
      function Qk(s) {
        var c = ++l7;
        return xt(s) + c;
      }
      var eS = pl(function(s, c) {
        return s + c;
      }, 0), tS = qh("ceil"), rS = pl(function(s, c) {
        return s / c;
      }, 1), nS = qh("floor");
      function oS(s) {
        return s && s.length ? sl(s, tn, Ph) : r;
      }
      function iS(s, c) {
        return s && s.length ? sl(s, De(c, 2), Ph) : r;
      }
      function aS(s) {
        return Sm(s, tn);
      }
      function sS(s, c) {
        return Sm(s, De(c, 2));
      }
      function uS(s) {
        return s && s.length ? sl(s, tn, $h) : r;
      }
      function cS(s, c) {
        return s && s.length ? sl(s, De(c, 2), $h) : r;
      }
      var lS = pl(function(s, c) {
        return s * c;
      }, 1), fS = qh("round"), dS = pl(function(s, c) {
        return s - c;
      }, 0);
      function hS(s) {
        return s && s.length ? bh(s, tn) : 0;
      }
      function pS(s, c) {
        return s && s.length ? bh(s, De(c, 2)) : 0;
      }
      return P.after = RA, P.ary = Yy, P.assign = Ax, P.assignIn = fb, P.assignInWith = Tl, P.assignWith = xx, P.at = kx, P.before = Jy, P.bind = np, P.bindAll = Pk, P.bindKey = Qy, P.castArray = WA, P.chain = Wy, P.chunk = n9, P.compact = o9, P.concat = i9, P.cond = Ck, P.conforms = Bk, P.constant = lp, P.countBy = hA, P.create = Sx, P.curry = eb, P.curryRight = tb, P.debounce = rb, P.defaults = Tx, P.defaultsDeep = Ix, P.defer = zA, P.delay = jA, P.difference = a9, P.differenceBy = s9, P.differenceWith = u9, P.drop = c9, P.dropRight = l9, P.dropRightWhile = f9, P.dropWhile = d9, P.fill = h9, P.filter = gA, P.flatMap = bA, P.flatMapDeep = wA, P.flatMapDepth = vA, P.flatten = Ky, P.flattenDeep = p9, P.flattenDepth = g9, P.flip = LA, P.flow = $k, P.flowRight = Uk, P.fromPairs = m9, P.functions = Ux, P.functionsIn = Rx, P.groupBy = EA, P.initial = b9, P.intersection = w9, P.intersectionBy = v9, P.intersectionWith = E9, P.invert = jx, P.invertBy = Lx, P.invokeMap = AA, P.iteratee = fp, P.keyBy = xA, P.keys = $r, P.keysIn = en, P.map = El, P.mapKeys = Fx, P.mapValues = Mx, P.matches = Rk, P.matchesProperty = zk, P.memoize = Al, P.merge = Dx, P.mergeWith = db, P.method = jk, P.methodOf = Lk, P.mixin = dp, P.negate = xl, P.nthArg = Fk, P.omit = Kx, P.omitBy = qx, P.once = HA, P.orderBy = kA, P.over = Mk, P.overArgs = FA, P.overEvery = Dk, P.overSome = Kk, P.partial = op, P.partialRight = nb, P.partition = SA, P.pick = Vx, P.pickBy = hb, P.property = vb, P.propertyOf = qk, P.pull = k9, P.pullAll = Vy, P.pullAllBy = S9, P.pullAllWith = T9, P.pullAt = I9, P.range = Vk, P.rangeRight = Gk, P.rearg = MA, P.reject = OA, P.remove = O9, P.rest = DA, P.reverse = tp, P.sampleSize = CA, P.set = Wx, P.setWith = Zx, P.shuffle = BA, P.slice = P9, P.sortBy = UA, P.sortedUniq = z9, P.sortedUniqBy = j9, P.split = bk, P.spread = KA, P.tail = L9, P.take = H9, P.takeRight = F9, P.takeRightWhile = M9, P.takeWhile = D9, P.tap = oA, P.throttle = qA, P.thru = vl, P.toArray = ub, P.toPairs = pb, P.toPairsIn = gb, P.toPath = Jk, P.toPlainObject = lb, P.transform = Xx, P.unary = VA, P.union = K9, P.unionBy = q9, P.unionWith = V9, P.uniq = G9, P.uniqBy = W9, P.uniqWith = Z9, P.unset = Yx, P.unzip = rp, P.unzipWith = Gy, P.update = Jx, P.updateWith = Qx, P.values = Xa, P.valuesIn = ek, P.without = X9, P.words = bb, P.wrap = GA, P.xor = Y9, P.xorBy = J9, P.xorWith = Q9, P.zip = eA, P.zipObject = tA, P.zipObjectDeep = rA, P.zipWith = nA, P.entries = pb, P.entriesIn = gb, P.extend = fb, P.extendWith = Tl, dp(P, P), P.add = eS, P.attempt = wb, P.camelCase = ok, P.capitalize = mb, P.ceil = tS, P.clamp = tk, P.clone = ZA, P.cloneDeep = YA, P.cloneDeepWith = JA, P.cloneWith = XA, P.conformsTo = QA, P.deburr = yb, P.defaultTo = Nk, P.divide = rS, P.endsWith = ik, P.eq = Wn, P.escape = ak, P.escapeRegExp = sk, P.every = pA, P.find = mA, P.findIndex = My, P.findKey = Ox, P.findLast = yA, P.findLastIndex = Dy, P.findLastKey = Px, P.floor = nS, P.forEach = Zy, P.forEachRight = Xy, P.forIn = Cx, P.forInRight = Bx, P.forOwn = Nx, P.forOwnRight = $x, P.get = sp, P.gt = ex, P.gte = tx, P.has = zx, P.hasIn = up, P.head = qy, P.identity = tn, P.includes = _A, P.indexOf = y9, P.inRange = rk, P.invoke = Hx, P.isArguments = ta, P.isArray = Xe, P.isArrayBuffer = rx, P.isArrayLike = Qr, P.isArrayLikeObject = ur, P.isBoolean = nx, P.isBuffer = wi, P.isDate = ox, P.isElement = ix, P.isEmpty = ax, P.isEqual = sx, P.isEqualWith = ux, P.isError = ip, P.isFinite = cx, P.isFunction = Uo, P.isInteger = ob, P.isLength = kl, P.isMap = ib, P.isMatch = lx, P.isMatchWith = fx, P.isNaN = dx, P.isNative = hx, P.isNil = gx, P.isNull = px, P.isNumber = ab, P.isObject = Xt, P.isObjectLike = Qt, P.isPlainObject = cu, P.isRegExp = ap, P.isSafeInteger = mx, P.isSet = sb, P.isString = Sl, P.isSymbol = En, P.isTypedArray = Za, P.isUndefined = yx, P.isWeakMap = bx, P.isWeakSet = wx, P.join = _9, P.kebabCase = uk, P.last = Un, P.lastIndexOf = A9, P.lowerCase = ck, P.lowerFirst = lk, P.lt = vx, P.lte = Ex, P.max = oS, P.maxBy = iS, P.mean = aS, P.meanBy = sS, P.min = uS, P.minBy = cS, P.stubArray = pp, P.stubFalse = gp, P.stubObject = Wk, P.stubString = Zk, P.stubTrue = Xk, P.multiply = lS, P.nth = x9, P.noConflict = Hk, P.noop = hp, P.now = _l, P.pad = fk, P.padEnd = dk, P.padStart = hk, P.parseInt = pk, P.random = nk, P.reduce = TA, P.reduceRight = IA, P.repeat = gk, P.replace = mk, P.result = Gx, P.round = fS, P.runInContext = V, P.sample = PA, P.size = NA, P.snakeCase = yk, P.some = $A, P.sortedIndex = C9, P.sortedIndexBy = B9, P.sortedIndexOf = N9, P.sortedLastIndex = $9, P.sortedLastIndexBy = U9, P.sortedLastIndexOf = R9, P.startCase = wk, P.startsWith = vk, P.subtract = dS, P.sum = hS, P.sumBy = pS, P.template = Ek, P.times = Yk, P.toFinite = Ro, P.toInteger = Qe, P.toLength = cb, P.toLower = _k, P.toNumber = Rn, P.toSafeInteger = _x, P.toString = xt, P.toUpper = Ak, P.trim = xk, P.trimEnd = kk, P.trimStart = Sk, P.truncate = Tk, P.unescape = Ik, P.uniqueId = Qk, P.upperCase = Ok, P.upperFirst = cp, P.each = Zy, P.eachRight = Xy, P.first = qy, dp(P, function() {
        var s = {};
        return ho(P, function(c, p) {
          St.call(P.prototype, p) || (s[p] = c);
        }), s;
      }(), { chain: !1 }), P.VERSION = n, Pn(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(s) {
        P[s].placeholder = P;
      }), Pn(["drop", "take"], function(s, c) {
        at.prototype[s] = function(p) {
          p = p === r ? 1 : Or(Qe(p), 0);
          var y = this.__filtered__ && !c ? new at(this) : this.clone();
          return y.__filtered__ ? y.__takeCount__ = Fr(p, y.__takeCount__) : y.__views__.push({
            size: Fr(p, Q),
            type: s + (y.__dir__ < 0 ? "Right" : "")
          }), y;
        }, at.prototype[s + "Right"] = function(p) {
          return this.reverse()[s](p).reverse();
        };
      }), Pn(["filter", "map", "takeWhile"], function(s, c) {
        var p = c + 1, y = p == ne || p == K;
        at.prototype[s] = function(x) {
          var B = this.clone();
          return B.__iteratees__.push({
            iteratee: De(x, 3),
            type: p
          }), B.__filtered__ = B.__filtered__ || y, B;
        };
      }), Pn(["head", "last"], function(s, c) {
        var p = "take" + (c ? "Right" : "");
        at.prototype[s] = function() {
          return this[p](1).value()[0];
        };
      }), Pn(["initial", "tail"], function(s, c) {
        var p = "drop" + (c ? "" : "Right");
        at.prototype[s] = function() {
          return this.__filtered__ ? new at(this) : this[p](1);
        };
      }), at.prototype.compact = function() {
        return this.filter(tn);
      }, at.prototype.find = function(s) {
        return this.filter(s).head();
      }, at.prototype.findLast = function(s) {
        return this.reverse().find(s);
      }, at.prototype.invokeMap = tt(function(s, c) {
        return typeof s == "function" ? new at(this) : this.map(function(p) {
          return nu(p, s, c);
        });
      }), at.prototype.reject = function(s) {
        return this.filter(xl(De(s)));
      }, at.prototype.slice = function(s, c) {
        s = Qe(s);
        var p = this;
        return p.__filtered__ && (s > 0 || c < 0) ? new at(p) : (s < 0 ? p = p.takeRight(-s) : s && (p = p.drop(s)), c !== r && (c = Qe(c), p = c < 0 ? p.dropRight(-c) : p.take(c - s)), p);
      }, at.prototype.takeRightWhile = function(s) {
        return this.reverse().takeWhile(s).reverse();
      }, at.prototype.toArray = function() {
        return this.take(Q);
      }, ho(at.prototype, function(s, c) {
        var p = /^(?:filter|find|map|reject)|While$/.test(c), y = /^(?:head|last)$/.test(c), x = P[y ? "take" + (c == "last" ? "Right" : "") : c], B = y || /^find/.test(c);
        x && (P.prototype[c] = function() {
          var R = this.__wrapped__, F = y ? [1] : arguments, Z = R instanceof at, ce = F[0], fe = Z || Xe(R), pe = function(ot) {
            var lt = x.apply(P, di([ot], F));
            return y && Se ? lt[0] : lt;
          };
          fe && p && typeof ce == "function" && ce.length != 1 && (Z = fe = !1);
          var Se = this.__chain__, $e = !!this.__actions__.length, Ke = B && !Se, et = Z && !$e;
          if (!B && fe) {
            R = et ? R : new at(this);
            var qe = s.apply(R, F);
            return qe.__actions__.push({ func: vl, args: [pe], thisArg: r }), new Bn(qe, Se);
          }
          return Ke && et ? s.apply(this, F) : (qe = this.thru(pe), Ke ? y ? qe.value()[0] : qe.value() : qe);
        });
      }), Pn(["pop", "push", "shift", "sort", "splice", "unshift"], function(s) {
        var c = Vc[s], p = /^(?:push|sort|unshift)$/.test(s) ? "tap" : "thru", y = /^(?:pop|shift)$/.test(s);
        P.prototype[s] = function() {
          var x = arguments;
          if (y && !this.__chain__) {
            var B = this.value();
            return c.apply(Xe(B) ? B : [], x);
          }
          return this[p](function(R) {
            return c.apply(Xe(R) ? R : [], x);
          });
        };
      }), ho(at.prototype, function(s, c) {
        var p = P[c];
        if (p) {
          var y = p.name + "";
          St.call(Ka, y) || (Ka[y] = []), Ka[y].push({ name: c, func: p });
        }
      }), Ka[hl(r, O).name] = [{
        name: "wrapper",
        func: r
      }], at.prototype.clone = I7, at.prototype.reverse = O7, at.prototype.value = P7, P.prototype.at = iA, P.prototype.chain = aA, P.prototype.commit = sA, P.prototype.next = uA, P.prototype.plant = lA, P.prototype.reverse = fA, P.prototype.toJSON = P.prototype.valueOf = P.prototype.value = dA, P.prototype.first = P.prototype.head, Xs && (P.prototype[Xs] = cA), P;
    }, Fa = s7();
    Gi ? ((Gi.exports = Fa)._ = Fa, fh._ = Fa) : zr._ = Fa;
  }).call(zt);
})(C5, C5.exports);
var EPe = C5.exports;
const Bj = /* @__PURE__ */ nV(EPe), _Pe = (e) => /^(?:[A-Za-z0-9+\/]{4})*?(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/.test(e), APe = (e) => /^[a-fA-F0-9]+$/.test(e), vp = (e) => {
  const t = [];
  let r = e;
  do {
    let n = r & BigInt(127);
    r >>= BigInt(7), r !== BigInt(0) && (n |= BigInt(128)), t.push(Number(n));
  } while (r !== BigInt(0));
  return { varint: Buffer.from(t) };
};
function KE(e) {
  return Bj.omitBy(e, Bj.isUndefined);
}
const xPe = ({
  runeId: e,
  amount: t,
  divisibility: r = 0,
  sendOutputIndex: n = 1,
  pointer: o = 0
}) => {
  r === 0 && (t = Math.floor(t));
  const i = vp(BigInt(22)).varint, a = vp(BigInt(o)).varint, u = vp(BigInt(0)).varint, l = vp(BigInt(t * 10 ** r)).varint, d = vp(BigInt(n)).varint, f = e.split(":"), h = Number(f[0]), g = Number(f[1]), b = vp(BigInt(h)).varint, w = vp(BigInt(g)).varint, E = Buffer.concat([
    i,
    a,
    u,
    b,
    w,
    l,
    d
  ]);
  let _ = E.byteLength.toString(16);
  return _.length % 2 !== 0 && (_ = "0" + E.byteLength.toString(16)), Buffer.concat([
    Buffer.from("6a", "hex"),
    Buffer.from("5d", "hex"),
    Buffer.from(_, "hex"),
    E
  ]);
}, qE = async (e, t) => {
  const r = JSON.stringify({
    jsonrpc: "2.0",
    id: e,
    method: e,
    params: t
  });
  return await un.post(`${HN}/${sw}`, r, {
    headers: {
      "content-type": "application/json"
    }
  }).then((n) => n.data).catch((n) => {
    throw n;
  });
}, kPe = async (e) => {
  try {
    return (await qE("ord_address", [
      e
    ])).result;
  } catch (t) {
    throw t;
  }
}, dY = async (e) => {
  try {
    return (await qE("ord_rune", [e])).result;
  } catch (t) {
    throw t;
  }
}, SPe = async (e) => {
  try {
    return (await qE("ord_rune", [e])).result;
  } catch (t) {
    throw t;
  }
}, TPe = async ({
  outpoints: e,
  rune_name: t
}) => {
  const r = [];
  for (let n = 0; n < e.length; n += 1e3) {
    const o = e.slice(n, n + 1e3), i = o.map((l) => ["ord_output", [l]]), { result: a } = await qE("sandshrew_multicall", i);
    for (let l = 0; l < a.length; l++)
      a[l].result.output = o[l];
    const u = a.filter(
      (l) => Object.keys(l.result.runes).includes(t)
    );
    r.push(...u);
  }
  return r;
}, IPe = async ({
  ordOutputs: e
}) => {
  var t;
  try {
    const r = [];
    for (let n = 0; n < e.length; n++) {
      const o = e[n], { result: i } = o;
      if (!((t = i.output) != null && t.split(":")))
        throw new Error("No output found");
      const { output: a, address: u, runes: l } = i, d = {
        output: a,
        wallet_addr: u,
        script: "",
        balances: [],
        decimals: [],
        rune_ids: [],
        value: i.value
      }, [f, h] = a.split(":");
      if (console.log(f, h, a), d.script = Buffer.from(
        oY(u, zn)
      ).toString("hex"), typeof l == "object" && !Array.isArray(l))
        for (const g in l)
          d.balances.push(l[g].amount), d.decimals.push(l[g].divisibility), d.rune_ids.push((await SPe(g)).id);
      r.push(d);
    }
    return r;
  } catch (r) {
    throw r;
  }
}, OPe = async ({
  address: e,
  runeId: t
}) => {
  const r = await kPe(e), { entry: n } = await dY(t), o = n.spaced_rune, i = await TPe({
    outpoints: r.outputs,
    rune_name: o
  });
  return await IPe({
    ordOutputs: i
  });
}, PPe = async ({
  runeId: e,
  amount: t,
  ordinalAddress: r,
  ordinalPublicKey: n,
  paymentAddress: o,
  paymentPublicKey: i,
  toAddress: a,
  signPsbt: u,
  network: l = zn
}) => {
  try {
    const d = await CPe({
      fromAddress: r,
      fromAddressPublicKey: n,
      fromPaymentAddress: o,
      fromPaymentPublicKey: i,
      toAddress: a,
      runeId: e,
      amount: t,
      network: l
    });
    if (!d || !(d != null && d.psbtHex))
      throw new Error("couldn't get commit tx");
    const f = String(d == null ? void 0 : d.psbtHex), h = String(d == null ? void 0 : d.psbtBase64), g = await u({
      tx: f,
      psbtHex: f,
      psbtBase64: h,
      finalize: !0,
      broadcast: !1,
      network: l
    });
    if (!g) throw new Error("sign psbt failed");
    const b = Yr.fromHex((g == null ? void 0 : g.signedPsbtHex) || "").extractTransaction();
    return await LE(b.toHex(), l);
  } catch (d) {
    throw d;
  }
}, CPe = async ({
  fromAddress: e,
  fromAddressPublicKey: t,
  fromPaymentAddress: r,
  fromPaymentPublicKey: n,
  toAddress: o,
  runeId: i,
  amount: a,
  network: u
}) => {
  try {
    const { fastestFee: l } = await nY(u);
    let d = (await VN(r, u)).sort((A, $) => $.value - A.value).filter((A) => A.value > 3e3);
    if (d.length === 0)
      throw new Error("No utxos found");
    let f = new Yr({ network: pn(u) }), h = 0;
    const g = await dY(i), b = await OPe({ runeId: i, address: e }), w = jE(d), E = qN(b.length, 2, 4);
    let _ = E * l < 250 ? 250 : E * l, O = 0;
    for await (const A of b) {
      const { output: $, value: U, script: M } = A, Y = $.split(":"), L = Y[0], ee = Y[1];
      f.addInput({
        hash: L,
        index: parseInt(ee),
        witnessUtxo: {
          value: BigInt(U),
          script: Buffer.from(M, "hex")
        },
        tapInternalKey: Uu(Buffer.from(t, "hex"))
      }), O++, h += U;
    }
    const C = zE(r, u);
    for (let A = 0; A < d.length; A++) {
      const $ = df(
        r,
        pn(zn)
      ), U = d[A];
      if (C === Y1 && f.addInput({
        hash: U.txid,
        index: U.vout,
        witnessUtxo: {
          value: BigInt(U.value),
          script: $
        },
        tapInternalKey: Uu(Buffer.from(n, "hex"))
      }), C === V2) {
        let M = gv(n, u);
        f.addInput({
          hash: U.txid,
          index: U.vout,
          witnessUtxo: {
            value: BigInt(U.value),
            script: $
          },
          redeemScript: M
        });
      }
      C === "p2wpkh" && f.addInput({
        hash: U.txid,
        index: U.vout,
        witnessUtxo: {
          value: BigInt(U.value),
          script: $
        }
      });
    }
    const I = { script: xPe({
      runeId: g.id,
      amount: a,
      divisibility: g.entry.divisibility,
      sendOutputIndex: 2,
      pointer: 1
    }), value: BigInt(0) };
    f.addOutput(I);
    const S = 546, T = w - (_ + S * 2);
    return f.addOutput({
      value: BigInt(S),
      address: e
    }), f.addOutput({
      value: BigInt(S),
      address: o
    }), f.addOutput({
      address: e,
      value: BigInt(T)
    }), { psbtBase64: f.toBase64(), psbtHex: f.toHex() };
  } catch (l) {
    throw l;
  }
}, hY = "maestro", BPe = "mempool-space", NPe = "sandshrew";
function xi(e, t, r) {
  var n;
  if (!e || typeof e != "object")
    return r;
  for (const o of t)
    if (e[o] !== void 0)
      return ((n = e[o]) == null ? void 0 : n.toString()) || r;
  return r;
}
function x8(e, t, r) {
  if (!e || typeof e != "object")
    return r;
  for (const n of t)
    if (e[n] !== void 0) {
      const o = Number(e[n]);
      return isNaN(o) ? r : o;
    }
  return r;
}
function N1(e, t = "unknown", r) {
  var n, o;
  if (!e)
    return console.warn(`Invalid inscription data from source: ${t}`), {
      id: "",
      inscriptionId: "",
      content: "",
      number: 0,
      address: "",
      contentType: "unknown",
      output: "",
      location: "",
      preview: "",
      genesisTransaction: "",
      height: 0,
      outputValue: 0
    };
  const i = xi(e, [
    "id",
    "inscription_id",
    "inscriptionId"
  ], ""), a = x8(e, [
    "num",
    "number",
    "inscriptionNumber"
  ], 0), u = xi(e, [
    "address",
    "owner",
    "ownerAddress"
  ], ""), l = xi(e, [
    "content_type",
    "contentType",
    "mime",
    "mimeType"
  ], "unknown");
  let d = xi(e, ["utxo_txid", "txid", "transaction_id"], ""), f = x8(e, ["vout", "utxo_vout"], 0), h = xi(e, ["output"], "");
  h || d && (h = `${d}:${f}`), h && (!d || !f) && (console.warn(`Invalid inscription location from source: ${t}`), d = h.split(":")[0], f = parseInt(h.split(":")[1]));
  const g = x8(e, ["output_value", "value", "outputValue", "postage", "satoshis"], 0), b = x8(e, ["height", "block_height"], 0);
  let w = xi(e, [
    "genesis_tx_id",
    "genesisTx",
    "genesis_txid",
    "genesisTransaction"
  ], ((o = (n = e.inscription_id) == null ? void 0 : n.split("i")) == null ? void 0 : o[0]) || e.txid || "");
  const E = e.utxo_sat_offset !== void 0 ? e.utxo_sat_offset : 0;
  if (!i)
    throw console.warn(`Invalid inscription data from source: ${t}`), new Error(`Invalid inscription data from source: ${t}`);
  if (!u)
    throw console.warn(`Invalid inscription address from source: ${t}`), new Error(`Invalid inscription address from source: ${t}`);
  if (!h)
    throw console.warn(`Invalid inscription output from source: ${t}`), new Error(`Invalid inscription output from source: ${t}`);
  if (!l)
    throw console.warn(`Invalid inscription content type from source: ${t}`), new Error(`Invalid inscription content type from source: ${t}`);
  return w || (w = i.split("i")[0]), {
    address: u,
    id: i,
    inscriptionId: i,
    number: a,
    outputValue: g,
    contentType: l,
    output: h,
    location: `${d}:${f}:${E}`,
    content: `${tOe(r)}/${i}`,
    preview: `${rOe(r)}/${i}`,
    genesisTransaction: w,
    height: b,
    offset: E
  };
}
function $Pe(e, t = "unknown") {
  const r = [];
  if (!e)
    return console.warn(`Invalid BRC20 balance data from source: ${t}`), r;
  if (e.data && typeof e.data == "object")
    return Object.entries(e.data).forEach(([n, o]) => {
      const i = xi(o, ["overall", "overallBalance", "total", "totalBalance"], "0"), a = xi(o, ["transferable", "transferableBalance"], "na"), u = xi(o, ["available", "availableBalance"], "0");
      if (!i || !u) {
        console.warn(`Invalid BRC20 balance data from source: ${t}`);
        return;
      }
      const l = {
        ticker: n,
        overall: i,
        transferable: a ?? "na",
        available: u
      };
      r.push(l);
    }), r;
  if (Array.isArray(e))
    return e.forEach((n) => {
      const o = xi(n, ["ticker", "tick", "token"], "");
      if (!o) {
        console.warn(`Missing ticker in BRC20 balance from source: ${t}`);
        return;
      }
      const i = xi(n, ["overall", "overallBalance", "total", "totalBalance"], "0"), a = xi(n, ["transferable", "transferableBalance"], "0"), u = xi(n, ["available", "availableBalance"], "0");
      if (!i || !u) {
        console.warn(`Invalid BRC20 balance data from source: ${t}`);
        return;
      }
      const l = {
        ticker: o,
        overall: i,
        transferable: a ?? "na",
        available: u
      };
      r.push(l);
    }), r;
  if (typeof e == "object" && !Array.isArray(e)) {
    const n = xi(e, ["ticker", "tick", "token"], "");
    if (!n)
      return console.warn(`Missing ticker in BRC20 balance from source: ${t}`), r;
    const o = xi(e, ["overall", "overallBalance", "total", "totalBalance"], "0"), i = xi(e, ["transferable", "transferableBalance"], "0"), a = xi(e, ["available", "availableBalance"], "0");
    if (!o || !a)
      throw console.warn(`Invalid BRC20 balance data from source: ${t}`), new Error(`Invalid BRC20 balance data from source: ${t}`);
    const u = {
      ticker: n,
      overall: o,
      transferable: i ?? "na",
      available: a
    };
    return r.push(u), r;
  }
  return console.warn(`Unrecognized BRC20 balance format from source: ${t}`), r;
}
class UPe {
  constructor(t, r, n) {
    ut(this, "apiUrl", ""), ut(this, "apiKey"), ut(this, "testnetApiKey"), this.apiKey = t, this.testnetApiKey = n, this.setNetwork(r);
  }
  getName() {
    return hY;
  }
  setNetwork(t) {
    this.apiUrl = eOe(t), this.apiUrl.includes("testnet") ? this.apiKey = this.testnetApiKey || this.apiKey : this.apiKey = this.apiKey;
  }
  async call(t, r, n) {
    const o = `${this.apiUrl}${r}`;
    try {
      const i = {
        headers: {
          "Content-Type": "application/json",
          "api-key": this.apiKey
        }
      };
      return (t === "get" ? await un.get(o, i) : await un.post(o, n, i)).data;
    } catch (i) {
      throw console.error("MaestroDataSource.call error:", i), i;
    }
  }
  async getAddressBtcBalance(t) {
    return (await this.call("get", `/addresses/${t}/balance`)).data;
  }
  async getAddressBrc20Balances(t) {
    return await this.call("get", `/addresses/${t}/brc20`);
  }
  async getAddressInscriptions(t, r, n) {
    const o = new URLSearchParams();
    r !== void 0 && o.append("offset", r.toString()), n !== void 0 && o.append("limit", n.toString());
    const i = `/addresses/${t}/inscriptions${o.toString() ? `?${o.toString()}` : ""}`, a = await this.call("get", i);
    return {
      ...a,
      data: a.data.map((u) => ({ ...u, address: t }))
    };
  }
  async getInscriptionInfo(t) {
    return await this.call("get", `/assets/inscriptions/${t}`);
  }
  async getBrc20ByTicker(t) {
    return this.call("get", `/assets/brc20/${t}`);
  }
  async getRuneById(t) {
    return this.call("get", `/assets/runes/${t}`);
  }
  async getRuneByName(t) {
    return this.call("get", `/assets/runes/${t}`);
  }
  async getTransactionInfo(t) {
    return this.call("get", `/rpc/transaction/${t}`);
  }
  async broadcastTransaction(t) {
    return await this.call("post", "/arpc/transaction/submit", t);
  }
  async getRawTransaction(t) {
    return this.call("get", `/raw-transactions/${t}`);
  }
  async getRecommendedFees() {
    return this.call("get", "/fees/recommended");
  }
  async getOrdAddress(t) {
    return this.call("get", `/inscriptions/${t}`);
  }
}
class RPe {
  constructor(t, r) {
    ut(this, "apiUrl", ""), this.setNetwork(r, t), console.log(this.apiUrl);
  }
  getName() {
    return BPe;
  }
  setNetwork(t, r) {
    this.apiUrl = r ? `${r}${t === "mainnet" ? "" : `/${t}`}` : dv(t);
  }
  async call(t, r, n) {
    try {
      const o = `${this.apiUrl}${r}`, i = {
        headers: {
          "Content-Type": t === "post" ? "text/plain" : "application/json"
        }
      };
      return (t === "get" ? await un.get(o, i) : await un.post(o, n, i)).data;
    } catch (o) {
      throw console.error("MempoolSpaceDataSource.call error:", o), o;
    }
  }
  async getOutputValueByVOutIndex(t, r) {
    const n = Date.now();
    for (; ; )
      try {
        const o = await this.getTransaction(t);
        if (o && o.vout && o.vout.length > 0)
          return Math.floor(o.vout[r].value);
        if (Date.now() - n > 6e4)
          return null;
        await new Promise((i) => setTimeout(i, 5e3));
      } catch (o) {
        if (console.error("Error fetching transaction output value:", o), Date.now() - n > 6e4)
          return null;
        await new Promise((i) => setTimeout(i, 5e3));
      }
  }
  async waitForTransaction(t) {
    const r = Date.now();
    for (; ; )
      try {
        if (await this.getTransaction(t))
          return console.log("Transaction found in mempool:", t), !0;
        if (Date.now() - r > 6e4)
          return !1;
        await new Promise((n) => setTimeout(n, 5e3));
      } catch {
        if (Date.now() - r > 6e4)
          return !1;
        await new Promise((n) => setTimeout(n, 5e3));
      }
  }
  async getAddressUtxos(t) {
    return this.call("get", `/api/address/${t}/utxo`);
  }
  async getTransaction(t) {
    return await this.call("get", `/api/tx/${t}`);
  }
  async getRecommendedFees() {
    return await this.call("get", "/api/v1/fees/recommended");
  }
  async broadcastTransaction(t) {
    return await this.call("post", "/api/tx", t);
  }
}
class zPe {
  constructor(t, r, n) {
    ut(this, "apiUrl", `${HN}/${sw}`), ut(this, "apiKey", sw), this.setNetwork(n, t), this.apiKey = r;
  }
  getName() {
    return NPe;
  }
  setNetwork(t, r) {
    this.apiUrl = `${this.apiUrl}/${this.apiKey || sw}`;
  }
  async call(t, r) {
    try {
      return (await un.post(this.apiUrl, {
        jsonrpc: "2.0",
        id: t,
        method: t,
        params: r
      }, {
        headers: {
          "Content-Type": "application/json"
        }
      })).data;
    } catch (n) {
      throw console.error("SandshrewDataSource.callRPC error:", n), n;
    }
  }
  async getTransaction(t) {
    return (await this.call("esplora_tx", [t])).result;
  }
  async getRuneById(t) {
    return (await this.call("ord_rune", [t])).result;
  }
  async getRuneByName(t) {
    return (await this.call("ord_rune", [t])).result;
  }
  async broadcastTransaction(t) {
    return await this.call("broadcast_tx", [t]);
  }
  async getOrdAddress(t) {
    return (await this.call("ord_address", [t])).result;
  }
  async getTxInfo(t) {
    return (await this.call("esplora_tx", [t])).result;
  }
  async batchOrdOutput({ outpoints: t, rune_name: r }) {
    const n = [];
    for (let o = 0; o < t.length; o += 1e3) {
      const i = t.slice(o, o + 1e3), a = i.map((d) => ["ord_output", [d]]), { result: u } = await this.call("sandshrew_multicall", a);
      for (let d = 0; d < u.length; d++)
        u[d].result.output = i[d];
      const l = u.filter(
        (d) => Object.keys(d.result.runes).includes(r)
      );
      n.push(...l);
    }
    return n;
  }
  async batchOrdInscriptionInfo(t) {
    const r = [];
    for (let n = 0; n < t.length; n += 1e3) {
      const o = t.slice(n, n + 1e3).map((a) => ["ord_inscription", [a]]), { result: i } = await this.call("sandshrew_multicall", o);
      for (let a = 0; a < i.length; a++)
        r.push(i[a].result);
    }
    return r;
  }
  async getAddressRunesBalances(t) {
    try {
      const r = (await this.getOrdAddress(t)).runes_balances;
      if (!r)
        throw new Error("No runes data found");
      return r.map((n) => ({
        name: n[0],
        balance: n[1],
        symbol: n[2]
      }));
    } catch (r) {
      throw console.error("Error fetching ord address:", r), r;
    }
  }
  async getInscriptionInfo(t) {
    return (await this.call("ord_inscription", [t])).result;
  }
  async getRuneOutpoints({ address: t, runeId: r }) {
    const n = await this.getOrdAddress(t), { entry: o } = await this.getRuneById(r), i = o.spaced_rune, a = await this.batchOrdOutput({
      outpoints: n.outputs,
      rune_name: i
    });
    return await this.mapRuneBalances({
      ordOutputs: a
    });
  }
  async mapRuneBalances({ ordOutputs: t }) {
    var r;
    try {
      const n = [];
      for (let o = 0; o < t.length; o++) {
        const i = t[o], { result: a } = i;
        if (!((r = a.output) != null && r.split(":")))
          throw new Error("No output found");
        const { output: u, address: l, runes: d } = a, f = {
          output: u,
          wallet_addr: l,
          script: "",
          balances: [],
          decimals: [],
          rune_ids: [],
          value: a.value
        };
        if (f.script = Buffer.from(
          oY(l, zn)
        ).toString("hex"), typeof d == "object" && !Array.isArray(d))
          for (const h in d)
            f.balances.push(d[h].amount), f.decimals.push(d[h].divisibility), f.rune_ids.push((await this.getRuneByName(h)).id);
        n.push(f);
      }
      return n;
    } catch (n) {
      throw n;
    }
  }
}
const Is = "Method not available on any data source", pY = class r1 {
  constructor(t) {
    ut(this, "dataSources", /* @__PURE__ */ new Map()), ut(this, "network");
    var r, n, o, i, a, u, l, d, f, h;
    const g = (t == null ? void 0 : t.network) || Ot.MAINNET;
    this.network = g, this.dataSources.set("mempool", new RPe(
      ((n = (r = t == null ? void 0 : t.dataSources) == null ? void 0 : r.mempool) == null ? void 0 : n.url) || dv(g),
      g
    )), this.dataSources.set("sandshrew", new zPe(
      ((i = (o = t == null ? void 0 : t.dataSources) == null ? void 0 : o.sandshrew) == null ? void 0 : i.url) || HN,
      ((u = (a = t == null ? void 0 : t.dataSources) == null ? void 0 : a.sandshrew) == null ? void 0 : u.apiKey) || sw,
      g
    )), this.dataSources.set("maestro", new UPe(
      ((d = (l = t == null ? void 0 : t.dataSources) == null ? void 0 : l.maestro) == null ? void 0 : d.apiKey) || RIe,
      g,
      ((h = (f = t == null ? void 0 : t.dataSources) == null ? void 0 : f.maestro) == null ? void 0 : h.testnetApiKey) || zIe
    ));
  }
  static init(t) {
    r1.instance || (r1.instance = new r1(t));
  }
  static getInstance() {
    if (!r1.instance)
      throw new Error("DataSourceManager has not been initialized");
    return r1.instance;
  }
  updateNetwork(t) {
    var r;
    this.network = t;
    for (const n of this.dataSources.values())
      (r = n.setNetwork) == null || r.call(n, t);
  }
  registerDataSource(t, r) {
    var n, o;
    this.dataSources.set(t, r), (o = (n = this.dataSources.get(t)) == null ? void 0 : n.setNetwork) == null || o.call(n, this.network);
  }
  getSource(t) {
    return this.dataSources.get(t);
  }
  async getAddressBtcBalance(t) {
    const r = this.findAvailableSource("getAddressBtcBalance");
    if (!r || !r.getAddressBtcBalance)
      throw new Error(Is);
    return await r.getAddressBtcBalance(t);
  }
  async getAddressBrc20Balances(t) {
    const r = this.findAvailableSource("getAddressBrc20Balances");
    if (!r || !r.getAddressBrc20Balances)
      throw new Error(Is);
    const n = await r.getAddressBrc20Balances(t);
    return $Pe(n);
  }
  async getAddressInscriptions(t, r, n) {
    const o = this.findAvailableSource("getAddressInscriptions");
    if (!o || !o.getAddressInscriptions)
      throw new Error(Is);
    if (!o.getInscriptionInfo)
      throw new Error(Is);
    const i = Ot.MAINNET, a = await o.getAddressInscriptions(t, r, n), u = o.getName();
    return u === hY && a.data ? (await Promise.all(
      a.data.map(async (l) => {
        try {
          if (!o.getInscriptionInfo)
            throw new Error(Is);
          const d = await o.getInscriptionInfo(l.inscription_id);
          return {
            ...l,
            ...d.data
          };
        } catch (d) {
          return console.error(`Failed to fetch details for inscription ${l.inscription_id}:`, d), l;
        }
      })
    )).map(
      (l) => N1(l, u, i)
    ) : a.inscriptions ? a.inscriptions.map(
      (l) => N1(l, u, i)
    ) : Array.isArray(a) ? a.map(
      (l) => N1(l, u, i)
    ) : (console.warn("Unable to normalize inscriptions from data source", u), []);
  }
  async getInscriptionInfo(t) {
    const r = this.findAvailableSource("getInscriptionInfo");
    if (!r || !r.getInscriptionInfo)
      throw new Error(Is);
    return await r.getInscriptionInfo(t);
  }
  async getRecommendedFees() {
    const t = this.findAvailableSource("getRecommendedFees");
    if (!t || !t.getRecommendedFees)
      throw new Error(Is);
    return console.log("getting recommended fees"), await t.getRecommendedFees();
  }
  async getAddressUtxos(t) {
    const r = this.findAvailableSource("getAddressUtxos");
    if (!r || !r.getAddressUtxos)
      throw new Error(Is);
    return await r.getAddressUtxos(t);
  }
  async getOutputValueByVOutIndex(t, r) {
    const n = this.findAvailableSource("getOutputValueByVOutIndex");
    if (!n || !n.getOutputValueByVOutIndex)
      throw new Error(Is);
    return await n.getOutputValueByVOutIndex(t, r);
  }
  async waitForTransaction(t) {
    const r = this.findAvailableSource("waitForTransaction");
    if (!r || !r.waitForTransaction)
      throw new Error(Is);
    return !!await r.waitForTransaction(t);
  }
  async getAddressRunesBalances(t) {
    const r = this.findAvailableSource("getAddressRunesBalances");
    if (!r || !r.getAddressRunesBalances)
      throw new Error(Is);
    return await r.getAddressRunesBalances(t);
  }
  async broadcastTransaction(t) {
    const r = this.findAvailableSource("broadcastTransaction");
    if (!r || !r.broadcastTransaction)
      throw new Error(Is);
    return await r.broadcastTransaction(t);
  }
  async withFallback(t, r) {
    const n = [t, ...Array.from(this.dataSources.keys()).filter((o) => o !== t)];
    for (const o of n)
      try {
        const i = this.getSource(o);
        if (!i) continue;
        return await r(i);
      } catch (i) {
        console.warn(`Fallback: ${o} failed`, i);
      }
    throw new Error("All data sources failed");
  }
  findAvailableSource(t) {
    for (const r of this.dataSources.values())
      if (typeof r[t] == "function")
        return r;
  }
};
ut(pY, "instance");
let e0 = pY;
const jPe = (e, t) => `{"p":"brc-20","op":"transfer","tick":"${e}","amt":"${t}"}`, LPe = async ({
  ticker: e,
  amount: t,
  ordinalAddress: r,
  ordinalPublicKey: n,
  paymentAddress: o,
  paymentPublicKey: i,
  toAddress: a,
  signPsbt: u,
  dataSourceManager: l,
  network: d = zn
}) => {
  try {
    let f;
    if (l ? f = l : f = e0.getInstance(), !f)
      throw new Error("Data source not found");
    if (!(f != null && f.getAddressBrc20Balances))
      throw new Error("Data source not found");
    if (!await (f == null ? void 0 : f.getAddressBrc20Balances(r)))
      throw new Error("Address balance not found");
    const h = jPe(e, t), g = await aY({
      contentBase64: btoa(h),
      mimeType: "text/plain",
      ordinalAddress: r,
      paymentAddress: o,
      paymentPublicKey: i,
      signPsbt: u,
      dataSourceManager: f,
      network: d
    });
    await f.waitForTransaction(g);
    const { fastestFee: b } = await f.getRecommendedFees(), w = 5 * 34 * 1, E = Math.floor(w * b * 1);
    await new Promise((Y) => setTimeout(Y, 1e4));
    const _ = (await f.getAddressUtxos(
      o
    )).filter((Y) => Y.value > 3e3).sort((Y, L) => L.value - Y.value);
    if (jE(_) < E)
      throw new Error("insufficient funds");
    console.log("inscriptionTxId", g);
    const O = new Yr({ network: pn(d) }), C = df(r, pn(d));
    O.addInput({
      hash: g,
      index: 0,
      witnessUtxo: {
        script: C,
        value: BigInt(546)
      },
      tapInternalKey: Uu(Buffer.from(n, "hex"))
    }), O.addOutput({
      address: a,
      value: BigInt(546)
    });
    let I = 0, S = 0;
    for await (const Y of _) {
      const L = df(o, pn(d)), ee = zE(o, d);
      if (O.addInput({
        hash: Y.txid,
        index: Y.vout,
        witnessUtxo: { value: BigInt(Y.value), script: L },
        tapInternalKey: Uu(Buffer.from(i, "hex"))
      }), ee === V2) {
        let de = gv(i, d);
        O.updateInput(I, { redeemScript: de });
      }
      if (I++, S += Y.value, S > E) {
        console.log("BREAKING");
        break;
      }
    }
    const T = S - E;
    T > 546 && O.addOutput({
      value: BigInt(T),
      address: o
    });
    const A = O == null ? void 0 : O.toHex(), $ = O == null ? void 0 : O.toBase64(), U = await u({
      tx: "",
      psbtHex: A,
      psbtBase64: $,
      finalize: !0,
      broadcast: !0,
      network: d
    });
    if (!U) throw new Error("sign psbt failed");
    const M = Yr.fromHex((U == null ? void 0 : U.signedPsbtHex) || "").extractTransaction();
    return await LE(M.toHex(), d);
  } catch (f) {
    throw f;
  }
}, HPe = async ({
  inscriptionIds: e,
  ordinalAddress: t,
  ordinalPublicKey: r,
  paymentAddress: n,
  paymentPublicKey: o,
  toAddress: i,
  signPsbt: a,
  dataSourceManager: u,
  network: l = zn
}) => {
  try {
    const d = await FPe({
      inscriptionIds: e,
      fromAddress: t,
      fromAddressPublicKey: r,
      fromPaymentAddress: n,
      fromPaymentPublicKey: o,
      dataSourceManager: u,
      toAddress: i,
      network: l
    });
    if (!d || !(d != null && d.psbtHex))
      throw new Error("couldn't get commit tx");
    const f = String(d == null ? void 0 : d.psbtHex), h = String(d == null ? void 0 : d.psbtBase64), g = await a({
      tx: "",
      psbtHex: f,
      psbtBase64: h,
      finalize: !0,
      broadcast: !1,
      network: l
    });
    if (!g) throw new Error("sign psbt failed");
    const b = Yr.fromHex((g == null ? void 0 : g.signedPsbtHex) || "").extractTransaction();
    return await LE(b.toHex(), l);
  } catch (d) {
    throw d;
  }
}, FPe = async ({
  fromAddress: e,
  fromAddressPublicKey: t,
  fromPaymentAddress: r,
  fromPaymentPublicKey: n,
  toAddress: o,
  inscriptionIds: i,
  dataSourceManager: a,
  network: u
}) => {
  try {
    const { fastestFee: l } = await nY(u);
    let d = (await a.getAddressUtxos(r)).sort((I, S) => S.value - I.value).filter((I) => I.value > 3e3);
    if (d.length === 0)
      throw new Error("No utxos found");
    const f = a.getSource("sandshrew");
    if (!f || !f.batchOrdInscriptionInfo)
      throw new Error("Sandshrew data source not found");
    const h = await (f == null ? void 0 : f.batchOrdInscriptionInfo(i));
    console.log(h);
    let g = new Yr({ network: pn(u) });
    const b = jE(d), w = qN(h.length, 2, 4);
    let E = w * l < 250 ? 250 : w * l, _ = 0;
    for await (const I of h) {
      const { value: S, satpoint: T } = I, [A, $] = T.split(":");
      if (!S || !A || !$)
        throw new Error("Invalid satpoint or value");
      const U = df(e, pn(zn));
      g.addInput({
        hash: A,
        index: parseInt($),
        witnessUtxo: {
          value: BigInt(S),
          script: U
        },
        tapInternalKey: Uu(Buffer.from(t, "hex"))
      }), g.addOutput({
        value: BigInt(S),
        address: o
      }), _++;
    }
    const O = zE(r, u);
    for (let I = 0; I < d.length; I++) {
      const S = df(
        r,
        pn(zn)
      ), T = d[I];
      if (O === Y1 && g.addInput({
        hash: T.txid,
        index: T.vout,
        witnessUtxo: {
          value: BigInt(T.value),
          script: S
        },
        tapInternalKey: Uu(Buffer.from(n, "hex"))
      }), O === V2) {
        let A = gv(n, u);
        g.addInput({
          hash: T.txid,
          index: T.vout,
          witnessUtxo: {
            value: BigInt(T.value),
            script: S
          },
          redeemScript: A
        });
      }
      O === "p2wpkh" && g.addInput({
        hash: T.txid,
        index: T.vout,
        witnessUtxo: {
          value: BigInt(T.value),
          script: S
        }
      });
    }
    const C = b - E;
    return g.addOutput({
      address: e,
      value: BigInt(C)
    }), { psbtBase64: g.toBase64(), psbtHex: g.toHex() };
  } catch (l) {
    throw l;
  }
}, MPe = new Error(
  "The connected wallet doesn't support this method..."
), DPe = new Error("Wallet is not installed");
class Ju {
  constructor(t, r, n) {
    ut(this, "$store"), ut(this, "$network"), ut(this, "dataSourceManager"), this.parent = r, this.config = n, this.$store = t.$store, this.$network = t.$network;
    try {
      this.dataSourceManager = e0.getInstance();
    } catch {
      e0.init(n), this.dataSourceManager = e0.getInstance();
    }
    this.initialize();
  }
  disconnect() {
  }
  async requestAccounts() {
    return this.$store.get().accounts;
  }
  async switchNetwork(t) {
    throw this.parent.disconnect(), MPe;
  }
  async getNetwork() {
    const { address: t } = this.$store.get();
    return t.slice(0, 1) === "t" && [ua, Ta, Fs, us].includes(this.$network.get()) ? this.$network.get() : zn;
  }
  async getPublicKey() {
    return this.$store.get().publicKey;
  }
  async getBalance() {
    if (!this.dataSourceManager.getAddressBtcBalance)
      throw new Error("Method not found on data source");
    return await this.dataSourceManager.getAddressBtcBalance(this.$store.get().paymentAddress);
  }
  async getMetaBalances(t) {
    switch (t) {
      case wj:
        return await this.getBalance();
      case Ej:
        if (this.$network.get() !== zn)
          throw new Error("Unsupported network");
        if (!this.dataSourceManager.getAddressRunesBalances)
          throw new Error("Method not found on data source");
        return await this.dataSourceManager.getAddressRunesBalances(this.$store.get().address);
      case vj:
        if (!this.dataSourceManager.getAddressBrc20Balances)
          throw new Error("Method not found on data source");
        return await this.dataSourceManager.getAddressBrc20Balances(this.$store.get().address);
      default:
        throw new Error("Unsupported protocol");
    }
  }
  async getInscriptions(t, r) {
    if (!this.dataSourceManager.getAddressInscriptions)
      throw new Error("Method not found on data source");
    return await this.dataSourceManager.getAddressInscriptions(this.$store.get().address, t, r);
  }
  async pushPsbt(t) {
    let r = t;
    return r.startsWith("02") || (r = Yr.fromHex(r).extractTransaction().toHex()), await LE(r, this.$network.get());
  }
  async inscribe(t, r, n) {
    return await aY({
      contentBase64: t,
      mimeType: r,
      ordinalAddress: this.$store.get().address,
      paymentAddress: this.$store.get().paymentAddress,
      paymentPublicKey: this.$store.get().paymentPublicKey,
      signPsbt: this.signPsbt.bind(this),
      dataSourceManager: n || this.dataSourceManager,
      network: this.$network.get()
    });
  }
  async send(t, r) {
    switch (t) {
      case wj:
        return await this.sendBTC(r.toAddress, r.amount);
      case Ej:
        if (this.$network.get() !== zn)
          throw new Error("Unsupported network");
        const n = r;
        if (!n.runeId || !n.amount || !n.toAddress)
          throw new Error("Missing required parameters");
        return await PPe({
          runeId: n.runeId,
          amount: n.amount,
          ordinalAddress: this.$store.get().address,
          ordinalPublicKey: this.$store.get().publicKey,
          paymentAddress: this.$store.get().paymentAddress,
          paymentPublicKey: this.$store.get().paymentPublicKey,
          toAddress: n.toAddress,
          signPsbt: this.signPsbt.bind(this),
          network: this.$network.get()
        });
      case vj:
        if (this.$network.get() !== zn)
          throw new Error("Unsupported network");
        const o = r;
        if (!o.ticker || !o.amount || !o.toAddress)
          throw new Error("Missing required parameters");
        return await LPe({
          ticker: o.ticker,
          amount: o.amount,
          ordinalAddress: this.$store.get().address,
          ordinalPublicKey: this.$store.get().publicKey,
          paymentAddress: this.$store.get().paymentAddress,
          paymentPublicKey: this.$store.get().paymentPublicKey,
          signPsbt: this.signPsbt.bind(this),
          toAddress: o.toAddress,
          dataSourceManager: this.dataSourceManager,
          network: this.$network.get()
        });
      default:
        throw new Error("Unsupported protocol");
    }
  }
  async sendInscriptions(t, r) {
    if ((await this.getInscriptions()).filter(
      (n) => t.includes(n.id)
    ).length !== t.length)
      throw new Error("Missing inscriptions");
    return await HPe({
      inscriptionIds: t,
      ordinalAddress: this.$store.get().address,
      ordinalPublicKey: this.$store.get().publicKey,
      paymentAddress: this.$store.get().paymentAddress,
      paymentPublicKey: this.$store.get().paymentPublicKey,
      toAddress: r,
      signPsbt: this.signPsbt.bind(this),
      dataSourceManager: this.dataSourceManager,
      network: this.$network.get()
    });
  }
}
class KPe extends Ju {
  constructor(t, r, n) {
    super(t, r, n), ut(this, "observer");
  }
  get library() {
    return window.unisat;
  }
  get network() {
    return this.$network.get();
  }
  initialize() {
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var t;
      this.library && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [Up]: !0
      }), (t = this.observer) == null || t.disconnect());
    }), this.observer.observe(document, { childList: !0, subtree: !0 })), Zu(this.$store, ["provider"], (t) => {
      if (t.provider !== Up) {
        this.removeListeners();
        return;
      }
      this.library.getAccounts().then((r) => {
        this.handleAccountsChanged(r);
      }), this.addListeners();
    });
  }
  addListeners() {
    this.library.on("accountsChanged", this.handleAccountsChanged.bind(this)), this.library.on("networkChanged", this.handleNetworkChanged.bind(this));
  }
  removeListeners() {
    var t, r;
    this.library && ((t = this.library) == null || t.removeListener(
      "accountsChanged",
      this.handleAccountsChanged.bind(this)
    ), (r = this.library) == null || r.removeListener(
      "networkChanged",
      this.handleNetworkChanged.bind(this)
    ));
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect(), this.removeListeners();
  }
  handleAccountsChanged(t) {
    if (!t.length) {
      this.parent.disconnect();
      return;
    }
    this.$store.get().accounts[0] !== t[0] && (this.$store.setKey("accounts", t), t.length > 0 ? this.parent.connect(Up) : this.parent.disconnect());
  }
  handleNetworkChanged(t) {
    const r = _5(t);
    this.network !== r && this.switchNetwork(r), this.parent.connect(Up);
  }
  async connect(t) {
    if (!this.library) throw new Error("Unisat isn't installed");
    const r = await this.library.requestAccounts();
    if (!r) throw new Error("No accounts found");
    await this.getNetwork().then((o) => {
      this.network !== o && this.switchNetwork(this.network);
    });
    const n = await this.library.getPublicKey();
    if (!n) throw new Error("No public key found");
    this.$store.setKey("accounts", r), this.$store.setKey("address", r[0]), this.$store.setKey("paymentAddress", r[0]), this.$store.setKey("publicKey", n), this.$store.setKey("paymentPublicKey", n);
  }
  async getNetwork() {
    var t;
    const r = await ((t = this.library) == null ? void 0 : t.getChain());
    return r ? _5(r.enum) : this.network;
  }
  async sendBTC(t, r) {
    var n;
    const o = await ((n = this.library) == null ? void 0 : n.sendBitcoin(t, r));
    if (!o) throw new Error("Transaction failed");
    return o;
  }
  async signMessage(t, r) {
    var n;
    const o = (r == null ? void 0 : r.protocol) === KN ? RE : r == null ? void 0 : r.protocol;
    return await ((n = this.library) == null ? void 0 : n.signMessage(t, o));
  }
  async signPsbt({
    psbtHex: t,
    broadcast: r,
    finalize: n,
    inputsToSign: o
  }) {
    var i;
    const a = await ((i = this.library) == null ? void 0 : i.signPsbt(
      t,
      KE({
        autoFinalized: n,
        toSignInputs: o
      })
    )), u = Yr.fromHex(a);
    if (n && r) {
      const l = await this.pushPsbt(a);
      return {
        signedPsbtHex: u.toHex(),
        signedPsbtBase64: u.toBase64(),
        txId: l
      };
    }
    return {
      signedPsbtHex: u.toHex(),
      signedPsbtBase64: u.toBase64(),
      txId: void 0
    };
  }
  async getPublicKey() {
    var t;
    return await ((t = this.library) == null ? void 0 : t.getPublicKey());
  }
  async getBalance() {
    return (await this.library.getBalance()).total;
  }
  async getInscriptions(t, r) {
    const n = t || 0, o = r || 10;
    return (await this.library.getInscriptions(n, o)).list.map((i) => N1(i, void 0, this.network));
  }
  async requestAccounts() {
    return await this.library.requestAccounts();
  }
  async switchNetwork(t) {
    var r;
    const n = qZ(t);
    await ((r = this.library) == null ? void 0 : r.switchChain(n)), this.$network.set(t);
  }
}
function qPe(e) {
  typeof window < "u" && typeof localStorage < "u" && setTimeout(() => {
    const t = document.createTextNode(" ");
    document.body.appendChild(t), t.remove(), Promise.resolve().then(e);
  }, 1500);
}
function gY() {
  return {
    $store: Cq({
      provider: void 0,
      address: "",
      paymentAddress: "",
      publicKey: "",
      paymentPublicKey: "",
      connected: !1,
      isConnecting: !1,
      isInitializing: !0,
      accounts: [],
      balance: void 0,
      hasProvider: {
        [k1]: !1,
        [Up]: !1,
        [Gl]: !1,
        [S1]: !1,
        [Pd]: !1,
        [Od]: !1,
        [x1]: !1,
        [jp]: !0,
        [Id]: !1,
        [zp]: !1,
        [Rp]: !1
      }
    }),
    $network: AO(zn),
    $library: AO(void 0)
  };
}
function VPe({ ...e }) {
  return {
    ...e
  };
}
const j0 = [
  "address",
  "paymentAddress",
  "publicKey",
  "paymentPublicKey",
  "balance"
];
function Wg(e, t, r, n) {
  var o, i, a;
  t.provider === e && (r ? r === "balance" ? n.setKey("balance", ((o = t.balance) == null ? void 0 : o.toString()) ?? "") : j0.includes(r) && n.setKey(
    r,
    ((i = t[r]) == null ? void 0 : i.toString()) ?? ""
  ) : n.set({
    address: t.address,
    paymentAddress: t.paymentAddress,
    paymentPublicKey: t.paymentPublicKey,
    publicKey: t.publicKey,
    balance: ((a = t.balance) == null ? void 0 : a.toString()) ?? ""
  }));
}
const GPe = (e) => {
  const t = e.match(/.{1,2}/g);
  if (!t)
    throw new Error("Invalid hex string");
  return Uint8Array.from(t.map((r) => parseInt(r, 16)));
};
function WPe(e, t) {
  var r;
  return (r = void 0) == null ? void 0 : r.get(t);
}
function VE(e) {
  var t, r;
  const n = typeof e;
  return n === "string" ? `"${e}"` : n === "number" || n === "bigint" || n === "boolean" ? `${e}` : n === "object" || n === "function" ? (e && ((r = (t = Object.getPrototypeOf(e)) == null ? void 0 : t.constructor) == null ? void 0 : r.name)) ?? "null" : n;
}
function Wo(e, t, r, n, o) {
  const i = o && "input" in o ? o.input : r.value, a = (o == null ? void 0 : o.expected) ?? e.expects ?? null, u = (o == null ? void 0 : o.received) ?? VE(i), l = {
    kind: e.kind,
    type: e.type,
    input: i,
    expected: a,
    received: u,
    message: `Invalid ${t}: ${a ? `Expected ${a} but r` : "R"}eceived ${u}`,
    requirement: e.requirement,
    path: o == null ? void 0 : o.path,
    issues: o == null ? void 0 : o.issues,
    lang: n.lang,
    abortEarly: n.abortEarly,
    abortPipeEarly: n.abortPipeEarly
  }, d = e.kind === "schema", f = (o == null ? void 0 : o.message) ?? e.message ?? WPe(e.reference, l.lang) ?? (d ? (l.lang, void 0) : null) ?? n.message ?? (l.lang, void 0);
  f && (l.message = typeof f == "function" ? (
    // @ts-expect-error
    f(l)
  ) : f), d && (r.typed = !1), r.issues ? r.issues.push(l) : r.issues = [l];
}
function mY(e, t) {
  return Object.hasOwn(e, t) && t !== "__proto__" && t !== "prototype" && t !== "constructor";
}
function GE(e, t) {
  const r = [...new Set(e)];
  return r.length > 1 ? `(${r.join(` ${t} `)})` : r[0] ?? "never";
}
function yY(e, t) {
  return {
    kind: "validation",
    type: "check",
    reference: yY,
    async: !1,
    expects: null,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && !this.requirement(r.value) && Wo(this, "input", r, n), r;
    }
  };
}
function bY(e, t) {
  return {
    kind: "validation",
    type: "max_length",
    reference: bY,
    async: !1,
    expects: `<=${e}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && r.value.length > this.requirement && Wo(this, "length", r, n, {
        received: `${r.value.length}`
      }), r;
    }
  };
}
function wY(e, t) {
  return {
    kind: "validation",
    type: "min_length",
    reference: wY,
    async: !1,
    expects: `>=${e}`,
    requirement: e,
    message: t,
    _run(r, n) {
      return r.typed && r.value.length < this.requirement && Wo(this, "length", r, n, {
        received: `${r.value.length}`
      }), r;
    }
  };
}
function vY(e, t, r) {
  return typeof e.default == "function" ? (
    // @ts-expect-error
    e.default(t, r)
  ) : (
    // @ts-expect-error
    e.default
  );
}
function Nj(e, t) {
  return !e._run({ typed: !1, value: t }, { abortEarly: !0 }).issues;
}
function Zo(e, t) {
  return {
    kind: "schema",
    type: "array",
    reference: Zo,
    expects: "Array",
    async: !1,
    item: e,
    message: t,
    _run(r, n) {
      var o;
      const i = r.value;
      if (Array.isArray(i)) {
        r.typed = !0, r.value = [];
        for (let a = 0; a < i.length; a++) {
          const u = i[a], l = this.item._run({ typed: !1, value: u }, n);
          if (l.issues) {
            const d = {
              type: "array",
              origin: "value",
              input: i,
              key: a,
              value: u
            };
            for (const f of l.issues)
              f.path ? f.path.unshift(d) : f.path = [d], (o = r.issues) == null || o.push(f);
            if (r.issues || (r.issues = l.issues), n.abortEarly) {
              r.typed = !1;
              break;
            }
          }
          l.typed || (r.typed = !1), r.value.push(l.value);
        }
      } else
        Wo(this, "type", r, n);
      return r;
    }
  };
}
function L0(e) {
  return {
    kind: "schema",
    type: "boolean",
    reference: L0,
    expects: "boolean",
    async: !1,
    message: e,
    _run(t, r) {
      return typeof t.value == "boolean" ? t.typed = !0 : Wo(this, "type", t, r), t;
    }
  };
}
function ps(e, t) {
  const r = Object.entries(e).filter(([n]) => isNaN(+n)).map(([, n]) => n);
  return {
    kind: "schema",
    type: "enum",
    reference: ps,
    expects: GE(r.map(VE), "|"),
    async: !1,
    enum: e,
    options: r,
    message: t,
    _run(n, o) {
      return this.options.includes(n.value) ? n.typed = !0 : Wo(this, "type", n, o), n;
    }
  };
}
function Er(e, t) {
  return {
    kind: "schema",
    type: "literal",
    reference: Er,
    expects: VE(e),
    async: !1,
    literal: e,
    message: t,
    _run(r, n) {
      return r.value === this.literal ? r.typed = !0 : Wo(this, "type", r, n), r;
    }
  };
}
function EY(e, t) {
  return {
    kind: "schema",
    type: "loose_object",
    reference: EY,
    expects: "Object",
    async: !1,
    entries: e,
    message: t,
    _run(r, n) {
      var o;
      const i = r.value;
      if (i && typeof i == "object") {
        r.typed = !0, r.value = {};
        for (const a in this.entries) {
          const u = i[a], l = this.entries[a]._run(
            { typed: !1, value: u },
            n
          );
          if (l.issues) {
            const d = {
              type: "object",
              origin: "value",
              input: i,
              key: a,
              value: u
            };
            for (const f of l.issues)
              f.path ? f.path.unshift(d) : f.path = [d], (o = r.issues) == null || o.push(f);
            if (r.issues || (r.issues = l.issues), n.abortEarly) {
              r.typed = !1;
              break;
            }
          }
          l.typed || (r.typed = !1), (l.value !== void 0 || a in i) && (r.value[a] = l.value);
        }
        if (!r.issues || !n.abortEarly)
          for (const a in i)
            mY(i, a) && !(a in this.entries) && (r.value[a] = i[a]);
      } else
        Wo(this, "type", r, n);
      return r;
    }
  };
}
function e$(e, t) {
  return {
    kind: "schema",
    type: "non_optional",
    reference: e$,
    expects: "!undefined",
    async: !1,
    wrapped: e,
    message: t,
    _run(r, n) {
      return r.value === void 0 ? (Wo(this, "type", r, n), r) : this.wrapped._run(r, n);
    }
  };
}
function qi(e) {
  return {
    kind: "schema",
    type: "null",
    reference: qi,
    expects: "null",
    async: !1,
    message: e,
    _run(t, r) {
      return t.value === null ? t.typed = !0 : Wo(this, "type", t, r), t;
    }
  };
}
function ui(e, ...t) {
  const r = {
    kind: "schema",
    type: "nullish",
    reference: ui,
    expects: `(${e.expects} | null | undefined)`,
    async: !1,
    wrapped: e,
    _run(n, o) {
      return (n.value === null || n.value === void 0) && ("default" in this && (n.value = vY(
        this,
        n,
        o
      )), n.value === null || n.value === void 0) ? (n.typed = !0, n) : this.wrapped._run(n, o);
    }
  };
  return 0 in t && (r.default = t[0]), r;
}
function lo(e) {
  return {
    kind: "schema",
    type: "number",
    reference: lo,
    expects: "number",
    async: !1,
    message: e,
    _run(t, r) {
      return typeof t.value == "number" && !isNaN(t.value) ? t.typed = !0 : Wo(this, "type", t, r), t;
    }
  };
}
function je(e, t) {
  return {
    kind: "schema",
    type: "object",
    reference: je,
    expects: "Object",
    async: !1,
    entries: e,
    message: t,
    _run(r, n) {
      var o;
      const i = r.value;
      if (i && typeof i == "object") {
        r.typed = !0, r.value = {};
        for (const a in this.entries) {
          const u = i[a], l = this.entries[a]._run(
            { typed: !1, value: u },
            n
          );
          if (l.issues) {
            const d = {
              type: "object",
              origin: "value",
              input: i,
              key: a,
              value: u
            };
            for (const f of l.issues)
              f.path ? f.path.unshift(d) : f.path = [d], (o = r.issues) == null || o.push(f);
            if (r.issues || (r.issues = l.issues), n.abortEarly) {
              r.typed = !1;
              break;
            }
          }
          l.typed || (r.typed = !1), (l.value !== void 0 || a in i) && (r.value[a] = l.value);
        }
      } else
        Wo(this, "type", r, n);
      return r;
    }
  };
}
function tr(e, ...t) {
  const r = {
    kind: "schema",
    type: "optional",
    reference: tr,
    expects: `(${e.expects} | undefined)`,
    async: !1,
    wrapped: e,
    _run(n, o) {
      return n.value === void 0 && ("default" in this && (n.value = vY(
        this,
        n,
        o
      )), n.value === void 0) ? (n.typed = !0, n) : this.wrapped._run(n, o);
    }
  };
  return 0 in t && (r.default = t[0]), r;
}
function _Y(e, t) {
  return {
    kind: "schema",
    type: "picklist",
    reference: _Y,
    expects: GE(e.map(VE), "|"),
    async: !1,
    options: e,
    message: t,
    _run(r, n) {
      return this.options.includes(r.value) ? r.typed = !0 : Wo(this, "type", r, n), r;
    }
  };
}
function AY(e, t, r) {
  return {
    kind: "schema",
    type: "record",
    reference: AY,
    expects: "Object",
    async: !1,
    key: e,
    value: t,
    message: r,
    _run(n, o) {
      var i, a;
      const u = n.value;
      if (u && typeof u == "object") {
        n.typed = !0, n.value = {};
        for (const l in u)
          if (mY(u, l)) {
            const d = u[l], f = this.key._run(
              { typed: !1, value: l },
              o
            );
            if (f.issues) {
              const g = {
                type: "object",
                origin: "key",
                input: u,
                key: l,
                value: d
              };
              for (const b of f.issues)
                b.path = [g], (i = n.issues) == null || i.push(b);
              if (n.issues || (n.issues = f.issues), o.abortEarly) {
                n.typed = !1;
                break;
              }
            }
            const h = this.value._run(
              { typed: !1, value: d },
              o
            );
            if (h.issues) {
              const g = {
                type: "object",
                origin: "value",
                input: u,
                key: l,
                value: d
              };
              for (const b of h.issues)
                b.path ? b.path.unshift(g) : b.path = [g], (a = n.issues) == null || a.push(b);
              if (n.issues || (n.issues = h.issues), o.abortEarly) {
                n.typed = !1;
                break;
              }
            }
            (!f.typed || !h.typed) && (n.typed = !1), f.typed && (n.value[f.value] = h.value);
          }
      } else
        Wo(this, "type", n, o);
      return n;
    }
  };
}
function Re(e) {
  return {
    kind: "schema",
    type: "string",
    reference: Re,
    expects: "string",
    async: !1,
    message: e,
    _run(t, r) {
      return typeof t.value == "string" ? t.typed = !0 : Wo(this, "type", t, r), t;
    }
  };
}
function $j(e) {
  let t;
  if (e)
    for (const r of e)
      t ? t.push(...r.issues) : t = r.issues;
  return t;
}
function Av(e, t) {
  return {
    kind: "schema",
    type: "union",
    reference: Av,
    expects: GE(
      e.map((r) => r.expects),
      "|"
    ),
    async: !1,
    options: e,
    message: t,
    _run(r, n) {
      let o, i, a;
      for (const u of this.options) {
        const l = u._run(
          { typed: !1, value: r.value },
          n
        );
        if (l.typed)
          if (l.issues)
            i ? i.push(l) : i = [l];
          else {
            o = l;
            break;
          }
        else
          a ? a.push(l) : a = [l];
      }
      if (o)
        return o;
      if (i) {
        if (i.length === 1)
          return i[0];
        Wo(this, "type", r, n, {
          issues: $j(i)
        }), r.typed = !0;
      } else {
        if ((a == null ? void 0 : a.length) === 1)
          return a[0];
        Wo(this, "type", r, n, {
          issues: $j(a)
        });
      }
      return r;
    }
  };
}
function WE() {
  return {
    kind: "schema",
    type: "unknown",
    reference: WE,
    expects: "unknown",
    async: !1,
    _run(e) {
      return e.typed = !0, e;
    }
  };
}
function xY(e, t, r) {
  return {
    kind: "schema",
    type: "variant",
    reference: xY,
    expects: "Object",
    async: !1,
    key: e,
    options: t,
    message: r,
    _run(n, o) {
      const i = n.value;
      if (i && typeof i == "object") {
        let a, u = 0, l = this.key, d = [];
        const f = (h, g) => {
          for (const b of h.options) {
            if (b.type === "variant")
              f(b, new Set(g).add(b.key));
            else {
              let w = !0, E = 0;
              for (const _ of g) {
                if (b.entries[_]._run(
                  // @ts-expect-error
                  { typed: !1, value: i[_] },
                  o
                ).issues) {
                  w = !1, l !== _ && (u < E || u === E && _ in i && !(l in i)) && (u = E, l = _, d = []), l === _ && d.push(
                    b.entries[_].expects
                  );
                  break;
                }
                E++;
              }
              if (w) {
                const _ = b._run(
                  { typed: !1, value: i },
                  o
                );
                (!a || !a.typed && _.typed) && (a = _);
              }
            }
            if (a && !a.issues)
              break;
          }
        };
        if (f(this, /* @__PURE__ */ new Set([this.key])), a)
          return a;
        Wo(this, "type", n, o, {
          // @ts-expect-error
          input: i[l],
          expected: GE(d, "|"),
          path: [
            {
              type: "object",
              origin: "value",
              input: i,
              key: l,
              // @ts-expect-error
              value: i[l]
            }
          ]
        });
      } else
        Wo(this, "type", n, o);
      return n;
    }
  };
}
function Uj(e, t) {
  const r = {
    ...e.entries
  };
  for (const n of t)
    delete r[n];
  return { ...e, entries: r };
}
function xP(...e) {
  return {
    ...e[0],
    pipe: e,
    _run(t, r) {
      for (const n of e)
        if (n.kind !== "metadata") {
          if (t.issues && (n.kind === "schema" || n.kind === "transformation")) {
            t.typed = !1;
            break;
          }
          (!t.issues || !r.abortEarly && !r.abortPipeEarly) && (t = n._run(t, r));
        }
      return t;
    }
  };
}
function ZPe(e) {
  return e.wrapped;
}
var vs = {}, fg = {}, ca = {}, Zg = {};
Zg.byteLength = JPe;
Zg.toByteArray = eCe;
Zg.fromByteArray = nCe;
var Ac = [], Bs = [], XPe = typeof Uint8Array < "u" ? Uint8Array : Array, uI = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var G0 = 0, YPe = uI.length; G0 < YPe; ++G0)
  Ac[G0] = uI[G0], Bs[uI.charCodeAt(G0)] = G0;
Bs[45] = 62;
Bs[95] = 63;
function kY(e) {
  var t = e.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = e.indexOf("=");
  r === -1 && (r = t);
  var n = r === t ? 0 : 4 - r % 4;
  return [r, n];
}
function JPe(e) {
  var t = kY(e), r = t[0], n = t[1];
  return (r + n) * 3 / 4 - n;
}
function QPe(e, t, r) {
  return (t + r) * 3 / 4 - r;
}
function eCe(e) {
  var t, r = kY(e), n = r[0], o = r[1], i = new XPe(QPe(e, n, o)), a = 0, u = o > 0 ? n - 4 : n, l;
  for (l = 0; l < u; l += 4)
    t = Bs[e.charCodeAt(l)] << 18 | Bs[e.charCodeAt(l + 1)] << 12 | Bs[e.charCodeAt(l + 2)] << 6 | Bs[e.charCodeAt(l + 3)], i[a++] = t >> 16 & 255, i[a++] = t >> 8 & 255, i[a++] = t & 255;
  return o === 2 && (t = Bs[e.charCodeAt(l)] << 2 | Bs[e.charCodeAt(l + 1)] >> 4, i[a++] = t & 255), o === 1 && (t = Bs[e.charCodeAt(l)] << 10 | Bs[e.charCodeAt(l + 1)] << 4 | Bs[e.charCodeAt(l + 2)] >> 2, i[a++] = t >> 8 & 255, i[a++] = t & 255), i;
}
function tCe(e) {
  return Ac[e >> 18 & 63] + Ac[e >> 12 & 63] + Ac[e >> 6 & 63] + Ac[e & 63];
}
function rCe(e, t, r) {
  for (var n, o = [], i = t; i < r; i += 3)
    n = (e[i] << 16 & 16711680) + (e[i + 1] << 8 & 65280) + (e[i + 2] & 255), o.push(tCe(n));
  return o.join("");
}
function nCe(e) {
  for (var t, r = e.length, n = r % 3, o = [], i = 16383, a = 0, u = r - n; a < u; a += i)
    o.push(rCe(e, a, a + i > u ? u : a + i));
  return n === 1 ? (t = e[r - 1], o.push(
    Ac[t >> 2] + Ac[t << 4 & 63] + "=="
  )) : n === 2 && (t = (e[r - 2] << 8) + e[r - 1], o.push(
    Ac[t >> 10] + Ac[t >> 4 & 63] + Ac[t << 2 & 63] + "="
  )), o.join("");
}
Object.defineProperty(ca, "__esModule", { value: !0 });
ca.decode = ca.encode = ca.unescape = ca.escape = ca.pad = void 0;
const SY = Zg;
function t$(e) {
  return `${e}${"=".repeat(4 - (e.length % 4 || 4))}`;
}
ca.pad = t$;
function TY(e) {
  return e.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
ca.escape = TY;
function IY(e) {
  return t$(e).replace(/-/g, "+").replace(/_/g, "/");
}
ca.unescape = IY;
function oCe(e) {
  return TY((0, SY.fromByteArray)(new TextEncoder().encode(e)));
}
ca.encode = oCe;
function iCe(e) {
  return new TextDecoder().decode((0, SY.toByteArray)(t$(IY(e))));
}
ca.decode = iCe;
var ZE = {}, XE = {}, OY = {};
const aCe = {}, sCe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: aCe
}, Symbol.toStringTag, { value: "Module" })), PY = /* @__PURE__ */ l2e(sCe);
(function(e) {
  /*! noble-secp256k1 - MIT License (c) 2019 Paul Miller (paulmillr.com) */
  Object.defineProperty(e, "__esModule", { value: !0 }), e.utils = e.schnorr = e.verify = e.signSync = e.sign = e.getSharedSecret = e.recoverPublicKey = e.getPublicKey = e.Signature = e.Point = e.CURVE = void 0;
  const t = PY, r = BigInt(0), n = BigInt(1), o = BigInt(2), i = BigInt(3), a = BigInt(8), u = Object.freeze({
    a: r,
    b: BigInt(7),
    P: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"),
    n: BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"),
    h: n,
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee")
  });
  e.CURVE = u;
  const l = (j, N) => (j + N / o) / N, d = {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar(j) {
      const { n: N } = u, z = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), W = -n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), ie = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), he = z, Ae = BigInt("0x100000000000000000000000000000000"), Ie = l(he * j, N), Me = l(-W * j, N);
      let Fe = J(j - Ie * z - Me * ie, N), We = J(-Ie * W - Me * he, N);
      const it = Fe > Ae, ct = We > Ae;
      if (it && (Fe = N - Fe), ct && (We = N - We), Fe > Ae || We > Ae)
        throw new Error("splitScalarEndo: Endomorphism failed, k=" + j);
      return { k1neg: it, k1: Fe, k2neg: ct, k2: We };
    }
  }, f = 32, h = 32, g = 32, b = f + 1, w = 2 * f + 1;
  function E(j) {
    const { a: N, b: z } = u, W = J(j * j), ie = J(W * j);
    return J(ie + N * j + z);
  }
  const _ = u.a === r;
  class O extends Error {
    constructor(N) {
      super(N);
    }
  }
  function C(j) {
    if (!(j instanceof I))
      throw new TypeError("JacobianPoint expected");
  }
  class I {
    constructor(N, z, W) {
      this.x = N, this.y = z, this.z = W;
    }
    static fromAffine(N) {
      if (!(N instanceof A))
        throw new TypeError("JacobianPoint#fromAffine: expected Point");
      return N.equals(A.ZERO) ? I.ZERO : new I(N.x, N.y, n);
    }
    static toAffineBatch(N) {
      const z = _e(N.map((W) => W.z));
      return N.map((W, ie) => W.toAffine(z[ie]));
    }
    static normalizeZ(N) {
      return I.toAffineBatch(N).map(I.fromAffine);
    }
    equals(N) {
      C(N);
      const { x: z, y: W, z: ie } = this, { x: he, y: Ae, z: Ie } = N, Me = J(ie * ie), Fe = J(Ie * Ie), We = J(z * Fe), it = J(he * Me), ct = J(J(W * Ie) * Fe), ar = J(J(Ae * ie) * Me);
      return We === it && ct === ar;
    }
    negate() {
      return new I(this.x, J(-this.y), this.z);
    }
    double() {
      const { x: N, y: z, z: W } = this, ie = J(N * N), he = J(z * z), Ae = J(he * he), Ie = N + he, Me = J(o * (J(Ie * Ie) - ie - Ae)), Fe = J(i * ie), We = J(Fe * Fe), it = J(We - o * Me), ct = J(Fe * (Me - it) - a * Ae), ar = J(o * z * W);
      return new I(it, ct, ar);
    }
    add(N) {
      C(N);
      const { x: z, y: W, z: ie } = this, { x: he, y: Ae, z: Ie } = N;
      if (he === r || Ae === r)
        return this;
      if (z === r || W === r)
        return N;
      const Me = J(ie * ie), Fe = J(Ie * Ie), We = J(z * Fe), it = J(he * Me), ct = J(J(W * Ie) * Fe), ar = J(J(Ae * ie) * Me), sr = J(it - We), qn = J(ar - ct);
      if (sr === r)
        return qn === r ? this.double() : I.ZERO;
      const ci = J(sr * sr), Io = J(sr * ci), li = J(We * ci), Ra = J(qn * qn - Io - o * li), Ws = J(qn * (li - Ra) - ct * Io), Vi = J(ie * Ie * sr);
      return new I(Ra, Ws, Vi);
    }
    subtract(N) {
      return this.add(N.negate());
    }
    multiplyUnsafe(N) {
      const z = I.ZERO;
      if (typeof N == "bigint" && N === r)
        return z;
      let W = se(N);
      if (W === n)
        return this;
      if (!_) {
        let it = z, ct = this;
        for (; W > r; )
          W & n && (it = it.add(ct)), ct = ct.double(), W >>= n;
        return it;
      }
      let { k1neg: ie, k1: he, k2neg: Ae, k2: Ie } = d.splitScalar(W), Me = z, Fe = z, We = this;
      for (; he > r || Ie > r; )
        he & n && (Me = Me.add(We)), Ie & n && (Fe = Fe.add(We)), We = We.double(), he >>= n, Ie >>= n;
      return ie && (Me = Me.negate()), Ae && (Fe = Fe.negate()), Fe = new I(J(Fe.x * d.beta), Fe.y, Fe.z), Me.add(Fe);
    }
    precomputeWindow(N) {
      const z = _ ? 128 / N + 1 : 256 / N + 1, W = [];
      let ie = this, he = ie;
      for (let Ae = 0; Ae < z; Ae++) {
        he = ie, W.push(he);
        for (let Ie = 1; Ie < 2 ** (N - 1); Ie++)
          he = he.add(ie), W.push(he);
        ie = he.double();
      }
      return W;
    }
    wNAF(N, z) {
      !z && this.equals(I.BASE) && (z = A.BASE);
      const W = z && z._WINDOW_SIZE || 1;
      if (256 % W)
        throw new Error("Point#wNAF: Invalid precomputation window, must be power of 2");
      let ie = z && T.get(z);
      ie || (ie = this.precomputeWindow(W), z && W !== 1 && (ie = I.normalizeZ(ie), T.set(z, ie)));
      let he = I.ZERO, Ae = I.BASE;
      const Ie = 1 + (_ ? 128 / W : 256 / W), Me = 2 ** (W - 1), Fe = BigInt(2 ** W - 1), We = 2 ** W, it = BigInt(W);
      for (let ct = 0; ct < Ie; ct++) {
        const ar = ct * Me;
        let sr = Number(N & Fe);
        N >>= it, sr > Me && (sr -= We, N += n);
        const qn = ar, ci = ar + Math.abs(sr) - 1, Io = ct % 2 !== 0, li = sr < 0;
        sr === 0 ? Ae = Ae.add(S(Io, ie[qn])) : he = he.add(S(li, ie[ci]));
      }
      return { p: he, f: Ae };
    }
    multiply(N, z) {
      let W = se(N), ie, he;
      if (_) {
        const { k1neg: Ae, k1: Ie, k2neg: Me, k2: Fe } = d.splitScalar(W);
        let { p: We, f: it } = this.wNAF(Ie, z), { p: ct, f: ar } = this.wNAF(Fe, z);
        We = S(Ae, We), ct = S(Me, ct), ct = new I(J(ct.x * d.beta), ct.y, ct.z), ie = We.add(ct), he = it.add(ar);
      } else {
        const { p: Ae, f: Ie } = this.wNAF(W, z);
        ie = Ae, he = Ie;
      }
      return I.normalizeZ([ie, he])[0];
    }
    toAffine(N) {
      const { x: z, y: W, z: ie } = this, he = this.equals(I.ZERO);
      N == null && (N = he ? a : Ee(ie));
      const Ae = N, Ie = J(Ae * Ae), Me = J(Ie * Ae), Fe = J(z * Ie), We = J(W * Me), it = J(ie * Ae);
      if (he)
        return A.ZERO;
      if (it !== n)
        throw new Error("invZ was invalid");
      return new A(Fe, We);
    }
  }
  I.BASE = new I(u.Gx, u.Gy, n), I.ZERO = new I(r, n, r);
  function S(j, N) {
    const z = N.negate();
    return j ? z : N;
  }
  const T = /* @__PURE__ */ new WeakMap();
  class A {
    constructor(N, z) {
      this.x = N, this.y = z;
    }
    _setWindowSize(N) {
      this._WINDOW_SIZE = N, T.delete(this);
    }
    hasEvenY() {
      return this.y % o === r;
    }
    static fromCompressedHex(N) {
      const z = N.length === 32, W = q(z ? N : N.subarray(1));
      if (!ge(W))
        throw new Error("Point is not on curve");
      const ie = E(W);
      let he = ve(ie);
      const Ae = (he & n) === n;
      z ? Ae && (he = J(-he)) : (N[0] & 1) === 1 !== Ae && (he = J(-he));
      const Ie = new A(W, he);
      return Ie.assertValidity(), Ie;
    }
    static fromUncompressedHex(N) {
      const z = q(N.subarray(1, f + 1)), W = q(N.subarray(f + 1, f * 2 + 1)), ie = new A(z, W);
      return ie.assertValidity(), ie;
    }
    static fromHex(N) {
      const z = Q(N), W = z.length, ie = z[0];
      if (W === f)
        return this.fromCompressedHex(z);
      if (W === b && (ie === 2 || ie === 3))
        return this.fromCompressedHex(z);
      if (W === w && ie === 4)
        return this.fromUncompressedHex(z);
      throw new Error(`Point.fromHex: received invalid point. Expected 32-${b} compressed bytes or ${w} uncompressed bytes, not ${W}`);
    }
    static fromPrivateKey(N) {
      return A.BASE.multiply(Oe(N));
    }
    static fromSignature(N, z, W) {
      const { r: ie, s: he } = mt(z);
      if (![0, 1, 2, 3].includes(W))
        throw new Error("Cannot recover: invalid recovery bit");
      const Ae = be(Q(N)), { n: Ie } = u, Me = W === 2 || W === 3 ? ie + Ie : ie, Fe = Ee(Me, Ie), We = J(-Ae * Fe, Ie), it = J(he * Fe, Ie), ct = W & 1 ? "03" : "02", ar = A.fromHex(ct + D(Me)), sr = A.BASE.multiplyAndAddUnsafe(ar, We, it);
      if (!sr)
        throw new Error("Cannot recover signature: point at infinify");
      return sr.assertValidity(), sr;
    }
    toRawBytes(N = !1) {
      return G(this.toHex(N));
    }
    toHex(N = !1) {
      const z = D(this.x);
      return N ? `${this.hasEvenY() ? "02" : "03"}${z}` : `04${z}${D(this.y)}`;
    }
    toHexX() {
      return this.toHex(!0).slice(2);
    }
    toRawX() {
      return this.toRawBytes(!0).slice(1);
    }
    assertValidity() {
      const N = "Point is not on elliptic curve", { x: z, y: W } = this;
      if (!ge(z) || !ge(W))
        throw new Error(N);
      const ie = J(W * W), he = E(z);
      if (J(ie - he) !== r)
        throw new Error(N);
    }
    equals(N) {
      return this.x === N.x && this.y === N.y;
    }
    negate() {
      return new A(this.x, J(-this.y));
    }
    double() {
      return I.fromAffine(this).double().toAffine();
    }
    add(N) {
      return I.fromAffine(this).add(I.fromAffine(N)).toAffine();
    }
    subtract(N) {
      return this.add(N.negate());
    }
    multiply(N) {
      return I.fromAffine(this).multiply(N, this).toAffine();
    }
    multiplyAndAddUnsafe(N, z, W) {
      const ie = I.fromAffine(this), he = z === r || z === n || this !== A.BASE ? ie.multiplyUnsafe(z) : ie.multiply(z), Ae = I.fromAffine(N).multiplyUnsafe(W), Ie = he.add(Ae);
      return Ie.equals(I.ZERO) ? void 0 : Ie.toAffine();
    }
  }
  e.Point = A, A.BASE = new A(u.Gx, u.Gy), A.ZERO = new A(r, r);
  function $(j) {
    return Number.parseInt(j[0], 16) >= 8 ? "00" + j : j;
  }
  function U(j) {
    if (j.length < 2 || j[0] !== 2)
      throw new Error(`Invalid signature integer tag: ${de(j)}`);
    const N = j[1], z = j.subarray(2, N + 2);
    if (!N || z.length !== N)
      throw new Error("Invalid signature integer: wrong length");
    if (z[0] === 0 && z[1] <= 127)
      throw new Error("Invalid signature integer: trailing length");
    return { data: q(z), left: j.subarray(N + 2) };
  }
  function M(j) {
    if (j.length < 2 || j[0] != 48)
      throw new Error(`Invalid signature tag: ${de(j)}`);
    if (j[1] !== j.length - 2)
      throw new Error("Invalid signature: incorrect length");
    const { data: N, left: z } = U(j.subarray(2)), { data: W, left: ie } = U(z);
    if (ie.length)
      throw new Error(`Invalid signature: left bytes after parsing: ${de(ie)}`);
    return { r: N, s: W };
  }
  class Y {
    constructor(N, z) {
      this.r = N, this.s = z, this.assertValidity();
    }
    static fromCompact(N) {
      const z = N instanceof Uint8Array, W = "Signature.fromCompact";
      if (typeof N != "string" && !z)
        throw new TypeError(`${W}: Expected string or Uint8Array`);
      const ie = z ? de(N) : N;
      if (ie.length !== 128)
        throw new Error(`${W}: Expected 64-byte hex`);
      return new Y(re(ie.slice(0, 64)), re(ie.slice(64, 128)));
    }
    static fromDER(N) {
      const z = N instanceof Uint8Array;
      if (typeof N != "string" && !z)
        throw new TypeError("Signature.fromDER: Expected string or Uint8Array");
      const { r: W, s: ie } = M(z ? N : G(N));
      return new Y(W, ie);
    }
    static fromHex(N) {
      return this.fromDER(N);
    }
    assertValidity() {
      const { r: N, s: z } = this;
      if (!Ve(N))
        throw new Error("Invalid Signature: r must be 0 < r < n");
      if (!Ve(z))
        throw new Error("Invalid Signature: s must be 0 < s < n");
    }
    hasHighS() {
      const N = u.n >> n;
      return this.s > N;
    }
    normalizeS() {
      return this.hasHighS() ? new Y(this.r, J(-this.s, u.n)) : this;
    }
    toDERRawBytes() {
      return G(this.toDERHex());
    }
    toDERHex() {
      const N = $(le(this.s)), z = $(le(this.r)), W = N.length / 2, ie = z.length / 2, he = le(W), Ae = le(ie);
      return `30${le(ie + W + 4)}02${Ae}${z}02${he}${N}`;
    }
    toRawBytes() {
      return this.toDERRawBytes();
    }
    toHex() {
      return this.toDERHex();
    }
    toCompactRawBytes() {
      return G(this.toCompactHex());
    }
    toCompactHex() {
      return D(this.r) + D(this.s);
    }
  }
  e.Signature = Y;
  function L(...j) {
    if (!j.every((W) => W instanceof Uint8Array))
      throw new Error("Uint8Array list expected");
    if (j.length === 1)
      return j[0];
    const N = j.reduce((W, ie) => W + ie.length, 0), z = new Uint8Array(N);
    for (let W = 0, ie = 0; W < j.length; W++) {
      const he = j[W];
      z.set(he, ie), ie += he.length;
    }
    return z;
  }
  const ee = Array.from({ length: 256 }, (j, N) => N.toString(16).padStart(2, "0"));
  function de(j) {
    if (!(j instanceof Uint8Array))
      throw new Error("Expected Uint8Array");
    let N = "";
    for (let z = 0; z < j.length; z++)
      N += ee[j[z]];
    return N;
  }
  const ne = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000");
  function D(j) {
    if (typeof j != "bigint")
      throw new Error("Expected bigint");
    if (!(r <= j && j < ne))
      throw new Error("Expected number 0 <= n < 2^256");
    return j.toString(16).padStart(64, "0");
  }
  function K(j) {
    const N = G(D(j));
    if (N.length !== 32)
      throw new Error("Error: expected 32 bytes");
    return N;
  }
  function le(j) {
    const N = j.toString(16);
    return N.length & 1 ? `0${N}` : N;
  }
  function re(j) {
    if (typeof j != "string")
      throw new TypeError("hexToNumber: expected string, got " + typeof j);
    return BigInt(`0x${j}`);
  }
  function G(j) {
    if (typeof j != "string")
      throw new TypeError("hexToBytes: expected string, got " + typeof j);
    if (j.length % 2)
      throw new Error("hexToBytes: received invalid unpadded hex" + j.length);
    const N = new Uint8Array(j.length / 2);
    for (let z = 0; z < N.length; z++) {
      const W = z * 2, ie = j.slice(W, W + 2), he = Number.parseInt(ie, 16);
      if (Number.isNaN(he) || he < 0)
        throw new Error("Invalid byte sequence");
      N[z] = he;
    }
    return N;
  }
  function q(j) {
    return re(de(j));
  }
  function Q(j) {
    return j instanceof Uint8Array ? Uint8Array.from(j) : G(j);
  }
  function se(j) {
    if (typeof j == "number" && Number.isSafeInteger(j) && j > 0)
      return BigInt(j);
    if (typeof j == "bigint" && Ve(j))
      return j;
    throw new TypeError("Expected valid private scalar: 0 < scalar < curve.n");
  }
  function J(j, N = u.P) {
    const z = j % N;
    return z >= r ? z : N + z;
  }
  function ye(j, N) {
    const { P: z } = u;
    let W = j;
    for (; N-- > r; )
      W *= W, W %= z;
    return W;
  }
  function ve(j) {
    const { P: N } = u, z = BigInt(6), W = BigInt(11), ie = BigInt(22), he = BigInt(23), Ae = BigInt(44), Ie = BigInt(88), Me = j * j * j % N, Fe = Me * Me * j % N, We = ye(Fe, i) * Fe % N, it = ye(We, i) * Fe % N, ct = ye(it, o) * Me % N, ar = ye(ct, W) * ct % N, sr = ye(ar, ie) * ar % N, qn = ye(sr, Ae) * sr % N, ci = ye(qn, Ie) * qn % N, Io = ye(ci, Ae) * sr % N, li = ye(Io, i) * Fe % N, Ra = ye(li, he) * ar % N, Ws = ye(Ra, z) * Me % N, Vi = ye(Ws, o);
    if (Vi * Vi % N !== j)
      throw new Error("Cannot find square root");
    return Vi;
  }
  function Ee(j, N = u.P) {
    if (j === r || N <= r)
      throw new Error(`invert: expected positive integers, got n=${j} mod=${N}`);
    let z = J(j, N), W = N, ie = r, he = n;
    for (; z !== r; ) {
      const Ae = W / z, Ie = W % z, Me = ie - he * Ae;
      W = z, z = Ie, ie = he, he = Me;
    }
    if (W !== n)
      throw new Error("invert: does not exist");
    return J(ie, N);
  }
  function _e(j, N = u.P) {
    const z = new Array(j.length), W = j.reduce((he, Ae, Ie) => Ae === r ? he : (z[Ie] = he, J(he * Ae, N)), n), ie = Ee(W, N);
    return j.reduceRight((he, Ae, Ie) => Ae === r ? he : (z[Ie] = J(he * z[Ie], N), J(he * Ae, N)), ie), z;
  }
  function we(j) {
    const N = j.length * 8 - h * 8, z = q(j);
    return N > 0 ? z >> BigInt(N) : z;
  }
  function be(j, N = !1) {
    const z = we(j);
    if (N)
      return z;
    const { n: W } = u;
    return z >= W ? z - W : z;
  }
  let Ge, Le;
  class Ne {
    constructor(N, z) {
      if (this.hashLen = N, this.qByteLen = z, typeof N != "number" || N < 2)
        throw new Error("hashLen must be a number");
      if (typeof z != "number" || z < 2)
        throw new Error("qByteLen must be a number");
      this.v = new Uint8Array(N).fill(1), this.k = new Uint8Array(N).fill(0), this.counter = 0;
    }
    hmac(...N) {
      return e.utils.hmacSha256(this.k, ...N);
    }
    hmacSync(...N) {
      return Le(this.k, ...N);
    }
    checkSync() {
      if (typeof Le != "function")
        throw new O("hmacSha256Sync needs to be set");
    }
    incr() {
      if (this.counter >= 1e3)
        throw new Error("Tried 1,000 k values for sign(), all were invalid");
      this.counter += 1;
    }
    async reseed(N = new Uint8Array()) {
      this.k = await this.hmac(this.v, Uint8Array.from([0]), N), this.v = await this.hmac(this.v), N.length !== 0 && (this.k = await this.hmac(this.v, Uint8Array.from([1]), N), this.v = await this.hmac(this.v));
    }
    reseedSync(N = new Uint8Array()) {
      this.checkSync(), this.k = this.hmacSync(this.v, Uint8Array.from([0]), N), this.v = this.hmacSync(this.v), N.length !== 0 && (this.k = this.hmacSync(this.v, Uint8Array.from([1]), N), this.v = this.hmacSync(this.v));
    }
    async generate() {
      this.incr();
      let N = 0;
      const z = [];
      for (; N < this.qByteLen; ) {
        this.v = await this.hmac(this.v);
        const W = this.v.slice();
        z.push(W), N += this.v.length;
      }
      return L(...z);
    }
    generateSync() {
      this.checkSync(), this.incr();
      let N = 0;
      const z = [];
      for (; N < this.qByteLen; ) {
        this.v = this.hmacSync(this.v);
        const W = this.v.slice();
        z.push(W), N += this.v.length;
      }
      return L(...z);
    }
  }
  function Ve(j) {
    return r < j && j < u.n;
  }
  function ge(j) {
    return r < j && j < u.P;
  }
  function Te(j, N, z, W = !0) {
    const { n: ie } = u, he = be(j, !0);
    if (!Ve(he))
      return;
    const Ae = Ee(he, ie), Ie = A.BASE.multiply(he), Me = J(Ie.x, ie);
    if (Me === r)
      return;
    const Fe = J(Ae * J(N + z * Me, ie), ie);
    if (Fe === r)
      return;
    let We = new Y(Me, Fe), it = (Ie.x === We.r ? 0 : 2) | Number(Ie.y & n);
    return W && We.hasHighS() && (We = We.normalizeS(), it ^= 1), { sig: We, recovery: it };
  }
  function Oe(j) {
    let N;
    if (typeof j == "bigint")
      N = j;
    else if (typeof j == "number" && Number.isSafeInteger(j) && j > 0)
      N = BigInt(j);
    else if (typeof j == "string") {
      if (j.length !== 2 * h)
        throw new Error("Expected 32 bytes of private key");
      N = re(j);
    } else if (j instanceof Uint8Array) {
      if (j.length !== h)
        throw new Error("Expected 32 bytes of private key");
      N = q(j);
    } else
      throw new TypeError("Expected valid private key");
    if (!Ve(N))
      throw new Error("Expected private key: 0 < key < n");
    return N;
  }
  function He(j) {
    return j instanceof A ? (j.assertValidity(), j) : A.fromHex(j);
  }
  function mt(j) {
    if (j instanceof Y)
      return j.assertValidity(), j;
    try {
      return Y.fromDER(j);
    } catch {
      return Y.fromCompact(j);
    }
  }
  function rt(j, N = !1) {
    return A.fromPrivateKey(j).toRawBytes(N);
  }
  e.getPublicKey = rt;
  function Pt(j, N, z, W = !1) {
    return A.fromSignature(j, N, z).toRawBytes(W);
  }
  e.recoverPublicKey = Pt;
  function _t(j) {
    const N = j instanceof Uint8Array, z = typeof j == "string", W = (N || z) && j.length;
    return N ? W === b || W === w : z ? W === b * 2 || W === w * 2 : j instanceof A;
  }
  function yt(j, N, z = !1) {
    if (_t(j))
      throw new TypeError("getSharedSecret: first arg must be private key");
    if (!_t(N))
      throw new TypeError("getSharedSecret: second arg must be public key");
    const W = He(N);
    return W.assertValidity(), W.multiply(Oe(j)).toRawBytes(z);
  }
  e.getSharedSecret = yt;
  function Zt(j) {
    const N = j.length > f ? j.slice(0, f) : j;
    return q(N);
  }
  function yn(j) {
    const N = Zt(j), z = J(N, u.n);
    return kt(z < r ? N : z);
  }
  function kt(j) {
    return K(j);
  }
  function qr(j, N, z) {
    if (j == null)
      throw new Error(`sign: expected valid message hash, not "${j}"`);
    const W = Q(j), ie = Oe(N), he = [kt(ie), yn(W)];
    if (z != null) {
      z === !0 && (z = e.utils.randomBytes(f));
      const Me = Q(z);
      if (Me.length !== f)
        throw new Error(`sign: Expected ${f} bytes of extra data`);
      he.push(Me);
    }
    const Ae = L(...he), Ie = Zt(W);
    return { seed: Ae, m: Ie, d: ie };
  }
  function m(j, N) {
    const { sig: z, recovery: W } = j, { der: ie, recovered: he } = Object.assign({ canonical: !0, der: !0 }, N), Ae = ie ? z.toDERRawBytes() : z.toCompactRawBytes();
    return he ? [Ae, W] : Ae;
  }
  async function v(j, N, z = {}) {
    const { seed: W, m: ie, d: he } = qr(j, N, z.extraEntropy), Ae = new Ne(g, h);
    await Ae.reseed(W);
    let Ie;
    for (; !(Ie = Te(await Ae.generate(), ie, he, z.canonical)); )
      await Ae.reseed();
    return m(Ie, z);
  }
  e.sign = v;
  function k(j, N, z = {}) {
    const { seed: W, m: ie, d: he } = qr(j, N, z.extraEntropy), Ae = new Ne(g, h);
    Ae.reseedSync(W);
    let Ie;
    for (; !(Ie = Te(Ae.generateSync(), ie, he, z.canonical)); )
      Ae.reseedSync();
    return m(Ie, z);
  }
  e.signSync = k;
  const H = { strict: !0 };
  function X(j, N, z, W = H) {
    let ie;
    try {
      ie = mt(j), N = Q(N);
    } catch {
      return !1;
    }
    const { r: he, s: Ae } = ie;
    if (W.strict && ie.hasHighS())
      return !1;
    const Ie = be(N);
    let Me;
    try {
      Me = He(z);
    } catch {
      return !1;
    }
    const { n: Fe } = u, We = Ee(Ae, Fe), it = J(Ie * We, Fe), ct = J(he * We, Fe), ar = A.BASE.multiplyAndAddUnsafe(Me, it, ct);
    return ar ? J(ar.x, Fe) === he : !1;
  }
  e.verify = X;
  function oe(j) {
    return J(q(j), u.n);
  }
  class me {
    constructor(N, z) {
      this.r = N, this.s = z, this.assertValidity();
    }
    static fromHex(N) {
      const z = Q(N);
      if (z.length !== 64)
        throw new TypeError(`SchnorrSignature.fromHex: expected 64 bytes, not ${z.length}`);
      const W = q(z.subarray(0, 32)), ie = q(z.subarray(32, 64));
      return new me(W, ie);
    }
    assertValidity() {
      const { r: N, s: z } = this;
      if (!ge(N) || !Ve(z))
        throw new Error("Invalid signature");
    }
    toHex() {
      return D(this.r) + D(this.s);
    }
    toRawBytes() {
      return G(this.toHex());
    }
  }
  function nt(j) {
    return A.fromPrivateKey(j).toRawX();
  }
  class Ct {
    constructor(N, z, W = e.utils.randomBytes()) {
      if (N == null)
        throw new TypeError(`sign: Expected valid message, not "${N}"`);
      this.m = Q(N);
      const { x: ie, scalar: he } = this.getScalar(Oe(z));
      if (this.px = ie, this.d = he, this.rand = Q(W), this.rand.length !== 32)
        throw new TypeError("sign: Expected 32 bytes of aux randomness");
    }
    getScalar(N) {
      const z = A.fromPrivateKey(N), W = z.hasEvenY() ? N : u.n - N;
      return { point: z, scalar: W, x: z.toRawX() };
    }
    initNonce(N, z) {
      return K(N ^ q(z));
    }
    finalizeNonce(N) {
      const z = J(q(N), u.n);
      if (z === r)
        throw new Error("sign: Creation of signature failed. k is zero");
      const { point: W, x: ie, scalar: he } = this.getScalar(z);
      return { R: W, rx: ie, k: he };
    }
    finalizeSig(N, z, W, ie) {
      return new me(N.x, J(z + W * ie, u.n)).toRawBytes();
    }
    error() {
      throw new Error("sign: Invalid signature produced");
    }
    async calc() {
      const { m: N, d: z, px: W, rand: ie } = this, he = e.utils.taggedHash, Ae = this.initNonce(z, await he(fo.aux, ie)), { R: Ie, rx: Me, k: Fe } = this.finalizeNonce(await he(fo.nonce, Ae, W, N)), We = oe(await he(fo.challenge, Me, W, N)), it = this.finalizeSig(Ie, Fe, We, z);
      return await Lc(it, N, W) || this.error(), it;
    }
    calcSync() {
      const { m: N, d: z, px: W, rand: ie } = this, he = e.utils.taggedHashSync, Ae = this.initNonce(z, he(fo.aux, ie)), { R: Ie, rx: Me, k: Fe } = this.finalizeNonce(he(fo.nonce, Ae, W, N)), We = oe(he(fo.challenge, Me, W, N)), it = this.finalizeSig(Ie, Fe, We, z);
      return Gs(it, N, W) || this.error(), it;
    }
  }
  async function At(j, N, z) {
    return new Ct(j, N, z).calc();
  }
  function vt(j, N, z) {
    return new Ct(j, N, z).calcSync();
  }
  function Ht(j, N, z) {
    const W = j instanceof me, ie = W ? j : me.fromHex(j);
    return W && ie.assertValidity(), {
      ...ie,
      m: Q(N),
      P: He(z)
    };
  }
  function jc(j, N, z, W) {
    const ie = A.BASE.multiplyAndAddUnsafe(N, Oe(z), J(-W, u.n));
    return !(!ie || !ie.hasEvenY() || ie.x !== j);
  }
  async function Lc(j, N, z) {
    try {
      const { r: W, s: ie, m: he, P: Ae } = Ht(j, N, z), Ie = oe(await e.utils.taggedHash(fo.challenge, K(W), Ae.toRawX(), he));
      return jc(W, Ae, ie, Ie);
    } catch {
      return !1;
    }
  }
  function Gs(j, N, z) {
    try {
      const { r: W, s: ie, m: he, P: Ae } = Ht(j, N, z), Ie = oe(e.utils.taggedHashSync(fo.challenge, K(W), Ae.toRawX(), he));
      return jc(W, Ae, ie, Ie);
    } catch (W) {
      if (W instanceof O)
        throw W;
      return !1;
    }
  }
  e.schnorr = {
    Signature: me,
    getPublicKey: nt,
    sign: At,
    verify: Lc,
    signSync: vt,
    verifySync: Gs
  }, A.BASE._setWindowSize(8);
  const Hr = {
    node: t,
    web: typeof self == "object" && "crypto" in self ? self.crypto : void 0
  }, fo = {
    challenge: "BIP0340/challenge",
    aux: "BIP0340/aux",
    nonce: "BIP0340/nonce"
  }, Ua = {};
  e.utils = {
    bytesToHex: de,
    hexToBytes: G,
    concatBytes: L,
    mod: J,
    invert: Ee,
    isValidPrivateKey(j) {
      try {
        return Oe(j), !0;
      } catch {
        return !1;
      }
    },
    _bigintTo32Bytes: K,
    _normalizePrivateKey: Oe,
    hashToPrivateKey: (j) => {
      j = Q(j);
      const N = h + 8;
      if (j.length < N || j.length > 1024)
        throw new Error("Expected valid bytes of private key as per FIPS 186");
      const z = J(q(j), u.n - n) + n;
      return K(z);
    },
    randomBytes: (j = 32) => {
      if (Hr.web)
        return Hr.web.getRandomValues(new Uint8Array(j));
      if (Hr.node) {
        const { randomBytes: N } = Hr.node;
        return Uint8Array.from(N(j));
      } else
        throw new Error("The environment doesn't have randomBytes function");
    },
    randomPrivateKey: () => e.utils.hashToPrivateKey(e.utils.randomBytes(h + 8)),
    precompute(j = 8, N = A.BASE) {
      const z = N === A.BASE ? N : new A(N.x, N.y);
      return z._setWindowSize(j), z.multiply(i), z;
    },
    sha256: async (...j) => {
      if (Hr.web) {
        const N = await Hr.web.subtle.digest("SHA-256", L(...j));
        return new Uint8Array(N);
      } else if (Hr.node) {
        const { createHash: N } = Hr.node, z = N("sha256");
        return j.forEach((W) => z.update(W)), Uint8Array.from(z.digest());
      } else
        throw new Error("The environment doesn't have sha256 function");
    },
    hmacSha256: async (j, ...N) => {
      if (Hr.web) {
        const z = await Hr.web.subtle.importKey("raw", j, { name: "HMAC", hash: { name: "SHA-256" } }, !1, ["sign"]), W = L(...N), ie = await Hr.web.subtle.sign("HMAC", z, W);
        return new Uint8Array(ie);
      } else if (Hr.node) {
        const { createHmac: z } = Hr.node, W = z("sha256", j);
        return N.forEach((ie) => W.update(ie)), Uint8Array.from(W.digest());
      } else
        throw new Error("The environment doesn't have hmac-sha256 function");
    },
    sha256Sync: void 0,
    hmacSha256Sync: void 0,
    taggedHash: async (j, ...N) => {
      let z = Ua[j];
      if (z === void 0) {
        const W = await e.utils.sha256(Uint8Array.from(j, (ie) => ie.charCodeAt(0)));
        z = L(W, W), Ua[j] = z;
      }
      return e.utils.sha256(z, ...N);
    },
    taggedHashSync: (j, ...N) => {
      if (typeof Ge != "function")
        throw new O("sha256Sync is undefined, you need to set it");
      let z = Ua[j];
      if (z === void 0) {
        const W = Ge(Uint8Array.from(j, (ie) => ie.charCodeAt(0)));
        z = L(W, W), Ua[j] = z;
      }
      return Ge(z, ...N);
    },
    _JacobianPoint: I
  }, Object.defineProperties(e.utils, {
    sha256Sync: {
      configurable: !1,
      get() {
        return Ge;
      },
      set(j) {
        Ge || (Ge = j);
      }
    },
    hmacSha256Sync: {
      configurable: !1,
      get() {
        return Le;
      },
      set(j) {
        Le || (Le = j);
      }
    }
  });
})(OY);
var dg = {};
Object.defineProperty(dg, "__esModule", { value: !0 });
dg.joseToDer = dg.derToJose = void 0;
const CY = Zg, BY = ca;
function cI(e) {
  return (e / 8 | 0) + (e % 8 === 0 ? 0 : 1);
}
const uCe = {
  ES256: cI(256),
  ES384: cI(384),
  ES512: cI(521)
};
function NY(e) {
  const t = uCe[e];
  if (t)
    return t;
  throw new Error(`Unknown algorithm "${e}"`);
}
const B5 = 128, $Y = 0, cCe = 32, lCe = 16, fCe = 2, UY = lCe | cCe | $Y << 6, N5 = fCe | $Y << 6;
function RY(e) {
  if (e instanceof Uint8Array)
    return e;
  if (typeof e == "string")
    return (0, CY.toByteArray)((0, BY.pad)(e));
  throw new TypeError("ECDSA signature must be a Base64 string or a Uint8Array");
}
function dCe(e, t) {
  const r = RY(e), n = NY(t), o = n + 1, i = r.length;
  let a = 0;
  if (r[a++] !== UY)
    throw new Error('Could not find expected "seq"');
  let u = r[a++];
  if (u === (B5 | 1) && (u = r[a++]), i - a < u)
    throw new Error(`"seq" specified length of "${u}", only "${i - a}" remaining`);
  if (r[a++] !== N5)
    throw new Error('Could not find expected "int" for "r"');
  const l = r[a++];
  if (i - a - 2 < l)
    throw new Error(`"r" specified length of "${l}", only "${i - a - 2}" available`);
  if (o < l)
    throw new Error(`"r" specified length of "${l}", max of "${o}" is acceptable`);
  const d = a;
  if (a += l, r[a++] !== N5)
    throw new Error('Could not find expected "int" for "s"');
  const f = r[a++];
  if (i - a !== f)
    throw new Error(`"s" specified length of "${f}", expected "${i - a}"`);
  if (o < f)
    throw new Error(`"s" specified length of "${f}", max of "${o}" is acceptable`);
  const h = a;
  if (a += f, a !== i)
    throw new Error(`Expected to consume entire array, but "${i - a}" bytes remain`);
  const g = n - l, b = n - f, w = new Uint8Array(g + l + b + f);
  for (a = 0; a < g; ++a)
    w[a] = 0;
  w.set(r.subarray(d + Math.max(-g, 0), d + l), a), a = n;
  for (const E = a; a < E + b; ++a)
    w[a] = 0;
  return w.set(r.subarray(h + Math.max(-b, 0), h + f), a), (0, BY.escape)((0, CY.fromByteArray)(w));
}
dg.derToJose = dCe;
function Rj(e, t, r) {
  let n = 0;
  for (; t + n < r && e[t + n] === 0; )
    ++n;
  return e[t + n] >= B5 && --n, n;
}
function hCe(e, t) {
  e = RY(e);
  const r = NY(t), n = e.length;
  if (n !== r * 2)
    throw new TypeError(`"${t}" signatures must be "${r * 2}" bytes, saw "${n}"`);
  const o = Rj(e, 0, r), i = Rj(e, r, e.length), a = r - o, u = r - i, l = 2 + a + 1 + 1 + u, d = l < B5, f = new Uint8Array((d ? 2 : 3) + l);
  let h = 0;
  return f[h++] = UY, d ? f[h++] = l : (f[h++] = B5 | 1, f[h++] = l & 255), f[h++] = N5, f[h++] = a, o < 0 ? (f[h++] = 0, f.set(e.subarray(0, r), h), h += r) : (f.set(e.subarray(o, r), h), h += r - o), f[h++] = N5, f[h++] = u, i < 0 ? (f[h++] = 0, f.set(e.subarray(r), h)) : f.set(e.subarray(r + i), h), f;
}
dg.joseToDer = hCe;
var gf = {};
Object.defineProperty(gf, "__esModule", { value: !0 });
gf.InvalidTokenError = gf.MissingParametersError = void 0;
class pCe extends Error {
  constructor(t) {
    super(), this.name = "MissingParametersError", this.message = t || "";
  }
}
gf.MissingParametersError = pCe;
class gCe extends Error {
  constructor(t) {
    super(), this.name = "InvalidTokenError", this.message = t || "";
  }
}
gf.InvalidTokenError = gCe;
Object.defineProperty(XE, "__esModule", { value: !0 });
XE.SECP256K1Client = void 0;
const mCe = Q2, yCe = Ru, Y8 = OY, zj = dg, jj = gf, Lj = Vs;
Y8.utils.hmacSha256Sync = (e, ...t) => {
  const r = mCe.hmac.create(yCe.sha256, e);
  return t.forEach((n) => r.update(n)), r.digest();
};
class zY {
  static derivePublicKey(t, r = !0) {
    return t.length === 66 && (t = t.slice(0, 64)), t.length < 64 && (t = t.padStart(64, "0")), (0, Lj.bytesToHex)(Y8.getPublicKey(t, r));
  }
  static signHash(t, r, n = "jose") {
    if (!t || !r)
      throw new jj.MissingParametersError("a signing input hash and private key are all required");
    const o = Y8.signSync(t, r.slice(0, 64), {
      der: !0,
      canonical: !1
    });
    if (n === "der")
      return (0, Lj.bytesToHex)(o);
    if (n === "jose")
      return (0, zj.derToJose)(o, "ES256");
    throw Error("Invalid signature format");
  }
  static loadSignature(t) {
    return (0, zj.joseToDer)(t, "ES256");
  }
  static verifyHash(t, r, n) {
    if (!t || !r || !n)
      throw new jj.MissingParametersError("a signing input hash, der signature, and public key are all required");
    return Y8.verify(r, t, n, { strict: !1 });
  }
}
XE.SECP256K1Client = zY;
zY.algorithmName = "ES256K";
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.cryptoClients = e.SECP256K1Client = void 0;
  const t = XE;
  Object.defineProperty(e, "SECP256K1Client", { enumerable: !0, get: function() {
    return t.SECP256K1Client;
  } });
  const r = {
    ES256K: t.SECP256K1Client
  };
  e.cryptoClients = r;
})(ZE);
var y0 = {}, bCe = zt && zt.__awaiter || function(e, t, r, n) {
  function o(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function u(f) {
      try {
        d(n.next(f));
      } catch (h) {
        a(h);
      }
    }
    function l(f) {
      try {
        d(n.throw(f));
      } catch (h) {
        a(h);
      }
    }
    function d(f) {
      f.done ? i(f.value) : o(f.value).then(u, l);
    }
    d((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty(y0, "__esModule", { value: !0 });
y0.hashSha256Async = y0.hashSha256 = void 0;
const wCe = Ru;
function jY(e) {
  return (0, wCe.sha256)(e);
}
y0.hashSha256 = jY;
function vCe(e) {
  return bCe(this, void 0, void 0, function* () {
    try {
      if (typeof crypto < "u" && typeof crypto.subtle < "u") {
        const t = typeof e == "string" ? new TextEncoder().encode(e) : e, r = yield crypto.subtle.digest("SHA-256", t);
        return new Uint8Array(r);
      } else {
        const t = PY;
        if (!t.createHash)
          throw new Error("`crypto` module does not contain `createHash`");
        return Promise.resolve(t.createHash("sha256").update(e).digest());
      }
    } catch (t) {
      return console.log(t), console.log('Crypto lib not found. Neither the global `crypto.subtle` Web Crypto API, nor the or the Node.js `require("crypto").createHash` module is available. Falling back to JS implementation.'), Promise.resolve(jY(e));
    }
  });
}
y0.hashSha256Async = vCe;
var ECe = zt && zt.__awaiter || function(e, t, r, n) {
  function o(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function u(f) {
      try {
        d(n.next(f));
      } catch (h) {
        a(h);
      }
    }
    function l(f) {
      try {
        d(n.throw(f));
      } catch (h) {
        a(h);
      }
    }
    function d(f) {
      f.done ? i(f.value) : o(f.value).then(u, l);
    }
    d((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty(fg, "__esModule", { value: !0 });
fg.TokenSigner = fg.createUnsecuredToken = void 0;
const kP = ca, Hj = ZE, _Ce = gf, Fj = y0;
function SP(e, t) {
  const r = [], n = kP.encode(JSON.stringify(t));
  r.push(n);
  const o = kP.encode(JSON.stringify(e));
  return r.push(o), r.join(".");
}
function ACe(e) {
  return SP(e, { typ: "JWT", alg: "none" }) + ".";
}
fg.createUnsecuredToken = ACe;
class xCe {
  constructor(t, r) {
    if (!(t && r))
      throw new _Ce.MissingParametersError("a signing algorithm and private key are required");
    if (typeof t != "string")
      throw new Error("signing algorithm parameter must be a string");
    if (t = t.toUpperCase(), !Hj.cryptoClients.hasOwnProperty(t))
      throw new Error("invalid signing algorithm");
    this.tokenType = "JWT", this.cryptoClient = Hj.cryptoClients[t], this.rawPrivateKey = r;
  }
  header(t = {}) {
    const r = { typ: this.tokenType, alg: this.cryptoClient.algorithmName };
    return Object.assign({}, r, t);
  }
  sign(t, r = !1, n = {}) {
    const o = this.header(n), i = SP(t, o), a = (0, Fj.hashSha256)(i);
    return this.createWithSignedHash(t, r, o, i, a);
  }
  signAsync(t, r = !1, n = {}) {
    return ECe(this, void 0, void 0, function* () {
      const o = this.header(n), i = SP(t, o), a = yield (0, Fj.hashSha256Async)(i);
      return this.createWithSignedHash(t, r, o, i, a);
    });
  }
  createWithSignedHash(t, r, n, o, i) {
    const a = this.cryptoClient.signHash(i, this.rawPrivateKey);
    return r ? {
      header: [kP.encode(JSON.stringify(n))],
      payload: JSON.stringify(t),
      signature: [a]
    } : [o, a].join(".");
  }
}
fg.TokenSigner = xCe;
var YE = {};
Object.defineProperty(YE, "__esModule", { value: !0 });
YE.TokenVerifier = void 0;
const kCe = ca, Mj = ZE, SCe = gf, k8 = y0;
class TCe {
  constructor(t, r) {
    if (!(t && r))
      throw new SCe.MissingParametersError("a signing algorithm and public key are required");
    if (typeof t != "string")
      throw "signing algorithm parameter must be a string";
    if (t = t.toUpperCase(), !Mj.cryptoClients.hasOwnProperty(t))
      throw "invalid signing algorithm";
    this.tokenType = "JWT", this.cryptoClient = Mj.cryptoClients[t], this.rawPublicKey = r;
  }
  verify(t) {
    return typeof t == "string" ? this.verifyCompact(t, !1) : typeof t == "object" ? this.verifyExpanded(t, !1) : !1;
  }
  verifyAsync(t) {
    return typeof t == "string" ? this.verifyCompact(t, !0) : typeof t == "object" ? this.verifyExpanded(t, !0) : Promise.resolve(!1);
  }
  verifyCompact(t, r) {
    const n = t.split("."), o = n[0] + "." + n[1], i = (a) => {
      const u = this.cryptoClient.loadSignature(n[2]);
      return this.cryptoClient.verifyHash(a, u, this.rawPublicKey);
    };
    if (r)
      return (0, k8.hashSha256Async)(o).then((a) => i(a));
    {
      const a = (0, k8.hashSha256)(o);
      return i(a);
    }
  }
  verifyExpanded(t, r) {
    const n = [t.header.join("."), kCe.encode(t.payload)].join(".");
    let o = !0;
    const i = (a) => (t.signature.map((u) => {
      const l = this.cryptoClient.loadSignature(u);
      this.cryptoClient.verifyHash(a, l, this.rawPublicKey) || (o = !1);
    }), o);
    if (r)
      return (0, k8.hashSha256Async)(n).then((a) => i(a));
    {
      const a = (0, k8.hashSha256)(n);
      return i(a);
    }
  }
}
YE.TokenVerifier = TCe;
var JE = {};
Object.defineProperty(JE, "__esModule", { value: !0 });
JE.decodeToken = void 0;
const S8 = ca;
function ICe(e) {
  if (typeof e == "string") {
    const t = e.split("."), r = JSON.parse(S8.decode(t[0])), n = JSON.parse(S8.decode(t[1])), o = t[2];
    return {
      header: r,
      payload: n,
      signature: o
    };
  } else if (typeof e == "object") {
    if (typeof e.payload != "string")
      throw new Error("Expected token payload to be a base64 or json string");
    let t = e.payload;
    e.payload[0] !== "{" && (t = S8.decode(t));
    const r = [];
    return e.header.map((n) => {
      const o = JSON.parse(S8.decode(n));
      r.push(o);
    }), {
      header: r,
      payload: JSON.parse(t),
      signature: e.signature
    };
  }
}
JE.decodeToken = ICe;
(function(e) {
  var t = zt && zt.__createBinding || (Object.create ? function(n, o, i, a) {
    a === void 0 && (a = i);
    var u = Object.getOwnPropertyDescriptor(o, i);
    (!u || ("get" in u ? !o.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return o[i];
    } }), Object.defineProperty(n, a, u);
  } : function(n, o, i, a) {
    a === void 0 && (a = i), n[a] = o[i];
  }), r = zt && zt.__exportStar || function(n, o) {
    for (var i in n) i !== "default" && !Object.prototype.hasOwnProperty.call(o, i) && t(o, n, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(fg, e), r(YE, e), r(JE, e), r(gf, e), r(ZE, e);
})(vs);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Dj = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
(() => {
  const e = Array(256).fill(-1);
  for (let t = 0; t < Dj.length; ++t) e[Dj.charCodeAt(t)] = t;
})();
var Kj, lI, T8, r$ = (Kj = function(e, t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.bech32m = t.bech32 = void 0;
  const r = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", n = {};
  for (let h = 0; h < 32; h++) {
    const g = r.charAt(h);
    n[g] = h;
  }
  function o(h) {
    const g = h >> 25;
    return (33554431 & h) << 5 ^ 996825010 & -(g >> 0 & 1) ^ 642813549 & -(g >> 1 & 1) ^ 513874426 & -(g >> 2 & 1) ^ 1027748829 & -(g >> 3 & 1) ^ 705979059 & -(g >> 4 & 1);
  }
  function i(h) {
    let g = 1;
    for (let b = 0; b < h.length; ++b) {
      const w = h.charCodeAt(b);
      if (w < 33 || w > 126) return "Invalid prefix (" + h + ")";
      g = o(g) ^ w >> 5;
    }
    g = o(g);
    for (let b = 0; b < h.length; ++b) {
      const w = h.charCodeAt(b);
      g = o(g) ^ 31 & w;
    }
    return g;
  }
  function a(h, g, b, w) {
    let E = 0, _ = 0;
    const O = (1 << b) - 1, C = [];
    for (let I = 0; I < h.length; ++I) for (E = E << g | h[I], _ += g; _ >= b; ) _ -= b, C.push(E >> _ & O);
    if (w) _ > 0 && C.push(E << b - _ & O);
    else {
      if (_ >= g) return "Excess padding";
      if (E << b - _ & O) return "Non-zero padding";
    }
    return C;
  }
  function u(h) {
    return a(h, 8, 5, !0);
  }
  function l(h) {
    const g = a(h, 5, 8, !1);
    if (Array.isArray(g)) return g;
  }
  function d(h) {
    const g = a(h, 5, 8, !1);
    if (Array.isArray(g)) return g;
    throw new Error(g);
  }
  function f(h) {
    let g;
    function b(w, E) {
      if (E = E || 90, w.length < 8) return w + " too short";
      if (w.length > E) return "Exceeds length limit";
      const _ = w.toLowerCase(), O = w.toUpperCase();
      if (w !== _ && w !== O) return "Mixed-case string " + w;
      const C = (w = _).lastIndexOf("1");
      if (C === -1) return "No separator character for " + w;
      if (C === 0) return "Missing prefix for " + w;
      const I = w.slice(0, C), S = w.slice(C + 1);
      if (S.length < 6) return "Data too short";
      let T = i(I);
      if (typeof T == "string") return T;
      const A = [];
      for (let $ = 0; $ < S.length; ++$) {
        const U = S.charAt($), M = n[U];
        if (M === void 0) return "Unknown character " + U;
        T = o(T) ^ M, $ + 6 >= S.length || A.push(M);
      }
      return T !== g ? "Invalid checksum for " + w : { prefix: I, words: A };
    }
    return g = h === "bech32" ? 1 : 734539939, { decodeUnsafe: function(w, E) {
      const _ = b(w, E);
      if (typeof _ == "object") return _;
    }, decode: function(w, E) {
      const _ = b(w, E);
      if (typeof _ == "object") return _;
      throw new Error(_);
    }, encode: function(w, E, _) {
      if (_ = _ || 90, w.length + 7 + E.length > _) throw new TypeError("Exceeds length limit");
      let O = i(w = w.toLowerCase());
      if (typeof O == "string") throw new Error(O);
      let C = w + "1";
      for (let I = 0; I < E.length; ++I) {
        const S = E[I];
        if (S >> 5) throw new Error("Non 5-bit word");
        O = o(O) ^ S, C += r.charAt(S);
      }
      for (let I = 0; I < 6; ++I) O = o(O);
      O ^= g;
      for (let I = 0; I < 6; ++I) C += r.charAt(O >> 5 * (5 - I) & 31);
      return C;
    }, toWords: u, fromWordsUnsafe: l, fromWords: d };
  }
  t.bech32 = f("bech32"), t.bech32m = f("bech32m");
}, Kj(lI = { exports: {} }, lI.exports), lI.exports);
(T8 = r$) && T8.__esModule && Object.prototype.hasOwnProperty.call(T8, "default") && T8.default;
r$.bech32m;
r$.bech32;
new Uint8Array(new Uint16Array([65279]).buffer)[0];
var h1, p1;
(function(e) {
  e.mainnet = "mainnet", e.testnet = "testnet", e.regtest = "regtest";
})(h1 || (h1 = {})), function(e) {
  e.p2pkh = "p2pkh", e.p2sh = "p2sh", e.p2wpkh = "p2wpkh", e.p2wsh = "p2wsh", e.p2tr = "p2tr";
}(p1 || (p1 = {}));
p1.p2pkh, h1.mainnet, p1.p2pkh, h1.testnet, p1.p2sh, h1.mainnet, p1.p2sh, h1.testnet;
var OCe = {}, n$ = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
n$.read = function(e, t, r, n, o) {
  var i, a, u = o * 8 - n - 1, l = (1 << u) - 1, d = l >> 1, f = -7, h = r ? o - 1 : 0, g = r ? -1 : 1, b = e[t + h];
  for (h += g, i = b & (1 << -f) - 1, b >>= -f, f += u; f > 0; i = i * 256 + e[t + h], h += g, f -= 8)
    ;
  for (a = i & (1 << -f) - 1, i >>= -f, f += n; f > 0; a = a * 256 + e[t + h], h += g, f -= 8)
    ;
  if (i === 0)
    i = 1 - d;
  else {
    if (i === l)
      return a ? NaN : (b ? -1 : 1) * (1 / 0);
    a = a + Math.pow(2, n), i = i - d;
  }
  return (b ? -1 : 1) * a * Math.pow(2, i - n);
};
n$.write = function(e, t, r, n, o, i) {
  var a, u, l, d = i * 8 - o - 1, f = (1 << d) - 1, h = f >> 1, g = o === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, b = n ? 0 : i - 1, w = n ? 1 : -1, E = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (u = isNaN(t) ? 1 : 0, a = f) : (a = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -a)) < 1 && (a--, l *= 2), a + h >= 1 ? t += g / l : t += g * Math.pow(2, 1 - h), t * l >= 2 && (a++, l /= 2), a + h >= f ? (u = 0, a = f) : a + h >= 1 ? (u = (t * l - 1) * Math.pow(2, o), a = a + h) : (u = t * Math.pow(2, h - 1) * Math.pow(2, o), a = 0)); o >= 8; e[r + b] = u & 255, b += w, u /= 256, o -= 8)
    ;
  for (a = a << o | u, d += o; d > 0; e[r + b] = a & 255, b += w, a /= 256, d -= 8)
    ;
  e[r + b - w] |= E * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(e) {
  const t = Zg, r = n$, n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  e.Buffer = u, e.SlowBuffer = C, e.INSPECT_MAX_BYTES = 50;
  const o = 2147483647;
  e.kMaxLength = o, u.TYPED_ARRAY_SUPPORT = i(), !u.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function i() {
    try {
      const m = new Uint8Array(1), v = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(v, Uint8Array.prototype), Object.setPrototypeOf(m, v), m.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(u.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (u.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(u.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (u.isBuffer(this))
        return this.byteOffset;
    }
  });
  function a(m) {
    if (m > o)
      throw new RangeError('The value "' + m + '" is invalid for option "size"');
    const v = new Uint8Array(m);
    return Object.setPrototypeOf(v, u.prototype), v;
  }
  function u(m, v, k) {
    if (typeof m == "number") {
      if (typeof v == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return h(m);
    }
    return l(m, v, k);
  }
  u.poolSize = 8192;
  function l(m, v, k) {
    if (typeof m == "string")
      return g(m, v);
    if (ArrayBuffer.isView(m))
      return w(m);
    if (m == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof m
      );
    if (yt(m, ArrayBuffer) || m && yt(m.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (yt(m, SharedArrayBuffer) || m && yt(m.buffer, SharedArrayBuffer)))
      return E(m, v, k);
    if (typeof m == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const H = m.valueOf && m.valueOf();
    if (H != null && H !== m)
      return u.from(H, v, k);
    const X = _(m);
    if (X) return X;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof m[Symbol.toPrimitive] == "function")
      return u.from(m[Symbol.toPrimitive]("string"), v, k);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof m
    );
  }
  u.from = function(m, v, k) {
    return l(m, v, k);
  }, Object.setPrototypeOf(u.prototype, Uint8Array.prototype), Object.setPrototypeOf(u, Uint8Array);
  function d(m) {
    if (typeof m != "number")
      throw new TypeError('"size" argument must be of type number');
    if (m < 0)
      throw new RangeError('The value "' + m + '" is invalid for option "size"');
  }
  function f(m, v, k) {
    return d(m), m <= 0 ? a(m) : v !== void 0 ? typeof k == "string" ? a(m).fill(v, k) : a(m).fill(v) : a(m);
  }
  u.alloc = function(m, v, k) {
    return f(m, v, k);
  };
  function h(m) {
    return d(m), a(m < 0 ? 0 : O(m) | 0);
  }
  u.allocUnsafe = function(m) {
    return h(m);
  }, u.allocUnsafeSlow = function(m) {
    return h(m);
  };
  function g(m, v) {
    if ((typeof v != "string" || v === "") && (v = "utf8"), !u.isEncoding(v))
      throw new TypeError("Unknown encoding: " + v);
    const k = I(m, v) | 0;
    let H = a(k);
    const X = H.write(m, v);
    return X !== k && (H = H.slice(0, X)), H;
  }
  function b(m) {
    const v = m.length < 0 ? 0 : O(m.length) | 0, k = a(v);
    for (let H = 0; H < v; H += 1)
      k[H] = m[H] & 255;
    return k;
  }
  function w(m) {
    if (yt(m, Uint8Array)) {
      const v = new Uint8Array(m);
      return E(v.buffer, v.byteOffset, v.byteLength);
    }
    return b(m);
  }
  function E(m, v, k) {
    if (v < 0 || m.byteLength < v)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (m.byteLength < v + (k || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let H;
    return v === void 0 && k === void 0 ? H = new Uint8Array(m) : k === void 0 ? H = new Uint8Array(m, v) : H = new Uint8Array(m, v, k), Object.setPrototypeOf(H, u.prototype), H;
  }
  function _(m) {
    if (u.isBuffer(m)) {
      const v = O(m.length) | 0, k = a(v);
      return k.length === 0 || m.copy(k, 0, 0, v), k;
    }
    if (m.length !== void 0)
      return typeof m.length != "number" || Zt(m.length) ? a(0) : b(m);
    if (m.type === "Buffer" && Array.isArray(m.data))
      return b(m.data);
  }
  function O(m) {
    if (m >= o)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + o.toString(16) + " bytes");
    return m | 0;
  }
  function C(m) {
    return +m != m && (m = 0), u.alloc(+m);
  }
  u.isBuffer = function(m) {
    return m != null && m._isBuffer === !0 && m !== u.prototype;
  }, u.compare = function(m, v) {
    if (yt(m, Uint8Array) && (m = u.from(m, m.offset, m.byteLength)), yt(v, Uint8Array) && (v = u.from(v, v.offset, v.byteLength)), !u.isBuffer(m) || !u.isBuffer(v))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (m === v) return 0;
    let k = m.length, H = v.length;
    for (let X = 0, oe = Math.min(k, H); X < oe; ++X)
      if (m[X] !== v[X]) {
        k = m[X], H = v[X];
        break;
      }
    return k < H ? -1 : H < k ? 1 : 0;
  }, u.isEncoding = function(m) {
    switch (String(m).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, u.concat = function(m, v) {
    if (!Array.isArray(m))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (m.length === 0)
      return u.alloc(0);
    let k;
    if (v === void 0)
      for (v = 0, k = 0; k < m.length; ++k)
        v += m[k].length;
    const H = u.allocUnsafe(v);
    let X = 0;
    for (k = 0; k < m.length; ++k) {
      let oe = m[k];
      if (yt(oe, Uint8Array))
        X + oe.length > H.length ? (u.isBuffer(oe) || (oe = u.from(oe)), oe.copy(H, X)) : Uint8Array.prototype.set.call(
          H,
          oe,
          X
        );
      else if (u.isBuffer(oe))
        oe.copy(H, X);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      X += oe.length;
    }
    return H;
  };
  function I(m, v) {
    if (u.isBuffer(m))
      return m.length;
    if (ArrayBuffer.isView(m) || yt(m, ArrayBuffer))
      return m.byteLength;
    if (typeof m != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof m
      );
    const k = m.length, H = arguments.length > 2 && arguments[2] === !0;
    if (!H && k === 0) return 0;
    let X = !1;
    for (; ; )
      switch (v) {
        case "ascii":
        case "latin1":
        case "binary":
          return k;
        case "utf8":
        case "utf-8":
          return He(m).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return k * 2;
        case "hex":
          return k >>> 1;
        case "base64":
          return Pt(m).length;
        default:
          if (X)
            return H ? -1 : He(m).length;
          v = ("" + v).toLowerCase(), X = !0;
      }
  }
  u.byteLength = I;
  function S(m, v, k) {
    let H = !1;
    if ((v === void 0 || v < 0) && (v = 0), v > this.length || ((k === void 0 || k > this.length) && (k = this.length), k <= 0) || (k >>>= 0, v >>>= 0, k <= v))
      return "";
    for (m || (m = "utf8"); ; )
      switch (m) {
        case "hex":
          return G(this, v, k);
        case "utf8":
        case "utf-8":
          return ne(this, v, k);
        case "ascii":
          return le(this, v, k);
        case "latin1":
        case "binary":
          return re(this, v, k);
        case "base64":
          return de(this, v, k);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return q(this, v, k);
        default:
          if (H) throw new TypeError("Unknown encoding: " + m);
          m = (m + "").toLowerCase(), H = !0;
      }
  }
  u.prototype._isBuffer = !0;
  function T(m, v, k) {
    const H = m[v];
    m[v] = m[k], m[k] = H;
  }
  u.prototype.swap16 = function() {
    const m = this.length;
    if (m % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let v = 0; v < m; v += 2)
      T(this, v, v + 1);
    return this;
  }, u.prototype.swap32 = function() {
    const m = this.length;
    if (m % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let v = 0; v < m; v += 4)
      T(this, v, v + 3), T(this, v + 1, v + 2);
    return this;
  }, u.prototype.swap64 = function() {
    const m = this.length;
    if (m % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let v = 0; v < m; v += 8)
      T(this, v, v + 7), T(this, v + 1, v + 6), T(this, v + 2, v + 5), T(this, v + 3, v + 4);
    return this;
  }, u.prototype.toString = function() {
    const m = this.length;
    return m === 0 ? "" : arguments.length === 0 ? ne(this, 0, m) : S.apply(this, arguments);
  }, u.prototype.toLocaleString = u.prototype.toString, u.prototype.equals = function(m) {
    if (!u.isBuffer(m)) throw new TypeError("Argument must be a Buffer");
    return this === m ? !0 : u.compare(this, m) === 0;
  }, u.prototype.inspect = function() {
    let m = "";
    const v = e.INSPECT_MAX_BYTES;
    return m = this.toString("hex", 0, v).replace(/(.{2})/g, "$1 ").trim(), this.length > v && (m += " ... "), "<Buffer " + m + ">";
  }, n && (u.prototype[n] = u.prototype.inspect), u.prototype.compare = function(m, v, k, H, X) {
    if (yt(m, Uint8Array) && (m = u.from(m, m.offset, m.byteLength)), !u.isBuffer(m))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof m
      );
    if (v === void 0 && (v = 0), k === void 0 && (k = m ? m.length : 0), H === void 0 && (H = 0), X === void 0 && (X = this.length), v < 0 || k > m.length || H < 0 || X > this.length)
      throw new RangeError("out of range index");
    if (H >= X && v >= k)
      return 0;
    if (H >= X)
      return -1;
    if (v >= k)
      return 1;
    if (v >>>= 0, k >>>= 0, H >>>= 0, X >>>= 0, this === m) return 0;
    let oe = X - H, me = k - v;
    const nt = Math.min(oe, me), Ct = this.slice(H, X), At = m.slice(v, k);
    for (let vt = 0; vt < nt; ++vt)
      if (Ct[vt] !== At[vt]) {
        oe = Ct[vt], me = At[vt];
        break;
      }
    return oe < me ? -1 : me < oe ? 1 : 0;
  };
  function A(m, v, k, H, X) {
    if (m.length === 0) return -1;
    if (typeof k == "string" ? (H = k, k = 0) : k > 2147483647 ? k = 2147483647 : k < -2147483648 && (k = -2147483648), k = +k, Zt(k) && (k = X ? 0 : m.length - 1), k < 0 && (k = m.length + k), k >= m.length) {
      if (X) return -1;
      k = m.length - 1;
    } else if (k < 0)
      if (X) k = 0;
      else return -1;
    if (typeof v == "string" && (v = u.from(v, H)), u.isBuffer(v))
      return v.length === 0 ? -1 : $(m, v, k, H, X);
    if (typeof v == "number")
      return v = v & 255, typeof Uint8Array.prototype.indexOf == "function" ? X ? Uint8Array.prototype.indexOf.call(m, v, k) : Uint8Array.prototype.lastIndexOf.call(m, v, k) : $(m, [v], k, H, X);
    throw new TypeError("val must be string, number or Buffer");
  }
  function $(m, v, k, H, X) {
    let oe = 1, me = m.length, nt = v.length;
    if (H !== void 0 && (H = String(H).toLowerCase(), H === "ucs2" || H === "ucs-2" || H === "utf16le" || H === "utf-16le")) {
      if (m.length < 2 || v.length < 2)
        return -1;
      oe = 2, me /= 2, nt /= 2, k /= 2;
    }
    function Ct(vt, Ht) {
      return oe === 1 ? vt[Ht] : vt.readUInt16BE(Ht * oe);
    }
    let At;
    if (X) {
      let vt = -1;
      for (At = k; At < me; At++)
        if (Ct(m, At) === Ct(v, vt === -1 ? 0 : At - vt)) {
          if (vt === -1 && (vt = At), At - vt + 1 === nt) return vt * oe;
        } else
          vt !== -1 && (At -= At - vt), vt = -1;
    } else
      for (k + nt > me && (k = me - nt), At = k; At >= 0; At--) {
        let vt = !0;
        for (let Ht = 0; Ht < nt; Ht++)
          if (Ct(m, At + Ht) !== Ct(v, Ht)) {
            vt = !1;
            break;
          }
        if (vt) return At;
      }
    return -1;
  }
  u.prototype.includes = function(m, v, k) {
    return this.indexOf(m, v, k) !== -1;
  }, u.prototype.indexOf = function(m, v, k) {
    return A(this, m, v, k, !0);
  }, u.prototype.lastIndexOf = function(m, v, k) {
    return A(this, m, v, k, !1);
  };
  function U(m, v, k, H) {
    k = Number(k) || 0;
    const X = m.length - k;
    H ? (H = Number(H), H > X && (H = X)) : H = X;
    const oe = v.length;
    H > oe / 2 && (H = oe / 2);
    let me;
    for (me = 0; me < H; ++me) {
      const nt = parseInt(v.substr(me * 2, 2), 16);
      if (Zt(nt)) return me;
      m[k + me] = nt;
    }
    return me;
  }
  function M(m, v, k, H) {
    return _t(He(v, m.length - k), m, k, H);
  }
  function Y(m, v, k, H) {
    return _t(mt(v), m, k, H);
  }
  function L(m, v, k, H) {
    return _t(Pt(v), m, k, H);
  }
  function ee(m, v, k, H) {
    return _t(rt(v, m.length - k), m, k, H);
  }
  u.prototype.write = function(m, v, k, H) {
    if (v === void 0)
      H = "utf8", k = this.length, v = 0;
    else if (k === void 0 && typeof v == "string")
      H = v, k = this.length, v = 0;
    else if (isFinite(v))
      v = v >>> 0, isFinite(k) ? (k = k >>> 0, H === void 0 && (H = "utf8")) : (H = k, k = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const X = this.length - v;
    if ((k === void 0 || k > X) && (k = X), m.length > 0 && (k < 0 || v < 0) || v > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    H || (H = "utf8");
    let oe = !1;
    for (; ; )
      switch (H) {
        case "hex":
          return U(this, m, v, k);
        case "utf8":
        case "utf-8":
          return M(this, m, v, k);
        case "ascii":
        case "latin1":
        case "binary":
          return Y(this, m, v, k);
        case "base64":
          return L(this, m, v, k);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ee(this, m, v, k);
        default:
          if (oe) throw new TypeError("Unknown encoding: " + H);
          H = ("" + H).toLowerCase(), oe = !0;
      }
  }, u.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function de(m, v, k) {
    return v === 0 && k === m.length ? t.fromByteArray(m) : t.fromByteArray(m.slice(v, k));
  }
  function ne(m, v, k) {
    k = Math.min(m.length, k);
    const H = [];
    let X = v;
    for (; X < k; ) {
      const oe = m[X];
      let me = null, nt = oe > 239 ? 4 : oe > 223 ? 3 : oe > 191 ? 2 : 1;
      if (X + nt <= k) {
        let Ct, At, vt, Ht;
        switch (nt) {
          case 1:
            oe < 128 && (me = oe);
            break;
          case 2:
            Ct = m[X + 1], (Ct & 192) === 128 && (Ht = (oe & 31) << 6 | Ct & 63, Ht > 127 && (me = Ht));
            break;
          case 3:
            Ct = m[X + 1], At = m[X + 2], (Ct & 192) === 128 && (At & 192) === 128 && (Ht = (oe & 15) << 12 | (Ct & 63) << 6 | At & 63, Ht > 2047 && (Ht < 55296 || Ht > 57343) && (me = Ht));
            break;
          case 4:
            Ct = m[X + 1], At = m[X + 2], vt = m[X + 3], (Ct & 192) === 128 && (At & 192) === 128 && (vt & 192) === 128 && (Ht = (oe & 15) << 18 | (Ct & 63) << 12 | (At & 63) << 6 | vt & 63, Ht > 65535 && Ht < 1114112 && (me = Ht));
        }
      }
      me === null ? (me = 65533, nt = 1) : me > 65535 && (me -= 65536, H.push(me >>> 10 & 1023 | 55296), me = 56320 | me & 1023), H.push(me), X += nt;
    }
    return K(H);
  }
  const D = 4096;
  function K(m) {
    const v = m.length;
    if (v <= D)
      return String.fromCharCode.apply(String, m);
    let k = "", H = 0;
    for (; H < v; )
      k += String.fromCharCode.apply(
        String,
        m.slice(H, H += D)
      );
    return k;
  }
  function le(m, v, k) {
    let H = "";
    k = Math.min(m.length, k);
    for (let X = v; X < k; ++X)
      H += String.fromCharCode(m[X] & 127);
    return H;
  }
  function re(m, v, k) {
    let H = "";
    k = Math.min(m.length, k);
    for (let X = v; X < k; ++X)
      H += String.fromCharCode(m[X]);
    return H;
  }
  function G(m, v, k) {
    const H = m.length;
    (!v || v < 0) && (v = 0), (!k || k < 0 || k > H) && (k = H);
    let X = "";
    for (let oe = v; oe < k; ++oe)
      X += yn[m[oe]];
    return X;
  }
  function q(m, v, k) {
    const H = m.slice(v, k);
    let X = "";
    for (let oe = 0; oe < H.length - 1; oe += 2)
      X += String.fromCharCode(H[oe] + H[oe + 1] * 256);
    return X;
  }
  u.prototype.slice = function(m, v) {
    const k = this.length;
    m = ~~m, v = v === void 0 ? k : ~~v, m < 0 ? (m += k, m < 0 && (m = 0)) : m > k && (m = k), v < 0 ? (v += k, v < 0 && (v = 0)) : v > k && (v = k), v < m && (v = m);
    const H = this.subarray(m, v);
    return Object.setPrototypeOf(H, u.prototype), H;
  };
  function Q(m, v, k) {
    if (m % 1 !== 0 || m < 0) throw new RangeError("offset is not uint");
    if (m + v > k) throw new RangeError("Trying to access beyond buffer length");
  }
  u.prototype.readUintLE = u.prototype.readUIntLE = function(m, v, k) {
    m = m >>> 0, v = v >>> 0, k || Q(m, v, this.length);
    let H = this[m], X = 1, oe = 0;
    for (; ++oe < v && (X *= 256); )
      H += this[m + oe] * X;
    return H;
  }, u.prototype.readUintBE = u.prototype.readUIntBE = function(m, v, k) {
    m = m >>> 0, v = v >>> 0, k || Q(m, v, this.length);
    let H = this[m + --v], X = 1;
    for (; v > 0 && (X *= 256); )
      H += this[m + --v] * X;
    return H;
  }, u.prototype.readUint8 = u.prototype.readUInt8 = function(m, v) {
    return m = m >>> 0, v || Q(m, 1, this.length), this[m];
  }, u.prototype.readUint16LE = u.prototype.readUInt16LE = function(m, v) {
    return m = m >>> 0, v || Q(m, 2, this.length), this[m] | this[m + 1] << 8;
  }, u.prototype.readUint16BE = u.prototype.readUInt16BE = function(m, v) {
    return m = m >>> 0, v || Q(m, 2, this.length), this[m] << 8 | this[m + 1];
  }, u.prototype.readUint32LE = u.prototype.readUInt32LE = function(m, v) {
    return m = m >>> 0, v || Q(m, 4, this.length), (this[m] | this[m + 1] << 8 | this[m + 2] << 16) + this[m + 3] * 16777216;
  }, u.prototype.readUint32BE = u.prototype.readUInt32BE = function(m, v) {
    return m = m >>> 0, v || Q(m, 4, this.length), this[m] * 16777216 + (this[m + 1] << 16 | this[m + 2] << 8 | this[m + 3]);
  }, u.prototype.readBigUInt64LE = kt(function(m) {
    m = m >>> 0, Ve(m, "offset");
    const v = this[m], k = this[m + 7];
    (v === void 0 || k === void 0) && ge(m, this.length - 8);
    const H = v + this[++m] * 2 ** 8 + this[++m] * 2 ** 16 + this[++m] * 2 ** 24, X = this[++m] + this[++m] * 2 ** 8 + this[++m] * 2 ** 16 + k * 2 ** 24;
    return BigInt(H) + (BigInt(X) << BigInt(32));
  }), u.prototype.readBigUInt64BE = kt(function(m) {
    m = m >>> 0, Ve(m, "offset");
    const v = this[m], k = this[m + 7];
    (v === void 0 || k === void 0) && ge(m, this.length - 8);
    const H = v * 2 ** 24 + this[++m] * 2 ** 16 + this[++m] * 2 ** 8 + this[++m], X = this[++m] * 2 ** 24 + this[++m] * 2 ** 16 + this[++m] * 2 ** 8 + k;
    return (BigInt(H) << BigInt(32)) + BigInt(X);
  }), u.prototype.readIntLE = function(m, v, k) {
    m = m >>> 0, v = v >>> 0, k || Q(m, v, this.length);
    let H = this[m], X = 1, oe = 0;
    for (; ++oe < v && (X *= 256); )
      H += this[m + oe] * X;
    return X *= 128, H >= X && (H -= Math.pow(2, 8 * v)), H;
  }, u.prototype.readIntBE = function(m, v, k) {
    m = m >>> 0, v = v >>> 0, k || Q(m, v, this.length);
    let H = v, X = 1, oe = this[m + --H];
    for (; H > 0 && (X *= 256); )
      oe += this[m + --H] * X;
    return X *= 128, oe >= X && (oe -= Math.pow(2, 8 * v)), oe;
  }, u.prototype.readInt8 = function(m, v) {
    return m = m >>> 0, v || Q(m, 1, this.length), this[m] & 128 ? (255 - this[m] + 1) * -1 : this[m];
  }, u.prototype.readInt16LE = function(m, v) {
    m = m >>> 0, v || Q(m, 2, this.length);
    const k = this[m] | this[m + 1] << 8;
    return k & 32768 ? k | 4294901760 : k;
  }, u.prototype.readInt16BE = function(m, v) {
    m = m >>> 0, v || Q(m, 2, this.length);
    const k = this[m + 1] | this[m] << 8;
    return k & 32768 ? k | 4294901760 : k;
  }, u.prototype.readInt32LE = function(m, v) {
    return m = m >>> 0, v || Q(m, 4, this.length), this[m] | this[m + 1] << 8 | this[m + 2] << 16 | this[m + 3] << 24;
  }, u.prototype.readInt32BE = function(m, v) {
    return m = m >>> 0, v || Q(m, 4, this.length), this[m] << 24 | this[m + 1] << 16 | this[m + 2] << 8 | this[m + 3];
  }, u.prototype.readBigInt64LE = kt(function(m) {
    m = m >>> 0, Ve(m, "offset");
    const v = this[m], k = this[m + 7];
    (v === void 0 || k === void 0) && ge(m, this.length - 8);
    const H = this[m + 4] + this[m + 5] * 2 ** 8 + this[m + 6] * 2 ** 16 + (k << 24);
    return (BigInt(H) << BigInt(32)) + BigInt(v + this[++m] * 2 ** 8 + this[++m] * 2 ** 16 + this[++m] * 2 ** 24);
  }), u.prototype.readBigInt64BE = kt(function(m) {
    m = m >>> 0, Ve(m, "offset");
    const v = this[m], k = this[m + 7];
    (v === void 0 || k === void 0) && ge(m, this.length - 8);
    const H = (v << 24) + // Overflow
    this[++m] * 2 ** 16 + this[++m] * 2 ** 8 + this[++m];
    return (BigInt(H) << BigInt(32)) + BigInt(this[++m] * 2 ** 24 + this[++m] * 2 ** 16 + this[++m] * 2 ** 8 + k);
  }), u.prototype.readFloatLE = function(m, v) {
    return m = m >>> 0, v || Q(m, 4, this.length), r.read(this, m, !0, 23, 4);
  }, u.prototype.readFloatBE = function(m, v) {
    return m = m >>> 0, v || Q(m, 4, this.length), r.read(this, m, !1, 23, 4);
  }, u.prototype.readDoubleLE = function(m, v) {
    return m = m >>> 0, v || Q(m, 8, this.length), r.read(this, m, !0, 52, 8);
  }, u.prototype.readDoubleBE = function(m, v) {
    return m = m >>> 0, v || Q(m, 8, this.length), r.read(this, m, !1, 52, 8);
  };
  function se(m, v, k, H, X, oe) {
    if (!u.isBuffer(m)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (v > X || v < oe) throw new RangeError('"value" argument is out of bounds');
    if (k + H > m.length) throw new RangeError("Index out of range");
  }
  u.prototype.writeUintLE = u.prototype.writeUIntLE = function(m, v, k, H) {
    if (m = +m, v = v >>> 0, k = k >>> 0, !H) {
      const me = Math.pow(2, 8 * k) - 1;
      se(this, m, v, k, me, 0);
    }
    let X = 1, oe = 0;
    for (this[v] = m & 255; ++oe < k && (X *= 256); )
      this[v + oe] = m / X & 255;
    return v + k;
  }, u.prototype.writeUintBE = u.prototype.writeUIntBE = function(m, v, k, H) {
    if (m = +m, v = v >>> 0, k = k >>> 0, !H) {
      const me = Math.pow(2, 8 * k) - 1;
      se(this, m, v, k, me, 0);
    }
    let X = k - 1, oe = 1;
    for (this[v + X] = m & 255; --X >= 0 && (oe *= 256); )
      this[v + X] = m / oe & 255;
    return v + k;
  }, u.prototype.writeUint8 = u.prototype.writeUInt8 = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 1, 255, 0), this[v] = m & 255, v + 1;
  }, u.prototype.writeUint16LE = u.prototype.writeUInt16LE = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 2, 65535, 0), this[v] = m & 255, this[v + 1] = m >>> 8, v + 2;
  }, u.prototype.writeUint16BE = u.prototype.writeUInt16BE = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 2, 65535, 0), this[v] = m >>> 8, this[v + 1] = m & 255, v + 2;
  }, u.prototype.writeUint32LE = u.prototype.writeUInt32LE = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 4, 4294967295, 0), this[v + 3] = m >>> 24, this[v + 2] = m >>> 16, this[v + 1] = m >>> 8, this[v] = m & 255, v + 4;
  }, u.prototype.writeUint32BE = u.prototype.writeUInt32BE = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 4, 4294967295, 0), this[v] = m >>> 24, this[v + 1] = m >>> 16, this[v + 2] = m >>> 8, this[v + 3] = m & 255, v + 4;
  };
  function J(m, v, k, H, X) {
    Ne(v, H, X, m, k, 7);
    let oe = Number(v & BigInt(4294967295));
    m[k++] = oe, oe = oe >> 8, m[k++] = oe, oe = oe >> 8, m[k++] = oe, oe = oe >> 8, m[k++] = oe;
    let me = Number(v >> BigInt(32) & BigInt(4294967295));
    return m[k++] = me, me = me >> 8, m[k++] = me, me = me >> 8, m[k++] = me, me = me >> 8, m[k++] = me, k;
  }
  function ye(m, v, k, H, X) {
    Ne(v, H, X, m, k, 7);
    let oe = Number(v & BigInt(4294967295));
    m[k + 7] = oe, oe = oe >> 8, m[k + 6] = oe, oe = oe >> 8, m[k + 5] = oe, oe = oe >> 8, m[k + 4] = oe;
    let me = Number(v >> BigInt(32) & BigInt(4294967295));
    return m[k + 3] = me, me = me >> 8, m[k + 2] = me, me = me >> 8, m[k + 1] = me, me = me >> 8, m[k] = me, k + 8;
  }
  u.prototype.writeBigUInt64LE = kt(function(m, v = 0) {
    return J(this, m, v, BigInt(0), BigInt("0xffffffffffffffff"));
  }), u.prototype.writeBigUInt64BE = kt(function(m, v = 0) {
    return ye(this, m, v, BigInt(0), BigInt("0xffffffffffffffff"));
  }), u.prototype.writeIntLE = function(m, v, k, H) {
    if (m = +m, v = v >>> 0, !H) {
      const nt = Math.pow(2, 8 * k - 1);
      se(this, m, v, k, nt - 1, -nt);
    }
    let X = 0, oe = 1, me = 0;
    for (this[v] = m & 255; ++X < k && (oe *= 256); )
      m < 0 && me === 0 && this[v + X - 1] !== 0 && (me = 1), this[v + X] = (m / oe >> 0) - me & 255;
    return v + k;
  }, u.prototype.writeIntBE = function(m, v, k, H) {
    if (m = +m, v = v >>> 0, !H) {
      const nt = Math.pow(2, 8 * k - 1);
      se(this, m, v, k, nt - 1, -nt);
    }
    let X = k - 1, oe = 1, me = 0;
    for (this[v + X] = m & 255; --X >= 0 && (oe *= 256); )
      m < 0 && me === 0 && this[v + X + 1] !== 0 && (me = 1), this[v + X] = (m / oe >> 0) - me & 255;
    return v + k;
  }, u.prototype.writeInt8 = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 1, 127, -128), m < 0 && (m = 255 + m + 1), this[v] = m & 255, v + 1;
  }, u.prototype.writeInt16LE = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 2, 32767, -32768), this[v] = m & 255, this[v + 1] = m >>> 8, v + 2;
  }, u.prototype.writeInt16BE = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 2, 32767, -32768), this[v] = m >>> 8, this[v + 1] = m & 255, v + 2;
  }, u.prototype.writeInt32LE = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 4, 2147483647, -2147483648), this[v] = m & 255, this[v + 1] = m >>> 8, this[v + 2] = m >>> 16, this[v + 3] = m >>> 24, v + 4;
  }, u.prototype.writeInt32BE = function(m, v, k) {
    return m = +m, v = v >>> 0, k || se(this, m, v, 4, 2147483647, -2147483648), m < 0 && (m = 4294967295 + m + 1), this[v] = m >>> 24, this[v + 1] = m >>> 16, this[v + 2] = m >>> 8, this[v + 3] = m & 255, v + 4;
  }, u.prototype.writeBigInt64LE = kt(function(m, v = 0) {
    return J(this, m, v, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), u.prototype.writeBigInt64BE = kt(function(m, v = 0) {
    return ye(this, m, v, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function ve(m, v, k, H, X, oe) {
    if (k + H > m.length) throw new RangeError("Index out of range");
    if (k < 0) throw new RangeError("Index out of range");
  }
  function Ee(m, v, k, H, X) {
    return v = +v, k = k >>> 0, X || ve(m, v, k, 4), r.write(m, v, k, H, 23, 4), k + 4;
  }
  u.prototype.writeFloatLE = function(m, v, k) {
    return Ee(this, m, v, !0, k);
  }, u.prototype.writeFloatBE = function(m, v, k) {
    return Ee(this, m, v, !1, k);
  };
  function _e(m, v, k, H, X) {
    return v = +v, k = k >>> 0, X || ve(m, v, k, 8), r.write(m, v, k, H, 52, 8), k + 8;
  }
  u.prototype.writeDoubleLE = function(m, v, k) {
    return _e(this, m, v, !0, k);
  }, u.prototype.writeDoubleBE = function(m, v, k) {
    return _e(this, m, v, !1, k);
  }, u.prototype.copy = function(m, v, k, H) {
    if (!u.isBuffer(m)) throw new TypeError("argument should be a Buffer");
    if (k || (k = 0), !H && H !== 0 && (H = this.length), v >= m.length && (v = m.length), v || (v = 0), H > 0 && H < k && (H = k), H === k || m.length === 0 || this.length === 0) return 0;
    if (v < 0)
      throw new RangeError("targetStart out of bounds");
    if (k < 0 || k >= this.length) throw new RangeError("Index out of range");
    if (H < 0) throw new RangeError("sourceEnd out of bounds");
    H > this.length && (H = this.length), m.length - v < H - k && (H = m.length - v + k);
    const X = H - k;
    return this === m && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(v, k, H) : Uint8Array.prototype.set.call(
      m,
      this.subarray(k, H),
      v
    ), X;
  }, u.prototype.fill = function(m, v, k, H) {
    if (typeof m == "string") {
      if (typeof v == "string" ? (H = v, v = 0, k = this.length) : typeof k == "string" && (H = k, k = this.length), H !== void 0 && typeof H != "string")
        throw new TypeError("encoding must be a string");
      if (typeof H == "string" && !u.isEncoding(H))
        throw new TypeError("Unknown encoding: " + H);
      if (m.length === 1) {
        const oe = m.charCodeAt(0);
        (H === "utf8" && oe < 128 || H === "latin1") && (m = oe);
      }
    } else typeof m == "number" ? m = m & 255 : typeof m == "boolean" && (m = Number(m));
    if (v < 0 || this.length < v || this.length < k)
      throw new RangeError("Out of range index");
    if (k <= v)
      return this;
    v = v >>> 0, k = k === void 0 ? this.length : k >>> 0, m || (m = 0);
    let X;
    if (typeof m == "number")
      for (X = v; X < k; ++X)
        this[X] = m;
    else {
      const oe = u.isBuffer(m) ? m : u.from(m, H), me = oe.length;
      if (me === 0)
        throw new TypeError('The value "' + m + '" is invalid for argument "value"');
      for (X = 0; X < k - v; ++X)
        this[X + v] = oe[X % me];
    }
    return this;
  };
  const we = {};
  function be(m, v, k) {
    we[m] = class extends k {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: v.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${m}]`, this.stack, delete this.name;
      }
      get code() {
        return m;
      }
      set code(H) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: H,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${m}]: ${this.message}`;
      }
    };
  }
  be(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(m) {
      return m ? `${m} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), be(
    "ERR_INVALID_ARG_TYPE",
    function(m, v) {
      return `The "${m}" argument must be of type number. Received type ${typeof v}`;
    },
    TypeError
  ), be(
    "ERR_OUT_OF_RANGE",
    function(m, v, k) {
      let H = `The value of "${m}" is out of range.`, X = k;
      return Number.isInteger(k) && Math.abs(k) > 2 ** 32 ? X = Ge(String(k)) : typeof k == "bigint" && (X = String(k), (k > BigInt(2) ** BigInt(32) || k < -(BigInt(2) ** BigInt(32))) && (X = Ge(X)), X += "n"), H += ` It must be ${v}. Received ${X}`, H;
    },
    RangeError
  );
  function Ge(m) {
    let v = "", k = m.length;
    const H = m[0] === "-" ? 1 : 0;
    for (; k >= H + 4; k -= 3)
      v = `_${m.slice(k - 3, k)}${v}`;
    return `${m.slice(0, k)}${v}`;
  }
  function Le(m, v, k) {
    Ve(v, "offset"), (m[v] === void 0 || m[v + k] === void 0) && ge(v, m.length - (k + 1));
  }
  function Ne(m, v, k, H, X, oe) {
    if (m > k || m < v) {
      const me = typeof v == "bigint" ? "n" : "";
      let nt;
      throw v === 0 || v === BigInt(0) ? nt = `>= 0${me} and < 2${me} ** ${(oe + 1) * 8}${me}` : nt = `>= -(2${me} ** ${(oe + 1) * 8 - 1}${me}) and < 2 ** ${(oe + 1) * 8 - 1}${me}`, new we.ERR_OUT_OF_RANGE("value", nt, m);
    }
    Le(H, X, oe);
  }
  function Ve(m, v) {
    if (typeof m != "number")
      throw new we.ERR_INVALID_ARG_TYPE(v, "number", m);
  }
  function ge(m, v, k) {
    throw Math.floor(m) !== m ? (Ve(m, k), new we.ERR_OUT_OF_RANGE("offset", "an integer", m)) : v < 0 ? new we.ERR_BUFFER_OUT_OF_BOUNDS() : new we.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${v}`,
      m
    );
  }
  const Te = /[^+/0-9A-Za-z-_]/g;
  function Oe(m) {
    if (m = m.split("=")[0], m = m.trim().replace(Te, ""), m.length < 2) return "";
    for (; m.length % 4 !== 0; )
      m = m + "=";
    return m;
  }
  function He(m, v) {
    v = v || 1 / 0;
    let k;
    const H = m.length;
    let X = null;
    const oe = [];
    for (let me = 0; me < H; ++me) {
      if (k = m.charCodeAt(me), k > 55295 && k < 57344) {
        if (!X) {
          if (k > 56319) {
            (v -= 3) > -1 && oe.push(239, 191, 189);
            continue;
          } else if (me + 1 === H) {
            (v -= 3) > -1 && oe.push(239, 191, 189);
            continue;
          }
          X = k;
          continue;
        }
        if (k < 56320) {
          (v -= 3) > -1 && oe.push(239, 191, 189), X = k;
          continue;
        }
        k = (X - 55296 << 10 | k - 56320) + 65536;
      } else X && (v -= 3) > -1 && oe.push(239, 191, 189);
      if (X = null, k < 128) {
        if ((v -= 1) < 0) break;
        oe.push(k);
      } else if (k < 2048) {
        if ((v -= 2) < 0) break;
        oe.push(
          k >> 6 | 192,
          k & 63 | 128
        );
      } else if (k < 65536) {
        if ((v -= 3) < 0) break;
        oe.push(
          k >> 12 | 224,
          k >> 6 & 63 | 128,
          k & 63 | 128
        );
      } else if (k < 1114112) {
        if ((v -= 4) < 0) break;
        oe.push(
          k >> 18 | 240,
          k >> 12 & 63 | 128,
          k >> 6 & 63 | 128,
          k & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return oe;
  }
  function mt(m) {
    const v = [];
    for (let k = 0; k < m.length; ++k)
      v.push(m.charCodeAt(k) & 255);
    return v;
  }
  function rt(m, v) {
    let k, H, X;
    const oe = [];
    for (let me = 0; me < m.length && !((v -= 2) < 0); ++me)
      k = m.charCodeAt(me), H = k >> 8, X = k % 256, oe.push(X), oe.push(H);
    return oe;
  }
  function Pt(m) {
    return t.toByteArray(Oe(m));
  }
  function _t(m, v, k, H) {
    let X;
    for (X = 0; X < H && !(X + k >= v.length || X >= m.length); ++X)
      v[X + k] = m[X];
    return X;
  }
  function yt(m, v) {
    return m instanceof v || m != null && m.constructor != null && m.constructor.name != null && m.constructor.name === v.name;
  }
  function Zt(m) {
    return m !== m;
  }
  const yn = function() {
    const m = "0123456789abcdef", v = new Array(256);
    for (let k = 0; k < 16; ++k) {
      const H = k * 16;
      for (let X = 0; X < 16; ++X)
        v[H + X] = m[k] + m[X];
    }
    return v;
  }();
  function kt(m) {
    return typeof BigInt > "u" ? qr : m;
  }
  function qr() {
    throw new Error("BigInt not supported");
  }
})(OCe);
var Aa = /* @__PURE__ */ ((e) => (e.Mainnet = "Mainnet", e.Testnet = "Testnet", e.Testnet4 = "Testnet4", e.Signet = "Signet", e.Regtest = "Regtest", e))(Aa || {}), o$ = tr(Av([Re(), lo(), qi()])), Xr = je({
  jsonrpc: Er("2.0"),
  method: Re(),
  params: tr(
    Av([
      Zo(WE()),
      EY({}),
      // Note: This is to support current incorrect usage of RPC 2.0. Params need
      // to be either an array or an object when provided. Changing this now would
      // be a breaking change, so accepting null values for now. Tracking in
      // https://linear.app/xverseapp/issue/ENG-4538.
      qi()
    ])
  ),
  id: ZPe(o$)
}), g1 = /* @__PURE__ */ ((e) => (e[e.PARSE_ERROR = -32700] = "PARSE_ERROR", e[e.INVALID_REQUEST = -32600] = "INVALID_REQUEST", e[e.METHOD_NOT_FOUND = -32601] = "METHOD_NOT_FOUND", e[e.INVALID_PARAMS = -32602] = "INVALID_PARAMS", e[e.INTERNAL_ERROR = -32603] = "INTERNAL_ERROR", e[e.USER_REJECTION = -32e3] = "USER_REJECTION", e[e.METHOD_NOT_SUPPORTED = -32001] = "METHOD_NOT_SUPPORTED", e[e.ACCESS_DENIED = -32002] = "ACCESS_DENIED", e))(g1 || {}), LY = je({
  jsonrpc: Er("2.0"),
  result: e$(WE()),
  id: o$
}), HY = je({
  jsonrpc: Er("2.0"),
  error: e$(WE()),
  id: o$
});
Av([
  LY,
  HY
]);
var PCe = "accountChange";
je({
  type: Er(PCe)
});
var CCe = "networkChange";
je({
  type: Er(CCe),
  bitcoin: je({
    name: ps(Aa)
  }),
  stacks: je({
    name: Re()
  })
});
var BCe = "disconnect";
je({
  type: Er(BCe)
});
async function QE(e) {
  var t;
  const r = await (e == null ? void 0 : e()) || ((t = window.XverseProviders) == null ? void 0 : t.BitcoinProvider) || window.BitcoinProvider;
  if (!r)
    throw new Error("No Bitcoin wallet installed");
  return r;
}
var NCe = "stx_callContract", $Ce = je({
  /**
   * The contract principal.
   *
   * E.g. `"SPKE...GD5C.my-contract"`
   */
  contract: Re(),
  /**
   * The name of the function to call.
   *
   * Note: spec changes ongoing,
   * https://github.com/stacksgov/sips/pull/166#pullrequestreview-1914236999
   */
  functionName: Re(),
  /**
   * The function's arguments. The arguments are expected to be hex-encoded
   * strings of Clarity values.
   *
   * To convert Clarity values to their hex representation, the `cvToHex`
   * helper from the `@stacks/transactions` package may be helpful.
   *
   * ```js
   * import { cvToHex } from '@stacks/transactions';
   *
   * const functionArgs = [someClarityValue1, someClarityValue2];
   * const hexArgs = functionArgs.map(cvToHex);
   * ```
   */
  arguments: tr(Zo(Re()))
});
je({
  ...Xr.entries,
  ...je({
    method: Er(NCe),
    params: $Ce,
    id: Re()
  }).entries
});
var UCe = "stx_deployContract", RCe = je({
  /**
   * Name of the contract.
   */
  name: Re(),
  /**
   * The source code of the Clarity contract.
   */
  clarityCode: Re(),
  /**
   * The version of the Clarity contract.
   */
  clarityVersion: tr(Re())
});
je({
  ...Xr.entries,
  ...je({
    method: Er(UCe),
    params: RCe,
    id: Re()
  }).entries
});
var zCe = ["software", "ledger", "keystone"], FY = _Y(zCe), b0 = /* @__PURE__ */ ((e) => (e.Ordinals = "ordinals", e.Payment = "payment", e.Stacks = "stacks", e))(b0 || {}), MY = /* @__PURE__ */ ((e) => (e.p2pkh = "p2pkh", e.p2sh = "p2sh", e.p2wpkh = "p2wpkh", e.p2wsh = "p2wsh", e.p2tr = "p2tr", e.stacks = "stacks", e))(MY || {}), jCe = je({
  address: Re(),
  publicKey: Re(),
  purpose: ps(b0),
  addressType: ps(MY),
  walletType: FY
}), LCe = async (e) => {
  var t, r;
  const n = await QE(e.getProvider), { purposes: o } = e.payload;
  if (!o)
    throw new Error("Address purposes are required");
  try {
    const i = vs.createUnsecuredToken(e.payload), a = await n.connect(i);
    (t = e.onFinish) == null || t.call(e, a);
  } catch (i) {
    console.error("[Connect] Error during address request", i), (r = e.onCancel) == null || r.call(e);
  }
}, HCe = je({
  read: tr(L0())
}), FCe = je({
  readNetwork: tr(L0())
}), MCe = je({
  type: Er("account"),
  resourceId: Re(),
  clientId: Re(),
  actions: HCe
}), DCe = je({
  type: Er("wallet"),
  resourceId: Re(),
  clientId: Re(),
  actions: FCe
}), DY = xY("type", [
  je({
    ...Uj(MCe, ["clientId"]).entries
  }),
  je({
    ...Uj(DCe, ["clientId"]).entries
  })
]), KCe = "wallet_requestPermissions", qCe = ui(Zo(DY));
Er(!0);
je({
  ...Xr.entries,
  ...je({
    method: Er(KCe),
    params: qCe,
    id: Re()
  }).entries
});
var VCe = "wallet_renouncePermissions", GCe = ui(qi());
ui(qi());
je({
  ...Xr.entries,
  ...je({
    method: Er(VCe),
    params: GCe,
    id: Re()
  }).entries
});
var WCe = "wallet_disconnect", ZCe = ui(qi());
ui(qi());
je({
  ...Xr.entries,
  ...je({
    method: Er(WCe),
    params: ZCe,
    id: Re()
  }).entries
});
var XCe = "wallet_getWalletType", YCe = ui(qi());
je({
  ...Xr.entries,
  ...je({
    method: Er(XCe),
    params: YCe,
    id: Re()
  }).entries
});
var JCe = "wallet_getCurrentPermissions", QCe = ui(qi());
je({
  ...Xr.entries,
  ...je({
    method: Er(JCe),
    params: QCe,
    id: Re()
  }).entries
});
var eBe = "wallet_getNetwork", tBe = ui(qi());
je({
  bitcoin: je({
    name: ps(Aa)
  }),
  stacks: je({
    name: Re()
  })
});
je({
  ...Xr.entries,
  ...je({
    method: Er(eBe),
    params: tBe,
    id: Re()
  }).entries
});
var rBe = "wallet_changeNetwork", nBe = je({
  name: ps(Aa)
});
ui(qi());
je({
  ...Xr.entries,
  ...je({
    method: Er(rBe),
    params: nBe,
    id: Re()
  }).entries
});
var oBe = "wallet_getAccount", iBe = ui(qi());
je({
  ...Xr.entries,
  ...je({
    method: Er(oBe),
    params: iBe,
    id: Re()
  }).entries
});
var aBe = "wallet_connect", sBe = ui(
  je({
    permissions: tr(Zo(DY)),
    addresses: tr(Zo(ps(b0))),
    message: tr(
      xP(Re(), bY(80, "The message must not exceed 80 characters."))
    )
  })
);
je({
  ...Xr.entries,
  ...je({
    method: Er(aBe),
    params: sBe,
    id: Re()
  }).entries
});
var uBe = "stx_getAccounts", cBe = ui(qi());
je({
  ...Xr.entries,
  ...je({
    method: Er(uBe),
    params: cBe,
    id: Re()
  }).entries
});
var lBe = "stx_getAddresses", fBe = ui(
  je({
    /**
     * A message to be displayed to the user in the request prompt.
     */
    message: tr(Re())
  })
);
je({
  ...Xr.entries,
  ...je({
    method: Er(lBe),
    params: fBe,
    id: Re()
  }).entries
});
var dBe = "stx_signMessage", hBe = je({
  /**
   * The message to sign.
   */
  message: Re(),
  /**
   * The public key to sign the message with.
   */
  publicKey: Re(),
  /**
   * The format version of the parameter.
   */
  parameterFormatVersion: tr(lo())
});
je({
  ...Xr.entries,
  ...je({
    method: Er(dBe),
    params: hBe,
    id: Re()
  }).entries
});
var pBe = "stx_signStructuredMessage", gBe = je({
  /**
   * The domain to be signed.
   */
  domain: Re(),
  /**
   * Message payload to be signed.
   */
  message: Re(),
  /**
   * The format version of the parameter.
   */
  parameterFormatVersion: tr(lo()),
  /**
   * The public key to sign the message with.
   */
  publicKey: tr(Re())
});
je({
  ...Xr.entries,
  ...je({
    method: Er(pBe),
    params: gBe,
    id: Re()
  }).entries
});
var mBe = "stx_signTransaction", yBe = je({
  /**
   * The transaction to sign as a hex-encoded string.
   */
  transaction: Re(),
  /**
   * The public key to sign the transaction with. The wallet may use any key
   * when not provided.
   */
  pubkey: tr(Re()),
  /**
   * Whether to broadcast the transaction after signing. Defaults to `true`.
   */
  broadcast: tr(L0())
});
je({
  ...Xr.entries,
  ...je({
    method: Er(mBe),
    params: yBe,
    id: Re()
  }).entries
});
var bBe = "stx_signTransactions", wBe = je({
  /**
   * The transactions to sign as hex-encoded strings.
   */
  transactions: xP(
    Zo(
      xP(
        Re(),
        yY((e) => !0, "Invalid hex-encoded Stacks transaction.")
      )
    ),
    wY(1)
  ),
  /**
   * Whether the signed transactions should be broadcast after signing. Defaults
   * to `true`.
   */
  broadcast: tr(L0())
});
je({
  ...Xr.entries,
  ...je({
    method: Er(bBe),
    params: wBe,
    id: Re()
  }).entries
});
var vBe = "stx_transferStx", EBe = je({
  /**
   * Amount of STX tokens to transfer in microstacks as a string. Anything
   * parseable by `BigInt` is acceptable.
   *
   * Example,
   *
   * ```js
   * const amount1 = 1234;
   * const amount2 = 1234n;
   * const amount3 = '1234';
   * ```
   */
  amount: Av([lo(), Re()]),
  /**
   * The recipeint's principal.
   */
  recipient: Re(),
  /**
   * A string representing the memo.
   */
  memo: tr(Re()),
  /**
   * Version of parameter format.
   */
  version: tr(Re()),
  /**
   * The mode of the post conditions.
   */
  postConditionMode: tr(lo()),
  /**
   * A hex-encoded string representing the post conditions.
   *
   * A post condition may be converted to it's hex representation using the `serializePostCondition` helper from the `@stacks/transactions` package,
   *
   * ```js
   * import { serializePostCondition } from '@stacks/transactions';
   *
   * const postCondition = somePostCondition;
   * const hexPostCondition = serializePostCondition(postCondition).toString('hex');
   * ```
   */
  postConditions: tr(Zo(Re())),
  /**
   * The public key to sign the transaction with. The wallet may use any key
   * when not provided.
   */
  pubkey: tr(Re())
});
je({
  ...Xr.entries,
  ...je({
    method: Er(vBe),
    params: EBe,
    id: Re()
  }).entries
});
var _Be = "getInfo", ABe = ui(qi());
je({
  /**
   * Version of the wallet.
   */
  version: Re(),
  /**
   * [WBIP](https://wbips.netlify.app/wbips/WBIP002) methods supported by the wallet.
   */
  methods: tr(Zo(Re())),
  /**
   * List of WBIP standards supported by the wallet. Not currently used.
   */
  supports: Zo(Re())
});
je({
  ...Xr.entries,
  ...je({
    method: Er(_Be),
    params: ABe,
    id: Re()
  }).entries
});
var xBe = "getAddresses", kBe = je({
  /**
   * The purposes for which to generate addresses. See
   * {@linkcode AddressPurpose} for available purposes.
   */
  purposes: Zo(ps(b0)),
  /**
   * A message to be displayed to the user in the request prompt.
   */
  message: tr(Re())
});
je({
  ...Xr.entries,
  ...je({
    method: Er(xBe),
    params: kBe,
    id: Re()
  }).entries
});
var SBe = "signMessage", w0 = /* @__PURE__ */ ((e) => (e.ECDSA = "ECDSA", e.BIP322 = "BIP322", e))(w0 || {}), TBe = je({
  /**
   * The address used for signing.
   **/
  address: Re(),
  /**
   * The message to sign.
   **/
  message: Re(),
  /**
   * The protocol to use for signing the message.
   */
  protocol: tr(ps(w0))
});
je({
  /**
   * The signature of the message.
   */
  signature: Re(),
  /**
   * hash of the message.
   */
  messageHash: Re(),
  /**
   * The address used for signing.
   */
  address: Re(),
  /**
   * The protocol to use for signing the message.
   */
  protocol: ps(w0)
});
je({
  ...Xr.entries,
  ...je({
    method: Er(SBe),
    params: TBe,
    id: Re()
  }).entries
});
var IBe = "sendTransfer", OBe = je({
  /**
   * Array of recipients to send to.
   * The amount to send to each recipient is in satoshis.
   */
  recipients: Zo(
    je({
      address: Re(),
      amount: lo()
    })
  )
});
je({
  ...Xr.entries,
  ...je({
    method: Er(IBe),
    params: OBe,
    id: Re()
  }).entries
});
var PBe = "signPsbt", CBe = je({
  /**
   * The base64 encoded PSBT to sign.
   */
  psbt: Re(),
  /**
   * The inputs to sign.
   * The key is the address and the value is an array of indexes of the inputs to sign.
   */
  signInputs: AY(Re(), Zo(lo())),
  /**
   * Whether to broadcast the transaction after signing.
   **/
  broadcast: tr(L0())
});
je({
  /**
   * The base64 encoded PSBT after signing.
   */
  psbt: Re(),
  /**
   * The transaction id as a hex-encoded string.
   * This is only returned if the transaction was broadcast.
   **/
  txid: tr(Re())
});
je({
  ...Xr.entries,
  ...je({
    method: Er(PBe),
    params: CBe,
    id: Re()
  }).entries
});
var BBe = "getAccounts", NBe = je({
  /**
   * The purposes for which to generate addresses. See
   * {@linkcode AddressPurpose} for available purposes.
   */
  purposes: Zo(ps(b0)),
  /**
   * A message to be displayed to the user in the request prompt.
   */
  message: tr(Re())
});
Zo(
  je({
    ...jCe.entries,
    ...je({
      walletType: FY
    }).entries
  })
);
je({
  ...Xr.entries,
  ...je({
    method: Er(BBe),
    params: NBe,
    id: Re()
  }).entries
});
var $Be = "getBalance";
ui(qi());
je({
  ...Xr.entries,
  ...je({
    method: Er($Be),
    id: Re()
  }).entries
});
var UBe = "runes_etch", RBe = je({
  amount: Re(),
  cap: Re(),
  heightStart: tr(Re()),
  heightEnd: tr(Re()),
  offsetStart: tr(Re()),
  offsetEnd: tr(Re())
}), zBe = je({
  contentType: Re(),
  contentBase64: Re()
}), jBe = je({
  runeName: Re(),
  divisibility: tr(lo()),
  symbol: tr(Re()),
  premine: tr(Re()),
  isMintable: L0(),
  delegateInscriptionId: tr(Re()),
  destinationAddress: Re(),
  refundAddress: Re(),
  feeRate: lo(),
  appServiceFee: tr(lo()),
  appServiceFeeAddress: tr(Re()),
  terms: tr(RBe),
  inscriptionDetails: tr(zBe),
  network: tr(ps(Aa))
});
je({
  ...Xr.entries,
  ...je({
    method: Er(UBe),
    params: jBe,
    id: Re()
  }).entries
});
var LBe = "runes_getBalance", HBe = ui(qi());
je({
  balances: Zo(
    je({
      runeName: Re(),
      amount: Re(),
      divisibility: lo(),
      symbol: Re(),
      inscriptionId: ui(Re())
    })
  )
});
je({
  ...Xr.entries,
  ...je({
    method: Er(LBe),
    params: HBe,
    id: Re()
  }).entries
});
var FBe = "runes_mint", MBe = je({
  appServiceFee: tr(lo()),
  appServiceFeeAddress: tr(Re()),
  destinationAddress: Re(),
  feeRate: lo(),
  refundAddress: Re(),
  repeats: lo(),
  runeName: Re(),
  network: tr(ps(Aa))
});
je({
  ...Xr.entries,
  ...je({
    method: Er(FBe),
    params: MBe,
    id: Re()
  }).entries
});
var DBe = "runes_transfer", KBe = je({
  recipients: Zo(
    je({
      runeName: Re(),
      amount: Re(),
      address: Re()
    })
  )
});
je({
  ...Xr.entries,
  ...je({
    method: Er(DBe),
    params: KBe,
    id: Re()
  }).entries
});
var qBe = "ord_getInscriptions", VBe = je({
  offset: lo(),
  limit: lo()
});
je({
  total: lo(),
  limit: lo(),
  offset: lo(),
  inscriptions: Zo(
    je({
      inscriptionId: Re(),
      inscriptionNumber: Re(),
      address: Re(),
      collectionName: tr(Re()),
      postage: Re(),
      contentLength: Re(),
      contentType: Re(),
      timestamp: lo(),
      offset: lo(),
      genesisTransaction: Re(),
      output: Re()
    })
  )
});
je({
  ...Xr.entries,
  ...je({
    method: Er(qBe),
    params: VBe,
    id: Re()
  }).entries
});
var GBe = "ord_sendInscriptions", WBe = je({
  transfers: Zo(
    je({
      address: Re(),
      inscriptionId: Re()
    })
  )
});
je({
  ...Xr.entries,
  ...je({
    method: Er(GBe),
    params: WBe,
    id: Re()
  }).entries
});
var Ep = async (e, t, r) => {
  var n;
  let o = ((n = window.XverseProviders) == null ? void 0 : n.BitcoinProvider) || window.BitcoinProvider;
  if (!o)
    throw new Error("no wallet provider was found");
  if (!e)
    throw new Error("A wallet method is required");
  const i = await o.request(e, t);
  return Nj(HY, i) ? {
    status: "error",
    error: i.error
  } : Nj(LY, i) ? {
    status: "success",
    result: i.result
  } : {
    status: "error",
    error: {
      code: -32603,
      message: "Received unknown response from provider.",
      data: i
    }
  };
}, qj = (e, t, r) => {
  var n;
  let o = ((n = window.XverseProviders) == null ? void 0 : n.BitcoinProvider) || window.BitcoinProvider;
  if (!o)
    throw new Error("no wallet provider was found");
  return o.addListener ? o.addListener(e, t) : (console.error(
    "The wallet provider you are using does not support the addListener method. Please update your wallet provider."
  ), () => {
  });
}, ZBe = async (e) => {
  var t, r;
  const n = await QE(e.getProvider), { address: o, message: i } = e.payload;
  if (!o)
    throw new Error("An address is required to sign a message");
  if (!i)
    throw new Error("A message to be signed is required");
  try {
    const a = vs.createUnsecuredToken(e.payload), u = await n.signMessage(a);
    (t = e.onFinish) == null || t.call(e, u);
  } catch (a) {
    console.error("[Connect] Error during sign message request", a), (r = e.onCancel) == null || r.call(e);
  }
}, XBe = (e) => e.map((t) => {
  const { address: r, amountSats: n } = t;
  return {
    address: r,
    amountSats: n.toString()
  };
}), YBe = async (e) => {
  var t, r;
  const n = await QE(e.getProvider), { recipients: o, senderAddress: i, network: a, message: u } = e.payload;
  if (!o || o.length === 0)
    throw new Error("At least one recipient is required");
  if (o.some(
    (l) => typeof l.address != "string" || typeof l.amountSats != "bigint"
  ))
    throw new Error("Incorrect recipient format");
  if (!i)
    throw new Error("The sender address is required");
  try {
    const l = XBe(o), d = {
      network: a,
      senderAddress: i,
      message: u,
      recipients: l
    }, f = vs.createUnsecuredToken(d), h = await n.sendBtcTransaction(f);
    (t = e.onFinish) == null || t.call(e, h);
  } catch (l) {
    console.error("[Connect] Error during send BTC transaction request", l), (r = e.onCancel) == null || r.call(e);
  }
}, JBe = async (e) => {
  var t, r;
  const n = await QE(e.getProvider), { psbtBase64: o, inputsToSign: i } = e.payload;
  if (!o)
    throw new Error("A value for psbtBase64 representing the tx hash is required");
  if (!i)
    throw new Error("An array specifying the inputs to be signed by the wallet is required");
  try {
    const a = vs.createUnsecuredToken(e.payload), u = await n.signTransaction(a);
    (t = e.onFinish) == null || t.call(e, u);
  } catch (a) {
    console.error("[Connect] Error during sign transaction request", a), (r = e.onCancel) == null || r.call(e);
  }
};
const QBe = (e) => e === zn ? Aa.Mainnet : e === ua ? Aa.Testnet : e === Fs ? Aa.Signet : e === us ? Aa.Testnet : e === ih ? Aa.Mainnet : e === Ta ? Aa.Testnet4 : Aa.Mainnet;
class eNe extends Ju {
  constructor() {
    super(...arguments), ut(this, "observer");
  }
  get network() {
    return this.$network.get();
  }
  initialize() {
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var t, r;
      (t = window == null ? void 0 : window.XverseProviders) != null && t.BitcoinProvider && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [Rp]: !0
      }), (r = this.observer) == null || r.disconnect());
    }), this.observer.observe(document, { childList: !0, subtree: !0 }));
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect(), this.removeListeners();
  }
  addListeners() {
    qj("accountChange", () => {
    }), qj("networkChange", (t) => {
      t.type === "networkChange" && this.handleNetworkChanged(t.bitcoin.name);
    });
  }
  removeListeners() {
    console.log("removeListeners");
  }
  // private handleAccountsChanged(accounts: string[]) {
  //   console.log('handleAccountsChanged', accounts)
  //   if (!accounts.length) {
  //     this.parent.disconnect()
  //     return
  //   }
  //   // if (this.$store.get().accounts[0] === accounts[0]) {
  //   //   return
  //   // }
  //   // this.$store.setKey('accounts', accounts)
  //   // if (accounts.length > 0) {
  //   //   this.parent.connect(XVERSE)
  //   // } else {
  //   //   this.parent.disconnect()
  //   // }
  // }
  handleNetworkChanged(t) {
    const r = eI(t);
    this.$network.set(r), this.parent.connect(Rp);
  }
  async connect(t) {
    let r, n, o;
    try {
      const i = await Ep("wallet_getAccount", null);
      if (i.status === "success")
        r = S5(i.result.addresses), n = T5(i.result.addresses), o = i.result.network.bitcoin.name;
      else
        throw new Error(`Error getting account: ${i.error.message}`);
    } catch (i) {
      if (i instanceof Error && (i.message.toLowerCase().includes("failed to get") || i.message.toLowerCase().includes("access denied"))) {
        const a = await Ep("wallet_connect", {
          addresses: [b0.Ordinals, b0.Payment],
          message: "Connecting with lasereyes"
        });
        if (a.status === "success")
          r = S5(a.result.addresses), n = T5(a.result.addresses), o = a.result.network.bitcoin.name;
        else
          throw a.error.code === g1.USER_REJECTION ? new Error(`User canceled lasereyes to ${Rp} wallet`) : new Error(a.error.message);
      } else
        throw console.error(i), new Error(`Error connecting to ${Rp} wallet`);
    }
    if (!r || !n)
      throw new Error("Could not find the addresses");
    this.$store.setKey("address", r.address), this.$store.setKey("paymentAddress", n.address), this.$store.setKey("accounts", [
      r.address,
      n.address
    ]), this.$store.setKey("publicKey", String(r.publicKey)), this.$store.setKey(
      "paymentPublicKey",
      String(n.publicKey)
    ), o && this.$network.set(eI(o));
  }
  async getNetwork() {
    try {
      const t = await Ep("wallet_getNetwork", null);
      if (t.status === "success")
        return eI(t.result.bitcoin.name);
      throw new Error("Error getting network");
    } catch {
      return this.network;
    }
  }
  async switchNetwork(t) {
    if ((await Ep("wallet_changeNetwork", {
      name: QBe(t)
    })).status === "success")
      this.handleNetworkChanged(t);
    else
      throw new Error("Error switching network");
  }
  async sendBTC(t, r) {
    const n = await Ep("sendTransfer", {
      recipients: [
        {
          address: t,
          amount: r
        }
      ]
    });
    if (n.status === "success")
      return n.result.txid;
    throw n.error.code === g1.USER_REJECTION ? new Error("User rejected the request") : new Error(`Error sending BTC: ${n.error.message}`);
  }
  async signMessage(t, { toSignAddress: r, protocol: n }) {
    const o = r || this.$store.get().paymentAddress, i = await Ep("signMessage", {
      address: o,
      message: t,
      protocol: n === pv ? w0.ECDSA : w0.BIP322
    });
    if (i.status === "success")
      return i.result.signature;
    throw i.error.code === g1.USER_REJECTION ? new Error("User rejected the request") : new Error(`Error signing message: ${i.error.message}`);
  }
  async signPsbt({
    psbtBase64: t,
    broadcast: r,
    finalize: n,
    inputsToSign: o
  }) {
    try {
      const i = Yr.fromBase64(String(t), {
        network: pn(this.network)
      }).data.inputs;
      let a = {};
      if (o)
        a = o.reduce(
          (g, b) => ({
            ...g,
            [b.address]: [...g[b.address] || [], b.index]
          }),
          {}
        );
      else {
        const { address: g, paymentAddress: b } = this.$store.get(), w = {
          [g]: []
        }, E = {
          [b]: []
        };
        for (const _ of i.keys()) {
          const O = i[_];
          if (O.witnessUtxo === void 0) {
            E[b].push(Number(_));
            continue;
          }
          const { script: C } = O.witnessUtxo, I = J2(
            C,
            pn(this.network)
          );
          I === b ? E[b].push(Number(_)) : I === g && w[g].push(Number(_));
        }
        w[g].length > 0 && (a = { ...a, ...w }), E[b].length > 0 && (a = { ...a, ...E });
      }
      let u, l, d, f;
      const h = await Ep("signPsbt", {
        psbt: t,
        broadcast: !!r,
        signInputs: a
      });
      if (h.status === "success")
        f = Yr.fromBase64(h.result.psbt, {
          network: pn(this.network)
        }), u = h.result.txid;
      else
        throw h.error.code === g1.USER_REJECTION ? new Error("User canceled the request") : new Error("Error signing psbt");
      if (!f)
        throw new Error("Error signing psbt");
      return n && !u ? (f.finalizeAllInputs(), l = f.toHex(), d = f.toBase64()) : (l = f.toHex(), d = f.toBase64()), {
        signedPsbtHex: l,
        signedPsbtBase64: d,
        txId: u
      };
    } catch (i) {
      throw console.error(i), i;
    }
  }
  // this is not working
  // TODO: Fix this
  // async getInscriptions(
  //   offset?: number,
  //   limit?: number
  // ): Promise<Inscription[]> {
  //   const offsetValue = offset || 0
  //   const limitValue = limit || 10
  //   const response = await request('ord_getInscriptions', {
  //     offset: offsetValue,
  //     limit: limitValue,
  //   })
  //   if (response.status === 'success') {
  //     const inscriptions = response.result.inscriptions.map((insc) => {
  //       return normalizeInscription(insc, undefined, this.network)
  //     })
  //     console.log(inscriptions)
  //     return inscriptions as Inscription[]
  //   }
  //   console.error(response.error)
  //   throw new Error('Error getting inscriptions')
  // }
}
class tNe extends Ju {
  constructor(t, r, n) {
    super(t, r, n), ut(this, "observer");
  }
  get library() {
    return window.wizz;
  }
  get network() {
    return this.$network.get();
  }
  handleNetworkChanged(t) {
    this.parent.connect(zp);
  }
  handleAccountsChanged(t) {
    if (!t.length) {
      this.parent.disconnect();
      return;
    }
    this.$store.get().accounts[0] !== t[0] && this.$store.setKey("accounts", t);
  }
  initialize() {
    Zu(this.$store, ["provider"], (t) => {
      t.provider === zp ? this.addLibraryListeners() : this.removeLibraryListeners();
    }), typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var t;
      this.library && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [zp]: !0
      }), (t = this.observer) == null || t.disconnect());
    }), this.observer.observe(document, { childList: !0, subtree: !0 }));
  }
  removeLibraryListeners() {
    var t, r;
    (t = this.library) == null || t.removeListener(
      "networkChanged",
      this.handleNetworkChanged.bind(this)
    ), (r = this.library) == null || r.removeListener(
      "accountsChanged",
      this.handleAccountsChanged.bind(this)
    );
  }
  addLibraryListeners() {
    var t, r;
    (t = this.library) == null || t.on("networkChanged", this.handleNetworkChanged.bind(this)), (r = this.library) == null || r.on("accountsChanged", this.handleAccountsChanged.bind(this));
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect(), this.removeLibraryListeners();
  }
  async connect() {
    if (!this.library) throw DPe;
    const t = await this.library.requestAccounts();
    if (!t) throw new Error("No accounts found");
    const r = await this.library.getPublicKey();
    if (!r) throw new Error("No public key found");
    this.$store.setKey("accounts", t), this.$store.setKey("address", t[0]), this.$store.setKey("paymentAddress", t[0]), this.$store.setKey("publicKey", r), this.$store.setKey("paymentPublicKey", r), this.$store.setKey("provider", zp), await this.getNetwork().then((n) => {
      var o;
      n && ((o = this.config) == null ? void 0 : o.network) !== n && this.parent.switchNetwork(n);
    }), this.$store.setKey("connected", !0);
  }
  async requestAccounts() {
    return await this.library.requestAccounts();
  }
  async getNetwork() {
    var t;
    const r = await ((t = this.library) == null ? void 0 : t.getNetwork());
    return r ? Jz(r) : void 0;
  }
  async switchNetwork(t) {
    var r;
    if (t === us || t === ih)
      return await this.library.switchNetwork(d1.MAINNET);
    const n = Jz(t);
    await ((r = this.library) == null ? void 0 : r.switchNetwork(n)), this.$network.set(t), await this.parent.getBalance();
  }
  async getPublicKey() {
    var t;
    return await ((t = this.library) == null ? void 0 : t.getPublicKey());
  }
  async getBalance() {
    return (await this.library.getBalance()).total;
  }
  async getInscriptions(t, r) {
    const n = t || 0, o = r || 10;
    return (await this.library.getInscriptions(n, o)).list.map((i) => N1(i, void 0, this.network));
  }
  async sendBTC(t, r) {
    var n;
    const o = await ((n = this.library) == null ? void 0 : n.sendBitcoin(t, r));
    if (o)
      return o;
    throw new Error("Error sending BTC");
  }
  async signMessage(t, r) {
    var n;
    const o = (r == null ? void 0 : r.protocol) === KN ? RE : r == null ? void 0 : r.protocol;
    return await ((n = this.library) == null ? void 0 : n.signMessage(t, o));
  }
  async signPsbt({
    psbtHex: t,
    broadcast: r,
    finalize: n,
    inputsToSign: o
  }) {
    var i;
    const a = await ((i = this.library) == null ? void 0 : i.signPsbt(t, KE({
      autoFinalized: n,
      broadcast: !1,
      toSignInputs: o
    }))), u = Yr.fromHex(a);
    let l;
    return n && r && (l = await this.pushPsbt(a)), {
      signedPsbtHex: u.toHex(),
      signedPsbtBase64: u.toBase64(),
      txId: l
    };
  }
}
let Vj = (e) => e, Wb = {}, vd = { addEventListener() {
}, removeEventListener() {
} };
function rNe() {
  try {
    return typeof localStorage < "u";
  } catch {
    return !1;
  }
}
rNe() && (Wb = localStorage);
let nNe = {
  addEventListener(e, t, r) {
    window.addEventListener("storage", t), window.addEventListener("pageshow", r);
  },
  removeEventListener(e, t, r) {
    window.removeEventListener("storage", t), window.removeEventListener("pageshow", r);
  }
};
typeof window < "u" && (vd = nNe);
function Xg(e, t = {}, r = {}) {
  let n = r.encode || Vj, o = r.decode || Vj, i = Cq(), a = i.setKey, u = (h, g) => {
    typeof g > "u" ? (r.listen !== !1 && vd.perKey && vd.removeEventListener(e + h, d, f), delete Wb[e + h]) : (r.listen !== !1 && vd.perKey && !(h in i.value) && vd.addEventListener(e + h, d, f), Wb[e + h] = n(g));
  };
  i.setKey = (h, g) => {
    u(h, g), a(h, g);
  };
  let l = i.set;
  i.set = function(h) {
    for (let g in h)
      u(g, h[g]);
    for (let g in i.value)
      g in h || u(g, void 0);
    l(h);
  };
  function d(h) {
    h.key ? h.key.startsWith(e) && (h.newValue === null ? a(h.key.slice(e.length), void 0) : a(h.key.slice(e.length), o(h.newValue))) : l({});
  }
  function f() {
    let h = { ...t };
    for (let g in Wb)
      g.startsWith(e) && (h[g.slice(e.length)] = o(Wb[g]));
    for (let g in h)
      i.setKey(g, h[g]);
  }
  return awe(i, () => {
    if (f(), r.listen !== !1)
      return vd.addEventListener(e, d, f), () => {
        vd.removeEventListener(e, d, f);
        for (let h in i.value)
          vd.removeEventListener(e + h, d, f);
      };
  }), i;
}
const oNe = "OYL_CONNECTED_WALLET_STATE";
class iNe extends Ju {
  constructor(t, r, n) {
    super(t, r, n), ut(this, "observer"), ut(this, "$valueStore", Xg(
      oNe,
      {
        address: "",
        paymentAddress: "",
        paymentPublicKey: "",
        publicKey: "",
        balance: ""
      }
    )), ut(this, "removeSubscriber");
  }
  get library() {
    return window.oyl;
  }
  get network() {
    return this.$network.get();
  }
  restorePersistedValues() {
    const t = this.$valueStore.get();
    for (const r of j0)
      r === "balance" && this.$store.setKey(r, BigInt(t[r])), this.$store.setKey(r, t[r]);
    this.$store.setKey(
      "accounts",
      [t.address, t.paymentAddress].filter(Boolean)
    );
  }
  watchStateChange(t, r, n) {
    Wg(x1, t, n, this.$valueStore);
  }
  initialize() {
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var t;
      window != null && window.oyl && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [x1]: !0
      }), (t = this.observer) == null || t.disconnect());
    }), this.observer.observe(document, { childList: !0, subtree: !0 })), Zu(this.$store, ["provider"], (t) => {
      t.provider !== x1 ? this.removeSubscriber && (this.$valueStore.set({
        address: "",
        publicKey: "",
        paymentAddress: "",
        paymentPublicKey: "",
        balance: ""
      }), this.removeSubscriber(), this.removeSubscriber = void 0) : this.removeSubscriber = this.$store.subscribe(
        this.watchStateChange.bind(this)
      );
    });
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect();
  }
  async connect(t) {
    const { address: r, paymentAddress: n } = this.$valueStore.get();
    if (r)
      if (r.startsWith("tb1") && mv(this.network))
        this.disconnect();
      else {
        this.restorePersistedValues(), m0(n, this.network).then((a) => {
          this.$store.setKey("balance", a);
        });
        return;
      }
    if (!this.library) throw new Error("Oyl isn't installed");
    const { nativeSegwit: o, taproot: i } = await this.library.getAddresses();
    if (!o || !i) throw new Error("No accounts found");
    this.$store.setKey("address", i.address), this.$store.setKey("paymentAddress", o.address), this.$store.setKey("publicKey", i.publicKey), this.$store.setKey("paymentPublicKey", o.publicKey);
  }
  async getNetwork() {
    return await this.library.getNetwork();
  }
  async sendBTC(t, r) {
    const { psbtHex: n, psbtBase64: o } = await GN(
      this.$store.get().address,
      this.$store.get().paymentAddress,
      t,
      r,
      this.$store.get().paymentPublicKey,
      this.network,
      7
    ), i = await this.signPsbt({ psbtBase64: o, psbtHex: n, tx: n, broadcast: !0, finalize: !0 });
    if (!i) throw new Error("Error sending BTC");
    return i.txId;
  }
  async signMessage(t, r) {
    const n = (r == null ? void 0 : r.toSignAddress) || this.$store.get().paymentAddress;
    return (await this.library.signMessage({
      address: n,
      message: t,
      protocol: r == null ? void 0 : r.protocol
    })).signature;
  }
  async signPsbt({ psbtHex: t, broadcast: r, finalize: n }) {
    const { psbt: o, txid: i } = await this.library.signPsbt({
      psbt: t,
      finalize: n,
      broadcast: r
    }), a = Yr.fromHex(o);
    return {
      signedPsbtHex: a.toHex(),
      signedPsbtBase64: a.toBase64(),
      txId: i
    };
  }
  async pushPsbt(t) {
    return (await this.library.pushPsbt({ psbt: t })).txid;
  }
  async getPublicKey() {
    const { nativeSegwit: t, taproot: r } = await this.library.getAddresses();
    if (!t || !r) throw new Error("No accounts found");
    return this.$store.setKey("publicKey", r.publicKey), this.$store.setKey("paymentPublicKey", t.publicKey), r.publicKey;
  }
  async getBalance() {
    const { total: t } = await this.library.getBalance();
    return this.$store.setKey("balance", t), t;
  }
  async requestAccounts() {
    return [this.$store.get().address, this.$store.get().paymentAddress];
  }
  async switchNetwork(t) {
    return await this.library.switchNetwork(t);
  }
}
const aNe = "LEATHER_CONNECTED_WALLET_STATE";
class sNe extends Ju {
  constructor(t, r, n) {
    super(t, r, n), ut(this, "observer"), ut(this, "$valueStore", Xg(
      aNe,
      {
        address: "",
        publicKey: "",
        paymentAddress: "",
        paymentPublicKey: "",
        balance: ""
      }
    )), ut(this, "removeSubscriber");
  }
  get library() {
    return window.LeatherProvider;
  }
  get network() {
    return this.$network.get();
  }
  restorePersistedValues() {
    const t = this.$valueStore.get();
    for (const r of j0)
      r === "balance" && this.$store.setKey(r, BigInt(t[r])), this.$store.setKey(r, t[r]);
    this.$store.setKey(
      "accounts",
      [t.address, t.paymentAddress].filter(Boolean)
    );
  }
  watchStateChange(t, r, n) {
    Wg(
      k1,
      t,
      n,
      this.$valueStore
    );
  }
  initialize() {
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var t;
      window != null && window.LeatherProvider && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [k1]: !0
      }), (t = this.observer) == null || t.disconnect());
    }), this.observer.observe(document, { childList: !0, subtree: !0 })), Zu(this.$store, ["provider"], (t) => {
      t.provider !== k1 ? this.removeSubscriber && (this.$valueStore.set({
        address: "",
        publicKey: "",
        paymentAddress: "",
        paymentPublicKey: "",
        balance: ""
      }), this.removeSubscriber(), this.removeSubscriber = void 0) : this.removeSubscriber = this.$store.subscribe(
        this.watchStateChange.bind(this)
      );
    });
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect();
  }
  async connect(t) {
    var r;
    const { address: n, paymentAddress: o } = this.$valueStore.get();
    if (n)
      if (n.startsWith("tb1") && mv(this.network))
        this.disconnect();
      else {
        this.restorePersistedValues(), m0(o, this.network).then((f) => {
          this.$store.setKey("balance", f);
        });
        return;
      }
    if (!this.library) throw new Error("Leather isn't installed");
    const i = await this.library.request("getAddresses");
    if (!i) throw new Error("No accounts found");
    const a = i.result.addresses, u = a.map(
      (f) => f.address
    ), l = a.find(
      (f) => f.type === Y1
    ), d = a.find(
      (f) => f.type === xO
    );
    if (!(l != null && l.publicKey) || !(d != null && d.publicKey))
      throw new Error("No accounts found");
    if ((r = String(l == null ? void 0 : l.address)) != null && r.startsWith("tb") && this.network !== ua && this.network !== Ta && this.network !== Fs)
      throw new Error(
        `Please switch networks to ${this.network} in the wallet settings.`
      );
    this.$store.setKey("accounts", u), this.$store.setKey("address", l.address), this.$store.setKey("paymentAddress", d.address), this.$store.setKey("publicKey", l.publicKey), this.$store.setKey("paymentPublicKey", d.publicKey);
  }
  async getNetwork() {
    return this.network;
  }
  async sendBTC(t, r) {
    var n, o;
    try {
      const i = await ((n = this.library) == null ? void 0 : n.request("sendTransfer", {
        recipients: [
          {
            address: t,
            amount: String(r)
          }
        ],
        network: this.network
      }));
      if ((o = i == null ? void 0 : i.result) != null && o.txid)
        return i.result.txid;
      throw i.error.code === g1.USER_REJECTION ? new Error("User rejected the request") : new Error("Error sending BTC: " + i.error.message);
    } catch (i) {
      throw console.log(i), new Error("error sending BTC");
    }
  }
  async signMessage(t, r) {
    var n;
    const o = r == null ? void 0 : r.toSignAddress;
    if ((r == null ? void 0 : r.protocol) === pv)
      throw new Error("Leather doesn't support ECDSA message signing");
    const i = o === this.$store.get().address ? Y1 : xO;
    if (o !== this.$store.get().address && o !== this.$store.get().paymentAddress)
      throw new Error("Invalid address to sign message");
    const a = await this.library.request("signMessage", {
      message: t,
      paymentType: i
    });
    return (n = a == null ? void 0 : a.result) == null ? void 0 : n.signature;
  }
  async signPsbt({
    psbtHex: t,
    broadcast: r,
    finalize: n,
    inputsToSign: o
  }) {
    const i = {
      hex: t,
      broadcast: !1,
      network: this.network,
      signAtIndex: o == null ? void 0 : o.map((l) => l.index)
    }, a = (await this.library.request(
      "signPsbt",
      i
    )).result.hex, u = Yr.fromHex(String(a));
    if (n && r) {
      const l = u.finalizeAllInputs(), d = await this.pushPsbt(l.toHex());
      return {
        signedPsbtHex: u.toHex(),
        signedPsbtBase64: u.toBase64(),
        txId: d
      };
    } else if (n) {
      const l = u.finalizeAllInputs();
      return {
        signedPsbtHex: l.toHex(),
        signedPsbtBase64: l.toBase64(),
        txId: void 0
      };
    } else
      return {
        signedPsbtHex: u.toHex(),
        signedPsbtBase64: u.toBase64(),
        txId: void 0
      };
  }
  async getPublicKey() {
    return this.$store.get().publicKey;
  }
  async getBalance() {
    const t = await m0(
      this.$store.get().paymentAddress,
      this.network
    );
    return this.$store.setKey("balance", t), t.toString();
  }
  async requestAccounts() {
    const { accounts: t } = this.$store.get();
    if (t.length > 0)
      return t;
    const { result: r } = await this.library.request(
      "getAddresses"
    ), n = r.addresses.map((o) => o.address);
    return this.$store.setKey("accounts", n), n;
  }
}
var lw = {}, KY = {}, Qu = {}, qY = {};
Object.defineProperty(qY, "__esModule", { value: !0 });
(function(e) {
  var t = zt && zt.__createBinding || (Object.create ? function(a, u, l, d) {
    d === void 0 && (d = l);
    var f = Object.getOwnPropertyDescriptor(u, l);
    (!f || ("get" in f ? !u.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return u[l];
    } }), Object.defineProperty(a, d, f);
  } : function(a, u, l, d) {
    d === void 0 && (d = l), a[d] = u[l];
  }), r = zt && zt.__exportStar || function(a, u) {
    for (var l in a) l !== "default" && !Object.prototype.hasOwnProperty.call(u, l) && t(u, a, l);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.getProviderById = e.getProviders = e.getProviderOrThrow = void 0;
  async function n(a) {
    var u, l;
    if (a) {
      const f = await a();
      if (f)
        return f;
    }
    const d = window.OrangeBitcoinProvider || ((u = window.OrangecryptoProviders) == null ? void 0 : u.BitcoinProvider) || ((l = window.OrangeWalletProviders) == null ? void 0 : l.OrangeBitcoinProvider);
    if (!d)
      throw new Error("No Orange Bitcoin wallet installed");
    return d;
  }
  e.getProviderOrThrow = n;
  function o() {
    return window.btc_providers || (window.btc_providers = []), window.btc_providers;
  }
  e.getProviders = o;
  function i(a) {
    var u;
    if (Array.isArray(window.btc_providers)) {
      const l = window.btc_providers.find((d) => d.id === a);
      return (u = l == null ? void 0 : l.id) == null ? void 0 : u.split(".").reduce((d, f) => d == null ? void 0 : d[f], window);
    } else {
      console.log("window.btc_providers is not defined or not an array");
      return;
    }
  }
  e.getProviderById = i, r(qY, e);
})(Qu);
var VY = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.AddressType = e.AddressPurpose = void 0, function(t) {
    t.Ordinals = "ordinals", t.Payment = "payment", t.Stacks = "stacks";
  }(e.AddressPurpose || (e.AddressPurpose = {})), function(t) {
    t.p2pkh = "p2pkh", t.p2sh = "p2sh", t.p2wpkh = "p2wpkh", t.p2wsh = "p2wsh", t.p2tr = "p2tr", t.stacks = "stacks";
  }(e.AddressType || (e.AddressType = {}));
})(VY);
(function(e) {
  var t = zt && zt.__createBinding || (Object.create ? function(a, u, l, d) {
    d === void 0 && (d = l);
    var f = Object.getOwnPropertyDescriptor(u, l);
    (!f || ("get" in f ? !u.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return u[l];
    } }), Object.defineProperty(a, d, f);
  } : function(a, u, l, d) {
    d === void 0 && (d = l), a[d] = u[l];
  }), r = zt && zt.__exportStar || function(a, u) {
    for (var l in a) l !== "default" && !Object.prototype.hasOwnProperty.call(u, l) && t(u, a, l);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.getAddress = void 0;
  const n = vs, o = Qu, i = async (a) => {
    var u, l;
    const d = await (0, o.getProviderOrThrow)(a.getProvider), { purposes: f } = a.payload;
    if (!f)
      throw new Error("Address purposes are required");
    try {
      const h = (0, n.createUnsecuredToken)(a.payload), g = await d.connect(h);
      (u = a.onFinish) == null || u.call(a, g);
    } catch (h) {
      console.error("[Connect] Error during address request", h), (l = a.onCancel) == null || l.call(a);
    }
  };
  e.getAddress = i, r(VY, e);
})(KY);
var GY = {}, WY = {}, ZY = {};
Object.defineProperty(ZY, "__esModule", { value: !0 });
var XY = {};
Object.defineProperty(XY, "__esModule", { value: !0 });
(function(e) {
  var t = zt && zt.__createBinding || (Object.create ? function(n, o, i, a) {
    a === void 0 && (a = i);
    var u = Object.getOwnPropertyDescriptor(o, i);
    (!u || ("get" in u ? !o.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return o[i];
    } }), Object.defineProperty(n, a, u);
  } : function(n, o, i, a) {
    a === void 0 && (a = i), n[a] = o[i];
  }), r = zt && zt.__exportStar || function(n, o) {
    for (var i in n) i !== "default" && !Object.prototype.hasOwnProperty.call(o, i) && t(o, n, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(ZY, e), r(XY, e);
})(WY);
(function(e) {
  var t = zt && zt.__createBinding || (Object.create ? function(a, u, l, d) {
    d === void 0 && (d = l);
    var f = Object.getOwnPropertyDescriptor(u, l);
    (!f || ("get" in f ? !u.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return u[l];
    } }), Object.defineProperty(a, d, f);
  } : function(a, u, l, d) {
    d === void 0 && (d = l), a[d] = u[l];
  }), r = zt && zt.__exportStar || function(a, u) {
    for (var l in a) l !== "default" && !Object.prototype.hasOwnProperty.call(u, l) && t(u, a, l);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.request = void 0;
  const n = Qu, o = async (a, u, l) => {
    var d;
    let f = ((d = window.OrangecryptoProviders) == null ? void 0 : d.BitcoinProvider) || window.OrangeBitcoinProvider;
    if (l && (f = await (0, n.getProviderById)(l)), !f)
      throw new Error("no wallet provider was found");
    if (!a)
      throw new Error("A wallet method is required");
    const h = await f.request(a, u);
    return i(h) ? {
      status: "success",
      result: h.result
    } : {
      status: "error",
      error: h.error
    };
  };
  e.request = o;
  const i = (a) => Object.hasOwn(a, "result") && !!a.result;
  r(WY, e);
})(GY);
var YY = {}, JY = {};
Object.defineProperty(JY, "__esModule", { value: !0 });
(function(e) {
  var t = zt && zt.__createBinding || (Object.create ? function(u, l, d, f) {
    f === void 0 && (f = d);
    var h = Object.getOwnPropertyDescriptor(l, d);
    (!h || ("get" in h ? !l.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return l[d];
    } }), Object.defineProperty(u, f, h);
  } : function(u, l, d, f) {
    f === void 0 && (f = d), u[f] = l[d];
  }), r = zt && zt.__exportStar || function(u, l) {
    for (var d in u) d !== "default" && !Object.prototype.hasOwnProperty.call(l, d) && t(l, u, d);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.getCapabilities = void 0;
  const n = vs, o = Qu, i = (u, l) => {
    const d = (h) => !(!u[h] || l && !l.has(h)), f = {
      request: d("request"),
      connect: d("connect"),
      signMessage: d("signMessage"),
      signTransaction: d("signTransaction"),
      sendBtcTransaction: d("sendBtcTransaction"),
      createInscription: d("createInscription"),
      createRepeatInscriptions: d("createRepeatInscriptions"),
      signMultipleTransactions: d("signMultipleTransactions")
    };
    return Object.entries(f).reduce((h, [g, b]) => b ? [...h, g] : h, []);
  }, a = async (u) => {
    var l, d, f;
    const h = await (0, o.getProviderOrThrow)(u.getProvider), g = (0, n.createUnsecuredToken)(u.payload);
    if (h.getCapabilities)
      try {
        const b = await h.getCapabilities(g);
        (l = u.onFinish) == null || l.call(u, i(h, new Set(b)));
      } catch (b) {
        console.error("[Connect] Error during capabilities request", b);
      }
    try {
      const b = i(h);
      (d = u.onFinish) == null || d.call(u, b);
    } catch (b) {
      console.error("[Connect] Error during capabilities request", b), (f = u.onCancel) == null || f.call(u);
    }
  };
  e.getCapabilities = a, r(JY, e);
})(YY);
var QY = {}, e6 = {}, xv = {};
Object.defineProperty(xv, "__esModule", { value: !0 });
xv.validateInscriptionPayload = void 0;
const uNe = 4e5, cNe = 6e4, lNe = (e) => {
  const { contentType: t, content: r, payloadType: n, network: o, appFeeAddress: i, appFee: a } = e;
  if (!/^[a-z]+\/[a-z0-9\-\.\+]+(?=;.*|$)/.test(t))
    throw new Error("Invalid content type detected");
  if (!r || r.length === 0)
    throw new Error("Empty content not allowed");
  if (!n || n !== "BASE_64" && n !== "PLAIN_TEXT")
    throw new Error("Empty invalid payloadType specified");
  if (r.length > (o.type === "Mainnet" ? uNe : cNe))
    throw new Error("Content too large");
  if (((i == null ? void 0 : i.length) ?? 0) > 0 && (a ?? 0) <= 0)
    throw new Error("Invalid combination of app fee address and fee provided");
};
xv.validateInscriptionPayload = lNe;
Object.defineProperty(e6, "__esModule", { value: !0 });
e6.createInscription = void 0;
const fNe = vs, dNe = Qu, hNe = xv, pNe = async (e) => {
  var t, r;
  const { getProvider: n } = e, o = await (0, dNe.getProviderOrThrow)(n);
  (0, hNe.validateInscriptionPayload)(e.payload);
  try {
    const i = (0, fNe.createUnsecuredToken)(e.payload), a = await o.createInscription(i);
    (t = e.onFinish) == null || t.call(e, a);
  } catch (i) {
    console.error("[Connect] Error during create inscription", i), (r = e.onCancel) == null || r.call(e);
  }
};
e6.createInscription = pNe;
var t6 = {};
Object.defineProperty(t6, "__esModule", { value: !0 });
t6.createRepeatInscriptions = void 0;
const gNe = Qu, mNe = vs, yNe = xv, bNe = async (e) => {
  var t, r;
  const { getProvider: n } = e, o = await (0, gNe.getProviderOrThrow)(n);
  (0, yNe.validateInscriptionPayload)(e.payload);
  try {
    const i = (0, mNe.createUnsecuredToken)(e.payload), a = await o.createRepeatInscriptions(i);
    (t = e.onFinish) == null || t.call(e, a);
  } catch (i) {
    console.error("[Connect] Error during create repeat inscriptions", i), (r = e.onCancel) == null || r.call(e);
  }
};
t6.createRepeatInscriptions = bNe;
var eJ = {};
Object.defineProperty(eJ, "__esModule", { value: !0 });
(function(e) {
  var t = zt && zt.__createBinding || (Object.create ? function(n, o, i, a) {
    a === void 0 && (a = i);
    var u = Object.getOwnPropertyDescriptor(o, i);
    (!u || ("get" in u ? !o.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return o[i];
    } }), Object.defineProperty(n, a, u);
  } : function(n, o, i, a) {
    a === void 0 && (a = i), n[a] = o[i];
  }), r = zt && zt.__exportStar || function(n, o) {
    for (var i in n) i !== "default" && !Object.prototype.hasOwnProperty.call(o, i) && t(o, n, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(e6, e), r(t6, e), r(eJ, e);
})(QY);
var tJ = {}, rJ = {};
Object.defineProperty(rJ, "__esModule", { value: !0 });
(function(e) {
  var t = zt && zt.__createBinding || (Object.create ? function(a, u, l, d) {
    d === void 0 && (d = l);
    var f = Object.getOwnPropertyDescriptor(u, l);
    (!f || ("get" in f ? !u.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return u[l];
    } }), Object.defineProperty(a, d, f);
  } : function(a, u, l, d) {
    d === void 0 && (d = l), a[d] = u[l];
  }), r = zt && zt.__exportStar || function(a, u) {
    for (var l in a) l !== "default" && !Object.prototype.hasOwnProperty.call(u, l) && t(u, a, l);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.signMessage = void 0;
  const n = vs, o = Qu, i = async (a) => {
    var u, l;
    const d = await (0, o.getProviderOrThrow)(a.getProvider), { address: f, message: h } = a.payload;
    if (!f)
      throw new Error("An address is required to sign a message");
    if (!h)
      throw new Error("A message to be signed is required");
    try {
      const g = (0, n.createUnsecuredToken)(a.payload), b = await d.signMessage(g);
      (u = a.onFinish) == null || u.call(a, b);
    } catch (g) {
      console.error("[Connect] Error during sign message request", g), (l = a.onCancel) == null || l.call(a);
    }
  };
  e.signMessage = i, r(rJ, e);
})(tJ);
var nJ = {}, r6 = {};
Object.defineProperty(r6, "__esModule", { value: !0 });
r6.sendBtcTransaction = void 0;
const wNe = vs, vNe = Qu, ENe = (e) => e.map((t) => {
  const { address: r, amountSats: n } = t;
  return {
    address: r,
    amountSats: n.toString()
  };
}), _Ne = async (e) => {
  var t, r;
  const n = await (0, vNe.getProviderOrThrow)(e.getProvider), { recipients: o, senderAddress: i, network: a, message: u } = e.payload;
  if (!o || o.length === 0)
    throw new Error("At least one recipient is required");
  if (o.some((l) => typeof l.address != "string" || typeof l.amountSats != "bigint"))
    throw new Error("Incorrect recipient format");
  if (!i)
    throw new Error("The sender address is required");
  try {
    const l = ENe(o), d = {
      network: a,
      senderAddress: i,
      message: u,
      recipients: l
    }, f = (0, wNe.createUnsecuredToken)(d), h = await n.sendBtcTransaction(f);
    (t = e.onFinish) == null || t.call(e, h);
  } catch (l) {
    console.error("[Connect] Error during send BTC transaction request", l), (r = e.onCancel) == null || r.call(e);
  }
};
r6.sendBtcTransaction = _Ne;
var n6 = {};
Object.defineProperty(n6, "__esModule", { value: !0 });
n6.signTransaction = void 0;
const ANe = vs, xNe = Qu, kNe = async (e) => {
  var t, r;
  const n = await (0, xNe.getProviderOrThrow)(e.getProvider), { psbtBase64: o, inputsToSign: i } = e.payload;
  if (!o)
    throw new Error("A value for psbtBase64 representing the tx hash is required");
  if (!i)
    throw new Error("An array specifying the inputs to be signed by the wallet is required");
  try {
    const a = (0, ANe.createUnsecuredToken)(e.payload), u = await n.signTransaction(a);
    (t = e.onFinish) == null || t.call(e, u);
  } catch (a) {
    console.error("[Connect] Error during sign transaction request", a), (r = e.onCancel) == null || r.call(e);
  }
};
n6.signTransaction = kNe;
var o6 = {};
Object.defineProperty(o6, "__esModule", { value: !0 });
o6.signMultipleTransactions = void 0;
const SNe = vs, TNe = Qu, INe = async (e) => {
  var t, r;
  const n = await (0, TNe.getProviderOrThrow)(e.getProvider), { psbts: o } = e.payload;
  if (!o || !o.length)
    throw new Error("psbts array is required");
  if (o.length > 100)
    throw new Error("psbts array must contain less than 100 psbts");
  try {
    const i = (0, SNe.createUnsecuredToken)(e.payload), a = await n.signMultipleTransactions(i);
    (t = e.onFinish) == null || t.call(e, a);
  } catch (i) {
    console.error("[Connect] Error during sign Multiple transactions request", i), (r = e.onCancel) == null || r.call(e);
  }
};
o6.signMultipleTransactions = INe;
var oJ = {};
Object.defineProperty(oJ, "__esModule", { value: !0 });
(function(e) {
  var t = zt && zt.__createBinding || (Object.create ? function(n, o, i, a) {
    a === void 0 && (a = i);
    var u = Object.getOwnPropertyDescriptor(o, i);
    (!u || ("get" in u ? !o.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return o[i];
    } }), Object.defineProperty(n, a, u);
  } : function(n, o, i, a) {
    a === void 0 && (a = i), n[a] = o[i];
  }), r = zt && zt.__exportStar || function(n, o) {
    for (var i in n) i !== "default" && !Object.prototype.hasOwnProperty.call(o, i) && t(o, n, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(r6, e), r(n6, e), r(o6, e), r(oJ, e);
})(nJ);
var iJ = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.RpcErrorCode = e.BitcoinNetworkType = void 0, function(t) {
    t.Mainnet = "Mainnet", t.Testnet = "Testnet";
  }(e.BitcoinNetworkType || (e.BitcoinNetworkType = {})), function(t) {
    t[t.PARSE_ERROR = -32700] = "PARSE_ERROR", t[t.INVALID_REQUEST = -32600] = "INVALID_REQUEST", t[t.METHOD_NOT_FOUND = -32601] = "METHOD_NOT_FOUND", t[t.INVALID_PARAMS = -32602] = "INVALID_PARAMS", t[t.INTERNAL_ERROR = -32603] = "INTERNAL_ERROR", t[t.USER_REJECTION = -32e3] = "USER_REJECTION", t[t.METHOD_NOT_SUPPORTED = -32001] = "METHOD_NOT_SUPPORTED";
  }(e.RpcErrorCode || (e.RpcErrorCode = {}));
})(iJ);
(function(e) {
  var t = zt && zt.__createBinding || (Object.create ? function(n, o, i, a) {
    a === void 0 && (a = i);
    var u = Object.getOwnPropertyDescriptor(o, i);
    (!u || ("get" in u ? !o.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return o[i];
    } }), Object.defineProperty(n, a, u);
  } : function(n, o, i, a) {
    a === void 0 && (a = i), n[a] = o[i];
  }), r = zt && zt.__exportStar || function(n, o) {
    for (var i in n) i !== "default" && !Object.prototype.hasOwnProperty.call(o, i) && t(o, n, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(KY, e), r(GY, e), r(YY, e), r(QY, e), r(tJ, e), r(Qu, e), r(nJ, e), r(iJ, e);
})(lw);
const ONe = /* @__PURE__ */ nV(lw), { signMessage: PNe, sendBtcTransaction: CNe } = ONe, BNe = "ORANGE_CONNECTED_WALLET_STATE";
class NNe extends Ju {
  constructor(t, r, n) {
    super(t, r, n), ut(this, "observer"), ut(this, "$valueStore", Xg(
      BNe,
      {
        address: "",
        paymentAddress: "",
        paymentPublicKey: "",
        publicKey: "",
        balance: ""
      }
    )), ut(this, "removeSubscriber");
  }
  get library() {
    var t;
    return (t = window == null ? void 0 : window.OrangeWalletProviders) == null ? void 0 : t.OrangeBitcoinProvider;
  }
  get network() {
    return this.$network.get();
  }
  restorePersistedValues() {
    const t = this.$valueStore.get();
    for (const r of j0)
      r === "balance" && this.$store.setKey(r, BigInt(t[r])), this.$store.setKey(r, t[r]);
    this.$store.setKey(
      "accounts",
      [t.address, t.paymentAddress].filter(Boolean)
    );
  }
  watchStateChange(t, r, n) {
    Wg(Od, t, n, this.$valueStore);
  }
  initialize() {
    var t;
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var r;
      window != null && window.OrangeBitcoinProvider && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [Od]: !0
      }), (r = this.observer) == null || r.disconnect());
    }), (t = this.observer) == null || t.observe(document, { childList: !0, subtree: !0 })), Zu(this.$store, ["provider"], (r) => {
      r.provider !== Od ? this.removeSubscriber && (this.$valueStore.set({
        address: "",
        paymentAddress: "",
        paymentPublicKey: "",
        publicKey: "",
        balance: ""
      }), this.removeSubscriber(), this.removeSubscriber = void 0) : this.removeSubscriber = this.$store.subscribe(
        this.watchStateChange.bind(this)
      );
    });
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect();
  }
  async connect(t) {
    const { address: r, paymentAddress: n } = this.$valueStore.get();
    try {
      if (r) {
        this.restorePersistedValues(), m0(n, this.network).then((a) => {
          this.$store.setKey("balance", a);
        });
        return;
      }
      let o = QT(this.network || zn);
      const i = {
        payload: {
          purposes: ["ordinals", "payment"],
          message: "Address for receiving Ordinals and payments",
          network: {
            type: o
          }
        },
        onFinish: (a) => {
          const u = S5(a.addresses), l = T5(a.addresses);
          if (!u || !(l != null && l.address))
            throw new Error("Could not find addresses");
          u && l && (this.$store.setKey("provider", Od), this.$store.setKey("address", u.address), this.$store.setKey("paymentAddress", l.address)), this.$store.setKey("publicKey", String(u.publicKey)), this.$store.setKey(
            "paymentPublicKey",
            String(l.publicKey)
          );
        },
        onCancel: () => {
          throw new Error(`User canceled lasereyes to ${Od} wallet`);
        }
      };
      await lw.getAddress(i), this.$store.setKey("connected", !0);
    } catch (o) {
      throw o;
    }
  }
  async getNetwork() {
    const { address: t } = this.$store.get();
    return t.slice(0, 1) === "t" && [ua, Ta, Fs, us].includes(this.network) ? this.network : zn;
  }
  async sendBTC(t, r) {
    let n = "";
    const o = {
      payload: {
        network: {
          type: QT(this.network)
        },
        recipients: [
          {
            address: t,
            amountSats: BigInt(r)
          }
        ],
        senderAddress: this.$store.get().paymentAddress
      },
      onFinish: (i) => {
        n = i;
      },
      onCancel: () => {
        throw new Error("User canceled the request");
      }
    };
    return await CNe(o), n;
  }
  async signMessage(t, r) {
    let n = "";
    const o = (r == null ? void 0 : r.toSignAddress) || this.$store.get().paymentAddress, i = {
      payload: {
        network: {
          type: QT(this.network)
        },
        address: o,
        message: t
      },
      onFinish: (a) => {
        n = a;
      },
      onCancel: () => {
        throw new Error("User canceled the request");
      }
    };
    return await PNe(i), n;
  }
  async signPsbt({
    psbtBase64: t,
    broadcast: r,
    finalize: n,
    inputsToSign: o
  }) {
    try {
      const i = Yr.fromBase64(String(t), {
        network: pn(this.network)
      }).data.inputs;
      let a = {};
      if (o)
        a = o.reduce(
          (g, b) => ({
            ...g,
            [b.address]: [...g[b.address] || [], b.index]
          }),
          {}
        );
      else {
        const { address: g, paymentAddress: b } = this.$store.get(), w = {
          [g]: []
        }, E = {
          [b]: []
        };
        for (let _ of i.keys()) {
          const O = i[_];
          if (O.witnessUtxo === void 0) {
            E[b].push(Number(_));
            continue;
          }
          const { script: C } = O.witnessUtxo, I = J2(
            C,
            pn(this.network)
          );
          I === b ? E[b].push(Number(_)) : I === g && w[g].push(Number(_));
        }
        w[g].length > 0 && (a = { ...a, ...w }), E[b].length > 0 && (a = { ...a, ...E });
      }
      let u, l, d, f;
      const h = await lw.request("signPsbt", {
        psbt: t,
        broadcast: !!r,
        signInputs: a
      });
      if (h.status === "success")
        f = Yr.fromBase64(h.result.psbt, {
          network: pn(this.network)
        }), u = h.result.txid;
      else
        throw h.error.code === lw.RpcErrorCode.USER_REJECTION ? new Error("User canceled the request") : new Error("Error signing psbt");
      if (!f)
        throw new Error("Error signing psbt");
      return n && !u ? (f.finalizeAllInputs(), l = f.toHex(), d = f.toBase64()) : (l = f.toHex(), d = f.toBase64()), {
        signedPsbtHex: l,
        signedPsbtBase64: d,
        txId: u
      };
    } catch (i) {
      throw console.error(i), i;
    }
  }
}
const $Ne = "OKX_CONNECTED_WALLET_STATE";
class UNe extends Ju {
  constructor(t, r, n) {
    super(t, r, n), ut(this, "observer"), ut(this, "$valueStore", Xg(
      $Ne,
      {
        address: "",
        paymentAddress: "",
        paymentPublicKey: "",
        publicKey: "",
        balance: ""
      }
    )), ut(this, "removeSubscriber");
  }
  get library() {
    var t, r;
    let n;
    return this.network === ua || this.network === Ta || this.network === Fs || this.network === us ? n = (t = window == null ? void 0 : window.okxwallet) == null ? void 0 : t.bitcoinTestnet : (this.network === zn || this.network === ih) && (n = (r = window == null ? void 0 : window.okxwallet) == null ? void 0 : r.bitcoin), n;
  }
  get network() {
    return this.$network.get();
  }
  restorePersistedValues() {
    const t = this.$valueStore.get();
    for (const r of j0)
      r === "balance" && this.$store.setKey(r, BigInt(t[r])), this.$store.setKey(r, t[r]);
    this.$store.setKey(
      "accounts",
      [t.address, t.paymentAddress].filter(Boolean)
    );
  }
  watchStateChange(t, r, n) {
    Wg(S1, t, n, this.$valueStore);
  }
  initialize() {
    var t;
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var r;
      this.library && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [S1]: !0
      }), (r = this.observer) == null || r.disconnect());
    }), (t = this.observer) == null || t.observe(document, { childList: !0, subtree: !0 })), Zu(this.$store, ["provider"], (r) => {
      r.provider !== S1 ? this.removeSubscriber && (this.$valueStore.set({
        address: "",
        paymentAddress: "",
        paymentPublicKey: "",
        publicKey: "",
        balance: ""
      }), this.removeSubscriber(), this.removeSubscriber = void 0) : this.removeSubscriber = this.$store.subscribe(
        this.watchStateChange.bind(this)
      );
    });
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect();
  }
  async connect(t) {
    const { address: r, paymentAddress: n } = this.$valueStore.get();
    if (r)
      if (r.startsWith("tb1") && mv(this.network))
        this.disconnect();
      else {
        this.restorePersistedValues(), m0(n, this.network).then((o) => {
          this.$store.setKey("balance", o);
        });
        return;
      }
    try {
      const o = await this.library.connect();
      if (!o) throw new Error("No accounts found");
      this.$store.setKey("address", o.address), this.$store.setKey("paymentAddress", o.address), this.$store.setKey("publicKey", o.publicKey), this.$store.setKey("paymentPublicKey", o.publicKey), this.$store.setKey("accounts", [o]);
    } catch (o) {
      throw o;
    }
  }
  async requestAccounts() {
    const t = this.library, r = this.network;
    return r === ua || r === Ta || r === us ? await t.connect() : await t.requestAccounts();
  }
  async getNetwork() {
    const { address: t } = this.$store.get(), r = this.network;
    if (t.slice(0, 1) === "t")
      return r === ua ? ua : r === Ta ? Ta : r === Fs ? Fs : r === us ? us : ua;
    const n = await this.library.getNetwork();
    return aTe(n);
  }
  async getPublicKey() {
    const t = this.library;
    return await (t == null ? void 0 : t.getPublicKey());
  }
  async getInscriptions(t, r) {
    const n = t || 0, o = r || 10;
    return (await this.library.getInscriptions(n, o)).list.map((i) => N1(i, void 0, this.network));
  }
  async sendBTC(t, r) {
    const n = await this.library.sendBitcoin(t, r);
    if (!n) throw new Error("Transaction failed");
    return n;
  }
  async signMessage(t, r) {
    const n = this.library, o = (r == null ? void 0 : r.protocol) === pv ? RE : r == null ? void 0 : r.protocol;
    return await (n == null ? void 0 : n.signMessage(t, o));
  }
  async signPsbt({ psbtHex: t, broadcast: r, finalize: n, inputsToSign: o }) {
    const i = await this.library.signPsbt(t, KE({
      autoFinalized: n,
      toSignInputs: o
    })), a = Yr.fromHex(i);
    if (n && r) {
      const u = await this.pushPsbt(i);
      return {
        signedPsbtHex: a.toHex(),
        signedPsbtBase64: a.toBase64(),
        txId: u
      };
    }
    return {
      signedPsbtHex: a.toHex(),
      signedPsbtBase64: a.toBase64(),
      txId: void 0
    };
  }
}
const RNe = "MAGIC_EDEN_CONNECTED_WALLET_STATE";
class zNe extends Ju {
  constructor(t, r, n) {
    super(t, r, n), ut(this, "observer"), ut(this, "$valueStore", Xg(
      RNe,
      {
        address: "",
        paymentAddress: "",
        paymentPublicKey: "",
        publicKey: "",
        balance: ""
      }
    )), ut(this, "removeSubscriber");
  }
  get library() {
    var t;
    return (t = window == null ? void 0 : window.magicEden) == null ? void 0 : t.bitcoin;
  }
  get network() {
    return this.$network.get();
  }
  restorePersistedValues() {
    const t = this.$valueStore.get();
    for (const r of j0) {
      if (r === "balance") {
        this.$store.setKey(r, BigInt(t[r]));
        continue;
      }
      this.$store.setKey(r, t[r]);
    }
    this.$store.setKey(
      "accounts",
      [t.address, t.paymentAddress].filter(Boolean)
    );
  }
  watchStateChange(t, r, n) {
    Wg(
      Gl,
      t,
      n,
      this.$valueStore
    );
  }
  initialize() {
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var t, r;
      (t = window == null ? void 0 : window.magicEden) != null && t.bitcoin && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [Gl]: !0
      }), (r = this.observer) == null || r.disconnect());
    }), this.observer.observe(document, { childList: !0, subtree: !0 })), Zu(this.$store, ["provider"], (t) => {
      t.provider !== Gl ? this.removeSubscriber && (this.$valueStore.set({
        address: "",
        paymentAddress: "",
        paymentPublicKey: "",
        publicKey: "",
        balance: ""
      }), this.removeSubscriber(), this.removeSubscriber = void 0) : this.removeSubscriber = this.$store.subscribe(
        this.watchStateChange.bind(this)
      );
    });
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect();
  }
  async connect(t) {
    const { address: r, paymentAddress: n } = this.$valueStore.get();
    try {
      if (r)
        if (r.startsWith("tb1") && mv(this.network))
          this.disconnect();
        else {
          m0(n, this.network).then((i) => {
            this.$store.setKey("balance", i);
          }), this.restorePersistedValues();
          return;
        }
      if (iY(this.network))
        throw new Error(`${this.network} is not supported by ${Gl}`);
      let o = JT(this.network || zn);
      await LCe({
        getProvider: async () => this.library,
        payload: {
          purposes: ["ordinals", "payment"],
          message: "Connecting with lasereyes",
          network: {
            type: o
          }
        },
        onFinish: (i) => {
          const a = S5(i.addresses), u = T5(i.addresses);
          if (!a || !u)
            throw new Error("No address found");
          a && u && (this.$store.setKey("address", a.address), this.$store.setKey("paymentAddress", u.address), this.$store.setKey("accounts", [
            a.address,
            u.address
          ])), this.$store.setKey(
            "publicKey",
            String(i.addresses[0].publicKey)
          ), this.$store.setKey(
            "paymentPublicKey",
            String(i.addresses[1].publicKey)
          );
        },
        onCancel: () => {
          throw new Error(`User canceled lasereyes to ${Gl} wallet`);
        },
        onError: (i) => {
          throw new Error(`Can't lasereyes to ${Gl} wallet`);
        }
      });
    } catch (o) {
      throw o;
    }
  }
  async sendBTC(t, r) {
    let n;
    if (await YBe({
      getProvider: async () => this.library,
      payload: {
        network: {
          type: JT(
            this.network
          )
        },
        recipients: [
          {
            address: t,
            amountSats: BigInt(r)
          }
        ],
        senderAddress: this.$store.get().paymentAddress
      },
      onFinish: (o) => {
        n = o;
      },
      onCancel: () => {
        throw console.error("Request canceled"), new Error("User canceled the request");
      }
    }), !n) throw new Error("Error sending BTC");
    return n.txid;
  }
  async signMessage(t, r) {
    try {
      const n = (r == null ? void 0 : r.toSignAddress) || this.$store.get().paymentAddress;
      let o = "";
      return await ZBe({
        getProvider: async () => this.library,
        payload: {
          network: {
            type: Aa.Mainnet
          },
          address: n,
          message: t,
          protocol: (r == null ? void 0 : r.protocol) === pv ? w0.ECDSA : w0.BIP322
        },
        onFinish: (i) => {
          o = i;
        },
        onCancel: () => {
          throw console.error("Request canceled"), new Error("User canceled the request");
        }
      }), o;
    } catch (n) {
      throw n;
    }
  }
  async signPsbt({
    psbtBase64: t,
    broadcast: r,
    finalize: n,
    inputsToSign: o
  }) {
    const i = Yr.fromBase64(String(t), {
      network: pn(this.network)
    }), a = i.data.inputs;
    let u = [];
    if (o) {
      const w = o.reduce(
        (E, _) => ({
          ...E,
          [_.address]: [...E[_.address] || [], _.index]
        }),
        {}
      );
      u = Object.entries(w).map(
        ([E, _]) => ({
          address: E,
          signingIndexes: _
        })
      );
    } else {
      const { address: w, paymentAddress: E } = this.$store.get(), _ = {
        address: w,
        signingIndexes: []
      }, O = {
        address: E,
        signingIndexes: []
      };
      for (let C of a.keys()) {
        const I = a[C];
        if (I.witnessUtxo === void 0) {
          O.signingIndexes.push(Number(C));
          continue;
        }
        const { script: S } = I.witnessUtxo, T = J2(
          S,
          pn(this.network)
        );
        T === E ? (O.signingIndexes.push(Number(C)), I.sighashType && (console.log("Updating sigHash for paymentsAddressData"), O.sigHash = I.sighashType)) : T === w && (_.signingIndexes.push(Number(C)), I.sighashType && (console.log("Updating sigHash for ordinalAddressData"), _.sigHash = I.sighashType));
      }
      _.signingIndexes.length > 0 && u.push(_), O.signingIndexes.length > 0 && u.push(O);
    }
    let l, d, f, h;
    const g = JT(this.network), b = {
      getProvider: async () => this.library,
      payload: {
        network: {
          type: g
        },
        message: "Sign Transaction",
        psbtBase64: i.toBase64(),
        broadcast: r,
        inputsToSign: u
      },
      onFinish: async (w) => {
        w.psbtBase64 && (h = Yr.fromBase64(String(w.psbtBase64), {
          network: pn(this.network)
        }), d = h.toHex(), f = h.toBase64());
      },
      onCancel: () => {
        throw console.log("Canceled"), new Error("User canceled the request");
      },
      onError: (w) => {
        throw console.log("error", w), w;
      }
    };
    if (await JBe(b), !h)
      throw new Error("signature failed");
    return n || r ? (h.finalizeAllInputs(), {
      signedPsbtHex: h.toHex(),
      signedPsbtBase64: f,
      txId: l
    }) : {
      signedPsbtHex: d,
      signedPsbtBase64: f,
      txId: l
    };
  }
}
class jNe extends Ju {
  constructor(t, r, n) {
    super(t, r, n), ut(this, "observer");
  }
  get library() {
    var t;
    return (t = window == null ? void 0 : window.phantom) == null ? void 0 : t.bitcoin;
  }
  get network() {
    return this.$network.get();
  }
  initialize() {
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var t;
      this.library && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [Id]: !0
      }), (t = this.observer) == null || t.disconnect());
    }), this.observer.observe(document, { childList: !0, subtree: !0 })), Zu(this.$store, ["provider"], (t) => {
      t.provider === Id && this.library.requestAccounts().then((r) => {
        this.handleAccountsChanged(r);
      });
    });
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect();
  }
  handleAccountsChanged(t) {
    if (!t.length) {
      this.parent.disconnect();
      return;
    }
    this.$store.get().accounts[0] !== t[0] && (this.$store.setKey("accounts", t), t.length > 0 ? this.parent.connect(Id) : this.parent.disconnect());
  }
  async connect(t) {
    if (!this.library) throw new Error("Phantom isn't installed");
    if (iY(this.network))
      throw new Error(`${this.network} is not supported by ${Id}`);
    const r = await this.library.requestAccounts();
    if (!r) throw new Error("No accounts found");
    this.$store.setKey("accounts", r);
    const n = r.find(
      (i) => i.purpose === "ordinals"
    ), o = r.find(
      (i) => i.purpose === "payment"
    );
    this.$store.setKey("address", n.address), this.$store.setKey("paymentAddress", o.address), this.$store.setKey("publicKey", n.publicKey), this.$store.setKey("paymentPublicKey", o.publicKey), this.$store.setKey("provider", Id), this.$store.setKey("connected", !0);
  }
  async getNetwork() {
    return this.$store.get().address.slice(0, 1) === "t" ? ua : zn;
  }
  async sendBTC(t, r) {
    const { psbtHex: n, psbtBase64: o } = await GN(
      this.$store.get().address,
      this.$store.get().paymentAddress,
      t,
      r,
      this.$store.get().paymentPublicKey,
      this.network,
      7
    ), i = await this.signPsbt({
      psbtBase64: o,
      psbtHex: n,
      tx: n,
      broadcast: !0,
      finalize: !0
    });
    if (!i) throw new Error("Error sending BTC");
    return i.txId;
  }
  async signMessage(t, r) {
    var n;
    if ((r == null ? void 0 : r.protocol) === pv)
      throw new Error("ECDSA signing is not supported by Phantom");
    const o = new TextEncoder().encode(t), i = new Uint8Array(o), a = (r == null ? void 0 : r.toSignAddress) || this.$store.get().paymentAddress, u = await ((n = this.library) == null ? void 0 : n.signMessage(a, i)), l = String.fromCharCode(...u.signature);
    return btoa(l);
  }
  async signPsbt({
    psbtHex: t,
    broadcast: r,
    finalize: n,
    inputsToSign: o
  }) {
    const i = Yr.fromHex(String(t), {
      network: pn(this.network)
    }).data.inputs;
    let a = [];
    if (o) {
      const d = o.reduce(
        (f, h) => ({
          ...f,
          [h.address]: [...f[h.address] || [], h.index]
        }),
        {}
      );
      a = Object.entries(d).map(
        ([f, h]) => ({
          address: f,
          signingIndexes: h
        })
      );
    } else {
      const { address: d, paymentAddress: f } = this.$store.get(), h = {
        address: d,
        signingIndexes: []
      }, g = {
        address: f,
        signingIndexes: []
      };
      for (let b of i.keys()) {
        const w = i[b];
        if (w.witnessUtxo === void 0) {
          g.signingIndexes.push(Number(b));
          continue;
        }
        const { script: E } = w.witnessUtxo, _ = J2(
          E,
          pn(this.network)
        );
        _ === f ? g.signingIndexes.push(Number(b)) : _ === d && h.signingIndexes.push(Number(b));
      }
      h.signingIndexes.length > 0 && a.push(h), g.signingIndexes.length > 0 && a.push(g);
    }
    const u = await this.library.signPSBT(
      GPe(t),
      {
        inputsToSign: a
      }
    ), l = Yr.fromBuffer(u);
    if (n && a.forEach((d) => {
      d.signingIndexes.forEach((f) => {
        l.finalizeInput(f);
      });
    }), r) {
      const d = await this.pushPsbt(l.toHex());
      return {
        signedPsbtHex: l.toHex(),
        signedPsbtBase64: l.toBase64(),
        txId: d
      };
    }
    return {
      signedPsbtHex: l.toHex(),
      signedPsbtBase64: l.toBase64(),
      txId: void 0
    };
  }
  async requestAccounts() {
    return await this.library.requestAccounts();
  }
}
class LNe extends Ju {
  constructor(t, r, n) {
    super(t, r, n), ut(this, "observer");
  }
  get library() {
    return window == null ? void 0 : window.opnet;
  }
  get network() {
    return this.$network.get();
  }
  initialize() {
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var t;
      this.library && (this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [Pd]: !0
      }), (t = this.observer) == null || t.disconnect());
    }), this.observer.observe(document, { childList: !0, subtree: !0 })), Zu(this.$store, ["provider"], (t) => {
      if (t.provider !== Pd) {
        this.removeListeners();
        return;
      }
      this.library.getAccounts().then((r) => {
        this.handleAccountsChanged(r);
      }), this.addListeners();
    });
  }
  addListeners() {
    this.library.on("accountsChanged", this.handleAccountsChanged.bind(this)), this.library.on("networkChanged", this.handleNetworkChanged.bind(this));
  }
  removeListeners() {
    var t, r;
    this.library && ((t = this.library) == null || t.removeListener(
      "accountsChanged",
      this.handleAccountsChanged.bind(this)
    ), (r = this.library) == null || r.removeListener(
      "networkChanged",
      this.handleNetworkChanged.bind(this)
    ));
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect(), this.removeListeners();
  }
  handleAccountsChanged(t) {
    if (!t.length) {
      this.parent.disconnect();
      return;
    }
    this.$store.get().accounts[0] !== t[0] && (this.$store.setKey("accounts", t), t.length > 0 ? this.parent.connect(Pd) : this.parent.disconnect());
  }
  handleNetworkChanged(t) {
    const r = _5(t);
    this.network !== r && this.switchNetwork(r), this.parent.connect(Pd);
  }
  async connect(t) {
    if (!this.library) throw new Error("OP_NET isn't installed");
    const r = await this.library.requestAccounts();
    if (!r) throw new Error("No accounts found");
    const n = await this.library.getPublicKey();
    if (!n) throw new Error("No public key found");
    this.$store.setKey("accounts", r), this.$store.setKey("address", r[0]), this.$store.setKey("paymentAddress", r[0]), this.$store.setKey("publicKey", n), this.$store.setKey("paymentPublicKey", n), this.$store.setKey("provider", Pd), await this.getNetwork().then((o) => {
      var i;
      ((i = this.config) == null ? void 0 : i.network) !== o && this.switchNetwork(o);
    }), this.$store.setKey("connected", !0);
  }
  async getNetwork() {
    var t;
    const r = await ((t = this.library) == null ? void 0 : t.getChain());
    return r ? _5(r.enum) : this.network;
  }
  async sendBTC(t, r) {
    var n;
    const o = await ((n = this.library) == null ? void 0 : n.sendBitcoin(t, r));
    if (!o) throw new Error("Transaction failed");
    return o;
  }
  async signMessage(t, r) {
    var n;
    const o = (r == null ? void 0 : r.protocol) === KN ? RE : r == null ? void 0 : r.protocol;
    return await ((n = this.library) == null ? void 0 : n.signMessage(t, o));
  }
  async signPsbt({ psbtHex: t, broadcast: r, finalize: n, inputsToSign: o }) {
    var i;
    const a = await ((i = this.library) == null ? void 0 : i.signPsbt(t, KE({
      autoFinalized: n,
      toSignInputs: o
    }))), u = Yr.fromHex(a);
    if (n && r) {
      const l = await this.pushPsbt(a);
      return {
        signedPsbtHex: u.toHex(),
        signedPsbtBase64: u.toBase64(),
        txId: l
      };
    }
    return {
      signedPsbtHex: u.toHex(),
      signedPsbtBase64: u.toBase64(),
      txId: void 0
    };
  }
  async getPublicKey() {
    var t;
    return await ((t = this.library) == null ? void 0 : t.getPublicKey());
  }
  async getBalance() {
    return (await this.library.getBalance()).total;
  }
  async getInscriptions(t, r) {
    return await this.library.getInscriptions(t, r);
  }
  async requestAccounts() {
    return await this.library.requestAccounts();
  }
  async switchNetwork(t) {
    var r;
    const n = qZ(t);
    await ((r = this.library) == null ? void 0 : r.switchChain(n)), this.$network.set(t);
  }
}
const I8 = {};
function Db(e) {
  if (I8[e])
    return console.warn(`Multiple requests for "${e}" detected`), I8[e];
  const t = new Promise((r) => {
    const n = console.log;
    console.log = (...o) => {
      o.length > 0 && typeof o[0] == "string" && (console.log = n, I8[e] = void 0, r(o[0]));
    }, n(
      `Please log a value for "${e}" using 
 console.log('<your-value>') 
 to continue.`
    );
  });
  return I8[e] = t, t;
}
class HNe {
  async requestAccounts() {
    const t = await Db("address");
    if (!t) throw new Error("No address provided");
    const r = await Db("paymentAddress");
    if (!r) throw new Error("No payment address provided");
    return [t, r];
  }
  async signMessage(t) {
    return console.log("sign this message in sparrow wallet:"), console.log(""), console.log(`${t}`), console.log(""), await Db("message to sign");
  }
  async signPsbt(t) {
    return console.log("sign this in sparrow wallet:"), console.log(""), console.log(`${t}`), console.log(""), await Db("signed psbt hex");
  }
  async getPublicKey() {
    const t = await Db("publicKey");
    if (!t) throw new Error("No public key provided");
    return t;
  }
  // TODO: Implement network switching between mainnet and testnet
  async getNetwork() {
    return "mainnet";
  }
  async switchNetwork(t) {
  }
}
const FNe = "SPARROW_CONNECTED_WALLET_STATE";
class MNe extends Ju {
  constructor() {
    super(...arguments), ut(this, "observer"), ut(this, "$valueStore", Xg(
      FNe,
      {
        address: "",
        paymentAddress: "",
        paymentPublicKey: "",
        publicKey: "",
        balance: ""
      }
    )), ut(this, "removeSubscriber");
  }
  get library() {
    return window == null ? void 0 : window.SparrowWalletProvider;
  }
  get network() {
    return this.$network.get();
  }
  initialize() {
    typeof window < "u" && typeof document < "u" && (this.observer = new window.MutationObserver(() => {
      var t;
      this.library || (window.SparrowWalletProvider = new HNe()), this.$store.setKey("hasProvider", {
        ...this.$store.get().hasProvider,
        [jp]: !0
      }), (t = this.observer) == null || t.disconnect();
    }), this.observer.observe(document, { childList: !0, subtree: !0 })), Zu(this.$store, ["provider"], (t) => {
      t.provider !== jp ? this.removeSubscriber && (this.$valueStore.set({
        address: "",
        paymentAddress: "",
        paymentPublicKey: "",
        publicKey: "",
        balance: ""
      }), this.removeSubscriber(), this.removeSubscriber = void 0) : this.removeSubscriber = this.$store.subscribe(
        this.watchStateChange.bind(this)
      );
    });
  }
  watchStateChange(t, r, n) {
    Wg(
      jp,
      t,
      n,
      this.$valueStore
    );
  }
  restorePersistedValues() {
    const t = this.$valueStore.get();
    for (const r of j0)
      r === "balance" && this.$store.setKey(r, BigInt(t[r])), this.$store.setKey(r, t[r]);
    this.$store.setKey(
      "accounts",
      [t.address, t.paymentAddress].filter(Boolean)
    );
  }
  dispose() {
    var t;
    (t = this.observer) == null || t.disconnect();
  }
  async connect(t) {
    try {
      const { address: r, paymentAddress: n } = this.$valueStore.get();
      if (r && n)
        if (r.startsWith("tb1") && mv(this.network))
          this.disconnect();
        else {
          this.restorePersistedValues();
          return;
        }
      if (!this.library) throw new Error("Sparrow wallet isn't supported");
      const o = await this.library.requestAccounts();
      if (!o) throw new Error("No accounts found");
      await this.getNetwork().then((a) => {
        this.network !== a && this.switchNetwork(this.network);
      });
      const i = await this.library.getPublicKey();
      if (!i) throw new Error("No public key found");
      this.$store.setKey("accounts", o), this.$store.setKey("address", o[0]), this.$store.setKey("paymentAddress", o[1]), this.$store.setKey("publicKey", i), this.$store.setKey("paymentPublicKey", i);
    } catch (r) {
      throw console.error("Error during sparrow connect:", r), r;
    }
  }
  async getNetwork() {
    return this.network;
  }
  async sendBTC(t, r) {
    const { psbtBase64: n } = await GN(
      this.$store.get().address,
      this.$store.get().paymentAddress,
      t,
      r,
      this.$store.get().paymentPublicKey,
      this.network,
      7
    ), o = await this.library.signPsbt(n);
    if (!o) throw new Error("No signed PSBT provided");
    const i = await this.pushPsbt(o);
    if (!i) throw new Error("send failed, no txid returned");
    return i;
  }
  async signMessage(t) {
    return await this.library.signMessage(t);
  }
  async signPsbt({ psbtBase64: t, broadcast: r, finalize: n }) {
    const o = Yr.fromBase64(t), i = await this.library.signPsbt(t);
    if (n && r) {
      const a = await this.pushPsbt(i);
      return {
        signedPsbtHex: i,
        signedPsbtBase64: o.toBase64(),
        txId: a
      };
    }
    return {
      signedPsbtHex: i,
      signedPsbtBase64: o.toBase64(),
      txId: void 0
    };
  }
  async getPublicKey() {
    const t = await this.library.getPublicKey();
    return this.$store.setKey("publicKey", t), t;
  }
  async getBalance() {
    const t = await m0(
      this.$store.get().paymentAddress,
      this.network
    );
    return this.$store.setKey("balance", t), t.toString();
  }
  async requestAccounts() {
    return await this.connect(jp), this.$store.get().accounts;
  }
}
class DNe {
  constructor(t, r) {
    ut(this, "$store"), ut(this, "$network"), ut(this, "$providerMap"), ut(this, "disposed", !1), ut(this, "dataSourceManager"), this.config = r, this.$store = t.$store, this.$network = t.$network, swe(this.$store), this.$providerMap = {
      [k1]: new sNe(t, this, r),
      [Gl]: new zNe(t, this, r),
      [S1]: new UNe(t, this, r),
      [Pd]: new LNe(t, this, r),
      [Od]: new NNe(t, this, r),
      [x1]: new iNe(t, this, r),
      [Id]: new jNe(t, this, r),
      [jp]: new MNe(t, this, r),
      [Up]: new KPe(t, this, r),
      [Rp]: new eNe(t, this, r),
      [zp]: new tNe(t, this, r)
    };
    try {
      this.dataSourceManager = e0.getInstance();
    } catch {
      e0.init(r), this.dataSourceManager = e0.getInstance();
    }
  }
  dispose() {
    this.disposed = !0;
    for (const t of Object.values(this.$providerMap))
      t.dispose();
  }
  initialize() {
    this.$network.listen(this.watchNetworkChange.bind(this)), Zu(this.$store, ["isInitializing"], (t, r) => {
      if (!this.disposed && t.isInitializing !== r.isInitializing)
        return this.handleIsInitializingChanged(t.isInitializing);
    }), this.checkNetwork(), qPe(() => this.$store.setKey("isInitializing", !1));
  }
  checkNetwork() {
    this.getNetwork().then((t) => {
      var r;
      t && (this.$network.set(t), this.dataSourceManager.updateNetwork(t));
      try {
        (r = this.config) != null && r.network && this.config.network !== t && this.switchNetwork(this.config.network);
      } catch (n) {
        console.error("Couldn't enforce config network", n), this.disconnect();
      }
    });
  }
  handleIsInitializingChanged(t) {
    if (typeof window < "u" && typeof localStorage < "u" && !t) {
      const r = localStorage == null ? void 0 : localStorage.getItem(
        hT
      );
      r && this.connect(r).then(() => {
        this.checkNetwork();
      });
    }
  }
  async connect(t) {
    if (this.disposed) {
      console.warn("Client disposed, cannot connect");
      return;
    }
    this.$store.setKey("isConnecting", !0);
    try {
      if (localStorage == null || localStorage.setItem(hT, t), !this.$providerMap[t])
        throw new Error("Unsupported wallet provider");
      const r = this.$providerMap[t];
      await (r == null ? void 0 : r.connect(t)), this.$store.setKey("connected", !0), this.$store.setKey("provider", t);
    } catch (r) {
      throw console.error("Error during connect:", r), this.$store.setKey("isConnecting", !1), this.disconnect(), r;
    } finally {
      this.$store.setKey("isConnecting", !1);
    }
  }
  async requestAccounts() {
    var t;
    const r = this.$store.get().provider;
    if (!r)
      throw new Error("No wallet provider connected");
    try {
      return await ((t = this.$providerMap[r]) == null ? void 0 : t.requestAccounts());
    } catch (n) {
      throw n instanceof Error && n.message.toLowerCase().includes("not implemented") ? new Error("The connected wallet doesn't support this method") : n;
    }
  }
  disconnect() {
    this.$store.set({
      provider: void 0,
      address: "",
      paymentAddress: "",
      publicKey: "",
      paymentPublicKey: "",
      balance: void 0,
      accounts: [],
      connected: !1,
      isConnecting: !1,
      isInitializing: !1,
      hasProvider: this.$store.get().hasProvider
    }), localStorage == null || localStorage.removeItem(hT);
  }
  async switchNetwork(t) {
    var r;
    try {
      const n = this.$store.get().provider;
      n && (await ((r = this.$providerMap[n]) == null ? void 0 : r.switchNetwork(t)), this.dataSourceManager.updateNetwork(t));
    } catch (n) {
      throw n instanceof Error && n.message.toLowerCase().includes("not implemented") ? (this.disconnect(), new Error(
        "The connected wallet doesn't support programmatic network changes.."
      )) : n;
    }
  }
  watchNetworkChange() {
    this.$store.setKey("balance", void 0), this.getBalance();
  }
  async getNetwork() {
    var t;
    const r = this.$store.get().provider;
    return r && this.$providerMap[r] ? await ((t = this.$providerMap[r]) == null ? void 0 : t.getNetwork()) : this.$network.get();
  }
  async sendBTC(t, r) {
    var n;
    if (r <= 0) throw new Error("Amount must be greater than 0");
    if (!Number.isInteger(r)) throw new Error("Amount must be an integer");
    const o = this.$store.get().provider;
    if (!o) throw new Error("No wallet connected");
    if (o && this.$providerMap[o])
      try {
        return await ((n = this.$providerMap[o]) == null ? void 0 : n.sendBTC(t, r));
      } catch (i) {
        throw i instanceof Error && i.message.toLowerCase().includes("not implemented") ? new Error(
          "The connected wallet doesn't support sending BTC..."
        ) : i;
      }
  }
  async signMessage(t, r) {
    var n;
    let o = {};
    typeof r == "string" ? o = { toSignAddress: r } : r && (o = r);
    const i = this.$store.get().provider;
    if (!i) throw new Error("No wallet connected");
    if (i && this.$providerMap[i])
      try {
        return await ((n = this.$providerMap[i]) == null ? void 0 : n.signMessage(t, o));
      } catch (a) {
        throw a instanceof Error && a.message.toLowerCase().includes("not implemented") ? new Error(
          "The connected wallet doesn't support message signing..."
        ) : a;
      }
  }
  async signPsbt(t, r, n) {
    var o;
    let i, a, u, l;
    typeof t == "string" ? (i = t, a = r ?? !1, u = n ?? !1) : (i = t.tx, a = t.finalize ?? !1, u = t.broadcast ?? !1, l = t.inputsToSign ?? []);
    let d, f;
    if (!i) throw new Error("No PSBT provided");
    if (APe(i))
      f = Yr.fromHex(i).toBase64(), d = i;
    else if (_Pe(i))
      f = i, d = Yr.fromBase64(i).toHex();
    else
      throw new Error("Invalid PSBT format");
    const h = this.$store.get().provider;
    if (h && this.$providerMap[h])
      try {
        return await ((o = this.$providerMap[h]) == null ? void 0 : o.signPsbt({
          psbtHex: d,
          psbtBase64: f,
          tx: i,
          broadcast: u,
          finalize: a,
          inputsToSign: l
        }));
      } catch (g) {
        throw g instanceof Error && g.message.toLowerCase().includes("not implemented") ? new Error(
          "The connected wallet doesn't support PSBT signing..."
        ) : g;
      }
    else
      throw new Error("No wallet provider connected");
  }
  async pushPsbt(t) {
    var r;
    const n = this.$store.get().provider;
    if (n && n && this.$providerMap[n])
      try {
        return await ((r = this.$providerMap[n]) == null ? void 0 : r.pushPsbt(t));
      } catch (o) {
        throw o instanceof Error && o.message.toLowerCase().includes("not implemented") ? new Error(
          "The connected wallet doesn't support PSBT signing..."
        ) : o;
      }
  }
  async inscribe(t, r) {
    var n;
    const o = this.$store.get().provider;
    if (o && o && this.$providerMap[o])
      try {
        return await ((n = this.$providerMap[o]) == null ? void 0 : n.inscribe(t, r));
      } catch (i) {
        throw i instanceof Error && i.message.toLowerCase().includes("not implemented") ? new Error(
          "The connected wallet doesn't support inscribing..."
        ) : i;
      }
  }
  async send(t, r) {
    var n;
    const o = this.$store.get().provider;
    if (o && o && this.$providerMap[o])
      try {
        return await ((n = this.$providerMap[o]) == null ? void 0 : n.send(t, r));
      } catch (i) {
        throw i instanceof Error && i.message.toLowerCase().includes("not implemented") ? new Error(
          "The connected wallet doesn't support sending stuff..."
        ) : i;
      }
  }
  async getPublicKey() {
    var t;
    const r = this.$store.get().provider;
    if (r && r && this.$providerMap[r])
      try {
        return await ((t = this.$providerMap[r]) == null ? void 0 : t.getPublicKey());
      } catch (n) {
        throw n instanceof Error && n.message.toLowerCase().includes("not implemented") ? new Error("The connected wallet doesn't support getPublicKey") : n;
      }
  }
  async getBalance() {
    const t = this.$store.get().provider;
    if (t && t && this.$providerMap[t])
      try {
        const r = await this.$providerMap[t].getBalance();
        return this.$store.setKey("balance", BigInt(r)), r;
      } catch (r) {
        throw r instanceof Error && r.message.toLowerCase().includes("not implemented") ? new Error("The connected wallet doesn't support getBalance") : r;
      }
  }
  async getMetaBalances(t) {
    const r = this.$store.get().provider;
    if (r && r && this.$providerMap[r])
      try {
        if (!t)
          throw new Error("No protocol provided");
        return await this.$providerMap[r].getMetaBalances(t);
      } catch (n) {
        throw n instanceof Error && n.message.toLowerCase().includes("not implemented") ? new Error("The connected wallet doesn't support getBalance") : n;
      }
  }
  async getInscriptions(t, r) {
    var n;
    const o = this.$store.get().provider;
    if (o && o && this.$providerMap[o])
      try {
        return await ((n = this.$providerMap[o]) == null ? void 0 : n.getInscriptions(t, r));
      } catch (i) {
        throw i instanceof Error && i.message.toLowerCase().includes("not implemented") ? new Error("The connected wallet doesn't support this method") : i;
      }
  }
  async sendInscriptions(t, r) {
    var n;
    const o = this.$store.get().provider;
    if (o && o && this.$providerMap[o])
      try {
        return await ((n = this.$providerMap[o]) == null ? void 0 : n.sendInscriptions(
          t,
          r
        ));
      } catch (i) {
        throw i instanceof Error && i.message.toLowerCase().includes("not implemented") ? new Error("The connected wallet doesn't support this method") : i;
      }
  }
}
const { $store: KNe, $network: qNe } = gY(), vi = {
  connect: async () => {
  },
  disconnect: () => {
  },
  getBalance: async () => "",
  getMetaBalances: async () => [],
  getInscriptions: async () => [],
  getNetwork: async () => "",
  getPublicKey: async () => "",
  pushPsbt: async () => "",
  signMessage: async () => "",
  requestAccounts: async () => [],
  sendBTC: async () => "",
  signPsbt: async () => ({
    signedPsbtBase64: "",
    signedPsbtHex: ""
  }),
  switchNetwork: async () => {
  },
  inscribe: async () => "",
  send: async () => "",
  sendInscriptions: async () => "",
  getUtxos: async () => []
}, aJ = uJ({
  $store: KNe,
  $network: qNe,
  client: null,
  methods: vi
});
function Gj(e, t) {
  return Object.keys(e).every(function(r) {
    return Object.prototype.hasOwnProperty.call(t, r) && (t[r] === e[r] || typeof e[r] == "number" && typeof t[r] == "number" && isNaN(t[r]) && isNaN(e[r]));
  });
}
function VNe(e, t) {
  return typeof e == "object" && typeof t == "object" ? Gj(e, t) && Gj(t, e) : e === t;
}
let TP = Symbol("clean"), du = [], md = 0;
const O8 = 4;
let J8 = 0, GNe = (e) => {
  let t = [], r = {
    get() {
      return r.lc || r.listen(() => {
      })(), r.value;
    },
    lc: 0,
    listen(n) {
      return r.lc = t.push(n), () => {
        for (let i = md + O8; i < du.length; )
          du[i] === n ? du.splice(i, O8) : i += O8;
        let o = t.indexOf(n);
        ~o && (t.splice(o, 1), --r.lc || r.off());
      };
    },
    notify(n, o) {
      J8++;
      let i = !du.length;
      for (let a of t)
        du.push(
          a,
          r.value,
          n,
          o
        );
      if (i) {
        for (md = 0; md < du.length; md += O8)
          du[md](
            du[md + 1],
            du[md + 2],
            du[md + 3]
          );
        du.length = 0;
      }
    },
    /* It will be called on last listener unsubscribing.
       We will redefine it in onMount and onStop. */
    off() {
    },
    set(n) {
      let o = r.value;
      o !== n && (r.value = n, r.notify(o));
    },
    subscribe(n) {
      let o = r.listen(n);
      return n(r.value), o;
    },
    value: e
  };
  return process.env.NODE_ENV !== "production" && (r[TP] = () => {
    t = [], r.lc = 0, r.off();
  }), r;
};
const WNe = 5, W0 = 6, P8 = 10;
let ZNe = (e, t, r, n) => (e.events = e.events || {}, e.events[r + P8] || (e.events[r + P8] = n((o) => {
  e.events[r].reduceRight((i, a) => (a(i), i), {
    shared: {},
    ...o
  });
})), e.events[r] = e.events[r] || [], e.events[r].push(t), () => {
  let o = e.events[r], i = o.indexOf(t);
  o.splice(i, 1), o.length || (delete e.events[r], e.events[r + P8](), delete e.events[r + P8]);
}), XNe = 1e3, YNe = (e, t) => ZNe(e, (r) => {
  let n = t(r);
  n && e.events[W0].push(n);
}, WNe, (r) => {
  let n = e.listen;
  e.listen = (...i) => (!e.lc && !e.active && (e.active = !0, r()), n(...i));
  let o = e.off;
  if (e.events[W0] = [], e.off = () => {
    o(), setTimeout(() => {
      if (e.active && !e.lc) {
        e.active = !1;
        for (let i of e.events[W0]) i();
        e.events[W0] = [];
      }
    }, XNe);
  }, process.env.NODE_ENV !== "production") {
    let i = e[TP];
    e[TP] = () => {
      for (let a of e.events[W0]) a();
      e.events[W0] = [], e.active = !1, i();
    };
  }
  return () => {
    e.listen = n, e.off = o;
  };
}), JNe = (e, t, r) => {
  Array.isArray(e) || (e = [e]);
  let n, o, i = () => {
    if (o === J8) return;
    o = J8;
    let d = e.map((f) => f.get());
    if (!n || d.some((f, h) => f !== n[h])) {
      n = d;
      let f = t(...d);
      f && f.then && f.t ? f.then((h) => {
        n === d && a.set(h);
      }) : (a.set(f), o = J8);
    }
  }, a = GNe(void 0), u = a.get;
  a.get = () => (i(), u());
  let l = i;
  return YNe(a, () => {
    let d = e.map((f) => f.listen(l));
    return i(), () => {
      for (let f of d) f();
    };
  }), a;
}, QNe = (e, t) => JNe(e, t), e$e = (e) => {
  e.listen(() => {
  });
};
const t$e = (e) => ({ ...e });
function pze(e) {
  const { $network: t, $store: r, methods: n, client: o } = cJ(
    aJ
  ), i = e ?? t$e, a = Xo(
    (f, h) => ({
      paymentAddress: f.paymentAddress,
      address: f.address,
      publicKey: f.publicKey,
      paymentPublicKey: f.paymentPublicKey,
      library: {},
      network: h,
      client: o,
      accounts: f.accounts,
      balance: f.balance ? Number(f.balance) : void 0,
      connected: f.connected,
      isConnecting: f.isConnecting,
      isInitializing: f.isInitializing,
      provider: f.provider,
      hasLeather: f.hasProvider.leather ?? !1,
      hasMagicEden: f.hasProvider["magic-eden"] ?? !1,
      hasOkx: f.hasProvider.okx ?? !1,
      hasOyl: f.hasProvider.oyl ?? !1,
      hasOrange: f.hasProvider.orange ?? !1,
      hasOpNet: f.hasProvider.op_net ?? !1,
      hasPhantom: f.hasProvider.phantom ?? !1,
      hasUnisat: f.hasProvider.unisat ?? !1,
      hasSparrow: f.hasProvider.sparrow ?? !1,
      hasWizz: f.hasProvider.wizz ?? !1,
      hasXverse: f.hasProvider.xverse ?? !1,
      ...n
    }),
    [o, n]
  ), u = C8(() => {
    const f = QNe([r, t], a);
    return e$e(f), f;
  }, [r, t, a]), [l, d] = Zj(() => i(u.get()));
  return Xj(() => {
    const f = u.listen((h) => {
      const g = i(h);
      VNe(g, l) || d(g);
    });
    return () => f();
  }, [u, i, l]), l;
}
function gze({
  config: e,
  children: t
}) {
  const r = C8(() => gY(), []), n = C8(
    () => VPe(e ?? { network: zn }),
    [e]
  ), [o, i] = Zj(null);
  Xj(() => {
    const U = new DNe(r, n);
    return i(() => U), U.initialize(), () => U.dispose();
  }, [n, r]);
  const a = Xo(
    async (U) => await (o == null ? void 0 : o.connect(U)),
    [o]
  ), u = Xo(() => o == null ? void 0 : o.disconnect(), [o]), l = Xo(
    async () => {
      var U;
      return ((U = await ((o == null ? void 0 : o.getBalance()) ?? vi.getBalance())) == null ? void 0 : U.toString()) ?? "";
    },
    [o]
  ), d = Xo(
    async (U) => await (o == null ? void 0 : o.getMetaBalances(U)) ?? vi.getMetaBalances(),
    [o]
  ), f = Xo(
    async (U, M) => await (o == null ? void 0 : o.getInscriptions(U, M)) ?? vi.getInscriptions(),
    [o]
  ), h = Xo(
    () => (o == null ? void 0 : o.getNetwork()) ?? vi.getNetwork(),
    [o]
  ), g = Xo(
    async () => await (o == null ? void 0 : o.getPublicKey()) ?? vi.getPublicKey(),
    [o]
  ), b = Xo(
    (U) => (o == null ? void 0 : o.pushPsbt(U)) ?? vi.pushPsbt(),
    [o]
  ), w = Xo(
    async (U, M) => {
      let Y = {};
      return typeof M == "string" ? Y = { toSignAddress: M } : M && (Y = M), await (o == null ? void 0 : o.signMessage(U, Y)) ?? vi.signMessage();
    },
    [o]
  ), E = Xo(
    async () => await (o == null ? void 0 : o.requestAccounts()) ?? vi.requestAccounts(),
    [o]
  ), _ = Xo(
    async (U, M) => await (o == null ? void 0 : o.sendBTC.call(o, U, M)) ?? vi.sendBTC(),
    [o]
  ), O = Xo(
    async (...U) => {
      var M, Y;
      if (typeof U[0] == "string") {
        const [L, ee, de] = U;
        return await ((M = o == null ? void 0 : o.signPsbt) == null ? void 0 : M.call(
          o,
          L,
          ee ?? !1,
          de ?? !1
        )) ?? vi.signPsbt();
      } else {
        const [L] = U;
        return await ((Y = o == null ? void 0 : o.signPsbt) == null ? void 0 : Y.call(o, L)) ?? vi.signPsbt();
      }
    },
    [o]
  ), C = Xo(
    async (U) => await (o == null ? void 0 : o.switchNetwork.call(o, U)),
    [o]
  ), I = Xo(
    async (U, M) => await (o == null ? void 0 : o.inscribe.call(o, U, M)) ?? vi.inscribe(),
    [o]
  ), S = Xo(
    async (U, M) => await (o == null ? void 0 : o.send.call(o, U, M)) ?? vi.send(),
    [o]
  ), T = Xo(
    async (U, M) => await (o == null ? void 0 : o.sendInscriptions.call(
      o,
      U,
      M
    )) ?? vi.sendInscriptions(),
    [o]
  ), A = Xo(
    async (U) => await (o == null ? void 0 : o.dataSourceManager.getAddressUtxos(U)) ?? vi.getUtxos(),
    [o]
  ), $ = C8(() => o ? {
    connect: a,
    disconnect: u,
    getBalance: l,
    getMetaBalances: d,
    getInscriptions: f,
    getNetwork: h,
    getPublicKey: g,
    pushPsbt: b,
    signMessage: w,
    requestAccounts: E,
    sendBTC: _,
    signPsbt: O,
    switchNetwork: C,
    inscribe: I,
    send: S,
    sendInscriptions: T,
    getUtxos: A
  } : vi, [
    o,
    a,
    u,
    l,
    f,
    d,
    h,
    g,
    I,
    b,
    E,
    S,
    _,
    T,
    w,
    O,
    C,
    A
  ]);
  return /* @__PURE__ */ ae(
    aJ.Provider,
    {
      value: {
        $store: r.$store,
        $network: r.$network,
        client: o,
        methods: $
      },
      children: t
    }
  );
}
const r$e = ({
  size: e = 42,
  variant: t = "first",
  className: r,
  ...n
}) => t === "first" ? /* @__PURE__ */ Lr(
  "svg",
  {
    className: r,
    width: e,
    height: e,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ ae(
        "rect",
        {
          width: "42",
          height: "42",
          rx: "10",
          fill: "#090A0C",
          style: { fill: "#090A0C", fillOpacity: 1 }
        }
      ),
      /* @__PURE__ */ ae(
        "path",
        {
          d: "M21 14C29.222 14 38 15.9676 38 20.9054C38 25.8622 29.222 28 21 28C12.778 28 4 26.0324 4 21.0946C4 16.1378 12.778 14 21 14ZM21.0397 25.3135C24.6939 25.3135 30.1752 24.3297 30.1752 21C30.1752 17.6703 24.6939 16.6865 21.0397 16.6865H20.9603C17.3061 16.6865 11.8248 17.6703 11.8248 21C11.8248 24.3297 17.3061 25.3135 20.9603 25.3135H21.0397Z",
          fill: "white",
          style: { fill: "white", fillOpacity: 1 }
        }
      )
    ]
  }
) : /* @__PURE__ */ Lr(
  "svg",
  {
    className: r,
    width: e,
    height: e,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ ae(
        "rect",
        {
          width: "42",
          height: "42",
          rx: "10",
          fill: "white",
          style: { fill: "white", fillOpacity: 1 }
        }
      ),
      /* @__PURE__ */ ae(
        "path",
        {
          d: "M21 14C29.222 14 38 15.9676 38 20.9054C38 25.8622 29.222 28 21 28C12.778 28 4 26.0324 4 21.0946C4 16.1378 12.778 14 21 14ZM21.0397 25.3135C24.6939 25.3135 30.1752 24.3297 30.1752 21C30.1752 17.6703 24.6939 16.6865 21.0397 16.6865H20.9603C17.3061 16.6865 11.8248 17.6703 11.8248 21C11.8248 24.3297 17.3061 25.3135 20.9603 25.3135H21.0397Z",
          fill: "#090A0C",
          style: { fill: "#090A0C", fillOpacity: 1 }
        }
      )
    ]
  }
), Wj = ({
  size: e = 42,
  variant: t = "first",
  className: r,
  ...n
}) => t === "first" ? /* @__PURE__ */ Lr(
  "svg",
  {
    className: r,
    width: e,
    height: e,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ ae("rect", { width: "128", height: "128", rx: "26.8387", fill: "#12100F" }),
      /* @__PURE__ */ ae(
        "path",
        {
          d: "M74.9171 52.7114C82.4766 51.5408 93.4087 43.5804 93.4087 37.3761C93.4087 35.5031 91.8968 34.2154 89.6871 34.2154C85.5004 34.2154 78.4061 40.5368 74.9171 52.7114ZM39.911 83.4991C30.0256 83.4991 29.2115 93.3324 39.0969 93.3324C43.5163 93.3324 48.8661 91.5764 51.6573 88.4157C47.5868 84.9038 44.2141 83.4991 39.911 83.4991ZM102.829 79.2848C103.41 95.7907 95.0369 105.039 80.8484 105.039C72.4748 105.039 68.2881 101.878 59.333 96.0249C54.681 101.176 45.8423 105.039 38.5154 105.039C13.2785 105.039 14.3252 72.8463 40.0273 72.8463C45.3771 72.8463 49.9128 74.2511 55.7277 77.88L59.5656 64.4177C43.7489 60.0864 35.8405 47.9118 43.6326 30.4693H56.1929C49.215 42.0586 53.9832 51.6578 62.822 52.7114C67.5903 35.7372 77.8246 22.509 91.4316 22.509C99.1074 22.509 105.155 27.5428 105.155 36.6737C105.155 51.3066 86.0819 63.2471 71.6607 64.4177L65.7295 85.3721C72.4748 93.2153 91.199 100.824 91.199 79.2848H102.829Z",
          fill: "#F5F1ED"
        }
      )
    ]
  }
) : /* @__PURE__ */ Lr(
  "svg",
  {
    className: r,
    width: e,
    height: e,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ ae("rect", { width: "128", height: "128", rx: "26.8387", fill: "#F5F1ED" }),
      /* @__PURE__ */ ae(
        "path",
        {
          d: "M74.9171 52.7115C82.4766 51.5409 93.4087 43.5806 93.4087 37.3762C93.4087 35.5032 91.8968 34.2155 89.6871 34.2155C85.5004 34.2155 78.4061 40.5369 74.9171 52.7115ZM39.911 83.4992C30.0256 83.4992 29.2115 93.3325 39.0969 93.3325C43.5163 93.3325 48.8661 91.5766 51.6573 88.4159C47.5868 84.904 44.2141 83.4992 39.911 83.4992ZM102.829 79.2849C103.41 95.7908 95.0369 105.039 80.8484 105.039C72.4748 105.039 68.2881 101.878 59.333 96.025C54.681 101.176 45.8423 105.039 38.5154 105.039C13.2785 105.039 14.3252 72.8464 40.0273 72.8464C45.3771 72.8464 49.9128 74.2512 55.7277 77.8801L59.5656 64.4179C43.7489 60.0865 35.8405 47.9119 43.6326 30.4695H56.1929C49.215 42.0587 53.9832 51.6579 62.822 52.7115C67.5903 35.7373 77.8246 22.5092 91.4316 22.5092C99.1074 22.5092 105.155 27.5429 105.155 36.6738C105.155 51.3068 86.0819 63.2472 71.6607 64.4179L65.7295 85.3722C72.4748 93.2155 91.199 100.825 91.199 79.2849H102.829Z",
          fill: "#12100F"
        }
      )
    ]
  }
), n$e = ({
  size: e = 42,
  variant: t = "first",
  className: r,
  ...n
}) => t === "first" ? /* @__PURE__ */ Lr(
  "svg",
  {
    className: r,
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    viewBox: "0 0 42 42",
    fill: "none",
    ...n,
    children: [
      /* @__PURE__ */ Lr("g", { clipPath: "url(#a)", children: [
        /* @__PURE__ */ ae(
          "path",
          {
            fill: "#AB9FF2",
            d: "M32 0H10C4.477 0 0 4.477 0 10v22c0 5.523 4.477 10 10 10h22c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10Z"
          }
        ),
        /* @__PURE__ */ ae(
          "path",
          {
            fill: "#FFFDF8",
            fillRule: "evenodd",
            d: "M17.686 27.567c-1.676 2.569-4.484 5.819-8.22 5.819-1.767 0-3.466-.728-3.466-3.887C6 21.454 16.984 9 27.176 9c5.798 0 8.108 4.023 8.108 8.59 0 5.864-3.805 12.568-7.587 12.568-1.2 0-1.79-.659-1.79-1.704 0-.273.046-.568.137-.887-1.291 2.205-3.783 4.25-6.116 4.25-1.698 0-2.559-1.068-2.559-2.568 0-.545.114-1.113.317-1.681Zm8.78-10.135c0 1.331-.786 1.997-1.664 1.997-.892 0-1.664-.666-1.664-1.997s.772-1.996 1.664-1.996c.878 0 1.663.665 1.663 1.996Zm4.99 0c0 1.331-.785 1.997-1.663 1.997-.892 0-1.664-.666-1.664-1.997 0-1.33.772-1.996 1.664-1.996.878 0 1.664.665 1.664 1.996Z",
            clipRule: "evenodd"
          }
        )
      ] }),
      /* @__PURE__ */ ae("defs", { children: /* @__PURE__ */ ae("clipPath", { id: "a", children: /* @__PURE__ */ ae("path", { fill: "#fff", d: "M0 0h42v42H0z" }) }) })
    ]
  }
) : /* @__PURE__ */ Lr(
  "svg",
  {
    className: r,
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    viewBox: "0 0 42 42",
    fill: "none",
    ...n,
    children: [
      /* @__PURE__ */ Lr("g", { clipPath: "url(#a)", children: [
        /* @__PURE__ */ ae(
          "path",
          {
            fill: "#FFFDF8",
            d: "M32 0H10C4.477 0 0 4.477 0 10v22c0 5.523 4.477 10 10 10h22c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10Z"
          }
        ),
        /* @__PURE__ */ ae(
          "path",
          {
            fill: "#AB9FF2",
            fillRule: "evenodd",
            d: "M17.686 27.567c-1.676 2.569-4.484 5.819-8.22 5.819-1.767 0-3.466-.728-3.466-3.887C6 21.454 16.984 9 27.176 9c5.798 0 8.108 4.023 8.108 8.59 0 5.864-3.805 12.568-7.587 12.568-1.2 0-1.79-.659-1.79-1.704 0-.273.046-.568.137-.887-1.291 2.205-3.783 4.25-6.116 4.25-1.698 0-2.559-1.068-2.559-2.568 0-.545.114-1.113.317-1.681Zm8.78-10.135c0 1.331-.786 1.997-1.664 1.997-.892 0-1.664-.666-1.664-1.997s.772-1.996 1.664-1.996c.878 0 1.663.665 1.663 1.996Zm4.99 0c0 1.331-.785 1.997-1.663 1.997-.892 0-1.664-.666-1.664-1.997 0-1.33.772-1.996 1.664-1.996.878 0 1.664.665 1.664 1.996Z",
            clipRule: "evenodd"
          }
        )
      ] }),
      /* @__PURE__ */ ae("defs", { children: /* @__PURE__ */ ae("clipPath", { id: "a", children: /* @__PURE__ */ ae("path", { fill: "#fff", d: "M0 0h42v42H0z" }) }) })
    ]
  }
), o$e = ({
  size: e = 42,
  variant: t = "first",
  className: r,
  ...n
}) => /* @__PURE__ */ Lr(
  "svg",
  {
    className: r,
    width: e,
    height: e,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ Lr("g", { clipPath: "url(#clip0_3_53)", children: [
        /* @__PURE__ */ ae(
          "path",
          {
            d: "M32 0H10C4.47715 0 0 4.47715 0 10V32C0 37.5228 4.47715 42 10 42H32C37.5228 42 42 37.5228 42 32V10C42 4.47715 37.5228 0 32 0Z",
            fill: "#181818"
          }
        ),
        /* @__PURE__ */ ae(
          "path",
          {
            d: "M32 31.6745V27.6829C32 27.5233 31.9203 27.3636 31.8406 27.2438L14.8225 10.1597C14.7029 10.0399 14.5435 10 14.3841 10H10.3986C10.1993 10 10.0399 10.1597 10.0399 10.3592V14.0715C10.0399 14.2311 10.1196 14.3908 10.1993 14.5105L16.2971 20.6177C16.4565 20.7774 16.4565 20.977 16.2971 21.1366L10.1196 27.3237C10.0399 27.4035 10 27.4834 10 27.5632V31.6346C10 31.8342 10.1594 31.9939 10.3587 31.9939H17.0544C17.2536 31.9939 17.413 31.8342 17.413 31.6346V29.2396C17.413 29.1598 17.4529 29.0401 17.5326 29.0002L20.8406 25.6871C21 25.5275 21.1993 25.5275 21.3587 25.6871L27.4964 31.8342C27.6159 31.954 27.7753 31.9939 27.9348 31.9939H31.6413C31.8406 32.0337 32 31.8741 32 31.6745Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ ae(
          "path",
          {
            d: "M23.3406 15.0793H26.5592C26.7507 15.0793 26.9039 15.2333 26.9039 15.4257V18.658C26.9039 18.9658 27.2871 19.1197 27.4788 18.8888L31.8851 14.4637C31.9617 14.3867 32 14.3097 32 14.2328V10.3463C32 10.1539 31.8468 10 31.6552 10H27.7469C27.6703 10 27.5554 10.0385 27.5171 10.1154L23.1107 14.5021C22.8808 14.6945 23.0341 15.0793 23.3406 15.0793Z",
            fill: "#EE7A30"
          }
        )
      ] }),
      /* @__PURE__ */ ae("defs", { children: /* @__PURE__ */ ae("clipPath", { id: "clip0_3_53", children: /* @__PURE__ */ ae("rect", { width: "42", height: "42", fill: "white" }) }) })
    ]
  }
), i$e = ({
  size: e = 42,
  variant: t = "first",
  className: r,
  ...n
}) => /* @__PURE__ */ Lr(
  "svg",
  {
    className: r,
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    viewBox: "0 0 42 42",
    fill: "none",
    ...n,
    children: [
      /* @__PURE__ */ Lr("g", { clipPath: "url(#a)", children: [
        /* @__PURE__ */ ae(
          "path",
          {
            fill: "#000",
            d: "M32 0H10C4.477 0 0 4.477 0 10v22c0 5.523 4.477 10 10 10h22c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10Z"
          }
        ),
        /* @__PURE__ */ ae(
          "path",
          {
            fill: "url(#b)",
            d: "m25.517 9.483 5.759 5.611c.49.477.731.959.724 1.445-.008.486-.219.929-.631 1.33-.431.421-.897.634-1.395.644-.497.007-.992-.228-1.482-.705l-5.89-5.738c-.669-.652-1.315-1.114-1.936-1.385a2.873 2.873 0 0 0-1.96-.127c-.685.185-1.42.662-2.21 1.428-1.086 1.06-1.605 2.054-1.552 2.983.053.929.593 1.893 1.617 2.89l5.938 5.786c.496.482.74.964.732 1.443-.008.48-.22.923-.64 1.332-.419.408-.88.62-1.382.638-.502.016-1.001-.217-1.495-.7l-5.76-5.61c-.936-.912-1.613-1.776-2.029-2.59-.416-.815-.572-1.737-.464-2.765.097-.88.384-1.732.863-2.558.477-.827 1.161-1.671 2.048-2.537C15.43 9.268 16.438 8.48 17.4 7.93c.96-.55 1.889-.854 2.786-.917.899-.064 1.784.112 2.66.527.876.415 1.765 1.061 2.67 1.943h.002Z"
          }
        ),
        /* @__PURE__ */ ae(
          "path",
          {
            fill: "url(#c)",
            d: "m16.482 32.123-5.758-5.611c-.49-.479-.731-.959-.724-1.445.008-.486.219-.929.631-1.33.431-.421.897-.634 1.395-.644.498-.007.992.227 1.482.705l5.888 5.738c.671.652 1.315 1.114 1.936 1.385.622.27 1.276.312 1.962.127.685-.185 1.42-.662 2.21-1.43 1.086-1.06 1.605-2.054 1.552-2.983-.053-.929-.593-1.893-1.617-2.891l-3.164-3.056c-.496-.482-.74-.964-.732-1.443.008-.48.22-.923.64-1.332.419-.408.88-.62 1.382-.638.502-.016 1.002.217 1.496.7l2.983 2.88c.936.912 1.613 1.775 2.03 2.59.415.815.571 1.736.463 2.764a6.477 6.477 0 0 1-.863 2.559c-.477.826-1.16 1.67-2.048 2.536-1.057 1.03-2.066 1.819-3.027 2.368-.962.55-1.89.856-2.79.92-.898.063-1.784-.113-2.66-.527-.876-.415-1.765-1.062-2.67-1.944l.003.002Z"
          }
        ),
        /* @__PURE__ */ ae(
          "path",
          {
            fill: "url(#d)",
            d: "M20.073 17.645c1.168 0 2.115-.93 2.115-2.08 0-1.149-.947-2.08-2.115-2.08-1.168 0-2.115.931-2.115 2.08 0 1.15.947 2.08 2.115 2.08Z"
          }
        )
      ] }),
      /* @__PURE__ */ Lr("defs", { children: [
        /* @__PURE__ */ Lr(
          "linearGradient",
          {
            id: "b",
            x1: 30.329,
            x2: 12.579,
            y1: 12.752,
            y2: 20.772,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ ae("stop", { stopColor: "#201C1B" }),
              /* @__PURE__ */ ae("stop", { offset: 0.36, stopColor: "#77390D" }),
              /* @__PURE__ */ ae("stop", { offset: 0.67, stopColor: "#EA8101" }),
              /* @__PURE__ */ ae("stop", { offset: 1, stopColor: "#F4B852" })
            ]
          }
        ),
        /* @__PURE__ */ Lr(
          "linearGradient",
          {
            id: "c",
            x1: 12.163,
            x2: 32.789,
            y1: 29.085,
            y2: 22.844,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ ae("stop", { stopColor: "#1F1D1C" }),
              /* @__PURE__ */ ae("stop", { offset: 0.37, stopColor: "#77390D" }),
              /* @__PURE__ */ ae("stop", { offset: 0.67, stopColor: "#EA8101" }),
              /* @__PURE__ */ ae("stop", { offset: 1, stopColor: "#F4FB52" })
            ]
          }
        ),
        /* @__PURE__ */ Lr(
          "radialGradient",
          {
            id: "d",
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "matrix(2.11484 0 0 2.08019 20.073 15.567)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ ae("stop", { stopColor: "#F4B852" }),
              /* @__PURE__ */ ae("stop", { offset: 0.33, stopColor: "#EA8101" }),
              /* @__PURE__ */ ae("stop", { offset: 0.64, stopColor: "#77390D" }),
              /* @__PURE__ */ ae("stop", { offset: 1, stopColor: "#211C1D" })
            ]
          }
        ),
        /* @__PURE__ */ ae("clipPath", { id: "a", children: /* @__PURE__ */ ae("path", { fill: "#fff", d: "M0 0h42v42H0z" }) })
      ] })
    ]
  }
), a$e = ({
  size: e = 42,
  variant: t = "first",
  className: r,
  ...n
}) => /* @__PURE__ */ Lr(
  "svg",
  {
    className: r,
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    viewBox: "0 0 42 42",
    fill: "none",
    ...n,
    children: [
      /* @__PURE__ */ Lr("g", { clipPath: "url(#a)", children: [
        /* @__PURE__ */ ae(
          "path",
          {
            fill: "#000",
            d: "M32 0H10C4.477 0 0 4.477 0 10v22c0 5.523 4.477 10 10 10h22c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10Z"
          }
        ),
        /* @__PURE__ */ Lr("g", { fillRule: "evenodd", clipPath: "url(#b)", clipRule: "evenodd", children: [
          /* @__PURE__ */ ae(
            "path",
            {
              fill: "#FFD815",
              d: "m26.507 17.74-1.623-1.623-1.624 1.623 1.623 1.623 1.624 1.624 1.623-1.624-1.623-1.623Z"
            }
          ),
          /* @__PURE__ */ ae(
            "path",
            {
              fill: "#FF9813",
              d: "m26.507 8-1.624 1.623 1.624 1.624 1.623-1.624L26.507 8ZM33 14.493l-1.623-1.623-1.624 1.623 1.624 1.623L33 14.493ZM23.26 27.48l1.623 1.623 1.624-1.623-1.623-1.624-1.624 1.624ZM11.897 16.117l1.623 1.623 1.623-1.623-1.623-1.624-1.623 1.624ZM20.014 8 18.39 9.623l1.624 1.624 1.623-1.624L20.014 8ZM13.52 11.247l1.624 1.623 1.623-1.623-1.623-1.624-1.624 1.624ZM31.377 19.363l-1.624 1.623 1.624 1.624L33 20.987l-1.623-1.624ZM28.13 25.856l1.623 1.624 1.624-1.624-1.624-1.623-1.623 1.623Z"
            }
          ),
          /* @__PURE__ */ ae(
            "path",
            {
              fill: "#5B5B72",
              d: "m26.507 20.986-1.624-1.623-1.623 1.623-1.623-1.623-1.623-1.623 1.623-1.624-1.623-1.623-1.624-1.623-1.623 1.623 1.623 1.623-1.623 1.624 1.623 1.623-1.623 1.623-.812-.811-1.623 1.623 1.623 1.623-1.623 1.624-1.543 1.542-1.542 1.543-1.624 1.623L8 31.377 9.623 33l1.624-1.623 1.623-1.624 1.543-1.542.08-.08 1.462-1.463.08-.08 1.544-1.543 1.623 1.623 1.623-1.623-.811-.812 1.623-1.623 1.623 1.623 1.623-1.623 1.624 1.623 1.623-1.623-1.623-1.624Z"
            }
          ),
          /* @__PURE__ */ ae(
            "path",
            {
              fill: "#FF9813",
              d: "m26.507 14.493-1.624-1.623-1.623 1.623-1.623-1.623-1.623 1.623 1.623 1.623-1.623 1.624 1.623 1.623 1.623 1.623 1.623-1.623-1.623-1.623 1.623-1.623 1.624 1.623 1.623-1.623-1.623-1.624Z"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ Lr("defs", { children: [
        /* @__PURE__ */ ae("clipPath", { id: "a", children: /* @__PURE__ */ ae("path", { fill: "#fff", d: "M0 0h42v42H0z" }) }),
        /* @__PURE__ */ ae("clipPath", { id: "b", children: /* @__PURE__ */ ae("path", { fill: "#fff", d: "M8 8h25v25H8z" }) })
      ] })
    ]
  }
), s$e = ({
  size: e = 42,
  variant: t = "first",
  className: r,
  ...n
}) => /* @__PURE__ */ Lr(
  "svg",
  {
    className: r,
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    viewBox: "0 0 42 42",
    fill: "none",
    ...n,
    children: [
      /* @__PURE__ */ Lr("g", { clipPath: "url(#a)", children: [
        /* @__PURE__ */ ae(
          "path",
          {
            fill: "#000",
            d: "M32 0H10C4.477 0 0 4.477 0 10v22c0 5.523 4.477 10 10 10h22c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10Z"
          }
        ),
        /* @__PURE__ */ ae("g", { fill: "#fff", clipPath: "url(#b)", children: /* @__PURE__ */ ae("path", { d: "M24.578 17.052h-6.787a.523.523 0 0 0-.52.52v6.788c0 .286.235.52.52.52h6.787c.286 0 .521-.234.521-.52v-6.787a.523.523 0 0 0-.52-.521ZM16.733 9.223H9.946a.523.523 0 0 0-.521.521v6.787c0 .286.235.521.52.521h6.788c.285 0 .52-.235.52-.52V9.743a.523.523 0 0 0-.52-.52ZM32.424 9.223h-6.787a.523.523 0 0 0-.521.521v6.787c0 .286.235.521.52.521h6.788c.286 0 .52-.235.52-.52V9.743a.523.523 0 0 0-.52-.52ZM16.733 24.898H9.946a.523.523 0 0 0-.521.52v6.788c0 .285.235.52.52.52h6.788c.285 0 .52-.235.52-.52v-6.788a.523.523 0 0 0-.52-.52ZM32.424 24.898h-6.787a.523.523 0 0 0-.521.52v6.788c0 .285.235.52.52.52h6.788c.286 0 .52-.235.52-.52v-6.788a.523.523 0 0 0-.52-.52Z" }) })
      ] }),
      /* @__PURE__ */ Lr("defs", { children: [
        /* @__PURE__ */ ae("clipPath", { id: "a", children: /* @__PURE__ */ ae("path", { fill: "#fff", d: "M0 0h42v42H0z" }) }),
        /* @__PURE__ */ ae("clipPath", { id: "b", children: /* @__PURE__ */ ae("path", { fill: "#fff", d: "M0 0h42v42H0z" }) })
      ] })
    ]
  }
), u$e = ({
  size: e = 42,
  variant: t = "first",
  className: r,
  ...n
}) => /* @__PURE__ */ Lr(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    className: r,
    viewBox: "0 0 42 42",
    fill: "none",
    ...n,
    children: [
      /* @__PURE__ */ Lr("g", { clipPath: "url(#clip0_17_93)", children: [
        /* @__PURE__ */ ae(
          "path",
          {
            fill: "#070C34",
            d: "M32 0H10C4.477 0 0 4.477 0 10v22c0 5.523 4.477 10 10 10h22c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10Z"
          }
        ),
        /* @__PURE__ */ ae(
          "path",
          {
            fill: "url(#paint0_linear_17_93)",
            d: "m27.666 16.837 1.874 2.177c.215.245.404.446.483.562.56.55.874 1.293.874 2.07-.053.915-.657 1.54-1.213 2.205l-1.311 1.521-.685.79a.184.184 0 0 0 .046.281c.033.02.07.028.107.026h6.835c1.045 0 2.36.868 2.283 2.184 0 .597-.247 1.171-.68 1.595a2.36 2.36 0 0 1-1.637.664H23.936c-.704 0-2.598.076-3.128-1.521a1.841 1.841 0 0 1-.043-1.035 4.5 4.5 0 0 1 .72-1.404 65.543 65.543 0 0 1 1.695-2.343c.741-1.002 1.503-1.971 2.251-2.992a.19.19 0 0 0 .04-.116.19.19 0 0 0-.04-.116l-2.72-3.156a.192.192 0 0 0-.153-.073.192.192 0 0 0-.152.073c-.728.96-3.917 5.203-4.598 6.063-.68.86-2.355.907-3.283 0l-4.255-4.161a.197.197 0 0 0-.1-.053.195.195 0 0 0-.2.082.192.192 0 0 0-.032.106v8a2.678 2.678 0 0 1-.494 1.594c-.33.466-.804.823-1.352 1.014a2.375 2.375 0 0 1-2.111-.293 2.271 2.271 0 0 1-.72-.805A2.22 2.22 0 0 1 5 28.736V14.349a2.416 2.416 0 0 1 .548-1.422c.33-.406.785-.7 1.298-.841a2.632 2.632 0 0 1 2.502.664l6.54 6.381c.019.02.043.034.07.043a.197.197 0 0 0 .161-.013.188.188 0 0 0 .061-.054l4.646-6.27c.215-.254.485-.46.79-.601.304-.142.636-.217.976-.221H34.68c.33 0 .657.07.959.204a2.31 2.31 0 0 1 1.263 1.409c.096.309.122.633.079.952a2.288 2.288 0 0 1-.813 1.42c-.439.364-.996.56-1.572.551h-6.768a.188.188 0 0 0-.163.099.187.187 0 0 0-.022.095c0 .032.013.065.032.093h-.008Z"
          }
        )
      ] }),
      /* @__PURE__ */ Lr("defs", { children: [
        /* @__PURE__ */ Lr(
          "linearGradient",
          {
            id: "paint0_linear_17_93",
            x1: "-0.315",
            x2: "35.366",
            y1: "9.343",
            y2: "30.176",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ ae("stop", { offset: "0.23", stopColor: "#FF0074" }),
              /* @__PURE__ */ ae("stop", { offset: "0.26", stopColor: "#FF0068" }),
              /* @__PURE__ */ ae("stop", { offset: "0.32", stopColor: "#FF0048" }),
              /* @__PURE__ */ ae("stop", { offset: "0.39", stopColor: "#FF0015" }),
              /* @__PURE__ */ ae("stop", { offset: "0.41", stopColor: "#FF0009" }),
              /* @__PURE__ */ ae("stop", { offset: "0.43", stopColor: "#FF0908" }),
              /* @__PURE__ */ ae("stop", { offset: "0.54", stopColor: "#FF4003" }),
              /* @__PURE__ */ ae("stop", { offset: "0.62", stopColor: "#FF6201" }),
              /* @__PURE__ */ ae("stop", { offset: "0.66", stopColor: "#FF6F00" }),
              /* @__PURE__ */ ae("stop", { offset: "0.72", stopColor: "#FF8700" }),
              /* @__PURE__ */ ae("stop", { offset: "0.83", stopColor: "#FFAB00" }),
              /* @__PURE__ */ ae("stop", { offset: "0.92", stopColor: "#FFC100" }),
              /* @__PURE__ */ ae("stop", { offset: "0.98", stopColor: "#FFCA00" })
            ]
          }
        ),
        /* @__PURE__ */ ae("clipPath", { id: "clip0_17_93", children: /* @__PURE__ */ ae("path", { fill: "#fff", d: "M0 0h42v42H0z" }) })
      ] })
    ]
  }
), c$e = ({
  size: e = 42,
  variant: t = "first",
  className: r,
  ...n
}) => /* @__PURE__ */ Lr(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: e,
    height: e,
    viewBox: "0 0 42 42",
    ...n,
    children: [
      /* @__PURE__ */ Lr("defs", { children: [
        /* @__PURE__ */ ae("clipPath", { id: "clip1", children: /* @__PURE__ */ ae("path", { d: "M 9.433594 0 L 32.566406 0 C 37.777344 0 42 4.222656 42 9.433594 L 42 32.566406 C 42 37.777344 37.777344 42 32.566406 42 L 9.433594 42 C 4.222656 42 0 37.777344 0 32.566406 L 0 9.433594 C 0 4.222656 4.222656 0 9.433594 0 Z M 9.433594 0 " }) }),
        /* @__PURE__ */ Lr(
          "radialGradient",
          {
            id: "radial0",
            gradientUnits: "userSpaceOnUse",
            cx: 0,
            cy: 0,
            fx: 0,
            fy: 0,
            r: 1,
            gradientTransform: "matrix(0.000000000000001938,31.643555,-31.643555,0.000000000000001938,21,5.578125)",
            children: [
              /* @__PURE__ */ ae(
                "stop",
                {
                  offset: 0,
                  style: {
                    stopColor: "rgb(5.098039%,5.490196%,7.058824%)",
                    stopOpacity: 1
                  }
                }
              ),
              /* @__PURE__ */ ae(
                "stop",
                {
                  offset: 1,
                  style: {
                    stopColor: "rgb(0%,0%,0%)",
                    stopOpacity: 1
                  }
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ ae(
          "image",
          {
            id: "image91",
            width: 42,
            height: 42,
            xlinkHref: "data:image/png;base64,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"
          }
        ),
        /* @__PURE__ */ ae(
          "filter",
          {
            id: "alpha",
            filterUnits: "objectBoundingBox",
            x: "0%",
            y: "0%",
            width: "100%",
            height: "100%",
            children: /* @__PURE__ */ ae(
              "feColorMatrix",
              {
                type: "matrix",
                in: "SourceGraphic",
                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
              }
            )
          }
        ),
        /* @__PURE__ */ ae(
          "image",
          {
            id: "image170",
            width: 42,
            height: 42,
            xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAABmJLR0QA/wD/AP+gvaeTAAACtklEQVRYhWNgGAWjYBSMglEwCkYcmGslLagZ26TedkTUMOD/H11nY2a5Sb+/sJBiBiOtHMfAwMCg73JCaNrNdN2kh/eF0eXKFXf+qZBhvfbqqMkdYsxior7zGBjUK65yXtwsbBq4/7wDNkcyMDAwdN53ZxE87KQX4tNtRIyZVA1Rc3M7ZpZn5eoNd1lVc1hCmInVJ7ov4fwRl0n38amhWoiyP3kmPbfVyfXNw0gNUhzJwMDA8D/3q1bnt2a8bqE4RFPWPhRMLPDTwxXFxIKtN84cUdFSe4VLnuwQhaVDmbBtjpQ6koGBgWHPo6d8+ORJKiIYGBDp0CgsQTXM4Dczw+9y8l2HBB4kJFEv6p2NmeVYi1m170ewcVLmLEzw6HHhye/yjU9xyRMV9XaXNnLcmHTA9slpbhNaONLtgvpfZV5TnOmTgYGIEP3LGciWdPSB/QmDu7zUcxoquNv66c6fWoZL+NQQDNFwZysdWjpS8mnzhzsL664RUoc3M9ld2sixVWiFvBz13IUC2HjqXtzv4z+jcCf/DyG1eKOeb66bnGTiCRPqOQ0Ccpjzvq3gTr5y9IviE2L14I163YZ8HsqdhQDP3hn9vf8m5tq3r+y7SHEkAwOBqH/ncPYvZU6DgEjWToYZ/8UefWbsusrwd9p3ckpevCEqdNL9E5lug4N58opvn6zy2v/iX/AZhr8nv5NrDl6H7vx0/ZXyhqBf5BisuOLXdxnTr2esH188OCdY/j15zkMAguUoX8haFclViXrEGvjsndHfn/+0bjbzSN4q56r9R5nzEICoKlQvzsrk54IreEspWDp8wdh1lZIoxgWIrusrJBTVpl6R15QSOofR1qzc+eH1kW+Pr1AjiqkCJv3+wuJszCwnwaeq23ZE1JC9Q0ktq+09/0C7axSMglEwCkbBKKA/AABq8ekilgplTAAAAABJRU5ErkJggg=="
          }
        ),
        /* @__PURE__ */ ae("mask", { id: "mask0", children: /* @__PURE__ */ ae("g", { filter: "url(#alpha)", children: /* @__PURE__ */ ae("use", { xlinkHref: "#image170" }) }) }),
        /* @__PURE__ */ ae(
          "image",
          {
            id: "image125",
            width: 42,
            height: 42,
            xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAABmJLR0QA/wD/AP+gvaeTAAAEF0lEQVRYhe2WTYscVRSGn3NvVXdPzySabwQN2SlGkQgjCC4EFWMU/A+CG925EhN0JSiof8BtxC8SSVZZiK7MRjRElPwEF8Ik0z3d9XXPOS6qJhM1pHucGXHRLxRFN9Sth/d977kFCy200EILLfR/kvwXL/n69NFvs6Y56MmGjUIlsU55TK9998eT866xp6DfvHTkcm9Snop1epBkqDuNQulCHWNT9Xq/s5FOv/7rxo1Za2V7AXjhzLEv+pPy5ODm+KSoSlQDdZI5GCQVCtdcKzuuw/5V4MCsNXfV0S9feeD8YKM4vlKVq5J0kJsR3Ajq4JAcygSjBOMkbEhEl3Ky+5dGb/6wdt+91t41Ry8+f+jS8tr6M3nTHNwEjO5EBxdwQFwIAcBxcxSjqY1Q6vKs9XcMevHMka+WxtPV/mh8IqiSWwcISJdXCIFkYIB5+5/jaHJSdIJa3DPQCy8f+3w4nj7auzl6PDYq0YzMncwcCYBDkIAByaAxaBxq2/pdG6iC2ez3bRv0dg/X1p8KSfu5GcGMgBMFEBAEFyG1ewg1qB3qBJVCqU6lLbDOCbEt0AvPHbyyf219Nd7Rw+BOJrQOGnjnYrfRW/e8A0zOVJ0iQaFQK7hu1WHHoJ+9ePTKynjy8HC0cSIzpff3HhpICLc7qNbu8Mah0TbmonEKc6YJxg1MGiikBWiH1g5Bz79w7Pul9Y3Hsro+nJkykLv38E4HN11sNmO21sVJgo0E0wSlQQpCiELMg+4Y1CfFQxTN4dyULBhBWhfv1sOmm5W1Qp2c0pxSaSEVyqaNfCqCBSH2I/kg03wQZ87ze4J++uzhn8NocsJUMTcQcAOTgPtfY07eRlwlpzYo7ujitLuXBjWCx0DWjwxX8rRvf+5vXV3r7Qg01WlfXVmM6m2sgAQB6SB9K+5aodqMWWHadIDWXgnBsoDkgf4g08Ew0+u/jT++DO/MgpwJqrUNK3OkcfIAwQR1QLbibiHbmKvOvYlCqVAZ1CZoDHge6PWi5ctZWh5mcvanW/15AOcCTU5UBVOQbozkAuCdm23MlbbRFtqe5UWCMggmAoNA7EUfLGVpaZhx7tr6tgDnArUQaFyoVUjm1Or0usPuzsgLawHL7rSpRPAQyHqRwXKWloaZvXt99K8A5wINecg0hFQgWZmEQpzYQOiiT9qC1d7GnOSfPfzlxviDS8Z7O4GEOT7z3n9i/6hcr/bV0wZJRugect8aRykIEgOSBXr9aPnwdg9n7uZdA3018MapR1Y+KTaaflMlUmrnknePexQkD/Ty6P1hloZLkXPX1ncNcG5QgI+ePlSMxrVURerVlYl3oCEIsRfo92MaDqKf3QPAbYFu6sPVA1XdKEk9OEgWxXt54O0fb+V7BbjQQgsttNBC/0/9CbvrotNPsOneAAAAAElFTkSuQmCC"
          }
        ),
        /* @__PURE__ */ ae(
          "image",
          {
            id: "image142",
            width: 42,
            height: 42,
            xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAABmJLR0QA/wD/AP+gvaeTAAAAmklEQVRYhe2U0QqAIBAE1/7/n+tFIaQyur21aAdEX4RhDgWMMemUul7BkciZ3JopMqKXGhWcJltOzldMkS3dfhe5bOTBSGWXwF3pjxARBYSyUVFAJMsQBQSyLNF0mKKpVdlF02R/OfpGStWsonTZX4++Qa3qohVaVRfdQanqoh3hqi7KRikaGr+LslGLPh6/i7KxKBuLsvmM6AZK+AVU/UCtAQAAAABJRU5ErkJggg=="
          }
        ),
        /* @__PURE__ */ ae("mask", { id: "mask1", children: /* @__PURE__ */ ae("g", { filter: "url(#alpha)", children: /* @__PURE__ */ ae(
          "rect",
          {
            x: 0,
            y: 0,
            width: 42,
            height: 42,
            style: {
              fill: "rgb(0%,0%,0%)",
              fillOpacity: 0.6,
              stroke: "none"
            }
          }
        ) }) }),
        /* @__PURE__ */ ae(
          "image",
          {
            id: "image148",
            width: 42,
            height: 42,
            xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAABmJLR0QA/wD/AP+gvaeTAAAEI0lEQVRYhe3XTW4kuREF4I9kZqX+7B61gAFGR5CWPsucZ9zn6Sv4Ct5ZfQAv1IABuaftaUlVmWR4kZS6tPKitBjDegCRZBaT9RA/Lxi84Q1veMMbDkF6msTTPPChz28kP+NTX99+3/+MSwGuhI+47utfhETS169BNEgvCF5JPkluJZeSO8lF/+3rHtl3ncSdcCHcCpfCjXAtXpPs8ILkjeRa8kVyJ7uUkE0SknvJuz2idzgWJg3hUkNzLlxpPiBEJOlQsilI/txJnu+RI7tXJPl5TJKtZJaMwiRshdCE5lhF8141aT4LNL+IlA4jml+QnGRfFQwejE6Mso1qMplwpDl2tj6POTKZVJNs49GIwd8NPituJVfSc0gdgAFcd9d+lb1T/GpwrPhmlAyKwaKoiiy7lxTxsNX626paDDJmZ9At/hd80Q4lmt30pCErsgdFMUg2Tm1kR5IjyYlwKpwa+zOcSk40xzbdst9sMLhXDD2Ufj6UJsOe/GRniq3BHwxmG4uNbFKMFhvJICua1L+omA3mHsfJpsflieY3zZ32LG8HEf0keS/5Z0+gSTEbVWNfTZpJ6cRDUSRNqKowS7bmrh5VM/dwyKqLZ48dSPR2T3pWCsXOIPdEaibVUSe9urVKslAsmkHuKlBVG7MHA93Kt3KXrQOJ/gnfJA/dootiUIRBMqg2hp75q2WH7vjAIssDbVlUYbE1SP2cU0k93Jor0c/doqw2mCRNlrtMMQijbBRGYUDWRElSJRYWydzTsXhUjJLHfu7d4WTz8+xYspEsUo/B78KvOzo6kbyGSE2KppT9fbV/v3StuH8di+b/vuX3ge9EH4SdMAhVyF1mnsYabVXrI9QSa2bX/X2lfz8Ij8LJ69yesp+EP/bDRmHutbuqWDzFXzMXdpoZO9murlV/HWHp9WmVplk46udevMLtyV+td8roFhlUO1W2CItit+a2VJNQ1C74a9aHnWRnsFN7mZi79R+Ef4leUg8keim8F/4h/KiiShbVjNKTg6RZVHlP8Jsqm4WtpRN+tGiq0ndcam5fw6JXwifhx27RrWoy00siqxgtandz2RP8JptVs9HWbKeYHVlQewmN5y7gIKIfcd4vvb+piuTfXU/HnhBh0SxjUebaLVp7smXLJsy7MCt2dmajxb2qai6Eq9cguvY4659WyZnqV0kI30SX/8Fonmu/SDdPJaIJdRe95ofFqRmLE9Vd99LHQ2k+ydNN73cWzVfVD6sFLXaKrerR4MHkXnP/4jl4UD0abTU7T0qxhlF77p8OxP9QK8La2l6LfhNvflLdqU7Mjs0WO5Ote1uTrTOPJlt3/f1i57i7nMXfNOf9rN6JHoohWbtEIXwA4Vzq7W9yqdlKziQnXrbLT0K+Fc722uUvXUleubd/wxve8IY3/B/gP+5/MI8x65+AAAAAAElFTkSuQmCC"
          }
        ),
        /* @__PURE__ */ ae("mask", { id: "mask2", children: /* @__PURE__ */ ae("g", { filter: "url(#alpha)", children: /* @__PURE__ */ ae(
          "rect",
          {
            x: 0,
            y: 0,
            width: 42,
            height: 42,
            style: {
              fill: "rgb(0%,0%,0%)",
              fillOpacity: 0.701961,
              stroke: "none"
            }
          }
        ) }) }),
        /* @__PURE__ */ ae(
          "image",
          {
            id: "image154",
            width: 42,
            height: 42,
            xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAABmJLR0QA/wD/AP+gvaeTAAAA/ElEQVRYhe2VwW7DIAxAn9M0qcSN///G3JDaFEIPwRvqoUHdWKXJT/IhMokeNiZgGIZhGIZh/EPkVTLnLGWNxvD0Ti6xAVlEtk6eDA1rBDgBZ2ACZu/9DMzleSz5lm+9zVFFh0pyrELYK5m89/dlWSIQRWT9lOipiE1VnCvRCKwaInLtJXrULj2Xdesn4EJpvXPuT1o/NqxR2Vp4YB+gLYSgki+781PeqUL+dYsGWkT1+tmAxH4uNZJzLpVc1w0ctV4lE3Dne4i+himEEEu+2x0KxxV9Fr0B1ypu3vuVvbpdRVv+TDpEGvXmdBMJ2EQkdvI0DMMwDMMwjI/yAInrT4nWGUiJAAAAAElFTkSuQmCC"
          }
        ),
        /* @__PURE__ */ ae(
          "image",
          {
            id: "image160",
            width: 42,
            height: 42,
            xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAABmJLR0QA/wD/AP+gvaeTAAACY0lEQVRYhe2W227iQBBEj7mFcAkbZf3/HxjtLUtCAtjeh6laN9YSDCHSPkxLrZE92BzXVPcM5MiRI0eOj0RxzZc1TeP3FcBAoxOgCWOtsSmKouFEjD4JcNgZBx3ASlmH688FFWQEHAJj5Uhp0ArYA7uQvv85oAGw6ABOgClwoxwLtBbkG/CqhNYO1wUNy+wl7QLeAjPlNIBWgnzRM9Bz2c8CPeJDL/GNAOfAIuSt5gG2AbImLfuW1hYfBz3iw4kApyT1FsBSeafraQDb6P8q0rKPNder87wL2sOHBlwIzrnU3ESvsnJb2iKL7ety0H+oOOoAzgW0HA6Hd1VVrXS90NxEz+5JBdNtUXG8HDRClmU5fnx8dKFEBVfAqqoqqzjXhxiyInnR1e7c6r576VVADWkFV8ovSvvxluRZ+24PvA0Gg+e6rn8DzjXJr1v9phfoexVnX45JKs0FdQ98BUqN97o/04c3AlwDP+u6/g58U/4Q7AvwWpblri/oUSM3TeO2MyMpeQ88CO6BpOZSH2FAL/ELSbkn4JfySfkXFKlaFMX+FGifpXcRuVc6b8Lz7okb4FkwT51cC3Cjj7F3r+JRwxrYhwz0B1vawogqRvUi4GsAdCFdbQv1i7zd7Wj36SFtA19zqOSapK4V7FZ6DdDniHcKtKHtdTv92YZUXA1JJTS34bCqnzn0oQErzjiDngPqE4/95y1wQ7s1Rm9GwK4P60sA+4LGpfZRzft0EeattgHdIw98eCnkOaDQqudjm+/5IOzCioBn+fAjoPZnhPZhwqD2XlfBi5c5R44cOXLkyJHjv40/gQUmD3HnzocAAAAASUVORK5CYII="
          }
        ),
        /* @__PURE__ */ ae("mask", { id: "mask3", children: /* @__PURE__ */ ae("g", { filter: "url(#alpha)", children: /* @__PURE__ */ ae(
          "rect",
          {
            x: 0,
            y: 0,
            width: 42,
            height: 42,
            style: {
              fill: "rgb(0%,0%,0%)",
              fillOpacity: 0.2,
              stroke: "none"
            }
          }
        ) }) }),
        /* @__PURE__ */ ae(
          "image",
          {
            id: "image166",
            width: 42,
            height: 42,
            xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAABmJLR0QA/wD/AP+gvaeTAAACY0lEQVRYhe2W227iQBBEj7mFcAkbZf3/HxjtLUtCAtjeh6laN9YSDCHSPkxLrZE92BzXVPcM5MiRI0eOj0RxzZc1TeP3FcBAoxOgCWOtsSmKouFEjD4JcNgZBx3ASlmH688FFWQEHAJj5Uhp0ArYA7uQvv85oAGw6ABOgClwoxwLtBbkG/CqhNYO1wUNy+wl7QLeAjPlNIBWgnzRM9Bz2c8CPeJDL/GNAOfAIuSt5gG2AbImLfuW1hYfBz3iw4kApyT1FsBSeafraQDb6P8q0rKPNder87wL2sOHBlwIzrnU3ESvsnJb2iKL7ety0H+oOOoAzgW0HA6Hd1VVrXS90NxEz+5JBdNtUXG8HDRClmU5fnx8dKFEBVfAqqoqqzjXhxiyInnR1e7c6r576VVADWkFV8ovSvvxluRZ+24PvA0Gg+e6rn8DzjXJr1v9phfoexVnX45JKs0FdQ98BUqN97o/04c3AlwDP+u6/g58U/4Q7AvwWpblri/oUSM3TeO2MyMpeQ88CO6BpOZSH2FAL/ELSbkn4JfySfkXFKlaFMX+FGifpXcRuVc6b8Lz7okb4FkwT51cC3Cjj7F3r+JRwxrYhwz0B1vawogqRvUi4GsAdCFdbQv1i7zd7Wj36SFtA19zqOSapK4V7FZ6DdDniHcKtKHtdTv92YZUXA1JJTS34bCqnzn0oQErzjiDngPqE4/95y1wQ7s1Rm9GwK4P60sA+4LGpfZRzft0EeattgHdIw98eCnkOaDQqudjm+/5IOzCioBn+fAjoPZnhPZhwqD2XlfBi5c5R44cOXLkyJHjv40/gQUmD3HnzocAAAAASUVORK5CYII="
          }
        ),
        /* @__PURE__ */ ae("clipPath", { id: "clip2", children: /* @__PURE__ */ ae("rect", { x: 0, y: 0, width: 42, height: 42 }) }),
        /* @__PURE__ */ Lr("g", { id: "surface169", clipPath: "url(#clip2)", children: [
          /* @__PURE__ */ ae("use", { xlinkHref: "#image125" }),
          /* @__PURE__ */ ae("use", { xlinkHref: "#image142" }),
          /* @__PURE__ */ ae("use", { xlinkHref: "#image148", mask: "url(#mask1)" }),
          /* @__PURE__ */ ae("use", { xlinkHref: "#image154", mask: "url(#mask2)" }),
          /* @__PURE__ */ ae("use", { xlinkHref: "#image160" }),
          /* @__PURE__ */ ae("use", { xlinkHref: "#image166", mask: "url(#mask3)" })
        ] })
      ] }),
      /* @__PURE__ */ ae("g", { id: "surface1", children: /* @__PURE__ */ Lr("g", { clipPath: "url(#clip1)", clipRule: "nonzero", children: [
        /* @__PURE__ */ ae(
          "path",
          {
            style: {
              stroke: "none",
              fillRule: "nonzero",
              fill: "url(#radial0)"
            },
            d: "M 9.433594 0 L 32.566406 0 C 37.777344 0 42 4.222656 42 9.433594 L 42 32.566406 C 42 37.777344 37.777344 42 32.566406 42 L 9.433594 42 C 4.222656 42 0 37.777344 0 32.566406 L 0 9.433594 C 0 4.222656 4.222656 0 9.433594 0 Z M 9.433594 0 "
          }
        ),
        /* @__PURE__ */ ae("use", { xlinkHref: "#image42" }),
        /* @__PURE__ */ ae("use", { xlinkHref: "#image91" }),
        /* @__PURE__ */ ae("use", { xlinkHref: "#surface169", mask: "url(#mask0)" })
      ] }) })
    ]
  }
), l$e = [
  { transform: "translate(40.2375 0.627991) rotate(90)", fill: "#FFDE31" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 0.627991)",
    fill: "#FFDE31"
  },
  { transform: "translate(63.9086 32.1895) rotate(-180)", fill: "#FFDE31" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 71.7989 32.1895)",
    fill: "#FFDE31"
  },
  { transform: "translate(40.2375 16.4087) rotate(90)", fill: "#FFF065" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 16.4087)",
    fill: "#FFF065"
  },
  { transform: "translate(32.3471 16.4087) rotate(90)", fill: "#FFDE31" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 103.36 16.4087)",
    fill: "#FFDE31"
  },
  { transform: "translate(32.3471 32.1895) rotate(90)", fill: "#FFDE31" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 103.36 32.1895)",
    fill: "#FFDE31"
  },
  { transform: "translate(48.1278 32.1895) rotate(90)", fill: "#FFDE31" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 87.5797 32.1895)",
    fill: "#FFDE31"
  },
  { transform: "translate(48.1278 16.4087) rotate(90)", fill: "#FFDE31" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 87.5797 16.4087)",
    fill: "#FFDE31"
  },
  { transform: "translate(48.1278 32.1895) rotate(-180)", fill: "#FFDE31" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 87.5797 32.1895)",
    fill: "#FFDE31"
  },
  { transform: "translate(40.2375 32.1895) rotate(90)", fill: "#FFF065" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 32.1895)",
    fill: "#FFF065"
  },
  { transform: "translate(32.3471 32.1895) rotate(-180)", fill: "#FFDE31" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 103.36 32.1895)",
    fill: "#FFDE31"
  },
  { transform: "translate(40.2375 40.0798) rotate(90)", fill: "#FFDE31" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 40.0798)",
    fill: "#FFDE31"
  },
  { transform: "translate(24.4567 32.1895) rotate(-180)", fill: "#FFF065" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 111.251 32.1895)",
    fill: "#FFF065"
  },
  { transform: "translate(40.2375 47.9702) rotate(90)", fill: "#FFDE31" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 47.9702)",
    fill: "#FFDE31"
  },
  { transform: "translate(16.5664 32.1895) rotate(-180)", fill: "#FFF065" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 119.141 32.1895)",
    fill: "#FFF065"
  },
  { transform: "translate(8.67601 32.1895) rotate(-180)", fill: "#FFDE31" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 127.031 32.1895)",
    fill: "#FFDE31"
  },
  { transform: "translate(40.2375 8.51831) rotate(90)", fill: "#FFDE31" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 8.51831)",
    fill: "#FFDE31"
  },
  { transform: "translate(56.0182 32.1895) rotate(-180)", fill: "#FFDE31" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 79.6893 32.1895)",
    fill: "#FFDE31"
  },
  { transform: "translate(40.2375 24.2991) rotate(90)", fill: "#FFF065" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 24.2991)",
    fill: "#FFF065"
  }
], f$e = [
  { transform: "translate(40.2375 0.232574) rotate(90)", fill: "#00E45D" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 0.232574)",
    fill: "#00E45D"
  },
  { transform: "translate(63.9086 31.794) rotate(-180)", fill: "#00E45D" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 71.7989 31.794)",
    fill: "#00E45D"
  },
  { transform: "translate(40.2375 16.0133) rotate(90)", fill: "#8AFF76" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 16.0133)",
    fill: "#8AFF76"
  },
  { transform: "translate(32.3471 16.0133) rotate(90)", fill: "#00E45D" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 103.36 16.0133)",
    fill: "#00E45D"
  },
  { transform: "translate(32.3471 31.794) rotate(90)", fill: "#00E45D" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 103.36 31.794)",
    fill: "#00E45D"
  },
  { transform: "translate(48.1278 31.794) rotate(90)", fill: "#00E45D" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 87.5797 31.794)",
    fill: "#00E45D"
  },
  { transform: "translate(48.1278 16.0133) rotate(90)", fill: "#00E45D" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 87.5797 16.0133)",
    fill: "#00E45D"
  },
  { transform: "translate(48.1278 31.794) rotate(-180)", fill: "#FFDE31" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 87.5797 31.794)",
    fill: "#FFDE31"
  },
  { transform: "translate(40.2375 31.794) rotate(90)", fill: "#8AFF76" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 31.794)",
    fill: "#8AFF76"
  },
  { transform: "translate(32.3471 31.794) rotate(-180)", fill: "#FFDE31" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 103.36 31.794)",
    fill: "#FFDE31"
  },
  { transform: "translate(40.2375 39.6844) rotate(90)", fill: "#00E45D" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 39.6844)",
    fill: "#00E45D"
  },
  { transform: "translate(24.4567 31.794) rotate(-180)", fill: "#8AFF76" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 111.251 31.794)",
    fill: "#8AFF76"
  },
  { transform: "translate(40.2375 47.5748) rotate(90)", fill: "#00E45D" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 47.5748)",
    fill: "#00E45D"
  },
  { transform: "translate(16.5664 31.794) rotate(-180)", fill: "#8AFF76" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 119.141 31.794)",
    fill: "#8AFF76"
  },
  { transform: "translate(8.67601 31.794) rotate(-180)", fill: "#00E45D" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 127.031 31.794)",
    fill: "#00E45D"
  },
  { transform: "translate(40.2375 8.12296) rotate(90)", fill: "#00E45D" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 8.12296)",
    fill: "#00E45D"
  },
  { transform: "translate(56.0182 31.794) rotate(-180)", fill: "#00E45D" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 79.6893 31.794)",
    fill: "#00E45D"
  },
  { transform: "translate(40.2375 23.9037) rotate(90)", fill: "#FFF065" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 23.9037)",
    fill: "#FFF065"
  }
], d$e = [
  { transform: "translate(40.2375 0.395386) rotate(90)", fill: "#FF701E" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 0.395386)",
    fill: "#FF701E"
  },
  { transform: "translate(63.9086 31.9568) rotate(-180)", fill: "#FF701E" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 71.7989 31.9568)",
    fill: "#FF701E"
  },
  { transform: "translate(40.2375 16.1761) rotate(90)", fill: "#FF9345" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 16.1761)",
    fill: "#FF9345"
  },
  { transform: "translate(32.3471 16.1761) rotate(90)", fill: "#FF701E" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 103.36 16.1761)",
    fill: "#FF701E"
  },
  { transform: "translate(32.3471 31.9568) rotate(90)", fill: "#FF701E" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 103.36 31.9568)",
    fill: "#FF701E"
  },
  { transform: "translate(48.1278 31.9568) rotate(90)", fill: "#FF701E" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 87.5797 31.9568)",
    fill: "#FF701E"
  },
  { transform: "translate(48.1278 16.1761) rotate(90)", fill: "#FF701E" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 87.5797 16.1761)",
    fill: "#FF701E"
  },
  { transform: "translate(48.1278 31.9568) rotate(-180)", fill: "#FFDE31" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 87.5797 31.9568)",
    fill: "#FFDE31"
  },
  { transform: "translate(40.2375 31.9568) rotate(90)", fill: "#FF9345" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 31.9568)",
    fill: "#FF9345"
  },
  { transform: "translate(32.3471 31.9568) rotate(-180)", fill: "#FFDE31" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 103.36 31.9568)",
    fill: "#FFDE31"
  },
  { transform: "translate(40.2375 39.8472) rotate(90)", fill: "#FF701E" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 39.8472)",
    fill: "#FF701E"
  },
  { transform: "translate(24.4567 31.9568) rotate(-180)", fill: "#FF9345" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 111.251 31.9568)",
    fill: "#FF9345"
  },
  { transform: "translate(40.2375 47.7375) rotate(90)", fill: "#FF701E" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 47.7375)",
    fill: "#FF701E"
  },
  { transform: "translate(16.5664 31.9568) rotate(-180)", fill: "#FF9345" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 119.141 31.9568)",
    fill: "#FF9345"
  },
  { transform: "translate(8.67601 31.9568) rotate(-180)", fill: "#FF701E" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 127.031 31.9568)",
    fill: "#FF701E"
  },
  { transform: "translate(40.2375 8.28577) rotate(90)", fill: "#FF701E" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 8.28577)",
    fill: "#FF701E"
  },
  { transform: "translate(56.0182 31.9568) rotate(-180)", fill: "#FF701E" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 79.6893 31.9568)",
    fill: "#FF701E"
  },
  { transform: "translate(40.2375 24.0665) rotate(90)", fill: "#FFF065" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 24.0665)",
    fill: "#FFF065"
  }
], h$e = [
  { transform: "translate(40.2375) rotate(90)", fill: "#F42F3B" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 0)",
    fill: "#F42F3B"
  },
  { transform: "translate(63.9086 31.5615) rotate(-180)", fill: "#F42F3B" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 71.7989 31.5615)",
    fill: "#F42F3B"
  },
  { transform: "translate(40.2375 15.7807) rotate(90)", fill: "#FF701E" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 15.7807)",
    fill: "#FF701E"
  },
  { transform: "translate(32.3471 15.7807) rotate(90)", fill: "#F42F3B" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 103.36 15.7807)",
    fill: "#F42F3B"
  },
  { transform: "translate(32.3471 31.5615) rotate(90)", fill: "#F42F3B" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 103.36 31.5615)",
    fill: "#F42F3B"
  },
  { transform: "translate(48.1278 31.5615) rotate(90)", fill: "#F42F3B" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 87.5797 31.5615)",
    fill: "#F42F3B"
  },
  { transform: "translate(48.1278 15.7807) rotate(90)", fill: "#F42F3B" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 87.5797 15.7807)",
    fill: "#F42F3B"
  },
  { transform: "translate(48.1278 31.5615) rotate(-180)", fill: "#FFDE31" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 87.5797 31.5615)",
    fill: "#FFDE31"
  },
  { transform: "translate(40.2375 31.5615) rotate(90)", fill: "#FF701E" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 31.5615)",
    fill: "#FF701E"
  },
  { transform: "translate(32.3471 31.5615) rotate(-180)", fill: "#FFDE31" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 103.36 31.5615)",
    fill: "#FFDE31"
  },
  { transform: "translate(40.2375 39.4518) rotate(90)", fill: "#F42F3B" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 39.4518)",
    fill: "#F42F3B"
  },
  { transform: "translate(24.4567 31.5615) rotate(-180)", fill: "#FF701E" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 111.251 31.5615)",
    fill: "#FF701E"
  },
  { transform: "translate(40.2375 47.3422) rotate(90)", fill: "#F42F3B" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 47.3422)",
    fill: "#F42F3B"
  },
  { transform: "translate(16.5664 31.5615) rotate(-180)", fill: "#FF701E" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 119.141 31.5615)",
    fill: "#FF701E"
  },
  { transform: "translate(8.67601 31.5615) rotate(-180)", fill: "#F42F3B" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 127.031 31.5615)",
    fill: "#F42F3B"
  },
  { transform: "translate(40.2375 7.89038) rotate(90)", fill: "#F42F3B" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 7.89038)",
    fill: "#F42F3B"
  },
  { transform: "translate(56.0182 31.5615) rotate(-180)", fill: "#F42F3B" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 79.6893 31.5615)",
    fill: "#F42F3B"
  },
  { transform: "translate(40.2375 23.6711) rotate(90)", fill: "#FFF065" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 23.6711)",
    fill: "#FFF065"
  }
], p$e = [
  { transform: "translate(40.2375 0.465149) rotate(90)", fill: "#36DBFF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 0.465149)",
    fill: "#36DBFF"
  },
  { transform: "translate(63.9086 32.0266) rotate(-180)", fill: "#36DBFF" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 71.7989 32.0266)",
    fill: "#36DBFF"
  },
  { transform: "translate(40.2375 16.2459) rotate(90)", fill: "#7FE8FF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 16.2459)",
    fill: "#7FE8FF"
  },
  { transform: "translate(32.3471 16.2459) rotate(90)", fill: "#36DBFF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 103.36 16.2459)",
    fill: "#36DBFF"
  },
  { transform: "translate(32.3471 32.0266) rotate(90)", fill: "#36DBFF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 103.36 32.0266)",
    fill: "#36DBFF"
  },
  { transform: "translate(48.1278 32.0266) rotate(90)", fill: "#36DBFF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 87.5797 32.0266)",
    fill: "#36DBFF"
  },
  { transform: "translate(48.1278 16.2459) rotate(90)", fill: "#36DBFF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 87.5797 16.2459)",
    fill: "#36DBFF"
  },
  { transform: "translate(48.1278 32.0266) rotate(-180)", fill: "#FFDE31" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 87.5797 32.0266)",
    fill: "#FFDE31"
  },
  { transform: "translate(40.2375 32.0266) rotate(90)", fill: "#7FE8FF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 32.0266)",
    fill: "#7FE8FF"
  },
  { transform: "translate(32.3471 32.0266) rotate(-180)", fill: "#FFDE31" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 103.36 32.0266)",
    fill: "#FFDE31"
  },
  { transform: "translate(40.2375 39.917) rotate(90)", fill: "#36DBFF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 39.917)",
    fill: "#36DBFF"
  },
  { transform: "translate(24.4567 32.0266) rotate(-180)", fill: "#7FE8FF" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 111.251 32.0266)",
    fill: "#7FE8FF"
  },
  { transform: "translate(40.2375 47.8073) rotate(90)", fill: "#36DBFF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 47.8073)",
    fill: "#36DBFF"
  },
  { transform: "translate(16.5664 32.0266) rotate(-180)", fill: "#7FE8FF" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 119.141 32.0266)",
    fill: "#7FE8FF"
  },
  { transform: "translate(8.67601 32.0266) rotate(-180)", fill: "#36DBFF" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 127.031 32.0266)",
    fill: "#36DBFF"
  },
  { transform: "translate(40.2375 8.35553) rotate(90)", fill: "#36DBFF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 8.35553)",
    fill: "#36DBFF"
  },
  { transform: "translate(56.0182 32.0266) rotate(-180)", fill: "#36DBFF" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 79.6893 32.0266)",
    fill: "#36DBFF"
  },
  { transform: "translate(40.2375 24.1363) rotate(90)", fill: "#FFF065" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 24.1363)",
    fill: "#FFF065"
  }
], g$e = [
  { transform: "translate(40.2375 0.697693) rotate(90)", fill: "#1657FF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 0.697693)",
    fill: "#1657FF"
  },
  { transform: "translate(63.9086 32.2592) rotate(-180)", fill: "#1657FF" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 71.7989 32.2592)",
    fill: "#1657FF"
  },
  { transform: "translate(40.2375 16.4785) rotate(90)", fill: "#3AA0FF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 16.4785)",
    fill: "#3AA0FF"
  },
  { transform: "translate(32.3471 16.4785) rotate(90)", fill: "#1657FF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 103.36 16.4785)",
    fill: "#1657FF"
  },
  { transform: "translate(32.3471 32.2592) rotate(90)", fill: "#1657FF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 103.36 32.2592)",
    fill: "#1657FF"
  },
  { transform: "translate(48.1278 32.2592) rotate(90)", fill: "#1657FF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 87.5797 32.2592)",
    fill: "#1657FF"
  },
  { transform: "translate(48.1278 16.4785) rotate(90)", fill: "#1657FF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 87.5797 16.4785)",
    fill: "#1657FF"
  },
  { transform: "translate(48.1278 32.2592) rotate(-180)", fill: "#FFDE31" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 87.5797 32.2592)",
    fill: "#FFDE31"
  },
  { transform: "translate(40.2375 32.2592) rotate(90)", fill: "#3AA0FF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 32.2592)",
    fill: "#3AA0FF"
  },
  { transform: "translate(32.3471 32.2592) rotate(-180)", fill: "#FFDE31" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 103.36 32.2592)",
    fill: "#FFDE31"
  },
  { transform: "translate(40.2375 40.1495) rotate(90)", fill: "#1657FF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 40.1495)",
    fill: "#1657FF"
  },
  { transform: "translate(24.4567 32.2592) rotate(-180)", fill: "#3AA0FF" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 111.251 32.2592)",
    fill: "#3AA0FF"
  },
  { transform: "translate(40.2375 48.0399) rotate(90)", fill: "#1657FF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 48.0399)",
    fill: "#1657FF"
  },
  { transform: "translate(16.5664 32.2592) rotate(-180)", fill: "#3AA0FF" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 119.141 32.2592)",
    fill: "#3AA0FF"
  },
  { transform: "translate(8.67601 32.2592) rotate(-180)", fill: "#1657FF" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 127.031 32.2592)",
    fill: "#1657FF"
  },
  { transform: "translate(40.2375 8.58807) rotate(90)", fill: "#1657FF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 8.58807)",
    fill: "#1657FF"
  },
  { transform: "translate(56.0182 32.2592) rotate(-180)", fill: "#1657FF" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 79.6893 32.2592)",
    fill: "#1657FF"
  },
  { transform: "translate(40.2375 24.3688) rotate(90)", fill: "#FFF065" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 24.3688)",
    fill: "#FFF065"
  }
], m$e = [
  { transform: "translate(40.2375 0.930267) rotate(90)", fill: "#A528F2" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 0.930267)",
    fill: "#A528F2"
  },
  { transform: "translate(63.9086 32.4917) rotate(-180)", fill: "#A528F2" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 71.7989 32.4917)",
    fill: "#A528F2"
  },
  { transform: "translate(40.2375 16.711) rotate(90)", fill: "#BF58FF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 16.711)",
    fill: "#BF58FF"
  },
  { transform: "translate(32.3471 16.711) rotate(90)", fill: "#A528F2" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 103.36 16.711)",
    fill: "#A528F2"
  },
  { transform: "translate(32.3471 32.4917) rotate(90)", fill: "#A528F2" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 103.36 32.4917)",
    fill: "#A528F2"
  },
  { transform: "translate(48.1278 32.4917) rotate(90)", fill: "#A528F2" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 87.5797 32.4917)",
    fill: "#A528F2"
  },
  { transform: "translate(48.1278 16.711) rotate(90)", fill: "#A528F2" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 87.5797 16.711)",
    fill: "#A528F2"
  },
  { transform: "translate(48.1278 32.4917) rotate(-180)", fill: "#FFDE31" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 87.5797 32.4917)",
    fill: "#FFDE31"
  },
  { transform: "translate(40.2375 32.4917) rotate(90)", fill: "#BF58FF" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 32.4917)",
    fill: "#BF58FF"
  },
  { transform: "translate(32.3471 32.4917) rotate(-180)", fill: "#FFDE31" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 103.36 32.4917)",
    fill: "#FFDE31"
  },
  { transform: "translate(40.2375 40.3821) rotate(90)", fill: "#A528F2" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 40.3821)",
    fill: "#A528F2"
  },
  { transform: "translate(24.4567 32.4917) rotate(-180)", fill: "#BF58FF" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 111.251 32.4917)",
    fill: "#BF58FF"
  },
  { transform: "translate(40.2375 48.2725) rotate(90)", fill: "#A528F2" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 48.2725)",
    fill: "#A528F2"
  },
  { transform: "translate(16.5664 32.4917) rotate(-180)", fill: "#BF58FF" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 119.141 32.4917)",
    fill: "#BF58FF"
  },
  { transform: "translate(8.67601 32.4917) rotate(-180)", fill: "#A528F2" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 127.031 32.4917)",
    fill: "#A528F2"
  },
  { transform: "translate(40.2375 8.82065) rotate(90)", fill: "#A528F2" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 8.82065)",
    fill: "#A528F2"
  },
  { transform: "translate(56.0182 32.4917) rotate(-180)", fill: "#A528F2" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 79.6893 32.4917)",
    fill: "#A528F2"
  },
  { transform: "translate(40.2375 24.6014) rotate(90)", fill: "#FFF065" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 24.6014)",
    fill: "#FFF065"
  }
], sJ = [
  { transform: "translate(40.2375 0.162842) rotate(90)", fill: "#FB51C1" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 0.162842)",
    fill: "#FB51C1"
  },
  { transform: "translate(63.9086 31.7243) rotate(-180)", fill: "#FB51C1" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 71.7989 31.7243)",
    fill: "#FB51C1"
  },
  { transform: "translate(40.2375 15.9436) rotate(90)", fill: "#FF7CD2" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 15.9436)",
    fill: "#FF7CD2"
  },
  { transform: "translate(32.3471 15.9436) rotate(90)", fill: "#FB51C1" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 103.36 15.9436)",
    fill: "#FB51C1"
  },
  { transform: "translate(32.3471 31.7243) rotate(90)", fill: "#FB51C1" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 103.36 31.7243)",
    fill: "#FB51C1"
  },
  { transform: "translate(48.1278 31.7243) rotate(90)", fill: "#FB51C1" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 87.5797 31.7243)",
    fill: "#FB51C1"
  },
  { transform: "translate(48.1278 15.9436) rotate(90)", fill: "#FB51C1" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 87.5797 15.9436)",
    fill: "#FB51C1"
  },
  { transform: "translate(48.1278 31.7243) rotate(-180)", fill: "#FFDE31" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 87.5797 31.7243)",
    fill: "#FFDE31"
  },
  { transform: "translate(40.2375 31.7243) rotate(90)", fill: "#FF7CD2" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 31.7243)",
    fill: "#FF7CD2"
  },
  { transform: "translate(32.3471 31.7243) rotate(-180)", fill: "#FFDE31" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 103.36 31.7243)",
    fill: "#FFDE31"
  },
  { transform: "translate(40.2375 39.6147) rotate(90)", fill: "#FB51C1" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 39.6147)",
    fill: "#FB51C1"
  },
  { transform: "translate(24.4567 31.7243) rotate(-180)", fill: "#FF7CD2" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 111.251 31.7243)",
    fill: "#FF7CD2"
  },
  { transform: "translate(40.2375 47.505) rotate(90)", fill: "#FB51C1" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 47.505)",
    fill: "#FB51C1"
  },
  { transform: "translate(16.5664 31.7243) rotate(-180)", fill: "#FF7CD2" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 119.141 31.7243)",
    fill: "#FF7CD2"
  },
  { transform: "translate(8.67601 31.7243) rotate(-180)", fill: "#FB51C1" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 127.031 31.7243)",
    fill: "#FB51C1"
  },
  { transform: "translate(40.2375 8.05322) rotate(90)", fill: "#FB51C1" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 8.05322)",
    fill: "#FB51C1"
  },
  { transform: "translate(56.0182 31.7243) rotate(-180)", fill: "#FB51C1" },
  {
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 79.6893 31.7243)",
    fill: "#FB51C1"
  },
  { transform: "translate(40.2375 23.834) rotate(90)", fill: "#FFF065" },
  {
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 95.47 23.834)",
    fill: "#FFF065"
  }
], y$e = {
  pink: sJ,
  purple: m$e,
  darkBlue: g$e,
  blue: p$e,
  red: h$e,
  orange: d$e,
  green: f$e,
  yellow: l$e
}, mze = ({
  width: e = 135,
  height: t,
  className: r = "",
  color: n = "green"
}) => {
  const o = 2.4107142857142856, i = t || e / o, a = e || t * o, u = y$e[n] || sJ;
  return /* @__PURE__ */ ae(
    "svg",
    {
      width: a,
      height: i,
      viewBox: "0 0 135 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: r,
      children: u.map((l, d) => /* @__PURE__ */ ae(
        "rect",
        {
          width: 7.89036,
          height: 7.89036,
          transform: l.transform,
          fill: l.fill
        },
        d
      ))
    }
  );
}, b$e = ({
  size: e = 42,
  variant: t = "first",
  className: r,
  ...n
}) => /* @__PURE__ */ Lr(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    id: "Ebene_2",
    "data-name": "Ebene 2",
    viewBox: "0 0 314.29 111.66",
    width: e,
    height: e,
    ...n,
    children: [
      /* @__PURE__ */ ae("defs", { children: /* @__PURE__ */ ae("style", { children: ".cls-1{fill:#fff;stroke-width:0}" }) }),
      /* @__PURE__ */ Lr("g", { id: "Ebene_1-2", "data-name": "Ebene 1", children: [
        /* @__PURE__ */ ae(
          "path",
          {
            d: "M118.13 0c-8.69-.1-16.81 2.21-23.8 6.26-2.57 1.49-3.29 4.91-1.55 7.33 3.44 4.8 6.15 10.15 7.97 15.9 1.01 3.2 4.82 4.23 7.65 2.43 3.55-2.25 7.97-3.25 12.67-2.33 6.53 1.27 11.95 6.44 13.44 12.93 2.61 11.39-5.97 21.5-16.91 21.5-3.41 0-6.58-.99-9.24-2.7-2.82-1.8-6.61-.66-7.63 2.53-4.48 14.04-14.26 25.71-27.02 32.66-1.67.91-2.75 2.6-2.75 4.5v5.58c0 2.8 2.27 5.07 5.07 5.07h19.13c2.8 0 5.07-2.27 5.07-5.07v-9.76c0-3.35 3.16-5.67 6.42-4.87 3.52.86 7.18 1.32 10.96 1.32 26.19 0 47.34-21.59 46.62-47.95C163.55 20.67 142.8.28 118.13 0Z",
            style: {
              fill: "#ff7900",
              strokeWidth: 0
            }
          }
        ),
        /* @__PURE__ */ ae(
          "path",
          {
            d: "M46.64 0C20.88 0 0 20.88 0 46.64s20.88 46.64 46.64 46.64S93.28 72.4 93.28 46.64 72.4 0 46.64 0Zm0 64.03c-9.6 0-17.38-7.78-17.38-17.39s7.78-17.39 17.38-17.39 17.39 7.78 17.39 17.39-7.78 17.39-17.39 17.39ZM188.46 41.7l20.14 33.14h11.26V18.5h-13.02v34.05L185.9 18.5h-10.38v56.34h12.94V41.7zM265.74 63.57h-24.29V51.9h15.46V40.8h-15.46V29.77h24.29V18.5h-37.88v56.34h37.88V63.57zM286.16 74.84h14.06V29.77h14.07V18.5H272.1v11.27h14.06v45.07z",
            className: "cls-1"
          }
        )
      ] })
    ]
  }
), w$e = ({
  size: e = 42,
  className: t,
  ...r
}) => /* @__PURE__ */ Lr(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    viewBox: "0 0 200 200",
    fill: "none",
    className: t,
    ...r,
    children: [
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.14
          },
          fill: "#090a0b",
          d: "M 81.5,9.5 C 82.2423,11.4258 83.2423,13.2591 84.5,15C 82.7184,15.1218 81.0518,14.6218 79.5,13.5C 79.2291,11.6203 79.8958,10.287 81.5,9.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#4f585a",
          d: "M 125.5,38.5 C 112.548,31.863 99.8817,25.0297 87.5,18C 100.667,29.0023 113.667,40.1689 126.5,51.5C 127.634,54.3704 128.3,57.3704 128.5,60.5C 126.668,59.7515 125.001,58.7515 123.5,57.5C 110.167,46.8333 96.8333,36.1667 83.5,25.5C 80.3626,22.7015 78.0293,19.3681 76.5,15.5C 76.9731,14.0937 77.9731,13.427 79.5,13.5C 81.0518,14.6218 82.7184,15.1218 84.5,15C 83.2423,13.2591 82.2423,11.4258 81.5,9.5C 83.4346,8.29099 85.4346,8.45766 87.5,10C 100.414,19.2774 113.08,28.7774 125.5,38.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.161
          },
          fill: "#08090a",
          d: "M 76.5,15.5 C 78.0293,19.3681 80.3626,22.7015 83.5,25.5C 80.5498,24.6916 77.8831,23.3582 75.5,21.5C 73.9378,19.0993 74.2712,17.0993 76.5,15.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.999
          },
          fill: "#778085",
          d: "M 75.5,21.5 C 77.8831,23.3582 80.5498,24.6916 83.5,25.5C 96.8333,36.1667 110.167,46.8333 123.5,57.5C 118.285,55.5594 113.285,53.0594 108.5,50C 99.2121,47.5708 90.0454,44.7374 81,41.5C 80.2352,41.5699 79.7352,41.9033 79.5,42.5C 75.0157,41.6841 72.6824,39.0174 72.5,34.5C 72.8417,33.6618 73.5084,33.3284 74.5,33.5C 77.4258,34.868 80.4258,35.7013 83.5,36C 80.3333,32.8333 77.1667,29.6667 74,26.5C 73.51,25.2068 73.3433,23.8734 73.5,22.5C 73.8417,21.6618 74.5084,21.3284 75.5,21.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.165
          },
          fill: "#070809",
          d: "M 73.5,22.5 C 73.3433,23.8734 73.51,25.2068 74,26.5C 77.1667,29.6667 80.3333,32.8333 83.5,36C 80.4258,35.7013 77.4258,34.868 74.5,33.5C 73.2222,31.2009 71.8889,28.8676 70.5,26.5C 71.0351,24.739 72.0351,23.4057 73.5,22.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#8d9999",
          d: "M 125.5,38.5 C 126.125,42.3258 126.791,46.1592 127.5,50C 127.43,50.7648 127.097,51.2648 126.5,51.5C 113.667,40.1689 100.667,29.0023 87.5,18C 99.8817,25.0297 112.548,31.863 125.5,38.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#8e9a9a",
          d: "M 123.5,57.5 C 125.001,58.7515 126.668,59.7515 128.5,60.5C 128.5,61.8333 128.5,63.1667 128.5,64.5C 128.5,65.8333 128.5,67.1667 128.5,68.5C 112.879,61.0229 97.5452,53.0229 82.5,44.5C 81.2905,44.0679 80.2905,43.4013 79.5,42.5C 79.7352,41.9033 80.2352,41.5699 81,41.5C 90.0454,44.7374 99.2121,47.5708 108.5,50C 113.285,53.0594 118.285,55.5594 123.5,57.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#777f85",
          d: "M 125.5,38.5 C 129.5,41.5 133.5,44.5 137.5,47.5C 136.428,51.7555 134.261,55.4222 131,58.5C 130.155,60.6115 129.322,62.6115 128.5,64.5C 128.5,63.1667 128.5,61.8333 128.5,60.5C 128.3,57.3704 127.634,54.3704 126.5,51.5C 127.097,51.2648 127.43,50.7648 127.5,50C 126.791,46.1592 126.125,42.3258 125.5,38.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.997
          },
          fill: "#888889",
          d: "M 58.5,63.5 C 48.5374,62.2002 38.7041,60.2002 29,57.5C 27.9302,57.528 27.0968,57.8614 26.5,58.5C 24.2459,57.5849 22.2459,56.2516 20.5,54.5C 18.4985,51.6662 15.9985,49.3329 13,47.5C 12.51,46.2068 12.3433,44.8734 12.5,43.5C 13.2506,42.4265 14.2506,42.2599 15.5,43C 29.1035,51.4694 43.4368,58.3027 58.5,63.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.17
          },
          fill: "#0e0f0f",
          d: "M 12.5,43.5 C 12.3433,44.8734 12.51,46.2068 13,47.5C 15.9985,49.3329 18.4985,51.6662 20.5,54.5C 20.44,55.0431 20.1067,55.3764 19.5,55.5C 16.3707,53.6001 13.0373,52.2667 9.5,51.5C 10.7279,49.9902 10.7279,48.4902 9.5,47C 10.1634,45.4815 11.1634,44.3149 12.5,43.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#7b848a",
          d: "M 82.5,44.5 C 97.5452,53.0229 112.879,61.0229 128.5,68.5C 128.72,71.4005 128.054,74.0671 126.5,76.5C 113.14,69.1544 99.8062,61.8211 86.5,54.5C 83.5279,52.6778 80.5279,50.8445 77.5,49C 76.6198,47.6439 76.2865,46.1439 76.5,44.5C 78.7411,44.9539 80.7411,44.9539 82.5,44.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.153
          },
          fill: "#050506",
          d: "M 72.5,34.5 C 72.6824,39.0174 75.0157,41.6841 79.5,42.5C 80.2905,43.4013 81.2905,44.0679 82.5,44.5C 80.7411,44.9539 78.7411,44.9539 76.5,44.5C 76.2865,46.1439 76.6198,47.6439 77.5,49C 80.5279,50.8445 83.5279,52.6778 86.5,54.5C 86.2774,59.2804 87.944,63.2804 91.5,66.5C 91.1496,69.4534 92.1496,71.7867 94.5,73.5C 92.4471,73.5979 90.7804,72.9313 89.5,71.5C 89.6495,70.448 89.4828,69.448 89,68.5C 85.7393,65.9786 84.0726,62.6453 84,58.5C 80.5991,56.6387 77.5991,54.3053 75,51.5C 74.2419,49.2305 74.4086,47.0639 75.5,45C 70.4866,42.378 69.4866,38.878 72.5,34.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.016
          },
          fill: "#0f1010",
          d: "M 138.5,48.5 C 140.539,49.911 141.539,51.911 141.5,54.5C 139.992,52.8185 138.992,50.8185 138.5,48.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.999
          },
          fill: "#343f49",
          d: "M 9.5,51.5 C 13.0373,52.2667 16.3707,53.6001 19.5,55.5C 20.1067,55.3764 20.44,55.0431 20.5,54.5C 22.2459,56.2516 24.2459,57.5849 26.5,58.5C 35.1667,62.8333 43.8333,67.1667 52.5,71.5C 56.6478,75.4041 60.9811,79.0708 65.5,82.5C 65.5,82.8333 65.5,83.1667 65.5,83.5C 50.001,77.6719 34.6676,71.6719 19.5,65.5C 16.9116,63.4392 14.0783,60.7726 11,57.5C 9.87201,55.6547 9.37201,53.6547 9.5,51.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.191
          },
          fill: "#070809",
          d: "M 9.5,51.5 C 9.37201,53.6547 9.87201,55.6547 11,57.5C 14.0783,60.7726 16.9116,63.4392 19.5,65.5C 16.2854,65.0951 13.2854,64.0951 10.5,62.5C 8.3912,60.8783 7.3912,58.7116 7.5,56C 7.30684,53.9919 7.9735,52.4919 9.5,51.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.05
          },
          fill: "#060707",
          d: "M 141.5,54.5 C 142.633,56.0552 143.299,57.8886 143.5,60C 142.418,65.9944 141.418,71.9944 140.5,78C 140.899,79.7275 141.566,81.2275 142.5,82.5C 142.167,83.5 141.5,84.1667 140.5,84.5C 140.046,81.1349 139.38,77.8015 138.5,74.5C 139.874,67.8812 140.874,61.2146 141.5,54.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#c9cbcb",
          d: "M 26.5,58.5 C 27.0968,57.8614 27.9302,57.528 29,57.5C 38.7041,60.2002 48.5374,62.2002 58.5,63.5C 61.221,63.9628 63.8877,64.6295 66.5,65.5C 72.5358,70.1912 78.8691,74.5245 85.5,78.5C 74.6653,76.7183 63.6653,74.385 52.5,71.5C 43.8333,67.1667 35.1667,62.8333 26.5,58.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#929294",
          d: "M 10.5,62.5 C 13.2854,64.0951 16.2854,65.0951 19.5,65.5C 34.6676,71.6719 50.001,77.6719 65.5,83.5C 63.9504,84.7199 62.2837,84.7199 60.5,83.5C 47.2117,81.5939 34.2117,78.5939 21.5,74.5C 15.1127,73.7734 10.7793,70.4401 8.5,64.5C 8.83333,63.5 9.5,62.8333 10.5,62.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#494f51",
          d: "M 137.5,47.5 C 138.167,47.5 138.5,47.8333 138.5,48.5C 138.992,50.8185 139.992,52.8185 141.5,54.5C 140.874,61.2146 139.874,67.8812 138.5,74.5C 139.38,77.8015 140.046,81.1349 140.5,84.5C 138.83,87.0016 136.664,89.0016 134,90.5C 132.478,88.2591 131.145,85.9258 130,83.5C 128.544,86.0324 127.377,88.6991 126.5,91.5C 115.094,82.7537 103.427,74.4203 91.5,66.5C 87.944,63.2804 86.2774,59.2804 86.5,54.5C 99.8062,61.8211 113.14,69.1544 126.5,76.5C 128.054,74.0671 128.72,71.4005 128.5,68.5C 128.5,67.1667 128.5,65.8333 128.5,64.5C 129.322,62.6115 130.155,60.6115 131,58.5C 134.261,55.4222 136.428,51.7555 137.5,47.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.183
          },
          fill: "#060606",
          d: "M 8.5,64.5 C 10.7793,70.4401 15.1127,73.7734 21.5,74.5C 19.3021,75.1653 16.9688,75.8319 14.5,76.5C 16.3737,81.6139 20.0404,84.6139 25.5,85.5C 26.5,85.5 27.5,85.5 28.5,85.5C 28.2627,86.791 28.596,87.791 29.5,88.5C 29.5106,90.0174 30.1772,91.1841 31.5,92C 34.7365,93.7862 38.0698,95.2862 41.5,96.5C 41.5,97.1667 41.8333,97.5 42.5,97.5C 42.5494,100.099 43.5494,102.266 45.5,104C 48.8168,104.498 52.1501,104.665 55.5,104.5C 55.2627,105.791 55.596,106.791 56.5,107.5C 56.9528,108.458 57.6195,109.292 58.5,110C 61.3771,111.127 64.3771,111.794 67.5,112C 68.9852,114.237 70.9852,115.737 73.5,116.5C 76.9386,117.019 80.272,118.019 83.5,119.5C 87.2508,121.079 91.2508,122.079 95.5,122.5C 95.5,122.833 95.5,123.167 95.5,123.5C 92.5715,130.285 90.2382,137.285 88.5,144.5C 88.1667,145.167 87.8333,145.833 87.5,146.5C 87.1667,146.5 86.8333,146.5 86.5,146.5C 87.7936,139.786 89.7936,133.286 92.5,127C 87.5169,126.897 83.1836,125.23 79.5,122C 74.2686,122.485 69.9353,120.819 66.5,117C 60.8614,116.865 56.528,114.531 53.5,110C 50.1853,109.059 46.852,108.226 43.5,107.5C 41.5592,105.166 39.8925,102.666 38.5,100C 32.4206,98.8085 28.0872,95.4752 25.5,90C 17.189,88.6898 12.689,83.8564 12,75.5C 9.28221,73.2292 7.44888,70.3958 6.5,67C 7.06594,66.0053 7.73261,65.172 8.5,64.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#b8b6ac",
          d: "M 52.5,71.5 C 63.6653,74.385 74.6653,76.7183 85.5,78.5C 89.228,81.5589 93.228,84.2256 97.5,86.5C 91.3341,87.3789 85.0007,87.3789 78.5,86.5C 75.3915,86.7359 72.3915,86.4025 69.5,85.5C 68.205,84.5116 66.8717,83.5116 65.5,82.5C 60.9811,79.0708 56.6478,75.4041 52.5,71.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#343f48",
          d: "M 21.5,74.5 C 34.2117,78.5939 47.2117,81.5939 60.5,83.5C 48.8333,84.1667 37.1667,84.8333 25.5,85.5C 20.0404,84.6139 16.3737,81.6139 14.5,76.5C 16.9688,75.8319 19.3021,75.1653 21.5,74.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#565a5e",
          d: "M 66.5,65.5 C 74.1667,67.5 81.8333,69.5 89.5,71.5C 90.7804,72.9313 92.4471,73.5979 94.5,73.5C 104.436,81.5934 114.269,89.9267 124,98.5C 124.333,100.5 124.667,102.5 125,104.5C 127.25,100.332 129.75,96.3318 132.5,92.5C 130.604,91.5344 128.604,91.2011 126.5,91.5C 127.377,88.6991 128.544,86.0324 130,83.5C 131.145,85.9258 132.478,88.2591 134,90.5C 136.664,89.0016 138.83,87.0016 140.5,84.5C 141.5,84.1667 142.167,83.5 142.5,82.5C 146.184,80.4717 149.85,78.4717 153.5,76.5C 153.5,76.8333 153.5,77.1667 153.5,77.5C 150.542,81.6911 148.542,86.3578 147.5,91.5C 151.5,90.5 155.5,89.5 159.5,88.5C 160.492,88.3284 161.158,88.6618 161.5,89.5C 160.26,90.6588 158.926,91.6588 157.5,92.5C 154.615,92.1936 151.948,92.5269 149.5,93.5C 148.391,93.4431 147.391,93.1098 146.5,92.5C 142.6,91.5701 138.6,91.2367 134.5,91.5C 134.46,94.8806 134.793,98.2139 135.5,101.5C 135.5,102.833 135.5,104.167 135.5,105.5C 131.563,105.207 127.73,105.54 124,106.5C 115.993,99.572 107.493,93.2387 98.5,87.5C 98.5,86.8333 98.1667,86.5 97.5,86.5C 93.228,84.2256 89.228,81.5589 85.5,78.5C 78.8691,74.5245 72.5358,70.1912 66.5,65.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#c0bbb1",
          d: "M 153.5,76.5 C 156.5,76.5 159.5,76.5 162.5,76.5C 164.526,80.5813 165.526,84.9146 165.5,89.5C 164.167,89.5 162.833,89.5 161.5,89.5C 161.158,88.6618 160.492,88.3284 159.5,88.5C 157.5,84.8333 155.5,81.1667 153.5,77.5C 153.5,77.1667 153.5,76.8333 153.5,76.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#7c858b",
          d: "M 153.5,77.5 C 155.5,81.1667 157.5,84.8333 159.5,88.5C 155.5,89.5 151.5,90.5 147.5,91.5C 148.542,86.3578 150.542,81.6911 153.5,77.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.996
          },
          fill: "#898a89",
          d: "M 162.5,76.5 C 167.023,78.0073 171.523,79.674 176,81.5C 177.03,81.8361 177.53,82.5028 177.5,83.5C 177.992,85.8185 178.992,87.8185 180.5,89.5C 181.338,89.8417 181.672,90.5084 181.5,91.5C 178.012,91.7054 174.679,92.5387 171.5,94C 176.66,95.6954 181.66,97.5287 186.5,99.5C 181.93,100.441 177.263,100.774 172.5,100.5C 171.793,98.2186 170.793,96.0519 169.5,94C 165.534,93.1721 161.534,92.6721 157.5,92.5C 158.926,91.6588 160.26,90.6588 161.5,89.5C 162.184,91.1852 163.517,92.1852 165.5,92.5C 168.012,91.2162 168.012,90.2162 165.5,89.5C 165.526,84.9146 164.526,80.5813 162.5,76.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#5c676f",
          d: "M 65.5,82.5 C 66.8717,83.5116 68.205,84.5116 69.5,85.5C 66.8333,87.5 64.1667,89.5 61.5,91.5C 51.2474,90.3957 41.0808,88.729 31,86.5C 29.9701,86.8361 29.4701,87.5028 29.5,88.5C 28.596,87.791 28.2627,86.791 28.5,85.5C 27.5,85.5 26.5,85.5 25.5,85.5C 37.1667,84.8333 48.8333,84.1667 60.5,83.5C 62.2837,84.7199 63.9504,84.7199 65.5,83.5C 65.5,83.1667 65.5,82.8333 65.5,82.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.018
          },
          fill: "#191919",
          d: "M 177.5,83.5 C 179.539,84.911 180.539,86.911 180.5,89.5C 178.992,87.8185 177.992,85.8185 177.5,83.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#cdcfd0",
          d: "M 61.5,91.5 C 64.3522,93.0765 67.3522,94.5765 70.5,96C 60.8391,96.4998 51.1724,96.6665 41.5,96.5C 38.0698,95.2862 34.7365,93.7862 31.5,92C 30.1772,91.1841 29.5106,90.0174 29.5,88.5C 29.4701,87.5028 29.9701,86.8361 31,86.5C 41.0808,88.729 51.2474,90.3957 61.5,91.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#7c858b",
          d: "M 78.5,86.5 C 85.0007,87.3789 91.3341,87.3789 97.5,86.5C 98.1667,86.5 98.5,86.8333 98.5,87.5C 95.9058,93.1859 92.9058,98.6859 89.5,104C 89.7284,104.399 90.0618,104.565 90.5,104.5C 94.7789,107.029 99.1122,109.363 103.5,111.5C 97.296,115.128 90.6293,117.795 83.5,119.5C 80.272,118.019 76.9386,117.019 73.5,116.5C 76.1873,116.664 78.854,116.497 81.5,116C 83.5871,112.492 85.9204,109.158 88.5,106C 88.2716,105.601 87.9382,105.435 87.5,105.5C 87.5,104.833 87.5,104.167 87.5,103.5C 87.9382,103.565 88.2716,103.399 88.5,103C 84.7673,97.6938 81.434,92.1938 78.5,86.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#3c413e",
          d: "M 91.5,66.5 C 103.427,74.4203 115.094,82.7537 126.5,91.5C 128.604,91.2011 130.604,91.5344 132.5,92.5C 129.75,96.3318 127.25,100.332 125,104.5C 124.667,102.5 124.333,100.5 124,98.5C 114.269,89.9267 104.436,81.5934 94.5,73.5C 92.1496,71.7867 91.1496,69.4534 91.5,66.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#e2730e",
          d: "M 161.5,89.5 C 162.833,89.5 164.167,89.5 165.5,89.5C 168.012,90.2162 168.012,91.2162 165.5,92.5C 163.517,92.1852 162.184,91.1852 161.5,89.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#b7b5ac",
          d: "M 146.5,92.5 C 147.265,95.0961 147.599,97.7628 147.5,100.5C 147.5,100.833 147.5,101.167 147.5,101.5C 143.569,102.132 140.235,103.799 137.5,106.5C 137.167,106.5 136.833,106.5 136.5,106.5C 136.784,104.585 136.451,102.919 135.5,101.5C 134.793,98.2139 134.46,94.8806 134.5,91.5C 138.6,91.2367 142.6,91.5701 146.5,92.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.998
          },
          fill: "#babbba",
          d: "M 181.5,91.5 C 184.81,93.4821 187.81,95.8154 190.5,98.5C 189.432,99.4345 188.099,99.7678 186.5,99.5C 181.66,97.5287 176.66,95.6954 171.5,94C 174.679,92.5387 178.012,91.7054 181.5,91.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#353f49",
          d: "M 146.5,92.5 C 147.391,93.1098 148.391,93.4431 149.5,93.5C 153.167,94.1667 156.833,94.8333 160.5,95.5C 156.624,98.1293 152.29,99.796 147.5,100.5C 147.599,97.7628 147.265,95.0961 146.5,92.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#d0c9c0",
          d: "M 149.5,93.5 C 151.948,92.5269 154.615,92.1936 157.5,92.5C 161.534,92.6721 165.534,93.1721 169.5,94C 170.793,96.0519 171.793,98.2186 172.5,100.5C 168.52,98.8702 164.52,97.2035 160.5,95.5C 156.833,94.8333 153.167,94.1667 149.5,93.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#7e8182",
          d: "M 160.5,95.5 C 164.52,97.2035 168.52,98.8702 172.5,100.5C 172.5,101.167 172.167,101.5 171.5,101.5C 163.981,101.175 156.648,101.508 149.5,102.5C 148.833,102.167 148.167,101.833 147.5,101.5C 147.5,101.167 147.5,100.833 147.5,100.5C 152.29,99.796 156.624,98.1293 160.5,95.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#5c666f",
          d: "M 42.5,97.5 C 52.1724,97.3335 61.8391,97.5002 71.5,98C 66.7133,99.8932 62.0466,102.06 57.5,104.5C 56.6143,105.325 56.281,106.325 56.5,107.5C 55.596,106.791 55.2627,105.791 55.5,104.5C 52.1501,104.665 48.8168,104.498 45.5,104C 43.5494,102.266 42.5494,100.099 42.5,97.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#5d6871",
          d: "M 87.5,103.5 C 87.5,104.167 87.5,104.833 87.5,105.5C 81.5738,106.774 75.7404,108.441 70,110.5C 69.5,110.167 69,109.833 68.5,109.5C 69.9376,105.167 71.9376,101.167 74.5,97.5C 78.9793,99.2405 83.3126,101.24 87.5,103.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.165
          },
          fill: "#070707",
          d: "M 190.5,98.5 C 192.676,99.7133 193.009,101.38 191.5,103.5C 185.274,105.018 178.94,105.852 172.5,106C 168.352,109.314 164.352,112.814 160.5,116.5C 157.833,124.323 154.667,131.99 151,139.5C 147.796,142.369 144.963,145.535 142.5,149C 139.761,150.026 137.428,151.526 135.5,153.5C 134.609,152.89 133.609,152.557 132.5,152.5C 131.833,152.5 131.167,152.5 130.5,152.5C 130.5,151.833 130.5,151.167 130.5,150.5C 131.167,150.5 131.5,150.167 131.5,149.5C 139.372,146.766 145.372,141.766 149.5,134.5C 150.167,134.5 150.5,134.167 150.5,133.5C 153.099,127.704 155.099,121.704 156.5,115.5C 157.167,115.5 157.5,115.167 157.5,114.5C 157.833,113.5 158.5,112.833 159.5,112.5C 163.5,108.833 167.5,105.167 171.5,101.5C 172.167,101.5 172.5,101.167 172.5,100.5C 177.263,100.774 181.93,100.441 186.5,99.5C 188.099,99.7678 189.432,99.4345 190.5,98.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#cdcfcf",
          d: "M 147.5,101.5 C 148.167,101.833 148.833,102.167 149.5,102.5C 153.14,105.473 156.473,108.806 159.5,112.5C 158.5,112.833 157.833,113.5 157.5,114.5C 150.833,111.833 144.167,109.167 137.5,106.5C 140.235,103.799 143.569,102.132 147.5,101.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#343e48",
          d: "M 171.5,101.5 C 167.5,105.167 163.5,108.833 159.5,112.5C 156.473,108.806 153.14,105.473 149.5,102.5C 156.648,101.508 163.981,101.175 171.5,101.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#969798",
          d: "M 69.5,85.5 C 72.3915,86.4025 75.3915,86.7359 78.5,86.5C 81.434,92.1938 84.7673,97.6938 88.5,103C 88.2716,103.399 87.9382,103.565 87.5,103.5C 83.3126,101.24 78.9793,99.2405 74.5,97.5C 71.9376,101.167 69.9376,105.167 68.5,109.5C 69,109.833 69.5,110.167 70,110.5C 75.7404,108.441 81.5738,106.774 87.5,105.5C 87.9382,105.435 88.2716,105.601 88.5,106C 85.9204,109.158 83.5871,112.492 81.5,116C 78.854,116.497 76.1873,116.664 73.5,116.5C 70.9852,115.737 68.9852,114.237 67.5,112C 64.3771,111.794 61.3771,111.127 58.5,110C 57.6195,109.292 56.9528,108.458 56.5,107.5C 56.281,106.325 56.6143,105.325 57.5,104.5C 62.0466,102.06 66.7133,99.8932 71.5,98C 61.8391,97.5002 52.1724,97.3335 42.5,97.5C 41.8333,97.5 41.5,97.1667 41.5,96.5C 51.1724,96.6665 60.8391,96.4998 70.5,96C 67.3522,94.5765 64.3522,93.0765 61.5,91.5C 64.1667,89.5 66.8333,87.5 69.5,85.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#bfc2c4",
          d: "M 90.5,104.5 C 100.989,105.041 111.322,105.707 121.5,106.5C 115.431,107.914 109.431,109.581 103.5,111.5C 99.1122,109.363 94.7789,107.029 90.5,104.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#5d6870",
          d: "M 98.5,87.5 C 107.493,93.2387 115.993,99.572 124,106.5C 127.73,105.54 131.563,105.207 135.5,105.5C 135.5,104.167 135.5,102.833 135.5,101.5C 136.451,102.919 136.784,104.585 136.5,106.5C 135.724,113.137 135.391,119.804 135.5,126.5C 129.121,126.038 122.788,125.538 116.5,125C 118.606,128.039 120.106,131.205 121,134.5C 116.332,132.082 111.499,130.082 106.5,128.5C 106.5,128.167 106.5,127.833 106.5,127.5C 106.5,126.833 106.833,126.5 107.5,126.5C 110.315,126.796 112.982,125.796 115.5,123.5C 114.639,121.089 113.306,119.089 111.5,117.5C 115.841,114.189 119.174,110.522 121.5,106.5C 111.322,105.707 100.989,105.041 90.5,104.5C 90.0618,104.565 89.7284,104.399 89.5,104C 92.9058,98.6859 95.9058,93.1859 98.5,87.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#959697",
          d: "M 136.5,106.5 C 136.833,106.5 137.167,106.5 137.5,106.5C 144.167,109.167 150.833,111.833 157.5,114.5C 157.5,115.167 157.167,115.5 156.5,115.5C 150.409,118.408 144.409,121.574 138.5,125C 137.619,125.708 136.953,126.542 136.5,127.5C 131.952,129.107 127.619,131.274 123.5,134C 127.152,134.499 130.818,134.665 134.5,134.5C 131.038,135.482 127.371,135.815 123.5,135.5C 121.308,139.098 120.308,143.098 120.5,147.5C 119.869,149.934 118.869,152.268 117.5,154.5C 116.833,155.5 116.167,156.5 115.5,157.5C 114.18,156.058 112.514,155.392 110.5,155.5C 108.704,154.207 107.037,152.707 105.5,151C 108.833,150.667 112.167,150.333 115.5,150C 107.624,149.113 99.7911,147.946 92,146.5C 90.6244,146.316 89.7911,145.649 89.5,144.5C 95.1404,139.195 100.807,133.861 106.5,128.5C 111.499,130.082 116.332,132.082 121,134.5C 120.106,131.205 118.606,128.039 116.5,125C 122.788,125.538 129.121,126.038 135.5,126.5C 135.391,119.804 135.724,113.137 136.5,106.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#56595b",
          d: "M 121.5,106.5 C 119.174,110.522 115.841,114.189 111.5,117.5C 106.167,119.167 100.833,120.833 95.5,122.5C 91.2508,122.079 87.2508,121.079 83.5,119.5C 90.6293,117.795 97.296,115.128 103.5,111.5C 109.431,109.581 115.431,107.914 121.5,106.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#56585a",
          d: "M 156.5,115.5 C 155.099,121.704 153.099,127.704 150.5,133.5C 145.597,132.048 140.93,130.048 136.5,127.5C 136.953,126.542 137.619,125.708 138.5,125C 144.409,121.574 150.409,118.408 156.5,115.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#858689",
          d: "M 111.5,117.5 C 110.16,120.529 108.827,123.529 107.5,126.5C 106.833,126.5 106.5,126.833 106.5,127.5C 102.721,126.442 99.0541,125.109 95.5,123.5C 95.5,123.167 95.5,122.833 95.5,122.5C 100.833,120.833 106.167,119.167 111.5,117.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#37414b",
          d: "M 111.5,117.5 C 113.306,119.089 114.639,121.089 115.5,123.5C 112.982,125.796 110.315,126.796 107.5,126.5C 108.827,123.529 110.16,120.529 111.5,117.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#343e48",
          d: "M 95.5,123.5 C 99.0541,125.109 102.721,126.442 106.5,127.5C 106.5,127.833 106.5,128.167 106.5,128.5C 100.807,133.861 95.1404,139.195 89.5,144.5C 89.1667,144.5 88.8333,144.5 88.5,144.5C 90.2382,137.285 92.5715,130.285 95.5,123.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#ced0d0",
          d: "M 136.5,127.5 C 140.93,130.048 145.597,132.048 150.5,133.5C 150.5,134.167 150.167,134.5 149.5,134.5C 144.5,134.5 139.5,134.5 134.5,134.5C 130.818,134.665 127.152,134.499 123.5,134C 127.619,131.274 131.952,129.107 136.5,127.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#7b8389",
          d: "M 134.5,134.5 C 139.5,134.5 144.5,134.5 149.5,134.5C 145.372,141.766 139.372,146.766 131.5,149.5C 128.406,145.074 125.739,140.407 123.5,135.5C 127.371,135.815 131.038,135.482 134.5,134.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#36414b",
          d: "M 123.5,135.5 C 125.739,140.407 128.406,145.074 131.5,149.5C 131.5,150.167 131.167,150.5 130.5,150.5C 126.881,150.119 123.548,149.119 120.5,147.5C 120.308,143.098 121.308,139.098 123.5,135.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#5d676f",
          d: "M 88.5,144.5 C 88.8333,144.5 89.1667,144.5 89.5,144.5C 89.7911,145.649 90.6244,146.316 92,146.5C 99.7911,147.946 107.624,149.113 115.5,150C 112.167,150.333 108.833,150.667 105.5,151C 107.037,152.707 108.704,154.207 110.5,155.5C 107.085,162 103.418,168.333 99.5,174.5C 101.095,168.717 103.095,163.051 105.5,157.5C 103.5,156.833 101.5,156.167 99.5,155.5C 101.316,154.185 102.983,152.685 104.5,151C 99.8333,150.333 95.1667,150.333 90.5,151C 91.4118,153.205 92.7451,155.038 94.5,156.5C 94.5,157.167 94.1667,157.5 93.5,157.5C 83.3942,165.095 73.3942,172.928 63.5,181C 62.8333,181.667 62.1667,181.667 61.5,181C 69.3025,172.197 77.4691,163.697 86,155.5C 87.1821,153.656 88.3488,151.823 89.5,150C 89.1918,148.541 88.5251,147.374 87.5,146.5C 87.8333,145.833 88.1667,145.167 88.5,144.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.999
          },
          fill: "#5e686e",
          d: "M 120.5,147.5 C 123.548,149.119 126.881,150.119 130.5,150.5C 130.5,151.167 130.5,151.833 130.5,152.5C 129.039,151.314 127.705,151.314 126.5,152.5C 123.402,152.756 120.402,153.422 117.5,154.5C 118.869,152.268 119.869,149.934 120.5,147.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.961
          },
          fill: "#b3afa3",
          d: "M 130.5,152.5 C 131.167,152.5 131.833,152.5 132.5,152.5C 133.306,153.728 134.306,154.728 135.5,155.5C 132.145,155.31 129.145,154.31 126.5,152.5C 127.705,151.314 129.039,151.314 130.5,152.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.988
          },
          fill: "#686b65",
          d: "M 132.5,152.5 C 133.609,152.557 134.609,152.89 135.5,153.5C 137.292,153.366 138.958,153.699 140.5,154.5C 139.789,156.03 138.789,157.363 137.5,158.5C 134.932,158.594 133.432,159.928 133,162.5C 131.794,159.162 132.96,157.329 136.5,157C 135.944,156.617 135.611,156.117 135.5,155.5C 134.306,154.728 133.306,153.728 132.5,152.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.176
          },
          fill: "#030404",
          d: "M 110.5,155.5 C 112.514,155.392 114.18,156.058 115.5,157.5C 117.986,159.155 119.986,161.322 121.5,164C 119.419,166.818 119.085,169.818 120.5,173C 121.167,173.667 121.833,173.667 122.5,173C 120.775,166.133 122.608,164.966 128,169.5C 129.505,171.298 129.672,173.132 128.5,175C 132.204,174.516 132.538,172.849 129.5,170C 132.657,170.176 134.157,172.009 134,175.5C 135.689,173.68 135.855,171.68 134.5,169.5C 137.686,172.399 138.02,175.566 135.5,179C 132.207,179.826 128.874,180.326 125.5,180.5C 127.089,177.036 126.589,174.036 124,171.5C 125.225,174.331 124.559,176.664 122,178.5C 119.086,177.252 117.253,175.086 116.5,172C 117.791,169.95 118.291,167.783 118,165.5C 116.316,163.649 114.483,161.982 112.5,160.5C 111.522,160.977 110.689,161.643 110,162.5C 105.922,170.991 101.588,179.324 97,187.5C 95.786,189.049 94.286,190.215 92.5,191C 77.4054,197.181 62.9054,196.014 49,187.5C 48.1742,184.788 48.6742,182.455 50.5,180.5C 50.238,181.978 50.5713,183.311 51.5,184.5C 56.3296,185.951 60.9962,187.617 65.5,189.5C 70.2981,190.744 74.9648,190.744 79.5,189.5C 82.9419,190.172 85.6086,189.172 87.5,186.5C 90.1569,186.838 92.4902,186.171 94.5,184.5C 96.705,181.423 98.3716,178.09 99.5,174.5C 103.418,168.333 107.085,162 110.5,155.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#555759",
          d: "M 94.5,156.5 C 96.0481,156.821 96.7148,157.821 96.5,159.5C 89.8331,168.856 83.4997,178.523 77.5,188.5C 77.9569,189.298 78.6236,189.631 79.5,189.5C 74.9648,190.744 70.2981,190.744 65.5,189.5C 68.4045,187.101 71.2379,184.435 74,181.5C 80.2688,173.286 86.7688,165.286 93.5,157.5C 94.1667,157.5 94.5,157.167 94.5,156.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.99
          },
          fill: "#2d363e",
          d: "M 140.5,154.5 C 143.802,155.294 147.135,155.96 150.5,156.5C 149.645,158.787 149.478,161.12 150,163.5C 148.334,164.34 148.167,163.84 149.5,162C 148.25,159.375 146.25,158.375 143.5,159C 146.47,162.145 145.97,164.645 142,166.5C 141.667,164.953 142.167,163.62 143.5,162.5C 142.833,159.167 140.833,157.833 137.5,158.5C 138.789,157.363 139.789,156.03 140.5,154.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#898f8c",
          d: "M 99.5,174.5 C 98.3716,178.09 96.705,181.423 94.5,184.5C 92.4902,186.171 90.1569,186.838 87.5,186.5C 90.2985,177.438 93.2985,168.438 96.5,159.5C 96.7148,157.821 96.0481,156.821 94.5,156.5C 92.7451,155.038 91.4118,153.205 90.5,151C 95.1667,150.333 99.8333,150.333 104.5,151C 102.983,152.685 101.316,154.185 99.5,155.5C 101.5,156.167 103.5,156.833 105.5,157.5C 103.095,163.051 101.095,168.717 99.5,174.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 0.132
          },
          fill: "#040505",
          d: "M 126.5,152.5 C 129.145,154.31 132.145,155.31 135.5,155.5C 135.611,156.117 135.944,156.617 136.5,157C 132.96,157.329 131.794,159.162 133,162.5C 133.432,159.928 134.932,158.594 137.5,158.5C 140.833,157.833 142.833,159.167 143.5,162.5C 142.167,163.62 141.667,164.953 142,166.5C 145.97,164.645 146.47,162.145 143.5,159C 146.25,158.375 148.25,159.375 149.5,162C 148.167,163.84 148.334,164.34 150,163.5C 149.478,161.12 149.645,158.787 150.5,156.5C 153.859,160.675 153.525,164.842 149.5,169C 146.36,168.418 143.36,168.751 140.5,170C 139.351,168.396 139.351,166.73 140.5,165C 140.387,163.72 139.72,162.887 138.5,162.5C 136.599,164.006 134.932,165.673 133.5,167.5C 132.29,167.068 131.29,166.401 130.5,165.5C 130.784,163.123 130.784,160.956 130.5,159C 128.722,158.296 126.888,157.796 125,157.5C 123.301,157.387 122.134,158.053 121.5,159.5C 119.413,158.415 118.08,156.749 117.5,154.5C 120.402,153.422 123.402,152.756 126.5,152.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#828688",
          d: "M 86.5,146.5 C 86.8333,146.5 87.1667,146.5 87.5,146.5C 88.5251,147.374 89.1918,148.541 89.5,150C 88.3488,151.823 87.1821,153.656 86,155.5C 77.4691,163.697 69.3025,172.197 61.5,181C 62.1667,181.667 62.8333,181.667 63.5,181C 73.3942,172.928 83.3942,165.095 93.5,157.5C 86.7688,165.286 80.2688,173.286 74,181.5C 71.2379,184.435 68.4045,187.101 65.5,189.5C 60.9962,187.617 56.3296,185.951 51.5,184.5C 50.5713,183.311 50.238,181.978 50.5,180.5C 62.1716,168.829 74.1716,157.495 86.5,146.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#5c666f",
          d: "M 96.5,159.5 C 93.2985,168.438 90.2985,177.438 87.5,186.5C 85.6086,189.172 82.9419,190.172 79.5,189.5C 78.6236,189.631 77.9569,189.298 77.5,188.5C 83.4997,178.523 89.8331,168.856 96.5,159.5 Z"
        }
      ) }),
      /* @__PURE__ */ ae("g", { children: /* @__PURE__ */ ae(
        "path",
        {
          style: {
            opacity: 1
          },
          fill: "#3b4346",
          d: "M 117.5,154.5 C 118.08,156.749 119.413,158.415 121.5,159.5C 124.328,161.748 127.328,163.748 130.5,165.5C 131.29,166.401 132.29,167.068 133.5,167.5C 133.833,168.167 134.167,168.833 134.5,169.5C 135.855,171.68 135.689,173.68 134,175.5C 134.157,172.009 132.657,170.176 129.5,170C 132.538,172.849 132.204,174.516 128.5,175C 129.672,173.132 129.505,171.298 128,169.5C 122.608,164.966 120.775,166.133 122.5,173C 121.833,173.667 121.167,173.667 120.5,173C 119.085,169.818 119.419,166.818 121.5,164C 119.986,161.322 117.986,159.155 115.5,157.5C 116.167,156.5 116.833,155.5 117.5,154.5 Z"
        }
      ) })
    ]
  }
), yze = ({
  size: e,
  className: t,
  variant: r,
  walletName: n
}) => n === Rp ? /* @__PURE__ */ ae(o$e, { size: e, className: t, variant: r }) : n === zp ? /* @__PURE__ */ ae(a$e, { size: e, className: t, variant: r }) : n === k1 ? /* @__PURE__ */ ae(Wj, { size: e, className: t, variant: r }) : n === Gl ? /* @__PURE__ */ ae(u$e, { size: e, className: t, variant: r }) : n === S1 ? /* @__PURE__ */ ae(s$e, { size: e, className: t, variant: r }) : n === jp ? /* @__PURE__ */ ae(w$e, { size: e, className: t, variant: r }) : n === Id ? /* @__PURE__ */ ae(n$e, { size: e, className: t, variant: r }) : n === Up ? /* @__PURE__ */ ae(i$e, { size: e, className: t, variant: r }) : n === x1 ? /* @__PURE__ */ ae(r$e, { size: e, className: t, variant: r }) : n === Od ? /* @__PURE__ */ ae(c$e, { size: e, className: t, variant: r }) : n === Pd ? /* @__PURE__ */ ae(b$e, { size: e, className: t, variant: r }) : /* @__PURE__ */ ae(Wj, { size: e, className: t, variant: r });
export {
  ARe as ALKANES,
  sRe as APPLICATION_ATOM_XML,
  uRe as APPLICATION_FORM_URLENCODED,
  oRe as APPLICATION_GZIP,
  eRe as APPLICATION_JAVASCRIPT,
  QUe as APPLICATION_JSON,
  cRe as APPLICATION_OCTET_STREAM,
  rRe as APPLICATION_PDF,
  aRe as APPLICATION_RSS_XML,
  iRe as APPLICATION_XHTML_XML,
  tRe as APPLICATION_XML,
  nRe as APPLICATION_ZIP,
  wRe as AUDIO_MP3,
  ERe as AUDIO_OGG,
  vRe as AUDIO_WAV,
  rB as BIP322,
  A4 as BIP322_SIMPLE,
  QU as BRC20,
  JU as BTC,
  gt as BaseNetwork,
  qb as CmdruidNetwork,
  Wp as DataSourceManager,
  U2 as ECDSA,
  th as FRACTAL_MAINNET,
  as as FRACTAL_TESTNET,
  iO as FractalNetwork,
  dRe as IMAGE_GIF,
  gRe as IMAGE_ICON,
  lRe as IMAGE_JPEG,
  fRe as IMAGE_PNG,
  hRe as IMAGE_SVG_XML,
  pRe as IMAGE_WEBP,
  Xb as LEATHER,
  gS as LOCAL_STORAGE_DEFAULT_WALLET,
  YRe as LaserEyesClient,
  mze as LaserEyesLogo,
  gze as LaserEyesProvider,
  Wj as LeatherLogo,
  E1 as LeatherNetwork,
  Ed as MAGIC_EDEN,
  Kn as MAINNET,
  _Re as MULTIPART_FORM_DATA,
  Gge as MaestroDataSource,
  u$e as MagicEdenLogo,
  Wge as MempoolSpaceDataSource,
  Yb as OKX,
  Sp as OP_NET,
  kp as ORANGE,
  Zb as OYL,
  s$e as OkxLogo,
  aO as OkxNetwork,
  gpe as OpNetwork,
  R8 as OrangeNetwork,
  r$e as OylLogo,
  bJ as P2PKH,
  _$e as P2PSH,
  h2 as P2SH,
  wJ as P2SH_P2WPKH,
  $1 as P2TR,
  hI as P2WPKH,
  vJ as P2WSH,
  xp as PHANTOM,
  n$e as PhantomLogo,
  xUe as REGTEST,
  eR as RUNES,
  Ls as SIGNET,
  a1 as SPARROW,
  A$e as SUPPORTED_WALLETS,
  Zge as SandshrewDataSource,
  aa as TESTNET,
  ka as TESTNET4,
  XUe as TEXT_CSS,
  ZUe as TEXT_HTML,
  YUe as TEXT_JAVASCRIPT,
  JUe as TEXT_MARKDOWN,
  dge as TEXT_PLAIN,
  n1 as UNISAT,
  eme as UNSUPPORTED_PROVIDER_METHOD_ERROR,
  i$e as UnisatLogo,
  va as UnisatNetwork,
  mRe as VIDEO_MP4,
  bRe as VIDEO_OGG,
  yRe as VIDEO_WEBM,
  tme as WALLET_NOT_INSTALLED_ERROR,
  i1 as WIZZ,
  yze as WalletIcon,
  Gu as WalletProvider,
  a$e as WizzLogo,
  zs as WizzNetwork,
  o1 as XVERSE,
  o$e as XverseLogo,
  Au as XverseNetwork,
  $Re as createConfig,
  NRe as createStores,
  mpe as getCmDruidNetwork,
  kUe as getLeatherNetwork,
  TUe as getNetworkForLeather,
  ype as getNetworkForOkx,
  B3 as getNetworkForUnisat,
  CU as getNetworkForWizz,
  rT as getNetworkForXverse,
  tT as getOrangeNetwork,
  eT as getSatsConnectNetwork,
  yD as getUnisatNetwork,
  SUe as getWizzNetwork,
  pze as useLaserEyes
};
